function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiread89"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiread89"] = parcelRequire;
}
parcelRequire.register("1Inan", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $13fbded6f09b74f4$export$1e511d4a378977f5; }, function (v) { return $13fbded6f09b74f4$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "fontStyleItalic", function () { return $13fbded6f09b74f4$export$ccef9f3ad06d68ef; }, function (v) { return $13fbded6f09b74f4$export$ccef9f3ad06d68ef = v; });
$parcel$export(module.exports, "fontWeightNormal", function () { return $13fbded6f09b74f4$export$a7877f1660ac75f4; }, function (v) { return $13fbded6f09b74f4$export$a7877f1660ac75f4 = v; });
$parcel$export(module.exports, "fontWeightBold", function () { return $13fbded6f09b74f4$export$c46df79513126abf; }, function (v) { return $13fbded6f09b74f4$export$c46df79513126abf = v; });
var $13fbded6f09b74f4$export$1e511d4a378977f5;
var $13fbded6f09b74f4$export$ccef9f3ad06d68ef;
var $13fbded6f09b74f4$export$a7877f1660ac75f4;
var $13fbded6f09b74f4$export$c46df79513126abf;
"use strict";
$13fbded6f09b74f4$export$1e511d4a378977f5 = true;
$13fbded6f09b74f4$export$ccef9f3ad06d68ef = {
    fontStyle: "italic"
};
$13fbded6f09b74f4$export$a7877f1660ac75f4 = {
    fontWeight: "normal"
};
$13fbded6f09b74f4$export$c46df79513126abf = {
    fontWeight: "bold"
};

});

parcelRequire.register("cCspI", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $92ff1302c855f9cc$export$1e511d4a378977f5; }, function (v) { return $92ff1302c855f9cc$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "flexRoot", function () { return $92ff1302c855f9cc$export$1381e2eeed179d62; }, function (v) { return $92ff1302c855f9cc$export$1381e2eeed179d62 = v; });
$parcel$export(module.exports, "pass", function () { return $92ff1302c855f9cc$export$167b0ad523238611; }, function (v) { return $92ff1302c855f9cc$export$167b0ad523238611 = v; });
$parcel$export(module.exports, "inlineRoot", function () { return $92ff1302c855f9cc$export$57dd25639770f8a0; }, function (v) { return $92ff1302c855f9cc$export$57dd25639770f8a0 = v; });
$parcel$export(module.exports, "horizontal", function () { return $92ff1302c855f9cc$export$641ecd0b2bc39508; }, function (v) { return $92ff1302c855f9cc$export$641ecd0b2bc39508 = v; });
$parcel$export(module.exports, "vertical", function () { return $92ff1302c855f9cc$export$32f8a6eb41d46820; }, function (v) { return $92ff1302c855f9cc$export$32f8a6eb41d46820 = v; });
$parcel$export(module.exports, "wrap", function () { return $92ff1302c855f9cc$export$4997ffc0176396a6; }, function (v) { return $92ff1302c855f9cc$export$4997ffc0176396a6 = v; });
$parcel$export(module.exports, "content", function () { return $92ff1302c855f9cc$export$a7db06668cad9adb; }, function (v) { return $92ff1302c855f9cc$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "flex", function () { return $92ff1302c855f9cc$export$97691fbb80847c19; }, function (v) { return $92ff1302c855f9cc$export$97691fbb80847c19 = v; });
$parcel$export(module.exports, "flex1", function () { return $92ff1302c855f9cc$export$fce79930bd73619a; }, function (v) { return $92ff1302c855f9cc$export$fce79930bd73619a = v; });
$parcel$export(module.exports, "flex2", function () { return $92ff1302c855f9cc$export$7692c0af341a3b00; }, function (v) { return $92ff1302c855f9cc$export$7692c0af341a3b00 = v; });
$parcel$export(module.exports, "flex3", function () { return $92ff1302c855f9cc$export$6f9cf2c7d6cc2a1e; }, function (v) { return $92ff1302c855f9cc$export$6f9cf2c7d6cc2a1e = v; });
$parcel$export(module.exports, "flex4", function () { return $92ff1302c855f9cc$export$a53f1e789b3c45b4; }, function (v) { return $92ff1302c855f9cc$export$a53f1e789b3c45b4 = v; });
$parcel$export(module.exports, "flex5", function () { return $92ff1302c855f9cc$export$fab216c835d65f2c; }, function (v) { return $92ff1302c855f9cc$export$fab216c835d65f2c = v; });
$parcel$export(module.exports, "flex6", function () { return $92ff1302c855f9cc$export$d8b742e67a6852c6; }, function (v) { return $92ff1302c855f9cc$export$d8b742e67a6852c6 = v; });
$parcel$export(module.exports, "flex7", function () { return $92ff1302c855f9cc$export$51a3466a730e8d8a; }, function (v) { return $92ff1302c855f9cc$export$51a3466a730e8d8a = v; });
$parcel$export(module.exports, "flex8", function () { return $92ff1302c855f9cc$export$741b131ea0ccedba; }, function (v) { return $92ff1302c855f9cc$export$741b131ea0ccedba = v; });
$parcel$export(module.exports, "flex9", function () { return $92ff1302c855f9cc$export$82d8795f7ff2ab15; }, function (v) { return $92ff1302c855f9cc$export$82d8795f7ff2ab15 = v; });
$parcel$export(module.exports, "flex10", function () { return $92ff1302c855f9cc$export$144fdac6cc2b6d2b; }, function (v) { return $92ff1302c855f9cc$export$144fdac6cc2b6d2b = v; });
$parcel$export(module.exports, "flex11", function () { return $92ff1302c855f9cc$export$2dd6cdf8243f8da6; }, function (v) { return $92ff1302c855f9cc$export$2dd6cdf8243f8da6 = v; });
$parcel$export(module.exports, "flex12", function () { return $92ff1302c855f9cc$export$eeb779268a435ff0; }, function (v) { return $92ff1302c855f9cc$export$eeb779268a435ff0 = v; });
$parcel$export(module.exports, "start", function () { return $92ff1302c855f9cc$export$b3571188c770cc5a; }, function (v) { return $92ff1302c855f9cc$export$b3571188c770cc5a = v; });
$parcel$export(module.exports, "center", function () { return $92ff1302c855f9cc$export$3481c78889e8fbe8; }, function (v) { return $92ff1302c855f9cc$export$3481c78889e8fbe8 = v; });
$parcel$export(module.exports, "end", function () { return $92ff1302c855f9cc$export$bd5df0f255a350f8; }, function (v) { return $92ff1302c855f9cc$export$bd5df0f255a350f8 = v; });
$parcel$export(module.exports, "startJustified", function () { return $92ff1302c855f9cc$export$db32c29ab4135d27; }, function (v) { return $92ff1302c855f9cc$export$db32c29ab4135d27 = v; });
$parcel$export(module.exports, "centerJustified", function () { return $92ff1302c855f9cc$export$565d92956b4a2d26; }, function (v) { return $92ff1302c855f9cc$export$565d92956b4a2d26 = v; });
$parcel$export(module.exports, "endJustified", function () { return $92ff1302c855f9cc$export$6104947d4469e353; }, function (v) { return $92ff1302c855f9cc$export$6104947d4469e353 = v; });
$parcel$export(module.exports, "aroundJustified", function () { return $92ff1302c855f9cc$export$593286e32268859e; }, function (v) { return $92ff1302c855f9cc$export$593286e32268859e = v; });
$parcel$export(module.exports, "betweenJustified", function () { return $92ff1302c855f9cc$export$ade64b1bb0afe8d; }, function (v) { return $92ff1302c855f9cc$export$ade64b1bb0afe8d = v; });
$parcel$export(module.exports, "centerCenter", function () { return $92ff1302c855f9cc$export$77a80c974bdf841c; }, function (v) { return $92ff1302c855f9cc$export$77a80c974bdf841c = v; });
$parcel$export(module.exports, "selfStart", function () { return $92ff1302c855f9cc$export$494f684ca24c3c79; }, function (v) { return $92ff1302c855f9cc$export$494f684ca24c3c79 = v; });
$parcel$export(module.exports, "selfCenter", function () { return $92ff1302c855f9cc$export$e954322f8f366e6a; }, function (v) { return $92ff1302c855f9cc$export$e954322f8f366e6a = v; });
$parcel$export(module.exports, "selfEnd", function () { return $92ff1302c855f9cc$export$717fc27ce72caa7e; }, function (v) { return $92ff1302c855f9cc$export$717fc27ce72caa7e = v; });
$parcel$export(module.exports, "selfStretch", function () { return $92ff1302c855f9cc$export$29d1fb5d1e2b0e0d; }, function (v) { return $92ff1302c855f9cc$export$29d1fb5d1e2b0e0d = v; });
var $92ff1302c855f9cc$export$1e511d4a378977f5;
/**
 * If you have more than one child prefer horizontal,vertical
 */ var $92ff1302c855f9cc$export$1381e2eeed179d62;
/**
 * A general grouping component that has no impact on the parent flexbox properties e.g.
 * <vertical>
 *    <pass>
 *       <content/>
 *    </pass>
 * </vertical>
 */ var $92ff1302c855f9cc$export$167b0ad523238611;
var $92ff1302c855f9cc$export$57dd25639770f8a0;
var $92ff1302c855f9cc$export$641ecd0b2bc39508;
var $92ff1302c855f9cc$export$32f8a6eb41d46820;
var $92ff1302c855f9cc$export$4997ffc0176396a6;
/**
 * If you want items to be sized automatically by their children use this
 * This is because of a bug in various flexbox implementations: http://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
 * Specifically bug 1 : https://github.com/philipwalton/flexbugs#1-minimum-content-sizing-of-flex-items-not-honored
 */ var $92ff1302c855f9cc$export$a7db06668cad9adb;
var $92ff1302c855f9cc$export$97691fbb80847c19;
var $92ff1302c855f9cc$export$fce79930bd73619a;
var $92ff1302c855f9cc$export$7692c0af341a3b00;
var $92ff1302c855f9cc$export$6f9cf2c7d6cc2a1e;
var $92ff1302c855f9cc$export$a53f1e789b3c45b4;
var $92ff1302c855f9cc$export$fab216c835d65f2c;
var $92ff1302c855f9cc$export$d8b742e67a6852c6;
var $92ff1302c855f9cc$export$51a3466a730e8d8a;
var $92ff1302c855f9cc$export$741b131ea0ccedba;
var $92ff1302c855f9cc$export$82d8795f7ff2ab15;
var $92ff1302c855f9cc$export$144fdac6cc2b6d2b;
var $92ff1302c855f9cc$export$2dd6cdf8243f8da6;
var $92ff1302c855f9cc$export$eeb779268a435ff0;
/////////////////////////////
// Alignment in cross axis //
/////////////////////////////
var $92ff1302c855f9cc$export$b3571188c770cc5a;
var $92ff1302c855f9cc$export$3481c78889e8fbe8;
var $92ff1302c855f9cc$export$bd5df0f255a350f8;
////////////////////////////
// Alignment in main axis //
////////////////////////////
var $92ff1302c855f9cc$export$db32c29ab4135d27;
var $92ff1302c855f9cc$export$565d92956b4a2d26;
var $92ff1302c855f9cc$export$6104947d4469e353;
var $92ff1302c855f9cc$export$593286e32268859e;
var $92ff1302c855f9cc$export$ade64b1bb0afe8d;
////////////////////////////
// Alignment in both axes //
////////////////////////////
var $92ff1302c855f9cc$export$77a80c974bdf841c;
////////////////////
// Self alignment //
////////////////////
var $92ff1302c855f9cc$export$494f684ca24c3c79;
var $92ff1302c855f9cc$export$e954322f8f366e6a;
var $92ff1302c855f9cc$export$717fc27ce72caa7e;
var $92ff1302c855f9cc$export$29d1fb5d1e2b0e0d;
"use strict";
$92ff1302c855f9cc$export$1e511d4a378977f5 = true;
parcelRequire("4LfDI");
var $a2AKD = parcelRequire("a2AKD");
$92ff1302c855f9cc$export$1381e2eeed179d62 = {
    display: [
        "-ms-flexbox",
        "-webkit-flex",
        "flex"
    ]
};
$92ff1302c855f9cc$export$167b0ad523238611 = {
    display: "inherit",
    "-ms-flex-direction": "inherit",
    "-webkit-flex-direction": "inherit",
    flexDirection: "inherit",
    "-ms-flex-positive": 1,
    "-webkit-flex-grow": 1,
    flexGrow: 1
};
$92ff1302c855f9cc$export$57dd25639770f8a0 = {
    display: [
        "-ms-inline-flexbox",
        "-webkit-inline-flex",
        "inline-flex"
    ]
};
$92ff1302c855f9cc$export$641ecd0b2bc39508 = $a2AKD.extend($92ff1302c855f9cc$export$1381e2eeed179d62, {
    "-ms-flex-direction": "row",
    "-webkit-flex-direction": "row",
    flexDirection: "row"
});
$92ff1302c855f9cc$export$32f8a6eb41d46820 = $a2AKD.extend($92ff1302c855f9cc$export$1381e2eeed179d62, {
    "-ms-flex-direction": "column",
    "-webkit-flex-direction": "column",
    flexDirection: "column"
});
$92ff1302c855f9cc$export$4997ffc0176396a6 = {
    "-ms-flex-wrap": "wrap",
    "-webkit-flex-wrap": "wrap",
    flexWrap: "wrap"
};
$92ff1302c855f9cc$export$a7db06668cad9adb = {
    "-ms-flex-negative": 0,
    "-webkit-flex-shrink": 0,
    flexShrink: 0,
    flexBasis: "auto"
};
$92ff1302c855f9cc$export$97691fbb80847c19 = {
    "-ms-flex": 1,
    "-webkit-flex": 1,
    flex: 1
};
$92ff1302c855f9cc$export$fce79930bd73619a = $92ff1302c855f9cc$export$97691fbb80847c19;
$92ff1302c855f9cc$export$7692c0af341a3b00 = {
    "-ms-flex": 2,
    "-webkit-flex": 2,
    flex: 2
};
$92ff1302c855f9cc$export$6f9cf2c7d6cc2a1e = {
    "-ms-flex": 3,
    "-webkit-flex": 3,
    flex: 3
};
$92ff1302c855f9cc$export$a53f1e789b3c45b4 = {
    "-ms-flex": 4,
    "-webkit-flex": 4,
    flex: 4
};
$92ff1302c855f9cc$export$fab216c835d65f2c = {
    "-ms-flex": 5,
    "-webkit-flex": 5,
    flex: 5
};
$92ff1302c855f9cc$export$d8b742e67a6852c6 = {
    "-ms-flex": 6,
    "-webkit-flex": 6,
    flex: 6
};
$92ff1302c855f9cc$export$51a3466a730e8d8a = {
    "-ms-flex": 7,
    "-webkit-flex": 7,
    flex: 7
};
$92ff1302c855f9cc$export$741b131ea0ccedba = {
    "-ms-flex": 8,
    "-webkit-flex": 8,
    flex: 8
};
$92ff1302c855f9cc$export$82d8795f7ff2ab15 = {
    "-ms-flex": 9,
    "-webkit-flex": 9,
    flex: 9
};
$92ff1302c855f9cc$export$144fdac6cc2b6d2b = {
    "-ms-flex": 10,
    "-webkit-flex": 10,
    flex: 10
};
$92ff1302c855f9cc$export$2dd6cdf8243f8da6 = {
    "-ms-flex": 11,
    "-webkit-flex": 11,
    flex: 11
};
$92ff1302c855f9cc$export$eeb779268a435ff0 = {
    "-ms-flex": 12,
    "-webkit-flex": 12,
    flex: 12
};
$92ff1302c855f9cc$export$b3571188c770cc5a = {
    "-ms-flex-align": "start",
    "-webkit-align-items": "flex-start",
    alignItems: "flex-start"
};
$92ff1302c855f9cc$export$3481c78889e8fbe8 = {
    "-ms-flex-align": "center",
    "-webkit-align-items": "center",
    alignItems: "center"
};
$92ff1302c855f9cc$export$bd5df0f255a350f8 = {
    "-ms-flex-align": "end",
    "-webkit-align-items": "flex-end",
    alignItems: "flex-end"
};
$92ff1302c855f9cc$export$db32c29ab4135d27 = {
    "-ms-flex-pack": "start",
    "-webkit-justify-content": "flex-start",
    justifyContent: "flex-start"
};
$92ff1302c855f9cc$export$565d92956b4a2d26 = {
    "-ms-flex-pack": "center",
    "-webkit-justify-content": "center",
    justifyContent: "center"
};
$92ff1302c855f9cc$export$6104947d4469e353 = {
    "-ms-flex-pack": "end",
    "-webkit-justify-content": "flex-end",
    justifyContent: "flex-end"
};
$92ff1302c855f9cc$export$593286e32268859e = {
    "-ms-flex-pack": "distribute",
    "-webkit-justify-content": "space-around",
    justifyContent: "space-around"
};
$92ff1302c855f9cc$export$ade64b1bb0afe8d = {
    "-ms-flex-pack": "justify",
    "-webkit-justify-content": "space-between",
    justifyContent: "space-between"
};
$92ff1302c855f9cc$export$77a80c974bdf841c = $a2AKD.extend($92ff1302c855f9cc$export$1381e2eeed179d62, $92ff1302c855f9cc$export$3481c78889e8fbe8, $92ff1302c855f9cc$export$565d92956b4a2d26);
$92ff1302c855f9cc$export$494f684ca24c3c79 = {
    "-ms-flex-item-align": "start",
    "-webkit-align-self": "flex-start",
    alignSelf: "flex-start"
};
$92ff1302c855f9cc$export$e954322f8f366e6a = {
    "-ms-flex-item-align": "center",
    "-webkit-align-self": "center",
    alignSelf: "center"
};
$92ff1302c855f9cc$export$717fc27ce72caa7e = {
    "-ms-flex-item-align": "end",
    "-webkit-align-self": "flex-end",
    alignSelf: "flex-end"
};
$92ff1302c855f9cc$export$29d1fb5d1e2b0e0d = {
    "-ms-flex-item-align": "stretch",
    "-webkit-align-self": "stretch",
    alignSelf: "stretch"
};

});
parcelRequire.register("4LfDI", function(module, exports) {

$parcel$export(module.exports, "cssRaw", function () { return $3777aeed2d138fd9$export$d28212b8a4a9b69d; });
$parcel$export(module.exports, "cssRule", function () { return $3777aeed2d138fd9$export$7bffc948341a2c5c; });
$parcel$export(module.exports, "style", function () { return $3777aeed2d138fd9$export$1d567c320f4763bc; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("a2AKD")).extend; });

var $dBs3l = parcelRequire("dBs3l");

var $evRVb = parcelRequire("evRVb");

var $a2AKD = parcelRequire("a2AKD");
/** Zero configuration, default instance of TypeStyle */ var $3777aeed2d138fd9$var$ts = new (0, $dBs3l.TypeStyle)({
    autoGenerateTag: true
});
var $3777aeed2d138fd9$export$b4c1ed5cd8d22259 = $3777aeed2d138fd9$var$ts.setStylesTarget;
var $3777aeed2d138fd9$export$d28212b8a4a9b69d = $3777aeed2d138fd9$var$ts.cssRaw;
var $3777aeed2d138fd9$export$7bffc948341a2c5c = $3777aeed2d138fd9$var$ts.cssRule;
var $3777aeed2d138fd9$export$9770592101341c48 = $3777aeed2d138fd9$var$ts.forceRenderStyles;
var $3777aeed2d138fd9$export$566c6c2ff0443c7 = $3777aeed2d138fd9$var$ts.fontFace;
var $3777aeed2d138fd9$export$ffd58b7f6f099a57 = $3777aeed2d138fd9$var$ts.getStyles;
var $3777aeed2d138fd9$export$d25ddfdf17c3ad3e = $3777aeed2d138fd9$var$ts.keyframes;
var $3777aeed2d138fd9$export$b545ad0f2df0be16 = $3777aeed2d138fd9$var$ts.reinit;
var $3777aeed2d138fd9$export$1d567c320f4763bc = $3777aeed2d138fd9$var$ts.style;
var $3777aeed2d138fd9$export$ab599ac46a775d57 = $3777aeed2d138fd9$var$ts.stylesheet;
function $3777aeed2d138fd9$export$33b2ae9d5b1dc022(target) {
    var instance = new (0, $dBs3l.TypeStyle)({
        autoGenerateTag: false
    });
    if (target) instance.setStylesTarget(target);
    return instance;
}

});
parcelRequire.register("dBs3l", function(module, exports) {

$parcel$export(module.exports, "TypeStyle", function () { return $9e747dd0c69ba642$export$f8557f743de52359; });

var $3Lqta = parcelRequire("3Lqta");

var $a2AKD = parcelRequire("a2AKD");

var $log2I = parcelRequire("log2I");
/**
 * Creates an instance of free style with our options
 */ var $9e747dd0c69ba642$var$createFreeStyle = function() {
    return $log2I.create(/** Use the default hash function */ undefined, /** Preserve $debugName values */ true);
};
/**
 * Maintains a single stylesheet and keeps it in sync with requested styles
 */ var $9e747dd0c69ba642$export$f8557f743de52359 = function() {
    function TypeStyle(_a) {
        var autoGenerateTag = _a.autoGenerateTag;
        var _this = this;
        /**
         * Insert `raw` CSS as a string. This is useful for e.g.
         * - third party CSS that you are customizing with template strings
         * - generating raw CSS in JavaScript
         * - reset libraries like normalize.css that you can use without loaders
         */ this.cssRaw = function(mustBeValidCSS) {
            if (!mustBeValidCSS) return;
            _this._raw += mustBeValidCSS || "";
            _this._pendingRawChange = true;
            _this._styleUpdated();
        };
        /**
         * Takes CSSProperties and registers it to a global selector (body, html, etc.)
         */ this.cssRule = function(selector) {
            var objects = [];
            for(var _i = 1; _i < arguments.length; _i++)objects[_i - 1] = arguments[_i];
            var object = (0, $3Lqta.ensureStringObj)((0, $a2AKD.extend).apply(void 0, objects)).result;
            _this._freeStyle.registerRule(selector, object);
            _this._styleUpdated();
            return;
        };
        /**
         * Renders styles to the singleton tag imediately
         * NOTE: You should only call it on initial render to prevent any non CSS flash.
         * After that it is kept sync using `requestAnimationFrame` and we haven't noticed any bad flashes.
         **/ this.forceRenderStyles = function() {
            var target = _this._getTag();
            if (!target) return;
            target.textContent = _this.getStyles();
        };
        /**
         * Utility function to register an @font-face
         */ this.fontFace = function() {
            var fontFace = [];
            for(var _i = 0; _i < arguments.length; _i++)fontFace[_i] = arguments[_i];
            var freeStyle = _this._freeStyle;
            for(var _a = 0, _b = fontFace; _a < _b.length; _a++){
                var face = _b[_a];
                freeStyle.registerRule("@font-face", face);
            }
            _this._styleUpdated();
            return;
        };
        /**
         * Allows use to use the stylesheet in a node.js environment
         */ this.getStyles = function() {
            return (_this._raw || "") + _this._freeStyle.getStyles();
        };
        /**
         * Takes keyframes and returns a generated animationName
         */ this.keyframes = function(frames) {
            var _a = (0, $3Lqta.explodeKeyframes)(frames), keyframes = _a.keyframes, $debugName = _a.$debugName;
            // TODO: replace $debugName with display name
            var animationName = _this._freeStyle.registerKeyframes(keyframes, $debugName);
            _this._styleUpdated();
            return animationName;
        };
        /**
         * Helps with testing. Reinitializes FreeStyle + raw
         */ this.reinit = function() {
            /** reinit freestyle */ var freeStyle = $9e747dd0c69ba642$var$createFreeStyle();
            _this._freeStyle = freeStyle;
            _this._lastFreeStyleChangeId = freeStyle.changeId;
            /** reinit raw */ _this._raw = "";
            _this._pendingRawChange = false;
            /** Clear any styles that were flushed */ var target = _this._getTag();
            if (target) target.textContent = "";
        };
        /** Sets the target tag where we write the css on style updates */ this.setStylesTarget = function(tag) {
            /** Clear any data in any previous tag */ if (_this._tag) _this._tag.textContent = "";
            _this._tag = tag;
            /** This special time buffer immediately */ _this.forceRenderStyles();
        };
        /**
         * Takes CSSProperties and return a generated className you can use on your component
         */ this.style = function() {
            var objects = [];
            for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
            var freeStyle = _this._freeStyle;
            var _a = (0, $3Lqta.ensureStringObj)((0, $a2AKD.extend).apply(void 0, objects)), result = _a.result, debugName = _a.debugName;
            var className = debugName ? freeStyle.registerStyle(result, debugName) : freeStyle.registerStyle(result);
            _this._styleUpdated();
            return className;
        };
        /**
         * Takes an object where property names are ideal class names and property values are CSSProperties, and
         * returns an object where property names are the same ideal class names and the property values are
         * the actual generated class names using the ideal class name as the $debugName
         */ this.stylesheet = function(classes) {
            var classNames = Object.getOwnPropertyNames(classes);
            var result = {};
            for(var _i = 0, classNames_1 = classNames; _i < classNames_1.length; _i++){
                var className = classNames_1[_i];
                var classDef = classes[className];
                if (classDef) {
                    classDef.$debugName = className;
                    result[className] = _this.style(classDef);
                }
            }
            return result;
        };
        var freeStyle = $9e747dd0c69ba642$var$createFreeStyle();
        this._autoGenerateTag = autoGenerateTag;
        this._freeStyle = freeStyle;
        this._lastFreeStyleChangeId = freeStyle.changeId;
        this._pending = 0;
        this._pendingRawChange = false;
        this._raw = "";
        this._tag = undefined;
    }
    /**
     * Only calls cb all sync operations settle
     */ TypeStyle.prototype._afterAllSync = function(cb) {
        var _this = this;
        this._pending++;
        var pending = this._pending;
        (0, $a2AKD.raf)(function() {
            if (pending !== _this._pending) return;
            cb();
        });
    };
    TypeStyle.prototype._getTag = function() {
        if (this._tag) return this._tag;
        if (this._autoGenerateTag) {
            var tag = typeof window === "undefined" ? {
                textContent: ""
            } : document.createElement("style");
            if (typeof document !== "undefined") document.head.appendChild(tag);
            this._tag = tag;
            return tag;
        }
        return undefined;
    };
    /** Checks if the style tag needs updating and if so queues up the change */ TypeStyle.prototype._styleUpdated = function() {
        var _this = this;
        var changeId = this._freeStyle.changeId;
        var lastChangeId = this._lastFreeStyleChangeId;
        if (!this._pendingRawChange && changeId === lastChangeId) return;
        this._lastFreeStyleChangeId = changeId;
        this._pendingRawChange = false;
        this._afterAllSync(function() {
            return _this.forceRenderStyles();
        });
    };
    return TypeStyle;
}();

});
parcelRequire.register("3Lqta", function(module, exports) {

$parcel$export(module.exports, "ensureStringObj", function () { return $2bda4b27ca97ecb9$export$354f03b695313e69; });
$parcel$export(module.exports, "explodeKeyframes", function () { return $2bda4b27ca97ecb9$export$d8cd3c5362543af4; });

var $log2I = parcelRequire("log2I");
function $2bda4b27ca97ecb9$export$354f03b695313e69(object) {
    /** The final result we will return */ var result = {};
    var debugName = "";
    for(var key in object){
        /** Grab the value upfront */ var val = object[key];
        /** TypeStyle configuration options */ if (key === "$unique") result[$log2I.IS_UNIQUE] = val;
        else if (key === "$nest") {
            var nested = val;
            for(var selector in nested){
                var subproperties = nested[selector];
                result[selector] = $2bda4b27ca97ecb9$export$354f03b695313e69(subproperties).result;
            }
        } else if (key === "$debugName") debugName = val;
        else result[key] = val;
    }
    return {
        result: result,
        debugName: debugName
    };
}
function $2bda4b27ca97ecb9$export$d8cd3c5362543af4(frames) {
    var result = {
        $debugName: undefined,
        keyframes: {}
    };
    for(var offset in frames){
        var val = frames[offset];
        if (offset === "$debugName") result.$debugName = val;
        else result.keyframes[offset] = val;
    }
    return result;
}

});
parcelRequire.register("log2I", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $f92848a4fef73f73$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * The unique id is used for unique hashes.
 */ var $f92848a4fef73f73$var$uniqueId = 0;
/**
 * Tag styles with this string to get unique hashes.
 */ module.exports.IS_UNIQUE = "__DO_NOT_DEDUPE_STYLE__";
var $f92848a4fef73f73$var$upperCasePattern = /[A-Z]/g;
var $f92848a4fef73f73$var$msPattern = /^ms-/;
var $f92848a4fef73f73$var$interpolatePattern = /&/g;
var $f92848a4fef73f73$var$escapePattern = /[ !#$%&()*+,./;<=>?@[\]^`{|}~"'\\]/g;
var $f92848a4fef73f73$var$propLower = function(m) {
    return "-" + m.toLowerCase();
};
/**
 * CSS properties that are valid unit-less numbers.
 */ var $f92848a4fef73f73$var$cssNumberProperties = [
    "animation-iteration-count",
    "box-flex",
    "box-flex-group",
    "column-count",
    "counter-increment",
    "counter-reset",
    "flex",
    "flex-grow",
    "flex-positive",
    "flex-shrink",
    "flex-negative",
    "font-weight",
    "line-clamp",
    "line-height",
    "opacity",
    "order",
    "orphans",
    "tab-size",
    "widows",
    "z-index",
    "zoom",
    // SVG properties.
    "fill-opacity",
    "stroke-dashoffset",
    "stroke-opacity",
    "stroke-width"
];
/**
 * Map of css number properties.
 */ var $f92848a4fef73f73$var$CSS_NUMBER = Object.create(null);
// Add vendor prefixes to all unit-less properties.
for(var $f92848a4fef73f73$var$_i = 0, $f92848a4fef73f73$var$_a = [
    "-webkit-",
    "-ms-",
    "-moz-",
    "-o-",
    ""
]; $f92848a4fef73f73$var$_i < $f92848a4fef73f73$var$_a.length; $f92848a4fef73f73$var$_i++){
    var $f92848a4fef73f73$var$prefix = $f92848a4fef73f73$var$_a[$f92848a4fef73f73$var$_i];
    for(var $f92848a4fef73f73$var$_b = 0, $f92848a4fef73f73$var$cssNumberProperties_1 = $f92848a4fef73f73$var$cssNumberProperties; $f92848a4fef73f73$var$_b < $f92848a4fef73f73$var$cssNumberProperties_1.length; $f92848a4fef73f73$var$_b++){
        var $f92848a4fef73f73$var$property = $f92848a4fef73f73$var$cssNumberProperties_1[$f92848a4fef73f73$var$_b];
        $f92848a4fef73f73$var$CSS_NUMBER[$f92848a4fef73f73$var$prefix + $f92848a4fef73f73$var$property] = true;
    }
}
/**
 * Escape a CSS class name.
 */ module.exports.escape = function(str) {
    return str.replace($f92848a4fef73f73$var$escapePattern, "\\$&");
};
/**
 * Transform a JavaScript property into a CSS property.
 */ function $f92848a4fef73f73$var$hyphenate(propertyName) {
    return propertyName.replace($f92848a4fef73f73$var$upperCasePattern, $f92848a4fef73f73$var$propLower).replace($f92848a4fef73f73$var$msPattern, "-ms-"); // Internet Explorer vendor prefix.
}
module.exports.hyphenate = $f92848a4fef73f73$var$hyphenate;
/**
 * Generate a hash value from a string.
 */ function $f92848a4fef73f73$var$stringHash(str) {
    var value = 5381;
    var len = str.length;
    while(len--)value = value * 33 ^ str.charCodeAt(len);
    return (value >>> 0).toString(36);
}
module.exports.stringHash = $f92848a4fef73f73$var$stringHash;
/**
 * Transform a style string to a CSS string.
 */ function $f92848a4fef73f73$var$styleToString(key, value) {
    if (typeof value === "number" && value !== 0 && !$f92848a4fef73f73$var$CSS_NUMBER[key]) return key + ":" + value + "px";
    return key + ":" + value;
}
/**
 * Sort an array of tuples by first value.
 */ function $f92848a4fef73f73$var$sortTuples(value) {
    return value.sort(function(a, b) {
        return a[0] > b[0] ? 1 : -1;
    });
}
/**
 * Categorize user styles.
 */ function $f92848a4fef73f73$var$parseStyles(styles, hasNestedStyles) {
    var properties = [];
    var nestedStyles = [];
    var isUnique = false;
    // Sort keys before adding to styles.
    for(var _i = 0, _a = Object.keys(styles); _i < _a.length; _i++){
        var key = _a[_i];
        var value = styles[key];
        if (value !== null && value !== undefined) {
            if (key === module.exports.IS_UNIQUE) isUnique = true;
            else if (typeof value === "object" && !Array.isArray(value)) nestedStyles.push([
                key.trim(),
                value
            ]);
            else properties.push([
                $f92848a4fef73f73$var$hyphenate(key.trim()),
                value
            ]);
        }
    }
    return {
        styleString: $f92848a4fef73f73$var$stringifyProperties($f92848a4fef73f73$var$sortTuples(properties)),
        nestedStyles: hasNestedStyles ? nestedStyles : $f92848a4fef73f73$var$sortTuples(nestedStyles),
        isUnique: isUnique
    };
}
/**
 * Stringify an array of property tuples.
 */ function $f92848a4fef73f73$var$stringifyProperties(properties) {
    return properties.map(function(_a) {
        var name = _a[0], value = _a[1];
        if (!Array.isArray(value)) return $f92848a4fef73f73$var$styleToString(name, value);
        return value.map(function(x) {
            return $f92848a4fef73f73$var$styleToString(name, x);
        }).join(";");
    }).join(";");
}
/**
 * Interpolate CSS selectors.
 */ function $f92848a4fef73f73$var$interpolate(selector, parent) {
    if (selector.indexOf("&") > -1) return selector.replace($f92848a4fef73f73$var$interpolatePattern, parent);
    return parent + " " + selector;
}
/**
 * Recursive loop building styles with deferred selectors.
 */ function $f92848a4fef73f73$var$stylize(cache, selector, styles, list, parent) {
    var _a = $f92848a4fef73f73$var$parseStyles(styles, !!selector), styleString = _a.styleString, nestedStyles = _a.nestedStyles, isUnique = _a.isUnique;
    var pid = styleString;
    if (selector.charCodeAt(0) === 64 /* @ */ ) {
        var rule = cache.add(new $f92848a4fef73f73$var$Rule(selector, parent ? undefined : styleString, cache.hash));
        // Nested styles support (e.g. `.foo > @media > .bar`).
        if (styleString && parent) {
            var style = rule.add(new $f92848a4fef73f73$var$Style(styleString, rule.hash, isUnique ? "u" + (++$f92848a4fef73f73$var$uniqueId).toString(36) : undefined));
            list.push([
                parent,
                style
            ]);
        }
        for(var _i = 0, nestedStyles_1 = nestedStyles; _i < nestedStyles_1.length; _i++){
            var _b = nestedStyles_1[_i], name = _b[0], value = _b[1];
            pid += name + $f92848a4fef73f73$var$stylize(rule, name, value, list, parent);
        }
    } else {
        var key = parent ? $f92848a4fef73f73$var$interpolate(selector, parent) : selector;
        if (styleString) {
            var style = cache.add(new $f92848a4fef73f73$var$Style(styleString, cache.hash, isUnique ? "u" + (++$f92848a4fef73f73$var$uniqueId).toString(36) : undefined));
            list.push([
                key,
                style
            ]);
        }
        for(var _c = 0, nestedStyles_2 = nestedStyles; _c < nestedStyles_2.length; _c++){
            var _d = nestedStyles_2[_c], name = _d[0], value = _d[1];
            pid += name + $f92848a4fef73f73$var$stylize(cache, name, value, list, key);
        }
    }
    return pid;
}
/**
 * Register all styles, but collect for selector interpolation using the hash.
 */ function $f92848a4fef73f73$var$composeStyles(container, selector, styles, isStyle, displayName) {
    var cache = new $f92848a4fef73f73$var$Cache(container.hash);
    var list = [];
    var pid = $f92848a4fef73f73$var$stylize(cache, selector, styles, list);
    var hash = "f" + cache.hash(pid);
    var id = displayName ? displayName + "_" + hash : hash;
    for(var _i = 0, list_1 = list; _i < list_1.length; _i++){
        var _a = list_1[_i], selector_1 = _a[0], style = _a[1];
        var key = isStyle ? $f92848a4fef73f73$var$interpolate(selector_1, "." + module.exports.escape(id)) : selector_1;
        style.add(new $f92848a4fef73f73$var$Selector(key, style.hash, undefined, pid));
    }
    return {
        cache: cache,
        pid: pid,
        id: id
    };
}
/**
 * Cache to list to styles.
 */ function $f92848a4fef73f73$var$join(arr) {
    var res = "";
    for(var i = 0; i < arr.length; i++)res += arr[i];
    return res;
}
/**
 * Noop changes.
 */ var $f92848a4fef73f73$var$noopChanges = {
    add: function() {
        return undefined;
    },
    change: function() {
        return undefined;
    },
    remove: function() {
        return undefined;
    }
};
/**
 * Implement a cache/event emitter.
 */ var $f92848a4fef73f73$var$Cache = /** @class */ function() {
    function Cache(hash, changes) {
        if (hash === void 0) hash = $f92848a4fef73f73$var$stringHash;
        if (changes === void 0) changes = $f92848a4fef73f73$var$noopChanges;
        this.hash = hash;
        this.changes = changes;
        this.sheet = [];
        this.changeId = 0;
        this._keys = [];
        this._children = Object.create(null);
        this._counters = Object.create(null);
    }
    Cache.prototype.add = function(style) {
        var count = this._counters[style.id] || 0;
        var item = this._children[style.id] || style.clone();
        this._counters[style.id] = count + 1;
        if (count === 0) {
            this._children[item.id] = item;
            this._keys.push(item.id);
            this.sheet.push(item.getStyles());
            this.changeId++;
            this.changes.add(item, this._keys.length - 1);
        } else {
            // Check if contents are different.
            if (item.getIdentifier() !== style.getIdentifier()) throw new TypeError("Hash collision: " + style.getStyles() + " === " + item.getStyles());
            var oldIndex = this._keys.indexOf(style.id);
            var newIndex = this._keys.length - 1;
            var prevChangeId = this.changeId;
            if (oldIndex !== newIndex) {
                this._keys.splice(oldIndex, 1);
                this._keys.push(style.id);
                this.changeId++;
            }
            if (item instanceof Cache && style instanceof Cache) {
                var prevChangeId_1 = item.changeId;
                item.merge(style);
                if (item.changeId !== prevChangeId_1) this.changeId++;
            }
            if (this.changeId !== prevChangeId) {
                if (oldIndex === newIndex) this.sheet.splice(oldIndex, 1, item.getStyles());
                else {
                    this.sheet.splice(oldIndex, 1);
                    this.sheet.splice(newIndex, 0, item.getStyles());
                }
                this.changes.change(item, oldIndex, newIndex);
            }
        }
        return item;
    };
    Cache.prototype.remove = function(style) {
        var count = this._counters[style.id];
        if (count > 0) {
            this._counters[style.id] = count - 1;
            var item = this._children[style.id];
            var index = this._keys.indexOf(item.id);
            if (count === 1) {
                delete this._counters[style.id];
                delete this._children[style.id];
                this._keys.splice(index, 1);
                this.sheet.splice(index, 1);
                this.changeId++;
                this.changes.remove(item, index);
            } else if (item instanceof Cache && style instanceof Cache) {
                var prevChangeId = item.changeId;
                item.unmerge(style);
                if (item.changeId !== prevChangeId) {
                    this.sheet.splice(index, 1, item.getStyles());
                    this.changeId++;
                    this.changes.change(item, index, index);
                }
            }
        }
    };
    Cache.prototype.merge = function(cache) {
        for(var _i = 0, _a = cache._keys; _i < _a.length; _i++){
            var id = _a[_i];
            this.add(cache._children[id]);
        }
        return this;
    };
    Cache.prototype.unmerge = function(cache) {
        for(var _i = 0, _a = cache._keys; _i < _a.length; _i++){
            var id = _a[_i];
            this.remove(cache._children[id]);
        }
        return this;
    };
    Cache.prototype.clone = function() {
        return new Cache(this.hash).merge(this);
    };
    return Cache;
}();
module.exports.Cache = $f92848a4fef73f73$var$Cache;
/**
 * Selector is a dumb class made to represent nested CSS selectors.
 */ var $f92848a4fef73f73$var$Selector = /** @class */ function() {
    function Selector(selector, hash, id, pid) {
        if (id === void 0) id = "s" + hash(selector);
        if (pid === void 0) pid = "";
        this.selector = selector;
        this.hash = hash;
        this.id = id;
        this.pid = pid;
    }
    Selector.prototype.getStyles = function() {
        return this.selector;
    };
    Selector.prototype.getIdentifier = function() {
        return this.pid + "." + this.selector;
    };
    Selector.prototype.clone = function() {
        return new Selector(this.selector, this.hash, this.id, this.pid);
    };
    return Selector;
}();
module.exports.Selector = $f92848a4fef73f73$var$Selector;
/**
 * The style container registers a style string with selectors.
 */ var $f92848a4fef73f73$var$Style = /** @class */ function(_super) {
    $f92848a4fef73f73$var$__extends(Style, _super);
    function Style(style, hash, id) {
        if (id === void 0) id = "c" + hash(style);
        var _this = _super.call(this, hash) || this;
        _this.style = style;
        _this.hash = hash;
        _this.id = id;
        return _this;
    }
    Style.prototype.getStyles = function() {
        return this.sheet.join(",") + "{" + this.style + "}";
    };
    Style.prototype.getIdentifier = function() {
        return this.style;
    };
    Style.prototype.clone = function() {
        return new Style(this.style, this.hash, this.id).merge(this);
    };
    return Style;
}($f92848a4fef73f73$var$Cache);
module.exports.Style = $f92848a4fef73f73$var$Style;
/**
 * Implement rule logic for style output.
 */ var $f92848a4fef73f73$var$Rule = /** @class */ function(_super) {
    $f92848a4fef73f73$var$__extends(Rule, _super);
    function Rule(rule, style, hash, id, pid) {
        if (style === void 0) style = "";
        if (id === void 0) id = "a" + hash(rule + "." + style);
        if (pid === void 0) pid = "";
        var _this = _super.call(this, hash) || this;
        _this.rule = rule;
        _this.style = style;
        _this.hash = hash;
        _this.id = id;
        _this.pid = pid;
        return _this;
    }
    Rule.prototype.getStyles = function() {
        return this.rule + "{" + this.style + $f92848a4fef73f73$var$join(this.sheet) + "}";
    };
    Rule.prototype.getIdentifier = function() {
        return this.pid + "." + this.rule + "." + this.style;
    };
    Rule.prototype.clone = function() {
        return new Rule(this.rule, this.style, this.hash, this.id, this.pid).merge(this);
    };
    return Rule;
}($f92848a4fef73f73$var$Cache);
module.exports.Rule = $f92848a4fef73f73$var$Rule;
/**
 * The FreeStyle class implements the API for everything else.
 */ var $f92848a4fef73f73$var$FreeStyle = /** @class */ function(_super) {
    $f92848a4fef73f73$var$__extends(FreeStyle, _super);
    function FreeStyle(hash, debug, id, changes) {
        if (hash === void 0) hash = $f92848a4fef73f73$var$stringHash;
        if (debug === void 0) debug = typeof $4TNnu !== "undefined" && false;
        if (id === void 0) id = "f" + (++$f92848a4fef73f73$var$uniqueId).toString(36);
        var _this = _super.call(this, hash, changes) || this;
        _this.hash = hash;
        _this.debug = debug;
        _this.id = id;
        return _this;
    }
    FreeStyle.prototype.registerStyle = function(styles, displayName) {
        var debugName = this.debug ? displayName : undefined;
        var _a = $f92848a4fef73f73$var$composeStyles(this, "&", styles, true, debugName), cache = _a.cache, id = _a.id;
        this.merge(cache);
        return id;
    };
    FreeStyle.prototype.registerKeyframes = function(keyframes, displayName) {
        return this.registerHashRule("@keyframes", keyframes, displayName);
    };
    FreeStyle.prototype.registerHashRule = function(prefix, styles, displayName) {
        var debugName = this.debug ? displayName : undefined;
        var _a = $f92848a4fef73f73$var$composeStyles(this, "", styles, false, debugName), cache = _a.cache, pid = _a.pid, id = _a.id;
        var rule = new $f92848a4fef73f73$var$Rule(prefix + " " + module.exports.escape(id), undefined, this.hash, undefined, pid);
        this.add(rule.merge(cache));
        return id;
    };
    FreeStyle.prototype.registerRule = function(rule, styles) {
        this.merge($f92848a4fef73f73$var$composeStyles(this, rule, styles, false).cache);
    };
    FreeStyle.prototype.registerCss = function(styles) {
        this.merge($f92848a4fef73f73$var$composeStyles(this, "", styles, false).cache);
    };
    FreeStyle.prototype.getStyles = function() {
        return $f92848a4fef73f73$var$join(this.sheet);
    };
    FreeStyle.prototype.getIdentifier = function() {
        return this.id;
    };
    FreeStyle.prototype.clone = function() {
        return new FreeStyle(this.hash, this.debug, this.id, this.changes).merge(this);
    };
    return FreeStyle;
}($f92848a4fef73f73$var$Cache);
module.exports.FreeStyle = $f92848a4fef73f73$var$FreeStyle;
/**
 * Exports a simple function to create a new instance.
 */ function $f92848a4fef73f73$var$create(hash, debug, changes) {
    return new $f92848a4fef73f73$var$FreeStyle(hash, debug, undefined, changes);
}
module.exports.create = $f92848a4fef73f73$var$create;

});
parcelRequire.register("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});



parcelRequire.register("a2AKD", function(module, exports) {

$parcel$export(module.exports, "raf", function () { return $74f6994cd089e249$export$27f233d61a9e2fa4; });
$parcel$export(module.exports, "extend", function () { return $74f6994cd089e249$export$8b58be045bf06082; });
/** Raf for node + browser */ var $74f6994cd089e249$export$27f233d61a9e2fa4 = typeof requestAnimationFrame === "undefined" ? function(cb) {
    return setTimeout(cb);
} : typeof window === "undefined" ? requestAnimationFrame : requestAnimationFrame.bind(window);
function $74f6994cd089e249$export$188d75d71883854a() {
    var classes = [];
    for(var _i = 0; _i < arguments.length; _i++)classes[_i] = arguments[_i];
    return classes.filter(function(c) {
        return !!c;
    }).join(" ");
}
function $74f6994cd089e249$export$8b58be045bf06082() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    /** The final result we will return */ var result = {};
    for(var _a = 0, objects_1 = objects; _a < objects_1.length; _a++){
        var object = objects_1[_a];
        if (object == null || object === false) continue;
        for(var key in object){
            /** Falsy values except a explicit 0 is ignored */ var val = object[key];
            if (!val && val !== 0) continue;
            /** if nested media or pseudo selector */ if (key === "$nest" && val) result[key] = result["$nest"] ? $74f6994cd089e249$export$8b58be045bf06082(result["$nest"], val) : val;
            else if (key.indexOf("&") !== -1 || key.indexOf("@media") === 0) result[key] = result[key] ? $74f6994cd089e249$export$8b58be045bf06082(result[key], val) : val;
            else result[key] = val;
        }
    }
    return result;
}
var $74f6994cd089e249$export$987d49ffe1b0900f = function(mediaQuery) {
    var objects = [];
    for(var _i = 1; _i < arguments.length; _i++)objects[_i - 1] = arguments[_i];
    var mediaQuerySections = [];
    if (mediaQuery.type) mediaQuerySections.push(mediaQuery.type);
    if (mediaQuery.orientation) mediaQuerySections.push("(orientation: " + mediaQuery.orientation + ")");
    if (mediaQuery.minWidth) mediaQuerySections.push("(min-width: " + $74f6994cd089e249$var$mediaLength(mediaQuery.minWidth) + ")");
    if (mediaQuery.maxWidth) mediaQuerySections.push("(max-width: " + $74f6994cd089e249$var$mediaLength(mediaQuery.maxWidth) + ")");
    if (mediaQuery.minHeight) mediaQuerySections.push("(min-height: " + $74f6994cd089e249$var$mediaLength(mediaQuery.minHeight) + ")");
    if (mediaQuery.maxHeight) mediaQuerySections.push("(max-height: " + $74f6994cd089e249$var$mediaLength(mediaQuery.maxHeight) + ")");
    var stringMediaQuery = "@media " + mediaQuerySections.join(" and ");
    var object = {
        $nest: (_a = {}, _a[stringMediaQuery] = $74f6994cd089e249$export$8b58be045bf06082.apply(void 0, objects), _a)
    };
    var _a;
    return object;
};
var $74f6994cd089e249$var$mediaLength = function(value) {
    return typeof value === "string" ? value : value + "px";
};

});


parcelRequire.register("evRVb", function(module, exports) {

});



parcelRequire.register("ekQDt", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $a6fbc35045ae4d9f$export$1e511d4a378977f5; }, function (v) { return $a6fbc35045ae4d9f$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "layerParent", function () { return $a6fbc35045ae4d9f$export$c6c37be152a31153; }, function (v) { return $a6fbc35045ae4d9f$export$c6c37be152a31153 = v; });
$parcel$export(module.exports, "attachToLayerParent", function () { return $a6fbc35045ae4d9f$export$ca4415b02b8662e7; }, function (v) { return $a6fbc35045ae4d9f$export$ca4415b02b8662e7 = v; });
$parcel$export(module.exports, "newLayer", function () { return $a6fbc35045ae4d9f$export$295f0fc612b00262; }, function (v) { return $a6fbc35045ae4d9f$export$295f0fc612b00262 = v; });
$parcel$export(module.exports, "attachToTop", function () { return $a6fbc35045ae4d9f$export$bd21ab662c8c7677; }, function (v) { return $a6fbc35045ae4d9f$export$bd21ab662c8c7677 = v; });
$parcel$export(module.exports, "attachToRight", function () { return $a6fbc35045ae4d9f$export$702d77a296cd4a2b; }, function (v) { return $a6fbc35045ae4d9f$export$702d77a296cd4a2b = v; });
$parcel$export(module.exports, "attachToBottom", function () { return $a6fbc35045ae4d9f$export$56f988ffab6eb04f; }, function (v) { return $a6fbc35045ae4d9f$export$56f988ffab6eb04f = v; });
$parcel$export(module.exports, "attachToLeft", function () { return $a6fbc35045ae4d9f$export$6e1b42d8ae114234; }, function (v) { return $a6fbc35045ae4d9f$export$6e1b42d8ae114234 = v; });
$parcel$export(module.exports, "pageTop", function () { return $a6fbc35045ae4d9f$export$6b12b8f36599507a; }, function (v) { return $a6fbc35045ae4d9f$export$6b12b8f36599507a = v; });
$parcel$export(module.exports, "pageRight", function () { return $a6fbc35045ae4d9f$export$5a1d902c18b065bf; }, function (v) { return $a6fbc35045ae4d9f$export$5a1d902c18b065bf = v; });
$parcel$export(module.exports, "pageBottom", function () { return $a6fbc35045ae4d9f$export$e332a27e180e6801; }, function (v) { return $a6fbc35045ae4d9f$export$e332a27e180e6801 = v; });
$parcel$export(module.exports, "pageLeft", function () { return $a6fbc35045ae4d9f$export$6c6705749bcdb848; }, function (v) { return $a6fbc35045ae4d9f$export$6c6705749bcdb848 = v; });
var $a6fbc35045ae4d9f$export$1e511d4a378977f5;
/**
 * New layer parent
 */ var $a6fbc35045ae4d9f$export$c6c37be152a31153;
/**
 * Use this to attach to any parent layer
 * and then you can use `left`/`top` etc to position yourself
 */ var $a6fbc35045ae4d9f$export$ca4415b02b8662e7;
/**
 * This new layer will attach itself to the nearest parent with `position:relative` or `position:absolute`
 * And will become the new `layerParent`
 */ var $a6fbc35045ae4d9f$export$295f0fc612b00262;
var $a6fbc35045ae4d9f$export$bd21ab662c8c7677;
var $a6fbc35045ae4d9f$export$702d77a296cd4a2b;
var $a6fbc35045ae4d9f$export$56f988ffab6eb04f;
var $a6fbc35045ae4d9f$export$6e1b42d8ae114234;
var $a6fbc35045ae4d9f$export$6b12b8f36599507a;
var $a6fbc35045ae4d9f$export$5a1d902c18b065bf;
var $a6fbc35045ae4d9f$export$e332a27e180e6801;
var $a6fbc35045ae4d9f$export$6c6705749bcdb848;
"use strict";
$a6fbc35045ae4d9f$export$1e511d4a378977f5 = true;
parcelRequire("4LfDI");
var $a2AKD = parcelRequire("a2AKD");
$a6fbc35045ae4d9f$export$c6c37be152a31153 = {
    position: "relative"
};
$a6fbc35045ae4d9f$export$ca4415b02b8662e7 = {
    position: "absolute"
};
$a6fbc35045ae4d9f$export$295f0fc612b00262 = $a2AKD.extend($a6fbc35045ae4d9f$export$ca4415b02b8662e7, {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
});
$a6fbc35045ae4d9f$export$bd21ab662c8c7677 = $a2AKD.extend($a6fbc35045ae4d9f$export$ca4415b02b8662e7, {
    top: 0,
    left: 0,
    right: 0
});
$a6fbc35045ae4d9f$export$702d77a296cd4a2b = $a2AKD.extend($a6fbc35045ae4d9f$export$ca4415b02b8662e7, {
    top: 0,
    right: 0,
    bottom: 0
});
$a6fbc35045ae4d9f$export$56f988ffab6eb04f = $a2AKD.extend($a6fbc35045ae4d9f$export$ca4415b02b8662e7, {
    right: 0,
    bottom: 0,
    left: 0
});
$a6fbc35045ae4d9f$export$6e1b42d8ae114234 = $a2AKD.extend($a6fbc35045ae4d9f$export$ca4415b02b8662e7, {
    top: 0,
    bottom: 0,
    left: 0
});
/**
 * Helps fixing to page
 */ var $a6fbc35045ae4d9f$var$fixed = {
    position: "fixed"
};
$a6fbc35045ae4d9f$export$6b12b8f36599507a = $a2AKD.extend($a6fbc35045ae4d9f$var$fixed, {
    top: 0,
    left: 0,
    right: 0
});
$a6fbc35045ae4d9f$export$5a1d902c18b065bf = $a2AKD.extend($a6fbc35045ae4d9f$var$fixed, {
    top: 0,
    right: 0,
    bottom: 0
});
$a6fbc35045ae4d9f$export$e332a27e180e6801 = $a2AKD.extend($a6fbc35045ae4d9f$var$fixed, {
    right: 0,
    bottom: 0,
    left: 0
});
$a6fbc35045ae4d9f$export$6c6705749bcdb848 = $a2AKD.extend($a6fbc35045ae4d9f$var$fixed, {
    top: 0,
    bottom: 0,
    left: 0
});

});

parcelRequire.register("eA0m8", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $a9d4b42ec45e3885$export$1e511d4a378977f5; }, function (v) { return $a9d4b42ec45e3885$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "padding", function () { return $a9d4b42ec45e3885$export$6f98e8eaf0be1996; }, function (v) { return $a9d4b42ec45e3885$export$6f98e8eaf0be1996 = v; });
$parcel$export(module.exports, "margin", function () { return $a9d4b42ec45e3885$export$7ede87f9b603dd3c; }, function (v) { return $a9d4b42ec45e3885$export$7ede87f9b603dd3c = v; });
$parcel$export(module.exports, "border", function () { return $a9d4b42ec45e3885$export$1edee58a52776cd9; }, function (v) { return $a9d4b42ec45e3885$export$1edee58a52776cd9 = v; });
$parcel$export(module.exports, "verticallySpaced", function () { return $a9d4b42ec45e3885$export$cc4ad74780f5e4cc; }, function (v) { return $a9d4b42ec45e3885$export$cc4ad74780f5e4cc = v; });
$parcel$export(module.exports, "horizontallySpaced", function () { return $a9d4b42ec45e3885$export$e5ae968fc3eef8dc; }, function (v) { return $a9d4b42ec45e3885$export$e5ae968fc3eef8dc = v; });
$parcel$export(module.exports, "gridSpaced", function () { return $a9d4b42ec45e3885$export$da63eba632613abb; }, function (v) { return $a9d4b42ec45e3885$export$da63eba632613abb = v; });
$parcel$export(module.exports, "fillParent", function () { return $a9d4b42ec45e3885$export$ce0f41cc7ea38861; }, function (v) { return $a9d4b42ec45e3885$export$ce0f41cc7ea38861 = v; });
$parcel$export(module.exports, "maxWidth", function () { return $a9d4b42ec45e3885$export$488fda99655ff65a; }, function (v) { return $a9d4b42ec45e3885$export$488fda99655ff65a = v; });
$parcel$export(module.exports, "maxHeight", function () { return $a9d4b42ec45e3885$export$dc0d8bd0b94f8570; }, function (v) { return $a9d4b42ec45e3885$export$dc0d8bd0b94f8570 = v; });
$parcel$export(module.exports, "horizontallyCenterSelf", function () { return $a9d4b42ec45e3885$export$22892fad59e2913; }, function (v) { return $a9d4b42ec45e3885$export$22892fad59e2913 = v; });
$parcel$export(module.exports, "horizontallyCenterChildren", function () { return $a9d4b42ec45e3885$export$2a511cc081aa03ab; }, function (v) { return $a9d4b42ec45e3885$export$2a511cc081aa03ab = v; });
$parcel$export(module.exports, "height", function () { return $a9d4b42ec45e3885$export$ac607276a8fe9f0a; }, function (v) { return $a9d4b42ec45e3885$export$ac607276a8fe9f0a = v; });
$parcel$export(module.exports, "width", function () { return $a9d4b42ec45e3885$export$7e3df82ee760448c; }, function (v) { return $a9d4b42ec45e3885$export$7e3df82ee760448c = v; });
var $a9d4b42ec45e3885$export$1e511d4a378977f5;
var $a9d4b42ec45e3885$export$6f98e8eaf0be1996;
var $a9d4b42ec45e3885$export$7ede87f9b603dd3c;
var $a9d4b42ec45e3885$export$1edee58a52776cd9;
/**
 * Puts a vertical margin between each child
 */ var $a9d4b42ec45e3885$export$cc4ad74780f5e4cc;
/**
 * Puts a horizontal margin between each child
 */ var $a9d4b42ec45e3885$export$e5ae968fc3eef8dc;
/**
 * Puts a (horizontal AND vertical) margin between each child
 */ var $a9d4b42ec45e3885$export$da63eba632613abb;
/**
 * Gives this element the same size as the nearest offsetParent
 */ var $a9d4b42ec45e3885$export$ce0f41cc7ea38861;
/** mixin: maxWidth */ var $a9d4b42ec45e3885$export$488fda99655ff65a;
/** mixin: maxHeight */ var $a9d4b42ec45e3885$export$dc0d8bd0b94f8570;
/**
 * Block elements: Centering *self* using margins
 */ var $a9d4b42ec45e3885$export$22892fad59e2913;
/**
 * Block elements: Centering *child* elements using textAlign
 */ var $a9d4b42ec45e3885$export$2a511cc081aa03ab;
/** mixin: height */ var $a9d4b42ec45e3885$export$ac607276a8fe9f0a;
/** mixin: width */ var $a9d4b42ec45e3885$export$7e3df82ee760448c;
"use strict";
$a9d4b42ec45e3885$export$1e511d4a378977f5 = true;
function $a9d4b42ec45e3885$var$boxUnitToString(value) {
    if (typeof value === "number") return value.toString() + "px";
    else return value;
}
/**
 * Takes a function that expects Box to be passed into it
 * and creates a BoxFunction
 */ function $a9d4b42ec45e3885$var$createBoxFunction(mapFromBox) {
    var result = function(a, b, c, d) {
        if (b === undefined && c === undefined && d === undefined) b = c = d = a;
        else if (c === undefined && d === undefined) {
            c = a;
            d = b;
        }
        var box = {
            top: $a9d4b42ec45e3885$var$boxUnitToString(a),
            right: $a9d4b42ec45e3885$var$boxUnitToString(b),
            bottom: $a9d4b42ec45e3885$var$boxUnitToString(c),
            left: $a9d4b42ec45e3885$var$boxUnitToString(d)
        };
        return mapFromBox(box);
    };
    return result;
}
$a9d4b42ec45e3885$export$6f98e8eaf0be1996 = $a9d4b42ec45e3885$var$createBoxFunction(function(box) {
    return {
        paddingTop: box.top,
        paddingRight: box.right,
        paddingBottom: box.bottom,
        paddingLeft: box.left
    };
});
$a9d4b42ec45e3885$export$7ede87f9b603dd3c = $a9d4b42ec45e3885$var$createBoxFunction(function(box) {
    return {
        marginTop: box.top,
        marginRight: box.right,
        marginBottom: box.bottom,
        marginLeft: box.left
    };
});
$a9d4b42ec45e3885$export$1edee58a52776cd9 = $a9d4b42ec45e3885$var$createBoxFunction(function(box) {
    return {
        borderTop: box.top,
        borderRight: box.right,
        borderBottom: box.bottom,
        borderLeft: box.left
    };
});
$a9d4b42ec45e3885$export$cc4ad74780f5e4cc = function(margin) {
    var spacing = $a9d4b42ec45e3885$var$boxUnitToString(margin);
    return {
        "&>*": {
            marginBottom: spacing + " !important"
        },
        "&>*:last-child": {
            marginBottom: "0px !important"
        }
    };
};
$a9d4b42ec45e3885$export$e5ae968fc3eef8dc = function(margin) {
    var spacing = $a9d4b42ec45e3885$var$boxUnitToString(margin);
    return {
        "&>*": {
            marginRight: spacing + " !important"
        },
        "&>*:last-child": {
            marginRight: "0px !important"
        }
    };
};
$a9d4b42ec45e3885$export$da63eba632613abb = function(margin) {
    var spacing = $a9d4b42ec45e3885$var$boxUnitToString(margin);
    return {
        marginTop: "-" + spacing,
        marginLeft: "-" + spacing,
        "&>*": {
            marginTop: spacing,
            marginLeft: spacing
        }
    };
};
$a9d4b42ec45e3885$export$ce0f41cc7ea38861 = {
    width: "100%",
    height: "100%"
};
$a9d4b42ec45e3885$export$488fda99655ff65a = function(value) {
    var maxWidth = $a9d4b42ec45e3885$var$boxUnitToString(value);
    return {
        maxWidth: maxWidth
    };
};
$a9d4b42ec45e3885$export$dc0d8bd0b94f8570 = function(value) {
    var maxHeight = $a9d4b42ec45e3885$var$boxUnitToString(value);
    return {
        maxHeight: maxHeight
    };
};
$a9d4b42ec45e3885$export$22892fad59e2913 = {
    marginLeft: "auto",
    marginRight: "auto"
};
$a9d4b42ec45e3885$export$2a511cc081aa03ab = {
    textAlign: "center"
};
$a9d4b42ec45e3885$export$ac607276a8fe9f0a = function(value) {
    var height = $a9d4b42ec45e3885$var$boxUnitToString(value);
    return {
        height: height
    };
};
$a9d4b42ec45e3885$export$7e3df82ee760448c = function(value) {
    var width = $a9d4b42ec45e3885$var$boxUnitToString(value);
    return {
        width: width
    };
};

});

parcelRequire.register("lNiW7", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $fddcdced793e7323$export$1e511d4a378977f5; }, function (v) { return $fddcdced793e7323$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "scroll", function () { return $fddcdced793e7323$export$209876d7b1ac8f3; }, function (v) { return $fddcdced793e7323$export$209876d7b1ac8f3 = v; });
$parcel$export(module.exports, "scrollX", function () { return $fddcdced793e7323$export$5320ec237fcf13b2; }, function (v) { return $fddcdced793e7323$export$5320ec237fcf13b2 = v; });
$parcel$export(module.exports, "scrollY", function () { return $fddcdced793e7323$export$2dd824eca41ca48d; }, function (v) { return $fddcdced793e7323$export$2dd824eca41ca48d = v; });
$parcel$export(module.exports, "someChildWillScroll", function () { return $fddcdced793e7323$export$d99b197b29c78e6d; }, function (v) { return $fddcdced793e7323$export$d99b197b29c78e6d = v; });
var $fddcdced793e7323$export$1e511d4a378977f5;
var $fddcdced793e7323$export$209876d7b1ac8f3;
var $fddcdced793e7323$export$5320ec237fcf13b2;
var $fddcdced793e7323$export$2dd824eca41ca48d;
/**
 * If you expect a child somewhere down in the tree to scroll
 * you need to tell the browser to prevent a scroll bar here
 */ var $fddcdced793e7323$export$d99b197b29c78e6d;
"use strict";
$fddcdced793e7323$export$1e511d4a378977f5 = true;
$fddcdced793e7323$export$209876d7b1ac8f3 = {
    "-webkit-overflow-scrolling": "touch",
    overflow: "auto"
};
$fddcdced793e7323$export$5320ec237fcf13b2 = {
    "-webkit-overflow-scrolling": "touch",
    overflowX: "auto"
};
$fddcdced793e7323$export$2dd824eca41ca48d = {
    "-webkit-overflow-scrolling": "touch",
    overflowY: "auto"
};
$fddcdced793e7323$export$d99b197b29c78e6d = {
    overflow: "hidden"
};

});

parcelRequire.register("4KX0F", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $37693b694dbbeafc$export$1e511d4a378977f5; }, function (v) { return $37693b694dbbeafc$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "block", function () { return $37693b694dbbeafc$export$837bd02682cd3db9; }, function (v) { return $37693b694dbbeafc$export$837bd02682cd3db9 = v; });
$parcel$export(module.exports, "none", function () { return $37693b694dbbeafc$export$f883a24d5edde77c; }, function (v) { return $37693b694dbbeafc$export$f883a24d5edde77c = v; });
$parcel$export(module.exports, "inlineBlock", function () { return $37693b694dbbeafc$export$192c1d0055d5e8df; }, function (v) { return $37693b694dbbeafc$export$192c1d0055d5e8df = v; });
$parcel$export(module.exports, "invisible", function () { return $37693b694dbbeafc$export$c99df9cf5e6bee9b; }, function (v) { return $37693b694dbbeafc$export$c99df9cf5e6bee9b = v; });
var $37693b694dbbeafc$export$1e511d4a378977f5;
var $37693b694dbbeafc$export$837bd02682cd3db9;
var $37693b694dbbeafc$export$f883a24d5edde77c;
var $37693b694dbbeafc$export$192c1d0055d5e8df;
var $37693b694dbbeafc$export$c99df9cf5e6bee9b;
"use strict";
$37693b694dbbeafc$export$1e511d4a378977f5 = true;
$37693b694dbbeafc$export$837bd02682cd3db9 = {
    display: "block"
};
$37693b694dbbeafc$export$f883a24d5edde77c = {
    display: "none"
};
$37693b694dbbeafc$export$192c1d0055d5e8df = {
    display: "inline-block"
};
$37693b694dbbeafc$export$c99df9cf5e6bee9b = {
    visibility: "hidden"
};

});

parcelRequire.register("bkbgr", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $83ea4cc65a94cc7f$export$1e511d4a378977f5; }, function (v) { return $83ea4cc65a94cc7f$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "normalize", function () { return $83ea4cc65a94cc7f$export$a3295358bff77e; }, function (v) { return $83ea4cc65a94cc7f$export$a3295358bff77e = v; });
var $83ea4cc65a94cc7f$export$1e511d4a378977f5;
var $83ea4cc65a94cc7f$export$a3295358bff77e;
"use strict";
$83ea4cc65a94cc7f$export$1e511d4a378977f5 = true;

var $4LfDI = parcelRequire("4LfDI");
/**
 * Adds normalize.css to the registerd outputs
 */ function $83ea4cc65a94cc7f$var$normalize() {
    /**
     * To update:
     * - https://cdnjs.com/libraries/normalize
     * - then latest. Currently https://cdnjs.cloudflare.com/ajax/libs/normalize/5.0.0/normalize.min.css
     * - then copy paste raw below
     * - remove the sourmap at the end of the file
     * - fix the test (checks length of raw)
     * - update the link in this comment
     *
     * Release
     * - If its a major version change in nomalize. Release as a major change in typestyle.
     * - otherwise minor
     **/ $4LfDI.cssRaw("\n    button,hr,input{overflow:visible}audio,canvas,progress,video{display:inline-block}progress,sub,sup{vertical-align:baseline}html{font-family:sans-serif;line-height:1.15;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0} menu,article,aside,details,footer,header,nav,section{display:block}h1{font-size:2em;margin:.67em 0}figcaption,figure,main{display:block}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}dfn{font-style:italic}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}audio:not([controls]){display:none;height:0}img{border-style:none}svg:not(:root){overflow:hidden}button,input,optgroup,select,textarea{font-family:sans-serif;font-size:100%;line-height:1.15;margin:0}button,input{}button,select{text-transform:none}[type=submit], [type=reset],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:ButtonText dotted 1px}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}[hidden],template{display:none}\n    ".trim());
}
$83ea4cc65a94cc7f$export$a3295358bff77e = $83ea4cc65a94cc7f$var$normalize;

});

parcelRequire.register("8GpuA", function(module, exports) {

$parcel$export(module.exports, "__esModule", function () { return $6526053ec5c447c1$export$1e511d4a378977f5; }, function (v) { return $6526053ec5c447c1$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "setupPage", function () { return $6526053ec5c447c1$export$a26df9904c51488d; }, function (v) { return $6526053ec5c447c1$export$a26df9904c51488d = v; });
var $6526053ec5c447c1$export$1e511d4a378977f5;
var $6526053ec5c447c1$export$a26df9904c51488d;
"use strict";
$6526053ec5c447c1$export$1e511d4a378977f5 = true;

var $4LfDI = parcelRequire("4LfDI");

var $eA0m8 = parcelRequire("eA0m8");
/**
 * Recommended Page setup
 * - Sets up the body to be full size
 * - Sets up box sizing to be border box
 **/ function $6526053ec5c447c1$var$setupPage(rootSelector) {
    /** Use full window size for application */ $4LfDI.cssRule("html, body", {
        height: "100%",
        width: "100%",
        padding: 0,
        margin: 0
    });
    /** Use border box */ $4LfDI.cssRule("html", {
        "-moz-box-sizing": "border-box",
        "-webkit-box-sizing": "border-box",
        boxSizing: "border-box"
    });
    $4LfDI.cssRule("*,*:before,*:after", {
        boxSizing: "inherit"
    });
    /** Also root should fill parent */ $4LfDI.cssRule(rootSelector, $eA0m8.fillParent);
}
$6526053ec5c447c1$export$a26df9904c51488d = $6526053ec5c447c1$var$setupPage;

});

parcelRequire.register("foRq4", function(module, exports) {
/** @license React v16.9.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4yvvI = parcelRequire("4yvvI");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$t(a) {
    for(var b = a.message, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, d = 1; d < arguments.length; d++)c += "&args[]=" + encodeURIComponent(arguments[d]);
    a.message = "Minified React error #" + b + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";
    return a;
}
if (!$bh6RR) throw $b36288e2db101ba3$var$t(Error(227));
var $b36288e2db101ba3$var$ba = null, $b36288e2db101ba3$var$ca = {};
function $b36288e2db101ba3$var$da() {
    if ($b36288e2db101ba3$var$ba) for(var a in $b36288e2db101ba3$var$ca){
        var b = $b36288e2db101ba3$var$ca[a], c = $b36288e2db101ba3$var$ba.indexOf(a);
        if (!(-1 < c)) throw $b36288e2db101ba3$var$t(Error(96), a);
        if (!$b36288e2db101ba3$var$ea[c]) {
            if (!b.extractEvents) throw $b36288e2db101ba3$var$t(Error(97), a);
            $b36288e2db101ba3$var$ea[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], h = b, g = d;
                if ($b36288e2db101ba3$var$fa.hasOwnProperty(g)) throw $b36288e2db101ba3$var$t(Error(99), g);
                $b36288e2db101ba3$var$fa[g] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && $b36288e2db101ba3$var$ha(k[e], h, g);
                    e = !0;
                } else f.registrationName ? ($b36288e2db101ba3$var$ha(f.registrationName, h, g), e = !0) : e = !1;
                if (!e) throw $b36288e2db101ba3$var$t(Error(98), d, a);
            }
        }
    }
}
function $b36288e2db101ba3$var$ha(a, b, c) {
    if ($b36288e2db101ba3$var$ia[a]) throw $b36288e2db101ba3$var$t(Error(100), a);
    $b36288e2db101ba3$var$ia[a] = b;
    $b36288e2db101ba3$var$ja[a] = b.eventTypes[c].dependencies;
}
var $b36288e2db101ba3$var$ea = [], $b36288e2db101ba3$var$fa = {}, $b36288e2db101ba3$var$ia = {}, $b36288e2db101ba3$var$ja = {};
function $b36288e2db101ba3$var$ka(a, b, c, d, e, f, h, g, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $b36288e2db101ba3$var$la = !1, $b36288e2db101ba3$var$ma = null, $b36288e2db101ba3$var$na = !1, $b36288e2db101ba3$var$oa = null, $b36288e2db101ba3$var$pa = {
    onError: function(a) {
        $b36288e2db101ba3$var$la = !0;
        $b36288e2db101ba3$var$ma = a;
    }
};
function $b36288e2db101ba3$var$qa(a, b, c, d, e, f, h, g, k) {
    $b36288e2db101ba3$var$la = !1;
    $b36288e2db101ba3$var$ma = null;
    $b36288e2db101ba3$var$ka.apply($b36288e2db101ba3$var$pa, arguments);
}
function $b36288e2db101ba3$var$ra(a, b, c, d, e, f, h, g, k) {
    $b36288e2db101ba3$var$qa.apply(this, arguments);
    if ($b36288e2db101ba3$var$la) {
        if ($b36288e2db101ba3$var$la) {
            var l = $b36288e2db101ba3$var$ma;
            $b36288e2db101ba3$var$la = !1;
            $b36288e2db101ba3$var$ma = null;
        } else throw $b36288e2db101ba3$var$t(Error(198));
        $b36288e2db101ba3$var$na || ($b36288e2db101ba3$var$na = !0, $b36288e2db101ba3$var$oa = l);
    }
}
var $b36288e2db101ba3$var$sa = null, $b36288e2db101ba3$var$ta = null, $b36288e2db101ba3$var$va = null;
function $b36288e2db101ba3$var$wa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $b36288e2db101ba3$var$va(c);
    $b36288e2db101ba3$var$ra(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$xa(a, b) {
    if (null == b) throw $b36288e2db101ba3$var$t(Error(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function $b36288e2db101ba3$var$ya(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var $b36288e2db101ba3$var$za = null;
function $b36288e2db101ba3$var$Aa(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)$b36288e2db101ba3$var$wa(a, b[d], c[d]);
        else b && $b36288e2db101ba3$var$wa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function $b36288e2db101ba3$var$Ba(a) {
    null !== a && ($b36288e2db101ba3$var$za = $b36288e2db101ba3$var$xa($b36288e2db101ba3$var$za, a));
    a = $b36288e2db101ba3$var$za;
    $b36288e2db101ba3$var$za = null;
    if (a) {
        $b36288e2db101ba3$var$ya(a, $b36288e2db101ba3$var$Aa);
        if ($b36288e2db101ba3$var$za) throw $b36288e2db101ba3$var$t(Error(95));
        if ($b36288e2db101ba3$var$na) throw a = $b36288e2db101ba3$var$oa, $b36288e2db101ba3$var$na = !1, $b36288e2db101ba3$var$oa = null, a;
    }
}
var $b36288e2db101ba3$var$Ca = {
    injectEventPluginOrder: function(a) {
        if ($b36288e2db101ba3$var$ba) throw $b36288e2db101ba3$var$t(Error(101));
        $b36288e2db101ba3$var$ba = Array.prototype.slice.call(a);
        $b36288e2db101ba3$var$da();
    },
    injectEventPluginsByName: function(a) {
        var b = !1, c;
        for(c in a)if (a.hasOwnProperty(c)) {
            var d = a[c];
            if (!$b36288e2db101ba3$var$ca.hasOwnProperty(c) || $b36288e2db101ba3$var$ca[c] !== d) {
                if ($b36288e2db101ba3$var$ca[c]) throw $b36288e2db101ba3$var$t(Error(102), c);
                $b36288e2db101ba3$var$ca[c] = d;
                b = !0;
            }
        }
        b && $b36288e2db101ba3$var$da();
    }
};
function $b36288e2db101ba3$var$Da(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $b36288e2db101ba3$var$sa(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw $b36288e2db101ba3$var$t(Error(231), b, typeof c);
    return c;
}
var $b36288e2db101ba3$var$Ea = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Fa = "__reactInternalInstance$" + $b36288e2db101ba3$var$Ea, $b36288e2db101ba3$var$Ga = "__reactEventHandlers$" + $b36288e2db101ba3$var$Ea;
function $b36288e2db101ba3$var$Ha(a) {
    if (a[$b36288e2db101ba3$var$Fa]) return a[$b36288e2db101ba3$var$Fa];
    for(; !a[$b36288e2db101ba3$var$Fa];)if (a.parentNode) a = a.parentNode;
    else return null;
    a = a[$b36288e2db101ba3$var$Fa];
    return 5 === a.tag || 6 === a.tag ? a : null;
}
function $b36288e2db101ba3$var$Ia(a) {
    a = a[$b36288e2db101ba3$var$Fa];
    return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$Ja(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw $b36288e2db101ba3$var$t(Error(33));
}
function $b36288e2db101ba3$var$Ka(a) {
    return a[$b36288e2db101ba3$var$Ga] || null;
}
function $b36288e2db101ba3$var$La(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$Ma(a, b, c) {
    if (b = $b36288e2db101ba3$var$Da(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = $b36288e2db101ba3$var$xa(c._dispatchListeners, b), c._dispatchInstances = $b36288e2db101ba3$var$xa(c._dispatchInstances, a);
}
function $b36288e2db101ba3$var$Na(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = $b36288e2db101ba3$var$La(b);
        for(b = c.length; 0 < b--;)$b36288e2db101ba3$var$Ma(c[b], "captured", a);
        for(b = 0; b < c.length; b++)$b36288e2db101ba3$var$Ma(c[b], "bubbled", a);
    }
}
function $b36288e2db101ba3$var$Oa(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = $b36288e2db101ba3$var$Da(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = $b36288e2db101ba3$var$xa(c._dispatchListeners, b), c._dispatchInstances = $b36288e2db101ba3$var$xa(c._dispatchInstances, a));
}
function $b36288e2db101ba3$var$Pa(a) {
    a && a.dispatchConfig.registrationName && $b36288e2db101ba3$var$Oa(a._targetInst, null, a);
}
function $b36288e2db101ba3$var$Qa(a) {
    $b36288e2db101ba3$var$ya(a, $b36288e2db101ba3$var$Na);
}
var $b36288e2db101ba3$var$Ra = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement);
function $b36288e2db101ba3$var$Sa(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$Ta = {
    animationend: $b36288e2db101ba3$var$Sa("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Sa("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Sa("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Sa("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Ua = {}, $b36288e2db101ba3$var$Va = {};
$b36288e2db101ba3$var$Ra && ($b36288e2db101ba3$var$Va = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$Ta.animationend.animation, delete $b36288e2db101ba3$var$Ta.animationiteration.animation, delete $b36288e2db101ba3$var$Ta.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$Ta.transitionend.transition);
function $b36288e2db101ba3$var$Wa(a) {
    if ($b36288e2db101ba3$var$Ua[a]) return $b36288e2db101ba3$var$Ua[a];
    if (!$b36288e2db101ba3$var$Ta[a]) return a;
    var b = $b36288e2db101ba3$var$Ta[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Va) return $b36288e2db101ba3$var$Ua[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$Xa = $b36288e2db101ba3$var$Wa("animationend"), $b36288e2db101ba3$var$Ya = $b36288e2db101ba3$var$Wa("animationiteration"), $b36288e2db101ba3$var$Za = $b36288e2db101ba3$var$Wa("animationstart"), $b36288e2db101ba3$var$ab = $b36288e2db101ba3$var$Wa("transitionend"), $b36288e2db101ba3$var$bb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$cb = null, $b36288e2db101ba3$var$db = null, $b36288e2db101ba3$var$eb = null;
function $b36288e2db101ba3$var$fb() {
    if ($b36288e2db101ba3$var$eb) return $b36288e2db101ba3$var$eb;
    var a, b = $b36288e2db101ba3$var$db, c = b.length, d, e = "value" in $b36288e2db101ba3$var$cb ? $b36288e2db101ba3$var$cb.value : $b36288e2db101ba3$var$cb.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var h = c - a;
    for(d = 1; d <= h && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$eb = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$gb() {
    return !0;
}
function $b36288e2db101ba3$var$hb() {
    return !1;
}
function $b36288e2db101ba3$var$y(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? $b36288e2db101ba3$var$gb : $b36288e2db101ba3$var$hb;
    this.isPropagationStopped = $b36288e2db101ba3$var$hb;
    return this;
}
$4yvvI($b36288e2db101ba3$var$y.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$gb);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$gb);
    },
    persist: function() {
        this.isPersistent = $b36288e2db101ba3$var$gb;
    },
    isPersistent: $b36288e2db101ba3$var$hb,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = $b36288e2db101ba3$var$hb;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
$b36288e2db101ba3$var$y.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
$b36288e2db101ba3$var$y.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $4yvvI(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $4yvvI({}, d.Interface, a);
    c.extend = d.extend;
    $b36288e2db101ba3$var$ib(c);
    return c;
};
$b36288e2db101ba3$var$ib($b36288e2db101ba3$var$y);
function $b36288e2db101ba3$var$jb(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function $b36288e2db101ba3$var$kb(a) {
    if (!(a instanceof this)) throw $b36288e2db101ba3$var$t(Error(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function $b36288e2db101ba3$var$ib(a) {
    a.eventPool = [];
    a.getPooled = $b36288e2db101ba3$var$jb;
    a.release = $b36288e2db101ba3$var$kb;
}
var $b36288e2db101ba3$var$lb = $b36288e2db101ba3$var$y.extend({
    data: null
}), $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$y.extend({
    data: null
}), $b36288e2db101ba3$var$nb = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ob = $b36288e2db101ba3$var$Ra && "CompositionEvent" in window, $b36288e2db101ba3$var$pb = null;
$b36288e2db101ba3$var$Ra && "documentMode" in document && ($b36288e2db101ba3$var$pb = document.documentMode);
var $b36288e2db101ba3$var$qb = $b36288e2db101ba3$var$Ra && "TextEvent" in window && !$b36288e2db101ba3$var$pb, $b36288e2db101ba3$var$sb = $b36288e2db101ba3$var$Ra && (!$b36288e2db101ba3$var$ob || $b36288e2db101ba3$var$pb && 8 < $b36288e2db101ba3$var$pb && 11 >= $b36288e2db101ba3$var$pb), $b36288e2db101ba3$var$tb = String.fromCharCode(32), $b36288e2db101ba3$var$ub = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, $b36288e2db101ba3$var$vb = !1;
function $b36288e2db101ba3$var$wb(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$nb.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$xb(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$yb = !1;
function $b36288e2db101ba3$var$Ab(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$xb(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$vb = !0;
            return $b36288e2db101ba3$var$tb;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$tb && $b36288e2db101ba3$var$vb ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$Bb(a, b) {
    if ($b36288e2db101ba3$var$yb) return "compositionend" === a || !$b36288e2db101ba3$var$ob && $b36288e2db101ba3$var$wb(a, b) ? (a = $b36288e2db101ba3$var$fb(), $b36288e2db101ba3$var$eb = $b36288e2db101ba3$var$db = $b36288e2db101ba3$var$cb = null, $b36288e2db101ba3$var$yb = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$sb && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Cb = {
    eventTypes: $b36288e2db101ba3$var$ub,
    extractEvents: function(a, b, c, d) {
        var e = void 0;
        var f = void 0;
        if ($b36288e2db101ba3$var$ob) b: {
            switch(a){
                case "compositionstart":
                    e = $b36288e2db101ba3$var$ub.compositionStart;
                    break b;
                case "compositionend":
                    e = $b36288e2db101ba3$var$ub.compositionEnd;
                    break b;
                case "compositionupdate":
                    e = $b36288e2db101ba3$var$ub.compositionUpdate;
                    break b;
            }
            e = void 0;
        }
        else $b36288e2db101ba3$var$yb ? $b36288e2db101ba3$var$wb(a, c) && (e = $b36288e2db101ba3$var$ub.compositionEnd) : "keydown" === a && 229 === c.keyCode && (e = $b36288e2db101ba3$var$ub.compositionStart);
        e ? ($b36288e2db101ba3$var$sb && "ko" !== c.locale && ($b36288e2db101ba3$var$yb || e !== $b36288e2db101ba3$var$ub.compositionStart ? e === $b36288e2db101ba3$var$ub.compositionEnd && $b36288e2db101ba3$var$yb && (f = $b36288e2db101ba3$var$fb()) : ($b36288e2db101ba3$var$cb = d, $b36288e2db101ba3$var$db = "value" in $b36288e2db101ba3$var$cb ? $b36288e2db101ba3$var$cb.value : $b36288e2db101ba3$var$cb.textContent, $b36288e2db101ba3$var$yb = !0)), e = $b36288e2db101ba3$var$lb.getPooled(e, b, c, d), f ? e.data = f : (f = $b36288e2db101ba3$var$xb(c), null !== f && (e.data = f)), $b36288e2db101ba3$var$Qa(e), f = e) : f = null;
        (a = $b36288e2db101ba3$var$qb ? $b36288e2db101ba3$var$Ab(a, c) : $b36288e2db101ba3$var$Bb(a, c)) ? (b = $b36288e2db101ba3$var$mb.getPooled($b36288e2db101ba3$var$ub.beforeInput, b, c, d), b.data = a, $b36288e2db101ba3$var$Qa(b)) : b = null;
        return null === f ? b : null === b ? f : [
            f,
            b
        ];
    }
}, $b36288e2db101ba3$var$Db = null, $b36288e2db101ba3$var$Eb = null, $b36288e2db101ba3$var$Fb = null;
function $b36288e2db101ba3$var$Gb(a) {
    if (a = $b36288e2db101ba3$var$ta(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$Db) throw $b36288e2db101ba3$var$t(Error(280));
        var b = $b36288e2db101ba3$var$sa(a.stateNode);
        $b36288e2db101ba3$var$Db(a.stateNode, a.type, b);
    }
}
function $b36288e2db101ba3$var$Hb(a) {
    $b36288e2db101ba3$var$Eb ? $b36288e2db101ba3$var$Fb ? $b36288e2db101ba3$var$Fb.push(a) : $b36288e2db101ba3$var$Fb = [
        a
    ] : $b36288e2db101ba3$var$Eb = a;
}
function $b36288e2db101ba3$var$Ib() {
    if ($b36288e2db101ba3$var$Eb) {
        var a = $b36288e2db101ba3$var$Eb, b = $b36288e2db101ba3$var$Fb;
        $b36288e2db101ba3$var$Fb = $b36288e2db101ba3$var$Eb = null;
        $b36288e2db101ba3$var$Gb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Gb(b[a]);
    }
}
function $b36288e2db101ba3$var$Jb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Kb(a, b, c, d) {
    return a(b, c, d);
}
function $b36288e2db101ba3$var$Lb() {}
var $b36288e2db101ba3$var$Mb = $b36288e2db101ba3$var$Jb, $b36288e2db101ba3$var$Nb = !1;
function $b36288e2db101ba3$var$Ob() {
    if (null !== $b36288e2db101ba3$var$Eb || null !== $b36288e2db101ba3$var$Fb) $b36288e2db101ba3$var$Lb(), $b36288e2db101ba3$var$Ib();
}
var $b36288e2db101ba3$var$Pb = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$Qb(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$Pb[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$Rb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function $b36288e2db101ba3$var$Sb(a) {
    if (!$b36288e2db101ba3$var$Ra) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
function $b36288e2db101ba3$var$Tb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ub(a) {
    var b = $b36288e2db101ba3$var$Tb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ub(a));
}
function $b36288e2db101ba3$var$Wb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Tb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
var $b36288e2db101ba3$var$Xb = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$b36288e2db101ba3$var$Xb.hasOwnProperty("ReactCurrentDispatcher") || ($b36288e2db101ba3$var$Xb.ReactCurrentDispatcher = {
    current: null
});
$b36288e2db101ba3$var$Xb.hasOwnProperty("ReactCurrentBatchConfig") || ($b36288e2db101ba3$var$Xb.ReactCurrentBatchConfig = {
    suspense: null
});
var $b36288e2db101ba3$var$Yb = /^(.*)[\\\/]/, $b36288e2db101ba3$var$B = "function" === typeof Symbol && Symbol.for, $b36288e2db101ba3$var$Zb = $b36288e2db101ba3$var$B ? Symbol.for("react.element") : 60103, $b36288e2db101ba3$var$$b = $b36288e2db101ba3$var$B ? Symbol.for("react.portal") : 60106, $b36288e2db101ba3$var$ac = $b36288e2db101ba3$var$B ? Symbol.for("react.fragment") : 60107, $b36288e2db101ba3$var$bc = $b36288e2db101ba3$var$B ? Symbol.for("react.strict_mode") : 60108, $b36288e2db101ba3$var$cc = $b36288e2db101ba3$var$B ? Symbol.for("react.profiler") : 60114, $b36288e2db101ba3$var$dc = $b36288e2db101ba3$var$B ? Symbol.for("react.provider") : 60109, $b36288e2db101ba3$var$ec = $b36288e2db101ba3$var$B ? Symbol.for("react.context") : 60110, $b36288e2db101ba3$var$fc = $b36288e2db101ba3$var$B ? Symbol.for("react.concurrent_mode") : 60111, $b36288e2db101ba3$var$gc = $b36288e2db101ba3$var$B ? Symbol.for("react.forward_ref") : 60112, $b36288e2db101ba3$var$hc = $b36288e2db101ba3$var$B ? Symbol.for("react.suspense") : 60113, $b36288e2db101ba3$var$ic = $b36288e2db101ba3$var$B ? Symbol.for("react.suspense_list") : 60120, $b36288e2db101ba3$var$jc = $b36288e2db101ba3$var$B ? Symbol.for("react.memo") : 60115, $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$B ? Symbol.for("react.lazy") : 60116;
$b36288e2db101ba3$var$B && Symbol.for("react.fundamental");
$b36288e2db101ba3$var$B && Symbol.for("react.responder");
var $b36288e2db101ba3$var$lc = "function" === typeof Symbol && Symbol.iterator;
function $b36288e2db101ba3$var$mc(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$lc && a[$b36288e2db101ba3$var$lc] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $b36288e2db101ba3$var$oc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ac:
            return "Fragment";
        case $b36288e2db101ba3$var$$b:
            return "Portal";
        case $b36288e2db101ba3$var$cc:
            return "Profiler";
        case $b36288e2db101ba3$var$bc:
            return "StrictMode";
        case $b36288e2db101ba3$var$hc:
            return "Suspense";
        case $b36288e2db101ba3$var$ic:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$ec:
            return "Context.Consumer";
        case $b36288e2db101ba3$var$dc:
            return "Context.Provider";
        case $b36288e2db101ba3$var$gc:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $b36288e2db101ba3$var$jc:
            return $b36288e2db101ba3$var$oc(a.type);
        case $b36288e2db101ba3$var$kc:
            if (a = 1 === a._status ? a._result : null) return $b36288e2db101ba3$var$oc(a);
    }
    return null;
}
function $b36288e2db101ba3$var$pc(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = $b36288e2db101ba3$var$oc(a.type);
                c = null;
                d && (c = $b36288e2db101ba3$var$oc(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace($b36288e2db101ba3$var$Yb, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
var $b36288e2db101ba3$var$qc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$rc = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$sc = {}, $b36288e2db101ba3$var$tc = {};
function $b36288e2db101ba3$var$uc(a) {
    if ($b36288e2db101ba3$var$rc.call($b36288e2db101ba3$var$tc, a)) return !0;
    if ($b36288e2db101ba3$var$rc.call($b36288e2db101ba3$var$sc, a)) return !1;
    if ($b36288e2db101ba3$var$qc.test(a)) return $b36288e2db101ba3$var$tc[a] = !0;
    $b36288e2db101ba3$var$sc[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$vc(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$wc(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$vc(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$D(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var $b36288e2db101ba3$var$F = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$F[b] = new $b36288e2db101ba3$var$D(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 5, !1, a.toLowerCase(), null, !1);
});
var $b36288e2db101ba3$var$xc = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$yc(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$xc, $b36288e2db101ba3$var$yc);
    $b36288e2db101ba3$var$F[b] = new $b36288e2db101ba3$var$D(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$xc, $b36288e2db101ba3$var$yc);
    $b36288e2db101ba3$var$F[b] = new $b36288e2db101ba3$var$D(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$xc, $b36288e2db101ba3$var$yc);
    $b36288e2db101ba3$var$F[b] = new $b36288e2db101ba3$var$D(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 1, !1, a.toLowerCase(), null, !1);
});
$b36288e2db101ba3$var$F.xlinkHref = new $b36288e2db101ba3$var$D("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$F[a] = new $b36288e2db101ba3$var$D(a, 1, !1, a.toLowerCase(), null, !0);
});
function $b36288e2db101ba3$var$zc(a, b, c, d) {
    var e = $b36288e2db101ba3$var$F.hasOwnProperty(b) ? $b36288e2db101ba3$var$F[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($b36288e2db101ba3$var$wc(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$uc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function $b36288e2db101ba3$var$Ac(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = b.checked;
    return $4yvvI({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Ac(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$Dc(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$zc(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$Ec(a, b) {
    $b36288e2db101ba3$var$Dc(a, b);
    var c = $b36288e2db101ba3$var$Ac(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$Fc(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$Fc(a, b.type, $b36288e2db101ba3$var$Ac(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$Gc(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !a.defaultChecked;
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$Fc(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$Hc = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function $b36288e2db101ba3$var$Ic(a, b, c) {
    a = $b36288e2db101ba3$var$y.getPooled($b36288e2db101ba3$var$Hc.change, a, b, c);
    a.type = "change";
    $b36288e2db101ba3$var$Hb(c);
    $b36288e2db101ba3$var$Qa(a);
    return a;
}
var $b36288e2db101ba3$var$Jc = null, $b36288e2db101ba3$var$Kc = null;
function $b36288e2db101ba3$var$Lc(a) {
    $b36288e2db101ba3$var$Ba(a);
}
function $b36288e2db101ba3$var$Mc(a) {
    var b = $b36288e2db101ba3$var$Ja(a);
    if ($b36288e2db101ba3$var$Wb(b)) return a;
}
function $b36288e2db101ba3$var$Nc(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$Oc = !1;
$b36288e2db101ba3$var$Ra && ($b36288e2db101ba3$var$Oc = $b36288e2db101ba3$var$Sb("input") && (!document.documentMode || 9 < document.documentMode));
function $b36288e2db101ba3$var$Pc() {
    $b36288e2db101ba3$var$Jc && ($b36288e2db101ba3$var$Jc.detachEvent("onpropertychange", $b36288e2db101ba3$var$Qc), $b36288e2db101ba3$var$Kc = $b36288e2db101ba3$var$Jc = null);
}
function $b36288e2db101ba3$var$Qc(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$Mc($b36288e2db101ba3$var$Kc)) {
        if (a = $b36288e2db101ba3$var$Ic($b36288e2db101ba3$var$Kc, a, $b36288e2db101ba3$var$Rb(a)), $b36288e2db101ba3$var$Nb) $b36288e2db101ba3$var$Ba(a);
        else {
            $b36288e2db101ba3$var$Nb = !0;
            try {
                $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$Lc, a);
            } finally{
                $b36288e2db101ba3$var$Nb = !1, $b36288e2db101ba3$var$Ob();
            }
        }
    }
}
function $b36288e2db101ba3$var$Rc(a, b, c) {
    "focus" === a ? ($b36288e2db101ba3$var$Pc(), $b36288e2db101ba3$var$Jc = b, $b36288e2db101ba3$var$Kc = c, $b36288e2db101ba3$var$Jc.attachEvent("onpropertychange", $b36288e2db101ba3$var$Qc)) : "blur" === a && $b36288e2db101ba3$var$Pc();
}
function $b36288e2db101ba3$var$Sc(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$Mc($b36288e2db101ba3$var$Kc);
}
function $b36288e2db101ba3$var$Tc(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$Mc(b);
}
function $b36288e2db101ba3$var$Uc(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$Mc(b);
}
var $b36288e2db101ba3$var$Vc = {
    eventTypes: $b36288e2db101ba3$var$Hc,
    _isInputEventSupported: $b36288e2db101ba3$var$Oc,
    extractEvents: function(a, b, c, d) {
        var e = b ? $b36288e2db101ba3$var$Ja(b) : window, f = void 0, h = void 0, g = e.nodeName && e.nodeName.toLowerCase();
        "select" === g || "input" === g && "file" === e.type ? f = $b36288e2db101ba3$var$Nc : $b36288e2db101ba3$var$Qb(e) ? $b36288e2db101ba3$var$Oc ? f = $b36288e2db101ba3$var$Uc : (f = $b36288e2db101ba3$var$Sc, h = $b36288e2db101ba3$var$Rc) : (g = e.nodeName) && "input" === g.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = $b36288e2db101ba3$var$Tc);
        if (f && (f = f(a, b))) return $b36288e2db101ba3$var$Ic(f, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && $b36288e2db101ba3$var$Fc(e, "number", e.value);
    }
}, $b36288e2db101ba3$var$Wc = $b36288e2db101ba3$var$y.extend({
    view: null,
    detail: null
}), $b36288e2db101ba3$var$Xc = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Yc(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Xc[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$Zc() {
    return $b36288e2db101ba3$var$Yc;
}
var $b36288e2db101ba3$var$$c = 0, $b36288e2db101ba3$var$ad = 0, $b36288e2db101ba3$var$bd = !1, $b36288e2db101ba3$var$cd = !1, $b36288e2db101ba3$var$dd = $b36288e2db101ba3$var$Wc.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: $b36288e2db101ba3$var$Zc,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = $b36288e2db101ba3$var$$c;
        $b36288e2db101ba3$var$$c = a.screenX;
        return $b36288e2db101ba3$var$bd ? "mousemove" === a.type ? a.screenX - b : 0 : ($b36288e2db101ba3$var$bd = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = $b36288e2db101ba3$var$ad;
        $b36288e2db101ba3$var$ad = a.screenY;
        return $b36288e2db101ba3$var$cd ? "mousemove" === a.type ? a.screenY - b : 0 : ($b36288e2db101ba3$var$cd = !0, 0);
    }
}), $b36288e2db101ba3$var$ed = $b36288e2db101ba3$var$dd.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), $b36288e2db101ba3$var$fd = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, $b36288e2db101ba3$var$gd = {
    eventTypes: $b36288e2db101ba3$var$fd,
    extractEvents: function(a, b, c, d) {
        var e = "mouseover" === a || "pointerover" === a, f = "mouseout" === a || "pointerout" === a;
        if (e && (c.relatedTarget || c.fromElement) || !f && !e) return null;
        e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
        f ? (f = b, b = (b = c.relatedTarget || c.toElement) ? $b36288e2db101ba3$var$Ha(b) : null) : f = null;
        if (f === b) return null;
        var h = void 0, g = void 0, k = void 0, l = void 0;
        if ("mouseout" === a || "mouseover" === a) h = $b36288e2db101ba3$var$dd, g = $b36288e2db101ba3$var$fd.mouseLeave, k = $b36288e2db101ba3$var$fd.mouseEnter, l = "mouse";
        else if ("pointerout" === a || "pointerover" === a) h = $b36288e2db101ba3$var$ed, g = $b36288e2db101ba3$var$fd.pointerLeave, k = $b36288e2db101ba3$var$fd.pointerEnter, l = "pointer";
        var n = null == f ? e : $b36288e2db101ba3$var$Ja(f);
        e = null == b ? e : $b36288e2db101ba3$var$Ja(b);
        a = h.getPooled(g, f, c, d);
        a.type = l + "leave";
        a.target = n;
        a.relatedTarget = e;
        c = h.getPooled(k, b, c, d);
        c.type = l + "enter";
        c.target = e;
        c.relatedTarget = n;
        d = b;
        if (f && d) a: {
            b = f;
            e = d;
            l = 0;
            for(h = b; h; h = $b36288e2db101ba3$var$La(h))l++;
            h = 0;
            for(k = e; k; k = $b36288e2db101ba3$var$La(k))h++;
            for(; 0 < l - h;)b = $b36288e2db101ba3$var$La(b), l--;
            for(; 0 < h - l;)e = $b36288e2db101ba3$var$La(e), h--;
            for(; l--;){
                if (b === e || b === e.alternate) break a;
                b = $b36288e2db101ba3$var$La(b);
                e = $b36288e2db101ba3$var$La(e);
            }
            b = null;
        }
        else b = null;
        e = b;
        for(b = []; f && f !== e;){
            l = f.alternate;
            if (null !== l && l === e) break;
            b.push(f);
            f = $b36288e2db101ba3$var$La(f);
        }
        for(f = []; d && d !== e;){
            l = d.alternate;
            if (null !== l && l === e) break;
            f.push(d);
            d = $b36288e2db101ba3$var$La(d);
        }
        for(d = 0; d < b.length; d++)$b36288e2db101ba3$var$Oa(b[d], "bubbled", a);
        for(d = f.length; 0 < d--;)$b36288e2db101ba3$var$Oa(f[d], "captured", c);
        return [
            a,
            c
        ];
    }
};
function $b36288e2db101ba3$var$hd(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$id = Object.prototype.hasOwnProperty;
function $b36288e2db101ba3$var$jd(a, b) {
    if ($b36288e2db101ba3$var$hd(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$b36288e2db101ba3$var$id.call(b, c[d]) || !$b36288e2db101ba3$var$hd(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$kd(a, b) {
    return {
        responder: a,
        props: b
    };
}
new Map;
new Map;
new Set;
new Map;
function $b36288e2db101ba3$var$ld(a) {
    var b = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        if (0 !== (b.effectTag & 2)) return 1;
        for(; b.return;)if (b = b.return, 0 !== (b.effectTag & 2)) return 1;
    }
    return 3 === b.tag ? 2 : 3;
}
function $b36288e2db101ba3$var$od(a) {
    if (2 !== $b36288e2db101ba3$var$ld(a)) throw $b36288e2db101ba3$var$t(Error(188));
}
function $b36288e2db101ba3$var$pd(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$ld(a);
        if (3 === b) throw $b36288e2db101ba3$var$t(Error(188));
        return 1 === b ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$od(e), a;
                if (f === d) return $b36288e2db101ba3$var$od(e), b;
                f = f.sibling;
            }
            throw $b36288e2db101ba3$var$t(Error(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var h = !1, g = e.child; g;){
                if (g === c) {
                    h = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (g === d) {
                    h = !0;
                    d = e;
                    c = f;
                    break;
                }
                g = g.sibling;
            }
            if (!h) {
                for(g = f.child; g;){
                    if (g === c) {
                        h = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (g === d) {
                        h = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    g = g.sibling;
                }
                if (!h) throw $b36288e2db101ba3$var$t(Error(189));
            }
        }
        if (c.alternate !== d) throw $b36288e2db101ba3$var$t(Error(190));
    }
    if (3 !== c.tag) throw $b36288e2db101ba3$var$t(Error(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$qd(a) {
    a = $b36288e2db101ba3$var$pd(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$rd = $b36288e2db101ba3$var$y.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), $b36288e2db101ba3$var$sd = $b36288e2db101ba3$var$y.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$Wc.extend({
    relatedTarget: null
});
function $b36288e2db101ba3$var$ud(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var $b36288e2db101ba3$var$vd = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$wd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$Wc.extend({
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$vd[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$ud(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$wd[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: $b36288e2db101ba3$var$Zc,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$ud(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$ud(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$yd = $b36288e2db101ba3$var$dd.extend({
    dataTransfer: null
}), $b36288e2db101ba3$var$zd = $b36288e2db101ba3$var$Wc.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: $b36288e2db101ba3$var$Zc
}), $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$y.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$dd.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), $b36288e2db101ba3$var$Cd = [
    [
        "blur",
        "blur",
        0
    ],
    [
        "cancel",
        "cancel",
        0
    ],
    [
        "click",
        "click",
        0
    ],
    [
        "close",
        "close",
        0
    ],
    [
        "contextmenu",
        "contextMenu",
        0
    ],
    [
        "copy",
        "copy",
        0
    ],
    [
        "cut",
        "cut",
        0
    ],
    [
        "auxclick",
        "auxClick",
        0
    ],
    [
        "dblclick",
        "doubleClick",
        0
    ],
    [
        "dragend",
        "dragEnd",
        0
    ],
    [
        "dragstart",
        "dragStart",
        0
    ],
    [
        "drop",
        "drop",
        0
    ],
    [
        "focus",
        "focus",
        0
    ],
    [
        "input",
        "input",
        0
    ],
    [
        "invalid",
        "invalid",
        0
    ],
    [
        "keydown",
        "keyDown",
        0
    ],
    [
        "keypress",
        "keyPress",
        0
    ],
    [
        "keyup",
        "keyUp",
        0
    ],
    [
        "mousedown",
        "mouseDown",
        0
    ],
    [
        "mouseup",
        "mouseUp",
        0
    ],
    [
        "paste",
        "paste",
        0
    ],
    [
        "pause",
        "pause",
        0
    ],
    [
        "play",
        "play",
        0
    ],
    [
        "pointercancel",
        "pointerCancel",
        0
    ],
    [
        "pointerdown",
        "pointerDown",
        0
    ],
    [
        "pointerup",
        "pointerUp",
        0
    ],
    [
        "ratechange",
        "rateChange",
        0
    ],
    [
        "reset",
        "reset",
        0
    ],
    [
        "seeked",
        "seeked",
        0
    ],
    [
        "submit",
        "submit",
        0
    ],
    [
        "touchcancel",
        "touchCancel",
        0
    ],
    [
        "touchend",
        "touchEnd",
        0
    ],
    [
        "touchstart",
        "touchStart",
        0
    ],
    [
        "volumechange",
        "volumeChange",
        0
    ],
    [
        "drag",
        "drag",
        1
    ],
    [
        "dragenter",
        "dragEnter",
        1
    ],
    [
        "dragexit",
        "dragExit",
        1
    ],
    [
        "dragleave",
        "dragLeave",
        1
    ],
    [
        "dragover",
        "dragOver",
        1
    ],
    [
        "mousemove",
        "mouseMove",
        1
    ],
    [
        "mouseout",
        "mouseOut",
        1
    ],
    [
        "mouseover",
        "mouseOver",
        1
    ],
    [
        "pointermove",
        "pointerMove",
        1
    ],
    [
        "pointerout",
        "pointerOut",
        1
    ],
    [
        "pointerover",
        "pointerOver",
        1
    ],
    [
        "scroll",
        "scroll",
        1
    ],
    [
        "toggle",
        "toggle",
        1
    ],
    [
        "touchmove",
        "touchMove",
        1
    ],
    [
        "wheel",
        "wheel",
        1
    ],
    [
        "abort",
        "abort",
        2
    ],
    [
        $b36288e2db101ba3$var$Xa,
        "animationEnd",
        2
    ],
    [
        $b36288e2db101ba3$var$Ya,
        "animationIteration",
        2
    ],
    [
        $b36288e2db101ba3$var$Za,
        "animationStart",
        2
    ],
    [
        "canplay",
        "canPlay",
        2
    ],
    [
        "canplaythrough",
        "canPlayThrough",
        2
    ],
    [
        "durationchange",
        "durationChange",
        2
    ],
    [
        "emptied",
        "emptied",
        2
    ],
    [
        "encrypted",
        "encrypted",
        2
    ],
    [
        "ended",
        "ended",
        2
    ],
    [
        "error",
        "error",
        2
    ],
    [
        "gotpointercapture",
        "gotPointerCapture",
        2
    ],
    [
        "load",
        "load",
        2
    ],
    [
        "loadeddata",
        "loadedData",
        2
    ],
    [
        "loadedmetadata",
        "loadedMetadata",
        2
    ],
    [
        "loadstart",
        "loadStart",
        2
    ],
    [
        "lostpointercapture",
        "lostPointerCapture",
        2
    ],
    [
        "playing",
        "playing",
        2
    ],
    [
        "progress",
        "progress",
        2
    ],
    [
        "seeking",
        "seeking",
        2
    ],
    [
        "stalled",
        "stalled",
        2
    ],
    [
        "suspend",
        "suspend",
        2
    ],
    [
        "timeupdate",
        "timeUpdate",
        2
    ],
    [
        $b36288e2db101ba3$var$ab,
        "transitionEnd",
        2
    ],
    [
        "waiting",
        "waiting",
        2
    ]
], $b36288e2db101ba3$var$Dd = {}, $b36288e2db101ba3$var$Ed = {}, $b36288e2db101ba3$var$Fd = 0;
for(; $b36288e2db101ba3$var$Fd < $b36288e2db101ba3$var$Cd.length; $b36288e2db101ba3$var$Fd++){
    var $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$Cd[$b36288e2db101ba3$var$Fd], $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$Gd[0], $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$Gd[1], $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$Gd[2], $b36288e2db101ba3$var$Kd = "on" + ($b36288e2db101ba3$var$Id[0].toUpperCase() + $b36288e2db101ba3$var$Id.slice(1)), $b36288e2db101ba3$var$Ld = {
        phasedRegistrationNames: {
            bubbled: $b36288e2db101ba3$var$Kd,
            captured: $b36288e2db101ba3$var$Kd + "Capture"
        },
        dependencies: [
            $b36288e2db101ba3$var$Hd
        ],
        eventPriority: $b36288e2db101ba3$var$Jd
    };
    $b36288e2db101ba3$var$Dd[$b36288e2db101ba3$var$Id] = $b36288e2db101ba3$var$Ld;
    $b36288e2db101ba3$var$Ed[$b36288e2db101ba3$var$Hd] = $b36288e2db101ba3$var$Ld;
}
var $b36288e2db101ba3$var$Md = {
    eventTypes: $b36288e2db101ba3$var$Dd,
    getEventPriority: function(a) {
        a = $b36288e2db101ba3$var$Ed[a];
        return void 0 !== a ? a.eventPriority : 2;
    },
    extractEvents: function(a, b, c, d) {
        var e = $b36288e2db101ba3$var$Ed[a];
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === $b36288e2db101ba3$var$ud(c)) return null;
            case "keydown":
            case "keyup":
                a = $b36288e2db101ba3$var$xd;
                break;
            case "blur":
            case "focus":
                a = $b36288e2db101ba3$var$td;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = $b36288e2db101ba3$var$dd;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = $b36288e2db101ba3$var$yd;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = $b36288e2db101ba3$var$zd;
                break;
            case $b36288e2db101ba3$var$Xa:
            case $b36288e2db101ba3$var$Ya:
            case $b36288e2db101ba3$var$Za:
                a = $b36288e2db101ba3$var$rd;
                break;
            case $b36288e2db101ba3$var$ab:
                a = $b36288e2db101ba3$var$Ad;
                break;
            case "scroll":
                a = $b36288e2db101ba3$var$Wc;
                break;
            case "wheel":
                a = $b36288e2db101ba3$var$Bd;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = $b36288e2db101ba3$var$sd;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = $b36288e2db101ba3$var$ed;
                break;
            default:
                a = $b36288e2db101ba3$var$y;
        }
        b = a.getPooled(e, b, c, d);
        $b36288e2db101ba3$var$Qa(b);
        return b;
    }
}, $b36288e2db101ba3$var$Nd = $b36288e2db101ba3$var$Md.getEventPriority, $b36288e2db101ba3$var$Od = [];
function $b36288e2db101ba3$var$Pd(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d;
        for(d = c; d.return;)d = d.return;
        d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        if (!d) break;
        a.ancestors.push(c);
        c = $b36288e2db101ba3$var$Ha(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = $b36288e2db101ba3$var$Rb(a.nativeEvent);
        d = a.topLevelType;
        for(var f = a.nativeEvent, h = null, g = 0; g < $b36288e2db101ba3$var$ea.length; g++){
            var k = $b36288e2db101ba3$var$ea[g];
            k && (k = k.extractEvents(d, b, f, e)) && (h = $b36288e2db101ba3$var$xa(h, k));
        }
        $b36288e2db101ba3$var$Ba(h);
    }
}
var $b36288e2db101ba3$var$Qd = !0;
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Rd(b, a, !1);
}
function $b36288e2db101ba3$var$Rd(a, b, c) {
    switch($b36288e2db101ba3$var$Nd(b)){
        case 0:
            var d = $b36288e2db101ba3$var$Sd.bind(null, b, 1);
            break;
        case 1:
            d = $b36288e2db101ba3$var$Td.bind(null, b, 1);
            break;
        default:
            d = $b36288e2db101ba3$var$Ud.bind(null, b, 1);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function $b36288e2db101ba3$var$Sd(a, b, c) {
    $b36288e2db101ba3$var$Nb || $b36288e2db101ba3$var$Lb();
    var d = $b36288e2db101ba3$var$Ud, e = $b36288e2db101ba3$var$Nb;
    $b36288e2db101ba3$var$Nb = !0;
    try {
        $b36288e2db101ba3$var$Kb(d, a, b, c);
    } finally{
        ($b36288e2db101ba3$var$Nb = e) || $b36288e2db101ba3$var$Ob();
    }
}
function $b36288e2db101ba3$var$Td(a, b, c) {
    $b36288e2db101ba3$var$Ud(a, b, c);
}
function $b36288e2db101ba3$var$Ud(a, b, c) {
    if ($b36288e2db101ba3$var$Qd) {
        b = $b36288e2db101ba3$var$Rb(c);
        b = $b36288e2db101ba3$var$Ha(b);
        null === b || "number" !== typeof b.tag || 2 === $b36288e2db101ba3$var$ld(b) || (b = null);
        if ($b36288e2db101ba3$var$Od.length) {
            var d = $b36288e2db101ba3$var$Od.pop();
            d.topLevelType = a;
            d.nativeEvent = c;
            d.targetInst = b;
            a = d;
        } else a = {
            topLevelType: a,
            nativeEvent: c,
            targetInst: b,
            ancestors: []
        };
        try {
            if (c = a, $b36288e2db101ba3$var$Nb) $b36288e2db101ba3$var$Pd(c, void 0);
            else {
                $b36288e2db101ba3$var$Nb = !0;
                try {
                    $b36288e2db101ba3$var$Mb($b36288e2db101ba3$var$Pd, c, void 0);
                } finally{
                    $b36288e2db101ba3$var$Nb = !1, $b36288e2db101ba3$var$Ob();
                }
            }
        } finally{
            a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > $b36288e2db101ba3$var$Od.length && $b36288e2db101ba3$var$Od.push(a);
        }
    }
}
var $b36288e2db101ba3$var$Vd = new ("function" === typeof WeakMap ? WeakMap : Map);
function $b36288e2db101ba3$var$Wd(a) {
    var b = $b36288e2db101ba3$var$Vd.get(a);
    void 0 === b && (b = new Set, $b36288e2db101ba3$var$Vd.set(a, b));
    return b;
}
function $b36288e2db101ba3$var$Xd(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Yd(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Zd(a, b) {
    var c = $b36288e2db101ba3$var$Yd(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Yd(c);
    }
}
function $b36288e2db101ba3$var$$d(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$$d(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$ae() {
    for(var a = window, b = $b36288e2db101ba3$var$Xd(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xd(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$be(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$Ra && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$de = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, $b36288e2db101ba3$var$ee = null, $b36288e2db101ba3$var$fe = null, $b36288e2db101ba3$var$ge = null, $b36288e2db101ba3$var$he = !1;
function $b36288e2db101ba3$var$ie(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if ($b36288e2db101ba3$var$he || null == $b36288e2db101ba3$var$ee || $b36288e2db101ba3$var$ee !== $b36288e2db101ba3$var$Xd(c)) return null;
    c = $b36288e2db101ba3$var$ee;
    "selectionStart" in c && $b36288e2db101ba3$var$be(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return $b36288e2db101ba3$var$ge && $b36288e2db101ba3$var$jd($b36288e2db101ba3$var$ge, c) ? null : ($b36288e2db101ba3$var$ge = c, a = $b36288e2db101ba3$var$y.getPooled($b36288e2db101ba3$var$de.select, $b36288e2db101ba3$var$fe, a, b), a.type = "select", a.target = $b36288e2db101ba3$var$ee, $b36288e2db101ba3$var$Qa(a), a);
}
var $b36288e2db101ba3$var$je = {
    eventTypes: $b36288e2db101ba3$var$de,
    extractEvents: function(a, b, c, d) {
        var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument, f;
        if (!(f = !e)) {
            a: {
                e = $b36288e2db101ba3$var$Wd(e);
                f = $b36288e2db101ba3$var$ja.onSelect;
                for(var h = 0; h < f.length; h++)if (!e.has(f[h])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? $b36288e2db101ba3$var$Ja(b) : window;
        switch(a){
            case "focus":
                if ($b36288e2db101ba3$var$Qb(e) || "true" === e.contentEditable) $b36288e2db101ba3$var$ee = e, $b36288e2db101ba3$var$fe = b, $b36288e2db101ba3$var$ge = null;
                break;
            case "blur":
                $b36288e2db101ba3$var$ge = $b36288e2db101ba3$var$fe = $b36288e2db101ba3$var$ee = null;
                break;
            case "mousedown":
                $b36288e2db101ba3$var$he = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return $b36288e2db101ba3$var$he = !1, $b36288e2db101ba3$var$ie(c, d);
            case "selectionchange":
                if ($b36288e2db101ba3$var$ce) break;
            case "keydown":
            case "keyup":
                return $b36288e2db101ba3$var$ie(c, d);
        }
        return null;
    }
};
$b36288e2db101ba3$var$Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
$b36288e2db101ba3$var$sa = $b36288e2db101ba3$var$Ka;
$b36288e2db101ba3$var$ta = $b36288e2db101ba3$var$Ia;
$b36288e2db101ba3$var$va = $b36288e2db101ba3$var$Ja;
$b36288e2db101ba3$var$Ca.injectEventPluginsByName({
    SimpleEventPlugin: $b36288e2db101ba3$var$Md,
    EnterLeaveEventPlugin: $b36288e2db101ba3$var$gd,
    ChangeEventPlugin: $b36288e2db101ba3$var$Vc,
    SelectEventPlugin: $b36288e2db101ba3$var$je,
    BeforeInputEventPlugin: $b36288e2db101ba3$var$Cb
});
function $b36288e2db101ba3$var$ke(a) {
    var b = "";
    $bh6RR.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $b36288e2db101ba3$var$le(a, b) {
    a = $4yvvI({
        children: void 0
    }, b);
    if (b = $b36288e2db101ba3$var$ke(b.children)) a.children = b;
    return a;
}
function $b36288e2db101ba3$var$me(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Ac(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$ne(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw $b36288e2db101ba3$var$t(Error(91));
    return $4yvvI({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$oe(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.defaultValue;
        b = b.children;
        if (null != b) {
            if (null != c) throw $b36288e2db101ba3$var$t(Error(92));
            if (Array.isArray(b)) {
                if (!(1 >= b.length)) throw $b36288e2db101ba3$var$t(Error(93));
                b = b[0];
            }
            c = b;
        }
        null == c && (c = "");
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Ac(c)
    };
}
function $b36288e2db101ba3$var$pe(a, b) {
    var c = $b36288e2db101ba3$var$Ac(b.value), d = $b36288e2db101ba3$var$Ac(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$qe(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && (a.value = b);
}
var $b36288e2db101ba3$var$re = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $b36288e2db101ba3$var$se(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$te(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$se(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$ue = void 0, $b36288e2db101ba3$var$ve = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $b36288e2db101ba3$var$re.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$ue = $b36288e2db101ba3$var$ue || document.createElement("div");
        $b36288e2db101ba3$var$ue.innerHTML = "<svg>" + b + "</svg>";
        for(b = $b36288e2db101ba3$var$ue.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$we(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$xe = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$ye = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$xe).forEach(function(a) {
    $b36288e2db101ba3$var$ye.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$xe[b] = $b36288e2db101ba3$var$xe[a];
    });
});
function $b36288e2db101ba3$var$ze(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$xe.hasOwnProperty(a) && $b36288e2db101ba3$var$xe[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$Ae(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$ze(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$Ce = $4yvvI({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$De(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$Ce[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw $b36288e2db101ba3$var$t(Error(137), a, "");
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw $b36288e2db101ba3$var$t(Error(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw $b36288e2db101ba3$var$t(Error(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw $b36288e2db101ba3$var$t(Error(62), "");
    }
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $b36288e2db101ba3$var$Fe(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = $b36288e2db101ba3$var$Wd(a);
    b = $b36288e2db101ba3$var$ja[b];
    for(var d = 0; d < b.length; d++){
        var e = b[d];
        if (!c.has(e)) {
            switch(e){
                case "scroll":
                    $b36288e2db101ba3$var$Rd(a, "scroll", !0);
                    break;
                case "focus":
                case "blur":
                    $b36288e2db101ba3$var$Rd(a, "focus", !0);
                    $b36288e2db101ba3$var$Rd(a, "blur", !0);
                    c.add("blur");
                    c.add("focus");
                    break;
                case "cancel":
                case "close":
                    $b36288e2db101ba3$var$Sb(e) && $b36288e2db101ba3$var$Rd(a, e, !0);
                    break;
                case "invalid":
                case "submit":
                case "reset":
                    break;
                default:
                    -1 === $b36288e2db101ba3$var$bb.indexOf(e) && $b36288e2db101ba3$var$G(e, a);
            }
            c.add(e);
        }
    }
}
function $b36288e2db101ba3$var$Ge() {}
var $b36288e2db101ba3$var$He = null, $b36288e2db101ba3$var$Ie = null;
function $b36288e2db101ba3$var$Je(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Le = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Me = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $b36288e2db101ba3$var$Ne(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
new Set;
var $b36288e2db101ba3$var$Oe = [], $b36288e2db101ba3$var$Pe = -1;
function $b36288e2db101ba3$var$H(a) {
    0 > $b36288e2db101ba3$var$Pe || (a.current = $b36288e2db101ba3$var$Oe[$b36288e2db101ba3$var$Pe], $b36288e2db101ba3$var$Oe[$b36288e2db101ba3$var$Pe] = null, $b36288e2db101ba3$var$Pe--);
}
function $b36288e2db101ba3$var$J(a, b) {
    $b36288e2db101ba3$var$Pe++;
    $b36288e2db101ba3$var$Oe[$b36288e2db101ba3$var$Pe] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Qe = {}, $b36288e2db101ba3$var$L = {
    current: $b36288e2db101ba3$var$Qe
}, $b36288e2db101ba3$var$M = {
    current: !1
}, $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe;
function $b36288e2db101ba3$var$Se(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Qe;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$N(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$Te(a) {
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M, a);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$L, a);
}
function $b36288e2db101ba3$var$Ue(a) {
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M, a);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$L, a);
}
function $b36288e2db101ba3$var$Ve(a, b, c) {
    if ($b36288e2db101ba3$var$L.current !== $b36288e2db101ba3$var$Qe) throw $b36288e2db101ba3$var$t(Error(168));
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$L, b, a);
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$M, c, a);
}
function $b36288e2db101ba3$var$We(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw $b36288e2db101ba3$var$t(Error(108), $b36288e2db101ba3$var$oc(b) || "Unknown", e);
    return $4yvvI({}, c, d);
}
function $b36288e2db101ba3$var$Xe(a) {
    var b = a.stateNode;
    b = b && b.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Qe;
    $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$L.current;
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$L, b, a);
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current, a);
    return !0;
}
function $b36288e2db101ba3$var$Ye(a, b, c) {
    var d = a.stateNode;
    if (!d) throw $b36288e2db101ba3$var$t(Error(169));
    c ? (b = $b36288e2db101ba3$var$We(a, b, $b36288e2db101ba3$var$Re), d.__reactInternalMemoizedMergedChildContext = b, $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M, a), $b36288e2db101ba3$var$H($b36288e2db101ba3$var$L, a), $b36288e2db101ba3$var$J($b36288e2db101ba3$var$L, b, a)) : $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M, a);
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$M, c, a);
}
var $b36288e2db101ba3$var$Ze = $4LCdk.unstable_runWithPriority, $b36288e2db101ba3$var$$e = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$af = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$bf = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$cf = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$df = $4LCdk.unstable_now, $b36288e2db101ba3$var$ef = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$ff = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$hf = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$jf = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$kf = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$lf = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$mf = {}, $b36288e2db101ba3$var$nf = void 0 !== $b36288e2db101ba3$var$cf ? $b36288e2db101ba3$var$cf : function() {}, $b36288e2db101ba3$var$of = null, $b36288e2db101ba3$var$pf = null, $b36288e2db101ba3$var$qf = !1, $b36288e2db101ba3$var$rf = $b36288e2db101ba3$var$df(), $b36288e2db101ba3$var$sf = 1E4 > $b36288e2db101ba3$var$rf ? $b36288e2db101ba3$var$df : function() {
    return $b36288e2db101ba3$var$df() - $b36288e2db101ba3$var$rf;
};
function $b36288e2db101ba3$var$tf() {
    switch($b36288e2db101ba3$var$ef()){
        case $b36288e2db101ba3$var$ff:
            return 99;
        case $b36288e2db101ba3$var$hf:
            return 98;
        case $b36288e2db101ba3$var$jf:
            return 97;
        case $b36288e2db101ba3$var$kf:
            return 96;
        case $b36288e2db101ba3$var$lf:
            return 95;
        default:
            throw $b36288e2db101ba3$var$t(Error(332));
    }
}
function $b36288e2db101ba3$var$uf(a) {
    switch(a){
        case 99:
            return $b36288e2db101ba3$var$ff;
        case 98:
            return $b36288e2db101ba3$var$hf;
        case 97:
            return $b36288e2db101ba3$var$jf;
        case 96:
            return $b36288e2db101ba3$var$kf;
        case 95:
            return $b36288e2db101ba3$var$lf;
        default:
            throw $b36288e2db101ba3$var$t(Error(332));
    }
}
function $b36288e2db101ba3$var$vf(a, b) {
    a = $b36288e2db101ba3$var$uf(a);
    return $b36288e2db101ba3$var$Ze(a, b);
}
function $b36288e2db101ba3$var$wf(a, b, c) {
    a = $b36288e2db101ba3$var$uf(a);
    return $b36288e2db101ba3$var$$e(a, b, c);
}
function $b36288e2db101ba3$var$xf(a) {
    null === $b36288e2db101ba3$var$of ? ($b36288e2db101ba3$var$of = [
        a
    ], $b36288e2db101ba3$var$pf = $b36288e2db101ba3$var$$e($b36288e2db101ba3$var$ff, $b36288e2db101ba3$var$yf)) : $b36288e2db101ba3$var$of.push(a);
    return $b36288e2db101ba3$var$mf;
}
function $b36288e2db101ba3$var$O() {
    null !== $b36288e2db101ba3$var$pf && $b36288e2db101ba3$var$af($b36288e2db101ba3$var$pf);
    $b36288e2db101ba3$var$yf();
}
function $b36288e2db101ba3$var$yf() {
    if (!$b36288e2db101ba3$var$qf && null !== $b36288e2db101ba3$var$of) {
        $b36288e2db101ba3$var$qf = !0;
        var a = 0;
        try {
            var b = $b36288e2db101ba3$var$of;
            $b36288e2db101ba3$var$vf(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $b36288e2db101ba3$var$of = null;
        } catch (c) {
            throw null !== $b36288e2db101ba3$var$of && ($b36288e2db101ba3$var$of = $b36288e2db101ba3$var$of.slice(a + 1)), $b36288e2db101ba3$var$$e($b36288e2db101ba3$var$ff, $b36288e2db101ba3$var$O), c;
        } finally{
            $b36288e2db101ba3$var$qf = !1;
        }
    }
}
function $b36288e2db101ba3$var$zf(a, b) {
    if (1073741823 === b) return 99;
    if (1 === b) return 95;
    a = 10 * (1073741821 - b) - 10 * (1073741821 - a);
    return 0 >= a ? 99 : 250 >= a ? 98 : 5250 >= a ? 97 : 95;
}
function $b36288e2db101ba3$var$Af(a, b) {
    if (a && a.defaultProps) {
        b = $4yvvI({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
function $b36288e2db101ba3$var$Bf(a) {
    var b = a._result;
    switch(a._status){
        case 1:
            return b;
        case 2:
            throw b;
        case 0:
            throw b;
        default:
            a._status = 0;
            b = a._ctor;
            b = b();
            b.then(function(b) {
                0 === a._status && (b = b.default, a._status = 1, a._result = b);
            }, function(b) {
                0 === a._status && (a._status = 2, a._result = b);
            });
            switch(a._status){
                case 1:
                    return a._result;
                case 2:
                    throw a._result;
            }
            a._result = b;
            throw b;
    }
}
var $b36288e2db101ba3$var$Cf = {
    current: null
}, $b36288e2db101ba3$var$Df = null, $b36288e2db101ba3$var$Ef = null, $b36288e2db101ba3$var$Ff = null;
function $b36288e2db101ba3$var$Gf() {
    $b36288e2db101ba3$var$Ff = $b36288e2db101ba3$var$Ef = $b36288e2db101ba3$var$Df = null;
}
function $b36288e2db101ba3$var$Hf(a, b) {
    var c = a.type._context;
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$Cf, c._currentValue, a);
    c._currentValue = b;
}
function $b36288e2db101ba3$var$If(a) {
    var b = $b36288e2db101ba3$var$Cf.current;
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$Cf, a);
    a.type._context._currentValue = b;
}
function $b36288e2db101ba3$var$Jf(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Kf(a, b) {
    $b36288e2db101ba3$var$Df = a;
    $b36288e2db101ba3$var$Ff = $b36288e2db101ba3$var$Ef = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && ($b36288e2db101ba3$var$Lf = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Mf(a, b) {
    if ($b36288e2db101ba3$var$Ff !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $b36288e2db101ba3$var$Ff = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $b36288e2db101ba3$var$Ef) {
            if (null === $b36288e2db101ba3$var$Df) throw $b36288e2db101ba3$var$t(Error(308));
            $b36288e2db101ba3$var$Ef = b;
            $b36288e2db101ba3$var$Df.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else $b36288e2db101ba3$var$Ef = $b36288e2db101ba3$var$Ef.next = b;
    }
    return a._currentValue;
}
var $b36288e2db101ba3$var$Nf = !1;
function $b36288e2db101ba3$var$Of(a) {
    return {
        baseState: a,
        firstUpdate: null,
        lastUpdate: null,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $b36288e2db101ba3$var$Pf(a) {
    return {
        baseState: a.baseState,
        firstUpdate: a.firstUpdate,
        lastUpdate: a.lastUpdate,
        firstCapturedUpdate: null,
        lastCapturedUpdate: null,
        firstEffect: null,
        lastEffect: null,
        firstCapturedEffect: null,
        lastCapturedEffect: null
    };
}
function $b36288e2db101ba3$var$Qf(a, b) {
    return {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null,
        nextEffect: null
    };
}
function $b36288e2db101ba3$var$Rf(a, b) {
    null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function $b36288e2db101ba3$var$Sf(a, b) {
    var c = a.alternate;
    if (null === c) {
        var d = a.updateQueue;
        var e = null;
        null === d && (d = a.updateQueue = $b36288e2db101ba3$var$Of(a.memoizedState));
    } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = $b36288e2db101ba3$var$Of(a.memoizedState), e = c.updateQueue = $b36288e2db101ba3$var$Of(c.memoizedState)) : d = a.updateQueue = $b36288e2db101ba3$var$Pf(e) : null === e && (e = c.updateQueue = $b36288e2db101ba3$var$Pf(d));
    null === e || d === e ? $b36288e2db101ba3$var$Rf(d, b) : null === d.lastUpdate || null === e.lastUpdate ? ($b36288e2db101ba3$var$Rf(d, b), $b36288e2db101ba3$var$Rf(e, b)) : ($b36288e2db101ba3$var$Rf(d, b), e.lastUpdate = b);
}
function $b36288e2db101ba3$var$Tf(a, b) {
    var c = a.updateQueue;
    c = null === c ? a.updateQueue = $b36288e2db101ba3$var$Of(a.memoizedState) : $b36288e2db101ba3$var$Uf(a, c);
    null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}
function $b36288e2db101ba3$var$Uf(a, b) {
    var c = a.alternate;
    null !== c && b === c.updateQueue && (b = a.updateQueue = $b36288e2db101ba3$var$Pf(b));
    return b;
}
function $b36288e2db101ba3$var$Vf(a, b, c, d, e, f) {
    switch(c.tag){
        case 1:
            return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
        case 3:
            a.effectTag = a.effectTag & -2049 | 64;
        case 0:
            a = c.payload;
            e = "function" === typeof a ? a.call(f, d, e) : a;
            if (null === e || void 0 === e) break;
            return $4yvvI({}, d, e);
        case 2:
            $b36288e2db101ba3$var$Nf = !0;
    }
    return d;
}
function $b36288e2db101ba3$var$Wf(a, b, c, d, e) {
    $b36288e2db101ba3$var$Nf = !1;
    b = $b36288e2db101ba3$var$Uf(a, b);
    for(var f = b.baseState, h = null, g = 0, k = b.firstUpdate, l = f; null !== k;){
        var n = k.expirationTime;
        n < e ? (null === h && (h = k, f = l), g < n && (g = n)) : ($b36288e2db101ba3$var$Xf(n, k.suspenseConfig), l = $b36288e2db101ba3$var$Vf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k)));
        k = k.next;
    }
    n = null;
    for(k = b.firstCapturedUpdate; null !== k;){
        var z = k.expirationTime;
        z < e ? (null === n && (n = k, null === h && (f = l)), g < z && (g = z)) : (l = $b36288e2db101ba3$var$Vf(a, b, k, l, c, d), null !== k.callback && (a.effectTag |= 32, k.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k)));
        k = k.next;
    }
    null === h && (b.lastUpdate = null);
    null === n ? b.lastCapturedUpdate = null : a.effectTag |= 32;
    null === h && null === n && (f = l);
    b.baseState = f;
    b.firstUpdate = h;
    b.firstCapturedUpdate = n;
    a.expirationTime = g;
    a.memoizedState = l;
}
function $b36288e2db101ba3$var$Yf(a, b, c) {
    null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
    $b36288e2db101ba3$var$Zf(b.firstEffect, c);
    b.firstEffect = b.lastEffect = null;
    $b36288e2db101ba3$var$Zf(b.firstCapturedEffect, c);
    b.firstCapturedEffect = b.lastCapturedEffect = null;
}
function $b36288e2db101ba3$var$Zf(a, b) {
    for(; null !== a;){
        var c = a.callback;
        if (null !== c) {
            a.callback = null;
            var d = b;
            if ("function" !== typeof c) throw $b36288e2db101ba3$var$t(Error(191), c);
            c.call(d);
        }
        a = a.nextEffect;
    }
}
var $b36288e2db101ba3$var$$f = $b36288e2db101ba3$var$Xb.ReactCurrentBatchConfig, $b36288e2db101ba3$var$ag = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$bg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4yvvI({}, b, c);
    a.memoizedState = c;
    d = a.updateQueue;
    null !== d && 0 === a.expirationTime && (d.baseState = c);
}
var $b36288e2db101ba3$var$fg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? 2 === $b36288e2db101ba3$var$ld(a) : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $b36288e2db101ba3$var$cg(), e = $b36288e2db101ba3$var$$f.suspense;
        d = $b36288e2db101ba3$var$dg(d, a, e);
        e = $b36288e2db101ba3$var$Qf(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $b36288e2db101ba3$var$Sf(a, e);
        $b36288e2db101ba3$var$eg(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = $b36288e2db101ba3$var$cg(), e = $b36288e2db101ba3$var$$f.suspense;
        d = $b36288e2db101ba3$var$dg(d, a, e);
        e = $b36288e2db101ba3$var$Qf(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        $b36288e2db101ba3$var$Sf(a, e);
        $b36288e2db101ba3$var$eg(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = $b36288e2db101ba3$var$cg(), d = $b36288e2db101ba3$var$$f.suspense;
        c = $b36288e2db101ba3$var$dg(c, a, d);
        d = $b36288e2db101ba3$var$Qf(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        $b36288e2db101ba3$var$Sf(a, d);
        $b36288e2db101ba3$var$eg(a, c);
    }
};
function $b36288e2db101ba3$var$gg(a, b, c, d, e, f, h) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, h) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$jd(c, d) || !$b36288e2db101ba3$var$jd(e, f) : !0;
}
function $b36288e2db101ba3$var$hg(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Qe;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Mf(f) : (e = $b36288e2db101ba3$var$N(b) ? $b36288e2db101ba3$var$Re : $b36288e2db101ba3$var$L.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Se(a, e) : $b36288e2db101ba3$var$Qe);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$fg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$ig(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$fg.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$jg(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$ag;
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Mf(f) : (f = $b36288e2db101ba3$var$N(b) ? $b36288e2db101ba3$var$Re : $b36288e2db101ba3$var$L.current, e.context = $b36288e2db101ba3$var$Se(a, f));
    f = a.updateQueue;
    null !== f && ($b36288e2db101ba3$var$Wf(a, f, c, e, d), e.state = a.memoizedState);
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$bg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$fg.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && ($b36288e2db101ba3$var$Wf(a, f, c, e, d), e.state = a.memoizedState));
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var $b36288e2db101ba3$var$kg = Array.isArray;
function $b36288e2db101ba3$var$lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            var d = void 0;
            if (c) {
                if (1 !== c.tag) throw $b36288e2db101ba3$var$t(Error(309));
                d = c.stateNode;
            }
            if (!d) throw $b36288e2db101ba3$var$t(Error(147), a);
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $b36288e2db101ba3$var$ag && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw $b36288e2db101ba3$var$t(Error(284));
        if (!c._owner) throw $b36288e2db101ba3$var$t(Error(290), a);
    }
    return a;
}
function $b36288e2db101ba3$var$mg(a, b) {
    if ("textarea" !== a.type) throw $b36288e2db101ba3$var$t(Error(31), "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function $b36288e2db101ba3$var$ng(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b, c) {
        a = $b36288e2db101ba3$var$og(a, b, c);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function h(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function g(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$pg(c, a.mode, d), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props, d), d.ref = $b36288e2db101ba3$var$lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$qg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$rg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || [], d);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$sg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c, d);
        b.return = a;
        return b;
    }
    function z(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $b36288e2db101ba3$var$pg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$Zb:
                    return c = $b36288e2db101ba3$var$qg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$$b:
                    return b = $b36288e2db101ba3$var$rg(b, a.mode, c), b.return = a, b;
            }
            if ($b36288e2db101ba3$var$kg(b) || $b36288e2db101ba3$var$mc(b)) return b = $b36288e2db101ba3$var$sg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$mg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : g(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$Zb:
                    return c.key === e ? c.type === $b36288e2db101ba3$var$ac ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$$b:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($b36288e2db101ba3$var$kg(c) || $b36288e2db101ba3$var$mc(c)) return null !== e ? null : n(a, b, c, d, null);
            $b36288e2db101ba3$var$mg(a, c);
        }
        return null;
    }
    function v(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, g(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$Zb:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $b36288e2db101ba3$var$ac ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $b36288e2db101ba3$var$$b:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($b36288e2db101ba3$var$kg(d) || $b36288e2db101ba3$var$mc(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $b36288e2db101ba3$var$mg(b, d);
        }
        return null;
    }
    function rb(e, h, g, k) {
        for(var l = null, u = null, n = h, w = h = 0, C = null; null !== n && w < g.length; w++){
            n.index > w ? (C = n, n = null) : C = n.sibling;
            var p = x(e, n, g[w], k);
            if (null === p) {
                null === n && (n = C);
                break;
            }
            a && n && null === p.alternate && b(e, n);
            h = f(p, h, w);
            null === u ? l = p : u.sibling = p;
            u = p;
            n = C;
        }
        if (w === g.length) return c(e, n), l;
        if (null === n) {
            for(; w < g.length; w++)n = z(e, g[w], k), null !== n && (h = f(n, h, w), null === u ? l = n : u.sibling = n, u = n);
            return l;
        }
        for(n = d(e, n); w < g.length; w++)C = v(n, e, w, g[w], k), null !== C && (a && null !== C.alternate && n.delete(null === C.key ? w : C.key), h = f(C, h, w), null === u ? l = C : u.sibling = C, u = C);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function Be(e, h, g, k) {
        var l = $b36288e2db101ba3$var$mc(g);
        if ("function" !== typeof l) throw $b36288e2db101ba3$var$t(Error(150));
        g = l.call(g);
        if (null == g) throw $b36288e2db101ba3$var$t(Error(151));
        for(var n = l = null, u = h, w = h = 0, C = null, p = g.next(); null !== u && !p.done; w++, p = g.next()){
            u.index > w ? (C = u, u = null) : C = u.sibling;
            var r = x(e, u, p.value, k);
            if (null === r) {
                null === u && (u = C);
                break;
            }
            a && u && null === r.alternate && b(e, u);
            h = f(r, h, w);
            null === n ? l = r : n.sibling = r;
            n = r;
            u = C;
        }
        if (p.done) return c(e, u), l;
        if (null === u) {
            for(; !p.done; w++, p = g.next())p = z(e, p.value, k), null !== p && (h = f(p, h, w), null === n ? l = p : n.sibling = p, n = p);
            return l;
        }
        for(u = d(e, u); !p.done; w++, p = g.next())p = v(u, e, w, p.value, k), null !== p && (a && null !== p.alternate && u.delete(null === p.key ? w : p.key), h = f(p, h, w), null === n ? l = p : n.sibling = p, n = p);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, g) {
        var k = "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ac && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $b36288e2db101ba3$var$Zb:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            if (7 === k.tag ? f.type === $b36288e2db101ba3$var$ac : k.elementType === f.type) {
                                c(a, k.sibling);
                                d = e(k, f.type === $b36288e2db101ba3$var$ac ? f.props.children : f.props, g);
                                d.ref = $b36288e2db101ba3$var$lg(a, k, f);
                                d.return = a;
                                a = d;
                                break a;
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $b36288e2db101ba3$var$ac ? (d = $b36288e2db101ba3$var$sg(f.props.children, a.mode, g, f.key), d.return = a, a = d) : (g = $b36288e2db101ba3$var$qg(f.type, f.key, f.props, null, a.mode, g), g.ref = $b36288e2db101ba3$var$lg(a, d, f), g.return = a, a = g);
                }
                return h(a);
            case $b36288e2db101ba3$var$$b:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || [], g);
                                d.return = a;
                                a = d;
                                break a;
                            }
                            c(a, d);
                            break;
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $b36288e2db101ba3$var$rg(f, a.mode, g);
                    d.return = a;
                    a = d;
                }
                return h(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, g), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$pg(f, a.mode, g), d.return = a, a = d), h(a);
        if ($b36288e2db101ba3$var$kg(f)) return rb(a, d, f, g);
        if ($b36288e2db101ba3$var$mc(f)) return Be(a, d, f, g);
        l && $b36288e2db101ba3$var$mg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, $b36288e2db101ba3$var$t(Error(152), a.displayName || a.name || "Component");
        }
        return c(a, d);
    };
}
var $b36288e2db101ba3$var$tg = $b36288e2db101ba3$var$ng(!0), $b36288e2db101ba3$var$ug = $b36288e2db101ba3$var$ng(!1), $b36288e2db101ba3$var$vg = {}, $b36288e2db101ba3$var$wg = {
    current: $b36288e2db101ba3$var$vg
}, $b36288e2db101ba3$var$xg = {
    current: $b36288e2db101ba3$var$vg
}, $b36288e2db101ba3$var$yg = {
    current: $b36288e2db101ba3$var$vg
};
function $b36288e2db101ba3$var$zg(a) {
    if (a === $b36288e2db101ba3$var$vg) throw $b36288e2db101ba3$var$t(Error(174));
    return a;
}
function $b36288e2db101ba3$var$Ag(a, b) {
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$yg, b, a);
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$xg, a, a);
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$wg, $b36288e2db101ba3$var$vg, a);
    var c = b.nodeType;
    switch(c){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$te(null, "");
            break;
        default:
            c = 8 === c ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = $b36288e2db101ba3$var$te(b, c);
    }
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$wg, a);
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$wg, b, a);
}
function $b36288e2db101ba3$var$Bg(a) {
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$wg, a);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$xg, a);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$yg, a);
}
function $b36288e2db101ba3$var$Cg(a) {
    $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$yg.current);
    var b = $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$wg.current);
    var c = $b36288e2db101ba3$var$te(b, a.type);
    b !== c && ($b36288e2db101ba3$var$J($b36288e2db101ba3$var$xg, a, a), $b36288e2db101ba3$var$J($b36288e2db101ba3$var$wg, c, a));
}
function $b36288e2db101ba3$var$Dg(a) {
    $b36288e2db101ba3$var$xg.current === a && ($b36288e2db101ba3$var$H($b36288e2db101ba3$var$wg, a), $b36288e2db101ba3$var$H($b36288e2db101ba3$var$xg, a));
}
var $b36288e2db101ba3$var$Eg = 1, $b36288e2db101ba3$var$Fg = 1, $b36288e2db101ba3$var$Gg = 2, $b36288e2db101ba3$var$P = {
    current: 0
};
function $b36288e2db101ba3$var$Hg(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            if (null !== b.memoizedState) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Ig = 0, $b36288e2db101ba3$var$Jg = 2, $b36288e2db101ba3$var$Kg = 4, $b36288e2db101ba3$var$Lg = 8, $b36288e2db101ba3$var$Mg = 16, $b36288e2db101ba3$var$Ng = 32, $b36288e2db101ba3$var$Og = 64, $b36288e2db101ba3$var$Pg = 128, $b36288e2db101ba3$var$Qg = $b36288e2db101ba3$var$Xb.ReactCurrentDispatcher, $b36288e2db101ba3$var$Rg = 0, $b36288e2db101ba3$var$Sg = null, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Tg = null, $b36288e2db101ba3$var$Ug = null, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Vg = null, $b36288e2db101ba3$var$Wg = 0, $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = 0, $b36288e2db101ba3$var$Zg = !1, $b36288e2db101ba3$var$$g = null, $b36288e2db101ba3$var$ah = 0;
function $b36288e2db101ba3$var$bh() {
    throw $b36288e2db101ba3$var$t(Error(321));
}
function $b36288e2db101ba3$var$ch(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$hd(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$dh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rg = f;
    $b36288e2db101ba3$var$Sg = b;
    $b36288e2db101ba3$var$Tg = null !== a ? a.memoizedState : null;
    $b36288e2db101ba3$var$Qg.current = null === $b36288e2db101ba3$var$Tg ? $b36288e2db101ba3$var$eh : $b36288e2db101ba3$var$fh;
    b = c(d, e);
    if ($b36288e2db101ba3$var$Zg) {
        do $b36288e2db101ba3$var$Zg = !1, $b36288e2db101ba3$var$ah += 1, $b36288e2db101ba3$var$Tg = null !== a ? a.memoizedState : null, $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Ug, $b36288e2db101ba3$var$Xg = $b36288e2db101ba3$var$R = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Qg.current = $b36288e2db101ba3$var$fh, b = c(d, e);
        while ($b36288e2db101ba3$var$Zg);
        $b36288e2db101ba3$var$$g = null;
        $b36288e2db101ba3$var$ah = 0;
    }
    $b36288e2db101ba3$var$Qg.current = $b36288e2db101ba3$var$hh;
    a = $b36288e2db101ba3$var$Sg;
    a.memoizedState = $b36288e2db101ba3$var$Ug;
    a.expirationTime = $b36288e2db101ba3$var$Wg;
    a.updateQueue = $b36288e2db101ba3$var$Xg;
    a.effectTag |= $b36288e2db101ba3$var$Yg;
    a = null !== $b36288e2db101ba3$var$Q && null !== $b36288e2db101ba3$var$Q.next;
    $b36288e2db101ba3$var$Rg = 0;
    $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$R = $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Tg = $b36288e2db101ba3$var$Q = $b36288e2db101ba3$var$Sg = null;
    $b36288e2db101ba3$var$Wg = 0;
    $b36288e2db101ba3$var$Xg = null;
    $b36288e2db101ba3$var$Yg = 0;
    if (a) throw $b36288e2db101ba3$var$t(Error(300));
    return b;
}
function $b36288e2db101ba3$var$ih() {
    $b36288e2db101ba3$var$Qg.current = $b36288e2db101ba3$var$hh;
    $b36288e2db101ba3$var$Rg = 0;
    $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$R = $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Tg = $b36288e2db101ba3$var$Q = $b36288e2db101ba3$var$Sg = null;
    $b36288e2db101ba3$var$Wg = 0;
    $b36288e2db101ba3$var$Xg = null;
    $b36288e2db101ba3$var$Yg = 0;
    $b36288e2db101ba3$var$Zg = !1;
    $b36288e2db101ba3$var$$g = null;
    $b36288e2db101ba3$var$ah = 0;
}
function $b36288e2db101ba3$var$jh() {
    var a = {
        memoizedState: null,
        baseState: null,
        queue: null,
        baseUpdate: null,
        next: null
    };
    null === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$R = a : $b36288e2db101ba3$var$R = $b36288e2db101ba3$var$R.next = a;
    return $b36288e2db101ba3$var$R;
}
function $b36288e2db101ba3$var$kh() {
    if (null !== $b36288e2db101ba3$var$Vg) $b36288e2db101ba3$var$R = $b36288e2db101ba3$var$Vg, $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$R.next, $b36288e2db101ba3$var$Q = $b36288e2db101ba3$var$Tg, $b36288e2db101ba3$var$Tg = null !== $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Q.next : null;
    else {
        if (null === $b36288e2db101ba3$var$Tg) throw $b36288e2db101ba3$var$t(Error(310));
        $b36288e2db101ba3$var$Q = $b36288e2db101ba3$var$Tg;
        var a = {
            memoizedState: $b36288e2db101ba3$var$Q.memoizedState,
            baseState: $b36288e2db101ba3$var$Q.baseState,
            queue: $b36288e2db101ba3$var$Q.queue,
            baseUpdate: $b36288e2db101ba3$var$Q.baseUpdate,
            next: null
        };
        $b36288e2db101ba3$var$R = null === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Ug = a : $b36288e2db101ba3$var$R.next = a;
        $b36288e2db101ba3$var$Tg = $b36288e2db101ba3$var$Q.next;
    }
    return $b36288e2db101ba3$var$R;
}
function $b36288e2db101ba3$var$lh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$mh(a) {
    var b = $b36288e2db101ba3$var$kh(), c = b.queue;
    if (null === c) throw $b36288e2db101ba3$var$t(Error(311));
    c.lastRenderedReducer = a;
    if (0 < $b36288e2db101ba3$var$ah) {
        var d = c.dispatch;
        if (null !== $b36288e2db101ba3$var$$g) {
            var e = $b36288e2db101ba3$var$$g.get(c);
            if (void 0 !== e) {
                $b36288e2db101ba3$var$$g.delete(c);
                var f = b.memoizedState;
                do f = a(f, e.action), e = e.next;
                while (null !== e);
                $b36288e2db101ba3$var$hd(f, b.memoizedState) || ($b36288e2db101ba3$var$Lf = !0);
                b.memoizedState = f;
                b.baseUpdate === c.last && (b.baseState = f);
                c.lastRenderedState = f;
                return [
                    f,
                    d
                ];
            }
        }
        return [
            b.memoizedState,
            d
        ];
    }
    d = c.last;
    var h = b.baseUpdate;
    f = b.baseState;
    null !== h ? (null !== d && (d.next = null), d = h.next) : d = null !== d ? d.next : null;
    if (null !== d) {
        var g = e = null, k = d, l = !1;
        do {
            var n = k.expirationTime;
            n < $b36288e2db101ba3$var$Rg ? (l || (l = !0, g = h, e = f), n > $b36288e2db101ba3$var$Wg && ($b36288e2db101ba3$var$Wg = n)) : ($b36288e2db101ba3$var$Xf(n, k.suspenseConfig), f = k.eagerReducer === a ? k.eagerState : a(f, k.action));
            h = k;
            k = k.next;
        }while (null !== k && k !== d);
        l || (g = h, e = f);
        $b36288e2db101ba3$var$hd(f, b.memoizedState) || ($b36288e2db101ba3$var$Lf = !0);
        b.memoizedState = f;
        b.baseUpdate = g;
        b.baseState = e;
        c.lastRenderedState = f;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$nh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    null === $b36288e2db101ba3$var$Xg ? ($b36288e2db101ba3$var$Xg = {
        lastEffect: null
    }, $b36288e2db101ba3$var$Xg.lastEffect = a.next = a) : (b = $b36288e2db101ba3$var$Xg.lastEffect, null === b ? $b36288e2db101ba3$var$Xg.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, $b36288e2db101ba3$var$Xg.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$oh(a, b, c, d) {
    var e = $b36288e2db101ba3$var$jh();
    $b36288e2db101ba3$var$Yg |= a;
    e.memoizedState = $b36288e2db101ba3$var$nh(b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ph(a, b, c, d) {
    var e = $b36288e2db101ba3$var$kh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$Q) {
        var h = $b36288e2db101ba3$var$Q.memoizedState;
        f = h.destroy;
        if (null !== d && $b36288e2db101ba3$var$ch(d, h.deps)) {
            $b36288e2db101ba3$var$nh($b36288e2db101ba3$var$Ig, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$Yg |= a;
    e.memoizedState = $b36288e2db101ba3$var$nh(b, c, f, d);
}
function $b36288e2db101ba3$var$qh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$rh() {}
function $b36288e2db101ba3$var$sh(a, b, c) {
    if (!(25 > $b36288e2db101ba3$var$ah)) throw $b36288e2db101ba3$var$t(Error(301));
    var d = a.alternate;
    if (a === $b36288e2db101ba3$var$Sg || null !== d && d === $b36288e2db101ba3$var$Sg) {
        if ($b36288e2db101ba3$var$Zg = !0, a = {
            expirationTime: $b36288e2db101ba3$var$Rg,
            suspenseConfig: null,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        }, null === $b36288e2db101ba3$var$$g && ($b36288e2db101ba3$var$$g = new Map), c = $b36288e2db101ba3$var$$g.get(b), void 0 === c) $b36288e2db101ba3$var$$g.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    } else {
        var e = $b36288e2db101ba3$var$cg(), f = $b36288e2db101ba3$var$$f.suspense;
        e = $b36288e2db101ba3$var$dg(e, a, f);
        f = {
            expirationTime: e,
            suspenseConfig: f,
            action: c,
            eagerReducer: null,
            eagerState: null,
            next: null
        };
        var h = b.last;
        if (null === h) f.next = f;
        else {
            var g = h.next;
            null !== g && (f.next = g);
            h.next = f;
        }
        b.last = f;
        if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
            var k = b.lastRenderedState, l = d(k, c);
            f.eagerReducer = d;
            f.eagerState = l;
            if ($b36288e2db101ba3$var$hd(l, k)) return;
        } catch (n) {} finally{}
        $b36288e2db101ba3$var$eg(a, e);
    }
}
var $b36288e2db101ba3$var$hh = {
    readContext: $b36288e2db101ba3$var$Mf,
    useCallback: $b36288e2db101ba3$var$bh,
    useContext: $b36288e2db101ba3$var$bh,
    useEffect: $b36288e2db101ba3$var$bh,
    useImperativeHandle: $b36288e2db101ba3$var$bh,
    useLayoutEffect: $b36288e2db101ba3$var$bh,
    useMemo: $b36288e2db101ba3$var$bh,
    useReducer: $b36288e2db101ba3$var$bh,
    useRef: $b36288e2db101ba3$var$bh,
    useState: $b36288e2db101ba3$var$bh,
    useDebugValue: $b36288e2db101ba3$var$bh,
    useResponder: $b36288e2db101ba3$var$bh
}, $b36288e2db101ba3$var$eh = {
    readContext: $b36288e2db101ba3$var$Mf,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$jh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Mf,
    useEffect: function(a, b) {
        return $b36288e2db101ba3$var$oh(516, $b36288e2db101ba3$var$Pg | $b36288e2db101ba3$var$Og, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$oh(4, $b36288e2db101ba3$var$Kg | $b36288e2db101ba3$var$Ng, $b36288e2db101ba3$var$qh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$oh(4, $b36288e2db101ba3$var$Kg | $b36288e2db101ba3$var$Ng, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$jh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$jh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $b36288e2db101ba3$var$sh.bind(null, $b36288e2db101ba3$var$Sg, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$jh();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: function(a) {
        var b = $b36288e2db101ba3$var$jh();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: $b36288e2db101ba3$var$lh,
            lastRenderedState: a
        };
        a = a.dispatch = $b36288e2db101ba3$var$sh.bind(null, $b36288e2db101ba3$var$Sg, a);
        return [
            b.memoizedState,
            a
        ];
    },
    useDebugValue: $b36288e2db101ba3$var$rh,
    useResponder: $b36288e2db101ba3$var$kd
}, $b36288e2db101ba3$var$fh = {
    readContext: $b36288e2db101ba3$var$Mf,
    useCallback: function(a, b) {
        var c = $b36288e2db101ba3$var$kh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $b36288e2db101ba3$var$ch(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Mf,
    useEffect: function(a, b) {
        return $b36288e2db101ba3$var$ph(516, $b36288e2db101ba3$var$Pg | $b36288e2db101ba3$var$Og, a, b);
    },
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ph(4, $b36288e2db101ba3$var$Kg | $b36288e2db101ba3$var$Ng, $b36288e2db101ba3$var$qh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ph(4, $b36288e2db101ba3$var$Kg | $b36288e2db101ba3$var$Ng, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$kh();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && $b36288e2db101ba3$var$ch(b, d[1])) return d[0];
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: $b36288e2db101ba3$var$mh,
    useRef: function() {
        return $b36288e2db101ba3$var$kh().memoizedState;
    },
    useState: function(a) {
        return $b36288e2db101ba3$var$mh($b36288e2db101ba3$var$lh, a);
    },
    useDebugValue: $b36288e2db101ba3$var$rh,
    useResponder: $b36288e2db101ba3$var$kd
}, $b36288e2db101ba3$var$th = null, $b36288e2db101ba3$var$uh = null, $b36288e2db101ba3$var$vh = !1;
function $b36288e2db101ba3$var$wh(a, b) {
    var c = $b36288e2db101ba3$var$xh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $b36288e2db101ba3$var$yh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$zh(a) {
    if ($b36288e2db101ba3$var$vh) {
        var b = $b36288e2db101ba3$var$uh;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$yh(a, b)) {
                b = $b36288e2db101ba3$var$Ne(c.nextSibling);
                if (!b || !$b36288e2db101ba3$var$yh(a, b)) {
                    a.effectTag |= 2;
                    $b36288e2db101ba3$var$vh = !1;
                    $b36288e2db101ba3$var$th = a;
                    return;
                }
                $b36288e2db101ba3$var$wh($b36288e2db101ba3$var$th, c);
            }
            $b36288e2db101ba3$var$th = a;
            $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Ne(b.firstChild);
        } else a.effectTag |= 2, $b36288e2db101ba3$var$vh = !1, $b36288e2db101ba3$var$th = a;
    }
}
function $b36288e2db101ba3$var$Ah(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 18 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$th = a;
}
function $b36288e2db101ba3$var$Bh(a) {
    if (a !== $b36288e2db101ba3$var$th) return !1;
    if (!$b36288e2db101ba3$var$vh) return $b36288e2db101ba3$var$Ah(a), $b36288e2db101ba3$var$vh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ke(b, a.memoizedProps)) for(b = $b36288e2db101ba3$var$uh; b;)$b36288e2db101ba3$var$wh(a, b), b = $b36288e2db101ba3$var$Ne(b.nextSibling);
    $b36288e2db101ba3$var$Ah(a);
    $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$th ? $b36288e2db101ba3$var$Ne(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Ch() {
    $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$th = null;
    $b36288e2db101ba3$var$vh = !1;
}
var $b36288e2db101ba3$var$Dh = $b36288e2db101ba3$var$Xb.ReactCurrentOwner, $b36288e2db101ba3$var$Lf = !1;
function $b36288e2db101ba3$var$S(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$ug(b, null, c, d) : $b36288e2db101ba3$var$tg(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Eh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Kf(b, e);
    d = $b36288e2db101ba3$var$dh(a, b, c, d, f, e);
    if (null !== a && !$b36288e2db101ba3$var$Lf) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $b36288e2db101ba3$var$Fh(a, b, e);
    b.effectTag |= 1;
    $b36288e2db101ba3$var$S(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$Gh(a, b, c, d, e, f) {
    if (null === a) {
        var h = c.type;
        if ("function" === typeof h && !$b36288e2db101ba3$var$Hh(h) && void 0 === h.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = h, $b36288e2db101ba3$var$Ih(a, b, h, d, e, f);
        a = $b36288e2db101ba3$var$qg(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    h = a.child;
    if (e < f && (e = h.memoizedProps, c = c.compare, c = null !== c ? c : $b36288e2db101ba3$var$jd, c(e, d) && a.ref === b.ref)) return $b36288e2db101ba3$var$Fh(a, b, f);
    b.effectTag |= 1;
    a = $b36288e2db101ba3$var$og(h, d, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$Ih(a, b, c, d, e, f) {
    return null !== a && $b36288e2db101ba3$var$jd(a.memoizedProps, d) && a.ref === b.ref && ($b36288e2db101ba3$var$Lf = !1, e < f) ? $b36288e2db101ba3$var$Fh(a, b, f) : $b36288e2db101ba3$var$Jh(a, b, c, d, f);
}
function $b36288e2db101ba3$var$Kh(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function $b36288e2db101ba3$var$Jh(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$N(c) ? $b36288e2db101ba3$var$Re : $b36288e2db101ba3$var$L.current;
    f = $b36288e2db101ba3$var$Se(b, f);
    $b36288e2db101ba3$var$Kf(b, e);
    c = $b36288e2db101ba3$var$dh(a, b, c, d, f, e);
    if (null !== a && !$b36288e2db101ba3$var$Lf) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $b36288e2db101ba3$var$Fh(a, b, e);
    b.effectTag |= 1;
    $b36288e2db101ba3$var$S(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$Lh(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$N(c)) {
        var f = !0;
        $b36288e2db101ba3$var$Xe(b);
    } else f = !1;
    $b36288e2db101ba3$var$Kf(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), $b36288e2db101ba3$var$hg(b, c, d, e), $b36288e2db101ba3$var$jg(b, c, d, e), d = !0;
    else if (null === a) {
        var h = b.stateNode, g = b.memoizedProps;
        h.props = g;
        var k = h.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Mf(l) : (l = $b36288e2db101ba3$var$N(c) ? $b36288e2db101ba3$var$Re : $b36288e2db101ba3$var$L.current, l = $b36288e2db101ba3$var$Se(b, l));
        var n = c.getDerivedStateFromProps, z = "function" === typeof n || "function" === typeof h.getSnapshotBeforeUpdate;
        z || "function" !== typeof h.UNSAFE_componentWillReceiveProps && "function" !== typeof h.componentWillReceiveProps || (g !== d || k !== l) && $b36288e2db101ba3$var$ig(b, h, d, l);
        $b36288e2db101ba3$var$Nf = !1;
        var x = b.memoizedState;
        k = h.state = x;
        var v = b.updateQueue;
        null !== v && ($b36288e2db101ba3$var$Wf(b, v, d, h, e), k = b.memoizedState);
        g !== d || x !== k || $b36288e2db101ba3$var$M.current || $b36288e2db101ba3$var$Nf ? ("function" === typeof n && ($b36288e2db101ba3$var$bg(b, c, n, d), k = b.memoizedState), (g = $b36288e2db101ba3$var$Nf || $b36288e2db101ba3$var$gg(b, c, g, d, x, k, l)) ? (z || "function" !== typeof h.UNSAFE_componentWillMount && "function" !== typeof h.componentWillMount || ("function" === typeof h.componentWillMount && h.componentWillMount(), "function" === typeof h.UNSAFE_componentWillMount && h.UNSAFE_componentWillMount()), "function" === typeof h.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof h.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), h.props = d, h.state = k, h.context = l, d = g) : ("function" === typeof h.componentDidMount && (b.effectTag |= 4), d = !1);
    } else h = b.stateNode, g = b.memoizedProps, h.props = b.type === b.elementType ? g : $b36288e2db101ba3$var$Af(b.type, g), k = h.context, l = c.contextType, "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Mf(l) : (l = $b36288e2db101ba3$var$N(c) ? $b36288e2db101ba3$var$Re : $b36288e2db101ba3$var$L.current, l = $b36288e2db101ba3$var$Se(b, l)), n = c.getDerivedStateFromProps, (z = "function" === typeof n || "function" === typeof h.getSnapshotBeforeUpdate) || "function" !== typeof h.UNSAFE_componentWillReceiveProps && "function" !== typeof h.componentWillReceiveProps || (g !== d || k !== l) && $b36288e2db101ba3$var$ig(b, h, d, l), $b36288e2db101ba3$var$Nf = !1, k = b.memoizedState, x = h.state = k, v = b.updateQueue, null !== v && ($b36288e2db101ba3$var$Wf(b, v, d, h, e), x = b.memoizedState), g !== d || k !== x || $b36288e2db101ba3$var$M.current || $b36288e2db101ba3$var$Nf ? ("function" === typeof n && ($b36288e2db101ba3$var$bg(b, c, n, d), x = b.memoizedState), (n = $b36288e2db101ba3$var$Nf || $b36288e2db101ba3$var$gg(b, c, g, d, k, x, l)) ? (z || "function" !== typeof h.UNSAFE_componentWillUpdate && "function" !== typeof h.componentWillUpdate || ("function" === typeof h.componentWillUpdate && h.componentWillUpdate(d, x, l), "function" === typeof h.UNSAFE_componentWillUpdate && h.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof h.componentDidUpdate && (b.effectTag |= 4), "function" === typeof h.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof h.componentDidUpdate || g === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof h.getSnapshotBeforeUpdate || g === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), h.props = d, h.state = x, h.context = l, d = n) : ("function" !== typeof h.componentDidUpdate || g === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof h.getSnapshotBeforeUpdate || g === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return $b36288e2db101ba3$var$Mh(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$Mh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Kh(a, b);
    var h = 0 !== (b.effectTag & 64);
    if (!d && !h) return e && $b36288e2db101ba3$var$Ye(b, c, !1), $b36288e2db101ba3$var$Fh(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Dh.current = b;
    var g = h && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && h ? (b.child = $b36288e2db101ba3$var$tg(b, a.child, null, f), b.child = $b36288e2db101ba3$var$tg(b, null, g, f)) : $b36288e2db101ba3$var$S(a, b, g, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$Ye(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$Nh(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$Ve(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$Ve(a, b.context, !1);
    $b36288e2db101ba3$var$Ag(a, b.containerInfo);
}
var $b36288e2db101ba3$var$Oh = {};
function $b36288e2db101ba3$var$Ph(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = $b36288e2db101ba3$var$P.current, h = null, g = !1, k;
    (k = 0 !== (b.effectTag & 64)) || (k = 0 !== (f & $b36288e2db101ba3$var$Gg) && (null === a || null !== a.memoizedState));
    k ? (h = $b36288e2db101ba3$var$Oh, g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= $b36288e2db101ba3$var$Fg);
    f &= $b36288e2db101ba3$var$Eg;
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, f, b);
    if (null === a) {
        if (g) {
            e = e.fallback;
            a = $b36288e2db101ba3$var$sg(null, d, 0, null);
            a.return = b;
            if (0 === (b.mode & 2)) for(g = null !== b.memoizedState ? b.child.child : b.child, a.child = g; null !== g;)g.return = a, g = g.sibling;
            c = $b36288e2db101ba3$var$sg(e, d, c, null);
            c.return = b;
            a.sibling = c;
            d = a;
        } else d = c = $b36288e2db101ba3$var$ug(b, null, e.children, c);
    } else {
        if (null !== a.memoizedState) {
            if (f = a.child, d = f.sibling, g) {
                e = e.fallback;
                c = $b36288e2db101ba3$var$og(f, f.pendingProps, 0);
                c.return = b;
                if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== f.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
                e = $b36288e2db101ba3$var$og(d, e, d.expirationTime);
                e.return = b;
                c.sibling = e;
                d = c;
                c.childExpirationTime = 0;
                c = e;
            } else d = c = $b36288e2db101ba3$var$tg(b, f.child, e.children, c);
        } else if (f = a.child, g) {
            g = e.fallback;
            e = $b36288e2db101ba3$var$sg(null, d, 0, null);
            e.return = b;
            e.child = f;
            null !== f && (f.return = e);
            if (0 === (b.mode & 2)) for(f = null !== b.memoizedState ? b.child.child : b.child, e.child = f; null !== f;)f.return = e, f = f.sibling;
            c = $b36288e2db101ba3$var$sg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            c.effectTag |= 2;
            d = e;
            e.childExpirationTime = 0;
        } else c = d = $b36288e2db101ba3$var$tg(b, f, e.children, c);
        b.stateNode = a.stateNode;
    }
    b.memoizedState = h;
    b.child = d;
    return c;
}
function $b36288e2db101ba3$var$Qh(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.last = d, f.tail = c, f.tailExpiration = 0, f.tailMode = e);
}
function $b36288e2db101ba3$var$Rh(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$S(a, b, d.children, c);
    d = $b36288e2db101ba3$var$P.current;
    if (0 !== (d & $b36288e2db101ba3$var$Gg)) d = d & $b36288e2db101ba3$var$Eg | $b36288e2db101ba3$var$Gg, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) {
                if (null !== a.memoizedState) {
                    a.expirationTime < c && (a.expirationTime = c);
                    var h = a.alternate;
                    null !== h && h.expirationTime < c && (h.expirationTime = c);
                    $b36288e2db101ba3$var$Jf(a.return, c);
                }
            } else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= $b36288e2db101ba3$var$Eg;
    }
    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, d, b);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)d = c.alternate, null !== d && null === $b36288e2db101ba3$var$Hg(d) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$Qh(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                d = e.alternate;
                if (null !== d && null === $b36288e2db101ba3$var$Hg(d)) {
                    b.child = e;
                    break;
                }
                d = e.sibling;
                e.sibling = c;
                c = e;
                e = d;
            }
            $b36288e2db101ba3$var$Qh(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$Qh(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$Fh(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw $b36288e2db101ba3$var$t(Error(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$og(a, a.pendingProps, a.expirationTime);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$og(a, a.pendingProps, a.expirationTime), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$Sh(a) {
    a.effectTag |= 4;
}
var $b36288e2db101ba3$var$Th = void 0, $b36288e2db101ba3$var$Uh = void 0, $b36288e2db101ba3$var$Vh = void 0, $b36288e2db101ba3$var$Wh = void 0;
$b36288e2db101ba3$var$Th = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (20 === c.tag) a.appendChild(c.stateNode.instance);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Uh = function() {};
$b36288e2db101ba3$var$Vh = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var h = b.stateNode;
        $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$wg.current);
        a = null;
        switch(c){
            case "input":
                f = $b36288e2db101ba3$var$Bc(h, f);
                d = $b36288e2db101ba3$var$Bc(h, d);
                a = [];
                break;
            case "option":
                f = $b36288e2db101ba3$var$le(h, f);
                d = $b36288e2db101ba3$var$le(h, d);
                a = [];
                break;
            case "select":
                f = $4yvvI({}, f, {
                    value: void 0
                });
                d = $4yvvI({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = $b36288e2db101ba3$var$ne(h, f);
                d = $b36288e2db101ba3$var$ne(h, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (h.onclick = $b36288e2db101ba3$var$Ge);
        }
        $b36288e2db101ba3$var$De(c, d);
        h = c = void 0;
        var g = null;
        for(c in f)if (!d.hasOwnProperty(c) && f.hasOwnProperty(c) && null != f[c]) {
            if ("style" === c) {
                var k = f[c];
                for(h in k)k.hasOwnProperty(h) && (g || (g = {}), g[h] = "");
            } else "dangerouslySetInnerHTML" !== c && "children" !== c && "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && "autoFocus" !== c && ($b36288e2db101ba3$var$ia.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
        }
        for(c in d){
            var l = d[c];
            k = null != f ? f[c] : void 0;
            if (d.hasOwnProperty(c) && l !== k && (null != l || null != k)) {
                if ("style" === c) {
                    if (k) {
                        for(h in k)!k.hasOwnProperty(h) || l && l.hasOwnProperty(h) || (g || (g = {}), g[h] = "");
                        for(h in l)l.hasOwnProperty(h) && k[h] !== l[h] && (g || (g = {}), g[h] = l[h]);
                    } else g || (a || (a = []), a.push(c, g)), g = l;
                } else "dangerouslySetInnerHTML" === c ? (l = l ? l.__html : void 0, k = k ? k.__html : void 0, null != l && k !== l && (a = a || []).push(c, "" + l)) : "children" === c ? k === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(c, "" + l) : "suppressContentEditableWarning" !== c && "suppressHydrationWarning" !== c && ($b36288e2db101ba3$var$ia.hasOwnProperty(c) ? (null != l && $b36288e2db101ba3$var$Fe(e, c), a || k === l || (a = [])) : (a = a || []).push(c, l));
            }
        }
        g && (a = a || []).push("style", g);
        e = a;
        (b.updateQueue = e) && $b36288e2db101ba3$var$Sh(b);
    }
};
$b36288e2db101ba3$var$Wh = function(a, b, c, d) {
    c !== d && $b36288e2db101ba3$var$Sh(b);
};
function $b36288e2db101ba3$var$$h(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$ai(a) {
    switch(a.tag){
        case 1:
            $b36288e2db101ba3$var$N(a.type) && $b36288e2db101ba3$var$Te(a);
            var b = a.effectTag;
            return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 3:
            $b36288e2db101ba3$var$Bg(a);
            $b36288e2db101ba3$var$Ue(a);
            b = a.effectTag;
            if (0 !== (b & 64)) throw $b36288e2db101ba3$var$t(Error(285));
            a.effectTag = b & -2049 | 64;
            return a;
        case 5:
            return $b36288e2db101ba3$var$Dg(a), null;
        case 13:
            return $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P, a), b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
        case 18:
            return null;
        case 19:
            return $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P, a), null;
        case 4:
            return $b36288e2db101ba3$var$Bg(a), null;
        case 10:
            return $b36288e2db101ba3$var$If(a), null;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$bi(a, b) {
    return {
        value: a,
        source: b,
        stack: $b36288e2db101ba3$var$pc(b)
    };
}
var $b36288e2db101ba3$var$ci = "function" === typeof WeakSet ? WeakSet : Set;
function $b36288e2db101ba3$var$di(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = $b36288e2db101ba3$var$pc(c));
    null !== c && $b36288e2db101ba3$var$oc(c.type);
    b = b.value;
    null !== a && 1 === a.tag && $b36288e2db101ba3$var$oc(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function $b36288e2db101ba3$var$ei(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        $b36288e2db101ba3$var$fi(a, c);
    }
}
function $b36288e2db101ba3$var$gi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $b36288e2db101ba3$var$fi(a, c);
        }
        else b.current = null;
    }
}
function $b36288e2db101ba3$var$hi(a, b, c) {
    c = c.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) !== $b36288e2db101ba3$var$Ig) {
                var e = d.destroy;
                d.destroy = void 0;
                void 0 !== e && e();
            }
            (d.tag & b) !== $b36288e2db101ba3$var$Ig && (e = d.create, d.destroy = e());
            d = d.next;
        }while (d !== c);
    }
}
function $b36288e2db101ba3$var$ii(a, b) {
    "function" === typeof $b36288e2db101ba3$var$ji && $b36288e2db101ba3$var$ji(a);
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            var c = a.updateQueue;
            if (null !== c && (c = c.lastEffect, null !== c)) {
                var d = c.next;
                $b36288e2db101ba3$var$vf(97 < b ? 97 : b, function() {
                    var b = d;
                    do {
                        var c = b.destroy;
                        if (void 0 !== c) {
                            var h = a;
                            try {
                                c();
                            } catch (g) {
                                $b36288e2db101ba3$var$fi(h, g);
                            }
                        }
                        b = b.next;
                    }while (b !== d);
                });
            }
            break;
        case 1:
            $b36288e2db101ba3$var$gi(a);
            b = a.stateNode;
            "function" === typeof b.componentWillUnmount && $b36288e2db101ba3$var$ei(a, b);
            break;
        case 5:
            $b36288e2db101ba3$var$gi(a);
            break;
        case 4:
            $b36288e2db101ba3$var$ki(a, b);
    }
}
function $b36288e2db101ba3$var$li(a, b) {
    for(var c = a;;)if ($b36288e2db101ba3$var$ii(c, b), null !== c.child && 4 !== c.tag) c.child.return = c, c = c.child;
    else {
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $b36288e2db101ba3$var$mi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$ni(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($b36288e2db101ba3$var$mi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw $b36288e2db101ba3$var$t(Error(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw $b36288e2db101ba3$var$t(Error(161));
    }
    c.effectTag & 16 && ($b36288e2db101ba3$var$we(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $b36288e2db101ba3$var$mi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    for(var e = a;;){
        var f = 5 === e.tag || 6 === e.tag;
        if (f || 20 === e.tag) {
            var h = f ? e.stateNode : e.stateNode.instance;
            if (c) {
                if (d) {
                    f = b;
                    var g = h;
                    h = c;
                    8 === f.nodeType ? f.parentNode.insertBefore(g, h) : f.insertBefore(g, h);
                } else b.insertBefore(h, c);
            } else d ? (g = b, 8 === g.nodeType ? (f = g.parentNode, f.insertBefore(h, g)) : (f = g, f.appendChild(h)), g = g._reactRootContainer, null !== g && void 0 !== g || null !== f.onclick || (f.onclick = $b36288e2db101ba3$var$Ge)) : b.appendChild(h);
        } else if (4 !== e.tag && null !== e.child) {
            e.child.return = e;
            e = e.child;
            continue;
        }
        if (e === a) break;
        for(; null === e.sibling;){
            if (null === e.return || e.return === a) return;
            e = e.return;
        }
        e.sibling.return = e.return;
        e = e.sibling;
    }
}
function $b36288e2db101ba3$var$ki(a, b) {
    for(var c = a, d = !1, e = void 0, f = void 0;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw $b36288e2db101ba3$var$t(Error(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            if ($b36288e2db101ba3$var$li(c, b), f) {
                var h = e, g = c.stateNode;
                8 === h.nodeType ? h.parentNode.removeChild(g) : h.removeChild(g);
            } else e.removeChild(c.stateNode);
        } else if (20 === c.tag) g = c.stateNode.instance, $b36288e2db101ba3$var$li(c, b), f ? (h = e, 8 === h.nodeType ? h.parentNode.removeChild(g) : h.removeChild(g)) : e.removeChild(g);
        else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($b36288e2db101ba3$var$ii(c, b), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $b36288e2db101ba3$var$oi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$hi($b36288e2db101ba3$var$Kg, $b36288e2db101ba3$var$Lg, b);
            break;
        case 1:
            break;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$b36288e2db101ba3$var$Ga] = d;
                    "input" === a && "radio" === d.type && null != d.name && $b36288e2db101ba3$var$Dc(c, d);
                    $b36288e2db101ba3$var$Ee(a, e);
                    b = $b36288e2db101ba3$var$Ee(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var h = f[e], g = f[e + 1];
                        "style" === h ? $b36288e2db101ba3$var$Ae(c, g) : "dangerouslySetInnerHTML" === h ? $b36288e2db101ba3$var$ve(c, g) : "children" === h ? $b36288e2db101ba3$var$we(c, g) : $b36288e2db101ba3$var$zc(c, h, g, b);
                    }
                    switch(a){
                        case "input":
                            $b36288e2db101ba3$var$Ec(c, d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$pe(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? $b36288e2db101ba3$var$me(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? $b36288e2db101ba3$var$me(c, !!d.multiple, d.defaultValue, !0) : $b36288e2db101ba3$var$me(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            break;
        case 6:
            if (null === b.stateNode) throw $b36288e2db101ba3$var$t(Error(162));
            b.stateNode.nodeValue = b.memoizedProps;
            break;
        case 3:
            break;
        case 12:
            break;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, $b36288e2db101ba3$var$pi = $b36288e2db101ba3$var$sf());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = $b36288e2db101ba3$var$ze("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            $b36288e2db101ba3$var$qi(b);
            break;
        case 19:
            $b36288e2db101ba3$var$qi(b);
            break;
        case 17:
            break;
        case 20:
            break;
        default:
            throw $b36288e2db101ba3$var$t(Error(163));
    }
}
function $b36288e2db101ba3$var$qi(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$ci);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ri.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var $b36288e2db101ba3$var$si = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$ti(a, b, c) {
    c = $b36288e2db101ba3$var$Qf(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$ui || ($b36288e2db101ba3$var$ui = !0, $b36288e2db101ba3$var$vi = d);
        $b36288e2db101ba3$var$di(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$wi(a, b, c) {
    c = $b36288e2db101ba3$var$Qf(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $b36288e2db101ba3$var$di(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $b36288e2db101ba3$var$xi ? $b36288e2db101ba3$var$xi = new Set([
            this
        ]) : $b36288e2db101ba3$var$xi.add(this), $b36288e2db101ba3$var$di(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $b36288e2db101ba3$var$yi = Math.ceil, $b36288e2db101ba3$var$zi = $b36288e2db101ba3$var$Xb.ReactCurrentDispatcher, $b36288e2db101ba3$var$Ai = $b36288e2db101ba3$var$Xb.ReactCurrentOwner, $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$Bi = 8, $b36288e2db101ba3$var$Ci = 16, $b36288e2db101ba3$var$Di = 32, $b36288e2db101ba3$var$Ei = 0, $b36288e2db101ba3$var$Fi = 1, $b36288e2db101ba3$var$Gi = 2, $b36288e2db101ba3$var$Hi = 3, $b36288e2db101ba3$var$Ii = 4, $b36288e2db101ba3$var$U = $b36288e2db101ba3$var$T, $b36288e2db101ba3$var$Ji = null, $b36288e2db101ba3$var$V = null, $b36288e2db101ba3$var$W = 0, $b36288e2db101ba3$var$X = $b36288e2db101ba3$var$Ei, $b36288e2db101ba3$var$Ki = 1073741823, $b36288e2db101ba3$var$Li = 1073741823, $b36288e2db101ba3$var$Mi = null, $b36288e2db101ba3$var$Ni = !1, $b36288e2db101ba3$var$pi = 0, $b36288e2db101ba3$var$Oi = 500, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$ui = !1, $b36288e2db101ba3$var$vi = null, $b36288e2db101ba3$var$xi = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Ri = 90, $b36288e2db101ba3$var$Si = 0, $b36288e2db101ba3$var$Ti = null, $b36288e2db101ba3$var$Ui = 0, $b36288e2db101ba3$var$Vi = null, $b36288e2db101ba3$var$Wi = 0;
function $b36288e2db101ba3$var$cg() {
    return ($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) !== $b36288e2db101ba3$var$T ? 1073741821 - ($b36288e2db101ba3$var$sf() / 10 | 0) : 0 !== $b36288e2db101ba3$var$Wi ? $b36288e2db101ba3$var$Wi : $b36288e2db101ba3$var$Wi = 1073741821 - ($b36288e2db101ba3$var$sf() / 10 | 0);
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = $b36288e2db101ba3$var$tf();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if (($b36288e2db101ba3$var$U & $b36288e2db101ba3$var$Ci) !== $b36288e2db101ba3$var$T) return $b36288e2db101ba3$var$W;
    if (null !== c) a = 1073741821 - 25 * (((1073741821 - a + (c.timeoutMs | 0 || 5E3) / 10) / 25 | 0) + 1);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = 1073741821 - 10 * (((1073741821 - a + 15) / 10 | 0) + 1);
            break;
        case 97:
        case 96:
            a = 1073741821 - 25 * (((1073741821 - a + 500) / 25 | 0) + 1);
            break;
        case 95:
            a = 1;
            break;
        default:
            throw $b36288e2db101ba3$var$t(Error(326));
    }
    null !== $b36288e2db101ba3$var$Ji && a === $b36288e2db101ba3$var$W && --a;
    return a;
}
var $b36288e2db101ba3$var$Xi = 0;
function $b36288e2db101ba3$var$eg(a, b) {
    if (50 < $b36288e2db101ba3$var$Ui) throw $b36288e2db101ba3$var$Ui = 0, $b36288e2db101ba3$var$Vi = null, $b36288e2db101ba3$var$t(Error(185));
    a = $b36288e2db101ba3$var$Yi(a, b);
    if (null !== a) {
        a.pingTime = 0;
        var c = $b36288e2db101ba3$var$tf();
        if (1073741823 === b) {
            if (($b36288e2db101ba3$var$U & $b36288e2db101ba3$var$Bi) !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) === $b36288e2db101ba3$var$T) for(var d = $b36288e2db101ba3$var$Z(a, 1073741823, !0); null !== d;)d = d(!0);
            else $b36288e2db101ba3$var$Zi(a, 99, 1073741823), $b36288e2db101ba3$var$U === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$O();
        } else $b36288e2db101ba3$var$Zi(a, c, b);
        ($b36288e2db101ba3$var$U & 4) === $b36288e2db101ba3$var$T || 98 !== c && 99 !== c || (null === $b36288e2db101ba3$var$Ti ? $b36288e2db101ba3$var$Ti = new Map([
            [
                a,
                b
            ]
        ]) : (c = $b36288e2db101ba3$var$Ti.get(a), (void 0 === c || c > b) && $b36288e2db101ba3$var$Ti.set(a, b)));
    }
}
function $b36288e2db101ba3$var$Yi(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (b > e.firstPendingTime && (e.firstPendingTime = b), a = e.lastPendingTime, 0 === a || b < a) && (e.lastPendingTime = b);
    return e;
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    if (a.callbackExpirationTime < c) {
        var d = a.callbackNode;
        null !== d && d !== $b36288e2db101ba3$var$mf && $b36288e2db101ba3$var$af(d);
        a.callbackExpirationTime = c;
        1073741823 === c ? a.callbackNode = $b36288e2db101ba3$var$xf($b36288e2db101ba3$var$$i.bind(null, a, $b36288e2db101ba3$var$Z.bind(null, a, c))) : (d = null, 1 !== c && (d = {
            timeout: 10 * (1073741821 - c) - $b36288e2db101ba3$var$sf()
        }), a.callbackNode = $b36288e2db101ba3$var$wf(b, $b36288e2db101ba3$var$$i.bind(null, a, $b36288e2db101ba3$var$Z.bind(null, a, c)), d));
    }
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    var d = a.callbackNode, e = null;
    try {
        return e = b(c), null !== e ? $b36288e2db101ba3$var$$i.bind(null, a, e) : null;
    } finally{
        null === e && d === a.callbackNode && (a.callbackNode = null, a.callbackExpirationTime = 0);
    }
}
function $b36288e2db101ba3$var$aj() {
    ($b36288e2db101ba3$var$U & (1 | $b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$bj(), $b36288e2db101ba3$var$cj());
}
function $b36288e2db101ba3$var$dj(a, b) {
    var c = a.firstBatch;
    return null !== c && c._defer && c._expirationTime >= b ? ($b36288e2db101ba3$var$wf(97, function() {
        c._onComplete();
        return null;
    }), !0) : !1;
}
function $b36288e2db101ba3$var$bj() {
    if (null !== $b36288e2db101ba3$var$Ti) {
        var a = $b36288e2db101ba3$var$Ti;
        $b36288e2db101ba3$var$Ti = null;
        a.forEach(function(a, c) {
            $b36288e2db101ba3$var$xf($b36288e2db101ba3$var$Z.bind(null, c, a));
        });
        $b36288e2db101ba3$var$O();
    }
}
function $b36288e2db101ba3$var$ej(a, b) {
    var c = $b36288e2db101ba3$var$U;
    $b36288e2db101ba3$var$U |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$U = c, $b36288e2db101ba3$var$U === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$O();
    }
}
function $b36288e2db101ba3$var$fj(a, b, c, d) {
    var e = $b36288e2db101ba3$var$U;
    $b36288e2db101ba3$var$U |= 4;
    try {
        return $b36288e2db101ba3$var$vf(98, a.bind(null, b, c, d));
    } finally{
        $b36288e2db101ba3$var$U = e, $b36288e2db101ba3$var$U === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$O();
    }
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = $b36288e2db101ba3$var$U;
    $b36288e2db101ba3$var$U &= -2;
    $b36288e2db101ba3$var$U |= $b36288e2db101ba3$var$Bi;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$U = c, $b36288e2db101ba3$var$U === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$O();
    }
}
function $b36288e2db101ba3$var$hj(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Me(c));
    if (null !== $b36288e2db101ba3$var$V) for(c = $b36288e2db101ba3$var$V.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                var e = d.type.childContextTypes;
                null !== e && void 0 !== e && $b36288e2db101ba3$var$Te(d);
                break;
            case 3:
                $b36288e2db101ba3$var$Bg(d);
                $b36288e2db101ba3$var$Ue(d);
                break;
            case 5:
                $b36288e2db101ba3$var$Dg(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Bg(d);
                break;
            case 13:
                $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P, d);
                break;
            case 19:
                $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P, d);
                break;
            case 10:
                $b36288e2db101ba3$var$If(d);
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Ji = a;
    $b36288e2db101ba3$var$V = $b36288e2db101ba3$var$og(a.current, null, b);
    $b36288e2db101ba3$var$W = b;
    $b36288e2db101ba3$var$X = $b36288e2db101ba3$var$Ei;
    $b36288e2db101ba3$var$Li = $b36288e2db101ba3$var$Ki = 1073741823;
    $b36288e2db101ba3$var$Mi = null;
    $b36288e2db101ba3$var$Ni = !1;
}
function $b36288e2db101ba3$var$Z(a, b, c) {
    if (($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) !== $b36288e2db101ba3$var$T) throw $b36288e2db101ba3$var$t(Error(327));
    if (a.firstPendingTime < b) return null;
    if (c && a.finishedExpirationTime === b) return $b36288e2db101ba3$var$ij.bind(null, a);
    $b36288e2db101ba3$var$cj();
    if (a !== $b36288e2db101ba3$var$Ji || b !== $b36288e2db101ba3$var$W) $b36288e2db101ba3$var$hj(a, b);
    else if ($b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Hi) {
        if ($b36288e2db101ba3$var$Ni) $b36288e2db101ba3$var$hj(a, b);
        else {
            var d = a.lastPendingTime;
            if (d < b) return $b36288e2db101ba3$var$Z.bind(null, a, d);
        }
    }
    if (null !== $b36288e2db101ba3$var$V) {
        d = $b36288e2db101ba3$var$U;
        $b36288e2db101ba3$var$U |= $b36288e2db101ba3$var$Ci;
        var e = $b36288e2db101ba3$var$zi.current;
        null === e && (e = $b36288e2db101ba3$var$hh);
        $b36288e2db101ba3$var$zi.current = $b36288e2db101ba3$var$hh;
        if (c) {
            if (1073741823 !== b) {
                var f = $b36288e2db101ba3$var$cg();
                if (f < b) return $b36288e2db101ba3$var$U = d, $b36288e2db101ba3$var$Gf(), $b36288e2db101ba3$var$zi.current = e, $b36288e2db101ba3$var$Z.bind(null, a, f);
            }
        } else $b36288e2db101ba3$var$Wi = 0;
        do try {
            if (c) for(; null !== $b36288e2db101ba3$var$V;)$b36288e2db101ba3$var$V = $b36288e2db101ba3$var$jj($b36288e2db101ba3$var$V);
            else for(; null !== $b36288e2db101ba3$var$V && !$b36288e2db101ba3$var$bf();)$b36288e2db101ba3$var$V = $b36288e2db101ba3$var$jj($b36288e2db101ba3$var$V);
            break;
        } catch (rb) {
            $b36288e2db101ba3$var$Gf();
            $b36288e2db101ba3$var$ih();
            f = $b36288e2db101ba3$var$V;
            if (null === f || null === f.return) throw $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$U = d, rb;
            a: {
                var h = a, g = f.return, k = f, l = rb, n = $b36288e2db101ba3$var$W;
                k.effectTag |= 1024;
                k.firstEffect = k.lastEffect = null;
                if (null !== l && "object" === typeof l && "function" === typeof l.then) {
                    var z = l, x = 0 !== ($b36288e2db101ba3$var$P.current & $b36288e2db101ba3$var$Fg);
                    l = g;
                    do {
                        var v;
                        if (v = 13 === l.tag) null !== l.memoizedState ? v = !1 : (v = l.memoizedProps, v = void 0 === v.fallback ? !1 : !0 !== v.unstable_avoidThisFallback ? !0 : x ? !1 : !0);
                        if (v) {
                            g = l.updateQueue;
                            null === g ? (g = new Set, g.add(z), l.updateQueue = g) : g.add(z);
                            if (0 === (l.mode & 2)) {
                                l.effectTag |= 64;
                                k.effectTag &= -1957;
                                1 === k.tag && (null === k.alternate ? k.tag = 17 : (n = $b36288e2db101ba3$var$Qf(1073741823, null), n.tag = 2, $b36288e2db101ba3$var$Sf(k, n)));
                                k.expirationTime = 1073741823;
                                break a;
                            }
                            k = h;
                            h = n;
                            x = k.pingCache;
                            null === x ? (x = k.pingCache = new $b36288e2db101ba3$var$si, g = new Set, x.set(z, g)) : (g = x.get(z), void 0 === g && (g = new Set, x.set(z, g)));
                            g.has(h) || (g.add(h), k = $b36288e2db101ba3$var$kj.bind(null, k, z, h), z.then(k, k));
                            l.effectTag |= 2048;
                            l.expirationTime = n;
                            break a;
                        }
                        l = l.return;
                    }while (null !== l);
                    l = Error(($b36288e2db101ba3$var$oc(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + $b36288e2db101ba3$var$pc(k));
                }
                $b36288e2db101ba3$var$X !== $b36288e2db101ba3$var$Ii && ($b36288e2db101ba3$var$X = $b36288e2db101ba3$var$Fi);
                l = $b36288e2db101ba3$var$bi(l, k);
                k = g;
                do {
                    switch(k.tag){
                        case 3:
                            k.effectTag |= 2048;
                            k.expirationTime = n;
                            n = $b36288e2db101ba3$var$ti(k, l, n);
                            $b36288e2db101ba3$var$Tf(k, n);
                            break a;
                        case 1:
                            if (z = l, h = k.type, g = k.stateNode, 0 === (k.effectTag & 64) && ("function" === typeof h.getDerivedStateFromError || null !== g && "function" === typeof g.componentDidCatch && (null === $b36288e2db101ba3$var$xi || !$b36288e2db101ba3$var$xi.has(g)))) {
                                k.effectTag |= 2048;
                                k.expirationTime = n;
                                n = $b36288e2db101ba3$var$wi(k, z, n);
                                $b36288e2db101ba3$var$Tf(k, n);
                                break a;
                            }
                    }
                    k = k.return;
                }while (null !== k);
            }
            $b36288e2db101ba3$var$V = $b36288e2db101ba3$var$lj(f);
        }
        while (1);
        $b36288e2db101ba3$var$U = d;
        $b36288e2db101ba3$var$Gf();
        $b36288e2db101ba3$var$zi.current = e;
        if (null !== $b36288e2db101ba3$var$V) return $b36288e2db101ba3$var$Z.bind(null, a, b);
    }
    a.finishedWork = a.current.alternate;
    a.finishedExpirationTime = b;
    if ($b36288e2db101ba3$var$dj(a, b)) return null;
    $b36288e2db101ba3$var$Ji = null;
    switch($b36288e2db101ba3$var$X){
        case $b36288e2db101ba3$var$Ei:
            throw $b36288e2db101ba3$var$t(Error(328));
        case $b36288e2db101ba3$var$Fi:
            return d = a.lastPendingTime, d < b ? $b36288e2db101ba3$var$Z.bind(null, a, d) : c ? $b36288e2db101ba3$var$ij.bind(null, a) : ($b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$xf($b36288e2db101ba3$var$Z.bind(null, a, b)), null);
        case $b36288e2db101ba3$var$Gi:
            if (1073741823 === $b36288e2db101ba3$var$Ki && !c && (c = $b36288e2db101ba3$var$pi + $b36288e2db101ba3$var$Oi - $b36288e2db101ba3$var$sf(), 10 < c)) {
                if ($b36288e2db101ba3$var$Ni) return $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Z.bind(null, a, b);
                d = a.lastPendingTime;
                if (d < b) return $b36288e2db101ba3$var$Z.bind(null, a, d);
                a.timeoutHandle = $b36288e2db101ba3$var$Le($b36288e2db101ba3$var$ij.bind(null, a), c);
                return null;
            }
            return $b36288e2db101ba3$var$ij.bind(null, a);
        case $b36288e2db101ba3$var$Hi:
            if (!c) {
                if ($b36288e2db101ba3$var$Ni) return $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Z.bind(null, a, b);
                c = a.lastPendingTime;
                if (c < b) return $b36288e2db101ba3$var$Z.bind(null, a, c);
                1073741823 !== $b36288e2db101ba3$var$Li ? c = 10 * (1073741821 - $b36288e2db101ba3$var$Li) - $b36288e2db101ba3$var$sf() : 1073741823 === $b36288e2db101ba3$var$Ki ? c = 0 : (c = 10 * (1073741821 - $b36288e2db101ba3$var$Ki) - 5E3, d = $b36288e2db101ba3$var$sf(), b = 10 * (1073741821 - b) - d, c = d - c, 0 > c && (c = 0), c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $b36288e2db101ba3$var$yi(c / 1960)) - c, b < c && (c = b));
                if (10 < c) return a.timeoutHandle = $b36288e2db101ba3$var$Le($b36288e2db101ba3$var$ij.bind(null, a), c), null;
            }
            return $b36288e2db101ba3$var$ij.bind(null, a);
        case $b36288e2db101ba3$var$Ii:
            return !c && 1073741823 !== $b36288e2db101ba3$var$Ki && null !== $b36288e2db101ba3$var$Mi && (d = $b36288e2db101ba3$var$Ki, e = $b36288e2db101ba3$var$Mi, b = e.busyMinDurationMs | 0, 0 >= b ? b = 0 : (c = e.busyDelayMs | 0, d = $b36288e2db101ba3$var$sf() - (10 * (1073741821 - d) - (e.timeoutMs | 0 || 5E3)), b = d <= c ? 0 : c + b - d), 10 < b) ? (a.timeoutHandle = $b36288e2db101ba3$var$Le($b36288e2db101ba3$var$ij.bind(null, a), b), null) : $b36288e2db101ba3$var$ij.bind(null, a);
        default:
            throw $b36288e2db101ba3$var$t(Error(329));
    }
}
function $b36288e2db101ba3$var$Xf(a, b) {
    a < $b36288e2db101ba3$var$Ki && 1 < a && ($b36288e2db101ba3$var$Ki = a);
    null !== b && a < $b36288e2db101ba3$var$Li && 1 < a && ($b36288e2db101ba3$var$Li = a, $b36288e2db101ba3$var$Mi = b);
}
function $b36288e2db101ba3$var$jj(a) {
    var b = $b36288e2db101ba3$var$mj(a.alternate, a, $b36288e2db101ba3$var$W);
    a.memoizedProps = a.pendingProps;
    null === b && (b = $b36288e2db101ba3$var$lj(a));
    $b36288e2db101ba3$var$Ai.current = null;
    return b;
}
function $b36288e2db101ba3$var$lj(a) {
    $b36288e2db101ba3$var$V = a;
    do {
        var b = $b36288e2db101ba3$var$V.alternate;
        a = $b36288e2db101ba3$var$V.return;
        if (0 === ($b36288e2db101ba3$var$V.effectTag & 1024)) {
            a: {
                var c = b;
                b = $b36288e2db101ba3$var$V;
                var d = $b36288e2db101ba3$var$W, e = b.pendingProps;
                switch(b.tag){
                    case 2:
                        break;
                    case 16:
                        break;
                    case 15:
                    case 0:
                        break;
                    case 1:
                        $b36288e2db101ba3$var$N(b.type) && $b36288e2db101ba3$var$Te(b);
                        break;
                    case 3:
                        $b36288e2db101ba3$var$Bg(b);
                        $b36288e2db101ba3$var$Ue(b);
                        d = b.stateNode;
                        d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
                        if (null === c || null === c.child) $b36288e2db101ba3$var$Bh(b), b.effectTag &= -3;
                        $b36288e2db101ba3$var$Uh(b);
                        break;
                    case 5:
                        $b36288e2db101ba3$var$Dg(b);
                        d = $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$yg.current);
                        var f = b.type;
                        if (null !== c && null != b.stateNode) $b36288e2db101ba3$var$Vh(c, b, f, e, d), c.ref !== b.ref && (b.effectTag |= 128);
                        else if (e) {
                            var h = $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$wg.current);
                            if ($b36288e2db101ba3$var$Bh(b)) {
                                c = b;
                                e = void 0;
                                f = c.stateNode;
                                var g = c.type, k = c.memoizedProps;
                                f[$b36288e2db101ba3$var$Fa] = c;
                                f[$b36288e2db101ba3$var$Ga] = k;
                                switch(g){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        $b36288e2db101ba3$var$G("load", f);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(var l = 0; l < $b36288e2db101ba3$var$bb.length; l++)$b36288e2db101ba3$var$G($b36288e2db101ba3$var$bb[l], f);
                                        break;
                                    case "source":
                                        $b36288e2db101ba3$var$G("error", f);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $b36288e2db101ba3$var$G("error", f);
                                        $b36288e2db101ba3$var$G("load", f);
                                        break;
                                    case "form":
                                        $b36288e2db101ba3$var$G("reset", f);
                                        $b36288e2db101ba3$var$G("submit", f);
                                        break;
                                    case "details":
                                        $b36288e2db101ba3$var$G("toggle", f);
                                        break;
                                    case "input":
                                        $b36288e2db101ba3$var$Cc(f, k);
                                        $b36288e2db101ba3$var$G("invalid", f);
                                        $b36288e2db101ba3$var$Fe(d, "onChange");
                                        break;
                                    case "select":
                                        f._wrapperState = {
                                            wasMultiple: !!k.multiple
                                        };
                                        $b36288e2db101ba3$var$G("invalid", f);
                                        $b36288e2db101ba3$var$Fe(d, "onChange");
                                        break;
                                    case "textarea":
                                        $b36288e2db101ba3$var$oe(f, k), $b36288e2db101ba3$var$G("invalid", f), $b36288e2db101ba3$var$Fe(d, "onChange");
                                }
                                $b36288e2db101ba3$var$De(g, k);
                                l = null;
                                for(e in k)k.hasOwnProperty(e) && (h = k[e], "children" === e ? "string" === typeof h ? f.textContent !== h && (l = [
                                    "children",
                                    h
                                ]) : "number" === typeof h && f.textContent !== "" + h && (l = [
                                    "children",
                                    "" + h
                                ]) : $b36288e2db101ba3$var$ia.hasOwnProperty(e) && null != h && $b36288e2db101ba3$var$Fe(d, e));
                                switch(g){
                                    case "input":
                                        $b36288e2db101ba3$var$Vb(f);
                                        $b36288e2db101ba3$var$Gc(f, k, !0);
                                        break;
                                    case "textarea":
                                        $b36288e2db101ba3$var$Vb(f);
                                        $b36288e2db101ba3$var$qe(f, k);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" === typeof k.onClick && (f.onclick = $b36288e2db101ba3$var$Ge);
                                }
                                d = l;
                                c.updateQueue = d;
                                null !== d && $b36288e2db101ba3$var$Sh(b);
                            } else {
                                k = f;
                                c = e;
                                g = b;
                                l = 9 === d.nodeType ? d : d.ownerDocument;
                                h === $b36288e2db101ba3$var$re.html && (h = $b36288e2db101ba3$var$se(k));
                                h === $b36288e2db101ba3$var$re.html ? "script" === k ? (k = l.createElement("div"), k.innerHTML = "<script></script>", l = k.removeChild(k.firstChild)) : "string" === typeof c.is ? l = l.createElement(k, {
                                    is: c.is
                                }) : (l = l.createElement(k), "select" === k && (k = l, c.multiple ? k.multiple = !0 : c.size && (k.size = c.size))) : l = l.createElementNS(h, k);
                                k = l;
                                k[$b36288e2db101ba3$var$Fa] = g;
                                k[$b36288e2db101ba3$var$Ga] = c;
                                c = k;
                                $b36288e2db101ba3$var$Th(c, b, !1, !1);
                                g = c;
                                var n = d, z = $b36288e2db101ba3$var$Ee(f, e);
                                switch(f){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        $b36288e2db101ba3$var$G("load", g);
                                        d = e;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(d = 0; d < $b36288e2db101ba3$var$bb.length; d++)$b36288e2db101ba3$var$G($b36288e2db101ba3$var$bb[d], g);
                                        d = e;
                                        break;
                                    case "source":
                                        $b36288e2db101ba3$var$G("error", g);
                                        d = e;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        $b36288e2db101ba3$var$G("error", g);
                                        $b36288e2db101ba3$var$G("load", g);
                                        d = e;
                                        break;
                                    case "form":
                                        $b36288e2db101ba3$var$G("reset", g);
                                        $b36288e2db101ba3$var$G("submit", g);
                                        d = e;
                                        break;
                                    case "details":
                                        $b36288e2db101ba3$var$G("toggle", g);
                                        d = e;
                                        break;
                                    case "input":
                                        $b36288e2db101ba3$var$Cc(g, e);
                                        d = $b36288e2db101ba3$var$Bc(g, e);
                                        $b36288e2db101ba3$var$G("invalid", g);
                                        $b36288e2db101ba3$var$Fe(n, "onChange");
                                        break;
                                    case "option":
                                        d = $b36288e2db101ba3$var$le(g, e);
                                        break;
                                    case "select":
                                        g._wrapperState = {
                                            wasMultiple: !!e.multiple
                                        };
                                        d = $4yvvI({}, e, {
                                            value: void 0
                                        });
                                        $b36288e2db101ba3$var$G("invalid", g);
                                        $b36288e2db101ba3$var$Fe(n, "onChange");
                                        break;
                                    case "textarea":
                                        $b36288e2db101ba3$var$oe(g, e);
                                        d = $b36288e2db101ba3$var$ne(g, e);
                                        $b36288e2db101ba3$var$G("invalid", g);
                                        $b36288e2db101ba3$var$Fe(n, "onChange");
                                        break;
                                    default:
                                        d = e;
                                }
                                $b36288e2db101ba3$var$De(f, d);
                                k = void 0;
                                l = f;
                                h = g;
                                var x = d;
                                for(k in x)if (x.hasOwnProperty(k)) {
                                    var v = x[k];
                                    "style" === k ? $b36288e2db101ba3$var$Ae(h, v) : "dangerouslySetInnerHTML" === k ? (v = v ? v.__html : void 0, null != v && $b36288e2db101ba3$var$ve(h, v)) : "children" === k ? "string" === typeof v ? ("textarea" !== l || "" !== v) && $b36288e2db101ba3$var$we(h, v) : "number" === typeof v && $b36288e2db101ba3$var$we(h, "" + v) : "suppressContentEditableWarning" !== k && "suppressHydrationWarning" !== k && "autoFocus" !== k && ($b36288e2db101ba3$var$ia.hasOwnProperty(k) ? null != v && $b36288e2db101ba3$var$Fe(n, k) : null != v && $b36288e2db101ba3$var$zc(h, k, v, z));
                                }
                                switch(f){
                                    case "input":
                                        $b36288e2db101ba3$var$Vb(g);
                                        $b36288e2db101ba3$var$Gc(g, e, !1);
                                        break;
                                    case "textarea":
                                        $b36288e2db101ba3$var$Vb(g);
                                        $b36288e2db101ba3$var$qe(g, e);
                                        break;
                                    case "option":
                                        null != e.value && g.setAttribute("value", "" + $b36288e2db101ba3$var$Ac(e.value));
                                        break;
                                    case "select":
                                        d = g;
                                        g = e;
                                        d.multiple = !!g.multiple;
                                        k = g.value;
                                        null != k ? $b36288e2db101ba3$var$me(d, !!g.multiple, k, !1) : null != g.defaultValue && $b36288e2db101ba3$var$me(d, !!g.multiple, g.defaultValue, !0);
                                        break;
                                    default:
                                        "function" === typeof d.onClick && (g.onclick = $b36288e2db101ba3$var$Ge);
                                }
                                $b36288e2db101ba3$var$Je(f, e) && $b36288e2db101ba3$var$Sh(b);
                                b.stateNode = c;
                            }
                            null !== b.ref && (b.effectTag |= 128);
                        } else if (null === b.stateNode) throw $b36288e2db101ba3$var$t(Error(166));
                        break;
                    case 6:
                        if (c && null != b.stateNode) $b36288e2db101ba3$var$Wh(c, b, c.memoizedProps, e);
                        else {
                            if ("string" !== typeof e && null === b.stateNode) throw $b36288e2db101ba3$var$t(Error(166));
                            c = $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$yg.current);
                            $b36288e2db101ba3$var$zg($b36288e2db101ba3$var$wg.current);
                            $b36288e2db101ba3$var$Bh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$b36288e2db101ba3$var$Fa] = b, d.nodeValue !== c && $b36288e2db101ba3$var$Sh(b)) : (d = b, c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(e), c[$b36288e2db101ba3$var$Fa] = b, d.stateNode = c);
                        }
                        break;
                    case 11:
                        break;
                    case 13:
                        $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P, b);
                        e = b.memoizedState;
                        if (0 !== (b.effectTag & 64)) {
                            b.expirationTime = d;
                            break a;
                        }
                        d = null !== e;
                        e = !1;
                        null === c ? $b36288e2db101ba3$var$Bh(b) : (f = c.memoizedState, e = null !== f, d || null === f || (f = c.child.sibling, null !== f && (g = b.firstEffect, null !== g ? (b.firstEffect = f, f.nextEffect = g) : (b.firstEffect = b.lastEffect = f, f.nextEffect = null), f.effectTag = 8)));
                        if (d && !e && 0 !== (b.mode & 2)) {
                            if (null === c && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($b36288e2db101ba3$var$P.current & $b36288e2db101ba3$var$Fg)) $b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Ei && ($b36288e2db101ba3$var$X = $b36288e2db101ba3$var$Gi);
                            else if ($b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Ei || $b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Gi) $b36288e2db101ba3$var$X = $b36288e2db101ba3$var$Hi;
                        }
                        if (d || e) b.effectTag |= 4;
                        break;
                    case 7:
                        break;
                    case 8:
                        break;
                    case 12:
                        break;
                    case 4:
                        $b36288e2db101ba3$var$Bg(b);
                        $b36288e2db101ba3$var$Uh(b);
                        break;
                    case 10:
                        $b36288e2db101ba3$var$If(b);
                        break;
                    case 9:
                        break;
                    case 14:
                        break;
                    case 17:
                        $b36288e2db101ba3$var$N(b.type) && $b36288e2db101ba3$var$Te(b);
                        break;
                    case 18:
                        break;
                    case 19:
                        $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P, b);
                        e = b.memoizedState;
                        if (null === e) break;
                        f = 0 !== (b.effectTag & 64);
                        g = e.rendering;
                        if (null === g) {
                            if (f) $b36288e2db101ba3$var$$h(e, !1);
                            else {
                                if ($b36288e2db101ba3$var$X !== $b36288e2db101ba3$var$Ei || null !== c && 0 !== (c.effectTag & 64)) for(c = b.child; null !== c;){
                                    g = $b36288e2db101ba3$var$Hg(c);
                                    if (null !== g) {
                                        b.effectTag |= 64;
                                        $b36288e2db101ba3$var$$h(e, !1);
                                        c = g.updateQueue;
                                        null !== c && (b.updateQueue = c, b.effectTag |= 4);
                                        b.firstEffect = b.lastEffect = null;
                                        for(c = b.child; null !== c;)e = c, f = d, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, g = e.alternate, null === g ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = g.childExpirationTime, e.expirationTime = g.expirationTime, e.child = g.child, e.memoizedProps = g.memoizedProps, e.memoizedState = g.memoizedState, e.updateQueue = g.updateQueue, f = g.dependencies, e.dependencies = null === f ? null : {
                                            expirationTime: f.expirationTime,
                                            firstContext: f.firstContext,
                                            responders: f.responders
                                        }), c = c.sibling;
                                        $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current & $b36288e2db101ba3$var$Eg | $b36288e2db101ba3$var$Gg, b);
                                        b = b.child;
                                        break a;
                                    }
                                    c = c.sibling;
                                }
                            }
                        } else {
                            if (!f) {
                                if (c = $b36288e2db101ba3$var$Hg(g), null !== c) {
                                    if (b.effectTag |= 64, f = !0, $b36288e2db101ba3$var$$h(e, !0), null === e.tail && "hidden" === e.tailMode) {
                                        d = c.updateQueue;
                                        null !== d && (b.updateQueue = d, b.effectTag |= 4);
                                        b = b.lastEffect = e.lastEffect;
                                        null !== b && (b.nextEffect = null);
                                        break;
                                    }
                                } else $b36288e2db101ba3$var$sf() > e.tailExpiration && 1 < d && (b.effectTag |= 64, f = !0, $b36288e2db101ba3$var$$h(e, !1), b.expirationTime = b.childExpirationTime = d - 1);
                            }
                            e.isBackwards ? (g.sibling = b.child, b.child = g) : (d = e.last, null !== d ? d.sibling = g : b.child = g, e.last = g);
                        }
                        if (null !== e.tail) {
                            0 === e.tailExpiration && (e.tailExpiration = $b36288e2db101ba3$var$sf() + 500);
                            d = e.tail;
                            e.rendering = d;
                            e.tail = d.sibling;
                            e.lastEffect = b.lastEffect;
                            d.sibling = null;
                            c = $b36288e2db101ba3$var$P.current;
                            c = f ? c & $b36288e2db101ba3$var$Eg | $b36288e2db101ba3$var$Gg : c & $b36288e2db101ba3$var$Eg;
                            $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, c, b);
                            b = d;
                            break a;
                        }
                        break;
                    case 20:
                        break;
                    default:
                        throw $b36288e2db101ba3$var$t(Error(156));
                }
                b = null;
            }
            d = $b36288e2db101ba3$var$V;
            if (1 === $b36288e2db101ba3$var$W || 1 !== d.childExpirationTime) {
                c = 0;
                for(e = d.child; null !== e;)f = e.expirationTime, g = e.childExpirationTime, f > c && (c = f), g > c && (c = g), e = e.sibling;
                d.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 1024) && (null === a.firstEffect && (a.firstEffect = $b36288e2db101ba3$var$V.firstEffect), null !== $b36288e2db101ba3$var$V.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = $b36288e2db101ba3$var$V.firstEffect), a.lastEffect = $b36288e2db101ba3$var$V.lastEffect), 1 < $b36288e2db101ba3$var$V.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = $b36288e2db101ba3$var$V : a.firstEffect = $b36288e2db101ba3$var$V, a.lastEffect = $b36288e2db101ba3$var$V));
        } else {
            b = $b36288e2db101ba3$var$ai($b36288e2db101ba3$var$V, $b36288e2db101ba3$var$W);
            if (null !== b) return b.effectTag &= 1023, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 1024);
        }
        b = $b36288e2db101ba3$var$V.sibling;
        if (null !== b) return b;
        $b36288e2db101ba3$var$V = a;
    }while (null !== $b36288e2db101ba3$var$V);
    $b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Ei && ($b36288e2db101ba3$var$X = $b36288e2db101ba3$var$Ii);
    return null;
}
function $b36288e2db101ba3$var$ij(a) {
    var b = $b36288e2db101ba3$var$tf();
    $b36288e2db101ba3$var$vf(99, $b36288e2db101ba3$var$nj.bind(null, a, b));
    null !== $b36288e2db101ba3$var$Qi && $b36288e2db101ba3$var$wf(97, function() {
        $b36288e2db101ba3$var$cj();
        return null;
    });
    return null;
}
function $b36288e2db101ba3$var$nj(a, b) {
    $b36288e2db101ba3$var$cj();
    if (($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) !== $b36288e2db101ba3$var$T) throw $b36288e2db101ba3$var$t(Error(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw $b36288e2db101ba3$var$t(Error(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    var e = c.expirationTime, f = c.childExpirationTime;
    e = f > e ? f : e;
    a.firstPendingTime = e;
    e < a.lastPendingTime && (a.lastPendingTime = e);
    a === $b36288e2db101ba3$var$Ji && ($b36288e2db101ba3$var$V = $b36288e2db101ba3$var$Ji = null, $b36288e2db101ba3$var$W = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        f = $b36288e2db101ba3$var$U;
        $b36288e2db101ba3$var$U |= $b36288e2db101ba3$var$Di;
        $b36288e2db101ba3$var$Ai.current = null;
        $b36288e2db101ba3$var$He = $b36288e2db101ba3$var$Qd;
        var h = $b36288e2db101ba3$var$ae();
        if ($b36288e2db101ba3$var$be(h)) {
            if ("selectionStart" in h) var g = {
                start: h.selectionStart,
                end: h.selectionEnd
            };
            else a: {
                g = (g = h.ownerDocument) && g.defaultView || window;
                var k = g.getSelection && g.getSelection();
                if (k && 0 !== k.rangeCount) {
                    g = k.anchorNode;
                    var l = k.anchorOffset, n = k.focusNode;
                    k = k.focusOffset;
                    try {
                        g.nodeType, n.nodeType;
                    } catch (zb) {
                        g = null;
                        break a;
                    }
                    var z = 0, x = -1, v = -1, rb = 0, Be = 0, u = h, w = null;
                    b: for(;;){
                        for(var C;;){
                            u !== g || 0 !== l && 3 !== u.nodeType || (x = z + l);
                            u !== n || 0 !== k && 3 !== u.nodeType || (v = z + k);
                            3 === u.nodeType && (z += u.nodeValue.length);
                            if (null === (C = u.firstChild)) break;
                            w = u;
                            u = C;
                        }
                        for(;;){
                            if (u === h) break b;
                            w === g && ++rb === l && (x = z);
                            w === n && ++Be === k && (v = z);
                            if (null !== (C = u.nextSibling)) break;
                            u = w;
                            w = u.parentNode;
                        }
                        u = C;
                    }
                    g = -1 === x || -1 === v ? null : {
                        start: x,
                        end: v
                    };
                } else g = null;
            }
            g = g || {
                start: 0,
                end: 0
            };
        } else g = null;
        $b36288e2db101ba3$var$Ie = {
            focusedElem: h,
            selectionRange: g
        };
        $b36288e2db101ba3$var$Qd = !1;
        $b36288e2db101ba3$var$Y = e;
        do try {
            for(; null !== $b36288e2db101ba3$var$Y;){
                if (0 !== ($b36288e2db101ba3$var$Y.effectTag & 256)) {
                    var I = $b36288e2db101ba3$var$Y.alternate;
                    h = $b36288e2db101ba3$var$Y;
                    switch(h.tag){
                        case 0:
                        case 11:
                        case 15:
                            $b36288e2db101ba3$var$hi($b36288e2db101ba3$var$Jg, $b36288e2db101ba3$var$Ig, h);
                            break;
                        case 1:
                            if (h.effectTag & 256 && null !== I) {
                                var E = I.memoizedProps, ua = I.memoizedState, gh = h.stateNode, oj = gh.getSnapshotBeforeUpdate(h.elementType === h.type ? E : $b36288e2db101ba3$var$Af(h.type, E), ua);
                                gh.__reactInternalSnapshotBeforeUpdate = oj;
                            }
                            break;
                        case 3:
                        case 5:
                        case 6:
                        case 4:
                        case 17:
                            break;
                        default:
                            throw $b36288e2db101ba3$var$t(Error(163));
                    }
                }
                $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Y.nextEffect;
            }
        } catch (zb) {
            if (null === $b36288e2db101ba3$var$Y) throw $b36288e2db101ba3$var$t(Error(330));
            $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$Y, zb);
            $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Y.nextEffect;
        }
        while (null !== $b36288e2db101ba3$var$Y);
        $b36288e2db101ba3$var$Y = e;
        do try {
            for(I = b; null !== $b36288e2db101ba3$var$Y;){
                var A = $b36288e2db101ba3$var$Y.effectTag;
                A & 16 && $b36288e2db101ba3$var$we($b36288e2db101ba3$var$Y.stateNode, "");
                if (A & 128) {
                    var p = $b36288e2db101ba3$var$Y.alternate;
                    if (null !== p) {
                        var r = p.ref;
                        null !== r && ("function" === typeof r ? r(null) : r.current = null);
                    }
                }
                switch(A & 14){
                    case 2:
                        $b36288e2db101ba3$var$ni($b36288e2db101ba3$var$Y);
                        $b36288e2db101ba3$var$Y.effectTag &= -3;
                        break;
                    case 6:
                        $b36288e2db101ba3$var$ni($b36288e2db101ba3$var$Y);
                        $b36288e2db101ba3$var$Y.effectTag &= -3;
                        $b36288e2db101ba3$var$oi($b36288e2db101ba3$var$Y.alternate, $b36288e2db101ba3$var$Y);
                        break;
                    case 4:
                        $b36288e2db101ba3$var$oi($b36288e2db101ba3$var$Y.alternate, $b36288e2db101ba3$var$Y);
                        break;
                    case 8:
                        E = $b36288e2db101ba3$var$Y;
                        $b36288e2db101ba3$var$ki(E, I);
                        E.return = null;
                        E.child = null;
                        E.memoizedState = null;
                        E.updateQueue = null;
                        E.dependencies = null;
                        var K = E.alternate;
                        null !== K && (K.return = null, K.child = null, K.memoizedState = null, K.updateQueue = null, K.dependencies = null);
                }
                $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Y.nextEffect;
            }
        } catch (zb) {
            if (null === $b36288e2db101ba3$var$Y) throw $b36288e2db101ba3$var$t(Error(330));
            $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$Y, zb);
            $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Y.nextEffect;
        }
        while (null !== $b36288e2db101ba3$var$Y);
        r = $b36288e2db101ba3$var$Ie;
        p = $b36288e2db101ba3$var$ae();
        A = r.focusedElem;
        I = r.selectionRange;
        if (p !== A && A && A.ownerDocument && $b36288e2db101ba3$var$$d(A.ownerDocument.documentElement, A)) {
            null !== I && $b36288e2db101ba3$var$be(A) && (p = I.start, r = I.end, void 0 === r && (r = p), "selectionStart" in A ? (A.selectionStart = p, A.selectionEnd = Math.min(r, A.value.length)) : (r = (p = A.ownerDocument || document) && p.defaultView || window, r.getSelection && (r = r.getSelection(), E = A.textContent.length, K = Math.min(I.start, E), I = void 0 === I.end ? K : Math.min(I.end, E), !r.extend && K > I && (E = I, I = K, K = E), E = $b36288e2db101ba3$var$Zd(A, K), ua = $b36288e2db101ba3$var$Zd(A, I), E && ua && (1 !== r.rangeCount || r.anchorNode !== E.node || r.anchorOffset !== E.offset || r.focusNode !== ua.node || r.focusOffset !== ua.offset) && (p = p.createRange(), p.setStart(E.node, E.offset), r.removeAllRanges(), K > I ? (r.addRange(p), r.extend(ua.node, ua.offset)) : (p.setEnd(ua.node, ua.offset), r.addRange(p))))));
            p = [];
            for(r = A; r = r.parentNode;)1 === r.nodeType && p.push({
                element: r,
                left: r.scrollLeft,
                top: r.scrollTop
            });
            "function" === typeof A.focus && A.focus();
            for(A = 0; A < p.length; A++)r = p[A], r.element.scrollLeft = r.left, r.element.scrollTop = r.top;
        }
        $b36288e2db101ba3$var$Ie = null;
        $b36288e2db101ba3$var$Qd = !!$b36288e2db101ba3$var$He;
        $b36288e2db101ba3$var$He = null;
        a.current = c;
        $b36288e2db101ba3$var$Y = e;
        do try {
            for(A = d; null !== $b36288e2db101ba3$var$Y;){
                var $a = $b36288e2db101ba3$var$Y.effectTag;
                if ($a & 36) {
                    var nc = $b36288e2db101ba3$var$Y.alternate;
                    p = $b36288e2db101ba3$var$Y;
                    r = A;
                    switch(p.tag){
                        case 0:
                        case 11:
                        case 15:
                            $b36288e2db101ba3$var$hi($b36288e2db101ba3$var$Mg, $b36288e2db101ba3$var$Ng, p);
                            break;
                        case 1:
                            var md = p.stateNode;
                            if (p.effectTag & 4) {
                                if (null === nc) md.componentDidMount();
                                else {
                                    var Fj = p.elementType === p.type ? nc.memoizedProps : $b36288e2db101ba3$var$Af(p.type, nc.memoizedProps);
                                    md.componentDidUpdate(Fj, nc.memoizedState, md.__reactInternalSnapshotBeforeUpdate);
                                }
                            }
                            var Xh = p.updateQueue;
                            null !== Xh && $b36288e2db101ba3$var$Yf(p, Xh, md, r);
                            break;
                        case 3:
                            var Yh = p.updateQueue;
                            if (null !== Yh) {
                                K = null;
                                if (null !== p.child) switch(p.child.tag){
                                    case 5:
                                        K = p.child.stateNode;
                                        break;
                                    case 1:
                                        K = p.child.stateNode;
                                }
                                $b36288e2db101ba3$var$Yf(p, Yh, K, r);
                            }
                            break;
                        case 5:
                            var Gj = p.stateNode;
                            null === nc && p.effectTag & 4 && (r = Gj, $b36288e2db101ba3$var$Je(p.type, p.memoizedProps) && r.focus());
                            break;
                        case 6:
                            break;
                        case 4:
                            break;
                        case 12:
                            break;
                        case 13:
                        case 19:
                        case 17:
                        case 20:
                            break;
                        default:
                            throw $b36288e2db101ba3$var$t(Error(163));
                    }
                }
                if ($a & 128) {
                    var nd = $b36288e2db101ba3$var$Y.ref;
                    if (null !== nd) {
                        var Zh = $b36288e2db101ba3$var$Y.stateNode;
                        switch($b36288e2db101ba3$var$Y.tag){
                            case 5:
                                var gf = Zh;
                                break;
                            default:
                                gf = Zh;
                        }
                        "function" === typeof nd ? nd(gf) : nd.current = gf;
                    }
                }
                $a & 512 && ($b36288e2db101ba3$var$Pi = !0);
                $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Y.nextEffect;
            }
        } catch (zb) {
            if (null === $b36288e2db101ba3$var$Y) throw $b36288e2db101ba3$var$t(Error(330));
            $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$Y, zb);
            $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Y.nextEffect;
        }
        while (null !== $b36288e2db101ba3$var$Y);
        $b36288e2db101ba3$var$Y = null;
        $b36288e2db101ba3$var$nf();
        $b36288e2db101ba3$var$U = f;
    } else a.current = c;
    if ($b36288e2db101ba3$var$Pi) $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = a, $b36288e2db101ba3$var$Si = d, $b36288e2db101ba3$var$Ri = b;
    else for($b36288e2db101ba3$var$Y = e; null !== $b36288e2db101ba3$var$Y;)b = $b36288e2db101ba3$var$Y.nextEffect, $b36288e2db101ba3$var$Y.nextEffect = null, $b36288e2db101ba3$var$Y = b;
    b = a.firstPendingTime;
    0 !== b ? ($a = $b36288e2db101ba3$var$cg(), $a = $b36288e2db101ba3$var$zf($a, b), $b36288e2db101ba3$var$Zi(a, $a, b)) : $b36288e2db101ba3$var$xi = null;
    "function" === typeof $b36288e2db101ba3$var$pj && $b36288e2db101ba3$var$pj(c.stateNode, d);
    1073741823 === b ? a === $b36288e2db101ba3$var$Vi ? $b36288e2db101ba3$var$Ui++ : ($b36288e2db101ba3$var$Ui = 0, $b36288e2db101ba3$var$Vi = a) : $b36288e2db101ba3$var$Ui = 0;
    if ($b36288e2db101ba3$var$ui) throw $b36288e2db101ba3$var$ui = !1, a = $b36288e2db101ba3$var$vi, $b36288e2db101ba3$var$vi = null, a;
    if (($b36288e2db101ba3$var$U & $b36288e2db101ba3$var$Bi) !== $b36288e2db101ba3$var$T) return null;
    $b36288e2db101ba3$var$O();
    return null;
}
function $b36288e2db101ba3$var$cj() {
    if (null === $b36288e2db101ba3$var$Qi) return !1;
    var a = $b36288e2db101ba3$var$Qi, b = $b36288e2db101ba3$var$Si, c = $b36288e2db101ba3$var$Ri;
    $b36288e2db101ba3$var$Qi = null;
    $b36288e2db101ba3$var$Si = 0;
    $b36288e2db101ba3$var$Ri = 90;
    return $b36288e2db101ba3$var$vf(97 < c ? 97 : c, $b36288e2db101ba3$var$qj.bind(null, a, b));
}
function $b36288e2db101ba3$var$qj(a) {
    if (($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) !== $b36288e2db101ba3$var$T) throw $b36288e2db101ba3$var$t(Error(331));
    var b = $b36288e2db101ba3$var$U;
    $b36288e2db101ba3$var$U |= $b36288e2db101ba3$var$Di;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                    $b36288e2db101ba3$var$hi($b36288e2db101ba3$var$Pg, $b36288e2db101ba3$var$Ig, c), $b36288e2db101ba3$var$hi($b36288e2db101ba3$var$Ig, $b36288e2db101ba3$var$Og, c);
            }
        } catch (d) {
            if (null === a) throw $b36288e2db101ba3$var$t(Error(330));
            $b36288e2db101ba3$var$fi(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    $b36288e2db101ba3$var$U = b;
    $b36288e2db101ba3$var$O();
    return !0;
}
function $b36288e2db101ba3$var$rj(a, b, c) {
    b = $b36288e2db101ba3$var$bi(c, b);
    b = $b36288e2db101ba3$var$ti(a, b, 1073741823);
    $b36288e2db101ba3$var$Sf(a, b);
    a = $b36288e2db101ba3$var$Yi(a, 1073741823);
    null !== a && $b36288e2db101ba3$var$Zi(a, 99, 1073741823);
}
function $b36288e2db101ba3$var$fi(a, b) {
    if (3 === a.tag) $b36288e2db101ba3$var$rj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $b36288e2db101ba3$var$rj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$xi || !$b36288e2db101ba3$var$xi.has(d))) {
                a = $b36288e2db101ba3$var$bi(b, a);
                a = $b36288e2db101ba3$var$wi(c, a, 1073741823);
                $b36288e2db101ba3$var$Sf(c, a);
                c = $b36288e2db101ba3$var$Yi(c, 1073741823);
                null !== c && $b36288e2db101ba3$var$Zi(c, 99, 1073741823);
                break;
            }
        }
        c = c.return;
    }
}
function $b36288e2db101ba3$var$kj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Ji === a && $b36288e2db101ba3$var$W === c ? $b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Hi || $b36288e2db101ba3$var$X === $b36288e2db101ba3$var$Gi && 1073741823 === $b36288e2db101ba3$var$Ki && $b36288e2db101ba3$var$sf() - $b36288e2db101ba3$var$pi < $b36288e2db101ba3$var$Oi ? $b36288e2db101ba3$var$hj(a, $b36288e2db101ba3$var$W) : $b36288e2db101ba3$var$Ni = !0 : a.lastPendingTime < c || (b = a.pingTime, 0 !== b && b < c || (a.pingTime = c, a.finishedExpirationTime === c && (a.finishedExpirationTime = 0, a.finishedWork = null), b = $b36288e2db101ba3$var$cg(), b = $b36288e2db101ba3$var$zf(b, c), $b36288e2db101ba3$var$Zi(a, b, c)));
}
function $b36288e2db101ba3$var$ri(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    c = $b36288e2db101ba3$var$cg();
    b = $b36288e2db101ba3$var$dg(c, a, null);
    c = $b36288e2db101ba3$var$zf(c, b);
    a = $b36288e2db101ba3$var$Yi(a, b);
    null !== a && $b36288e2db101ba3$var$Zi(a, c, b);
}
var $b36288e2db101ba3$var$mj = void 0;
$b36288e2db101ba3$var$mj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || $b36288e2db101ba3$var$M.current) $b36288e2db101ba3$var$Lf = !0;
        else if (d < c) {
            $b36288e2db101ba3$var$Lf = !1;
            switch(b.tag){
                case 3:
                    $b36288e2db101ba3$var$Nh(b);
                    $b36288e2db101ba3$var$Ch();
                    break;
                case 5:
                    $b36288e2db101ba3$var$Cg(b);
                    if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                    break;
                case 1:
                    $b36288e2db101ba3$var$N(b.type) && $b36288e2db101ba3$var$Xe(b);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ag(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    $b36288e2db101ba3$var$Hf(b, b.memoizedProps.value);
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        d = b.child.childExpirationTime;
                        if (0 !== d && d >= c) return $b36288e2db101ba3$var$Ph(a, b, c);
                        $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current & $b36288e2db101ba3$var$Eg, b);
                        b = $b36288e2db101ba3$var$Fh(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current & $b36288e2db101ba3$var$Eg, b);
                    break;
                case 19:
                    d = b.childExpirationTime >= c;
                    if (0 !== (a.effectTag & 64)) {
                        if (d) return $b36288e2db101ba3$var$Rh(a, b, c);
                        b.effectTag |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null);
                    $b36288e2db101ba3$var$J($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current, b);
                    if (!d) return null;
            }
            return $b36288e2db101ba3$var$Fh(a, b, c);
        }
    } else $b36288e2db101ba3$var$Lf = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $b36288e2db101ba3$var$Se(b, $b36288e2db101ba3$var$L.current);
            $b36288e2db101ba3$var$Kf(b, c);
            e = $b36288e2db101ba3$var$dh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                $b36288e2db101ba3$var$ih();
                if ($b36288e2db101ba3$var$N(d)) {
                    var f = !0;
                    $b36288e2db101ba3$var$Xe(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                var h = d.getDerivedStateFromProps;
                "function" === typeof h && $b36288e2db101ba3$var$bg(b, d, h, a);
                e.updater = $b36288e2db101ba3$var$fg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                $b36288e2db101ba3$var$jg(b, d, a, c);
                b = $b36288e2db101ba3$var$Mh(null, b, d, !0, f, c);
            } else b.tag = 0, $b36288e2db101ba3$var$S(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = $b36288e2db101ba3$var$Bf(e);
            b.type = e;
            f = b.tag = $b36288e2db101ba3$var$sj(e);
            a = $b36288e2db101ba3$var$Af(e, a);
            switch(f){
                case 0:
                    b = $b36288e2db101ba3$var$Jh(null, b, e, a, c);
                    break;
                case 1:
                    b = $b36288e2db101ba3$var$Lh(null, b, e, a, c);
                    break;
                case 11:
                    b = $b36288e2db101ba3$var$Eh(null, b, e, a, c);
                    break;
                case 14:
                    b = $b36288e2db101ba3$var$Gh(null, b, e, $b36288e2db101ba3$var$Af(e.type, a), d, c);
                    break;
                default:
                    throw $b36288e2db101ba3$var$t(Error(306), e, "");
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Af(d, e), $b36288e2db101ba3$var$Jh(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Af(d, e), $b36288e2db101ba3$var$Lh(a, b, d, e, c);
        case 3:
            $b36288e2db101ba3$var$Nh(b);
            d = b.updateQueue;
            if (null === d) throw $b36288e2db101ba3$var$t(Error(282));
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $b36288e2db101ba3$var$Wf(b, d, b.pendingProps, null, c);
            d = b.memoizedState.element;
            if (d === e) $b36288e2db101ba3$var$Ch(), b = $b36288e2db101ba3$var$Fh(a, b, c);
            else {
                e = b.stateNode;
                if (e = (null === a || null === a.child) && e.hydrate) $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Ne(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$th = b, e = $b36288e2db101ba3$var$vh = !0;
                e ? (b.effectTag |= 2, b.child = $b36288e2db101ba3$var$ug(b, null, d, c)) : ($b36288e2db101ba3$var$S(a, b, d, c), $b36288e2db101ba3$var$Ch());
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Cg(b), null === a && $b36288e2db101ba3$var$zh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, h = e.children, $b36288e2db101ba3$var$Ke(d, e) ? h = null : null !== f && $b36288e2db101ba3$var$Ke(d, f) && (b.effectTag |= 16), $b36288e2db101ba3$var$Kh(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : ($b36288e2db101ba3$var$S(a, b, h, c), b = b.child), b;
        case 6:
            return null === a && $b36288e2db101ba3$var$zh(b), null;
        case 13:
            return $b36288e2db101ba3$var$Ph(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ag(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$tg(b, null, d, c) : $b36288e2db101ba3$var$S(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Af(d, e), $b36288e2db101ba3$var$Eh(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$S(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$S(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$S(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                h = b.memoizedProps;
                f = e.value;
                $b36288e2db101ba3$var$Hf(b, f);
                if (null !== h) {
                    var g = h.value;
                    f = $b36288e2db101ba3$var$hd(g, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(g, f) : 1073741823) | 0;
                    if (0 === f) {
                        if (h.children === e.children && !$b36288e2db101ba3$var$M.current) {
                            b = $b36288e2db101ba3$var$Fh(a, b, c);
                            break a;
                        }
                    } else for(g = b.child, null !== g && (g.return = b); null !== g;){
                        var k = g.dependencies;
                        if (null !== k) {
                            h = g.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === g.tag && (l = $b36288e2db101ba3$var$Qf(c, null), l.tag = 2, $b36288e2db101ba3$var$Sf(g, l));
                                    g.expirationTime < c && (g.expirationTime = c);
                                    l = g.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    $b36288e2db101ba3$var$Jf(g.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else h = 10 === g.tag ? g.type === b.type ? null : g.child : g.child;
                        if (null !== h) h.return = g;
                        else for(h = g; null !== h;){
                            if (h === b) {
                                h = null;
                                break;
                            }
                            g = h.sibling;
                            if (null !== g) {
                                g.return = h.return;
                                h = g;
                                break;
                            }
                            h = h.return;
                        }
                        g = h;
                    }
                }
                $b36288e2db101ba3$var$S(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $b36288e2db101ba3$var$Kf(b, c), e = $b36288e2db101ba3$var$Mf(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, $b36288e2db101ba3$var$S(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $b36288e2db101ba3$var$Af(e, b.pendingProps), f = $b36288e2db101ba3$var$Af(e.type, f), $b36288e2db101ba3$var$Gh(a, b, e, f, d, c);
        case 15:
            return $b36288e2db101ba3$var$Ih(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Af(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, $b36288e2db101ba3$var$N(d) ? (a = !0, $b36288e2db101ba3$var$Xe(b)) : a = !1, $b36288e2db101ba3$var$Kf(b, c), $b36288e2db101ba3$var$hg(b, d, e, c), $b36288e2db101ba3$var$jg(b, d, e, c), $b36288e2db101ba3$var$Mh(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$Rh(a, b, c);
    }
    throw $b36288e2db101ba3$var$t(Error(156));
};
var $b36288e2db101ba3$var$pj = null, $b36288e2db101ba3$var$ji = null;
function $b36288e2db101ba3$var$tj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        $b36288e2db101ba3$var$pj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        $b36288e2db101ba3$var$ji = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function $b36288e2db101ba3$var$uj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$xh(a, b, c, d) {
    return new $b36288e2db101ba3$var$uj(a, b, c, d);
}
function $b36288e2db101ba3$var$Hh(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$sj(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$Hh(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$gc) return 11;
        if (a === $b36288e2db101ba3$var$jc) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$og(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$xh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$qg(a, b, c, d, e, f) {
    var h = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$Hh(a) && (h = 1);
    else if ("string" === typeof a) h = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ac:
            return $b36288e2db101ba3$var$sg(c.children, e, f, b);
        case $b36288e2db101ba3$var$fc:
            h = 8;
            e |= 7;
            break;
        case $b36288e2db101ba3$var$bc:
            h = 8;
            e |= 1;
            break;
        case $b36288e2db101ba3$var$cc:
            return a = $b36288e2db101ba3$var$xh(12, c, b, e | 8), a.elementType = $b36288e2db101ba3$var$cc, a.type = $b36288e2db101ba3$var$cc, a.expirationTime = f, a;
        case $b36288e2db101ba3$var$hc:
            return a = $b36288e2db101ba3$var$xh(13, c, b, e), a.type = $b36288e2db101ba3$var$hc, a.elementType = $b36288e2db101ba3$var$hc, a.expirationTime = f, a;
        case $b36288e2db101ba3$var$ic:
            return a = $b36288e2db101ba3$var$xh(19, c, b, e), a.elementType = $b36288e2db101ba3$var$ic, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$dc:
                    h = 10;
                    break a;
                case $b36288e2db101ba3$var$ec:
                    h = 9;
                    break a;
                case $b36288e2db101ba3$var$gc:
                    h = 11;
                    break a;
                case $b36288e2db101ba3$var$jc:
                    h = 14;
                    break a;
                case $b36288e2db101ba3$var$kc:
                    h = 16;
                    d = null;
                    break a;
            }
            throw $b36288e2db101ba3$var$t(Error(130), null == a ? a : typeof a, "");
    }
    b = $b36288e2db101ba3$var$xh(h, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function $b36288e2db101ba3$var$sg(a, b, c, d) {
    a = $b36288e2db101ba3$var$xh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function $b36288e2db101ba3$var$pg(a, b, c) {
    a = $b36288e2db101ba3$var$xh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function $b36288e2db101ba3$var$rg(a, b, c) {
    b = $b36288e2db101ba3$var$xh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = this.firstBatch = null;
    this.pingTime = this.lastPendingTime = this.firstPendingTime = this.callbackExpirationTime = 0;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a = new $b36288e2db101ba3$var$vj(a, b, c);
    b = $b36288e2db101ba3$var$xh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    a.current = b;
    return b.stateNode = a;
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e, f) {
    var h = b.current;
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (2 !== $b36288e2db101ba3$var$ld(c) || 1 !== c.tag) throw $b36288e2db101ba3$var$t(Error(170));
            var g = c;
            do {
                switch(g.tag){
                    case 3:
                        g = g.stateNode.context;
                        break b;
                    case 1:
                        if ($b36288e2db101ba3$var$N(g.type)) {
                            g = g.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                g = g.return;
            }while (null !== g);
            throw $b36288e2db101ba3$var$t(Error(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($b36288e2db101ba3$var$N(k)) {
                c = $b36288e2db101ba3$var$We(c, k, g);
                break a;
            }
        }
        c = g;
    } else c = $b36288e2db101ba3$var$Qe;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = f;
    e = $b36288e2db101ba3$var$Qf(d, e);
    e.payload = {
        element: a
    };
    b = void 0 === b ? null : b;
    null !== b && (e.callback = b);
    $b36288e2db101ba3$var$Sf(h, e);
    $b36288e2db101ba3$var$eg(h, d);
    return d;
}
function $b36288e2db101ba3$var$yj(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$cg(), h = $b36288e2db101ba3$var$$f.suspense;
    e = $b36288e2db101ba3$var$dg(f, e, h);
    return $b36288e2db101ba3$var$xj(a, b, c, e, h, d);
}
function $b36288e2db101ba3$var$zj(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$Aj(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$$b,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
$b36288e2db101ba3$var$Db = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$Ec(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Ka(d);
                        if (!e) throw $b36288e2db101ba3$var$t(Error(90));
                        $b36288e2db101ba3$var$Wb(d);
                        $b36288e2db101ba3$var$Ec(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$pe(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$me(a, !!c.multiple, b, !1);
    }
};
function $b36288e2db101ba3$var$Bj(a) {
    var b = 1073741821 - 25 * (((1073741821 - $b36288e2db101ba3$var$cg() + 500) / 25 | 0) + 1);
    b <= $b36288e2db101ba3$var$Xi && --b;
    this._expirationTime = $b36288e2db101ba3$var$Xi = b;
    this._root = a;
    this._callbacks = this._next = null;
    this._hasChildren = this._didComplete = !1;
    this._children = null;
    this._defer = !0;
}
$b36288e2db101ba3$var$Bj.prototype.render = function(a) {
    if (!this._defer) throw $b36288e2db101ba3$var$t(Error(250));
    this._hasChildren = !0;
    this._children = a;
    var b = this._root._internalRoot, c = this._expirationTime, d = new $b36288e2db101ba3$var$Cj;
    $b36288e2db101ba3$var$xj(a, b, null, c, null, d._onCommit);
    return d;
};
$b36288e2db101ba3$var$Bj.prototype.then = function(a) {
    if (this._didComplete) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$b36288e2db101ba3$var$Bj.prototype.commit = function() {
    var a = this._root._internalRoot, b = a.firstBatch;
    if (!this._defer || null === b) throw $b36288e2db101ba3$var$t(Error(251));
    if (this._hasChildren) {
        var c = this._expirationTime;
        if (b !== this) {
            this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));
            for(var d = null, e = b; e !== this;)d = e, e = e._next;
            if (null === d) throw $b36288e2db101ba3$var$t(Error(251));
            d._next = e._next;
            this._next = b;
            a.firstBatch = this;
        }
        this._defer = !1;
        b = c;
        if (($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) !== $b36288e2db101ba3$var$T) throw $b36288e2db101ba3$var$t(Error(253));
        $b36288e2db101ba3$var$xf($b36288e2db101ba3$var$Z.bind(null, a, b));
        $b36288e2db101ba3$var$O();
        b = this._next;
        this._next = null;
        b = a.firstBatch = b;
        null !== b && b._hasChildren && b.render(b._children);
    } else this._next = null, this._defer = !1;
};
$b36288e2db101ba3$var$Bj.prototype._onComplete = function() {
    if (!this._didComplete) {
        this._didComplete = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++)(0, a[b])();
    }
};
function $b36288e2db101ba3$var$Cj() {
    this._callbacks = null;
    this._didCommit = !1;
    this._onCommit = this._onCommit.bind(this);
}
$b36288e2db101ba3$var$Cj.prototype.then = function(a) {
    if (this._didCommit) a();
    else {
        var b = this._callbacks;
        null === b && (b = this._callbacks = []);
        b.push(a);
    }
};
$b36288e2db101ba3$var$Cj.prototype._onCommit = function() {
    if (!this._didCommit) {
        this._didCommit = !0;
        var a = this._callbacks;
        if (null !== a) for(var b = 0; b < a.length; b++){
            var c = a[b];
            if ("function" !== typeof c) throw $b36288e2db101ba3$var$t(Error(191), c);
            c();
        }
    }
};
function $b36288e2db101ba3$var$Dj(a, b, c) {
    this._internalRoot = $b36288e2db101ba3$var$wj(a, b, c);
}
function $b36288e2db101ba3$var$Ej(a, b) {
    this._internalRoot = $b36288e2db101ba3$var$wj(a, 2, b);
}
$b36288e2db101ba3$var$Ej.prototype.render = $b36288e2db101ba3$var$Dj.prototype.render = function(a, b) {
    var c = this._internalRoot, d = new $b36288e2db101ba3$var$Cj;
    b = void 0 === b ? null : b;
    null !== b && d.then(b);
    $b36288e2db101ba3$var$yj(a, c, null, d._onCommit);
    return d;
};
$b36288e2db101ba3$var$Ej.prototype.unmount = $b36288e2db101ba3$var$Dj.prototype.unmount = function(a) {
    var b = this._internalRoot, c = new $b36288e2db101ba3$var$Cj;
    a = void 0 === a ? null : a;
    null !== a && c.then(a);
    $b36288e2db101ba3$var$yj(null, b, null, c._onCommit);
    return c;
};
$b36288e2db101ba3$var$Ej.prototype.createBatch = function() {
    var a = new $b36288e2db101ba3$var$Bj(this), b = a._expirationTime, c = this._internalRoot, d = c.firstBatch;
    if (null === d) c.firstBatch = a, a._next = null;
    else {
        for(c = null; null !== d && d._expirationTime >= b;)c = d, d = d._next;
        a._next = d;
        null !== c && (c._next = a);
    }
    return a;
};
function $b36288e2db101ba3$var$Hj(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
$b36288e2db101ba3$var$Jb = $b36288e2db101ba3$var$ej;
$b36288e2db101ba3$var$Kb = $b36288e2db101ba3$var$fj;
$b36288e2db101ba3$var$Lb = $b36288e2db101ba3$var$aj;
$b36288e2db101ba3$var$Mb = function(a, b) {
    var c = $b36288e2db101ba3$var$U;
    $b36288e2db101ba3$var$U |= 2;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$U = c, $b36288e2db101ba3$var$U === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$O();
    }
};
function $b36288e2db101ba3$var$Ij(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $b36288e2db101ba3$var$Dj(a, 0, b);
}
function $b36288e2db101ba3$var$Jj(a, b, c, d, e) {
    var f = c._reactRootContainer, h = void 0;
    if (f) {
        h = f._internalRoot;
        if ("function" === typeof e) {
            var g = e;
            e = function() {
                var a = $b36288e2db101ba3$var$zj(h);
                g.call(a);
            };
        }
        $b36288e2db101ba3$var$yj(b, h, a, e);
    } else {
        f = c._reactRootContainer = $b36288e2db101ba3$var$Ij(c, d);
        h = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $b36288e2db101ba3$var$zj(h);
                k.call(a);
            };
        }
        $b36288e2db101ba3$var$gj(function() {
            $b36288e2db101ba3$var$yj(b, h, a, e);
        });
    }
    return $b36288e2db101ba3$var$zj(h);
}
function $b36288e2db101ba3$var$Kj(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$Hj(b)) throw $b36288e2db101ba3$var$t(Error(200));
    return $b36288e2db101ba3$var$Aj(a, b, null, c);
}
var $b36288e2db101ba3$var$Nj = {
    createPortal: $b36288e2db101ba3$var$Kj,
    findDOMNode: function(a) {
        if (null == a) a = null;
        else if (1 !== a.nodeType) {
            var b = a._reactInternalFiber;
            if (void 0 === b) {
                if ("function" === typeof a.render) throw $b36288e2db101ba3$var$t(Error(188));
                throw $b36288e2db101ba3$var$t(Error(268), Object.keys(a));
            }
            a = $b36288e2db101ba3$var$qd(b);
            a = null === a ? null : a.stateNode;
        }
        return a;
    },
    hydrate: function(a, b, c) {
        if (!$b36288e2db101ba3$var$Hj(b)) throw $b36288e2db101ba3$var$t(Error(200));
        return $b36288e2db101ba3$var$Jj(null, a, b, !0, c);
    },
    render: function(a, b, c) {
        if (!$b36288e2db101ba3$var$Hj(b)) throw $b36288e2db101ba3$var$t(Error(200));
        return $b36288e2db101ba3$var$Jj(null, a, b, !1, c);
    },
    unstable_renderSubtreeIntoContainer: function(a, b, c, d) {
        if (!$b36288e2db101ba3$var$Hj(c)) throw $b36288e2db101ba3$var$t(Error(200));
        if (null == a || void 0 === a._reactInternalFiber) throw $b36288e2db101ba3$var$t(Error(38));
        return $b36288e2db101ba3$var$Jj(a, b, c, !1, d);
    },
    unmountComponentAtNode: function(a) {
        if (!$b36288e2db101ba3$var$Hj(a)) throw $b36288e2db101ba3$var$t(Error(40));
        return a._reactRootContainer ? ($b36288e2db101ba3$var$gj(function() {
            $b36288e2db101ba3$var$Jj(null, null, a, !1, function() {
                a._reactRootContainer = null;
            });
        }), !0) : !1;
    },
    unstable_createPortal: function() {
        return $b36288e2db101ba3$var$Kj.apply(void 0, arguments);
    },
    unstable_batchedUpdates: $b36288e2db101ba3$var$ej,
    unstable_interactiveUpdates: function(a, b, c, d) {
        $b36288e2db101ba3$var$aj();
        return $b36288e2db101ba3$var$fj(a, b, c, d);
    },
    unstable_discreteUpdates: $b36288e2db101ba3$var$fj,
    unstable_flushDiscreteUpdates: $b36288e2db101ba3$var$aj,
    flushSync: function(a, b) {
        if (($b36288e2db101ba3$var$U & ($b36288e2db101ba3$var$Ci | $b36288e2db101ba3$var$Di)) !== $b36288e2db101ba3$var$T) throw $b36288e2db101ba3$var$t(Error(187));
        var c = $b36288e2db101ba3$var$U;
        $b36288e2db101ba3$var$U |= 1;
        try {
            return $b36288e2db101ba3$var$vf(99, a.bind(null, b));
        } finally{
            $b36288e2db101ba3$var$U = c, $b36288e2db101ba3$var$O();
        }
    },
    unstable_createRoot: $b36288e2db101ba3$var$Lj,
    unstable_createSyncRoot: $b36288e2db101ba3$var$Mj,
    unstable_flushControlled: function(a) {
        var b = $b36288e2db101ba3$var$U;
        $b36288e2db101ba3$var$U |= 1;
        try {
            $b36288e2db101ba3$var$vf(99, a);
        } finally{
            $b36288e2db101ba3$var$U = b, $b36288e2db101ba3$var$U === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$O();
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        Events: [
            $b36288e2db101ba3$var$Ia,
            $b36288e2db101ba3$var$Ja,
            $b36288e2db101ba3$var$Ka,
            $b36288e2db101ba3$var$Ca.injectEventPluginsByName,
            $b36288e2db101ba3$var$fa,
            $b36288e2db101ba3$var$Qa,
            function(a) {
                $b36288e2db101ba3$var$ya(a, $b36288e2db101ba3$var$Pa);
            },
            $b36288e2db101ba3$var$Hb,
            $b36288e2db101ba3$var$Ib,
            $b36288e2db101ba3$var$Ud,
            $b36288e2db101ba3$var$Ba,
            $b36288e2db101ba3$var$cj,
            {
                current: !1
            }
        ]
    }
};
function $b36288e2db101ba3$var$Lj(a, b) {
    if (!$b36288e2db101ba3$var$Hj(a)) throw $b36288e2db101ba3$var$t(Error(299), "unstable_createRoot");
    return new $b36288e2db101ba3$var$Ej(a, null != b && !0 === b.hydrate);
}
function $b36288e2db101ba3$var$Mj(a, b) {
    if (!$b36288e2db101ba3$var$Hj(a)) throw $b36288e2db101ba3$var$t(Error(299), "unstable_createRoot");
    return new $b36288e2db101ba3$var$Dj(a, 1, null != b && !0 === b.hydrate);
}
(function(a) {
    var b = a.findFiberByHostInstance;
    return $b36288e2db101ba3$var$tj($4yvvI({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: $b36288e2db101ba3$var$Xb.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = $b36288e2db101ba3$var$qd(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: $b36288e2db101ba3$var$Ha,
    bundleType: 0,
    version: "16.9.0",
    rendererPackageName: "react-dom"
});
var $b36288e2db101ba3$var$Oj = {
    default: $b36288e2db101ba3$var$Nj
}, $b36288e2db101ba3$var$Pj = $b36288e2db101ba3$var$Oj && $b36288e2db101ba3$var$Nj || $b36288e2db101ba3$var$Oj;
module.exports = $b36288e2db101ba3$var$Pj.default || $b36288e2db101ba3$var$Pj;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {
/** @license React v16.9.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4yvvI = parcelRequire("4yvvI");
var $92f4fea5bc247620$var$n = "function" === typeof Symbol && Symbol.for, $92f4fea5bc247620$var$p = $92f4fea5bc247620$var$n ? Symbol.for("react.element") : 60103, $92f4fea5bc247620$var$q = $92f4fea5bc247620$var$n ? Symbol.for("react.portal") : 60106, $92f4fea5bc247620$var$r = $92f4fea5bc247620$var$n ? Symbol.for("react.fragment") : 60107, $92f4fea5bc247620$var$t = $92f4fea5bc247620$var$n ? Symbol.for("react.strict_mode") : 60108, $92f4fea5bc247620$var$u = $92f4fea5bc247620$var$n ? Symbol.for("react.profiler") : 60114, $92f4fea5bc247620$var$v = $92f4fea5bc247620$var$n ? Symbol.for("react.provider") : 60109, $92f4fea5bc247620$var$w = $92f4fea5bc247620$var$n ? Symbol.for("react.context") : 60110, $92f4fea5bc247620$var$x = $92f4fea5bc247620$var$n ? Symbol.for("react.forward_ref") : 60112, $92f4fea5bc247620$var$y = $92f4fea5bc247620$var$n ? Symbol.for("react.suspense") : 60113, $92f4fea5bc247620$var$aa = $92f4fea5bc247620$var$n ? Symbol.for("react.suspense_list") : 60120, $92f4fea5bc247620$var$ba = $92f4fea5bc247620$var$n ? Symbol.for("react.memo") : 60115, $92f4fea5bc247620$var$ca = $92f4fea5bc247620$var$n ? Symbol.for("react.lazy") : 60116;
$92f4fea5bc247620$var$n && Symbol.for("react.fundamental");
$92f4fea5bc247620$var$n && Symbol.for("react.responder");
var $92f4fea5bc247620$var$z = "function" === typeof Symbol && Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    for(var b = a.message, d = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, c = 1; c < arguments.length; c++)d += "&args[]=" + encodeURIComponent(arguments[c]);
    a.message = "Minified React error #" + b + "; visit " + d + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";
    return a;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = {};
function $92f4fea5bc247620$var$D(a, b, d) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$C;
    this.updater = d || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$D.prototype.isReactComponent = {};
$92f4fea5bc247620$var$D.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw $92f4fea5bc247620$var$A(Error(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$D.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$E() {}
$92f4fea5bc247620$var$E.prototype = $92f4fea5bc247620$var$D.prototype;
function $92f4fea5bc247620$var$F(a, b, d) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$C;
    this.updater = d || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$G = $92f4fea5bc247620$var$F.prototype = new $92f4fea5bc247620$var$E;
$92f4fea5bc247620$var$G.constructor = $92f4fea5bc247620$var$F;
$4yvvI($92f4fea5bc247620$var$G, $92f4fea5bc247620$var$D.prototype);
$92f4fea5bc247620$var$G.isPureReactComponent = !0;
var $92f4fea5bc247620$var$H = {
    current: null
}, $92f4fea5bc247620$var$I = {
    suspense: null
}, $92f4fea5bc247620$var$J = {
    current: null
}, $92f4fea5bc247620$var$K = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, d) {
    var c = void 0, e = {}, g = null, k = null;
    if (null != b) for(c in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$92f4fea5bc247620$var$K.call(b, c) && !$92f4fea5bc247620$var$L.hasOwnProperty(c) && (e[c] = b[c]);
    var f = arguments.length - 2;
    if (1 === f) e.children = d;
    else if (1 < f) {
        for(var l = Array(f), m = 0; m < f; m++)l[m] = arguments[m + 2];
        e.children = l;
    }
    if (a && a.defaultProps) for(c in f = a.defaultProps, f)void 0 === e[c] && (e[c] = f[c]);
    return {
        $$typeof: $92f4fea5bc247620$var$p,
        type: a,
        key: g,
        ref: k,
        props: e,
        _owner: $92f4fea5bc247620$var$J.current
    };
}
function $92f4fea5bc247620$var$da(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$N(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$p;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$O = /\/+/g, $92f4fea5bc247620$var$P = [];
function $92f4fea5bc247620$var$Q(a, b, d, c) {
    if ($92f4fea5bc247620$var$P.length) {
        var e = $92f4fea5bc247620$var$P.pop();
        e.result = a;
        e.keyPrefix = b;
        e.func = d;
        e.context = c;
        e.count = 0;
        return e;
    }
    return {
        result: a,
        keyPrefix: b,
        func: d,
        context: c,
        count: 0
    };
}
function $92f4fea5bc247620$var$R(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $92f4fea5bc247620$var$P.length && $92f4fea5bc247620$var$P.push(a);
}
function $92f4fea5bc247620$var$S(a, b, d, c) {
    var e = typeof a;
    if ("undefined" === e || "boolean" === e) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(e){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$p:
                case $92f4fea5bc247620$var$q:
                    g = !0;
            }
    }
    if (g) return d(c, a, "" === b ? "." + $92f4fea5bc247620$var$T(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        e = a[k];
        var f = b + $92f4fea5bc247620$var$T(e, k);
        g += $92f4fea5bc247620$var$S(e, f, d, c);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(e = a.next()).done;)e = e.value, f = b + $92f4fea5bc247620$var$T(e, k++), g += $92f4fea5bc247620$var$S(e, f, d, c);
    else if ("object" === e) throw d = "" + a, $92f4fea5bc247620$var$A(Error(31), "[object Object]" === d ? "object with keys {" + Object.keys(a).join(", ") + "}" : d, "");
    return g;
}
function $92f4fea5bc247620$var$U(a, b, d) {
    return null == a ? 0 : $92f4fea5bc247620$var$S(a, "", b, d);
}
function $92f4fea5bc247620$var$T(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape(a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$ea(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $92f4fea5bc247620$var$fa(a, b, d) {
    var c = a.result, e = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $92f4fea5bc247620$var$V(a, c, d, function(a) {
        return a;
    }) : null != a && ($92f4fea5bc247620$var$N(a) && (a = $92f4fea5bc247620$var$da(a, e + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($92f4fea5bc247620$var$O, "$&/") + "/") + d)), c.push(a));
}
function $92f4fea5bc247620$var$V(a, b, d, c, e) {
    var g = "";
    null != d && (g = ("" + d).replace($92f4fea5bc247620$var$O, "$&/") + "/");
    b = $92f4fea5bc247620$var$Q(b, g, c, e);
    $92f4fea5bc247620$var$U(a, $92f4fea5bc247620$var$fa, b);
    $92f4fea5bc247620$var$R(b);
}
function $92f4fea5bc247620$var$W() {
    var a = $92f4fea5bc247620$var$H.current;
    if (null === a) throw $92f4fea5bc247620$var$A(Error(321));
    return a;
}
var $92f4fea5bc247620$var$X = {
    Children: {
        map: function(a, b, d) {
            if (null == a) return a;
            var c = [];
            $92f4fea5bc247620$var$V(a, c, null, b, d);
            return c;
        },
        forEach: function(a, b, d) {
            if (null == a) return a;
            b = $92f4fea5bc247620$var$Q(null, null, b, d);
            $92f4fea5bc247620$var$U(a, $92f4fea5bc247620$var$ea, b);
            $92f4fea5bc247620$var$R(b);
        },
        count: function(a) {
            return $92f4fea5bc247620$var$U(a, function() {
                return null;
            }, null);
        },
        toArray: function(a) {
            var b = [];
            $92f4fea5bc247620$var$V(a, b, null, function(a) {
                return a;
            });
            return b;
        },
        only: function(a) {
            if (!$92f4fea5bc247620$var$N(a)) throw $92f4fea5bc247620$var$A(Error(143));
            return a;
        }
    },
    createRef: function() {
        return {
            current: null
        };
    },
    Component: $92f4fea5bc247620$var$D,
    PureComponent: $92f4fea5bc247620$var$F,
    createContext: function(a, b) {
        void 0 === b && (b = null);
        a = {
            $$typeof: $92f4fea5bc247620$var$w,
            _calculateChangedBits: b,
            _currentValue: a,
            _currentValue2: a,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        a.Provider = {
            $$typeof: $92f4fea5bc247620$var$v,
            _context: a
        };
        return a.Consumer = a;
    },
    forwardRef: function(a) {
        return {
            $$typeof: $92f4fea5bc247620$var$x,
            render: a
        };
    },
    lazy: function(a) {
        return {
            $$typeof: $92f4fea5bc247620$var$ca,
            _ctor: a,
            _status: -1,
            _result: null
        };
    },
    memo: function(a, b) {
        return {
            $$typeof: $92f4fea5bc247620$var$ba,
            type: a,
            compare: void 0 === b ? null : b
        };
    },
    useCallback: function(a, b) {
        return $92f4fea5bc247620$var$W().useCallback(a, b);
    },
    useContext: function(a, b) {
        return $92f4fea5bc247620$var$W().useContext(a, b);
    },
    useEffect: function(a, b) {
        return $92f4fea5bc247620$var$W().useEffect(a, b);
    },
    useImperativeHandle: function(a, b, d) {
        return $92f4fea5bc247620$var$W().useImperativeHandle(a, b, d);
    },
    useDebugValue: function() {},
    useLayoutEffect: function(a, b) {
        return $92f4fea5bc247620$var$W().useLayoutEffect(a, b);
    },
    useMemo: function(a, b) {
        return $92f4fea5bc247620$var$W().useMemo(a, b);
    },
    useReducer: function(a, b, d) {
        return $92f4fea5bc247620$var$W().useReducer(a, b, d);
    },
    useRef: function(a) {
        return $92f4fea5bc247620$var$W().useRef(a);
    },
    useState: function(a) {
        return $92f4fea5bc247620$var$W().useState(a);
    },
    Fragment: $92f4fea5bc247620$var$r,
    Profiler: $92f4fea5bc247620$var$u,
    StrictMode: $92f4fea5bc247620$var$t,
    Suspense: $92f4fea5bc247620$var$y,
    unstable_SuspenseList: $92f4fea5bc247620$var$aa,
    createElement: $92f4fea5bc247620$var$M,
    cloneElement: function(a, b, d) {
        if (null === a || void 0 === a) throw $92f4fea5bc247620$var$A(Error(267), a);
        var c = void 0, e = $4yvvI({}, a.props), g = a.key, k = a.ref, f = a._owner;
        if (null != b) {
            void 0 !== b.ref && (k = b.ref, f = $92f4fea5bc247620$var$J.current);
            void 0 !== b.key && (g = "" + b.key);
            var l = void 0;
            a.type && a.type.defaultProps && (l = a.type.defaultProps);
            for(c in b)$92f4fea5bc247620$var$K.call(b, c) && !$92f4fea5bc247620$var$L.hasOwnProperty(c) && (e[c] = void 0 === b[c] && void 0 !== l ? l[c] : b[c]);
        }
        c = arguments.length - 2;
        if (1 === c) e.children = d;
        else if (1 < c) {
            l = Array(c);
            for(var m = 0; m < c; m++)l[m] = arguments[m + 2];
            e.children = l;
        }
        return {
            $$typeof: $92f4fea5bc247620$var$p,
            type: a.type,
            key: g,
            ref: k,
            props: e,
            _owner: f
        };
    },
    createFactory: function(a) {
        var b = $92f4fea5bc247620$var$M.bind(null, a);
        b.type = a;
        return b;
    },
    isValidElement: $92f4fea5bc247620$var$N,
    version: "16.9.0",
    unstable_withSuspenseConfig: function(a, b) {
        var d = $92f4fea5bc247620$var$I.suspense;
        $92f4fea5bc247620$var$I.suspense = void 0 === b ? null : b;
        try {
            a();
        } finally{
            $92f4fea5bc247620$var$I.suspense = d;
        }
    },
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
        ReactCurrentDispatcher: $92f4fea5bc247620$var$H,
        ReactCurrentBatchConfig: $92f4fea5bc247620$var$I,
        ReactCurrentOwner: $92f4fea5bc247620$var$J,
        IsSomeRendererActing: {
            current: !1
        },
        assign: $4yvvI
    }
}, $92f4fea5bc247620$var$Y = {
    default: $92f4fea5bc247620$var$X
}, $92f4fea5bc247620$var$Z = $92f4fea5bc247620$var$Y && $92f4fea5bc247620$var$X || $92f4fea5bc247620$var$Y;
module.exports = $92f4fea5bc247620$var$Z.default || $92f4fea5bc247620$var$Z;

});
parcelRequire.register("4yvvI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {
/** @license React v0.15.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $6445fa7f31ec0ca5$var$d = void 0, $6445fa7f31ec0ca5$var$e = void 0, $6445fa7f31ec0ca5$var$g = void 0, $6445fa7f31ec0ca5$var$m = void 0, $6445fa7f31ec0ca5$var$n = void 0;
module.exports.unstable_now = void 0;
module.exports.unstable_forceFrameRate = void 0;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$p = null, $6445fa7f31ec0ca5$var$q = null, $6445fa7f31ec0ca5$var$r = function() {
        if (null !== $6445fa7f31ec0ca5$var$p) try {
            var a = module.exports.unstable_now();
            $6445fa7f31ec0ca5$var$p(!0, a);
            $6445fa7f31ec0ca5$var$p = null;
        } catch (b) {
            throw setTimeout($6445fa7f31ec0ca5$var$r, 0), b;
        }
    };
    module.exports.unstable_now = function() {
        return Date.now();
    };
    $6445fa7f31ec0ca5$var$d = function(a) {
        null !== $6445fa7f31ec0ca5$var$p ? setTimeout($6445fa7f31ec0ca5$var$d, 0, a) : ($6445fa7f31ec0ca5$var$p = a, setTimeout($6445fa7f31ec0ca5$var$r, 0));
    };
    $6445fa7f31ec0ca5$var$e = function(a, b) {
        $6445fa7f31ec0ca5$var$q = setTimeout(a, b);
    };
    $6445fa7f31ec0ca5$var$g = function() {
        clearTimeout($6445fa7f31ec0ca5$var$q);
    };
    $6445fa7f31ec0ca5$var$m = function() {
        return !1;
    };
    $6445fa7f31ec0ca5$var$n = module.exports.unstable_forceFrameRate = function() {};
} else {
    var $6445fa7f31ec0ca5$var$t = window.performance, $6445fa7f31ec0ca5$var$u = window.Date, $6445fa7f31ec0ca5$var$v = window.setTimeout, $6445fa7f31ec0ca5$var$w = window.clearTimeout, $6445fa7f31ec0ca5$var$x = window.requestAnimationFrame, $6445fa7f31ec0ca5$var$y = window.cancelAnimationFrame;
    "undefined" !== typeof console && ("function" !== typeof $6445fa7f31ec0ca5$var$x && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof $6445fa7f31ec0ca5$var$y && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    module.exports.unstable_now = "object" === typeof $6445fa7f31ec0ca5$var$t && "function" === typeof $6445fa7f31ec0ca5$var$t.now ? function() {
        return $6445fa7f31ec0ca5$var$t.now();
    } : function() {
        return $6445fa7f31ec0ca5$var$u.now();
    };
    var $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = null, $6445fa7f31ec0ca5$var$B = -1, $6445fa7f31ec0ca5$var$C = -1, $6445fa7f31ec0ca5$var$D = 33.33, $6445fa7f31ec0ca5$var$E = -1, $6445fa7f31ec0ca5$var$F = -1, $6445fa7f31ec0ca5$var$G = 0, $6445fa7f31ec0ca5$var$H = !1;
    $6445fa7f31ec0ca5$var$m = function() {
        return module.exports.unstable_now() >= $6445fa7f31ec0ca5$var$G;
    };
    $6445fa7f31ec0ca5$var$n = function() {};
    module.exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : 0 < a ? ($6445fa7f31ec0ca5$var$D = Math.floor(1E3 / a), $6445fa7f31ec0ca5$var$H = !0) : ($6445fa7f31ec0ca5$var$D = 33.33, $6445fa7f31ec0ca5$var$H = !1);
    };
    var $6445fa7f31ec0ca5$var$J = function() {
        if (null !== $6445fa7f31ec0ca5$var$A) {
            var a = module.exports.unstable_now(), b = 0 < $6445fa7f31ec0ca5$var$G - a;
            try {
                $6445fa7f31ec0ca5$var$A(b, a) || ($6445fa7f31ec0ca5$var$A = null);
            } catch (c) {
                throw $6445fa7f31ec0ca5$var$I.postMessage(null), c;
            }
        }
    }, $6445fa7f31ec0ca5$var$K = new MessageChannel, $6445fa7f31ec0ca5$var$I = $6445fa7f31ec0ca5$var$K.port2;
    $6445fa7f31ec0ca5$var$K.port1.onmessage = $6445fa7f31ec0ca5$var$J;
    var $6445fa7f31ec0ca5$var$L = function(a) {
        if (null === $6445fa7f31ec0ca5$var$A) $6445fa7f31ec0ca5$var$F = $6445fa7f31ec0ca5$var$E = -1, $6445fa7f31ec0ca5$var$z = !1;
        else {
            $6445fa7f31ec0ca5$var$z = !0;
            $6445fa7f31ec0ca5$var$x(function(a) {
                $6445fa7f31ec0ca5$var$w($6445fa7f31ec0ca5$var$B);
                $6445fa7f31ec0ca5$var$L(a);
            });
            var b = function() {
                $6445fa7f31ec0ca5$var$G = module.exports.unstable_now() + $6445fa7f31ec0ca5$var$D / 2;
                $6445fa7f31ec0ca5$var$J();
                $6445fa7f31ec0ca5$var$B = $6445fa7f31ec0ca5$var$v(b, 3 * $6445fa7f31ec0ca5$var$D);
            };
            $6445fa7f31ec0ca5$var$B = $6445fa7f31ec0ca5$var$v(b, 3 * $6445fa7f31ec0ca5$var$D);
            if (-1 !== $6445fa7f31ec0ca5$var$E && .1 < a - $6445fa7f31ec0ca5$var$E) {
                var c = a - $6445fa7f31ec0ca5$var$E;
                !$6445fa7f31ec0ca5$var$H && -1 !== $6445fa7f31ec0ca5$var$F && c < $6445fa7f31ec0ca5$var$D && $6445fa7f31ec0ca5$var$F < $6445fa7f31ec0ca5$var$D && ($6445fa7f31ec0ca5$var$D = c < $6445fa7f31ec0ca5$var$F ? $6445fa7f31ec0ca5$var$F : c, 8.33 > $6445fa7f31ec0ca5$var$D && ($6445fa7f31ec0ca5$var$D = 8.33));
                $6445fa7f31ec0ca5$var$F = c;
            }
            $6445fa7f31ec0ca5$var$E = a;
            $6445fa7f31ec0ca5$var$G = a + $6445fa7f31ec0ca5$var$D;
            $6445fa7f31ec0ca5$var$I.postMessage(null);
        }
    };
    $6445fa7f31ec0ca5$var$d = function(a) {
        $6445fa7f31ec0ca5$var$A = a;
        $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$z = !0, $6445fa7f31ec0ca5$var$x(function(a) {
            $6445fa7f31ec0ca5$var$L(a);
        }));
    };
    $6445fa7f31ec0ca5$var$e = function(a, b) {
        $6445fa7f31ec0ca5$var$C = $6445fa7f31ec0ca5$var$v(function() {
            a(module.exports.unstable_now());
        }, b);
    };
    $6445fa7f31ec0ca5$var$g = function() {
        $6445fa7f31ec0ca5$var$w($6445fa7f31ec0ca5$var$C);
        $6445fa7f31ec0ca5$var$C = -1;
    };
}
var $6445fa7f31ec0ca5$var$M = null, $6445fa7f31ec0ca5$var$N = null, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$P = 3, $6445fa7f31ec0ca5$var$Q = !1, $6445fa7f31ec0ca5$var$R = !1, $6445fa7f31ec0ca5$var$S = !1;
function $6445fa7f31ec0ca5$var$T(a, b) {
    var c = a.next;
    if (c === a) $6445fa7f31ec0ca5$var$M = null;
    else {
        a === $6445fa7f31ec0ca5$var$M && ($6445fa7f31ec0ca5$var$M = c);
        var f = a.previous;
        f.next = c;
        c.previous = f;
    }
    a.next = a.previous = null;
    c = a.callback;
    f = $6445fa7f31ec0ca5$var$P;
    var l = $6445fa7f31ec0ca5$var$O;
    $6445fa7f31ec0ca5$var$P = a.priorityLevel;
    $6445fa7f31ec0ca5$var$O = a;
    try {
        var h = a.expirationTime <= b;
        switch($6445fa7f31ec0ca5$var$P){
            case 1:
                var k = c(h);
                break;
            case 2:
                k = c(h);
                break;
            case 3:
                k = c(h);
                break;
            case 4:
                k = c(h);
                break;
            case 5:
                k = c(h);
        }
    } catch (Z) {
        throw Z;
    } finally{
        $6445fa7f31ec0ca5$var$P = f, $6445fa7f31ec0ca5$var$O = l;
    }
    if ("function" === typeof k) {
        if (b = a.expirationTime, a.callback = k, null === $6445fa7f31ec0ca5$var$M) $6445fa7f31ec0ca5$var$M = a.next = a.previous = a;
        else {
            k = null;
            h = $6445fa7f31ec0ca5$var$M;
            do {
                if (b <= h.expirationTime) {
                    k = h;
                    break;
                }
                h = h.next;
            }while (h !== $6445fa7f31ec0ca5$var$M);
            null === k ? k = $6445fa7f31ec0ca5$var$M : k === $6445fa7f31ec0ca5$var$M && ($6445fa7f31ec0ca5$var$M = a);
            b = k.previous;
            b.next = k.previous = a;
            a.next = k;
            a.previous = b;
        }
    }
}
function $6445fa7f31ec0ca5$var$U(a) {
    if (null !== $6445fa7f31ec0ca5$var$N && $6445fa7f31ec0ca5$var$N.startTime <= a) do {
        var b = $6445fa7f31ec0ca5$var$N, c = b.next;
        if (b === c) $6445fa7f31ec0ca5$var$N = null;
        else {
            $6445fa7f31ec0ca5$var$N = c;
            var f = b.previous;
            f.next = c;
            c.previous = f;
        }
        b.next = b.previous = null;
        $6445fa7f31ec0ca5$var$V(b, b.expirationTime);
    }while (null !== $6445fa7f31ec0ca5$var$N && $6445fa7f31ec0ca5$var$N.startTime <= a);
}
function $6445fa7f31ec0ca5$var$W(a) {
    $6445fa7f31ec0ca5$var$S = !1;
    $6445fa7f31ec0ca5$var$U(a);
    $6445fa7f31ec0ca5$var$R || (null !== $6445fa7f31ec0ca5$var$M ? ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$d($6445fa7f31ec0ca5$var$X)) : null !== $6445fa7f31ec0ca5$var$N && $6445fa7f31ec0ca5$var$e($6445fa7f31ec0ca5$var$W, $6445fa7f31ec0ca5$var$N.startTime - a));
}
function $6445fa7f31ec0ca5$var$X(a, b) {
    $6445fa7f31ec0ca5$var$R = !1;
    $6445fa7f31ec0ca5$var$S && ($6445fa7f31ec0ca5$var$S = !1, $6445fa7f31ec0ca5$var$g());
    $6445fa7f31ec0ca5$var$U(b);
    $6445fa7f31ec0ca5$var$Q = !0;
    try {
        if (!a) for(; null !== $6445fa7f31ec0ca5$var$M && $6445fa7f31ec0ca5$var$M.expirationTime <= b;)$6445fa7f31ec0ca5$var$T($6445fa7f31ec0ca5$var$M, b), b = module.exports.unstable_now(), $6445fa7f31ec0ca5$var$U(b);
        else if (null !== $6445fa7f31ec0ca5$var$M) do $6445fa7f31ec0ca5$var$T($6445fa7f31ec0ca5$var$M, b), b = module.exports.unstable_now(), $6445fa7f31ec0ca5$var$U(b);
        while (null !== $6445fa7f31ec0ca5$var$M && !$6445fa7f31ec0ca5$var$m());
        if (null !== $6445fa7f31ec0ca5$var$M) return !0;
        null !== $6445fa7f31ec0ca5$var$N && $6445fa7f31ec0ca5$var$e($6445fa7f31ec0ca5$var$W, $6445fa7f31ec0ca5$var$N.startTime - b);
        return !1;
    } finally{
        $6445fa7f31ec0ca5$var$Q = !1;
    }
}
function $6445fa7f31ec0ca5$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
function $6445fa7f31ec0ca5$var$V(a, b) {
    if (null === $6445fa7f31ec0ca5$var$M) $6445fa7f31ec0ca5$var$M = a.next = a.previous = a;
    else {
        var c = null, f = $6445fa7f31ec0ca5$var$M;
        do {
            if (b < f.expirationTime) {
                c = f;
                break;
            }
            f = f.next;
        }while (f !== $6445fa7f31ec0ca5$var$M);
        null === c ? c = $6445fa7f31ec0ca5$var$M : c === $6445fa7f31ec0ca5$var$M && ($6445fa7f31ec0ca5$var$M = a);
        b = c.previous;
        b.next = c.previous = a;
        a.next = c;
        a.previous = b;
    }
}
var $6445fa7f31ec0ca5$var$aa = $6445fa7f31ec0ca5$var$n;
module.exports.unstable_ImmediatePriority = 1;
module.exports.unstable_UserBlockingPriority = 2;
module.exports.unstable_NormalPriority = 3;
module.exports.unstable_IdlePriority = 5;
module.exports.unstable_LowPriority = 4;
module.exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$P;
    $6445fa7f31ec0ca5$var$P = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$P = c;
    }
};
module.exports.unstable_next = function(a) {
    switch($6445fa7f31ec0ca5$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$P;
    }
    var c = $6445fa7f31ec0ca5$var$P;
    $6445fa7f31ec0ca5$var$P = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$P = c;
    }
};
module.exports.unstable_scheduleCallback = function(a, b, c) {
    var f = module.exports.unstable_now();
    if ("object" === typeof c && null !== c) {
        var l = c.delay;
        l = "number" === typeof l && 0 < l ? f + l : f;
        c = "number" === typeof c.timeout ? c.timeout : $6445fa7f31ec0ca5$var$Y(a);
    } else c = $6445fa7f31ec0ca5$var$Y(a), l = f;
    c = l + c;
    a = {
        callback: b,
        priorityLevel: a,
        startTime: l,
        expirationTime: c,
        next: null,
        previous: null
    };
    if (l > f) {
        c = l;
        if (null === $6445fa7f31ec0ca5$var$N) $6445fa7f31ec0ca5$var$N = a.next = a.previous = a;
        else {
            b = null;
            var h = $6445fa7f31ec0ca5$var$N;
            do {
                if (c < h.startTime) {
                    b = h;
                    break;
                }
                h = h.next;
            }while (h !== $6445fa7f31ec0ca5$var$N);
            null === b ? b = $6445fa7f31ec0ca5$var$N : b === $6445fa7f31ec0ca5$var$N && ($6445fa7f31ec0ca5$var$N = a);
            c = b.previous;
            c.next = b.previous = a;
            a.next = b;
            a.previous = c;
        }
        null === $6445fa7f31ec0ca5$var$M && $6445fa7f31ec0ca5$var$N === a && ($6445fa7f31ec0ca5$var$S ? $6445fa7f31ec0ca5$var$g() : $6445fa7f31ec0ca5$var$S = !0, $6445fa7f31ec0ca5$var$e($6445fa7f31ec0ca5$var$W, l - f));
    } else $6445fa7f31ec0ca5$var$V(a, c), $6445fa7f31ec0ca5$var$R || $6445fa7f31ec0ca5$var$Q || ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$d($6445fa7f31ec0ca5$var$X));
    return a;
};
module.exports.unstable_cancelCallback = function(a) {
    var b = a.next;
    if (null !== b) {
        if (a === b) a === $6445fa7f31ec0ca5$var$M ? $6445fa7f31ec0ca5$var$M = null : a === $6445fa7f31ec0ca5$var$N && ($6445fa7f31ec0ca5$var$N = null);
        else {
            a === $6445fa7f31ec0ca5$var$M ? $6445fa7f31ec0ca5$var$M = b : a === $6445fa7f31ec0ca5$var$N && ($6445fa7f31ec0ca5$var$N = b);
            var c = a.previous;
            c.next = b;
            b.previous = c;
        }
        a.next = a.previous = null;
    }
};
module.exports.unstable_wrapCallback = function(a) {
    var b = $6445fa7f31ec0ca5$var$P;
    return function() {
        var c = $6445fa7f31ec0ca5$var$P;
        $6445fa7f31ec0ca5$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$P = c;
        }
    };
};
module.exports.unstable_getCurrentPriorityLevel = function() {
    return $6445fa7f31ec0ca5$var$P;
};
module.exports.unstable_shouldYield = function() {
    var a = module.exports.unstable_now();
    $6445fa7f31ec0ca5$var$U(a);
    return null !== $6445fa7f31ec0ca5$var$O && null !== $6445fa7f31ec0ca5$var$M && $6445fa7f31ec0ca5$var$M.startTime <= a && $6445fa7f31ec0ca5$var$M.expirationTime < $6445fa7f31ec0ca5$var$O.expirationTime || $6445fa7f31ec0ca5$var$m();
};
module.exports.unstable_requestPaint = $6445fa7f31ec0ca5$var$aa;
module.exports.unstable_continueExecution = function() {
    $6445fa7f31ec0ca5$var$R || $6445fa7f31ec0ca5$var$Q || ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$d($6445fa7f31ec0ca5$var$X));
};
module.exports.unstable_pauseExecution = function() {};
module.exports.unstable_getFirstCallbackNode = function() {
    return $6445fa7f31ec0ca5$var$M;
};

});



parcelRequire.register("XIR2z", function(module, exports) {
"use strict";

var $0b384df86e13f3b1$require$assign = (parcelRequire("9SgFk")).assign;

var $e1Xnm = parcelRequire("e1Xnm");

var $2KUcj = parcelRequire("2KUcj");

var $7K70r = parcelRequire("7K70r");

var $cNRLi = parcelRequire("cNRLi");

var $1hCjm = parcelRequire("1hCjm");



/**
 * Preset configs
 */ var $0b384df86e13f3b1$var$config = {
    "default": (parcelRequire("eFvaC")),
    "full": (parcelRequire("guN2t")),
    "commonmark": (parcelRequire("jyRhi"))
};
/**
 * The `StateCore` class manages state.
 *
 * @param {Object} `instance` Remarkable instance
 * @param {String} `str` Markdown string
 * @param {Object} `env`
 */ function $0b384df86e13f3b1$var$StateCore(instance, str, env) {
    this.src = str;
    this.env = env;
    this.options = instance.options;
    this.tokens = [];
    this.inlineMode = false;
    this.inline = instance.inline;
    this.block = instance.block;
    this.renderer = instance.renderer;
    this.typographer = instance.typographer;
}
/**
 * The main `Remarkable` class. Create an instance of
 * `Remarkable` with a `preset` and/or `options`.
 *
 * @param {String} `preset` If no preset is given, `default` is used.
 * @param {Object} `options`
 */ function $0b384df86e13f3b1$var$Remarkable(preset, options) {
    if (typeof preset !== "string") {
        options = preset;
        preset = "default";
    }
    this.inline = new $cNRLi();
    this.block = new $7K70r();
    this.core = new $2KUcj();
    this.renderer = new $e1Xnm();
    this.ruler = new $1hCjm();
    this.options = {};
    this.configure($0b384df86e13f3b1$var$config[preset]);
    this.set(options || {});
}
/**
 * Set options as an alternative to passing them
 * to the constructor.
 *
 * ```js
 * md.set({typographer: true});
 * ```
 * @param {Object} `options`
 * @api public
 */ $0b384df86e13f3b1$var$Remarkable.prototype.set = function(options) {
    $0b384df86e13f3b1$require$assign(this.options, options);
};
/**
 * Batch loader for components rules states, and options
 *
 * @param  {Object} `presets`
 */ $0b384df86e13f3b1$var$Remarkable.prototype.configure = function(presets) {
    var self = this;
    if (!presets) throw new Error("Wrong `remarkable` preset, check name/content");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enable(presets.components[name].rules, true);
    });
};
/**
 * Use a plugin.
 *
 * ```js
 * var md = new Remarkable();
 *
 * md.use(plugin1)
 *   .use(plugin2, opts)
 *   .use(plugin3);
 * ```
 *
 * @param  {Function} `plugin`
 * @param  {Object} `options`
 * @return {Object} `Remarkable` for chaining
 */ $0b384df86e13f3b1$var$Remarkable.prototype.use = function(plugin, options) {
    plugin(this, options);
    return this;
};
/**
 * Parse the input `string` and return a tokens array.
 * Modifies `env` with definitions data.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */ $0b384df86e13f3b1$var$Remarkable.prototype.parse = function(str, env) {
    var state = new $0b384df86e13f3b1$var$StateCore(this, str, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * The main `.render()` method that does all the magic :)
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {String} Rendered HTML.
 */ $0b384df86e13f3b1$var$Remarkable.prototype.render = function(str, env) {
    env = env || {};
    return this.renderer.render(this.parse(str, env), this.options, env);
};
/**
 * Parse the given content `string` as a single string.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */ $0b384df86e13f3b1$var$Remarkable.prototype.parseInline = function(str, env) {
    var state = new $0b384df86e13f3b1$var$StateCore(this, str, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * Render a single content `string`, without wrapping it
 * to paragraphs
 *
 * @param  {String} `str`
 * @param  {Object} `env`
 * @return {String}
 */ $0b384df86e13f3b1$var$Remarkable.prototype.renderInline = function(str, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(str, env), this.options, env);
};
/**
 * Expose `Remarkable`
 */ module.exports = $0b384df86e13f3b1$var$Remarkable;

/**
 * Expose `utils`, Useful helper functions for custom
 * rendering.
 */ module.exports.utils = (parcelRequire("9SgFk"));

});
parcelRequire.register("9SgFk", function(module, exports) {

$parcel$export(module.exports, "assign", function () { return $730615a340c42a30$export$e6e34fd1f2686227; }, function (v) { return $730615a340c42a30$export$e6e34fd1f2686227 = v; });
$parcel$export(module.exports, "isString", function () { return $730615a340c42a30$export$844ec244b1367d54; }, function (v) { return $730615a340c42a30$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "has", function () { return $730615a340c42a30$export$a4f4bb6b1453fff5; }, function (v) { return $730615a340c42a30$export$a4f4bb6b1453fff5 = v; });
$parcel$export(module.exports, "unescapeMd", function () { return $730615a340c42a30$export$5ccde1ea0c14bb03; }, function (v) { return $730615a340c42a30$export$5ccde1ea0c14bb03 = v; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $730615a340c42a30$export$644a8f5b13b2a36d; }, function (v) { return $730615a340c42a30$export$644a8f5b13b2a36d = v; });
$parcel$export(module.exports, "fromCodePoint", function () { return $730615a340c42a30$export$73bfc63873071f74; }, function (v) { return $730615a340c42a30$export$73bfc63873071f74 = v; });
$parcel$export(module.exports, "replaceEntities", function () { return $730615a340c42a30$export$92752f49babf4588; }, function (v) { return $730615a340c42a30$export$92752f49babf4588 = v; });
$parcel$export(module.exports, "escapeHtml", function () { return $730615a340c42a30$export$4cf11838cdc2a8a8; }, function (v) { return $730615a340c42a30$export$4cf11838cdc2a8a8 = v; });
////////////////////////////////////////////////////////////////////////////////
var $730615a340c42a30$export$e6e34fd1f2686227;
var $730615a340c42a30$export$844ec244b1367d54;
var $730615a340c42a30$export$a4f4bb6b1453fff5;
var $730615a340c42a30$export$5ccde1ea0c14bb03;
var $730615a340c42a30$export$644a8f5b13b2a36d;
var $730615a340c42a30$export$73bfc63873071f74;
var $730615a340c42a30$export$92752f49babf4588;
var $730615a340c42a30$export$4cf11838cdc2a8a8;
"use strict";
/**
 * Utility functions
 */ function $730615a340c42a30$var$typeOf(obj) {
    return Object.prototype.toString.call(obj);
}
function $730615a340c42a30$var$isString(obj) {
    return $730615a340c42a30$var$typeOf(obj) === "[object String]";
}
var $730615a340c42a30$var$hasOwn = Object.prototype.hasOwnProperty;
function $730615a340c42a30$var$has(object, key) {
    return object ? $730615a340c42a30$var$hasOwn.call(object, key) : false;
}
// Extend objects
//
function $730615a340c42a30$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = [].slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
////////////////////////////////////////////////////////////////////////////////
var $730615a340c42a30$var$UNESCAPE_MD_RE = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
function $730615a340c42a30$var$unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($730615a340c42a30$var$UNESCAPE_MD_RE, "$1");
}
////////////////////////////////////////////////////////////////////////////////
function $730615a340c42a30$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $730615a340c42a30$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $730615a340c42a30$var$NAMED_ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $730615a340c42a30$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

var $kYjHw = parcelRequire("kYjHw");
function $730615a340c42a30$var$replaceEntityPattern(match, name) {
    var code = 0;
    if ($730615a340c42a30$var$has($kYjHw, name)) return $kYjHw[name];
    else if (name.charCodeAt(0) === 0x23 /* # */  && $730615a340c42a30$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($730615a340c42a30$var$isValidEntityCode(code)) return $730615a340c42a30$var$fromCodePoint(code);
    }
    return match;
}
function $730615a340c42a30$var$replaceEntities(str) {
    if (str.indexOf("&") < 0) return str;
    return str.replace($730615a340c42a30$var$NAMED_ENTITY_RE, $730615a340c42a30$var$replaceEntityPattern);
}
////////////////////////////////////////////////////////////////////////////////
var $730615a340c42a30$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $730615a340c42a30$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $730615a340c42a30$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $730615a340c42a30$var$replaceUnsafeChar(ch) {
    return $730615a340c42a30$var$HTML_REPLACEMENTS[ch];
}
function $730615a340c42a30$var$escapeHtml(str) {
    if ($730615a340c42a30$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($730615a340c42a30$var$HTML_ESCAPE_REPLACE_RE, $730615a340c42a30$var$replaceUnsafeChar);
    return str;
}
$730615a340c42a30$export$e6e34fd1f2686227 = $730615a340c42a30$var$assign;
$730615a340c42a30$export$844ec244b1367d54 = $730615a340c42a30$var$isString;
$730615a340c42a30$export$a4f4bb6b1453fff5 = $730615a340c42a30$var$has;
$730615a340c42a30$export$5ccde1ea0c14bb03 = $730615a340c42a30$var$unescapeMd;
$730615a340c42a30$export$644a8f5b13b2a36d = $730615a340c42a30$var$isValidEntityCode;
$730615a340c42a30$export$73bfc63873071f74 = $730615a340c42a30$var$fromCodePoint;
$730615a340c42a30$export$92752f49babf4588 = $730615a340c42a30$var$replaceEntities;
$730615a340c42a30$export$4cf11838cdc2a8a8 = $730615a340c42a30$var$escapeHtml;

});
parcelRequire.register("kYjHw", function(module, exports) {
// List of valid entities
//
// Generate with ./support/entities.js script
//
"use strict";
/*eslint quotes:0*/ module.exports = {
    "Aacute": "\xc1",
    "aacute": "\xe1",
    "Abreve": "Ă",
    "abreve": "ă",
    "ac": "∾",
    "acd": "∿",
    "acE": "∾̳",
    "Acirc": "\xc2",
    "acirc": "\xe2",
    "acute": "\xb4",
    "Acy": "А",
    "acy": "а",
    "AElig": "\xc6",
    "aelig": "\xe6",
    "af": "⁡",
    "Afr": "\uD835\uDD04",
    "afr": "\uD835\uDD1E",
    "Agrave": "\xc0",
    "agrave": "\xe0",
    "alefsym": "ℵ",
    "aleph": "ℵ",
    "Alpha": "Α",
    "alpha": "α",
    "Amacr": "Ā",
    "amacr": "ā",
    "amalg": "⨿",
    "AMP": "&",
    "amp": "&",
    "And": "⩓",
    "and": "∧",
    "andand": "⩕",
    "andd": "⩜",
    "andslope": "⩘",
    "andv": "⩚",
    "ang": "∠",
    "ange": "⦤",
    "angle": "∠",
    "angmsd": "∡",
    "angmsdaa": "⦨",
    "angmsdab": "⦩",
    "angmsdac": "⦪",
    "angmsdad": "⦫",
    "angmsdae": "⦬",
    "angmsdaf": "⦭",
    "angmsdag": "⦮",
    "angmsdah": "⦯",
    "angrt": "∟",
    "angrtvb": "⊾",
    "angrtvbd": "⦝",
    "angsph": "∢",
    "angst": "\xc5",
    "angzarr": "⍼",
    "Aogon": "Ą",
    "aogon": "ą",
    "Aopf": "\uD835\uDD38",
    "aopf": "\uD835\uDD52",
    "ap": "≈",
    "apacir": "⩯",
    "apE": "⩰",
    "ape": "≊",
    "apid": "≋",
    "apos": "'",
    "ApplyFunction": "⁡",
    "approx": "≈",
    "approxeq": "≊",
    "Aring": "\xc5",
    "aring": "\xe5",
    "Ascr": "\uD835\uDC9C",
    "ascr": "\uD835\uDCB6",
    "Assign": "≔",
    "ast": "*",
    "asymp": "≈",
    "asympeq": "≍",
    "Atilde": "\xc3",
    "atilde": "\xe3",
    "Auml": "\xc4",
    "auml": "\xe4",
    "awconint": "∳",
    "awint": "⨑",
    "backcong": "≌",
    "backepsilon": "϶",
    "backprime": "‵",
    "backsim": "∽",
    "backsimeq": "⋍",
    "Backslash": "∖",
    "Barv": "⫧",
    "barvee": "⊽",
    "Barwed": "⌆",
    "barwed": "⌅",
    "barwedge": "⌅",
    "bbrk": "⎵",
    "bbrktbrk": "⎶",
    "bcong": "≌",
    "Bcy": "Б",
    "bcy": "б",
    "bdquo": "„",
    "becaus": "∵",
    "Because": "∵",
    "because": "∵",
    "bemptyv": "⦰",
    "bepsi": "϶",
    "bernou": "ℬ",
    "Bernoullis": "ℬ",
    "Beta": "Β",
    "beta": "β",
    "beth": "ℶ",
    "between": "≬",
    "Bfr": "\uD835\uDD05",
    "bfr": "\uD835\uDD1F",
    "bigcap": "⋂",
    "bigcirc": "◯",
    "bigcup": "⋃",
    "bigodot": "⨀",
    "bigoplus": "⨁",
    "bigotimes": "⨂",
    "bigsqcup": "⨆",
    "bigstar": "★",
    "bigtriangledown": "▽",
    "bigtriangleup": "△",
    "biguplus": "⨄",
    "bigvee": "⋁",
    "bigwedge": "⋀",
    "bkarow": "⤍",
    "blacklozenge": "⧫",
    "blacksquare": "▪",
    "blacktriangle": "▴",
    "blacktriangledown": "▾",
    "blacktriangleleft": "◂",
    "blacktriangleright": "▸",
    "blank": "␣",
    "blk12": "▒",
    "blk14": "░",
    "blk34": "▓",
    "block": "█",
    "bne": "=⃥",
    "bnequiv": "≡⃥",
    "bNot": "⫭",
    "bnot": "⌐",
    "Bopf": "\uD835\uDD39",
    "bopf": "\uD835\uDD53",
    "bot": "⊥",
    "bottom": "⊥",
    "bowtie": "⋈",
    "boxbox": "⧉",
    "boxDL": "╗",
    "boxDl": "╖",
    "boxdL": "╕",
    "boxdl": "┐",
    "boxDR": "╔",
    "boxDr": "╓",
    "boxdR": "╒",
    "boxdr": "┌",
    "boxH": "═",
    "boxh": "─",
    "boxHD": "╦",
    "boxHd": "╤",
    "boxhD": "╥",
    "boxhd": "┬",
    "boxHU": "╩",
    "boxHu": "╧",
    "boxhU": "╨",
    "boxhu": "┴",
    "boxminus": "⊟",
    "boxplus": "⊞",
    "boxtimes": "⊠",
    "boxUL": "╝",
    "boxUl": "╜",
    "boxuL": "╛",
    "boxul": "┘",
    "boxUR": "╚",
    "boxUr": "╙",
    "boxuR": "╘",
    "boxur": "└",
    "boxV": "║",
    "boxv": "│",
    "boxVH": "╬",
    "boxVh": "╫",
    "boxvH": "╪",
    "boxvh": "┼",
    "boxVL": "╣",
    "boxVl": "╢",
    "boxvL": "╡",
    "boxvl": "┤",
    "boxVR": "╠",
    "boxVr": "╟",
    "boxvR": "╞",
    "boxvr": "├",
    "bprime": "‵",
    "Breve": "˘",
    "breve": "˘",
    "brvbar": "\xa6",
    "Bscr": "ℬ",
    "bscr": "\uD835\uDCB7",
    "bsemi": "⁏",
    "bsim": "∽",
    "bsime": "⋍",
    "bsol": "\\",
    "bsolb": "⧅",
    "bsolhsub": "⟈",
    "bull": "•",
    "bullet": "•",
    "bump": "≎",
    "bumpE": "⪮",
    "bumpe": "≏",
    "Bumpeq": "≎",
    "bumpeq": "≏",
    "Cacute": "Ć",
    "cacute": "ć",
    "Cap": "⋒",
    "cap": "∩",
    "capand": "⩄",
    "capbrcup": "⩉",
    "capcap": "⩋",
    "capcup": "⩇",
    "capdot": "⩀",
    "CapitalDifferentialD": "ⅅ",
    "caps": "∩︀",
    "caret": "⁁",
    "caron": "ˇ",
    "Cayleys": "ℭ",
    "ccaps": "⩍",
    "Ccaron": "Č",
    "ccaron": "č",
    "Ccedil": "\xc7",
    "ccedil": "\xe7",
    "Ccirc": "Ĉ",
    "ccirc": "ĉ",
    "Cconint": "∰",
    "ccups": "⩌",
    "ccupssm": "⩐",
    "Cdot": "Ċ",
    "cdot": "ċ",
    "cedil": "\xb8",
    "Cedilla": "\xb8",
    "cemptyv": "⦲",
    "cent": "\xa2",
    "CenterDot": "\xb7",
    "centerdot": "\xb7",
    "Cfr": "ℭ",
    "cfr": "\uD835\uDD20",
    "CHcy": "Ч",
    "chcy": "ч",
    "check": "✓",
    "checkmark": "✓",
    "Chi": "Χ",
    "chi": "χ",
    "cir": "○",
    "circ": "ˆ",
    "circeq": "≗",
    "circlearrowleft": "↺",
    "circlearrowright": "↻",
    "circledast": "⊛",
    "circledcirc": "⊚",
    "circleddash": "⊝",
    "CircleDot": "⊙",
    "circledR": "\xae",
    "circledS": "Ⓢ",
    "CircleMinus": "⊖",
    "CirclePlus": "⊕",
    "CircleTimes": "⊗",
    "cirE": "⧃",
    "cire": "≗",
    "cirfnint": "⨐",
    "cirmid": "⫯",
    "cirscir": "⧂",
    "ClockwiseContourIntegral": "∲",
    "CloseCurlyDoubleQuote": "”",
    "CloseCurlyQuote": "’",
    "clubs": "♣",
    "clubsuit": "♣",
    "Colon": "∷",
    "colon": ":",
    "Colone": "⩴",
    "colone": "≔",
    "coloneq": "≔",
    "comma": ",",
    "commat": "@",
    "comp": "∁",
    "compfn": "∘",
    "complement": "∁",
    "complexes": "ℂ",
    "cong": "≅",
    "congdot": "⩭",
    "Congruent": "≡",
    "Conint": "∯",
    "conint": "∮",
    "ContourIntegral": "∮",
    "Copf": "ℂ",
    "copf": "\uD835\uDD54",
    "coprod": "∐",
    "Coproduct": "∐",
    "COPY": "\xa9",
    "copy": "\xa9",
    "copysr": "℗",
    "CounterClockwiseContourIntegral": "∳",
    "crarr": "↵",
    "Cross": "⨯",
    "cross": "✗",
    "Cscr": "\uD835\uDC9E",
    "cscr": "\uD835\uDCB8",
    "csub": "⫏",
    "csube": "⫑",
    "csup": "⫐",
    "csupe": "⫒",
    "ctdot": "⋯",
    "cudarrl": "⤸",
    "cudarrr": "⤵",
    "cuepr": "⋞",
    "cuesc": "⋟",
    "cularr": "↶",
    "cularrp": "⤽",
    "Cup": "⋓",
    "cup": "∪",
    "cupbrcap": "⩈",
    "CupCap": "≍",
    "cupcap": "⩆",
    "cupcup": "⩊",
    "cupdot": "⊍",
    "cupor": "⩅",
    "cups": "∪︀",
    "curarr": "↷",
    "curarrm": "⤼",
    "curlyeqprec": "⋞",
    "curlyeqsucc": "⋟",
    "curlyvee": "⋎",
    "curlywedge": "⋏",
    "curren": "\xa4",
    "curvearrowleft": "↶",
    "curvearrowright": "↷",
    "cuvee": "⋎",
    "cuwed": "⋏",
    "cwconint": "∲",
    "cwint": "∱",
    "cylcty": "⌭",
    "Dagger": "‡",
    "dagger": "†",
    "daleth": "ℸ",
    "Darr": "↡",
    "dArr": "⇓",
    "darr": "↓",
    "dash": "‐",
    "Dashv": "⫤",
    "dashv": "⊣",
    "dbkarow": "⤏",
    "dblac": "˝",
    "Dcaron": "Ď",
    "dcaron": "ď",
    "Dcy": "Д",
    "dcy": "д",
    "DD": "ⅅ",
    "dd": "ⅆ",
    "ddagger": "‡",
    "ddarr": "⇊",
    "DDotrahd": "⤑",
    "ddotseq": "⩷",
    "deg": "\xb0",
    "Del": "∇",
    "Delta": "Δ",
    "delta": "δ",
    "demptyv": "⦱",
    "dfisht": "⥿",
    "Dfr": "\uD835\uDD07",
    "dfr": "\uD835\uDD21",
    "dHar": "⥥",
    "dharl": "⇃",
    "dharr": "⇂",
    "DiacriticalAcute": "\xb4",
    "DiacriticalDot": "˙",
    "DiacriticalDoubleAcute": "˝",
    "DiacriticalGrave": "`",
    "DiacriticalTilde": "˜",
    "diam": "⋄",
    "Diamond": "⋄",
    "diamond": "⋄",
    "diamondsuit": "♦",
    "diams": "♦",
    "die": "\xa8",
    "DifferentialD": "ⅆ",
    "digamma": "ϝ",
    "disin": "⋲",
    "div": "\xf7",
    "divide": "\xf7",
    "divideontimes": "⋇",
    "divonx": "⋇",
    "DJcy": "Ђ",
    "djcy": "ђ",
    "dlcorn": "⌞",
    "dlcrop": "⌍",
    "dollar": "$",
    "Dopf": "\uD835\uDD3B",
    "dopf": "\uD835\uDD55",
    "Dot": "\xa8",
    "dot": "˙",
    "DotDot": "⃜",
    "doteq": "≐",
    "doteqdot": "≑",
    "DotEqual": "≐",
    "dotminus": "∸",
    "dotplus": "∔",
    "dotsquare": "⊡",
    "doublebarwedge": "⌆",
    "DoubleContourIntegral": "∯",
    "DoubleDot": "\xa8",
    "DoubleDownArrow": "⇓",
    "DoubleLeftArrow": "⇐",
    "DoubleLeftRightArrow": "⇔",
    "DoubleLeftTee": "⫤",
    "DoubleLongLeftArrow": "⟸",
    "DoubleLongLeftRightArrow": "⟺",
    "DoubleLongRightArrow": "⟹",
    "DoubleRightArrow": "⇒",
    "DoubleRightTee": "⊨",
    "DoubleUpArrow": "⇑",
    "DoubleUpDownArrow": "⇕",
    "DoubleVerticalBar": "∥",
    "DownArrow": "↓",
    "Downarrow": "⇓",
    "downarrow": "↓",
    "DownArrowBar": "⤓",
    "DownArrowUpArrow": "⇵",
    "DownBreve": "̑",
    "downdownarrows": "⇊",
    "downharpoonleft": "⇃",
    "downharpoonright": "⇂",
    "DownLeftRightVector": "⥐",
    "DownLeftTeeVector": "⥞",
    "DownLeftVector": "↽",
    "DownLeftVectorBar": "⥖",
    "DownRightTeeVector": "⥟",
    "DownRightVector": "⇁",
    "DownRightVectorBar": "⥗",
    "DownTee": "⊤",
    "DownTeeArrow": "↧",
    "drbkarow": "⤐",
    "drcorn": "⌟",
    "drcrop": "⌌",
    "Dscr": "\uD835\uDC9F",
    "dscr": "\uD835\uDCB9",
    "DScy": "Ѕ",
    "dscy": "ѕ",
    "dsol": "⧶",
    "Dstrok": "Đ",
    "dstrok": "đ",
    "dtdot": "⋱",
    "dtri": "▿",
    "dtrif": "▾",
    "duarr": "⇵",
    "duhar": "⥯",
    "dwangle": "⦦",
    "DZcy": "Џ",
    "dzcy": "џ",
    "dzigrarr": "⟿",
    "Eacute": "\xc9",
    "eacute": "\xe9",
    "easter": "⩮",
    "Ecaron": "Ě",
    "ecaron": "ě",
    "ecir": "≖",
    "Ecirc": "\xca",
    "ecirc": "\xea",
    "ecolon": "≕",
    "Ecy": "Э",
    "ecy": "э",
    "eDDot": "⩷",
    "Edot": "Ė",
    "eDot": "≑",
    "edot": "ė",
    "ee": "ⅇ",
    "efDot": "≒",
    "Efr": "\uD835\uDD08",
    "efr": "\uD835\uDD22",
    "eg": "⪚",
    "Egrave": "\xc8",
    "egrave": "\xe8",
    "egs": "⪖",
    "egsdot": "⪘",
    "el": "⪙",
    "Element": "∈",
    "elinters": "⏧",
    "ell": "ℓ",
    "els": "⪕",
    "elsdot": "⪗",
    "Emacr": "Ē",
    "emacr": "ē",
    "empty": "∅",
    "emptyset": "∅",
    "EmptySmallSquare": "◻",
    "emptyv": "∅",
    "EmptyVerySmallSquare": "▫",
    "emsp": " ",
    "emsp13": " ",
    "emsp14": " ",
    "ENG": "Ŋ",
    "eng": "ŋ",
    "ensp": " ",
    "Eogon": "Ę",
    "eogon": "ę",
    "Eopf": "\uD835\uDD3C",
    "eopf": "\uD835\uDD56",
    "epar": "⋕",
    "eparsl": "⧣",
    "eplus": "⩱",
    "epsi": "ε",
    "Epsilon": "Ε",
    "epsilon": "ε",
    "epsiv": "ϵ",
    "eqcirc": "≖",
    "eqcolon": "≕",
    "eqsim": "≂",
    "eqslantgtr": "⪖",
    "eqslantless": "⪕",
    "Equal": "⩵",
    "equals": "=",
    "EqualTilde": "≂",
    "equest": "≟",
    "Equilibrium": "⇌",
    "equiv": "≡",
    "equivDD": "⩸",
    "eqvparsl": "⧥",
    "erarr": "⥱",
    "erDot": "≓",
    "Escr": "ℰ",
    "escr": "ℯ",
    "esdot": "≐",
    "Esim": "⩳",
    "esim": "≂",
    "Eta": "Η",
    "eta": "η",
    "ETH": "\xd0",
    "eth": "\xf0",
    "Euml": "\xcb",
    "euml": "\xeb",
    "euro": "€",
    "excl": "!",
    "exist": "∃",
    "Exists": "∃",
    "expectation": "ℰ",
    "ExponentialE": "ⅇ",
    "exponentiale": "ⅇ",
    "fallingdotseq": "≒",
    "Fcy": "Ф",
    "fcy": "ф",
    "female": "♀",
    "ffilig": "ﬃ",
    "fflig": "ﬀ",
    "ffllig": "ﬄ",
    "Ffr": "\uD835\uDD09",
    "ffr": "\uD835\uDD23",
    "filig": "ﬁ",
    "FilledSmallSquare": "◼",
    "FilledVerySmallSquare": "▪",
    "fjlig": "fj",
    "flat": "♭",
    "fllig": "ﬂ",
    "fltns": "▱",
    "fnof": "ƒ",
    "Fopf": "\uD835\uDD3D",
    "fopf": "\uD835\uDD57",
    "ForAll": "∀",
    "forall": "∀",
    "fork": "⋔",
    "forkv": "⫙",
    "Fouriertrf": "ℱ",
    "fpartint": "⨍",
    "frac12": "\xbd",
    "frac13": "⅓",
    "frac14": "\xbc",
    "frac15": "⅕",
    "frac16": "⅙",
    "frac18": "⅛",
    "frac23": "⅔",
    "frac25": "⅖",
    "frac34": "\xbe",
    "frac35": "⅗",
    "frac38": "⅜",
    "frac45": "⅘",
    "frac56": "⅚",
    "frac58": "⅝",
    "frac78": "⅞",
    "frasl": "⁄",
    "frown": "⌢",
    "Fscr": "ℱ",
    "fscr": "\uD835\uDCBB",
    "gacute": "ǵ",
    "Gamma": "Γ",
    "gamma": "γ",
    "Gammad": "Ϝ",
    "gammad": "ϝ",
    "gap": "⪆",
    "Gbreve": "Ğ",
    "gbreve": "ğ",
    "Gcedil": "Ģ",
    "Gcirc": "Ĝ",
    "gcirc": "ĝ",
    "Gcy": "Г",
    "gcy": "г",
    "Gdot": "Ġ",
    "gdot": "ġ",
    "gE": "≧",
    "ge": "≥",
    "gEl": "⪌",
    "gel": "⋛",
    "geq": "≥",
    "geqq": "≧",
    "geqslant": "⩾",
    "ges": "⩾",
    "gescc": "⪩",
    "gesdot": "⪀",
    "gesdoto": "⪂",
    "gesdotol": "⪄",
    "gesl": "⋛︀",
    "gesles": "⪔",
    "Gfr": "\uD835\uDD0A",
    "gfr": "\uD835\uDD24",
    "Gg": "⋙",
    "gg": "≫",
    "ggg": "⋙",
    "gimel": "ℷ",
    "GJcy": "Ѓ",
    "gjcy": "ѓ",
    "gl": "≷",
    "gla": "⪥",
    "glE": "⪒",
    "glj": "⪤",
    "gnap": "⪊",
    "gnapprox": "⪊",
    "gnE": "≩",
    "gne": "⪈",
    "gneq": "⪈",
    "gneqq": "≩",
    "gnsim": "⋧",
    "Gopf": "\uD835\uDD3E",
    "gopf": "\uD835\uDD58",
    "grave": "`",
    "GreaterEqual": "≥",
    "GreaterEqualLess": "⋛",
    "GreaterFullEqual": "≧",
    "GreaterGreater": "⪢",
    "GreaterLess": "≷",
    "GreaterSlantEqual": "⩾",
    "GreaterTilde": "≳",
    "Gscr": "\uD835\uDCA2",
    "gscr": "ℊ",
    "gsim": "≳",
    "gsime": "⪎",
    "gsiml": "⪐",
    "GT": ">",
    "Gt": "≫",
    "gt": ">",
    "gtcc": "⪧",
    "gtcir": "⩺",
    "gtdot": "⋗",
    "gtlPar": "⦕",
    "gtquest": "⩼",
    "gtrapprox": "⪆",
    "gtrarr": "⥸",
    "gtrdot": "⋗",
    "gtreqless": "⋛",
    "gtreqqless": "⪌",
    "gtrless": "≷",
    "gtrsim": "≳",
    "gvertneqq": "≩︀",
    "gvnE": "≩︀",
    "Hacek": "ˇ",
    "hairsp": " ",
    "half": "\xbd",
    "hamilt": "ℋ",
    "HARDcy": "Ъ",
    "hardcy": "ъ",
    "hArr": "⇔",
    "harr": "↔",
    "harrcir": "⥈",
    "harrw": "↭",
    "Hat": "^",
    "hbar": "ℏ",
    "Hcirc": "Ĥ",
    "hcirc": "ĥ",
    "hearts": "♥",
    "heartsuit": "♥",
    "hellip": "…",
    "hercon": "⊹",
    "Hfr": "ℌ",
    "hfr": "\uD835\uDD25",
    "HilbertSpace": "ℋ",
    "hksearow": "⤥",
    "hkswarow": "⤦",
    "hoarr": "⇿",
    "homtht": "∻",
    "hookleftarrow": "↩",
    "hookrightarrow": "↪",
    "Hopf": "ℍ",
    "hopf": "\uD835\uDD59",
    "horbar": "―",
    "HorizontalLine": "─",
    "Hscr": "ℋ",
    "hscr": "\uD835\uDCBD",
    "hslash": "ℏ",
    "Hstrok": "Ħ",
    "hstrok": "ħ",
    "HumpDownHump": "≎",
    "HumpEqual": "≏",
    "hybull": "⁃",
    "hyphen": "‐",
    "Iacute": "\xcd",
    "iacute": "\xed",
    "ic": "⁣",
    "Icirc": "\xce",
    "icirc": "\xee",
    "Icy": "И",
    "icy": "и",
    "Idot": "İ",
    "IEcy": "Е",
    "iecy": "е",
    "iexcl": "\xa1",
    "iff": "⇔",
    "Ifr": "ℑ",
    "ifr": "\uD835\uDD26",
    "Igrave": "\xcc",
    "igrave": "\xec",
    "ii": "ⅈ",
    "iiiint": "⨌",
    "iiint": "∭",
    "iinfin": "⧜",
    "iiota": "℩",
    "IJlig": "Ĳ",
    "ijlig": "ĳ",
    "Im": "ℑ",
    "Imacr": "Ī",
    "imacr": "ī",
    "image": "ℑ",
    "ImaginaryI": "ⅈ",
    "imagline": "ℐ",
    "imagpart": "ℑ",
    "imath": "ı",
    "imof": "⊷",
    "imped": "Ƶ",
    "Implies": "⇒",
    "in": "∈",
    "incare": "℅",
    "infin": "∞",
    "infintie": "⧝",
    "inodot": "ı",
    "Int": "∬",
    "int": "∫",
    "intcal": "⊺",
    "integers": "ℤ",
    "Integral": "∫",
    "intercal": "⊺",
    "Intersection": "⋂",
    "intlarhk": "⨗",
    "intprod": "⨼",
    "InvisibleComma": "⁣",
    "InvisibleTimes": "⁢",
    "IOcy": "Ё",
    "iocy": "ё",
    "Iogon": "Į",
    "iogon": "į",
    "Iopf": "\uD835\uDD40",
    "iopf": "\uD835\uDD5A",
    "Iota": "Ι",
    "iota": "ι",
    "iprod": "⨼",
    "iquest": "\xbf",
    "Iscr": "ℐ",
    "iscr": "\uD835\uDCBE",
    "isin": "∈",
    "isindot": "⋵",
    "isinE": "⋹",
    "isins": "⋴",
    "isinsv": "⋳",
    "isinv": "∈",
    "it": "⁢",
    "Itilde": "Ĩ",
    "itilde": "ĩ",
    "Iukcy": "І",
    "iukcy": "і",
    "Iuml": "\xcf",
    "iuml": "\xef",
    "Jcirc": "Ĵ",
    "jcirc": "ĵ",
    "Jcy": "Й",
    "jcy": "й",
    "Jfr": "\uD835\uDD0D",
    "jfr": "\uD835\uDD27",
    "jmath": "ȷ",
    "Jopf": "\uD835\uDD41",
    "jopf": "\uD835\uDD5B",
    "Jscr": "\uD835\uDCA5",
    "jscr": "\uD835\uDCBF",
    "Jsercy": "Ј",
    "jsercy": "ј",
    "Jukcy": "Є",
    "jukcy": "є",
    "Kappa": "Κ",
    "kappa": "κ",
    "kappav": "ϰ",
    "Kcedil": "Ķ",
    "kcedil": "ķ",
    "Kcy": "К",
    "kcy": "к",
    "Kfr": "\uD835\uDD0E",
    "kfr": "\uD835\uDD28",
    "kgreen": "ĸ",
    "KHcy": "Х",
    "khcy": "х",
    "KJcy": "Ќ",
    "kjcy": "ќ",
    "Kopf": "\uD835\uDD42",
    "kopf": "\uD835\uDD5C",
    "Kscr": "\uD835\uDCA6",
    "kscr": "\uD835\uDCC0",
    "lAarr": "⇚",
    "Lacute": "Ĺ",
    "lacute": "ĺ",
    "laemptyv": "⦴",
    "lagran": "ℒ",
    "Lambda": "Λ",
    "lambda": "λ",
    "Lang": "⟪",
    "lang": "⟨",
    "langd": "⦑",
    "langle": "⟨",
    "lap": "⪅",
    "Laplacetrf": "ℒ",
    "laquo": "\xab",
    "Larr": "↞",
    "lArr": "⇐",
    "larr": "←",
    "larrb": "⇤",
    "larrbfs": "⤟",
    "larrfs": "⤝",
    "larrhk": "↩",
    "larrlp": "↫",
    "larrpl": "⤹",
    "larrsim": "⥳",
    "larrtl": "↢",
    "lat": "⪫",
    "lAtail": "⤛",
    "latail": "⤙",
    "late": "⪭",
    "lates": "⪭︀",
    "lBarr": "⤎",
    "lbarr": "⤌",
    "lbbrk": "❲",
    "lbrace": "{",
    "lbrack": "[",
    "lbrke": "⦋",
    "lbrksld": "⦏",
    "lbrkslu": "⦍",
    "Lcaron": "Ľ",
    "lcaron": "ľ",
    "Lcedil": "Ļ",
    "lcedil": "ļ",
    "lceil": "⌈",
    "lcub": "{",
    "Lcy": "Л",
    "lcy": "л",
    "ldca": "⤶",
    "ldquo": "“",
    "ldquor": "„",
    "ldrdhar": "⥧",
    "ldrushar": "⥋",
    "ldsh": "↲",
    "lE": "≦",
    "le": "≤",
    "LeftAngleBracket": "⟨",
    "LeftArrow": "←",
    "Leftarrow": "⇐",
    "leftarrow": "←",
    "LeftArrowBar": "⇤",
    "LeftArrowRightArrow": "⇆",
    "leftarrowtail": "↢",
    "LeftCeiling": "⌈",
    "LeftDoubleBracket": "⟦",
    "LeftDownTeeVector": "⥡",
    "LeftDownVector": "⇃",
    "LeftDownVectorBar": "⥙",
    "LeftFloor": "⌊",
    "leftharpoondown": "↽",
    "leftharpoonup": "↼",
    "leftleftarrows": "⇇",
    "LeftRightArrow": "↔",
    "Leftrightarrow": "⇔",
    "leftrightarrow": "↔",
    "leftrightarrows": "⇆",
    "leftrightharpoons": "⇋",
    "leftrightsquigarrow": "↭",
    "LeftRightVector": "⥎",
    "LeftTee": "⊣",
    "LeftTeeArrow": "↤",
    "LeftTeeVector": "⥚",
    "leftthreetimes": "⋋",
    "LeftTriangle": "⊲",
    "LeftTriangleBar": "⧏",
    "LeftTriangleEqual": "⊴",
    "LeftUpDownVector": "⥑",
    "LeftUpTeeVector": "⥠",
    "LeftUpVector": "↿",
    "LeftUpVectorBar": "⥘",
    "LeftVector": "↼",
    "LeftVectorBar": "⥒",
    "lEg": "⪋",
    "leg": "⋚",
    "leq": "≤",
    "leqq": "≦",
    "leqslant": "⩽",
    "les": "⩽",
    "lescc": "⪨",
    "lesdot": "⩿",
    "lesdoto": "⪁",
    "lesdotor": "⪃",
    "lesg": "⋚︀",
    "lesges": "⪓",
    "lessapprox": "⪅",
    "lessdot": "⋖",
    "lesseqgtr": "⋚",
    "lesseqqgtr": "⪋",
    "LessEqualGreater": "⋚",
    "LessFullEqual": "≦",
    "LessGreater": "≶",
    "lessgtr": "≶",
    "LessLess": "⪡",
    "lesssim": "≲",
    "LessSlantEqual": "⩽",
    "LessTilde": "≲",
    "lfisht": "⥼",
    "lfloor": "⌊",
    "Lfr": "\uD835\uDD0F",
    "lfr": "\uD835\uDD29",
    "lg": "≶",
    "lgE": "⪑",
    "lHar": "⥢",
    "lhard": "↽",
    "lharu": "↼",
    "lharul": "⥪",
    "lhblk": "▄",
    "LJcy": "Љ",
    "ljcy": "љ",
    "Ll": "⋘",
    "ll": "≪",
    "llarr": "⇇",
    "llcorner": "⌞",
    "Lleftarrow": "⇚",
    "llhard": "⥫",
    "lltri": "◺",
    "Lmidot": "Ŀ",
    "lmidot": "ŀ",
    "lmoust": "⎰",
    "lmoustache": "⎰",
    "lnap": "⪉",
    "lnapprox": "⪉",
    "lnE": "≨",
    "lne": "⪇",
    "lneq": "⪇",
    "lneqq": "≨",
    "lnsim": "⋦",
    "loang": "⟬",
    "loarr": "⇽",
    "lobrk": "⟦",
    "LongLeftArrow": "⟵",
    "Longleftarrow": "⟸",
    "longleftarrow": "⟵",
    "LongLeftRightArrow": "⟷",
    "Longleftrightarrow": "⟺",
    "longleftrightarrow": "⟷",
    "longmapsto": "⟼",
    "LongRightArrow": "⟶",
    "Longrightarrow": "⟹",
    "longrightarrow": "⟶",
    "looparrowleft": "↫",
    "looparrowright": "↬",
    "lopar": "⦅",
    "Lopf": "\uD835\uDD43",
    "lopf": "\uD835\uDD5D",
    "loplus": "⨭",
    "lotimes": "⨴",
    "lowast": "∗",
    "lowbar": "_",
    "LowerLeftArrow": "↙",
    "LowerRightArrow": "↘",
    "loz": "◊",
    "lozenge": "◊",
    "lozf": "⧫",
    "lpar": "(",
    "lparlt": "⦓",
    "lrarr": "⇆",
    "lrcorner": "⌟",
    "lrhar": "⇋",
    "lrhard": "⥭",
    "lrm": "‎",
    "lrtri": "⊿",
    "lsaquo": "‹",
    "Lscr": "ℒ",
    "lscr": "\uD835\uDCC1",
    "Lsh": "↰",
    "lsh": "↰",
    "lsim": "≲",
    "lsime": "⪍",
    "lsimg": "⪏",
    "lsqb": "[",
    "lsquo": "‘",
    "lsquor": "‚",
    "Lstrok": "Ł",
    "lstrok": "ł",
    "LT": "<",
    "Lt": "≪",
    "lt": "<",
    "ltcc": "⪦",
    "ltcir": "⩹",
    "ltdot": "⋖",
    "lthree": "⋋",
    "ltimes": "⋉",
    "ltlarr": "⥶",
    "ltquest": "⩻",
    "ltri": "◃",
    "ltrie": "⊴",
    "ltrif": "◂",
    "ltrPar": "⦖",
    "lurdshar": "⥊",
    "luruhar": "⥦",
    "lvertneqq": "≨︀",
    "lvnE": "≨︀",
    "macr": "\xaf",
    "male": "♂",
    "malt": "✠",
    "maltese": "✠",
    "Map": "⤅",
    "map": "↦",
    "mapsto": "↦",
    "mapstodown": "↧",
    "mapstoleft": "↤",
    "mapstoup": "↥",
    "marker": "▮",
    "mcomma": "⨩",
    "Mcy": "М",
    "mcy": "м",
    "mdash": "—",
    "mDDot": "∺",
    "measuredangle": "∡",
    "MediumSpace": " ",
    "Mellintrf": "ℳ",
    "Mfr": "\uD835\uDD10",
    "mfr": "\uD835\uDD2A",
    "mho": "℧",
    "micro": "\xb5",
    "mid": "∣",
    "midast": "*",
    "midcir": "⫰",
    "middot": "\xb7",
    "minus": "−",
    "minusb": "⊟",
    "minusd": "∸",
    "minusdu": "⨪",
    "MinusPlus": "∓",
    "mlcp": "⫛",
    "mldr": "…",
    "mnplus": "∓",
    "models": "⊧",
    "Mopf": "\uD835\uDD44",
    "mopf": "\uD835\uDD5E",
    "mp": "∓",
    "Mscr": "ℳ",
    "mscr": "\uD835\uDCC2",
    "mstpos": "∾",
    "Mu": "Μ",
    "mu": "μ",
    "multimap": "⊸",
    "mumap": "⊸",
    "nabla": "∇",
    "Nacute": "Ń",
    "nacute": "ń",
    "nang": "∠⃒",
    "nap": "≉",
    "napE": "⩰̸",
    "napid": "≋̸",
    "napos": "ŉ",
    "napprox": "≉",
    "natur": "♮",
    "natural": "♮",
    "naturals": "ℕ",
    "nbsp": "\xa0",
    "nbump": "≎̸",
    "nbumpe": "≏̸",
    "ncap": "⩃",
    "Ncaron": "Ň",
    "ncaron": "ň",
    "Ncedil": "Ņ",
    "ncedil": "ņ",
    "ncong": "≇",
    "ncongdot": "⩭̸",
    "ncup": "⩂",
    "Ncy": "Н",
    "ncy": "н",
    "ndash": "–",
    "ne": "≠",
    "nearhk": "⤤",
    "neArr": "⇗",
    "nearr": "↗",
    "nearrow": "↗",
    "nedot": "≐̸",
    "NegativeMediumSpace": "​",
    "NegativeThickSpace": "​",
    "NegativeThinSpace": "​",
    "NegativeVeryThinSpace": "​",
    "nequiv": "≢",
    "nesear": "⤨",
    "nesim": "≂̸",
    "NestedGreaterGreater": "≫",
    "NestedLessLess": "≪",
    "NewLine": "\n",
    "nexist": "∄",
    "nexists": "∄",
    "Nfr": "\uD835\uDD11",
    "nfr": "\uD835\uDD2B",
    "ngE": "≧̸",
    "nge": "≱",
    "ngeq": "≱",
    "ngeqq": "≧̸",
    "ngeqslant": "⩾̸",
    "nges": "⩾̸",
    "nGg": "⋙̸",
    "ngsim": "≵",
    "nGt": "≫⃒",
    "ngt": "≯",
    "ngtr": "≯",
    "nGtv": "≫̸",
    "nhArr": "⇎",
    "nharr": "↮",
    "nhpar": "⫲",
    "ni": "∋",
    "nis": "⋼",
    "nisd": "⋺",
    "niv": "∋",
    "NJcy": "Њ",
    "njcy": "њ",
    "nlArr": "⇍",
    "nlarr": "↚",
    "nldr": "‥",
    "nlE": "≦̸",
    "nle": "≰",
    "nLeftarrow": "⇍",
    "nleftarrow": "↚",
    "nLeftrightarrow": "⇎",
    "nleftrightarrow": "↮",
    "nleq": "≰",
    "nleqq": "≦̸",
    "nleqslant": "⩽̸",
    "nles": "⩽̸",
    "nless": "≮",
    "nLl": "⋘̸",
    "nlsim": "≴",
    "nLt": "≪⃒",
    "nlt": "≮",
    "nltri": "⋪",
    "nltrie": "⋬",
    "nLtv": "≪̸",
    "nmid": "∤",
    "NoBreak": "⁠",
    "NonBreakingSpace": "\xa0",
    "Nopf": "ℕ",
    "nopf": "\uD835\uDD5F",
    "Not": "⫬",
    "not": "\xac",
    "NotCongruent": "≢",
    "NotCupCap": "≭",
    "NotDoubleVerticalBar": "∦",
    "NotElement": "∉",
    "NotEqual": "≠",
    "NotEqualTilde": "≂̸",
    "NotExists": "∄",
    "NotGreater": "≯",
    "NotGreaterEqual": "≱",
    "NotGreaterFullEqual": "≧̸",
    "NotGreaterGreater": "≫̸",
    "NotGreaterLess": "≹",
    "NotGreaterSlantEqual": "⩾̸",
    "NotGreaterTilde": "≵",
    "NotHumpDownHump": "≎̸",
    "NotHumpEqual": "≏̸",
    "notin": "∉",
    "notindot": "⋵̸",
    "notinE": "⋹̸",
    "notinva": "∉",
    "notinvb": "⋷",
    "notinvc": "⋶",
    "NotLeftTriangle": "⋪",
    "NotLeftTriangleBar": "⧏̸",
    "NotLeftTriangleEqual": "⋬",
    "NotLess": "≮",
    "NotLessEqual": "≰",
    "NotLessGreater": "≸",
    "NotLessLess": "≪̸",
    "NotLessSlantEqual": "⩽̸",
    "NotLessTilde": "≴",
    "NotNestedGreaterGreater": "⪢̸",
    "NotNestedLessLess": "⪡̸",
    "notni": "∌",
    "notniva": "∌",
    "notnivb": "⋾",
    "notnivc": "⋽",
    "NotPrecedes": "⊀",
    "NotPrecedesEqual": "⪯̸",
    "NotPrecedesSlantEqual": "⋠",
    "NotReverseElement": "∌",
    "NotRightTriangle": "⋫",
    "NotRightTriangleBar": "⧐̸",
    "NotRightTriangleEqual": "⋭",
    "NotSquareSubset": "⊏̸",
    "NotSquareSubsetEqual": "⋢",
    "NotSquareSuperset": "⊐̸",
    "NotSquareSupersetEqual": "⋣",
    "NotSubset": "⊂⃒",
    "NotSubsetEqual": "⊈",
    "NotSucceeds": "⊁",
    "NotSucceedsEqual": "⪰̸",
    "NotSucceedsSlantEqual": "⋡",
    "NotSucceedsTilde": "≿̸",
    "NotSuperset": "⊃⃒",
    "NotSupersetEqual": "⊉",
    "NotTilde": "≁",
    "NotTildeEqual": "≄",
    "NotTildeFullEqual": "≇",
    "NotTildeTilde": "≉",
    "NotVerticalBar": "∤",
    "npar": "∦",
    "nparallel": "∦",
    "nparsl": "⫽⃥",
    "npart": "∂̸",
    "npolint": "⨔",
    "npr": "⊀",
    "nprcue": "⋠",
    "npre": "⪯̸",
    "nprec": "⊀",
    "npreceq": "⪯̸",
    "nrArr": "⇏",
    "nrarr": "↛",
    "nrarrc": "⤳̸",
    "nrarrw": "↝̸",
    "nRightarrow": "⇏",
    "nrightarrow": "↛",
    "nrtri": "⋫",
    "nrtrie": "⋭",
    "nsc": "⊁",
    "nsccue": "⋡",
    "nsce": "⪰̸",
    "Nscr": "\uD835\uDCA9",
    "nscr": "\uD835\uDCC3",
    "nshortmid": "∤",
    "nshortparallel": "∦",
    "nsim": "≁",
    "nsime": "≄",
    "nsimeq": "≄",
    "nsmid": "∤",
    "nspar": "∦",
    "nsqsube": "⋢",
    "nsqsupe": "⋣",
    "nsub": "⊄",
    "nsubE": "⫅̸",
    "nsube": "⊈",
    "nsubset": "⊂⃒",
    "nsubseteq": "⊈",
    "nsubseteqq": "⫅̸",
    "nsucc": "⊁",
    "nsucceq": "⪰̸",
    "nsup": "⊅",
    "nsupE": "⫆̸",
    "nsupe": "⊉",
    "nsupset": "⊃⃒",
    "nsupseteq": "⊉",
    "nsupseteqq": "⫆̸",
    "ntgl": "≹",
    "Ntilde": "\xd1",
    "ntilde": "\xf1",
    "ntlg": "≸",
    "ntriangleleft": "⋪",
    "ntrianglelefteq": "⋬",
    "ntriangleright": "⋫",
    "ntrianglerighteq": "⋭",
    "Nu": "Ν",
    "nu": "ν",
    "num": "#",
    "numero": "№",
    "numsp": " ",
    "nvap": "≍⃒",
    "nVDash": "⊯",
    "nVdash": "⊮",
    "nvDash": "⊭",
    "nvdash": "⊬",
    "nvge": "≥⃒",
    "nvgt": ">⃒",
    "nvHarr": "⤄",
    "nvinfin": "⧞",
    "nvlArr": "⤂",
    "nvle": "≤⃒",
    "nvlt": "<⃒",
    "nvltrie": "⊴⃒",
    "nvrArr": "⤃",
    "nvrtrie": "⊵⃒",
    "nvsim": "∼⃒",
    "nwarhk": "⤣",
    "nwArr": "⇖",
    "nwarr": "↖",
    "nwarrow": "↖",
    "nwnear": "⤧",
    "Oacute": "\xd3",
    "oacute": "\xf3",
    "oast": "⊛",
    "ocir": "⊚",
    "Ocirc": "\xd4",
    "ocirc": "\xf4",
    "Ocy": "О",
    "ocy": "о",
    "odash": "⊝",
    "Odblac": "Ő",
    "odblac": "ő",
    "odiv": "⨸",
    "odot": "⊙",
    "odsold": "⦼",
    "OElig": "Œ",
    "oelig": "œ",
    "ofcir": "⦿",
    "Ofr": "\uD835\uDD12",
    "ofr": "\uD835\uDD2C",
    "ogon": "˛",
    "Ograve": "\xd2",
    "ograve": "\xf2",
    "ogt": "⧁",
    "ohbar": "⦵",
    "ohm": "Ω",
    "oint": "∮",
    "olarr": "↺",
    "olcir": "⦾",
    "olcross": "⦻",
    "oline": "‾",
    "olt": "⧀",
    "Omacr": "Ō",
    "omacr": "ō",
    "Omega": "Ω",
    "omega": "ω",
    "Omicron": "Ο",
    "omicron": "ο",
    "omid": "⦶",
    "ominus": "⊖",
    "Oopf": "\uD835\uDD46",
    "oopf": "\uD835\uDD60",
    "opar": "⦷",
    "OpenCurlyDoubleQuote": "“",
    "OpenCurlyQuote": "‘",
    "operp": "⦹",
    "oplus": "⊕",
    "Or": "⩔",
    "or": "∨",
    "orarr": "↻",
    "ord": "⩝",
    "order": "ℴ",
    "orderof": "ℴ",
    "ordf": "\xaa",
    "ordm": "\xba",
    "origof": "⊶",
    "oror": "⩖",
    "orslope": "⩗",
    "orv": "⩛",
    "oS": "Ⓢ",
    "Oscr": "\uD835\uDCAA",
    "oscr": "ℴ",
    "Oslash": "\xd8",
    "oslash": "\xf8",
    "osol": "⊘",
    "Otilde": "\xd5",
    "otilde": "\xf5",
    "Otimes": "⨷",
    "otimes": "⊗",
    "otimesas": "⨶",
    "Ouml": "\xd6",
    "ouml": "\xf6",
    "ovbar": "⌽",
    "OverBar": "‾",
    "OverBrace": "⏞",
    "OverBracket": "⎴",
    "OverParenthesis": "⏜",
    "par": "∥",
    "para": "\xb6",
    "parallel": "∥",
    "parsim": "⫳",
    "parsl": "⫽",
    "part": "∂",
    "PartialD": "∂",
    "Pcy": "П",
    "pcy": "п",
    "percnt": "%",
    "period": ".",
    "permil": "‰",
    "perp": "⊥",
    "pertenk": "‱",
    "Pfr": "\uD835\uDD13",
    "pfr": "\uD835\uDD2D",
    "Phi": "Φ",
    "phi": "φ",
    "phiv": "ϕ",
    "phmmat": "ℳ",
    "phone": "☎",
    "Pi": "Π",
    "pi": "π",
    "pitchfork": "⋔",
    "piv": "ϖ",
    "planck": "ℏ",
    "planckh": "ℎ",
    "plankv": "ℏ",
    "plus": "+",
    "plusacir": "⨣",
    "plusb": "⊞",
    "pluscir": "⨢",
    "plusdo": "∔",
    "plusdu": "⨥",
    "pluse": "⩲",
    "PlusMinus": "\xb1",
    "plusmn": "\xb1",
    "plussim": "⨦",
    "plustwo": "⨧",
    "pm": "\xb1",
    "Poincareplane": "ℌ",
    "pointint": "⨕",
    "Popf": "ℙ",
    "popf": "\uD835\uDD61",
    "pound": "\xa3",
    "Pr": "⪻",
    "pr": "≺",
    "prap": "⪷",
    "prcue": "≼",
    "prE": "⪳",
    "pre": "⪯",
    "prec": "≺",
    "precapprox": "⪷",
    "preccurlyeq": "≼",
    "Precedes": "≺",
    "PrecedesEqual": "⪯",
    "PrecedesSlantEqual": "≼",
    "PrecedesTilde": "≾",
    "preceq": "⪯",
    "precnapprox": "⪹",
    "precneqq": "⪵",
    "precnsim": "⋨",
    "precsim": "≾",
    "Prime": "″",
    "prime": "′",
    "primes": "ℙ",
    "prnap": "⪹",
    "prnE": "⪵",
    "prnsim": "⋨",
    "prod": "∏",
    "Product": "∏",
    "profalar": "⌮",
    "profline": "⌒",
    "profsurf": "⌓",
    "prop": "∝",
    "Proportion": "∷",
    "Proportional": "∝",
    "propto": "∝",
    "prsim": "≾",
    "prurel": "⊰",
    "Pscr": "\uD835\uDCAB",
    "pscr": "\uD835\uDCC5",
    "Psi": "Ψ",
    "psi": "ψ",
    "puncsp": " ",
    "Qfr": "\uD835\uDD14",
    "qfr": "\uD835\uDD2E",
    "qint": "⨌",
    "Qopf": "ℚ",
    "qopf": "\uD835\uDD62",
    "qprime": "⁗",
    "Qscr": "\uD835\uDCAC",
    "qscr": "\uD835\uDCC6",
    "quaternions": "ℍ",
    "quatint": "⨖",
    "quest": "?",
    "questeq": "≟",
    "QUOT": '"',
    "quot": '"',
    "rAarr": "⇛",
    "race": "∽̱",
    "Racute": "Ŕ",
    "racute": "ŕ",
    "radic": "√",
    "raemptyv": "⦳",
    "Rang": "⟫",
    "rang": "⟩",
    "rangd": "⦒",
    "range": "⦥",
    "rangle": "⟩",
    "raquo": "\xbb",
    "Rarr": "↠",
    "rArr": "⇒",
    "rarr": "→",
    "rarrap": "⥵",
    "rarrb": "⇥",
    "rarrbfs": "⤠",
    "rarrc": "⤳",
    "rarrfs": "⤞",
    "rarrhk": "↪",
    "rarrlp": "↬",
    "rarrpl": "⥅",
    "rarrsim": "⥴",
    "Rarrtl": "⤖",
    "rarrtl": "↣",
    "rarrw": "↝",
    "rAtail": "⤜",
    "ratail": "⤚",
    "ratio": "∶",
    "rationals": "ℚ",
    "RBarr": "⤐",
    "rBarr": "⤏",
    "rbarr": "⤍",
    "rbbrk": "❳",
    "rbrace": "}",
    "rbrack": "]",
    "rbrke": "⦌",
    "rbrksld": "⦎",
    "rbrkslu": "⦐",
    "Rcaron": "Ř",
    "rcaron": "ř",
    "Rcedil": "Ŗ",
    "rcedil": "ŗ",
    "rceil": "⌉",
    "rcub": "}",
    "Rcy": "Р",
    "rcy": "р",
    "rdca": "⤷",
    "rdldhar": "⥩",
    "rdquo": "”",
    "rdquor": "”",
    "rdsh": "↳",
    "Re": "ℜ",
    "real": "ℜ",
    "realine": "ℛ",
    "realpart": "ℜ",
    "reals": "ℝ",
    "rect": "▭",
    "REG": "\xae",
    "reg": "\xae",
    "ReverseElement": "∋",
    "ReverseEquilibrium": "⇋",
    "ReverseUpEquilibrium": "⥯",
    "rfisht": "⥽",
    "rfloor": "⌋",
    "Rfr": "ℜ",
    "rfr": "\uD835\uDD2F",
    "rHar": "⥤",
    "rhard": "⇁",
    "rharu": "⇀",
    "rharul": "⥬",
    "Rho": "Ρ",
    "rho": "ρ",
    "rhov": "ϱ",
    "RightAngleBracket": "⟩",
    "RightArrow": "→",
    "Rightarrow": "⇒",
    "rightarrow": "→",
    "RightArrowBar": "⇥",
    "RightArrowLeftArrow": "⇄",
    "rightarrowtail": "↣",
    "RightCeiling": "⌉",
    "RightDoubleBracket": "⟧",
    "RightDownTeeVector": "⥝",
    "RightDownVector": "⇂",
    "RightDownVectorBar": "⥕",
    "RightFloor": "⌋",
    "rightharpoondown": "⇁",
    "rightharpoonup": "⇀",
    "rightleftarrows": "⇄",
    "rightleftharpoons": "⇌",
    "rightrightarrows": "⇉",
    "rightsquigarrow": "↝",
    "RightTee": "⊢",
    "RightTeeArrow": "↦",
    "RightTeeVector": "⥛",
    "rightthreetimes": "⋌",
    "RightTriangle": "⊳",
    "RightTriangleBar": "⧐",
    "RightTriangleEqual": "⊵",
    "RightUpDownVector": "⥏",
    "RightUpTeeVector": "⥜",
    "RightUpVector": "↾",
    "RightUpVectorBar": "⥔",
    "RightVector": "⇀",
    "RightVectorBar": "⥓",
    "ring": "˚",
    "risingdotseq": "≓",
    "rlarr": "⇄",
    "rlhar": "⇌",
    "rlm": "‏",
    "rmoust": "⎱",
    "rmoustache": "⎱",
    "rnmid": "⫮",
    "roang": "⟭",
    "roarr": "⇾",
    "robrk": "⟧",
    "ropar": "⦆",
    "Ropf": "ℝ",
    "ropf": "\uD835\uDD63",
    "roplus": "⨮",
    "rotimes": "⨵",
    "RoundImplies": "⥰",
    "rpar": ")",
    "rpargt": "⦔",
    "rppolint": "⨒",
    "rrarr": "⇉",
    "Rrightarrow": "⇛",
    "rsaquo": "›",
    "Rscr": "ℛ",
    "rscr": "\uD835\uDCC7",
    "Rsh": "↱",
    "rsh": "↱",
    "rsqb": "]",
    "rsquo": "’",
    "rsquor": "’",
    "rthree": "⋌",
    "rtimes": "⋊",
    "rtri": "▹",
    "rtrie": "⊵",
    "rtrif": "▸",
    "rtriltri": "⧎",
    "RuleDelayed": "⧴",
    "ruluhar": "⥨",
    "rx": "℞",
    "Sacute": "Ś",
    "sacute": "ś",
    "sbquo": "‚",
    "Sc": "⪼",
    "sc": "≻",
    "scap": "⪸",
    "Scaron": "Š",
    "scaron": "š",
    "sccue": "≽",
    "scE": "⪴",
    "sce": "⪰",
    "Scedil": "Ş",
    "scedil": "ş",
    "Scirc": "Ŝ",
    "scirc": "ŝ",
    "scnap": "⪺",
    "scnE": "⪶",
    "scnsim": "⋩",
    "scpolint": "⨓",
    "scsim": "≿",
    "Scy": "С",
    "scy": "с",
    "sdot": "⋅",
    "sdotb": "⊡",
    "sdote": "⩦",
    "searhk": "⤥",
    "seArr": "⇘",
    "searr": "↘",
    "searrow": "↘",
    "sect": "\xa7",
    "semi": ";",
    "seswar": "⤩",
    "setminus": "∖",
    "setmn": "∖",
    "sext": "✶",
    "Sfr": "\uD835\uDD16",
    "sfr": "\uD835\uDD30",
    "sfrown": "⌢",
    "sharp": "♯",
    "SHCHcy": "Щ",
    "shchcy": "щ",
    "SHcy": "Ш",
    "shcy": "ш",
    "ShortDownArrow": "↓",
    "ShortLeftArrow": "←",
    "shortmid": "∣",
    "shortparallel": "∥",
    "ShortRightArrow": "→",
    "ShortUpArrow": "↑",
    "shy": "\xad",
    "Sigma": "Σ",
    "sigma": "σ",
    "sigmaf": "ς",
    "sigmav": "ς",
    "sim": "∼",
    "simdot": "⩪",
    "sime": "≃",
    "simeq": "≃",
    "simg": "⪞",
    "simgE": "⪠",
    "siml": "⪝",
    "simlE": "⪟",
    "simne": "≆",
    "simplus": "⨤",
    "simrarr": "⥲",
    "slarr": "←",
    "SmallCircle": "∘",
    "smallsetminus": "∖",
    "smashp": "⨳",
    "smeparsl": "⧤",
    "smid": "∣",
    "smile": "⌣",
    "smt": "⪪",
    "smte": "⪬",
    "smtes": "⪬︀",
    "SOFTcy": "Ь",
    "softcy": "ь",
    "sol": "/",
    "solb": "⧄",
    "solbar": "⌿",
    "Sopf": "\uD835\uDD4A",
    "sopf": "\uD835\uDD64",
    "spades": "♠",
    "spadesuit": "♠",
    "spar": "∥",
    "sqcap": "⊓",
    "sqcaps": "⊓︀",
    "sqcup": "⊔",
    "sqcups": "⊔︀",
    "Sqrt": "√",
    "sqsub": "⊏",
    "sqsube": "⊑",
    "sqsubset": "⊏",
    "sqsubseteq": "⊑",
    "sqsup": "⊐",
    "sqsupe": "⊒",
    "sqsupset": "⊐",
    "sqsupseteq": "⊒",
    "squ": "□",
    "Square": "□",
    "square": "□",
    "SquareIntersection": "⊓",
    "SquareSubset": "⊏",
    "SquareSubsetEqual": "⊑",
    "SquareSuperset": "⊐",
    "SquareSupersetEqual": "⊒",
    "SquareUnion": "⊔",
    "squarf": "▪",
    "squf": "▪",
    "srarr": "→",
    "Sscr": "\uD835\uDCAE",
    "sscr": "\uD835\uDCC8",
    "ssetmn": "∖",
    "ssmile": "⌣",
    "sstarf": "⋆",
    "Star": "⋆",
    "star": "☆",
    "starf": "★",
    "straightepsilon": "ϵ",
    "straightphi": "ϕ",
    "strns": "\xaf",
    "Sub": "⋐",
    "sub": "⊂",
    "subdot": "⪽",
    "subE": "⫅",
    "sube": "⊆",
    "subedot": "⫃",
    "submult": "⫁",
    "subnE": "⫋",
    "subne": "⊊",
    "subplus": "⪿",
    "subrarr": "⥹",
    "Subset": "⋐",
    "subset": "⊂",
    "subseteq": "⊆",
    "subseteqq": "⫅",
    "SubsetEqual": "⊆",
    "subsetneq": "⊊",
    "subsetneqq": "⫋",
    "subsim": "⫇",
    "subsub": "⫕",
    "subsup": "⫓",
    "succ": "≻",
    "succapprox": "⪸",
    "succcurlyeq": "≽",
    "Succeeds": "≻",
    "SucceedsEqual": "⪰",
    "SucceedsSlantEqual": "≽",
    "SucceedsTilde": "≿",
    "succeq": "⪰",
    "succnapprox": "⪺",
    "succneqq": "⪶",
    "succnsim": "⋩",
    "succsim": "≿",
    "SuchThat": "∋",
    "Sum": "∑",
    "sum": "∑",
    "sung": "♪",
    "Sup": "⋑",
    "sup": "⊃",
    "sup1": "\xb9",
    "sup2": "\xb2",
    "sup3": "\xb3",
    "supdot": "⪾",
    "supdsub": "⫘",
    "supE": "⫆",
    "supe": "⊇",
    "supedot": "⫄",
    "Superset": "⊃",
    "SupersetEqual": "⊇",
    "suphsol": "⟉",
    "suphsub": "⫗",
    "suplarr": "⥻",
    "supmult": "⫂",
    "supnE": "⫌",
    "supne": "⊋",
    "supplus": "⫀",
    "Supset": "⋑",
    "supset": "⊃",
    "supseteq": "⊇",
    "supseteqq": "⫆",
    "supsetneq": "⊋",
    "supsetneqq": "⫌",
    "supsim": "⫈",
    "supsub": "⫔",
    "supsup": "⫖",
    "swarhk": "⤦",
    "swArr": "⇙",
    "swarr": "↙",
    "swarrow": "↙",
    "swnwar": "⤪",
    "szlig": "\xdf",
    "Tab": "	",
    "target": "⌖",
    "Tau": "Τ",
    "tau": "τ",
    "tbrk": "⎴",
    "Tcaron": "Ť",
    "tcaron": "ť",
    "Tcedil": "Ţ",
    "tcedil": "ţ",
    "Tcy": "Т",
    "tcy": "т",
    "tdot": "⃛",
    "telrec": "⌕",
    "Tfr": "\uD835\uDD17",
    "tfr": "\uD835\uDD31",
    "there4": "∴",
    "Therefore": "∴",
    "therefore": "∴",
    "Theta": "Θ",
    "theta": "θ",
    "thetasym": "ϑ",
    "thetav": "ϑ",
    "thickapprox": "≈",
    "thicksim": "∼",
    "ThickSpace": "  ",
    "thinsp": " ",
    "ThinSpace": " ",
    "thkap": "≈",
    "thksim": "∼",
    "THORN": "\xde",
    "thorn": "\xfe",
    "Tilde": "∼",
    "tilde": "˜",
    "TildeEqual": "≃",
    "TildeFullEqual": "≅",
    "TildeTilde": "≈",
    "times": "\xd7",
    "timesb": "⊠",
    "timesbar": "⨱",
    "timesd": "⨰",
    "tint": "∭",
    "toea": "⤨",
    "top": "⊤",
    "topbot": "⌶",
    "topcir": "⫱",
    "Topf": "\uD835\uDD4B",
    "topf": "\uD835\uDD65",
    "topfork": "⫚",
    "tosa": "⤩",
    "tprime": "‴",
    "TRADE": "™",
    "trade": "™",
    "triangle": "▵",
    "triangledown": "▿",
    "triangleleft": "◃",
    "trianglelefteq": "⊴",
    "triangleq": "≜",
    "triangleright": "▹",
    "trianglerighteq": "⊵",
    "tridot": "◬",
    "trie": "≜",
    "triminus": "⨺",
    "TripleDot": "⃛",
    "triplus": "⨹",
    "trisb": "⧍",
    "tritime": "⨻",
    "trpezium": "⏢",
    "Tscr": "\uD835\uDCAF",
    "tscr": "\uD835\uDCC9",
    "TScy": "Ц",
    "tscy": "ц",
    "TSHcy": "Ћ",
    "tshcy": "ћ",
    "Tstrok": "Ŧ",
    "tstrok": "ŧ",
    "twixt": "≬",
    "twoheadleftarrow": "↞",
    "twoheadrightarrow": "↠",
    "Uacute": "\xda",
    "uacute": "\xfa",
    "Uarr": "↟",
    "uArr": "⇑",
    "uarr": "↑",
    "Uarrocir": "⥉",
    "Ubrcy": "Ў",
    "ubrcy": "ў",
    "Ubreve": "Ŭ",
    "ubreve": "ŭ",
    "Ucirc": "\xdb",
    "ucirc": "\xfb",
    "Ucy": "У",
    "ucy": "у",
    "udarr": "⇅",
    "Udblac": "Ű",
    "udblac": "ű",
    "udhar": "⥮",
    "ufisht": "⥾",
    "Ufr": "\uD835\uDD18",
    "ufr": "\uD835\uDD32",
    "Ugrave": "\xd9",
    "ugrave": "\xf9",
    "uHar": "⥣",
    "uharl": "↿",
    "uharr": "↾",
    "uhblk": "▀",
    "ulcorn": "⌜",
    "ulcorner": "⌜",
    "ulcrop": "⌏",
    "ultri": "◸",
    "Umacr": "Ū",
    "umacr": "ū",
    "uml": "\xa8",
    "UnderBar": "_",
    "UnderBrace": "⏟",
    "UnderBracket": "⎵",
    "UnderParenthesis": "⏝",
    "Union": "⋃",
    "UnionPlus": "⊎",
    "Uogon": "Ų",
    "uogon": "ų",
    "Uopf": "\uD835\uDD4C",
    "uopf": "\uD835\uDD66",
    "UpArrow": "↑",
    "Uparrow": "⇑",
    "uparrow": "↑",
    "UpArrowBar": "⤒",
    "UpArrowDownArrow": "⇅",
    "UpDownArrow": "↕",
    "Updownarrow": "⇕",
    "updownarrow": "↕",
    "UpEquilibrium": "⥮",
    "upharpoonleft": "↿",
    "upharpoonright": "↾",
    "uplus": "⊎",
    "UpperLeftArrow": "↖",
    "UpperRightArrow": "↗",
    "Upsi": "ϒ",
    "upsi": "υ",
    "upsih": "ϒ",
    "Upsilon": "Υ",
    "upsilon": "υ",
    "UpTee": "⊥",
    "UpTeeArrow": "↥",
    "upuparrows": "⇈",
    "urcorn": "⌝",
    "urcorner": "⌝",
    "urcrop": "⌎",
    "Uring": "Ů",
    "uring": "ů",
    "urtri": "◹",
    "Uscr": "\uD835\uDCB0",
    "uscr": "\uD835\uDCCA",
    "utdot": "⋰",
    "Utilde": "Ũ",
    "utilde": "ũ",
    "utri": "▵",
    "utrif": "▴",
    "uuarr": "⇈",
    "Uuml": "\xdc",
    "uuml": "\xfc",
    "uwangle": "⦧",
    "vangrt": "⦜",
    "varepsilon": "ϵ",
    "varkappa": "ϰ",
    "varnothing": "∅",
    "varphi": "ϕ",
    "varpi": "ϖ",
    "varpropto": "∝",
    "vArr": "⇕",
    "varr": "↕",
    "varrho": "ϱ",
    "varsigma": "ς",
    "varsubsetneq": "⊊︀",
    "varsubsetneqq": "⫋︀",
    "varsupsetneq": "⊋︀",
    "varsupsetneqq": "⫌︀",
    "vartheta": "ϑ",
    "vartriangleleft": "⊲",
    "vartriangleright": "⊳",
    "Vbar": "⫫",
    "vBar": "⫨",
    "vBarv": "⫩",
    "Vcy": "В",
    "vcy": "в",
    "VDash": "⊫",
    "Vdash": "⊩",
    "vDash": "⊨",
    "vdash": "⊢",
    "Vdashl": "⫦",
    "Vee": "⋁",
    "vee": "∨",
    "veebar": "⊻",
    "veeeq": "≚",
    "vellip": "⋮",
    "Verbar": "‖",
    "verbar": "|",
    "Vert": "‖",
    "vert": "|",
    "VerticalBar": "∣",
    "VerticalLine": "|",
    "VerticalSeparator": "❘",
    "VerticalTilde": "≀",
    "VeryThinSpace": " ",
    "Vfr": "\uD835\uDD19",
    "vfr": "\uD835\uDD33",
    "vltri": "⊲",
    "vnsub": "⊂⃒",
    "vnsup": "⊃⃒",
    "Vopf": "\uD835\uDD4D",
    "vopf": "\uD835\uDD67",
    "vprop": "∝",
    "vrtri": "⊳",
    "Vscr": "\uD835\uDCB1",
    "vscr": "\uD835\uDCCB",
    "vsubnE": "⫋︀",
    "vsubne": "⊊︀",
    "vsupnE": "⫌︀",
    "vsupne": "⊋︀",
    "Vvdash": "⊪",
    "vzigzag": "⦚",
    "Wcirc": "Ŵ",
    "wcirc": "ŵ",
    "wedbar": "⩟",
    "Wedge": "⋀",
    "wedge": "∧",
    "wedgeq": "≙",
    "weierp": "℘",
    "Wfr": "\uD835\uDD1A",
    "wfr": "\uD835\uDD34",
    "Wopf": "\uD835\uDD4E",
    "wopf": "\uD835\uDD68",
    "wp": "℘",
    "wr": "≀",
    "wreath": "≀",
    "Wscr": "\uD835\uDCB2",
    "wscr": "\uD835\uDCCC",
    "xcap": "⋂",
    "xcirc": "◯",
    "xcup": "⋃",
    "xdtri": "▽",
    "Xfr": "\uD835\uDD1B",
    "xfr": "\uD835\uDD35",
    "xhArr": "⟺",
    "xharr": "⟷",
    "Xi": "Ξ",
    "xi": "ξ",
    "xlArr": "⟸",
    "xlarr": "⟵",
    "xmap": "⟼",
    "xnis": "⋻",
    "xodot": "⨀",
    "Xopf": "\uD835\uDD4F",
    "xopf": "\uD835\uDD69",
    "xoplus": "⨁",
    "xotime": "⨂",
    "xrArr": "⟹",
    "xrarr": "⟶",
    "Xscr": "\uD835\uDCB3",
    "xscr": "\uD835\uDCCD",
    "xsqcup": "⨆",
    "xuplus": "⨄",
    "xutri": "△",
    "xvee": "⋁",
    "xwedge": "⋀",
    "Yacute": "\xdd",
    "yacute": "\xfd",
    "YAcy": "Я",
    "yacy": "я",
    "Ycirc": "Ŷ",
    "ycirc": "ŷ",
    "Ycy": "Ы",
    "ycy": "ы",
    "yen": "\xa5",
    "Yfr": "\uD835\uDD1C",
    "yfr": "\uD835\uDD36",
    "YIcy": "Ї",
    "yicy": "ї",
    "Yopf": "\uD835\uDD50",
    "yopf": "\uD835\uDD6A",
    "Yscr": "\uD835\uDCB4",
    "yscr": "\uD835\uDCCE",
    "YUcy": "Ю",
    "yucy": "ю",
    "Yuml": "Ÿ",
    "yuml": "\xff",
    "Zacute": "Ź",
    "zacute": "ź",
    "Zcaron": "Ž",
    "zcaron": "ž",
    "Zcy": "З",
    "zcy": "з",
    "Zdot": "Ż",
    "zdot": "ż",
    "zeetrf": "ℨ",
    "ZeroWidthSpace": "​",
    "Zeta": "Ζ",
    "zeta": "ζ",
    "Zfr": "ℨ",
    "zfr": "\uD835\uDD37",
    "ZHcy": "Ж",
    "zhcy": "ж",
    "zigrarr": "⇝",
    "Zopf": "ℤ",
    "zopf": "\uD835\uDD6B",
    "Zscr": "\uD835\uDCB5",
    "zscr": "\uD835\uDCCF",
    "zwj": "‍",
    "zwnj": "‌"
};

});


parcelRequire.register("e1Xnm", function(module, exports) {
"use strict";

var $9SgFk = parcelRequire("9SgFk");

var $9Puzk = parcelRequire("9Puzk");
/**
 * Expose `Renderer`
 */ module.exports = $a36f37773c49ec33$var$Renderer;
/**
 * Renderer class. Renders HTML and exposes `rules` to allow
 * local modifications.
 */ function $a36f37773c49ec33$var$Renderer() {
    this.rules = $9SgFk.assign({}, $9Puzk);
    // exported helper, for custom rules only
    this.getBreak = $9Puzk.getBreak;
}
/**
 * Render a string of inline HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */ $a36f37773c49ec33$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var _rules = this.rules;
    var len = tokens.length, i = 0;
    var result = "";
    while(len--)result += _rules[tokens[i].type](tokens, i++, options, env, this);
    return result;
};
/**
 * Render a string of HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */ $a36f37773c49ec33$var$Renderer.prototype.render = function(tokens, options, env) {
    var _rules = this.rules;
    var len = tokens.length, i = -1;
    var result = "";
    while(++i < len)if (tokens[i].type === "inline") result += this.renderInline(tokens[i].children, options, env);
    else result += _rules[tokens[i].type](tokens, i, options, env, this);
    return result;
};

});
parcelRequire.register("9Puzk", function(module, exports) {
"use strict";

var $9SgFk = parcelRequire("9SgFk");
var $728096d0671bef59$require$has = $9SgFk.has;

var $9SgFk = parcelRequire("9SgFk");
var $728096d0671bef59$require$unescapeMd = $9SgFk.unescapeMd;

var $9SgFk = parcelRequire("9SgFk");
var $728096d0671bef59$require$replaceEntities = $9SgFk.replaceEntities;

var $9SgFk = parcelRequire("9SgFk");
var $728096d0671bef59$require$escapeHtml = $9SgFk.escapeHtml;
/**
 * Renderer rules cache
 */ var $728096d0671bef59$var$rules = {};
/**
 * Blockquotes
 */ $728096d0671bef59$var$rules.blockquote_open = function() {
    return "<blockquote>\n";
};
$728096d0671bef59$var$rules.blockquote_close = function(tokens, idx /*, options, env */ ) {
    return "</blockquote>" + $728096d0671bef59$var$getBreak(tokens, idx);
};
/**
 * Code
 */ $728096d0671bef59$var$rules.code = function(tokens, idx /*, options, env */ ) {
    if (tokens[idx].block) return "<pre><code>" + $728096d0671bef59$require$escapeHtml(tokens[idx].content) + "</code></pre>" + $728096d0671bef59$var$getBreak(tokens, idx);
    return "<code>" + $728096d0671bef59$require$escapeHtml(tokens[idx].content) + "</code>";
};
/**
 * Fenced code blocks
 */ $728096d0671bef59$var$rules.fence = function(tokens, idx, options, env, instance) {
    var token = tokens[idx];
    var langClass = "";
    var langPrefix = options.langPrefix;
    var langName = "", fences, fenceName;
    var highlighted;
    if (token.params) {
        //
        // ```foo bar
        //
        // Try custom renderer "foo" first. That will simplify overwrite
        // for diagrams, latex, and any other fenced block with custom look
        //
        fences = token.params.split(/\s+/g);
        fenceName = fences.join(" ");
        if ($728096d0671bef59$require$has(instance.rules.fence_custom, fences[0])) return instance.rules.fence_custom[fences[0]](tokens, idx, options, env, instance);
        langName = $728096d0671bef59$require$escapeHtml($728096d0671bef59$require$replaceEntities($728096d0671bef59$require$unescapeMd(fenceName)));
        langClass = ' class="' + langPrefix + langName + '"';
    }
    if (options.highlight) highlighted = options.highlight.apply(options.highlight, [
        token.content
    ].concat(fences)) || $728096d0671bef59$require$escapeHtml(token.content);
    else highlighted = $728096d0671bef59$require$escapeHtml(token.content);
    return "<pre><code" + langClass + ">" + highlighted + "</code></pre>" + $728096d0671bef59$var$getBreak(tokens, idx);
};
$728096d0671bef59$var$rules.fence_custom = {};
/**
 * Headings
 */ $728096d0671bef59$var$rules.heading_open = function(tokens, idx /*, options, env */ ) {
    return "<h" + tokens[idx].hLevel + ">";
};
$728096d0671bef59$var$rules.heading_close = function(tokens, idx /*, options, env */ ) {
    return "</h" + tokens[idx].hLevel + ">\n";
};
/**
 * Horizontal rules
 */ $728096d0671bef59$var$rules.hr = function(tokens, idx, options /*, env */ ) {
    return (options.xhtmlOut ? "<hr />" : "<hr>") + $728096d0671bef59$var$getBreak(tokens, idx);
};
/**
 * Bullets
 */ $728096d0671bef59$var$rules.bullet_list_open = function() {
    return "<ul>\n";
};
$728096d0671bef59$var$rules.bullet_list_close = function(tokens, idx /*, options, env */ ) {
    return "</ul>" + $728096d0671bef59$var$getBreak(tokens, idx);
};
/**
 * List items
 */ $728096d0671bef59$var$rules.list_item_open = function() {
    return "<li>";
};
$728096d0671bef59$var$rules.list_item_close = function() {
    return "</li>\n";
};
/**
 * Ordered list items
 */ $728096d0671bef59$var$rules.ordered_list_open = function(tokens, idx /*, options, env */ ) {
    var token = tokens[idx];
    var order = token.order > 1 ? ' start="' + token.order + '"' : "";
    return "<ol" + order + ">\n";
};
$728096d0671bef59$var$rules.ordered_list_close = function(tokens, idx /*, options, env */ ) {
    return "</ol>" + $728096d0671bef59$var$getBreak(tokens, idx);
};
/**
 * Paragraphs
 */ $728096d0671bef59$var$rules.paragraph_open = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].tight ? "" : "<p>";
};
$728096d0671bef59$var$rules.paragraph_close = function(tokens, idx /*, options, env */ ) {
    var addBreak = !(tokens[idx].tight && idx && tokens[idx - 1].type === "inline" && !tokens[idx - 1].content);
    return (tokens[idx].tight ? "" : "</p>") + (addBreak ? $728096d0671bef59$var$getBreak(tokens, idx) : "");
};
/**
 * Links
 */ $728096d0671bef59$var$rules.link_open = function(tokens, idx, options /* env */ ) {
    var title = tokens[idx].title ? ' title="' + $728096d0671bef59$require$escapeHtml($728096d0671bef59$require$replaceEntities(tokens[idx].title)) + '"' : "";
    var target = options.linkTarget ? ' target="' + options.linkTarget + '"' : "";
    return '<a href="' + $728096d0671bef59$require$escapeHtml(tokens[idx].href) + '"' + title + target + ">";
};
$728096d0671bef59$var$rules.link_close = function() {
    return "</a>";
};
/**
 * Images
 */ $728096d0671bef59$var$rules.image = function(tokens, idx, options /*, env */ ) {
    var src = ' src="' + $728096d0671bef59$require$escapeHtml(tokens[idx].src) + '"';
    var title = tokens[idx].title ? ' title="' + $728096d0671bef59$require$escapeHtml($728096d0671bef59$require$replaceEntities(tokens[idx].title)) + '"' : "";
    var alt = ' alt="' + (tokens[idx].alt ? $728096d0671bef59$require$escapeHtml($728096d0671bef59$require$replaceEntities($728096d0671bef59$require$unescapeMd(tokens[idx].alt))) : "") + '"';
    var suffix = options.xhtmlOut ? " /" : "";
    return "<img" + src + alt + title + suffix + ">";
};
/**
 * Tables
 */ $728096d0671bef59$var$rules.table_open = function() {
    return "<table>\n";
};
$728096d0671bef59$var$rules.table_close = function() {
    return "</table>\n";
};
$728096d0671bef59$var$rules.thead_open = function() {
    return "<thead>\n";
};
$728096d0671bef59$var$rules.thead_close = function() {
    return "</thead>\n";
};
$728096d0671bef59$var$rules.tbody_open = function() {
    return "<tbody>\n";
};
$728096d0671bef59$var$rules.tbody_close = function() {
    return "</tbody>\n";
};
$728096d0671bef59$var$rules.tr_open = function() {
    return "<tr>";
};
$728096d0671bef59$var$rules.tr_close = function() {
    return "</tr>\n";
};
$728096d0671bef59$var$rules.th_open = function(tokens, idx /*, options, env */ ) {
    var token = tokens[idx];
    return "<th" + (token.align ? ' style="text-align:' + token.align + '"' : "") + ">";
};
$728096d0671bef59$var$rules.th_close = function() {
    return "</th>";
};
$728096d0671bef59$var$rules.td_open = function(tokens, idx /*, options, env */ ) {
    var token = tokens[idx];
    return "<td" + (token.align ? ' style="text-align:' + token.align + '"' : "") + ">";
};
$728096d0671bef59$var$rules.td_close = function() {
    return "</td>";
};
/**
 * Bold
 */ $728096d0671bef59$var$rules.strong_open = function() {
    return "<strong>";
};
$728096d0671bef59$var$rules.strong_close = function() {
    return "</strong>";
};
/**
 * Italicize
 */ $728096d0671bef59$var$rules.em_open = function() {
    return "<em>";
};
$728096d0671bef59$var$rules.em_close = function() {
    return "</em>";
};
/**
 * Strikethrough
 */ $728096d0671bef59$var$rules.del_open = function() {
    return "<del>";
};
$728096d0671bef59$var$rules.del_close = function() {
    return "</del>";
};
/**
 * Insert
 */ $728096d0671bef59$var$rules.ins_open = function() {
    return "<ins>";
};
$728096d0671bef59$var$rules.ins_close = function() {
    return "</ins>";
};
/**
 * Highlight
 */ $728096d0671bef59$var$rules.mark_open = function() {
    return "<mark>";
};
$728096d0671bef59$var$rules.mark_close = function() {
    return "</mark>";
};
/**
 * Super- and sub-script
 */ $728096d0671bef59$var$rules.sub = function(tokens, idx /*, options, env */ ) {
    return "<sub>" + $728096d0671bef59$require$escapeHtml(tokens[idx].content) + "</sub>";
};
$728096d0671bef59$var$rules.sup = function(tokens, idx /*, options, env */ ) {
    return "<sup>" + $728096d0671bef59$require$escapeHtml(tokens[idx].content) + "</sup>";
};
/**
 * Breaks
 */ $728096d0671bef59$var$rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$728096d0671bef59$var$rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
/**
 * Text
 */ $728096d0671bef59$var$rules.text = function(tokens, idx /*, options, env */ ) {
    return $728096d0671bef59$require$escapeHtml(tokens[idx].content);
};
/**
 * Content
 */ $728096d0671bef59$var$rules.htmlblock = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$728096d0671bef59$var$rules.htmltag = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * Abbreviations, initialism
 */ $728096d0671bef59$var$rules.abbr_open = function(tokens, idx /*, options, env */ ) {
    return '<abbr title="' + $728096d0671bef59$require$escapeHtml($728096d0671bef59$require$replaceEntities(tokens[idx].title)) + '">';
};
$728096d0671bef59$var$rules.abbr_close = function() {
    return "</abbr>";
};
/**
 * Footnotes
 */ $728096d0671bef59$var$rules.footnote_ref = function(tokens, idx) {
    var n = Number(tokens[idx].id + 1).toString();
    var id = "fnref" + n;
    if (tokens[idx].subId > 0) id += ":" + tokens[idx].subId;
    return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">[' + n + "]</a></sup>";
};
$728096d0671bef59$var$rules.footnote_block_open = function(tokens, idx, options) {
    var hr = options.xhtmlOut ? '<hr class="footnotes-sep" />\n' : '<hr class="footnotes-sep">\n';
    return hr + '<section class="footnotes">\n<ol class="footnotes-list">\n';
};
$728096d0671bef59$var$rules.footnote_block_close = function() {
    return "</ol>\n</section>\n";
};
$728096d0671bef59$var$rules.footnote_open = function(tokens, idx) {
    var id = Number(tokens[idx].id + 1).toString();
    return '<li id="fn' + id + '"  class="footnote-item">';
};
$728096d0671bef59$var$rules.footnote_close = function() {
    return "</li>\n";
};
$728096d0671bef59$var$rules.footnote_anchor = function(tokens, idx) {
    var n = Number(tokens[idx].id + 1).toString();
    var id = "fnref" + n;
    if (tokens[idx].subId > 0) id += ":" + tokens[idx].subId;
    return ' <a href="#' + id + '" class="footnote-backref">↩</a>';
};
/**
 * Definition lists
 */ $728096d0671bef59$var$rules.dl_open = function() {
    return "<dl>\n";
};
$728096d0671bef59$var$rules.dt_open = function() {
    return "<dt>";
};
$728096d0671bef59$var$rules.dd_open = function() {
    return "<dd>";
};
$728096d0671bef59$var$rules.dl_close = function() {
    return "</dl>\n";
};
$728096d0671bef59$var$rules.dt_close = function() {
    return "</dt>\n";
};
$728096d0671bef59$var$rules.dd_close = function() {
    return "</dd>\n";
};
/**
 * Helper functions
 */ function $728096d0671bef59$var$nextToken(tokens, idx) {
    if (++idx >= tokens.length - 2) return idx;
    if (tokens[idx].type === "paragraph_open" && tokens[idx].tight && tokens[idx + 1].type === "inline" && tokens[idx + 1].content.length === 0 && tokens[idx + 2].type === "paragraph_close" && tokens[idx + 2].tight) return $728096d0671bef59$var$nextToken(tokens, idx + 2);
    return idx;
}
/**
 * Check to see if `\n` is needed before the next token.
 *
 * @param  {Array} `tokens`
 * @param  {Number} `idx`
 * @return {String} Empty string or newline
 * @api private
 */ var $728096d0671bef59$var$getBreak = $728096d0671bef59$var$rules.getBreak = function getBreak(tokens, idx) {
    idx = $728096d0671bef59$var$nextToken(tokens, idx);
    if (idx < tokens.length && tokens[idx].type === "list_item_close") return "";
    return "\n";
};
/**
 * Expose `rules`
 */ module.exports = $728096d0671bef59$var$rules;

});


parcelRequire.register("2KUcj", function(module, exports) {
"use strict";

var $1hCjm = parcelRequire("1hCjm");









/**
 * Core parser `rules`
 */ var $201b785387e28240$var$_rules = [
    [
        "block",
        (parcelRequire("ccgGg"))
    ],
    [
        "abbr",
        (parcelRequire("8xoO4"))
    ],
    [
        "references",
        (parcelRequire("YFgPK"))
    ],
    [
        "inline",
        (parcelRequire("bnxh8"))
    ],
    [
        "footnote_tail",
        (parcelRequire("fpKXV"))
    ],
    [
        "abbr2",
        (parcelRequire("oBeK7"))
    ],
    [
        "replacements",
        (parcelRequire("bGgW8"))
    ],
    [
        "smartquotes",
        (parcelRequire("Fy0Mh"))
    ],
    [
        "linkify",
        (parcelRequire("hi7lb"))
    ]
];
/**
 * Class for top level (`core`) parser rules
 *
 * @api private
 */ function $201b785387e28240$var$Core() {
    this.options = {};
    this.ruler = new $1hCjm();
    for(var i = 0; i < $201b785387e28240$var$_rules.length; i++)this.ruler.push($201b785387e28240$var$_rules[i][0], $201b785387e28240$var$_rules[i][1]);
}
/**
 * Process rules with the given `state`
 *
 * @param  {Object} `state`
 * @api private
 */ $201b785387e28240$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules("");
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};
/**
 * Expose `Core`
 */ module.exports = $201b785387e28240$var$Core;

});
parcelRequire.register("1hCjm", function(module, exports) {
"use strict";
/**
 * Ruler is a helper class for building responsibility chains from
 * parse rules. It allows:
 *
 *   - easy stack rules chains
 *   - getting main chain and named chains content (as arrays of functions)
 *
 * Helper methods, should not be used directly.
 * @api private
 */ function $0ef518d184171b9c$var$Ruler() {
    // List of added rules. Each element is:
    //
    // { name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ] }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - digital anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
/**
 * Find the index of a rule by `name`.
 *
 * @param  {String} `name`
 * @return {Number} Index of the given `name`
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.__find__ = function(name) {
    var len = this.__rules__.length;
    var i = -1;
    while(len--){
        if (this.__rules__[++i].name === name) return i;
    }
    return -1;
};
/**
 * Build the rules lookup cache
 *
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler public methods
 * ------------------------------------------------
 */ /**
 * Replace rule function
 *
 * @param  {String} `name` Rule name
 * @param  {Function `fn`
 * @param  {Object} `options`
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.at = function(name, fn, options) {
    var idx = this.__find__(name);
    var opt = options || {};
    if (idx === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[idx].fn = fn;
    this.__rules__[idx].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Add a rule to the chain before given the `ruleName`.
 *
 * @param  {String}   `beforeName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var idx = this.__find__(beforeName);
    var opt = options || {};
    if (idx === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(idx, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Add a rule to the chain after the given `ruleName`.
 *
 * @param  {String}   `afterName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var idx = this.__find__(afterName);
    var opt = options || {};
    if (idx === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(idx + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Add a rule to the end of chain.
 *
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @return {String}
 */ $0ef518d184171b9c$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Enable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to enable
 * @param  {Boolean} `strict` If `true`, all non listed rules will be disabled.
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.enable = function(list, strict) {
    list = !Array.isArray(list) ? [
        list
    ] : list;
    // In strict mode disable all existing rules first
    if (strict) this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) throw new Error("Rules manager: invalid rule name " + name);
        this.__rules__[idx].enabled = true;
    }, this);
    this.__cache__ = null;
};
/**
 * Disable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to disable
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.disable = function(list) {
    list = !Array.isArray(list) ? [
        list
    ] : list;
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) throw new Error("Rules manager: invalid rule name " + name);
        this.__rules__[idx].enabled = false;
    }, this);
    this.__cache__ = null;
};
/**
 * Get a rules list as an array of functions.
 *
 * @param  {String} `chainName`
 * @return {Object}
 * @api private
 */ $0ef518d184171b9c$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    return this.__cache__[chainName] || [];
};
/**
 * Expose `Ruler`
 */ module.exports = $0ef518d184171b9c$var$Ruler;

});

parcelRequire.register("ccgGg", function(module, exports) {
"use strict";
module.exports = function block(state) {
    if (state.inlineMode) state.tokens.push({
        type: "inline",
        content: state.src.replace(/\n/g, " ").trim(),
        level: 0,
        lines: [
            0,
            1
        ],
        children: []
    });
    else state.block.parse(state.src, state.options, state.env, state.tokens);
};

});

parcelRequire.register("8xoO4", function(module, exports) {
// Parse abbreviation definitions, i.e. `*[abbr]: description`
//
"use strict";

var $9kd81 = parcelRequire("9kd81");

var $gAxxv = parcelRequire("gAxxv");
function $6374a5d8cc961338$var$parseAbbr(str, parserInline, options, env) {
    var state, labelEnd, pos, max, label, title;
    if (str.charCodeAt(0) !== 0x2A /* * */ ) return -1;
    if (str.charCodeAt(1) !== 0x5B /* [ */ ) return -1;
    if (str.indexOf("]:") === -1) return -1;
    state = new $9kd81(str, parserInline, options, env, []);
    labelEnd = $gAxxv(state, 1);
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return -1;
    max = state.posMax;
    // abbr title is always one line, so looking for ending "\n" here
    for(pos = labelEnd + 2; pos < max; pos++){
        if (state.src.charCodeAt(pos) === 0x0A) break;
    }
    label = str.slice(2, labelEnd);
    title = str.slice(labelEnd + 2, pos).trim();
    if (title.length === 0) return -1;
    if (!env.abbreviations) env.abbreviations = {};
    // prepend ':' to avoid conflict with Object.prototype members
    if (typeof env.abbreviations[":" + label] === "undefined") env.abbreviations[":" + label] = title;
    return pos;
}
module.exports = function abbr(state) {
    var tokens = state.tokens, i, l, content, pos;
    if (state.inlineMode) return;
    // Parse inlines
    for(i = 1, l = tokens.length - 1; i < l; i++)if (tokens[i - 1].type === "paragraph_open" && tokens[i].type === "inline" && tokens[i + 1].type === "paragraph_close") {
        content = tokens[i].content;
        while(content.length){
            pos = $6374a5d8cc961338$var$parseAbbr(content, state.inline, state.options, state.env);
            if (pos < 0) break;
            content = content.slice(pos).trim();
        }
        tokens[i].content = content;
        if (!content.length) {
            tokens[i - 1].tight = true;
            tokens[i + 1].tight = true;
        }
    }
};

});
parcelRequire.register("9kd81", function(module, exports) {
// Inline parser state
"use strict";
function $6ca02a538222c2f5$var$StateInline(src, parserInline, options, env, outTokens) {
    this.src = src;
    this.env = env;
    this.options = options;
    this.parser = parserInline;
    this.tokens = outTokens;
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    this.cache = []; // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    // Link parser state vars
    this.isInLabel = false; // Set true when seek link label - we should disable
    // "paired" rules (emphasis, strikes) to not skip
    // tailing `]`
    this.linkLevel = 0; // Increment for each nesting link. Used to prevent
    // nesting in definitions
    this.linkContent = ""; // Temporary storage for link url
    this.labelUnmatchedScopes = 0; // Track unpaired `[` for link labels
// (backtrack optimization)
}
// Flush pending text
//
$6ca02a538222c2f5$var$StateInline.prototype.pushPending = function() {
    this.tokens.push({
        type: "text",
        content: this.pending,
        level: this.pendingLevel
    });
    this.pending = "";
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$6ca02a538222c2f5$var$StateInline.prototype.push = function(token) {
    if (this.pending) this.pushPending();
    this.tokens.push(token);
    this.pendingLevel = this.level;
};
// Store value to cache.
// !!! Implementation has parser-specific optimizations
// !!! keys MUST be integer, >= 0; values MUST be integer, > 0
//
$6ca02a538222c2f5$var$StateInline.prototype.cacheSet = function(key, val) {
    for(var i = this.cache.length; i <= key; i++)this.cache.push(0);
    this.cache[key] = val;
};
// Get cache value
//
$6ca02a538222c2f5$var$StateInline.prototype.cacheGet = function(key) {
    return key < this.cache.length ? this.cache[key] : 0;
};
module.exports = $6ca02a538222c2f5$var$StateInline;

});

parcelRequire.register("gAxxv", function(module, exports) {
"use strict";
/**
 * Parse link labels
 *
 * This function assumes that first character (`[`) already matches;
 * returns the end of the label.
 *
 * @param  {Object} state
 * @param  {Number} start
 * @api private
 */ module.exports = function parseLinkLabel(state, start) {
    var level, found, marker, labelEnd = -1, max = state.posMax, oldPos = state.pos, oldFlag = state.isInLabel;
    if (state.isInLabel) return -1;
    if (state.labelUnmatchedScopes) {
        state.labelUnmatchedScopes--;
        return -1;
    }
    state.pos = start + 1;
    state.isInLabel = true;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5B /* [ */ ) level++;
        else if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        state.parser.skipToken(state);
    }
    if (found) {
        labelEnd = state.pos;
        state.labelUnmatchedScopes = 0;
    } else state.labelUnmatchedScopes = level - 1;
    // restore old state
    state.pos = oldPos;
    state.isInLabel = oldFlag;
    return labelEnd;
};

});


parcelRequire.register("YFgPK", function(module, exports) {
"use strict";

var $9kd81 = parcelRequire("9kd81");

var $gAxxv = parcelRequire("gAxxv");

var $eiTsM = parcelRequire("eiTsM");

var $jDCYX = parcelRequire("jDCYX");

var $gEsqy = parcelRequire("gEsqy");
function $0b659e2ccfc6b0f4$var$parseReference(str, parser, options, env) {
    var state, labelEnd, pos, max, code, start, href, title, label;
    if (str.charCodeAt(0) !== 0x5B /* [ */ ) return -1;
    if (str.indexOf("]:") === -1) return -1;
    state = new $9kd81(str, parser, options, env, []);
    labelEnd = $gAxxv(state, 0);
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return -1;
    max = state.posMax;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    if (!$eiTsM(state, pos)) return -1;
    href = state.linkContent;
    pos = state.pos;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(pos = pos + 1; pos < max; pos++){
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    if (pos < max && start !== pos && $jDCYX(state, pos)) {
        title = state.linkContent;
        pos = state.pos;
    } else {
        title = "";
        pos = start;
    }
    // ensure that the end of the line is empty
    while(pos < max && state.src.charCodeAt(pos) === 0x20 /* space */ )pos++;
    if (pos < max && state.src.charCodeAt(pos) !== 0x0A) return -1;
    label = $gEsqy(str.slice(1, labelEnd));
    if (typeof env.references[label] === "undefined") env.references[label] = {
        title: title,
        href: href
    };
    return pos;
}
module.exports = function references(state) {
    var tokens = state.tokens, i, l, content, pos;
    state.env.references = state.env.references || {};
    if (state.inlineMode) return;
    // Scan definitions in paragraph inlines
    for(i = 1, l = tokens.length - 1; i < l; i++)if (tokens[i].type === "inline" && tokens[i - 1].type === "paragraph_open" && tokens[i + 1].type === "paragraph_close") {
        content = tokens[i].content;
        while(content.length){
            pos = $0b659e2ccfc6b0f4$var$parseReference(content, state.inline, state.options, state.env);
            if (pos < 0) break;
            content = content.slice(pos).trim();
        }
        tokens[i].content = content;
        if (!content.length) {
            tokens[i - 1].tight = true;
            tokens[i + 1].tight = true;
        }
    }
};

});
parcelRequire.register("eiTsM", function(module, exports) {
"use strict";

var $cV03X = parcelRequire("cV03X");

var $9SgFk = parcelRequire("9SgFk");
var $a69dc4f66eb4ea22$require$unescapeMd = $9SgFk.unescapeMd;
/**
 * Parse link destination
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */ module.exports = function parseLinkDestination(state, pos) {
    var code, level, link, start = pos, max = state.posMax;
    if (state.src.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = state.src.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return false;
            if (code === 0x3E /* > */ ) {
                link = $cV03X($a69dc4f66eb4ea22$require$unescapeMd(state.src.slice(start + 1, pos)));
                if (!state.parser.validateLink(link)) return false;
                state.pos = pos + 1;
                state.linkContent = link;
                return true;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return false;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = state.src.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control chars
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 1) break;
        }
        if (code === 0x29 /* ) */ ) {
            level--;
            if (level < 0) break;
        }
        pos++;
    }
    if (start === pos) return false;
    link = $a69dc4f66eb4ea22$require$unescapeMd(state.src.slice(start, pos));
    if (!state.parser.validateLink(link)) return false;
    state.linkContent = link;
    state.pos = pos;
    return true;
};

});
parcelRequire.register("cV03X", function(module, exports) {
"use strict";

var $9SgFk = parcelRequire("9SgFk");
var $967adb61349dab43$require$replaceEntities = $9SgFk.replaceEntities;
module.exports = function normalizeLink(url) {
    var normalized = $967adb61349dab43$require$replaceEntities(url);
    // We shouldn't care about the result of malformed URIs,
    // and should not throw an exception.
    try {
        normalized = decodeURI(normalized);
    } catch (err) {}
    return encodeURI(normalized);
};

});


parcelRequire.register("jDCYX", function(module, exports) {
"use strict";

var $9SgFk = parcelRequire("9SgFk");
var $e4bfe5e0fb3fd968$require$unescapeMd = $9SgFk.unescapeMd;
/**
 * Parse link title
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */ module.exports = function parseLinkTitle(state, pos) {
    var code, start = pos, max = state.posMax, marker = state.src.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return false;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = state.src.charCodeAt(pos);
        if (code === marker) {
            state.pos = pos + 1;
            state.linkContent = $e4bfe5e0fb3fd968$require$unescapeMd(state.src.slice(start + 1, pos));
            return true;
        }
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos += 2;
            continue;
        }
        pos++;
    }
    return false;
};

});

parcelRequire.register("gEsqy", function(module, exports) {
"use strict";
module.exports = function normalizeReference(str) {
    // use .toUpperCase() instead of .toLowerCase()
    // here to avoid a conflict with Object.prototype
    // members (most notably, `__proto__`)
    return str.trim().replace(/\s+/g, " ").toUpperCase();
};

});


parcelRequire.register("bnxh8", function(module, exports) {
"use strict";
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === "inline") state.inline.parse(tok.content, state.options, state.env, tok.children);
    }
};

});

parcelRequire.register("fpKXV", function(module, exports) {
"use strict";
module.exports = function footnote_block(state) {
    var i, l, j, t, lastParagraph, list, tokens, current, currentLabel, level = 0, insideRef = false, refTokens = {};
    if (!state.env.footnotes) return;
    state.tokens = state.tokens.filter(function(tok) {
        if (tok.type === "footnote_reference_open") {
            insideRef = true;
            current = [];
            currentLabel = tok.label;
            return false;
        }
        if (tok.type === "footnote_reference_close") {
            insideRef = false;
            // prepend ':' to avoid conflict with Object.prototype members
            refTokens[":" + currentLabel] = current;
            return false;
        }
        if (insideRef) current.push(tok);
        return !insideRef;
    });
    if (!state.env.footnotes.list) return;
    list = state.env.footnotes.list;
    state.tokens.push({
        type: "footnote_block_open",
        level: level++
    });
    for(i = 0, l = list.length; i < l; i++){
        state.tokens.push({
            type: "footnote_open",
            id: i,
            level: level++
        });
        if (list[i].tokens) {
            tokens = [];
            tokens.push({
                type: "paragraph_open",
                tight: false,
                level: level++
            });
            tokens.push({
                type: "inline",
                content: "",
                level: level,
                children: list[i].tokens
            });
            tokens.push({
                type: "paragraph_close",
                tight: false,
                level: --level
            });
        } else if (list[i].label) tokens = refTokens[":" + list[i].label];
        state.tokens = state.tokens.concat(tokens);
        if (state.tokens[state.tokens.length - 1].type === "paragraph_close") lastParagraph = state.tokens.pop();
        else lastParagraph = null;
        t = list[i].count > 0 ? list[i].count : 1;
        for(j = 0; j < t; j++)state.tokens.push({
            type: "footnote_anchor",
            id: i,
            subId: j,
            level: level
        });
        if (lastParagraph) state.tokens.push(lastParagraph);
        state.tokens.push({
            type: "footnote_close",
            level: --level
        });
    }
    state.tokens.push({
        type: "footnote_block_close",
        level: --level
    });
};

});

parcelRequire.register("oBeK7", function(module, exports) {
// Enclose abbreviations in <abbr> tags
//
"use strict";
var $049f2074b0d42b36$var$PUNCT_CHARS = " \n()[]'\".,!?-";
// from Google closure library
// http://closure-library.googlecode.com/git-history/docs/local_closure_goog_string_string.js.source.html#line1021
function $049f2074b0d42b36$var$regEscape(s) {
    return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1");
}
module.exports = function abbr2(state) {
    var i, j, l, tokens, token, text, nodes, pos, level, reg, m, regText, blockTokens = state.tokens;
    if (!state.env.abbreviations) return;
    if (!state.env.abbrRegExp) {
        regText = "(^|[" + $049f2074b0d42b36$var$PUNCT_CHARS.split("").map($049f2074b0d42b36$var$regEscape).join("") + "])" + "(" + Object.keys(state.env.abbreviations).map(function(x) {
            return x.substr(1);
        }).sort(function(a, b) {
            return b.length - a.length;
        }).map($049f2074b0d42b36$var$regEscape).join("|") + ")" + "($|[" + $049f2074b0d42b36$var$PUNCT_CHARS.split("").map($049f2074b0d42b36$var$regEscape).join("") + "])";
        state.env.abbrRegExp = new RegExp(regText, "g");
    }
    reg = state.env.abbrRegExp;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        tokens = blockTokens[j].children;
        // We scan from the end, to keep position when new tags added.
        for(i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token.type !== "text") continue;
            pos = 0;
            text = token.content;
            reg.lastIndex = 0;
            level = token.level;
            nodes = [];
            while(m = reg.exec(text)){
                if (reg.lastIndex > pos) nodes.push({
                    type: "text",
                    content: text.slice(pos, m.index + m[1].length),
                    level: level
                });
                nodes.push({
                    type: "abbr_open",
                    title: state.env.abbreviations[":" + m[2]],
                    level: level++
                });
                nodes.push({
                    type: "text",
                    content: m[2],
                    level: level
                });
                nodes.push({
                    type: "abbr_close",
                    level: --level
                });
                pos = reg.lastIndex - m[3].length;
            }
            if (!nodes.length) continue;
            if (pos < text.length) nodes.push({
                type: "text",
                content: text.slice(pos),
                level: level
            });
            // replace current node
            blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
        }
    }
};

});

parcelRequire.register("bGgW8", function(module, exports) {
// Simple typographical replacements
//
"use strict";
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4
var $8810c13f2fe4881e$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
var $8810c13f2fe4881e$var$SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var $8810c13f2fe4881e$var$SCOPED_ABBR = {
    "c": "\xa9",
    "r": "\xae",
    "p": "\xa7",
    "tm": "™"
};
function $8810c13f2fe4881e$var$replaceScopedAbbr(str) {
    if (str.indexOf("(") < 0) return str;
    return str.replace($8810c13f2fe4881e$var$SCOPED_ABBR_RE, function(match, name) {
        return $8810c13f2fe4881e$var$SCOPED_ABBR[name.toLowerCase()];
    });
}
module.exports = function replace(state) {
    var i, token, text, inlineTokens, blkIdx;
    if (!state.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        inlineTokens = state.tokens[blkIdx].children;
        for(i = inlineTokens.length - 1; i >= 0; i--){
            token = inlineTokens[i];
            if (token.type === "text") {
                text = token.content;
                text = $8810c13f2fe4881e$var$replaceScopedAbbr(text);
                if ($8810c13f2fe4881e$var$RARE_RE.test(text)) text = text.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
                // but ?..... & !..... -> ?.. & !..
                .replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
                .replace(/(^|[^-])---([^-]|$)/mg, "$1—$2")// en-dash
                .replace(/(^|\s)--(\s|$)/mg, "$1–$2").replace(/(^|[^-\s])--([^-\s]|$)/mg, "$1–$2");
                token.content = text;
            }
        }
    }
};

});

parcelRequire.register("Fy0Mh", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
"use strict";
var $07ce366f3a402906$var$QUOTE_TEST_RE = /['"]/;
var $07ce366f3a402906$var$QUOTE_RE = /['"]/g;
var $07ce366f3a402906$var$PUNCT_RE = /[-\s()\[\]]/;
var $07ce366f3a402906$var$APOSTROPHE = "’";
// This function returns true if the character at `pos`
// could be inside a word.
function $07ce366f3a402906$var$isLetter(str, pos) {
    if (pos < 0 || pos >= str.length) return false;
    return !$07ce366f3a402906$var$PUNCT_RE.test(str[pos]);
}
function $07ce366f3a402906$var$replaceAt(str, index, ch) {
    return str.substr(0, index) + ch + str.substr(index + 1);
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var i, token, text, t, pos, max, thisLevel, lastSpace, nextSpace, item, canOpen, canClose, j, isSingle, blkIdx, tokens, stack;
    if (!state.options.typographer) return;
    stack = [];
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        tokens = state.tokens[blkIdx].children;
        stack.length = 0;
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            if (token.type !== "text" || $07ce366f3a402906$var$QUOTE_TEST_RE.test(token.text)) continue;
            thisLevel = tokens[i].level;
            for(j = stack.length - 1; j >= 0; j--){
                if (stack[j].level <= thisLevel) break;
            }
            stack.length = j + 1;
            text = token.content;
            pos = 0;
            max = text.length;
            /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
                $07ce366f3a402906$var$QUOTE_RE.lastIndex = pos;
                t = $07ce366f3a402906$var$QUOTE_RE.exec(text);
                if (!t) break;
                lastSpace = !$07ce366f3a402906$var$isLetter(text, t.index - 1);
                pos = t.index + 1;
                isSingle = t[0] === "'";
                nextSpace = !$07ce366f3a402906$var$isLetter(text, pos);
                if (!nextSpace && !lastSpace) {
                    // middle of word
                    if (isSingle) token.content = $07ce366f3a402906$var$replaceAt(token.content, t.index, $07ce366f3a402906$var$APOSTROPHE);
                    continue;
                }
                canOpen = !nextSpace;
                canClose = !lastSpace;
                if (canClose) // this could be a closing quote, rewind the stack to get a match
                for(j = stack.length - 1; j >= 0; j--){
                    item = stack[j];
                    if (stack[j].level < thisLevel) break;
                    if (item.single === isSingle && stack[j].level === thisLevel) {
                        item = stack[j];
                        if (isSingle) {
                            tokens[item.token].content = $07ce366f3a402906$var$replaceAt(tokens[item.token].content, item.pos, state.options.quotes[2]);
                            token.content = $07ce366f3a402906$var$replaceAt(token.content, t.index, state.options.quotes[3]);
                        } else {
                            tokens[item.token].content = $07ce366f3a402906$var$replaceAt(tokens[item.token].content, item.pos, state.options.quotes[0]);
                            token.content = $07ce366f3a402906$var$replaceAt(token.content, t.index, state.options.quotes[1]);
                        }
                        stack.length = j;
                        continue OUTER;
                    }
                }
                if (canOpen) stack.push({
                    token: i,
                    pos: t.index,
                    single: isSingle,
                    level: thisLevel
                });
                else if (canClose && isSingle) token.content = $07ce366f3a402906$var$replaceAt(token.content, t.index, $07ce366f3a402906$var$APOSTROPHE);
            }
        }
    }
};

});

parcelRequire.register("hi7lb", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `inline.validateLink()` to http/https/ftp
//
"use strict";

var $bB6Uz = parcelRequire("bB6Uz");
var $c969cfca8ebeadc7$var$LINK_SCAN_RE = /www|@|\:\/\//;
function $c969cfca8ebeadc7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c969cfca8ebeadc7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
// Stupid fabric to avoid singletons, for thread safety.
// Required for engines like Nashorn.
//
function $c969cfca8ebeadc7$var$createLinkifier() {
    var links = [];
    var autolinker = new $bB6Uz({
        stripPrefix: false,
        url: true,
        email: true,
        twitter: false,
        replaceFn: function(linker, match) {
            // Only collect matched strings but don't change anything.
            switch(match.getType()){
                /*eslint default-case:0*/ case "url":
                    links.push({
                        text: match.matchedText,
                        url: match.getUrl()
                    });
                    break;
                case "email":
                    links.push({
                        text: match.matchedText,
                        // normalize email protocol
                        url: "mailto:" + match.getEmail().replace(/^mailto:/i, "")
                    });
                    break;
            }
            return false;
        }
    });
    return {
        links: links,
        autolinker: autolinker
    };
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, text, nodes, ln, pos, level, htmlLinkLevel, blockTokens = state.tokens, linkifier = null, links, autolinker;
    if (!state.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            // Skip content of markdown links
            if (token.type === "link_close") {
                i--;
                while(tokens[i].level !== token.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (token.type === "htmltag") {
                if ($c969cfca8ebeadc7$var$isLinkOpen(token.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($c969cfca8ebeadc7$var$isLinkClose(token.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (token.type === "text" && $c969cfca8ebeadc7$var$LINK_SCAN_RE.test(token.content)) {
                // Init linkifier in lazy manner, only if required.
                if (!linkifier) {
                    linkifier = $c969cfca8ebeadc7$var$createLinkifier();
                    links = linkifier.links;
                    autolinker = linkifier.autolinker;
                }
                text = token.content;
                links.length = 0;
                autolinker.link(text);
                if (!links.length) continue;
                // Now split string to nodes
                nodes = [];
                level = token.level;
                for(ln = 0; ln < links.length; ln++){
                    if (!state.inline.validateLink(links[ln].url)) continue;
                    pos = text.indexOf(links[ln].text);
                    if (pos) {
                        level;
                        nodes.push({
                            type: "text",
                            content: text.slice(0, pos),
                            level: level
                        });
                    }
                    nodes.push({
                        type: "link_open",
                        href: links[ln].url,
                        title: "",
                        level: level++
                    });
                    nodes.push({
                        type: "text",
                        content: links[ln].text,
                        level: level
                    });
                    nodes.push({
                        type: "link_close",
                        level: --level
                    });
                    text = text.slice(pos + links[ln].text.length);
                }
                if (text.length) nodes.push({
                    type: "text",
                    content: text,
                    level: level
                });
                // replace current node
                blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
            }
        }
    }
};

});
parcelRequire.register("bB6Uz", function(module, exports) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else module.exports = factory();
})(module.exports, function() {
    /**
 * @class Autolinker
 * @extends Object
 *
 * Utility class used to process a given string of text, and wrap the matches in
 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
 *
 * Any of the configuration options may be provided in an Object (map) provided
 * to the Autolinker constructor, which will configure how the {@link #link link()}
 * method will process the links.
 *
 * For example:
 *
 *     var autolinker = new Autolinker( {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *
 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * The {@link #static-link static link()} method may also be used to inline
 * options into a single call, which may be more convenient for one-off uses.
 * For example:
 *
 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
 *         newWindow : false,
 *         truncate  : 30
 *     } );
 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
 *
 *
 * ## Custom Replacements of Links
 *
 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
 * may be provided to fully customize the output of Autolinker. This function is
 * called once for each URL/Email/Phone#/Twitter Handle/Hashtag match that is
 * encountered.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Twitter Handles, and Hashtags
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( autolinker, match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
 *                         var tag = autolinker.getTagBuilder().build( match );  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
 *                         tag.setAttr( 'rel', 'nofollow' );
 *                         tag.addClass( 'external-link' );
 *
 *                         return tag;
 *
 *                     } else {
 *                         return true;  // let Autolinker perform its normal anchor tag replacement
 *                     }
 *
 *                 case 'email' :
 *                     var email = match.getEmail();
 *                     console.log( "email: ", email );
 *
 *                     if( email === "my@own.address" ) {
 *                         return false;  // don't auto-link this particular email address; leave as-is
 *                     } else {
 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
 *                     }
 *
 *                 case 'phone' :
 *                     var phoneNumber = match.getPhoneNumber();
 *                     console.log( phoneNumber );
 *
 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
 *
 *                 case 'twitter' :
 *                     var twitterHandle = match.getTwitterHandle();
 *                     console.log( twitterHandle );
 *
 *                     return '<a href="http://newplace.to.link.twitter.handles.to/">' + twitterHandle + '</a>';
 *
 *                 case 'hashtag' :
 *                     var hashtag = match.getHashtag();
 *                     console.log( hashtag );
 *
 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
 *             }
 *         }
 *     } );
 *
 *
 * The function may return the following values:
 *
 * - `true` (Boolean): Allow Autolinker to replace the match as it normally
 *   would.
 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
 * - Any String: If a string is returned from the function, the string will be
 *   used directly as the replacement HTML for the match.
 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
 *   an HTML tag before writing out its HTML text.
 *
 * @constructor
 * @param {Object} [cfg] The configuration options for the Autolinker instance,
 *   specified in an Object (map).
 */ var Autolinker = function(cfg) {
        cfg = cfg || {};
        this.version = Autolinker.version;
        this.urls = this.normalizeUrlsCfg(cfg.urls);
        this.email = typeof cfg.email === "boolean" ? cfg.email : true;
        this.twitter = typeof cfg.twitter === "boolean" ? cfg.twitter : true;
        this.phone = typeof cfg.phone === "boolean" ? cfg.phone : true;
        this.hashtag = cfg.hashtag || false;
        this.newWindow = typeof cfg.newWindow === "boolean" ? cfg.newWindow : true;
        this.stripPrefix = typeof cfg.stripPrefix === "boolean" ? cfg.stripPrefix : true;
        // Validate the value of the `hashtag` cfg.
        var hashtag = this.hashtag;
        if (hashtag !== false && hashtag !== "twitter" && hashtag !== "facebook" && hashtag !== "instagram") throw new Error("invalid `hashtag` cfg - see docs");
        this.truncate = this.normalizeTruncateCfg(cfg.truncate);
        this.className = cfg.className || "";
        this.replaceFn = cfg.replaceFn || null;
        this.htmlParser = null;
        this.matchers = null;
        this.tagBuilder = null;
    };
    /**
 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
 * and Hashtags found in the given chunk of HTML. Does not link URLs found
 * within HTML tags.
 *
 * For instance, if given the text: `You should go to http://www.yahoo.com`,
 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
 *
 * Example:
 *
 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
 *
 * @static
 * @param {String} textOrHtml The HTML or text to find matches within (depending
 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter},
 *   and {@link #hashtag} options are enabled).
 * @param {Object} [options] Any of the configuration options for the Autolinker
 *   class, specified in an Object (map). See the class description for an
 *   example call.
 * @return {String} The HTML text, with matches automatically linked.
 */ Autolinker.link = function(textOrHtml, options) {
        var autolinker = new Autolinker(options);
        return autolinker.link(textOrHtml);
    };
    /**
 * @static
 * @property {String} version (readonly)
 *
 * The Autolinker version number in the form major.minor.patch
 *
 * Ex: 0.25.1
 */ Autolinker.version = "0.28.1";
    Autolinker.prototype = {
        constructor: Autolinker,
        /**
	 * @cfg {Boolean/Object} [urls=true]
	 *
	 * `true` if URLs should be automatically linked, `false` if they should not
	 * be.
	 *
	 * This option also accepts an Object form with 3 properties, to allow for
	 * more customization of what exactly gets linked. All default to `true`:
	 *
	 * @param {Boolean} schemeMatches `true` to match URLs found prefixed with a
	 *   scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
	 *   `false` to prevent these types of matches.
	 * @param {Boolean} wwwMatches `true` to match urls found prefixed with
	 *   `'www.'`, i.e. `www.google.com`. `false` to prevent these types of
	 *   matches. Note that if the URL had a prefixed scheme, and
	 *   `schemeMatches` is true, it will still be linked.
	 * @param {Boolean} tldMatches `true` to match URLs with known top level
	 *   domains (.com, .net, etc.) that are not prefixed with a scheme or
	 *   `'www.'`. This option attempts to match anything that looks like a URL
	 *   in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc. `false`
	 *   to prevent these types of matches.
	 */ /**
	 * @cfg {Boolean} [email=true]
	 *
	 * `true` if email addresses should be automatically linked, `false` if they
	 * should not be.
	 */ /**
	 * @cfg {Boolean} [twitter=true]
	 *
	 * `true` if Twitter handles ("@example") should be automatically linked,
	 * `false` if they should not be.
	 */ /**
	 * @cfg {Boolean} [phone=true]
	 *
	 * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
	 * `false` if they should not be.
	 */ /**
	 * @cfg {Boolean/String} [hashtag=false]
	 *
	 * A string for the service name to have hashtags (ex: "#myHashtag")
	 * auto-linked to. The currently-supported values are:
	 *
	 * - 'twitter'
	 * - 'facebook'
	 * - 'instagram'
	 *
	 * Pass `false` to skip auto-linking of hashtags.
	 */ /**
	 * @cfg {Boolean} [newWindow=true]
	 *
	 * `true` if the links should open in a new window, `false` otherwise.
	 */ /**
	 * @cfg {Boolean} [stripPrefix=true]
	 *
	 * `true` if 'http://' or 'https://' and/or the 'www.' should be stripped
	 * from the beginning of URL links' text, `false` otherwise.
	 */ /**
	 * @cfg {Number/Object} [truncate=0]
	 *
	 * ## Number Form
	 *
	 * A number for how many characters matched text should be truncated to
	 * inside the text of a link. If the matched text is over this number of
	 * characters, it will be truncated to this length by adding a two period
	 * ellipsis ('..') to the end of the string.
	 *
	 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
	 * truncated to 25 characters might look something like this:
	 * 'yahoo.com/some/long/pat..'
	 *
	 * Example Usage:
	 *
	 *     truncate: 25
	 *
	 *
	 *  Defaults to `0` for "no truncation."
	 *
	 *
	 * ## Object Form
	 *
	 * An Object may also be provided with two properties: `length` (Number) and
	 * `location` (String). `location` may be one of the following: 'end'
	 * (default), 'middle', or 'smart'.
	 *
	 * Example Usage:
	 *
	 *     truncate: { length: 25, location: 'middle' }
	 *
	 * @cfg {Number} [truncate.length=0] How many characters to allow before
	 *   truncation will occur. Defaults to `0` for "no truncation."
	 * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
	 *
	 * - 'end' (default): will truncate up to the number of characters, and then
	 *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
	 * - 'middle': will truncate and add the ellipsis in the middle. Ex:
	 *   'yahoo.com/s..th/to/a/file'
	 * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
	 *   parts first (such as the 'www.', then URL scheme, hash, etc.),
	 *   attempting to make the URL human-readable before looking for a good
	 *   point to insert the ellipsis if it is still too long. Ex:
	 *   'yahoo.com/some..to/a/file'. For more details, see
	 *   {@link Autolinker.truncate.TruncateSmart}.
	 */ /**
	 * @cfg {String} className
	 *
	 * A CSS class name to add to the generated links. This class will be added
	 * to all links, as well as this class plus match suffixes for styling
	 * url/email/phone/twitter/hashtag links differently.
	 *
	 * For example, if this config is provided as "myLink", then:
	 *
	 * - URL links will have the CSS classes: "myLink myLink-url"
	 * - Email links will have the CSS classes: "myLink myLink-email", and
	 * - Twitter links will have the CSS classes: "myLink myLink-twitter"
	 * - Phone links will have the CSS classes: "myLink myLink-phone"
	 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
	 */ /**
	 * @cfg {Function} replaceFn
	 *
	 * A function to individually process each match found in the input string.
	 *
	 * See the class's description for usage.
	 *
	 * This function is called with the following parameters:
	 *
	 * @cfg {Autolinker} replaceFn.autolinker The Autolinker instance, which may
	 *   be used to retrieve child objects from (such as the instance's
	 *   {@link #getTagBuilder tag builder}).
	 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
	 *   can be used to retrieve information about the match that the `replaceFn`
	 *   is currently processing. See {@link Autolinker.match.Match} subclasses
	 *   for details.
	 */ /**
	 * @property {String} version (readonly)
	 *
	 * The Autolinker version number in the form major.minor.patch
	 *
	 * Ex: 0.25.1
	 */ /**
	 * @private
	 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
	 *
	 * The HtmlParser instance used to skip over HTML tags, while finding text
	 * nodes to process. This is lazily instantiated in the {@link #getHtmlParser}
	 * method.
	 */ /**
	 * @private
	 * @property {Autolinker.matcher.Matcher[]} matchers
	 *
	 * The {@link Autolinker.matcher.Matcher} instances for this Autolinker
	 * instance.
	 *
	 * This is lazily created in {@link #getMatchers}.
	 */ /**
	 * @private
	 * @property {Autolinker.AnchorTagBuilder} tagBuilder
	 *
	 * The AnchorTagBuilder instance used to build match replacement anchor tags.
	 * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
	 */ /**
	 * Normalizes the {@link #urls} config into an Object with 3 properties:
	 * `schemeMatches`, `wwwMatches`, and `tldMatches`, all Booleans.
	 *
	 * See {@link #urls} config for details.
	 *
	 * @private
	 * @param {Boolean/Object} urls
	 * @return {Object}
	 */ normalizeUrlsCfg: function(urls) {
            if (urls == null) urls = true; // default to `true`
            if (typeof urls === "boolean") return {
                schemeMatches: urls,
                wwwMatches: urls,
                tldMatches: urls
            };
            else return {
                schemeMatches: typeof urls.schemeMatches === "boolean" ? urls.schemeMatches : true,
                wwwMatches: typeof urls.wwwMatches === "boolean" ? urls.wwwMatches : true,
                tldMatches: typeof urls.tldMatches === "boolean" ? urls.tldMatches : true
            };
        },
        /**
	 * Normalizes the {@link #truncate} config into an Object with 2 properties:
	 * `length` (Number), and `location` (String).
	 *
	 * See {@link #truncate} config for details.
	 *
	 * @private
	 * @param {Number/Object} truncate
	 * @return {Object}
	 */ normalizeTruncateCfg: function(truncate) {
            if (typeof truncate === "number") return {
                length: truncate,
                location: "end"
            };
            else return Autolinker.Util.defaults(truncate || {}, {
                length: Number.POSITIVE_INFINITY,
                location: "end"
            });
        },
        /**
	 * Parses the input `textOrHtml` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method is used by the {@link #link} method, but can also be used to
	 * simply do parsing of the input in order to discover what kinds of links
	 * there are and how many.
	 *
	 * @param {String} textOrHtml The HTML or text to find matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #twitter}, and {@link #hashtag} options are enabled).
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `textOrHtml`.
	 */ parse: function(textOrHtml) {
            var htmlParser = this.getHtmlParser(), htmlNodes = htmlParser.parse(textOrHtml), anchorTagStackCount = 0, matches = [];
            // Find all matches within the `textOrHtml` (but not matches that are
            // already nested within <a> tags)
            for(var i = 0, len = htmlNodes.length; i < len; i++){
                var node = htmlNodes[i], nodeType = node.getType();
                if (nodeType === "element" && node.getTagName() === "a") {
                    if (!node.isClosing()) anchorTagStackCount++;
                    else anchorTagStackCount = Math.max(anchorTagStackCount - 1, 0); // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
                } else if (nodeType === "text" && anchorTagStackCount === 0) {
                    var textNodeMatches = this.parseText(node.getText(), node.getOffset());
                    matches.push.apply(matches, textNodeMatches);
                }
            }
            // After we have found all matches, remove subsequent matches that
            // overlap with a previous match. This can happen for instance with URLs,
            // where the url 'google.com/#link' would match '#link' as a hashtag.
            matches = this.compactMatches(matches);
            // And finally, remove matches for match types that have been turned
            // off. We needed to have all match types turned on initially so that
            // things like hashtags could be filtered out if they were really just
            // part of a URL match (for instance, as a named anchor).
            matches = this.removeUnwantedMatches(matches);
            return matches;
        },
        /**
	 * After we have found all matches, we need to remove subsequent matches
	 * that overlap with a previous match. This can happen for instance with
	 * URLs, where the url 'google.com/#link' would match '#link' as a hashtag.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches
	 * @return {Autolinker.match.Match[]}
	 */ compactMatches: function(matches) {
            // First, the matches need to be sorted in order of offset
            matches.sort(function(a, b) {
                return a.getOffset() - b.getOffset();
            });
            for(var i = 0; i < matches.length - 1; i++){
                var match = matches[i], endIdx = match.getOffset() + match.getMatchedText().length;
                // Remove subsequent matches that overlap with the current match
                while(i + 1 < matches.length && matches[i + 1].getOffset() <= endIdx)matches.splice(i + 1, 1);
            }
            return matches;
        },
        /**
	 * Removes matches for matchers that were turned off in the options. For
	 * example, if {@link #hashtag hashtags} were not to be matched, we'll
	 * remove them from the `matches` array here.
	 *
	 * @private
	 * @param {Autolinker.match.Match[]} matches The array of matches to remove
	 *   the unwanted matches from. Note: this array is mutated for the
	 *   removals.
	 * @return {Autolinker.match.Match[]} The mutated input `matches` array.
	 */ removeUnwantedMatches: function(matches) {
            var remove = Autolinker.Util.remove;
            if (!this.hashtag) remove(matches, function(match) {
                return match.getType() === "hashtag";
            });
            if (!this.email) remove(matches, function(match) {
                return match.getType() === "email";
            });
            if (!this.phone) remove(matches, function(match) {
                return match.getType() === "phone";
            });
            if (!this.twitter) remove(matches, function(match) {
                return match.getType() === "twitter";
            });
            if (!this.urls.schemeMatches) remove(matches, function(m) {
                return m.getType() === "url" && m.getUrlMatchType() === "scheme";
            });
            if (!this.urls.wwwMatches) remove(matches, function(m) {
                return m.getType() === "url" && m.getUrlMatchType() === "www";
            });
            if (!this.urls.tldMatches) remove(matches, function(m) {
                return m.getType() === "url" && m.getUrlMatchType() === "tld";
            });
            return matches;
        },
        /**
	 * Parses the input `text` looking for URLs, email addresses, phone
	 * numbers, username handles, and hashtags (depending on the configuration
	 * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
	 * objects describing those matches.
	 *
	 * This method processes a **non-HTML string**, and is used to parse and
	 * match within the text nodes of an HTML string. This method is used
	 * internally by {@link #parse}.
	 *
	 * @private
	 * @param {String} text The text to find matches within (depending on if the
	 *   {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter}, and
	 *   {@link #hashtag} options are enabled). This must be a non-HTML string.
	 * @param {Number} [offset=0] The offset of the text node within the
	 *   original string. This is used when parsing with the {@link #parse}
	 *   method to generate correct offsets within the {@link Autolinker.match.Match}
	 *   instances, but may be omitted if calling this method publicly.
	 * @return {Autolinker.match.Match[]} The array of Matches found in the
	 *   given input `text`.
	 */ parseText: function(text, offset) {
            offset = offset || 0;
            var matchers = this.getMatchers(), matches = [];
            for(var i = 0, numMatchers = matchers.length; i < numMatchers; i++){
                var textMatches = matchers[i].parseMatches(text);
                // Correct the offset of each of the matches. They are originally
                // the offset of the match within the provided text node, but we
                // need to correct them to be relative to the original HTML input
                // string (i.e. the one provided to #parse).
                for(var j = 0, numTextMatches = textMatches.length; j < numTextMatches; j++)textMatches[j].setOffset(offset + textMatches[j].getOffset());
                matches.push.apply(matches, textMatches);
            }
            return matches;
        },
        /**
	 * Automatically links URLs, Email addresses, Phone numbers, Twitter
	 * handles, and Hashtags found in the given chunk of HTML. Does not link
	 * URLs found within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to
	 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * This method finds the text around any HTML elements in the input
	 * `textOrHtml`, which will be the text that is processed. Any original HTML
	 * elements will be left as-is, as well as the text that is already wrapped
	 * in anchor (&lt;a&gt;) tags.
	 *
	 * @param {String} textOrHtml The HTML or text to autolink matches within
	 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
	 *   {@link #twitter}, and {@link #hashtag} options are enabled).
	 * @return {String} The HTML, with matches automatically linked.
	 */ link: function(textOrHtml) {
            if (!textOrHtml) return "";
             // handle `null` and `undefined`
            var matches = this.parse(textOrHtml), newHtml = [], lastIndex = 0;
            for(var i = 0, len = matches.length; i < len; i++){
                var match = matches[i];
                newHtml.push(textOrHtml.substring(lastIndex, match.getOffset()));
                newHtml.push(this.createMatchReturnVal(match));
                lastIndex = match.getOffset() + match.getMatchedText().length;
            }
            newHtml.push(textOrHtml.substring(lastIndex)); // handle the text after the last match
            return newHtml.join("");
        },
        /**
	 * Creates the return string value for a given match in the input string.
	 *
	 * This method handles the {@link #replaceFn}, if one was provided.
	 *
	 * @private
	 * @param {Autolinker.match.Match} match The Match object that represents
	 *   the match.
	 * @return {String} The string that the `match` should be replaced with.
	 *   This is usually the anchor tag string, but may be the `matchStr` itself
	 *   if the match is not to be replaced.
	 */ createMatchReturnVal: function(match) {
            // Handle a custom `replaceFn` being provided
            var replaceFnResult;
            if (this.replaceFn) replaceFnResult = this.replaceFn.call(this, this, match); // Autolinker instance is the context, and the first arg
            if (typeof replaceFnResult === "string") return replaceFnResult; // `replaceFn` returned a string, use that
            else if (replaceFnResult === false) return match.getMatchedText(); // no replacement for the match
            else if (replaceFnResult instanceof Autolinker.HtmlTag) return replaceFnResult.toAnchorString();
            else {
                // Perform Autolinker's default anchor tag generation
                var anchorTag = match.buildTag(); // returns an Autolinker.HtmlTag instance
                return anchorTag.toAnchorString();
            }
        },
        /**
	 * Lazily instantiates and returns the {@link #htmlParser} instance for this
	 * Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.htmlParser.HtmlParser}
	 */ getHtmlParser: function() {
            var htmlParser = this.htmlParser;
            if (!htmlParser) htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
            return htmlParser;
        },
        /**
	 * Lazily instantiates and returns the {@link Autolinker.matcher.Matcher}
	 * instances for this Autolinker instance.
	 *
	 * @protected
	 * @return {Autolinker.matcher.Matcher[]}
	 */ getMatchers: function() {
            if (!this.matchers) {
                var matchersNs = Autolinker.matcher, tagBuilder = this.getTagBuilder();
                var matchers = [
                    new matchersNs.Hashtag({
                        tagBuilder: tagBuilder,
                        serviceName: this.hashtag
                    }),
                    new matchersNs.Email({
                        tagBuilder: tagBuilder
                    }),
                    new matchersNs.Phone({
                        tagBuilder: tagBuilder
                    }),
                    new matchersNs.Twitter({
                        tagBuilder: tagBuilder
                    }),
                    new matchersNs.Url({
                        tagBuilder: tagBuilder,
                        stripPrefix: this.stripPrefix
                    })
                ];
                return this.matchers = matchers;
            } else return this.matchers;
        },
        /**
	 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
	 * if it does not yet exist.
	 *
	 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
	 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 * @return {Autolinker.AnchorTagBuilder}
	 */ getTagBuilder: function() {
            var tagBuilder = this.tagBuilder;
            if (!tagBuilder) tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder({
                newWindow: this.newWindow,
                truncate: this.truncate,
                className: this.className
            });
            return tagBuilder;
        }
    };
    // Autolinker Namespaces
    Autolinker.match = {};
    Autolinker.matcher = {};
    Autolinker.htmlParser = {};
    Autolinker.truncate = {};
    /*global Autolinker */ /*jshint eqnull:true, boss:true */ /**
 * @class Autolinker.Util
 * @singleton
 *
 * A few utility methods for Autolinker.
 */ Autolinker.Util = {
        /**
	 * @property {Function} abstractMethod
	 *
	 * A function object which represents an abstract method.
	 */ abstractMethod: function() {
            throw "abstract";
        },
        /**
	 * @private
	 * @property {RegExp} trimRegex
	 *
	 * The regular expression used to trim the leading and trailing whitespace
	 * from a string.
	 */ trimRegex: /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
        /**
	 * Assigns (shallow copies) the properties of `src` onto `dest`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */ assign: function(dest, src) {
            for(var prop in src)if (src.hasOwnProperty(prop)) dest[prop] = src[prop];
            return dest;
        },
        /**
	 * Assigns (shallow copies) the properties of `src` onto `dest`, if the
	 * corresponding property on `dest` === `undefined`.
	 *
	 * @param {Object} dest The destination object.
	 * @param {Object} src The source object.
	 * @return {Object} The destination object (`dest`)
	 */ defaults: function(dest, src) {
            for(var prop in src)if (src.hasOwnProperty(prop) && dest[prop] === undefined) dest[prop] = src[prop];
            return dest;
        },
        /**
	 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
	 *
	 * @param {Function} superclass The constructor function for the superclass.
	 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
	 *   special property `constructor`, which will be used as the new subclass's constructor function.
	 * @return {Function} The new subclass function.
	 */ extend: function(superclass, protoProps) {
            var superclassProto = superclass.prototype;
            var F = function() {};
            F.prototype = superclassProto;
            var subclass;
            if (protoProps.hasOwnProperty("constructor")) subclass = protoProps.constructor;
            else subclass = function() {
                superclassProto.constructor.apply(this, arguments);
            };
            var subclassProto = subclass.prototype = new F(); // set up prototype chain
            subclassProto.constructor = subclass; // fix constructor property
            subclassProto.superclass = superclassProto;
            delete protoProps.constructor; // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
            Autolinker.Util.assign(subclassProto, protoProps);
            return subclass;
        },
        /**
	 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
	 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
	 * `len`, the string will be returned unchanged.
	 *
	 * @param {String} str The string to truncate and add an ellipsis to.
	 * @param {Number} truncateLen The length to truncate the string at.
	 * @param {String} [ellipsisChars=..] The ellipsis character(s) to add to the end of `str`
	 *   when truncated. Defaults to '..'
	 */ ellipsis: function(str, truncateLen, ellipsisChars) {
            if (str.length > truncateLen) {
                ellipsisChars = ellipsisChars == null ? ".." : ellipsisChars;
                str = str.substring(0, truncateLen - ellipsisChars.length) + ellipsisChars;
            }
            return str;
        },
        /**
	 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
	 *
	 * @param {Array} arr The array to find an element of.
	 * @param {*} element The element to find in the array, and return the index of.
	 * @return {Number} The index of the `element`, or -1 if it was not found.
	 */ indexOf: function(arr, element) {
            if (Array.prototype.indexOf) return arr.indexOf(element);
            else {
                for(var i = 0, len = arr.length; i < len; i++){
                    if (arr[i] === element) return i;
                }
                return -1;
            }
        },
        /**
	 * Removes array elements based on a filtering function. Mutates the input
	 * array.
	 *
	 * Using this instead of the ES5 Array.prototype.filter() function, to allow
	 * Autolinker compatibility with IE8, and also to prevent creating many new
	 * arrays in memory for filtering.
	 *
	 * @param {Array} arr The array to remove elements from. This array is
	 *   mutated.
	 * @param {Function} fn A function which should return `true` to
	 *   remove an element.
	 * @return {Array} The mutated input `arr`.
	 */ remove: function(arr, fn) {
            for(var i = arr.length - 1; i >= 0; i--)if (fn(arr[i]) === true) arr.splice(i, 1);
        },
        /**
	 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
	 * with a regular expression that contains capturing parenthesis.
	 *
	 * For example:
	 *
	 *     // Modern browsers:
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
	 *
	 *     // Old IE (including IE8):
	 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
	 *
	 * This method emulates the functionality of modern browsers for the old IE case.
	 *
	 * @param {String} str The string to split.
	 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
	 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
	 *   description of this method.
	 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
	 *   Note #2: for simplicity's sake, the regular expression does not need
	 *   to contain capturing parenthesis - it will be assumed that any match has them.
	 * @return {String[]} The split array of strings, with the splitting character(s) included.
	 */ splitAndCapture: function(str, splitRegex) {
            if (!splitRegex.global) throw new Error("`splitRegex` must have the 'g' flag set");
            var result = [], lastIdx = 0, match;
            while(match = splitRegex.exec(str)){
                result.push(str.substring(lastIdx, match.index));
                result.push(match[0]); // push the splitting char(s)
                lastIdx = match.index + match[0].length;
            }
            result.push(str.substring(lastIdx));
            return result;
        },
        /**
	 * Trims the leading and trailing whitespace from a string.
	 *
	 * @param {String} str The string to trim.
	 * @return {String}
	 */ trim: function(str) {
            return str.replace(this.trimRegex, "");
        }
    };
    /*global Autolinker */ /*jshint boss:true */ /**
 * @class Autolinker.HtmlTag
 * @extends Object
 *
 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
 *
 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
 *
 * ## Examples
 *
 * Example instantiation:
 *
 *     var tag = new Autolinker.HtmlTag( {
 *         tagName : 'a',
 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
 *         innerHtml : 'Google'
 *     } );
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *     // Individual accessor methods
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *
 * Using mutator methods (which may be used in combination with instantiation config properties):
 *
 *     var tag = new Autolinker.HtmlTag();
 *     tag.setTagName( 'a' );
 *     tag.setAttr( 'href', 'http://google.com' );
 *     tag.addClass( 'external-link' );
 *     tag.setInnerHtml( 'Google' );
 *
 *     tag.getTagName();                 // 'a'
 *     tag.getAttr( 'href' );            // 'http://google.com'
 *     tag.hasClass( 'external-link' );  // true
 *
 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
 *
 *
 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 *
 *
 * ## Example use with a new tag for the replacement
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = new Autolinker.HtmlTag( {
 *                 tagName : 'button',
 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
 *             } );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
 */ Autolinker.HtmlTag = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {String} tagName
	 *
	 * The tag name. Ex: 'a', 'button', etc.
	 *
	 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
	 * is executed.
	 */ /**
	 * @cfg {Object.<String, String>} attrs
	 *
	 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
	 * values are the attribute values.
	 */ /**
	 * @cfg {String} innerHtml
	 *
	 * The inner HTML for the tag.
	 *
	 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
	 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
	 * if you prefer, but this one is recommended.
	 */ /**
	 * @cfg {String} innerHTML
	 *
	 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
	 * for acronym names.
	 */ /**
	 * @protected
	 * @property {RegExp} whitespaceRegex
	 *
	 * Regular expression used to match whitespace in a string of CSS classes.
	 */ whitespaceRegex: /\s+/,
        /**
	 * @constructor
	 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
	 */ constructor: function(cfg) {
            Autolinker.Util.assign(this, cfg);
            this.innerHtml = this.innerHtml || this.innerHTML; // accept either the camelCased form or the fully capitalized acronym
        },
        /**
	 * Sets the tag name that will be used to generate the tag with.
	 *
	 * @param {String} tagName
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setTagName: function(tagName) {
            this.tagName = tagName;
            return this;
        },
        /**
	 * Retrieves the tag name.
	 *
	 * @return {String}
	 */ getTagName: function() {
            return this.tagName || "";
        },
        /**
	 * Sets an attribute on the HtmlTag.
	 *
	 * @param {String} attrName The attribute name to set.
	 * @param {String} attrValue The attribute value to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setAttr: function(attrName, attrValue) {
            var tagAttrs = this.getAttrs();
            tagAttrs[attrName] = attrValue;
            return this;
        },
        /**
	 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
	 *
	 * @param {String} attrName The attribute name to retrieve.
	 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
	 */ getAttr: function(attrName) {
            return this.getAttrs()[attrName];
        },
        /**
	 * Sets one or more attributes on the HtmlTag.
	 *
	 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setAttrs: function(attrs) {
            var tagAttrs = this.getAttrs();
            Autolinker.Util.assign(tagAttrs, attrs);
            return this;
        },
        /**
	 * Retrieves the attributes Object (map) for the HtmlTag.
	 *
	 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
	 */ getAttrs: function() {
            return this.attrs || (this.attrs = {});
        },
        /**
	 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setClass: function(cssClass) {
            return this.setAttr("class", cssClass);
        },
        /**
	 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to add.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ addClass: function(cssClass) {
            var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, indexOf = Autolinker.Util.indexOf, classes = !classAttr ? [] : classAttr.split(whitespaceRegex), newClasses = cssClass.split(whitespaceRegex), newClass;
            while(newClass = newClasses.shift())if (indexOf(classes, newClass) === -1) classes.push(newClass);
            this.getAttrs()["class"] = classes.join(" ");
            return this;
        },
        /**
	 * Convenience method to remove one or more CSS classes from the HtmlTag.
	 *
	 * @param {String} cssClass One or more space-separated CSS classes to remove.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ removeClass: function(cssClass) {
            var classAttr = this.getClass(), whitespaceRegex = this.whitespaceRegex, indexOf = Autolinker.Util.indexOf, classes = !classAttr ? [] : classAttr.split(whitespaceRegex), removeClasses = cssClass.split(whitespaceRegex), removeClass;
            while(classes.length && (removeClass = removeClasses.shift())){
                var idx = indexOf(classes, removeClass);
                if (idx !== -1) classes.splice(idx, 1);
            }
            this.getAttrs()["class"] = classes.join(" ");
            return this;
        },
        /**
	 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
	 * there are multiple.
	 *
	 * @return {String}
	 */ getClass: function() {
            return this.getAttrs()["class"] || "";
        },
        /**
	 * Convenience method to check if the tag has a CSS class or not.
	 *
	 * @param {String} cssClass The CSS class to check for.
	 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
	 */ hasClass: function(cssClass) {
            return (" " + this.getClass() + " ").indexOf(" " + cssClass + " ") !== -1;
        },
        /**
	 * Sets the inner HTML for the tag.
	 *
	 * @param {String} html The inner HTML to set.
	 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
	 */ setInnerHtml: function(html) {
            this.innerHtml = html;
            return this;
        },
        /**
	 * Retrieves the inner HTML for the tag.
	 *
	 * @return {String}
	 */ getInnerHtml: function() {
            return this.innerHtml || "";
        },
        /**
	 * Override of superclass method used to generate the HTML string for the tag.
	 *
	 * @return {String}
	 */ toAnchorString: function() {
            var tagName = this.getTagName(), attrsStr = this.buildAttrsStr();
            attrsStr = attrsStr ? " " + attrsStr : ""; // prepend a space if there are actually attributes
            return [
                "<",
                tagName,
                attrsStr,
                ">",
                this.getInnerHtml(),
                "</",
                tagName,
                ">"
            ].join("");
        },
        /**
	 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
	 * the stringified HtmlTag.
	 *
	 * @protected
	 * @return {String} Example return: `attr1="value1" attr2="value2"`
	 */ buildAttrsStr: function() {
            if (!this.attrs) return ""; // no `attrs` Object (map) has been set, return empty string
            var attrs = this.getAttrs(), attrsArr = [];
            for(var prop in attrs)if (attrs.hasOwnProperty(prop)) attrsArr.push(prop + '="' + attrs[prop] + '"');
            return attrsArr.join(" ");
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.RegexLib
 * @singleton
 *
 * Builds and stores a library of the common regular expressions used by the
 * Autolinker utility.
 *
 * Other regular expressions may exist ad-hoc, but these are generally the
 * regular expressions that are shared between source files.
 */ Autolinker.RegexLib = function() {
        /**
	 * The string form of a regular expression that would match all of the
	 * alphabetic ("letter") chars in the unicode character set when placed in a
	 * RegExp character class (`[]`). This includes all international alphabetic
	 * characters.
	 *
	 * These would be the characters matched by unicode regex engines `\p{L}`
	 * escape ("all letters").
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */ var alphaCharsStr = "A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠ-ࢴऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿕ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꞭꞰ-ꞷꟷ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭥꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ";
        /**
	 * The string form of a regular expression that would match all of the
	 * decimal number chars in the unicode character set when placed in a RegExp
	 * character class (`[]`).
	 *
	 * These would be the characters matched by unicode regex engines `\p{Nd}`
	 * escape ("all decimal numbers")
	 *
	 * Taken from the XRegExp library: http://xregexp.com/
	 * Specifically: http://xregexp.com/v/3.0.0/unicode-categories.js
	 *
	 * @private
	 * @type {String}
	 */ var decimalNumbersStr = "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９";
        // See documentation below
        var alphaNumericCharsStr = alphaCharsStr + decimalNumbersStr;
        // See documentation below
        var domainNameRegex = new RegExp("[" + alphaNumericCharsStr + ".\\-]*[" + alphaNumericCharsStr + "\\-]");
        // See documentation below
        var tldRegex = /(?:travelersinsurance|sandvikcoromant|kerryproperties|cancerresearch|weatherchannel|kerrylogistics|spreadbetting|international|wolterskluwer|lifeinsurance|construction|pamperedchef|scholarships|versicherung|bridgestone|creditunion|kerryhotels|investments|productions|blackfriday|enterprises|lamborghini|photography|motorcycles|williamhill|playstation|contractors|barclaycard|accountants|redumbrella|engineering|management|telefonica|protection|consulting|tatamotors|creditcard|vlaanderen|schaeffler|associates|properties|foundation|republican|bnpparibas|boehringer|eurovision|extraspace|industries|immobilien|university|technology|volkswagen|healthcare|restaurant|cuisinella|vistaprint|apartments|accountant|travelers|homedepot|institute|vacations|furniture|fresenius|insurance|christmas|bloomberg|solutions|barcelona|firestone|financial|kuokgroup|fairwinds|community|passagens|goldpoint|equipment|lifestyle|yodobashi|aquarelle|marketing|analytics|education|amsterdam|statefarm|melbourne|allfinanz|directory|microsoft|stockholm|montblanc|accenture|lancaster|landrover|everbank|istanbul|graphics|grainger|ipiranga|softbank|attorney|pharmacy|saarland|catering|airforce|yokohama|mortgage|frontier|mutuelle|stcgroup|memorial|pictures|football|symantec|cipriani|ventures|telecity|cityeats|verisign|flsmidth|boutique|cleaning|firmdale|clinique|clothing|redstone|infiniti|deloitte|feedback|services|broadway|plumbing|commbank|training|barclays|exchange|computer|brussels|software|delivery|barefoot|builders|business|bargains|engineer|holdings|download|security|helsinki|lighting|movistar|discount|hdfcbank|supplies|marriott|property|diamonds|capetown|partners|democrat|jpmorgan|bradesco|budapest|rexroth|zuerich|shriram|academy|science|support|youtube|singles|surgery|alibaba|statoil|dentist|schwarz|android|cruises|cricket|digital|markets|starhub|systems|courses|coupons|netbank|country|domains|corsica|network|neustar|realtor|lincoln|limited|schmidt|yamaxun|cooking|contact|auction|spiegel|liaison|leclerc|latrobe|lasalle|abogado|compare|lanxess|exposed|express|company|cologne|college|avianca|lacaixa|fashion|recipes|ferrero|komatsu|storage|wanggou|clubmed|sandvik|fishing|fitness|bauhaus|kitchen|flights|florist|flowers|watches|weather|temasek|samsung|bentley|forsale|channel|theater|frogans|theatre|okinawa|website|tickets|jewelry|gallery|tiffany|iselect|shiksha|brother|organic|wedding|genting|toshiba|origins|philips|hyundai|hotmail|hoteles|hosting|rentals|windows|cartier|bugatti|holiday|careers|whoswho|hitachi|panerai|caravan|reviews|guitars|capital|trading|hamburg|hangout|finance|stream|family|abbott|health|review|travel|report|hermes|hiphop|gratis|career|toyota|hockey|dating|repair|google|social|soccer|reisen|global|otsuka|giving|unicom|casino|photos|center|broker|rocher|orange|bostik|garden|insure|ryukyu|bharti|safety|physio|sakura|oracle|online|jaguar|gallup|piaget|tienda|futbol|pictet|joburg|webcam|berlin|office|juegos|kaufen|chanel|chrome|xihuan|church|tennis|circle|kinder|flickr|bayern|claims|clinic|viajes|nowruz|xperia|norton|yachts|studio|coffee|camera|sanofi|nissan|author|expert|events|comsec|lawyer|tattoo|viking|estate|villas|condos|realty|yandex|energy|emerck|virgin|vision|durban|living|school|coupon|london|taobao|natura|taipei|nagoya|luxury|walter|aramco|sydney|madrid|credit|maison|makeup|schule|market|anquan|direct|design|swatch|suzuki|alsace|vuelos|dental|alipay|voyage|shouji|voting|airtel|mutual|degree|supply|agency|museum|mobily|dealer|monash|select|mormon|active|moscow|racing|datsun|quebec|nissay|rodeo|email|gifts|works|photo|chloe|edeka|cheap|earth|vista|tushu|koeln|glass|shoes|globo|tunes|gmail|nokia|space|kyoto|black|ricoh|seven|lamer|sener|epson|cisco|praxi|trust|citic|crown|shell|lease|green|legal|lexus|ninja|tatar|gripe|nikon|group|video|wales|autos|gucci|party|nexus|guide|linde|adult|parts|amica|lixil|boats|azure|loans|locus|cymru|lotte|lotto|stada|click|poker|quest|dabur|lupin|nadex|paris|faith|dance|canon|place|gives|trade|skype|rocks|mango|cloud|boots|smile|final|swiss|homes|honda|media|horse|cards|deals|watch|bosch|house|pizza|miami|osaka|tours|total|xerox|coach|sucks|style|delta|toray|iinet|tools|money|codes|beats|tokyo|salon|archi|movie|baidu|study|actor|yahoo|store|apple|world|forex|today|bible|tmall|tirol|irish|tires|forum|reise|vegas|vodka|sharp|omega|weber|jetzt|audio|promo|build|bingo|chase|gallo|drive|dubai|rehab|press|solar|sale|beer|bbva|bank|band|auto|sapo|sarl|saxo|audi|asia|arte|arpa|army|yoga|ally|zara|scor|scot|sexy|seat|zero|seek|aero|adac|zone|aarp|maif|meet|meme|menu|surf|mini|mobi|mtpc|porn|desi|star|ltda|name|talk|navy|love|loan|live|link|news|limo|like|spot|life|nico|lidl|lgbt|land|taxi|team|tech|kred|kpmg|sony|song|kiwi|kddi|jprs|jobs|sohu|java|itau|tips|info|immo|icbc|hsbc|town|host|page|toys|here|help|pars|haus|guru|guge|tube|goog|golf|gold|sncf|gmbh|gift|ggee|gent|gbiz|game|vana|pics|fund|ford|ping|pink|fish|film|fast|farm|play|fans|fail|plus|skin|pohl|fage|moda|post|erni|dvag|prod|doha|prof|docs|viva|diet|luxe|site|dell|sina|dclk|show|qpon|date|vote|cyou|voto|read|coop|cool|wang|club|city|chat|cern|cash|reit|rent|casa|cars|care|camp|rest|call|cafe|weir|wien|rich|wiki|buzz|wine|book|bond|room|work|rsvp|shia|ruhr|blue|bing|shaw|bike|safe|xbox|best|pwc|mtn|lds|aig|boo|fyi|nra|nrw|ntt|car|gal|obi|zip|aeg|vin|how|one|ong|onl|dad|ooo|bet|esq|org|htc|bar|uol|ibm|ovh|gdn|ice|icu|uno|gea|ifm|bot|top|wtf|lol|day|pet|eus|wtc|ubs|tvs|aco|ing|ltd|ink|tab|abb|afl|cat|int|pid|pin|bid|cba|gle|com|cbn|ads|man|wed|ceb|gmo|sky|ist|gmx|tui|mba|fan|ski|iwc|app|pro|med|ceo|jcb|jcp|goo|dev|men|aaa|meo|pub|jlc|bom|jll|gop|jmp|mil|got|gov|win|jot|mma|joy|trv|red|cfa|cfd|bio|moe|moi|mom|ren|biz|aws|xin|bbc|dnp|buy|kfh|mov|thd|xyz|fit|kia|rio|rip|kim|dog|vet|nyc|bcg|mtr|bcn|bms|bmw|run|bzh|rwe|tel|stc|axa|kpn|fly|krd|cab|bnl|foo|crs|eat|tci|sap|srl|nec|sas|net|cal|sbs|sfr|sca|scb|csc|edu|new|xxx|hiv|fox|wme|ngo|nhk|vip|sex|frl|lat|yun|law|you|tax|soy|sew|om|ac|hu|se|sc|sg|sh|sb|sa|rw|ru|rs|ro|re|qa|py|si|pw|pt|ps|sj|sk|pr|pn|pm|pl|sl|sm|pk|sn|ph|so|pg|pf|pe|pa|zw|nz|nu|nr|np|no|nl|ni|ng|nf|sr|ne|st|nc|na|mz|my|mx|mw|mv|mu|mt|ms|mr|mq|mp|mo|su|mn|mm|ml|mk|mh|mg|me|sv|md|mc|sx|sy|ma|ly|lv|sz|lu|lt|ls|lr|lk|li|lc|lb|la|tc|kz|td|ky|kw|kr|kp|kn|km|ki|kh|tf|tg|th|kg|ke|jp|jo|jm|je|it|is|ir|tj|tk|tl|tm|iq|tn|to|io|in|im|il|ie|ad|sd|ht|hr|hn|hm|tr|hk|gy|gw|gu|gt|gs|gr|gq|tt|gp|gn|gm|gl|tv|gi|tw|tz|ua|gh|ug|uk|gg|gf|ge|gd|us|uy|uz|va|gb|ga|vc|ve|fr|fo|fm|fk|fj|vg|vi|fi|eu|et|es|er|eg|ee|ec|dz|do|dm|dk|vn|dj|de|cz|cy|cx|cw|vu|cv|cu|cr|co|cn|cm|cl|ck|ci|ch|cg|cf|cd|cc|ca|wf|bz|by|bw|bv|bt|bs|br|bo|bn|bm|bj|bi|ws|bh|bg|bf|be|bd|bb|ba|az|ax|aw|au|at|as|ye|ar|aq|ao|am|al|yt|ai|za|ag|af|ae|zm|id)\b/;
        return {
            /**
		 * The string form of a regular expression that would match all of the
		 * letters and decimal number chars in the unicode character set when placed
		 * in a RegExp character class (`[]`).
		 *
		 * These would be the characters matched by unicode regex engines `[\p{L}\p{Nd}]`
		 * escape ("all letters and decimal numbers")
		 *
		 * @property {String} alphaNumericCharsStr
		 */ alphaNumericCharsStr: alphaNumericCharsStr,
            /**
		 * A regular expression to match domain names of a URL or email address.
		 * Ex: 'google', 'yahoo', 'some-other-company', etc.
		 *
		 * @property {RegExp} domainNameRegex
		 */ domainNameRegex: domainNameRegex,
            /**
		 * A regular expression to match top level domains (TLDs) for a URL or
		 * email address. Ex: 'com', 'org', 'net', etc.
		 *
		 * @property {RegExp} tldRegex
		 */ tldRegex: tldRegex
        };
    }();
    /*global Autolinker */ /*jshint sub:true */ /**
 * @protected
 * @class Autolinker.AnchorTagBuilder
 * @extends Object
 *
 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
 * found.
 *
 * Normally this class is instantiated, configured, and used internally by an
 * {@link Autolinker} instance, but may actually be retrieved in a {@link Autolinker#replaceFn replaceFn}
 * to create {@link Autolinker.HtmlTag HtmlTag} instances which may be modified
 * before returning from the {@link Autolinker#replaceFn replaceFn}. For
 * example:
 *
 *     var html = Autolinker.link( "Test google.com", {
 *         replaceFn : function( autolinker, match ) {
 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
 *             tag.setAttr( 'rel', 'nofollow' );
 *
 *             return tag;
 *         }
 *     } );
 *
 *     // generated html:
 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
 */ Autolinker.AnchorTagBuilder = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Boolean} newWindow
	 * @inheritdoc Autolinker#newWindow
	 */ /**
	 * @cfg {Object} truncate
	 * @inheritdoc Autolinker#truncate
	 */ /**
	 * @cfg {String} className
	 * @inheritdoc Autolinker#className
	 */ /**
	 * @constructor
	 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.Util.assign(this, cfg);
        },
        /**
	 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
	 * matched text, via its `match` object.
	 *
	 * @param {Autolinker.match.Match} match The Match instance to generate an
	 *   anchor tag from.
	 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
	 */ build: function(match) {
            return new Autolinker.HtmlTag({
                tagName: "a",
                attrs: this.createAttrs(match.getType(), match.getAnchorHref()),
                innerHtml: this.processAnchorText(match.getAnchorText())
            });
        },
        /**
	 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
	 *   tag being generated.
	 *
	 * @protected
	 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
	 *   match that an anchor tag is being generated for.
	 * @param {String} anchorHref The href for the anchor tag.
	 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
	 */ createAttrs: function(matchType, anchorHref) {
            var attrs = {
                "href": anchorHref // we'll always have the `href` attribute
            };
            var cssClass = this.createCssClass(matchType);
            if (cssClass) attrs["class"] = cssClass;
            if (this.newWindow) {
                attrs["target"] = "_blank";
                attrs["rel"] = "noopener noreferrer";
            }
            return attrs;
        },
        /**
	 * Creates the CSS class that will be used for a given anchor tag, based on
	 * the `matchType` and the {@link #className} config.
	 *
	 * @private
	 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
	 *   match that an anchor tag is being generated for.
	 * @return {String} The CSS class string for the link. Example return:
	 *   "myLink myLink-url". If no {@link #className} was configured, returns
	 *   an empty string.
	 */ createCssClass: function(matchType) {
            var className = this.className;
            if (!className) return "";
            else return className + " " + className + "-" + matchType; // ex: "myLink myLink-url", "myLink myLink-email", "myLink myLink-phone", "myLink myLink-twitter", or "myLink myLink-hashtag"
        },
        /**
	 * Processes the `anchorText` by truncating the text according to the
	 * {@link #truncate} config.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The processed `anchorText`.
	 */ processAnchorText: function(anchorText) {
            anchorText = this.doTruncate(anchorText);
            return anchorText;
        },
        /**
	 * Performs the truncation of the `anchorText` based on the {@link #truncate}
	 * option. If the `anchorText` is longer than the length specified by the
	 * {@link #truncate} option, the truncation is performed based on the
	 * `location` property. See {@link #truncate} for details.
	 *
	 * @private
	 * @param {String} anchorText The anchor tag's text (i.e. what will be
	 *   displayed).
	 * @return {String} The truncated anchor text.
	 */ doTruncate: function(anchorText) {
            var truncate = this.truncate;
            if (!truncate || !truncate.length) return anchorText;
            var truncateLength = truncate.length, truncateLocation = truncate.location;
            if (truncateLocation === "smart") return Autolinker.truncate.TruncateSmart(anchorText, truncateLength, "..");
            else if (truncateLocation === "middle") return Autolinker.truncate.TruncateMiddle(anchorText, truncateLength, "..");
            else return Autolinker.truncate.TruncateEnd(anchorText, truncateLength, "..");
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.HtmlParser
 * @extends Object
 *
 * An HTML parser implementation which simply walks an HTML string and returns an array of
 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
 *
 * Autolinker uses this to only link URLs/emails/Twitter handles within text nodes, effectively ignoring / "walking
 * around" HTML tags.
 */ Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend(Object, {
        /**
	 * @private
	 * @property {RegExp} htmlRegex
	 *
	 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
	 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
	 *
	 * Capturing groups:
	 *
	 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
	 * 2. If it is an end tag, this group will have the '/'.
	 * 3. If it is a comment tag, this group will hold the comment text (i.e.
	 *    the text inside the `&lt;!--` and `--&gt;`.
	 * 4. The tag name for all tags (other than the &lt;!DOCTYPE&gt; tag)
	 */ htmlRegex: function() {
            var commentTagRegex = /!--([\s\S]+?)--/, tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/, attrNameRegex = /[^\s"'>\/=\x00-\x1F\x7F]+/, attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, nameEqualsValueRegex = attrNameRegex.source + "(?:\\s*=\\s*" + attrValueRegex.source + ")?"; // optional '=[value]'
            return new RegExp([
                // for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
                "(?:",
                "<(!DOCTYPE)",
                // Zero or more attributes following the tag name
                "(?:",
                "\\s+",
                // Either:
                // A. attr="value", or
                // B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
                "(?:",
                nameEqualsValueRegex,
                "|",
                attrValueRegex.source + ")",
                ")*",
                ">",
                ")",
                "|",
                // All other HTML tags (i.e. tags that are not <!DOCTYPE>)
                "(?:",
                "<(/)?",
                // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.
                "(?:",
                commentTagRegex.source,
                "|",
                "(?:",
                // *** Capturing Group 4 - The tag name
                "(" + tagNameRegex.source + ")",
                // Zero or more attributes following the tag name
                "(?:",
                "(?:\\s+|\\b)",
                nameEqualsValueRegex,
                ")*",
                "\\s*/?",
                ")",
                ")",
                ">",
                ")"
            ].join(""), "gi");
        }(),
        /**
	 * @private
	 * @property {RegExp} htmlCharacterEntitiesRegex
	 *
	 * The regular expression that matches common HTML character entities.
	 *
	 * Ignoring &amp; as it could be part of a query string -- handling it separately.
	 */ htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,
        /**
	 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
	 * to represent the HTML structure of the input string.
	 *
	 * @param {String} html The HTML to parse.
	 * @return {Autolinker.htmlParser.HtmlNode[]}
	 */ parse: function(html) {
            var htmlRegex = this.htmlRegex, currentResult, lastIndex = 0, textAndEntityNodes, nodes = []; // will be the result of the method
            while((currentResult = htmlRegex.exec(html)) !== null){
                var tagText = currentResult[0], commentText = currentResult[3], tagName = currentResult[1] || currentResult[4], isClosingTag = !!currentResult[2], offset = currentResult.index, inBetweenTagsText = html.substring(lastIndex, offset);
                // Push TextNodes and EntityNodes for any text found between tags
                if (inBetweenTagsText) {
                    textAndEntityNodes = this.parseTextAndEntityNodes(lastIndex, inBetweenTagsText);
                    nodes.push.apply(nodes, textAndEntityNodes);
                }
                // Push the CommentNode or ElementNode
                if (commentText) nodes.push(this.createCommentNode(offset, tagText, commentText));
                else nodes.push(this.createElementNode(offset, tagText, tagName, isClosingTag));
                lastIndex = offset + tagText.length;
            }
            // Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
            if (lastIndex < html.length) {
                var text = html.substring(lastIndex);
                // Push TextNodes and EntityNodes for any text found between tags
                if (text) {
                    textAndEntityNodes = this.parseTextAndEntityNodes(lastIndex, text);
                    nodes.push.apply(nodes, textAndEntityNodes);
                }
            }
            return nodes;
        },
        /**
	 * Parses text and HTML entity nodes from a given string. The input string
	 * should not have any HTML tags (elements) within it.
	 *
	 * @private
	 * @param {Number} offset The offset of the text node match within the
	 *   original HTML string.
	 * @param {String} text The string of text to parse. This is from an HTML
	 *   text node.
	 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
	 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
	 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
	 */ parseTextAndEntityNodes: function(offset, text) {
            var nodes = [], textAndEntityTokens = Autolinker.Util.splitAndCapture(text, this.htmlCharacterEntitiesRegex); // split at HTML entities, but include the HTML entities in the results array
            // Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
            // For example: an input `text` of "Test &quot;this&quot; today" would turn into the
            //   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
            for(var i = 0, len = textAndEntityTokens.length; i < len; i += 2){
                var textToken = textAndEntityTokens[i], entityToken = textAndEntityTokens[i + 1];
                if (textToken) {
                    nodes.push(this.createTextNode(offset, textToken));
                    offset += textToken.length;
                }
                if (entityToken) {
                    nodes.push(this.createEntityNode(offset, entityToken));
                    offset += entityToken.length;
                }
            }
            return nodes;
        },
        /**
	 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (comment) that was
	 *   matched, including its &lt;!-- and --&gt;.
	 * @param {String} commentText The full text of the comment that was matched.
	 */ createCommentNode: function(offset, tagText, commentText) {
            return new Autolinker.htmlParser.CommentNode({
                offset: offset,
                text: tagText,
                comment: Autolinker.Util.trim(commentText)
            });
        },
        /**
	 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} tagText The full text of the tag (element) that was
	 *   matched, including its attributes.
	 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
	 *   be passed to this method as "img".
	 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
	 *   otherwise.
	 * @return {Autolinker.htmlParser.ElementNode}
	 */ createElementNode: function(offset, tagText, tagName, isClosingTag) {
            return new Autolinker.htmlParser.ElementNode({
                offset: offset,
                text: tagText,
                tagName: tagName.toLowerCase(),
                closing: isClosingTag
            });
        },
        /**
	 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched for the HTML entity (such
	 *   as '&amp;nbsp;').
	 * @return {Autolinker.htmlParser.EntityNode}
	 */ createEntityNode: function(offset, text) {
            return new Autolinker.htmlParser.EntityNode({
                offset: offset,
                text: text
            });
        },
        /**
	 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
	 *
	 * @private
	 * @param {Number} offset The offset of the match within the original HTML
	 *   string.
	 * @param {String} text The text that was matched.
	 * @return {Autolinker.htmlParser.TextNode}
	 */ createTextNode: function(offset, text) {
            return new Autolinker.htmlParser.TextNode({
                offset: offset,
                text: text
            });
        }
    });
    /*global Autolinker */ /**
 * @abstract
 * @class Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML node found in an input string. An HTML node is one of the
 * following:
 *
 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
 *    HTML tags.
 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
 *    HTML comments.
 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
 *    outside or within HTML tags.
 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
 *    one of the known HTML entities that Autolinker looks for. This includes
 *    common ones such as &amp;quot; and &amp;nbsp;
 */ Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of the HTML node in the original text that was parsed.
	 */ offset: undefined,
        /**
	 * @cfg {String} text (required)
	 *
	 * The text that was matched for the HtmlNode.
	 *
	 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
	 *   this will be the tag's text.
	 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
	 *   this will be the comment's text.
	 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
	 *   will be the text itself.
	 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
	 *   this will be the text of the HTML entity.
	 */ text: undefined,
        /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 * specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.Util.assign(this, cfg);
            if (this.offset == null) throw new Error("`offset` cfg required");
            if (this.text == null) throw new Error("`text` cfg required");
        },
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */ getType: Autolinker.Util.abstractMethod,
        /**
	 * Retrieves the {@link #offset} of the HtmlNode. This is the offset of the
	 * HTML node in the original string that was parsed.
	 *
	 * @return {Number}
	 */ getOffset: function() {
            return this.offset;
        },
        /**
	 * Retrieves the {@link #text} for the HtmlNode.
	 *
	 * @return {String}
	 */ getText: function() {
            return this.text;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.CommentNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML comment node that has been parsed by the
 * {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.CommentNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * @cfg {String} comment (required)
	 *
	 * The text inside the comment tag. This text is stripped of any leading or
	 * trailing whitespace.
	 */ comment: "",
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "comment";
        },
        /**
	 * Returns the comment inside the comment tag.
	 *
	 * @return {String}
	 */ getComment: function() {
            return this.comment;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.ElementNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.ElementNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * @cfg {String} tagName (required)
	 *
	 * The name of the tag that was matched.
	 */ tagName: "",
        /**
	 * @cfg {Boolean} closing (required)
	 *
	 * `true` if the element (tag) is a closing tag, `false` if its an opening
	 * tag.
	 */ closing: false,
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "element";
        },
        /**
	 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
	 * returns "img".
	 *
	 * @return {String}
	 */ getTagName: function() {
            return this.tagName;
        },
        /**
	 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
	 * returns `false`, while &lt;/div&gt; returns `true`.
	 *
	 * @return {Boolean}
	 */ isClosing: function() {
            return this.closing;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.EntityNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
 * method.
 *
 * Note that this class will only be returned from the HtmlParser for the set of
 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.EntityNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "entity";
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.htmlParser.TextNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */ Autolinker.htmlParser.TextNode = Autolinker.Util.extend(Autolinker.htmlParser.HtmlNode, {
        /**
	 * Returns a string name for the type of node that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "text";
        }
    });
    /*global Autolinker */ /**
 * @abstract
 * @class Autolinker.match.Match
 *
 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
 *
 * For example:
 *
 *     var input = "...";  // string with URLs, Email Addresses, and Twitter Handles
 *
 *     var linkedText = Autolinker.link( input, {
 *         replaceFn : function( autolinker, match ) {
 *             console.log( "href = ", match.getAnchorHref() );
 *             console.log( "text = ", match.getAnchorText() );
 *
 *             switch( match.getType() ) {
 *                 case 'url' :
 *                     console.log( "url: ", match.getUrl() );
 *
 *                 case 'email' :
 *                     console.log( "email: ", match.getEmail() );
 *
 *                 case 'twitter' :
 *                     console.log( "twitter: ", match.getTwitterHandle() );
 *             }
 *         }
 *     } );
 *
 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
 */ Autolinker.match.Match = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate an anchor
	 * tag for the Match.
	 */ /**
	 * @cfg {String} matchedText (required)
	 *
	 * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
	 */ /**
	 * @cfg {Number} offset (required)
	 *
	 * The offset of where the match was made in the input string.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            if (cfg.tagBuilder == null) throw new Error("`tagBuilder` cfg required");
            if (cfg.matchedText == null) throw new Error("`matchedText` cfg required");
            if (cfg.offset == null) throw new Error("`offset` cfg required");
            this.tagBuilder = cfg.tagBuilder;
            this.matchedText = cfg.matchedText;
            this.offset = cfg.offset;
        },
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @abstract
	 * @return {String}
	 */ getType: Autolinker.Util.abstractMethod,
        /**
	 * Returns the original text that was matched.
	 *
	 * @return {String}
	 */ getMatchedText: function() {
            return this.matchedText;
        },
        /**
	 * Sets the {@link #offset} of where the match was made in the input string.
	 *
	 * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
	 * and will therefore set an original offset that is relative to the HTML
	 * text node itself. However, we want this offset to be relative to the full
	 * HTML input string, and thus if using {@link Autolinker#parse} (rather
	 * than calling a {@link Autolinker.matcher.Matcher} directly), then this
	 * offset is corrected after the Matcher itself has done its job.
	 *
	 * @param {Number} offset
	 */ setOffset: function(offset) {
            this.offset = offset;
        },
        /**
	 * Returns the offset of where the match was made in the input string. This
	 * is the 0-based index of the match.
	 *
	 * @return {Number}
	 */ getOffset: function() {
            return this.offset;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */ getAnchorHref: Autolinker.Util.abstractMethod,
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @abstract
	 * @return {String}
	 */ getAnchorText: Autolinker.Util.abstractMethod,
        /**
	 * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
	 * Match.
	 *
	 * This can be used to easily generate anchor tags from matches, and either
	 * return their HTML string, or modify them before doing so.
	 *
	 * Example Usage:
	 *
	 *     var tag = match.buildTag();
	 *     tag.addClass( 'cordova-link' );
	 *     tag.setAttr( 'target', '_system' );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
	 */ buildTag: function() {
            return this.tagBuilder.build(this);
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Email
 * @extends Autolinker.match.Match
 *
 * Represents a Email match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */ Autolinker.match.Email = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} email (required)
	 *
	 * The email address that was matched.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (!cfg.email) throw new Error("`email` cfg required");
            this.email = cfg.email;
        },
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "email";
        },
        /**
	 * Returns the email address that was matched.
	 *
	 * @return {String}
	 */ getEmail: function() {
            return this.email;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            return "mailto:" + this.email;
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return this.email;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Hashtag
 * @extends Autolinker.match.Match
 *
 * Represents a Hashtag match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */ Autolinker.match.Hashtag = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */ /**
	 * @cfg {String} hashtag (required)
	 *
	 * The Hashtag that was matched, without the '#'.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            // TODO: if( !serviceName ) throw new Error( '`serviceName` cfg required' );
            if (!cfg.hashtag) throw new Error("`hashtag` cfg required");
            this.serviceName = cfg.serviceName;
            this.hashtag = cfg.hashtag;
        },
        /**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "hashtag";
        },
        /**
	 * Returns the configured {@link #serviceName} to point the Hashtag to.
	 * Ex: 'facebook', 'twitter'.
	 *
	 * @return {String}
	 */ getServiceName: function() {
            return this.serviceName;
        },
        /**
	 * Returns the matched hashtag, without the '#' character.
	 *
	 * @return {String}
	 */ getHashtag: function() {
            return this.hashtag;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            var serviceName = this.serviceName, hashtag = this.hashtag;
            switch(serviceName){
                case "twitter":
                    return "https://twitter.com/hashtag/" + hashtag;
                case "facebook":
                    return "https://www.facebook.com/hashtag/" + hashtag;
                case "instagram":
                    return "https://instagram.com/explore/tags/" + hashtag;
                default:
                    throw new Error("Unknown service name to point hashtag to: ", serviceName);
            }
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return "#" + this.hashtag;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Phone
 * @extends Autolinker.match.Match
 *
 * Represents a Phone number match found in an input string which should be
 * Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more
 * details.
 */ Autolinker.match.Phone = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @protected
	 * @property {String} number (required)
	 *
	 * The phone number that was matched, without any delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 */ /**
	 * @protected
	 * @property  {Boolean} plusSign (required)
	 *
	 * `true` if the matched phone number started with a '+' sign. We'll include
	 * it in the `tel:` URL if so, as this is needed for international numbers.
	 *
	 * Ex: '+1 (123) 456 7879'
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (!cfg.number) throw new Error("`number` cfg required");
            if (cfg.plusSign == null) throw new Error("`plusSign` cfg required");
            this.number = cfg.number;
            this.plusSign = cfg.plusSign;
        },
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "phone";
        },
        /**
	 * Returns the phone number that was matched as a string, without any
	 * delimiter characters.
	 *
	 * Note: This is a string to allow for prefixed 0's.
	 *
	 * @return {String}
	 */ getNumber: function() {
            return this.number;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            return "tel:" + (this.plusSign ? "+" : "") + this.number;
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return this.matchedText;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Twitter
 * @extends Autolinker.match.Match
 *
 * Represents a Twitter match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */ Autolinker.match.Twitter = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} twitterHandle (required)
	 *
	 * The Twitter handle that was matched, without the '@' character.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (!cfg.twitterHandle) throw new Error("`twitterHandle` cfg required");
            this.twitterHandle = cfg.twitterHandle;
        },
        /**
	 * Returns the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "twitter";
        },
        /**
	 * Returns the twitter handle, without the '@' character.
	 *
	 * @return {String}
	 */ getTwitterHandle: function() {
            return this.twitterHandle;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            return "https://twitter.com/" + this.twitterHandle;
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            return "@" + this.twitterHandle;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.match.Url
 * @extends Autolinker.match.Match
 *
 * Represents a Url match found in an input string which should be Autolinked.
 *
 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
 */ Autolinker.match.Url = Autolinker.Util.extend(Autolinker.match.Match, {
        /**
	 * @cfg {String} url (required)
	 *
	 * The url that was matched.
	 */ /**
	 * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
	 *
	 * The type of URL match that this class represents. This helps to determine
	 * if the match was made in the original text with a prefixed scheme (ex:
	 * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
	 * was matched by a known top-level domain (ex: 'google.com').
	 */ /**
	 * @cfg {Boolean} protocolUrlMatch (required)
	 *
	 * `true` if the URL is a match which already has a protocol (i.e.
	 * 'http://'), `false` if the match was from a 'www' or known TLD match.
	 */ /**
	 * @cfg {Boolean} protocolRelativeMatch (required)
	 *
	 * `true` if the URL is a protocol-relative match. A protocol-relative match
	 * is a URL that starts with '//', and will be either http:// or https://
	 * based on the protocol that the site is loaded under.
	 */ /**
	 * @cfg {Boolean} stripPrefix (required)
	 * @inheritdoc Autolinker#cfg-stripPrefix
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.match.Match.prototype.constructor.call(this, cfg);
            if (cfg.urlMatchType !== "scheme" && cfg.urlMatchType !== "www" && cfg.urlMatchType !== "tld") throw new Error('`urlMatchType` cfg must be one of: "scheme", "www", or "tld"');
            if (!cfg.url) throw new Error("`url` cfg required");
            if (cfg.protocolUrlMatch == null) throw new Error("`protocolUrlMatch` cfg required");
            if (cfg.protocolRelativeMatch == null) throw new Error("`protocolRelativeMatch` cfg required");
            if (cfg.stripPrefix == null) throw new Error("`stripPrefix` cfg required");
            this.urlMatchType = cfg.urlMatchType;
            this.url = cfg.url;
            this.protocolUrlMatch = cfg.protocolUrlMatch;
            this.protocolRelativeMatch = cfg.protocolRelativeMatch;
            this.stripPrefix = cfg.stripPrefix;
        },
        /**
	 * @private
	 * @property {RegExp} urlPrefixRegex
	 *
	 * A regular expression used to remove the 'http://' or 'https://' and/or the 'www.' from URLs.
	 */ urlPrefixRegex: /^(https?:\/\/)?(www\.)?/i,
        /**
	 * @private
	 * @property {RegExp} protocolRelativeRegex
	 *
	 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
	 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
	 */ protocolRelativeRegex: /^\/\//,
        /**
	 * @private
	 * @property {Boolean} protocolPrepended
	 *
	 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
	 * {@link #url} did not have a protocol)
	 */ protocolPrepended: false,
        /**
	 * Returns a string name for the type of match that this class represents.
	 *
	 * @return {String}
	 */ getType: function() {
            return "url";
        },
        /**
	 * Returns a string name for the type of URL match that this class
	 * represents.
	 *
	 * This helps to determine if the match was made in the original text with a
	 * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
	 * 'www.google.com'), or was matched by a known top-level domain (ex:
	 * 'google.com').
	 *
	 * @return {"scheme"/"www"/"tld"}
	 */ getUrlMatchType: function() {
            return this.urlMatchType;
        },
        /**
	 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
	 * match was missing a protocol.
	 *
	 * @return {String}
	 */ getUrl: function() {
            var url = this.url;
            // if the url string doesn't begin with a protocol, assume 'http://'
            if (!this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended) {
                url = this.url = "http://" + url;
                this.protocolPrepended = true;
            }
            return url;
        },
        /**
	 * Returns the anchor href that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorHref: function() {
            var url = this.getUrl();
            return url.replace(/&amp;/g, "&"); // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
        },
        /**
	 * Returns the anchor text that should be generated for the match.
	 *
	 * @return {String}
	 */ getAnchorText: function() {
            var anchorText = this.getMatchedText();
            if (this.protocolRelativeMatch) // Strip off any protocol-relative '//' from the anchor text
            anchorText = this.stripProtocolRelativePrefix(anchorText);
            if (this.stripPrefix) anchorText = this.stripUrlPrefix(anchorText);
            anchorText = this.removeTrailingSlash(anchorText); // remove trailing slash, if there is one
            return anchorText;
        },
        // ---------------------------------------
        // Utility Functionality
        /**
	 * Strips the URL prefix (such as "http://" or "https://") from the given text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   url prefix (such as stripping off "http://")
	 * @return {String} The `anchorText`, with the prefix stripped.
	 */ stripUrlPrefix: function(text) {
            return text.replace(this.urlPrefixRegex, "");
        },
        /**
	 * Strips any protocol-relative '//' from the anchor text.
	 *
	 * @private
	 * @param {String} text The text of the anchor that is being generated, for which to strip off the
	 *   protocol-relative prefix (such as stripping off "//")
	 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
	 */ stripProtocolRelativePrefix: function(text) {
            return text.replace(this.protocolRelativeRegex, "");
        },
        /**
	 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
	 *
	 * @private
	 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
	 *   slash ('/') that may exist.
	 * @return {String} The `anchorText`, with the trailing slash removed.
	 */ removeTrailingSlash: function(anchorText) {
            if (anchorText.charAt(anchorText.length - 1) === "/") anchorText = anchorText.slice(0, -1);
            return anchorText;
        }
    });
    /*global Autolinker */ /**
 * @abstract
 * @class Autolinker.matcher.Matcher
 *
 * An abstract class and interface for individual matchers to find matches in
 * an input string with linkified versions of them.
 *
 * Note that Matchers do not take HTML into account - they must be fed the text
 * nodes of any HTML string, which is handled by {@link Autolinker#parse}.
 */ Autolinker.matcher.Matcher = Autolinker.Util.extend(Object, {
        /**
	 * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
	 *
	 * Reference to the AnchorTagBuilder instance to use to generate HTML tags
	 * for {@link Autolinker.match.Match Matches}.
	 */ /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Matcher
	 *   instance, specified in an Object (map).
	 */ constructor: function(cfg) {
            if (!cfg.tagBuilder) throw new Error("`tagBuilder` cfg required");
            this.tagBuilder = cfg.tagBuilder;
        },
        /**
	 * Parses the input `text` and returns the array of {@link Autolinker.match.Match Matches}
	 * for the matcher.
	 *
	 * @abstract
	 * @param {String} text The text to scan and replace matches in.
	 * @return {Autolinker.match.Match[]}
	 */ parseMatches: Autolinker.Util.abstractMethod
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Email
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find email matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */ Autolinker.matcher.Email = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * The regular expression to match email addresses. Example match:
	 *
	 *     person@place.com
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: function() {
            var alphaNumericChars = Autolinker.RegexLib.alphaNumericCharsStr, emailRegex = new RegExp("[" + alphaNumericChars + "\\-_';:&=+$.,]+@"), domainNameRegex = Autolinker.RegexLib.domainNameRegex, tldRegex = Autolinker.RegexLib.tldRegex; // match our known top level domains (TLDs)
            return new RegExp([
                emailRegex.source,
                domainNameRegex.source,
                "\\.",
                tldRegex.source // '.com', '.net', etc
            ].join(""), "gi");
        }(),
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var matchedText = match[0];
                matches.push(new Autolinker.match.Email({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: match.index,
                    email: matchedText
                }));
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Hashtag
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Hashtag matches in an input string.
 */ Autolinker.matcher.Hashtag = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * @cfg {String} serviceName
	 *
	 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
	 * for available values.
	 */ /**
	 * The regular expression to match Hashtags. Example match:
	 *
	 *     #asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: new RegExp("#[_" + Autolinker.RegexLib.alphaNumericCharsStr + "]{1,139}", "g"),
        /**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */ nonWordCharRegex: new RegExp("[^" + Autolinker.RegexLib.alphaNumericCharsStr + "]"),
        /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);
            this.serviceName = cfg.serviceName;
        },
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, nonWordCharRegex = this.nonWordCharRegex, serviceName = this.serviceName, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var offset = match.index, prevChar = text.charAt(offset - 1);
                // If we found the match at the beginning of the string, or we found the match
                // and there is a whitespace char in front of it (meaning it is not a '#' char
                // in the middle of a word), then it is a hashtag match.
                if (offset === 0 || nonWordCharRegex.test(prevChar)) {
                    var matchedText = match[0], hashtag = match[0].slice(1); // strip off the '#' character at the beginning
                    matches.push(new Autolinker.match.Hashtag({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: offset,
                        serviceName: serviceName,
                        hashtag: hashtag
                    }));
                }
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Phone
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find Phone number matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more
 * details.
 */ Autolinker.matcher.Phone = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * The regular expression to match Phone numbers. Example match:
	 *
	 *     (123) 456-7890
	 *
	 * This regular expression has the following capturing groups:
	 *
	 * 1. The prefixed '+' sign, if there is one.
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: /(?:(\+)?\d{1,3}[-\040.])?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]\d{4}/g,
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                // Remove non-numeric values from phone number string
                var matchedText = match[0], cleanNumber = matchedText.replace(/\D/g, ""), plusSign = !!match[1]; // match[ 1 ] is the prefixed plus sign, if there is one
                matches.push(new Autolinker.match.Phone({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: match.index,
                    number: cleanNumber,
                    plusSign: plusSign
                }));
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Twitter
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find/replace username matches in an input string.
 */ Autolinker.matcher.Twitter = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * The regular expression to match username handles. Example match:
	 *
	 *     @asdf
	 *
	 * @private
	 * @property {RegExp} matcherRegex
	 */ matcherRegex: new RegExp("@[_" + Autolinker.RegexLib.alphaNumericCharsStr + "]{1,20}", "g"),
        /**
	 * The regular expression to use to check the character before a username match to
	 * make sure we didn't accidentally match an email address.
	 *
	 * For example, the string "asdf@asdf.com" should not match "@asdf" as a username.
	 *
	 * @private
	 * @property {RegExp} nonWordCharRegex
	 */ nonWordCharRegex: new RegExp("[^" + Autolinker.RegexLib.alphaNumericCharsStr + "]"),
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, nonWordCharRegex = this.nonWordCharRegex, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var offset = match.index, prevChar = text.charAt(offset - 1);
                // If we found the match at the beginning of the string, or we found the match
                // and there is a whitespace char in front of it (meaning it is not an email
                // address), then it is a username match.
                if (offset === 0 || nonWordCharRegex.test(prevChar)) {
                    var matchedText = match[0], twitterHandle = match[0].slice(1); // strip off the '@' character at the beginning
                    matches.push(new Autolinker.match.Twitter({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: offset,
                        twitterHandle: twitterHandle
                    }));
                }
            }
            return matches;
        }
    });
    /*global Autolinker */ /**
 * @class Autolinker.matcher.Url
 * @extends Autolinker.matcher.Matcher
 *
 * Matcher to find URL matches in an input string.
 *
 * See this class's superclass ({@link Autolinker.matcher.Matcher}) for more details.
 */ Autolinker.matcher.Url = Autolinker.Util.extend(Autolinker.matcher.Matcher, {
        /**
	 * @cfg {Boolean} stripPrefix (required)
	 * @inheritdoc Autolinker#stripPrefix
	 */ /**
	 * @private
	 * @property {RegExp} matcherRegex
	 *
	 * The regular expression to match URLs with an optional scheme, port
	 * number, path, query string, and hash anchor.
	 *
	 * Example matches:
	 *
	 *     http://google.com
	 *     www.google.com
	 *     google.com/path/to/file?q1=1&q2=2#myAnchor
	 *
	 *
	 * This regular expression will have the following capturing groups:
	 *
	 * 1.  Group that matches a scheme-prefixed URL (i.e. 'http://google.com').
	 *     This is used to match scheme URLs with just a single word, such as
	 *     'http://localhost', where we won't double check that the domain name
	 *     has at least one dot ('.') in it.
	 * 2.  Group that matches a 'www.' prefixed URL. This is only matched if the
	 *     'www.' text was not prefixed by a scheme (i.e.: not prefixed by
	 *     'http://', 'ftp:', etc.)
	 * 3.  A protocol-relative ('//') match for the case of a 'www.' prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     We need to know the character before the '//' in order to determine
	 *     if it is a valid match or the // was in a string we don't want to
	 *     auto-link.
	 * 4.  Group that matches a known TLD (top level domain), when a scheme
	 *     or 'www.'-prefixed domain is not matched.
	 * 5.  A protocol-relative ('//') match for the case of a known TLD prefixed
	 *     URL. Will be an empty string if it is not a protocol-relative match.
	 *     See #3 for more info.
	 */ matcherRegex: function() {
            var schemeRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/, wwwRegex = /(?:www\.)/, domainNameRegex = Autolinker.RegexLib.domainNameRegex, tldRegex = Autolinker.RegexLib.tldRegex, alphaNumericCharsStr = Autolinker.RegexLib.alphaNumericCharsStr, // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
            // http://blog.codinghorror.com/the-problem-with-urls/
            urlSuffixRegex = new RegExp("[" + alphaNumericCharsStr + "\\-+&@#/%=~_()|'$*\\[\\]?!:,.;]*[" + alphaNumericCharsStr + "\\-+&@#/%=~_()|'$*\\[\\]]");
            return new RegExp([
                "(?:",
                "(",
                schemeRegex.source,
                domainNameRegex.source,
                ")",
                "|",
                "(",
                "(//)?",
                wwwRegex.source,
                domainNameRegex.source,
                ")",
                "|",
                "(",
                "(//)?",
                domainNameRegex.source + "\\.",
                tldRegex.source,
                ")",
                ")",
                "(?:" + urlSuffixRegex.source + ")?" // match for path, query string, and/or hash anchor - optional
            ].join(""), "gi");
        }(),
        /**
	 * A regular expression to use to check the character before a protocol-relative
	 * URL match. We don't want to match a protocol-relative URL if it is part
	 * of another word.
	 *
	 * For example, we want to match something like "Go to: //google.com",
	 * but we don't want to match something like "abc//google.com"
	 *
	 * This regular expression is used to test the character before the '//'.
	 *
	 * @private
	 * @type {RegExp} wordCharRegExp
	 */ wordCharRegExp: /\w/,
        /**
	 * The regular expression to match opening parenthesis in a URL match.
	 *
	 * This is to determine if we have unbalanced parenthesis in the URL, and to
	 * drop the final parenthesis that was matched if so.
	 *
	 * Ex: The text "(check out: wikipedia.com/something_(disambiguation))"
	 * should only autolink the inner "wikipedia.com/something_(disambiguation)"
	 * part, so if we find that we have unbalanced parenthesis, we will drop the
	 * last one for the match.
	 *
	 * @private
	 * @property {RegExp}
	 */ openParensRe: /\(/g,
        /**
	 * The regular expression to match closing parenthesis in a URL match. See
	 * {@link #openParensRe} for more information.
	 *
	 * @private
	 * @property {RegExp}
	 */ closeParensRe: /\)/g,
        /**
	 * @constructor
	 * @param {Object} cfg The configuration properties for the Match instance,
	 *   specified in an Object (map).
	 */ constructor: function(cfg) {
            Autolinker.matcher.Matcher.prototype.constructor.call(this, cfg);
            this.stripPrefix = cfg.stripPrefix;
            if (this.stripPrefix == null) throw new Error("`stripPrefix` cfg required");
        },
        /**
	 * @inheritdoc
	 */ parseMatches: function(text) {
            var matcherRegex = this.matcherRegex, stripPrefix = this.stripPrefix, tagBuilder = this.tagBuilder, matches = [], match;
            while((match = matcherRegex.exec(text)) !== null){
                var matchStr = match[0], schemeUrlMatch = match[1], wwwUrlMatch = match[2], wwwProtocolRelativeMatch = match[3], //tldUrlMatch = match[ 4 ],  -- not needed at the moment
                tldProtocolRelativeMatch = match[5], offset = match.index, protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch, prevChar = text.charAt(offset - 1);
                if (!Autolinker.matcher.UrlMatchValidator.isValid(matchStr, schemeUrlMatch)) continue;
                // If the match is preceded by an '@' character, then it is either
                // an email address or a username. Skip these types of matches.
                if (offset > 0 && prevChar === "@") continue;
                // If it's a protocol-relative '//' match, but the character before the '//'
                // was a word character (i.e. a letter/number), then we found the '//' in the
                // middle of another word (such as "asdf//asdf.com"). In this case, skip the
                // match.
                if (offset > 0 && protocolRelativeMatch && this.wordCharRegExp.test(prevChar)) continue;
                // Handle a closing parenthesis at the end of the match, and exclude
                // it if there is not a matching open parenthesis in the match
                // itself.
                if (this.matchHasUnbalancedClosingParen(matchStr)) matchStr = matchStr.substr(0, matchStr.length - 1); // remove the trailing ")"
                else {
                    // Handle an invalid character after the TLD
                    var pos = this.matchHasInvalidCharAfterTld(matchStr, schemeUrlMatch);
                    if (pos > -1) matchStr = matchStr.substr(0, pos); // remove the trailing invalid chars
                }
                var urlMatchType = schemeUrlMatch ? "scheme" : wwwUrlMatch ? "www" : "tld", protocolUrlMatch = !!schemeUrlMatch;
                matches.push(new Autolinker.match.Url({
                    tagBuilder: tagBuilder,
                    matchedText: matchStr,
                    offset: offset,
                    urlMatchType: urlMatchType,
                    url: matchStr,
                    protocolUrlMatch: protocolUrlMatch,
                    protocolRelativeMatch: !!protocolRelativeMatch,
                    stripPrefix: stripPrefix
                }));
            }
            return matches;
        },
        /**
	 * Determines if a match found has an unmatched closing parenthesis. If so,
	 * this parenthesis will be removed from the match itself, and appended
	 * after the generated anchor tag.
	 *
	 * A match may have an extra closing parenthesis at the end of the match
	 * because the regular expression must include parenthesis for URLs such as
	 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
	 *
	 * However, an extra parenthesis *will* be included when the URL itself is
	 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
	 * In this case, the last closing parenthesis should *not* be part of the
	 * URL itself, and this method will return `true`.
	 *
	 * @private
	 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
	 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
	 *   the end of the `matchStr`, `false` otherwise.
	 */ matchHasUnbalancedClosingParen: function(matchStr) {
            var lastChar = matchStr.charAt(matchStr.length - 1);
            if (lastChar === ")") {
                var openParensMatch = matchStr.match(this.openParensRe), closeParensMatch = matchStr.match(this.closeParensRe), numOpenParens = openParensMatch && openParensMatch.length || 0, numCloseParens = closeParensMatch && closeParensMatch.length || 0;
                if (numOpenParens < numCloseParens) return true;
            }
            return false;
        },
        /**
	 * Determine if there's an invalid character after the TLD in a URL. Valid
	 * characters after TLD are ':/?#'. Exclude scheme matched URLs from this
	 * check.
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} schemeUrlMatch The match URL string for a scheme
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Number} the position where the invalid character was found. If
	 *   no such character was found, returns -1
	 */ matchHasInvalidCharAfterTld: function(urlMatch, schemeUrlMatch) {
            if (!urlMatch) return -1;
            var offset = 0;
            if (schemeUrlMatch) {
                offset = urlMatch.indexOf(":");
                urlMatch = urlMatch.slice(offset);
            }
            var re = /^((.?\/\/)?[A-Za-z0-9\u00C0-\u017F\.\-]*[A-Za-z0-9\u00C0-\u017F\-]\.[A-Za-z]+)/;
            var res = re.exec(urlMatch);
            if (res === null) return -1;
            offset += res[1].length;
            urlMatch = urlMatch.slice(res[1].length);
            if (/^[^.A-Za-z:\/?#]/.test(urlMatch)) return offset;
            return -1;
        }
    });
    /*global Autolinker */ /*jshint scripturl:true */ /**
 * @private
 * @class Autolinker.matcher.UrlMatchValidator
 * @singleton
 *
 * Used by Autolinker to filter out false URL positives from the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 *
 * Due to the limitations of regular expressions (including the missing feature
 * of look-behinds in JS regular expressions), we cannot always determine the
 * validity of a given match. This class applies a bit of additional logic to
 * filter out any false positives that have been matched by the
 * {@link Autolinker.matcher.Url UrlMatcher}.
 */ Autolinker.matcher.UrlMatchValidator = {
        /**
	 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
	 *
	 * @private
	 * @property {RegExp} hasFullProtocolRegex
	 */ hasFullProtocolRegex: /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,
        /**
	 * Regex to find the URI scheme, such as 'mailto:'.
	 *
	 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
	 *
	 * @private
	 * @property {RegExp} uriSchemeRegex
	 */ uriSchemeRegex: /^[A-Za-z][-.+A-Za-z0-9]*:/,
        /**
	 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
	 *
	 * @private
	 * @property {RegExp} hasWordCharAfterProtocolRegex
	 */ hasWordCharAfterProtocolRegex: /:[^\s]*?[A-Za-z\u00C0-\u017F]/,
        /**
	 * Regex to determine if the string is a valid IP address
	 *
	 * @private
	 * @property {RegExp} ipRegex
	 */ ipRegex: /[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?\.[0-9][0-9]?[0-9]?(:[0-9]*)?\/?$/,
        /**
	 * Determines if a given URL match found by the {@link Autolinker.matcher.Url UrlMatcher}
	 * is valid. Will return `false` for:
	 *
	 * 1) URL matches which do not have at least have one period ('.') in the
	 *    domain name (effectively skipping over matches like "abc:def").
	 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
	 * 2) URL matches which do not have at least one word character in the
	 *    domain name (effectively skipping over matches like "git:1.0").
	 * 3) A protocol-relative url match (a URL beginning with '//') whose
	 *    previous character is a word character (effectively skipping over
	 *    strings like "abc//google.com")
	 *
	 * Otherwise, returns `true`.
	 *
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the match given is valid and should be
	 *   processed, or `false` if the match is invalid and/or should just not be
	 *   processed.
	 */ isValid: function(urlMatch, protocolUrlMatch) {
            if (protocolUrlMatch && !this.isValidUriScheme(protocolUrlMatch) || this.urlMatchDoesNotHaveProtocolOrDot(urlMatch, protocolUrlMatch) || // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
            this.urlMatchDoesNotHaveAtLeastOneWordChar(urlMatch, protocolUrlMatch) && // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
            !this.isValidIpAddress(urlMatch) // Except if it's an IP address
            ) return false;
            return true;
        },
        isValidIpAddress: function(uriSchemeMatch) {
            var newRegex = new RegExp(this.hasFullProtocolRegex.source + this.ipRegex.source);
            var uriScheme = uriSchemeMatch.match(newRegex);
            return uriScheme !== null;
        },
        /**
	 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
	 * `false` if the scheme is 'javascript:' or 'vbscript:'
	 *
	 * @private
	 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
	 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
	 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
	 */ isValidUriScheme: function(uriSchemeMatch) {
            var uriScheme = uriSchemeMatch.match(this.uriSchemeRegex)[0].toLowerCase();
            return uriScheme !== "javascript:" && uriScheme !== "vbscript:";
        },
        /**
	 * Determines if a URL match does not have either:
	 *
	 * a) a full protocol (i.e. 'http://'), or
	 * b) at least one dot ('.') in the domain name (for a non-full-protocol
	 *    match).
	 *
	 * Either situation is considered an invalid URL (ex: 'git:d' does not have
	 * either the '://' part, or at least one dot in the domain name. If the
	 * match was 'git:abc.com', we would consider this valid.)
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to match something like
	 *   'http://localhost', where we won't double check that the domain name
	 *   has at least one '.' in it.
	 * @return {Boolean} `true` if the URL match does not have a full protocol,
	 *   or at least one dot ('.') in a non-full-protocol match.
	 */ urlMatchDoesNotHaveProtocolOrDot: function(urlMatch, protocolUrlMatch) {
            return !!urlMatch && (!protocolUrlMatch || !this.hasFullProtocolRegex.test(protocolUrlMatch)) && urlMatch.indexOf(".") === -1;
        },
        /**
	 * Determines if a URL match does not have at least one word character after
	 * the protocol (i.e. in the domain name).
	 *
	 * At least one letter character must exist in the domain name after a
	 * protocol match. Ex: skip over something like "git:1.0"
	 *
	 * @private
	 * @param {String} urlMatch The matched URL, if there was one. Will be an
	 *   empty string if the match is not a URL match.
	 * @param {String} protocolUrlMatch The match URL string for a protocol
	 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
	 *   have a protocol in the URL string, in order to check for a word
	 *   character after the protocol separator (':').
	 * @return {Boolean} `true` if the URL match does not have at least one word
	 *   character in it after the protocol, `false` otherwise.
	 */ urlMatchDoesNotHaveAtLeastOneWordChar: function(urlMatch, protocolUrlMatch) {
            if (urlMatch && protocolUrlMatch) return !this.hasWordCharAfterProtocolRegex.test(urlMatch);
            else return false;
        }
    };
    /*global Autolinker */ /**
 * A truncation feature where the ellipsis will be placed at the end of the URL.
 *
 * @param {String} anchorText
 * @param {Number} truncateLen The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */ Autolinker.truncate.TruncateEnd = function(anchorText, truncateLen, ellipsisChars) {
        return Autolinker.Util.ellipsis(anchorText, truncateLen, ellipsisChars);
    };
    /*global Autolinker */ /**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
 *
 * @param {String} url             A URL.
 * @param {Number} truncateLen     The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */ Autolinker.truncate.TruncateMiddle = function(url, truncateLen, ellipsisChars) {
        if (url.length <= truncateLen) return url;
        var availableLength = truncateLen - ellipsisChars.length;
        var end = "";
        if (availableLength > 0) end = url.substr(-1 * Math.floor(availableLength / 2));
        return (url.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, truncateLen);
    };
    /*global Autolinker */ /**
 * Date: 2015-10-05
 * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
 *
 * A truncation feature, where the ellipsis will be placed at a section within
 * the URL making it still somewhat human readable.
 *
 * @param {String} url						 A URL.
 * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
 * @param {String} ellipsisChars	 The characters to place within the url, e.g. "..".
 * @return {String} The truncated URL.
 */ Autolinker.truncate.TruncateSmart = function(url, truncateLen, ellipsisChars) {
        var parse_url = function(url) {
            var urlObj = {};
            var urlSub = url;
            var match = urlSub.match(/^([a-z]+):\/\//i);
            if (match) {
                urlObj.scheme = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
            if (match) {
                urlObj.host = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
            if (match) {
                urlObj.path = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
            if (match) {
                urlObj.query = match[1];
                urlSub = urlSub.substr(match[0].length);
            }
            match = urlSub.match(/^#(.*?)$/i);
            if (match) urlObj.fragment = match[1];
            return urlObj;
        };
        var buildUrl = function(urlObj) {
            var url = "";
            if (urlObj.scheme && urlObj.host) url += urlObj.scheme + "://";
            if (urlObj.host) url += urlObj.host;
            if (urlObj.path) url += "/" + urlObj.path;
            if (urlObj.query) url += "?" + urlObj.query;
            if (urlObj.fragment) url += "#" + urlObj.fragment;
            return url;
        };
        var buildSegment = function(segment, remainingAvailableLength) {
            var remainingAvailableLengthHalf = remainingAvailableLength / 2, startOffset = Math.ceil(remainingAvailableLengthHalf), endOffset = -1 * Math.floor(remainingAvailableLengthHalf), end = "";
            if (endOffset < 0) end = segment.substr(endOffset);
            return segment.substr(0, startOffset) + ellipsisChars + end;
        };
        if (url.length <= truncateLen) return url;
        var availableLength = truncateLen - ellipsisChars.length;
        var urlObj = parse_url(url);
        // Clean up the URL
        if (urlObj.query) {
            var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|\#))(.*?)$/i);
            if (matchQuery) {
                // Malformed URL; two or more "?". Removed any content behind the 2nd.
                urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
                url = buildUrl(urlObj);
            }
        }
        if (url.length <= truncateLen) return url;
        if (urlObj.host) {
            urlObj.host = urlObj.host.replace(/^www\./, "");
            url = buildUrl(urlObj);
        }
        if (url.length <= truncateLen) return url;
        // Process and build the URL
        var str = "";
        if (urlObj.host) str += urlObj.host;
        if (str.length >= availableLength) {
            if (urlObj.host.length == truncateLen) return (urlObj.host.substr(0, truncateLen - ellipsisChars.length) + ellipsisChars).substr(0, truncateLen);
            return buildSegment(str, availableLength).substr(0, truncateLen);
        }
        var pathAndQuery = "";
        if (urlObj.path) pathAndQuery += "/" + urlObj.path;
        if (urlObj.query) pathAndQuery += "?" + urlObj.query;
        if (pathAndQuery) {
            if ((str + pathAndQuery).length >= availableLength) {
                if ((str + pathAndQuery).length == truncateLen) return (str + pathAndQuery).substr(0, truncateLen);
                var remainingAvailableLength = availableLength - str.length;
                return (str + buildSegment(pathAndQuery, remainingAvailableLength)).substr(0, truncateLen);
            } else str += pathAndQuery;
        }
        if (urlObj.fragment) {
            var fragment = "#" + urlObj.fragment;
            if ((str + fragment).length >= availableLength) {
                if ((str + fragment).length == truncateLen) return (str + fragment).substr(0, truncateLen);
                var remainingAvailableLength2 = availableLength - str.length;
                return (str + buildSegment(fragment, remainingAvailableLength2)).substr(0, truncateLen);
            } else str += fragment;
        }
        if (urlObj.scheme && urlObj.host) {
            var scheme = urlObj.scheme + "://";
            if ((str + scheme).length < availableLength) return (scheme + str).substr(0, truncateLen);
        }
        if (str.length <= truncateLen) return str;
        var end = "";
        if (availableLength > 0) end = str.substr(-1 * Math.floor(availableLength / 2));
        return (str.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, truncateLen);
    };
    return Autolinker;
});

});



parcelRequire.register("7K70r", function(module, exports) {
"use strict";

var $1hCjm = parcelRequire("1hCjm");

var $5EVfp = parcelRequire("5EVfp");












/**
 * Parser rules
 */ var $5a324386da8ef958$var$_rules = [
    [
        "code",
        (parcelRequire("lf280"))
    ],
    [
        "fences",
        (parcelRequire("i2zdx")),
        [
            "paragraph",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (parcelRequire("3TYOt")),
        [
            "paragraph",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (parcelRequire("8QWKV")),
        [
            "paragraph",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (parcelRequire("gI5rZ")),
        [
            "paragraph",
            "blockquote"
        ]
    ],
    [
        "footnote",
        (parcelRequire("3aPzm")),
        [
            "paragraph"
        ]
    ],
    [
        "heading",
        (parcelRequire("iPNxI")),
        [
            "paragraph",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (parcelRequire("1vYLp"))
    ],
    [
        "htmlblock",
        (parcelRequire("2tzZg")),
        [
            "paragraph",
            "blockquote"
        ]
    ],
    [
        "table",
        (parcelRequire("eunOQ")),
        [
            "paragraph"
        ]
    ],
    [
        "deflist",
        (parcelRequire("a3ipl")),
        [
            "paragraph"
        ]
    ],
    [
        "paragraph",
        (parcelRequire("5yH65"))
    ]
];
/**
 * Block Parser class
 *
 * @api private
 */ function $5a324386da8ef958$var$ParserBlock() {
    this.ruler = new $1hCjm();
    for(var i = 0; i < $5a324386da8ef958$var$_rules.length; i++)this.ruler.push($5a324386da8ef958$var$_rules[i][0], $5a324386da8ef958$var$_rules[i][1], {
        alt: ($5a324386da8ef958$var$_rules[i][2] || []).slice()
    });
}
/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state` Has properties like `src`, `parser`, `options` etc
 * @param  {Number} `startLine`
 * @param  {Number} `endLine`
 * @api private
 */ $5a324386da8ef958$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var rules = this.ruler.getRules("");
    var len = rules.length;
    var line = startLine;
    var hasEmptyLines = false;
    var ok, i;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.tShift[line] < state.blkIndent) break;
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) break;
        }
        // set state.tight iff we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            // two empty lines should stop the parser in list mode
            if (line < endLine && state.parentType === "list" && state.isEmpty(line)) break;
            state.line = line;
        }
    }
};
var $5a324386da8ef958$var$TABS_SCAN_RE = /[\n\t]/g;
var $5a324386da8ef958$var$NEWLINES_RE = /\r[\n\u0085]|[\u2424\u2028\u0085]/g;
var $5a324386da8ef958$var$SPACES_RE = /\u00a0/g;
/**
 * Tokenize the given `str`.
 *
 * @param  {String} `str` Source string
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */ $5a324386da8ef958$var$ParserBlock.prototype.parse = function(str, options, env, outTokens) {
    var state, lineStart = 0, lastTabPos = 0;
    if (!str) return [];
    // Normalize spaces
    str = str.replace($5a324386da8ef958$var$SPACES_RE, " ");
    // Normalize newlines
    str = str.replace($5a324386da8ef958$var$NEWLINES_RE, "\n");
    // Replace tabs with proper number of spaces (1..4)
    if (str.indexOf("	") >= 0) str = str.replace($5a324386da8ef958$var$TABS_SCAN_RE, function(match, offset) {
        var result;
        if (str.charCodeAt(offset) === 0x0A) {
            lineStart = offset + 1;
            lastTabPos = 0;
            return match;
        }
        result = "    ".slice((offset - lineStart - lastTabPos) % 4);
        lastTabPos = offset - lineStart + 1;
        return result;
    });
    state = new $5EVfp(str, this, options, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
/**
 * Expose `ParserBlock`
 */ module.exports = $5a324386da8ef958$var$ParserBlock;

});
parcelRequire.register("5EVfp", function(module, exports) {
// Parser state class
"use strict";
function $41ed185b15366786$var$StateBlock(src, parser, options, env, tokens) {
    var ch, s, start, pos, len, indent, indent_found;
    this.src = src;
    // Shortcuts to simplify nested calls
    this.parser = parser;
    this.options = options;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // indent for each line
    // block parser variables
    this.blkIndent = 0; // required block content indent
    // (for example, if we are in list)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.parentType = "root"; // if `list`, block parser stops on two newlines
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.level = 0;
    // renderer
    this.result = "";
    // Create caches
    // Generate markers.
    s = this.src;
    indent = 0;
    indent_found = false;
    for(start = pos = indent = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if (ch === 0x20 /* space */ ) {
                indent++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            indent_found = false;
            indent = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
$41ed185b15366786$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$41ed185b15366786$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$41ed185b15366786$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== 0x20 /* space */ ) break;
    }
    return pos;
};
// Skip char codes from given position
$41ed185b15366786$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$41ed185b15366786$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$41ed185b15366786$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, first, last, queue, shift, line = begin;
    if (begin >= end) return "";
    // Opt: don't use push queue for single line;
    if (line + 1 === end) {
        first = this.bMarks[line] + Math.min(this.tShift[line], indent);
        last = keepLastLF ? this.eMarks[line] + 1 : this.eMarks[line];
        return this.src.slice(first, last);
    }
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        shift = this.tShift[line];
        if (shift > indent) shift = indent;
        if (shift < 0) shift = 0;
        first = this.bMarks[line] + shift;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
module.exports = $41ed185b15366786$var$StateBlock;

});

parcelRequire.register("lf280", function(module, exports) {
// Code block (4 spaces padded)
"use strict";
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last;
    if (state.tShift[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.tShift[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = nextLine;
    state.tokens.push({
        type: "code",
        content: state.getLines(startLine, last, 4 + state.blkIndent, true),
        block: true,
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    return true;
};

});

parcelRequire.register("i2zdx", function(module, exports) {
// fences (``` lang, ~~~ lang)
"use strict";
module.exports = function fences(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    params = state.src.slice(pos, max).trim();
    if (params.indexOf("`") >= 0) return false;
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.tShift[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.tShift[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.tShift[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    state.tokens.push({
        type: "fence",
        params: params,
        content: state.getLines(startLine + 1, nextLine, len, true),
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    return true;
};

});

parcelRequire.register("3TYOt", function(module, exports) {
// Block quotes
"use strict";
module.exports = function blockquote(state, startLine, endLine, silent) {
    var nextLine, lastLineEmpty, oldTShift, oldBMarks, oldIndent, oldParentType, lines, terminatorRules, i, l, terminate, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos > max) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos++) !== 0x3E /* > */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    // skip one optional space after '>'
    if (state.src.charCodeAt(pos) === 0x20) pos++;
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    oldBMarks = [
        state.bMarks[startLine]
    ];
    state.bMarks[startLine] = pos;
    // check if we have an empty blockquote
    pos = pos < max ? state.skipSpaces(pos) : pos;
    lastLineEmpty = pos >= max;
    oldTShift = [
        state.tShift[startLine]
    ];
    state.tShift[startLine] = pos - state.bMarks[startLine];
    terminatorRules = state.parser.ruler.getRules("blockquote");
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine + 1; nextLine < endLine; nextLine++){
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */ ) {
            // This line is inside the blockquote.
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20) pos++;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            pos = pos < max ? state.skipSpaces(pos) : pos;
            lastLineEmpty = pos >= max;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        oldBMarks.push(state.bMarks[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        // A negative number means that this is a paragraph continuation;
        //
        // Any negative number will do the job here, but it's better for it
        // to be large enough to make any bugs obvious.
        state.tShift[nextLine] = -1337;
    }
    oldParentType = state.parentType;
    state.parentType = "blockquote";
    state.tokens.push({
        type: "blockquote_open",
        lines: lines = [
            startLine,
            0
        ],
        level: state.level++
    });
    state.parser.tokenize(state, startLine, nextLine);
    state.tokens.push({
        type: "blockquote_close",
        level: --state.level
    });
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRequire.register("8QWKV", function(module, exports) {
// Horizontal rule
"use strict";
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, pos = state.bMarks[startLine], max = state.eMarks[startLine];
    pos += state.tShift[startLine];
    if (pos > max) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 one
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && ch !== 0x20 /* space */ ) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    state.tokens.push({
        type: "hr",
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    return true;
};

});

parcelRequire.register("gI5rZ", function(module, exports) {
// Lists
"use strict";
// Search `[-+*][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function $c2a4fbc058faefee$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    if (pos >= max) return -1;
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max && state.src.charCodeAt(pos) !== 0x20) // " 1.test " - is not a list item
    return -1;
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function $c2a4fbc058faefee$var$skipOrderedListMarker(state, startLine) {
    var ch, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) continue;
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max && state.src.charCodeAt(pos) !== 0x20 /* space */ ) // " 1.test " - is not a list item
    return -1;
    return pos;
}
function $c2a4fbc058faefee$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].tight = true;
        state.tokens[i].tight = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var nextLine, indent, oldTShift, oldIndent, oldTight, oldParentType, start, posAfterMarker, max, indentAfterMarker, markerValue, markerCharCode, isOrdered, contentStart, listTokIdx, prevEmptyEnd, listLines, itemLines, tight = true, terminatorRules, i, l, terminate;
    // Detect list type and position after marker
    if ((posAfterMarker = $c2a4fbc058faefee$var$skipOrderedListMarker(state, startLine)) >= 0) isOrdered = true;
    else if ((posAfterMarker = $c2a4fbc058faefee$var$skipBulletListMarker(state, startLine)) >= 0) isOrdered = false;
    else return false;
    if (state.level >= state.options.maxNesting) return false;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // For validation mode we can terminate immediately
    if (silent) return true;
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        start = state.bMarks[startLine] + state.tShift[startLine];
        markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));
        state.tokens.push({
            type: "ordered_list_open",
            order: markerValue,
            lines: listLines = [
                startLine,
                0
            ],
            level: state.level++
        });
    } else state.tokens.push({
        type: "bullet_list_open",
        lines: listLines = [
            startLine,
            0
        ],
        level: state.level++
    });
    //
    // Iterate list items
    //
    nextLine = startLine;
    prevEmptyEnd = false;
    terminatorRules = state.parser.ruler.getRules("list");
    while(nextLine < endLine){
        contentStart = state.skipSpaces(posAfterMarker);
        max = state.eMarks[nextLine];
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = contentStart - posAfterMarker;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // If indent is less than 1, assume that it's one, example:
        //  "-\n  test"
        if (indentAfterMarker < 1) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = posAfterMarker - state.bMarks[nextLine] + indentAfterMarker;
        // Run subparser & write tokens
        state.tokens.push({
            type: "list_item_open",
            lines: itemLines = [
                startLine,
                0
            ],
            level: state.level++
        });
        oldIndent = state.blkIndent;
        oldTight = state.tight;
        oldTShift = state.tShift[startLine];
        oldParentType = state.parentType;
        state.tShift[startLine] = contentStart - state.bMarks[startLine];
        state.blkIndent = indent;
        state.tight = true;
        state.parentType = "list";
        state.parser.tokenize(state, startLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - startLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = oldIndent;
        state.tShift[startLine] = oldTShift;
        state.tight = oldTight;
        state.parentType = oldParentType;
        state.tokens.push({
            type: "list_item_close",
            level: --state.level
        });
        nextLine = startLine = state.line;
        itemLines[1] = nextLine;
        contentStart = state.bMarks[startLine];
        if (nextLine >= endLine) break;
        if (state.isEmpty(nextLine)) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.tShift[nextLine] < state.blkIndent) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $c2a4fbc058faefee$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        } else {
            posAfterMarker = $c2a4fbc058faefee$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finilize list
    state.tokens.push({
        type: isOrdered ? "ordered_list_close" : "bullet_list_close",
        level: --state.level
    });
    listLines[1] = nextLine;
    state.line = nextLine;
    // mark paragraphs tight if needed
    if (tight) $c2a4fbc058faefee$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRequire.register("3aPzm", function(module, exports) {
// Process footnote reference list
"use strict";
module.exports = function footnote(state, startLine, endLine, silent) {
    var oldBMark, oldTShift, oldParentType, pos, label, start = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // line should be at least 5 chars - "[^x]:"
    if (start + 4 > max) return false;
    if (state.src.charCodeAt(start) !== 0x5B /* [ */ ) return false;
    if (state.src.charCodeAt(start + 1) !== 0x5E /* ^ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    for(pos = start + 2; pos < max; pos++){
        if (state.src.charCodeAt(pos) === 0x20) return false;
        if (state.src.charCodeAt(pos) === 0x5D /* ] */ ) break;
    }
    if (pos === start + 2) return false;
     // no empty footnote labels
    if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 0x3A /* : */ ) return false;
    if (silent) return true;
    pos++;
    if (!state.env.footnotes) state.env.footnotes = {};
    if (!state.env.footnotes.refs) state.env.footnotes.refs = {};
    label = state.src.slice(start + 2, pos - 2);
    state.env.footnotes.refs[":" + label] = -1;
    state.tokens.push({
        type: "footnote_reference_open",
        label: label,
        level: state.level++
    });
    oldBMark = state.bMarks[startLine];
    oldTShift = state.tShift[startLine];
    oldParentType = state.parentType;
    state.tShift[startLine] = state.skipSpaces(pos) - pos;
    state.bMarks[startLine] = pos;
    state.blkIndent += 4;
    state.parentType = "footnote";
    if (state.tShift[startLine] < state.blkIndent) {
        state.tShift[startLine] += state.blkIndent;
        state.bMarks[startLine] -= state.blkIndent;
    }
    state.parser.tokenize(state, startLine, endLine, true);
    state.parentType = oldParentType;
    state.blkIndent -= 4;
    state.tShift[startLine] = oldTShift;
    state.bMarks[startLine] = oldBMark;
    state.tokens.push({
        type: "footnote_reference_close",
        level: --state.level
    });
    return true;
};

});

parcelRequire.register("iPNxI", function(module, exports) {
// heading (#, ##, ...)
"use strict";
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    if (pos >= max) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && ch !== 0x20 /* space */ ) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipCharsBack(max, 0x20, pos); // space
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && state.src.charCodeAt(tmp - 1) === 0x20 /* space */ ) max = tmp;
    state.line = startLine + 1;
    state.tokens.push({
        type: "heading_open",
        hLevel: level,
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    // only if header is not empty
    if (pos < max) state.tokens.push({
        type: "inline",
        content: state.src.slice(pos, max).trim(),
        level: state.level + 1,
        lines: [
            startLine,
            state.line
        ],
        children: []
    });
    state.tokens.push({
        type: "heading_close",
        hLevel: level,
        level: state.level
    });
    return true;
};

});

parcelRequire.register("1vYLp", function(module, exports) {
// lheading (---, ===)
"use strict";
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var marker, pos, max, next = startLine + 1;
    if (next >= endLine) return false;
    if (state.tShift[next] < state.blkIndent) return false;
    // Scan next line
    if (state.tShift[next] - state.blkIndent > 3) return false;
    pos = state.bMarks[next] + state.tShift[next];
    max = state.eMarks[next];
    if (pos >= max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x2D /* - */  && marker !== 0x3D /* = */ ) return false;
    pos = state.skipChars(pos, marker);
    pos = state.skipSpaces(pos);
    if (pos < max) return false;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    state.line = next + 1;
    state.tokens.push({
        type: "heading_open",
        hLevel: marker === 0x3D /* = */  ? 1 : 2,
        lines: [
            startLine,
            state.line
        ],
        level: state.level
    });
    state.tokens.push({
        type: "inline",
        content: state.src.slice(pos, state.eMarks[startLine]).trim(),
        level: state.level + 1,
        lines: [
            startLine,
            state.line - 1
        ],
        children: []
    });
    state.tokens.push({
        type: "heading_close",
        hLevel: marker === 0x3D /* = */  ? 1 : 2,
        level: state.level
    });
    return true;
};

});

parcelRequire.register("2tzZg", function(module, exports) {
// HTML block
"use strict";

var $03rTC = parcelRequire("03rTC");
var $1cda347b9b09e02e$var$HTML_TAG_OPEN_RE = /^<([a-zA-Z]{1,15})[\s\/>]/;
var $1cda347b9b09e02e$var$HTML_TAG_CLOSE_RE = /^<\/([a-zA-Z]{1,15})[\s>]/;
function $1cda347b9b09e02e$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function htmlblock(state, startLine, endLine, silent) {
    var ch, match, nextLine, pos = state.bMarks[startLine], max = state.eMarks[startLine], shift = state.tShift[startLine];
    pos += shift;
    if (!state.options.html) return false;
    if (shift > 3 || pos + 2 >= max) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x21 /* ! */  || ch === 0x3F /* ? */ ) {
        // Directive start / comment start / processing instruction start
        if (silent) return true;
    } else if (ch === 0x2F /* / */  || $1cda347b9b09e02e$var$isLetter(ch)) {
        // Probably start or end of tag
        if (ch === 0x2F /* \ */ ) {
            // closing tag
            match = state.src.slice(pos, max).match($1cda347b9b09e02e$var$HTML_TAG_CLOSE_RE);
            if (!match) return false;
        } else {
            // opening tag
            match = state.src.slice(pos, max).match($1cda347b9b09e02e$var$HTML_TAG_OPEN_RE);
            if (!match) return false;
        }
        // Make sure tag name is valid
        if ($03rTC[match[1].toLowerCase()] !== true) return false;
        if (silent) return true;
    } else return false;
    // If we are here - we detected HTML block.
    // Let's roll down till empty line (block end).
    nextLine = startLine + 1;
    while(nextLine < state.lineMax && !state.isEmpty(nextLine))nextLine++;
    state.line = nextLine;
    state.tokens.push({
        type: "htmlblock",
        level: state.level,
        lines: [
            startLine,
            state.line
        ],
        content: state.getLines(startLine, nextLine, 0, true)
    });
    return true;
};

});
parcelRequire.register("03rTC", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
"use strict";
var $00a5eb7e07ed62e0$var$html_blocks = {};
[
    "article",
    "aside",
    "button",
    "blockquote",
    "body",
    "canvas",
    "caption",
    "col",
    "colgroup",
    "dd",
    "div",
    "dl",
    "dt",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "iframe",
    "li",
    "map",
    "object",
    "ol",
    "output",
    "p",
    "pre",
    "progress",
    "script",
    "section",
    "style",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "tr",
    "thead",
    "ul",
    "video"
].forEach(function(name) {
    $00a5eb7e07ed62e0$var$html_blocks[name] = true;
});
module.exports = $00a5eb7e07ed62e0$var$html_blocks;

});


parcelRequire.register("eunOQ", function(module, exports) {
// GFM table, non-standard
"use strict";
function $a8c658043dff82ad$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, rows, cell, aligns, t, tableLines, tbodyLines;
    // should have at least three lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.tShift[nextLine] < state.blkIndent) return false;
    // first character of the second line should be '|' or '-'
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */ ) return false;
    lineText = $a8c658043dff82ad$var$getLine(state, startLine + 1);
    if (!/^[-:| ]+$/.test(lineText)) return false;
    rows = lineText.split("|");
    if (rows <= 2) return false;
    aligns = [];
    for(i = 0; i < rows.length; i++){
        t = rows[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === rows.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $a8c658043dff82ad$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    rows = lineText.replace(/^\||\|$/g, "").split("|");
    if (aligns.length !== rows.length) return false;
    if (silent) return true;
    state.tokens.push({
        type: "table_open",
        lines: tableLines = [
            startLine,
            0
        ],
        level: state.level++
    });
    state.tokens.push({
        type: "thead_open",
        lines: [
            startLine,
            startLine + 1
        ],
        level: state.level++
    });
    state.tokens.push({
        type: "tr_open",
        lines: [
            startLine,
            startLine + 1
        ],
        level: state.level++
    });
    for(i = 0; i < rows.length; i++){
        state.tokens.push({
            type: "th_open",
            align: aligns[i],
            lines: [
                startLine,
                startLine + 1
            ],
            level: state.level++
        });
        state.tokens.push({
            type: "inline",
            content: rows[i].trim(),
            lines: [
                startLine,
                startLine + 1
            ],
            level: state.level,
            children: []
        });
        state.tokens.push({
            type: "th_close",
            level: --state.level
        });
    }
    state.tokens.push({
        type: "tr_close",
        level: --state.level
    });
    state.tokens.push({
        type: "thead_close",
        level: --state.level
    });
    state.tokens.push({
        type: "tbody_open",
        lines: tbodyLines = [
            startLine + 2,
            0
        ],
        level: state.level++
    });
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.tShift[nextLine] < state.blkIndent) break;
        lineText = $a8c658043dff82ad$var$getLine(state, nextLine).trim();
        if (lineText.indexOf("|") === -1) break;
        rows = lineText.replace(/^\||\|$/g, "").split("|");
        state.tokens.push({
            type: "tr_open",
            level: state.level++
        });
        for(i = 0; i < rows.length; i++){
            state.tokens.push({
                type: "td_open",
                align: aligns[i],
                level: state.level++
            });
            // 0x7c === '|'
            cell = rows[i].substring(rows[i].charCodeAt(0) === 0x7c ? 1 : 0, rows[i].charCodeAt(rows[i].length - 1) === 0x7c ? rows[i].length - 1 : rows[i].length).trim();
            state.tokens.push({
                type: "inline",
                content: cell,
                level: state.level,
                children: []
            });
            state.tokens.push({
                type: "td_close",
                level: --state.level
            });
        }
        state.tokens.push({
            type: "tr_close",
            level: --state.level
        });
    }
    state.tokens.push({
        type: "tbody_close",
        level: --state.level
    });
    state.tokens.push({
        type: "table_close",
        level: --state.level
    });
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});

parcelRequire.register("a3ipl", function(module, exports) {
// Definition lists
"use strict";
// Search `[:~][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $7518769734e8622f$var$skipMarker(state, line) {
    var pos, marker, start = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    if (start >= max) return -1;
    // Check bullet
    marker = state.src.charCodeAt(start++);
    if (marker !== 0x7E /* ~ */  && marker !== 0x3A /* : */ ) return -1;
    pos = state.skipSpaces(start);
    // require space after ":"
    if (start === pos) return -1;
    // no empty definitions, e.g. "  : "
    if (pos >= max) return -1;
    return pos;
}
function $7518769734e8622f$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].tight = true;
        state.tokens[i].tight = true;
        i += 2;
    }
}
module.exports = function deflist(state, startLine, endLine, silent) {
    var contentStart, ddLine, dtLine, itemLines, listLines, listTokIdx, nextLine, oldIndent, oldDDIndent, oldParentType, oldTShift, oldTight, prevEmptyEnd, tight;
    if (silent) {
        // quirk: validation mode validates a dd block only, not a whole deflist
        if (state.ddIndent < 0) return false;
        return $7518769734e8622f$var$skipMarker(state, startLine) >= 0;
    }
    nextLine = startLine + 1;
    if (state.isEmpty(nextLine)) {
        if (++nextLine > endLine) return false;
    }
    if (state.tShift[nextLine] < state.blkIndent) return false;
    contentStart = $7518769734e8622f$var$skipMarker(state, nextLine);
    if (contentStart < 0) return false;
    if (state.level >= state.options.maxNesting) return false;
    // Start list
    listTokIdx = state.tokens.length;
    state.tokens.push({
        type: "dl_open",
        lines: listLines = [
            startLine,
            0
        ],
        level: state.level++
    });
    //
    // Iterate list items
    //
    dtLine = startLine;
    ddLine = nextLine;
    // One definition list can contain multiple DTs,
    // and one DT can be followed by multiple DDs.
    //
    // Thus, there is two loops here, and label is
    // needed to break out of the second one
    //
    /*eslint no-labels:0,block-scoped-var:0*/ OUTER: for(;;){
        tight = true;
        prevEmptyEnd = false;
        state.tokens.push({
            type: "dt_open",
            lines: [
                dtLine,
                dtLine
            ],
            level: state.level++
        });
        state.tokens.push({
            type: "inline",
            content: state.getLines(dtLine, dtLine + 1, state.blkIndent, false).trim(),
            level: state.level + 1,
            lines: [
                dtLine,
                dtLine
            ],
            children: []
        });
        state.tokens.push({
            type: "dt_close",
            level: --state.level
        });
        for(;;){
            state.tokens.push({
                type: "dd_open",
                lines: itemLines = [
                    nextLine,
                    0
                ],
                level: state.level++
            });
            oldTight = state.tight;
            oldDDIndent = state.ddIndent;
            oldIndent = state.blkIndent;
            oldTShift = state.tShift[ddLine];
            oldParentType = state.parentType;
            state.blkIndent = state.ddIndent = state.tShift[ddLine] + 2;
            state.tShift[ddLine] = contentStart - state.bMarks[ddLine];
            state.tight = true;
            state.parentType = "deflist";
            state.parser.tokenize(state, ddLine, endLine, true);
            // If any of list item is tight, mark list as tight
            if (!state.tight || prevEmptyEnd) tight = false;
            // Item become loose if finish with empty line,
            // but we should filter last element, because it means list finish
            prevEmptyEnd = state.line - ddLine > 1 && state.isEmpty(state.line - 1);
            state.tShift[ddLine] = oldTShift;
            state.tight = oldTight;
            state.parentType = oldParentType;
            state.blkIndent = oldIndent;
            state.ddIndent = oldDDIndent;
            state.tokens.push({
                type: "dd_close",
                level: --state.level
            });
            itemLines[1] = nextLine = state.line;
            if (nextLine >= endLine) break OUTER;
            if (state.tShift[nextLine] < state.blkIndent) break OUTER;
            contentStart = $7518769734e8622f$var$skipMarker(state, nextLine);
            if (contentStart < 0) break;
            ddLine = nextLine;
        // go to the next loop iteration:
        // insert DD tag and repeat checking
        }
        if (nextLine >= endLine) break;
        dtLine = nextLine;
        if (state.isEmpty(dtLine)) break;
        if (state.tShift[dtLine] < state.blkIndent) break;
        ddLine = dtLine + 1;
        if (ddLine >= endLine) break;
        if (state.isEmpty(ddLine)) ddLine++;
        if (ddLine >= endLine) break;
        if (state.tShift[ddLine] < state.blkIndent) break;
        contentStart = $7518769734e8622f$var$skipMarker(state, ddLine);
        if (contentStart < 0) break;
    // go to the next loop iteration:
    // insert DT and DD tags and repeat checking
    }
    // Finilize list
    state.tokens.push({
        type: "dl_close",
        level: --state.level
    });
    listLines[1] = nextLine;
    state.line = nextLine;
    // mark paragraphs tight if needed
    if (tight) $7518769734e8622f$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRequire.register("5yH65", function(module, exports) {
// Paragraph
"use strict";
module.exports = function paragraph(state, startLine /*, endLine*/ ) {
    var endLine, content, terminate, i, l, nextLine = startLine + 1, terminatorRules;
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    if (nextLine < endLine && !state.isEmpty(nextLine)) {
        terminatorRules = state.parser.ruler.getRules("paragraph");
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            // this would be a code block normally, but after paragraph
            // it's considered a lazy continuation regardless of what's there
            if (state.tShift[nextLine] - state.blkIndent > 3) continue;
            // Some tags can terminate paragraph without empty line.
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    if (content.length) {
        state.tokens.push({
            type: "paragraph_open",
            tight: false,
            lines: [
                startLine,
                state.line
            ],
            level: state.level
        });
        state.tokens.push({
            type: "inline",
            content: content,
            level: state.level + 1,
            lines: [
                startLine,
                state.line
            ],
            children: []
        });
        state.tokens.push({
            type: "paragraph_close",
            tight: false,
            level: state.level
        });
    }
    return true;
};

});


parcelRequire.register("cNRLi", function(module, exports) {
"use strict";

var $1hCjm = parcelRequire("1hCjm");

var $9kd81 = parcelRequire("9kd81");

var $9SgFk = parcelRequire("9SgFk");
















/**
 * Inline Parser `rules`
 */ var $9523c399d64dc8f9$var$_rules = [
    [
        "text",
        (parcelRequire("Uk6dp"))
    ],
    [
        "newline",
        (parcelRequire("ifSht"))
    ],
    [
        "escape",
        (parcelRequire("3vgyf"))
    ],
    [
        "backticks",
        (parcelRequire("lhkzb"))
    ],
    [
        "del",
        (parcelRequire("7sGUC"))
    ],
    [
        "ins",
        (parcelRequire("gUQhx"))
    ],
    [
        "mark",
        (parcelRequire("fvHgP"))
    ],
    [
        "emphasis",
        (parcelRequire("9G1KN"))
    ],
    [
        "sub",
        (parcelRequire("4ykCY"))
    ],
    [
        "sup",
        (parcelRequire("65bVi"))
    ],
    [
        "links",
        (parcelRequire("6RRmc"))
    ],
    [
        "footnote_inline",
        (parcelRequire("6Z85x"))
    ],
    [
        "footnote_ref",
        (parcelRequire("51Nxh"))
    ],
    [
        "autolink",
        (parcelRequire("7exMJ"))
    ],
    [
        "htmltag",
        (parcelRequire("6ddK5"))
    ],
    [
        "entity",
        (parcelRequire("kBBpH"))
    ]
];
/**
 * Inline Parser class. Note that link validation is stricter
 * in Remarkable than what is specified by CommonMark. If you
 * want to change this you can use a custom validator.
 *
 * @api private
 */ function $9523c399d64dc8f9$var$ParserInline() {
    this.ruler = new $1hCjm();
    for(var i = 0; i < $9523c399d64dc8f9$var$_rules.length; i++)this.ruler.push($9523c399d64dc8f9$var$_rules[i][0], $9523c399d64dc8f9$var$_rules[i][1]);
    // Can be overridden with a custom validator
    this.validateLink = $9523c399d64dc8f9$var$validateLink;
}
/**
 * Skip a single token by running all rules in validation mode.
 * Returns `true` if any rule reports success.
 *
 * @param  {Object} `state`
 * @api privage
 */ $9523c399d64dc8f9$var$ParserInline.prototype.skipToken = function(state) {
    var rules = this.ruler.getRules("");
    var len = rules.length;
    var pos = state.pos;
    var i, cached_pos;
    if ((cached_pos = state.cacheGet(pos)) > 0) {
        state.pos = cached_pos;
        return;
    }
    for(i = 0; i < len; i++)if (rules[i](state, true)) {
        state.cacheSet(pos, state.pos);
        return;
    }
    state.pos++;
    state.cacheSet(pos, state.pos);
};
/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state`
 * @api private
 */ $9523c399d64dc8f9$var$ParserInline.prototype.tokenize = function(state) {
    var rules = this.ruler.getRules("");
    var len = rules.length;
    var end = state.posMax;
    var ok, i;
    while(state.pos < end){
        // Try all possible rules.
        // On success, the rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) break;
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * Parse the given input string.
 *
 * @param  {String} `str`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */ $9523c399d64dc8f9$var$ParserInline.prototype.parse = function(str, options, env, outTokens) {
    var state = new $9kd81(str, this, options, env, outTokens);
    this.tokenize(state);
};
/**
 * Validate the given `url` by checking for bad protocols.
 *
 * @param  {String} `url`
 * @return {Boolean}
 */ function $9523c399d64dc8f9$var$validateLink(url) {
    var BAD_PROTOCOLS = [
        "vbscript",
        "javascript",
        "file",
        "data"
    ];
    var str = url.trim().toLowerCase();
    // Care about digital entities "javascript&#x3A;alert(1)"
    str = $9SgFk.replaceEntities(str);
    if (str.indexOf(":") !== -1 && BAD_PROTOCOLS.indexOf(str.split(":")[0]) !== -1) return false;
    return true;
}
/**
 * Expose `ParserInline`
 */ module.exports = $9523c399d64dc8f9$var$ParserInline;

});
parcelRequire.register("Uk6dp", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
"use strict";
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
function $0a94d25e6d7f026b$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x5C /* \ */ :
        case 0x60 /* ` */ :
        case 0x2A /* * */ :
        case 0x5F /* _ */ :
        case 0x5E /* ^ */ :
        case 0x5B /* [ */ :
        case 0x5D /* ] */ :
        case 0x21 /* ! */ :
        case 0x26 /* & */ :
        case 0x3C /* < */ :
        case 0x3E /* > */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x40 /* @ */ :
        case 0x7E /* ~ */ :
        case 0x2B /* + */ :
        case 0x3D /* = */ :
        case 0x3A /* : */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$0a94d25e6d7f026b$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
};

});

parcelRequire.register("ifSht", function(module, exports) {
// Proceess '\n'
"use strict";
module.exports = function newline(state, silent) {
    var pmax, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Strip out all trailing spaces on this line.
                for(var i = pmax - 2; i >= 0; i--)if (state.pending.charCodeAt(i) !== 0x20) {
                    state.pending = state.pending.substring(0, i + 1);
                    break;
                }
                state.push({
                    type: "hardbreak",
                    level: state.level
                });
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push({
                    type: "softbreak",
                    level: state.level
                });
            }
        } else state.push({
            type: "softbreak",
            level: state.level
        });
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && state.src.charCodeAt(pos) === 0x20)pos++;
    state.pos = pos;
    return true;
};

});

parcelRequire.register("3vgyf", function(module, exports) {
// Proceess escaped chars and hardbreaks
"use strict";
var $28d11b17212177aa$var$ESCAPED = [];
for(var $28d11b17212177aa$var$i = 0; $28d11b17212177aa$var$i < 256; $28d11b17212177aa$var$i++)$28d11b17212177aa$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $28d11b17212177aa$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (ch < 256 && $28d11b17212177aa$var$ESCAPED[ch] !== 0) {
            if (!silent) state.pending += state.src[pos];
            state.pos += 2;
            return true;
        }
        if (ch === 0x0A) {
            if (!silent) state.push({
                type: "hardbreak",
                level: state.level
            });
            pos++;
            // skip leading whitespaces from next line
            while(pos < max && state.src.charCodeAt(pos) === 0x20)pos++;
            state.pos = pos;
            return true;
        }
    }
    if (!silent) state.pending += "\\";
    state.pos++;
    return true;
};

});

parcelRequire.register("lhkzb", function(module, exports) {
// Parse backticks
"use strict";
module.exports = function backticks(state, silent) {
    var start, max, marker, matchStart, matchEnd, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    matchStart = matchEnd = pos;
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        if (matchEnd - matchStart === marker.length) {
            if (!silent) state.push({
                type: "code",
                content: state.src.slice(pos, matchStart).replace(/[ \n]+/g, " ").trim(),
                block: false,
                level: state.level
            });
            state.pos = matchEnd;
            return true;
        }
    }
    if (!silent) state.pending += marker;
    state.pos += marker.length;
    return true;
};

});

parcelRequire.register("7sGUC", function(module, exports) {
// Process ~~deleted text~~
"use strict";
module.exports = function del(state, silent) {
    var found, pos, stack, max = state.posMax, start = state.pos, lastChar, nextChar;
    if (state.src.charCodeAt(start) !== 0x7E /* ~ */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 4 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x7E /* ~ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    nextChar = state.src.charCodeAt(start + 2);
    if (lastChar === 0x7E /* ~ */ ) return false;
    if (nextChar === 0x7E /* ~ */ ) return false;
    if (nextChar === 0x20 || nextChar === 0x0A) return false;
    pos = start + 2;
    while(pos < max && state.src.charCodeAt(pos) === 0x7E /* ~ */ )pos++;
    if (pos > start + 3) {
        // sequence of 4+ markers taking as literal, same as in a emphasis
        state.pos += pos - start;
        if (!silent) state.pending += state.src.slice(start, pos);
        return true;
    }
    state.pos = start + 2;
    stack = 1;
    while(state.pos + 1 < max){
        if (state.src.charCodeAt(state.pos) === 0x7E /* ~ */ ) {
            if (state.src.charCodeAt(state.pos + 1) === 0x7E /* ~ */ ) {
                lastChar = state.src.charCodeAt(state.pos - 1);
                nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
                if (nextChar !== 0x7E /* ~ */  && lastChar !== 0x7E /* ~ */ ) {
                    if (lastChar !== 0x20 && lastChar !== 0x0A) // closing '~~'
                    stack--;
                    else if (nextChar !== 0x20 && nextChar !== 0x0A) // opening '~~'
                    stack++;
                     // else {
                    //  // standalone ' ~~ ' indented with spaces
                    // }
                    if (stack <= 0) {
                        found = true;
                        break;
                    }
                }
            }
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 2;
    if (!silent) {
        state.push({
            type: "del_open",
            level: state.level++
        });
        state.parser.tokenize(state);
        state.push({
            type: "del_close",
            level: --state.level
        });
    }
    state.pos = state.posMax + 2;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("gUQhx", function(module, exports) {
// Process ++inserted text++
"use strict";
module.exports = function ins(state, silent) {
    var found, pos, stack, max = state.posMax, start = state.pos, lastChar, nextChar;
    if (state.src.charCodeAt(start) !== 0x2B /* + */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 4 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x2B /* + */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    nextChar = state.src.charCodeAt(start + 2);
    if (lastChar === 0x2B /* + */ ) return false;
    if (nextChar === 0x2B /* + */ ) return false;
    if (nextChar === 0x20 || nextChar === 0x0A) return false;
    pos = start + 2;
    while(pos < max && state.src.charCodeAt(pos) === 0x2B /* + */ )pos++;
    if (pos !== start + 2) {
        // sequence of 3+ markers taking as literal, same as in a emphasis
        state.pos += pos - start;
        if (!silent) state.pending += state.src.slice(start, pos);
        return true;
    }
    state.pos = start + 2;
    stack = 1;
    while(state.pos + 1 < max){
        if (state.src.charCodeAt(state.pos) === 0x2B /* + */ ) {
            if (state.src.charCodeAt(state.pos + 1) === 0x2B /* + */ ) {
                lastChar = state.src.charCodeAt(state.pos - 1);
                nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
                if (nextChar !== 0x2B /* + */  && lastChar !== 0x2B /* + */ ) {
                    if (lastChar !== 0x20 && lastChar !== 0x0A) // closing '++'
                    stack--;
                    else if (nextChar !== 0x20 && nextChar !== 0x0A) // opening '++'
                    stack++;
                     // else {
                    //  // standalone ' ++ ' indented with spaces
                    // }
                    if (stack <= 0) {
                        found = true;
                        break;
                    }
                }
            }
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 2;
    if (!silent) {
        state.push({
            type: "ins_open",
            level: state.level++
        });
        state.parser.tokenize(state);
        state.push({
            type: "ins_close",
            level: --state.level
        });
    }
    state.pos = state.posMax + 2;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("fvHgP", function(module, exports) {
// Process ==highlighted text==
"use strict";
module.exports = function del(state, silent) {
    var found, pos, stack, max = state.posMax, start = state.pos, lastChar, nextChar;
    if (state.src.charCodeAt(start) !== 0x3D /* = */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 4 >= max) return false;
    if (state.src.charCodeAt(start + 1) !== 0x3D /* = */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    nextChar = state.src.charCodeAt(start + 2);
    if (lastChar === 0x3D /* = */ ) return false;
    if (nextChar === 0x3D /* = */ ) return false;
    if (nextChar === 0x20 || nextChar === 0x0A) return false;
    pos = start + 2;
    while(pos < max && state.src.charCodeAt(pos) === 0x3D /* = */ )pos++;
    if (pos !== start + 2) {
        // sequence of 3+ markers taking as literal, same as in a emphasis
        state.pos += pos - start;
        if (!silent) state.pending += state.src.slice(start, pos);
        return true;
    }
    state.pos = start + 2;
    stack = 1;
    while(state.pos + 1 < max){
        if (state.src.charCodeAt(state.pos) === 0x3D /* = */ ) {
            if (state.src.charCodeAt(state.pos + 1) === 0x3D /* = */ ) {
                lastChar = state.src.charCodeAt(state.pos - 1);
                nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
                if (nextChar !== 0x3D /* = */  && lastChar !== 0x3D /* = */ ) {
                    if (lastChar !== 0x20 && lastChar !== 0x0A) // closing '=='
                    stack--;
                    else if (nextChar !== 0x20 && nextChar !== 0x0A) // opening '=='
                    stack++;
                     // else {
                    //  // standalone ' == ' indented with spaces
                    // }
                    if (stack <= 0) {
                        found = true;
                        break;
                    }
                }
            }
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 2;
    if (!silent) {
        state.push({
            type: "mark_open",
            level: state.level++
        });
        state.parser.tokenize(state);
        state.push({
            type: "mark_close",
            level: --state.level
        });
    }
    state.pos = state.posMax + 2;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("9G1KN", function(module, exports) {
// Process *this* and _that_
"use strict";
function $70b96591573c0495$var$isAlphaNum(code) {
    return code >= 0x30 /* 0 */  && code <= 0x39 /* 9 */  || code >= 0x41 /* A */  && code <= 0x5A /* Z */  || code >= 0x61 /* a */  && code <= 0x7A /* z */ ;
}
// parse sequence of emphasis markers,
// "start" should point at a valid marker
function $70b96591573c0495$var$scanDelims(state, start) {
    var pos = start, lastChar, nextChar, count, can_open = true, can_close = true, max = state.posMax, marker = state.src.charCodeAt(start);
    lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
    while(pos < max && state.src.charCodeAt(pos) === marker)pos++;
    if (pos >= max) can_open = false;
    count = pos - start;
    if (count >= 4) // sequence of four or more unescaped markers can't start/end an emphasis
    can_open = can_close = false;
    else {
        nextChar = pos < max ? state.src.charCodeAt(pos) : -1;
        // check whitespace conditions
        if (nextChar === 0x20 || nextChar === 0x0A) can_open = false;
        if (lastChar === 0x20 || lastChar === 0x0A) can_close = false;
        if (marker === 0x5F /* _ */ ) {
            // check if we aren't inside the word
            if ($70b96591573c0495$var$isAlphaNum(lastChar)) can_open = false;
            if ($70b96591573c0495$var$isAlphaNum(nextChar)) can_close = false;
        }
    }
    return {
        can_open: can_open,
        can_close: can_close,
        delims: count
    };
}
module.exports = function emphasis(state, silent) {
    var startCount, count, found, oldCount, newCount, stack, res, max = state.posMax, start = state.pos, marker = state.src.charCodeAt(start);
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    res = $70b96591573c0495$var$scanDelims(state, start);
    startCount = res.delims;
    if (!res.can_open) {
        state.pos += startCount;
        if (!silent) state.pending += state.src.slice(start, state.pos);
        return true;
    }
    if (state.level >= state.options.maxNesting) return false;
    state.pos = start + startCount;
    stack = [
        startCount
    ];
    while(state.pos < max){
        if (state.src.charCodeAt(state.pos) === marker) {
            res = $70b96591573c0495$var$scanDelims(state, state.pos);
            count = res.delims;
            if (res.can_close) {
                oldCount = stack.pop();
                newCount = count;
                while(oldCount !== newCount){
                    if (newCount < oldCount) {
                        stack.push(oldCount - newCount);
                        break;
                    }
                    // assert(newCount > oldCount)
                    newCount -= oldCount;
                    if (stack.length === 0) break;
                    state.pos += oldCount;
                    oldCount = stack.pop();
                }
                if (stack.length === 0) {
                    startCount = oldCount;
                    found = true;
                    break;
                }
                state.pos += count;
                continue;
            }
            if (res.can_open) stack.push(count);
            state.pos += count;
            continue;
        }
        state.parser.skipToken(state);
    }
    if (!found) {
        // parser failed to find ending tag, so it's not valid emphasis
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + startCount;
    if (!silent) {
        if (startCount === 2 || startCount === 3) state.push({
            type: "strong_open",
            level: state.level++
        });
        if (startCount === 1 || startCount === 3) state.push({
            type: "em_open",
            level: state.level++
        });
        state.parser.tokenize(state);
        if (startCount === 1 || startCount === 3) state.push({
            type: "em_close",
            level: --state.level
        });
        if (startCount === 2 || startCount === 3) state.push({
            type: "strong_close",
            level: --state.level
        });
    }
    state.pos = state.posMax + startCount;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("4ykCY", function(module, exports) {
// Process ~subscript~
"use strict";
// same as UNESCAPE_MD_RE plus a space
var $350a569d955dcdff$var$UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
module.exports = function sub(state, silent) {
    var found, content, max = state.posMax, start = state.pos;
    if (state.src.charCodeAt(start) !== 0x7E /* ~ */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 2 >= max) return false;
    if (state.level >= state.options.maxNesting) return false;
    state.pos = start + 1;
    while(state.pos < max){
        if (state.src.charCodeAt(state.pos) === 0x7E /* ~ */ ) {
            found = true;
            break;
        }
        state.parser.skipToken(state);
    }
    if (!found || start + 1 === state.pos) {
        state.pos = start;
        return false;
    }
    content = state.src.slice(start + 1, state.pos);
    // don't allow unescaped spaces/newlines inside
    if (content.match(/(^|[^\\])(\\\\)*\s/)) {
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 1;
    if (!silent) state.push({
        type: "sub",
        level: state.level,
        content: content.replace($350a569d955dcdff$var$UNESCAPE_RE, "$1")
    });
    state.pos = state.posMax + 1;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("65bVi", function(module, exports) {
// Process ^superscript^
"use strict";
// same as UNESCAPE_MD_RE plus a space
var $46dc75639d77f922$var$UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;
module.exports = function sup(state, silent) {
    var found, content, max = state.posMax, start = state.pos;
    if (state.src.charCodeAt(start) !== 0x5E /* ^ */ ) return false;
    if (silent) return false;
     // don't run any pairs in validation mode
    if (start + 2 >= max) return false;
    if (state.level >= state.options.maxNesting) return false;
    state.pos = start + 1;
    while(state.pos < max){
        if (state.src.charCodeAt(state.pos) === 0x5E /* ^ */ ) {
            found = true;
            break;
        }
        state.parser.skipToken(state);
    }
    if (!found || start + 1 === state.pos) {
        state.pos = start;
        return false;
    }
    content = state.src.slice(start + 1, state.pos);
    // don't allow unescaped spaces/newlines inside
    if (content.match(/(^|[^\\])(\\\\)*\s/)) {
        state.pos = start;
        return false;
    }
    // found!
    state.posMax = state.pos;
    state.pos = start + 1;
    if (!silent) state.push({
        type: "sup",
        level: state.level,
        content: content.replace($46dc75639d77f922$var$UNESCAPE_RE, "$1")
    });
    state.pos = state.posMax + 1;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("6RRmc", function(module, exports) {
// Process [links](<to> "stuff")
"use strict";

var $gAxxv = parcelRequire("gAxxv");

var $eiTsM = parcelRequire("eiTsM");

var $jDCYX = parcelRequire("jDCYX");

var $gEsqy = parcelRequire("gEsqy");
module.exports = function links(state, silent) {
    var labelStart, labelEnd, label, href, title, pos, ref, code, isImage = false, oldPos = state.pos, max = state.posMax, start = state.pos, marker = state.src.charCodeAt(start);
    if (marker === 0x21 /* ! */ ) {
        isImage = true;
        marker = state.src.charCodeAt(++start);
    }
    if (marker !== 0x5B /* [ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    labelStart = start + 1;
    labelEnd = $gAxxv(state, start);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (code !== 0x20 && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        if ($eiTsM(state, pos)) {
            href = state.linkContent;
            pos = state.pos;
        } else href = "";
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (code !== 0x20 && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        if (pos < max && start !== pos && $jDCYX(state, pos)) {
            title = state.linkContent;
            pos = state.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (code !== 0x20 && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        // do not allow nested reference links
        if (state.linkLevel > 0) return false;
        // [foo]  [bar]
        //      ^^ optional whitespace (can include newlines)
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (code !== 0x20 && code !== 0x0A) break;
        }
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = $gAxxv(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = start - 1;
        }
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) {
            if (typeof label === "undefined") pos = labelEnd + 1;
            label = state.src.slice(labelStart, labelEnd);
        }
        ref = state.env.references[$gEsqy(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        if (isImage) state.push({
            type: "image",
            src: href,
            title: title,
            alt: state.src.substr(labelStart, labelEnd - labelStart),
            level: state.level
        });
        else {
            state.push({
                type: "link_open",
                href: href,
                title: title,
                level: state.level++
            });
            state.linkLevel++;
            state.parser.tokenize(state);
            state.linkLevel--;
            state.push({
                type: "link_close",
                level: --state.level
            });
        }
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("6Z85x", function(module, exports) {
// Process inline footnotes (^[...])
"use strict";

var $gAxxv = parcelRequire("gAxxv");
module.exports = function footnote_inline(state, silent) {
    var labelStart, labelEnd, footnoteId, oldLength, max = state.posMax, start = state.pos;
    if (start + 2 >= max) return false;
    if (state.src.charCodeAt(start) !== 0x5E /* ^ */ ) return false;
    if (state.src.charCodeAt(start + 1) !== 0x5B /* [ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    labelStart = start + 2;
    labelEnd = $gAxxv(state, start + 1);
    // parser failed to find ']', so it's not a valid note
    if (labelEnd < 0) return false;
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        if (!state.env.footnotes) state.env.footnotes = {};
        if (!state.env.footnotes.list) state.env.footnotes.list = [];
        footnoteId = state.env.footnotes.list.length;
        state.pos = labelStart;
        state.posMax = labelEnd;
        state.push({
            type: "footnote_ref",
            id: footnoteId,
            level: state.level
        });
        state.linkLevel++;
        oldLength = state.tokens.length;
        state.parser.tokenize(state);
        state.env.footnotes.list[footnoteId] = {
            tokens: state.tokens.splice(oldLength)
        };
        state.linkLevel--;
    }
    state.pos = labelEnd + 1;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("51Nxh", function(module, exports) {
// Process footnote references ([^...])
"use strict";
module.exports = function footnote_ref(state, silent) {
    var label, pos, footnoteId, footnoteSubId, max = state.posMax, start = state.pos;
    // should be at least 4 chars - "[^x]"
    if (start + 3 > max) return false;
    if (!state.env.footnotes || !state.env.footnotes.refs) return false;
    if (state.src.charCodeAt(start) !== 0x5B /* [ */ ) return false;
    if (state.src.charCodeAt(start + 1) !== 0x5E /* ^ */ ) return false;
    if (state.level >= state.options.maxNesting) return false;
    for(pos = start + 2; pos < max; pos++){
        if (state.src.charCodeAt(pos) === 0x20) return false;
        if (state.src.charCodeAt(pos) === 0x0A) return false;
        if (state.src.charCodeAt(pos) === 0x5D /* ] */ ) break;
    }
    if (pos === start + 2) return false;
     // no empty footnote labels
    if (pos >= max) return false;
    pos++;
    label = state.src.slice(start + 2, pos - 1);
    if (typeof state.env.footnotes.refs[":" + label] === "undefined") return false;
    if (!silent) {
        if (!state.env.footnotes.list) state.env.footnotes.list = [];
        if (state.env.footnotes.refs[":" + label] < 0) {
            footnoteId = state.env.footnotes.list.length;
            state.env.footnotes.list[footnoteId] = {
                label: label,
                count: 0
            };
            state.env.footnotes.refs[":" + label] = footnoteId;
        } else footnoteId = state.env.footnotes.refs[":" + label];
        footnoteSubId = state.env.footnotes.list[footnoteId].count;
        state.env.footnotes.list[footnoteId].count++;
        state.push({
            type: "footnote_ref",
            id: footnoteId,
            subId: footnoteSubId,
            level: state.level
        });
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRequire.register("7exMJ", function(module, exports) {
// Process autolinks '<protocol:...>'
"use strict";

var $fSnj4 = parcelRequire("fSnj4");

var $cV03X = parcelRequire("cV03X");
/*eslint max-len:0*/ var $54440c315d13c43e$var$EMAIL_RE = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var $54440c315d13c43e$var$AUTOLINK_RE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;
module.exports = function autolink(state, silent) {
    var tail, linkMatch, emailMatch, url, fullUrl, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    tail = state.src.slice(pos);
    if (tail.indexOf(">") < 0) return false;
    linkMatch = tail.match($54440c315d13c43e$var$AUTOLINK_RE);
    if (linkMatch) {
        if ($fSnj4.indexOf(linkMatch[1].toLowerCase()) < 0) return false;
        url = linkMatch[0].slice(1, -1);
        fullUrl = $cV03X(url);
        if (!state.parser.validateLink(url)) return false;
        if (!silent) {
            state.push({
                type: "link_open",
                href: fullUrl,
                level: state.level
            });
            state.push({
                type: "text",
                content: url,
                level: state.level + 1
            });
            state.push({
                type: "link_close",
                level: state.level
            });
        }
        state.pos += linkMatch[0].length;
        return true;
    }
    emailMatch = tail.match($54440c315d13c43e$var$EMAIL_RE);
    if (emailMatch) {
        url = emailMatch[0].slice(1, -1);
        fullUrl = $cV03X("mailto:" + url);
        if (!state.parser.validateLink(fullUrl)) return false;
        if (!silent) {
            state.push({
                type: "link_open",
                href: fullUrl,
                level: state.level
            });
            state.push({
                type: "text",
                content: url,
                level: state.level + 1
            });
            state.push({
                type: "link_close",
                level: state.level
            });
        }
        state.pos += emailMatch[0].length;
        return true;
    }
    return false;
};

});
parcelRequire.register("fSnj4", function(module, exports) {
// List of valid url schemas, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#autolinks
"use strict";
module.exports = [
    "coap",
    "doi",
    "javascript",
    "aaa",
    "aaas",
    "about",
    "acap",
    "cap",
    "cid",
    "crid",
    "data",
    "dav",
    "dict",
    "dns",
    "file",
    "ftp",
    "geo",
    "go",
    "gopher",
    "h323",
    "http",
    "https",
    "iax",
    "icap",
    "im",
    "imap",
    "info",
    "ipp",
    "iris",
    "iris.beep",
    "iris.xpc",
    "iris.xpcs",
    "iris.lwz",
    "ldap",
    "mailto",
    "mid",
    "msrp",
    "msrps",
    "mtqp",
    "mupdate",
    "news",
    "nfs",
    "ni",
    "nih",
    "nntp",
    "opaquelocktoken",
    "pop",
    "pres",
    "rtsp",
    "service",
    "session",
    "shttp",
    "sieve",
    "sip",
    "sips",
    "sms",
    "snmp",
    "soap.beep",
    "soap.beeps",
    "tag",
    "tel",
    "telnet",
    "tftp",
    "thismessage",
    "tn3270",
    "tip",
    "tv",
    "urn",
    "vemmi",
    "ws",
    "wss",
    "xcon",
    "xcon-userid",
    "xmlrpc.beep",
    "xmlrpc.beeps",
    "xmpp",
    "z39.50r",
    "z39.50s",
    "adiumxtra",
    "afp",
    "afs",
    "aim",
    "apt",
    "attachment",
    "aw",
    "beshare",
    "bitcoin",
    "bolo",
    "callto",
    "chrome",
    "chrome-extension",
    "com-eventbrite-attendee",
    "content",
    "cvs",
    "dlna-playsingle",
    "dlna-playcontainer",
    "dtn",
    "dvb",
    "ed2k",
    "facetime",
    "feed",
    "finger",
    "fish",
    "gg",
    "git",
    "gizmoproject",
    "gtalk",
    "hcp",
    "icon",
    "ipn",
    "irc",
    "irc6",
    "ircs",
    "itms",
    "jar",
    "jms",
    "keyparc",
    "lastfm",
    "ldaps",
    "magnet",
    "maps",
    "market",
    "message",
    "mms",
    "ms-help",
    "msnim",
    "mumble",
    "mvn",
    "notes",
    "oid",
    "palm",
    "paparazzi",
    "platform",
    "proxy",
    "psyc",
    "query",
    "res",
    "resource",
    "rmi",
    "rsync",
    "rtmp",
    "secondlife",
    "sftp",
    "sgn",
    "skype",
    "smb",
    "soldat",
    "spotify",
    "ssh",
    "steam",
    "svn",
    "teamspeak",
    "things",
    "udp",
    "unreal",
    "ut2004",
    "ventrilo",
    "view-source",
    "webcal",
    "wtai",
    "wyciwyg",
    "xfire",
    "xri",
    "ymsgr"
];

});


parcelRequire.register("6ddK5", function(module, exports) {
// Process html tags
"use strict";

var $lpWRa = parcelRequire("lpWRa");
var $485e9de3ce585c1a$require$HTML_TAG_RE = $lpWRa.HTML_TAG_RE;
function $485e9de3ce585c1a$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function htmltag(state, silent) {
    var ch, match, max, pos = state.pos;
    if (!state.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$485e9de3ce585c1a$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($485e9de3ce585c1a$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) state.push({
        type: "htmltag",
        content: state.src.slice(pos, pos + match[0].length),
        level: state.level
    });
    state.pos += match[0].length;
    return true;
};

});
parcelRequire.register("lpWRa", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", function () { return $f9799678af4f9caa$export$6db61d2c3a16e419; }, function (v) { return $f9799678af4f9caa$export$6db61d2c3a16e419 = v; });
// Regexps to match html elements
var $f9799678af4f9caa$export$6db61d2c3a16e419;
"use strict";
function $f9799678af4f9caa$var$replace(regex, options) {
    regex = regex.source;
    options = options || "";
    return function self(name, val) {
        if (!name) return new RegExp(regex, options);
        val = val.source || val;
        regex = regex.replace(name, val);
        return self;
    };
}
var $f9799678af4f9caa$var$attr_name = /[a-zA-Z_:][a-zA-Z0-9:._-]*/;
var $f9799678af4f9caa$var$unquoted = /[^"'=<>`\x00-\x20]+/;
var $f9799678af4f9caa$var$single_quoted = /'[^']*'/;
var $f9799678af4f9caa$var$double_quoted = /"[^"]*"/;
/*eslint no-spaced-func:0*/ var $f9799678af4f9caa$var$attr_value = $f9799678af4f9caa$var$replace(/(?:unquoted|single_quoted|double_quoted)/)("unquoted", $f9799678af4f9caa$var$unquoted)("single_quoted", $f9799678af4f9caa$var$single_quoted)("double_quoted", $f9799678af4f9caa$var$double_quoted)();
var $f9799678af4f9caa$var$attribute = $f9799678af4f9caa$var$replace(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)("attr_name", $f9799678af4f9caa$var$attr_name)("attr_value", $f9799678af4f9caa$var$attr_value)();
var $f9799678af4f9caa$var$open_tag = $f9799678af4f9caa$var$replace(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)("attribute", $f9799678af4f9caa$var$attribute)();
var $f9799678af4f9caa$var$close_tag = /<\/[A-Za-z][A-Za-z0-9]*\s*>/;
var $f9799678af4f9caa$var$comment = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/;
var $f9799678af4f9caa$var$processing = /<[?].*?[?]>/;
var $f9799678af4f9caa$var$declaration = /<![A-Z]+\s+[^>]*>/;
var $f9799678af4f9caa$var$cdata = /<!\[CDATA\[[\s\S]*?\]\]>/;
var $f9799678af4f9caa$var$HTML_TAG_RE = $f9799678af4f9caa$var$replace(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)("open_tag", $f9799678af4f9caa$var$open_tag)("close_tag", $f9799678af4f9caa$var$close_tag)("comment", $f9799678af4f9caa$var$comment)("processing", $f9799678af4f9caa$var$processing)("declaration", $f9799678af4f9caa$var$declaration)("cdata", $f9799678af4f9caa$var$cdata)();
$f9799678af4f9caa$export$6db61d2c3a16e419 = $f9799678af4f9caa$var$HTML_TAG_RE;

});


parcelRequire.register("kBBpH", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
"use strict";

var $kYjHw = parcelRequire("kYjHw");

var $9SgFk = parcelRequire("9SgFk");
var $f00448e0cbd4dc39$require$has = $9SgFk.has;

var $9SgFk = parcelRequire("9SgFk");
var $f00448e0cbd4dc39$require$isValidEntityCode = $9SgFk.isValidEntityCode;

var $9SgFk = parcelRequire("9SgFk");
var $f00448e0cbd4dc39$require$fromCodePoint = $9SgFk.fromCodePoint;
var $f00448e0cbd4dc39$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var $f00448e0cbd4dc39$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 < max) {
        ch = state.src.charCodeAt(pos + 1);
        if (ch === 0x23 /* # */ ) {
            match = state.src.slice(pos).match($f00448e0cbd4dc39$var$DIGITAL_RE);
            if (match) {
                if (!silent) {
                    code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                    state.pending += $f00448e0cbd4dc39$require$isValidEntityCode(code) ? $f00448e0cbd4dc39$require$fromCodePoint(code) : $f00448e0cbd4dc39$require$fromCodePoint(0xFFFD);
                }
                state.pos += match[0].length;
                return true;
            }
        } else {
            match = state.src.slice(pos).match($f00448e0cbd4dc39$var$NAMED_RE);
            if (match) {
                if ($f00448e0cbd4dc39$require$has($kYjHw, match[1])) {
                    if (!silent) state.pending += $kYjHw[match[1]];
                    state.pos += match[0].length;
                    return true;
                }
            }
        }
    }
    if (!silent) state.pending += "&";
    state.pos++;
    return true;
};

});


parcelRequire.register("eFvaC", function(module, exports) {
// Remarkable default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        linkTarget: "",
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "“”‘’",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "block",
                "inline",
                "references",
                "replacements",
                "linkify",
                "smartquotes",
                "references",
                "abbr2",
                "footnote_tail"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fences",
                "footnote",
                "heading",
                "hr",
                "htmlblock",
                "lheading",
                "list",
                "paragraph",
                "table"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "del",
                "emphasis",
                "entity",
                "escape",
                "footnote_ref",
                "htmltag",
                "links",
                "newline",
                "text"
            ]
        }
    }
};

});

parcelRequire.register("guN2t", function(module, exports) {
// Remarkable default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        linkTarget: "",
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "“”‘’",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        // Don't restrict core/block/inline rules
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRequire.register("jyRhi", function(module, exports) {
// Commonmark default options
"use strict";
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        linkTarget: "",
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
        quotes: "“”‘’",
        // Highlighter function. Should return escaped HTML,
        // or '' if input not changed
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "block",
                "inline",
                "references",
                "abbr2"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fences",
                "heading",
                "hr",
                "htmlblock",
                "lheading",
                "list",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "htmltag",
                "links",
                "newline",
                "text"
            ]
        }
    }
};

});


parcelRequire.register("eSIsJ", function(module, exports) {
module.exports = $ad58992a8a0fce03$var$encode;
function $ad58992a8a0fce03$var$encode(keyword, content) {
    keyword = String(keyword);
    content = String(content);
    if (!/^[\x00-\xFF]+$/.test(keyword) || !/^[\x00-\xFF]+$/.test(content)) throw new Error("Only Latin-1 characters are permitted in PNG tEXt chunks. You might want to consider base64 encoding and/or zEXt compression");
    if (keyword.length >= 80) throw new Error('Keyword "' + keyword + '" is longer than the 79-character limit imposed by the PNG specification');
    var totalSize = keyword.length + content.length + 1;
    var output = new Uint8Array(totalSize);
    var idx = 0;
    var code;
    for(var i = 0; i < keyword.length; i++){
        if (!(code = keyword.charCodeAt(i))) throw new Error("0x00 character is not permitted in tEXt keywords");
        output[idx++] = code;
    }
    output[idx++] = 0;
    for(var j = 0; j < content.length; j++){
        if (!(code = content.charCodeAt(j))) throw new Error("0x00 character is not permitted in tEXt content");
        output[idx++] = code;
    }
    return {
        name: "tEXt",
        data: output
    };
}

});

parcelRequire.register("hJOiA", function(module, exports) {
module.exports = $ce9da7f39ea8b9eb$var$decode;
function $ce9da7f39ea8b9eb$var$decode(data) {
    if (data.data && data.name) data = data.data;
    var naming = true;
    var text = "";
    var name = "";
    for(var i = 0; i < data.length; i++){
        var code = data[i];
        if (naming) {
            if (code) name += String.fromCharCode(code);
            else naming = false;
        } else {
            if (code) text += String.fromCharCode(code);
            else throw new Error("Invalid NULL character found. 0x00 character is not permitted in tEXt content");
        }
    }
    return {
        keyword: name,
        text: text
    };
}

});

parcelRequire.register("27IK1", function(module, exports) {

module.exports = import("./" + (parcelRequire("kyEFX")).resolve("79Ox7")).then(()=>parcelRequire("adDlL"));

});

var $4aa2fd92cb1b046f$exports = {};
"use strict";
function $4aa2fd92cb1b046f$var$__export(m) {
    for(var p in m)if (!$4aa2fd92cb1b046f$exports.hasOwnProperty(p)) $4aa2fd92cb1b046f$exports[p] = m[p];
}
$4aa2fd92cb1b046f$exports.__esModule = true;

/**
 * TODO: move out to csstips
 */ $4aa2fd92cb1b046f$var$__export((parcelRequire("1Inan")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("cCspI")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("ekQDt")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("eA0m8")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("lNiW7")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("4KX0F")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("bkbgr")));

$4aa2fd92cb1b046f$var$__export((parcelRequire("8GpuA")));


var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $17d8c0717df1150b$exports = {};
"use strict";
var $17d8c0717df1150b$var$__assign = $17d8c0717df1150b$exports && $17d8c0717df1150b$exports.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
Object.defineProperty($17d8c0717df1150b$exports, "__esModule", {
    value: true
});
/** Store for some state

Store laws (assuming no listeners):

1. `s.set(a).get() = a`

2. `s.set(s.get()).get() = s.get()`

3. `s.set(a).set(b).get() = s.set(b).get()`

Store laws with listeners:

1. `s.transaction(() => s.set(a).get()) = a`

2. `s.transaction(() => s.set(s.get()).get()) = s.get()`

3. `s.transaction(() => s.set(a).set(b).get()) = s.set(b).get()`

A store is a partially applied, existentially quantified lens with a change listener.
*/ var $17d8c0717df1150b$var$Store = /** @class */ function() {
    function Store(transact, listen, _get, _set) {
        this.transact = transact;
        this.listen = listen;
        this._get = _get;
        this._set = _set;
    }
    /** Make the root store (static method) */ Store.init = function(s0) {
        /** Current state */ var s = s0;
        /** Transaction depth, only notify when setting at depth 0 */ var depth = 0;
        /** Only notify on transacts that actually did set */ var pending = false;
        /** Listeners */ var listeners = $17d8c0717df1150b$var$ListWithRemove();
        /** Notify listeners if applicable */ function notify() {
            if (depth == 0 && pending) {
                pending = false;
                // must use a transact because listeners might set the state again
                transact(function() {
                    return listeners.iter(function(k) {
                        return k();
                    });
                });
            }
        }
        function transact(m) {
            depth++;
            m();
            depth--;
            notify();
        }
        var set = function(v) {
            s = v;
            pending = true;
            notify();
        };
        return new Store(transact, function(k) {
            return listeners.push(k);
        }, function() {
            return s;
        }, set);
    };
    /** Get the current value (which must not be mutated)
  
        const store = Store.init(1)
        store.get()
        // => 1
  
    */ Store.prototype.get = function() {
        return this._get();
    };
    /** Set the value
  
        const store = Store.init(1)
        store.set(2)
        store.get()
        // => 2
  
    Returns itself. */ Store.prototype.set = function(s) {
        this._set(s);
        return this;
    };
    /** Update some parts of the state, keep the rest constant
  
        const store = Store.init({a: 1, b: 2})
        store.update({a: 3})
        store.get()
        // => {a: 3, b: 2}
  
    Returns itself. */ Store.prototype.update = function(parts) {
        var _this = this;
        var keys = Object.keys(parts);
        this.transact(function() {
            keys.forEach(function(k) {
                return _this.at(k).set(parts[k]);
            });
        });
        return this;
    };
    /** Modify the value in the store (must not use mutation: construct a new value)
  
        const store = Store.init(1)
        store.modify(x => x + 1)
        store.get()
        // => 2
  
    Returns itself. */ Store.prototype.modify = function(f) {
        this.set(f(this.get()));
        return this;
    };
    /** React on changes. Returns the unsubscribe function.
  
        const store = Store.init(1)
        let last
        const off = store.on(x => last = x)
        store.set(2)
        last // => 2
        off()
        store.set(3)
        last // => 2
  
    */ Store.prototype.on = function(k) {
        var _this = this;
        return this.listen(function() {
            return k(_this.get());
        });
    };
    /** React on a difference in value. Returns the unsubscribe function.
  
          const store = Store.init({a: 0})
          let diffs = 0
          const off = store.ondiff((new_value, old) => {
            assert.notEqual(new_value, old)
            diffs++
          })
          diffs // => 0
          const object = {a: 1}
          store.set(object)            // diff: new object
          diffs                        // => 1
          store.set(object)            // no diff: same object
          diffs                        // => 1
          store.set({a: 2})            // diff: new object
          diffs                        // => 2
          store.set({a: 2})            // diff: this is yet another new literal object
          diffs                        // => 3
          store.set(store.get())       // no diff: same object
          diffs                        // => 3
          store.modify(x => x)         // no diff: same object
          diffs                        // => 3
          store.at('a').modify(x => x) // diff: at does not see if the value actually changed
          diffs                        // => 4
  
    Note: keeps a reference to the last value in memory. */ Store.prototype.ondiff = function(k) {
        var old_value = this.get();
        return this.on(function(new_value) {
            if (new_value !== old_value) {
                k(new_value, old_value);
                old_value = new_value;
            }
        });
    };
    /** Start a new transaction: listeners are only invoked when the
    (top-level) transaction finishes, and not on set (and modify) inside the transaction.
  
        const store = Store.init(1)
        let last
        store.on(x => last = x)
        store.transaction(() => {
          store.set(2)
          assert.equal(last, undefined)
          return 3
        })   // => 3
        last // => 2
  
    */ Store.prototype.transaction = function(m) {
        var a;
        this.transact(function() {
            a = m();
        });
        return a; // unsafe cast, but safe because transact will run m (exactly once)
    };
    /** Zoom in on a subpart of the store via a lens
  
        const store = Store.init({a: 1, b: 2} as Record<string, number>)
        const a_store = store.via(Lens.key('a'))
        a_store.set(3)
        store.get() // => {a: 3, b: 2}
        a_store.get() // => 3
        a_store.set(undefined)
        store.get() // => {b: 2}
  
    */ Store.prototype.via = function(lens) {
        var _this = this;
        return new Store(this.transact, this.listen, function() {
            return lens.get(_this.get());
        }, function(t) {
            return _this.set(lens.set(_this.get(), t));
        });
    // possible "optimization": only set if t /= lens.get()
    };
    /** Make a substore at a key
  
        const store = Store.init({a: 1, b: 2})
        store.at('a').set(3)
        store.get() // => {a: 3, b: 2}
        store.at('a').get() // => 3
  
    Note: the key must always be present. */ Store.prototype.at = function(k) {
        return this.via($17d8c0717df1150b$var$Lens.at(k));
    };
    /** Make a substore by picking many keys
  
        const store = Store.init({a: 1, b: 2, c: 3})
        store.pick('a', 'b').get() // => {a: 1, b: 2}
        store.pick('a', 'b').set({a: 5, b: 4})
        store.get() // => {a: 5, b: 4, c: 3}
  
    Note: the keys must always be present. */ Store.prototype.pick = function() {
        var ks = [];
        for(var _i = 0; _i < arguments.length; _i++)ks[_i] = arguments[_i];
        return this.via($17d8c0717df1150b$var$Lens.pick.apply($17d8c0717df1150b$var$Lens, ks));
    };
    /** Make a substore which omits some keys
  
      const store = Store.init({a: 1, b: 2, c: 3, d: 4})
      const cd = store.omit('a', 'b')
      cd.get() // => {c: 3, d: 4}
      cd.set({c: 5, d: 6})
      store.get() // {a: 1, b: 2, c: 5, d: 6}
  
    */ Store.prototype.omit = function() {
        var ks = [];
        for(var _i = 0; _i < arguments.length; _i++)ks[_i] = arguments[_i];
        return this.via($17d8c0717df1150b$var$Lens.omit.apply($17d8c0717df1150b$var$Lens, ks));
    };
    /** Make a substore by relabelling
  
        const store = Store.init({a: 1, b: 2, c: 3})
        const other = store.relabel({x: store.at('a'), y: store.at('b')})
        other.get() // => {x: 1, y: 2}
        other.set({x: 5, y: 4})
        store.get() // => {a: 5, b: 4, c: 3}
  
    Note: must not use the same part of the store several times. */ Store.prototype.relabel = function(stores) {
        var _this = this;
        var keys = Object.keys(stores);
        return new Store(this.transact, this.listen, function() {
            var ret = {};
            keys.forEach(function(k) {
                ret[k] = stores[k].get();
            });
            return ret;
        }, function(t) {
            _this.transact(function() {
                keys.forEach(function(k) {
                    stores[k].set(t[k]);
                });
            });
        });
    };
    /** Merge two stores
  
        const store = Store.init({a: 1, b: 2, c: 3})
        const small = store.pick('a')
        const other = small.merge(store.relabel({z: store.at('c')}))
        other.get() // => {a: 1, z: 3}
        other.set({a: 0, z: 4})
        store.get() // => {a: 0, b: 2, c: 4}
  
    Note: the two stores must originate from the same root.
    Note: this store and the other store must both be objects.
    Note: must not use the same part of the store several times. */ Store.prototype.merge = function(other) {
        var _this = this;
        var other_keys = {};
        Object.keys(other.get()).forEach(function(k) {
            return other_keys[k] = true;
        });
        return new Store(this.transact, this.listen, function() {
            return $17d8c0717df1150b$var$__assign({}, _this.get(), other.get());
        }, function(t) {
            _this.transact(function() {
                Object.keys(t).forEach(function(k) {
                    if (k in other_keys) other.at(k).set(t[k]);
                    else _this.at(k).set(t[k]);
                });
            });
        });
    };
    /** Set the value using an array method (purity is ensured because the spine is copied before running the function)
  
        const store = Store.init(['a', 'b', 'c', 'd'])
        Store.arr(store, 'splice')(1, 2, 'x', 'y', 'z') // => ['b', 'c']
        store.get() // => ['a', 'x', 'y', 'z', 'd']
  
    (static method) */ Store.arr = function(store, k) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var xs = store.get().slice();
            var ret = xs[k].apply(xs, args);
            store.set(xs);
            return ret;
        };
    };
    /** Get partial stores for each position currently in the array
  
        const store = Store.init(['a', 'b', 'c'])
        Store.each(store).map((substore, i) => substore.modify(s => s + i.toString()))
        store.get() // => ['a0', 'b1', 'c2']
  
    (static method)
  
    Note: exceptions are thrown when looking outside the array. */ Store.each = function(store) {
        return store.get().map(function(_, i) {
            return store.via($17d8c0717df1150b$var$Lens.index(i));
        });
    };
    /** Connect with local storage */ Store.prototype.storage_connect = function(key, audit, api) {
        if (key === void 0) key = "state";
        if (audit === void 0) audit = function(_, str) {
            return str.length < 1000000;
        };
        if (api === void 0) api = {
            get: window.localStorage.getItem.bind(window.localStorage),
            set: window.localStorage.setItem.bind(window.localStorage)
        };
        var stored = api.get(key);
        if (stored) try {
            var parsed = JSON.parse(stored);
            if (audit(parsed, stored)) this.set(parsed);
        } catch (_) {
        // pass
        }
        return this.on(function(s) {
            var str = JSON.stringify(s);
            audit(s, str) && api.set(key, str);
        });
    };
    /** Connect with window.location.hash */ Store.location_connect = function(store, audit, api) {
        if (audit === void 0) audit = function() {
            return true;
        };
        if (api === void 0) api = {
            get: function() {
                return window.location.hash.slice(1);
            },
            set: function(s) {
                window.location.hash = s;
            },
            on: function(cb) {
                window.onhashchange = cb;
            }
        };
        var update = function() {
            var now = store.get();
            if (now != api.get()) {
                var updated = api.get();
                if (!audit(updated)) // gibberish, just revert it to what is now
                api.set(store.get());
                else store.set(updated);
            }
        };
        api.on(update);
        update();
        return store.on(function(hash) {
            if (hash != api.get()) api.set(hash);
        });
    };
    return Store;
}();
$17d8c0717df1150b$exports.Store = $17d8c0717df1150b$var$Store;
/** Attach a store with a virtual DOM, returning the reattach function for hot module reloading. */ function $17d8c0717df1150b$var$attach(render, init_state, setup_view) {
    function connect(store, setup_view) {
        var view = setup_view(store);
        function redraw() {
            store.transaction(function() {
                render(view());
            });
        }
        var off = store.on(redraw);
        redraw();
        return off;
    }
    var store = $17d8c0717df1150b$var$Store.init(init_state);
    var off = connect(store, setup_view);
    return function(setup_next_view) {
        off();
        store = $17d8c0717df1150b$var$Store.init(store.get());
        off = connect(store, setup_next_view);
    };
}
$17d8c0717df1150b$exports.attach = $17d8c0717df1150b$var$attach;
/** Common lens constructors and functions */ var $17d8c0717df1150b$var$Lens;
(function(Lens) {
    /** Make a lens from a getter and setter
  
    Note: lenses are subject to the three lens laws */ function lens(get, set) {
        return {
            get: get,
            set: set
        };
    }
    Lens.lens = lens;
    /** Lens from a record of lenses
  
    Note: must not use the same part of the store several times. */ function relabel(lenses) {
        var keys = Object.keys(lenses);
        return lens(function(s) {
            var ret = {};
            keys.forEach(function(k) {
                ret[k] = lenses[k].get(s);
            });
            return ret;
        }, function(s, t) {
            var r = s;
            keys.forEach(function(k) {
                r = lenses[k].set(r, t[k]);
            });
            return r;
        });
    }
    Lens.relabel = relabel;
    /** Lens to a key in a record
  
    Note: the key must always be present. */ function at(k) {
        return lens(function(s) {
            return s[k];
        }, function(s, v) {
            var _a;
            return $17d8c0717df1150b$var$__assign({}, s, (_a = {}, _a[k] = v, _a));
        });
    // unsafe cast // safe cast
    }
    Lens.at = at;
    /** Make a lens from an isomorphism.
  
        const store = Store.init(5)
        const doubled = store.via(Lens.iso(x => 2 * x, x => x / 2))
        doubled.get() // => 10
        doubled.set(50)
        store.get() // => 25
        doubled.modify(x => x * 2).get() // => 100
        store.get() // => 50
  
    Note: requires that for all `s` and `t` we have `f(g(t)) = t` and `g(f(s)) = s` */ function iso(f, g) {
        return lens(f, function(_s, t) {
            return g(t);
        });
    }
    Lens.iso = iso;
    /** Lens to a keys in a record
  
    Note: the keys must always be present. */ function pick() {
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var lenses = {};
        keys.forEach(function(k) {
            return lenses[k] = at(k);
        });
        return relabel(lenses);
    }
    Lens.pick = pick;
    /** Lens to a key in a record which may be missing
  
    Note: setting the value to undefined removes the key from the record. */ function key(k) {
        return lens(function(x) {
            return x[k];
        }, function(s, v) {
            // as string: safe cast
            // as any: https://github.com/Microsoft/TypeScript/issues/14409
            if (v === undefined) {
                var copy = {};
                for(var i in s)if (i != k) copy[i] = s[i];
                return copy;
            } else return $17d8c0717df1150b$var$__assign({}, s, (_a = {}, _a[k] = v, _a));
            var _a;
        });
    }
    Lens.key = key;
    /** Lens which refer to a default value instead of undefined
  
        const store = Store.init({a: 1, b: 2} as Record<string, number>)
        const a_store = store.via(Lens.key('a')).via(Lens.def(0))
        a_store.set(3)
        store.get() // => {a: 3, b: 2}
        a_store.get() // => 3
        a_store.set(0)
        store.get() // => {b: 2}
        a_store.modify(x => x + 1)
        store.get() // => {a: 1, b: 2}
  
    */ function def(missing) {
        return iso(function(a) {
            return a === undefined ? missing : a;
        }, function(a) {
            return a === missing ? undefined : a;
        });
    }
    Lens.def = def;
    /** Compose two lenses sequentially */ function seq(lens1, lens2) {
        return lens(function(s) {
            return lens2.get(lens1.get(s));
        }, function(s, u) {
            return lens1.set(s, lens2.set(lens1.get(s), u));
        });
    }
    Lens.seq = seq;
    /** Make a lens which omits some keys */ function omit() {
        var ks = [];
        for(var _i = 0; _i < arguments.length; _i++)ks[_i] = arguments[_i];
        var curry = function(s) {
            var all_keys = Object.keys(s);
            var picked = all_keys.filter(function(x) {
                return -1 == ks.indexOf(x);
            });
            return Lens.pick.apply(Lens, picked);
        };
        return Lens.lens(function(s) {
            return curry(s).get(s);
        }, function(s, t) {
            return curry(s).set(s, t);
        });
    }
    Lens.omit = omit;
    /** Partial lens to a particular index in an array
  
        const store = Store.init([0, 1, 2, 3])
        const first = store.via(Lens.index(0))
        first.get() // => 0
        first.set(99)
        store.get() // => [99, 1, 2, 3]
  
    Note: an exception is thrown if you look outside the array. */ function index(i) {
        var within = function(xs) {
            if (i < 0 || i >= xs.length) throw "Out of bounds";
        };
        return lens(function(xs) {
            return within(xs), xs[i];
        }, function(xs, x) {
            within(xs);
            var ys = xs.slice();
            ys[i] = x;
            return ys;
        });
    }
    Lens.index = index;
})($17d8c0717df1150b$var$Lens = $17d8c0717df1150b$exports.Lens || ($17d8c0717df1150b$exports.Lens = {}));
/** History zipper functions

    const {undo, redo, advance, advance_to} = Undo
    const store = Store.init(Undo.init({a: 1, b: 2}))
    const modify = op => store.modify(op)
    const now = store.at('now')
    now.get() // => {a: 1, b: 2}
    modify(advance_to({a: 3, b: 4}))
    now.get() // => {a: 3, b: 4}
    modify(undo)
    now.get() // => {a: 1, b: 2}
    modify(redo)
    now.get() // => {a: 3, b: 4}
    modify(advance)
    now.update({a: 5})
    now.get() // => {a: 5, b: 4}
    modify(undo)
    now.get() // => {a: 3, b: 4}
    modify(undo)
    now.get() // => {a: 1, b: 2}
    modify(undo)
    now.get() // => {a: 1, b: 2}

*/ var $17d8c0717df1150b$var$Undo;
(function(Undo) {
    /** Undo iff there is a past */ function undo(h) {
        if (h.prev != null) return {
            now: h.prev.top,
            prev: h.prev.pop,
            next: {
                top: h.now,
                pop: h.next
            }
        };
        else return h;
    }
    Undo.undo = undo;
    /** Redo iff there is a future */ function redo(h) {
        if (h.next != null) return {
            now: h.next.top,
            prev: {
                top: h.now,
                pop: h.prev
            },
            next: h.next.pop
        };
        else return h;
    }
    Undo.redo = redo;
    /** Advances the history by copying the present state */ function advance(h) {
        return {
            now: h.now,
            prev: {
                top: h.now,
                pop: h.prev
            },
            next: null
        };
    }
    Undo.advance = advance;
    /** Initialise the history */ function init(now) {
        return {
            now: now,
            prev: null,
            next: null
        };
    }
    Undo.init = init;
    /** Advances the history to some new state */ function advance_to(s) {
        return function(h) {
            return $17d8c0717df1150b$var$Lens.at("now").set(advance(h), s);
        };
    }
    Undo.advance_to = advance_to;
    /** Is there a state to undo to? */ function can_undo(h) {
        return h.prev != null;
    }
    Undo.can_undo = can_undo;
    /** Is there a state to redo to? */ function can_redo(h) {
        return h.next != null;
    }
    Undo.can_redo = can_redo;
})($17d8c0717df1150b$var$Undo = $17d8c0717df1150b$exports.Undo || ($17d8c0717df1150b$exports.Undo = {}));
/** List with iteration and O(1) push and remove */ function $17d8c0717df1150b$var$ListWithRemove() {
    var dict = {};
    var order = [];
    var next_unique = 0;
    var dirty = false;
    return {
        /** Push a new element, returns the delete function */ push: function(a) {
            var id = next_unique++;
            dict[id] = a;
            order.push(id);
            return function() {
                delete dict[id];
                dirty = true;
            };
        },
        /** Iterate over the elements */ iter: function(f) {
            if (dirty) {
                order = order.filter(function(id) {
                    return id in dict;
                });
                dirty = false;
            }
            order.forEach(function(id) {
                if (id in dict) f(dict[id]);
            });
        }
    };
}
/** Utility functions to make Elm/Redux-style requests

A queue of requests are maintained in an array.

TODO: Document and test. */ var $17d8c0717df1150b$var$Requests;
(function(Requests) {
    /** Make a function for making requests */ function request_maker(store) {
        return $17d8c0717df1150b$var$Store.arr(store, "push");
    }
    Requests.request_maker = request_maker;
    /** Make a request */ function request(store, request) {
        request_maker(store)(request);
    }
    Requests.request = request;
    /** Process requests, one at a time
  
    Retuns the off function. */ function process_requests(store, process) {
        return store.ondiff(function(requests) {
            if (requests.length > 0) store.transaction(function() {
                store.set([]);
                requests.forEach(process);
            });
        });
    }
    Requests.process_requests = process_requests;
})($17d8c0717df1150b$var$Requests = $17d8c0717df1150b$exports.Requests || ($17d8c0717df1150b$exports.Requests = {}));



var $b402d4a7f0e14377$exports = {};
var $566cb6e3cba7cd4f$exports = {};

$parcel$export($566cb6e3cba7cd4f$exports, "opposite", function () { return $566cb6e3cba7cd4f$export$a27c3a1c44ba515b; });
$parcel$export($566cb6e3cba7cd4f$exports, "sides", function () { return $566cb6e3cba7cd4f$export$832b6fa47fa053d2; });
$parcel$export($566cb6e3cba7cd4f$exports, "sidecase", function () { return $566cb6e3cba7cd4f$export$f9c0c991fb0646be; });
$parcel$export($566cb6e3cba7cd4f$exports, "mapSides", function () { return $566cb6e3cba7cd4f$export$e1ba3adfdc99288f; });
$parcel$export($566cb6e3cba7cd4f$exports, "Edge", function () { return $566cb6e3cba7cd4f$export$b9d9805c9b77a56d; });
$parcel$export($566cb6e3cba7cd4f$exports, "is_comment_label", function () { return $566cb6e3cba7cd4f$export$4d1b37ad7bc31b75; });
$parcel$export($566cb6e3cba7cd4f$exports, "merge_edges", function () { return $566cb6e3cba7cd4f$export$6b4ef9c17f912616; });
$parcel$export($566cb6e3cba7cd4f$exports, "zero_edge", function () { return $566cb6e3cba7cd4f$export$d56f0e7673f0b9d9; });
$parcel$export($566cb6e3cba7cd4f$exports, "edge_record", function () { return $566cb6e3cba7cd4f$export$27823d486efd100e; });
$parcel$export($566cb6e3cba7cd4f$exports, "check_invariant", function () { return $566cb6e3cba7cd4f$export$39ede186e36e8c0b; });
$parcel$export($566cb6e3cba7cd4f$exports, "target_texts", function () { return $566cb6e3cba7cd4f$export$bcca83b25b058d41; });
$parcel$export($566cb6e3cba7cd4f$exports, "source_texts", function () { return $566cb6e3cba7cd4f$export$1aa3e3e981886a9b; });
$parcel$export($566cb6e3cba7cd4f$exports, "align", function () { return $566cb6e3cba7cd4f$export$9ea32abc1be18076; });
$parcel$export($566cb6e3cba7cd4f$exports, "is_graph", function () { return $566cb6e3cba7cd4f$export$23b96a0307014ab2; });
$parcel$export($566cb6e3cba7cd4f$exports, "init", function () { return $566cb6e3cba7cd4f$export$2cd8252107eb640b; });
$parcel$export($566cb6e3cba7cd4f$exports, "init_from", function () { return $566cb6e3cba7cd4f$export$8170fdccd13fc536; });
$parcel$export($566cb6e3cba7cd4f$exports, "empty", function () { return $566cb6e3cba7cd4f$export$6e22c362a0406a2c; });
$parcel$export($566cb6e3cba7cd4f$exports, "set_comment", function () { return $566cb6e3cba7cd4f$export$b9ae51c2964107cf; });
$parcel$export($566cb6e3cba7cd4f$exports, "clone", function () { return $566cb6e3cba7cd4f$export$9cd59f9826255e47; });
$parcel$export($566cb6e3cba7cd4f$exports, "from_unaligned", function () { return $566cb6e3cba7cd4f$export$cf3044484bb03519; });
$parcel$export($566cb6e3cba7cd4f$exports, "edge_map", function () { return $566cb6e3cba7cd4f$export$13b0e7a577fb573c; });
$parcel$export($566cb6e3cba7cd4f$exports, "token_ids_to_edges", function () { return $566cb6e3cba7cd4f$export$8d414a6135f9d320; });
$parcel$export($566cb6e3cba7cd4f$exports, "token_ids_to_edge_ids", function () { return $566cb6e3cba7cd4f$export$d382192b07e5eedd; });
$parcel$export($566cb6e3cba7cd4f$exports, "partition_ids", function () { return $566cb6e3cba7cd4f$export$2ec92a4fdd52410a; });
$parcel$export($566cb6e3cba7cd4f$exports, "source_map", function () { return $566cb6e3cba7cd4f$export$d36e500d2474b487; });
$parcel$export($566cb6e3cba7cd4f$exports, "target_map", function () { return $566cb6e3cba7cd4f$export$4d058cb8e7aacf9e; });
$parcel$export($566cb6e3cba7cd4f$exports, "token_map", function () { return $566cb6e3cba7cd4f$export$a669ad57b3bc989b; });
$parcel$export($566cb6e3cba7cd4f$exports, "edge_at", function () { return $566cb6e3cba7cd4f$export$93a4046b31a058e0; });
$parcel$export($566cb6e3cba7cd4f$exports, "related", function () { return $566cb6e3cba7cd4f$export$10a2f465a9af7604; });
$parcel$export($566cb6e3cba7cd4f$exports, "target_text", function () { return $566cb6e3cba7cd4f$export$8bc6b66de3102a9d; });
$parcel$export($566cb6e3cba7cd4f$exports, "source_text", function () { return $566cb6e3cba7cd4f$export$4f78c7b40cf11a9a; });
$parcel$export($566cb6e3cba7cd4f$exports, "next_id", function () { return $566cb6e3cba7cd4f$export$42ac17aabdaccaaf; });
$parcel$export($566cb6e3cba7cd4f$exports, "unaligned_modify", function () { return $566cb6e3cba7cd4f$export$13caaff6d048129b; });
$parcel$export($566cb6e3cba7cd4f$exports, "get_side_texts", function () { return $566cb6e3cba7cd4f$export$45415d7f69065d4f; });
$parcel$export($566cb6e3cba7cd4f$exports, "get_side_text", function () { return $566cb6e3cba7cd4f$export$e9abecb4b4534687; });
$parcel$export($566cb6e3cba7cd4f$exports, "unaligned_modify_tokens", function () { return $566cb6e3cba7cd4f$export$fc53b94a430e131; });
$parcel$export($566cb6e3cba7cd4f$exports, "modify", function () { return $566cb6e3cba7cd4f$export$3ff57735a52b8713; });
$parcel$export($566cb6e3cba7cd4f$exports, "modify_tokens", function () { return $566cb6e3cba7cd4f$export$72d5c64f9cc56871; });
$parcel$export($566cb6e3cba7cd4f$exports, "unaligned_rearrange", function () { return $566cb6e3cba7cd4f$export$14ebf44f366567dd; });
$parcel$export($566cb6e3cba7cd4f$exports, "rearrange", function () { return $566cb6e3cba7cd4f$export$3286e37e80af903; });
$parcel$export($566cb6e3cba7cd4f$exports, "unaligned_set_side", function () { return $566cb6e3cba7cd4f$export$43b47dab349addfb; });
$parcel$export($566cb6e3cba7cd4f$exports, "set_target", function () { return $566cb6e3cba7cd4f$export$fa4f16e9ce2f3748; });
$parcel$export($566cb6e3cba7cd4f$exports, "set_source", function () { return $566cb6e3cba7cd4f$export$abfa187bec951c1; });
$parcel$export($566cb6e3cba7cd4f$exports, "set_side", function () { return $566cb6e3cba7cd4f$export$d1eddfd431b5acad; });
$parcel$export($566cb6e3cba7cd4f$exports, "unaligned_invert", function () { return $566cb6e3cba7cd4f$export$be93d9364d30f087; });
$parcel$export($566cb6e3cba7cd4f$exports, "invert", function () { return $566cb6e3cba7cd4f$export$6897c284b6f9f4dc; });
$parcel$export($566cb6e3cba7cd4f$exports, "unaligned_revert", function () { return $566cb6e3cba7cd4f$export$b39b0465aa0379b9; });
$parcel$export($566cb6e3cba7cd4f$exports, "calculate_dnd_diff", function () { return $566cb6e3cba7cd4f$export$157d502e885eaac3; });
$parcel$export($566cb6e3cba7cd4f$exports, "from_dnd_diff", function () { return $566cb6e3cba7cd4f$export$4f76bac744e2a890; });
$parcel$export($566cb6e3cba7cd4f$exports, "revert", function () { return $566cb6e3cba7cd4f$export$3fdd26f3d9e7dc78; });
$parcel$export($566cb6e3cba7cd4f$exports, "connect", function () { return $566cb6e3cba7cd4f$export$64605811ab45167f; });
$parcel$export($566cb6e3cba7cd4f$exports, "disconnect", function () { return $566cb6e3cba7cd4f$export$37dfea93db2e14ed; });
$parcel$export($566cb6e3cba7cd4f$exports, "edge_first_index", function () { return $566cb6e3cba7cd4f$export$21198a890f6b0d7d; });
$parcel$export($566cb6e3cba7cd4f$exports, "group_consecutive", function () { return $566cb6e3cba7cd4f$export$83844fbbb0a27299; });
$parcel$export($566cb6e3cba7cd4f$exports, "calculate_diff", function () { return $566cb6e3cba7cd4f$export$801569266451b712; });
$parcel$export($566cb6e3cba7cd4f$exports, "split_up_edits", function () { return $566cb6e3cba7cd4f$export$d05562b754e74081; });
$parcel$export($566cb6e3cba7cd4f$exports, "diff_to_graph", function () { return $566cb6e3cba7cd4f$export$3cf150b3f5a90d5f; });
$parcel$export($566cb6e3cba7cd4f$exports, "target_sentence", function () { return $566cb6e3cba7cd4f$export$32fe3c41b81e8036; });
$parcel$export($566cb6e3cba7cd4f$exports, "subspan_merge", function () { return $566cb6e3cba7cd4f$export$cccc4cc31d5a14b; });
$parcel$export($566cb6e3cba7cd4f$exports, "subspan_to_indicies", function () { return $566cb6e3cba7cd4f$export$2fd78a041f969714; });
$parcel$export($566cb6e3cba7cd4f$exports, "sentences", function () { return $566cb6e3cba7cd4f$export$e54858d5d3f4b923; });
$parcel$export($566cb6e3cba7cd4f$exports, "sentences_around", function () { return $566cb6e3cba7cd4f$export$49709d8cccb10e07; });
$parcel$export($566cb6e3cba7cd4f$exports, "all_sentences", function () { return $566cb6e3cba7cd4f$export$c662939406e0fc09; });
$parcel$export($566cb6e3cba7cd4f$exports, "subgraph", function () { return $566cb6e3cba7cd4f$export$ecd98896577df54e; });
$parcel$export($566cb6e3cba7cd4f$exports, "indicies_around_positions", function () { return $566cb6e3cba7cd4f$export$33eaa0f45f0e6960; });
$parcel$export($566cb6e3cba7cd4f$exports, "sentence_groups", function () { return $566cb6e3cba7cd4f$export$a26fd11fb69f7d4c; });
$parcel$export($566cb6e3cba7cd4f$exports, "used_labels", function () { return $566cb6e3cba7cd4f$export$479ec94dbc76044a; });
$parcel$export($566cb6e3cba7cd4f$exports, "modify_labels", function () { return $566cb6e3cba7cd4f$export$5f402a225d1edecc; });
$parcel$export($566cb6e3cba7cd4f$exports, "edge_store", function () { return $566cb6e3cba7cd4f$export$9450cd7eaa1fab13; });
$parcel$export($566cb6e3cba7cd4f$exports, "comment_edge", function () { return $566cb6e3cba7cd4f$export$3ad331fd950bc447; });
$parcel$export($566cb6e3cba7cd4f$exports, "normalize", function () { return $566cb6e3cba7cd4f$export$a3295358bff77e; });
$parcel$export($566cb6e3cba7cd4f$exports, "equal", function () { return $566cb6e3cba7cd4f$export$411ce8e5a71e3069; });
$parcel$export($566cb6e3cba7cd4f$exports, "normalize_whitespace", function () { return $566cb6e3cba7cd4f$export$a2d48d31bcf0d424; });
$parcel$export($566cb6e3cba7cd4f$exports, "source_to_target", function () { return $566cb6e3cba7cd4f$export$97d6f5b546d7d09f; });
$parcel$export($566cb6e3cba7cd4f$exports, "sort_edge_labels", function () { return $566cb6e3cba7cd4f$export$3d1c8131457e647; });
$parcel$export($566cb6e3cba7cd4f$exports, "label_edge_map", function () { return $566cb6e3cba7cd4f$export$c555d49ba8ab6cad; });
/** Parallel corpus as a graph */ function $45dc1e3851ea45b5$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}


function $1119b291707c3284$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}


/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      var t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var $8e63af234d14ba1a$var$always = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function always(val) {
    return function() {
        return val;
    };
});
var $8e63af234d14ba1a$export$2e2bcd8739ae039 = $8e63af234d14ba1a$var$always;


/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */ var $be3c44954cbd1a40$var$F = /*#__PURE__*/ (0, $8e63af234d14ba1a$export$2e2bcd8739ae039)(false);
var $be3c44954cbd1a40$export$2e2bcd8739ae039 = $be3c44954cbd1a40$var$F;



/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.F
 * @example
 *
 *      R.T(); //=> true
 */ var $a7728c965a9c3ff1$var$T = /*#__PURE__*/ (0, $8e63af234d14ba1a$export$2e2bcd8739ae039)(true);
var $a7728c965a9c3ff1$export$2e2bcd8739ae039 = $a7728c965a9c3ff1$var$T;


/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      var greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var $06eff9a88b5c2eb9$export$2e2bcd8739ae039 = {
    "@@functional/placeholder": true
};




function $5bc7a8bc494b0aa9$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) ? f2 : (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) ? f2 : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) ? (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) ? (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}


/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var $f019de71e8a06f52$var$add = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function add(a, b) {
    return Number(a) + Number(b);
});
var $f019de71e8a06f52$export$2e2bcd8739ae039 = $f019de71e8a06f52$var$add;


/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ function $77ebcc3f4af9905b$export$2e2bcd8739ae039(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}



function $b92606b8e25b6843$export$2e2bcd8739ae039(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
}






function $53afa373fbec91db$export$2e2bcd8739ae039(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(left, $53afa373fbec91db$export$2e2bcd8739ae039(length, combined, fn));
    };
}


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      var sumArgs = (...args) => R.sum(args);
 *
 *      var curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */ var $9e65c03c0b3b4a25$var$curryN = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function curryN(length, fn) {
    if (length === 1) return (0, $1119b291707c3284$export$2e2bcd8739ae039)(fn);
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(length, (0, $53afa373fbec91db$export$2e2bcd8739ae039)(length, [], fn));
});
var $9e65c03c0b3b4a25$export$2e2bcd8739ae039 = $9e65c03c0b3b4a25$var$curryN;


/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> (a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      var mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var $9d607ad6ce1a2566$var$addIndex = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function addIndex(fn) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
var $9d607ad6ce1a2566$export$2e2bcd8739ae039 = $9d607ad6ce1a2566$var$addIndex;






function $e7795d8db44cc84b$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) ? f3 : (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) ? f3 : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) ? (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) ? (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(c) ? f3 : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) ? (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(c) ? (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) && (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(c) ? (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(a) ? (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(b) ? (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $45dc1e3851ea45b5$export$2e2bcd8739ae039)(c) ? (0, $1119b291707c3284$export$2e2bcd8739ae039)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}


/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig (a -> a) -> Number -> [a] -> [a]
 * @param {Function} fn The function to apply.
 * @param {Number} idx The index.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(R.add(10), 1, [1, 2, 3]);     //=> [1, 12, 3]
 *      R.adjust(R.add(10))(1)([1, 2, 3]);     //=> [1, 12, 3]
 * @symb R.adjust(f, -1, [a, b]) = [a, f(b)]
 * @symb R.adjust(f, 0, [a, b]) = [f(a), b]
 */ var $fcd6a9bca4955925$var$adjust = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function adjust(fn, idx, list) {
    if (idx >= list.length || idx < -list.length) return list;
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
var $fcd6a9bca4955925$export$2e2bcd8739ae039 = $fcd6a9bca4955925$var$adjust;



/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $2d039bdca17f43bf$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};


function $f855957a4a9612bf$export$2e2bcd8739ae039(obj) {
    return typeof obj["@@transducer/step"] === "function";
}


function $e82fd3c19264968c$export$2e2bcd8739ae039(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === "function") return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, $f855957a4a9612bf$export$2e2bcd8739ae039)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}



function $0079da3350b7af31$export$2e2bcd8739ae039(x) {
    return x && x["@@transducer/reduced"] ? x : {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}


var $75b4df47bddaba3e$export$2e2bcd8739ae039 = {
    init: function() {
        return this.xf["@@transducer/init"]();
    },
    result: function(result) {
        return this.xf["@@transducer/result"](result);
    }
};


var $db71956d1f1729d2$var$XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XAll.prototype["@@transducer/result"] = function(result) {
        if (this.all) result = this.xf["@@transducer/step"](result, true);
        return this.xf["@@transducer/result"](result);
    };
    XAll.prototype["@@transducer/step"] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, $0079da3350b7af31$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, false));
        }
        return result;
    };
    return XAll;
}();
var $db71956d1f1729d2$var$_xall = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xall(f, xf) {
    return new $db71956d1f1729d2$var$XAll(f, xf);
});
var $db71956d1f1729d2$export$2e2bcd8739ae039 = $db71956d1f1729d2$var$_xall;


/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      var equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var $b3f97e37d6ab2dee$var$all = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "all"
], (0, $db71956d1f1729d2$export$2e2bcd8739ae039), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
var $b3f97e37d6ab2dee$export$2e2bcd8739ae039 = $b3f97e37d6ab2dee$var$all;





/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var $6204b82ba19ab48a$var$max = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function max(a, b) {
    return b > a ? b : a;
});
var $6204b82ba19ab48a$export$2e2bcd8739ae039 = $6204b82ba19ab48a$var$max;





function $de665e827334f055$export$2e2bcd8739ae039(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}




function $e9802355e9a971f3$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var $b2aaca034408573f$var$_isArrayLike = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function isArrayLike(x) {
    if ((0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(x)) return true;
    if (!x) return false;
    if (typeof x !== "object") return false;
    if ((0, $e9802355e9a971f3$export$2e2bcd8739ae039)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
var $b2aaca034408573f$export$2e2bcd8739ae039 = $b2aaca034408573f$var$_isArrayLike;


var $4d56fbe3ec82dcda$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype["@@transducer/init"] = function() {
        throw new Error("init not implemented on XWrap");
    };
    XWrap.prototype["@@transducer/result"] = function(acc) {
        return acc;
    };
    XWrap.prototype["@@transducer/step"] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $4d56fbe3ec82dcda$export$2e2bcd8739ae039(fn) {
    return new $4d56fbe3ec82dcda$var$XWrap(fn);
}




/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      var log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $1ff6471db06bc0ba$var$bind = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function bind(fn, thisObj) {
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
var $1ff6471db06bc0ba$export$2e2bcd8739ae039 = $1ff6471db06bc0ba$var$bind;


function $eeff341e2e828e35$var$_arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf["@@transducer/step"](acc, list[idx]);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        idx += 1;
    }
    return xf["@@transducer/result"](acc);
}
function $eeff341e2e828e35$var$_iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf["@@transducer/step"](acc, step.value);
        if (acc && acc["@@transducer/reduced"]) {
            acc = acc["@@transducer/value"];
            break;
        }
        step = iter.next();
    }
    return xf["@@transducer/result"](acc);
}
function $eeff341e2e828e35$var$_methodReduce(xf, acc, obj, methodName) {
    return xf["@@transducer/result"](obj[methodName]((0, $1ff6471db06bc0ba$export$2e2bcd8739ae039)(xf["@@transducer/step"], xf), acc));
}
var $eeff341e2e828e35$var$symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function $eeff341e2e828e35$export$2e2bcd8739ae039(fn, acc, list) {
    if (typeof fn === "function") fn = (0, $4d56fbe3ec82dcda$export$2e2bcd8739ae039)(fn);
    if ((0, $b2aaca034408573f$export$2e2bcd8739ae039)(list)) return $eeff341e2e828e35$var$_arrayReduce(fn, acc, list);
    if (typeof list["fantasy-land/reduce"] === "function") return $eeff341e2e828e35$var$_methodReduce(fn, acc, list, "fantasy-land/reduce");
    if (list[$eeff341e2e828e35$var$symIterator] != null) return $eeff341e2e828e35$var$_iterableReduce(fn, acc, list[$eeff341e2e828e35$var$symIterator]());
    if (typeof list.next === "function") return $eeff341e2e828e35$var$_iterableReduce(fn, acc, list);
    if (typeof list.reduce === "function") return $eeff341e2e828e35$var$_methodReduce(fn, acc, list, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
}




var $20a3a1533f900427$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XMap.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XMap.prototype["@@transducer/step"] = function(result, input) {
        return this.xf["@@transducer/step"](result, this.f(input));
    };
    return XMap;
}();
var $20a3a1533f900427$var$_xmap = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xmap(f, xf) {
    return new $20a3a1533f900427$var$XMap(f, xf);
});
var $20a3a1533f900427$export$2e2bcd8739ae039 = $20a3a1533f900427$var$_xmap;




function $88eb77390bd89c62$export$2e2bcd8739ae039(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}



var $39b7a2b3276535bb$var$toString = Object.prototype.toString;
var $39b7a2b3276535bb$var$_isArguments = function() {
    return $39b7a2b3276535bb$var$toString.call(arguments) === "[object Arguments]" ? function _isArguments(x) {
        return $39b7a2b3276535bb$var$toString.call(x) === "[object Arguments]";
    } : function _isArguments(x) {
        return (0, $88eb77390bd89c62$export$2e2bcd8739ae039)("callee", x);
    };
};
var $39b7a2b3276535bb$export$2e2bcd8739ae039 = $39b7a2b3276535bb$var$_isArguments;


// cover IE < 9 keys issues
var $7bd231648493210b$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable("toString");
var $7bd231648493210b$var$nonEnumerableProps = [
    "constructor",
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
// Safari bug
var $7bd231648493210b$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    "use strict";
    return arguments.propertyIsEnumerable("length");
}();
var $7bd231648493210b$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $7bd231648493210b$var$_keys = typeof Object.keys === "function" && !$7bd231648493210b$var$hasArgsEnumBug ? function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
} : function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $7bd231648493210b$var$hasArgsEnumBug && (0, $39b7a2b3276535bb$export$2e2bcd8739ae039)(obj);
    for(prop in obj)if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(prop, obj) && (!checkArgsLength || prop !== "length")) ks[ks.length] = prop;
    if ($7bd231648493210b$var$hasEnumBug) {
        nIdx = $7bd231648493210b$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $7bd231648493210b$var$nonEnumerableProps[nIdx];
            if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(prop, obj) && !$7bd231648493210b$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
};
var $7bd231648493210b$var$keys = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)($7bd231648493210b$var$_keys);
var $7bd231648493210b$export$2e2bcd8739ae039 = $7bd231648493210b$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      var double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $eeba40a83c1af2c4$var$map = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "fantasy-land/map",
    "map"
], (0, $20a3a1533f900427$export$2e2bcd8739ae039), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case "[object Function]":
            return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case "[object Object]":
            return (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, $7bd231648493210b$export$2e2bcd8739ae039)(functor));
        default:
            return (0, $de665e827334f055$export$2e2bcd8739ae039)(fn, functor);
    }
}));
var $eeba40a83c1af2c4$export$2e2bcd8739ae039 = $eeba40a83c1af2c4$var$map;




/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */ var $50cfe1e3236edffe$var$path = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function path(paths, obj) {
    var val = obj;
    var idx = 0;
    while(idx < paths.length){
        if (val == null) return;
        val = val[paths[idx]];
        idx += 1;
    }
    return val;
});
var $50cfe1e3236edffe$export$2e2bcd8739ae039 = $50cfe1e3236edffe$var$path;


/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 */ var $db1c0ae5df507421$var$prop = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function prop(p, obj) {
    return (0, $50cfe1e3236edffe$export$2e2bcd8739ae039)([
        p
    ], obj);
});
var $db1c0ae5df507421$export$2e2bcd8739ae039 = $db1c0ae5df507421$var$prop;


/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      R.pluck('a')([{a: 1}, {a: 2}]); //=> [1, 2]
 *      R.pluck(0)([[1, 2], [3, 4]]);   //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var $20af923c068efeea$var$pluck = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function pluck(p, list) {
    return (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)((0, $db1c0ae5df507421$export$2e2bcd8739ae039)(p), list);
});
var $20af923c068efeea$export$2e2bcd8739ae039 = $20af923c068efeea$var$pluck;




/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $7452afdb416c43f8$var$reduce = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)((0, $eeff341e2e828e35$export$2e2bcd8739ae039));
var $7452afdb416c43f8$export$2e2bcd8739ae039 = $7452afdb416c43f8$var$reduce;


/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      var isQueen = R.propEq('rank', 'Q');
 *      var isSpade = R.propEq('suit', '♠︎');
 *      var isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var $88cd691dec1de35f$var$allPass = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function allPass(preds) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)((0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $6204b82ba19ab48a$export$2e2bcd8739ae039), 0, (0, $20af923c068efeea$export$2e2bcd8739ae039)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
var $88cd691dec1de35f$export$2e2bcd8739ae039 = $88cd691dec1de35f$var$allPass;




/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var $e83df1add25442cb$var$and = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function and(a, b) {
    return a && b;
});
var $e83df1add25442cb$export$2e2bcd8739ae039 = $e83df1add25442cb$var$and;







var $ad62fc19e10ee0c1$var$XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XAny.prototype["@@transducer/result"] = function(result) {
        if (!this.any) result = this.xf["@@transducer/step"](result, false);
        return this.xf["@@transducer/result"](result);
    };
    XAny.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, $0079da3350b7af31$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, true));
        }
        return result;
    };
    return XAny;
}();
var $ad62fc19e10ee0c1$var$_xany = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xany(f, xf) {
    return new $ad62fc19e10ee0c1$var$XAny(f, xf);
});
var $ad62fc19e10ee0c1$export$2e2bcd8739ae039 = $ad62fc19e10ee0c1$var$_xany;


/**
 * Returns `true` if at least one of elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      var lessThan0 = R.flip(R.lt)(0);
 *      var lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var $98f0f3c4f07b45c4$var$any = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "any"
], (0, $ad62fc19e10ee0c1$export$2e2bcd8739ae039), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
var $98f0f3c4f07b45c4$export$2e2bcd8739ae039 = $98f0f3c4f07b45c4$var$any;







/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      var isClub = R.propEq('suit', '♣');
 *      var isSpade = R.propEq('suit', '♠');
 *      var isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var $3390b5d7de574bcf$var$anyPass = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function anyPass(preds) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)((0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $6204b82ba19ab48a$export$2e2bcd8739ae039), 0, (0, $20af923c068efeea$export$2e2bcd8739ae039)("length", preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
var $3390b5d7de574bcf$export$2e2bcd8739ae039 = $3390b5d7de574bcf$var$anyPass;






/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (a -> b -> c) -> (a -> b) -> (a -> c)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var $58ae1df029b78e7c$var$ap = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function ap(applyF, applyX) {
    return typeof applyX["fantasy-land/ap"] === "function" ? applyX["fantasy-land/ap"](applyF) : typeof applyF.ap === "function" ? applyF.ap(applyX) : typeof applyF === "function" ? function(x) {
        return applyF(x)(applyX(x));
    } : // else
    (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(function(acc, f) {
        return (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)(acc, (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(f, applyX));
    }, [], applyF);
});
var $58ae1df029b78e7c$export$2e2bcd8739ae039 = $58ae1df029b78e7c$var$ap;


function $e81ca85952250262$export$2e2bcd8739ae039(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}







var $dddc3506049f0649$var$XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XAperture.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XAperture.prototype["@@transducer/step"] = function(result, input) {
        this.store(input);
        return this.full ? this.xf["@@transducer/step"](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var $dddc3506049f0649$var$_xaperture = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xaperture(n, xf) {
    return new $dddc3506049f0649$var$XAperture(n, xf);
});
var $dddc3506049f0649$export$2e2bcd8739ae039 = $dddc3506049f0649$var$_xaperture;


/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var $221d662d8cac9deb$var$aperture = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $dddc3506049f0649$export$2e2bcd8739ae039), (0, $e81ca85952250262$export$2e2bcd8739ae039)));
var $221d662d8cac9deb$export$2e2bcd8739ae039 = $221d662d8cac9deb$var$aperture;




/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var $780f703f2778694a$var$append = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function append(el, list) {
    return (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)(list, [
        el
    ]);
});
var $780f703f2778694a$export$2e2bcd8739ae039 = $780f703f2778694a$var$append;



/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      var nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var $2475babd9d8dcc62$var$apply = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function apply(fn, args) {
    return fn.apply(this, args);
});
var $2475babd9d8dcc62$export$2e2bcd8739ae039 = $2475babd9d8dcc62$var$apply;











/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var $020e2ebaafa140d3$var$values = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function values(obj) {
    var props = (0, $7bd231648493210b$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
var $020e2ebaafa140d3$export$2e2bcd8739ae039 = $020e2ebaafa140d3$var$values;


/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      var getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var $a43166d6d0f7f4ee$var$applySpec = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function applySpec(spec) {
    spec = (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(function(v) {
        return typeof v == "function" ? v : applySpec(v);
    }, spec);
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)((0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $6204b82ba19ab48a$export$2e2bcd8739ae039), 0, (0, $20af923c068efeea$export$2e2bcd8739ae039)("length", (0, $020e2ebaafa140d3$export$2e2bcd8739ae039)(spec))), function() {
        var args = arguments;
        return (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(function(f) {
            return (0, $2475babd9d8dcc62$export$2e2bcd8739ae039)(f, args);
        }, spec);
    });
});
var $a43166d6d0f7f4ee$export$2e2bcd8739ae039 = $a43166d6d0f7f4ee$var$applySpec;



/**
* Takes a value and applies a function to it.
*
* This function is also known as the `thrush` combinator.
*
* @func
* @memberOf R
 * @since v0.25.0
* @category Function
* @sig a -> (a -> b) -> b
* @param {*} x The value
* @param {Function} f The function to apply
* @return {*} The result of applying `f` to `x`
* @example
*
*      var t42 = R.applyTo(42);
*      t42(R.identity); //=> 42
*      t42(R.add(1)); //=> 43
*/ var $ac7808daade2acb2$var$applyTo = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function applyTo(x, f) {
    return f(x);
});
var $ac7808daade2acb2$export$2e2bcd8739ae039 = $ac7808daade2acb2$var$applyTo;



/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      var byAge = R.ascend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByYoungestFirst = R.sort(byAge, people);
 */ var $a0c014520ff1521d$var$ascend = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
var $a0c014520ff1521d$export$2e2bcd8739ae039 = $a0c014520ff1521d$var$ascend;



/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var $d38b1d7ec30b4cc6$var$assoc = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function assoc(prop, val, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
});
var $d38b1d7ec30b4cc6$export$2e2bcd8739ae039 = $d38b1d7ec30b4cc6$var$assoc;





/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var $16dfade75a60b17d$export$2e2bcd8739ae039 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};




/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var $137b501e3ff61b75$var$isNil = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function isNil(x) {
    return x == null;
});
var $137b501e3ff61b75$export$2e2bcd8739ae039 = $137b501e3ff61b75$var$isNil;


/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var $1d89aceb744d3614$var$assocPath = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, $137b501e3ff61b75$export$2e2bcd8739ae039)(obj) && (0, $88eb77390bd89c62$export$2e2bcd8739ae039)(idx, obj) ? obj[idx] : (0, $16dfade75a60b17d$export$2e2bcd8739ae039)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    if ((0, $16dfade75a60b17d$export$2e2bcd8739ae039)(idx) && (0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(obj)) {
        var arr = [].concat(obj);
        arr[idx] = val;
        return arr;
    } else return (0, $d38b1d7ec30b4cc6$export$2e2bcd8739ae039)(idx, val, obj);
});
var $1d89aceb744d3614$export$2e2bcd8739ae039 = $1d89aceb744d3614$var$assocPath;




/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      var takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var $3a7e87844ea63781$var$nAry = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error("First argument to nAry must be a non-negative integer no greater than ten");
    }
});
var $3a7e87844ea63781$export$2e2bcd8739ae039 = $3a7e87844ea63781$var$nAry;


/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      var takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      var takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var $481bda5e73a94543$var$binary = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function binary(fn) {
    return (0, $3a7e87844ea63781$export$2e2bcd8739ae039)(2, fn);
});
var $481bda5e73a94543$export$2e2bcd8739ae039 = $481bda5e73a94543$var$binary;




function $52388c18ea030e9e$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Function]";
}









/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      var madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var $8b1baa26315250af$var$liftN = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function liftN(arity, fn) {
    var lifted = (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(arity, fn);
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(arity, function() {
        return (0, $eeff341e2e828e35$export$2e2bcd8739ae039)((0, $58ae1df029b78e7c$export$2e2bcd8739ae039), (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
var $8b1baa26315250af$export$2e2bcd8739ae039 = $8b1baa26315250af$var$liftN;


/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      var madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      var madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */ var $97e36b70d21dd970$var$lift = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function lift(fn) {
    return (0, $8b1baa26315250af$export$2e2bcd8739ae039)(fn.length, fn);
});
var $97e36b70d21dd970$export$2e2bcd8739ae039 = $97e36b70d21dd970$var$lift;


/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      var gt10 = R.gt(R.__, 10)
 *      var lt20 = R.lt(R.__, 20)
 *      var f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 */ var $bdc36488d7f1425c$var$both = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function both(f, g) {
    return (0, $52388c18ea030e9e$export$2e2bcd8739ae039)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, $97e36b70d21dd970$export$2e2bcd8739ae039)((0, $e83df1add25442cb$export$2e2bcd8739ae039))(f, g);
});
var $bdc36488d7f1425c$export$2e2bcd8739ae039 = $bdc36488d7f1425c$var$both;




/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN
 * @example
 *
 *      var addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      var curriedAddFourNumbers = R.curry(addFourNumbers);
 *      var f = curriedAddFourNumbers(1, 2);
 *      var g = f(3);
 *      g(4); //=> 10
 */ var $d8a10bb9a75db244$var$curry = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function curry(fn) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(fn.length, fn);
});
var $d8a10bb9a75db244$export$2e2bcd8739ae039 = $d8a10bb9a75db244$var$curry;


/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      var indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      var format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var $2cdea76982142116$var$call = /*#__PURE__*/ (0, $d8a10bb9a75db244$export$2e2bcd8739ae039)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
var $2cdea76982142116$export$2e2bcd8739ae039 = $2cdea76982142116$var$call;





function $69211660636da41c$export$2e2bcd8739ae039(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, $b2aaca034408573f$export$2e2bcd8739ae039)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}



function $0463d5a1c2709be6$export$2e2bcd8739ae039(x) {
    return {
        "@@transducer/value": x,
        "@@transducer/reduced": true
    };
}





var $525f84ee45c00ccb$var$preservingReduced = function(xf) {
    return {
        "@@transducer/init": (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init,
        "@@transducer/result": function(result) {
            return xf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            var ret = xf["@@transducer/step"](result, input);
            return ret["@@transducer/reduced"] ? (0, $0463d5a1c2709be6$export$2e2bcd8739ae039)(ret) : ret;
        }
    };
};
var $525f84ee45c00ccb$var$_flatCat = function _xcat(xf) {
    var rxf = $525f84ee45c00ccb$var$preservingReduced(xf);
    return {
        "@@transducer/init": (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init,
        "@@transducer/result": function(result) {
            return rxf["@@transducer/result"](result);
        },
        "@@transducer/step": function(result, input) {
            return !(0, $b2aaca034408573f$export$2e2bcd8739ae039)(input) ? (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(rxf, result, [
                input
            ]) : (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(rxf, result, input);
        }
    };
};
var $525f84ee45c00ccb$export$2e2bcd8739ae039 = $525f84ee45c00ccb$var$_flatCat;



var $8b3dcb6a0d2445ed$var$_xchain = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xchain(f, xf) {
    return (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(f, (0, $525f84ee45c00ccb$export$2e2bcd8739ae039)(xf));
});
var $8b3dcb6a0d2445ed$export$2e2bcd8739ae039 = $8b3dcb6a0d2445ed$var$_xchain;



/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      var duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var $404a156d8184580f$var$chain = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "fantasy-land/chain",
    "chain"
], (0, $8b3dcb6a0d2445ed$export$2e2bcd8739ae039), function chain(fn, monad) {
    if (typeof monad === "function") return function(x) {
        return fn(monad(x))(x);
    };
    return (0, $69211660636da41c$export$2e2bcd8739ae039)(false)((0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(fn, monad));
}));
var $404a156d8184580f$export$2e2bcd8739ae039 = $404a156d8184580f$var$chain;



/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var $27afcb26e2edec90$var$clamp = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function clamp(min, max, value) {
    if (min > max) throw new Error("min must not be greater than max in clamp(min, max, value)");
    return value < min ? min : value > max ? max : value;
});
var $27afcb26e2edec90$export$2e2bcd8739ae039 = $27afcb26e2edec90$var$clamp;


function $2d910f6d3e8cbb17$export$2e2bcd8739ae039(pattern) {
    return new RegExp(pattern.source, (pattern.global ? "g" : "") + (pattern.ignoreCase ? "i" : "") + (pattern.multiline ? "m" : "") + (pattern.sticky ? "y" : "") + (pattern.unicode ? "u" : ""));
}



/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $4bfffc9135d5e302$var$type = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function type(val) {
    return val === null ? "Null" : val === undefined ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
var $4bfffc9135d5e302$export$2e2bcd8739ae039 = $4bfffc9135d5e302$var$type;


function $f551b53ecb369187$export$2e2bcd8739ae039(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx + 1] = value;
        refTo[idx + 1] = copiedValue;
        for(var key in value)copiedValue[key] = deep ? $f551b53ecb369187$export$2e2bcd8739ae039(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, $4bfffc9135d5e302$export$2e2bcd8739ae039)(value)){
        case "Object":
            return copy({});
        case "Array":
            return copy([]);
        case "Date":
            return new Date(value.valueOf());
        case "RegExp":
            return (0, $2d910f6d3e8cbb17$export$2e2bcd8739ae039)(value);
        default:
            return value;
    }
}



/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      var objects = [{}, {}, {}];
 *      var objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var $5d3293da545595c4$var$clone = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function clone(value) {
    return value != null && typeof value.clone === "function" ? value.clone() : (0, $f551b53ecb369187$export$2e2bcd8739ae039)(value, [], [], true);
});
var $5d3293da545595c4$export$2e2bcd8739ae039 = $5d3293da545595c4$var$clone;



/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      var byAge = R.comparator((a, b) => a.age < b.age);
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByIncreasingAge = R.sort(byAge, people);
 */ var $14a34219769a9210$var$comparator = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
var $14a34219769a9210$export$2e2bcd8739ae039 = $14a34219769a9210$var$comparator;




/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var $5c800688ba668440$var$not = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function not(a) {
    return !a;
});
var $5c800688ba668440$export$2e2bcd8739ae039 = $5c800688ba668440$var$not;


/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      var isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var $b2ddb7f6dd218313$var$complement = /*#__PURE__*/ (0, $97e36b70d21dd970$export$2e2bcd8739ae039)((0, $5c800688ba668440$export$2e2bcd8739ae039));
var $b2ddb7f6dd218313$export$2e2bcd8739ae039 = $b2ddb7f6dd218313$var$complement;



function $047c7be6062fb0ab$export$2e2bcd8739ae039(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}




function $a3f06d6355efa679$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(obj) || typeof obj[methodname] !== "function" ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}





/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $4308737fb8a829dd$var$slice = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a3f06d6355efa679$export$2e2bcd8739ae039)("slice", function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
var $4308737fb8a829dd$export$2e2bcd8739ae039 = $4308737fb8a829dd$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $ba75e59f86286cec$var$tail = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a3f06d6355efa679$export$2e2bcd8739ae039)("tail", /*#__PURE__*/ (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(1, Infinity)));
var $ba75e59f86286cec$export$2e2bcd8739ae039 = $ba75e59f86286cec$var$tail;


function $0bc59dad427e50d1$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipe requires at least one argument");
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(arguments[0].length, (0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $047c7be6062fb0ab$export$2e2bcd8739ae039), arguments[0], (0, $ba75e59f86286cec$export$2e2bcd8739ae039)(arguments)));
}




/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var $95f561f65fac8c60$var$reverse = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function reverse(list) {
    return (0, $e9802355e9a971f3$export$2e2bcd8739ae039)(list) ? list.split("").reverse().join("") : Array.prototype.slice.call(list, 0).reverse();
});
var $95f561f65fac8c60$export$2e2bcd8739ae039 = $95f561f65fac8c60$var$reverse;


function $98f66900c8aaac5b$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("compose requires at least one argument");
    return (0, $0bc59dad427e50d1$export$2e2bcd8739ae039).apply(this, (0, $95f561f65fac8c60$export$2e2bcd8739ae039)(arguments));
}





function $dc7735313275e0ee$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("composeK requires at least one argument");
    var init = Array.prototype.slice.call(arguments);
    var last = init.pop();
    return (0, $98f66900c8aaac5b$export$2e2bcd8739ae039)((0, $98f66900c8aaac5b$export$2e2bcd8739ae039).apply(this, (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)((0, $404a156d8184580f$export$2e2bcd8739ae039), init)), last);
}



function $b593c82ed54e0a17$export$2e2bcd8739ae039(f, g) {
    return function() {
        var ctx = this;
        return f.apply(ctx, arguments).then(function(x) {
            return g.call(ctx, x);
        });
    };
}




function $98bcdf9e647e5f4d$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipeP requires at least one argument");
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(arguments[0].length, (0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $b593c82ed54e0a17$export$2e2bcd8739ae039), arguments[0], (0, $ba75e59f86286cec$export$2e2bcd8739ae039)(arguments)));
}



function $0986c8ef131b4211$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("composeP requires at least one argument");
    return (0, $98bcdf9e647e5f4d$export$2e2bcd8739ae039).apply(this, (0, $95f561f65fac8c60$export$2e2bcd8739ae039)(arguments));
}








function $f629798414e95cd0$export$2e2bcd8739ae039(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}


function $2555cbf5393f2ef6$export$2e2bcd8739ae039(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}


function $6737b82bd7305540$export$2e2bcd8739ae039(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? "" : match[1];
}




/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      var o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var $b168ac3dde7a08d5$var$identical = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function identical(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
});
var $b168ac3dde7a08d5$export$2e2bcd8739ae039 = $b168ac3dde7a08d5$var$identical;




/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function $2aae46b50a5bf9ed$var$_uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, $f629798414e95cd0$export$2e2bcd8739ae039)(aIterator);
    var b = (0, $f629798414e95cd0$export$2e2bcd8739ae039)(bIterator);
    function eq(_a, _b) {
        return $2aae46b50a5bf9ed$export$2e2bcd8739ae039(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, $2555cbf5393f2ef6$export$2e2bcd8739ae039)(function(b, aItem) {
        return !(0, $2555cbf5393f2ef6$export$2e2bcd8739ae039)(eq, aItem, b);
    }, b, a);
}
function $2aae46b50a5bf9ed$export$2e2bcd8739ae039(a, b, stackA, stackB) {
    if ((0, $b168ac3dde7a08d5$export$2e2bcd8739ae039)(a, b)) return true;
    var typeA = (0, $4bfffc9135d5e302$export$2e2bcd8739ae039)(a);
    if (typeA !== (0, $4bfffc9135d5e302$export$2e2bcd8739ae039)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a["fantasy-land/equals"] === "function" || typeof b["fantasy-land/equals"] === "function") return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b) && typeof b["fantasy-land/equals"] === "function" && b["fantasy-land/equals"](a);
    if (typeof a.equals === "function" || typeof b.equals === "function") return typeof a.equals === "function" && a.equals(b) && typeof b.equals === "function" && b.equals(a);
    switch(typeA){
        case "Arguments":
        case "Array":
        case "Object":
            if (typeof a.constructor === "function" && (0, $6737b82bd7305540$export$2e2bcd8739ae039)(a.constructor) === "Promise") return a === b;
            break;
        case "Boolean":
        case "Number":
        case "String":
            if (!(typeof a === typeof b && (0, $b168ac3dde7a08d5$export$2e2bcd8739ae039)(a.valueOf(), b.valueOf()))) return false;
            break;
        case "Date":
            if (!(0, $b168ac3dde7a08d5$export$2e2bcd8739ae039)(a.valueOf(), b.valueOf())) return false;
            break;
        case "Error":
            return a.name === b.name && a.message === b.message;
        case "RegExp":
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case "Map":
            if (a.size !== b.size) return false;
            return $2aae46b50a5bf9ed$var$_uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Set":
            if (a.size !== b.size) return false;
            return $2aae46b50a5bf9ed$var$_uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case "Arguments":
        case "Array":
        case "Object":
        case "Boolean":
        case "Number":
        case "String":
        case "Date":
        case "Error":
        case "RegExp":
        case "Int8Array":
        case "Uint8Array":
        case "Uint8ClampedArray":
        case "Int16Array":
        case "Uint16Array":
        case "Int32Array":
        case "Uint32Array":
        case "Float32Array":
        case "Float64Array":
        case "ArrayBuffer":
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, $7bd231648493210b$export$2e2bcd8739ae039)(a);
    if (keysA.length !== (0, $7bd231648493210b$export$2e2bcd8739ae039)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(key, b) && $2aae46b50a5bf9ed$export$2e2bcd8739ae039(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}


/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      var a = {}; a.v = a;
 *      var b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var $bb5c76e6a1c0ede6$var$equals = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function equals(a, b) {
    return (0, $2aae46b50a5bf9ed$export$2e2bcd8739ae039)(a, b, [], []);
});
var $bb5c76e6a1c0ede6$export$2e2bcd8739ae039 = $bb5c76e6a1c0ede6$var$equals;


function $92336e3dbd59ce7b$export$2e2bcd8739ae039(list, a, idx) {
    var inf, item;
    // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === "function") switch(typeof a){
        case "number":
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === "number" && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            }
            // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case "string":
        case "boolean":
        case "function":
        case "undefined":
            return list.indexOf(a, idx);
        case "object":
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
    // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}


function $21ed1b58cd507ed8$export$2e2bcd8739ae039(a, list) {
    return (0, $92336e3dbd59ce7b$export$2e2bcd8739ae039)(list, a, 0) >= 0;
}



function $e6297b7408cbabc0$export$2e2bcd8739ae039(s) {
    var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b") // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}


/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var $db62453296ddf01c$var$pad = function pad(n) {
    return (n < 10 ? "0" : "") + n;
};
var $db62453296ddf01c$var$_toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + "-" + $db62453296ddf01c$var$pad(d.getUTCMonth() + 1) + "-" + $db62453296ddf01c$var$pad(d.getUTCDate()) + "T" + $db62453296ddf01c$var$pad(d.getUTCHours()) + ":" + $db62453296ddf01c$var$pad(d.getUTCMinutes()) + ":" + $db62453296ddf01c$var$pad(d.getUTCSeconds()) + "." + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + "Z";
};
var $db62453296ddf01c$export$2e2bcd8739ae039 = $db62453296ddf01c$var$_toISOString;



function $1f308d2c1fa8bdbd$export$2e2bcd8739ae039(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}





function $9e0cebe40b946a96$export$2e2bcd8739ae039(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}


function $5ef083029079931f$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
}





var $0f53cc1d32387337$var$XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XFilter.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XFilter.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : result;
    };
    return XFilter;
}();
var $0f53cc1d32387337$var$_xfilter = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xfilter(f, xf) {
    return new $0f53cc1d32387337$var$XFilter(f, xf);
});
var $0f53cc1d32387337$export$2e2bcd8739ae039 = $0f53cc1d32387337$var$_xfilter;



/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $0512e21c9d88d410$var$filter = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "filter"
], (0, $0f53cc1d32387337$export$2e2bcd8739ae039), function(pred, filterable) {
    return (0, $5ef083029079931f$export$2e2bcd8739ae039)(filterable) ? (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, $7bd231648493210b$export$2e2bcd8739ae039)(filterable)) : // else
    (0, $9e0cebe40b946a96$export$2e2bcd8739ae039)(pred, filterable);
}));
var $0512e21c9d88d410$export$2e2bcd8739ae039 = $0512e21c9d88d410$var$filter;


/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      var isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var $1b72f1e2ce8a2a5c$var$reject = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function reject(pred, filterable) {
    return (0, $0512e21c9d88d410$export$2e2bcd8739ae039)((0, $1f308d2c1fa8bdbd$export$2e2bcd8739ae039)(pred), filterable);
});
var $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039 = $1b72f1e2ce8a2a5c$var$reject;


function $61862f56e8e76c96$export$2e2bcd8739ae039(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, $21ed1b58cd507ed8$export$2e2bcd8739ae039)(y, xs) ? "<Circular>" : $61862f56e8e76c96$export$2e2bcd8739ae039(y, xs);
    };
    //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, $de665e827334f055$export$2e2bcd8739ae039)(function(k) {
            return (0, $e6297b7408cbabc0$export$2e2bcd8739ae039)(k) + ": " + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case "[object Arguments]":
            return "(function() { return arguments; }(" + (0, $de665e827334f055$export$2e2bcd8739ae039)(recur, x).join(", ") + "))";
        case "[object Array]":
            return "[" + (0, $de665e827334f055$export$2e2bcd8739ae039)(recur, x).concat(mapPairs(x, (0, $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039)(function(k) {
                return /^\d+$/.test(k);
            }, (0, $7bd231648493210b$export$2e2bcd8739ae039)(x)))).join(", ") + "]";
        case "[object Boolean]":
            return typeof x === "object" ? "new Boolean(" + recur(x.valueOf()) + ")" : x.toString();
        case "[object Date]":
            return "new Date(" + (isNaN(x.valueOf()) ? recur(NaN) : (0, $e6297b7408cbabc0$export$2e2bcd8739ae039)((0, $db62453296ddf01c$export$2e2bcd8739ae039)(x))) + ")";
        case "[object Null]":
            return "null";
        case "[object Number]":
            return typeof x === "object" ? "new Number(" + recur(x.valueOf()) + ")" : 1 / x === -Infinity ? "-0" : x.toString(10);
        case "[object String]":
            return typeof x === "object" ? "new String(" + recur(x.valueOf()) + ")" : (0, $e6297b7408cbabc0$export$2e2bcd8739ae039)(x);
        case "[object Undefined]":
            return "undefined";
        default:
            if (typeof x.toString === "function") {
                var repr = x.toString();
                if (repr !== "[object Object]") return repr;
            }
            return "{" + mapPairs(x, (0, $7bd231648493210b$export$2e2bcd8739ae039)(x)).join(", ") + "}";
    }
}


/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var $bad19a2637b95cc5$var$toString = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function toString(val) {
    return (0, $61862f56e8e76c96$export$2e2bcd8739ae039)(val, []);
});
var $bad19a2637b95cc5$export$2e2bcd8739ae039 = $bad19a2637b95cc5$var$toString;


/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var $bc076d26ac1675e1$var$concat = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function concat(a, b) {
    if ((0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(a)) {
        if ((0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(b)) return a.concat(b);
        throw new TypeError((0, $bad19a2637b95cc5$export$2e2bcd8739ae039)(b) + " is not an array");
    }
    if ((0, $e9802355e9a971f3$export$2e2bcd8739ae039)(a)) {
        if ((0, $e9802355e9a971f3$export$2e2bcd8739ae039)(b)) return a + b;
        throw new TypeError((0, $bad19a2637b95cc5$export$2e2bcd8739ae039)(b) + " is not a string");
    }
    if (a != null && (0, $52388c18ea030e9e$export$2e2bcd8739ae039)(a["fantasy-land/concat"])) return a["fantasy-land/concat"](b);
    if (a != null && (0, $52388c18ea030e9e$export$2e2bcd8739ae039)(a.concat)) return a.concat(b);
    throw new TypeError((0, $bad19a2637b95cc5$export$2e2bcd8739ae039)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
var $bc076d26ac1675e1$export$2e2bcd8739ae039 = $bc076d26ac1675e1$var$concat;







/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @example
 *
 *      var fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var $9ae7328027a816a6$var$cond = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function cond(pairs) {
    var arity = (0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $6204b82ba19ab48a$export$2e2bcd8739ae039), 0, (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
var $9ae7328027a816a6$export$2e2bcd8739ae039 = $9ae7328027a816a6$var$cond;






/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        var instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      var ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      var salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var $ded1c958242888d8$var$constructN = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function constructN(n, Fn) {
    if (n > 10) throw new Error("Constructor with greater than ten arguments");
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, $d8a10bb9a75db244$export$2e2bcd8739ae039)((0, $3a7e87844ea63781$export$2e2bcd8739ae039)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
var $ded1c958242888d8$export$2e2bcd8739ae039 = $ded1c958242888d8$var$constructN;


/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      var AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      var animalTypes = ["Lion", "Tiger", "Bear"];
 *      var animalSighting = R.invoker(0, 'sighting');
 *      var sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var $31b6909fdd42254a$var$construct = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function construct(Fn) {
    return (0, $ded1c958242888d8$export$2e2bcd8739ae039)(Fn.length, Fn);
});
var $31b6909fdd42254a$export$2e2bcd8739ae039 = $31b6909fdd42254a$var$construct;





/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 */ var $da0dfe4dba3b612f$var$contains = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)((0, $21ed1b58cd507ed8$export$2e2bcd8739ae039));
var $da0dfe4dba3b612f$export$2e2bcd8739ae039 = $da0dfe4dba3b612f$var$contains;








/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. When invoked, this new function is applied to some
 * arguments, each branching function is applied to those same arguments. The
 * results of each branching function are passed as arguments to the converging
 * function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      var average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      var strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var $4b2678ecd0196288$var$converge = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function converge(after, fns) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)((0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $6204b82ba19ab48a$export$2e2bcd8739ae039), 0, (0, $20af923c068efeea$export$2e2bcd8739ae039)("length", fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, $de665e827334f055$export$2e2bcd8739ae039)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
var $4b2678ecd0196288$export$2e2bcd8739ae039 = $4b2678ecd0196288$var$converge;









var $4872b68b3ceecede$var$XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XReduceBy.prototype["@@transducer/result"] = function(result) {
        var key;
        for(key in this.inputs)if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(key, this.inputs)) {
            result = this.xf["@@transducer/step"](result, this.inputs[key]);
            if (result["@@transducer/reduced"]) {
                result = result["@@transducer/value"];
                break;
            }
        }
        this.inputs = null;
        return this.xf["@@transducer/result"](result);
    };
    XReduceBy.prototype["@@transducer/step"] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var $4872b68b3ceecede$var$_xreduceBy = /*#__PURE__*/ (0, $53afa373fbec91db$export$2e2bcd8739ae039)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new $4872b68b3ceecede$var$XReduceBy(valueFn, valueAcc, keyFn, xf);
});
var $4872b68b3ceecede$export$2e2bcd8739ae039 = $4872b68b3ceecede$var$_xreduceBy;


/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      var reduceToNamesBy = R.reduceBy((acc, student) => acc.concat(student.name), []);
 *      var namesByGrade = reduceToNamesBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Lucy', score: 92},
 *                      {name: 'Drew', score: 85},
 *                      // ...
 *                      {name: 'Bart', score: 62}];
 *      namesByGrade(students);
 *      // {
 *      //   'A': ['Lucy'],
 *      //   'B': ['Drew']
 *      //   // ...,
 *      //   'F': ['Bart']
 *      // }
 */ var $5030f6fa9c4aba5d$var$reduceBy = /*#__PURE__*/ (0, $53afa373fbec91db$export$2e2bcd8739ae039)(4, [], /*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $4872b68b3ceecede$export$2e2bcd8739ae039), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(function(acc, elt) {
        var key = keyFn(elt);
        acc[key] = valueFn((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(key, acc) ? acc[key] : valueAcc, elt);
        return acc;
    }, {}, list);
}));
var $5030f6fa9c4aba5d$export$2e2bcd8739ae039 = $5030f6fa9c4aba5d$var$reduceBy;


/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      var numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      var letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var $66524acae191e92a$var$countBy = /*#__PURE__*/ (0, $5030f6fa9c4aba5d$export$2e2bcd8739ae039)(function(acc, elem) {
    return acc + 1;
}, 0);
var $66524acae191e92a$export$2e2bcd8739ae039 = $66524acae191e92a$var$countBy;





/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var $8a733cded38a9e49$var$dec = /*#__PURE__*/ (0, $f019de71e8a06f52$export$2e2bcd8739ae039)(-1);
var $8a733cded38a9e49$export$2e2bcd8739ae039 = $8a733cded38a9e49$var$dec;



/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      var defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var $d9bbbf3f37bc8daa$var$defaultTo = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
var $d9bbbf3f37bc8daa$export$2e2bcd8739ae039 = $d9bbbf3f37bc8daa$var$defaultTo;



/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      var byAge = R.descend(R.prop('age'));
 *      var people = [
 *        // ...
 *      ];
 *      var peopleByOldestFirst = R.sort(byAge, people);
 */ var $37ed38c5bc90598d$var$descend = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
var $37ed38c5bc90598d$export$2e2bcd8739ae039 = $37ed38c5bc90598d$var$descend;




/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var $5a88f499f8de57e0$var$difference = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $21ed1b58cd507ed8$export$2e2bcd8739ae039)(first[idx], second) && !(0, $21ed1b58cd507ed8$export$2e2bcd8739ae039)(first[idx], out)) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
var $5a88f499f8de57e0$export$2e2bcd8739ae039 = $5a88f499f8de57e0$var$difference;




/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      var cmp = (x, y) => x.a === y.a;
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      var l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var $1f539a638986d66f$var$differenceWith = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, $2555cbf5393f2ef6$export$2e2bcd8739ae039)(pred, first[idx], second) && !(0, $2555cbf5393f2ef6$export$2e2bcd8739ae039)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
var $1f539a638986d66f$export$2e2bcd8739ae039 = $1f539a638986d66f$var$differenceWith;



/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var $2dbfaafe7349f01f$var$dissoc = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function dissoc(prop, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
});
var $2dbfaafe7349f01f$export$2e2bcd8739ae039 = $2dbfaafe7349f01f$var$dissoc;







/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var $882a21f30d217790$var$remove = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
var $882a21f30d217790$export$2e2bcd8739ae039 = $882a21f30d217790$var$remove;





/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, 11, [0, 1, 2]);     //=> [0, 11, 2]
 *      R.update(1)(11)([0, 1, 2]);     //=> [0, 11, 2]
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var $ec0fc44412296678$var$update = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function update(idx, x, list) {
    return (0, $fcd6a9bca4955925$export$2e2bcd8739ae039)((0, $8e63af234d14ba1a$export$2e2bcd8739ae039)(x), idx, list);
});
var $ec0fc44412296678$export$2e2bcd8739ae039 = $ec0fc44412296678$var$update;


/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var $ff7b86861b570ccd$var$dissocPath = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function dissocPath(path, obj) {
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, $16dfade75a60b17d$export$2e2bcd8739ae039)(path[0]) ? (0, $882a21f30d217790$export$2e2bcd8739ae039)(path[0], 1, obj) : (0, $2dbfaafe7349f01f$export$2e2bcd8739ae039)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return obj;
            else if ((0, $16dfade75a60b17d$export$2e2bcd8739ae039)(path[0])) return (0, $ec0fc44412296678$export$2e2bcd8739ae039)(head, dissocPath(tail, obj[head]), obj);
            else return (0, $d38b1d7ec30b4cc6$export$2e2bcd8739ae039)(head, dissocPath(tail, obj[head]), obj);
    }
});
var $ff7b86861b570ccd$export$2e2bcd8739ae039 = $ff7b86861b570ccd$var$dissocPath;



/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      var half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      var reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var $9cabd68d1ebc95a5$var$divide = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function divide(a, b) {
    return a / b;
});
var $9cabd68d1ebc95a5$export$2e2bcd8739ae039 = $9cabd68d1ebc95a5$var$divide;






var $2ae8679dac435b42$var$XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XDrop.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XDrop.prototype["@@transducer/step"] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDrop;
}();
var $2ae8679dac435b42$var$_xdrop = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xdrop(n, xf) {
    return new $2ae8679dac435b42$var$XDrop(n, xf);
});
var $2ae8679dac435b42$export$2e2bcd8739ae039 = $2ae8679dac435b42$var$_xdrop;



/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var $fc1564f0616b33f5$var$drop = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "drop"
], (0, $2ae8679dac435b42$export$2e2bcd8739ae039), function drop(n, xs) {
    return (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(Math.max(0, n), Infinity, xs);
}));
var $fc1564f0616b33f5$export$2e2bcd8739ae039 = $fc1564f0616b33f5$var$drop;









var $5ee1e801e2e5e157$var$XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XTake.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XTake.prototype["@@transducer/step"] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf["@@transducer/step"](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, $0079da3350b7af31$export$2e2bcd8739ae039)(ret) : ret;
    };
    return XTake;
}();
var $5ee1e801e2e5e157$var$_xtake = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xtake(n, xf) {
    return new $5ee1e801e2e5e157$var$XTake(n, xf);
});
var $5ee1e801e2e5e157$export$2e2bcd8739ae039 = $5ee1e801e2e5e157$var$_xtake;



/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      var personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      var takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var $2092a6321d126114$var$take = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "take"
], (0, $5ee1e801e2e5e157$export$2e2bcd8739ae039), function take(n, xs) {
    return (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(0, n < 0 ? Infinity : n, xs);
}));
var $2092a6321d126114$export$2e2bcd8739ae039 = $2092a6321d126114$var$take;


function $337b955319f04381$export$2e2bcd8739ae039(n, xs) {
    return (0, $2092a6321d126114$export$2e2bcd8739ae039)(n < xs.length ? xs.length - n : 0, xs);
}




var $e7396a47af249d52$var$XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XDropLast.prototype["@@transducer/result"] = function(result) {
        this.acc = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.full) result = this.xf["@@transducer/step"](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var $e7396a47af249d52$var$_xdropLast = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xdropLast(n, xf) {
    return new $e7396a47af249d52$var$XDropLast(n, xf);
});
var $e7396a47af249d52$export$2e2bcd8739ae039 = $e7396a47af249d52$var$_xdropLast;


/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var $f3b9889469bc17a1$var$dropLast = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $e7396a47af249d52$export$2e2bcd8739ae039), (0, $337b955319f04381$export$2e2bcd8739ae039)));
var $f3b9889469bc17a1$export$2e2bcd8739ae039 = $f3b9889469bc17a1$var$dropLast;





function $6681df887f936cad$export$2e2bcd8739ae039(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(0, idx + 1, xs);
}





var $88ba95f0aa909cee$var$XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XDropLastWhile.prototype["@@transducer/result"] = function(result) {
        this.retained = null;
        return this.xf["@@transducer/result"](result);
    };
    XDropLastWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(this.xf["@@transducer/step"], result, this.retained);
        this.retained = [];
        return this.xf["@@transducer/step"](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var $88ba95f0aa909cee$var$_xdropLastWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xdropLastWhile(fn, xf) {
    return new $88ba95f0aa909cee$var$XDropLastWhile(fn, xf);
});
var $88ba95f0aa909cee$export$2e2bcd8739ae039 = $88ba95f0aa909cee$var$_xdropLastWhile;


/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      var lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var $8b6b73f6399d6de4$var$dropLastWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $88ba95f0aa909cee$export$2e2bcd8739ae039), (0, $6681df887f936cad$export$2e2bcd8739ae039)));
var $8b6b73f6399d6de4$export$2e2bcd8739ae039 = $8b6b73f6399d6de4$var$dropLastWhile;






var $233e2c4a9cb334d0$var$XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XDropRepeatsWith.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XDropRepeatsWith.prototype["@@transducer/step"] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf["@@transducer/step"](result, input);
    };
    return XDropRepeatsWith;
}();
var $233e2c4a9cb334d0$var$_xdropRepeatsWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xdropRepeatsWith(pred, xf) {
    return new $233e2c4a9cb334d0$var$XDropRepeatsWith(pred, xf);
});
var $233e2c4a9cb334d0$export$2e2bcd8739ae039 = $233e2c4a9cb334d0$var$_xdropRepeatsWith;







/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      var list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var $789dcb83ae130e07$var$nth = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, $e9802355e9a971f3$export$2e2bcd8739ae039)(list) ? list.charAt(idx) : list[idx];
});
var $789dcb83ae130e07$export$2e2bcd8739ae039 = $789dcb83ae130e07$var$nth;


/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var $4b94247aa033ec20$var$last = /*#__PURE__*/ (0, $789dcb83ae130e07$export$2e2bcd8739ae039)(-1);
var $4b94247aa033ec20$export$2e2bcd8739ae039 = $4b94247aa033ec20$var$last;


/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      var l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var $05e4d572be1db82f$var$dropRepeatsWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $233e2c4a9cb334d0$export$2e2bcd8739ae039), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, $4b94247aa033ec20$export$2e2bcd8739ae039)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
var $05e4d572be1db82f$export$2e2bcd8739ae039 = $05e4d572be1db82f$var$dropRepeatsWith;



/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var $04da6f19b34d18b2$var$dropRepeats = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], /*#__PURE__*/ (0, $233e2c4a9cb334d0$export$2e2bcd8739ae039)((0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)), /*#__PURE__*/ (0, $05e4d572be1db82f$export$2e2bcd8739ae039)((0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039))));
var $04da6f19b34d18b2$export$2e2bcd8739ae039 = $04da6f19b34d18b2$var$dropRepeats;







var $bc94a98b8e335be7$var$XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XDropWhile.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XDropWhile.prototype["@@transducer/step"] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf["@@transducer/step"](result, input);
    };
    return XDropWhile;
}();
var $bc94a98b8e335be7$var$_xdropWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xdropWhile(f, xf) {
    return new $bc94a98b8e335be7$var$XDropWhile(f, xf);
});
var $bc94a98b8e335be7$export$2e2bcd8739ae039 = $bc94a98b8e335be7$var$_xdropWhile;



/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      var lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var $55a83c85ebb36cf2$var$dropWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "dropWhile"
], (0, $bc94a98b8e335be7$export$2e2bcd8739ae039), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(idx, Infinity, xs);
}));
var $55a83c85ebb36cf2$export$2e2bcd8739ae039 = $55a83c85ebb36cf2$var$dropWhile;






/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var $cd734a16b38a9022$var$or = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function or(a, b) {
    return a || b;
});
var $cd734a16b38a9022$export$2e2bcd8739ae039 = $cd734a16b38a9022$var$or;


/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      var gt10 = x => x > 10;
 *      var even = x => x % 2 === 0;
 *      var f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 */ var $2689264ba6e1f423$var$either = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function either(f, g) {
    return (0, $52388c18ea030e9e$export$2e2bcd8739ae039)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, $97e36b70d21dd970$export$2e2bcd8739ae039)((0, $cd734a16b38a9022$export$2e2bcd8739ae039))(f, g);
});
var $2689264ba6e1f423$export$2e2bcd8739ae039 = $2689264ba6e1f423$var$either;







/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */ var $95cdf578cb9f0fb4$var$empty = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function empty(x) {
    return x != null && typeof x["fantasy-land/empty"] === "function" ? x["fantasy-land/empty"]() : x != null && x.constructor != null && typeof x.constructor["fantasy-land/empty"] === "function" ? x.constructor["fantasy-land/empty"]() : x != null && typeof x.empty === "function" ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === "function" ? x.constructor.empty() : (0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(x) ? [] : (0, $e9802355e9a971f3$export$2e2bcd8739ae039)(x) ? "" : (0, $5ef083029079931f$export$2e2bcd8739ae039)(x) ? {} : (0, $39b7a2b3276535bb$export$2e2bcd8739ae039)(x) ? function() {
        return arguments;
    }() : // else
    void 0;
});
var $95cdf578cb9f0fb4$export$2e2bcd8739ae039 = $95cdf578cb9f0fb4$var$empty;






/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var $91ed8e6648f9796f$var$takeLast = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function takeLast(n, xs) {
    return (0, $fc1564f0616b33f5$export$2e2bcd8739ae039)(n >= 0 ? xs.length - n : 0, xs);
});
var $91ed8e6648f9796f$export$2e2bcd8739ae039 = $91ed8e6648f9796f$var$takeLast;


/**
 * Checks if a list ends with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $5b269805945f9106$var$endsWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(suffix, list) {
    return (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)((0, $91ed8e6648f9796f$export$2e2bcd8739ae039)(suffix.length, list), suffix);
});
var $5b269805945f9106$export$2e2bcd8739ae039 = $5b269805945f9106$var$endsWith;




/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var $de0dc0fdc2fca6b0$var$eqBy = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function eqBy(f, x, y) {
    return (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)(f(x), f(y));
});
var $de0dc0fdc2fca6b0$export$2e2bcd8739ae039 = $de0dc0fdc2fca6b0$var$eqBy;




/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      var o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      var o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var $e7a3aede200ee572$var$eqProps = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function eqProps(prop, obj1, obj2) {
    return (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)(obj1[prop], obj2[prop]);
});
var $e7a3aede200ee572$export$2e2bcd8739ae039 = $e7a3aede200ee572$var$eqProps;




/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      var tomato  = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      var transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $4736be36c022d5fa$var$evolve = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function evolve(transformations, object) {
    var result = {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === "function" ? transformation(object[key]) : transformation && type === "object" ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $4736be36c022d5fa$export$2e2bcd8739ae039 = $4736be36c022d5fa$var$evolve;








var $51d3a49480b820d4$var$XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XFind.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, void 0);
        return this.xf["@@transducer/result"](result);
    };
    XFind.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, $0079da3350b7af31$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, input));
        }
        return result;
    };
    return XFind;
}();
var $51d3a49480b820d4$var$_xfind = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xfind(f, xf) {
    return new $51d3a49480b820d4$var$XFind(f, xf);
});
var $51d3a49480b820d4$export$2e2bcd8739ae039 = $51d3a49480b820d4$var$_xfind;


/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var $be3bbf4aff7ab2d2$var$find = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "find"
], (0, $51d3a49480b820d4$export$2e2bcd8739ae039), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
var $be3bbf4aff7ab2d2$export$2e2bcd8739ae039 = $be3bbf4aff7ab2d2$var$find;







var $a951dec0f6f8924c$var$XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XFindIndex.prototype["@@transducer/result"] = function(result) {
        if (!this.found) result = this.xf["@@transducer/step"](result, -1);
        return this.xf["@@transducer/result"](result);
    };
    XFindIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, $0079da3350b7af31$export$2e2bcd8739ae039)(this.xf["@@transducer/step"](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var $a951dec0f6f8924c$var$_xfindIndex = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xfindIndex(f, xf) {
    return new $a951dec0f6f8924c$var$XFindIndex(f, xf);
});
var $a951dec0f6f8924c$export$2e2bcd8739ae039 = $a951dec0f6f8924c$var$_xfindIndex;


/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $2697d8ac56f54dea$var$findIndex = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $a951dec0f6f8924c$export$2e2bcd8739ae039), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
var $2697d8ac56f54dea$export$2e2bcd8739ae039 = $2697d8ac56f54dea$var$findIndex;






var $2caef016d72a3a6d$var$XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XFindLast.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.last));
    };
    XFindLast.prototype["@@transducer/step"] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var $2caef016d72a3a6d$var$_xfindLast = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xfindLast(f, xf) {
    return new $2caef016d72a3a6d$var$XFindLast(f, xf);
});
var $2caef016d72a3a6d$export$2e2bcd8739ae039 = $2caef016d72a3a6d$var$_xfindLast;


/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var $e3aa5a79a55b640e$var$findLast = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $2caef016d72a3a6d$export$2e2bcd8739ae039), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
var $e3aa5a79a55b640e$export$2e2bcd8739ae039 = $e3aa5a79a55b640e$var$findLast;






var $1b1a02be44277aa2$var$XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XFindLastIndex.prototype["@@transducer/result"] = function(result) {
        return this.xf["@@transducer/result"](this.xf["@@transducer/step"](result, this.lastIdx));
    };
    XFindLastIndex.prototype["@@transducer/step"] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var $1b1a02be44277aa2$var$_xfindLastIndex = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xfindLastIndex(f, xf) {
    return new $1b1a02be44277aa2$var$XFindLastIndex(f, xf);
});
var $1b1a02be44277aa2$export$2e2bcd8739ae039 = $1b1a02be44277aa2$var$_xfindLastIndex;


/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      var xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var $dd0b8d656563e33d$var$findLastIndex = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $1b1a02be44277aa2$export$2e2bcd8739ae039), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
var $dd0b8d656563e33d$export$2e2bcd8739ae039 = $dd0b8d656563e33d$var$findLastIndex;




/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var $f2655336c8f34f07$var$flatten = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $69211660636da41c$export$2e2bcd8739ae039)(true));
var $f2655336c8f34f07$export$2e2bcd8739ae039 = $f2655336c8f34f07$var$flatten;




/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      var mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var $9770ba9f27278ec2$var$flip = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function flip(fn) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
var $9770ba9f27278ec2$export$2e2bcd8739ae039 = $9770ba9f27278ec2$var$flip;




/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      var printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var $412695138084de1b$var$forEach = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a3f06d6355efa679$export$2e2bcd8739ae039)("forEach", function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
var $412695138084de1b$export$2e2bcd8739ae039 = $412695138084de1b$var$forEach;




/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      var printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var $bb8fb90afb79b8ce$var$forEachObjIndexed = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, $7bd231648493210b$export$2e2bcd8739ae039)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
var $bb8fb90afb79b8ce$export$2e2bcd8739ae039 = $bb8fb90afb79b8ce$var$forEachObjIndexed;



/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var $921bdc4e1290d437$var$fromPairs = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
var $921bdc4e1290d437$export$2e2bcd8739ae039 = $921bdc4e1290d437$var$fromPairs;





/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.transduce
 * @example
 *
 *      var byGrade = R.groupBy(function(student) {
 *        var score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      var students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var $2acbb5ba886412c5$var$groupBy = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a3f06d6355efa679$export$2e2bcd8739ae039)("groupBy", /*#__PURE__*/ (0, $5030f6fa9c4aba5d$export$2e2bcd8739ae039)(function(acc, item) {
    if (acc == null) acc = [];
    acc.push(item);
    return acc;
}, null)));
var $2acbb5ba886412c5$export$2e2bcd8739ae039 = $2acbb5ba886412c5$var$groupBy;



/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var $e646a66ad5024e63$var$groupWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
var $e646a66ad5024e63$export$2e2bcd8739ae039 = $e646a66ad5024e63$var$groupWith;



/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var $a68eb37395bf8a47$var$gt = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function gt(a, b) {
    return a > b;
});
var $a68eb37395bf8a47$export$2e2bcd8739ae039 = $a68eb37395bf8a47$var$gt;



/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var $fc0ab4d0c9bb36a2$var$gte = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function gte(a, b) {
    return a >= b;
});
var $fc0ab4d0c9bb36a2$export$2e2bcd8739ae039 = $fc0ab4d0c9bb36a2$var$gte;




/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      var hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      var point = {x: 0, y: 0};
 *      var pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var $7eedc28b5553776a$var$has = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)((0, $88eb77390bd89c62$export$2e2bcd8739ae039));
var $7eedc28b5553776a$export$2e2bcd8739ae039 = $7eedc28b5553776a$var$has;



/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      var square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var $df07d922b0ca7e8d$var$hasIn = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function hasIn(prop, obj) {
    return prop in obj;
});
var $df07d922b0ca7e8d$export$2e2bcd8739ae039 = $df07d922b0ca7e8d$var$hasIn;



/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var $35c0ff6f91c4dae0$var$head = /*#__PURE__*/ (0, $789dcb83ae130e07$export$2e2bcd8739ae039)(0);
var $35c0ff6f91c4dae0$export$2e2bcd8739ae039 = $35c0ff6f91c4dae0$var$head;




function $f2f55f01782be410$export$2e2bcd8739ae039(x) {
    return x;
}


/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      var obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var $4f99436f72054941$var$identity = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)((0, $f2f55f01782be410$export$2e2bcd8739ae039));
var $4f99436f72054941$export$2e2bcd8739ae039 = $4f99436f72054941$var$identity;




/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new unary function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when
 * @example
 *
 *      var incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */ var $4f511211afc19273$var$ifElse = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function ifElse(condition, onTrue, onFalse) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
var $4f511211afc19273$export$2e2bcd8739ae039 = $4f511211afc19273$var$ifElse;



/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var $5047288a248076ae$var$inc = /*#__PURE__*/ (0, $f019de71e8a06f52$export$2e2bcd8739ae039)(1);
var $5047288a248076ae$export$2e2bcd8739ae039 = $5047288a248076ae$var$inc;



/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      var list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var $54920ba89edae26a$var$indexBy = /*#__PURE__*/ (0, $5030f6fa9c4aba5d$export$2e2bcd8739ae039)(function(acc, elem) {
    return elem;
}, null);
var $54920ba89edae26a$export$2e2bcd8739ae039 = $54920ba89edae26a$var$indexBy;





/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var $b558519782f8d23d$var$indexOf = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function indexOf(target, xs) {
    return typeof xs.indexOf === "function" && !(0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(xs) ? xs.indexOf(target) : (0, $92336e3dbd59ce7b$export$2e2bcd8739ae039)(xs, target, 0);
});
var $b558519782f8d23d$export$2e2bcd8739ae039 = $b558519782f8d23d$var$indexOf;



/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var $ed18faa229c71b72$var$init = /*#__PURE__*/ (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(0, -1);
var $ed18faa229c71b72$export$2e2bcd8739ae039 = $ed18faa229c71b72$var$init;





/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var $4b3c9813342c99ff$var$innerJoin = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function innerJoin(pred, xs, ys) {
    return (0, $9e0cebe40b946a96$export$2e2bcd8739ae039)(function(x) {
        return (0, $2555cbf5393f2ef6$export$2e2bcd8739ae039)(pred, x, ys);
    }, xs);
});
var $4b3c9813342c99ff$export$2e2bcd8739ae039 = $4b3c9813342c99ff$var$innerJoin;



/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var $6495545f3e2168b4$var$insert = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
var $6495545f3e2168b4$export$2e2bcd8739ae039 = $6495545f3e2168b4$var$insert;



/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var $e88ce0cce4c54ba9$var$insertAll = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
var $e88ce0cce4c54ba9$export$2e2bcd8739ae039 = $e88ce0cce4c54ba9$var$insertAll;








var $824be21b4d2b0b08$var$_Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === "function" ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !$824be21b4d2b0b08$var$hasOrAdd(item, true, this);
    };
    //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return $824be21b4d2b0b08$var$hasOrAdd(item, false, this);
    };
    //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function $824be21b4d2b0b08$var$hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case "string":
        case "number":
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items["-0"]) return true;
                else {
                    if (shouldAdd) set._items["-0"] = true;
                    return false;
                }
            }
            // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case "boolean":
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case "function":
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, $21ed1b58cd507ed8$export$2e2bcd8739ae039)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case "undefined":
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case "object":
            if (item === null) {
                if (!set._items["null"]) {
                    if (shouldAdd) set._items["null"] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            }
            // scan through all previously applied items
            if (!(0, $21ed1b58cd507ed8$export$2e2bcd8739ae039)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
}
var // A simple Set type that honours R.equals semantics
$824be21b4d2b0b08$export$2e2bcd8739ae039 = $824be21b4d2b0b08$var$_Set;



/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var $898874da84038705$var$uniqBy = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function uniqBy(fn, list) {
    var set = new (0, $824be21b4d2b0b08$export$2e2bcd8739ae039)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
});
var $898874da84038705$export$2e2bcd8739ae039 = $898874da84038705$var$uniqBy;


/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var $53a794c0ca314ed5$var$uniq = /*#__PURE__*/ (0, $898874da84038705$export$2e2bcd8739ae039)((0, $4f99436f72054941$export$2e2bcd8739ae039));
var $53a794c0ca314ed5$export$2e2bcd8739ae039 = $53a794c0ca314ed5$var$uniq;


/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var $e37862a4003e0682$var$intersection = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, $53a794c0ca314ed5$export$2e2bcd8739ae039)((0, $9e0cebe40b946a96$export$2e2bcd8739ae039)((0, $9770ba9f27278ec2$export$2e2bcd8739ae039)((0, $21ed1b58cd507ed8$export$2e2bcd8739ae039))(lookupList), filteredList));
});
var $e37862a4003e0682$export$2e2bcd8739ae039 = $e37862a4003e0682$var$intersection;




/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('n', ['ba', 'a', 'a']); //=> ['ba', 'n', 'a', 'n', 'a']
 */ var $bee7044035d44079$var$intersperse = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $a3f06d6355efa679$export$2e2bcd8739ae039)("intersperse", function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
var $bee7044035d44079$export$2e2bcd8739ae039 = $bee7044035d44079$var$intersperse;







function $7d78728eeb34fa56$export$2e2bcd8739ae039(target) {
    if (target == null) throw new TypeError("Cannot convert undefined or null to object");
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}


var $7af927483e458c6e$export$2e2bcd8739ae039 = typeof Object.assign === "function" ? Object.assign : (0, $7d78728eeb34fa56$export$2e2bcd8739ae039);






/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      var matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var $c2f8019748569875$var$objOf = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
var $c2f8019748569875$export$2e2bcd8739ae039 = $c2f8019748569875$var$objOf;


var $eba66104026c7e04$var$_stepCatArray = {
    "@@transducer/init": Array,
    "@@transducer/step": function(xs, x) {
        xs.push(x);
        return xs;
    },
    "@@transducer/result": (0, $f2f55f01782be410$export$2e2bcd8739ae039)
};
var $eba66104026c7e04$var$_stepCatString = {
    "@@transducer/init": String,
    "@@transducer/step": function(a, b) {
        return a + b;
    },
    "@@transducer/result": (0, $f2f55f01782be410$export$2e2bcd8739ae039)
};
var $eba66104026c7e04$var$_stepCatObject = {
    "@@transducer/init": Object,
    "@@transducer/step": function(result, input) {
        return (0, $7af927483e458c6e$export$2e2bcd8739ae039)(result, (0, $b2aaca034408573f$export$2e2bcd8739ae039)(input) ? (0, $c2f8019748569875$export$2e2bcd8739ae039)(input[0], input[1]) : input);
    },
    "@@transducer/result": (0, $f2f55f01782be410$export$2e2bcd8739ae039)
};
function $eba66104026c7e04$export$2e2bcd8739ae039(obj) {
    if ((0, $f855957a4a9612bf$export$2e2bcd8739ae039)(obj)) return obj;
    if ((0, $b2aaca034408573f$export$2e2bcd8739ae039)(obj)) return $eba66104026c7e04$var$_stepCatArray;
    if (typeof obj === "string") return $eba66104026c7e04$var$_stepCatString;
    if (typeof obj === "object") return $eba66104026c7e04$var$_stepCatObject;
    throw new Error("Cannot create transformer for " + obj);
}


/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      var intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var $c9975b3e1b9eb8d4$var$into = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function into(acc, xf, list) {
    return (0, $f855957a4a9612bf$export$2e2bcd8739ae039)(acc) ? (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(xf(acc), acc["@@transducer/init"](), list) : (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(xf((0, $eba66104026c7e04$export$2e2bcd8739ae039)(acc)), (0, $f551b53ecb369187$export$2e2bcd8739ae039)(acc, [], [], false), list);
});
var $c9975b3e1b9eb8d4$export$2e2bcd8739ae039 = $c9975b3e1b9eb8d4$var$into;





/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      var raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var $b4821c382bf84898$var$invert = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function invert(obj) {
    var props = (0, $7bd231648493210b$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, $88eb77390bd89c62$export$2e2bcd8739ae039)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
var $b4821c382bf84898$export$2e2bcd8739ae039 = $b4821c382bf84898$var$invert;




/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      var raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      var raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var $9b952454e0c09699$var$invertObj = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function invertObj(obj) {
    var props = (0, $7bd231648493210b$export$2e2bcd8739ae039)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
var $9b952454e0c09699$export$2e2bcd8739ae039 = $9b952454e0c09699$var$invertObj;






/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      var sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      var sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var $f766cfb0d864fc63$var$invoker = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function invoker(arity, method) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, $52388c18ea030e9e$export$2e2bcd8739ae039)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, $bad19a2637b95cc5$export$2e2bcd8739ae039)(target) + ' does not have a method named "' + method + '"');
    });
});
var $f766cfb0d864fc63$export$2e2bcd8739ae039 = $f766cfb0d864fc63$var$invoker;



/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $085980b9125d5a68$var$is = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
var $085980b9125d5a68$export$2e2bcd8739ae039 = $085980b9125d5a68$var$is;





/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */ var $59001049593e892a$var$isEmpty = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function isEmpty(x) {
    return x != null && (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)(x, (0, $95cdf578cb9f0fb4$export$2e2bcd8739ae039)(x));
});
var $59001049593e892a$export$2e2bcd8739ae039 = $59001049593e892a$var$isEmpty;




/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      var spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var $87847b15a1658ceb$var$join = /*#__PURE__*/ (0, $f766cfb0d864fc63$export$2e2bcd8739ae039)(1, "join");
var $87847b15a1658ceb$export$2e2bcd8739ae039 = $87847b15a1658ceb$var$join;




/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      var getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var $46df668603f5774e$var$juxt = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function juxt(fns) {
    return (0, $4b2678ecd0196288$export$2e2bcd8739ae039)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
var $46df668603f5774e$export$2e2bcd8739ae039 = $46df668603f5774e$var$juxt;




/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var $2bdd150423f4428b$var$keysIn = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
var $2bdd150423f4428b$export$2e2bcd8739ae039 = $2bdd150423f4428b$var$keysIn;






/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var $63054537b156f68e$var$lastIndexOf = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === "function" && !(0, $2d039bdca17f43bf$export$2e2bcd8739ae039)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
var $63054537b156f68e$export$2e2bcd8739ae039 = $63054537b156f68e$var$lastIndexOf;



function $dbac088bf7e0bf22$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object Number]";
}


/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var $883f66af709c58f9$var$length = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function length(list) {
    return list != null && (0, $dbac088bf7e0bf22$export$2e2bcd8739ae039)(list.length) ? list.length : NaN;
});
var $883f66af709c58f9$export$2e2bcd8739ae039 = $883f66af709c58f9$var$length;




/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $0ef3d3cc214c5868$var$lens = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
var $0ef3d3cc214c5868$export$2e2bcd8739ae039 = $0ef3d3cc214c5868$var$lens;






/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var $c4636f40da13225e$var$lensIndex = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function lensIndex(n) {
    return (0, $0ef3d3cc214c5868$export$2e2bcd8739ae039)((0, $789dcb83ae130e07$export$2e2bcd8739ae039)(n), (0, $ec0fc44412296678$export$2e2bcd8739ae039)(n));
});
var $c4636f40da13225e$export$2e2bcd8739ae039 = $c4636f40da13225e$var$lensIndex;






/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var $03e06792699a478a$var$lensPath = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function lensPath(p) {
    return (0, $0ef3d3cc214c5868$export$2e2bcd8739ae039)((0, $50cfe1e3236edffe$export$2e2bcd8739ae039)(p), (0, $1d89aceb744d3614$export$2e2bcd8739ae039)(p));
});
var $03e06792699a478a$export$2e2bcd8739ae039 = $03e06792699a478a$var$lensPath;






/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var $ce05721023eb443a$var$lensProp = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function lensProp(k) {
    return (0, $0ef3d3cc214c5868$export$2e2bcd8739ae039)((0, $db1c0ae5df507421$export$2e2bcd8739ae039)(k), (0, $d38b1d7ec30b4cc6$export$2e2bcd8739ae039)(k));
});
var $ce05721023eb443a$export$2e2bcd8739ae039 = $ce05721023eb443a$var$lensProp;





/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var $e0832a775c482209$var$lt = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function lt(a, b) {
    return a < b;
});
var $e0832a775c482209$export$2e2bcd8739ae039 = $e0832a775c482209$var$lt;



/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var $d1803e5447a6867d$var$lte = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function lte(a, b) {
    return a <= b;
});
var $d1803e5447a6867d$export$2e2bcd8739ae039 = $d1803e5447a6867d$var$lte;




/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccumRight
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var $c7f89aefbb30a63b$var$mapAccum = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
var $c7f89aefbb30a63b$export$2e2bcd8739ae039 = $c7f89aefbb30a63b$var$mapAccum;



/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *value* and *acc*, and should
 * return a tuple *[value, acc]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((x, acc) -> (y, acc)) -> acc -> [x] -> ([y], acc)
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      var digits = ['1', '2', '3', '4'];
 *      var append = (a, b) => [a + b, a + b];
 *
 *      R.mapAccumRight(append, 5, digits); //=> [['12345', '2345', '345', '45'], '12345']
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   [
 *     f(b, f(c, f(d, a)[0])[0])[1],
 *     f(c, f(d, a)[0])[1],
 *     f(d, a)[1],
 *   ]
 *   f(b, f(c, f(d, a)[0])[0])[0],
 * ]
 */ var $693632208370ae85$var$mapAccumRight = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(list[idx], tuple[0]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        result,
        tuple[0]
    ];
});
var $693632208370ae85$export$2e2bcd8739ae039 = $693632208370ae85$var$mapAccumRight;





/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      var values = { x: 1, y: 2, z: 3 };
 *      var prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, values); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var $0c6d34e5ebf48b37$var$mapObjIndexed = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function mapObjIndexed(fn, obj) {
    return (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, $7bd231648493210b$export$2e2bcd8739ae039)(obj));
});
var $0c6d34e5ebf48b37$export$2e2bcd8739ae039 = $0c6d34e5ebf48b37$var$mapObjIndexed;



/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var $cd04d93bbfa3cb82$var$match = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function match(rx, str) {
    return str.match(rx) || [];
});
var $cd04d93bbfa3cb82$export$2e2bcd8739ae039 = $cd04d93bbfa3cb82$var$match;




/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      var clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      var seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var $d8feb4d1fbfc3875$var$mathMod = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function mathMod(m, p) {
    if (!(0, $16dfade75a60b17d$export$2e2bcd8739ae039)(m)) return NaN;
    if (!(0, $16dfade75a60b17d$export$2e2bcd8739ae039)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
var $d8feb4d1fbfc3875$export$2e2bcd8739ae039 = $d8feb4d1fbfc3875$var$mathMod;




/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var $45dd3a7606822cc5$var$maxBy = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
var $45dd3a7606822cc5$export$2e2bcd8739ae039 = $45dd3a7606822cc5$var$maxBy;





/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var $ec6bcd8055bff467$var$sum = /*#__PURE__*/ (0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $f019de71e8a06f52$export$2e2bcd8739ae039), 0);
var $ec6bcd8055bff467$export$2e2bcd8739ae039 = $ec6bcd8055bff467$var$sum;


/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var $9bf24ad60709b0d8$var$mean = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function mean(list) {
    return (0, $ec6bcd8055bff467$export$2e2bcd8739ae039)(list) / list.length;
});
var $9bf24ad60709b0d8$export$2e2bcd8739ae039 = $9bf24ad60709b0d8$var$mean;




/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var $cfbc55a8481b6e99$var$median = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, $9bf24ad60709b0d8$export$2e2bcd8739ae039)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
var $cfbc55a8481b6e99$export$2e2bcd8739ae039 = $cfbc55a8481b6e99$var$median;





/**
 * A customisable version of [`R.memoize`](#memoize). `memoizeWith` takes an
 * additional function that will be applied to a given argument set and used to
 * create the cache key under which the results of the function to be memoized
 * will be stored. Care must be taken when implementing key generation to avoid
 * clashes that may overwrite previous entries erroneously.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoize
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var $71f6219784bdddd5$var$memoizeWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, $88eb77390bd89c62$export$2e2bcd8739ae039)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
var $71f6219784bdddd5$export$2e2bcd8739ae039 = $71f6219784bdddd5$var$memoizeWith;



/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @see R.memoizeWith
 * @deprecated since v0.25.0
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoize(n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var $50002e35c2cf8817$var$memoize = /*#__PURE__*/ (0, $71f6219784bdddd5$export$2e2bcd8739ae039)(function() {
    return (0, $bad19a2637b95cc5$export$2e2bcd8739ae039)(arguments);
});
var $50002e35c2cf8817$export$2e2bcd8739ae039 = $50002e35c2cf8817$var$memoize;





/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      var resetToDefault = R.merge(R.__, {x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge({ x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: 5, z: 3 }
 */ var $4458ab8ad9cce495$var$merge = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function merge(l, r) {
    return (0, $7af927483e458c6e$export$2e2bcd8739ae039)({}, l, r);
});
var $4458ab8ad9cce495$export$2e2bcd8739ae039 = $4458ab8ad9cce495$var$merge;




/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var $b32fbef3e2dbed92$var$mergeAll = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function mergeAll(list) {
    return (0, $7af927483e458c6e$export$2e2bcd8739ae039).apply(null, [
        {}
    ].concat(list));
});
var $b32fbef3e2dbed92$export$2e2bcd8739ae039 = $b32fbef3e2dbed92$var$mergeAll;







/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $3332ed23789643b8$var$mergeWithKey = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(k, l)) result[k] = (0, $88eb77390bd89c62$export$2e2bcd8739ae039)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(k, r) && !(0, $88eb77390bd89c62$export$2e2bcd8739ae039)(k, result)) result[k] = r[k];
    return result;
});
var $3332ed23789643b8$export$2e2bcd8739ae039 = $3332ed23789643b8$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeep, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $be34cea7118120e5$var$mergeDeepWithKey = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, $3332ed23789643b8$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        if ((0, $5ef083029079931f$export$2e2bcd8739ae039)(lVal) && (0, $5ef083029079931f$export$2e2bcd8739ae039)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
var $be34cea7118120e5$export$2e2bcd8739ae039 = $be34cea7118120e5$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $a5be8a4ba105bd9d$var$mergeDeepLeft = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function mergeDeepLeft(lObj, rObj) {
    return (0, $be34cea7118120e5$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
var $a5be8a4ba105bd9d$export$2e2bcd8739ae039 = $a5be8a4ba105bd9d$var$mergeDeepLeft;




/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var $35029e6524682208$var$mergeDeepRight = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function mergeDeepRight(lObj, rObj) {
    return (0, $be34cea7118120e5$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
var $35029e6524682208$export$2e2bcd8739ae039 = $35029e6524682208$var$mergeDeepRight;




/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeep, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var $9585420473934811$var$mergeDeepWith = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, $be34cea7118120e5$export$2e2bcd8739ae039)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
var $9585420473934811$export$2e2bcd8739ae039 = $9585420473934811$var$mergeDeepWith;





/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var $ae47d31727ce0ea6$var$mergeWith = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function mergeWith(fn, l, r) {
    return (0, $3332ed23789643b8$export$2e2bcd8739ae039)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
var $ae47d31727ce0ea6$export$2e2bcd8739ae039 = $ae47d31727ce0ea6$var$mergeWith;




/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var $4a109e3e85af9205$var$min = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function min(a, b) {
    return b < a ? b : a;
});
var $4a109e3e85af9205$export$2e2bcd8739ae039 = $4a109e3e85af9205$var$min;



/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      var square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var $28d52e1a07ee210e$var$minBy = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
var $28d52e1a07ee210e$export$2e2bcd8739ae039 = $28d52e1a07ee210e$var$minBy;



/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      var isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var $4326b32412a4c10a$var$modulo = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function modulo(a, b) {
    return a % b;
});
var $4326b32412a4c10a$export$2e2bcd8739ae039 = $4326b32412a4c10a$var$modulo;



/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      var double = R.multiply(2);
 *      var triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var $03abd7373b3ca0e5$var$multiply = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function multiply(a, b) {
    return a * b;
});
var $03abd7373b3ca0e5$export$2e2bcd8739ae039 = $03abd7373b3ca0e5$var$multiply;




/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var $edcd222a518c057f$var$negate = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function negate(n) {
    return -n;
});
var $edcd222a518c057f$export$2e2bcd8739ae039 = $edcd222a518c057f$var$negate;







/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      var isEven = n => n % 2 === 0;
 *      var isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var $a01a2647498efb15$var$none = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $1f308d2c1fa8bdbd$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "any"
], (0, $ad62fc19e10ee0c1$export$2e2bcd8739ae039), (0, $98f0f3c4f07b45c4$export$2e2bcd8739ae039))));
var $a01a2647498efb15$export$2e2bcd8739ae039 = $a01a2647498efb15$var$none;







/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var $eaea537e83a84c4b$var$nthArg = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(arity, function() {
        return (0, $789dcb83ae130e07$export$2e2bcd8739ae039)(n, arguments);
    });
});
var $eaea537e83a84c4b$export$2e2bcd8739ae039 = $eaea537e83a84c4b$var$nthArg;



/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      var classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      var yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var $6b4e5bd33eae9fe0$var$o = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function o(f, g, x) {
    return f(g(x));
});
var $6b4e5bd33eae9fe0$export$2e2bcd8739ae039 = $6b4e5bd33eae9fe0$var$o;




function $c1500578447889e5$export$2e2bcd8739ae039(x) {
    return [
        x
    ];
}


/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var $1e473933401e574f$var$of = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)((0, $c1500578447889e5$export$2e2bcd8739ae039));
var $1e473933401e574f$export$2e2bcd8739ae039 = $1e473933401e574f$var$of;



/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var $13033c48a51df7a1$var$omit = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
var $13033c48a51df7a1$export$2e2bcd8739ae039 = $13033c48a51df7a1$var$omit;




/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      var addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var $dc699b06c099e638$var$once = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function once(fn) {
    var called = false;
    var result;
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
var $dc699b06c099e638$export$2e2bcd8739ae039 = $dc699b06c099e638$var$once;




// `Identity` is a functor that holds a single value, where `map` simply
// transforms the held value with the provided function.
var $72a5a568549a5d54$var$Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return $72a5a568549a5d54$var$Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var $72a5a568549a5d54$var$over = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return $72a5a568549a5d54$var$Identity(f(y));
    })(x).value;
});
var $72a5a568549a5d54$export$2e2bcd8739ae039 = $72a5a568549a5d54$var$over;



/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var $f3dce8682185fe38$var$pair = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
var $f3dce8682185fe38$export$2e2bcd8739ae039 = $f3dce8682185fe38$var$pair;





function $73261296eb038d54$export$2e2bcd8739ae039(concat) {
    return (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(fn, args) {
        return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}


/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight
 * @example
 *
 *      var multiply2 = (a, b) => a * b;
 *      var double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var sayHello = R.partial(greet, ['Hello']);
 *      var sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var $59667c92551151c2$var$partial = /*#__PURE__*/ (0, $73261296eb038d54$export$2e2bcd8739ae039)((0, $77ebcc3f4af9905b$export$2e2bcd8739ae039));
var $59667c92551151c2$export$2e2bcd8739ae039 = $59667c92551151c2$var$partial;





/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      var greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      var greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var $571e5e9366cde9b0$var$partialRight = /*#__PURE__*/ (0, $73261296eb038d54$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $9770ba9f27278ec2$export$2e2bcd8739ae039)((0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)));
var $571e5e9366cde9b0$export$2e2bcd8739ae039 = $571e5e9366cde9b0$var$partialRight;





/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.contains('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.contains('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var $7bb9e41aed762abe$var$partition = /*#__PURE__*/ (0, $46df668603f5774e$export$2e2bcd8739ae039)([
    (0, $0512e21c9d88d410$export$2e2bcd8739ae039),
    (0, $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039)
]);
var $7bb9e41aed762abe$export$2e2bcd8739ae039 = $7bb9e41aed762abe$var$partition;






/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      var user1 = { address: { zipCode: 90210 } };
 *      var user2 = { address: { zipCode: 55555 } };
 *      var user3 = { name: 'Bob' };
 *      var users = [ user1, user2, user3 ];
 *      var isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var $46496dbc35676dcf$var$pathEq = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function pathEq(_path, val, obj) {
    return (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)((0, $50cfe1e3236edffe$export$2e2bcd8739ae039)(_path, obj), val);
});
var $46496dbc35676dcf$export$2e2bcd8739ae039 = $46496dbc35676dcf$var$pathEq;





/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var $237cfa7a8a4352aa$var$pathOr = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function pathOr(d, p, obj) {
    return (0, $d9bbbf3f37bc8daa$export$2e2bcd8739ae039)(d, (0, $50cfe1e3236edffe$export$2e2bcd8739ae039)(p, obj));
});
var $237cfa7a8a4352aa$export$2e2bcd8739ae039 = $237cfa7a8a4352aa$var$pathOr;




/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */ var $c2cb1fe0a9dff280$var$pathSatisfies = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function pathSatisfies(pred, propPath, obj) {
    return propPath.length > 0 && pred((0, $50cfe1e3236edffe$export$2e2bcd8739ae039)(propPath, obj));
});
var $c2cb1fe0a9dff280$export$2e2bcd8739ae039 = $c2cb1fe0a9dff280$var$pathSatisfies;



/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var $e4657c4ef70c424e$var$pick = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
var $e4657c4ef70c424e$export$2e2bcd8739ae039 = $e4657c4ef70c424e$var$pick;



/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var $96ade886caf05266$var$pickAll = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
var $96ade886caf05266$export$2e2bcd8739ae039 = $96ade886caf05266$var$pickAll;



/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      var isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var $3436c2b0e12e3231$var$pickBy = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
var $3436c2b0e12e3231$export$2e2bcd8739ae039 = $3436c2b0e12e3231$var$pickBy;





function $caafa7af5310edd8$export$2e2bcd8739ae039() {
    if (arguments.length === 0) throw new Error("pipeK requires at least one argument");
    return (0, $dc7735313275e0ee$export$2e2bcd8739ae039).apply(this, (0, $95f561f65fac8c60$export$2e2bcd8739ae039)(arguments));
}






/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var $a5a082351a61401a$var$prepend = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function prepend(el, list) {
    return (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)([
        el
    ], list);
});
var $a5a082351a61401a$export$2e2bcd8739ae039 = $a5a082351a61401a$var$prepend;




/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var $a62d848ee29b206b$var$product = /*#__PURE__*/ (0, $7452afdb416c43f8$export$2e2bcd8739ae039)((0, $03abd7373b3ca0e5$export$2e2bcd8739ae039), 1);
var $a62d848ee29b206b$export$2e2bcd8739ae039 = $a62d848ee29b206b$var$product;







/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var $a8ba708880b3f6c3$var$useWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function useWith(fn, transformers) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
var $a8ba708880b3f6c3$export$2e2bcd8739ae039 = $a8ba708880b3f6c3$var$useWith;


/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      var kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var $664924c1e60c3a7f$var$project = /*#__PURE__*/ (0, $a8ba708880b3f6c3$export$2e2bcd8739ae039)((0, $de665e827334f055$export$2e2bcd8739ae039), [
    (0, $96ade886caf05266$export$2e2bcd8739ae039),
    (0, $4f99436f72054941$export$2e2bcd8739ae039)
]); // passing `identity` gives correct arity
var $664924c1e60c3a7f$export$2e2bcd8739ae039 = $664924c1e60c3a7f$var$project;





/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      var abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      var fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      var rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      var alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      var kids = [abby, fred, rusty, alois];
 *      var hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var $2597b9e224d7155a$var$propEq = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function propEq(name, val, obj) {
    return (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)(val, obj[name]);
});
var $2597b9e224d7155a$export$2e2bcd8739ae039 = $2597b9e224d7155a$var$propEq;




/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var $3d1668d8f846484a$var$propIs = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function propIs(type, name, obj) {
    return (0, $085980b9125d5a68$export$2e2bcd8739ae039)(type, obj[name]);
});
var $3d1668d8f846484a$export$2e2bcd8739ae039 = $3d1668d8f846484a$var$propIs;




/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var favorite = R.prop('favoriteLibrary');
 *      var favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var $3d18d62015a49895$var$propOr = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function propOr(val, p, obj) {
    return obj != null && (0, $88eb77390bd89c62$export$2e2bcd8739ae039)(p, obj) ? obj[p] : val;
});
var $3d18d62015a49895$export$2e2bcd8739ae039 = $3d18d62015a49895$var$propOr;



/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var $a52ca6196861a7c2$var$propSatisfies = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function propSatisfies(pred, name, obj) {
    return pred(obj[name]);
});
var $a52ca6196861a7c2$export$2e2bcd8739ae039 = $a52ca6196861a7c2$var$propSatisfies;



/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      var fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var $e8dab3d82e120475$var$props = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function props(ps, obj) {
    var len = ps.length;
    var out = [];
    var idx = 0;
    while(idx < len){
        out[idx] = obj[ps[idx]];
        idx += 1;
    }
    return out;
});
var $e8dab3d82e120475$export$2e2bcd8739ae039 = $e8dab3d82e120475$var$props;




/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in tthe set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var $699c2821590b6e22$var$range = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function range(from, to) {
    if (!((0, $dbac088bf7e0bf22$export$2e2bcd8739ae039)(from) && (0, $dbac088bf7e0bf22$export$2e2bcd8739ae039)(to))) throw new TypeError("Both arguments to range must be numbers");
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
var $699c2821590b6e22$export$2e2bcd8739ae039 = $699c2821590b6e22$var$range;





/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var $e63abf39a9cd0229$var$reduceRight = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        idx -= 1;
    }
    return acc;
});
var $e63abf39a9cd0229$export$2e2bcd8739ae039 = $e63abf39a9cd0229$var$reduceRight;





/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      var isOdd = (acc, x) => x % 2 === 1;
 *      var xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      var ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var $0c7074e263894bb9$var$reduceWhile = /*#__PURE__*/ (0, $53afa373fbec91db$export$2e2bcd8739ae039)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, $0079da3350b7af31$export$2e2bcd8739ae039)(acc);
    }, a, list);
});
var $0c7074e263894bb9$export$2e2bcd8739ae039 = $0c7074e263894bb9$var$reduceWhile;




/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is unavailable to functions not explicitly listed
 * above. For instance, it is not currently supported by
 * [`reduceRight`](#reduceRight).
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var $630906fac1e188b9$var$reduced = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)((0, $0079da3350b7af31$export$2e2bcd8739ae039));
var $630906fac1e188b9$export$2e2bcd8739ae039 = $630906fac1e188b9$var$reduced;







/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var $b1186e00c2b95e20$var$times = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError("n must be a non-negative number");
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
var $b1186e00c2b95e20$export$2e2bcd8739ae039 = $b1186e00c2b95e20$var$times;


/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      var obj = {};
 *      var repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var $f4f839f224ea68da$var$repeat = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function repeat(value, n) {
    return (0, $b1186e00c2b95e20$export$2e2bcd8739ae039)((0, $8e63af234d14ba1a$export$2e2bcd8739ae039)(value), n);
});
var $f4f839f224ea68da$export$2e2bcd8739ae039 = $f4f839f224ea68da$var$repeat;



/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var $8318f73234b785b6$var$replace = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
var $8318f73234b785b6$export$2e2bcd8739ae039 = $8318f73234b785b6$var$replace;




/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var $8735f9199b9220e1$var$scan = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
var $8735f9199b9220e1$export$2e2bcd8739ae039 = $8735f9199b9220e1$var$scan;







/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var $67dbf70025d127d8$var$sequence = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function sequence(of, traversable) {
    return typeof traversable.sequence === "function" ? traversable.sequence(of) : (0, $e63abf39a9cd0229$export$2e2bcd8739ae039)(function(x, acc) {
        return (0, $58ae1df029b78e7c$export$2e2bcd8739ae039)((0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)((0, $a5a082351a61401a$export$2e2bcd8739ae039), x), acc);
    }, of([]), traversable);
});
var $67dbf70025d127d8$export$2e2bcd8739ae039 = $67dbf70025d127d8$var$sequence;





/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var $c252c4a9de7c2480$var$set = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function set(lens, v, x) {
    return (0, $72a5a568549a5d54$export$2e2bcd8739ae039)(lens, (0, $8e63af234d14ba1a$export$2e2bcd8739ae039)(v), x);
});
var $c252c4a9de7c2480$export$2e2bcd8739ae039 = $c252c4a9de7c2480$var$set;




/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      var diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var $2c6747568ff4340f$var$sort = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
var $2c6747568ff4340f$export$2e2bcd8739ae039 = $2c6747568ff4340f$var$sort;



/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      var sortByFirstItem = R.sortBy(R.prop(0));
 *      var sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      var pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *      var alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      var bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      var people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var $88cf8f066fd3d09d$var$sortBy = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
var $88cf8f066fd3d09d$export$2e2bcd8739ae039 = $88cf8f066fd3d09d$var$sortBy;



/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      var alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      var bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      var clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      var people = [clara, bob, alice];
 *      var ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var $0c44a1ff97f8ad3a$var$sortWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
var $0c44a1ff97f8ad3a$export$2e2bcd8739ae039 = $0c44a1ff97f8ad3a$var$sortWith;



/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      var pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var $f7a69d4871758d7b$var$split = /*#__PURE__*/ (0, $f766cfb0d864fc63$export$2e2bcd8739ae039)(1, "split");
var $f7a69d4871758d7b$export$2e2bcd8739ae039 = $f7a69d4871758d7b$var$split;





/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var $a60e80e084e1281e$var$splitAt = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function splitAt(index, array) {
    return [
        (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(0, index, array),
        (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(index, (0, $883f66af709c58f9$export$2e2bcd8739ae039)(array), array)
    ];
});
var $a60e80e084e1281e$export$2e2bcd8739ae039 = $a60e80e084e1281e$var$splitAt;




/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var $4f0b976c160825c3$var$splitEvery = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function splitEvery(n, list) {
    if (n <= 0) throw new Error("First argument to splitEvery must be a positive integer");
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, $4308737fb8a829dd$export$2e2bcd8739ae039)(idx, idx += n, list));
    return result;
});
var $4f0b976c160825c3$export$2e2bcd8739ae039 = $4f0b976c160825c3$var$splitEvery;



/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var $0b0da9cc4d7dbf8c$var$splitWhen = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
var $0b0da9cc4d7dbf8c$export$2e2bcd8739ae039 = $0b0da9cc4d7dbf8c$var$splitWhen;





/**
 * Checks if a list starts with the provided values
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> Boolean
 * @sig String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var $56caf477f41067fc$var$startsWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(prefix, list) {
    return (0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039)((0, $2092a6321d126114$export$2e2bcd8739ae039)(prefix.length, list), prefix);
});
var $56caf477f41067fc$export$2e2bcd8739ae039 = $56caf477f41067fc$var$startsWith;



/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      var minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      var complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var $bd554b906aa6c458$var$subtract = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function subtract(a, b) {
    return Number(a) - Number(b);
});
var $bd554b906aa6c458$export$2e2bcd8739ae039 = $bd554b906aa6c458$var$subtract;






/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var $d3365ba2e7de83db$var$symmetricDifference = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function symmetricDifference(list1, list2) {
    return (0, $bc076d26ac1675e1$export$2e2bcd8739ae039)((0, $5a88f499f8de57e0$export$2e2bcd8739ae039)(list1, list2), (0, $5a88f499f8de57e0$export$2e2bcd8739ae039)(list2, list1));
});
var $d3365ba2e7de83db$export$2e2bcd8739ae039 = $d3365ba2e7de83db$var$symmetricDifference;





/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      var eqA = R.eqBy(R.prop('a'));
 *      var l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      var l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var $d99881c5f603fffc$var$symmetricDifferenceWith = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, $bc076d26ac1675e1$export$2e2bcd8739ae039)((0, $1f539a638986d66f$export$2e2bcd8739ae039)(pred, list1, list2), (0, $1f539a638986d66f$export$2e2bcd8739ae039)(pred, list2, list1));
});
var $d99881c5f603fffc$export$2e2bcd8739ae039 = $d99881c5f603fffc$var$symmetricDifferenceWith;







/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      var isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var $7bdc9aa494146858$var$takeLastWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(idx + 1, Infinity, xs);
});
var $7bdc9aa494146858$export$2e2bcd8739ae039 = $7bdc9aa494146858$var$takeLastWhile;







var $3707cbd04c47e1b7$var$XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XTakeWhile.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XTakeWhile.prototype["@@transducer/step"] = function(result, input) {
        return this.f(input) ? this.xf["@@transducer/step"](result, input) : (0, $0079da3350b7af31$export$2e2bcd8739ae039)(result);
    };
    return XTakeWhile;
}();
var $3707cbd04c47e1b7$var$_xtakeWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xtakeWhile(f, xf) {
    return new $3707cbd04c47e1b7$var$XTakeWhile(f, xf);
});
var $3707cbd04c47e1b7$export$2e2bcd8739ae039 = $3707cbd04c47e1b7$var$_xtakeWhile;



/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      var isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var $2896547f0b1d93f9$var$takeWhile = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([
    "takeWhile"
], (0, $3707cbd04c47e1b7$export$2e2bcd8739ae039), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, $4308737fb8a829dd$export$2e2bcd8739ae039)(0, idx, xs);
}));
var $2896547f0b1d93f9$export$2e2bcd8739ae039 = $2896547f0b1d93f9$var$takeWhile;






var $d1c20d568e2d4682$var$XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype["@@transducer/init"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).init;
    XTap.prototype["@@transducer/result"] = (0, $75b4df47bddaba3e$export$2e2bcd8739ae039).result;
    XTap.prototype["@@transducer/step"] = function(result, input) {
        this.f(input);
        return this.xf["@@transducer/step"](result, input);
    };
    return XTap;
}();
var $d1c20d568e2d4682$var$_xtap = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _xtap(f, xf) {
    return new $d1c20d568e2d4682$var$XTap(f, xf);
});
var $d1c20d568e2d4682$export$2e2bcd8739ae039 = $d1c20d568e2d4682$var$_xtap;


/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      var sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var $ac26ce73bed1035e$var$tap = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $e82fd3c19264968c$export$2e2bcd8739ae039)([], (0, $d1c20d568e2d4682$export$2e2bcd8739ae039), function tap(fn, x) {
    fn(x);
    return x;
}));
var $ac26ce73bed1035e$export$2e2bcd8739ae039 = $ac26ce73bed1035e$var$tap;




function $0cfe08503b8d6d53$export$2e2bcd8739ae039(x) {
    return Object.prototype.toString.call(x) === "[object RegExp]";
}



/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var $e4bccc81b18bede0$var$test = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function test(pattern, str) {
    if (!(0, $0cfe08503b8d6d53$export$2e2bcd8739ae039)(pattern)) throw new TypeError("‘test’ requires a value of type RegExp as its first argument; received " + (0, $bad19a2637b95cc5$export$2e2bcd8739ae039)(pattern));
    return (0, $2d910f6d3e8cbb17$export$2e2bcd8739ae039)(pattern).test(str);
});
var $e4bccc81b18bede0$export$2e2bcd8739ae039 = $e4bccc81b18bede0$var$test;




/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var $a9667ff05e6e2673$var$toLower = /*#__PURE__*/ (0, $f766cfb0d864fc63$export$2e2bcd8739ae039)(0, "toLowerCase");
var $a9667ff05e6e2673$export$2e2bcd8739ae039 = $a9667ff05e6e2673$var$toLower;




/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var $a8e6b3dea9f3b4aa$var$toPairs = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $a8e6b3dea9f3b4aa$export$2e2bcd8739ae039 = $a8e6b3dea9f3b4aa$var$toPairs;



/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var $dcf2a9387776ce07$var$toPairsIn = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
var $dcf2a9387776ce07$export$2e2bcd8739ae039 = $dcf2a9387776ce07$var$toPairsIn;




/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var $dc986dcc9af431d1$var$toUpper = /*#__PURE__*/ (0, $f766cfb0d864fc63$export$2e2bcd8739ae039)(0, "toUpperCase");
var $dc986dcc9af431d1$export$2e2bcd8739ae039 = $dc986dcc9af431d1$var$toUpper;





/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      var numbers = [1, 2, 3, 4];
 *      var transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      var isOdd = (x) => x % 2 === 1;
 *      var firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var $aa7ef27a523ac1bc$var$transduce = /*#__PURE__*/ (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(4, function transduce(xf, fn, acc, list) {
    return (0, $eeff341e2e828e35$export$2e2bcd8739ae039)(xf(typeof fn === "function" ? (0, $4d56fbe3ec82dcda$export$2e2bcd8739ae039)(fn) : fn), acc, list);
});
var $aa7ef27a523ac1bc$export$2e2bcd8739ae039 = $aa7ef27a523ac1bc$var$transduce;



/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var $850b222cee504b50$var$transpose = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === "undefined") result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
var $850b222cee504b50$export$2e2bcd8739ae039 = $850b222cee504b50$var$transpose;





/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Nothing` if the given divisor is `0`
 *      safeDiv = n => d => d === 0 ? Nothing() : Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Nothing
 */ var $dc54195437ee7b06$var$traverse = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function traverse(of, f, traversable) {
    return typeof traversable["fantasy-land/traverse"] === "function" ? traversable["fantasy-land/traverse"](f, of) : (0, $67dbf70025d127d8$export$2e2bcd8739ae039)(of, (0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)(f, traversable));
});
var $dc54195437ee7b06$export$2e2bcd8739ae039 = $dc54195437ee7b06$var$traverse;



var $50f1577a65a8503a$var$ws = "	\n\v\f\r \xa0 ᠎             　\u2028\u2029\uFEFF";
var $50f1577a65a8503a$var$zeroWidth = "​";
var $50f1577a65a8503a$var$hasProtoTrim = typeof String.prototype.trim === "function";
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var $50f1577a65a8503a$var$_trim = !$50f1577a65a8503a$var$hasProtoTrim || /*#__PURE__*/ $50f1577a65a8503a$var$ws.trim() || !/*#__PURE__*/ $50f1577a65a8503a$var$zeroWidth.trim() ? function trim(str) {
    var beginRx = new RegExp("^[" + $50f1577a65a8503a$var$ws + "][" + $50f1577a65a8503a$var$ws + "]*");
    var endRx = new RegExp("[" + $50f1577a65a8503a$var$ws + "][" + $50f1577a65a8503a$var$ws + "]*$");
    return str.replace(beginRx, "").replace(endRx, "");
} : function trim(str) {
    return str.trim();
};
var $50f1577a65a8503a$var$trim = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)($50f1577a65a8503a$var$_trim);
var $50f1577a65a8503a$export$2e2bcd8739ae039 = $50f1577a65a8503a$var$trim;





/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(R.prop('x'), R.F)(null);      //=> false
 */ var $fbd977eade7de053$var$tryCatch = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function _tryCatch(tryer, catcher) {
    return (0, $b92606b8e25b6843$export$2e2bcd8739ae039)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)([
                e
            ], arguments));
        }
    });
});
var $fbd977eade7de053$export$2e2bcd8739ae039 = $fbd977eade7de053$var$tryCatch;




/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var $873cad90b85bfd5c$var$unapply = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
var $873cad90b85bfd5c$export$2e2bcd8739ae039 = $873cad90b85bfd5c$var$unapply;




/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      var takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      var takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var $4eca2a528c3c9441$var$unary = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function unary(fn) {
    return (0, $3a7e87844ea63781$export$2e2bcd8739ae039)(1, fn);
});
var $4eca2a528c3c9441$export$2e2bcd8739ae039 = $4eca2a528c3c9441$var$unary;




/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      var addFour = a => b => c => d => a + b + c + d;
 *
 *      var uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var $2b6236173b683ad8$var$uncurryN = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function uncurryN(depth, fn) {
    return (0, $9e65c03c0b3b4a25$export$2e2bcd8739ae039)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === "function"){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
var $2b6236173b683ad8$export$2e2bcd8739ae039 = $2b6236173b683ad8$var$uncurryN;



/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      var f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var $3fc73347a812c635$var$unfold = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
var $3fc73347a812c635$export$2e2bcd8739ae039 = $3fc73347a812c635$var$unfold;






/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var $b8e328fc88889769$var$union = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $98f66900c8aaac5b$export$2e2bcd8739ae039)((0, $53a794c0ca314ed5$export$2e2bcd8739ae039), (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)));
var $b8e328fc88889769$export$2e2bcd8739ae039 = $b8e328fc88889769$var$union;






/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      var strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var $a66cc249f8e883bc$var$uniqWith = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function uniqWith(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, $2555cbf5393f2ef6$export$2e2bcd8739ae039)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
});
var $a66cc249f8e883bc$export$2e2bcd8739ae039 = $a66cc249f8e883bc$var$uniqWith;


/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      var l1 = [{a: 1}, {a: 2}];
 *      var l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var $277375fe4b05ea82$var$unionWith = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function unionWith(pred, list1, list2) {
    return (0, $a66cc249f8e883bc$export$2e2bcd8739ae039)(pred, (0, $77ebcc3f4af9905b$export$2e2bcd8739ae039)(list1, list2));
});
var $277375fe4b05ea82$export$2e2bcd8739ae039 = $277375fe4b05ea82$var$unionWith;






/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var $b5488ec7fb47c5d1$var$unless = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
var $b5488ec7fb47c5d1$export$2e2bcd8739ae039 = $b5488ec7fb47c5d1$var$unless;




/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var $5b3db807d0bef66e$var$unnest = /*#__PURE__*/ (0, $404a156d8184580f$export$2e2bcd8739ae039)((0, $f2f55f01782be410$export$2e2bcd8739ae039));
var $5b3db807d0bef66e$export$2e2bcd8739ae039 = $5b3db807d0bef66e$var$unnest;



/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var $2170a128e2c133f3$var$until = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
var $2170a128e2c133f3$export$2e2bcd8739ae039 = $2170a128e2c133f3$var$until;






/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      var F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      var f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var $0f925ee23251634d$var$valuesIn = /*#__PURE__*/ (0, $1119b291707c3284$export$2e2bcd8739ae039)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
var $0f925ee23251634d$export$2e2bcd8739ae039 = $0f925ee23251634d$var$valuesIn;



// `Const` is a functor that effectively ignores the function given to `map`.
var $8a8cab4aa87e2dd4$var$Const = function(x) {
    return {
        value: x,
        "fantasy-land/map": function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      var xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var $8a8cab4aa87e2dd4$var$view = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens($8a8cab4aa87e2dd4$var$Const)(x).value;
});
var $8a8cab4aa87e2dd4$export$2e2bcd8739ae039 = $8a8cab4aa87e2dd4$var$view;



/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless
 * @example
 *
 *      // truncate :: String -> String
 *      var truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var $58eefed053cb042f$var$when = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
var $58eefed053cb042f$export$2e2bcd8739ae039 = $58eefed053cb042f$var$when;




/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var $74ee78bc08fd8323$var$where = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, $88eb77390bd89c62$export$2e2bcd8739ae039)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
var $74ee78bc08fd8323$export$2e2bcd8739ae039 = $74ee78bc08fd8323$var$where;






/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      var pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var $2adc6941da96aa59$var$whereEq = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function whereEq(spec, testObj) {
    return (0, $74ee78bc08fd8323$export$2e2bcd8739ae039)((0, $eeba40a83c1af2c4$export$2e2bcd8739ae039)((0, $bb5c76e6a1c0ede6$export$2e2bcd8739ae039), spec), testObj);
});
var $2adc6941da96aa59$export$2e2bcd8739ae039 = $2adc6941da96aa59$var$whereEq;






/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var $64369378d9a9e357$var$without = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function(xs, list) {
    return (0, $1b72f1e2ce8a2a5c$export$2e2bcd8739ae039)((0, $9770ba9f27278ec2$export$2e2bcd8739ae039)((0, $21ed1b58cd507ed8$export$2e2bcd8739ae039))(xs), list);
});
var $64369378d9a9e357$export$2e2bcd8739ae039 = $64369378d9a9e357$var$without;



/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var $a1433f5f4c8d07b2$var$xprod = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
var $a1433f5f4c8d07b2$export$2e2bcd8739ae039 = $a1433f5f4c8d07b2$var$xprod;



/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var $d53e4f2617269976$var$zip = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
var $d53e4f2617269976$export$2e2bcd8739ae039 = $d53e4f2617269976$var$zip;



/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var $023c734c92cfafb9$var$zipObj = /*#__PURE__*/ (0, $5bc7a8bc494b0aa9$export$2e2bcd8739ae039)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
var $023c734c92cfafb9$export$2e2bcd8739ae039 = $023c734c92cfafb9$var$zipObj;



/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      var f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var $490b35eff4ce0e0c$var$zipWith = /*#__PURE__*/ (0, $e7795d8db44cc84b$export$2e2bcd8739ae039)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
var $490b35eff4ce0e0c$export$2e2bcd8739ae039 = $490b35eff4ce0e0c$var$zipWith;




var $a0933ef57ff1c2b9$exports = {};

$parcel$export($a0933ef57ff1c2b9$exports, "dmp", function () { return $a0933ef57ff1c2b9$export$21b0d22d12aeedc7; });
$parcel$export($a0933ef57ff1c2b9$exports, "capitalize_head", function () { return $a0933ef57ff1c2b9$export$9f8c3630c3d15aa2; });
$parcel$export($a0933ef57ff1c2b9$exports, "debug", function () { return $a0933ef57ff1c2b9$export$1c9f709888824e05; });
$parcel$export($a0933ef57ff1c2b9$exports, "debugName", function () { return $a0933ef57ff1c2b9$export$9acf59296ec0cce1; });
$parcel$export($a0933ef57ff1c2b9$exports, "char_stream", function () { return $a0933ef57ff1c2b9$export$1bfa025333b3570e; });
$parcel$export($a0933ef57ff1c2b9$exports, "raw_diff", function () { return $a0933ef57ff1c2b9$export$73042cc6e64aaf37; });
$parcel$export($a0933ef57ff1c2b9$exports, "hdiff", function () { return $a0933ef57ff1c2b9$export$6baddf9e2d3d7a3b; });
$parcel$export($a0933ef57ff1c2b9$exports, "flatMap", function () { return $a0933ef57ff1c2b9$export$5b8affa63fc6df16; });
$parcel$export($a0933ef57ff1c2b9$exports, "str_map", function () { return $a0933ef57ff1c2b9$export$d04e030ebc4d0326; });
$parcel$export($a0933ef57ff1c2b9$exports, "end_with_space", function () { return $a0933ef57ff1c2b9$export$14c0f847aecec6f1; });
$parcel$export($a0933ef57ff1c2b9$exports, "token_diff", function () { return $a0933ef57ff1c2b9$export$55a979e417d1ea1b; });
$parcel$export($a0933ef57ff1c2b9$exports, "invert_token_diff", function () { return $a0933ef57ff1c2b9$export$ca60277ef2eae2d4; });
$parcel$export($a0933ef57ff1c2b9$exports, "multi_token_diff", function () { return $a0933ef57ff1c2b9$export$9f1a18fcf029fd45; });
$parcel$export($a0933ef57ff1c2b9$exports, "shallow_array_eq", function () { return $a0933ef57ff1c2b9$export$a19dbeb44f6a0bab; });
$parcel$export($a0933ef57ff1c2b9$exports, "array_multiset_eq", function () { return $a0933ef57ff1c2b9$export$574e067f403877b3; });
$parcel$export($a0933ef57ff1c2b9$exports, "map_equal", function () { return $a0933ef57ff1c2b9$export$ad8955a544efecc6; });
$parcel$export($a0933ef57ff1c2b9$exports, "set_equal", function () { return $a0933ef57ff1c2b9$export$c90d60d0819468be; });
$parcel$export($a0933ef57ff1c2b9$exports, "array_set_eq", function () { return $a0933ef57ff1c2b9$export$74895c65cb076870; });
$parcel$export($a0933ef57ff1c2b9$exports, "show", function () { return $a0933ef57ff1c2b9$export$57bf213be019eeb0; });
$parcel$export($a0933ef57ff1c2b9$exports, "stderr", function () { return $a0933ef57ff1c2b9$export$8343b6e3d09a3606; });
$parcel$export($a0933ef57ff1c2b9$exports, "stdout", function () { return $a0933ef57ff1c2b9$export$9eda70b29dd52ef9; });
$parcel$export($a0933ef57ff1c2b9$exports, "numsort", function () { return $a0933ef57ff1c2b9$export$bab4a1db406f2fa9; });
$parcel$export($a0933ef57ff1c2b9$exports, "chain_cmps", function () { return $a0933ef57ff1c2b9$export$ac82cbe7dc0182d2; });
$parcel$export($a0933ef57ff1c2b9$exports, "cmp_order", function () { return $a0933ef57ff1c2b9$export$479e93f6971754e6; });
$parcel$export($a0933ef57ff1c2b9$exports, "mkcmp", function () { return $a0933ef57ff1c2b9$export$10a14be77be1fbf8; });
$parcel$export($a0933ef57ff1c2b9$exports, "ltrim", function () { return $a0933ef57ff1c2b9$export$c6a55a9d77585122; });
$parcel$export($a0933ef57ff1c2b9$exports, "whitespace_split", function () { return $a0933ef57ff1c2b9$export$fa2642df3bb464aa; });
$parcel$export($a0933ef57ff1c2b9$exports, "initial_whitespace_split", function () { return $a0933ef57ff1c2b9$export$22a074bb5a7310a6; });
$parcel$export($a0933ef57ff1c2b9$exports, "increases", function () { return $a0933ef57ff1c2b9$export$e12697c9e41305e2; });
$parcel$export($a0933ef57ff1c2b9$exports, "contiguous", function () { return $a0933ef57ff1c2b9$export$e8ee1b9f9c7189a; });
$parcel$export($a0933ef57ff1c2b9$exports, "group_contiguous", function () { return $a0933ef57ff1c2b9$export$a01aafba61e29e63; });
$parcel$export($a0933ef57ff1c2b9$exports, "flatten", function () { return $a0933ef57ff1c2b9$export$bffa455ba8c619a6; });
$parcel$export($a0933ef57ff1c2b9$exports, "across", function () { return $a0933ef57ff1c2b9$export$c9b6b290379e9dc7; });
$parcel$export($a0933ef57ff1c2b9$exports, "splitAt3", function () { return $a0933ef57ff1c2b9$export$972dde9b4ef006d4; });
$parcel$export($a0933ef57ff1c2b9$exports, "stringSplitAt3", function () { return $a0933ef57ff1c2b9$export$5417a444a9c88ecf; });
$parcel$export($a0933ef57ff1c2b9$exports, "cat", function () { return $a0933ef57ff1c2b9$export$99aaa11fb71d263; });
$parcel$export($a0933ef57ff1c2b9$exports, "cycle", function () { return $a0933ef57ff1c2b9$export$c04a9f24a4230e1f; });
$parcel$export($a0933ef57ff1c2b9$exports, "minimum", function () { return $a0933ef57ff1c2b9$export$916782c1f0ddb132; });
$parcel$export($a0933ef57ff1c2b9$exports, "maximum", function () { return $a0933ef57ff1c2b9$export$b25e0be55f42c9a; });
$parcel$export($a0933ef57ff1c2b9$exports, "sum", function () { return $a0933ef57ff1c2b9$export$8a63f25cc62965f1; });
$parcel$export($a0933ef57ff1c2b9$exports, "minimumBy", function () { return $a0933ef57ff1c2b9$export$b65392d958998255; });
$parcel$export($a0933ef57ff1c2b9$exports, "maximumBy", function () { return $a0933ef57ff1c2b9$export$c42fa06aba2a552c; });
$parcel$export($a0933ef57ff1c2b9$exports, "uniq", function () { return $a0933ef57ff1c2b9$export$f70730c3d1fc524e; });
$parcel$export($a0933ef57ff1c2b9$exports, "filterthese", function () { return $a0933ef57ff1c2b9$export$829d143888d75f2a; });
$parcel$export($a0933ef57ff1c2b9$exports, "yesorno", function () { return $a0933ef57ff1c2b9$export$a0aab0b679927e4d; });
$parcel$export($a0933ef57ff1c2b9$exports, "usandthem", function () { return $a0933ef57ff1c2b9$export$7fff46e75e637d73; });
$parcel$export($a0933ef57ff1c2b9$exports, "ends", function () { return $a0933ef57ff1c2b9$export$2bf2d3a3b8f5f2c5; });
$parcel$export($a0933ef57ff1c2b9$exports, "set_modify", function () { return $a0933ef57ff1c2b9$export$cc169e0ad6247842; });
$parcel$export($a0933ef57ff1c2b9$exports, "drop_adjacent_equal", function () { return $a0933ef57ff1c2b9$export$8c9375ca799b720c; });
$parcel$export($a0933ef57ff1c2b9$exports, "UnionFind", function () { return $a0933ef57ff1c2b9$export$bc3b6d8d31aa9744; });
$parcel$export($a0933ef57ff1c2b9$exports, "Renumber", function () { return $a0933ef57ff1c2b9$export$4b1ceda60dba9c5a; });
$parcel$export($a0933ef57ff1c2b9$exports, "PolyUnionFind", function () { return $a0933ef57ff1c2b9$export$6b13ca446b1d0fd3; });
$parcel$export($a0933ef57ff1c2b9$exports, "guard", function () { return $a0933ef57ff1c2b9$export$864d727b48066337; });
$parcel$export($a0933ef57ff1c2b9$exports, "Counter", function () { return $a0933ef57ff1c2b9$export$1b74141c5fe63a28; });
$parcel$export($a0933ef57ff1c2b9$exports, "splice", function () { return $a0933ef57ff1c2b9$export$869882364835d202; });
$parcel$export($a0933ef57ff1c2b9$exports, "throws", function () { return $a0933ef57ff1c2b9$export$b784e1159c889d6b; });
$parcel$export($a0933ef57ff1c2b9$exports, "unique_check", function () { return $a0933ef57ff1c2b9$export$6be1a247e0437315; });
$parcel$export($a0933ef57ff1c2b9$exports, "count", function () { return $a0933ef57ff1c2b9$export$85b9a36db797e02b; });
$parcel$export($a0933ef57ff1c2b9$exports, "raise", function () { return $a0933ef57ff1c2b9$export$66313c302b2ea154; });
$parcel$export($a0933ef57ff1c2b9$exports, "overlaps", function () { return $a0933ef57ff1c2b9$export$d921bb9ade5a90ff; });
$parcel$export($a0933ef57ff1c2b9$exports, "rearrange", function () { return $a0933ef57ff1c2b9$export$3286e37e80af903; });
$parcel$export($a0933ef57ff1c2b9$exports, "range", function () { return $a0933ef57ff1c2b9$export$d02631cccf789723; });
$parcel$export($a0933ef57ff1c2b9$exports, "fromTo", function () { return $a0933ef57ff1c2b9$export$ed3047ae95eb9b2b; });
$parcel$export($a0933ef57ff1c2b9$exports, "next_id", function () { return $a0933ef57ff1c2b9$export$42ac17aabdaccaaf; });
$parcel$export($a0933ef57ff1c2b9$exports, "absurd", function () { return $a0933ef57ff1c2b9$export$f172309911142386; });
$parcel$export($a0933ef57ff1c2b9$exports, "array_store_key", function () { return $a0933ef57ff1c2b9$export$58f44b650c4cecce; });
$parcel$export($a0933ef57ff1c2b9$exports, "array_store", function () { return $a0933ef57ff1c2b9$export$add972cb5ef3dec; });
$parcel$export($a0933ef57ff1c2b9$exports, "fromPairs", function () { return $a0933ef57ff1c2b9$export$8995636b7242f090; });
$parcel$export($a0933ef57ff1c2b9$exports, "store_join", function () { return $a0933ef57ff1c2b9$export$de1af2a0ca9899b4; });
$parcel$export($a0933ef57ff1c2b9$exports, "request", function () { return $a0933ef57ff1c2b9$export$b5fe3f66a567bec0; });
$parcel$export($a0933ef57ff1c2b9$exports, "POST", function () { return $a0933ef57ff1c2b9$export$484f3009c2ee32ad; });
$parcel$export($a0933ef57ff1c2b9$exports, "get_cookie", function () { return $a0933ef57ff1c2b9$export$622991c71a1f52b3; });
$parcel$export($a0933ef57ff1c2b9$exports, "GET", function () { return $a0933ef57ff1c2b9$export$1bb358554aac31c1; });
$parcel$export($a0933ef57ff1c2b9$exports, "debounce", function () { return $a0933ef57ff1c2b9$export$61fc7d43ac8f84b0; });
$parcel$export($a0933ef57ff1c2b9$exports, "fix", function () { return $a0933ef57ff1c2b9$export$d838837eb5b184e3; });
$parcel$export($a0933ef57ff1c2b9$exports, "cartesian", function () { return $a0933ef57ff1c2b9$export$6e6697ef026a96; });
$parcel$export($a0933ef57ff1c2b9$exports, "upper_triangular", function () { return $a0933ef57ff1c2b9$export$8075fec7d7cec517; });
$parcel$export($a0933ef57ff1c2b9$exports, "merge_series", function () { return $a0933ef57ff1c2b9$export$77d92587fe11873; });
$parcel$export($a0933ef57ff1c2b9$exports, "zipWithPrevious", function () { return $a0933ef57ff1c2b9$export$bd7c999bdb8c7605; });
$parcel$export($a0933ef57ff1c2b9$exports, "KV", function () { return $a0933ef57ff1c2b9$export$916430c3578a176d; });
$parcel$export($a0933ef57ff1c2b9$exports, "snoc", function () { return $a0933ef57ff1c2b9$export$c40cf5aab899f397; });
$parcel$export($a0933ef57ff1c2b9$exports, "snocs", function () { return $a0933ef57ff1c2b9$export$cf6c2c83d6c223e; });
$parcel$export($a0933ef57ff1c2b9$exports, "snocsToArray", function () { return $a0933ef57ff1c2b9$export$9c5cd851e3a05d4a; });
$parcel$export($a0933ef57ff1c2b9$exports, "expr", function () { return $a0933ef57ff1c2b9$export$dce8637ca0d755f; });
$parcel$export($a0933ef57ff1c2b9$exports, "chain", function () { return $a0933ef57ff1c2b9$export$e08e3b67e392101e; });
$parcel$export($a0933ef57ff1c2b9$exports, "push", function () { return $a0933ef57ff1c2b9$export$4cbf152802aa238; });
$parcel$export($a0933ef57ff1c2b9$exports, "setIfChanged", function () { return $a0933ef57ff1c2b9$export$9be1301193883bb5; });
$parcel$export($a0933ef57ff1c2b9$exports, "edit_range", function () { return $a0933ef57ff1c2b9$export$5160ab928f687bd; });
$parcel$export($a0933ef57ff1c2b9$exports, "within", function () { return $a0933ef57ff1c2b9$export$f28d906d67a997f3; });
$parcel$export($a0933ef57ff1c2b9$exports, "findLastIndex", function () { return $a0933ef57ff1c2b9$export$8855a8be7bd3e9f8; });
$parcel$export($a0933ef57ff1c2b9$exports, "timeit", function () { return $a0933ef57ff1c2b9$export$d6ed4c2f46abc031; });
$parcel$export($a0933ef57ff1c2b9$exports, "getUnsafe", function () { return $a0933ef57ff1c2b9$export$df91a094d1ff523d; });
$parcel$export($a0933ef57ff1c2b9$exports, "any", function () { return $a0933ef57ff1c2b9$export$4154a199d7d90455; });
$parcel$export($a0933ef57ff1c2b9$exports, "scrollIntoView", function () { return $a0933ef57ff1c2b9$export$53a0910f038337bd; });
function $d9d0435d2b879de6$export$185802fd694ee1f5(ks, f) {
    const obj = {};
    ks.forEach((k, i)=>obj[k] = f(k, i));
    return obj;
}
function $d9d0435d2b879de6$export$2cd8252107eb640b(kvs) {
    const obj = {};
    kvs.forEach(({ k: k, v: v })=>obj[k] = v);
    return obj;
}
function $d9d0435d2b879de6$export$346677f925de839c(x) {
    return Object.keys(x).length;
}
function $d9d0435d2b879de6$export$bffa455ba8c619a6(oss) {
    const obj = {};
    oss.forEach((os)=>$d9d0435d2b879de6$export$4b80e395e36b5a56(os, (v, k)=>obj[k] = v));
    return obj;
}
function $d9d0435d2b879de6$export$4b80e395e36b5a56(x, k) {
    Object.keys(x).forEach((id)=>k(x[id], id));
}
function $d9d0435d2b879de6$export$df3f009e3d155b20(x, k, sort_keys = false) {
    const ks = Object.keys(x);
    if (sort_keys) ks.sort();
    return ks.map((id)=>k(x[id], id));
}
function $d9d0435d2b879de6$export$871de8747c9eaa88(x, k) {
    const out = {};
    $d9d0435d2b879de6$export$4b80e395e36b5a56(x, (a, id)=>out[id] = k(a, id));
    return out;
}
function $d9d0435d2b879de6$export$3dea766d36a8935f(x, k) {
    const out = {};
    $d9d0435d2b879de6$export$4b80e395e36b5a56(x, (a, id)=>k(a, id) && (out[id] = a));
    return out;
}
function $d9d0435d2b879de6$export$dfc7155ac0343b8(x, k, def) {
    return x[k] || def;
}
function $d9d0435d2b879de6$export$3ff57735a52b8713(x, k, def, f) {
    return x[k] = f(x[k] || def);
}
function $d9d0435d2b879de6$export$44e922edf8a1f41a(x, v) {
    return $d9d0435d2b879de6$export$df3f009e3d155b20($d9d0435d2b879de6$export$3dea766d36a8935f(x, (v2)=>v == v2), (v, k)=>k)[0];
}
function $d9d0435d2b879de6$export$e9bab7fafb253603(a, b) {
    try {
        $d9d0435d2b879de6$export$4b80e395e36b5a56(a, (v, k)=>{
            if (b[k] !== v) throw new Error();
        });
        $d9d0435d2b879de6$export$4b80e395e36b5a56(b, (v, k)=>{
            if (a[k] !== v) throw new Error();
        });
    } catch (e) {
        return false;
    }
    return true;
}




var $3e08936831d1dd3a$exports = {};
/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */ /**
 * Class containing the diff, match and patch methods.
 * @constructor
 */ function $3e08936831d1dd3a$var$diff_match_patch() {
    // Defaults.
    // Redefine these in your program to override the defaults.
    // Number of seconds to map a diff before giving up (0 for infinity).
    this.Diff_Timeout = 1.0;
    // Cost of an empty edit operation in terms of edit characters.
    this.Diff_EditCost = 4;
    // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
    this.Match_Threshold = 0.5;
    // How far to search for a match (0 = exact location, 1000+ = broad match).
    // A match this many characters away from the expected location will add
    // 1.0 to the score (0.0 is a perfect match).
    this.Match_Distance = 1000;
    // When deleting a large block of text (over ~64 characters), how close do
    // the contents have to be to match the expected contents. (0.0 = perfection,
    // 1.0 = very loose).  Note that Match_Threshold controls how closely the
    // end points of a delete need to match.
    this.Patch_DeleteThreshold = 0.5;
    // Chunk size for context length.
    this.Patch_Margin = 4;
    // The number of bits in an int.
    this.Match_MaxBits = 32;
}
//  DIFF FUNCTIONS
/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $3e08936831d1dd3a$var$DIFF_DELETE = -1;
var $3e08936831d1dd3a$var$DIFF_INSERT = 1;
var $3e08936831d1dd3a$var$DIFF_EQUAL = 0;
/** @typedef {{0: number, 1: string}} */ $3e08936831d1dd3a$var$diff_match_patch.Diff;
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_main = function(text1, text2, opt_checklines, opt_deadline) {
    // Set a deadline by which time the diff must be complete.
    if (typeof opt_deadline == "undefined") {
        if (this.Diff_Timeout <= 0) opt_deadline = Number.MAX_VALUE;
        else opt_deadline = (new Date).getTime() + this.Diff_Timeout * 1000;
    }
    var deadline = opt_deadline;
    // Check for null inputs.
    if (text1 == null || text2 == null) throw new Error("Null input. (diff_main)");
    // Check for equality (speedup).
    if (text1 == text2) {
        if (text1) return [
            [
                $3e08936831d1dd3a$var$DIFF_EQUAL,
                text1
            ]
        ];
        return [];
    }
    if (typeof opt_checklines == "undefined") opt_checklines = true;
    var checklines = opt_checklines;
    // Trim off common prefix (speedup).
    var commonlength = this.diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = this.diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = this.diff_compute_(text1, text2, checklines, deadline);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift([
        $3e08936831d1dd3a$var$DIFF_EQUAL,
        commonprefix
    ]);
    if (commonsuffix) diffs.push([
        $3e08936831d1dd3a$var$DIFF_EQUAL,
        commonsuffix
    ]);
    this.diff_cleanupMerge(diffs);
    return diffs;
};
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_compute_ = function(text1, text2, checklines, deadline) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        [
            $3e08936831d1dd3a$var$DIFF_INSERT,
            text2
        ]
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        [
            $3e08936831d1dd3a$var$DIFF_DELETE,
            text1
        ]
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i != -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            [
                $3e08936831d1dd3a$var$DIFF_INSERT,
                longtext.substring(0, i)
            ],
            [
                $3e08936831d1dd3a$var$DIFF_EQUAL,
                shorttext
            ],
            [
                $3e08936831d1dd3a$var$DIFF_INSERT,
                longtext.substring(i + shorttext.length)
            ]
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $3e08936831d1dd3a$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length == 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        [
            $3e08936831d1dd3a$var$DIFF_DELETE,
            text1
        ],
        [
            $3e08936831d1dd3a$var$DIFF_INSERT,
            text2
        ]
    ];
    // Check to see if the problem can be split in two.
    var hm = this.diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
        var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
        // Merge the results.
        return diffs_a.concat([
            [
                $3e08936831d1dd3a$var$DIFF_EQUAL,
                mid_common
            ]
        ], diffs_b);
    }
    if (checklines && text1.length > 100 && text2.length > 100) return this.diff_lineMode_(text1, text2, deadline);
    return this.diff_bisect_(text1, text2, deadline);
};
/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_lineMode_ = function(text1, text2, deadline) {
    // Scan the text on a line-by-line basis first.
    var a = this.diff_linesToChars_(text1, text2);
    text1 = a.chars1;
    text2 = a.chars2;
    var linearray = a.lineArray;
    var diffs = this.diff_main(text1, text2, false, deadline);
    // Convert the diff back to original text.
    this.diff_charsToLines_(diffs, linearray);
    // Eliminate freak matches (e.g. blank lines)
    this.diff_cleanupSemantic(diffs);
    // Rediff any replacement blocks, this time character-by-character.
    // Add a dummy entry at the end.
    diffs.push([
        $3e08936831d1dd3a$var$DIFF_EQUAL,
        ""
    ]);
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    while(pointer < diffs.length){
        switch(diffs[pointer][0]){
            case $3e08936831d1dd3a$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                break;
            case $3e08936831d1dd3a$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                break;
            case $3e08936831d1dd3a$var$DIFF_EQUAL:
                // Upon reaching an equality, check for prior redundancies.
                if (count_delete >= 1 && count_insert >= 1) {
                    // Delete the offending records and add the merged ones.
                    diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
                    pointer = pointer - count_delete - count_insert;
                    var a = this.diff_main(text_delete, text_insert, false, deadline);
                    for(var j = a.length - 1; j >= 0; j--)diffs.splice(pointer, 0, a[j]);
                    pointer = pointer + a.length;
                }
                count_insert = 0;
                count_delete = 0;
                text_delete = "";
                text_insert = "";
                break;
        }
        pointer++;
    }
    diffs.pop(); // Remove the dummy entry at the end.
    return diffs;
};
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_bisect_ = function(text1, text2, deadline) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 != 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Bail out if deadline is reached.
        if (new Date().getTime() > deadline) break;
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        [
            $3e08936831d1dd3a$var$DIFF_DELETE,
            text1
        ],
        [
            $3e08936831d1dd3a$var$DIFF_INSERT,
            text2
        ]
    ];
};
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_bisectSplit_ = function(text1, text2, x, y, deadline) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = this.diff_main(text1a, text2a, false, deadline);
    var diffsb = this.diff_main(text1b, text2b, false, deadline);
    return diffs.concat(diffsb);
};
/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_linesToChars_ = function(text1, text2) {
    var lineArray = []; // e.g. lineArray[4] == 'Hello\n'
    var lineHash = {}; // e.g. lineHash['Hello\n'] == 4
    // '\x00' is a valid character, but various debuggers don't like it.
    // So we'll insert a junk entry to avoid generating a null character.
    lineArray[0] = "";
    /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */ function diff_linesToCharsMunge_(text) {
        var chars = "";
        // Walk the text, pulling out a substring for each line.
        // text.split('\n') would would temporarily double our memory footprint.
        // Modifying text would create many large strings to garbage collect.
        var lineStart = 0;
        var lineEnd = -1;
        // Keeping our own length variable is faster than looking it up.
        var lineArrayLength = lineArray.length;
        while(lineEnd < text.length - 1){
            lineEnd = text.indexOf("\n", lineStart);
            if (lineEnd == -1) lineEnd = text.length - 1;
            var line = text.substring(lineStart, lineEnd + 1);
            lineStart = lineEnd + 1;
            if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
            else {
                chars += String.fromCharCode(lineArrayLength);
                lineHash[line] = lineArrayLength;
                lineArray[lineArrayLength++] = line;
            }
        }
        return chars;
    }
    var chars1 = diff_linesToCharsMunge_(text1);
    var chars2 = diff_linesToCharsMunge_(text2);
    return {
        chars1: chars1,
        chars2: chars2,
        lineArray: lineArray
    };
};
/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_charsToLines_ = function(diffs, lineArray) {
    for(var x = 0; x < diffs.length; x++){
        var chars = diffs[x][1];
        var text = [];
        for(var y = 0; y < chars.length; y++)text[y] = lineArray[chars.charCodeAt(y)];
        diffs[x][1] = text.join("");
    }
};
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_commonPrefix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_commonSuffix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
    // Binary search.
    // Performance analysis: http://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_commonOverlap_ = function(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: http://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
};
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_halfMatch_ = function(text1, text2) {
    if (this.Diff_Timeout <= 0) // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = "";
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) != -1){
            var prefixLength = dmp.diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
};
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_cleanupSemantic = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $3e08936831d1dd3a$var$DIFF_EQUAL) {
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastequality = diffs[pointer][1];
        } else {
            if (diffs[pointer][0] == $3e08936831d1dd3a$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastequality && lastequality.length <= Math.max(length_insertions1, length_deletions1) && lastequality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $3e08936831d1dd3a$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $3e08936831d1dd3a$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastequality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) this.diff_cleanupMerge(diffs);
    this.diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $3e08936831d1dd3a$var$DIFF_DELETE && diffs[pointer][0] == $3e08936831d1dd3a$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, [
                        $3e08936831d1dd3a$var$DIFF_EQUAL,
                        insertion.substring(0, overlap_length1)
                    ]);
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, [
                    $3e08936831d1dd3a$var$DIFF_EQUAL,
                    deletion.substring(0, overlap_length2)
                ]);
                diffs[pointer - 1][0] = $3e08936831d1dd3a$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $3e08936831d1dd3a$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
};
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_cleanupSemanticLossless = function(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($3e08936831d1dd3a$var$diff_match_patch.nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($3e08936831d1dd3a$var$diff_match_patch.nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($3e08936831d1dd3a$var$diff_match_patch.whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($3e08936831d1dd3a$var$diff_match_patch.whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($3e08936831d1dd3a$var$diff_match_patch.linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($3e08936831d1dd3a$var$diff_match_patch.linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($3e08936831d1dd3a$var$diff_match_patch.blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($3e08936831d1dd3a$var$diff_match_patch.blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $3e08936831d1dd3a$var$DIFF_EQUAL && diffs[pointer + 1][0] == $3e08936831d1dd3a$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = this.diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
};
// Define some regex patterns for matching boundaries.
$3e08936831d1dd3a$var$diff_match_patch.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
$3e08936831d1dd3a$var$diff_match_patch.whitespaceRegex_ = /\s/;
$3e08936831d1dd3a$var$diff_match_patch.linebreakRegex_ = /[\r\n]/;
$3e08936831d1dd3a$var$diff_match_patch.blanklineEndRegex_ = /\n\r?\n$/;
$3e08936831d1dd3a$var$diff_match_patch.blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_cleanupEfficiency = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastequality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Is there an insertion operation before the last equality.
    var pre_ins = false;
    // Is there a deletion operation before the last equality.
    var pre_del = false;
    // Is there an insertion operation after the last equality.
    var post_ins = false;
    // Is there a deletion operation after the last equality.
    var post_del = false;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $3e08936831d1dd3a$var$DIFF_EQUAL) {
            if (diffs[pointer][1].length < this.Diff_EditCost && (post_ins || post_del)) {
                // Candidate found.
                equalities[equalitiesLength++] = pointer;
                pre_ins = post_ins;
                pre_del = post_del;
                lastequality = diffs[pointer][1];
            } else {
                // Not a candidate, and can never become one.
                equalitiesLength = 0;
                lastequality = null;
            }
            post_ins = post_del = false;
        } else {
            if (diffs[pointer][0] == $3e08936831d1dd3a$var$DIFF_DELETE) post_del = true;
            else post_ins = true;
            /*
       * Five types to be split:
       * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
       * <ins>A</ins>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<ins>C</ins>
       * <ins>A</del>X<ins>C</ins><del>D</del>
       * <ins>A</ins><del>B</del>X<del>C</del>
       */ if (lastequality && (pre_ins && pre_del && post_ins && post_del || lastequality.length < this.Diff_EditCost / 2 && pre_ins + pre_del + post_ins + post_del == 3)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, [
                    $3e08936831d1dd3a$var$DIFF_DELETE,
                    lastequality
                ]);
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $3e08936831d1dd3a$var$DIFF_INSERT;
                equalitiesLength--; // Throw away the equality we just deleted;
                lastequality = null;
                if (pre_ins && pre_del) {
                    // No changes made which could affect previous entry, keep going.
                    post_ins = post_del = true;
                    equalitiesLength = 0;
                } else {
                    equalitiesLength--; // Throw away the previous equality.
                    pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                    post_ins = post_del = false;
                }
                changes = true;
            }
        }
        pointer++;
    }
    if (changes) this.diff_cleanupMerge(diffs);
};
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_cleanupMerge = function(diffs) {
    diffs.push([
        $3e08936831d1dd3a$var$DIFF_EQUAL,
        ""
    ]); // Add a dummy entry at the end.
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = "";
    var text_insert = "";
    var commonlength;
    while(pointer < diffs.length)switch(diffs[pointer][0]){
        case $3e08936831d1dd3a$var$DIFF_INSERT:
            count_insert++;
            text_insert += diffs[pointer][1];
            pointer++;
            break;
        case $3e08936831d1dd3a$var$DIFF_DELETE:
            count_delete++;
            text_delete += diffs[pointer][1];
            pointer++;
            break;
        case $3e08936831d1dd3a$var$DIFF_EQUAL:
            // Upon reaching an equality, check for prior redundancies.
            if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                    // Factor out any common prefixies.
                    commonlength = this.diff_commonPrefix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == $3e08936831d1dd3a$var$DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                        else {
                            diffs.splice(0, 0, [
                                $3e08936831d1dd3a$var$DIFF_EQUAL,
                                text_insert.substring(0, commonlength)
                            ]);
                            pointer++;
                        }
                        text_insert = text_insert.substring(commonlength);
                        text_delete = text_delete.substring(commonlength);
                    }
                    // Factor out any common suffixies.
                    commonlength = this.diff_commonSuffix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                        text_insert = text_insert.substring(0, text_insert.length - commonlength);
                        text_delete = text_delete.substring(0, text_delete.length - commonlength);
                    }
                }
                // Delete the offending records and add the merged ones.
                if (count_delete === 0) diffs.splice(pointer - count_insert, count_delete + count_insert, [
                    $3e08936831d1dd3a$var$DIFF_INSERT,
                    text_insert
                ]);
                else if (count_insert === 0) diffs.splice(pointer - count_delete, count_delete + count_insert, [
                    $3e08936831d1dd3a$var$DIFF_DELETE,
                    text_delete
                ]);
                else diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [
                    $3e08936831d1dd3a$var$DIFF_DELETE,
                    text_delete
                ], [
                    $3e08936831d1dd3a$var$DIFF_INSERT,
                    text_insert
                ]);
                pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
            } else if (pointer !== 0 && diffs[pointer - 1][0] == $3e08936831d1dd3a$var$DIFF_EQUAL) {
                // Merge this equality with the previous one.
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
            } else pointer++;
            count_insert = 0;
            count_delete = 0;
            text_delete = "";
            text_insert = "";
            break;
    }
    if (diffs[diffs.length - 1][1] === "") diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $3e08936831d1dd3a$var$DIFF_EQUAL && diffs[pointer + 1][0] == $3e08936831d1dd3a$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) this.diff_cleanupMerge(diffs);
};
/**
 * loc is a location in text1, compute and return the equivalent location in
 * text2.
 * e.g. 'The cat' vs 'The big cat', 1->1, 5->8
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {number} loc Location within text1.
 * @return {number} Location within text2.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_xIndex = function(diffs, loc) {
    var chars1 = 0;
    var chars2 = 0;
    var last_chars1 = 0;
    var last_chars2 = 0;
    var x;
    for(x = 0; x < diffs.length; x++){
        if (diffs[x][0] !== $3e08936831d1dd3a$var$DIFF_INSERT) chars1 += diffs[x][1].length;
        if (diffs[x][0] !== $3e08936831d1dd3a$var$DIFF_DELETE) chars2 += diffs[x][1].length;
        if (chars1 > loc) break;
        last_chars1 = chars1;
        last_chars2 = chars2;
    }
    // Was the location was deleted?
    if (diffs.length != x && diffs[x][0] === $3e08936831d1dd3a$var$DIFF_DELETE) return last_chars2;
    // Add the remaining character length.
    return last_chars2 + (loc - last_chars1);
};
/**
 * Convert a diff array into a pretty HTML report.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} HTML representation.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_prettyHtml = function(diffs) {
    var html = [];
    var pattern_amp = /&/g;
    var pattern_lt = /</g;
    var pattern_gt = />/g;
    var pattern_para = /\n/g;
    for(var x = 0; x < diffs.length; x++){
        var op = diffs[x][0]; // Operation (insert, delete, equal)
        var data = diffs[x][1]; // Text of change.
        var text = data.replace(pattern_amp, "&amp;").replace(pattern_lt, "&lt;").replace(pattern_gt, "&gt;").replace(pattern_para, "&para;<br>");
        switch(op){
            case $3e08936831d1dd3a$var$DIFF_INSERT:
                html[x] = '<ins style="background:#e6ffe6;">' + text + "</ins>";
                break;
            case $3e08936831d1dd3a$var$DIFF_DELETE:
                html[x] = '<del style="background:#ffe6e6;">' + text + "</del>";
                break;
            case $3e08936831d1dd3a$var$DIFF_EQUAL:
                html[x] = "<span>" + text + "</span>";
                break;
        }
    }
    return html.join("");
};
/**
 * Compute and return the source text (all equalities and deletions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Source text.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_text1 = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== $3e08936831d1dd3a$var$DIFF_INSERT) text[x] = diffs[x][1];
    return text.join("");
};
/**
 * Compute and return the destination text (all equalities and insertions).
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Destination text.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_text2 = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)if (diffs[x][0] !== $3e08936831d1dd3a$var$DIFF_DELETE) text[x] = diffs[x][1];
    return text.join("");
};
/**
 * Compute the Levenshtein distance; the number of inserted, deleted or
 * substituted characters.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {number} Number of changes.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_levenshtein = function(diffs) {
    var levenshtein = 0;
    var insertions = 0;
    var deletions = 0;
    for(var x = 0; x < diffs.length; x++){
        var op = diffs[x][0];
        var data = diffs[x][1];
        switch(op){
            case $3e08936831d1dd3a$var$DIFF_INSERT:
                insertions += data.length;
                break;
            case $3e08936831d1dd3a$var$DIFF_DELETE:
                deletions += data.length;
                break;
            case $3e08936831d1dd3a$var$DIFF_EQUAL:
                // A deletion and an insertion is one substitution.
                levenshtein += Math.max(insertions, deletions);
                insertions = 0;
                deletions = 0;
                break;
        }
    }
    levenshtein += Math.max(insertions, deletions);
    return levenshtein;
};
/**
 * Crush the diff into an encoded string which describes the operations
 * required to transform text1 into text2.
 * E.g. =3\t-2\t+ing  -> Keep 3 chars, delete 2 chars, insert 'ing'.
 * Operations are tab-separated.  Inserted text is escaped using %xx notation.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @return {string} Delta text.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_toDelta = function(diffs) {
    var text = [];
    for(var x = 0; x < diffs.length; x++)switch(diffs[x][0]){
        case $3e08936831d1dd3a$var$DIFF_INSERT:
            text[x] = "+" + encodeURI(diffs[x][1]);
            break;
        case $3e08936831d1dd3a$var$DIFF_DELETE:
            text[x] = "-" + diffs[x][1].length;
            break;
        case $3e08936831d1dd3a$var$DIFF_EQUAL:
            text[x] = "=" + diffs[x][1].length;
            break;
    }
    return text.join("	").replace(/%20/g, " ");
};
/**
 * Given the original text1, and an encoded string which describes the
 * operations required to transform text1 into text2, compute the full diff.
 * @param {string} text1 Source string for the diff.
 * @param {string} delta Delta text.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @throws {!Error} If invalid input.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.diff_fromDelta = function(text1, delta) {
    var diffs = [];
    var diffsLength = 0; // Keeping our own length var is faster in JS.
    var pointer = 0; // Cursor in text1
    var tokens = delta.split(/\t/g);
    for(var x = 0; x < tokens.length; x++){
        // Each token begins with a one character parameter which specifies the
        // operation of this token (delete, insert, equality).
        var param = tokens[x].substring(1);
        switch(tokens[x].charAt(0)){
            case "+":
                try {
                    diffs[diffsLength++] = [
                        $3e08936831d1dd3a$var$DIFF_INSERT,
                        decodeURI(param)
                    ];
                } catch (ex) {
                    // Malformed URI sequence.
                    throw new Error("Illegal escape in diff_fromDelta: " + param);
                }
                break;
            case "-":
            // Fall through.
            case "=":
                var n = parseInt(param, 10);
                if (isNaN(n) || n < 0) throw new Error("Invalid number in diff_fromDelta: " + param);
                var text = text1.substring(pointer, pointer += n);
                if (tokens[x].charAt(0) == "=") diffs[diffsLength++] = [
                    $3e08936831d1dd3a$var$DIFF_EQUAL,
                    text
                ];
                else diffs[diffsLength++] = [
                    $3e08936831d1dd3a$var$DIFF_DELETE,
                    text
                ];
                break;
            default:
                // Blank tokens are ok (from a trailing \t).
                // Anything else is an error.
                if (tokens[x]) throw new Error("Invalid diff operation in diff_fromDelta: " + tokens[x]);
        }
    }
    if (pointer != text1.length) throw new Error("Delta length (" + pointer + ") does not equal source text length (" + text1.length + ").");
    return diffs;
};
//  MATCH FUNCTIONS
/**
 * Locate the best instance of 'pattern' in 'text' near 'loc'.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.match_main = function(text, pattern, loc) {
    // Check for null inputs.
    if (text == null || pattern == null || loc == null) throw new Error("Null input. (match_main)");
    loc = Math.max(0, Math.min(loc, text.length));
    if (text == pattern) // Shortcut (potentially not guaranteed by the algorithm)
    return 0;
    else if (!text.length) // Nothing to match.
    return -1;
    else if (text.substring(loc, loc + pattern.length) == pattern) // Perfect match at the perfect spot!  (Includes case of null pattern)
    return loc;
    else // Do a fuzzy compare.
    return this.match_bitap_(text, pattern, loc);
};
/**
 * Locate the best instance of 'pattern' in 'text' near 'loc' using the
 * Bitap algorithm.
 * @param {string} text The text to search.
 * @param {string} pattern The pattern to search for.
 * @param {number} loc The location to search around.
 * @return {number} Best match index or -1.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.match_bitap_ = function(text, pattern, loc) {
    if (pattern.length > this.Match_MaxBits) throw new Error("Pattern too long for this browser.");
    // Initialise the alphabet.
    var s = this.match_alphabet_(pattern);
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Compute and return the score for a match with e errors and x location.
   * Accesses loc and pattern through being a closure.
   * @param {number} e Number of errors in match.
   * @param {number} x Location of match.
   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
   * @private
   */ function match_bitapScore_(e, x) {
        var accuracy = e / pattern.length;
        var proximity = Math.abs(loc - x);
        if (!dmp.Match_Distance) // Dodge divide by zero error.
        return proximity ? 1.0 : accuracy;
        return accuracy + proximity / dmp.Match_Distance;
    }
    // Highest score beyond which we give up.
    var score_threshold = this.Match_Threshold;
    // Is there a nearby exact match? (speedup)
    var best_loc = text.indexOf(pattern, loc);
    if (best_loc != -1) {
        score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
        // What about in the other direction? (speedup)
        best_loc = text.lastIndexOf(pattern, loc + pattern.length);
        if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
    }
    // Initialise the bit arrays.
    var matchmask = 1 << pattern.length - 1;
    best_loc = -1;
    var bin_min, bin_mid;
    var bin_max = pattern.length + text.length;
    var last_rd;
    for(var d = 0; d < pattern.length; d++){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from 'loc' we can stray at this
        // error level.
        bin_min = 0;
        bin_mid = bin_max;
        while(bin_min < bin_mid){
            if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
            else bin_max = bin_mid;
            bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
        }
        // Use the result from this iteration as the maximum for the next.
        bin_max = bin_mid;
        var start = Math.max(1, loc - bin_mid + 1);
        var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
        var rd = Array(finish + 2);
        rd[finish + 1] = (1 << d) - 1;
        for(var j = finish; j >= start; j--){
            // The alphabet (s) is a sparse hash, so the following line generates
            // warnings.
            var charMatch = s[text.charAt(j - 1)];
            if (d === 0) rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
            else rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
            if (rd[j] & matchmask) {
                var score = match_bitapScore_(d, j - 1);
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (score <= score_threshold) {
                    // Told you so.
                    score_threshold = score;
                    best_loc = j - 1;
                    if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                    start = Math.max(1, 2 * loc - best_loc);
                    else break;
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        if (match_bitapScore_(d + 1, loc) > score_threshold) break;
        last_rd = rd;
    }
    return best_loc;
};
/**
 * Initialise the alphabet for the Bitap algorithm.
 * @param {string} pattern The text to encode.
 * @return {!Object} Hash of character locations.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.match_alphabet_ = function(pattern) {
    var s = {};
    for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] = 0;
    for(var i = 0; i < pattern.length; i++)s[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
    return s;
};
//  PATCH FUNCTIONS
/**
 * Increase the context until it is unique,
 * but don't let the pattern expand beyond Match_MaxBits.
 * @param {!diff_match_patch.patch_obj} patch The patch to grow.
 * @param {string} text Source text.
 * @private
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_addContext_ = function(patch, text) {
    if (text.length == 0) return;
    var pattern = text.substring(patch.start2, patch.start2 + patch.length1);
    var padding = 0;
    // Look for the first and last matches of pattern in text.  If two different
    // matches are found, increase the pattern length.
    while(text.indexOf(pattern) != text.lastIndexOf(pattern) && pattern.length < this.Match_MaxBits - this.Patch_Margin - this.Patch_Margin){
        padding += this.Patch_Margin;
        pattern = text.substring(patch.start2 - padding, patch.start2 + patch.length1 + padding);
    }
    // Add one chunk for good luck.
    padding += this.Patch_Margin;
    // Add the prefix.
    var prefix = text.substring(patch.start2 - padding, patch.start2);
    if (prefix) patch.diffs.unshift([
        $3e08936831d1dd3a$var$DIFF_EQUAL,
        prefix
    ]);
    // Add the suffix.
    var suffix = text.substring(patch.start2 + patch.length1, patch.start2 + patch.length1 + padding);
    if (suffix) patch.diffs.push([
        $3e08936831d1dd3a$var$DIFF_EQUAL,
        suffix
    ]);
    // Roll back the start points.
    patch.start1 -= prefix.length;
    patch.start2 -= prefix.length;
    // Extend the lengths.
    patch.length1 += prefix.length + suffix.length;
    patch.length2 += prefix.length + suffix.length;
};
/**
 * Compute a list of patches to turn text1 into text2.
 * Use diffs if provided, otherwise compute it ourselves.
 * There are four ways to call this function, depending on what data is
 * available to the caller:
 * Method 1:
 * a = text1, b = text2
 * Method 2:
 * a = diffs
 * Method 3 (optimal):
 * a = text1, b = diffs
 * Method 4 (deprecated, use method 3):
 * a = text1, b = text2, c = diffs
 *
 * @param {string|!Array.<!diff_match_patch.Diff>} a text1 (methods 1,3,4) or
 * Array of diff tuples for text1 to text2 (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_b text2 (methods 1,4) or
 * Array of diff tuples for text1 to text2 (method 3) or undefined (method 2).
 * @param {string|!Array.<!diff_match_patch.Diff>} opt_c Array of diff tuples
 * for text1 to text2 (method 4) or undefined (methods 1,2,3).
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_make = function(a, opt_b, opt_c) {
    var text1, diffs;
    if (typeof a == "string" && typeof opt_b == "string" && typeof opt_c == "undefined") {
        // Method 1: text1, text2
        // Compute diffs from text1 and text2.
        text1 = /** @type {string} */ a;
        diffs = this.diff_main(text1, /** @type {string} */ opt_b, true);
        if (diffs.length > 2) {
            this.diff_cleanupSemantic(diffs);
            this.diff_cleanupEfficiency(diffs);
        }
    } else if (a && typeof a == "object" && typeof opt_b == "undefined" && typeof opt_c == "undefined") {
        // Method 2: diffs
        // Compute text1 from diffs.
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ a;
        text1 = this.diff_text1(diffs);
    } else if (typeof a == "string" && opt_b && typeof opt_b == "object" && typeof opt_c == "undefined") {
        // Method 3: text1, diffs
        text1 = /** @type {string} */ a;
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_b;
    } else if (typeof a == "string" && typeof opt_b == "string" && opt_c && typeof opt_c == "object") {
        // Method 4: text1, text2, diffs
        // text2 is not used.
        text1 = /** @type {string} */ a;
        diffs = /** @type {!Array.<!diff_match_patch.Diff>} */ opt_c;
    } else throw new Error("Unknown call format to patch_make.");
    if (diffs.length === 0) return []; // Get rid of the null case.
    var patches = [];
    var patch = new $3e08936831d1dd3a$var$diff_match_patch.patch_obj();
    var patchDiffLength = 0; // Keeping our own length var is faster in JS.
    var char_count1 = 0; // Number of characters into the text1 string.
    var char_count2 = 0; // Number of characters into the text2 string.
    // Start with text1 (prepatch_text) and apply the diffs until we arrive at
    // text2 (postpatch_text).  We recreate the patches one by one to determine
    // context info.
    var prepatch_text = text1;
    var postpatch_text = text1;
    for(var x = 0; x < diffs.length; x++){
        var diff_type = diffs[x][0];
        var diff_text = diffs[x][1];
        if (!patchDiffLength && diff_type !== $3e08936831d1dd3a$var$DIFF_EQUAL) {
            // A new patch starts here.
            patch.start1 = char_count1;
            patch.start2 = char_count2;
        }
        switch(diff_type){
            case $3e08936831d1dd3a$var$DIFF_INSERT:
                patch.diffs[patchDiffLength++] = diffs[x];
                patch.length2 += diff_text.length;
                postpatch_text = postpatch_text.substring(0, char_count2) + diff_text + postpatch_text.substring(char_count2);
                break;
            case $3e08936831d1dd3a$var$DIFF_DELETE:
                patch.length1 += diff_text.length;
                patch.diffs[patchDiffLength++] = diffs[x];
                postpatch_text = postpatch_text.substring(0, char_count2) + postpatch_text.substring(char_count2 + diff_text.length);
                break;
            case $3e08936831d1dd3a$var$DIFF_EQUAL:
                if (diff_text.length <= 2 * this.Patch_Margin && patchDiffLength && diffs.length != x + 1) {
                    // Small equality inside a patch.
                    patch.diffs[patchDiffLength++] = diffs[x];
                    patch.length1 += diff_text.length;
                    patch.length2 += diff_text.length;
                } else if (diff_text.length >= 2 * this.Patch_Margin) // Time for a new patch.
                {
                    if (patchDiffLength) {
                        this.patch_addContext_(patch, prepatch_text);
                        patches.push(patch);
                        patch = new $3e08936831d1dd3a$var$diff_match_patch.patch_obj();
                        patchDiffLength = 0;
                        // Unlike Unidiff, our patch lists have a rolling context.
                        // http://code.google.com/p/google-diff-match-patch/wiki/Unidiff
                        // Update prepatch text & pos to reflect the application of the
                        // just completed patch.
                        prepatch_text = postpatch_text;
                        char_count1 = char_count2;
                    }
                }
                break;
        }
        // Update the current character count.
        if (diff_type !== $3e08936831d1dd3a$var$DIFF_INSERT) char_count1 += diff_text.length;
        if (diff_type !== $3e08936831d1dd3a$var$DIFF_DELETE) char_count2 += diff_text.length;
    }
    // Pick up the leftover patch if not empty.
    if (patchDiffLength) {
        this.patch_addContext_(patch, prepatch_text);
        patches.push(patch);
    }
    return patches;
};
/**
 * Given an array of patches, return another array that is identical.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_deepCopy = function(patches) {
    // Making deep copies is hard in JavaScript.
    var patchesCopy = [];
    for(var x = 0; x < patches.length; x++){
        var patch = patches[x];
        var patchCopy = new $3e08936831d1dd3a$var$diff_match_patch.patch_obj();
        patchCopy.diffs = [];
        for(var y = 0; y < patch.diffs.length; y++)patchCopy.diffs[y] = patch.diffs[y].slice();
        patchCopy.start1 = patch.start1;
        patchCopy.start2 = patch.start2;
        patchCopy.length1 = patch.length1;
        patchCopy.length2 = patch.length2;
        patchesCopy[x] = patchCopy;
    }
    return patchesCopy;
};
/**
 * Merge a set of patches onto the text.  Return a patched text, as well
 * as a list of true/false values indicating which patches were applied.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @param {string} text Old text.
 * @return {!Array.<string|!Array.<boolean>>} Two element Array, containing the
 *      new text and an array of boolean values.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_apply = function(patches, text) {
    if (patches.length == 0) return [
        text,
        []
    ];
    // Deep copy the patches so that no changes are made to originals.
    patches = this.patch_deepCopy(patches);
    var nullPadding = this.patch_addPadding(patches);
    text = nullPadding + text + nullPadding;
    this.patch_splitMax(patches);
    // delta keeps track of the offset between the expected and actual location
    // of the previous patch.  If there are patches expected at positions 10 and
    // 20, but the first patch was found at 12, delta is 2 and the second patch
    // has an effective expected position of 22.
    var delta = 0;
    var results = [];
    for(var x = 0; x < patches.length; x++){
        var expected_loc = patches[x].start2 + delta;
        var text1 = this.diff_text1(patches[x].diffs);
        var start_loc;
        var end_loc = -1;
        if (text1.length > this.Match_MaxBits) {
            // patch_splitMax will only provide an oversized pattern in the case of
            // a monster delete.
            start_loc = this.match_main(text, text1.substring(0, this.Match_MaxBits), expected_loc);
            if (start_loc != -1) {
                end_loc = this.match_main(text, text1.substring(text1.length - this.Match_MaxBits), expected_loc + text1.length - this.Match_MaxBits);
                if (end_loc == -1 || start_loc >= end_loc) // Can't find valid trailing context.  Drop this patch.
                start_loc = -1;
            }
        } else start_loc = this.match_main(text, text1, expected_loc);
        if (start_loc == -1) {
            // No match found.  :(
            results[x] = false;
            // Subtract the delta for this failed patch from subsequent patches.
            delta -= patches[x].length2 - patches[x].length1;
        } else {
            // Found a match.  :)
            results[x] = true;
            delta = start_loc - expected_loc;
            var text2;
            if (end_loc == -1) text2 = text.substring(start_loc, start_loc + text1.length);
            else text2 = text.substring(start_loc, end_loc + this.Match_MaxBits);
            if (text1 == text2) // Perfect match, just shove the replacement text in.
            text = text.substring(0, start_loc) + this.diff_text2(patches[x].diffs) + text.substring(start_loc + text1.length);
            else {
                // Imperfect match.  Run a diff to get a framework of equivalent
                // indices.
                var diffs = this.diff_main(text1, text2, false);
                if (text1.length > this.Match_MaxBits && this.diff_levenshtein(diffs) / text1.length > this.Patch_DeleteThreshold) // The end points match, but the content is unacceptably bad.
                results[x] = false;
                else {
                    this.diff_cleanupSemanticLossless(diffs);
                    var index1 = 0;
                    var index2;
                    for(var y = 0; y < patches[x].diffs.length; y++){
                        var mod = patches[x].diffs[y];
                        if (mod[0] !== $3e08936831d1dd3a$var$DIFF_EQUAL) index2 = this.diff_xIndex(diffs, index1);
                        if (mod[0] === $3e08936831d1dd3a$var$DIFF_INSERT) text = text.substring(0, start_loc + index2) + mod[1] + text.substring(start_loc + index2);
                        else if (mod[0] === $3e08936831d1dd3a$var$DIFF_DELETE) text = text.substring(0, start_loc + index2) + text.substring(start_loc + this.diff_xIndex(diffs, index1 + mod[1].length));
                        if (mod[0] !== $3e08936831d1dd3a$var$DIFF_DELETE) index1 += mod[1].length;
                    }
                }
            }
        }
    }
    // Strip the padding off.
    text = text.substring(nullPadding.length, text.length - nullPadding.length);
    return [
        text,
        results
    ];
};
/**
 * Add some padding on text start and end so that edges can match something.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} The padding string added to each side.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_addPadding = function(patches) {
    var paddingLength = this.Patch_Margin;
    var nullPadding = "";
    for(var x = 1; x <= paddingLength; x++)nullPadding += String.fromCharCode(x);
    // Bump all the patches forward.
    for(var x = 0; x < patches.length; x++){
        patches[x].start1 += paddingLength;
        patches[x].start2 += paddingLength;
    }
    // Add some padding on start of first diff.
    var patch = patches[0];
    var diffs = patch.diffs;
    if (diffs.length == 0 || diffs[0][0] != $3e08936831d1dd3a$var$DIFF_EQUAL) {
        // Add nullPadding equality.
        diffs.unshift([
            $3e08936831d1dd3a$var$DIFF_EQUAL,
            nullPadding
        ]);
        patch.start1 -= paddingLength; // Should be 0.
        patch.start2 -= paddingLength; // Should be 0.
        patch.length1 += paddingLength;
        patch.length2 += paddingLength;
    } else if (paddingLength > diffs[0][1].length) {
        // Grow first equality.
        var extraLength = paddingLength - diffs[0][1].length;
        diffs[0][1] = nullPadding.substring(diffs[0][1].length) + diffs[0][1];
        patch.start1 -= extraLength;
        patch.start2 -= extraLength;
        patch.length1 += extraLength;
        patch.length2 += extraLength;
    }
    // Add some padding on end of last diff.
    patch = patches[patches.length - 1];
    diffs = patch.diffs;
    if (diffs.length == 0 || diffs[diffs.length - 1][0] != $3e08936831d1dd3a$var$DIFF_EQUAL) {
        // Add nullPadding equality.
        diffs.push([
            $3e08936831d1dd3a$var$DIFF_EQUAL,
            nullPadding
        ]);
        patch.length1 += paddingLength;
        patch.length2 += paddingLength;
    } else if (paddingLength > diffs[diffs.length - 1][1].length) {
        // Grow last equality.
        var extraLength = paddingLength - diffs[diffs.length - 1][1].length;
        diffs[diffs.length - 1][1] += nullPadding.substring(0, extraLength);
        patch.length1 += extraLength;
        patch.length2 += extraLength;
    }
    return nullPadding;
};
/**
 * Look through the patches and break up any which are longer than the maximum
 * limit of the match algorithm.
 * Intended to be called only from within patch_apply.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_splitMax = function(patches) {
    var patch_size = this.Match_MaxBits;
    for(var x = 0; x < patches.length; x++){
        if (patches[x].length1 <= patch_size) continue;
        var bigpatch = patches[x];
        // Remove the big old patch.
        patches.splice(x--, 1);
        var start1 = bigpatch.start1;
        var start2 = bigpatch.start2;
        var precontext = "";
        while(bigpatch.diffs.length !== 0){
            // Create one of several smaller patches.
            var patch = new $3e08936831d1dd3a$var$diff_match_patch.patch_obj();
            var empty = true;
            patch.start1 = start1 - precontext.length;
            patch.start2 = start2 - precontext.length;
            if (precontext !== "") {
                patch.length1 = patch.length2 = precontext.length;
                patch.diffs.push([
                    $3e08936831d1dd3a$var$DIFF_EQUAL,
                    precontext
                ]);
            }
            while(bigpatch.diffs.length !== 0 && patch.length1 < patch_size - this.Patch_Margin){
                var diff_type = bigpatch.diffs[0][0];
                var diff_text = bigpatch.diffs[0][1];
                if (diff_type === $3e08936831d1dd3a$var$DIFF_INSERT) {
                    // Insertions are harmless.
                    patch.length2 += diff_text.length;
                    start2 += diff_text.length;
                    patch.diffs.push(bigpatch.diffs.shift());
                    empty = false;
                } else if (diff_type === $3e08936831d1dd3a$var$DIFF_DELETE && patch.diffs.length == 1 && patch.diffs[0][0] == $3e08936831d1dd3a$var$DIFF_EQUAL && diff_text.length > 2 * patch_size) {
                    // This is a large deletion.  Let it pass in one chunk.
                    patch.length1 += diff_text.length;
                    start1 += diff_text.length;
                    empty = false;
                    patch.diffs.push([
                        diff_type,
                        diff_text
                    ]);
                    bigpatch.diffs.shift();
                } else {
                    // Deletion or equality.  Only take as much as we can stomach.
                    diff_text = diff_text.substring(0, patch_size - patch.length1 - this.Patch_Margin);
                    patch.length1 += diff_text.length;
                    start1 += diff_text.length;
                    if (diff_type === $3e08936831d1dd3a$var$DIFF_EQUAL) {
                        patch.length2 += diff_text.length;
                        start2 += diff_text.length;
                    } else empty = false;
                    patch.diffs.push([
                        diff_type,
                        diff_text
                    ]);
                    if (diff_text == bigpatch.diffs[0][1]) bigpatch.diffs.shift();
                    else bigpatch.diffs[0][1] = bigpatch.diffs[0][1].substring(diff_text.length);
                }
            }
            // Compute the head context for the next patch.
            precontext = this.diff_text2(patch.diffs);
            precontext = precontext.substring(precontext.length - this.Patch_Margin);
            // Append the end context for this patch.
            var postcontext = this.diff_text1(bigpatch.diffs).substring(0, this.Patch_Margin);
            if (postcontext !== "") {
                patch.length1 += postcontext.length;
                patch.length2 += postcontext.length;
                if (patch.diffs.length !== 0 && patch.diffs[patch.diffs.length - 1][0] === $3e08936831d1dd3a$var$DIFF_EQUAL) patch.diffs[patch.diffs.length - 1][1] += postcontext;
                else patch.diffs.push([
                    $3e08936831d1dd3a$var$DIFF_EQUAL,
                    postcontext
                ]);
            }
            if (!empty) patches.splice(++x, 0, patch);
        }
    }
};
/**
 * Take a list of patches and return a textual representation.
 * @param {!Array.<!diff_match_patch.patch_obj>} patches Array of Patch objects.
 * @return {string} Text representation of patches.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_toText = function(patches) {
    var text = [];
    for(var x = 0; x < patches.length; x++)text[x] = patches[x];
    return text.join("");
};
/**
 * Parse a textual representation of patches and return a list of Patch objects.
 * @param {string} textline Text representation of patches.
 * @return {!Array.<!diff_match_patch.patch_obj>} Array of Patch objects.
 * @throws {!Error} If invalid input.
 */ $3e08936831d1dd3a$var$diff_match_patch.prototype.patch_fromText = function(textline) {
    var patches = [];
    if (!textline) return patches;
    var text = textline.split("\n");
    var textPointer = 0;
    var patchHeader = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/;
    while(textPointer < text.length){
        var m = text[textPointer].match(patchHeader);
        if (!m) throw new Error("Invalid patch string: " + text[textPointer]);
        var patch = new $3e08936831d1dd3a$var$diff_match_patch.patch_obj();
        patches.push(patch);
        patch.start1 = parseInt(m[1], 10);
        if (m[2] === "") {
            patch.start1--;
            patch.length1 = 1;
        } else if (m[2] == "0") patch.length1 = 0;
        else {
            patch.start1--;
            patch.length1 = parseInt(m[2], 10);
        }
        patch.start2 = parseInt(m[3], 10);
        if (m[4] === "") {
            patch.start2--;
            patch.length2 = 1;
        } else if (m[4] == "0") patch.length2 = 0;
        else {
            patch.start2--;
            patch.length2 = parseInt(m[4], 10);
        }
        textPointer++;
        while(textPointer < text.length){
            var sign = text[textPointer].charAt(0);
            try {
                var line = decodeURI(text[textPointer].substring(1));
            } catch (ex) {
                // Malformed URI sequence.
                throw new Error("Illegal escape in patch_fromText: " + line);
            }
            if (sign == "-") // Deletion.
            patch.diffs.push([
                $3e08936831d1dd3a$var$DIFF_DELETE,
                line
            ]);
            else if (sign == "+") // Insertion.
            patch.diffs.push([
                $3e08936831d1dd3a$var$DIFF_INSERT,
                line
            ]);
            else if (sign == " ") // Minor equality.
            patch.diffs.push([
                $3e08936831d1dd3a$var$DIFF_EQUAL,
                line
            ]);
            else if (sign == "@") break;
            else if (sign === "") ;
            else // WTF?
            throw new Error('Invalid patch mode "' + sign + '" in: ' + line);
            textPointer++;
        }
    }
    return patches;
};
/**
 * Class representing one patch operation.
 * @constructor
 */ $3e08936831d1dd3a$var$diff_match_patch.patch_obj = function() {
    /** @type {!Array.<!diff_match_patch.Diff>} */ this.diffs = [];
    /** @type {?number} */ this.start1 = null;
    /** @type {?number} */ this.start2 = null;
    /** @type {number} */ this.length1 = 0;
    /** @type {number} */ this.length2 = 0;
};
/**
 * Emmulate GNU diff's format.
 * Header: @@ -382,8 +481,9 @@
 * Indicies are printed as 1-based, not 0-based.
 * @return {string} The GNU diff string.
 */ $3e08936831d1dd3a$var$diff_match_patch.patch_obj.prototype.toString = function() {
    var coords1, coords2;
    if (this.length1 === 0) coords1 = this.start1 + ",0";
    else if (this.length1 == 1) coords1 = this.start1 + 1;
    else coords1 = this.start1 + 1 + "," + this.length1;
    if (this.length2 === 0) coords2 = this.start2 + ",0";
    else if (this.length2 == 1) coords2 = this.start2 + 1;
    else coords2 = this.start2 + 1 + "," + this.length2;
    var text = [
        "@@ -" + coords1 + " +" + coords2 + " @@\n"
    ];
    var op;
    // Escape the body of the patch with %xx notation.
    for(var x = 0; x < this.diffs.length; x++){
        switch(this.diffs[x][0]){
            case $3e08936831d1dd3a$var$DIFF_INSERT:
                op = "+";
                break;
            case $3e08936831d1dd3a$var$DIFF_DELETE:
                op = "-";
                break;
            case $3e08936831d1dd3a$var$DIFF_EQUAL:
                op = " ";
                break;
        }
        text[x + 1] = op + encodeURI(this.diffs[x][1]) + "\n";
    }
    return text.join("").replace(/%20/g, " ");
};
// The following export code was added by @ForbesLindesay
$3e08936831d1dd3a$exports = $3e08936831d1dd3a$var$diff_match_patch;
$3e08936831d1dd3a$exports["diff_match_patch"] = $3e08936831d1dd3a$var$diff_match_patch;
$3e08936831d1dd3a$exports["DIFF_DELETE"] = $3e08936831d1dd3a$var$DIFF_DELETE;
$3e08936831d1dd3a$exports["DIFF_INSERT"] = $3e08936831d1dd3a$var$DIFF_INSERT;
$3e08936831d1dd3a$exports["DIFF_EQUAL"] = $3e08936831d1dd3a$var$DIFF_EQUAL;


const $a0933ef57ff1c2b9$export$21b0d22d12aeedc7 = new $3e08936831d1dd3a$exports.diff_match_patch();
function $a0933ef57ff1c2b9$export$9f8c3630c3d15aa2(s) {
    return s.slice(0, 1).toUpperCase() + s.slice(1);
}
function $a0933ef57ff1c2b9$export$1c9f709888824e05() {
    const env = "production";
    return env === "production";
}
function $a0933ef57ff1c2b9$export$9acf59296ec0cce1($debugName) {
    const env = "production";
    if (env === "production") return {};
    else return {
        $debugName: $debugName
    };
}
function $a0933ef57ff1c2b9$export$1bfa025333b3570e() {
    let i = 0;
    return ()=>{
        return String.fromCharCode(parseInt((i++).toString(), 16));
    };
}
function $a0933ef57ff1c2b9$export$73042cc6e64aaf37(xs, ys, cmp = (a)=>a.toString()) {
    return $a0933ef57ff1c2b9$export$6baddf9e2d3d7a3b(xs, ys, cmp, cmp).map((c)=>$f3dce8682185fe38$export$2e2bcd8739ae039(c.change, c.change == 1 ? c.b : c.a));
}
function $a0933ef57ff1c2b9$export$6baddf9e2d3d7a3b(xs, ys, a_cmp = (a)=>a.toString(), b_cmp = (b)=>b.toString()) {
    const to = new Map();
    const a_from = new Map();
    const b_from = new Map();
    const next = $a0933ef57ff1c2b9$export$1bfa025333b3570e();
    function assign(c, c_cmp, c_from) {
        const s = c_cmp(c);
        let u = to.get(s);
        if (u === undefined) {
            u = next();
            to.set(s, u);
        }
        let arr = c_from.get(u);
        if (!arr) {
            arr = [];
            c_from.set(u, arr);
        }
        arr.push(c);
        return u;
    }
    const s1 = xs.map((a)=>assign(a, a_cmp, a_from)).join("");
    const s2 = ys.map((b)=>assign(b, b_cmp, b_from)).join("");
    const d = $a0933ef57ff1c2b9$export$21b0d22d12aeedc7.diff_main(s1, s2);
    return $a0933ef57ff1c2b9$export$5b8affa63fc6df16(d, ([change, cs])=>{
        return $a0933ef57ff1c2b9$export$d04e030ebc4d0326(cs, (c)=>{
            if (change == 0) {
                const a = a_from.get(c).shift();
                const b = b_from.get(c).shift();
                return {
                    change: 0,
                    a: a,
                    b: b
                };
            } else if (change == -1) {
                const a = a_from.get(c).shift();
                return {
                    change: -1,
                    a: a
                };
            } else if (change == 1) {
                const b = b_from.get(c).shift();
                return {
                    change: 1,
                    b: b
                };
            }
            throw "diff match patch returned change not in range [-1, 1]: " + change;
        });
    });
}
function $a0933ef57ff1c2b9$export$14c0f847aecec6f1(s) {
    return s.match(/\s$/) ? s : s + " ";
}
function $a0933ef57ff1c2b9$export$55a979e417d1ea1b(s1, s2) {
    const d = $a0933ef57ff1c2b9$export$21b0d22d12aeedc7.diff_main(s1, s2);
    $a0933ef57ff1c2b9$export$21b0d22d12aeedc7.diff_cleanupSemantic(d);
    return d;
}
const $a0933ef57ff1c2b9$export$ca60277ef2eae2d4 = (ds)=>ds.map(([i, s])=>[
            -i,
            s
        ]);
function $a0933ef57ff1c2b9$export$9f1a18fcf029fd45(ss, s2) {
    if (ss.length === 0) return [];
    let lengths = ss.map((s)=>s.length);
    const diff = $a0933ef57ff1c2b9$export$55a979e417d1ea1b(ss.join(""), s2);
    let cur = [];
    const out = [
        cur
    ];
    diff.map(([i, s])=>{
        if (i == 0 || i == -1) {
            while(s.length > lengths[0]){
                const n = lengths.shift();
                cur.push([
                    i,
                    s.slice(0, n)
                ]);
                cur = [];
                out.push(cur);
                s = s.slice(n);
            }
            if (s.length > 0) {
                cur.push([
                    i,
                    s
                ]);
                lengths[0] -= s.length;
            }
        } else cur.push([
            i,
            s
        ]);
    });
    return out;
}
function $a0933ef57ff1c2b9$export$a19dbeb44f6a0bab(xs, ys) {
    return xs.length == ys.length && xs.every((x, i)=>x == ys[i]);
}
function $a0933ef57ff1c2b9$export$574e067f403877b3(xs, ys) {
    const xm = new Map();
    const ym = new Map();
    let tmp;
    xs.map((x)=>xm.set(x, (tmp = xm.get(x), tmp === undefined ? 1 : tmp + 1)));
    ys.map((y)=>ym.set(y, (tmp = ym.get(y), tmp === undefined ? 1 : tmp + 1)));
    return $a0933ef57ff1c2b9$export$ad8955a544efecc6(xm, ym);
}
function $a0933ef57ff1c2b9$export$ad8955a544efecc6(a, b) {
    let ok = true;
    a.forEach((k, v)=>ok = ok && b.get(v) == k);
    b.forEach((k, v)=>ok = ok && a.get(v) == k);
    return ok;
}
function $a0933ef57ff1c2b9$export$c90d60d0819468be(a, b) {
    let ok = true;
    a.forEach((k)=>ok = ok && b.has(k));
    b.forEach((k)=>ok = ok && a.has(k));
    return ok;
}
function $a0933ef57ff1c2b9$export$74895c65cb076870(xs, ys) {
    return $a0933ef57ff1c2b9$export$c90d60d0819468be(new Set(xs), new Set(ys));
}
function $a0933ef57ff1c2b9$export$d04e030ebc4d0326(s, f) {
    const out = [];
    for(let i = 0; i < s.length; ++i)out.push(f(s[i], i));
    return out;
}
var $d4327903c1727cf4$exports = {};
function $d4327903c1727cf4$var$stringify(obj, options) {
    options = options || {};
    var indent = JSON.stringify([
        1
    ], null, $d4327903c1727cf4$var$get(options, "indent", 2)).slice(2, -3);
    var addMargin = $d4327903c1727cf4$var$get(options, "margins", false);
    var maxLength = indent === "" ? Infinity : $d4327903c1727cf4$var$get(options, "maxLength", 80);
    return function _stringify(obj, currentIndent, reserved) {
        if (obj && typeof obj.toJSON === "function") obj = obj.toJSON();
        var string = JSON.stringify(obj);
        if (string === undefined) return string;
        var length = maxLength - currentIndent.length - reserved;
        if (string.length <= length) {
            var prettified = $d4327903c1727cf4$var$prettify(string, addMargin);
            if (prettified.length <= length) return prettified;
        }
        if (typeof obj === "object" && obj !== null) {
            var nextIndent = currentIndent + indent;
            var items = [];
            var delimiters;
            var comma = function(array, index) {
                return index === array.length - 1 ? 0 : 1;
            };
            if (Array.isArray(obj)) {
                for(var index = 0; index < obj.length; index++)items.push(_stringify(obj[index], nextIndent, comma(obj, index)) || "null");
                delimiters = "[]";
            } else {
                Object.keys(obj).forEach(function(key, index, array) {
                    var keyPart = JSON.stringify(key) + ": ";
                    var value = _stringify(obj[key], nextIndent, keyPart.length + comma(array, index));
                    if (value !== undefined) items.push(keyPart + value);
                });
                delimiters = "{}";
            }
            if (items.length > 0) return [
                delimiters[0],
                indent + items.join(",\n" + nextIndent),
                delimiters[1]
            ].join("\n" + currentIndent);
        }
        return string;
    }(obj, "", 0);
}
// Note: This regex matches even invalid JSON strings, but since we’re
// working on the output of `JSON.stringify` we know that only valid strings
// are present (unless the user supplied a weird `options.indent` but in
// that case we don’t care since the output would be invalid anyway).
var $d4327903c1727cf4$var$stringOrChar = /("(?:[^\\"]|\\.)*")|[:,\][}{]/g;
function $d4327903c1727cf4$var$prettify(string, addMargin) {
    var m = addMargin ? " " : "";
    var tokens = {
        "{": "{" + m,
        "[": "[" + m,
        "}": m + "}",
        "]": m + "]",
        ",": ", ",
        ":": ": "
    };
    return string.replace($d4327903c1727cf4$var$stringOrChar, function(match, string) {
        return string ? match : tokens[match];
    });
}
function $d4327903c1727cf4$var$get(options, name, defaultValue) {
    return name in options ? options[name] : defaultValue;
}
$d4327903c1727cf4$exports = $d4327903c1727cf4$var$stringify;


function $a0933ef57ff1c2b9$export$57bf213be019eeb0(x) {
    return $d4327903c1727cf4$exports(x);
// return JSON.stringify(x, undefined, 2)
}
function $a0933ef57ff1c2b9$export$8343b6e3d09a3606(x) {
    console.error($a0933ef57ff1c2b9$export$57bf213be019eeb0(x));
    console.error();
    return x;
}
function $a0933ef57ff1c2b9$export$9eda70b29dd52ef9(x) {
    console.log($a0933ef57ff1c2b9$export$57bf213be019eeb0(x));
    return x;
}
function $a0933ef57ff1c2b9$export$bab4a1db406f2fa9(xs) {
    return xs.slice().sort((u, v)=>u - v);
}
function $a0933ef57ff1c2b9$export$ac82cbe7dc0182d2(...cmps) {
    return (a, b)=>{
        let ret = 0;
        for (const cmp of [
            ...cmps,
            $a0933ef57ff1c2b9$export$479e93f6971754e6
        ]){
            ret = cmp(a, b);
            if (ret != 0) break;
        }
        return ret;
    };
}
function $a0933ef57ff1c2b9$export$479e93f6971754e6(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $a0933ef57ff1c2b9$export$10a14be77be1fbf8(f, negate = false) {
    return (a, b)=>(negate ? -1 : 1) * $a0933ef57ff1c2b9$export$479e93f6971754e6(f(a), f(b));
}
function $a0933ef57ff1c2b9$export$c6a55a9d77585122(s) {
    const m = s.match(/^\s*(.*)$/);
    if (m) return m[1];
    else return s // unreachable, the regex always matches
    ;
}
function $a0933ef57ff1c2b9$export$fa2642df3bb464aa(s) {
    const m = s.match(/^(.*?)(\s*)$/);
    if (m && m.length == 3) return [
        m[1],
        m[2]
    ];
    return [
        s,
        ""
    ] // unreachable (the regexp matches any string)
    ;
}
function $a0933ef57ff1c2b9$export$22a074bb5a7310a6(s) {
    const m = s.match(/^(\s*)(.*)$/);
    if (m && m.length == 3) return [
        m[1],
        m[2]
    ];
    return [
        s,
        ""
    ] // unreachable (the regexp matches any string)
    ;
}
function $a0933ef57ff1c2b9$export$e12697c9e41305e2(xs) {
    return xs.every((v, i)=>i == 0 || v > xs[i - 1]);
}
function $a0933ef57ff1c2b9$export$e8ee1b9f9c7189a(xs) {
    return xs.every((x, i)=>i == 0 || xs[i - 1] + 1 == x);
}
function $a0933ef57ff1c2b9$export$a01aafba61e29e63(xs, cmp) {
    const groups = [];
    xs.sort((a, b)=>cmp(a) - cmp(b)).forEach((x)=>{
        let g = groups[groups.length - 1];
        // Contiguous with the last group, or create a new one?
        g && cmp(g[g.length - 1]) + 1 == cmp(x) ? g.push(x) : groups.push([
            x
        ]);
    });
    return groups;
}
function $a0933ef57ff1c2b9$export$bffa455ba8c619a6(xss) {
    return [].concat(...xss);
}
function $a0933ef57ff1c2b9$export$5b8affa63fc6df16(xs, f) {
    return $a0933ef57ff1c2b9$export$bffa455ba8c619a6(xs.map(f));
}
function $a0933ef57ff1c2b9$export$c9b6b290379e9dc7(i, ...xss) {
    return xss.map((xs)=>xs[i]);
}
function $a0933ef57ff1c2b9$export$972dde9b4ef006d4(xs, start, end) {
    const [ab, c] = $a60e80e084e1281e$export$2e2bcd8739ae039(end, xs);
    const [a, b] = $a60e80e084e1281e$export$2e2bcd8739ae039(start, ab);
    return [
        a,
        b,
        c
    ];
}
function $a0933ef57ff1c2b9$export$5417a444a9c88ecf(xs, start, end) {
    const [ab, c] = $a60e80e084e1281e$export$2e2bcd8739ae039(end, xs);
    const [a, b] = $a60e80e084e1281e$export$2e2bcd8739ae039(start, ab);
    return [
        a,
        b,
        c
    ];
}
function $a0933ef57ff1c2b9$export$99aaa11fb71d263(xs) {
    const out = [];
    xs.map((x)=>x != null && out.push(x));
    return out;
}
function $a0933ef57ff1c2b9$export$c04a9f24a4230e1f(n, xs) {
    const out = [];
    let i = 0;
    while(out.length < n){
        out.push(xs[i]);
        i++;
        if (i >= xs.length) i = 0;
    }
    return out;
}
function $a0933ef57ff1c2b9$export$916782c1f0ddb132(xs) {
    return xs.reduce((x, y)=>Math.min(x, y), xs[0]);
}
function $a0933ef57ff1c2b9$export$b25e0be55f42c9a(xs) {
    return xs.reduce((x, y)=>Math.max(x, y), xs[0]);
}
function $a0933ef57ff1c2b9$export$8a63f25cc62965f1(xs) {
    return xs.reduce((x, y)=>x + y, 0);
}
function $a0933ef57ff1c2b9$export$b65392d958998255(inj, [hd, ...tl]) {
    return $7452afdb416c43f8$export$2e2bcd8739ae039($28d52e1a07ee210e$export$2e2bcd8739ae039(inj), hd, tl);
}
function $a0933ef57ff1c2b9$export$c42fa06aba2a552c(inj, [hd, ...tl]) {
    return $7452afdb416c43f8$export$2e2bcd8739ae039($45dd3a7606822cc5$export$2e2bcd8739ae039(inj), hd, tl);
}
function $a0933ef57ff1c2b9$export$f70730c3d1fc524e(xs) {
    const seen = {};
    return xs.filter((x)=>{
        const s = x.toString();
        const duplicate = s in seen;
        seen[s] = true;
        return !duplicate;
    });
}
function $a0933ef57ff1c2b9$export$829d143888d75f2a(xs, filter, outs) {
    return outs.map((b)=>xs.filter((x)=>filter(x) === b));
}
function $a0933ef57ff1c2b9$export$a0aab0b679927e4d(xs, filter) {
    return $a0933ef57ff1c2b9$export$829d143888d75f2a(xs, (x)=>!!filter(x), [
        true,
        false
    ]);
}
function $a0933ef57ff1c2b9$export$7fff46e75e637d73(xs, filter, we) {
    return $a0933ef57ff1c2b9$export$a0aab0b679927e4d(xs, (x)=>filter(x) == we);
}
function $a0933ef57ff1c2b9$export$2bf2d3a3b8f5f2c5(xs) {
    return [
        xs[0],
        xs.slice(-1)[0]
    ];
}
function $a0933ef57ff1c2b9$export$cc169e0ad6247842(members, point, value) {
    if (value) return $a0933ef57ff1c2b9$export$f70730c3d1fc524e([
        ...members,
        point
    ]);
    else return members.filter((m)=>m.toString() != point.toString());
}
function $a0933ef57ff1c2b9$export$8c9375ca799b720c(xs) {
    return xs.filter((x, i)=>i == 0 || x !== xs[i - 1]);
}
function $a0933ef57ff1c2b9$export$bc3b6d8d31aa9744() {
    const rev = [];
    const find = (x)=>{
        if (rev[x] == undefined) rev[x] = x;
        else if (rev[x] != x) rev[x] = find(rev[x]);
        return rev[x];
    };
    const union = (x, y)=>{
        const find_x = find(x);
        const find_y = find(y);
        if (find_x != find_y) rev[find_y] = find_x;
        return find_x;
    };
    const unions = (xs)=>{
        if (xs.length > 0) xs.reduce(union, xs[0]);
    };
    return {
        find: find,
        union: union,
        unions: unions
    };
}
function $a0933ef57ff1c2b9$export$4b1ceda60dba9c5a(serialize = (a)=>JSON.stringify(a)) {
    const bw = {};
    const fw = {};
    let i = 0;
    return {
        /** What number does (the serialization of) this element have? */ num (a) {
            const s = serialize(a);
            if (!(s in bw)) {
                fw[i] = a;
                bw[s] = i++;
            }
            return bw[s];
        },
        /** What is the serialization of any element that has this number? */ un (n) {
            return fw[n];
        }
    };
}
function $a0933ef57ff1c2b9$export$6b13ca446b1d0fd3(serialize = (a)=>JSON.stringify(a)) {
    const { un: un, num: num } = $a0933ef57ff1c2b9$export$4b1ceda60dba9c5a(serialize);
    const uf = $a0933ef57ff1c2b9$export$bc3b6d8d31aa9744();
    return {
        /** What number does the group of this element have? */ repr: (x)=>uf.find(num(x)),
        find: (x)=>un(uf.find(num(x))),
        union: (x, y)=>un(uf.union(num(x), num(y))),
        unions: (xs)=>uf.unions(xs.map(num))
    };
}
function $a0933ef57ff1c2b9$export$864d727b48066337(p, x) {
    return p ? [
        x
    ] : [];
}
function $a0933ef57ff1c2b9$export$1b74141c5fe63a28(xs, serialize = (a)=>JSON.stringify(a)) {
    const count = {};
    const insert = (x)=>{
        const s = serialize(x);
        count[s] = 1 + (count[s] || 0);
    };
    xs.forEach(insert);
    return (x)=>count[serialize(x)] || 0;
}
function $a0933ef57ff1c2b9$export$869882364835d202(xs, start, count, ...insert) {
    const ys = xs.slice();
    const zs = ys.splice(start, count, ...insert);
    return [
        ys,
        zs
    ];
}
function $a0933ef57ff1c2b9$export$b784e1159c889d6b(m) {
    try {
        return m(), false;
    } catch (e) {
        return true;
    }
}
function $a0933ef57ff1c2b9$export$6be1a247e0437315() {
    const c = $a0933ef57ff1c2b9$export$85b9a36db797e02b();
    return (s)=>c.inc(s) === 1;
}
function $a0933ef57ff1c2b9$export$85b9a36db797e02b() {
    const m = new Map();
    return {
        get (s) {
            return m.get(s) || 0;
        },
        inc (s) {
            m.set(s, this.get(s) + 1);
            return this.get(s);
        }
    };
}
function $a0933ef57ff1c2b9$export$66313c302b2ea154(s) {
    throw new Error(s);
}
function $a0933ef57ff1c2b9$export$d921bb9ade5a90ff(s, t) {
    return [
        ...s.keys()
    ].some((k)=>t.has(k));
}
function $a0933ef57ff1c2b9$export$3286e37e80af903(xs, begin, end, dest) {
    const [a, mid, z] = $a0933ef57ff1c2b9$export$972dde9b4ef006d4(xs, begin, end + 1);
    const w = end - begin;
    if (dest > begin) dest -= w;
    const [pre, post] = $a60e80e084e1281e$export$2e2bcd8739ae039(dest, a.concat(z));
    return pre.concat(mid, post);
}
function $a0933ef57ff1c2b9$export$d02631cccf789723(to) {
    const out = [];
    for(let i = 0; i < to; ++i)out.push(i);
    return out;
}
function $a0933ef57ff1c2b9$export$ed3047ae95eb9b2b(begin, end) {
    const out = [];
    for(let i = begin; i < end; ++i)out.push(i);
    return out;
}
function $a0933ef57ff1c2b9$export$42ac17aabdaccaaf(xs) {
    let max = -1;
    xs.forEach((x)=>(x.match(/\d+/g) || []).forEach((i)=>max = Math.max(max, parseInt(i))));
    return max + 1;
}
function $a0933ef57ff1c2b9$export$f172309911142386(c) {
    return c;
}
function $a0933ef57ff1c2b9$export$58f44b650c4cecce(store, key) {
    return $a0933ef57ff1c2b9$export$add972cb5ef3dec(store).via((0, $17d8c0717df1150b$exports.Lens).key(key)).via((0, $17d8c0717df1150b$exports.Lens).iso((tu)=>tu || false, (b)=>b || undefined));
}
function $a0933ef57ff1c2b9$export$8995636b7242f090(xs) {
    return Object.assign({}, ...xs.map(([a, b])=>({
            [a]: b
        })));
}
function $a0933ef57ff1c2b9$export$add972cb5ef3dec(store) {
    return store.via((0, $17d8c0717df1150b$exports.Lens).iso((xs)=>$a0933ef57ff1c2b9$export$8995636b7242f090(xs.map((x)=>[
                x,
                true
            ])), (r)=>$d9d0435d2b879de6$export$df3f009e3d155b20(r, (_, s)=>s)));
}
function $a0933ef57ff1c2b9$export$de1af2a0ca9899b4(store) {
    return store.via((0, $17d8c0717df1150b$exports.Lens).iso((ss)=>ss.join(" "), (s)=>s.split(/\s+/g)));
}
function $a0933ef57ff1c2b9$export$b5fe3f66a567bec0(url, options, k, k_err = ()=>{}) {
    const r = new XMLHttpRequest();
    r.onreadystatechange = ()=>{
        if (r.readyState == 4 && r.status == 200) k(r.response);
        if (r.readyState == 4 && (r.status >= 300 || r.status == 0)) k_err(r.response, r.status);
    };
    r.open(options.method, url, true);
    r.withCredentials = !!options.withCredentials;
    options.contentType == "json" && r.setRequestHeader("Content-Type", "application/json");
    r.send(options.data);
}
function $a0933ef57ff1c2b9$export$484f3009c2ee32ad(url, data, k, k_err = ()=>{}) {
    const csrftoken = $a0933ef57ff1c2b9$export$622991c71a1f52b3("csrftoken");
    const options = {
        method: "POST",
        contentType: "json",
        withCredentials: true,
        headers: csrftoken ? [
            {
                "X-CSRFToken": csrftoken
            }
        ] : [],
        data: JSON.stringify(data)
    };
    $a0933ef57ff1c2b9$export$b5fe3f66a567bec0(url, options, k, k_err);
}
function $a0933ef57ff1c2b9$export$1bb358554aac31c1(url, k, k_err = ()=>{}) {
    const options = {
        method: "GET",
        contentType: "json",
        withCredentials: true
    };
    $a0933ef57ff1c2b9$export$b5fe3f66a567bec0(url, options, k, k_err);
}
function $a0933ef57ff1c2b9$export$622991c71a1f52b3(name) {
    for (const cookie of document.cookie.split(/\s*;\s*/)){
        if (cookie.substring(0, name.length + 1) === name + "=") return decodeURIComponent(cookie.substring(name.length + 1));
    }
}
function $a0933ef57ff1c2b9$export$61fc7d43ac8f84b0(wait, k) {
    let id;
    return (...args)=>{
        if (id != null) clearTimeout(id);
        id = setTimeout(()=>{
            id = null;
            k(...args);
        }, wait);
    };
}
function $a0933ef57ff1c2b9$export$d838837eb5b184e3(init, f) {
    let v = init;
    let last = v;
    do {
        last = v;
        v = f(v);
    }while (!$bb5c76e6a1c0ede6$export$2e2bcd8739ae039(v, last));
    return v;
}
function $a0933ef57ff1c2b9$export$6e6697ef026a96(r) {
    const ks = Object.keys(r);
    if (ks.length == 0) return [
        {}
    ];
    else {
        const k = ks[0];
        const { [k]: vs, ...rest } = r;
        return $a0933ef57ff1c2b9$export$bffa455ba8c619a6($a0933ef57ff1c2b9$export$6e6697ef026a96(rest).map((cr)=>vs.map((v)=>({
                    [k]: v,
                    ...cr
                }))));
    }
}
function $a0933ef57ff1c2b9$export$8075fec7d7cec517(xs) {
    const out = [];
    xs.forEach((x, i)=>xs.forEach((y, j)=>j > i && out.push([
                x,
                y
            ])));
    return out;
}
function $a0933ef57ff1c2b9$export$77d92587fe11873(r, concat, cmp) {
    const coords = $a0933ef57ff1c2b9$export$6e6697ef026a96($d9d0435d2b879de6$export$871de8747c9eaa88(r, (ss)=>ss.map((_, i)=>i))).sort((a, b)=>$a0933ef57ff1c2b9$export$8a63f25cc62965f1(Object.values(a)) - $a0933ef57ff1c2b9$export$8a63f25cc62965f1(Object.values(b)));
    const prev = $d9d0435d2b879de6$export$871de8747c9eaa88(r, (_)=>0);
    const out = [];
    coords.forEach((coord)=>{
        if ($d9d0435d2b879de6$export$df3f009e3d155b20(coord, (i, k)=>i >= prev[k]).every((b)=>b)) {
            const a = $d9d0435d2b879de6$export$871de8747c9eaa88(r, (s, k)=>concat($a0933ef57ff1c2b9$export$ed3047ae95eb9b2b(prev[k], coord[k] + 1).map((i)=>s[i])));
            if ($a0933ef57ff1c2b9$export$8075fec7d7cec517(Object.values(a)).every(([x, y])=>cmp(x, y))) {
                $d9d0435d2b879de6$export$4b80e395e36b5a56(coord, (i, k)=>prev[k] = i + 1);
                out.push(a);
            }
        }
    });
    return out;
}
function $a0933ef57ff1c2b9$export$bd7c999bdb8c7605(xs, k) {
    return xs.map((x, i)=>k(x, xs[i - 1], i));
}
function $a0933ef57ff1c2b9$export$916430c3578a176d(s = JSON.stringify) {
    const obj = {};
    const krev = {};
    const api = {
        has (k) {
            return s(k) in obj;
        },
        get (k) {
            return obj[s(k)];
        },
        set (k, v) {
            obj[s(k)] = v;
            krev[s(k)] = k;
        },
        forEach (f) {
            Object.keys(obj).map((sk)=>f(obj[sk], krev[sk]));
        },
        batch (kvs) {
            kvs.map((m)=>api.set(m.key, m.value));
        },
        obj: obj
    };
    return api;
}
function $a0933ef57ff1c2b9$export$c40cf5aab899f397(xs, x) {
    return ()=>[
            xs,
            x
        ];
}
function $a0933ef57ff1c2b9$export$cf6c2c83d6c223e(xs, ys) {
    return ys.reduce((xs, y)=>$a0933ef57ff1c2b9$export$c40cf5aab899f397(xs, y), xs);
}
function $a0933ef57ff1c2b9$export$9c5cd851e3a05d4a(xs) {
    const out = [];
    while(xs !== null){
        const cell = xs();
        out.push(cell[1]);
        xs = cell[0];
    }
    return out.reverse();
}
function $a0933ef57ff1c2b9$export$dce8637ca0d755f(k) {
    return k();
}
function $a0933ef57ff1c2b9$export$e08e3b67e392101e(a, f) {
    return f(a);
}
function $a0933ef57ff1c2b9$export$4cbf152802aa238(obj, k, ...vs) {
    const _obj = obj;
    (_obj[k] || (_obj[k] = [])).push(...vs);
}
function $a0933ef57ff1c2b9$export$9be1301193883bb5(store, value) {
    const now = store.get();
    if (!$bb5c76e6a1c0ede6$export$2e2bcd8739ae039(now, value)) store.set(value);
}
function $a0933ef57ff1c2b9$export$5160ab928f687bd(s0, s) {
    const patches = $a0933ef57ff1c2b9$export$55a979e417d1ea1b(s0, s);
    const pre = $2896547f0b1d93f9$export$2e2bcd8739ae039((i)=>i[0] == 0, patches);
    const post = $7bdc9aa494146858$export$2e2bcd8739ae039((i)=>i[0] == 0, $fc1564f0616b33f5$export$2e2bcd8739ae039(pre.length, patches));
    const from = pre.map((i)=>i[1]).join("").length;
    const postlen = post.map((i)=>i[1]).join("").length;
    const to = s0.length - postlen;
    const insert = s.slice(from, s.length - (s0.length - to));
    return {
        from: from,
        to: to,
        insert: insert
    };
}
function $a0933ef57ff1c2b9$export$f28d906d67a997f3(lo, x, hi) {
    return lo <= x && x < hi;
}
function $a0933ef57ff1c2b9$export$8855a8be7bd3e9f8(xs, f) {
    const op = (rindex)=>xs.length - rindex - 1;
    return op(xs.findIndex((_, rindex)=>f(xs[op(rindex)], op(rindex))));
}
function $a0933ef57ff1c2b9$export$d6ed4c2f46abc031(label, doit) {
    const yes = false;
    yes && console.time(label);
    const a = doit();
    yes && console.timeEnd(label);
    return a;
}
function $a0933ef57ff1c2b9$export$df91a094d1ff523d(m, k) {
    return m.get(k) || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Key missing: ${k}`);
}
function $a0933ef57ff1c2b9$export$4154a199d7d90455(...bs) {
    for (const b of bs){
        if (b) return true;
    }
    return false;
}
function $a0933ef57ff1c2b9$export$53a0910f038337bd(parent, child) {
    const scrollY = (top)=>parent.scroll({
            top: top,
            behavior: "smooth"
        });
    // If child bottom is below parent bottom, align bottoms.
    if (child.offsetTop + child.offsetHeight > parent.scrollTop + parent.offsetHeight) scrollY(child.offsetTop + child.offsetHeight - parent.offsetHeight);
    // If child top is above parent top, align tops.
    if (child.offsetTop < parent.scrollTop) scrollY(child.offsetTop);
}



var $58ccaae15ba3b7ae$exports = {};

$parcel$export($58ccaae15ba3b7ae$exports, "Token", function () { return $58ccaae15ba3b7ae$export$50792b0e93539fde; });
$parcel$export($58ccaae15ba3b7ae$exports, "token", function () { return $58ccaae15ba3b7ae$export$9e1725a4cfeada27; });
$parcel$export($58ccaae15ba3b7ae$exports, "text", function () { return $58ccaae15ba3b7ae$export$6f093cfa640b7166; });
$parcel$export($58ccaae15ba3b7ae$exports, "texts", function () { return $58ccaae15ba3b7ae$export$29f9f81de5c56283; });
$parcel$export($58ccaae15ba3b7ae$exports, "punc", function () { return $58ccaae15ba3b7ae$export$41635737e14bf4f4; });
$parcel$export($58ccaae15ba3b7ae$exports, "prev_punc", function () { return $58ccaae15ba3b7ae$export$5d0935d19179e80b; });
$parcel$export($58ccaae15ba3b7ae$exports, "next_punc", function () { return $58ccaae15ba3b7ae$export$55ddf53e1db21b31; });
$parcel$export($58ccaae15ba3b7ae$exports, "span_merge", function () { return $58ccaae15ba3b7ae$export$26e4dba69d72ef56; });
$parcel$export($58ccaae15ba3b7ae$exports, "merge_spans", function () { return $58ccaae15ba3b7ae$export$307cc6fe569c4c20; });
$parcel$export($58ccaae15ba3b7ae$exports, "span_within", function () { return $58ccaae15ba3b7ae$export$c880d684ac38a017; });
$parcel$export($58ccaae15ba3b7ae$exports, "sentence_starts", function () { return $58ccaae15ba3b7ae$export$25e87b990f51ada5; });
$parcel$export($58ccaae15ba3b7ae$exports, "sentence_ends", function () { return $58ccaae15ba3b7ae$export$75d6574086804bc7; });
$parcel$export($58ccaae15ba3b7ae$exports, "sentence_bounds", function () { return $58ccaae15ba3b7ae$export$b8629c942bfd8bd1; });
$parcel$export($58ccaae15ba3b7ae$exports, "sentence", function () { return $58ccaae15ba3b7ae$export$ae6a5ab41f356242; });
$parcel$export($58ccaae15ba3b7ae$exports, "tokenize", function () { return $58ccaae15ba3b7ae$export$660b2ee2d4fb4eff; });
$parcel$export($58ccaae15ba3b7ae$exports, "identify", function () { return $58ccaae15ba3b7ae$export$65e5b62a4c490288; });
$parcel$export($58ccaae15ba3b7ae$exports, "text_offset", function () { return $58ccaae15ba3b7ae$export$2b9c8a4ef870afef; });
$parcel$export($58ccaae15ba3b7ae$exports, "token_at", function () { return $58ccaae15ba3b7ae$export$162b77d70e08a240; });

function $58ccaae15ba3b7ae$export$50792b0e93539fde(text, id) {
    return {
        id: id,
        text: text
    };
}
function $58ccaae15ba3b7ae$export$9e1725a4cfeada27(t) {
    return $58ccaae15ba3b7ae$export$50792b0e93539fde(t.text, t.id);
}
function $58ccaae15ba3b7ae$export$6f093cfa640b7166(ts) {
    return $58ccaae15ba3b7ae$export$29f9f81de5c56283(ts).join("");
}
function $58ccaae15ba3b7ae$export$29f9f81de5c56283(ts) {
    return ts.map((t)=>t.text);
}
function $58ccaae15ba3b7ae$export$41635737e14bf4f4(s) {
    return !!s.match(/^\s*[.!?␤]+\s*$/) || !!s.match(/\.\s*$/) && !s.match(/^t\./);
}
function $58ccaae15ba3b7ae$export$5d0935d19179e80b(tokens, i) {
    for(let j = i; j >= 0; --j){
        if ($58ccaae15ba3b7ae$export$41635737e14bf4f4(tokens[j])) return j;
    }
    return -1;
}
function $58ccaae15ba3b7ae$export$55ddf53e1db21b31(tokens, i) {
    for(let j = i; j < tokens.length; ++j){
        if ($58ccaae15ba3b7ae$export$41635737e14bf4f4(tokens[j])) return j;
    }
    return -1;
}
function $58ccaae15ba3b7ae$export$26e4dba69d72ef56(s1, s2) {
    return {
        begin: Math.min(s1.begin, s2.begin),
        end: Math.max(s1.end, s2.end)
    };
}
function $58ccaae15ba3b7ae$export$307cc6fe569c4c20(ss) {
    const ws = ss.slice();
    let s = ss[0];
    while(ws.length > 1){
        const s_last = ws.pop();
        s = $58ccaae15ba3b7ae$export$26e4dba69d72ef56(s, s_last);
    }
    return s;
}
function $58ccaae15ba3b7ae$export$c880d684ac38a017(i, s) {
    return s.begin <= i && i <= s.end;
}
function $58ccaae15ba3b7ae$export$25e87b990f51ada5(tokens) {
    const out = [];
    let begin = 0;
    for(let i = 0; i < tokens.length; ++i){
        out.push(begin);
        if ($58ccaae15ba3b7ae$export$41635737e14bf4f4(tokens[i])) begin = i + 1;
    }
    return out;
}
function $58ccaae15ba3b7ae$export$75d6574086804bc7(tokens) {
    const out = [];
    let end = tokens.length - 1;
    for(let i = tokens.length - 1; i >= 0; --i){
        if ($58ccaae15ba3b7ae$export$41635737e14bf4f4(tokens[i])) end = i;
        out.push(end);
    }
    return out.reverse();
}
function $58ccaae15ba3b7ae$export$b8629c942bfd8bd1(tokens) {
    const begins = $58ccaae15ba3b7ae$export$25e87b990f51ada5(tokens);
    const ends = $58ccaae15ba3b7ae$export$75d6574086804bc7(tokens);
    return begins.map((begin, i)=>({
            begin: begin,
            end: ends[i]
        }));
}
function $58ccaae15ba3b7ae$export$ae6a5ab41f356242(tokens, i) {
    return $58ccaae15ba3b7ae$export$b8629c942bfd8bd1(tokens)[i];
}
function $58ccaae15ba3b7ae$export$660b2ee2d4fb4eff(s) {
    return (s.match(/\s*\S+\s*/g) || s.match(/^\s+$/g) || []).map($a0933ef57ff1c2b9$export$14c0f847aecec6f1);
}
function $58ccaae15ba3b7ae$export$65e5b62a4c490288(toks, prefix) {
    return toks.map((text, i)=>$58ccaae15ba3b7ae$export$50792b0e93539fde(text, prefix + i));
}
function $58ccaae15ba3b7ae$export$2b9c8a4ef870afef(texts, index) {
    return texts.slice(0, index).reduce((x, s)=>x + s.length, 0);
}
function $58ccaae15ba3b7ae$export$162b77d70e08a240(tokens, character_offset) {
    let passed = 0;
    for(let i = 0; i < tokens.length; i++){
        const w = tokens[i].length;
        passed += w;
        if (passed > character_offset) return {
            token: i,
            offset: character_offset - passed + w
        };
    }
    if (character_offset == tokens.join("").length) return {
        token: tokens.length,
        offset: 0
    };
    return $a0933ef57ff1c2b9$export$66313c302b2ea154("Out of bounds: " + JSON.stringify({
        tokens: tokens,
        character_offset: character_offset
    }));
}



var $71ea9e6a68987862$exports = {};

$parcel$export($71ea9e6a68987862$exports, "Dropped", function () { return $71ea9e6a68987862$export$cd21c26327732088; });
$parcel$export($71ea9e6a68987862$exports, "Dragged", function () { return $71ea9e6a68987862$export$85474be84530bbbc; });
$parcel$export($71ea9e6a68987862$exports, "Edited", function () { return $71ea9e6a68987862$export$bd087b9eaaaf169d; });
$parcel$export($71ea9e6a68987862$exports, "match", function () { return $71ea9e6a68987862$export$4659b591c19bdf3d; });
$parcel$export($71ea9e6a68987862$exports, "dnd_match", function () { return $71ea9e6a68987862$export$2eb1db01bac868b0; });
$parcel$export($71ea9e6a68987862$exports, "tokens", function () { return $71ea9e6a68987862$export$6ad93df59e712c43; });
$parcel$export($71ea9e6a68987862$exports, "source", function () { return $71ea9e6a68987862$export$b4d5da5f34fb77ad; });
$parcel$export($71ea9e6a68987862$exports, "target", function () { return $71ea9e6a68987862$export$44271b4f0c6a3563; });
$parcel$export($71ea9e6a68987862$exports, "token_count", function () { return $71ea9e6a68987862$export$a361a8d103897fde; });
$parcel$export($71ea9e6a68987862$exports, "partition", function () { return $71ea9e6a68987862$export$b29f828819edca8d; });
$parcel$export($71ea9e6a68987862$exports, "Index", function () { return $71ea9e6a68987862$export$cf17b003b6192af3; });
$parcel$export($71ea9e6a68987862$exports, "mass_centers", function () { return $71ea9e6a68987862$export$297258f26f0c3976; });




const $71ea9e6a68987862$export$cd21c26327732088 = (target, id, manual)=>({
        edit: "Dropped",
        target: target,
        id: id,
        manual: manual
    });
const $71ea9e6a68987862$export$85474be84530bbbc = (source, id, manual)=>({
        edit: "Dragged",
        source: source,
        id: id,
        manual: manual
    });
const $71ea9e6a68987862$export$bd087b9eaaaf169d = (source, target, id, manual)=>({
        edit: "Edited",
        source: source,
        target: target,
        id: id,
        manual: manual
    });
function $71ea9e6a68987862$export$4659b591c19bdf3d(cases) {
    return (d)=>(cases[d.edit] || cases.default)(d);
}
function $71ea9e6a68987862$export$2eb1db01bac868b0(cases) {
    return (d)=>(cases[d.edit] || cases.default)(d);
}
const $71ea9e6a68987862$export$6ad93df59e712c43 = $71ea9e6a68987862$export$4659b591c19bdf3d({
    Edited: (d)=>[
            ...d.source,
            ...d.target
        ],
    Dragged: (d)=>[
            d.source
        ],
    Dropped: (d)=>[
            d.target
        ]
});
const $71ea9e6a68987862$export$b4d5da5f34fb77ad = $71ea9e6a68987862$export$4659b591c19bdf3d({
    Edited: (d)=>$58ccaae15ba3b7ae$export$6f093cfa640b7166(d.source),
    Dragged: (d)=>d.source.text,
    Dropped: (d)=>""
});
const $71ea9e6a68987862$export$44271b4f0c6a3563 = $71ea9e6a68987862$export$4659b591c19bdf3d({
    Edited: (d)=>$58ccaae15ba3b7ae$export$6f093cfa640b7166(d.target),
    Dragged: (d)=>"",
    Dropped: (d)=>d.target.text
});
const $71ea9e6a68987862$export$a361a8d103897fde = $71ea9e6a68987862$export$4659b591c19bdf3d({
    Edited: (d)=>d.target.length + d.source.length,
    Dragged: (d)=>1,
    Dropped: (d)=>1
});
function $71ea9e6a68987862$export$b29f828819edca8d(diff) {
    const dropped = [];
    const dragged = [];
    diff.forEach($71ea9e6a68987862$export$2eb1db01bac868b0({
        Dragged: (d)=>dragged.push(d),
        Dropped: (d)=>dropped.push(d)
    }));
    return {
        dropped: dropped,
        dragged: dragged
    };
}
function $71ea9e6a68987862$export$cf17b003b6192af3(ds) {
    return ds.map((d, index)=>({
            ...d,
            index: index
        }));
}
function $71ea9e6a68987862$export$297258f26f0c3976(diff) {
    return $d9d0435d2b879de6$export$871de8747c9eaa88($2acbb5ba886412c5$export$2e2bcd8739ae039((d)=>d.id, $71ea9e6a68987862$export$cf17b003b6192af3(diff)), (ds, id)=>{
        // try to move to a source position close to the center of mass of all involved positions
        const fractional_center_of_mass = $a0933ef57ff1c2b9$export$8a63f25cc62965f1(ds.map((d)=>d.index * $71ea9e6a68987862$export$a361a8d103897fde(d))) / $a0933ef57ff1c2b9$export$8a63f25cc62965f1(ds.map($71ea9e6a68987862$export$a361a8d103897fde));
        // snap-to-grid center of mass calculated only from source positions
        return $a0933ef57ff1c2b9$export$b65392d958998255((d)=>Math.abs(fractional_center_of_mass - d.index), ds).index;
    });
}


const $566cb6e3cba7cd4f$export$a27c3a1c44ba515b = (s)=>s === "source" ? "target" : "source";
const $566cb6e3cba7cd4f$export$832b6fa47fa053d2 = [
    "source",
    "target"
];
const $566cb6e3cba7cd4f$export$f9c0c991fb0646be = (side, s, t)=>side === "source" ? s : t;
function $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, f) {
    return {
        source: f(g.source, "source"),
        target: f(g.target, "target")
    };
}
function $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(ids, labels, manual = false, comment) {
    const ids_sorted = ids.sort();
    const labels_nub = $a0933ef57ff1c2b9$export$f70730c3d1fc524e(labels);
    return {
        id: "e-" + ids_sorted.join("-"),
        ids: ids_sorted,
        labels: labels_nub,
        manual: manual,
        ...comment && labels_nub.some($566cb6e3cba7cd4f$export$4d1b37ad7bc31b75) ? {
            comment: comment
        } : {}
    };
}
function $566cb6e3cba7cd4f$export$6b4ef9c17f912616(...es) {
    return $566cb6e3cba7cd4f$export$b9d9805c9b77a56d($a0933ef57ff1c2b9$export$5b8affa63fc6df16(es, (e)=>e.ids), $a0933ef57ff1c2b9$export$5b8affa63fc6df16(es, (e)=>e.labels), es.some((e)=>!!e.manual), $a0933ef57ff1c2b9$export$f70730c3d1fc524e(es.map((e)=>e.comment).filter(Boolean)).join("\n\n"));
}
const $566cb6e3cba7cd4f$export$d56f0e7673f0b9d9 = $566cb6e3cba7cd4f$export$6b4ef9c17f912616();
function $566cb6e3cba7cd4f$export$27823d486efd100e(es) {
    const out = {};
    es.forEach((e)=>out[e.id] = e);
    return out;
}
function $566cb6e3cba7cd4f$export$39ede186e36e8c0b(g) {
    try {
        const tokens = g.source.concat(g.target);
        {
            const unique_id = $a0933ef57ff1c2b9$export$6be1a247e0437315();
            tokens.forEach((t)=>unique_id(t.id) || $a0933ef57ff1c2b9$export$66313c302b2ea154("Duplicate id: " + t));
            $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>unique_id(e.id) || $a0933ef57ff1c2b9$export$66313c302b2ea154("Duplicate id from edges: " + e.id));
        }
        const check_tokens = (toks)=>{
            if (toks.length == 1) {
                const t = toks[0];
                t.match(/^\s*\S*\s*$/) || $a0933ef57ff1c2b9$export$66313c302b2ea154("Bad single token: " + JSON.stringify(t));
            } else toks.forEach((t, i)=>t.match(/^\s*\S+\s+$/) || $a0933ef57ff1c2b9$export$66313c302b2ea154("Bad text token: " + JSON.stringify(t)));
        };
        check_tokens($566cb6e3cba7cd4f$export$bcca83b25b058d41(g));
        check_tokens($566cb6e3cba7cd4f$export$1aa3e3e981886a9b(g));
        $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e, id)=>e.id === id || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Edge key and id do not match: ${id} and ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(e)}`));
        $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>e.ids.length > 0 || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Edge without any associated identifiers ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(e)}`));
        $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>!e.comment || e.labels.some($566cb6e3cba7cd4f$export$4d1b37ad7bc31b75) || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Edge with comment but no comment label: ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(e)}`));
        $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>$bb5c76e6a1c0ede6$export$2e2bcd8739ae039(e, $566cb6e3cba7cd4f$export$6b4ef9c17f912616(e)) || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Edge not in normal form: ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(e)}`));
        {
            const token_ids = new Set(tokens.map((t)=>t.id));
            $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>e.ids.forEach((id)=>{
                    token_ids.has(id) || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Edge ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(e)} refers to unknown token ${id}`);
                }));
        }
        {
            const token_count = $a0933ef57ff1c2b9$export$85b9a36db797e02b();
            $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>e.ids.forEach((id)=>token_count.inc(id)));
            tokens.forEach((tok)=>{
                const n = token_count.get(tok.id);
                n == 1 || $a0933ef57ff1c2b9$export$66313c302b2ea154("Token not appearing exactly once in edge lists: " + tok.id);
            });
        }
        $bb5c76e6a1c0ede6$export$2e2bcd8739ae039(g, $566cb6e3cba7cd4f$export$9ea32abc1be18076(g)) || $a0933ef57ff1c2b9$export$66313c302b2ea154("Graph not automatically aligned");
        g.comment !== "" || $a0933ef57ff1c2b9$export$66313c302b2ea154("Graph comment must not be empty string");
        $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>e.comment !== "" || $a0933ef57ff1c2b9$export$66313c302b2ea154("Edge comment must not be empty string"));
    } catch (e) {
        // console.error(e)
        // console.error(JSON.stringify(g, undefined, 2))
        return {
            violation: e.toString(),
            g: g
        };
    }
    return "ok";
}
function $566cb6e3cba7cd4f$export$23b96a0307014ab2(g) {
    return $566cb6e3cba7cd4f$export$39ede186e36e8c0b(g) === "ok";
}
function $566cb6e3cba7cd4f$export$2cd8252107eb640b(s, manual = false) {
    return $566cb6e3cba7cd4f$export$8170fdccd13fc536($58ccaae15ba3b7ae$export$660b2ee2d4fb4eff(s), manual);
}
function $566cb6e3cba7cd4f$export$8170fdccd13fc536(tokens, manual = false) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076({
        source: $58ccaae15ba3b7ae$export$65e5b62a4c490288(tokens, "s"),
        target: $58ccaae15ba3b7ae$export$65e5b62a4c490288(tokens, "t"),
        edges: $566cb6e3cba7cd4f$export$27823d486efd100e(tokens.map((_, i)=>$566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
                "s" + i,
                "t" + i
            ], [], manual)))
    });
}
function $566cb6e3cba7cd4f$export$6e22c362a0406a2c(g) {
    return !g.source.length || !g.target.length;
}
function $566cb6e3cba7cd4f$export$b9ae51c2964107cf(g, c) {
    return c ? {
        ...g,
        comment: c
    } : {
        source: g.source,
        target: g.target,
        edges: g.edges
    };
}
function $566cb6e3cba7cd4f$export$9cd59f9826255e47(graph) {
    return {
        source: graph.source.map((x)=>x),
        target: graph.target.map((x)=>x),
        edges: $d9d0435d2b879de6$export$871de8747c9eaa88(graph.edges, (x)=>({
                ...x
            })),
        ...graph.comment ? {
            comment: graph.comment
        } : {}
    };
}
function $566cb6e3cba7cd4f$export$cf3044484bb03519(st) {
    const edges = {};
    const g = $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(st, (toks, side)=>toks.map((tok, i)=>{
            const id = side[0] + i;
            const e = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
                id
            ], tok.labels, false);
            edges[id] = e;
            return $58ccaae15ba3b7ae$export$50792b0e93539fde(tok.text, id);
        }));
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076({
        ...g,
        edges: edges
    });
}
function $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g) {
    return new Map($a0933ef57ff1c2b9$export$bffa455ba8c619a6($d9d0435d2b879de6$export$df3f009e3d155b20(g.edges, (e)=>e.ids.map((id)=>[
                id,
                e
            ]))));
}
function $566cb6e3cba7cd4f$export$8d414a6135f9d320(g, ids) {
    const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
    const out = [];
    const first = $a0933ef57ff1c2b9$export$6be1a247e0437315();
    ids.forEach((id)=>{
        const e = em.get(id);
        if (e && first(e.id)) out.push(e);
    });
    return out;
}
function $566cb6e3cba7cd4f$export$d382192b07e5eedd(g, ids) {
    return $566cb6e3cba7cd4f$export$8d414a6135f9d320(g, ids).map((e)=>e.id);
}
function $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(g) {
    const sm = $566cb6e3cba7cd4f$export$d36e500d2474b487(g);
    const tm = $566cb6e3cba7cd4f$export$4d058cb8e7aacf9e(g);
    return (ids)=>{
        const source = [];
        const target = [];
        ids.forEach((id)=>{
            const s = sm.get(id);
            if (s !== undefined) source.push(g.source[s]);
            const t = tm.get(id);
            if (t !== undefined) target.push(g.target[t]);
        });
        return {
            source: source,
            target: target
        };
    };
}
function $566cb6e3cba7cd4f$export$a669ad57b3bc989b(g) {
    const m = $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, (tokens, side)=>tokens.map((token, index)=>[
                token.id,
                {
                    side: side,
                    index: index
                }
            ]));
    return new Map([
        ...m.source,
        ...m.target
    ]);
}
function $566cb6e3cba7cd4f$export$d36e500d2474b487(g) {
    return new Map(g.source.map((s, i)=>[
            s.id,
            i
        ]));
}
function $566cb6e3cba7cd4f$export$4d058cb8e7aacf9e(g) {
    return new Map(g.target.map((t, i)=>[
            t.id,
            i
        ]));
}
function $566cb6e3cba7cd4f$export$93a4046b31a058e0(g, index, side = "target") {
    const token_id = g[side][index].id;
    return $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g).get(token_id) || $a0933ef57ff1c2b9$export$66313c302b2ea154("Out of bounds: " + JSON.stringify({
        g: g,
        index: index
    }));
}
function $566cb6e3cba7cd4f$export$10a2f465a9af7604(g, index) {
    return $566cb6e3cba7cd4f$export$93a4046b31a058e0(g, index).ids;
}
function $566cb6e3cba7cd4f$export$8bc6b66de3102a9d(g) {
    return $58ccaae15ba3b7ae$export$6f093cfa640b7166(g.target);
}
function $566cb6e3cba7cd4f$export$4f78c7b40cf11a9a(g) {
    return $58ccaae15ba3b7ae$export$6f093cfa640b7166(g.source);
}
function $566cb6e3cba7cd4f$export$bcca83b25b058d41(g) {
    return $58ccaae15ba3b7ae$export$29f9f81de5c56283(g.target);
}
function $566cb6e3cba7cd4f$export$1aa3e3e981886a9b(g) {
    return $58ccaae15ba3b7ae$export$29f9f81de5c56283(g.source);
}
function $566cb6e3cba7cd4f$export$42ac17aabdaccaaf(g) {
    return $a0933ef57ff1c2b9$export$42ac17aabdaccaaf([
        ...g.target.map((t)=>t.id),
        ...g.source.map((t)=>t.id)
    ]);
}
function $566cb6e3cba7cd4f$export$13caaff6d048129b(g, from, to, text, side = "target") {
    const tokens = $566cb6e3cba7cd4f$export$45415d7f69065d4f(g, side);
    const { token: from_token, offset: from_ix } = $58ccaae15ba3b7ae$export$162b77d70e08a240(tokens, from);
    const pre = (tokens[from_token] || "").slice(0, from_ix);
    if (to === $566cb6e3cba7cd4f$export$e9abecb4b4534687(g, side).length) return $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from_token, g[side].length, pre + text, side);
    else {
        const { token: to_token, offset: to_ix } = $58ccaae15ba3b7ae$export$162b77d70e08a240(tokens, to);
        const post = (tokens[to_token] || "").slice(to_ix);
        return $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from_token, to_token + 1, pre + text + post, side);
    }
}
function $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from, to, text, side = "target") {
    if (from < 0 || to < 0 || from > g[side].length || to > g[side].length || from > to) throw new Error("Invalid coordinates " + $a0933ef57ff1c2b9$export$57bf213be019eeb0({
        g: g,
        from: from,
        to: to,
        text: text
    }));
    if (text.match(/^\s+$/)) {
        // replacement text is only whitespace: need to find some token to put it on
        if (from > 0) return $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from - 1, to, g[side][from - 1].text + text, side);
        else if (to < g[side].length) return $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from, to + 1, text + g[side][to].text, side);
    }
    if (text.match(/\S$/) && to < g[side].length) // if replacement text does not end with whitespace, grab the next word as well
    return $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from, to + 1, text + g[side][to].text, side);
    if (from > 0 && from == g[side].length && to === g[side].length) // we're adding a word at the end but the last token might not end in whitespace:
    // glue them together
    return $566cb6e3cba7cd4f$export$fc53b94a430e131(g, from - 1, to, g[side][from - 1].text + text, side);
    const id_offset = $566cb6e3cba7cd4f$export$42ac17aabdaccaaf(g);
    const tokens = $58ccaae15ba3b7ae$export$660b2ee2d4fb4eff(text).map((t, i)=>(0, $58ccaae15ba3b7ae$export$50792b0e93539fde)(t, side[0] + (id_offset + i)));
    const [new_tokens, removed] = $a0933ef57ff1c2b9$export$869882364835d202(g[side], from, to - from, ...tokens);
    const ids_removed = new Set(removed.map((t)=>t.id));
    const new_edge_ids = new Set(tokens.map((t)=>t.id));
    const new_edge_labels = new Set();
    let new_edge_manual = false;
    const edges = $d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (e)=>{
        if (e.ids.some((id)=>ids_removed.has(id))) {
            e.ids.forEach((id)=>ids_removed.has(id) || new_edge_ids.add(id));
            e.labels.forEach((lbl)=>new_edge_labels.add(lbl));
            new_edge_manual = new_edge_manual || e.manual === true;
            return false;
        } else return true;
    });
    if (new_edge_ids.size > 0) {
        const e = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
            ...new_edge_ids
        ], [
            ...new_edge_labels
        ], new_edge_manual);
        edges[e.id] = e;
    }
    return {
        ...g,
        [side]: new_tokens,
        edges: edges
    };
}
function $566cb6e3cba7cd4f$export$3ff57735a52b8713(g, from, to, text, side = "target") {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$13caaff6d048129b(g, from, to, text, side));
}
function $566cb6e3cba7cd4f$export$72d5c64f9cc56871(g, from, to, text, side = "target") {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$fc53b94a430e131(g, from, to, text, side));
}
function $566cb6e3cba7cd4f$export$14ebf44f366567dd(g, begin, end, dest) {
    const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
    const edge_ids_to_update = new Set(g.target.slice(begin, end + 1).map((t)=>em.get(t.id).id));
    const new_edges = {};
    edge_ids_to_update.forEach((id)=>{
        new_edges[id] = $566cb6e3cba7cd4f$export$6b4ef9c17f912616(g.edges[id], $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([], [], true));
    });
    return {
        ...g,
        source: g.source,
        target: $a0933ef57ff1c2b9$export$3286e37e80af903(g.target, begin, end, dest),
        edges: {
            ...g.edges,
            ...new_edges
        }
    };
}
function $566cb6e3cba7cd4f$export$3286e37e80af903(g, begin, end, dest) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$14ebf44f366567dd(g, begin, end, dest));
}
function $566cb6e3cba7cd4f$export$43b47dab349addfb(g, side, text) {
    const text0 = $566cb6e3cba7cd4f$export$e9abecb4b4534687(g, side);
    const { from: from, to: to } = $a0933ef57ff1c2b9$export$5160ab928f687bd(text0, text);
    const new_text = text.slice(from, text.length - (text0.length - to));
    return $566cb6e3cba7cd4f$export$13caaff6d048129b(g, from, to, new_text, side);
}
function $566cb6e3cba7cd4f$export$fa4f16e9ce2f3748(g, text) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$43b47dab349addfb(g, "target", text));
}
function $566cb6e3cba7cd4f$export$abfa187bec951c1(g, text) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$43b47dab349addfb(g, "source", text));
}
function $566cb6e3cba7cd4f$export$d1eddfd431b5acad(g, side, text) {
    return $566cb6e3cba7cd4f$export$f9c0c991fb0646be(side, $566cb6e3cba7cd4f$export$abfa187bec951c1, $566cb6e3cba7cd4f$export$fa4f16e9ce2f3748)(g, text);
}
function $566cb6e3cba7cd4f$export$e9abecb4b4534687(g, side) {
    return $58ccaae15ba3b7ae$export$6f093cfa640b7166(g[side]);
}
function $566cb6e3cba7cd4f$export$45415d7f69065d4f(g, side) {
    return $58ccaae15ba3b7ae$export$29f9f81de5c56283(g[side]);
}
function $566cb6e3cba7cd4f$export$be93d9364d30f087(g) {
    return {
        ...g,
        source: g.target,
        target: g.source
    };
}
function $566cb6e3cba7cd4f$export$6897c284b6f9f4dc(g) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$be93d9364d30f087(g));
}
function $566cb6e3cba7cd4f$export$b39b0465aa0379b9(g, edge_ids) {
    const edge_set = new Set(edge_ids);
    const diff = $566cb6e3cba7cd4f$export$157d502e885eaac3(g);
    let supply = $566cb6e3cba7cd4f$export$42ac17aabdaccaaf(g);
    const edges = $d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (_, id)=>!edge_set.has(id));
    const reverted = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(diff, $71ea9e6a68987862$export$2eb1db01bac868b0({
        Dragged (d) {
            if (edge_set.has(d.id)) {
                const s = d.source;
                const t = {
                    ...d.source,
                    id: "t" + supply++
                };
                const e = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
                    s.id,
                    t.id
                ], []);
                edges[e.id] = e;
                return [
                    $71ea9e6a68987862$export$85474be84530bbbc(s, e.id, false),
                    $71ea9e6a68987862$export$cd21c26327732088(t, e.id, false)
                ];
            } else return [
                d
            ];
        },
        Dropped (d) {
            if (edge_set.has(d.id)) return [];
            else return [
                d
            ];
        }
    }));
    return {
        ...g,
        ...$566cb6e3cba7cd4f$export$4f76bac744e2a890(reverted, edges)
    };
}
function $566cb6e3cba7cd4f$export$3fdd26f3d9e7dc78(g, edge_ids) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$b39b0465aa0379b9(g, edge_ids));
}
function $566cb6e3cba7cd4f$export$64605811ab45167f(g, edge_ids) {
    const edges = $d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (e, _)=>!edge_ids.some((id)=>id == e.id));
    const es = $d9d0435d2b879de6$export$df3f009e3d155b20($d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (e, _)=>edge_ids.some((id)=>id == e.id)), (e)=>e);
    const edge = $566cb6e3cba7cd4f$export$6b4ef9c17f912616(...es, $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([], [], true));
    edges[edge.id] = edge;
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076({
        ...g,
        edges: edges
    });
}
function $566cb6e3cba7cd4f$export$37dfea93db2e14ed(g, ids) {
    if (ids.length == 0) return $566cb6e3cba7cd4f$export$9ea32abc1be18076(g);
    const id = ids[0];
    const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
    const edge = em.get(id);
    if (edge) {
        const edge_without = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(edge.ids.filter((i)=>i != id), edge.labels, true, edge.comment);
        const edge_with = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
            id
        ], [], true, edge.comment);
        const edges = $d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (_, id)=>id != edge.id);
        edges[edge_with.id] = edge_with;
        if (edge_without.ids.length > 0) edges[edge_without.id] = edge_without;
        return $566cb6e3cba7cd4f$export$37dfea93db2e14ed({
            ...g,
            edges: edges
        }, ids.slice(1));
    } else {
        $a0933ef57ff1c2b9$export$8343b6e3d09a3606({
            id: id,
            ids: ids,
            g: g
        });
        return $a0933ef57ff1c2b9$export$66313c302b2ea154("Trying to disconnect unidentifiable token");
    }
}
function $566cb6e3cba7cd4f$export$21198a890f6b0d7d(g, edge, side) {
    return edge.ids.map((id)=>$566cb6e3cba7cd4f$export$a669ad57b3bc989b(g).get(id)).filter((si)=>si.side == side).map((si)=>si.index).shift();
}
function $566cb6e3cba7cd4f$export$83844fbbb0a27299(g, edges, side) {
    return $a0933ef57ff1c2b9$export$a01aafba61e29e63(edges, (e)=>{
        let i = $566cb6e3cba7cd4f$export$21198a890f6b0d7d(g, e, side);
        return i !== undefined ? i : -1;
    });
}
/**

  [
    {char: ' ', id: undefined},
    {char: 'a', id: 'id'},
    {char: 'b', id: 'id'},
    {char: ' ', id: undefined}
  ] // => to_char_ids(Token(' ab ', 'id'))

*/ function $566cb6e3cba7cd4f$var$to_char_ids(token) {
    return $a0933ef57ff1c2b9$export$d04e030ebc4d0326(token.text, (char)=>({
            char: char,
            id: char === " " ? undefined : token.id
        }));
}
function $566cb6e3cba7cd4f$export$9ea32abc1be18076(g) {
    // Use a union-find to group characters into edges.
    const uf = $a0933ef57ff1c2b9$export$6b13ca446b1d0fd3((u)=>u);
    const em = $a0933ef57ff1c2b9$export$e08e3b67e392101e($566cb6e3cba7cd4f$export$13b0e7a577fb573c(g), (m)=>(id)=>m.get(id) || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Token id ${id} not in edge map`));
    {
        // Character by character, what was deleted and inserted?
        const chars = $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, (tokens)=>$a0933ef57ff1c2b9$export$5b8affa63fc6df16(tokens.filter((token)=>!em(token.id).manual), $566cb6e3cba7cd4f$var$to_char_ids));
        const char_diff = $a0933ef57ff1c2b9$export$6baddf9e2d3d7a3b(chars.source, chars.target, (u)=>u.char, (u)=>u.char);
        // For any unchanged character, unify its source and target tokens.
        // If source is "a bc" and target is "ab c", all characters will be unified to the same group.
        // The union-find operates over token ids, so an edge is represented by a "root" token id.
        char_diff.forEach((c)=>{
            if (c.change == 0) // these undefined makes the alignment skip spaces.
            // they originate from to_char_ids
            {
                if (c.a.id !== undefined && c.b.id !== undefined) uf.union(c.a.id, c.b.id);
            }
        });
    }
    // Use manual edges as they are.
    const proto_edges = $d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (e)=>!!e.manual);
    const first = $a0933ef57ff1c2b9$export$6be1a247e0437315();
    $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, (tokens, side)=>tokens.forEach((token)=>{
            let e_repr = em(token.id);
            // Skip manual edges, they have already been added.
            if (!e_repr.manual) {
                // Use the labels from the old edge.
                const labels = first(e_repr.id) ? e_repr.labels : [];
                // New edges are temporarily keyed by the "root" token id.
                // Merge a single-token edge into the edge that has the same "root" token.
                // Or add as a new edge if there is no such edge yet.
                const e_token = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
                    token.id
                ], labels, false, e_repr.comment);
                $d9d0435d2b879de6$export$3ff57735a52b8713(proto_edges, uf.find(token.id), $566cb6e3cba7cd4f$export$d56f0e7673f0b9d9, (e)=>$566cb6e3cba7cd4f$export$6b4ef9c17f912616(e, e_token));
            }
        }));
    // Re-key edges.
    const edges = $566cb6e3cba7cd4f$export$27823d486efd100e($d9d0435d2b879de6$export$df3f009e3d155b20(proto_edges, (e)=>e));
    return {
        ...g,
        edges: edges
    };
}
function $566cb6e3cba7cd4f$export$801569266451b712(g, order_changing_label = ()=>false) {
    const m = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
    const lookup = (tok)=>m.get(tok.id);
    const I = g.source.length;
    const J = g.target.length;
    const OPT = new Array(I + 1).fill({}).map((i)=>new Array(J + 1).fill({
            score: 0,
            diff: null
        }));
    function opt(i, j) {
        if (i < 0 && j < 0) return {
            score: 0,
            diff: null
        };
        else return OPT[i + 1][j + 1];
    }
    for(let i = -1; i < I; ++i)for(let j = -1; j < J; ++j){
        const cands = [];
        const same = (ii, jj)=>ii >= 0 && jj >= 0 && lookup(g.source[ii]).id === lookup(g.target[jj]).id;
        if (i >= 0 && j >= 0 && same(i, j)) {
            let ii = i;
            let jj = j;
            while(same(--ii, j));
            while(same(i, --jj));
            const edge = lookup(g.source[i]);
            const { score: score, diff: diff } = opt(ii, jj);
            let factor = 1;
            if (edge.manual) factor *= 0.01;
            if (edge.labels.some(order_changing_label)) factor *= 0.0001;
            cands.push({
                score: score + factor * (i - ii + (j - jj)),
                diff: $a0933ef57ff1c2b9$export$c40cf5aab899f397(diff, $71ea9e6a68987862$export$bd087b9eaaaf169d(g.source.slice(ii + 1, i + 1), g.target.slice(jj + 1, j + 1), edge.id, !!edge.manual))
            });
        }
        if (j >= 0) {
            const { score: score, diff: diff } = opt(i, j - 1);
            const edge = lookup(g.target[j]);
            cands.push({
                score: score,
                diff: $a0933ef57ff1c2b9$export$c40cf5aab899f397(diff, $71ea9e6a68987862$export$cd21c26327732088(g.target[j], edge.id, !!edge.manual))
            });
        }
        if (i >= 0) {
            const { score: score, diff: diff } = opt(i - 1, j);
            const edge = lookup(g.source[i]);
            cands.push({
                score: score,
                diff: $a0933ef57ff1c2b9$export$c40cf5aab899f397(diff, $71ea9e6a68987862$export$85474be84530bbbc(g.source[i], edge.id, !!edge.manual))
            });
        }
        OPT[i + 1][j + 1] = $88cf8f066fd3d09d$export$2e2bcd8739ae039((x)=>-x.score, cands)[0];
    }
    const { score: score, diff: diff } = opt(I - 1, J - 1);
    const arr = $a0933ef57ff1c2b9$export$9c5cd851e3a05d4a(diff);
    return arr;
}
function $566cb6e3cba7cd4f$export$d05562b754e74081(ds, audit = (edge_id)=>true) {
    return $a0933ef57ff1c2b9$export$5b8affa63fc6df16(ds, (d)=>{
        if (d.edit == "Edited" && audit(d.id)) return [
            ...d.source.map((t)=>$71ea9e6a68987862$export$85474be84530bbbc(t, d.id, d.manual)),
            ...d.target.map((t)=>$71ea9e6a68987862$export$cd21c26327732088(t, d.id, d.manual))
        ];
        else return [
            d
        ];
    });
}
function $566cb6e3cba7cd4f$export$157d502e885eaac3(g, order_changing_label = ()=>false) {
    return $566cb6e3cba7cd4f$export$d05562b754e74081($566cb6e3cba7cd4f$export$801569266451b712(g, order_changing_label));
}
function $566cb6e3cba7cd4f$export$4f76bac744e2a890(diff, edges0) {
    const source = [];
    const target = [];
    const edges = $5d3293da545595c4$export$2e2bcd8739ae039(edges0);
    diff.forEach((d)=>$d9d0435d2b879de6$export$3ff57735a52b8713(edges, d.id, $566cb6e3cba7cd4f$export$d56f0e7673f0b9d9, (e)=>$566cb6e3cba7cd4f$export$6b4ef9c17f912616(e, $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([], [], d.manual))));
    diff.forEach($71ea9e6a68987862$export$2eb1db01bac868b0({
        Dragged: (d)=>source.push(d.source),
        Dropped: (d)=>target.push(d.target)
    }));
    return {
        source: source,
        target: target,
        edges: edges
    };
}
function $566cb6e3cba7cd4f$export$3cf150b3f5a90d5f(diff, edges) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($566cb6e3cba7cd4f$export$4f76bac744e2a890($566cb6e3cba7cd4f$export$d05562b754e74081(diff), edges));
}
function $566cb6e3cba7cd4f$export$32fe3c41b81e8036(g, i) {
    return $58ccaae15ba3b7ae$export$ae6a5ab41f356242($566cb6e3cba7cd4f$export$bcca83b25b058d41(g), i);
}
function $566cb6e3cba7cd4f$export$cccc4cc31d5a14b(ss) {
    let { source: source, target: target } = ss[0];
    ss.forEach((s)=>{
        source = $58ccaae15ba3b7ae$export$26e4dba69d72ef56(source, s.source);
        target = $58ccaae15ba3b7ae$export$26e4dba69d72ef56(target, s.target);
    });
    return {
        source: source,
        target: target
    };
}
function $566cb6e3cba7cd4f$export$2fd78a041f969714(subspan) {
    const span_to_indicies = (side)=>[
            {
                side: side,
                index: subspan[side].begin
            },
            {
                side: side,
                index: subspan[side].end
            }
        ];
    return [
        ...span_to_indicies("source"),
        ...span_to_indicies("target")
    ];
}
function $566cb6e3cba7cd4f$export$e54858d5d3f4b923(g, target_index) {
    return $566cb6e3cba7cd4f$export$49709d8cccb10e07(g, [
        {
            side: "target",
            index: target_index
        }
    ]);
}
function $566cb6e3cba7cd4f$export$49709d8cccb10e07(g, indicies) {
    const starts = $a0933ef57ff1c2b9$export$6b13ca446b1d0fd3();
    const bounds = $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, (tokens, side)=>{
        const bs = $58ccaae15ba3b7ae$export$25e87b990f51ada5($58ccaae15ba3b7ae$export$29f9f81de5c56283(tokens));
        bs.forEach((start, index)=>{
            starts.union({
                side: side,
                index: index
            }, {
                side: side,
                index: start
            });
        });
        return bs;
    });
    const m = $566cb6e3cba7cd4f$export$a669ad57b3bc989b(g);
    $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>{
        const ids = e.ids.map((id)=>m.get(id));
        starts.unions(ids);
    });
    starts.unions(indicies);
    const main = indicies[0];
    // grr-ish: we want to get the "minimal" representative now, but have to loop over
    // all positions to check.
    const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
    const main_repr = starts.repr(main);
    return $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, (tokens, side)=>{
        // If sentence starts or ends with only removed tokens we slurp these straggler tokens:
        function pad_missing(d, index) {
            if (index < 0) return 0;
            if (index >= tokens.length) return tokens.length - 1;
            const adjacent = tokens[index + d];
            if (!adjacent) return index;
            const edge = em.get(adjacent.id);
            if (!edge) return index;
            const all_on_this_side = edge.ids.every((id)=>{
                const token = m.get(id);
                return token ? token.side == side : false;
            });
            if (!all_on_this_side) return index;
            return pad_missing(d, index + d);
        }
        return {
            begin: pad_missing(-1, tokens.findIndex((_, index)=>starts.repr({
                    side: side,
                    index: index
                }) == main_repr)),
            end: pad_missing(1, $a0933ef57ff1c2b9$export$8855a8be7bd3e9f8(tokens, (_, index)=>starts.repr({
                    side: side,
                    index: index
                }) == main_repr))
        };
    });
}
function $566cb6e3cba7cd4f$export$c662939406e0fc09(g, begin = 0) {
    if (begin >= g.target.length) return [];
    else {
        const s = $566cb6e3cba7cd4f$export$e54858d5d3f4b923(g, begin);
        return [
            s
        ].concat($566cb6e3cba7cd4f$export$c662939406e0fc09(g, s.target.end + 1));
    }
}
function $566cb6e3cba7cd4f$export$ecd98896577df54e(g, s) {
    const source = g.source.slice(s.source.begin, s.source.end + 1);
    const target = g.target.slice(s.target.begin, s.target.end + 1);
    const proto_g = {
        source: source,
        target: target,
        edges: $566cb6e3cba7cd4f$export$27823d486efd100e([])
    };
    const sm = $566cb6e3cba7cd4f$export$d36e500d2474b487(proto_g);
    const tm = $566cb6e3cba7cd4f$export$4d058cb8e7aacf9e(proto_g);
    const edges = $d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (e)=>e.ids.some((id)=>sm.has(id) || tm.has(id)));
    return {
        source: source,
        target: target,
        edges: edges
    };
}
function $566cb6e3cba7cd4f$export$33eaa0f45f0e6960(g, side, positions) {
    const N = $566cb6e3cba7cd4f$export$8bc6b66de3102a9d(g).length;
    const nearby = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(positions, (i)=>[
            i - 1,
            i,
            i + 1
        ]);
    const in_bounds = nearby.filter((i)=>$a0933ef57ff1c2b9$export$f28d906d67a997f3(0, i, N));
    return in_bounds.map((i)=>({
            side: side,
            index: $58ccaae15ba3b7ae$export$162b77d70e08a240($566cb6e3cba7cd4f$export$45415d7f69065d4f(g, side), i).token
        }));
}
function $566cb6e3cba7cd4f$export$a26fd11fb69f7d4c(gs) {
    return $a0933ef57ff1c2b9$export$77d92587fe11873($d9d0435d2b879de6$export$871de8747c9eaa88(gs, (g)=>$566cb6e3cba7cd4f$export$c662939406e0fc09(g)), $566cb6e3cba7cd4f$export$cccc4cc31d5a14b, $e7a3aede200ee572$export$2e2bcd8739ae039("source"));
}
function $566cb6e3cba7cd4f$export$479ec94dbc76044a(g) {
    return $a0933ef57ff1c2b9$export$f70730c3d1fc524e($a0933ef57ff1c2b9$export$5b8affa63fc6df16(Object.values(g.edges), (e)=>e.labels));
}
function $566cb6e3cba7cd4f$export$4d1b37ad7bc31b75(label) {
    return label.indexOf("!") != -1;
}
function $566cb6e3cba7cd4f$export$5f402a225d1edecc(g, edge_id, k) {
    const store = (0, $17d8c0717df1150b$exports.Store).init(g);
    const edge = $566cb6e3cba7cd4f$export$9450cd7eaa1fab13(store, edge_id);
    edge.modify((e)=>{
        const labels = k(e.labels);
        const comment = labels.some($566cb6e3cba7cd4f$export$4d1b37ad7bc31b75) ? e.comment : undefined;
        return $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(e.ids, labels, e.manual, comment);
    });
    return store.get();
}
function $566cb6e3cba7cd4f$export$3ad331fd950bc447(g, edge_id, comment) {
    const store = (0, $17d8c0717df1150b$exports.Store).init(g);
    const edge = $566cb6e3cba7cd4f$export$9450cd7eaa1fab13(store, edge_id);
    edge.modify((e)=>$566cb6e3cba7cd4f$export$b9d9805c9b77a56d(e.ids, e.labels, e.manual, comment));
    return store.get();
}
function $566cb6e3cba7cd4f$export$9450cd7eaa1fab13(g, edge_id) {
    return g.at("edges").via((0, $17d8c0717df1150b$exports.Lens).key(edge_id)).via((0, $17d8c0717df1150b$exports.Lens).def($566cb6e3cba7cd4f$export$b9d9805c9b77a56d([], [])));
}
function $566cb6e3cba7cd4f$export$a3295358bff77e(g, set_manual_to = true, s_prefix = "s", t_prefix = "t") {
    const rev = {};
    const rn = $a0933ef57ff1c2b9$export$4b1ceda60dba9c5a();
    g.source.forEach((tk)=>rn.num(tk.id));
    g.target.forEach((tk)=>rn.num(tk.id));
    const N = g.source.length;
    const new_id = (id)=>{
        const i = rn.num(id);
        return i < N || s_prefix == t_prefix ? s_prefix + i : t_prefix + (i - N);
    };
    const source = g.source.map((s)=>(0, $58ccaae15ba3b7ae$export$50792b0e93539fde)(s.text, new_id(s.id)));
    const target = g.target.map((s)=>(0, $58ccaae15ba3b7ae$export$50792b0e93539fde)(s.text, new_id(s.id)));
    const edges = $921bdc4e1290d437$export$2e2bcd8739ae039($d9d0435d2b879de6$export$df3f009e3d155b20(g.edges, (e)=>{
        const E = $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(e.ids.map(new_id), e.labels.sort(), set_manual_to === "keep" ? e.manual : set_manual_to, e.comment);
        return [
            E.id,
            E
        ];
    }));
    return {
        source: source,
        target: target,
        edges: edges,
        ...g.comment ? {
            comment: g.comment
        } : {}
    };
}
function $566cb6e3cba7cd4f$export$411ce8e5a71e3069(g1, g2, set_manual_to = true) {
    return $bb5c76e6a1c0ede6$export$2e2bcd8739ae039($566cb6e3cba7cd4f$export$a3295358bff77e(g1, set_manual_to), $566cb6e3cba7cd4f$export$a3295358bff77e(g2, set_manual_to));
}
function $566cb6e3cba7cd4f$export$a2d48d31bcf0d424(g, ws = " ") {
    const on_tok = (s)=>(0, $58ccaae15ba3b7ae$export$50792b0e93539fde)((s.text.match(/\S+/) || [
            ""
        ])[0] + ws, s.id);
    return {
        ...g,
        source: g.source.map(on_tok),
        target: g.target.map(on_tok)
    };
}
function $566cb6e3cba7cd4f$export$97d6f5b546d7d09f(g, make_manual = true) {
    let i = $566cb6e3cba7cd4f$export$42ac17aabdaccaaf(g);
    const rename_map = {};
    const target = g.source.map((s)=>{
        const id = "t" + i++;
        rename_map[s.id] = id;
        return (0, $58ccaae15ba3b7ae$export$50792b0e93539fde)(s.text, id);
    });
    const edges = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(Object.values(g.edges), (e)=>{
        const ids = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(e.ids, (sid)=>{
            const tid = rename_map[sid];
            if (tid) return [
                sid,
                tid
            ];
            else return [];
        });
        if (ids.length > 0) return [
            $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(ids, e.labels, make_manual, e.comment)
        ];
        else return [];
    });
    return {
        source: g.source,
        target: target,
        edges: $566cb6e3cba7cd4f$export$27823d486efd100e(edges)
    };
}
function $566cb6e3cba7cd4f$export$3d1c8131457e647(g, order) {
    return {
        ...g,
        edges: $d9d0435d2b879de6$export$871de8747c9eaa88(g.edges, (e)=>$566cb6e3cba7cd4f$export$b9d9805c9b77a56d(e.ids, $88cf8f066fd3d09d$export$2e2bcd8739ae039(order, e.labels), e.manual, e.comment))
    };
}
function $566cb6e3cba7cd4f$export$c555d49ba8ab6cad(g, filter) {
    const label_edge_map = {};
    $d9d0435d2b879de6$export$4b80e395e36b5a56(g.edges, (e)=>e.labels.forEach((l)=>(!filter || filter(l)) && $a0933ef57ff1c2b9$export$4cbf152802aa238(label_edge_map, l, e)));
    return label_edge_map;
}



var $ad3f23047509641d$exports = {};

$parcel$export($ad3f23047509641d$exports, "mapGrid", function () { return $ad3f23047509641d$export$958f23b6cd75b4ae; });
$parcel$export($ad3f23047509641d$exports, "mapLine", function () { return $ad3f23047509641d$export$4246969f50ac043e; });
$parcel$export($ad3f23047509641d$exports, "mapGrids", function () { return $ad3f23047509641d$export$4e9beafb3583b360; });
$parcel$export($ad3f23047509641d$exports, "DiffToGrid", function () { return $ad3f23047509641d$export$7fde6103dc528d71; });
$parcel$export($ad3f23047509641d$exports, "Grid", function () { return $ad3f23047509641d$export$ef2184bd89960b14; });
$parcel$export($ad3f23047509641d$exports, "ProtoLines", function () { return $ad3f23047509641d$export$12be675ce16eb752; });
$parcel$export($ad3f23047509641d$exports, "VFlip", function () { return $ad3f23047509641d$export$3f527ed3bed4a429; });




function $ad3f23047509641d$export$958f23b6cd75b4ae(grid, f) {
    return grid.map((col)=>col.map((line)=>$ad3f23047509641d$export$4246969f50ac043e(line, f)));
}
function $ad3f23047509641d$export$4e9beafb3583b360(grids, f) {
    return {
        upper: $ad3f23047509641d$export$958f23b6cd75b4ae(grids.upper, f),
        lower: $ad3f23047509641d$export$958f23b6cd75b4ae(grids.lower, f)
    };
}
function $ad3f23047509641d$export$7fde6103dc528d71(diff) {
    return {
        upper: $ad3f23047509641d$export$ef2184bd89960b14($ad3f23047509641d$export$12be675ce16eb752(diff, "Dragged"), diff.length),
        lower: $ad3f23047509641d$export$3f527ed3bed4a429($ad3f23047509641d$export$ef2184bd89960b14($ad3f23047509641d$export$12be675ce16eb752(diff, "Dropped"), diff.length))
    };
}
function $ad3f23047509641d$export$12be675ce16eb752(diff, keep) {
    const centers = (0, $71ea9e6a68987862$export$297258f26f0c3976)(diff);
    return $88cf8f066fd3d09d$export$2e2bcd8739ae039((r)=>r.lines.length, $d9d0435d2b879de6$export$df3f009e3d155b20($2acbb5ba886412c5$export$2e2bcd8739ae039((d)=>d.id, (0, $71ea9e6a68987862$export$cf17b003b6192af3)(diff)), (ds, id)=>{
        const center_of_mass = centers[ds[0].id];
        const lines = ds.filter((d)=>{
            if (d.edit == "Edited") return keep == "Dragged" && d.source.length > 0 || keep == "Dropped" && d.target.length > 0;
            else return d.edit == keep;
        }).map((d)=>({
                from: d.index,
                to: center_of_mass
            }));
        return {
            id: id,
            center_of_mass: center_of_mass,
            lines: lines
        };
    }));
}
function $ad3f23047509641d$export$4246969f50ac043e(l, f) {
    return {
        ...l,
        meta: f(l.meta)
    };
}
function $ad3f23047509641d$export$ef2184bd89960b14(proto_lines, width) {
    const heights = new Array(width).fill(0);
    const out_lines = heights.map((_)=>[]);
    const postponed = [];
    proto_lines.forEach(({ id: id, lines: lines })=>{
        if (lines.length == 0) return;
        const poses = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(lines, (pl)=>[
                pl.from,
                pl.to
            ]);
        const lo = $a0933ef57ff1c2b9$export$916782c1f0ddb132(poses);
        const hi = $a0933ef57ff1c2b9$export$b25e0be55f42c9a(poses);
        const range = $699c2821590b6e22$export$2e2bcd8739ae039(lo, hi + 1);
        const vertical = lines.length == 1 && lines[0].from == lines[0].to;
        const h = $a0933ef57ff1c2b9$export$b25e0be55f42c9a(range.map((i)=>heights[i])) + (vertical ? 0 : 1);
        range.map((i)=>heights[i] = h);
        postponed.push((final_height)=>lines.map((line)=>{
                if (line.from == line.to) out_lines[line.from].push({
                    x0: 0.5,
                    y0: 0,
                    x1: 0.5,
                    y1: 1,
                    meta: {
                        id: id
                    }
                });
                else {
                    const dir = line.to > line.from ? "right" : "left";
                    const x0 = dir == "left" ? 1 : 0;
                    const x1 = dir == "left" ? 0 : 1;
                    const y = h / final_height;
                    out_lines[line.from].push({
                        x0: 0.5,
                        y0: 0,
                        x1: x1,
                        y1: y,
                        meta: {
                            id: id
                        }
                    });
                    const dx = dir == "left" ? -1 : 1;
                    let x = line.from + dx;
                    while(x != line.to){
                        out_lines[x].push({
                            x0: x0,
                            y0: y,
                            x1: x1,
                            y1: y,
                            meta: {
                                id: id
                            }
                        });
                        x += dx;
                    }
                    out_lines[line.to].push({
                        x0: x0,
                        y0: y,
                        x1: 0.5,
                        y1: 1,
                        meta: {
                            id: id
                        }
                    });
                }
            }));
    });
    const height = $a0933ef57ff1c2b9$export$b25e0be55f42c9a(heights) + 1;
    postponed.map((k)=>k(height));
    return out_lines;
}
function $ad3f23047509641d$export$3f527ed3bed4a429(grid) {
    return grid.map((column)=>column.map((line)=>({
                ...line,
                y0: 1 - line.y0,
                y1: 1 - line.y1
            })));
}


var $c625aec54bd34bcf$exports = {};

$parcel$export($c625aec54bd34bcf$exports, "enrichen", function () { return $c625aec54bd34bcf$export$17043b50a1e129e6; });
$parcel$export($c625aec54bd34bcf$exports, "restrict_to_side", function () { return $c625aec54bd34bcf$export$f01a9127b9ddc1c; });




function $c625aec54bd34bcf$export$17043b50a1e129e6(g, order_changing_label = ()=>false) {
    const diff = $566cb6e3cba7cd4f$export$801569266451b712(g, order_changing_label);
    const partition = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(g);
    return $71ea9e6a68987862$export$cf17b003b6192af3(diff).map((d)=>{
        switch(d.edit){
            case "Edited":
                return {
                    ...d,
                    source_diffs: $a0933ef57ff1c2b9$export$9f1a18fcf029fd45($58ccaae15ba3b7ae$export$29f9f81de5c56283(d.source), $58ccaae15ba3b7ae$export$6f093cfa640b7166(d.target)),
                    target_diffs: $a0933ef57ff1c2b9$export$9f1a18fcf029fd45($58ccaae15ba3b7ae$export$29f9f81de5c56283(d.target), $58ccaae15ba3b7ae$export$6f093cfa640b7166(d.source)).map($a0933ef57ff1c2b9$export$ca60277ef2eae2d4)
                };
            case "Dragged":
                {
                    const { source: source, target: target } = partition(g.edges[d.id].ids);
                    const source_diff = $a0933ef57ff1c2b9$export$9f1a18fcf029fd45($58ccaae15ba3b7ae$export$29f9f81de5c56283(source), $58ccaae15ba3b7ae$export$6f093cfa640b7166(target));
                    const i = source.findIndex((s)=>s.id == d.source.id);
                    return {
                        ...d,
                        source_diff: source_diff[i]
                    };
                }
            case "Dropped":
                {
                    const { source: source, target: target } = partition(g.edges[d.id].ids);
                    const target_diff = $a0933ef57ff1c2b9$export$9f1a18fcf029fd45($58ccaae15ba3b7ae$export$29f9f81de5c56283(target), $58ccaae15ba3b7ae$export$6f093cfa640b7166(source)).map($a0933ef57ff1c2b9$export$ca60277ef2eae2d4);
                    const i = target.findIndex((t)=>t.id == d.target.id);
                    return {
                        ...d,
                        target_diff: target_diff[i]
                    };
                }
        }
    });
}
function $c625aec54bd34bcf$export$f01a9127b9ddc1c(rd, side) {
    if (side === "source") return rd.filter((d)=>d.edit != "Dropped").map((d)=>d.edit == "Edited" ? {
            ...d,
            target: [],
            target_diffs: []
        } : d);
    else if (side === "target") return rd.filter((d)=>d.edit != "Dragged").map((d)=>d.edit == "Edited" ? {
            ...d,
            source: [],
            source_diffs: []
        } : d);
    else return rd;
}



var $8f42eafc2f1b3c8d$exports = {};

$parcel$export($8f42eafc2f1b3c8d$exports, "parse", function () { return $8f42eafc2f1b3c8d$export$98e6a39c04603d36; });
$parcel$export($8f42eafc2f1b3c8d$exports, "parse_strict", function () { return $8f42eafc2f1b3c8d$export$554ca05e3f76eca5; });
$parcel$export($8f42eafc2f1b3c8d$exports, "units_to_graph", function () { return $8f42eafc2f1b3c8d$export$9cb5350a7a87beb; });
$parcel$export($8f42eafc2f1b3c8d$exports, "units_to_string", function () { return $8f42eafc2f1b3c8d$export$a4a6ecdacd1cddbe; });
$parcel$export($8f42eafc2f1b3c8d$exports, "proto_graph_to_units", function () { return $8f42eafc2f1b3c8d$export$4a1451e37fdf0cf8; });
$parcel$export($8f42eafc2f1b3c8d$exports, "minimize", function () { return $8f42eafc2f1b3c8d$export$bd1f3e32ee61fba2; });
$parcel$export($8f42eafc2f1b3c8d$exports, "graph_to_units", function () { return $8f42eafc2f1b3c8d$export$93d135f93a177c5; });
$parcel$export($8f42eafc2f1b3c8d$exports, "graph_to_compact", function () { return $8f42eafc2f1b3c8d$export$18523638253a9637; });
$parcel$export($8f42eafc2f1b3c8d$exports, "compact_to_graph", function () { return $8f42eafc2f1b3c8d$export$c4038c4546988c18; });
var $b04b6dbdae1c30eb$exports = {};
"use strict";
Object.defineProperty($b04b6dbdae1c30eb$exports, "__esModule", {
    value: true
});
var $e11eb2700046c52f$exports = {};
"use strict";
var $e11eb2700046c52f$var$__assign = $e11eb2700046c52f$exports && $e11eb2700046c52f$exports.__assign || function() {
    $e11eb2700046c52f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e11eb2700046c52f$var$__assign.apply(this, arguments);
};
Object.defineProperty($e11eb2700046c52f$exports, "__esModule", {
    value: true
});
var $da18856e9734b7b7$exports = {};
"use strict";
Object.defineProperty($da18856e9734b7b7$exports, "__esModule", {
    value: true
});
/**
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.identity = function(a) {
    return a;
};
/**
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.unsafeCoerce = $da18856e9734b7b7$exports.identity;
/**
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.not = function(predicate) {
    return function(a) {
        return !predicate(a);
    };
};
function $da18856e9734b7b7$var$or(p1, p2) {
    return function(a) {
        return p1(a) || p2(a);
    };
}
$da18856e9734b7b7$exports.or = $da18856e9734b7b7$var$or;
/**
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.and = function(p1, p2) {
    return function(a) {
        return p1(a) && p2(a);
    };
};
/**
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.constant = function(a) {
    return function() {
        return a;
    };
};
/**
 * A thunk that returns always `true`
 *
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.constTrue = function() {
    return true;
};
/**
 * A thunk that returns always `false`
 *
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.constFalse = function() {
    return false;
};
/**
 * A thunk that returns always `null`
 *
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.constNull = function() {
    return null;
};
/**
 * A thunk that returns always `undefined`
 *
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.constUndefined = function() {
    return;
};
/**
 * A thunk that returns always `void`
 *
 * @since 1.14.0
 */ $da18856e9734b7b7$exports.constVoid = function() {
    return;
};
/**
 * Flips the order of the arguments to a function of two arguments.
 *
 * @since 1.0.0
 */ // tslint:disable-next-line: deprecation
$da18856e9734b7b7$exports.flip = function(f) {
    return function(b) {
        return function(a) {
            return f(a)(b);
        };
    };
};
/**
 * The `on` function is used to change the domain of a binary operator.
 *
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$da18856e9734b7b7$exports.on = function(op) {
    return function(f) {
        return function(x, y) {
            return op(f(x), f(y));
        };
    };
};
function $da18856e9734b7b7$var$compose() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    var len = fns.length - 1;
    return function(x) {
        var y = x;
        for(var i = len; i > -1; i--)y = fns[i].call(this, y);
        return y;
    };
}
$da18856e9734b7b7$exports.compose = $da18856e9734b7b7$var$compose;
function $da18856e9734b7b7$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    var len = fns.length - 1;
    return function(x) {
        var y = x;
        for(var i = 0; i <= len; i++)y = fns[i].call(this, y);
        return y;
    };
}
$da18856e9734b7b7$exports.pipe = $da18856e9734b7b7$var$pipe;
/**
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.concat = function(x, y) {
    var lenx = x.length;
    if (lenx === 0) return y;
    var leny = y.length;
    if (leny === 0) return x;
    var r = Array(lenx + leny);
    for(var i = 0; i < lenx; i++)r[i] = x[i];
    for(var i = 0; i < leny; i++)r[i + lenx] = y[i];
    return r;
};
/**
 * @since 1.0.0
 * @deprecated
 */ function $da18856e9734b7b7$var$curried(f, n, acc) {
    return function(x) {
        // tslint:disable-next-line: deprecation
        var combined = $da18856e9734b7b7$exports.concat(acc, [
            x
        ]);
        // tslint:disable-next-line: deprecation
        return n === 0 ? f.apply(this, combined) : $da18856e9734b7b7$var$curried(f, n - 1, combined);
    };
}
$da18856e9734b7b7$exports.curried = $da18856e9734b7b7$var$curried;
function $da18856e9734b7b7$var$curry(f) {
    // tslint:disable-next-line: deprecation
    return $da18856e9734b7b7$var$curried(f, f.length - 1, []);
}
$da18856e9734b7b7$exports.curry = $da18856e9734b7b7$var$curry;
/* tslint:disable-next-line */ var $da18856e9734b7b7$var$getFunctionName = function(f) {
    return f.displayName || f.name || "<function" + f.length + ">";
};
/**
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.toString = function(x) {
    if (typeof x === "string") return JSON.stringify(x);
    if (x instanceof Date) return "new Date('" + x.toISOString() + "')";
    if (Array.isArray(x)) // tslint:disable-next-line: deprecation
    return "[" + x.map($da18856e9734b7b7$exports.toString).join(", ") + "]";
    if (typeof x === "function") return $da18856e9734b7b7$var$getFunctionName(x);
    if (x == null) return String(x);
    if (typeof x.toString === "function" && x.toString !== Object.prototype.toString) return x.toString();
    try {
        return JSON.stringify(x, null, 2);
    } catch (e) {
        return String(x);
    }
};
/**
 * @since 1.0.0
 */ $da18856e9734b7b7$exports.tuple = function() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
};
/**
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.tupleCurried = function(a) {
    return function(b) {
        return [
            a,
            b
        ];
    };
};
/**
 * Applies a function to an argument ($)
 *
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.apply = function(f) {
    return function(a) {
        return f(a);
    };
};
/**
 * Applies an argument to a function (#)
 *
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.applyFlipped = function(a) {
    return function(f) {
        return f(a);
    };
};
/**
 * For use with phantom fields
 *
 * @since 1.0.0
 * @deprecated
 */ $da18856e9734b7b7$exports.phantom = undefined;
/**
 * A thunk that returns always the `identity` function.
 * For use with `applySecond` methods.
 *
 * @since 1.5.0
 * @deprecated
 */ $da18856e9734b7b7$exports.constIdentity = function() {
    return $da18856e9734b7b7$exports.identity;
};
/**
 * @since 1.9.0
 */ $da18856e9734b7b7$exports.increment = function(n) {
    return n + 1;
};
/**
 * @since 1.9.0
 */ $da18856e9734b7b7$exports.decrement = function(n) {
    return n - 1;
};
/**
 * @since 1.18.0
 */ function $da18856e9734b7b7$var$absurd(_) {
    throw new Error("Called `absurd` function which should be uncallable");
}
$da18856e9734b7b7$exports.absurd = $da18856e9734b7b7$var$absurd;
function $da18856e9734b7b7$var$flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
}
$da18856e9734b7b7$exports.flow = $da18856e9734b7b7$var$flow;


var $b0f11c009d4633f7$exports = {};
"use strict";
var $b0f11c009d4633f7$var$__assign = $b0f11c009d4633f7$exports && $b0f11c009d4633f7$exports.__assign || function() {
    $b0f11c009d4633f7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b0f11c009d4633f7$var$__assign.apply(this, arguments);
};
Object.defineProperty($b0f11c009d4633f7$exports, "__esModule", {
    value: true
});
var $37e5cd3b0c7fa08f$exports = {};
"use strict";
var $37e5cd3b0c7fa08f$var$__assign = $37e5cd3b0c7fa08f$exports && $37e5cd3b0c7fa08f$exports.__assign || function() {
    $37e5cd3b0c7fa08f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $37e5cd3b0c7fa08f$var$__assign.apply(this, arguments);
};
Object.defineProperty($37e5cd3b0c7fa08f$exports, "__esModule", {
    value: true
});
var $4e552386da5371f0$exports = {};
"use strict";
Object.defineProperty($4e552386da5371f0$exports, "__esModule", {
    value: true
});
var $418bb2c9516a5b59$exports = {};
"use strict";
Object.defineProperty($418bb2c9516a5b59$exports, "__esModule", {
    value: true
});

function $418bb2c9516a5b59$var$pipe(a, ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        case 10:
            return ij(hi(gh(fg(ef(de(cd(bc(ab(a)))))))));
    }
}
$418bb2c9516a5b59$exports.pipe = $418bb2c9516a5b59$var$pipe;
var $418bb2c9516a5b59$var$isFunctor = function(I) {
    return typeof I.map === "function";
};
var $418bb2c9516a5b59$var$isContravariant = function(I) {
    return typeof I.contramap === "function";
};
var $418bb2c9516a5b59$var$isFunctorWithIndex = function(I) {
    return typeof I.mapWithIndex === "function";
};
var $418bb2c9516a5b59$var$isApply = function(I) {
    return typeof I.ap === "function";
};
var $418bb2c9516a5b59$var$isChain = function(I) {
    return typeof I.chain === "function";
};
var $418bb2c9516a5b59$var$isBifunctor = function(I) {
    return typeof I.bimap === "function";
};
var $418bb2c9516a5b59$var$isExtend = function(I) {
    return typeof I.extend === "function";
};
var $418bb2c9516a5b59$var$isFoldable = function(I) {
    return typeof I.reduce === "function";
};
var $418bb2c9516a5b59$var$isFoldableWithIndex = function(I) {
    return typeof I.reduceWithIndex === "function";
};
var $418bb2c9516a5b59$var$isAlt = function(I) {
    return typeof I.alt === "function";
};
var $418bb2c9516a5b59$var$isCompactable = function(I) {
    return typeof I.compact === "function";
};
var $418bb2c9516a5b59$var$isFilterable = function(I) {
    return typeof I.filter === "function";
};
var $418bb2c9516a5b59$var$isFilterableWithIndex = function(I) {
    return typeof I.filterWithIndex === "function";
};
var $418bb2c9516a5b59$var$isProfunctor = function(I) {
    return typeof I.promap === "function";
};
var $418bb2c9516a5b59$var$isSemigroupoid = function(I) {
    return typeof I.compose === "function";
};
var $418bb2c9516a5b59$var$isMonadThrow = function(I) {
    return typeof I.throwError === "function";
};
function $418bb2c9516a5b59$var$pipeable(I) {
    var r = {};
    if ($418bb2c9516a5b59$var$isFunctor(I)) {
        var map = function(f) {
            return function(fa) {
                return I.map(fa, f);
            };
        };
        r.map = map;
    }
    if ($418bb2c9516a5b59$var$isContravariant(I)) {
        var contramap = function(f) {
            return function(fa) {
                return I.contramap(fa, f);
            };
        };
        r.contramap = contramap;
    }
    if ($418bb2c9516a5b59$var$isFunctorWithIndex(I)) {
        var mapWithIndex = function(f) {
            return function(fa) {
                return I.mapWithIndex(fa, f);
            };
        };
        r.mapWithIndex = mapWithIndex;
    }
    if ($418bb2c9516a5b59$var$isApply(I)) {
        var ap = function(fa) {
            return function(fab) {
                return I.ap(fab, fa);
            };
        };
        var apFirst = function(fb) {
            return function(fa) {
                return I.ap(I.map(fa, function(a) {
                    return function() {
                        return a;
                    };
                }), fb);
            };
        };
        r.ap = ap;
        r.apFirst = apFirst;
        r.apSecond = function(fb) {
            return function(fa) {
                return I.ap(I.map(fa, function() {
                    return function(b) {
                        return b;
                    };
                }), fb);
            };
        };
    }
    if ($418bb2c9516a5b59$var$isChain(I)) {
        var chain = function(f) {
            return function(ma) {
                return I.chain(ma, f);
            };
        };
        var chainFirst = function(f) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return I.map(f(a), function() {
                        return a;
                    });
                });
            };
        };
        var flatten = function(mma) {
            return I.chain(mma, $da18856e9734b7b7$exports.identity);
        };
        r.chain = chain;
        r.chainFirst = chainFirst;
        r.flatten = flatten;
    }
    if ($418bb2c9516a5b59$var$isBifunctor(I)) {
        var bimap = function(f, g) {
            return function(fa) {
                return I.bimap(fa, f, g);
            };
        };
        var mapLeft = function(f) {
            return function(fa) {
                return I.bimap(fa, f, $da18856e9734b7b7$exports.identity);
            };
        };
        r.bimap = bimap;
        r.mapLeft = mapLeft;
    }
    if ($418bb2c9516a5b59$var$isExtend(I)) {
        var extend = function(f) {
            return function(wa) {
                return I.extend(wa, f);
            };
        };
        var duplicate = function(wa) {
            return I.extend(wa, $da18856e9734b7b7$exports.identity);
        };
        r.extend = extend;
        r.duplicate = duplicate;
    }
    if ($418bb2c9516a5b59$var$isFoldable(I)) {
        var reduce = function(b, f) {
            return function(fa) {
                return I.reduce(fa, b, f);
            };
        };
        var foldMap = function(M) {
            var foldMapM = I.foldMap(M);
            return function(f) {
                return function(fa) {
                    return foldMapM(fa, f);
                };
            };
        };
        var reduceRight = function(b, f) {
            return function(fa) {
                return I.foldr(fa, b, f);
            };
        };
        r.reduce = reduce;
        r.foldMap = foldMap;
        r.reduceRight = reduceRight;
    }
    if ($418bb2c9516a5b59$var$isFoldableWithIndex(I)) {
        var reduceWithIndex = function(b, f) {
            return function(fa) {
                return I.reduceWithIndex(fa, b, f);
            };
        };
        var foldMapWithIndex = function(M) {
            var foldMapM = I.foldMapWithIndex(M);
            return function(f) {
                return function(fa) {
                    return foldMapM(fa, f);
                };
            };
        };
        var reduceRightWithIndex = function(b, f) {
            return function(fa) {
                return I.foldrWithIndex(fa, b, f);
            };
        };
        r.reduceWithIndex = reduceWithIndex;
        r.foldMapWithIndex = foldMapWithIndex;
        r.reduceRightWithIndex = reduceRightWithIndex;
    }
    if ($418bb2c9516a5b59$var$isAlt(I)) {
        var alt = function(that) {
            return function(fa) {
                return I.alt(fa, that());
            };
        };
        r.alt = alt;
    }
    if ($418bb2c9516a5b59$var$isCompactable(I)) {
        r.compact = I.compact;
        r.separate = I.separate;
    }
    if ($418bb2c9516a5b59$var$isFilterable(I)) {
        var filter = function(predicate) {
            return function(fa) {
                return I.filter(fa, predicate);
            };
        };
        var filterMap = function(f) {
            return function(fa) {
                return I.filterMap(fa, f);
            };
        };
        var partition = function(predicate) {
            return function(fa) {
                return I.partition(fa, predicate);
            };
        };
        var partitionMap = function(f) {
            return function(fa) {
                return I.partitionMap(fa, f);
            };
        };
        r.filter = filter;
        r.filterMap = filterMap;
        r.partition = partition;
        r.partitionMap = partitionMap;
    }
    if ($418bb2c9516a5b59$var$isFilterableWithIndex(I)) {
        var filterWithIndex = function(predicateWithIndex) {
            return function(fa) {
                return I.filterWithIndex(fa, predicateWithIndex);
            };
        };
        var filterMapWithIndex = function(f) {
            return function(fa) {
                return I.filterMapWithIndex(fa, f);
            };
        };
        var partitionWithIndex = function(predicateWithIndex) {
            return function(fa) {
                return I.partitionWithIndex(fa, predicateWithIndex);
            };
        };
        var partitionMapWithIndex = function(f) {
            return function(fa) {
                return I.partitionMapWithIndex(fa, f);
            };
        };
        r.filterWithIndex = filterWithIndex;
        r.filterMapWithIndex = filterMapWithIndex;
        r.partitionWithIndex = partitionWithIndex;
        r.partitionMapWithIndex = partitionMapWithIndex;
    }
    if ($418bb2c9516a5b59$var$isProfunctor(I)) {
        var promap = function(f, g) {
            return function(fa) {
                return I.promap(fa, f, g);
            };
        };
        r.promap = promap;
    }
    if ($418bb2c9516a5b59$var$isSemigroupoid(I)) {
        var compose = function(that) {
            return function(fa) {
                return I.compose(fa, that);
            };
        };
        r.compose = compose;
    }
    if ($418bb2c9516a5b59$var$isMonadThrow(I)) {
        var fromOption = function(onNone) {
            return function(ma) {
                return ma._tag === "None" ? I.throwError(onNone()) : I.of(ma.value);
            };
        };
        var fromEither = function(ma) {
            return ma._tag === "Left" ? I.throwError(ma.value) : I.of(ma.value);
        };
        var fromPredicate = function(predicate, onFalse) {
            return function(a) {
                return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
            };
        };
        var filterOrElse = function(predicate, onFalse) {
            return function(ma) {
                return I.chain(ma, function(a) {
                    return predicate(a) ? I.of(a) : I.throwError(onFalse(a));
                });
            };
        };
        r.fromOption = fromOption;
        r.fromEither = fromEither;
        r.fromPredicate = fromPredicate;
        r.filterOrElse = filterOrElse;
    }
    return r;
}
$418bb2c9516a5b59$exports.pipeable = $418bb2c9516a5b59$var$pipeable;


/**
 * @since 1.19.0
 */ $4e552386da5371f0$exports.URI = "Eq";
/**
 * @since 1.19.0
 */ function $4e552386da5371f0$var$fromEquals(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
}
$4e552386da5371f0$exports.fromEquals = $4e552386da5371f0$var$fromEquals;
/**
 * @since 1.19.0
 */ function $4e552386da5371f0$var$strictEqual(a, b) {
    return a === b;
}
$4e552386da5371f0$exports.strictEqual = $4e552386da5371f0$var$strictEqual;
var $4e552386da5371f0$var$eqStrict = {
    equals: $4e552386da5371f0$var$strictEqual
};
/**
 * @since 1.19.0
 */ $4e552386da5371f0$exports.eqString = $4e552386da5371f0$var$eqStrict;
/**
 * @since 1.19.0
 */ $4e552386da5371f0$exports.eqNumber = $4e552386da5371f0$var$eqStrict;
/**
 * @since 1.19.0
 */ $4e552386da5371f0$exports.eqBoolean = $4e552386da5371f0$var$eqStrict;
/**
 * @since 1.19.0
 */ function $4e552386da5371f0$var$getStructEq(eqs) {
    return $4e552386da5371f0$var$fromEquals(function(x, y) {
        for(var k in eqs){
            if (!eqs[k].equals(x[k], y[k])) return false;
        }
        return true;
    });
}
$4e552386da5371f0$exports.getStructEq = $4e552386da5371f0$var$getStructEq;
/**
 * Given a tuple of `Eq`s returns a `Eq` for the tuple
 *
 * @example
 * import { getTupleEq, eqString, eqNumber, eqBoolean } from 'fp-ts/lib/Eq'
 *
 * const E = getTupleEq(eqString, eqNumber, eqBoolean)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 1, true]), true)
 * assert.strictEqual(E.equals(['a', 1, true], ['b', 1, true]), false)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 2, true]), false)
 * assert.strictEqual(E.equals(['a', 1, true], ['a', 1, false]), false)
 *
 * @since 1.19.0
 */ function $4e552386da5371f0$var$getTupleEq() {
    var eqs = [];
    for(var _i = 0; _i < arguments.length; _i++)eqs[_i] = arguments[_i];
    return $4e552386da5371f0$var$fromEquals(function(x, y) {
        return eqs.every(function(E, i) {
            return E.equals(x[i], y[i]);
        });
    });
}
$4e552386da5371f0$exports.getTupleEq = $4e552386da5371f0$var$getTupleEq;
/**
 * @since 1.19.0
 */ $4e552386da5371f0$exports.eq = {
    URI: $4e552386da5371f0$exports.URI,
    contramap: function(fa, f) {
        return $4e552386da5371f0$var$fromEquals(function(x, y) {
            return fa.equals(f(x), f(y));
        });
    }
};
var $4e552386da5371f0$var$contramap = $418bb2c9516a5b59$exports.pipeable($4e552386da5371f0$exports.eq).contramap;
$4e552386da5371f0$exports.contramap = $4e552386da5371f0$var$contramap;
/**
 * @since 1.19.0
 */ $4e552386da5371f0$exports.eqDate = $4e552386da5371f0$exports.eq.contramap($4e552386da5371f0$exports.eqNumber, function(date) {
    return date.valueOf();
});



var $45c0dc5778c36c2c$exports = {};
"use strict";
Object.defineProperty($45c0dc5778c36c2c$exports, "__esModule", {
    value: true
});
/**
 * @since 1.0.0
 */ $45c0dc5778c36c2c$exports.sign = function(n) {
    return n <= -1 ? -1 : n >= 1 ? 1 : 0;
};
/**
 * @since 1.19.0
 */ $45c0dc5778c36c2c$exports.eqOrdering = {
    equals: function(x, y) {
        return x === y;
    }
};
/**
 * Use `eqOrdering`
 *
 * @since 1.0.0
 * @deprecated
 */ $45c0dc5778c36c2c$exports.setoidOrdering = $45c0dc5778c36c2c$exports.eqOrdering;
/**
 * @since 1.0.0
 */ $45c0dc5778c36c2c$exports.semigroupOrdering = {
    concat: function(x, y) {
        return x !== 0 ? x : y;
    }
};
/**
 * @since 1.0.0
 */ $45c0dc5778c36c2c$exports.invert = function(O) {
    switch(O){
        case -1:
            return 1;
        case 1:
            return -1;
        default:
            return 0;
    }
};


/**
 * @since 1.19.0
 */ $37e5cd3b0c7fa08f$exports.URI = "Ord";
/**
 * @since 1.0.0
 * @deprecated
 */ $37e5cd3b0c7fa08f$exports.unsafeCompare = function(x, y) {
    return x < y ? -1 : x > y ? 1 : 0;
};
/**
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.ordString = $37e5cd3b0c7fa08f$var$__assign({}, $4e552386da5371f0$exports.eqString, {
    // tslint:disable-next-line: deprecation
    compare: $37e5cd3b0c7fa08f$exports.unsafeCompare
});
/**
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.ordNumber = $37e5cd3b0c7fa08f$var$__assign({}, $4e552386da5371f0$exports.eqNumber, {
    // tslint:disable-next-line: deprecation
    compare: $37e5cd3b0c7fa08f$exports.unsafeCompare
});
/**
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.ordBoolean = $37e5cd3b0c7fa08f$var$__assign({}, $4e552386da5371f0$exports.eqBoolean, {
    // tslint:disable-next-line: deprecation
    compare: $37e5cd3b0c7fa08f$exports.unsafeCompare
});
/**
 * Test whether one value is _strictly less than_ another
 *
 * @since 1.19.0
 */ $37e5cd3b0c7fa08f$exports.lt = function(O) {
    return function(x, y) {
        return O.compare(x, y) === -1;
    };
};
/**
 * Use `lt`
 *
 * @since 1.0.0
 * @deprecated
 */ $37e5cd3b0c7fa08f$exports.lessThan = $37e5cd3b0c7fa08f$exports.lt;
/**
 * Test whether one value is _strictly greater than_ another
 *
 * @since 1.19.0
 */ $37e5cd3b0c7fa08f$exports.gt = function(O) {
    return function(x, y) {
        return O.compare(x, y) === 1;
    };
};
/**
 * Use `gt`
 *
 * @since 1.0.0
 * @deprecated
 */ $37e5cd3b0c7fa08f$exports.greaterThan = $37e5cd3b0c7fa08f$exports.gt;
/**
 * Test whether one value is _non-strictly less than_ another
 *
 * @since 1.19.0
 */ $37e5cd3b0c7fa08f$exports.leq = function(O) {
    return function(x, y) {
        return O.compare(x, y) !== 1;
    };
};
/**
 * Use `leq`
 *
 * @since 1.0.0
 * @deprecated
 */ $37e5cd3b0c7fa08f$exports.lessThanOrEq = $37e5cd3b0c7fa08f$exports.leq;
/**
 * Test whether one value is _non-strictly greater than_ another
 *
 * @since 1.19.0
 */ $37e5cd3b0c7fa08f$exports.geq = function(O) {
    return function(x, y) {
        return O.compare(x, y) !== -1;
    };
};
/**
 * Use `geq`
 *
 * @since 1.0.0
 * @deprecated
 */ $37e5cd3b0c7fa08f$exports.greaterThanOrEq = $37e5cd3b0c7fa08f$exports.geq;
/**
 * Take the minimum of two values. If they are considered equal, the first argument is chosen
 *
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.min = function(O) {
    return function(x, y) {
        return O.compare(x, y) === 1 ? y : x;
    };
};
/**
 * Take the maximum of two values. If they are considered equal, the first argument is chosen
 *
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.max = function(O) {
    return function(x, y) {
        return O.compare(x, y) === -1 ? y : x;
    };
};
/**
 * Clamp a value between a minimum and a maximum
 *
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.clamp = function(O) {
    var minO = $37e5cd3b0c7fa08f$exports.min(O);
    var maxO = $37e5cd3b0c7fa08f$exports.max(O);
    return function(low, hi) {
        return function(x) {
            return maxO(minO(x, hi), low);
        };
    };
};
/**
 * Test whether a value is between a minimum and a maximum (inclusive)
 *
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.between = function(O) {
    var lessThanO = $37e5cd3b0c7fa08f$exports.lt(O);
    var greaterThanO = $37e5cd3b0c7fa08f$exports.gt(O);
    return function(low, hi) {
        return function(x) {
            return lessThanO(x, low) || greaterThanO(x, hi) ? false : true;
        };
    };
};
/**
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.fromCompare = function(compare) {
    var optimizedCompare = function(x, y) {
        return x === y ? 0 : compare(x, y);
    };
    return {
        equals: function(x, y) {
            return optimizedCompare(x, y) === 0;
        },
        compare: optimizedCompare
    };
};
function $37e5cd3b0c7fa08f$var$_contramap(f, O) {
    // tslint:disable-next-line: deprecation
    return $37e5cd3b0c7fa08f$exports.fromCompare($da18856e9734b7b7$exports.on(O.compare)(f));
}
function $37e5cd3b0c7fa08f$var$contramap() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(O) {
        return $37e5cd3b0c7fa08f$var$_contramap(args[0], O);
    } : $37e5cd3b0c7fa08f$var$_contramap(args[0], args[1]);
}
$37e5cd3b0c7fa08f$exports.contramap = $37e5cd3b0c7fa08f$var$contramap;
/**
 * @since 1.0.0
 */ $37e5cd3b0c7fa08f$exports.getSemigroup = function() {
    return {
        concat: function(x, y) {
            return $37e5cd3b0c7fa08f$exports.fromCompare(function(a, b) {
                return $45c0dc5778c36c2c$exports.semigroupOrdering.concat(x.compare(a, b), y.compare(a, b));
            });
        }
    };
};
/**
 * Given a tuple of `Ord`s returns an `Ord` for the tuple
 *
 * @example
 * import { getTupleOrd, ordString, ordNumber, ordBoolean } from 'fp-ts/lib/Ord'
 *
 * const O = getTupleOrd(ordString, ordNumber, ordBoolean)
 * assert.strictEqual(O.compare(['a', 1, true], ['b', 2, true]), -1)
 * assert.strictEqual(O.compare(['a', 1, true], ['a', 2, true]), -1)
 * assert.strictEqual(O.compare(['a', 1, true], ['a', 1, false]), 1)
 *
 * @since 1.14.3
 */ $37e5cd3b0c7fa08f$exports.getTupleOrd = function() {
    var ords = [];
    for(var _i = 0; _i < arguments.length; _i++)ords[_i] = arguments[_i];
    var len = ords.length;
    return $37e5cd3b0c7fa08f$exports.fromCompare(function(x, y) {
        var i = 0;
        for(; i < len - 1; i++){
            var r = ords[i].compare(x[i], y[i]);
            if (r !== 0) return r;
        }
        return ords[i].compare(x[i], y[i]);
    });
};
/**
 * Use `getTupleOrd` instead
 * @since 1.0.0
 * @deprecated
 */ $37e5cd3b0c7fa08f$exports.getProductOrd = function(OA, OB) {
    return $37e5cd3b0c7fa08f$exports.getTupleOrd(OA, OB);
};
/**
 * @since 1.3.0
 */ $37e5cd3b0c7fa08f$exports.getDualOrd = function(O) {
    return $37e5cd3b0c7fa08f$exports.fromCompare(function(x, y) {
        return O.compare(y, x);
    });
};
/**
 * @since 1.19.0
 */ $37e5cd3b0c7fa08f$exports.ord = {
    URI: $37e5cd3b0c7fa08f$exports.URI,
    // tslint:disable-next-line: deprecation
    contramap: function(fa, f) {
        return $37e5cd3b0c7fa08f$var$contramap(f, fa);
    }
};
/**
 * @since 1.4.0
 */ $37e5cd3b0c7fa08f$exports.ordDate = $37e5cd3b0c7fa08f$exports.ord.contramap($37e5cd3b0c7fa08f$exports.ordNumber, function(date) {
    return date.valueOf();
});



/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.fold = function(S) {
    return function(a) {
        return function(as) {
            return as.reduce(S.concat, a);
        };
    };
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.getFirstSemigroup = function() {
    return {
        concat: $da18856e9734b7b7$exports.identity
    };
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.getLastSemigroup = function() {
    return {
        concat: function(_, y) {
            return y;
        }
    };
};
/**
 * Given a tuple of semigroups returns a semigroup for the tuple
 *
 * @example
 * import { getTupleSemigroup, semigroupString, semigroupSum, semigroupAll } from 'fp-ts/lib/Semigroup'
 *
 * const S1 = getTupleSemigroup(semigroupString, semigroupSum)
 * assert.deepStrictEqual(S1.concat(['a', 1], ['b', 2]), ['ab', 3])
 *
 * const S2 = getTupleSemigroup(semigroupString, semigroupSum, semigroupAll)
 * assert.deepStrictEqual(S2.concat(['a', 1, true], ['b', 2, false]), ['ab', 3, false])
 *
 * @since 1.14.0
 */ $b0f11c009d4633f7$exports.getTupleSemigroup = function() {
    var semigroups = [];
    for(var _i = 0; _i < arguments.length; _i++)semigroups[_i] = arguments[_i];
    return {
        concat: function(x, y) {
            return semigroups.map(function(s, i) {
                return s.concat(x[i], y[i]);
            });
        }
    };
};
/**
 * Use `getTupleSemigroup` instead
 * @since 1.0.0
 * @deprecated
 */ $b0f11c009d4633f7$exports.getProductSemigroup = function(SA, SB) {
    return $b0f11c009d4633f7$exports.getTupleSemigroup(SA, SB);
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.getDualSemigroup = function(S) {
    return {
        concat: function(x, y) {
            return S.concat(y, x);
        }
    };
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.getFunctionSemigroup = function(S) {
    return function() {
        return {
            concat: function(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
/**
 * @since 1.14.0
 */ $b0f11c009d4633f7$exports.getStructSemigroup = function(semigroups) {
    return {
        concat: function(x, y) {
            var r = {};
            for(var _i = 0, _a = Object.keys(semigroups); _i < _a.length; _i++){
                var key = _a[_i];
                r[key] = semigroups[key].concat(x[key], y[key]);
            }
            return r;
        }
    };
};
/**
 * Use `getStructSemigroup` instead
 * @since 1.0.0
 * @deprecated
 */ $b0f11c009d4633f7$exports.getRecordSemigroup = function(semigroups) {
    return $b0f11c009d4633f7$exports.getStructSemigroup(semigroups);
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.getMeetSemigroup = function(O) {
    return {
        concat: $37e5cd3b0c7fa08f$exports.min(O)
    };
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.getJoinSemigroup = function(O) {
    return {
        concat: $37e5cd3b0c7fa08f$exports.max(O)
    };
};
/**
 * Boolean semigroup under conjunction
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.semigroupAll = {
    concat: function(x, y) {
        return x && y;
    }
};
/**
 * Boolean semigroup under disjunction
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.semigroupAny = {
    concat: function(x, y) {
        return x || y;
    }
};
/**
 * Use `Array`'s `getMonoid`
 *
 * @since 1.0.0
 * @deprecated
 */ $b0f11c009d4633f7$exports.getArraySemigroup = function() {
    return {
        concat: $da18856e9734b7b7$exports.concat
    };
};
function $b0f11c009d4633f7$var$getDictionarySemigroup(S) {
    return {
        concat: function(x, y) {
            var r = $b0f11c009d4633f7$var$__assign({}, x);
            var keys = Object.keys(y);
            var len = keys.length;
            for(var i = 0; i < len; i++){
                var k = keys[i];
                r[k] = x.hasOwnProperty(k) ? S.concat(x[k], y[k]) : y[k];
            }
            return r;
        }
    };
}
$b0f11c009d4633f7$exports.getDictionarySemigroup = $b0f11c009d4633f7$var$getDictionarySemigroup;
// tslint:disable-next-line: deprecation
var $b0f11c009d4633f7$var$semigroupAnyDictionary = $b0f11c009d4633f7$var$getDictionarySemigroup($b0f11c009d4633f7$exports.getLastSemigroup());
/**
 * Returns a `Semigroup` instance for objects preserving their type
 *
 * @example
 * import { getObjectSemigroup } from 'fp-ts/lib/Semigroup'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 *
 * const S = getObjectSemigroup<Person>()
 * assert.deepStrictEqual(S.concat({ name: 'name', age: 23 }, { name: 'name', age: 24 }), { name: 'name', age: 24 })
 *
 * @since 1.4.0
 */ $b0f11c009d4633f7$exports.getObjectSemigroup = function() {
    return $b0f11c009d4633f7$var$semigroupAnyDictionary;
};
/**
 * Number `Semigroup` under addition
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.semigroupSum = {
    concat: function(x, y) {
        return x + y;
    }
};
/**
 * Number `Semigroup` under multiplication
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.semigroupProduct = {
    concat: function(x, y) {
        return x * y;
    }
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.semigroupString = {
    concat: function(x, y) {
        return x + y;
    }
};
/**
 * @since 1.0.0
 */ $b0f11c009d4633f7$exports.semigroupVoid = {
    concat: function() {
        return undefined;
    }
};


/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.fold = function(M) {
    return $b0f11c009d4633f7$exports.fold(M)(M.empty);
};
/**
 * Given a tuple of monoids returns a monoid for the tuple
 *
 * @example
 * import { getTupleMonoid, monoidString, monoidSum, monoidAll } from 'fp-ts/lib/Monoid'
 *
 * const M1 = getTupleMonoid(monoidString, monoidSum)
 * assert.deepStrictEqual(M1.concat(['a', 1], ['b', 2]), ['ab', 3])
 *
 * const M2 = getTupleMonoid(monoidString, monoidSum, monoidAll)
 * assert.deepStrictEqual(M2.concat(['a', 1, true], ['b', 2, false]), ['ab', 3, false])
 *
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.getTupleMonoid = function() {
    var monoids = [];
    for(var _i = 0; _i < arguments.length; _i++)monoids[_i] = arguments[_i];
    return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getTupleSemigroup.apply(void 0, monoids), {
        empty: monoids.map(function(m) {
            return m.empty;
        })
    });
};
/**
 * Use `getTupleMonoid` instead
 * @since 1.0.0
 * @deprecated
 */ $e11eb2700046c52f$exports.getProductMonoid = function(MA, MB) {
    return $e11eb2700046c52f$exports.getTupleMonoid(MA, MB);
};
/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.getDualMonoid = function(M) {
    return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getDualSemigroup(M), {
        empty: M.empty
    });
};
/**
 * Boolean monoid under conjunction
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.monoidAll = $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.semigroupAll, {
    empty: true
});
/**
 * Boolean monoid under disjunction
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.monoidAny = $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.semigroupAny, {
    empty: false
});
var $e11eb2700046c52f$var$emptyArray = [];
/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.unsafeMonoidArray = {
    concat: $da18856e9734b7b7$exports.concat,
    empty: $e11eb2700046c52f$var$emptyArray
};
/**
 * Use `Array`'s `getMonoid`
 *
 * @since 1.0.0
 * @deprecated
 */ $e11eb2700046c52f$exports.getArrayMonoid = function() {
    return $e11eb2700046c52f$exports.unsafeMonoidArray;
};
var $e11eb2700046c52f$var$emptyObject = {};
function $e11eb2700046c52f$var$getDictionaryMonoid(S) {
    return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getDictionarySemigroup(S), {
        empty: $e11eb2700046c52f$var$emptyObject
    });
}
$e11eb2700046c52f$exports.getDictionaryMonoid = $e11eb2700046c52f$var$getDictionaryMonoid;
/**
 * Number monoid under addition
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.monoidSum = $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.semigroupSum, {
    empty: 0
});
/**
 * Number monoid under multiplication
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.monoidProduct = $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.semigroupProduct, {
    empty: 1
});
/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.monoidString = $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.semigroupString, {
    empty: ""
});
/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.monoidVoid = $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.semigroupVoid, {
    empty: undefined
});
/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.getFunctionMonoid = function(M) {
    return function() {
        return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getFunctionSemigroup(M)(), {
            empty: function() {
                return M.empty;
            }
        });
    };
};
/**
 * @since 1.0.0
 */ $e11eb2700046c52f$exports.getEndomorphismMonoid = function() {
    return {
        concat: function(x, y) {
            return function(a) {
                return x(y(a));
            };
        },
        empty: $da18856e9734b7b7$exports.identity
    };
};
/**
 * @since 1.14.0
 */ $e11eb2700046c52f$exports.getStructMonoid = function(monoids) {
    var empty = {};
    for(var _i = 0, _a = Object.keys(monoids); _i < _a.length; _i++){
        var key = _a[_i];
        empty[key] = monoids[key].empty;
    }
    return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getStructSemigroup(monoids), {
        empty: empty
    });
};
/**
 * Use `getStructMonoid` instead
 * @since 1.0.0
 * @deprecated
 */ $e11eb2700046c52f$exports.getRecordMonoid = function(monoids) {
    return $e11eb2700046c52f$exports.getStructMonoid(monoids);
};
/**
 * @since 1.9.0
 */ $e11eb2700046c52f$exports.getMeetMonoid = function(B) {
    return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getMeetSemigroup(B), {
        empty: B.top
    });
};
/**
 * @since 1.9.0
 */ $e11eb2700046c52f$exports.getJoinMonoid = function(B) {
    return $e11eb2700046c52f$var$__assign({}, $b0f11c009d4633f7$exports.getJoinSemigroup(B), {
        empty: B.bottom
    });
};


var $179ffbf36670c650$exports = {};
"use strict";
Object.defineProperty($179ffbf36670c650$exports, "__esModule", {
    value: true
});

function $179ffbf36670c650$var$applyFirst(F) {
    return function(fa, fb) {
        return F.ap(F.map(fa, $da18856e9734b7b7$exports.constant), fb);
    };
}
$179ffbf36670c650$exports.applyFirst = $179ffbf36670c650$var$applyFirst;
function $179ffbf36670c650$var$applySecond(F) {
    return function(fa, fb) {
        return F.ap(F.map(fa, function() {
            return function(b) {
                return b;
            };
        }), fb);
    };
}
$179ffbf36670c650$exports.applySecond = $179ffbf36670c650$var$applySecond;
// tslint:disable-next-line: deprecation
function $179ffbf36670c650$var$liftA2(F) {
    return function(f) {
        return function(fa) {
            return function(fb) {
                return F.ap(F.map(fa, f), fb);
            };
        };
    };
}
$179ffbf36670c650$exports.liftA2 = $179ffbf36670c650$var$liftA2;
function $179ffbf36670c650$var$liftA3(F) {
    return function(f) {
        return function(fa) {
            return function(fb) {
                return function(fc) {
                    return F.ap(F.ap(F.map(fa, f), fb), fc);
                };
            };
        };
    };
}
$179ffbf36670c650$exports.liftA3 = $179ffbf36670c650$var$liftA3;
function $179ffbf36670c650$var$liftA4(F) {
    return function(f) {
        return function(fa) {
            return function(fb) {
                return function(fc) {
                    return function(fd) {
                        return F.ap(F.ap(F.ap(F.map(fa, f), fb), fc), fd);
                    };
                };
            };
        };
    };
}
$179ffbf36670c650$exports.liftA4 = $179ffbf36670c650$var$liftA4;
function $179ffbf36670c650$var$getSemigroup(F, S) {
    var f = function(a) {
        return function(b) {
            return S.concat(a, b);
        };
    };
    return function() {
        return {
            concat: function(x, y) {
                return F.ap(F.map(x, f), y);
            }
        };
    };
}
$179ffbf36670c650$exports.getSemigroup = $179ffbf36670c650$var$getSemigroup;
var $179ffbf36670c650$var$tupleConstructors = {};
function $179ffbf36670c650$var$getTupleConstructor(len) {
    if (!$179ffbf36670c650$var$tupleConstructors.hasOwnProperty(len)) // tslint:disable-next-line: deprecation
    $179ffbf36670c650$var$tupleConstructors[len] = $da18856e9734b7b7$exports.curried($da18856e9734b7b7$exports.tuple, len - 1, []);
    return $179ffbf36670c650$var$tupleConstructors[len];
}
function $179ffbf36670c650$var$sequenceT(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = $179ffbf36670c650$var$getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
$179ffbf36670c650$exports.sequenceT = $179ffbf36670c650$var$sequenceT;
function $179ffbf36670c650$var$getRecordConstructor(keys) {
    var len = keys.length;
    // tslint:disable-next-line: deprecation
    return $da18856e9734b7b7$exports.curried(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var r = {};
        for(var i = 0; i < len; i++)r[keys[i]] = args[i];
        return r;
    }, len - 1, []);
}
function $179ffbf36670c650$var$sequenceS(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = $179ffbf36670c650$var$getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}
$179ffbf36670c650$exports.sequenceS = $179ffbf36670c650$var$sequenceS;


var $0370766540a3ee1a$exports = {};
"use strict";
/**
 * @file Represents a value of one of two possible types (a disjoint union).
 *
 * An instance of `Either` is either an instance of `Left` or `Right`.
 *
 * A common use of `Either` is as an alternative to `Option` for dealing with possible missing values. In this usage,
 * `None` is replaced with a `Left` which can contain useful information. `Right` takes the place of `Some`. Convention
 * dictates that `Left` is used for failure and `Right` is used for success.
 *
 * For example, you could use `Either<string, number>` to detect whether a received input is a `string` or a `number`.
 *
 * ```ts
 * const parse = (errorMessage: string) => (input: string): Either<string, number> => {
 *   const n = parseInt(input, 10)
 *   return isNaN(n) ? left(errorMessage) : right(n)
 * }
 * ```
 *
 * `Either` is right-biased, which means that `Right` is assumed to be the default case to operate on. If it is `Left`,
 * operations like `map`, `chain`, ... return the `Left` value unchanged:
 *
 * ```ts
 * right(12).map(double) // right(24)
 * left(23).map(double)  // left(23)
 * ```
 */ var $0370766540a3ee1a$var$__assign = $0370766540a3ee1a$exports && $0370766540a3ee1a$exports.__assign || function() {
    $0370766540a3ee1a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0370766540a3ee1a$var$__assign.apply(this, arguments);
};
Object.defineProperty($0370766540a3ee1a$exports, "__esModule", {
    value: true
});
var $9b044b6f3e28deb5$exports = {};
"use strict";
Object.defineProperty($9b044b6f3e28deb5$exports, "__esModule", {
    value: true
});
/**
 * @since 1.0.0
 */ $9b044b6f3e28deb5$exports.tailRec = function(f, a) {
    var v = f(a);
    while(v.isLeft())v = f(v.value);
    return v.value;
};





$0370766540a3ee1a$exports.URI = "Either";
/**
 * Left side of `Either`
 */ var $0370766540a3ee1a$var$Left = /** @class */ function() {
    function Left(value) {
        this.value = value;
        this._tag = "Left";
    }
    /**
     * The given function is applied if this is a `Right`
     * @obsolete
     */ Left.prototype.map = function(f) {
        return this;
    };
    /** @obsolete */ Left.prototype.ap = function(fab) {
        return fab.isLeft() ? fab : this;
    };
    /**
     * Flipped version of `ap`
     * @obsolete
     */ Left.prototype.ap_ = function(fb) {
        return fb.ap(this);
    };
    /**
     * Binds the given function across `Right`
     * @obsolete
     */ Left.prototype.chain = function(f) {
        return this;
    };
    /** @obsolete */ Left.prototype.bimap = function(f, g) {
        return new Left(f(this.value));
    };
    /** @obsolete */ Left.prototype.alt = function(fy) {
        return fy;
    };
    /**
     * Lazy version of `alt`
     *
     * @example
     * import { right } from 'fp-ts/lib/Either'
     *
     * assert.deepStrictEqual(right(1).orElse(() => right(2)), right(1))
     *
     * @since 1.6.0
     * @obsolete
     */ Left.prototype.orElse = function(fy) {
        return fy(this.value);
    };
    /** @obsolete */ Left.prototype.extend = function(f) {
        return this;
    };
    /** @obsolete */ Left.prototype.reduce = function(b, f) {
        return b;
    };
    /**
     * Applies a function to each case in the data structure
     * @obsolete
     */ Left.prototype.fold = function(onLeft, onRight) {
        return onLeft(this.value);
    };
    /**
     * Returns the value from this `Right` or the given argument if this is a `Left`
     * @obsolete
     */ Left.prototype.getOrElse = function(a) {
        return a;
    };
    /**
     * Returns the value from this `Right` or the result of given argument if this is a `Left`
     * @obsolete
     */ Left.prototype.getOrElseL = function(f) {
        return f(this.value);
    };
    /**
     * Maps the left side of the disjunction
     * @obsolete
     */ Left.prototype.mapLeft = function(f) {
        return new Left(f(this.value));
    };
    Left.prototype.inspect = function() {
        return this.toString();
    };
    Left.prototype.toString = function() {
        // tslint:disable-next-line: deprecation
        return "left(" + $da18856e9734b7b7$exports.toString(this.value) + ")";
    };
    /**
     * Returns `true` if the either is an instance of `Left`, `false` otherwise
     * @obsolete
     */ Left.prototype.isLeft = function() {
        return true;
    };
    /**
     * Returns `true` if the either is an instance of `Right`, `false` otherwise
     * @obsolete
     */ Left.prototype.isRight = function() {
        return false;
    };
    /**
     * Swaps the disjunction values
     * @obsolete
     */ Left.prototype.swap = function() {
        return new $0370766540a3ee1a$var$Right(this.value);
    };
    Left.prototype.filterOrElse = function(_, zero) {
        return this;
    };
    Left.prototype.filterOrElseL = function(_, zero) {
        return this;
    };
    /**
     * Use `filterOrElse` instead
     * @since 1.6.0
     * @deprecated
     */ Left.prototype.refineOrElse = function(p, zero) {
        return this;
    };
    /**
     * Lazy version of `refineOrElse`
     * Use `filterOrElseL` instead
     * @since 1.6.0
     * @deprecated
     */ Left.prototype.refineOrElseL = function(p, zero) {
        return this;
    };
    return Left;
}();
$0370766540a3ee1a$exports.Left = $0370766540a3ee1a$var$Left;
/**
 * Right side of `Either`
 */ var $0370766540a3ee1a$var$Right = /** @class */ function() {
    function Right(value) {
        this.value = value;
        this._tag = "Right";
    }
    Right.prototype.map = function(f) {
        return new Right(f(this.value));
    };
    Right.prototype.ap = function(fab) {
        return fab.isRight() ? this.map(fab.value) : $0370766540a3ee1a$exports.left(fab.value);
    };
    Right.prototype.ap_ = function(fb) {
        return fb.ap(this);
    };
    Right.prototype.chain = function(f) {
        return f(this.value);
    };
    Right.prototype.bimap = function(f, g) {
        return new Right(g(this.value));
    };
    Right.prototype.alt = function(fy) {
        return this;
    };
    Right.prototype.orElse = function(fy) {
        return this;
    };
    Right.prototype.extend = function(f) {
        return new Right(f(this));
    };
    Right.prototype.reduce = function(b, f) {
        return f(b, this.value);
    };
    Right.prototype.fold = function(onLeft, onRight) {
        return onRight(this.value);
    };
    Right.prototype.getOrElse = function(a) {
        return this.value;
    };
    Right.prototype.getOrElseL = function(f) {
        return this.value;
    };
    Right.prototype.mapLeft = function(f) {
        return new Right(this.value);
    };
    Right.prototype.inspect = function() {
        return this.toString();
    };
    Right.prototype.toString = function() {
        // tslint:disable-next-line: deprecation
        return "right(" + $da18856e9734b7b7$exports.toString(this.value) + ")";
    };
    Right.prototype.isLeft = function() {
        return false;
    };
    Right.prototype.isRight = function() {
        return true;
    };
    Right.prototype.swap = function() {
        return new $0370766540a3ee1a$var$Left(this.value);
    };
    Right.prototype.filterOrElse = function(p, zero) {
        return p(this.value) ? this : $0370766540a3ee1a$exports.left(zero);
    };
    Right.prototype.filterOrElseL = function(p, zero) {
        return p(this.value) ? this : $0370766540a3ee1a$exports.left(zero(this.value));
    };
    Right.prototype.refineOrElse = function(p, zero) {
        return p(this.value) ? this : $0370766540a3ee1a$exports.left(zero);
    };
    Right.prototype.refineOrElseL = function(p, zero) {
        return p(this.value) ? this : $0370766540a3ee1a$exports.left(zero(this.value));
    };
    return Right;
}();
$0370766540a3ee1a$exports.Right = $0370766540a3ee1a$var$Right;
/**
 * @since 1.17.0
 */ $0370766540a3ee1a$exports.getShow = function(SL, SA) {
    return {
        show: function(e) {
            return e.fold(function(l) {
                return "left(" + SL.show(l) + ")";
            }, function(a) {
                return "right(" + SA.show(a) + ")";
            });
        }
    };
};
/**
 * Use `getEq`
 *
 * @since 1.0.0
 * @deprecated
 */ $0370766540a3ee1a$exports.getSetoid = $0370766540a3ee1a$var$getEq;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$getEq(EL, EA) {
    return $4e552386da5371f0$exports.fromEquals(function(x, y) {
        return x.isLeft() ? y.isLeft() && EL.equals(x.value, y.value) : y.isRight() && EA.equals(x.value, y.value);
    });
}
$0370766540a3ee1a$exports.getEq = $0370766540a3ee1a$var$getEq;
/**
 * Semigroup returning the left-most non-`Left` value. If both operands are `Right`s then the inner values are
 * appended using the provided `Semigroup`
 *
 * @example
 * import { getSemigroup, left, right } from 'fp-ts/lib/Either'
 * import { semigroupSum } from 'fp-ts/lib/Semigroup'
 *
 * const S = getSemigroup<string, number>(semigroupSum)
 * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
 * assert.deepStrictEqual(S.concat(left('a'), right(2)), right(2))
 * assert.deepStrictEqual(S.concat(right(1), left('b')), right(1))
 * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
 *
 *
 * @since 1.7.0
 */ $0370766540a3ee1a$exports.getSemigroup = function(S) {
    return {
        concat: function(x, y) {
            return y.isLeft() ? x : x.isLeft() ? y : $0370766540a3ee1a$exports.right(S.concat(x.value, y.value));
        }
    };
};
/**
 * `Apply` semigroup
 *
 * @example
 * import { getApplySemigroup, left, right } from 'fp-ts/lib/Either'
 * import { semigroupSum } from 'fp-ts/lib/Semigroup'
 *
 * const S = getApplySemigroup<string, number>(semigroupSum)
 * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
 * assert.deepStrictEqual(S.concat(left('a'), right(2)), left('a'))
 * assert.deepStrictEqual(S.concat(right(1), left('b')), left('b'))
 * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
 *
 *
 * @since 1.7.0
 */ $0370766540a3ee1a$exports.getApplySemigroup = function(S) {
    return {
        concat: function(x, y) {
            return x.isLeft() ? x : y.isLeft() ? y : $0370766540a3ee1a$exports.right(S.concat(x.value, y.value));
        }
    };
};
/**
 * @since 1.7.0
 */ $0370766540a3ee1a$exports.getApplyMonoid = function(M) {
    return $0370766540a3ee1a$var$__assign({}, $0370766540a3ee1a$exports.getApplySemigroup(M), {
        empty: $0370766540a3ee1a$exports.right(M.empty)
    });
};
/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.left = function(l) {
    return new $0370766540a3ee1a$var$Left(l);
};
/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.right = function(a) {
    return new $0370766540a3ee1a$var$Right(a);
};
/**
 * Use `fromPredicate` instead
 *
 * @since 1.6.0
 * @deprecated
 */ $0370766540a3ee1a$exports.fromRefinement = function(refinement, onFalse) {
    return function(a) {
        return refinement(a) ? $0370766540a3ee1a$exports.right(a) : $0370766540a3ee1a$exports.left(onFalse(a));
    };
};
/**
 * Takes a default and a `Option` value, if the value is a `Some`, turn it into a `Right`, if the value is a `None` use
 * the provided default as a `Left`
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.fromOption = function(onNone) {
    return function(fa) {
        return fa.isNone() ? $0370766540a3ee1a$exports.left(onNone) : $0370766540a3ee1a$exports.right(fa.value);
    };
};
/**
 * Takes a default and a nullable value, if the value is not nully, turn it into a `Right`, if the value is nully use
 * the provided default as a `Left`
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.fromNullable = function(defaultValue) {
    return function(a) {
        return a == null ? $0370766540a3ee1a$exports.left(defaultValue) : $0370766540a3ee1a$exports.right(a);
    };
};
/**
 * Default value for the optional `onerror` argument of `tryCatch`
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.toError = function(e) {
    if (e instanceof Error) return e;
    else return new Error(String(e));
};
/**
 * Use `tryCatch2v` instead
 *
 * @since 1.0.0
 * @deprecated
 */ $0370766540a3ee1a$exports.tryCatch = function(f, onerror) {
    if (onerror === void 0) onerror = $0370766540a3ee1a$exports.toError;
    return $0370766540a3ee1a$exports.tryCatch2v(f, onerror);
};
/**
 * Constructs a new `Either` from a function that might throw
 *
 * @example
 * import { Either, left, right, tryCatch2v } from 'fp-ts/lib/Either'
 *
 * const unsafeHead = <A>(as: Array<A>): A => {
 *   if (as.length > 0) {
 *     return as[0]
 *   } else {
 *     throw new Error('empty array')
 *   }
 * }
 *
 * const head = <A>(as: Array<A>): Either<Error, A> => {
 *   return tryCatch2v(() => unsafeHead(as), e => (e instanceof Error ? e : new Error('unknown error')))
 * }
 *
 * assert.deepStrictEqual(head([]), left(new Error('empty array')))
 * assert.deepStrictEqual(head([1, 2, 3]), right(1))
 *
 * @since 1.11.0
 */ $0370766540a3ee1a$exports.tryCatch2v = function(f, onerror) {
    try {
        return $0370766540a3ee1a$exports.right(f());
    } catch (e) {
        return $0370766540a3ee1a$exports.left(onerror(e));
    }
};
/**
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.fromValidation = function(fa) {
    return fa.isFailure() ? $0370766540a3ee1a$exports.left(fa.value) : $0370766540a3ee1a$exports.right(fa.value);
};
/**
 * Returns `true` if the either is an instance of `Left`, `false` otherwise
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.isLeft = function(fa) {
    return fa.isLeft();
};
/**
 * Returns `true` if the either is an instance of `Right`, `false` otherwise
 *
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.isRight = function(fa) {
    return fa.isRight();
};
/**
 * Use `getWitherable`
 *
 * @since 1.7.0
 * @deprecated
 */ function $0370766540a3ee1a$var$getCompactable(ML) {
    var compact = function(fa) {
        if (fa.isLeft()) return fa;
        if (fa.value.isNone()) return $0370766540a3ee1a$exports.left(ML.empty);
        return $0370766540a3ee1a$exports.right(fa.value.value);
    };
    var separate = function(fa) {
        if (fa.isLeft()) return {
            left: fa,
            right: fa
        };
        if (fa.value.isLeft()) return {
            left: $0370766540a3ee1a$exports.right(fa.value.value),
            right: $0370766540a3ee1a$exports.left(ML.empty)
        };
        return {
            left: $0370766540a3ee1a$exports.left(ML.empty),
            right: $0370766540a3ee1a$exports.right(fa.value.value)
        };
    };
    return {
        URI: $0370766540a3ee1a$exports.URI,
        _L: undefined,
        compact: compact,
        separate: separate
    };
}
$0370766540a3ee1a$exports.getCompactable = $0370766540a3ee1a$var$getCompactable;
/**
 * Use `getWitherable`
 *
 * @since 1.7.0
 * @deprecated
 */ function $0370766540a3ee1a$var$getFilterable(ML) {
    // tslint:disable-next-line: deprecation
    var C = $0370766540a3ee1a$var$getCompactable(ML);
    var partitionMap = function(fa, f) {
        if (fa.isLeft()) return {
            left: fa,
            right: fa
        };
        var e = f(fa.value);
        if (e.isLeft()) return {
            left: $0370766540a3ee1a$exports.right(e.value),
            right: $0370766540a3ee1a$exports.left(ML.empty)
        };
        return {
            left: $0370766540a3ee1a$exports.left(ML.empty),
            right: $0370766540a3ee1a$exports.right(e.value)
        };
    };
    var partition = function(fa, p) {
        if (fa.isLeft()) return {
            left: fa,
            right: fa
        };
        if (p(fa.value)) return {
            left: $0370766540a3ee1a$exports.left(ML.empty),
            right: $0370766540a3ee1a$exports.right(fa.value)
        };
        return {
            left: $0370766540a3ee1a$exports.right(fa.value),
            right: $0370766540a3ee1a$exports.left(ML.empty)
        };
    };
    var filterMap = function(fa, f) {
        if (fa.isLeft()) return fa;
        var optionB = f(fa.value);
        if (optionB.isSome()) return $0370766540a3ee1a$exports.right(optionB.value);
        return $0370766540a3ee1a$exports.left(ML.empty);
    };
    var filter = function(fa, p) {
        return fa.filterOrElse(p, ML.empty);
    };
    return $0370766540a3ee1a$var$__assign({}, C, {
        map: $0370766540a3ee1a$exports.either.map,
        partitionMap: partitionMap,
        filterMap: filterMap,
        partition: partition,
        filter: filter
    });
}
$0370766540a3ee1a$exports.getFilterable = $0370766540a3ee1a$var$getFilterable;
/**
 * Builds `Witherable` instance for `Either` given `Monoid` for the left side
 *
 * @since 1.7.0
 */ function $0370766540a3ee1a$var$getWitherable(ML) {
    // tslint:disable-next-line: deprecation
    var filterableEither = $0370766540a3ee1a$var$getFilterable(ML);
    var wither = function(F) {
        var traverseF = $0370766540a3ee1a$exports.either.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), filterableEither.compact);
        };
    };
    var wilt = function(F) {
        var traverseF = $0370766540a3ee1a$exports.either.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), filterableEither.separate);
        };
    };
    return $0370766540a3ee1a$var$__assign({}, filterableEither, {
        traverse: $0370766540a3ee1a$exports.either.traverse,
        reduce: $0370766540a3ee1a$exports.either.reduce,
        wither: wither,
        wilt: wilt
    });
}
$0370766540a3ee1a$exports.getWitherable = $0370766540a3ee1a$var$getWitherable;
/**
 * Converts a JavaScript Object Notation (JSON) string into an object.
 *
 * @example
 * import { parseJSON, toError } from 'fp-ts/lib/Either'
 *
 * assert.deepStrictEqual(parseJSON('{"a":1}', toError).value, { a: 1 })
 * assert.deepStrictEqual(parseJSON('{"a":}', toError).value, new SyntaxError('Unexpected token } in JSON at position 5'))
 *
 * @since 1.16.0
 */ $0370766540a3ee1a$exports.parseJSON = function(s, onError) {
    return $0370766540a3ee1a$exports.tryCatch2v(function() {
        return JSON.parse(s);
    }, onError);
};
/**
 * Converts a JavaScript value to a JavaScript Object Notation (JSON) string.
 *
 * @example
 * import { stringifyJSON, toError } from 'fp-ts/lib/Either'
 *
 * assert.deepStrictEqual(stringifyJSON({ a: 1 }, toError).value, '{"a":1}')
 * const circular: any = { ref: null }
 * circular.ref = circular
 * assert.deepStrictEqual(stringifyJSON(circular, toError).value, new TypeError('Converting circular structure to JSON'))
 *
 * @since 1.16.0
 */ $0370766540a3ee1a$exports.stringifyJSON = function(u, onError) {
    return $0370766540a3ee1a$exports.tryCatch2v(function() {
        return JSON.stringify(u);
    }, onError);
};
var $0370766540a3ee1a$var$throwError = $0370766540a3ee1a$exports.left;
var $0370766540a3ee1a$var$fromEither = $da18856e9734b7b7$exports.identity;
/**
 * @since 1.0.0
 */ $0370766540a3ee1a$exports.either = {
    URI: $0370766540a3ee1a$exports.URI,
    map: function(ma, f) {
        return ma.map(f);
    },
    of: $0370766540a3ee1a$exports.right,
    ap: function(mab, ma) {
        return ma.ap(mab);
    },
    chain: function(ma, f) {
        return ma.chain(f);
    },
    reduce: function(fa, b, f) {
        return fa.reduce(b, f);
    },
    foldMap: function(M) {
        return function(fa, f) {
            return fa.isLeft() ? M.empty : f(fa.value);
        };
    },
    foldr: function(fa, b, f) {
        return fa.isLeft() ? b : f(fa.value, b);
    },
    traverse: function(F) {
        return function(ta, f) {
            return ta.isLeft() ? F.of($0370766540a3ee1a$exports.left(ta.value)) : F.map(f(ta.value), $0370766540a3ee1a$exports.right);
        };
    },
    sequence: function(F) {
        return function(ta) {
            return ta.isLeft() ? F.of($0370766540a3ee1a$exports.left(ta.value)) : F.map(ta.value, $0370766540a3ee1a$exports.right);
        };
    },
    bimap: function(fla, f, g) {
        return fla.bimap(f, g);
    },
    alt: function(mx, my) {
        return mx.alt(my);
    },
    extend: function(wa, f) {
        return wa.extend(f);
    },
    chainRec: function(a, f) {
        return $9b044b6f3e28deb5$exports.tailRec(function(e) {
            if (e.isLeft()) return $0370766540a3ee1a$exports.right($0370766540a3ee1a$exports.left(e.value));
            else {
                var r = e.value;
                return r.isLeft() ? $0370766540a3ee1a$exports.left(f(r.value)) : $0370766540a3ee1a$exports.right($0370766540a3ee1a$exports.right(r.value));
            }
        }, f(a));
    },
    throwError: $0370766540a3ee1a$var$throwError,
    fromEither: $0370766540a3ee1a$var$fromEither,
    fromOption: function(o, e) {
        return o.isNone() ? $0370766540a3ee1a$var$throwError(e) : $0370766540a3ee1a$exports.right(o.value);
    }
};
//
// backporting
//
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$fold(onLeft, onRight) {
    return function(ma) {
        return ma.fold(onLeft, onRight);
    };
}
$0370766540a3ee1a$exports.fold = $0370766540a3ee1a$var$fold;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$orElse(f) {
    return function(ma) {
        return ma.orElse(f);
    };
}
$0370766540a3ee1a$exports.orElse = $0370766540a3ee1a$var$orElse;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$getOrElse(f) {
    return function(ma) {
        return ma.getOrElseL(f);
    };
}
$0370766540a3ee1a$exports.getOrElse = $0370766540a3ee1a$var$getOrElse;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$elem(E) {
    return function(a) {
        return function(ma) {
            return $0370766540a3ee1a$exports.isLeft(ma) ? false : E.equals(a, ma.value);
        };
    };
}
$0370766540a3ee1a$exports.elem = $0370766540a3ee1a$var$elem;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$getValidation(S) {
    return {
        URI: $0370766540a3ee1a$exports.URI,
        _L: undefined,
        map: $0370766540a3ee1a$exports.either.map,
        of: $0370766540a3ee1a$exports.either.of,
        ap: function(mab, ma) {
            return $0370766540a3ee1a$exports.isLeft(mab) ? $0370766540a3ee1a$exports.isLeft(ma) ? $0370766540a3ee1a$exports.left(S.concat(mab.value, ma.value)) : mab : $0370766540a3ee1a$exports.isLeft(ma) ? ma : $0370766540a3ee1a$exports.right(mab.value(ma.value));
        },
        chain: $0370766540a3ee1a$exports.either.chain,
        alt: function(fx, fy) {
            if ($0370766540a3ee1a$exports.isRight(fx)) return fx;
            return $0370766540a3ee1a$exports.isLeft(fy) ? $0370766540a3ee1a$exports.left(S.concat(fx.value, fy.value)) : fy;
        }
    };
}
$0370766540a3ee1a$exports.getValidation = $0370766540a3ee1a$var$getValidation;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$getValidationSemigroup(SE, SA) {
    return {
        concat: function(fx, fy) {
            return $0370766540a3ee1a$exports.isLeft(fx) ? $0370766540a3ee1a$exports.isLeft(fy) ? $0370766540a3ee1a$exports.left(SE.concat(fx.value, fy.value)) : fx : $0370766540a3ee1a$exports.isLeft(fy) ? fy : $0370766540a3ee1a$exports.right(SA.concat(fx.value, fy.value));
        }
    };
}
$0370766540a3ee1a$exports.getValidationSemigroup = $0370766540a3ee1a$var$getValidationSemigroup;
/**
 * @since 1.19.0
 */ function $0370766540a3ee1a$var$getValidationMonoid(SE, SA) {
    return {
        concat: $0370766540a3ee1a$var$getValidationSemigroup(SE, SA).concat,
        empty: $0370766540a3ee1a$exports.right(SA.empty)
    };
}
$0370766540a3ee1a$exports.getValidationMonoid = $0370766540a3ee1a$var$getValidationMonoid;
var $0370766540a3ee1a$var$_a = $418bb2c9516a5b59$exports.pipeable($0370766540a3ee1a$exports.either), $0370766540a3ee1a$var$alt = $0370766540a3ee1a$var$_a.alt, $0370766540a3ee1a$var$ap = $0370766540a3ee1a$var$_a.ap, $0370766540a3ee1a$var$apFirst = $0370766540a3ee1a$var$_a.apFirst, $0370766540a3ee1a$var$apSecond = $0370766540a3ee1a$var$_a.apSecond, $0370766540a3ee1a$var$bimap = $0370766540a3ee1a$var$_a.bimap, $0370766540a3ee1a$var$chain = $0370766540a3ee1a$var$_a.chain, $0370766540a3ee1a$var$chainFirst = $0370766540a3ee1a$var$_a.chainFirst, $0370766540a3ee1a$var$duplicate = $0370766540a3ee1a$var$_a.duplicate, $0370766540a3ee1a$var$extend = $0370766540a3ee1a$var$_a.extend, $0370766540a3ee1a$var$flatten = $0370766540a3ee1a$var$_a.flatten, $0370766540a3ee1a$var$foldMap = $0370766540a3ee1a$var$_a.foldMap, $0370766540a3ee1a$var$map = $0370766540a3ee1a$var$_a.map, $0370766540a3ee1a$var$mapLeft = $0370766540a3ee1a$var$_a.mapLeft, $0370766540a3ee1a$var$reduce = $0370766540a3ee1a$var$_a.reduce, $0370766540a3ee1a$var$reduceRight = $0370766540a3ee1a$var$_a.reduceRight, $0370766540a3ee1a$var$fromPredicate = $0370766540a3ee1a$var$_a.fromPredicate, $0370766540a3ee1a$var$filterOrElse = $0370766540a3ee1a$var$_a.filterOrElse, $0370766540a3ee1a$var$pipeableFromOption = $0370766540a3ee1a$var$_a.fromOption;
$0370766540a3ee1a$exports.alt = $0370766540a3ee1a$var$alt;
$0370766540a3ee1a$exports.ap = $0370766540a3ee1a$var$ap;
$0370766540a3ee1a$exports.apFirst = $0370766540a3ee1a$var$apFirst;
$0370766540a3ee1a$exports.apSecond = $0370766540a3ee1a$var$apSecond;
$0370766540a3ee1a$exports.bimap = $0370766540a3ee1a$var$bimap;
$0370766540a3ee1a$exports.chain = $0370766540a3ee1a$var$chain;
$0370766540a3ee1a$exports.chainFirst = $0370766540a3ee1a$var$chainFirst;
$0370766540a3ee1a$exports.duplicate = $0370766540a3ee1a$var$duplicate;
$0370766540a3ee1a$exports.extend = $0370766540a3ee1a$var$extend;
$0370766540a3ee1a$exports.flatten = $0370766540a3ee1a$var$flatten;
$0370766540a3ee1a$exports.foldMap = $0370766540a3ee1a$var$foldMap;
$0370766540a3ee1a$exports.map = $0370766540a3ee1a$var$map;
$0370766540a3ee1a$exports.mapLeft = $0370766540a3ee1a$var$mapLeft;
$0370766540a3ee1a$exports.reduce = $0370766540a3ee1a$var$reduce;
$0370766540a3ee1a$exports.reduceRight = $0370766540a3ee1a$var$reduceRight;
$0370766540a3ee1a$exports.fromPredicate = $0370766540a3ee1a$var$fromPredicate;
$0370766540a3ee1a$exports.filterOrElse = $0370766540a3ee1a$var$filterOrElse;
/**
 * Lazy version of `fromOption`
 *
 * @since 1.3.0
 */ $0370766540a3ee1a$exports.fromOptionL = $0370766540a3ee1a$var$pipeableFromOption;



var $a299095f4f86d8f0$exports = {};
"use strict";
Object.defineProperty($a299095f4f86d8f0$exports, "__esModule", {
    value: true
});
var $779003da930f62c7$exports = {};
"use strict";
Object.defineProperty($779003da930f62c7$exports, "__esModule", {
    value: true
});

var $c07775bc63cd1cbe$exports = {};
"use strict";
var $c07775bc63cd1cbe$var$__assign = $c07775bc63cd1cbe$exports && $c07775bc63cd1cbe$exports.__assign || function() {
    $c07775bc63cd1cbe$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c07775bc63cd1cbe$var$__assign.apply(this, arguments);
};
Object.defineProperty($c07775bc63cd1cbe$exports, "__esModule", {
    value: true
});





$c07775bc63cd1cbe$exports.URI = "Option";
var $c07775bc63cd1cbe$var$None = /** @class */ function() {
    function None() {
        this._tag = "None";
    }
    /**
     * Takes a function `f` and an `Option` of `A`. Maps `f` either on `None` or `Some`, Option's data constructors. If it
     * maps on `Some` then it will apply the `f` on `Some`'s value, if it maps on `None` it will return `None`.
     *
     * @example
     * import { some } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(some(1).map(n => n * 2), some(2))
     * @obsolete
     */ None.prototype.map = function(f) {
        return $c07775bc63cd1cbe$exports.none;
    };
    /**
     * Maps `f` over this `Option`'s value. If the value returned from `f` is null or undefined, returns `None`
     *
     * @example
     * import { none, some } from 'fp-ts/lib/Option'
     *
     * interface Foo {
     *   bar?: {
     *     baz?: string
     *   }
     * }
     *
     * assert.deepStrictEqual(
     *   some<Foo>({ bar: { baz: 'quux' } })
     *     .mapNullable(foo => foo.bar)
     *     .mapNullable(bar => bar.baz),
     *   some('quux')
     * )
     * assert.deepStrictEqual(
     *   some<Foo>({ bar: {} })
     *     .mapNullable(foo => foo.bar)
     *     .mapNullable(bar => bar.baz),
     *   none
     * )
     * assert.deepStrictEqual(
     *   some<Foo>({})
     *     .mapNullable(foo => foo.bar)
     *     .mapNullable(bar => bar.baz),
     *   none
     * )
     * @obsolete
     */ None.prototype.mapNullable = function(f) {
        return $c07775bc63cd1cbe$exports.none;
    };
    /**
     * `ap`, some may also call it "apply". Takes a function `fab` that is in the context of `Option`, and applies that
     * function to this `Option`'s value. If the `Option` calling `ap` is `none` it will return `none`.
     *
     * @example
     * import { some, none } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(some(2).ap(some((x: number) => x + 1)), some(3))
     * assert.deepStrictEqual(none.ap(some((x: number) => x + 1)), none)
     * @obsolete
     */ None.prototype.ap = function(fab) {
        return $c07775bc63cd1cbe$exports.none;
    };
    /**
     * Flipped version of `ap`
     *
     * @example
     * import { some, none } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(some((x: number) => x + 1).ap_(some(2)), some(3))
     * assert.deepStrictEqual(none.ap_(some(2)), none)
     * @obsolete
     */ None.prototype.ap_ = function(fb) {
        return fb.ap(this);
    };
    /**
     * Returns the result of applying f to this `Option`'s value if this `Option` is nonempty. Returns `None` if this
     * `Option` is empty. Slightly different from `map` in that `f` is expected to return an `Option` (which could be
     * `None`)
     * @obsolete
     */ None.prototype.chain = function(f) {
        return $c07775bc63cd1cbe$exports.none;
    };
    /** @obsolete */ None.prototype.reduce = function(b, f) {
        return b;
    };
    /**
     * `alt` short for alternative, takes another `Option`. If this `Option` is a `Some` type then it will be returned, if
     * it is a `None` then it will return the next `Some` if it exist. If both are `None` then it will return `none`.
     *
     * @example
     * import { Option, some, none } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(some(2).alt(some(4)), some(2))
     * const fa: Option<number> = none
     * assert.deepStrictEqual(fa.alt(some(4)), some(4))
     * @obsolete
     */ None.prototype.alt = function(fa) {
        return fa;
    };
    /**
     * Lazy version of `alt`
     *
     * @example
     * import { some } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(some(1).orElse(() => some(2)), some(1))
     *
     * @since 1.6.0
     * @obsolete
     */ None.prototype.orElse = function(fa) {
        return fa();
    };
    /** @obsolete */ None.prototype.extend = function(f) {
        return $c07775bc63cd1cbe$exports.none;
    };
    /**
     * Applies a function to each case in the data structure
     *
     * @example
     * import { none, some } from 'fp-ts/lib/Option'
     *
     * assert.strictEqual(some(1).fold('none', a => `some: ${a}`), 'some: 1')
     * assert.strictEqual(none.fold('none', a => `some: ${a}`), 'none')
     * @obsolete
     */ None.prototype.fold = function(b, onSome) {
        return b;
    };
    /**
     * Lazy version of `fold`
     * @obsolete
     */ None.prototype.foldL = function(onNone, onSome) {
        return onNone();
    };
    /**
     * Returns the value from this `Some` or the given argument if this is a `None`
     *
     * @example
     * import { Option, none, some } from 'fp-ts/lib/Option'
     *
     * assert.strictEqual(some(1).getOrElse(0), 1)
     * const fa: Option<number> = none
     * assert.strictEqual(fa.getOrElse(0), 0)
     * @obsolete
     */ None.prototype.getOrElse = function(a) {
        return a;
    };
    /**
     * Lazy version of `getOrElse`
     * @obsolete
     */ None.prototype.getOrElseL = function(f) {
        return f();
    };
    /**
     * Returns the value from this `Some` or `null` if this is a `None`
     * @obsolete
     */ None.prototype.toNullable = function() {
        return null;
    };
    /**
     * Returns the value from this `Some` or `undefined` if this is a `None`
     * @obsolete
     */ None.prototype.toUndefined = function() {
        return undefined;
    };
    None.prototype.inspect = function() {
        return this.toString();
    };
    None.prototype.toString = function() {
        return "none";
    };
    /**
     * Returns `true` if the option has an element that is equal (as determined by `S`) to `a`, `false` otherwise
     * @obsolete
     */ None.prototype.contains = function(E, a) {
        return false;
    };
    /**
     * Returns `true` if the option is `None`, `false` otherwise
     * @obsolete
     */ None.prototype.isNone = function() {
        return true;
    };
    /**
     * Returns `true` if the option is an instance of `Some`, `false` otherwise
     * @obsolete
     */ None.prototype.isSome = function() {
        return false;
    };
    /**
     * Returns `true` if this option is non empty and the predicate `p` returns `true` when applied to this Option's value
     * @obsolete
     */ None.prototype.exists = function(p) {
        return false;
    };
    None.prototype.filter = function(p) {
        return $c07775bc63cd1cbe$exports.none;
    };
    /**
     * Use `filter` instead.
     * Returns this option refined as `Option<B>` if it is non empty and the `refinement` returns `true` when applied to
     * this Option's value. Otherwise returns `None`
     * @since 1.3.0
     * @deprecated
     */ None.prototype.refine = function(refinement) {
        return $c07775bc63cd1cbe$exports.none;
    };
    None.value = new None();
    return None;
}();
$c07775bc63cd1cbe$exports.None = $c07775bc63cd1cbe$var$None;
/**
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.none = $c07775bc63cd1cbe$var$None.value;
var $c07775bc63cd1cbe$var$Some = /** @class */ function() {
    function Some(value) {
        this.value = value;
        this._tag = "Some";
    }
    Some.prototype.map = function(f) {
        return new Some(f(this.value));
    };
    Some.prototype.mapNullable = function(f) {
        return $c07775bc63cd1cbe$exports.fromNullable(f(this.value));
    };
    Some.prototype.ap = function(fab) {
        return fab.isNone() ? $c07775bc63cd1cbe$exports.none : new Some(fab.value(this.value));
    };
    Some.prototype.ap_ = function(fb) {
        return fb.ap(this);
    };
    Some.prototype.chain = function(f) {
        return f(this.value);
    };
    Some.prototype.reduce = function(b, f) {
        return f(b, this.value);
    };
    Some.prototype.alt = function(fa) {
        return this;
    };
    Some.prototype.orElse = function(fa) {
        return this;
    };
    Some.prototype.extend = function(f) {
        return new Some(f(this));
    };
    Some.prototype.fold = function(b, onSome) {
        return onSome(this.value);
    };
    Some.prototype.foldL = function(onNone, onSome) {
        return onSome(this.value);
    };
    Some.prototype.getOrElse = function(a) {
        return this.value;
    };
    Some.prototype.getOrElseL = function(f) {
        return this.value;
    };
    Some.prototype.toNullable = function() {
        return this.value;
    };
    Some.prototype.toUndefined = function() {
        return this.value;
    };
    Some.prototype.inspect = function() {
        return this.toString();
    };
    Some.prototype.toString = function() {
        // tslint:disable-next-line: deprecation
        return "some(" + $da18856e9734b7b7$exports.toString(this.value) + ")";
    };
    Some.prototype.contains = function(E, a) {
        return E.equals(this.value, a);
    };
    Some.prototype.isNone = function() {
        return false;
    };
    Some.prototype.isSome = function() {
        return true;
    };
    Some.prototype.exists = function(p) {
        return p(this.value);
    };
    Some.prototype.filter = function(p) {
        return this.exists(p) ? this : $c07775bc63cd1cbe$exports.none;
    };
    Some.prototype.refine = function(refinement) {
        return this.filter(refinement);
    };
    return Some;
}();
$c07775bc63cd1cbe$exports.Some = $c07775bc63cd1cbe$var$Some;
/**
 * @since 1.17.0
 */ $c07775bc63cd1cbe$exports.getShow = function(S) {
    return {
        show: function(oa) {
            return oa.fold("none", function(a) {
                return "some(" + S.show(a) + ")";
            });
        }
    };
};
/**
 * Use `getEq`
 *
 * @since 1.0.0
 * @deprecated
 */ $c07775bc63cd1cbe$exports.getSetoid = $c07775bc63cd1cbe$var$getEq;
/**
 * @example
 * import { none, some, getEq } from 'fp-ts/lib/Option'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * const S = getEq(eqNumber)
 * assert.strictEqual(S.equals(none, none), true)
 * assert.strictEqual(S.equals(none, some(1)), false)
 * assert.strictEqual(S.equals(some(1), none), false)
 * assert.strictEqual(S.equals(some(1), some(2)), false)
 * assert.strictEqual(S.equals(some(1), some(1)), true)
 *
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$getEq(E) {
    return $4e552386da5371f0$exports.fromEquals(function(x, y) {
        return x.isNone() ? y.isNone() : y.isNone() ? false : E.equals(x.value, y.value);
    });
}
$c07775bc63cd1cbe$exports.getEq = $c07775bc63cd1cbe$var$getEq;
/**
 * The `Ord` instance allows `Option` values to be compared with
 * `compare`, whenever there is an `Ord` instance for
 * the type the `Option` contains.
 *
 * `None` is considered to be less than any `Some` value.
 *
 *
 * @example
 * import { none, some, getOrd } from 'fp-ts/lib/Option'
 * import { ordNumber } from 'fp-ts/lib/Ord'
 *
 * const O = getOrd(ordNumber)
 * assert.strictEqual(O.compare(none, none), 0)
 * assert.strictEqual(O.compare(none, some(1)), -1)
 * assert.strictEqual(O.compare(some(1), none), 1)
 * assert.strictEqual(O.compare(some(1), some(2)), -1)
 * assert.strictEqual(O.compare(some(1), some(1)), 0)
 *
 * @since 1.2.0
 */ $c07775bc63cd1cbe$exports.getOrd = function(O) {
    return $37e5cd3b0c7fa08f$exports.fromCompare(function(x, y) {
        return x.isSome() ? y.isSome() ? O.compare(x.value, y.value) : 1 : -1;
    });
};
/**
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.some = function(a) {
    return new $c07775bc63cd1cbe$var$Some(a);
};
/**
 * `Apply` semigroup
 *
 * | x       | y       | concat(x, y)       |
 * | ------- | ------- | ------------------ |
 * | none    | none    | none               |
 * | some(a) | none    | none               |
 * | none    | some(a) | none               |
 * | some(a) | some(b) | some(concat(a, b)) |
 *
 * @example
 * import { getApplySemigroup, some, none } from 'fp-ts/lib/Option'
 * import { semigroupSum } from 'fp-ts/lib/Semigroup'
 *
 * const S = getApplySemigroup(semigroupSum)
 * assert.deepStrictEqual(S.concat(none, none), none)
 * assert.deepStrictEqual(S.concat(some(1), none), none)
 * assert.deepStrictEqual(S.concat(none, some(1)), none)
 * assert.deepStrictEqual(S.concat(some(1), some(2)), some(3))
 *
 * @since 1.7.0
 */ $c07775bc63cd1cbe$exports.getApplySemigroup = function(S) {
    return {
        concat: function(x, y) {
            return x.isSome() && y.isSome() ? $c07775bc63cd1cbe$exports.some(S.concat(x.value, y.value)) : $c07775bc63cd1cbe$exports.none;
        }
    };
};
/**
 * @since 1.7.0
 */ $c07775bc63cd1cbe$exports.getApplyMonoid = function(M) {
    return $c07775bc63cd1cbe$var$__assign({}, $c07775bc63cd1cbe$exports.getApplySemigroup(M), {
        empty: $c07775bc63cd1cbe$exports.some(M.empty)
    });
};
/**
 * Monoid returning the left-most non-`None` value
 *
 * | x       | y       | concat(x, y) |
 * | ------- | ------- | ------------ |
 * | none    | none    | none         |
 * | some(a) | none    | some(a)      |
 * | none    | some(a) | some(a)      |
 * | some(a) | some(b) | some(a)      |
 *
 * @example
 * import { getFirstMonoid, some, none } from 'fp-ts/lib/Option'
 *
 * const M = getFirstMonoid<number>()
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(1)), some(1))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(1))
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.getFirstMonoid = function() {
    return {
        concat: $c07775bc63cd1cbe$exports.option.alt,
        empty: $c07775bc63cd1cbe$exports.none
    };
};
/**
 * Monoid returning the right-most non-`None` value
 *
 * | x       | y       | concat(x, y) |
 * | ------- | ------- | ------------ |
 * | none    | none    | none         |
 * | some(a) | none    | some(a)      |
 * | none    | some(a) | some(a)      |
 * | some(a) | some(b) | some(b)      |
 *
 * @example
 * import { getLastMonoid, some, none } from 'fp-ts/lib/Option'
 *
 * const M = getLastMonoid<number>()
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(1)), some(1))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(2))
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.getLastMonoid = function() {
    return $e11eb2700046c52f$exports.getDualMonoid($c07775bc63cd1cbe$exports.getFirstMonoid());
};
/**
 * Monoid returning the left-most non-`None` value. If both operands are `Some`s then the inner values are
 * appended using the provided `Semigroup`
 *
 * | x       | y       | concat(x, y)       |
 * | ------- | ------- | ------------------ |
 * | none    | none    | none               |
 * | some(a) | none    | some(a)            |
 * | none    | some(a) | some(a)            |
 * | some(a) | some(b) | some(concat(a, b)) |
 *
 * @example
 * import { getMonoid, some, none } from 'fp-ts/lib/Option'
 * import { semigroupSum } from 'fp-ts/lib/Semigroup'
 *
 * const M = getMonoid(semigroupSum)
 * assert.deepStrictEqual(M.concat(none, none), none)
 * assert.deepStrictEqual(M.concat(some(1), none), some(1))
 * assert.deepStrictEqual(M.concat(none, some(1)), some(1))
 * assert.deepStrictEqual(M.concat(some(1), some(2)), some(3))
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.getMonoid = function(S) {
    return {
        concat: function(x, y) {
            return x.isNone() ? y : y.isNone() ? x : $c07775bc63cd1cbe$exports.some(S.concat(x.value, y.value));
        },
        empty: $c07775bc63cd1cbe$exports.none
    };
};
/**
 * Constructs a new `Option` from a nullable type. If the value is `null` or `undefined`, returns `None`, otherwise
 * returns the value wrapped in a `Some`
 *
 * @example
 * import { none, some, fromNullable } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(fromNullable(undefined), none)
 * assert.deepStrictEqual(fromNullable(null), none)
 * assert.deepStrictEqual(fromNullable(1), some(1))
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.fromNullable = function(a) {
    return a == null ? $c07775bc63cd1cbe$exports.none : new $c07775bc63cd1cbe$var$Some(a);
};
function $c07775bc63cd1cbe$var$fromPredicate(predicate) {
    return function(a) {
        return predicate(a) ? $c07775bc63cd1cbe$exports.some(a) : $c07775bc63cd1cbe$exports.none;
    };
}
$c07775bc63cd1cbe$exports.fromPredicate = $c07775bc63cd1cbe$var$fromPredicate;
/**
 * Transforms an exception into an `Option`. If `f` throws, returns `None`, otherwise returns the output wrapped in
 * `Some`
 *
 * @example
 * import { none, some, tryCatch } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(
 *   tryCatch(() => {
 *     throw new Error()
 *   }),
 *   none
 * )
 * assert.deepStrictEqual(tryCatch(() => 1), some(1))
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.tryCatch = function(f) {
    try {
        return $c07775bc63cd1cbe$exports.some(f());
    } catch (e) {
        return $c07775bc63cd1cbe$exports.none;
    }
};
/**
 * Constructs a new `Option` from a `Either`. If the value is a `Left`, returns `None`, otherwise returns the inner
 * value wrapped in a `Some`
 *
 * @example
 * import { none, some, fromEither } from 'fp-ts/lib/Option'
 * import { left, right } from 'fp-ts/lib/Either'
 *
 * assert.deepStrictEqual(fromEither(left(1)), none)
 * assert.deepStrictEqual(fromEither(right(1)), some(1))
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.fromEither = function(fa) {
    return fa.isLeft() ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(fa.value);
};
/**
 * Returns `true` if the option is an instance of `Some`, `false` otherwise
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.isSome = function(fa) {
    return fa.isSome();
};
/**
 * Returns `true` if the option is `None`, `false` otherwise
 *
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.isNone = function(fa) {
    return fa.isNone();
};
/**
 * Use `fromPredicate` instead.
 * Refinement version of `fromPredicate`
 *
 * @since 1.3.0
 * @deprecated
 */ $c07775bc63cd1cbe$exports.fromRefinement = function(refinement) {
    return function(a) {
        return refinement(a) ? $c07775bc63cd1cbe$exports.some(a) : $c07775bc63cd1cbe$exports.none;
    };
};
/**
 * Returns a refinement from a prism.
 * This function ensures that a custom type guard definition is type-safe.
 *
 * ```ts
 * import { some, none, getRefinement } from 'fp-ts/lib/Option'
 *
 * type A = { type: 'A' }
 * type B = { type: 'B' }
 * type C = A | B
 *
 * const isA = (c: C): c is A => c.type === 'B' // <= typo but typescript doesn't complain
 * const isA = getRefinement<C, A>(c => (c.type === 'B' ? some(c) : none)) // static error: Type '"B"' is not assignable to type '"A"'
 * ```
 *
 * @since 1.7.0
 */ $c07775bc63cd1cbe$exports.getRefinement = function(getOption) {
    return function(a) {
        return getOption(a).isSome();
    };
};
var $c07775bc63cd1cbe$var$defaultSeparate = {
    left: $c07775bc63cd1cbe$exports.none,
    right: $c07775bc63cd1cbe$exports.none
};
/**
 * @since 1.0.0
 */ $c07775bc63cd1cbe$exports.option = {
    URI: $c07775bc63cd1cbe$exports.URI,
    map: function(ma, f) {
        return $c07775bc63cd1cbe$exports.isNone(ma) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(f(ma.value));
    },
    of: $c07775bc63cd1cbe$exports.some,
    ap: function(mab, ma) {
        return $c07775bc63cd1cbe$exports.isNone(mab) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.isNone(ma) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(mab.value(ma.value));
    },
    chain: function(ma, f) {
        return $c07775bc63cd1cbe$exports.isNone(ma) ? $c07775bc63cd1cbe$exports.none : f(ma.value);
    },
    reduce: function(fa, b, f) {
        return $c07775bc63cd1cbe$exports.isNone(fa) ? b : f(b, fa.value);
    },
    foldMap: function(M) {
        return function(fa, f) {
            return $c07775bc63cd1cbe$exports.isNone(fa) ? M.empty : f(fa.value);
        };
    },
    foldr: function(fa, b, f) {
        return $c07775bc63cd1cbe$exports.isNone(fa) ? b : f(fa.value, b);
    },
    traverse: function(F) {
        return function(ta, f) {
            return $c07775bc63cd1cbe$exports.isNone(ta) ? F.of($c07775bc63cd1cbe$exports.none) : F.map(f(ta.value), $c07775bc63cd1cbe$exports.some);
        };
    },
    sequence: function(F) {
        return function(ta) {
            return $c07775bc63cd1cbe$exports.isNone(ta) ? F.of($c07775bc63cd1cbe$exports.none) : F.map(ta.value, $c07775bc63cd1cbe$exports.some);
        };
    },
    zero: function() {
        return $c07775bc63cd1cbe$exports.none;
    },
    alt: function(mx, my) {
        return $c07775bc63cd1cbe$exports.isNone(mx) ? my : mx;
    },
    extend: function(wa, f) {
        return $c07775bc63cd1cbe$exports.isNone(wa) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(f(wa));
    },
    compact: function(ma) {
        return $c07775bc63cd1cbe$exports.option.chain(ma, $da18856e9734b7b7$exports.identity);
    },
    separate: function(ma) {
        var o = $c07775bc63cd1cbe$exports.option.map(ma, function(e) {
            return {
                left: $c07775bc63cd1cbe$var$getLeft(e),
                right: $c07775bc63cd1cbe$var$getRight(e)
            };
        });
        return $c07775bc63cd1cbe$exports.isNone(o) ? $c07775bc63cd1cbe$var$defaultSeparate : o.value;
    },
    filter: function(fa, predicate) {
        return $c07775bc63cd1cbe$exports.isNone(fa) ? $c07775bc63cd1cbe$exports.none : predicate(fa.value) ? fa : $c07775bc63cd1cbe$exports.none;
    },
    filterMap: function(ma, f) {
        return $c07775bc63cd1cbe$exports.isNone(ma) ? $c07775bc63cd1cbe$exports.none : f(ma.value);
    },
    partition: function(fa, predicate) {
        return {
            left: $c07775bc63cd1cbe$exports.option.filter(fa, function(a) {
                return !predicate(a);
            }),
            right: $c07775bc63cd1cbe$exports.option.filter(fa, predicate)
        };
    },
    partitionMap: function(fa, f) {
        return $c07775bc63cd1cbe$exports.option.separate($c07775bc63cd1cbe$exports.option.map(fa, f));
    },
    wither: function(F) {
        return function(fa, f) {
            return $c07775bc63cd1cbe$exports.isNone(fa) ? F.of($c07775bc63cd1cbe$exports.none) : f(fa.value);
        };
    },
    wilt: function(F) {
        return function(fa, f) {
            var o = $c07775bc63cd1cbe$exports.option.map(fa, function(a) {
                return F.map(f(a), function(e) {
                    return {
                        left: $c07775bc63cd1cbe$var$getLeft(e),
                        right: $c07775bc63cd1cbe$var$getRight(e)
                    };
                });
            });
            return $c07775bc63cd1cbe$exports.isNone(o) ? F.of({
                left: $c07775bc63cd1cbe$exports.none,
                right: $c07775bc63cd1cbe$exports.none
            }) : o.value;
        };
    },
    throwError: function() {
        return $c07775bc63cd1cbe$exports.none;
    },
    fromEither: $c07775bc63cd1cbe$exports.fromEither,
    fromOption: $da18856e9734b7b7$exports.identity
};
//
// backporting
//
/**
 * Returns an `L` value if possible
 *
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$getLeft(ma) {
    return ma._tag === "Right" ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(ma.value);
}
$c07775bc63cd1cbe$exports.getLeft = $c07775bc63cd1cbe$var$getLeft;
/**
 * Returns an `A` value if possible
 *
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$getRight(ma) {
    return ma._tag === "Left" ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(ma.value);
}
$c07775bc63cd1cbe$exports.getRight = $c07775bc63cd1cbe$var$getRight;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$fold(onNone, onSome) {
    return function(ma) {
        return ma.foldL(onNone, onSome);
    };
}
$c07775bc63cd1cbe$exports.fold = $c07775bc63cd1cbe$var$fold;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$toNullable(ma) {
    return ma.toNullable();
}
$c07775bc63cd1cbe$exports.toNullable = $c07775bc63cd1cbe$var$toNullable;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$toUndefined(ma) {
    return ma.toUndefined();
}
$c07775bc63cd1cbe$exports.toUndefined = $c07775bc63cd1cbe$var$toUndefined;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$getOrElse(f) {
    return function(ma) {
        return ma.getOrElseL(f);
    };
}
$c07775bc63cd1cbe$exports.getOrElse = $c07775bc63cd1cbe$var$getOrElse;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$elem(E) {
    return function(a) {
        return function(ma) {
            return ma.contains(E, a);
        };
    };
}
$c07775bc63cd1cbe$exports.elem = $c07775bc63cd1cbe$var$elem;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$exists(predicate) {
    return function(ma) {
        return ma.exists(predicate);
    };
}
$c07775bc63cd1cbe$exports.exists = $c07775bc63cd1cbe$var$exists;
/**
 * @since 1.19.0
 */ function $c07775bc63cd1cbe$var$mapNullable(f) {
    return function(ma) {
        return ma.mapNullable(f);
    };
}
$c07775bc63cd1cbe$exports.mapNullable = $c07775bc63cd1cbe$var$mapNullable;
var $c07775bc63cd1cbe$var$_a = $418bb2c9516a5b59$exports.pipeable($c07775bc63cd1cbe$exports.option), $c07775bc63cd1cbe$var$alt = $c07775bc63cd1cbe$var$_a.alt, $c07775bc63cd1cbe$var$ap = $c07775bc63cd1cbe$var$_a.ap, $c07775bc63cd1cbe$var$apFirst = $c07775bc63cd1cbe$var$_a.apFirst, $c07775bc63cd1cbe$var$apSecond = $c07775bc63cd1cbe$var$_a.apSecond, $c07775bc63cd1cbe$var$chain = $c07775bc63cd1cbe$var$_a.chain, $c07775bc63cd1cbe$var$chainFirst = $c07775bc63cd1cbe$var$_a.chainFirst, $c07775bc63cd1cbe$var$duplicate = $c07775bc63cd1cbe$var$_a.duplicate, $c07775bc63cd1cbe$var$extend = $c07775bc63cd1cbe$var$_a.extend, $c07775bc63cd1cbe$var$filter = $c07775bc63cd1cbe$var$_a.filter, $c07775bc63cd1cbe$var$filterMap = $c07775bc63cd1cbe$var$_a.filterMap, $c07775bc63cd1cbe$var$flatten = $c07775bc63cd1cbe$var$_a.flatten, $c07775bc63cd1cbe$var$foldMap = $c07775bc63cd1cbe$var$_a.foldMap, $c07775bc63cd1cbe$var$map = $c07775bc63cd1cbe$var$_a.map, $c07775bc63cd1cbe$var$partition = $c07775bc63cd1cbe$var$_a.partition, $c07775bc63cd1cbe$var$partitionMap = $c07775bc63cd1cbe$var$_a.partitionMap, $c07775bc63cd1cbe$var$reduce = $c07775bc63cd1cbe$var$_a.reduce, $c07775bc63cd1cbe$var$reduceRight = $c07775bc63cd1cbe$var$_a.reduceRight, $c07775bc63cd1cbe$var$compact = $c07775bc63cd1cbe$var$_a.compact, $c07775bc63cd1cbe$var$separate = $c07775bc63cd1cbe$var$_a.separate;
$c07775bc63cd1cbe$exports.alt = $c07775bc63cd1cbe$var$alt;
$c07775bc63cd1cbe$exports.ap = $c07775bc63cd1cbe$var$ap;
$c07775bc63cd1cbe$exports.apFirst = $c07775bc63cd1cbe$var$apFirst;
$c07775bc63cd1cbe$exports.apSecond = $c07775bc63cd1cbe$var$apSecond;
$c07775bc63cd1cbe$exports.chain = $c07775bc63cd1cbe$var$chain;
$c07775bc63cd1cbe$exports.chainFirst = $c07775bc63cd1cbe$var$chainFirst;
$c07775bc63cd1cbe$exports.duplicate = $c07775bc63cd1cbe$var$duplicate;
$c07775bc63cd1cbe$exports.extend = $c07775bc63cd1cbe$var$extend;
$c07775bc63cd1cbe$exports.filter = $c07775bc63cd1cbe$var$filter;
$c07775bc63cd1cbe$exports.filterMap = $c07775bc63cd1cbe$var$filterMap;
$c07775bc63cd1cbe$exports.flatten = $c07775bc63cd1cbe$var$flatten;
$c07775bc63cd1cbe$exports.foldMap = $c07775bc63cd1cbe$var$foldMap;
$c07775bc63cd1cbe$exports.map = $c07775bc63cd1cbe$var$map;
$c07775bc63cd1cbe$exports.partition = $c07775bc63cd1cbe$var$partition;
$c07775bc63cd1cbe$exports.partitionMap = $c07775bc63cd1cbe$var$partitionMap;
$c07775bc63cd1cbe$exports.reduce = $c07775bc63cd1cbe$var$reduce;
$c07775bc63cd1cbe$exports.reduceRight = $c07775bc63cd1cbe$var$reduceRight;
$c07775bc63cd1cbe$exports.compact = $c07775bc63cd1cbe$var$compact;
$c07775bc63cd1cbe$exports.separate = $c07775bc63cd1cbe$var$separate;



var $b46dbf0f214f94d4$exports = {};
"use strict";
/**
 * @file This type class is deprecated, please use `Eq` instead.
 */ Object.defineProperty($b46dbf0f214f94d4$exports, "__esModule", {
    value: true
});
/**
 * Use `Eq.fromEquals` instead
 * @since 1.14.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.fromEquals = function(equals) {
    return {
        equals: function(x, y) {
            return x === y || equals(x, y);
        }
    };
};
/**
 * Use `Eq.strictEqual` instead
 * @since 1.0.0
 * @deprecated
 */ $b46dbf0f214f94d4$exports.strictEqual = function(a, b) {
    return a === b;
};
// tslint:disable-next-line: deprecation
var $b46dbf0f214f94d4$var$setoidStrict = {
    equals: $b46dbf0f214f94d4$exports.strictEqual
};
/**
 * Use `Eq.eqString` instead
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.setoidString = $b46dbf0f214f94d4$var$setoidStrict;
/**
 * Use `Eq.eqNumber` instead
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.setoidNumber = $b46dbf0f214f94d4$var$setoidStrict;
/**
 * Use `Eq.eqBoolean` instead
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.setoidBoolean = $b46dbf0f214f94d4$var$setoidStrict;
/**
 * Use `Array.getMonoid` instead
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.getArraySetoid = function(S) {
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.fromEquals(function(xs, ys) {
        return xs.length === ys.length && xs.every(function(x, i) {
            return S.equals(x, ys[i]);
        });
    });
};
/**
 * Use `Eq.getStructEq` instead
 * @since 1.14.2
 * @deprecated
 */ $b46dbf0f214f94d4$exports.getStructSetoid = function(// tslint:disable-next-line: deprecation
setoids) {
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.fromEquals(function(x, y) {
        for(var k in setoids){
            if (!setoids[k].equals(x[k], y[k])) return false;
        }
        return true;
    });
};
/**
 * Use `Eq.getStructEq` instead
 * @since 1.0.0
 * @deprecated
 */ $b46dbf0f214f94d4$exports.getRecordSetoid = function(// tslint:disable-next-line: deprecation
setoids) {
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.getStructSetoid(setoids);
};
/**
 * Use `Eq.getTupleEq` instead
 * @since 1.14.2
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.getTupleSetoid = function() {
    var setoids = [];
    for(var _i = 0; _i < arguments.length; _i++)setoids[_i] = arguments[_i];
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.fromEquals(function(x, y) {
        return setoids.every(function(S, i) {
            return S.equals(x[i], y[i]);
        });
    });
};
/**
 * Use `Eq.getTupleEq` instead
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.getProductSetoid = function(SA, SB) {
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.getTupleSetoid(SA, SB);
};
/**
 * Use `Eq.contramap` instead
 * @since 1.2.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.contramap = function(f, fa) {
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.fromEquals(function(x, y) {
        return fa.equals(f(x), f(y));
    });
};
/**
 * Use `Eq.eqDate` instead
 * @since 1.4.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$b46dbf0f214f94d4$exports.setoidDate = $b46dbf0f214f94d4$exports.contramap(function(date) {
    return date.valueOf();
}, $b46dbf0f214f94d4$exports.setoidNumber);



$779003da930f62c7$exports.URI = "Array";
/**
 * @since 1.17.0
 */ $779003da930f62c7$exports.getShow = function(S) {
    return {
        show: function(arr) {
            return "[" + arr.map(S.show).join(", ") + "]";
        }
    };
};
/**
 *
 * @example
 * import { getMonoid } from 'fp-ts/lib/Array'
 *
 * const M = getMonoid<number>()
 * assert.deepStrictEqual(M.concat([1, 2], [3, 4]), [1, 2, 3, 4])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.getMonoid = function() {
    return {
        concat: $da18856e9734b7b7$exports.concat,
        empty: $779003da930f62c7$exports.empty
    };
};
/**
 * Use `getEq`
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.getSetoid = $779003da930f62c7$var$getEq;
/**
 * Derives a `Eq` over the `Array` of a given element type from the `Eq` of that type. The derived eq defines two
 * arrays as equal if all elements of both arrays are compared equal pairwise with the given eq `S`. In case of
 * arrays of different lengths, the result is non equality.
 *
 * @example
 * import { eqString } from 'fp-ts/lib/Eq'
 * import { getEq } from 'fp-ts/lib/Array'
 *
 * const E = getEq(eqString)
 * assert.strictEqual(E.equals(['a', 'b'], ['a', 'b']), true)
 * assert.strictEqual(E.equals(['a'], []), false)
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$getEq(E) {
    // tslint:disable-next-line: deprecation
    return $b46dbf0f214f94d4$exports.getArraySetoid(E);
}
$779003da930f62c7$exports.getEq = $779003da930f62c7$var$getEq;
/**
 * Derives an `Ord` over the Array of a given element type from the `Ord` of that type. The ordering between two such
 * arrays is equal to: the first non equal comparison of each arrays elements taken pairwise in increasing order, in
 * case of equality over all the pairwise elements; the longest array is considered the greatest, if both arrays have
 * the same length, the result is equality.
 *
 *
 * @example
 * import { getOrd } from 'fp-ts/lib/Array'
 * import { ordString } from 'fp-ts/lib/Ord'
 *
 * const O = getOrd(ordString)
 * assert.strictEqual(O.compare(['b'], ['a']), 1)
 * assert.strictEqual(O.compare(['a'], ['a']), 0)
 * assert.strictEqual(O.compare(['a'], ['b']), -1)
 *
 *
 * @since 1.2.0
 */ $779003da930f62c7$exports.getOrd = function(O) {
    return $37e5cd3b0c7fa08f$exports.fromCompare(function(a, b) {
        var aLen = a.length;
        var bLen = b.length;
        var len = Math.min(aLen, bLen);
        for(var i = 0; i < len; i++){
            var order = O.compare(a[i], b[i]);
            if (order !== 0) return order;
        }
        return $37e5cd3b0c7fa08f$exports.ordNumber.compare(aLen, bLen);
    });
};
function $779003da930f62c7$var$traverse(F) {
    return $779003da930f62c7$exports.array.traverse(F);
}
$779003da930f62c7$exports.traverse = $779003da930f62c7$var$traverse;
/**
 * An empty array
 *
 *
 * @since 1.9.0
 */ $779003da930f62c7$exports.empty = [];
/**
 * Return a list of length `n` with element `i` initialized with `f(i)`
 *
 * @example
 * import { makeBy } from 'fp-ts/lib/Array'
 *
 * const double = (n: number): number => n * 2
 * assert.deepStrictEqual(makeBy(5, double), [0, 2, 4, 6, 8])
 *
 *
 * @since 1.10.0
 */ $779003da930f62c7$exports.makeBy = function(n, f) {
    var r = [];
    for(var i = 0; i < n; i++)r.push(f(i));
    return r;
};
/**
 * Create an array containing a range of integers, including both endpoints
 *
 * @example
 * import { range } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(range(1, 5), [1, 2, 3, 4, 5])
 *
 *
 * @since 1.10.0
 */ $779003da930f62c7$exports.range = function(start, end) {
    return $779003da930f62c7$exports.makeBy(end - start + 1, function(i) {
        return start + i;
    });
};
/**
 * Create an array containing a value repeated the specified number of times
 *
 * @example
 * import { replicate } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(replicate(3, 'a'), ['a', 'a', 'a'])
 *
 *
 * @since 1.10.0
 */ $779003da930f62c7$exports.replicate = function(n, a) {
    return $779003da930f62c7$exports.makeBy(n, function() {
        return a;
    });
};
/**
 * Removes one level of nesting
 *
 * @example
 * import { flatten } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(flatten([[1], [2], [3]]), [1, 2, 3])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.flatten = function(ffa) {
    var rLen = 0;
    var len = ffa.length;
    for(var i = 0; i < len; i++)rLen += ffa[i].length;
    var r = Array(rLen);
    var start = 0;
    for(var i = 0; i < len; i++){
        var arr = ffa[i];
        var l = arr.length;
        for(var j = 0; j < l; j++)r[j + start] = arr[j];
        start += l;
    }
    return r;
};
/**
 * Use `foldLeft`
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.fold = function(as, onNil, onCons) {
    return $779003da930f62c7$exports.isEmpty(as) ? onNil : onCons(as[0], as.slice(1));
};
/**
 * Use `foldLeft`
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.foldL = function(as, onNil, onCons) {
    return $779003da930f62c7$exports.isEmpty(as) ? onNil() : onCons(as[0], as.slice(1));
};
/**
 * Use `foldRight`
 *
 * @since 1.7.0
 * @deprecated
 */ $779003da930f62c7$exports.foldr = function(as, onNil, onCons) {
    return $779003da930f62c7$exports.isEmpty(as) ? onNil : onCons(as.slice(0, as.length - 1), as[as.length - 1]);
};
/**
 * Use `foldRight`
 *
 * @since 1.7.0
 * @deprecated
 */ $779003da930f62c7$exports.foldrL = function(as, onNil, onCons) {
    return $779003da930f62c7$exports.isEmpty(as) ? onNil() : onCons(as.slice(0, as.length - 1), as[as.length - 1]);
};
/**
 * Same as `reduce` but it carries over the intermediate steps
 *
 * ```ts
 * import { scanLeft } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(scanLeft([1, 2, 3], 10, (b, a) => b - a), [ 10, 9, 7, 4 ])
 * ```
 *
 *
 * @since 1.1.0
 */ $779003da930f62c7$exports.scanLeft = function(as, b, f) {
    var l = as.length;
    var r = new Array(l + 1);
    r[0] = b;
    for(var i = 0; i < l; i++)r[i + 1] = f(r[i], as[i]);
    return r;
};
/**
 * Fold an array from the right, keeping all intermediate results instead of only the final result
 *
 * @example
 * import { scanRight } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(scanRight([1, 2, 3], 10, (a, b) => b - a), [ 4, 5, 7, 10 ])
 *
 *
 * @since 1.1.0
 */ $779003da930f62c7$exports.scanRight = function(as, b, f) {
    var l = as.length;
    var r = new Array(l + 1);
    r[l] = b;
    for(var i = l - 1; i >= 0; i--)r[i] = f(as[i], r[i + 1]);
    return r;
};
/**
 * Test whether an array is empty
 *
 * @example
 * import { isEmpty } from 'fp-ts/lib/Array'
 *
 * assert.strictEqual(isEmpty([]), true)
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.isEmpty = function(as) {
    return as.length === 0;
};
/**
 * Test whether an array is non empty narrowing down the type to `NonEmptyArray<A>`
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$isNonEmpty(as) {
    return as.length > 0;
}
$779003da930f62c7$exports.isNonEmpty = $779003da930f62c7$var$isNonEmpty;
/**
 * Test whether an array contains a particular index
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.isOutOfBound = function(i, as) {
    return i < 0 || i >= as.length;
};
/**
 * This function provides a safe way to read a value at a particular index from an array
 *
 * @example
 * import { lookup } from 'fp-ts/lib/Array'
 * import { some, none } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(lookup(1, [1, 2, 3]), some(2))
 * assert.deepStrictEqual(lookup(3, [1, 2, 3]), none)
 *
 * @since 1.14.0
 */ $779003da930f62c7$exports.lookup = function(i, as) {
    return $779003da930f62c7$exports.isOutOfBound(i, as) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(as[i]);
};
/**
 * Use `lookup` instead
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.index = function(i, as) {
    return $779003da930f62c7$exports.lookup(i, as);
};
/**
 * Attaches an element to the front of an array, creating a new non empty array
 *
 * @example
 * import { cons } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(cons(0, [1, 2, 3]), [0, 1, 2, 3])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.cons = function(a, as) {
    var len = as.length;
    var r = Array(len + 1);
    for(var i = 0; i < len; i++)r[i + 1] = as[i];
    r[0] = a;
    return r;
};
/**
 * Append an element to the end of an array, creating a new non empty array
 *
 * @example
 * import { snoc } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(snoc([1, 2, 3], 4), [1, 2, 3, 4])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.snoc = function(as, a) {
    var len = as.length;
    var r = Array(len + 1);
    for(var i = 0; i < len; i++)r[i] = as[i];
    r[len] = a;
    return r;
};
/**
 * Get the first element in an array, or `None` if the array is empty
 *
 * @example
 * import { head } from 'fp-ts/lib/Array'
 * import { some, none } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(head([1, 2, 3]), some(1))
 * assert.deepStrictEqual(head([]), none)
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.head = function(as) {
    return $779003da930f62c7$exports.isEmpty(as) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(as[0]);
};
/**
 * Get the last element in an array, or `None` if the array is empty
 *
 * @example
 * import { last } from 'fp-ts/lib/Array'
 * import { some, none } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(last([1, 2, 3]), some(3))
 * assert.deepStrictEqual(last([]), none)
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.last = function(as) {
    return $779003da930f62c7$exports.lookup(as.length - 1, as);
};
/**
 * Get all but the first element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { tail } from 'fp-ts/lib/Array'
 * import { some, none } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(tail([1, 2, 3]), some([2, 3]))
 * assert.deepStrictEqual(tail([]), none)
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.tail = function(as) {
    return $779003da930f62c7$exports.isEmpty(as) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(as.slice(1));
};
/**
 * Get all but the last element of an array, creating a new array, or `None` if the array is empty
 *
 * @example
 * import { init } from 'fp-ts/lib/Array'
 * import { some, none } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(init([1, 2, 3]), some([1, 2]))
 * assert.deepStrictEqual(init([]), none)
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.init = function(as) {
    var len = as.length;
    return len === 0 ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(as.slice(0, len - 1));
};
/**
 * Use `takeLeft`
 *
 * @since 1.0.0
 * @deprecated
 */ function $779003da930f62c7$var$take(n, as) {
    return as.slice(0, n);
}
$779003da930f62c7$exports.take = $779003da930f62c7$var$take;
/**
 * Use `takeRight`
 *
 * @since 1.10.0
 * @deprecated
 */ $779003da930f62c7$exports.takeEnd = function(n, as) {
    return n === 0 ? $779003da930f62c7$exports.empty : as.slice(-n);
};
function $779003da930f62c7$var$takeWhile(as, predicate) {
    var i = $779003da930f62c7$var$spanIndexUncurry(as, predicate);
    var init = Array(i);
    for(var j = 0; j < i; j++)init[j] = as[j];
    return init;
}
$779003da930f62c7$exports.takeWhile = $779003da930f62c7$var$takeWhile;
var $779003da930f62c7$var$spanIndexUncurry = function(as, predicate) {
    var l = as.length;
    var i = 0;
    for(; i < l; i++){
        if (!predicate(as[i])) break;
    }
    return i;
};
function $779003da930f62c7$var$span(as, predicate) {
    var i = $779003da930f62c7$var$spanIndexUncurry(as, predicate);
    var init = Array(i);
    for(var j = 0; j < i; j++)init[j] = as[j];
    var l = as.length;
    var rest = Array(l - i);
    for(var j = i; j < l; j++)rest[j - i] = as[j];
    return {
        init: init,
        rest: rest
    };
}
$779003da930f62c7$exports.span = $779003da930f62c7$var$span;
/**
 * Use `dropLeft`
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.drop = function(n, as) {
    return as.slice(n, as.length);
};
/**
 * Use `dropRight`
 *
 * @since 1.10.0
 * @deprecated
 */ $779003da930f62c7$exports.dropEnd = function(n, as) {
    return as.slice(0, as.length - n);
};
/**
 * Use `dropLeftWhile`
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.dropWhile = function(as, predicate) {
    var i = $779003da930f62c7$var$spanIndexUncurry(as, predicate);
    var l = as.length;
    var rest = Array(l - i);
    for(var j = i; j < l; j++)rest[j - i] = as[j];
    return rest;
};
function $779003da930f62c7$var$_findIndex(as, predicate) {
    var len = as.length;
    for(var i = 0; i < len; i++){
        if (predicate(as[i])) return $c07775bc63cd1cbe$exports.some(i);
    }
    return $c07775bc63cd1cbe$exports.none;
}
function $779003da930f62c7$var$findIndex() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_findIndex(as, args[0]);
    } : $779003da930f62c7$var$_findIndex(args[0], args[1]);
}
$779003da930f62c7$exports.findIndex = $779003da930f62c7$var$findIndex;
function $779003da930f62c7$var$_findFirst(as, predicate) {
    var len = as.length;
    for(var i = 0; i < len; i++){
        if (predicate(as[i])) return $c07775bc63cd1cbe$exports.some(as[i]);
    }
    return $c07775bc63cd1cbe$exports.none;
}
function $779003da930f62c7$var$findFirst() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_findFirst(as, args[0]);
    } : $779003da930f62c7$var$_findFirst(args[0], args[1]);
}
$779003da930f62c7$exports.findFirst = $779003da930f62c7$var$findFirst;
function $779003da930f62c7$var$_findFirstMap(arr, f) {
    var len = arr.length;
    for(var i = 0; i < len; i++){
        var v = f(arr[i]);
        if (v.isSome()) return v;
    }
    return $c07775bc63cd1cbe$exports.none;
}
function $779003da930f62c7$var$findFirstMap() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_findFirstMap(as, args[0]);
    } : $779003da930f62c7$var$_findFirstMap(args[0], args[1]);
}
$779003da930f62c7$exports.findFirstMap = $779003da930f62c7$var$findFirstMap;
function $779003da930f62c7$var$_findLast(as, predicate) {
    var len = as.length;
    for(var i = len - 1; i >= 0; i--){
        if (predicate(as[i])) return $c07775bc63cd1cbe$exports.some(as[i]);
    }
    return $c07775bc63cd1cbe$exports.none;
}
function $779003da930f62c7$var$findLast() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_findLast(as, args[0]);
    } : $779003da930f62c7$var$_findLast(args[0], args[1]);
}
$779003da930f62c7$exports.findLast = $779003da930f62c7$var$findLast;
function $779003da930f62c7$var$_findLastMap(arr, f) {
    var len = arr.length;
    for(var i = len - 1; i >= 0; i--){
        var v = f(arr[i]);
        if (v.isSome()) return v;
    }
    return $c07775bc63cd1cbe$exports.none;
}
function $779003da930f62c7$var$findLastMap() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_findLastMap(as, args[0]);
    } : $779003da930f62c7$var$_findLastMap(args[0], args[1]);
}
$779003da930f62c7$exports.findLastMap = $779003da930f62c7$var$findLastMap;
function $779003da930f62c7$var$_findLastIndex(as, predicate) {
    var len = as.length;
    for(var i = len - 1; i >= 0; i--){
        if (predicate(as[i])) return $c07775bc63cd1cbe$exports.some(i);
    }
    return $c07775bc63cd1cbe$exports.none;
}
function $779003da930f62c7$var$findLastIndex() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_findLastIndex(as, args[0]);
    } : $779003da930f62c7$var$_findLastIndex(args[0], args[1]);
}
$779003da930f62c7$exports.findLastIndex = $779003da930f62c7$var$findLastIndex;
/**
 * Use `array.filter` instead
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.refine = function(as, refinement) {
    // tslint:disable-next-line: deprecation
    return $779003da930f62c7$var$filter(as, refinement);
};
/**
 * @since 1.0.0
 */ $779003da930f62c7$exports.copy = function(as) {
    var l = as.length;
    var r = Array(l);
    for(var i = 0; i < l; i++)r[i] = as[i];
    return r;
};
/**
 * @since 1.0.0
 */ $779003da930f62c7$exports.unsafeInsertAt = function(i, a, as) {
    var xs = $779003da930f62c7$exports.copy(as);
    xs.splice(i, 0, a);
    return xs;
};
function $779003da930f62c7$var$_insertAt(i, a, as) {
    return i < 0 || i > as.length ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some($779003da930f62c7$exports.unsafeInsertAt(i, a, as));
}
function $779003da930f62c7$var$insertAt() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 2 ? function(as) {
        return $779003da930f62c7$var$_insertAt(args[0], args[1], as);
    } : $779003da930f62c7$var$_insertAt(args[0], args[1], args[2]);
}
$779003da930f62c7$exports.insertAt = $779003da930f62c7$var$insertAt;
/**
 * @since 1.0.0
 */ $779003da930f62c7$exports.unsafeUpdateAt = function(i, a, as) {
    if (as[i] === a) return as;
    else {
        var xs = $779003da930f62c7$exports.copy(as);
        xs[i] = a;
        return xs;
    }
};
function $779003da930f62c7$var$_updateAt(i, a, as) {
    return $779003da930f62c7$exports.isOutOfBound(i, as) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some($779003da930f62c7$exports.unsafeUpdateAt(i, a, as));
}
function $779003da930f62c7$var$updateAt() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 2 ? function(as) {
        return $779003da930f62c7$var$_updateAt(args[0], args[1], as);
    } : $779003da930f62c7$var$_updateAt(args[0], args[1], args[2]);
}
$779003da930f62c7$exports.updateAt = $779003da930f62c7$var$updateAt;
/**
 * @since 1.0.0
 */ $779003da930f62c7$exports.unsafeDeleteAt = function(i, as) {
    var xs = $779003da930f62c7$exports.copy(as);
    xs.splice(i, 1);
    return xs;
};
function $779003da930f62c7$var$_deleteAt(i, as) {
    return $779003da930f62c7$exports.isOutOfBound(i, as) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some($779003da930f62c7$exports.unsafeDeleteAt(i, as));
}
function $779003da930f62c7$var$deleteAt() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_deleteAt(args[0], as);
    } : $779003da930f62c7$var$_deleteAt(args[0], args[1]);
}
$779003da930f62c7$exports.deleteAt = $779003da930f62c7$var$deleteAt;
function $779003da930f62c7$var$_modifyAt(as, i, f) {
    return $779003da930f62c7$exports.isOutOfBound(i, as) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some($779003da930f62c7$exports.unsafeUpdateAt(i, f(as[i]), as));
}
function $779003da930f62c7$var$modifyAt() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 2 ? function(as) {
        return $779003da930f62c7$var$_modifyAt(as, args[0], args[1]);
    } : $779003da930f62c7$var$_modifyAt(args[0], args[1], args[2]);
}
$779003da930f62c7$exports.modifyAt = $779003da930f62c7$var$modifyAt;
/**
 * Reverse an array, creating a new array
 *
 * @example
 * import { reverse } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(reverse([1, 2, 3]), [3, 2, 1])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.reverse = function(as) {
    return $779003da930f62c7$exports.copy(as).reverse();
};
/**
 * Extracts from an array of `Either` all the `Right` elements. All the `Right` elements are extracted in order
 *
 * @example
 * import { rights } from 'fp-ts/lib/Array'
 * import { right, left } from 'fp-ts/lib/Either'
 *
 * assert.deepStrictEqual(rights([right(1), left('foo'), right(2)]), [1, 2])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.rights = function(as) {
    var r = [];
    var len = as.length;
    for(var i = 0; i < len; i++){
        var a = as[i];
        if (a.isRight()) r.push(a.value);
    }
    return r;
};
/**
 * Extracts from an array of `Either` all the `Left` elements. All the `Left` elements are extracted in order
 *
 * @example
 * import { lefts } from 'fp-ts/lib/Array'
 * import { left, right } from 'fp-ts/lib/Either'
 *
 * assert.deepStrictEqual(lefts([right(1), left('foo'), right(2)]), ['foo'])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.lefts = function(as) {
    var r = [];
    var len = as.length;
    for(var i = 0; i < len; i++){
        var a = as[i];
        if (a.isLeft()) r.push(a.value);
    }
    return r;
};
/**
 * Sort the elements of an array in increasing order, creating a new array
 *
 * @example
 * import { sort } from 'fp-ts/lib/Array'
 * import { ordNumber } from 'fp-ts/lib/Ord'
 *
 * assert.deepStrictEqual(sort(ordNumber)([3, 2, 1]), [1, 2, 3])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.sort = function(O) {
    return function(as) {
        return $779003da930f62c7$exports.copy(as).sort(O.compare);
    };
};
/**
 * Apply a function to pairs of elements at the same index in two arrays, collecting the results in a new array. If one
 * input array is short, excess elements of the longer array are discarded.
 *
 * @example
 * import { zipWith } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(zipWith([1, 2, 3], ['a', 'b', 'c', 'd'], (n, s) => s + n), ['a1', 'b2', 'c3'])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.zipWith = function(fa, fb, f) {
    var fc = [];
    var len = Math.min(fa.length, fb.length);
    for(var i = 0; i < len; i++)fc[i] = f(fa[i], fb[i]);
    return fc;
};
/**
 * Takes two arrays and returns an array of corresponding pairs. If one input array is short, excess elements of the
 * longer array are discarded
 *
 * @example
 * import { zip } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(zip([1, 2, 3], ['a', 'b', 'c', 'd']), [[1, 'a'], [2, 'b'], [3, 'c']])
 *
 * @since 1.0.0
 */ $779003da930f62c7$exports.zip = function(fa, fb) {
    return $779003da930f62c7$exports.zipWith(fa, fb, $da18856e9734b7b7$exports.tuple);
};
/**
 * The function is reverse of `zip`. Takes an array of pairs and return two corresponding arrays
 *
 * @example
 * import { unzip } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(unzip([[1, 'a'], [2, 'b'], [3, 'c']]), [[1, 2, 3], ['a', 'b', 'c']])
 *
 *
 * @since 1.13.0
 */ $779003da930f62c7$exports.unzip = function(as) {
    var fa = [];
    var fb = [];
    for(var i = 0; i < as.length; i++){
        fa[i] = as[i][0];
        fb[i] = as[i][1];
    }
    return [
        fa,
        fb
    ];
};
function $779003da930f62c7$var$_rotate(n, xs) {
    var len = xs.length;
    if (n === 0 || len <= 1 || len === Math.abs(n)) return xs;
    else if (n < 0) return $779003da930f62c7$var$_rotate(len + n, xs);
    else return xs.slice(-n).concat(xs.slice(0, len - n));
}
function $779003da930f62c7$var$rotate() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_rotate(args[0], as);
    } : $779003da930f62c7$var$_rotate(args[0], args[1]);
}
$779003da930f62c7$exports.rotate = $779003da930f62c7$var$rotate;
/**
 * Test if a value is a member of an array. Takes a `Eq<A>` as a single
 * argument which returns the function to use to search for a value of type `A` in
 * an array of type `Array<A>`.
 *
 * @example
 * import { elem } from 'fp-ts/lib/Array'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * assert.strictEqual(elem(eqNumber)(1, [1, 2, 3]), true)
 * assert.strictEqual(elem(eqNumber)(4, [1, 2, 3]), false)
 *
 * @since 1.14.0
 */ $779003da930f62c7$exports.elem = function(E) {
    return function(a, as) {
        var predicate = function(e) {
            return E.equals(e, a);
        };
        var i = 0;
        var len = as.length;
        for(; i < len; i++){
            if (predicate(as[i])) return true;
        }
        return false;
    };
};
/**
 * Use `elem` instead
 * @since 1.3.0
 * @deprecated
 */ $779003da930f62c7$exports.member = function(E) {
    var has = $779003da930f62c7$exports.elem(E);
    return function(as, a) {
        return has(a, as);
    };
};
/**
 * Remove duplicates from an array, keeping the first occurance of an element.
 *
 * @example
 * import { uniq } from 'fp-ts/lib/Array'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * assert.deepStrictEqual(uniq(eqNumber)([1, 2, 1]), [1, 2])
 *
 *
 * @since 1.3.0
 */ $779003da930f62c7$exports.uniq = function(E) {
    var elemE = $779003da930f62c7$exports.elem(E);
    return function(as) {
        var r = [];
        var len = as.length;
        var i = 0;
        for(; i < len; i++){
            var a = as[i];
            if (!elemE(a, r)) r.push(a);
        }
        return len === r.length ? as : r;
    };
};
/**
 * Sort the elements of an array in increasing order, where elements are compared using first `ords[0]`, then `ords[1]`,
 * etc...
 *
 * @example
 * import { sortBy } from 'fp-ts/lib/Array'
 * import { contramap, ordString, ordNumber } from 'fp-ts/lib/Ord'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 * const byName = contramap((p: Person) => p.name, ordString)
 * const byAge = contramap((p: Person) => p.age, ordNumber)
 *
 * const sortByNameByAge = sortBy([byName, byAge])
 *
 * if (sortByNameByAge.isSome()) {
 *   const persons = [{ name: 'a', age: 1 }, { name: 'b', age: 3 }, { name: 'c', age: 2 }, { name: 'b', age: 2 }]
 *   assert.deepStrictEqual(sortByNameByAge.value(persons), [
 *     { name: 'a', age: 1 },
 *     { name: 'b', age: 2 },
 *     { name: 'b', age: 3 },
 *     { name: 'c', age: 2 }
 *   ])
 * }
 *
 *
 * @since 1.3.0
 */ $779003da930f62c7$exports.sortBy = function(ords) {
    // tslint:disable-next-line: deprecation
    return $779003da930f62c7$exports.fold(ords, $c07775bc63cd1cbe$exports.none, function(head, tail) {
        return $c07775bc63cd1cbe$exports.some($779003da930f62c7$exports.sortBy1(head, tail));
    });
};
/**
 * Non failing version of `sortBy`
 * @example
 * import { sortBy1 } from 'fp-ts/lib/Array'
 * import { contramap, ordString, ordNumber } from 'fp-ts/lib/Ord'
 *
 * interface Person {
 *   name: string
 *   age: number
 * }
 * const byName = contramap((p: Person) => p.name, ordString)
 * const byAge = contramap((p: Person) => p.age, ordNumber)
 *
 * const sortByNameByAge = sortBy1(byName, [byAge])
 *
 * const persons = [{ name: 'a', age: 1 }, { name: 'b', age: 3 }, { name: 'c', age: 2 }, { name: 'b', age: 2 }]
 * assert.deepStrictEqual(sortByNameByAge(persons), [
 *   { name: 'a', age: 1 },
 *   { name: 'b', age: 2 },
 *   { name: 'b', age: 3 },
 *   { name: 'c', age: 2 }
 * ])
 *
 *
 * @since 1.3.0
 */ $779003da930f62c7$exports.sortBy1 = function(head, tail) {
    return $779003da930f62c7$exports.sort(tail.reduce($37e5cd3b0c7fa08f$exports.getSemigroup().concat, head));
};
/**
 * Use `filterMap`
 *
 * Apply a function to each element in an array, keeping only the results which contain a value, creating a new array.
 *
 * @example
 * import { mapOption } from 'fp-ts/lib/Array'
 * import { Option, some, none } from 'fp-ts/lib/Option'
 *
 * const f = (n: number): Option<number> => (n % 2 === 0 ? none : some(n))
 * assert.deepStrictEqual(mapOption([1, 2, 3], f), [1, 3])
 *
 * @since 1.0.0
 * @deprecated
 */ $779003da930f62c7$exports.mapOption = function(as, f) {
    return $779003da930f62c7$exports.array.filterMapWithIndex(as, function(_, a) {
        return f(a);
    });
};
/**
 * Use `compact`
 *
 * Filter an array of optional values, keeping only the elements which contain a value, creating a new array.
 *
 * @example
 * import { catOptions } from 'fp-ts/lib/Array'
 * import { some, none } from 'fp-ts/lib/Option'
 *
 * assert.deepStrictEqual(catOptions([some(1), none, some(3)]), [1, 3])
 *
 * @since 1.0.0
 * @deprecated
 */ // tslint:disable-next-line: deprecation
$779003da930f62c7$exports.catOptions = function(as) {
    return $779003da930f62c7$exports.mapOption(as, $da18856e9734b7b7$exports.identity);
};
function $779003da930f62c7$var$partitionMap() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(fa) {
        return $779003da930f62c7$exports.array.partitionMapWithIndex(fa, function(_, a) {
            return args[0](a);
        });
    } : $779003da930f62c7$exports.array.partitionMapWithIndex(args[0], function(_, a) {
        return args[1](a);
    });
}
$779003da930f62c7$exports.partitionMap = $779003da930f62c7$var$partitionMap;
function $779003da930f62c7$var$filter() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$exports.array.filter(as, args[0]);
    } : $779003da930f62c7$exports.array.filter(args[0], args[1]);
}
$779003da930f62c7$exports.filter = $779003da930f62c7$var$filter;
function $779003da930f62c7$var$partition() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(fa) {
        return $779003da930f62c7$exports.array.partitionWithIndex(fa, function(_, a) {
            return args[0](a);
        });
    } : $779003da930f62c7$exports.array.partitionWithIndex(args[0], function(_, a) {
        return args[1](a);
    });
}
$779003da930f62c7$exports.partition = $779003da930f62c7$var$partition;
function $779003da930f62c7$var$_chop(as, f) {
    var result = [];
    var cs = as;
    while($779003da930f62c7$var$isNonEmpty(cs)){
        var _a = f(cs), b = _a[0], c = _a[1];
        result.push(b);
        cs = c;
    }
    return result;
}
function $779003da930f62c7$var$chop() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_chop(as, args[0]);
    } : $779003da930f62c7$var$_chop(args[0], args[1]);
}
$779003da930f62c7$exports.chop = $779003da930f62c7$var$chop;
/**
 * Use `splitAt`
 *
 * @since 1.10.0
 * @deprecated
 */ $779003da930f62c7$exports.split = function(n, as) {
    return [
        as.slice(0, n),
        as.slice(n)
    ];
};
function $779003da930f62c7$var$_chunksOf(as, n) {
    // tslint:disable-next-line: deprecation
    return as.length === 0 ? $779003da930f62c7$exports.empty : $779003da930f62c7$exports.isOutOfBound(n - 1, as) ? [
        as
    ] : $779003da930f62c7$var$chop(as, function(as) {
        return $779003da930f62c7$exports.split(n, as);
    });
}
function $779003da930f62c7$var$chunksOf() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.length === 1 ? function(as) {
        return $779003da930f62c7$var$_chunksOf(as, args[0]);
    } : $779003da930f62c7$var$_chunksOf(args[0], args[1]);
}
$779003da930f62c7$exports.chunksOf = $779003da930f62c7$var$chunksOf;
function $779003da930f62c7$var$comprehension(input, f, g) {
    var go = function(scope, input) {
        if (input.length === 0) return f.apply(void 0, scope) ? [
            g.apply(void 0, scope)
        ] : $779003da930f62c7$exports.empty;
        else return $779003da930f62c7$exports.array.chain(input[0], function(x) {
            return go($779003da930f62c7$exports.snoc(scope, x), input.slice(1));
        });
    };
    return go($779003da930f62c7$exports.empty, input);
}
$779003da930f62c7$exports.comprehension = $779003da930f62c7$var$comprehension;
/**
 * Creates an array of unique values, in order, from all given arrays using a `Eq` for equality comparisons
 *
 * @example
 * import { union } from 'fp-ts/lib/Array'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * assert.deepStrictEqual(union(eqNumber)([1, 2], [2, 3]), [1, 2, 3])
 *
 *
 * @since 1.12.0
 */ $779003da930f62c7$exports.union = function(E) {
    var elemE = $779003da930f62c7$exports.elem(E);
    // tslint:disable-next-line: deprecation
    return function(xs, ys) {
        return $da18856e9734b7b7$exports.concat(xs, ys.filter(function(a) {
            return !elemE(a, xs);
        }));
    };
};
/**
 * Creates an array of unique values that are included in all given arrays using a `Eq` for equality
 * comparisons. The order and references of result values are determined by the first array.
 *
 * @example
 * import { intersection } from 'fp-ts/lib/Array'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * assert.deepStrictEqual(intersection(eqNumber)([1, 2], [2, 3]), [2])
 *
 *
 * @since 1.12.0
 */ $779003da930f62c7$exports.intersection = function(E) {
    var elemE = $779003da930f62c7$exports.elem(E);
    return function(xs, ys) {
        return xs.filter(function(a) {
            return elemE(a, ys);
        });
    };
};
/**
 * Creates an array of array values not included in the other given array using a `Eq` for equality
 * comparisons. The order and references of result values are determined by the first array.
 *
 * @example
 * import { difference } from 'fp-ts/lib/Array'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * assert.deepStrictEqual(difference(eqNumber)([1, 2], [2, 3]), [1])
 *
 *
 * @since 1.12.0
 */ $779003da930f62c7$exports.difference = function(E) {
    var elemE = $779003da930f62c7$exports.elem(E);
    return function(xs, ys) {
        return xs.filter(function(a) {
            return !elemE(a, ys);
        });
    };
};
/**
 * @since 1.0.0
 */ $779003da930f62c7$exports.array = {
    URI: $779003da930f62c7$exports.URI,
    map: function(fa, f) {
        return fa.map(function(a) {
            return f(a);
        });
    },
    mapWithIndex: function(fa, f) {
        return fa.map(function(a, i) {
            return f(i, a);
        });
    },
    compact: function(as) {
        return $779003da930f62c7$exports.array.filterMap(as, $da18856e9734b7b7$exports.identity);
    },
    separate: function(fa) {
        var left = [];
        var right = [];
        for(var _i = 0, fa_1 = fa; _i < fa_1.length; _i++){
            var e = fa_1[_i];
            if (e._tag === "Left") left.push(e.value);
            else right.push(e.value);
        }
        return {
            left: left,
            right: right
        };
    },
    filter: function(as, predicate) {
        return as.filter(predicate);
    },
    filterMap: function(as, f) {
        return $779003da930f62c7$exports.array.filterMapWithIndex(as, function(_, a) {
            return f(a);
        });
    },
    partition: function(fa, predicate) {
        return $779003da930f62c7$exports.array.partitionWithIndex(fa, function(_, a) {
            return predicate(a);
        });
    },
    partitionMap: $779003da930f62c7$var$partitionMap,
    of: $779003da930f62c7$var$of,
    ap: function(fab, fa) {
        return $779003da930f62c7$exports.flatten($779003da930f62c7$exports.array.map(fab, function(f) {
            return $779003da930f62c7$exports.array.map(fa, f);
        }));
    },
    chain: function(fa, f) {
        var resLen = 0;
        var l = fa.length;
        var temp = new Array(l);
        for(var i = 0; i < l; i++){
            var e = fa[i];
            var arr = f(e);
            resLen += arr.length;
            temp[i] = arr;
        }
        var r = Array(resLen);
        var start = 0;
        for(var i = 0; i < l; i++){
            var arr = temp[i];
            var l_1 = arr.length;
            for(var j = 0; j < l_1; j++)r[j + start] = arr[j];
            start += l_1;
        }
        return r;
    },
    reduce: function(fa, b, f) {
        return $779003da930f62c7$exports.array.reduceWithIndex(fa, b, function(_, b, a) {
            return f(b, a);
        });
    },
    foldMap: function(M) {
        var foldMapWithIndexM = $779003da930f62c7$exports.array.foldMapWithIndex(M);
        return function(fa, f) {
            return foldMapWithIndexM(fa, function(_, a) {
                return f(a);
            });
        };
    },
    foldr: function(fa, b, f) {
        return $779003da930f62c7$exports.array.foldrWithIndex(fa, b, function(_, a, b) {
            return f(a, b);
        });
    },
    unfoldr: function(b, f) {
        var ret = [];
        var bb = b;
        while(true){
            var mt = f(bb);
            if ($c07775bc63cd1cbe$exports.isSome(mt)) {
                var _a = mt.value, a = _a[0], b_1 = _a[1];
                ret.push(a);
                bb = b_1;
            } else break;
        }
        return ret;
    },
    traverse: function(F) {
        var traverseWithIndexF = $779003da930f62c7$exports.array.traverseWithIndex(F);
        return function(ta, f) {
            return traverseWithIndexF(ta, function(_, a) {
                return f(a);
            });
        };
    },
    sequence: function(F) {
        return function(ta) {
            return $779003da930f62c7$exports.array.reduce(ta, F.of($779003da930f62c7$exports.array.zero()), function(fas, fa) {
                return F.ap(F.map(fas, function(as) {
                    return function(a) {
                        return $779003da930f62c7$exports.snoc(as, a);
                    };
                }), fa);
            });
        };
    },
    zero: function() {
        return $779003da930f62c7$exports.empty;
    },
    // tslint:disable-next-line: deprecation
    alt: function(fx, fy) {
        return $da18856e9734b7b7$exports.concat(fx, fy);
    },
    extend: function(fa, f) {
        return fa.map(function(_, i, as) {
            return f(as.slice(i));
        });
    },
    wither: function(F) {
        var traverseF = $779003da930f62c7$exports.array.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), $779003da930f62c7$exports.array.compact);
        };
    },
    wilt: function(F) {
        var traverseF = $779003da930f62c7$exports.array.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), $779003da930f62c7$exports.array.separate);
        };
    },
    reduceWithIndex: function(fa, b, f) {
        var l = fa.length;
        var r = b;
        for(var i = 0; i < l; i++)r = f(i, r, fa[i]);
        return r;
    },
    foldMapWithIndex: function(M) {
        return function(fa, f) {
            return fa.reduce(function(b, a, i) {
                return M.concat(b, f(i, a));
            }, M.empty);
        };
    },
    foldrWithIndex: function(fa, b, f) {
        return fa.reduceRight(function(b, a, i) {
            return f(i, a, b);
        }, b);
    },
    traverseWithIndex: function(F) {
        return function(ta, f) {
            return $779003da930f62c7$exports.array.reduceWithIndex(ta, F.of($779003da930f62c7$exports.array.zero()), function(i, fbs, a) {
                return F.ap(F.map(fbs, function(bs) {
                    return function(b) {
                        return $779003da930f62c7$exports.snoc(bs, b);
                    };
                }), f(i, a));
            });
        };
    },
    partitionMapWithIndex: function(fa, f) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var e = f(i, fa[i]);
            if (e._tag === "Left") left.push(e.value);
            else right.push(e.value);
        }
        return {
            left: left,
            right: right
        };
    },
    partitionWithIndex: function(fa, predicateWithIndex) {
        var left = [];
        var right = [];
        for(var i = 0; i < fa.length; i++){
            var a = fa[i];
            if (predicateWithIndex(i, a)) right.push(a);
            else left.push(a);
        }
        return {
            left: left,
            right: right
        };
    },
    filterMapWithIndex: function(fa, f) {
        var result = [];
        for(var i = 0; i < fa.length; i++){
            var optionB = f(i, fa[i]);
            if ($c07775bc63cd1cbe$exports.isSome(optionB)) result.push(optionB.value);
        }
        return result;
    },
    filterWithIndex: function(fa, predicateWithIndex) {
        return fa.filter(function(a, i) {
            return predicateWithIndex(i, a);
        });
    }
};
//
// backporting
//
/**
 * @since 1.19.0
 */ function $779003da930f62c7$var$of(a) {
    return [
        a
    ];
}
$779003da930f62c7$exports.of = $779003da930f62c7$var$of;
/**
 * Break an array into its first element and remaining elements
 *
 * @example
 * import { foldLeft } from 'fp-ts/lib/Array'
 *
 * const len: <A>(as: Array<A>) => number = foldLeft(() => 0, (_, tail) => 1 + len(tail))
 * assert.strictEqual(len([1, 2, 3]), 3)
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$foldLeft(onNil, onCons) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.foldL(as, onNil, onCons);
    };
}
$779003da930f62c7$exports.foldLeft = $779003da930f62c7$var$foldLeft;
/**
 * Break an array into its initial elements and the last element
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$foldRight(onNil, onCons) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.foldrL(as, onNil, onCons);
    };
}
$779003da930f62c7$exports.foldRight = $779003da930f62c7$var$foldRight;
/**
 * Keep only a number of elements from the start of an array, creating a new array.
 * `n` must be a natural number
 *
 * @example
 * import { takeLeft } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(takeLeft(2)([1, 2, 3]), [1, 2])
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$takeLeft(n) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$var$take(n, as);
    };
}
$779003da930f62c7$exports.takeLeft = $779003da930f62c7$var$takeLeft;
/**
 * Keep only a number of elements from the end of an array, creating a new array.
 * `n` must be a natural number
 *
 * @example
 * import { takeRight } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(takeRight(2)([1, 2, 3, 4, 5]), [4, 5])
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$takeRight(n) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.takeEnd(n, as);
    };
}
$779003da930f62c7$exports.takeRight = $779003da930f62c7$var$takeRight;
function $779003da930f62c7$var$takeLeftWhile(predicate) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$var$takeWhile(as, predicate);
    };
}
$779003da930f62c7$exports.takeLeftWhile = $779003da930f62c7$var$takeLeftWhile;
function $779003da930f62c7$var$spanLeft(predicate) {
    return function(as) {
        return $779003da930f62c7$var$span(as, predicate);
    };
}
$779003da930f62c7$exports.spanLeft = $779003da930f62c7$var$spanLeft;
/**
 * Drop a number of elements from the start of an array, creating a new array
 *
 * @example
 * import { dropLeft } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(dropLeft(2)([1, 2, 3]), [3])
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$dropLeft(n) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.drop(n, as);
    };
}
$779003da930f62c7$exports.dropLeft = $779003da930f62c7$var$dropLeft;
/**
 * Drop a number of elements from the end of an array, creating a new array
 *
 * @example
 * import { dropRight } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(dropRight(2)([1, 2, 3, 4, 5]), [1, 2, 3])
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$dropRight(n) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.dropEnd(n, as);
    };
}
$779003da930f62c7$exports.dropRight = $779003da930f62c7$var$dropRight;
/**
 * Remove the longest initial subarray for which all element satisfy the specified predicate, creating a new array
 *
 * @example
 * import { dropLeftWhile } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(dropLeftWhile((n: number) => n % 2 === 1)([1, 3, 2, 4, 5]), [2, 4, 5])
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$dropLeftWhile(predicate) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.dropWhile(as, predicate);
    };
}
$779003da930f62c7$exports.dropLeftWhile = $779003da930f62c7$var$dropLeftWhile;
/**
 * Splits an array into two pieces, the first piece has `n` elements.
 *
 * @example
 * import { splitAt } from 'fp-ts/lib/Array'
 *
 * assert.deepStrictEqual(splitAt(2)([1, 2, 3, 4, 5]), [[1, 2], [3, 4, 5]])
 *
 * @since 1.19.0
 */ function $779003da930f62c7$var$splitAt(n) {
    // tslint:disable-next-line: deprecation
    return function(as) {
        return $779003da930f62c7$exports.split(n, as);
    };
}
$779003da930f62c7$exports.splitAt = $779003da930f62c7$var$splitAt;
var $779003da930f62c7$var$_a = $418bb2c9516a5b59$exports.pipeable($779003da930f62c7$exports.array), $779003da930f62c7$var$alt = $779003da930f62c7$var$_a.alt, $779003da930f62c7$var$ap = $779003da930f62c7$var$_a.ap, $779003da930f62c7$var$apFirst = $779003da930f62c7$var$_a.apFirst, $779003da930f62c7$var$apSecond = $779003da930f62c7$var$_a.apSecond, $779003da930f62c7$var$chain = $779003da930f62c7$var$_a.chain, $779003da930f62c7$var$chainFirst = $779003da930f62c7$var$_a.chainFirst, $779003da930f62c7$var$duplicate = $779003da930f62c7$var$_a.duplicate, $779003da930f62c7$var$extend = $779003da930f62c7$var$_a.extend, // filter, // this top level function already exists
$779003da930f62c7$var$filterMap = $779003da930f62c7$var$_a.filterMap, $779003da930f62c7$var$filterMapWithIndex = $779003da930f62c7$var$_a.filterMapWithIndex, $779003da930f62c7$var$filterWithIndex = $779003da930f62c7$var$_a.filterWithIndex, $779003da930f62c7$var$foldMap = $779003da930f62c7$var$_a.foldMap, $779003da930f62c7$var$foldMapWithIndex = $779003da930f62c7$var$_a.foldMapWithIndex, $779003da930f62c7$var$map = $779003da930f62c7$var$_a.map, $779003da930f62c7$var$mapWithIndex = $779003da930f62c7$var$_a.mapWithIndex, // partition, // this top level function already exists
// partitionMap, // this top level function already exists
$779003da930f62c7$var$partitionMapWithIndex = $779003da930f62c7$var$_a.partitionMapWithIndex, $779003da930f62c7$var$partitionWithIndex = $779003da930f62c7$var$_a.partitionWithIndex, $779003da930f62c7$var$reduce = $779003da930f62c7$var$_a.reduce, $779003da930f62c7$var$reduceRight = $779003da930f62c7$var$_a.reduceRight, $779003da930f62c7$var$reduceRightWithIndex = $779003da930f62c7$var$_a.reduceRightWithIndex, $779003da930f62c7$var$reduceWithIndex = $779003da930f62c7$var$_a.reduceWithIndex, $779003da930f62c7$var$compact = $779003da930f62c7$var$_a.compact, $779003da930f62c7$var$separate = $779003da930f62c7$var$_a.separate;
$779003da930f62c7$exports.alt = $779003da930f62c7$var$alt;
$779003da930f62c7$exports.ap = $779003da930f62c7$var$ap;
$779003da930f62c7$exports.apFirst = $779003da930f62c7$var$apFirst;
$779003da930f62c7$exports.apSecond = $779003da930f62c7$var$apSecond;
$779003da930f62c7$exports.chain = $779003da930f62c7$var$chain;
$779003da930f62c7$exports.chainFirst = $779003da930f62c7$var$chainFirst;
$779003da930f62c7$exports.duplicate = $779003da930f62c7$var$duplicate;
$779003da930f62c7$exports.extend = $779003da930f62c7$var$extend;
$779003da930f62c7$exports.filterMap = $779003da930f62c7$var$filterMap;
$779003da930f62c7$exports.filterMapWithIndex = $779003da930f62c7$var$filterMapWithIndex;
$779003da930f62c7$exports.filterWithIndex = $779003da930f62c7$var$filterWithIndex;
$779003da930f62c7$exports.foldMap = $779003da930f62c7$var$foldMap;
$779003da930f62c7$exports.foldMapWithIndex = $779003da930f62c7$var$foldMapWithIndex;
$779003da930f62c7$exports.map = $779003da930f62c7$var$map;
$779003da930f62c7$exports.mapWithIndex = $779003da930f62c7$var$mapWithIndex;
$779003da930f62c7$exports.partitionMapWithIndex = $779003da930f62c7$var$partitionMapWithIndex;
$779003da930f62c7$exports.partitionWithIndex = $779003da930f62c7$var$partitionWithIndex;
$779003da930f62c7$exports.reduce = $779003da930f62c7$var$reduce;
$779003da930f62c7$exports.reduceRight = $779003da930f62c7$var$reduceRight;
$779003da930f62c7$exports.reduceRightWithIndex = $779003da930f62c7$var$reduceRightWithIndex;
$779003da930f62c7$exports.reduceWithIndex = $779003da930f62c7$var$reduceWithIndex;
$779003da930f62c7$exports.compact = $779003da930f62c7$var$compact;
$779003da930f62c7$exports.separate = $779003da930f62c7$var$separate;






$a299095f4f86d8f0$exports.URI = "NonEmptyArray";
/**
 * @since 1.0.0
 */ var $a299095f4f86d8f0$var$NonEmptyArray = /** @class */ function() {
    function NonEmptyArray(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    /**
     * Converts this `NonEmptyArray` to a plain `Array`
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3]).toArray(), [1, 2, 3])
     */ NonEmptyArray.prototype.toArray = function() {
        return [
            this.head
        ].concat(this.tail);
    };
    /**
     * Converts this `NonEmptyArray` to a plain `Array` using the given map function
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * assert.deepStrictEqual(new NonEmptyArray('a', ['bb', 'ccc']).toArrayMap(s => s.length), [1, 2, 3])
     *
     * @since 1.14.0
     */ NonEmptyArray.prototype.toArrayMap = function(f) {
        return [
            f(this.head)
        ].concat(this.tail.map(function(a) {
            return f(a);
        }));
    };
    /**
     * Concatenates this `NonEmptyArray` and passed `Array`
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * assert.deepStrictEqual(new NonEmptyArray<number>(1, []).concatArray([2]), new NonEmptyArray(1, [2]))
     */ NonEmptyArray.prototype.concatArray = function(as) {
        return new NonEmptyArray(this.head, this.tail.concat(as));
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * const double = (n: number): number => n * 2
     * assert.deepStrictEqual(new NonEmptyArray(1, [2]).map(double), new NonEmptyArray(2, [4]))
     */ NonEmptyArray.prototype.map = function(f) {
        return new NonEmptyArray(f(this.head), this.tail.map(f));
    };
    NonEmptyArray.prototype.mapWithIndex = function(f) {
        return new NonEmptyArray(f(0, this.head), $779003da930f62c7$exports.array.mapWithIndex(this.tail, function(i, a) {
            return f(i + 1, a);
        }));
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * const x = new NonEmptyArray(1, [2])
     * const double = (n: number): number => n * 2
     * assert.deepStrictEqual(x.ap(new NonEmptyArray(double, [double])).toArray(), [2, 4, 2, 4])
     */ NonEmptyArray.prototype.ap = function(fab) {
        var _this = this;
        return fab.chain(function(f) {
            return _this.map(f);
        }); // <= derived
    };
    /**
     * Flipped version of `ap`
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * const x = new NonEmptyArray(1, [2])
     * const double = (n: number) => n * 2
     * assert.deepStrictEqual(new NonEmptyArray(double, [double]).ap_(x).toArray(), [2, 4, 2, 4])
     */ NonEmptyArray.prototype.ap_ = function(fb) {
        return fb.ap(this);
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * const x = new NonEmptyArray(1, [2])
     * const f = (a: number) => new NonEmptyArray(a, [4])
     * assert.deepStrictEqual(x.chain(f).toArray(), [1, 4, 2, 4])
     */ NonEmptyArray.prototype.chain = function(f) {
        return f(this.head).concatArray($779003da930f62c7$exports.array.chain(this.tail, function(a) {
            return f(a).toArray();
        }));
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * const x = new NonEmptyArray(1, [2])
     * const y = new NonEmptyArray(3, [4])
     * assert.deepStrictEqual(x.concat(y).toArray(), [1, 2, 3, 4])
     */ NonEmptyArray.prototype.concat = function(y) {
        return this.concatArray(y.toArray());
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * const x = new NonEmptyArray('a', ['b'])
     * assert.strictEqual(x.reduce('', (b, a) => b + a), 'ab')
     */ NonEmptyArray.prototype.reduce = function(b, f) {
        return $779003da930f62c7$exports.array.reduce(this.toArray(), b, f);
    };
    /**
     * @since 1.12.0
     */ NonEmptyArray.prototype.reduceWithIndex = function(b, f) {
        return $779003da930f62c7$exports.array.reduceWithIndex(this.toArray(), b, f);
    };
    /**
     * @since 1.12.0
     */ NonEmptyArray.prototype.foldr = function(b, f) {
        return this.foldrWithIndex(b, function(_, a, b) {
            return f(a, b);
        });
    };
    /**
     * @since 1.12.0
     */ NonEmptyArray.prototype.foldrWithIndex = function(b, f) {
        return f(0, this.head, this.tail.reduceRight(function(acc, a, i) {
            return f(i + 1, a, acc);
        }, b));
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { fold, monoidSum } from 'fp-ts/lib/Monoid'
     *
     * const sum = (as: NonEmptyArray<number>) => fold(monoidSum)(as.toArray())
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3, 4]).extend(sum), new NonEmptyArray(10, [9, 7, 4]))
     */ NonEmptyArray.prototype.extend = function(f) {
        return $a299095f4f86d8f0$var$unsafeFromArray($779003da930f62c7$exports.array.extend(this.toArray(), function(as) {
            return f($a299095f4f86d8f0$var$unsafeFromArray(as));
        }));
    };
    /**
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * assert.strictEqual(new NonEmptyArray(1, [2, 3]).extract(), 1)
     */ NonEmptyArray.prototype.extract = function() {
        return this.head;
    };
    /**
     * Same as `toString`
     */ NonEmptyArray.prototype.inspect = function() {
        return this.toString();
    };
    /**
     * Return stringified representation of this `NonEmptyArray`
     */ NonEmptyArray.prototype.toString = function() {
        // tslint:disable-next-line: deprecation
        return "new NonEmptyArray(" + $da18856e9734b7b7$exports.toString(this.head) + ", " + $da18856e9734b7b7$exports.toString(this.tail) + ")";
    };
    /**
     * Gets minimum of this `NonEmptyArray` using specified `Ord` instance
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { ordNumber } from 'fp-ts/lib/Ord'
     *
     * assert.strictEqual(new NonEmptyArray(1, [2, 3]).min(ordNumber), 1)
     *
     * @since 1.3.0
     */ NonEmptyArray.prototype.min = function(ord) {
        return $b0f11c009d4633f7$exports.fold($b0f11c009d4633f7$exports.getMeetSemigroup(ord))(this.head)(this.tail);
    };
    /**
     * Gets maximum of this `NonEmptyArray` using specified `Ord` instance
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { ordNumber } from 'fp-ts/lib/Ord'
     *
     * assert.strictEqual(new NonEmptyArray(1, [2, 3]).max(ordNumber), 3)
     *
     * @since 1.3.0
     */ NonEmptyArray.prototype.max = function(ord) {
        return $b0f11c009d4633f7$exports.fold($b0f11c009d4633f7$exports.getJoinSemigroup(ord))(this.head)(this.tail);
    };
    /**
     * Gets last element of this `NonEmptyArray`
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * assert.strictEqual(new NonEmptyArray(1, [2, 3]).last(), 3)
     * assert.strictEqual(new NonEmptyArray(1, []).last(), 1)
     *
     * @since 1.6.0
     */ NonEmptyArray.prototype.last = function() {
        return $779003da930f62c7$exports.last(this.tail).getOrElse(this.head);
    };
    /**
     * Sorts this `NonEmptyArray` using specified `Ord` instance
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { ordNumber } from 'fp-ts/lib/Ord'
     *
     * assert.deepStrictEqual(new NonEmptyArray(3, [2, 1]).sort(ordNumber), new NonEmptyArray(1, [2, 3]))
     *
     * @since 1.6.0
     */ NonEmptyArray.prototype.sort = function(ord) {
        return $a299095f4f86d8f0$var$unsafeFromArray($779003da930f62c7$exports.sort(ord)(this.toArray()));
    };
    /**
     * Reverts this `NonEmptyArray`
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     *
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3]).reverse(), new NonEmptyArray(3, [2, 1]))
     *
     * @since 1.6.0
     */ NonEmptyArray.prototype.reverse = function() {
        return $a299095f4f86d8f0$var$unsafeFromArray(this.toArray().reverse());
    };
    /**
     * @since 1.10.0
     */ NonEmptyArray.prototype.length = function() {
        return 1 + this.tail.length;
    };
    /**
     * This function provides a safe way to read a value at a particular index from an NonEmptyArray
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { some, none } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3]).lookup(1), some(2))
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3]).lookup(3), none)
     *
     * @since 1.14.0
     */ NonEmptyArray.prototype.lookup = function(i) {
        return i === 0 ? $c07775bc63cd1cbe$exports.some(this.head) : $779003da930f62c7$exports.lookup(i - 1, this.tail);
    };
    /**
     * Use `lookup` instead
     * @since 1.11.0
     * @deprecated
     */ NonEmptyArray.prototype.index = function(i) {
        return this.lookup(i);
    };
    NonEmptyArray.prototype.findFirst = function(predicate) {
        // tslint:disable-next-line: deprecation
        return predicate(this.head) ? $c07775bc63cd1cbe$exports.some(this.head) : $779003da930f62c7$exports.findFirst(this.tail, predicate);
    };
    NonEmptyArray.prototype.findLast = function(predicate) {
        // tslint:disable-next-line: deprecation
        var a = $779003da930f62c7$exports.findLast(this.tail, predicate);
        return a.isSome() ? a : predicate(this.head) ? $c07775bc63cd1cbe$exports.some(this.head) : $c07775bc63cd1cbe$exports.none;
    };
    /**
     * Find the first index for which a predicate holds
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { some, none } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3]).findIndex(x => x === 2), some(1))
     * assert.deepStrictEqual(new NonEmptyArray<number>(1, []).findIndex(x => x === 2), none)
     *
     * @since 1.11.0
     */ NonEmptyArray.prototype.findIndex = function(predicate) {
        if (predicate(this.head)) return $c07775bc63cd1cbe$exports.some(0);
        else {
            // tslint:disable-next-line: deprecation
            var i = $779003da930f62c7$exports.findIndex(this.tail, predicate);
            return i.isSome() ? $c07775bc63cd1cbe$exports.some(i.value + 1) : $c07775bc63cd1cbe$exports.none;
        }
    };
    /**
     * Returns the index of the last element of the list which matches the predicate
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { some, none } from 'fp-ts/lib/Option'
     *
     * interface X {
     *   a: number
     *   b: number
     * }
     * const xs: NonEmptyArray<X> = new NonEmptyArray({ a: 1, b: 0 }, [{ a: 1, b: 1 }])
     * assert.deepStrictEqual(xs.findLastIndex(x => x.a === 1), some(1))
     * assert.deepStrictEqual(xs.findLastIndex(x => x.a === 4), none)
     *
     * @since 1.11.0
     */ NonEmptyArray.prototype.findLastIndex = function(predicate) {
        // tslint:disable-next-line: deprecation
        var i = $779003da930f62c7$exports.findLastIndex(this.tail, predicate);
        return i.isSome() ? $c07775bc63cd1cbe$exports.some(i.value + 1) : predicate(this.head) ? $c07775bc63cd1cbe$exports.some(0) : $c07775bc63cd1cbe$exports.none;
    };
    /**
     * Insert an element at the specified index, creating a new NonEmptyArray, or returning `None` if the index is out of bounds
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { some } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3, 4]).insertAt(2, 5), some(new NonEmptyArray(1, [2, 5, 3, 4])))
     *
     * @since 1.11.0
     */ NonEmptyArray.prototype.insertAt = function(i, a) {
        if (i === 0) return $c07775bc63cd1cbe$exports.some(new NonEmptyArray(a, this.toArray()));
        else {
            // tslint:disable-next-line: deprecation
            var t = $779003da930f62c7$exports.insertAt(i - 1, a, this.tail);
            return t.isSome() ? $c07775bc63cd1cbe$exports.some(new NonEmptyArray(this.head, t.value)) : $c07775bc63cd1cbe$exports.none;
        }
    };
    /**
     * Change the element at the specified index, creating a new NonEmptyArray, or returning `None` if the index is out of bounds
     *
     * @example
     * import { NonEmptyArray } from 'fp-ts/lib/NonEmptyArray'
     * import { some, none } from 'fp-ts/lib/Option'
     *
     * assert.deepStrictEqual(new NonEmptyArray(1, [2, 3]).updateAt(1, 1), some(new NonEmptyArray(1, [1, 3])))
     * assert.deepStrictEqual(new NonEmptyArray(1, []).updateAt(1, 1), none)
     *
     * @since 1.11.0
     */ NonEmptyArray.prototype.updateAt = function(i, a) {
        if (i === 0) return this.head === a ? $c07775bc63cd1cbe$exports.some(this) : $c07775bc63cd1cbe$exports.some(new NonEmptyArray(a, this.tail));
        else {
            // tslint:disable-next-line: deprecation
            var t = $779003da930f62c7$exports.updateAt(i - 1, a, this.tail);
            return t.isSome() ? t.value === this.tail ? $c07775bc63cd1cbe$exports.some(this) : $c07775bc63cd1cbe$exports.some(new NonEmptyArray(this.head, t.value)) : $c07775bc63cd1cbe$exports.none;
        }
    };
    NonEmptyArray.prototype.filter = function(predicate) {
        return this.filterWithIndex(function(_, a) {
            return predicate(a);
        });
    };
    /**
     * @since 1.12.0
     */ NonEmptyArray.prototype.filterWithIndex = function(predicate) {
        var t = $779003da930f62c7$exports.array.filterWithIndex(this.tail, function(i, a) {
            return predicate(i + 1, a);
        });
        return predicate(0, this.head) ? $c07775bc63cd1cbe$exports.some(new NonEmptyArray(this.head, t)) : $a299095f4f86d8f0$exports.fromArray(t);
    };
    /**
     * @since 1.14.0
     */ NonEmptyArray.prototype.some = function(predicate) {
        return predicate(this.head) || this.tail.some(function(a) {
            return predicate(a);
        });
    };
    /**
     * @since 1.14.0
     */ NonEmptyArray.prototype.every = function(predicate) {
        return predicate(this.head) && this.tail.every(function(a) {
            return predicate(a);
        });
    };
    return NonEmptyArray;
}();
$a299095f4f86d8f0$exports.NonEmptyArray = $a299095f4f86d8f0$var$NonEmptyArray;
var $a299095f4f86d8f0$var$unsafeFromArray = function(as) {
    return new $a299095f4f86d8f0$var$NonEmptyArray(as[0], as.slice(1));
};
/**
 * Builds a `NonEmptyArray` from an `Array` returning `none` if `as` is an empty array
 *
 * @since 1.0.0
 */ $a299095f4f86d8f0$exports.fromArray = function(as) {
    return as.length > 0 ? $c07775bc63cd1cbe$exports.some($a299095f4f86d8f0$var$unsafeFromArray(as)) : $c07775bc63cd1cbe$exports.none;
};
var $a299095f4f86d8f0$var$map = function(fa, f) {
    return fa.map(f);
};
var $a299095f4f86d8f0$var$mapWithIndex = function(fa, f) {
    return fa.mapWithIndex(f);
};
var $a299095f4f86d8f0$var$of = function(a) {
    return new $a299095f4f86d8f0$var$NonEmptyArray(a, []);
};
var $a299095f4f86d8f0$var$ap = function(fab, fa) {
    return fa.ap(fab);
};
var $a299095f4f86d8f0$var$chain = function(fa, f) {
    return fa.chain(f);
};
var $a299095f4f86d8f0$var$concat = function(fx, fy) {
    return fx.concat(fy);
};
/**
 * Builds a `Semigroup` instance for `NonEmptyArray`
 *
 * @since 1.0.0
 */ $a299095f4f86d8f0$exports.getSemigroup = function() {
    return {
        concat: $a299095f4f86d8f0$var$concat
    };
};
/**
 * Use `getEq`
 *
 * @since 1.14.0
 * @deprecated
 */ $a299095f4f86d8f0$exports.getSetoid = $a299095f4f86d8f0$var$getEq;
/**
 * @example
 * import { NonEmptyArray, getEq } from 'fp-ts/lib/NonEmptyArray'
 * import { eqNumber } from 'fp-ts/lib/Eq'
 *
 * const E = getEq(eqNumber)
 * assert.strictEqual(E.equals(new NonEmptyArray(1, []), new NonEmptyArray(1, [])), true)
 * assert.strictEqual(E.equals(new NonEmptyArray(1, []), new NonEmptyArray(1, [2])), false)
 *
 * @since 1.19.0
 */ function $a299095f4f86d8f0$var$getEq(S) {
    var eqTail = $779003da930f62c7$exports.getEq(S);
    return $4e552386da5371f0$exports.fromEquals(function(x, y) {
        return S.equals(x.head, y.head) && eqTail.equals(x.tail, y.tail);
    });
}
$a299095f4f86d8f0$exports.getEq = $a299095f4f86d8f0$var$getEq;
/**
 * Group equal, consecutive elements of an array into non empty arrays.
 *
 * @example
 * import { NonEmptyArray, group } from 'fp-ts/lib/NonEmptyArray'
 * import { ordNumber } from 'fp-ts/lib/Ord'
 *
 * assert.deepStrictEqual(group(ordNumber)([1, 2, 1, 1]), [
 *   new NonEmptyArray(1, []),
 *   new NonEmptyArray(2, []),
 *   new NonEmptyArray(1, [1])
 * ])
 *
 * @since 1.7.0
 */ $a299095f4f86d8f0$exports.group = function(S) {
    return function(as) {
        var r = [];
        var len = as.length;
        if (len === 0) return r;
        var head = as[0];
        var tail = [];
        for(var i = 1; i < len; i++){
            var x = as[i];
            if (S.equals(x, head)) tail.push(x);
            else {
                r.push(new $a299095f4f86d8f0$var$NonEmptyArray(head, tail));
                head = x;
                tail = [];
            }
        }
        r.push(new $a299095f4f86d8f0$var$NonEmptyArray(head, tail));
        return r;
    };
};
/**
 * Sort and then group the elements of an array into non empty arrays.
 *
 * @example
 * import { NonEmptyArray, groupSort } from 'fp-ts/lib/NonEmptyArray'
 * import { ordNumber } from 'fp-ts/lib/Ord'
 *
 * assert.deepStrictEqual(groupSort(ordNumber)([1, 2, 1, 1]), [new NonEmptyArray(1, [1, 1]), new NonEmptyArray(2, [])])
 *
 * @since 1.7.0
 */ $a299095f4f86d8f0$exports.groupSort = function(O) {
    // tslint:disable-next-line: deprecation
    return $da18856e9734b7b7$exports.compose($a299095f4f86d8f0$exports.group(O), $779003da930f62c7$exports.sort(O));
};
var $a299095f4f86d8f0$var$reduce = function(fa, b, f) {
    return fa.reduce(b, f);
};
var $a299095f4f86d8f0$var$foldMap = function(M) {
    return function(fa, f) {
        return fa.tail.reduce(function(acc, a) {
            return M.concat(acc, f(a));
        }, f(fa.head));
    };
};
var $a299095f4f86d8f0$var$foldr = function(fa, b, f) {
    return fa.foldr(b, f);
};
var $a299095f4f86d8f0$var$reduceWithIndex = function(fa, b, f) {
    return fa.reduceWithIndex(b, f);
};
var $a299095f4f86d8f0$var$foldMapWithIndex = function(M) {
    return function(fa, f) {
        return fa.tail.reduce(function(acc, a, i) {
            return M.concat(acc, f(i + 1, a));
        }, f(0, fa.head));
    };
};
var $a299095f4f86d8f0$var$foldrWithIndex = function(fa, b, f) {
    return fa.foldrWithIndex(b, f);
};
var $a299095f4f86d8f0$var$extend = function(fa, f) {
    return fa.extend(f);
};
var $a299095f4f86d8f0$var$extract = function(fa) {
    return fa.extract();
};
function $a299095f4f86d8f0$var$traverse(F) {
    var traverseWithIndexF = $a299095f4f86d8f0$var$traverseWithIndex(F);
    return function(ta, f) {
        return traverseWithIndexF(ta, function(_, a) {
            return f(a);
        });
    };
}
function $a299095f4f86d8f0$var$sequence(F) {
    var sequenceF = $779003da930f62c7$exports.array.sequence(F);
    return function(ta) {
        return F.ap(F.map(ta.head, function(a) {
            return function(as) {
                return new $a299095f4f86d8f0$var$NonEmptyArray(a, as);
            };
        }), sequenceF(ta.tail));
    };
}
/**
 * Splits an array into sub-non-empty-arrays stored in an object, based on the result of calling a `string`-returning
 * function on each element, and grouping the results according to values returned
 *
 * @example
 * import { NonEmptyArray, groupBy } from 'fp-ts/lib/NonEmptyArray'
 *
 * assert.deepStrictEqual(groupBy(['foo', 'bar', 'foobar'], a => String(a.length)), {
 *   '3': new NonEmptyArray('foo', ['bar']),
 *   '6': new NonEmptyArray('foobar', [])
 * })
 *
 * @since 1.10.0
 */ $a299095f4f86d8f0$exports.groupBy = function(as, f) {
    var r = {};
    for(var _i = 0, as_1 = as; _i < as_1.length; _i++){
        var a = as_1[_i];
        var k = f(a);
        if (r.hasOwnProperty(k)) r[k].tail.push(a);
        else r[k] = new $a299095f4f86d8f0$var$NonEmptyArray(a, []);
    }
    return r;
};
var $a299095f4f86d8f0$var$traverseWithIndex = function(F) {
    var traverseWithIndexF = $779003da930f62c7$exports.array.traverseWithIndex(F);
    return function(ta, f) {
        var fb = f(0, ta.head);
        var fbs = traverseWithIndexF(ta.tail, function(i, a) {
            return f(i + 1, a);
        });
        return F.ap(F.map(fb, function(b) {
            return function(bs) {
                return new $a299095f4f86d8f0$var$NonEmptyArray(b, bs);
            };
        }), fbs);
    };
};
/**
 * @since 1.0.0
 */ $a299095f4f86d8f0$exports.nonEmptyArray = {
    URI: $a299095f4f86d8f0$exports.URI,
    extend: $a299095f4f86d8f0$var$extend,
    extract: $a299095f4f86d8f0$var$extract,
    map: $a299095f4f86d8f0$var$map,
    mapWithIndex: $a299095f4f86d8f0$var$mapWithIndex,
    of: $a299095f4f86d8f0$var$of,
    ap: $a299095f4f86d8f0$var$ap,
    chain: $a299095f4f86d8f0$var$chain,
    reduce: $a299095f4f86d8f0$var$reduce,
    foldMap: $a299095f4f86d8f0$var$foldMap,
    foldr: $a299095f4f86d8f0$var$foldr,
    traverse: $a299095f4f86d8f0$var$traverse,
    sequence: $a299095f4f86d8f0$var$sequence,
    reduceWithIndex: $a299095f4f86d8f0$var$reduceWithIndex,
    foldMapWithIndex: $a299095f4f86d8f0$var$foldMapWithIndex,
    foldrWithIndex: $a299095f4f86d8f0$var$foldrWithIndex,
    traverseWithIndex: $a299095f4f86d8f0$var$traverseWithIndex
};



$b04b6dbdae1c30eb$exports.URI = "Parser";
var $b04b6dbdae1c30eb$var$Parser = /** @class */ function() {
    function Parser(run) {
        this.run = run;
    }
    Parser.prototype.map = function(f) {
        var _this = this;
        return new Parser(function(s) {
            return _this.run(s).map(function(_a) {
                var a = _a[0], s1 = _a[1];
                return [
                    f(a),
                    s1
                ];
            });
        });
    };
    Parser.prototype.ap = function(fab) {
        var _this = this;
        return fab.chain(function(f) {
            return _this.map(f);
        }); // <= derived
    };
    /**
     * Flipped version of {@link ap}
     */ Parser.prototype.ap_ = function(fb) {
        return fb.ap(this);
    };
    /**
     * Combine two effectful actions, keeping only the result of the first
     */ Parser.prototype.applyFirst = function(fb) {
        return fb.ap(this.map($da18856e9734b7b7$exports.constant));
    };
    /**
     * Combine two effectful actions, keeping only the result of the second
     */ Parser.prototype.applySecond = function(fb) {
        return fb.ap(this.map($da18856e9734b7b7$exports.constIdentity));
    };
    Parser.prototype.chain = function(f) {
        var _this = this;
        return new Parser(function(s) {
            return _this.run(s).chain(function(_a) {
                var a = _a[0], s1 = _a[1];
                return f(a).run(s1);
            });
        });
    };
    Parser.prototype.alt = function(fa) {
        var _this = this;
        return new Parser(function(s) {
            var e = _this.run(s);
            return e.fold(function() {
                return fa.run(s);
            }, function() {
                return e;
            });
        });
    };
    return Parser;
}();
$b04b6dbdae1c30eb$exports.Parser = $b04b6dbdae1c30eb$var$Parser;
var $b04b6dbdae1c30eb$var$map = function(fa, f) {
    return fa.map(f);
};
var $b04b6dbdae1c30eb$var$of = function(a) {
    return new $b04b6dbdae1c30eb$var$Parser(function(s) {
        return $b04b6dbdae1c30eb$exports.createParseSuccess(a, s);
    });
};
var $b04b6dbdae1c30eb$var$ap = function(fab, fa) {
    return fa.ap(fab);
};
var $b04b6dbdae1c30eb$var$chain = function(fa, f) {
    return fa.chain(f);
};
var $b04b6dbdae1c30eb$var$alt = function(fx, fy) {
    return fx.alt(fy);
};
var $b04b6dbdae1c30eb$var$zero = function() {
    return $b04b6dbdae1c30eb$exports.fail;
};
var $b04b6dbdae1c30eb$var$empty = $b04b6dbdae1c30eb$var$of("");
var $b04b6dbdae1c30eb$var$concat = function(x, y) {
    return y.ap(x.map(function(a) {
        return function(b) {
            return a + b;
        };
    }));
};
$b04b6dbdae1c30eb$exports.alts = function() {
    var fs = [];
    for(var _i = 0; _i < arguments.length; _i++)fs[_i] = arguments[_i];
    return fs.reduce(function(fx, fy) {
        return fx.alt(fy);
    }, $b04b6dbdae1c30eb$exports.fail);
};
//
// helpers
//
$b04b6dbdae1c30eb$exports.createParseFailure = function(remaining, message) {
    return $0370766540a3ee1a$exports.left({
        remaining: remaining,
        message: message
    });
};
$b04b6dbdae1c30eb$exports.createParseSuccess = function(a, s) {
    return $0370766540a3ee1a$exports.right([
        a,
        s
    ]);
};
$b04b6dbdae1c30eb$exports.consumed = function(result) {
    return result.map(function(_a) {
        var a = _a[0], _ = _a[1];
        return a;
    });
};
$b04b6dbdae1c30eb$exports.remaining = function(result) {
    return result.fold(function(pe) {
        return pe.remaining;
    }, function(_a) {
        var _ = _a[0], s = _a[1];
        return s;
    });
};
$b04b6dbdae1c30eb$exports.getAndNext = function(s) {
    return s.length > 0 ? $c07775bc63cd1cbe$exports.some($da18856e9734b7b7$exports.tuple(s.substring(0, 1), s.substring(1))) : $c07775bc63cd1cbe$exports.none;
};
/** Get the result of a parse, plus the unparsed input remainder */ $b04b6dbdae1c30eb$exports.unparser = function(parser) {
    return function(s) {
        var e = parser.run(s);
        return {
            consumed: $b04b6dbdae1c30eb$exports.consumed(e),
            remaining: $b04b6dbdae1c30eb$exports.remaining(e)
        };
    };
};
//
// combinators
//
/** Returns a parser which will fail immediately with the provided message */ $b04b6dbdae1c30eb$exports.failWith = function(message) {
    return new $b04b6dbdae1c30eb$var$Parser(function(s) {
        return $b04b6dbdae1c30eb$exports.createParseFailure(s, message);
    });
};
/** The `fail` parser will just fail immediately without consuming any input */ $b04b6dbdae1c30eb$exports.fail = $b04b6dbdae1c30eb$exports.failWith("Parse failed on `fail`");
/**
 * The `succeed` parser constructor creates a parser which will simply
 * return the value provided as its argument, without consuming any input.
 *
 * This is equivalent to the monadic `of`
 */ $b04b6dbdae1c30eb$exports.succeed = $b04b6dbdae1c30eb$var$of;
/**
 * A parser combinator which returns the provided parser unchanged, except
 * that if it fails, the provided error message will be returned in the
 * `ParseFailure`.
 */ $b04b6dbdae1c30eb$exports.expected = function(parser, message) {
    return $b04b6dbdae1c30eb$exports.expectedL(parser, function() {
        return message;
    });
};
$b04b6dbdae1c30eb$exports.expectedL = function(parser, message) {
    return new $b04b6dbdae1c30eb$var$Parser(function(s) {
        return parser.run(s).mapLeft(function(_a) {
            var remaining = _a.remaining;
            return {
                remaining: remaining,
                message: message(remaining)
            };
        });
    });
};
/** The `item` parser consumes a single value, regardless of what it is,
 * and returns it as its result.
 */ $b04b6dbdae1c30eb$exports.item = new $b04b6dbdae1c30eb$var$Parser(function(s) {
    return $b04b6dbdae1c30eb$exports.getAndNext(s).foldL(function() {
        return $b04b6dbdae1c30eb$exports.createParseFailure(s, "Parse failed on item");
    }, function(_a) {
        var c = _a[0], s = _a[1];
        return $b04b6dbdae1c30eb$exports.createParseSuccess(c, s);
    });
});
/**
 * The `seq` combinator takes a parser, and a function which will receive
 * the result of that parser if it succeeds, and which should return another
 * parser, which will be run immediately after the initial parser. In this
 * way, you can join parsers together in a sequence, producing more complex
 * parsers.
 *
 * This is equivalent to the monadic `bind` operation.
 */ $b04b6dbdae1c30eb$exports.seq = $b04b6dbdae1c30eb$var$chain;
/**
 * The `either` combinator takes two parsers, runs the first on the input
 * stream, and if that fails, it will backtrack and attempt the second
 * parser on the same input. Basically, try parser 1, then try parser 2.
 *
 * This is equivalent to the `alt` operation of `Alt`.
 */ $b04b6dbdae1c30eb$exports.either = $b04b6dbdae1c30eb$var$alt;
/**
 * The `sat` parser constructor takes a predicate function, and will consume
 * a single character if calling that predicate function with the character
 * as its argument returns `true`. If it returns `false`, the parser will
 * fail
 */ $b04b6dbdae1c30eb$exports.sat = function(predicate) {
    return new $b04b6dbdae1c30eb$var$Parser(function(s) {
        return $b04b6dbdae1c30eb$exports.getAndNext(s).chain(function(x) {
            return predicate(x[0]) ? $c07775bc63cd1cbe$exports.some(x) : $c07775bc63cd1cbe$exports.none;
        }).foldL(function() {
            return $b04b6dbdae1c30eb$exports.createParseFailure(s, "Parse failed on sat");
        }, function(_a) {
            var c = _a[0], s = _a[1];
            return $b04b6dbdae1c30eb$exports.createParseSuccess(c, s);
        });
    });
};
/**
 * The `maybe` parser combinator creates a parser which will run the provided
 * parser on the input, and if it fails, it will returns the empty string (as
 * a result, without consuming any input.
 */ $b04b6dbdae1c30eb$exports.maybe = function(parser) {
    return parser.alt($b04b6dbdae1c30eb$var$empty);
};
/**
 * Matches the end of the input
 */ $b04b6dbdae1c30eb$exports.eof = new $b04b6dbdae1c30eb$var$Parser(function(s) {
    return s === "" ? $b04b6dbdae1c30eb$exports.createParseSuccess(undefined, "") : $b04b6dbdae1c30eb$exports.createParseFailure(s, "end of file");
});
/**
 * The `many` combinator takes a parser, and returns a new parser which will
 * run the parser repeatedly on the input stream until it fails, returning
 * a list of the result values of each parse operation as its result, or the
 * empty list if the parser never succeeded.
 *
 * Read that as "match this parser zero or more times and give me a list of
 * the results."
 */ $b04b6dbdae1c30eb$exports.many = function(parser) {
    return $b04b6dbdae1c30eb$var$alt($b04b6dbdae1c30eb$exports.many1(parser).map(function(a) {
        return a.toArray();
    }), $b04b6dbdae1c30eb$var$of([]));
};
/**
 * The `many1` combinator is just like the `many` combinator, except it
 * requires its wrapped parser to match at least once. The resulting list is
 * thus guaranteed to contain at least one value.
 */ $b04b6dbdae1c30eb$exports.many1 = function(parser) {
    return parser.chain(function(head) {
        return $b04b6dbdae1c30eb$exports.many(parser).chain(function(tail) {
            return $b04b6dbdae1c30eb$var$of(new $a299095f4f86d8f0$exports.NonEmptyArray(head, tail));
        });
    });
};
/**
 * Matches the provided parser `p` zero or more times, but requires the
 * parser `sep` to match once in between each match of `p`. In other words,
 * use `sep` to match separator characters in between matches of `p`.
 */ $b04b6dbdae1c30eb$exports.sepBy = function(sep, parser) {
    return $b04b6dbdae1c30eb$var$alt($b04b6dbdae1c30eb$exports.sepBy1(sep, parser).map(function(a) {
        return a.toArray();
    }), $b04b6dbdae1c30eb$var$of([]));
};
/** Matches both parsers and return the value of the second */ $b04b6dbdae1c30eb$exports.second = function(pa) {
    return function(pb) {
        return new $b04b6dbdae1c30eb$var$Parser(function(s) {
            return $b04b6dbdae1c30eb$var$applySecondParser(pa, pb).run(s);
        });
    };
};
/**
 * Matches the provided parser `p` one or more times, but requires the
 * parser `sep` to match once in between each match of `p`. In other words,
 * use `sep` to match separator characters in between matches of `p`.
 */ $b04b6dbdae1c30eb$exports.sepBy1 = function(sep, parser) {
    return parser.chain(function(head) {
        return $b04b6dbdae1c30eb$var$alt($b04b6dbdae1c30eb$exports.many($b04b6dbdae1c30eb$exports.second(sep)(parser)), $b04b6dbdae1c30eb$var$of([])).chain(function(tail) {
            return $b04b6dbdae1c30eb$var$of(new $a299095f4f86d8f0$exports.NonEmptyArray(head, tail));
        });
    });
};
$b04b6dbdae1c30eb$exports.parser = {
    URI: $b04b6dbdae1c30eb$exports.URI,
    map: $b04b6dbdae1c30eb$var$map,
    of: $b04b6dbdae1c30eb$var$of,
    ap: $b04b6dbdae1c30eb$var$ap,
    chain: $b04b6dbdae1c30eb$var$chain,
    zero: $b04b6dbdae1c30eb$var$zero,
    alt: $b04b6dbdae1c30eb$var$alt,
    empty: $b04b6dbdae1c30eb$var$empty,
    concat: $b04b6dbdae1c30eb$var$concat
};
$b04b6dbdae1c30eb$exports.fold = $e11eb2700046c52f$exports.fold($b04b6dbdae1c30eb$exports.parser);
var $b04b6dbdae1c30eb$var$applySecondParser = $179ffbf36670c650$exports.applySecond($b04b6dbdae1c30eb$exports.parser);


var $190dec43630cdf93$exports = {};
"use strict";
Object.defineProperty($190dec43630cdf93$exports, "__esModule", {
    value: true
});


/**
 * The `char` parser constructor returns a parser which matches only the
 * specified single character
 */ function $190dec43630cdf93$var$char(c) {
    return $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat(function(s) {
        return s === c;
    }), '"' + c + '"');
}
$190dec43630cdf93$exports.char = $190dec43630cdf93$var$char;
/**
 * Takes a `P.Parser<string>` and matches it zero or more times, returning
 * a `String` of what was matched.
 */ function $190dec43630cdf93$var$many(parser) {
    return $b04b6dbdae1c30eb$exports.maybe($190dec43630cdf93$var$many1(parser));
}
$190dec43630cdf93$exports.many = $190dec43630cdf93$var$many;
/**
 * Takes a `P.Parser<string>` and matches it one or more times, returning
 * a `String` of what was matched.
 */ function $190dec43630cdf93$var$many1(parser) {
    return $b04b6dbdae1c30eb$exports.many1(parser).map(function(nea) {
        return nea.toArray().join("");
    });
}
$190dec43630cdf93$exports.many1 = $190dec43630cdf93$var$many1;
/**
 * The `notChar` parser constructor makes a parser which will match any
 * single character other than the one provided.
 */ function $190dec43630cdf93$var$notChar(c) {
    return $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat(function(c1) {
        return c1 !== c;
    }), 'anything but "' + c + '"');
}
$190dec43630cdf93$exports.notChar = $190dec43630cdf93$var$notChar;
function $190dec43630cdf93$var$isOneOf(s, c) {
    return s.indexOf(c) !== -1;
}
/** Matches any one character from the provided string. */ function $190dec43630cdf93$var$oneOf(s) {
    return $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat(function(c) {
        return $190dec43630cdf93$var$isOneOf(s, c);
    }), 'One of "' + s + '"');
}
$190dec43630cdf93$exports.oneOf = $190dec43630cdf93$var$oneOf;
function $190dec43630cdf93$var$isDigit(c) {
    return "0123456789".indexOf(c) !== -1;
}
/** Matches a single digit. */ $190dec43630cdf93$exports.digit = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($190dec43630cdf93$var$isDigit), "a digit");
var $190dec43630cdf93$var$spaceRe = /^\s$/;
function $190dec43630cdf93$var$isSpace(c) {
    return $190dec43630cdf93$var$spaceRe.test(c);
}
/** Matches a single whitespace character. */ $190dec43630cdf93$exports.space = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($190dec43630cdf93$var$isSpace), "whitespace");
function $190dec43630cdf93$var$isUnderscore(c) {
    return c === "_";
}
function $190dec43630cdf93$var$isLetter(c) {
    return /[a-z]/.test(c.toLowerCase());
}
function $190dec43630cdf93$var$isAlphanum(c) {
    return $190dec43630cdf93$var$isLetter(c) || $190dec43630cdf93$var$isDigit(c) || $190dec43630cdf93$var$isUnderscore(c);
}
/** Matches a single letter, digit or underscore character. */ $190dec43630cdf93$exports.alphanum = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($190dec43630cdf93$var$isAlphanum), "a word character");
/** Matches a single ASCII letter. */ $190dec43630cdf93$exports.letter = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($190dec43630cdf93$var$isLetter), "a letter");
function $190dec43630cdf93$var$isUpper(c) {
    return $190dec43630cdf93$var$isLetter(c) && c === c.toUpperCase();
}
/** Matches a single upper case ASCII letter. */ $190dec43630cdf93$exports.upper = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($190dec43630cdf93$var$isUpper), "an upper case letter");
function $190dec43630cdf93$var$isLower(c) {
    return $190dec43630cdf93$var$isLetter(c) && c === c.toLowerCase();
}
/** Matches a single lower case ASCII letter. */ $190dec43630cdf93$exports.lower = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($190dec43630cdf93$var$isLower), "a lower case letter");
/** Matches a single character which isn't a character from the provided string. */ function $190dec43630cdf93$var$notOneOf(s) {
    return $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat(function(c) {
        return !$190dec43630cdf93$var$isOneOf(s, c);
    }), "Not one of " + JSON.stringify(s));
}
$190dec43630cdf93$exports.notOneOf = $190dec43630cdf93$var$notOneOf;
/** Matches a single character which isn't a digit. */ $190dec43630cdf93$exports.notDigit = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($da18856e9734b7b7$exports.not($190dec43630cdf93$var$isDigit)), "a non-digit");
/** Matches a single character which isn't whitespace. */ $190dec43630cdf93$exports.notSpace = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($da18856e9734b7b7$exports.not($190dec43630cdf93$var$isSpace)), "a non-whitespace character");
/** Matches a single character which isn't a letter, digit or underscore. */ $190dec43630cdf93$exports.notAlphanum = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($da18856e9734b7b7$exports.not($190dec43630cdf93$var$isAlphanum)), "a non-word character");
/** Matches a single character which isn't an ASCII letter. */ $190dec43630cdf93$exports.notLetter = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($da18856e9734b7b7$exports.not($190dec43630cdf93$var$isLetter)), "a non-letter character");
/** Matches a single character which isn't an upper case ASCII letter. */ $190dec43630cdf93$exports.notUpper = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($da18856e9734b7b7$exports.not($190dec43630cdf93$var$isUpper)), "anything but an upper case letter");
/** Matches a single character which isn't a lower case ASCII letter. */ $190dec43630cdf93$exports.notLower = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.sat($da18856e9734b7b7$exports.not($190dec43630cdf93$var$isLower)), "anything but a lower case letter");


var $0e37f92304955e7c$exports = {};
"use strict";
Object.defineProperty($0e37f92304955e7c$exports, "__esModule", {
    value: true
});



/**
 * Matches the given parser zero or more times, returning a string of the
 * entire match
 */ function $0e37f92304955e7c$var$many(parser) {
    return $b04b6dbdae1c30eb$exports.maybe($0e37f92304955e7c$var$many1(parser));
}
$0e37f92304955e7c$exports.many = $0e37f92304955e7c$var$many;
/**
 * Matches the given parser one or more times, returning a string of the
 * entire match
 */ function $0e37f92304955e7c$var$many1(parser) {
    return $b04b6dbdae1c30eb$exports.many1(parser).map(function(nea) {
        return nea.toArray().join("");
    });
}
$0e37f92304955e7c$exports.many1 = $0e37f92304955e7c$var$many1;
function $0e37f92304955e7c$var$getAndNext(s, prefix) {
    var i = s.indexOf(prefix);
    if (i === 0) return $c07775bc63cd1cbe$exports.some([
        prefix,
        s.substring(prefix.length)
    ]);
    return $c07775bc63cd1cbe$exports.none;
}
$0e37f92304955e7c$exports.getAndNext = $0e37f92304955e7c$var$getAndNext;
/** Matches the exact string provided. */ function $0e37f92304955e7c$var$string(prefix) {
    return new $b04b6dbdae1c30eb$exports.Parser(function(s) {
        return $0e37f92304955e7c$var$getAndNext(s, prefix).foldL(function() {
            return $b04b6dbdae1c30eb$exports.createParseFailure(s, JSON.stringify(prefix));
        }, function(_a) {
            var c = _a[0], s = _a[1];
            return $b04b6dbdae1c30eb$exports.createParseSuccess(c, s);
        });
    });
}
$0e37f92304955e7c$exports.string = $0e37f92304955e7c$var$string;
/** Matches one of a list of strings. */ function $0e37f92304955e7c$var$oneOf(ss) {
    return $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.alts.apply($b04b6dbdae1c30eb$exports, ss.map($0e37f92304955e7c$var$string)), "one of " + JSON.stringify(ss));
}
$0e37f92304955e7c$exports.oneOf = $0e37f92304955e7c$var$oneOf;
/** Matches zero or more whitespace characters. */ $0e37f92304955e7c$exports.spaces = $190dec43630cdf93$exports.many($190dec43630cdf93$exports.space);
/** Matches one or more whitespace characters. */ $0e37f92304955e7c$exports.spaces1 = $190dec43630cdf93$exports.many1($190dec43630cdf93$exports.space);
/** Matches zero or more non-whitespace characters. */ $0e37f92304955e7c$exports.notSpaces = $190dec43630cdf93$exports.many($190dec43630cdf93$exports.notSpace);
/** Matches one or more non-whitespace characters. */ $0e37f92304955e7c$exports.notSpaces1 = $190dec43630cdf93$exports.many1($190dec43630cdf93$exports.notSpace);
function $0e37f92304955e7c$var$fromString(s) {
    var n = parseFloat(s);
    return isNaN(n) ? $c07775bc63cd1cbe$exports.none : $c07775bc63cd1cbe$exports.some(n);
}
var $0e37f92304955e7c$var$intParsers = [
    $b04b6dbdae1c30eb$exports.maybe($190dec43630cdf93$exports.char("-")),
    $190dec43630cdf93$exports.many1($190dec43630cdf93$exports.digit)
];
$0e37f92304955e7c$exports.int = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.fold($0e37f92304955e7c$var$intParsers).chain(function(s) {
    return $0e37f92304955e7c$var$fromString(s).fold($b04b6dbdae1c30eb$exports.fail, $b04b6dbdae1c30eb$exports.succeed);
}), "an integer");
var $0e37f92304955e7c$var$floatParsers = [
    $b04b6dbdae1c30eb$exports.maybe($190dec43630cdf93$exports.char("-")),
    $190dec43630cdf93$exports.many($190dec43630cdf93$exports.digit),
    $b04b6dbdae1c30eb$exports.maybe($b04b6dbdae1c30eb$exports.fold([
        $190dec43630cdf93$exports.char("."),
        $190dec43630cdf93$exports.many1($190dec43630cdf93$exports.digit)
    ]))
];
$0e37f92304955e7c$exports.float = $b04b6dbdae1c30eb$exports.expected($b04b6dbdae1c30eb$exports.fold($0e37f92304955e7c$var$floatParsers).chain(function(s) {
    return $0e37f92304955e7c$var$fromString(s).fold($b04b6dbdae1c30eb$exports.fail, $b04b6dbdae1c30eb$exports.succeed);
}), "a float");
$0e37f92304955e7c$exports.doubleQuote = $190dec43630cdf93$exports.char('"');
/**
 * Parses a double quoted string, with support for escaping double quotes
 * inside it, and returns the inner string. Does not perform any other form
 * of string escaping.
 */ $0e37f92304955e7c$exports.doubleQuotedString = $0e37f92304955e7c$exports.doubleQuote.chain(function() {
    return $0e37f92304955e7c$var$many($b04b6dbdae1c30eb$exports.either($0e37f92304955e7c$var$string('\\"'), $190dec43630cdf93$exports.notChar('"')));
}).chain(function(s) {
    return $0e37f92304955e7c$exports.doubleQuote.chain(function() {
        return $b04b6dbdae1c30eb$exports.succeed(s);
    });
});






const $8f42eafc2f1b3c8d$var$idLink = (id)=>({
        tag: "id",
        id: id
    });
const $8f42eafc2f1b3c8d$var$unlinked = {
    tag: "unlinked"
};
const $8f42eafc2f1b3c8d$var$run_parser = (p, input)=>p.run(input).bimap((_)=>null, (x)=>x[0]).value;
const $8f42eafc2f1b3c8d$var$run_parser_strict = (p, input)=>{
    const r = $8f42eafc2f1b3c8d$var$run_parser(p, input);
    if (r === null) throw "Parse failed on input: " + input;
    else return r;
};
/**
  run_parser(space_, '_') // => '_'
  run_parser(space_, ' ') // => ' '
  run_parser(space_, '!') // => null
*/ const $8f42eafc2f1b3c8d$var$space_ = $190dec43630cdf93$exports.oneOf(" \n	_");
const $8f42eafc2f1b3c8d$var$spaces_ = $0e37f92304955e7c$exports.many($8f42eafc2f1b3c8d$var$space_);
const $8f42eafc2f1b3c8d$var$spaces1_ = $0e37f92304955e7c$exports.many1($8f42eafc2f1b3c8d$var$space_);
const $8f42eafc2f1b3c8d$var$quote = $190dec43630cdf93$exports.char(`'`);
/**
  run_parser(quoted, `'apa'`) // => `apa`
  run_parser(quoted, `apa`) // => null
  run_parser(quoted, `'apa`) // => null
  run_parser(quoted, `apa'`) // => null
  run_parser(quoted, `'a'a'`) // => `a`
  run_parser(quoted, `'\\\\'`) // => `\\`
  run_parser(quoted, `'\\''`) // => `'`
*/ const $8f42eafc2f1b3c8d$var$quoted = $8f42eafc2f1b3c8d$var$quote.chain((_)=>$0e37f92304955e7c$exports.many($b04b6dbdae1c30eb$exports.alts($0e37f92304955e7c$exports.string(`\\\\`).map((_)=>`\\`), $0e37f92304955e7c$exports.string(`\\'`).map((_)=>`'`), $190dec43630cdf93$exports.notOneOf(`'\\`)))).chain((s)=>$8f42eafc2f1b3c8d$var$quote.chain((_)=>$b04b6dbdae1c30eb$exports.succeed(s)));
const $8f42eafc2f1b3c8d$var$head = $190dec43630cdf93$exports.notOneOf(` '_\t\n:@^~`);
const $8f42eafc2f1b3c8d$var$tail = $0e37f92304955e7c$exports.many($190dec43630cdf93$exports.notOneOf(` _\t\n:@^~`));
/**
  run_parser(text, `'apa'`) // => `apa`
  run_parser(text, `apa`) // => `apa`
  run_parser(text, `'apa`) // => null
  run_parser(text, `apa'`) // => `apa'`
  run_parser(text, `'a'a'`) // => `a`
  run_parser(text, `'\\\\'`) // => `\\`
  run_parser(text, `'\\''`) // => `'`
  run_parser(text, `a b`) // => `a`
  run_parser(text, `a_b`) // => `a`
  run_parser(text, `a:b`) // => `a`
  run_parser(text, `a^b`) // => `a`
  run_parser(text, `a~b`) // => `a`
  run_parser(text, `a+b`) // => `a+b`
*/ const $8f42eafc2f1b3c8d$var$text = $b04b6dbdae1c30eb$exports.alts($8f42eafc2f1b3c8d$var$quoted, $8f42eafc2f1b3c8d$var$head.chain((c)=>$8f42eafc2f1b3c8d$var$tail.map((s)=>c + s)));
/**
  drop_one_last_space('w ') // => 'w'
  drop_one_last_space('w  ') // => 'w '
  drop_one_last_space('w\n') // => 'w\n'
  drop_one_last_space('w \n') // => 'w \n'
  drop_one_last_space('w\n ') // => 'w\n'

  // should this one error instead?
  drop_one_last_space('w') // => 'w'
*/ function $8f42eafc2f1b3c8d$var$drop_one_last_space(s) {
    return s.replace(/ +$/, (x)=>x.slice(1));
}
/**
  add_one_last_space('w') // => 'w '
  add_one_last_space('w ') // => 'w  '
  add_one_last_space('w\n') // => 'w\n'
  add_one_last_space('w \n') // => 'w \n'
  add_one_last_space('w\n') // => 'w\n'

  // should this one error instead?
  add_one_last_space('w') // => 'w '
*/ function $8f42eafc2f1b3c8d$var$add_one_last_space(s) {
    return s.match(/\S *$/) ? s + " " : s;
}
/**
  run_parser(word, `'apa'`) // => `apa `
  run_parser(word, `apa`) // => `apa `
  run_parser(word, `'apa`) // => null
  run_parser(word, `apa'`) // => `apa' `
*/ const $8f42eafc2f1b3c8d$var$word = $8f42eafc2f1b3c8d$var$text.map($8f42eafc2f1b3c8d$var$add_one_last_space);
const $8f42eafc2f1b3c8d$var$id = $190dec43630cdf93$exports.char("@").chain((_)=>$8f42eafc2f1b3c8d$var$text);
const $8f42eafc2f1b3c8d$var$label = $190dec43630cdf93$exports.char(":").chain((_)=>$8f42eafc2f1b3c8d$var$text);
const $8f42eafc2f1b3c8d$var$link = $190dec43630cdf93$exports.oneOf("^~").chain((_)=>$b04b6dbdae1c30eb$exports.alts($8f42eafc2f1b3c8d$var$word.map((text)=>({
            tag: "text",
            text: text
        })), $8f42eafc2f1b3c8d$var$id.map($8f42eafc2f1b3c8d$var$idLink), $b04b6dbdae1c30eb$exports.succeed({
        tag: "unlinked"
    })));
function $8f42eafc2f1b3c8d$var$flatten(keys, parts) {
    const out = $d9d0435d2b879de6$export$2cd8252107eb640b(keys.map((k)=>({
            k: k,
            v: []
        })));
    parts.forEach((part)=>{
        for(const k in part){
            const v = part[k];
            if (v !== undefined) out[k].push(...v);
        }
    });
    return out;
}
const $8f42eafc2f1b3c8d$var$attribute = $b04b6dbdae1c30eb$exports.alts($8f42eafc2f1b3c8d$var$id.map((x)=>[
        x
    ]).map((ids)=>({
        ids: ids
    })), $8f42eafc2f1b3c8d$var$label.map((x)=>[
        x
    ]).map((labels)=>({
        labels: labels
    })), $8f42eafc2f1b3c8d$var$link.map((x)=>[
        x
    ]).map((links)=>({
        links: links
    })));
function $8f42eafc2f1b3c8d$var$Unit(text, attrs) {
    const r = $8f42eafc2f1b3c8d$var$flatten([
        "ids",
        "labels",
        "links"
    ], attrs);
    return {
        text: text,
        ...r
    };
}
/**
  const expect: Unit = {
    text: `apa `,
    labels: [`bepa`],
    ids: [`cepa`],
    links: [{tag: 'text', text: `depa `}]
  }
  run_parser(unit, `'apa':'bepa'@'cepa'^'depa'`) // => expect
  run_parser(unit, `apa:bepa@cepa^depa`) // => expect

  const expect: Unit = {
    text: `apa `, labels: [], ids: [],
    links: [{tag: 'unlinked'}]
  }
  run_parser(unit, `apa^`) // => expect
*/ const $8f42eafc2f1b3c8d$var$unit = $8f42eafc2f1b3c8d$var$word.chain((word)=>$b04b6dbdae1c30eb$exports.many($8f42eafc2f1b3c8d$var$attribute).map((attrs)=>$8f42eafc2f1b3c8d$var$Unit(word, attrs)));
const $8f42eafc2f1b3c8d$var$space_padded = (f)=>$8f42eafc2f1b3c8d$var$spaces_.chain((_)=>f.chain((a)=>$8f42eafc2f1b3c8d$var$spaces_.chain((_)=>$b04b6dbdae1c30eb$exports.succeed(a))));
/**
  const expect: Unit = {
    text: `apa `,
    labels: [`bepa`],
    ids: [`cepa`],
    links: [{tag: 'text', text: `depa `}]
  }
  run_parser(units, ` apa:bepa@cepa^depa 'apa':'bepa'@'cepa'^'depa' `) // => [expect, expect]
  run_parser(units, `_apa:bepa@cepa^depa_'apa':'bepa'@'cepa'^'depa'_`) // => [expect, expect]

  run_parser(units, `__one___two___three___`) // => `one two three`.split(' ').map(x => Unit(x + ' ', []))
  run_parser(units, `__one@0_two@1_three@2_`) // => `one two three`.split(' ').map((x, i) => Unit(x + ' ', [{ids: [i+'']}]))
  run_parser(units, `__one:0_two:1_three:2_`) // => `one two three`.split(' ').map((x, i) => Unit(x + ' ', [{labels: [i+'']}]))

  run_parser(units, `  one    two    three    `) // => `one two three`.split(' ').map(x => Unit(x + ' ', []))
  run_parser(units, `  one@0  two@1  three@2  `) // => `one two three`.split(' ').map((x, i) => Unit(x + ' ', [{ids: [i+'']}]))
  run_parser(units, `  one:0  two:1  three:2  `) // => `one two three`.split(' ').map((x, i) => Unit(x + ' ', [{labels: [i+'']}]))
*/ const $8f42eafc2f1b3c8d$var$units = $8f42eafc2f1b3c8d$var$space_padded($b04b6dbdae1c30eb$exports.sepBy($8f42eafc2f1b3c8d$var$spaces1_, $8f42eafc2f1b3c8d$var$unit));
const $8f42eafc2f1b3c8d$var$safe_parse = (s)=>$8f42eafc2f1b3c8d$var$run_parser($8f42eafc2f1b3c8d$var$units, s) || undefined;
const $8f42eafc2f1b3c8d$export$98e6a39c04603d36 = (s)=>$8f42eafc2f1b3c8d$var$safe_parse(s) || [];
const $8f42eafc2f1b3c8d$export$554ca05e3f76eca5 = (s)=>$8f42eafc2f1b3c8d$var$run_parser_strict($8f42eafc2f1b3c8d$var$units, s);
const $8f42eafc2f1b3c8d$var$identify = (prefix, us)=>us.map((u, i)=>({
            ...u,
            ids: [
                prefix + i,
                ...u.ids
            ]
        }));
// could also put the user-supplied ids first and append the generated ID
// to try to preserve the user-supplied id
// one problem is possible name-collision
function $8f42eafc2f1b3c8d$var$to_unaligned_graph(stu) {
    const s = $8f42eafc2f1b3c8d$var$identify("s", stu.source);
    const t = $8f42eafc2f1b3c8d$var$identify("t", stu.target);
    const uf = $a0933ef57ff1c2b9$export$6b13ca446b1d0fd3();
    const count = $a0933ef57ff1c2b9$export$1b74141c5fe63a28(s.map((u)=>u.text));
    s.forEach((u)=>uf.unions([
            ...u.ids.map($8f42eafc2f1b3c8d$var$idLink),
            ...u.links.filter((link)=>link.tag != "unlinked"),
            // one may link to the text if it is unique
            ...$a0933ef57ff1c2b9$export$864d727b48066337(count(u.text) == 1, {
                tag: "text",
                text: u.text
            })
        ]));
    t.forEach((u)=>uf.unions([
            ...u.ids.map($8f42eafc2f1b3c8d$var$idLink),
            ...u.links.filter((link)=>link.tag != "unlinked")
        ]));
    const proto_edges = {};
    function link(u) {
        const id = u.ids[0];
        const r = "" + uf.repr($8f42eafc2f1b3c8d$var$idLink(id));
        $d9d0435d2b879de6$export$3ff57735a52b8713(proto_edges, r, $566cb6e3cba7cd4f$export$d56f0e7673f0b9d9, (e)=>$566cb6e3cba7cd4f$export$6b4ef9c17f912616(e, $566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
                id
            ], u.labels, u.links.length > 0)));
        return $58ccaae15ba3b7ae$export$50792b0e93539fde(u.text, id);
    }
    const source = s.map(link);
    const target = t.map(link);
    const edges = $566cb6e3cba7cd4f$export$27823d486efd100e($d9d0435d2b879de6$export$df3f009e3d155b20(proto_edges, (e)=>e));
    return {
        source: source,
        target: target,
        edges: edges
    };
}
function $8f42eafc2f1b3c8d$export$9cb5350a7a87beb(source, target) {
    return $566cb6e3cba7cd4f$export$9ea32abc1be18076($8f42eafc2f1b3c8d$var$to_unaligned_graph({
        source: source,
        target: target
    }));
}
function $8f42eafc2f1b3c8d$var$unit_to_string(unit) {
    const quote_as_necessary = (text)=>{
        const escape = text.search(/[ '_\t\n:@^~]/);
        if (escape != -1) {
            const escaped = text.replace(/['\\']/g, (s)=>"\\" + s);
            return `'${escaped}'`;
        } else return text;
    };
    const word = (text)=>quote_as_necessary($8f42eafc2f1b3c8d$var$drop_one_last_space(text));
    const text = word(unit.text);
    const ids = unit.ids.map((id)=>"@" + quote_as_necessary(id)).join("");
    const link_to_string = (link)=>{
        if (link.tag == "text") return word(link.text);
        else if (link.tag == "id") return "@" + quote_as_necessary(link.id);
        else if (link.tag == "unlinked") return "";
        else return link;
    };
    const links = unit.links.map((link)=>"~" + link_to_string(link)).join("");
    const labels = unit.labels.map((label)=>":" + quote_as_necessary(label)).join("");
    return text + ids + links + labels;
}
function $8f42eafc2f1b3c8d$export$a4a6ecdacd1cddbe(units, sep = " ") {
    return units.map($8f42eafc2f1b3c8d$var$unit_to_string).join(sep);
}
function $8f42eafc2f1b3c8d$export$4a1451e37fdf0cf8(g) {
    const em = $a0933ef57ff1c2b9$export$e08e3b67e392101e($566cb6e3cba7cd4f$export$13b0e7a577fb573c(g), (m)=>(id)=>m.get(id) || $a0933ef57ff1c2b9$export$66313c302b2ea154(`Token id ${id} not in edge map`));
    const first = $a0933ef57ff1c2b9$export$6be1a247e0437315();
    return $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(g, (tokens)=>tokens.map((token)=>{
            const e = em(token.id);
            const labels = first(e.id) ? e.labels : [];
            const links = $a0933ef57ff1c2b9$export$dce8637ca0d755f(()=>{
                if (!e.manual) return [];
                if (e.ids.length === 1) return [
                    $8f42eafc2f1b3c8d$var$unlinked
                ];
                // we sort because we want 's0' to be chosen instead of 't0'
                // in prefer_text_links because linked words always refer
                // to the source text
                return [
                    $8f42eafc2f1b3c8d$var$idLink(e.ids.sort()[0])
                ];
            });
            return $8f42eafc2f1b3c8d$var$Unit(token.text, [
                {
                    ids: [
                        token.id
                    ],
                    links: links,
                    labels: labels
                }
            ]);
        }));
}
function $8f42eafc2f1b3c8d$export$bd1f3e32ee61fba2(stu) {
    return $8f42eafc2f1b3c8d$var$remove_unused_ids($8f42eafc2f1b3c8d$var$prefer_text_links(stu));
}
function $8f42eafc2f1b3c8d$var$prefer_text_links(stu) {
    const count = $a0933ef57ff1c2b9$export$1b74141c5fe63a28(stu.source.map((u)=>u.text));
    const repl = {};
    stu.source.forEach((u)=>{
        if (count(u.text) == 1) u.ids.forEach((id)=>repl[id] = {
                tag: "text",
                text: u.text
            });
    });
    const replace_link = (link)=>{
        if (link.tag == "id" && repl[link.id]) return repl[link.id];
        else return link;
    };
    return $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(stu, (units)=>units.map((u)=>({
                ...u,
                links: u.links.map(replace_link)
            })));
}
function $8f42eafc2f1b3c8d$var$remove_unused_ids(stu) {
    const ids = [];
    $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(stu, (units)=>units.forEach((u)=>u.links.forEach((link)=>link.tag == "id" && ids.push(link.id))));
    const count = $a0933ef57ff1c2b9$export$1b74141c5fe63a28(ids);
    return $566cb6e3cba7cd4f$export$e1ba3adfdc99288f(stu, (units)=>units.map((u)=>({
                ...u,
                ids: u.ids.filter((id)=>count(id) > 0)
            })));
}
function $8f42eafc2f1b3c8d$export$93d135f93a177c5(g) {
    return $8f42eafc2f1b3c8d$export$bd1f3e32ee61fba2($8f42eafc2f1b3c8d$export$4a1451e37fdf0cf8(g));
}
function $8f42eafc2f1b3c8d$var$safe_compact_to_graph(s) {
    const [source_string, target_string] = s.split("//", 2);
    if (source_string && target_string) {
        const source = $8f42eafc2f1b3c8d$var$safe_parse(source_string);
        const target = $8f42eafc2f1b3c8d$var$safe_parse(target_string);
        if (source !== undefined && target !== undefined) return $8f42eafc2f1b3c8d$export$9cb5350a7a87beb(source, target);
    }
}
function $8f42eafc2f1b3c8d$export$18523638253a9637(g) {
    const stu = $8f42eafc2f1b3c8d$export$93d135f93a177c5(g);
    return $8f42eafc2f1b3c8d$export$a4a6ecdacd1cddbe(stu.source) + "//" + $8f42eafc2f1b3c8d$export$a4a6ecdacd1cddbe(stu.target);
}
function $8f42eafc2f1b3c8d$export$c4038c4546988c18(s) {
    return $8f42eafc2f1b3c8d$var$safe_compact_to_graph(s) || $a0933ef57ff1c2b9$export$66313c302b2ea154("not a valid compact representation " + $a0933ef57ff1c2b9$export$57bf213be019eeb0(s));
}


var $84505fa089775c7a$exports = {};

$parcel$export($84505fa089775c7a$exports, "navigate", function () { return $84505fa089775c7a$export$ff7962acd6052c28; });
$parcel$export($84505fa089775c7a$exports, "navigate_token_ids", function () { return $84505fa089775c7a$export$ceb1036482b0fe9; });





function $84505fa089775c7a$export$ff7962acd6052c28(g, selected_edges, dir, kind, order_changing_label) {
    const diff = $566cb6e3cba7cd4f$export$801569266451b712(g, order_changing_label);
    const interesting = new Set(diff.filter((d)=>$a0933ef57ff1c2b9$export$4154a199d7d90455(g.edges[d.id].labels.length > 0, g.edges[d.id].manual, d.edit != "Edited", $71ea9e6a68987862$export$44271b4f0c6a3563(d) != $71ea9e6a68987862$export$b4d5da5f34fb77ad(d))).map((d)=>d.id));
    const centers = $88cf8f066fd3d09d$export$2e2bcd8739ae039((i)=>dir == "next" ? i.center : -i.center, $d9d0435d2b879de6$export$df3f009e3d155b20($71ea9e6a68987862$export$297258f26f0c3976(diff), (center, id)=>({
            id: id,
            center: center
        })));
    for(let i = 0; i < centers.length; ++i){
        if (selected_edges.some((id)=>id == centers[i].id)) for(; i < centers.length; ++i){
            const next = centers[i + 1];
            if (!next) return;
            if (kind == "boring" || interesting.has(next.id)) return next.id;
        }
    }
}
function $84505fa089775c7a$export$ceb1036482b0fe9(g, selected_ids, dir, kind, order_changing_label) {
    const edge_ids = $566cb6e3cba7cd4f$export$d382192b07e5eedd(g, selected_ids);
    const new_edge_id = $84505fa089775c7a$export$ff7962acd6052c28(g, edge_ids, dir, kind, order_changing_label);
    return new_edge_id && g.edges[new_edge_id].ids;
}


$parcel$exportWildcard($b402d4a7f0e14377$exports, $566cb6e3cba7cd4f$exports);
$parcel$exportWildcard($b402d4a7f0e14377$exports, $71ea9e6a68987862$exports);
$parcel$exportWildcard($b402d4a7f0e14377$exports, $ad3f23047509641d$exports);
$parcel$exportWildcard($b402d4a7f0e14377$exports, $c625aec54bd34bcf$exports);
$parcel$exportWildcard($b402d4a7f0e14377$exports, $58ccaae15ba3b7ae$exports);
$parcel$exportWildcard($b402d4a7f0e14377$exports, $8f42eafc2f1b3c8d$exports);
$parcel$exportWildcard($b402d4a7f0e14377$exports, $84505fa089775c7a$exports);












var $bh6RR = parcelRequire("bh6RR");
var $1e43c716286664f5$exports = {};
"use strict";

$1e43c716286664f5$exports = (parcelRequire("XIR2z"));


const $c63a26974c87e863$var$remarkable = new $1e43c716286664f5$exports({
    linkify: true,
    typographer: true,
    html: true
});
function $c63a26974c87e863$export$f4de1c043ce6927(snippets, ...vnodes) {
    const init_spaces = (snippets[0].match(/^[^\n\S]*(?=\S)/m) || [
        ""
    ])[0];
    const drop = (s)=>s.split(/\n/).map((line)=>line.slice(init_spaces.length)).join("\n");
    const render = (s)=>({
            __html: $c63a26974c87e863$var$remarkable.render(drop(s))
        });
    const out = [];
    for(let i = 0; i < vnodes.length; i++){
        out.push(/*#__PURE__*/ $bh6RR.createElement("div", {
            key: "snip" + i,
            dangerouslySetInnerHTML: render(snippets[i])
        }));
        out.push(vnodes[i]);
    }
    if (snippets.length > vnodes.length) out.push(/*#__PURE__*/ $bh6RR.createElement("div", {
        key: "last",
        dangerouslySetInnerHTML: render(snippets[vnodes.length])
    }));
    return /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "md"
    }, out);
}


const $5459fbbcf1f7402d$export$d5db38ffe1f43b01 = {};
const $5459fbbcf1f7402d$export$e3a471c1563f3053 = [];
function $5459fbbcf1f7402d$var$page(slug, text, target, graph = $566cb6e3cba7cd4f$export$8170fdccd13fc536($566cb6e3cba7cd4f$export$1aa3e3e981886a9b(target)), mode = "normalization") {
    $5459fbbcf1f7402d$export$e3a471c1563f3053.push(slug);
    $5459fbbcf1f7402d$export$d5db38ffe1f43b01[slug] = {
        slug: slug,
        text: text,
        graph: graph,
        target: target,
        mode: mode
    };
}
$5459fbbcf1f7402d$var$page("manual", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Manual

This is an interactive manual.

It consists of a series of examples of fabricated learner texts that illustrate how to use the editor.

There are two windows for text: source text and target hypothesis text.
Showing the source text is toggled by clicking _show source text_.
The text areas can be resized. Try resizing the target hypothesis window so that you can see what is below it.

In the target hypothesis window below you can see the learner text _a example_.
Edit the target hypothesis text below to make it _an example_.

The word pairs _a_ and _an_ will automatically be aligned in the graph under
the target hypothesis window because the words are similar.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18("a example//an example"));
$5459fbbcf1f7402d$var$page("labelling", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Labelling

Under the target hypothesis window you see the linked structure from the learner text (on the top layer) to the
hypothesis text (on the bottom layer). Click on the first link to select it.

When you have a selection you can put labels on it using the menu that appears to the left.
You can either write in the label name into the text area or click on the name of the label.
Pick an appropriate label for this error (_O_).
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18("a example//an:O example"));
$5459fbbcf1f7402d$var$page("selections", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Selections and browsing between links

When you have a selection you can select the next group with the next and prev buttons.
There are also shortcuts to these which you find by hovering them.
You can also go directly to the next group which has any modifications (skipping pairs
that are the same) by clicking _prev mod_ and _next mod_.

Clicking a word will select it; clicking the link will select the words in that group.
In order to select multiple words, hold Ctrl or ⌘ while clicking.
Deselect by clicking outside the graph.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`Their was a problem yesteray .//There:O was a problem yesterday:O .`), $8f42eafc2f1b3c8d$export$c4038c4546988c18(`Their was a problem yesteray .//There was a problem yesterday .`));
$5459fbbcf1f7402d$var$page("compounds", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Compound errors

We will now look at a little bit more complicated link structures.

Compound errors (over-compounding and over-splitting) introduce links that are 2-1 and 1-2
(from two source words to one target word, and vice versa.)

Correct the sentence below by changing _high light_ to _highlight_ and _compounderrors_ to _compound errors_ and you will see that you get 2-1 and 1-2 links.

Mark a group to label it. When you put a label on these all three linked words (for example: _highlight_, _high_ and _light_) share the label.
Put labels on both linked groups (_O-COMP_).
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`
This example high lights compounderrors .//
This example highlights:O-COMP compound errors:O-COMP .
`));
$5459fbbcf1f7402d$var$page("group", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Making manual link groups

The automatic linking will not work when the words are too dissimilar.

When this happens, click the words you want to group and press group
in the label sidebar. There is also a keyboard shortcut and you see the shortcut
by hovering over the button.

Connect the words _well_ and _good_ below. They are not automatically linked since they have no common letters. The link will become blue to highlight that it is a manual link.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`I see good .//I see well~good .`), $8f42eafc2f1b3c8d$export$c4038c4546988c18(`I see good .//I see well .`));
$5459fbbcf1f7402d$var$page("orphan", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Orphan: disconnecting words

Here a linked group has too many members.
We want to put _with_ and _many_ in groups of their own.
Here we cannot select both of them and press _group_ since then they will
be linked to themselves (try it and use then use undo).

Instead select both and press the _orphan_ button to make each word orphaned: only connected to itself.

(Another alternative is to select the words one by one and press _group_: indeed, with only one word selected _group_ and _orphan_ do the same thing.)
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`A sentence wery missing words .// A sentence with~ very many~ missing words .`), $8f42eafc2f1b3c8d$export$c4038c4546988c18(`A sentence wery missing words .// A sentence with very many missing words .`));
$5459fbbcf1f7402d$var$page("unlinking", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Removing links

In the example below the automatic aligner has aligned _his_ and _where_ (because they share the _h_)
but we want _his_ and _he_ to be aligned.

This can be resolved in three ways (use "undo" after each try):

1.  Select _his_ and _he_ and use _group_.
2.  Select _where_ and use _orphan_.
3.  Select _where_ and use _group_.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`I don't know his lives .//I don't know where he~his lives .`), $8f42eafc2f1b3c8d$export$c4038c4546988c18(`I don't know his lives .//I don't know where he lives .`));
$5459fbbcf1f7402d$var$page("auto", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Removing manual links

In case you get too many manual links you can remove them with the button _auto_
which makes them fall back to the automatic linker. Do so and then make sure _well_ and _good_
are aligned.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`I see good .//I see well~good .`), $8f42eafc2f1b3c8d$export$c4038c4546988c18(`I@1 see~@1 good~@1 .~@1//I~@1 see~@1 well~@1 .~@1`));
$5459fbbcf1f7402d$var$page("revert", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Revert

There is normal undo functionality on Ctrl-Z and redo on Ctrl-Y which works with linear history.
(Keep the cursor in the text area in order to use these keyboard shortcuts.)

Sometimes it is more useful to revert at a specific selection in the graph.
In the example below some changes have been made to the text but we would like to revert them.
Select a changed word and use _revert_. Do this for all changed words.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`A sentence with many words . // A sentence with many words . `), $8f42eafc2f1b3c8d$export$c4038c4546988c18(`A sentence with many words . // Sentences with many missing words .`));
$5459fbbcf1f7402d$var$page("movement", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Word movement

Word movement can be tracked by changing the text and then selecting the words and grouping them.
You can do this by erasing the word and then rewriting it or by using standard copy and paste functionality.

A quicker way is to have the cursor on the word and use Alt-&larr; and Alt-&rarr; (⌘-&larr; and ⌘-&rarr; on Mac) for transposing the word backward and forward, respectively.
If the cursor is on many words (select many words in the editor by using the mouse or shift and arrow keys) they will be moved in unison.

Try these different approaches to move _was_ and _his son_ into their correct places.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`
    The room very dirty was . He got to clean his son . //
    The room was~was very dirty . He got his~his son~son to clean .
  `));
$5459fbbcf1f7402d$var$page("anonymization", (0, $c63a26974c87e863$export$f4de1c043ce6927)`
# Anonymization mode

In anonymization mode there is no target text to edit.
Data about the entities are put directly onto the edge groups.

Add labels as appropriate on the named entities in the example.
For each labeling, a pseudonym is generated for the target token.
To keep pseudonymization consistent, each distinct entity needs a unique number.
The label editor allows adding numbers besides the predefined categories of labels.
Give Alice number 1, Bob number 2 and Paris number 3.
Use morphology labels to denote features like genitive.

In the demo mode you can toggle between the anonymization view and normalization
view with _switch to anonymization/normalization_.

The buttons _show/hide source/target in graph_ which are accessible under _show options_
can be helpful when doing the anonymization, as they make the view more compact.
Hiding the source side can work as assistance to verify that the text
actually reads as anonymized.
  `, $8f42eafc2f1b3c8d$export$c4038c4546988c18(`
Alice and Bob went to Paris . Alice's wallet was stolen . //
Alice:'firstname_female':1 and Bob:'firstname_male':2 went to Paris:city:3 . Alice's:'firstname_female':1:gen wallet was stolen .
`), undefined, "anonymization");
/* Uncomment in https://github.com/spraakbanken/swell-editor/issues/92
page(
  'image_links',
  md`
# Image linking

To facilitate communication and documentation it is possible to link to a
view of the editor. This gives a link that is usable as the mark up format _markdown_,
which can be used in many issue tracking system's such as github's.

To view the link for the current sentence go to _show options_ and then _show image link_.
This will give you a link at the bottom of the page which can be dragged into a
text area which supports markdown.

To get the image back you drag and drop it into the editor using the mouse.
There is an example image here already which to try on:

![](https://ws.spraakbanken.gu.se/ws/swell/png?Drag_and_drop_me//Drag_and_drop_me)

The actual markdown containing the link to the image looks like this:

    ![](https://ws.spraakbanken.gu.se/ws/swell/png?Drag_and_drop_me//Drag_and_drop_me)
  `,
  G.init('Drag and drop me'),
  G.init('The graph'),
  undefined
)
*/ $5459fbbcf1f7402d$export$e3a471c1563f3053.push("print");



const $144d13b54a739243$var$image_ws_url = "https://ws.spraakbanken.gu.se/ws/swell";
const $144d13b54a739243$var$pseuws_url = "https://ws.spraakbanken.gu.se/ws/larka/pseuws";
const $144d13b54a739243$var$ex = (source, target)=>({
        source: source,
        target: target
    });
const $144d13b54a739243$var$examples = `
Alice and Bob went to Paris . Alice's wallet was stolen . // Alice:1:'firstname_female' and Bob:2:'firstname_male' went to Paris:3:city . Alice's:1:'firstname_female':gen wallet was stolen .

Their was a problem yesteray . // There was a problem yesterday .

I don't know his lives . // I don't know where he~his lives .

He get to cleaned his son . // He got his~his son~son to:O clean:O the~ room~ .

We wrote down the number . // We wrote the number down~down .
`.trim().split(/\n\n+/gm).map((line)=>$144d13b54a739243$var$ex.apply({}, line.split("//").map((side)=>side.trim())));
const $144d13b54a739243$var$order_changing_labels = {
    "S-adv": true,
    "S-finV": true,
    "S-WO": true,
    WO: true,
    INV: true,
    OINV: true
};
const $144d13b54a739243$export$ebb418edcdf3dd37 = {
};
const $144d13b54a739243$var$extra = "gen def pl foreign".split(" ");
const $144d13b54a739243$var$temporary = "OBS! Cit-FL Com!".split(" ");
const $144d13b54a739243$var$digits = /^\d+$/;
var $144d13b54a739243$export$4889b9a43e973648;
(function(LabelOrder) {
    LabelOrder[LabelOrder["BASE"] = 0] = "BASE";
    LabelOrder[LabelOrder["NUM"] = 1] = "NUM";
    LabelOrder[LabelOrder["EXTRA"] = 2] = "EXTRA";
    LabelOrder[LabelOrder["TEMP"] = 3] = "TEMP";
})($144d13b54a739243$export$4889b9a43e973648 || ($144d13b54a739243$export$4889b9a43e973648 = {}));
function $144d13b54a739243$export$64979d6b7e67c3aa(label) {
    if ($144d13b54a739243$var$temporary.includes(label)) return $144d13b54a739243$export$4889b9a43e973648.TEMP;
    else if ($144d13b54a739243$var$extra.includes(label)) return $144d13b54a739243$export$4889b9a43e973648.EXTRA;
    else if ($144d13b54a739243$var$digits.test(label)) return $144d13b54a739243$export$4889b9a43e973648.NUM;
    else return $144d13b54a739243$export$4889b9a43e973648.BASE;
}
const $144d13b54a739243$export$f4c10db555342dd9 = (0, $a0933ef57ff1c2b9$export$ac82cbe7dc0182d2)((0, $a0933ef57ff1c2b9$export$10a14be77be1fbf8)($144d13b54a739243$export$571398232cbac325), (0, $a0933ef57ff1c2b9$export$10a14be77be1fbf8)($144d13b54a739243$export$64979d6b7e67c3aa), (0, $a0933ef57ff1c2b9$export$479e93f6971754e6));
const $144d13b54a739243$var$anonymization = [
    {
        group: "Morphology",
        entries: [
            {
                label: "gen",
                desc: "genitive"
            },
            {
                label: "def",
                desc: "definite"
            },
            {
                label: "pl",
                desc: "plural"
            }
        ]
    },
    {
        group: "Names",
        entries: [
            {
                label: "firstname_male",
                desc: ""
            },
            {
                label: "firstname_female",
                desc: ""
            },
            {
                label: "firstname_unknown",
                desc: ""
            },
            {
                label: "initials",
                desc: ""
            },
            {
                label: "middlename",
                desc: ""
            },
            {
                label: "surname",
                desc: ""
            },
            {
                label: "nickname",
                desc: ""
            },
            {
                label: "pet_name",
                desc: "names of pet animals"
            }
        ]
    },
    {
        group: "Geographic data",
        entries: [
            {
                label: "foreign",
                desc: ""
            },
            {
                label: "area",
                desc: ""
            },
            {
                label: "city",
                desc: "city including villages"
            },
            {
                label: "country",
                desc: ""
            },
            {
                label: "geo",
                desc: "forest, lake, mountain, etc"
            },
            {
                label: "place",
                desc: ""
            },
            {
                label: "region",
                desc: ""
            },
            {
                label: "street_nr",
                desc: "street number"
            },
            {
                label: "zip_code",
                desc: ""
            }
        ]
    },
    {
        group: "Institutions",
        entries: [
            {
                label: "school",
                desc: ""
            },
            {
                label: "work",
                desc: ""
            },
            {
                label: "public_authority",
                desc: "Skatteverket, Socialt\xe4nsten, etc."
            },
            {
                label: "other_institution",
                desc: ""
            }
        ]
    },
    {
        group: "Transportation",
        entries: [
            {
                label: "transport_name",
                desc: "bus, metro, tram, train, express"
            },
            {
                label: "transport_nr",
                desc: "number, color"
            }
        ]
    },
    {
        group: "Age",
        entries: [
            {
                label: "age_digits",
                desc: ""
            },
            {
                label: "age_string",
                desc: ""
            }
        ]
    },
    {
        group: "Dates",
        entries: [
            {
                label: "date_digits",
                desc: "numerical date represenation, delimiters are retained"
            },
            {
                label: "day",
                desc: ""
            },
            {
                label: "month_digit",
                desc: ""
            },
            {
                label: "month_word",
                desc: ""
            },
            {
                label: "year",
                desc: ""
            },
            {
                label: "timepoint",
                desc: "yesterday, tomorrow, Wednesday"
            },
            {
                label: "time_span",
                desc: "two weeks, five months"
            }
        ]
    },
    {
        group: "Misc",
        entries: [
            {
                label: "account_nr",
                desc: ""
            },
            {
                label: "email",
                desc: ""
            },
            {
                label: "extra",
                desc: ""
            },
            {
                label: "license_nr",
                desc: ""
            },
            {
                label: "other_nr_seq",
                desc: "a sequence of numbers"
            },
            {
                label: "phone_nr",
                desc: ""
            },
            {
                label: "personid_nr",
                desc: ""
            },
            {
                label: "url",
                desc: ""
            },
            {
                label: "username",
                desc: "usernames and @names from online contexts"
            },
            {
                label: "pet_type",
                desc: "pet breed or species, for names use name_xyz"
            },
            {
                label: "language",
                desc: "(foreign) language spoken"
            },
            {
                label: "ethnicity",
                desc: ""
            },
            {
                label: "currency",
                desc: ""
            },
            {
                label: "hobby",
                desc: "routine and relatively unique activity"
            },
            {
                label: "crime",
                desc: "a crime perpetrated by or against the person in question"
            },
            {
                label: "health_condition",
                desc: "an illness, injury, or any other condition influencing health"
            }
        ]
    },
    {
        group: "Mark",
        entries: [
            {
                label: "edu",
                desc: "education, courses"
            },
            {
                label: "fam",
                desc: "family members"
            },
            {
                label: "prof",
                desc: "profession"
            },
            {
                label: "faith",
                desc: "description or expression of religious beliefs"
            },
            {
                label: "political",
                desc: "description or expression of political convictions"
            },
            {
                label: "gender",
                desc: "description or expression of gender"
            },
            {
                label: "sexuality",
                desc: "description or expression of sexuality"
            },
            {
                label: "sensitive",
                desc: "other sensitive spans"
            }
        ]
    },
    {
        group: "Other",
        entries: [
            {
                label: "Cit-FL",
                desc: "Citation for a language"
            },
            {
                label: "Com!",
                desc: "Comment"
            },
            {
                label: "OBS!",
                desc: "Attention"
            }
        ]
    }
];
const $144d13b54a739243$export$ff83e808a709eda7 = [
    {
        group: "Other",
        entries: [
            {
                label: "Cit-FL",
                desc: "Citation for a language"
            },
            {
                label: "Com!",
                desc: "Comment"
            },
            {
                label: "OBS!",
                desc: "Attention"
            },
            {
                label: "X",
                desc: "Impossible to interpret the writer’s intention"
            }
        ]
    }
];
const $144d13b54a739243$export$d9f1636a87b25055 = [
    {
        group: "Orthographic",
        entries: [
            {
                label: "O",
                desc: "Spelling"
            },
            {
                label: "O-Cap",
                desc: "Upper/lower case"
            },
            {
                label: "O-Comp",
                desc: "Spaces and hyphens between words"
            }
        ]
    },
    {
        group: "Lexical",
        entries: [
            {
                label: "L-Der",
                desc: "Word formation (derivation and compounding)"
            },
            {
                label: "L-FL",
                desc: "Non-Swedish word corrected to Swedish word"
            },
            {
                label: "L-Ref",
                desc: "Choice of anaphoric expression"
            },
            {
                label: "L-W",
                desc: "Wrong word or phrase, other"
            }
        ]
    },
    {
        group: "Morphological",
        entries: [
            {
                label: "M-Adj/adv",
                desc: "Adjective form of word corrected to adverb form"
            },
            {
                label: "M-Case",
                desc: "Nominative vs genitive/accusative"
            },
            {
                label: "M-Def",
                desc: "Definiteness: articles; forms of nouns and adjectives"
            },
            {
                label: "M-F",
                desc: "Grammatical category kept, form changed"
            },
            {
                label: "M-Gend",
                desc: "Gender"
            },
            {
                label: "M-Num",
                desc: "Number"
            },
            {
                label: "M-Other",
                desc: "Other morphological corrections, including change between different comparational forms of adjectives"
            },
            {
                label: "M-Verb",
                desc: "Verb forms; use of ha, komma and skola auxiliaries"
            }
        ]
    },
    {
        group: "Punctuation",
        entries: [
            {
                label: "P-M",
                desc: "Punctuation missing (added)"
            },
            {
                label: "P-R",
                desc: "Punctuation redundant (removed)"
            },
            {
                label: "P-Sent",
                desc: "Sentence segmentation"
            },
            {
                label: "P-W",
                desc: "Wrong punctuation"
            }
        ]
    },
    {
        group: "Syntactical",
        entries: [
            {
                label: "S-Adv",
                desc: "Adverbial placement"
            },
            {
                label: "S-Comp",
                desc: "Compound vs multi-word expression, and other restructuring of the same lexical morphemes within a phrase"
            },
            {
                label: "S-Clause",
                desc: "Change of basic clause structure: syntactic function of components, hierarchical clause structure"
            },
            {
                label: "S-Ext",
                desc: "Extensive and complex correction"
            },
            {
                label: "S-FinV",
                desc: "Finite verb placement"
            },
            {
                label: "S-M",
                desc: "Word missing (added)"
            },
            {
                label: "S-Msubj",
                desc: "Subject missing (added)"
            },
            {
                label: "S-Other",
                desc: "Other syntactical correction"
            },
            {
                label: "S-R",
                desc: "Word redundant (removed)"
            },
            {
                label: "S-Type",
                desc: "Change of phrase type/part of speech"
            },
            {
                label: "S-WO",
                desc: "Word order, other"
            }
        ]
    },
    {
        group: "Other",
        entries: [
            {
                label: "C",
                desc: "Consistency correction, necessitated by other correction"
            },
            {
                label: "Cit-FL",
                desc: "Non-Swedish word kept, i.e. not corrected"
            },
            {
                label: "Com!",
                desc: "Comments for the corpus user"
            },
            {
                label: "OBS!",
                desc: "Internal and temporary comments for the annotators"
            },
            {
                label: "Unid",
                desc: "Unidentified correction"
            },
            {
                label: "X",
                desc: "Unintelligible string"
            }
        ]
    }
];
function $144d13b54a739243$var$doc_url(title) {
    return "https://spraakbanken.github.io/swell-project/" + title;
}
const $144d13b54a739243$var$docs = {
    anonymization: {
        "pseudonymization guidelines": $144d13b54a739243$var$doc_url("Pseudonymization_guidelines")
    },
    normalization: {
        "normalization guidelines": $144d13b54a739243$var$doc_url("Normalization_guidelines")
    },
    correctannot: {
        "annotation guidelines": $144d13b54a739243$var$doc_url("Correction-annotation_guidelines")
    }
};
const $144d13b54a739243$export$e506a1d27d1eaa20 = {
    order_changing_labels: $144d13b54a739243$var$order_changing_labels,
    examples: $144d13b54a739243$var$examples,
    image_ws_url: $144d13b54a739243$var$image_ws_url,
    pseuws_url: $144d13b54a739243$var$pseuws_url,
    taxonomy: {
        anonymization: $144d13b54a739243$var$anonymization,
        normalization: $144d13b54a739243$export$ff83e808a709eda7,
        correctannot: $144d13b54a739243$export$d9f1636a87b25055
    },
    docs: $144d13b54a739243$var$docs
};
function $144d13b54a739243$export$d5d3568b3c7f09f0(label) {
    return $144d13b54a739243$export$e506a1d27d1eaa20.taxonomy.anonymization.find((group)=>!!group.entries.find((entry)=>entry.label == label));
}
function $144d13b54a739243$export$d50b53d04a3696a4(label) {
    const order = $144d13b54a739243$export$64979d6b7e67c3aa(label);
    if (order === $144d13b54a739243$export$4889b9a43e973648.NUM) return {
        taxonomy: "anonymization",
        group: "Number",
        entry: {
            label: label,
            desc: "number"
        }
    };
    if (order === $144d13b54a739243$export$4889b9a43e973648.TEMP) return undefined;
    for(let taxonomy in $144d13b54a739243$export$e506a1d27d1eaa20.taxonomy)for (let group of $144d13b54a739243$export$e506a1d27d1eaa20.taxonomy[taxonomy]){
        let entry = group.entries.find((entry)=>entry.label == label);
        if (entry !== undefined) return {
            taxonomy: taxonomy,
            group: group.group,
            entry: entry
        };
    }
}
function $144d13b54a739243$export$571398232cbac325(label) {
    return $144d13b54a739243$export$d50b53d04a3696a4(label) ? $144d13b54a739243$export$d50b53d04a3696a4(label).taxonomy : null;
}
function $144d13b54a739243$export$b9193eea530b254f(taxonomy, label) {
    if (!(taxonomy in $144d13b54a739243$export$e506a1d27d1eaa20.taxonomy)) return false;
    const tax = $144d13b54a739243$export$e506a1d27d1eaa20.taxonomy;
    return !!tax[taxonomy].find((g)=>!!g.entries.find((l)=>l.label == label));
}




function $a3df2e600d37ee5f$export$f1ff2a90c38ff669(name, check) {
    return {
        name: name,
        check: check
    };
}
var $a3df2e600d37ee5f$export$918a9776c0a3cf27;
(function(Severity) {
    Severity["WARNING"] = "warning";
    Severity["ERROR"] = "error";
})($a3df2e600d37ee5f$export$918a9776c0a3cf27 || ($a3df2e600d37ee5f$export$918a9776c0a3cf27 = {}));
function $a3df2e600d37ee5f$export$e1276971c8e90b02(cond, check, severity = $a3df2e600d37ee5f$export$918a9776c0a3cf27.ERROR) {
    return ({ state: state, graph: graph })=>{
        // Exit early if generic condition fails.
        if (!cond(state)) return [];
        // Emit an error for each edge where the edge condition fails.
        const emits = [];
        const partition_ids = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(graph);
        $d9d0435d2b879de6$export$871de8747c9eaa88(graph.edges, (edge)=>{
            const { source: source, target: target } = partition_ids(edge.ids);
            if (edge && check(edge, source, target)) emits.push({
                subject: edge.id,
                severity: severity
            });
        });
        return emits;
    };
}






var $ed27b30e72f83249$exports = {};
"use strict";
Object.defineProperty($ed27b30e72f83249$exports, "__esModule", {
    value: true
});
var $07cfce07512b2c7a$exports = {};
"use strict";
Object.defineProperty($07cfce07512b2c7a$exports, "__esModule", {
    value: true
});
$07cfce07512b2c7a$exports.maleName = [
    "David",
    "Peter",
    "Erik",
    "Johan",
    "Anders"
];
$07cfce07512b2c7a$exports.femaleName = [
    "Emma",
    "Anna",
    "Sara",
    "Maria",
    "Karin"
];
$07cfce07512b2c7a$exports.unknownName = [
    "Kim",
    "Alex",
    "Charlie"
];
$07cfce07512b2c7a$exports.surname = [
    "Olsson",
    "Svensson",
    "Johansson"
];
$07cfce07512b2c7a$exports.school = [
    "A-skola",
    "B-skola",
    "C-skola",
    "D-skola"
];
$07cfce07512b2c7a$exports.workplace = [
    "A-arbetsplats",
    "B-arbetsplats",
    "C-arbetsplats",
    "D-arbetsplats"
];
$07cfce07512b2c7a$exports.otherInstitution = [
    "A-institution",
    "B-institution",
    "C-institution",
    "D-institution"
];
$07cfce07512b2c7a$exports.countryOfOrigin = [
    "A-hemland",
    "B-hemland",
    "C-hemland",
    "D-hemland"
];
$07cfce07512b2c7a$exports.country = [
    "A-land",
    "B-land",
    "C-land",
    "D-land"
];
$07cfce07512b2c7a$exports.city = [
    "Tuna",
    "Sund",
    "V\xe4stan\xe5",
    "Bj\xf6rk\xe5s",
    "Lundby",
    "Petersborg",
    "Sj\xf6vik",
    "L\xf6vsta",
    "Segerstad",
    "Norrby",
    "Haga"
];
$07cfce07512b2c7a$exports.place = [
    "Ringv\xe4gen",
    "Skolgatan",
    "Bj\xf6rkv\xe4gen",
    "Skogsv\xe4gen",
    "Strandv\xe4gen",
    "Storgatan",
    "Parkv\xe4gen",
    "Nygatan",
    "Kyrkv\xe4gen",
    "Industrigatan",
    "Kvarnv\xe4gen",
    "Genv\xe4gen",
    "Drottninggatan"
];
$07cfce07512b2c7a$exports.region = [
    "Norrland",
    "Mellansverige",
    "Sydsverige",
    "V\xe4stsverige"
];
$07cfce07512b2c7a$exports.area = [
    "A-omr\xe5de",
    "B-omr\xe5de",
    "C-omr\xe5de",
    "D-omr\xe5de"
];
$07cfce07512b2c7a$exports.cityForeign = [
    "A-stad",
    "B-stad",
    "C-stad",
    "D-stad"
];
$07cfce07512b2c7a$exports.placeForeign = [
    "A-plats",
    "B-plats",
    "C-plats",
    "D-plats"
];
$07cfce07512b2c7a$exports.regionForeign = [
    "A-region",
    "B-region",
    "C-region",
    "D-region"
];
$07cfce07512b2c7a$exports.areaForeign = [
    "A-omr\xe5de",
    "B-omr\xe5de",
    "C-omr\xe5de",
    "D-omr\xe5de"
];
$07cfce07512b2c7a$exports.geographicLocation = [
    "A-geoplats",
    "B-geoplats",
    "C-geoplats",
    "D-geoplats"
];
$07cfce07512b2c7a$exports.transport = [
    "A-linjen",
    "B-linjen",
    "C-linjen",
    "D-linjen"
];


var $432726bda85399c1$exports = {};
"use strict";
Object.defineProperty($432726bda85399c1$exports, "__esModule", {
    value: true
});
function $432726bda85399c1$var$getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}
$432726bda85399c1$exports.getRandomInt = $432726bda85399c1$var$getRandomInt;
function $432726bda85399c1$var$getRandomBool() {
    return Math.random() > 0.5;
}
$432726bda85399c1$exports.getRandomBool = $432726bda85399c1$var$getRandomBool;
function $432726bda85399c1$var$getRandomBetween(from, to) {
    return from + $432726bda85399c1$var$getRandomInt(from - to);
}
$432726bda85399c1$exports.getRandomBetween = $432726bda85399c1$var$getRandomBetween;


/** A store of pseudonyms, indexed by type and variable index. */ $ed27b30e72f83249$exports.variableMapping = {};
$ed27b30e72f83249$exports.usedForType = {};
function $ed27b30e72f83249$var$pseudonymize(s, labels) {
    let [type, extra_labels] = [
        labels[0],
        labels.slice(1)
    ];
    const variableIdx = $ed27b30e72f83249$var$getVariableIdx(extra_labels);
    const fun = $ed27b30e72f83249$exports.anonymization[labels[0]];
    // By default, return the input.
    let p = s;
    // First try the store.
    if (variableIdx !== undefined && $ed27b30e72f83249$var$storeHas(type, variableIdx)) p = $ed27b30e72f83249$var$storeGet(type, variableIdx);
    else if (fun) p = fun(type, extra_labels, s);
    // Save to store before returning.
    if (variableIdx !== undefined) $ed27b30e72f83249$var$storeSet(type, variableIdx, p);
    return p + $ed27b30e72f83249$var$affix(labels);
}
$ed27b30e72f83249$exports.pseudonymize = $ed27b30e72f83249$var$pseudonymize;
/** Get the first numeric label. */ function $ed27b30e72f83249$var$getVariableIdx(labels) {
    return labels.map((l)=>parseInt(l)).filter((n)=>!isNaN(n)).shift();
}
/** Check the presence of a stored pseudonym. */ function $ed27b30e72f83249$var$storeHas(type, variableIdx) {
    return $ed27b30e72f83249$exports.variableMapping[type] && $ed27b30e72f83249$exports.variableMapping[type][variableIdx] !== undefined;
}
/** Get a stored pseudonym. */ function $ed27b30e72f83249$var$storeGet(type, variableIdx) {
    return $ed27b30e72f83249$exports.variableMapping[type][variableIdx];
}
/** Save a pseudonym to the store. */ function $ed27b30e72f83249$var$storeSet(type, variableIdx, p) {
    if (!$ed27b30e72f83249$exports.variableMapping[type]) $ed27b30e72f83249$exports.variableMapping[type] = [];
    $ed27b30e72f83249$exports.variableMapping[type][variableIdx] = p;
}
/** Get affix string like "-gen-ort" */ function $ed27b30e72f83249$var$affix(labels) {
    return labels.filter((l)=>$ed27b30e72f83249$var$affixLabels.includes(l)).map((l)=>"-" + l).join("");
}
function $ed27b30e72f83249$var$pseudonymizeAge(type, labels, s) {
    const ageInt = parseInt(s);
    if (isNaN(ageInt)) return "" + $432726bda85399c1$exports.getRandomInt(70);
    else {
        const offset = $432726bda85399c1$exports.getRandomInt(5) - 2;
        return "" + (ageInt + offset);
    }
}
/** The age is given as a numerical label, e.g. "eighteen" should be labeled "age_string 18". */ function $ed27b30e72f83249$var$pseudonymizeAgeString(type, labels, s) {
    const age = labels.find((v)=>!isNaN(Number(v)));
    return $ed27b30e72f83249$var$pseudonymizeAge(type, labels, age || "");
}
function $ed27b30e72f83249$var$pseudonymizeFromList(a) {
    return function(type, labels, s) {
        if (!$ed27b30e72f83249$exports.usedForType[type]) $ed27b30e72f83249$exports.usedForType[type] = [];
        const arrayIdx = $ed27b30e72f83249$var$getRandomArrayIdx(a, $ed27b30e72f83249$exports.usedForType[type]);
        if ($ed27b30e72f83249$exports.usedForType[type].indexOf(arrayIdx) == -1) $ed27b30e72f83249$exports.usedForType[type].push(arrayIdx);
        return a[arrayIdx];
    };
}
function $ed27b30e72f83249$var$randomInt() {
    return "" + ($432726bda85399c1$exports.getRandomInt(50) + 1);
}
function $ed27b30e72f83249$var$zipCode(type, labels, s) {
    let letters = "ABCDEFGHIJKLMNOPQRZTUVZXY";
    s = $ed27b30e72f83249$var$replaceNumbersWithZero(s);
    const letterExp = new RegExp("[0-9]", "g");
    let newString = "";
    for(let i = 0; i < s.length; i++)if ($ed27b30e72f83249$var$isLetter(s[i])) {
        newString += letters[0];
        letters = letters.slice(1);
    } else newString += s[i];
    return newString;
}
function $ed27b30e72f83249$var$isLetter(char) {
    return char.toUpperCase() != char.toLowerCase();
}
function $ed27b30e72f83249$var$phoneNumber(type, labels, s) {
    return $ed27b30e72f83249$var$replaceNumbersWithZero(s);
}
function $ed27b30e72f83249$var$replaceNumbersWithZero(s) {
    return s.replace(new RegExp("[0-9]", "g"), "0");
}
function $ed27b30e72f83249$var$email() {
    return "email@dot.com";
}
function $ed27b30e72f83249$var$institution(type, labels, s) {
    const instType = labels[0];
    if (instType === "school") return $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.school)(type, labels, s);
    else if (instType === "work") return $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.workplace)(type, labels, s);
    else return $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.otherInstitution)(type, labels, s);
}
function $ed27b30e72f83249$var$getRandomArrayIdx(a, used = []) {
    if (used.length == a.length) // every element in a has already been used, take a random one
    return $432726bda85399c1$exports.getRandomInt(a.length);
    let idx = 0;
    do idx = $432726bda85399c1$exports.getRandomInt(a.length);
    while (used.indexOf(idx) != -1);
    return idx;
}
function $ed27b30e72f83249$var$isUpperCase(str) {
    return /^[A-Z]*$/.test(str);
}
function $ed27b30e72f83249$var$pseudonymizeWrittenMonth(type, labels, s) {
    const idx = $432726bda85399c1$exports.getRandomInt(12);
    const months = [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ];
    let result = months[idx];
    /* if (isUpperCase(s[0])) {
      result = result[0].toUpperCase() + result.slice(1)
    } */ return result;
}
function $ed27b30e72f83249$var$pseudonymizeYear(type, labels, s) {
    const yearInt = parseInt(s);
    if (isNaN(yearInt)) return "" + $432726bda85399c1$exports.getRandomBetween(1970, 2018);
    else {
        const offset = $432726bda85399c1$exports.getRandomInt(5) - 2;
        return "" + Math.max(1, yearInt + offset);
    }
}
function $ed27b30e72f83249$var$pseudonymizeDate(type, labels, s) {
    return s.replace(new RegExp("[0-9]", "g"), "1");
}
function $ed27b30e72f83249$var$pseudonymizeTransport(type, labels, s) {
    let result = $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.transport)(type, labels, s);
    if ($ed27b30e72f83249$var$isUpperCase(s[0])) result = s[0].toUpperCase() + result.slice(1);
    return result;
}
/** Modifiers labels, not associated with pseudonym categories. */ const $ed27b30e72f83249$var$affixLabels = [
    "gen",
    "def",
    "pl",
    "ort"
];
$ed27b30e72f83249$exports.anonymization = {
    "firstname_male": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.maleName),
    "firstname_female": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.femaleName),
    "firstname_unknown": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.unknownName),
    "surname": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.surname),
    "middlename": ()=>"A",
    "initials": ()=>"A",
    "institution": $ed27b30e72f83249$var$institution,
    "school": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.school),
    "work": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.workplace),
    "other_institution": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.otherInstitution),
    "country_of_origin": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.countryOfOrigin),
    "country": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.country),
    "zip_code": $ed27b30e72f83249$var$zipCode,
    "region": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.region),
    "city": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.city),
    "city_foreign": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.cityForeign),
    "area_foreign": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.areaForeign),
    "place_foreign": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.placeForeign),
    "region_foreign": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.regionForeign),
    "area": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.area),
    "place": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.place),
    "geo": $ed27b30e72f83249$var$pseudonymizeFromList($07cfce07512b2c7a$exports.geographicLocation),
    "street_nr": $ed27b30e72f83249$var$randomInt,
    "transport_name": $ed27b30e72f83249$var$pseudonymizeTransport,
    "transport_nr": ()=>"1",
    "age_digits": $ed27b30e72f83249$var$pseudonymizeAge,
    "age_string": $ed27b30e72f83249$var$pseudonymizeAgeString,
    "day": ()=>"" + ($432726bda85399c1$exports.getRandomInt(28) + 1),
    "month_digit": ()=>"" + ($432726bda85399c1$exports.getRandomInt(12) + 1),
    "month_word": $ed27b30e72f83249$var$pseudonymizeWrittenMonth,
    "year": $ed27b30e72f83249$var$pseudonymizeYear,
    "date_digits": $ed27b30e72f83249$var$pseudonymizeDate,
    "phone_nr": $ed27b30e72f83249$var$phoneNumber,
    "email": $ed27b30e72f83249$var$email,
    "personid_nr": ()=>"123456-0000",
    "account_nr": (type, labels, str)=>$ed27b30e72f83249$var$replaceNumbersWithZero(str),
    "license_nr": $ed27b30e72f83249$var$zipCode,
    "url": ()=>"url.com",
    "other_nr_seq": (type, labels, str)=>$ed27b30e72f83249$var$replaceNumbersWithZero(str)
};


function $0cbe5267c7ef82d0$export$ee072a2ca7182767(label) {
    return !isNaN(Number(label)) || (0, $144d13b54a739243$export$b9193eea530b254f)("anonymization", label) && !$566cb6e3cba7cd4f$export$4d1b37ad7bc31b75(label);
}
function $0cbe5267c7ef82d0$export$98fd79d374891146(labels) {
    return labels.filter($0cbe5267c7ef82d0$export$ee072a2ca7182767).sort((0, $144d13b54a739243$export$f4c10db555342dd9));
}
function $0cbe5267c7ef82d0$export$935ff5091e2a573d(graph) {
    const partition = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(graph);
    const out = {};
    // Go through anonymized edges.
    $d9d0435d2b879de6$export$4b80e395e36b5a56($d9d0435d2b879de6$export$3dea766d36a8935f(graph.edges, (e)=>e.labels.some($0cbe5267c7ef82d0$export$ee072a2ca7182767)), (edge)=>{
        const st = partition(edge.ids);
        // Add the target text for each label combination.
        out[$0cbe5267c7ef82d0$export$98fd79d374891146(edge.labels).join(" ")] = $566cb6e3cba7cd4f$export$8bc6b66de3102a9d(st);
    });
    return out;
}
function $0cbe5267c7ef82d0$export$cbb67bddceec4333(graph, pstore, pmod) {
    const g = $566cb6e3cba7cd4f$export$9cd59f9826255e47(graph);
    let i = $566cb6e3cba7cd4f$export$42ac17aabdaccaaf(g);
    const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
    const first = $a0933ef57ff1c2b9$export$6be1a247e0437315();
    const pi = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(g);
    const target = [];
    const edges = [];
    g.source.forEach((source_token)=>{
        const e = $a0933ef57ff1c2b9$export$df91a094d1ff523d(em, source_token.id);
        // If the edge has anon labels.
        const anonLabels = $0cbe5267c7ef82d0$export$98fd79d374891146(e.labels);
        if (!first(e.id)) return;
        if (anonLabels.length) {
            const source_text = $58ccaae15ba3b7ae$export$6f093cfa640b7166(pi(e.ids).source);
            // Ensure a pseudonymization in the store.
            const { src: src, labels: labels } = pmod ? pmod(source_token.id, source_text, anonLabels) : {
                src: source_text,
                labels: anonLabels
            };
            const [affixes, main_labels] = $a0933ef57ff1c2b9$export$7fff46e75e637d73(labels, (0, $144d13b54a739243$export$64979d6b7e67c3aa), (0, $144d13b54a739243$export$4889b9a43e973648).EXTRA);
            const pp = pstore.at(main_labels.join(" "));
            if (affixes.includes("foreign") && main_labels.includes("city")) pp.get() || pp.set((0, $ed27b30e72f83249$exports.pseudonymize)(src, [
                "city_foreign",
                main_labels[1]
            ]));
            else if (affixes.includes("foreign") && main_labels.includes("area")) pp.get() || pp.set((0, $ed27b30e72f83249$exports.pseudonymize)(src, [
                "area_foreign",
                main_labels[1]
            ]));
            else if (affixes.includes("foreign") && main_labels.includes("place")) pp.get() || pp.set((0, $ed27b30e72f83249$exports.pseudonymize)(src, [
                "place_foreign",
                main_labels[1]
            ]));
            else if (affixes.includes("foreign") && main_labels.includes("region")) pp.get() || pp.set((0, $ed27b30e72f83249$exports.pseudonymize)(src, [
                "region_foreign",
                main_labels[1]
            ]));
            else pp.get() || pp.set((0, $ed27b30e72f83249$exports.pseudonymize)(src, main_labels));
            const pseudonym = [
                pp.get(),
                ...affixes
            ].join("-");
            const new_pseudonym = pseudonym.replace("-foreign", "");
            const ts = $58ccaae15ba3b7ae$export$660b2ee2d4fb4eff(new_pseudonym).map((text)=>$58ccaae15ba3b7ae$export$50792b0e93539fde($a0933ef57ff1c2b9$export$14c0f847aecec6f1(text), "t" + i++));
            edges.push($566cb6e3cba7cd4f$export$b9d9805c9b77a56d([
                ...pi(e.ids).source.map((s)=>s.id),
                ...ts.map((t)=>t.id)
            ], e.labels, true, e.comment));
            ts.forEach((t)=>target.push(t));
        } else {
            edges.push(e);
            target.push(...pi(e.ids).target);
        }
    });
    return {
        ...$566cb6e3cba7cd4f$export$9cd59f9826255e47(g),
        source: g.source,
        target: target,
        edges: $566cb6e3cba7cd4f$export$27823d486efd100e(edges)
    };
}
function $0cbe5267c7ef82d0$export$6eef6642601245aa(b) {
    return (graph, pstore, pmod)=>b ? $0cbe5267c7ef82d0$export$cbb67bddceec4333(graph, pstore, pmod) : graph;
}
function $0cbe5267c7ef82d0$export$5da77726a9654879(graph) {
    let g = $566cb6e3cba7cd4f$export$9cd59f9826255e47(graph);
    const p = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(g);
    const tm = $566cb6e3cba7cd4f$export$a669ad57b3bc989b(g);
    // For new anonymizations, overwrite source with pseudonymized target.
    $d9d0435d2b879de6$export$4b80e395e36b5a56($d9d0435d2b879de6$export$3dea766d36a8935f(g.edges, (e)=>e.labels.some($0cbe5267c7ef82d0$export$ee072a2ca7182767)), (edge, eid)=>{
        const st = p(edge.ids);
        // If source and target differ, this is a new anonymization.
        if (!$a0933ef57ff1c2b9$export$a19dbeb44f6a0bab($566cb6e3cba7cd4f$export$1aa3e3e981886a9b(st), $566cb6e3cba7cd4f$export$bcca83b25b058d41(st))) {
            // Replace the first token with the pseudonymization.
            const first_source_token = st.source.shift();
            if (first_source_token === undefined) return;
            const i = $a0933ef57ff1c2b9$export$df91a094d1ff523d(tm, first_source_token.id).index;
            g = $566cb6e3cba7cd4f$export$72d5c64f9cc56871(g, i, i + 1, $566cb6e3cba7cd4f$export$8bc6b66de3102a9d(st), "source");
            // Remove any subsequent tokens (e.g. "Park Road" in "Glenister Park Road").
            // Go backwards to keep indexes safe.
            st.source.reverse().forEach((t)=>{
                const i = $a0933ef57ff1c2b9$export$df91a094d1ff523d(tm, t.id).index;
                g = $566cb6e3cba7cd4f$export$72d5c64f9cc56871(g, i, i + 1, "", "source");
            });
        }
    });
    return g;
}


function $7ce66515d279521f$export$1aca998cb633196e(store, k) {
    store.transaction(()=>{
        store.update({
            backend: undefined,
            essay: undefined,
            start_mode: undefined,
            version: undefined
        });
        k();
    });
}
const $7ce66515d279521f$var$essay_url = (state, endpoint = "")=>`${state.backend}${state.essay}${state.user ? "/" + state.user : ""}${endpoint}`;
const $7ce66515d279521f$export$d49663c289e0cae7 = (state)=>({
        state: !state.readonly && !state.done,
        done: !state.readonly
    });
function $7ce66515d279521f$export$f21d8fd7f00f60f4(store, then) {
    const state = store.get();
    if (state.backend && state.essay) {
        function get(last_route, h) {
            $a0933ef57ff1c2b9$export$1bb358554aac31c1($7ce66515d279521f$var$essay_url(state, last_route), (res_str)=>{
                try {
                    h(JSON.parse(res_str));
                } catch (e) {
                    $7ce66515d279521f$export$e1c744d13458e1d(store, `Error ${e.toString()} when extracting state from ${res_str}`);
                }
            }, (err, code)=>$7ce66515d279521f$export$e1c744d13458e1d(store, `${code}: ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(err)}`));
        }
        get("", (res)=>{
            const version = res.version;
            if (version !== undefined && typeof version === "number") {
                function try_raw(raw) {
                    if (raw !== undefined && typeof raw === "string") return $566cb6e3cba7cd4f$export$2cd8252107eb640b(raw);
                }
                let state;
                const graph = try_raw(res.raw) || (state = JSON.parse(res.state), try_raw(state.raw) || state);
                store.update({
                    graph: (0, $17d8c0717df1150b$exports.Undo).init(graph),
                    version: version
                });
                store.update({
                    readonly: !res.access_write
                });
                get("/status", (res)=>{
                    const done = res.done;
                    if (done !== undefined && typeof done == "boolean") {
                        store.update({
                            done: done
                        });
                        then();
                    } else $7ce66515d279521f$export$e1c744d13458e1d(store, `Invalid status in ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(res)}`);
                });
            } else $7ce66515d279521f$export$e1c744d13458e1d(store, `Invalid state in ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(res)}`);
        });
    }
}
function $7ce66515d279521f$export$a1544dad697b423d(store) {
    const state = store.get();
    const graph = store.get().mode == "anonymization" ? $7ce66515d279521f$export$e0a937f731644887(store) : state.graph.now;
    if (state.version !== undefined && state.backend && state.essay && $d9d0435d2b879de6$export$346677f925de839c(state.errors) == 0) {
        console.log("saving...");
        store.update({
            version: undefined
        });
        $a0933ef57ff1c2b9$export$484f3009c2ee32ad($7ce66515d279521f$var$essay_url(state, `/version/${state.version + 1}`), graph, (res_str)=>{
            try {
                const res = JSON.parse(res_str);
                const version = res.version;
                if (version !== undefined && typeof version === "number") {
                    console.log({
                        version: version
                    });
                    store.update({
                        version: version
                    });
                } else $7ce66515d279521f$export$e1c744d13458e1d(store, `No version confirmation in ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(res)}`);
            } catch (e) {
                $7ce66515d279521f$export$e1c744d13458e1d(store, `Error ${e.toString} when responding to ${res_str}`);
            }
        }, (err, code)=>$7ce66515d279521f$export$e1c744d13458e1d(store, `Error ${code} when saving: ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(err)}`));
    }
}
function $7ce66515d279521f$export$f18d5b0af29128b7(store, message) {
    const state = store.get();
    $a0933ef57ff1c2b9$export$484f3009c2ee32ad($7ce66515d279521f$var$essay_url(state, "/report"), {
        message: message
    }, ()=>{}, (err, code)=>$7ce66515d279521f$export$e1c744d13458e1d(store, `Error ${code} when reporting "${message}": ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(err)}`));
}
function $7ce66515d279521f$export$3ccf567208079273(store) {
    const debounced_save = $a0933ef57ff1c2b9$export$61fc7d43ac8f84b0(1000, ()=>{
        !$7ce66515d279521f$export$39d12591b9d419b4(store.get()) && !store.get().readonly && $7ce66515d279521f$export$a1544dad697b423d(store);
    });
    store.at("graph").at("now").ondiff((g1, g2)=>$566cb6e3cba7cd4f$export$411ce8e5a71e3069(g1, g2) || debounced_save());
    store.at("done").ondiff((done)=>{
        done && $7ce66515d279521f$export$6925991e7e736e7(store);
        const state = store.get();
        if (state.backend && state.essay && $d9d0435d2b879de6$export$346677f925de839c(state.errors) == 0 && !$7ce66515d279521f$export$39d12591b9d419b4(state)) $a0933ef57ff1c2b9$export$484f3009c2ee32ad($7ce66515d279521f$var$essay_url(state, "/status"), {
            done: done
        }, (res_str)=>{
            const res = JSON.parse(res_str);
            store.update({
                readonly: !res.access_write
            });
        }, (err, code)=>{
            $7ce66515d279521f$export$e1c744d13458e1d(store, `Error ${code} when setting done status: ${$a0933ef57ff1c2b9$export$57bf213be019eeb0(err)}`);
            store.at("done").set(!done);
        });
    });
}
const $7ce66515d279521f$export$4a6bdc0a840be00 = {
    anonymization: "anonymization",
    normalization: "normalization",
    correctannot: "correctannot"
};
function $7ce66515d279521f$export$90760e89e7ed6c8a(mode) {
    return ({
        [$7ce66515d279521f$export$4a6bdc0a840be00.anonymization]: "pseudonymization",
        [$7ce66515d279521f$export$4a6bdc0a840be00.normalization]: "normalization",
        [$7ce66515d279521f$export$4a6bdc0a840be00.correctannot]: "correction annotation"
    })[mode];
}
function $7ce66515d279521f$export$c6e3ee227122f5b7(mode) {
    return [
        $7ce66515d279521f$export$4a6bdc0a840be00.anonymization,
        $7ce66515d279521f$export$4a6bdc0a840be00.correctannot
    ].includes(mode);
}
const $7ce66515d279521f$export$2cd8252107eb640b = {
    graph: (0, $17d8c0717df1150b$exports.Undo).init($566cb6e3cba7cd4f$export$2cd8252107eb640b("")),
    rich_diff: undefined,
    hover_id: undefined,
    selected: {},
    subspan: undefined,
    side_restriction: undefined,
    generation: 0,
    errors: {},
    validation_messages: [],
    mode: $7ce66515d279521f$export$4a6bdc0a840be00.normalization,
    taxonomy: (0, $144d13b54a739243$export$e506a1d27d1eaa20).taxonomy,
    automatic_rendering: true,
    show: {
        target_text: true
    },
    pseudonyms: {},
    pseudonym_args: {}
};
function $7ce66515d279521f$export$39ede186e36e8c0b(store) {
    return (g)=>{
        const inv = $566cb6e3cba7cd4f$export$39ede186e36e8c0b(g);
        if (inv !== "ok") {
            $a0933ef57ff1c2b9$export$8343b6e3d09a3606(inv);
            const msg = [
                `Internal invariant violated:`,
                inv.violation,
                "",
                `Please report this as a bug, describe what you did and include the current graph:`,
                $a0933ef57ff1c2b9$export$57bf213be019eeb0(inv.g)
            ].join("\n");
            $7ce66515d279521f$export$e1c744d13458e1d(store, msg);
            store.at("graph").set((0, $17d8c0717df1150b$exports.Undo).init($566cb6e3cba7cd4f$export$2cd8252107eb640b("x")));
        }
    };
}
/** Validation rules for app state.

  const graph = G.modify_labels(G.init('x'), 'e-s0-t0', () => ['OBS!'])
  validationRules[0].check({graph, state: {...init, mode: 'anonymization', done: true}}) // => [{subject: 'e-s0-t0', severity: Severity.WARNING}]
  validationRules[0].check({graph, state: {...init, mode: 'normalization', done: true}}) // => [{subject: 'e-s0-t0', severity: Severity.WARNING}]
  validationRules[0].check({graph, state: {...init, mode: 'anonymization', done: false}}) // => []

  const graph = G.unaligned_modify_tokens(G.init('x'), 0, 1, 'y ')
  validationRules[1].check({graph, state: {...init, mode: 'correctannot'}}) // => [{subject: 'e-s0-t1', severity: Severity.WARNING}]

  const graph = G.modify_labels(G.init('x'), 'e-s0-t0', () => ['firstname_female', 'region', 'OBS!', 'gen', 'ort'])
  validationRules[2].check({graph, state: {...init, mode: 'anonymization'}}) // => [{subject: 'e-s0-t0', severity: Severity.ERROR}]

  const g0 = G.init('x y')
  const g1 = G.modify_labels(g0, 'e-s0-t0', () => ['firstname_female'])
  const graph = G.modify_labels(g1, 'e-s1-t1', () => ['firstname_female', '1'])
  validationRules[3].check({graph, state: {...init, mode: 'anonymization', done: true}}) // => [{subject: 'e-s0-t0', severity: Severity.ERROR}]
  validationRules[3].check({graph, state: {...init, mode: 'anonymization'}}) // => []
  validationRules[3].check({graph, state: {...init, done: true}}) // => []

  const g0 = G.init('x y')
  const g1 = G.modify_labels(g0, 'e-s0-t0', () => ['1'])
  const graph = G.modify_labels(g1, 'e-s1-t1', () => ['firstname_female', '1'])
  validationRules[4].check({graph, state: {...init, mode: 'anonymization', done: true}}) // => [{subject: 'e-s0-t0', severity: Severity.ERROR}]
  validationRules[4].check({graph, state: {...init, done: true}}) // => []
  validationRules[4].check({graph, state: {...init, mode: 'anonymization'}}) // => []

*/ const $7ce66515d279521f$var$validationRules = [
    (0, $a3df2e600d37ee5f$export$f1ff2a90c38ff669)("Temporary/comment tags remaining when done", (0, $a3df2e600d37ee5f$export$e1276971c8e90b02)((state)=>!!state.done && !$7ce66515d279521f$export$39d12591b9d419b4(state), (edge)=>edge.labels.filter((l)=>(0, $144d13b54a739243$export$64979d6b7e67c3aa)(l) == (0, $144d13b54a739243$export$4889b9a43e973648).TEMP).length > 0, (0, $a3df2e600d37ee5f$export$918a9776c0a3cf27).WARNING)),
    (0, $a3df2e600d37ee5f$export$f1ff2a90c38ff669)("Normalization missing a label", (0, $a3df2e600d37ee5f$export$e1276971c8e90b02)((state)=>state.mode == $7ce66515d279521f$export$4a6bdc0a840be00.correctannot, (edge, source, target)=>$58ccaae15ba3b7ae$export$6f093cfa640b7166(source) != $58ccaae15ba3b7ae$export$6f093cfa640b7166(target) && edge.labels.length == 0, (0, $a3df2e600d37ee5f$export$918a9776c0a3cf27).WARNING)),
    (0, $a3df2e600d37ee5f$export$f1ff2a90c38ff669)("Too many main labels", (0, $a3df2e600d37ee5f$export$e1276971c8e90b02)((state)=>state.mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization, (edge)=>edge.labels.filter((l)=>(0, $0cbe5267c7ef82d0$export$ee072a2ca7182767)(l) && (0, $144d13b54a739243$export$64979d6b7e67c3aa)(l) == (0, $144d13b54a739243$export$4889b9a43e973648).BASE).length > 1)),
    (0, $a3df2e600d37ee5f$export$f1ff2a90c38ff669)("Running number missing", (0, $a3df2e600d37ee5f$export$e1276971c8e90b02)((state)=>state.mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization && !!state.done, (edge)=>edge.labels.filter((l)=>(0, $0cbe5267c7ef82d0$export$ee072a2ca7182767)(l) && (0, $144d13b54a739243$export$64979d6b7e67c3aa)(l) == (0, $144d13b54a739243$export$4889b9a43e973648).BASE).length > 0 && edge.labels.filter((l)=>(0, $144d13b54a739243$export$64979d6b7e67c3aa)(l) == (0, $144d13b54a739243$export$4889b9a43e973648).NUM).length == 0)),
    (0, $a3df2e600d37ee5f$export$f1ff2a90c38ff669)("Running number used alone", (0, $a3df2e600d37ee5f$export$e1276971c8e90b02)((state)=>state.mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization && !!state.done, (edge)=>edge.labels.filter((l)=>(0, $144d13b54a739243$export$64979d6b7e67c3aa)(l) == (0, $144d13b54a739243$export$4889b9a43e973648).NUM).length > 0 && edge.labels.filter((l)=>(0, $0cbe5267c7ef82d0$export$ee072a2ca7182767)(l) && (0, $144d13b54a739243$export$64979d6b7e67c3aa)(l) == (0, $144d13b54a739243$export$4889b9a43e973648).BASE).length == 0))
];
function $7ce66515d279521f$export$6925991e7e736e7(store, show) {
    $7ce66515d279521f$export$334d2dd303122535(store);
    const state = store.get();
    const graph = state.graph.now;
    $7ce66515d279521f$var$validationRules.forEach((rule)=>{
        rule.check({
            state: state,
            graph: graph
        }).forEach((result)=>{
            $7ce66515d279521f$export$7f32d1c40c0b8aa9(store, rule.name, result.severity, result.subject);
        });
    });
    show !== undefined && store.at("show").update({
        validation: show ? true : undefined
    });
}
function $7ce66515d279521f$export$8fce3efcf5a2aae4(store, f, show) {
    // Avoid triggering listeners until we're done.
    return store.transaction(()=>{
        // Remember ingoing state.
        const prev = store.get();
        // Perform changes.
        f(store);
        // Validate new state.
        $7ce66515d279521f$export$6925991e7e736e7(store, show);
        const validation_messages = store.at("validation_messages").get();
        const errors = validation_messages.filter((msg)=>msg.severity == (0, $a3df2e600d37ee5f$export$918a9776c0a3cf27).ERROR);
        // If the changes result in invalid state, revert to ingoing state but with messages added.
        if (errors.length > 0) {
            store.set({
                ...prev,
                validation_messages: validation_messages
            });
            store.at("show").via((0, $17d8c0717df1150b$exports.Lens).key("validation")).set(show || undefined);
        }
        return errors.length === 0;
    });
}
function $7ce66515d279521f$export$e1c744d13458e1d(store, msg) {
    store.at("errors").update({
        [msg]: true
    });
}
function $7ce66515d279521f$export$7f32d1c40c0b8aa9(store, message, severity, subject) {
    store.at("validation_messages").modify((msgs)=>[
            ...msgs,
            {
                message: message,
                severity: severity,
                subject: subject
            }
        ]);
}
function $7ce66515d279521f$export$334d2dd303122535(store) {
    store.at("validation_messages").set([]);
}
function $7ce66515d279521f$export$9e05035ca7fe6979(store, slug) {
    if (slug === undefined) store.at("manual").set(undefined);
    else {
        const page = $5459fbbcf1f7402d$export$d5db38ffe1f43b01[slug] || {
            graph: $566cb6e3cba7cd4f$export$2cd8252107eb640b(""),
            mode: $7ce66515d279521f$export$4a6bdc0a840be00.normalization
        };
        $7ce66515d279521f$export$1aca998cb633196e(store, ()=>store.update({
                manual: slug,
                graph: (0, $17d8c0717df1150b$exports.Undo).init(page.graph),
                mode: page.mode,
                selected: {}
            }));
    }
}
function $7ce66515d279521f$export$9caaf78dc1897bf2(store, json) {
    store.update({
        mode: "correctannot"
    });
    const g = JSON.parse(json);
    $566cb6e3cba7cd4f$export$23b96a0307014ab2(g) && store.at("graph").modify((0, $17d8c0717df1150b$exports.Undo).advance_to(g));
}
function $7ce66515d279521f$export$5bb86370ea51314a(store) {
    store.update({
        selected: {},
        hover_id: undefined
    });
}
function $7ce66515d279521f$export$51df77521fa337de(store, ids, value) {
    store.transaction(()=>ids.forEach((id)=>store.at("selected").via((0, $17d8c0717df1150b$exports.Lens).key(id)).set(value == false ? undefined : value)));
}
function $7ce66515d279521f$export$f6e36f80a8190133(store, ids) {
    store.transaction(()=>{
        store.at("selected").set($d9d0435d2b879de6$export$185802fd694ee1f5(ids, ()=>true));
    });
}
function $7ce66515d279521f$export$ab3686cfac071135(store, selected0) {
    const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c($7ce66515d279521f$export$9a86c1ce88ca19ad(store));
    const present = (s)=>em.has(s);
    const selected = $d9d0435d2b879de6$export$3dea766d36a8935f(selected0, (_, id)=>present(id));
    if ($d9d0435d2b879de6$export$346677f925de839c(selected) < $d9d0435d2b879de6$export$346677f925de839c(selected0)) return {
        selected: selected
    };
}
function $7ce66515d279521f$export$68c05593fd98348a(store, indicies) {
    const g = $7ce66515d279521f$export$9a86c1ce88ca19ad(store);
    const tm = $566cb6e3cba7cd4f$export$a669ad57b3bc989b(g);
    const selected = Object.keys(store.get().selected).map((token_id)=>$a0933ef57ff1c2b9$export$df91a094d1ff523d(tm, token_id));
    $a0933ef57ff1c2b9$export$9be1301193883bb5(store.at("subspan"), $566cb6e3cba7cd4f$export$49709d8cccb10e07(g, [
        ...indicies,
        ...selected
    ]));
}
function $7ce66515d279521f$export$93f1b562a4709b2(store) {
    const state = store.get();
    return state.hover_id !== undefined;
}
function $7ce66515d279521f$export$493931e7c80626e7(state) {
    return state.mode === $7ce66515d279521f$export$4a6bdc0a840be00.anonymization;
}
function $7ce66515d279521f$export$39d12591b9d419b4(state) {
    const start_mode = state.start_mode;
    return start_mode && start_mode != $7ce66515d279521f$export$4a6bdc0a840be00.anonymization && $7ce66515d279521f$export$493931e7c80626e7(state);
}
function $7ce66515d279521f$export$55abd4691b317664(store) {
    return {
        undo: ()=>store.at("graph").modify((0, $17d8c0717df1150b$exports.Undo).undo),
        redo: ()=>store.at("graph").modify((0, $17d8c0717df1150b$exports.Undo).redo),
        canUndo: ()=>(0, $17d8c0717df1150b$exports.Undo).can_undo(store.get().graph),
        canRedo: ()=>(0, $17d8c0717df1150b$exports.Undo).can_redo(store.get().graph)
    };
}
function $7ce66515d279521f$export$46c0d0540c0c99ee(store) {
    return store.at("graph").at("now");
}
function $7ce66515d279521f$export$88c4ac24ed656637(store) {
    return $7ce66515d279521f$export$46c0d0540c0c99ee(store).get();
}
function $7ce66515d279521f$export$57bd86207114870b(store) {
    return $7ce66515d279521f$export$46c0d0540c0c99ee(store).via((0, $17d8c0717df1150b$exports.Lens).iso((g)=>$566cb6e3cba7cd4f$export$e1ba3adfdc99288f($8f42eafc2f1b3c8d$export$93d135f93a177c5(g), (us)=>$8f42eafc2f1b3c8d$export$a4a6ecdacd1cddbe(us)), (state)=>{
        const s = $8f42eafc2f1b3c8d$export$98e6a39c04603d36(state.source);
        const t = $8f42eafc2f1b3c8d$export$98e6a39c04603d36(state.target);
        return $8f42eafc2f1b3c8d$export$9cb5350a7a87beb(s, t);
    }));
}
function $7ce66515d279521f$export$90a4f11d22f5cfb6(store) {
    store.at("pseudonyms").set((0, $0cbe5267c7ef82d0$export$935ff5091e2a573d)($7ce66515d279521f$export$88c4ac24ed656637(store)));
}
function $7ce66515d279521f$export$9a86c1ce88ca19ad(store) {
    const pmod = (token_id, src, labels)=>({
            src: src,
            labels: labels.concat(store.get().pseudonym_args[token_id] || [])
        });
    return $7ce66515d279521f$export$493931e7c80626e7(store.get()) ? (0, $0cbe5267c7ef82d0$export$cbb67bddceec4333)($566cb6e3cba7cd4f$export$3d1c8131457e647($7ce66515d279521f$export$88c4ac24ed656637(store), (0, $144d13b54a739243$export$64979d6b7e67c3aa)), store.at("pseudonyms"), pmod) : $7ce66515d279521f$export$88c4ac24ed656637(store);
}
function $7ce66515d279521f$export$e0a937f731644887(store) {
    const state = store.get();
    const g = $7ce66515d279521f$export$9a86c1ce88ca19ad(store);
    return state.subspan && state.mode !== $7ce66515d279521f$export$4a6bdc0a840be00.anonymization ? $566cb6e3cba7cd4f$export$ecd98896577df54e(g, state.subspan) : g;
}
function $7ce66515d279521f$export$2cc8197d6ae5570(store, ids, only) {
    const emv = $566cb6e3cba7cd4f$export$13b0e7a577fb573c($7ce66515d279521f$export$e0a937f731644887(store));
    const involved_ids = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(ids, (id)=>{
        if ($7ce66515d279521f$export$493931e7c80626e7(store.get())) // Select full edge.
        return $a0933ef57ff1c2b9$export$df91a094d1ff523d(emv, id).ids;
        else return [
            id
        ];
    });
    if (only) $7ce66515d279521f$export$f6e36f80a8190133(store, involved_ids);
    else {
        const selected = store.get().selected;
        const b = involved_ids.every((id)=>selected[id]) ? undefined : true;
        $7ce66515d279521f$export$51df77521fa337de(store, involved_ids, b);
    }
}
function $7ce66515d279521f$export$2ae79f5e5d10736f(store) {
    const graph = store.at("graph");
    const now = graph.at("now");
    return (k)=>store.transaction(()=>{
            const g0 = now.get();
            k(g0);
            const g1 = now.get();
            if (!$566cb6e3cba7cd4f$export$411ce8e5a71e3069(g0, g1)) {
                now.set(g0);
                graph.modify((0, $17d8c0717df1150b$exports.Undo).advance_to(g1));
            }
        });
}
function $7ce66515d279521f$export$4f65e594f6031297(store, token_ids, label, value) {
    const edges = $566cb6e3cba7cd4f$export$8d414a6135f9d320($7ce66515d279521f$export$88c4ac24ed656637(store), token_ids);
    const graph = $7ce66515d279521f$export$46c0d0540c0c99ee(store);
    const edge_ids = edges.map((e)=>e.id);
    const labels = $a0933ef57ff1c2b9$export$f70730c3d1fc524e($a0933ef57ff1c2b9$export$5b8affa63fc6df16(edges, (e)=>e.labels));
    // Add/remove label.
    // For numbers and main anon labels, replace existing ones.
    const replace_conds = [
        (x)=>/^\d+$/.test(x),
        (x)=>(0, $144d13b54a739243$export$b9193eea530b254f)($7ce66515d279521f$export$4a6bdc0a840be00.anonymization, x) && (0, $144d13b54a739243$export$64979d6b7e67c3aa)(x) == (0, $144d13b54a739243$export$4889b9a43e973648).BASE
    ];
    const replace_cond = replace_conds.find((cond)=>cond(label));
    const single_set_label = (labels)=>replace_cond ? labels.filter((l)=>!replace_cond(l)).concat(value ? [
            label
        ] : []) : $a0933ef57ff1c2b9$export$cc169e0ad6247842(labels, label, value);
    edge_ids.forEach((id)=>graph.modify((g)=>$566cb6e3cba7cd4f$export$5f402a225d1edecc(g, id, single_set_label)));
    // Auto-group consecutive tokens in anonymization.
    if (store.get().mode == "anonymization") {
        if (value && (0, $144d13b54a739243$export$64979d6b7e67c3aa)(label) == (0, $144d13b54a739243$export$4889b9a43e973648).BASE) {
            // When adding a main label, also connect the selected tokens.
            graph.modify((g)=>$566cb6e3cba7cd4f$export$83844fbbb0a27299(g, edges, "source").reduce((g, es)=>$566cb6e3cba7cd4f$export$64605811ab45167f(g, es.map((e)=>e.id)), g));
            // The selected tokens may have new edges.
            const edges_new = $566cb6e3cba7cd4f$export$8d414a6135f9d320(graph.get(), token_ids);
            // Number magic: For each new edge, if the source text matches an already number-labeled
            // source text, use that number, otherwise use the maximum + 1.
            const nem = $7ce66515d279521f$export$e46213c4904f0841(graph.get());
            const partition = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(graph.get());
            const edge_source = (e)=>$58ccaae15ba3b7ae$export$6f093cfa640b7166(partition(e.ids)["source"]);
            const strmax = (xs)=>$a0933ef57ff1c2b9$export$b25e0be55f42c9a([
                    0,
                    ...xs.map((l)=>Number(l) || 0)
                ]);
            let maxnum = strmax(Object.keys(nem));
            edges_new.forEach((e)=>{
                const match = Object.keys($d9d0435d2b879de6$export$3dea766d36a8935f(nem, (nes)=>nes.some((ne)=>edge_source(ne) == edge_source(e))))[0];
                (0, $144d13b54a739243$export$ebb418edcdf3dd37)[label] || graph.modify((g)=>$566cb6e3cba7cd4f$export$5f402a225d1edecc(g, e.id, (l)=>[
                            ...l,
                            String(match ? match : ++maxnum)
                        ]));
            });
        } else if (!value && labels.length <= 1) // When there was only one label and we are removing it, revert the connection made before.
        graph.modify((g)=>$566cb6e3cba7cd4f$export$3fdd26f3d9e7dc78(g, edge_ids));
    }
}
function $7ce66515d279521f$export$e46213c4904f0841(g) {
    return $566cb6e3cba7cd4f$export$c555d49ba8ab6cad(g, (l)=>/^\d+$/.test(l));
}
const $7ce66515d279521f$export$b6fb1741c7f64881 = {
    normalization: [
        "prev",
        "next",
        "prev_mod",
        "next_mod",
        "group",
        "orphan",
        "auto",
        "revert"
    ],
    correctannot: [
        "prev",
        "next",
        "prev_mod",
        "next_mod",
        "group",
        "orphan",
        "auto" /*, 'revert'*/ 
    ],
    anonymization: [
        "prev",
        "next",
        "prev_mod",
        "next_mod"
    ]
};
const $7ce66515d279521f$export$a7046e0c111216af = {
    revert: "Local undo on the selected tokens. Restores them to the source text.",
    auto: "Makes the selected tokens stop being manually linked and falls back to the automatic aligner.",
    orphan: "Makes each of the selected tokens be orphaned: only linked to themselves.",
    merge: "Connects the selected tokens and the tokens they are linked to.",
    group: "Makes a group of the selected words. (Any words they in turn are connected that are not selected will not be part of the group.)",
    deselect: "Deselects the current group",
    next: "Select next group",
    prev: "Select previous group",
    next_mod: "Select the next group which has modifications",
    prev_mod: "Select the previous group which has modifications"
};
const $7ce66515d279521f$export$cb571d1feb4bc7b = {
    revert: "revert",
    auto: "auto",
    orphan: "orphan",
    merge: "merge",
    group: "group",
    deselect: "deselect",
    next: "next",
    prev: "previous",
    next_mod: "next mod",
    prev_mod: "prev mod"
};
const $7ce66515d279521f$export$9fc7b98fb0c7c1a5 = {
    revert: "Alt-r",
    auto: "Alt-a",
    orphan: "Alt-o",
    merge: "Alt-m",
    group: "Alt-g",
    deselect: "Escape",
    next: "Alt-ArrowRight",
    prev: "Alt-ArrowLeft",
    next_mod: "Alt-Shift-ArrowRight",
    prev_mod: "Alt-Shift-ArrowLeft"
};
function $7ce66515d279521f$var$navigate(direction, kind) {
    return ({ graph: graph, selected: selected })=>{
        return {
            type: "selection",
            selected: $84505fa089775c7a$export$ceb1036482b0fe9(graph, selected, direction, kind, (i)=>(0, $144d13b54a739243$export$e506a1d27d1eaa20).order_changing_labels[i]) || selected
        };
    };
}
const $7ce66515d279521f$var$act_on_selected = {
    revert ({ graph: graph, selected: selected }) {
        const edge_ids = $566cb6e3cba7cd4f$export$d382192b07e5eedd(graph, selected);
        const edges = $566cb6e3cba7cd4f$export$8d414a6135f9d320(graph, selected);
        return $566cb6e3cba7cd4f$export$3fdd26f3d9e7dc78(graph, edge_ids);
    },
    auto ({ graph: graph, selected: selected }) {
        const edge_ids = $566cb6e3cba7cd4f$export$d382192b07e5eedd(graph, selected);
        return $566cb6e3cba7cd4f$export$9ea32abc1be18076({
            ...graph,
            edges: $d9d0435d2b879de6$export$871de8747c9eaa88(graph.edges, (e)=>{
                if (edge_ids.some((id)=>id == e.id)) return $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(e.ids, e.labels, false, e.comment);
                else return e;
            })
        });
    },
    orphan ({ graph: graph, selected: selected }) {
        return $566cb6e3cba7cd4f$export$37dfea93db2e14ed(graph, selected);
    },
    merge ({ graph: graph, selected: selected }) {
        return $566cb6e3cba7cd4f$export$64605811ab45167f(graph, $566cb6e3cba7cd4f$export$d382192b07e5eedd(graph, selected));
    },
    group ({ graph: graph, selected: selected }) {
        return this.merge({
            graph: $566cb6e3cba7cd4f$export$37dfea93db2e14ed(graph, selected),
            selected: selected
        });
    },
    deselect () {
        return {
            type: "selection",
            selected: []
        };
    },
    next: $7ce66515d279521f$var$navigate("next", "boring"),
    prev: $7ce66515d279521f$var$navigate("prev", "boring"),
    next_mod: $7ce66515d279521f$var$navigate("next", "interesting"),
    prev_mod: $7ce66515d279521f$var$navigate("prev", "interesting")
};
function $7ce66515d279521f$export$c6f93ba583c9acfc(store, action) {
    const graph_store = store.at("graph").at("now");
    const selected = Object.keys(store.get().selected);
    const res = $7ce66515d279521f$var$act_on_selected[action]({
        graph: $7ce66515d279521f$export$9a86c1ce88ca19ad(store),
        selected: selected
    });
    if ("type" in res) $7ce66515d279521f$export$f6e36f80a8190133(store, res.selected);
    else {
        const advance = $7ce66515d279521f$export$2ae79f5e5d10736f(store);
        advance(()=>graph_store.set(res));
    }
}
const $7ce66515d279521f$var$subkeys = (...ks)=>ks;
const $7ce66515d279521f$var$location_keys = $7ce66515d279521f$var$subkeys("manual", "backurl", "backend", "essay", "start_mode", "user", "svlink");
const $7ce66515d279521f$var$base64_keys = $7ce66515d279521f$var$subkeys("backurl", "backend");
const $7ce66515d279521f$var$id = (s)=>s;
function $7ce66515d279521f$export$471a9fea0ebf807(store) {
    const encode = (k)=>$7ce66515d279521f$var$base64_keys.some((o)=>o == k) ? btoa : $7ce66515d279521f$var$id;
    const decode = (k)=>$7ce66515d279521f$var$base64_keys.some((o)=>o == k) ? atob : $7ce66515d279521f$var$id;
    const substore = store.pick(...$7ce66515d279521f$var$location_keys);
    return substore.via((0, $17d8c0717df1150b$exports.Lens).iso((state)=>$d9d0435d2b879de6$export$df3f009e3d155b20(state, (v, k)=>v === undefined ? "" : `${k}=${encode(k)(v)}`).filter((s)=>s).join("&"), (str)=>{
        const obj = $d9d0435d2b879de6$export$bffa455ba8c619a6(str.split("&").map((s)=>{
            const i = s.indexOf("=");
            if (i) {
                const k = s.slice(0, i);
                const v = decodeURIComponent(s.slice(i + 1));
                return {
                    [k]: v
                };
            } else return {};
        }));
        const r = {};
        $7ce66515d279521f$var$location_keys.map((k)=>{
            if (k in obj) r[k] = decode(k)(obj[k]);
        });
        return r;
    }));
}


var $d6eaaf2d5469d0cb$exports = {};
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE
// This is CodeMirror (https://codemirror.net), a code editor
// implemented in JavaScript on top of the browser's DOM.
//
// You can find some technical background for some of the code below
// at http://marijnhaverbeke.nl/blog/#cm-internals .
(function(global, factory) {
    $d6eaaf2d5469d0cb$exports = factory();
})($d6eaaf2d5469d0cb$exports, function() {
    "use strict";
    // Kludges for bugs and behavior differences that can't be feature
    // detected are enabled based on userAgent etc sniffing.
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;
    var gecko = /gecko\/\d/i.test(userAgent);
    var ie_upto10 = /MSIE \d/.test(userAgent);
    var ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(userAgent);
    var edge = /Edge\/(\d+)/.exec(userAgent);
    var ie = ie_upto10 || ie_11up || edge;
    var ie_version = ie && (ie_upto10 ? document.documentMode || 6 : +(edge || ie_11up)[1]);
    var webkit = !edge && /WebKit\//.test(userAgent);
    var qtwebkit = webkit && /Qt\/\d+\.\d+/.test(userAgent);
    var chrome = !edge && /Chrome\//.test(userAgent);
    var presto = /Opera\//.test(userAgent);
    var safari = /Apple Computer/.test(navigator.vendor);
    var mac_geMountainLion = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(userAgent);
    var phantom = /PhantomJS/.test(userAgent);
    var ios = !edge && /AppleWebKit/.test(userAgent) && /Mobile\/\w+/.test(userAgent);
    var android = /Android/.test(userAgent);
    // This is woefully incomplete. Suggestions for alternative methods welcome.
    var mobile = ios || android || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(userAgent);
    var mac = ios || /Mac/.test(platform);
    var chromeOS = /\bCrOS\b/.test(userAgent);
    var windows = /win/i.test(platform);
    var presto_version = presto && userAgent.match(/Version\/(\d*\.\d*)/);
    if (presto_version) presto_version = Number(presto_version[1]);
    if (presto_version && presto_version >= 15) {
        presto = false;
        webkit = true;
    }
    // Some browsers use the wrong event properties to signal cmd/ctrl on OS X
    var flipCtrlCmd = mac && (qtwebkit || presto && (presto_version == null || presto_version < 12.11));
    var captureRightClick = gecko || ie && ie_version >= 9;
    function classTest(cls) {
        return new RegExp("(^|\\s)" + cls + "(?:$|\\s)\\s*");
    }
    var rmClass = function(node, cls) {
        var current = node.className;
        var match = classTest(cls).exec(current);
        if (match) {
            var after = current.slice(match.index + match[0].length);
            node.className = current.slice(0, match.index) + (after ? match[1] + after : "");
        }
    };
    function removeChildren(e) {
        for(var count = e.childNodes.length; count > 0; --count)e.removeChild(e.firstChild);
        return e;
    }
    function removeChildrenAndAdd(parent, e) {
        return removeChildren(parent).appendChild(e);
    }
    function elt(tag, content, className, style) {
        var e = document.createElement(tag);
        if (className) e.className = className;
        if (style) e.style.cssText = style;
        if (typeof content == "string") e.appendChild(document.createTextNode(content));
        else if (content) for(var i = 0; i < content.length; ++i)e.appendChild(content[i]);
        return e;
    }
    // wrapper for elt, which removes the elt from the accessibility tree
    function eltP(tag, content, className, style) {
        var e = elt(tag, content, className, style);
        e.setAttribute("role", "presentation");
        return e;
    }
    var range;
    if (document.createRange) range = function(node, start, end, endNode) {
        var r = document.createRange();
        r.setEnd(endNode || node, end);
        r.setStart(node, start);
        return r;
    };
    else range = function(node, start, end) {
        var r = document.body.createTextRange();
        try {
            r.moveToElementText(node.parentNode);
        } catch (e) {
            return r;
        }
        r.collapse(true);
        r.moveEnd("character", end);
        r.moveStart("character", start);
        return r;
    };
    function contains(parent, child) {
        if (child.nodeType == 3) child = child.parentNode;
        if (parent.contains) return parent.contains(child);
        do {
            if (child.nodeType == 11) child = child.host;
            if (child == parent) return true;
        }while (child = child.parentNode);
    }
    function activeElt() {
        // IE and Edge may throw an "Unspecified Error" when accessing document.activeElement.
        // IE < 10 will throw when accessed while the page is loading or in an iframe.
        // IE > 9 and Edge will throw when accessed in an iframe if document.body is unavailable.
        var activeElement;
        try {
            activeElement = document.activeElement;
        } catch (e) {
            activeElement = document.body || null;
        }
        while(activeElement && activeElement.shadowRoot && activeElement.shadowRoot.activeElement)activeElement = activeElement.shadowRoot.activeElement;
        return activeElement;
    }
    function addClass(node, cls) {
        var current = node.className;
        if (!classTest(cls).test(current)) node.className += (current ? " " : "") + cls;
    }
    function joinClasses(a, b) {
        var as = a.split(" ");
        for(var i = 0; i < as.length; i++)if (as[i] && !classTest(as[i]).test(b)) b += " " + as[i];
        return b;
    }
    var selectInput = function(node) {
        node.select();
    };
    if (ios) selectInput = function(node) {
        node.selectionStart = 0;
        node.selectionEnd = node.value.length;
    };
    else if (ie) selectInput = function(node) {
        try {
            node.select();
        } catch (_e) {}
    };
    function bind(f) {
        var args = Array.prototype.slice.call(arguments, 1);
        return function() {
            return f.apply(null, args);
        };
    }
    function copyObj(obj, target, overwrite) {
        if (!target) target = {};
        for(var prop in obj)if (obj.hasOwnProperty(prop) && (overwrite !== false || !target.hasOwnProperty(prop))) target[prop] = obj[prop];
        return target;
    }
    // Counts the column offset in a string, taking tabs into account.
    // Used mostly to find indentation.
    function countColumn(string, end, tabSize, startIndex, startValue) {
        if (end == null) {
            end = string.search(/[^\s\u00a0]/);
            if (end == -1) end = string.length;
        }
        for(var i = startIndex || 0, n = startValue || 0;;){
            var nextTab = string.indexOf("	", i);
            if (nextTab < 0 || nextTab >= end) return n + (end - i);
            n += nextTab - i;
            n += tabSize - n % tabSize;
            i = nextTab + 1;
        }
    }
    var Delayed = function() {
        this.id = null;
    };
    Delayed.prototype.set = function(ms, f) {
        clearTimeout(this.id);
        this.id = setTimeout(f, ms);
    };
    function indexOf(array, elt) {
        for(var i = 0; i < array.length; ++i){
            if (array[i] == elt) return i;
        }
        return -1;
    }
    // Number of pixels added to scroller and sizer to hide scrollbar
    var scrollerGap = 30;
    // Returned or thrown by various protocols to signal 'I'm not
    // handling this'.
    var Pass = {
        toString: function() {
            return "CodeMirror.Pass";
        }
    };
    // Reused option objects for setSelection & friends
    var sel_dontScroll = {
        scroll: false
    }, sel_mouse = {
        origin: "*mouse"
    }, sel_move = {
        origin: "+move"
    };
    // The inverse of countColumn -- find the offset that corresponds to
    // a particular column.
    function findColumn(string, goal, tabSize) {
        for(var pos = 0, col = 0;;){
            var nextTab = string.indexOf("	", pos);
            if (nextTab == -1) nextTab = string.length;
            var skipped = nextTab - pos;
            if (nextTab == string.length || col + skipped >= goal) return pos + Math.min(skipped, goal - col);
            col += nextTab - pos;
            col += tabSize - col % tabSize;
            pos = nextTab + 1;
            if (col >= goal) return pos;
        }
    }
    var spaceStrs = [
        ""
    ];
    function spaceStr(n) {
        while(spaceStrs.length <= n)spaceStrs.push(lst(spaceStrs) + " ");
        return spaceStrs[n];
    }
    function lst(arr) {
        return arr[arr.length - 1];
    }
    function map(array, f) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = f(array[i], i);
        return out;
    }
    function insertSorted(array, value, score) {
        var pos = 0, priority = score(value);
        while(pos < array.length && score(array[pos]) <= priority)pos++;
        array.splice(pos, 0, value);
    }
    function nothing() {}
    function createObj(base, props) {
        var inst;
        if (Object.create) inst = Object.create(base);
        else {
            nothing.prototype = base;
            inst = new nothing();
        }
        if (props) copyObj(props, inst);
        return inst;
    }
    var nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
    function isWordCharBasic(ch) {
        return /\w/.test(ch) || ch > "\x80" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch));
    }
    function isWordChar(ch, helper) {
        if (!helper) return isWordCharBasic(ch);
        if (helper.source.indexOf("\\w") > -1 && isWordCharBasic(ch)) return true;
        return helper.test(ch);
    }
    function isEmpty(obj) {
        for(var n in obj){
            if (obj.hasOwnProperty(n) && obj[n]) return false;
        }
        return true;
    }
    // Extending unicode characters. A series of a non-extending char +
    // any number of extending chars is treated as a single unit as far
    // as editing and measuring is concerned. This is not fully correct,
    // since some scripts/fonts/browsers also treat other configurations
    // of code points as a group.
    var extendingChars = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
    function isExtendingChar(ch) {
        return ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
    }
    // Returns a number from the range [`0`; `str.length`] unless `pos` is outside that range.
    function skipExtendingChars(str, pos, dir) {
        while((dir < 0 ? pos > 0 : pos < str.length) && isExtendingChar(str.charAt(pos)))pos += dir;
        return pos;
    }
    // Returns the value from the range [`from`; `to`] that satisfies
    // `pred` and is closest to `from`. Assumes that at least `to`
    // satisfies `pred`. Supports `from` being greater than `to`.
    function findFirst(pred, from, to) {
        // At any point we are certain `to` satisfies `pred`, don't know
        // whether `from` does.
        var dir = from > to ? -1 : 1;
        for(;;){
            if (from == to) return from;
            var midF = (from + to) / 2, mid = dir < 0 ? Math.ceil(midF) : Math.floor(midF);
            if (mid == from) return pred(mid) ? from : to;
            if (pred(mid)) to = mid;
            else from = mid + dir;
        }
    }
    // BIDI HELPERS
    function iterateBidiSections(order, from, to, f) {
        if (!order) return f(from, to, "ltr", 0);
        var found = false;
        for(var i = 0; i < order.length; ++i){
            var part = order[i];
            if (part.from < to && part.to > from || from == to && part.to == from) {
                f(Math.max(part.from, from), Math.min(part.to, to), part.level == 1 ? "rtl" : "ltr", i);
                found = true;
            }
        }
        if (!found) f(from, to, "ltr");
    }
    var bidiOther = null;
    function getBidiPartAt(order, ch, sticky) {
        var found;
        bidiOther = null;
        for(var i = 0; i < order.length; ++i){
            var cur = order[i];
            if (cur.from < ch && cur.to > ch) return i;
            if (cur.to == ch) {
                if (cur.from != cur.to && sticky == "before") found = i;
                else bidiOther = i;
            }
            if (cur.from == ch) {
                if (cur.from != cur.to && sticky != "before") found = i;
                else bidiOther = i;
            }
        }
        return found != null ? found : bidiOther;
    }
    // Bidirectional ordering algorithm
    // See http://unicode.org/reports/tr9/tr9-13.html for the algorithm
    // that this (partially) implements.
    // One-char codes used for character types:
    // L (L):   Left-to-Right
    // R (R):   Right-to-Left
    // r (AL):  Right-to-Left Arabic
    // 1 (EN):  European Number
    // + (ES):  European Number Separator
    // % (ET):  European Number Terminator
    // n (AN):  Arabic Number
    // , (CS):  Common Number Separator
    // m (NSM): Non-Spacing Mark
    // b (BN):  Boundary Neutral
    // s (B):   Paragraph Separator
    // t (S):   Segment Separator
    // w (WS):  Whitespace
    // N (ON):  Other Neutrals
    // Returns null if characters are ordered as they appear
    // (left-to-right), or an array of sections ({from, to, level}
    // objects) in the order in which they occur visually.
    var bidiOrdering = function() {
        // Character types for codepoints 0 to 0xff
        var lowTypes = "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN";
        // Character types for codepoints 0x600 to 0x6f9
        var arabicTypes = "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111";
        function charType(code) {
            if (code <= 0xf7) return lowTypes.charAt(code);
            else if (0x590 <= code && code <= 0x5f4) return "R";
            else if (0x600 <= code && code <= 0x6f9) return arabicTypes.charAt(code - 0x600);
            else if (0x6ee <= code && code <= 0x8ac) return "r";
            else if (0x2000 <= code && code <= 0x200b) return "w";
            else if (code == 0x200c) return "b";
            else return "L";
        }
        var bidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
        var isNeutral = /[stwN]/, isStrong = /[LRr]/, countsAsLeft = /[Lb1n]/, countsAsNum = /[1n]/;
        function BidiSpan(level, from, to) {
            this.level = level;
            this.from = from;
            this.to = to;
        }
        return function(str, direction) {
            var outerType = direction == "ltr" ? "L" : "R";
            if (str.length == 0 || direction == "ltr" && !bidiRE.test(str)) return false;
            var len = str.length, types = [];
            for(var i = 0; i < len; ++i)types.push(charType(str.charCodeAt(i)));
            // W1. Examine each non-spacing mark (NSM) in the level run, and
            // change the type of the NSM to the type of the previous
            // character. If the NSM is at the start of the level run, it will
            // get the type of sor.
            for(var i$1 = 0, prev = outerType; i$1 < len; ++i$1){
                var type = types[i$1];
                if (type == "m") types[i$1] = prev;
                else prev = type;
            }
            // W2. Search backwards from each instance of a European number
            // until the first strong type (R, L, AL, or sor) is found. If an
            // AL is found, change the type of the European number to Arabic
            // number.
            // W3. Change all ALs to R.
            for(var i$2 = 0, cur = outerType; i$2 < len; ++i$2){
                var type$1 = types[i$2];
                if (type$1 == "1" && cur == "r") types[i$2] = "n";
                else if (isStrong.test(type$1)) {
                    cur = type$1;
                    if (type$1 == "r") types[i$2] = "R";
                }
            }
            // W4. A single European separator between two European numbers
            // changes to a European number. A single common separator between
            // two numbers of the same type changes to that type.
            for(var i$3 = 1, prev$1 = types[0]; i$3 < len - 1; ++i$3){
                var type$2 = types[i$3];
                if (type$2 == "+" && prev$1 == "1" && types[i$3 + 1] == "1") types[i$3] = "1";
                else if (type$2 == "," && prev$1 == types[i$3 + 1] && (prev$1 == "1" || prev$1 == "n")) types[i$3] = prev$1;
                prev$1 = type$2;
            }
            // W5. A sequence of European terminators adjacent to European
            // numbers changes to all European numbers.
            // W6. Otherwise, separators and terminators change to Other
            // Neutral.
            for(var i$4 = 0; i$4 < len; ++i$4){
                var type$3 = types[i$4];
                if (type$3 == ",") types[i$4] = "N";
                else if (type$3 == "%") {
                    var end = void 0;
                    for(end = i$4 + 1; end < len && types[end] == "%"; ++end);
                    var replace = i$4 && types[i$4 - 1] == "!" || end < len && types[end] == "1" ? "1" : "N";
                    for(var j = i$4; j < end; ++j)types[j] = replace;
                    i$4 = end - 1;
                }
            }
            // W7. Search backwards from each instance of a European number
            // until the first strong type (R, L, or sor) is found. If an L is
            // found, then change the type of the European number to L.
            for(var i$5 = 0, cur$1 = outerType; i$5 < len; ++i$5){
                var type$4 = types[i$5];
                if (cur$1 == "L" && type$4 == "1") types[i$5] = "L";
                else if (isStrong.test(type$4)) cur$1 = type$4;
            }
            // N1. A sequence of neutrals takes the direction of the
            // surrounding strong text if the text on both sides has the same
            // direction. European and Arabic numbers act as if they were R in
            // terms of their influence on neutrals. Start-of-level-run (sor)
            // and end-of-level-run (eor) are used at level run boundaries.
            // N2. Any remaining neutrals take the embedding direction.
            for(var i$6 = 0; i$6 < len; ++i$6)if (isNeutral.test(types[i$6])) {
                var end$1 = void 0;
                for(end$1 = i$6 + 1; end$1 < len && isNeutral.test(types[end$1]); ++end$1);
                var before = (i$6 ? types[i$6 - 1] : outerType) == "L";
                var after = (end$1 < len ? types[end$1] : outerType) == "L";
                var replace$1 = before == after ? before ? "L" : "R" : outerType;
                for(var j$1 = i$6; j$1 < end$1; ++j$1)types[j$1] = replace$1;
                i$6 = end$1 - 1;
            }
            // Here we depart from the documented algorithm, in order to avoid
            // building up an actual levels array. Since there are only three
            // levels (0, 1, 2) in an implementation that doesn't take
            // explicit embedding into account, we can build up the order on
            // the fly, without following the level-based algorithm.
            var order = [], m;
            for(var i$7 = 0; i$7 < len;)if (countsAsLeft.test(types[i$7])) {
                var start = i$7;
                for(++i$7; i$7 < len && countsAsLeft.test(types[i$7]); ++i$7);
                order.push(new BidiSpan(0, start, i$7));
            } else {
                var pos = i$7, at = order.length;
                for(++i$7; i$7 < len && types[i$7] != "L"; ++i$7);
                for(var j$2 = pos; j$2 < i$7;)if (countsAsNum.test(types[j$2])) {
                    if (pos < j$2) order.splice(at, 0, new BidiSpan(1, pos, j$2));
                    var nstart = j$2;
                    for(++j$2; j$2 < i$7 && countsAsNum.test(types[j$2]); ++j$2);
                    order.splice(at, 0, new BidiSpan(2, nstart, j$2));
                    pos = j$2;
                } else ++j$2;
                if (pos < i$7) order.splice(at, 0, new BidiSpan(1, pos, i$7));
            }
            if (direction == "ltr") {
                if (order[0].level == 1 && (m = str.match(/^\s+/))) {
                    order[0].from = m[0].length;
                    order.unshift(new BidiSpan(0, 0, m[0].length));
                }
                if (lst(order).level == 1 && (m = str.match(/\s+$/))) {
                    lst(order).to -= m[0].length;
                    order.push(new BidiSpan(0, len - m[0].length, len));
                }
            }
            return direction == "rtl" ? order.reverse() : order;
        };
    }();
    // Get the bidi ordering for the given line (and cache it). Returns
    // false for lines that are fully left-to-right, and an array of
    // BidiSpan objects otherwise.
    function getOrder(line, direction) {
        var order = line.order;
        if (order == null) order = line.order = bidiOrdering(line.text, direction);
        return order;
    }
    // EVENT HANDLING
    // Lightweight event framework. on/off also work on DOM nodes,
    // registering native DOM handlers.
    var noHandlers = [];
    var on = function(emitter, type, f) {
        if (emitter.addEventListener) emitter.addEventListener(type, f, false);
        else if (emitter.attachEvent) emitter.attachEvent("on" + type, f);
        else {
            var map$$1 = emitter._handlers || (emitter._handlers = {});
            map$$1[type] = (map$$1[type] || noHandlers).concat(f);
        }
    };
    function getHandlers(emitter, type) {
        return emitter._handlers && emitter._handlers[type] || noHandlers;
    }
    function off(emitter, type, f) {
        if (emitter.removeEventListener) emitter.removeEventListener(type, f, false);
        else if (emitter.detachEvent) emitter.detachEvent("on" + type, f);
        else {
            var map$$1 = emitter._handlers, arr = map$$1 && map$$1[type];
            if (arr) {
                var index = indexOf(arr, f);
                if (index > -1) map$$1[type] = arr.slice(0, index).concat(arr.slice(index + 1));
            }
        }
    }
    function signal(emitter, type /*, values...*/ ) {
        var handlers = getHandlers(emitter, type);
        if (!handlers.length) return;
        var args = Array.prototype.slice.call(arguments, 2);
        for(var i = 0; i < handlers.length; ++i)handlers[i].apply(null, args);
    }
    // The DOM events that CodeMirror handles can be overridden by
    // registering a (non-DOM) handler on the editor for the event name,
    // and preventDefault-ing the event in that handler.
    function signalDOMEvent(cm, e, override) {
        if (typeof e == "string") e = {
            type: e,
            preventDefault: function() {
                this.defaultPrevented = true;
            }
        };
        signal(cm, override || e.type, cm, e);
        return e_defaultPrevented(e) || e.codemirrorIgnore;
    }
    function signalCursorActivity(cm) {
        var arr = cm._handlers && cm._handlers.cursorActivity;
        if (!arr) return;
        var set = cm.curOp.cursorActivityHandlers || (cm.curOp.cursorActivityHandlers = []);
        for(var i = 0; i < arr.length; ++i)if (indexOf(set, arr[i]) == -1) set.push(arr[i]);
    }
    function hasHandler(emitter, type) {
        return getHandlers(emitter, type).length > 0;
    }
    // Add on and off methods to a constructor's prototype, to make
    // registering events on such objects more convenient.
    function eventMixin(ctor) {
        ctor.prototype.on = function(type, f) {
            on(this, type, f);
        };
        ctor.prototype.off = function(type, f) {
            off(this, type, f);
        };
    }
    // Due to the fact that we still support jurassic IE versions, some
    // compatibility wrappers are needed.
    function e_preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
    }
    function e_stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else e.cancelBubble = true;
    }
    function e_defaultPrevented(e) {
        return e.defaultPrevented != null ? e.defaultPrevented : e.returnValue == false;
    }
    function e_stop(e) {
        e_preventDefault(e);
        e_stopPropagation(e);
    }
    function e_target(e) {
        return e.target || e.srcElement;
    }
    function e_button(e) {
        var b = e.which;
        if (b == null) {
            if (e.button & 1) b = 1;
            else if (e.button & 2) b = 3;
            else if (e.button & 4) b = 2;
        }
        if (mac && e.ctrlKey && b == 1) b = 3;
        return b;
    }
    // Detect drag-and-drop
    var dragAndDrop = function() {
        // There is *some* kind of drag-and-drop support in IE6-8, but I
        // couldn't get it to work yet.
        if (ie && ie_version < 9) return false;
        var div = elt("div");
        return "draggable" in div || "dragDrop" in div;
    }();
    var zwspSupported;
    function zeroWidthElement(measure) {
        if (zwspSupported == null) {
            var test = elt("span", "​");
            removeChildrenAndAdd(measure, elt("span", [
                test,
                document.createTextNode("x")
            ]));
            if (measure.firstChild.offsetHeight != 0) zwspSupported = test.offsetWidth <= 1 && test.offsetHeight > 2 && !(ie && ie_version < 8);
        }
        var node = zwspSupported ? elt("span", "​") : elt("span", "\xa0", null, "display: inline-block; width: 1px; margin-right: -1px");
        node.setAttribute("cm-text", "");
        return node;
    }
    // Feature-detect IE's crummy client rect reporting for bidi text
    var badBidiRects;
    function hasBadBidiRects(measure) {
        if (badBidiRects != null) return badBidiRects;
        var txt = removeChildrenAndAdd(measure, document.createTextNode("AخA"));
        var r0 = range(txt, 0, 1).getBoundingClientRect();
        var r1 = range(txt, 1, 2).getBoundingClientRect();
        removeChildren(measure);
        if (!r0 || r0.left == r0.right) return false;
         // Safari returns null in some cases (#2780)
        return badBidiRects = r1.right - r0.right < 3;
    }
    // See if "".split is the broken IE version, if so, provide an
    // alternative way to split lines.
    var splitLinesAuto = "\n\nb".split(/\n/).length != 3 ? function(string) {
        var pos = 0, result = [], l = string.length;
        while(pos <= l){
            var nl = string.indexOf("\n", pos);
            if (nl == -1) nl = string.length;
            var line = string.slice(pos, string.charAt(nl - 1) == "\r" ? nl - 1 : nl);
            var rt = line.indexOf("\r");
            if (rt != -1) {
                result.push(line.slice(0, rt));
                pos += rt + 1;
            } else {
                result.push(line);
                pos = nl + 1;
            }
        }
        return result;
    } : function(string) {
        return string.split(/\r\n?|\n/);
    };
    var hasSelection = window.getSelection ? function(te) {
        try {
            return te.selectionStart != te.selectionEnd;
        } catch (e) {
            return false;
        }
    } : function(te) {
        var range$$1;
        try {
            range$$1 = te.ownerDocument.selection.createRange();
        } catch (e) {}
        if (!range$$1 || range$$1.parentElement() != te) return false;
        return range$$1.compareEndPoints("StartToEnd", range$$1) != 0;
    };
    var hasCopyEvent = function() {
        var e = elt("div");
        if ("oncopy" in e) return true;
        e.setAttribute("oncopy", "return;");
        return typeof e.oncopy == "function";
    }();
    var badZoomedRects = null;
    function hasBadZoomedRects(measure) {
        if (badZoomedRects != null) return badZoomedRects;
        var node = removeChildrenAndAdd(measure, elt("span", "x"));
        var normal = node.getBoundingClientRect();
        var fromRange = range(node, 0, 1).getBoundingClientRect();
        return badZoomedRects = Math.abs(normal.left - fromRange.left) > 1;
    }
    // Known modes, by name and by MIME
    var modes = {}, mimeModes = {};
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    function defineMode(name, mode) {
        if (arguments.length > 2) mode.dependencies = Array.prototype.slice.call(arguments, 2);
        modes[name] = mode;
    }
    function defineMIME(mime, spec) {
        mimeModes[mime] = spec;
    }
    // Given a MIME type, a {name, ...options} config object, or a name
    // string, return a mode config object.
    function resolveMode(spec) {
        if (typeof spec == "string" && mimeModes.hasOwnProperty(spec)) spec = mimeModes[spec];
        else if (spec && typeof spec.name == "string" && mimeModes.hasOwnProperty(spec.name)) {
            var found = mimeModes[spec.name];
            if (typeof found == "string") found = {
                name: found
            };
            spec = createObj(found, spec);
            spec.name = found.name;
        } else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+xml$/.test(spec)) return resolveMode("application/xml");
        else if (typeof spec == "string" && /^[\w\-]+\/[\w\-]+\+json$/.test(spec)) return resolveMode("application/json");
        if (typeof spec == "string") return {
            name: spec
        };
        else return spec || {
            name: "null"
        };
    }
    // Given a mode spec (anything that resolveMode accepts), find and
    // initialize an actual mode object.
    function getMode(options, spec) {
        spec = resolveMode(spec);
        var mfactory = modes[spec.name];
        if (!mfactory) return getMode(options, "text/plain");
        var modeObj = mfactory(options, spec);
        if (modeExtensions.hasOwnProperty(spec.name)) {
            var exts = modeExtensions[spec.name];
            for(var prop in exts){
                if (!exts.hasOwnProperty(prop)) continue;
                if (modeObj.hasOwnProperty(prop)) modeObj["_" + prop] = modeObj[prop];
                modeObj[prop] = exts[prop];
            }
        }
        modeObj.name = spec.name;
        if (spec.helperType) modeObj.helperType = spec.helperType;
        if (spec.modeProps) for(var prop$1 in spec.modeProps)modeObj[prop$1] = spec.modeProps[prop$1];
        return modeObj;
    }
    // This can be used to attach properties to mode objects from
    // outside the actual mode definition.
    var modeExtensions = {};
    function extendMode(mode, properties) {
        var exts = modeExtensions.hasOwnProperty(mode) ? modeExtensions[mode] : modeExtensions[mode] = {};
        copyObj(properties, exts);
    }
    function copyState(mode, state) {
        if (state === true) return state;
        if (mode.copyState) return mode.copyState(state);
        var nstate = {};
        for(var n in state){
            var val = state[n];
            if (val instanceof Array) val = val.concat([]);
            nstate[n] = val;
        }
        return nstate;
    }
    // Given a mode and a state (for that mode), find the inner mode and
    // state at the position that the state refers to.
    function innerMode(mode, state) {
        var info;
        while(mode.innerMode){
            info = mode.innerMode(state);
            if (!info || info.mode == mode) break;
            state = info.state;
            mode = info.mode;
        }
        return info || {
            mode: mode,
            state: state
        };
    }
    function startState(mode, a1, a2) {
        return mode.startState ? mode.startState(a1, a2) : true;
    }
    // STRING STREAM
    // Fed to the mode parsers, provides helper functions to make
    // parsers more succinct.
    var StringStream = function(string, tabSize, lineOracle) {
        this.pos = this.start = 0;
        this.string = string;
        this.tabSize = tabSize || 8;
        this.lastColumnPos = this.lastColumnValue = 0;
        this.lineStart = 0;
        this.lineOracle = lineOracle;
    };
    StringStream.prototype.eol = function() {
        return this.pos >= this.string.length;
    };
    StringStream.prototype.sol = function() {
        return this.pos == this.lineStart;
    };
    StringStream.prototype.peek = function() {
        return this.string.charAt(this.pos) || undefined;
    };
    StringStream.prototype.next = function() {
        if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    };
    StringStream.prototype.eat = function(match) {
        var ch = this.string.charAt(this.pos);
        var ok;
        if (typeof match == "string") ok = ch == match;
        else ok = ch && (match.test ? match.test(ch) : match(ch));
        if (ok) {
            ++this.pos;
            return ch;
        }
    };
    StringStream.prototype.eatWhile = function(match) {
        var start = this.pos;
        while(this.eat(match));
        return this.pos > start;
    };
    StringStream.prototype.eatSpace = function() {
        var this$1 = this;
        var start = this.pos;
        while(/[\s\u00a0]/.test(this.string.charAt(this.pos)))++this$1.pos;
        return this.pos > start;
    };
    StringStream.prototype.skipToEnd = function() {
        this.pos = this.string.length;
    };
    StringStream.prototype.skipTo = function(ch) {
        var found = this.string.indexOf(ch, this.pos);
        if (found > -1) {
            this.pos = found;
            return true;
        }
    };
    StringStream.prototype.backUp = function(n) {
        this.pos -= n;
    };
    StringStream.prototype.column = function() {
        if (this.lastColumnPos < this.start) {
            this.lastColumnValue = countColumn(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue);
            this.lastColumnPos = this.start;
        }
        return this.lastColumnValue - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.indentation = function() {
        return countColumn(this.string, null, this.tabSize) - (this.lineStart ? countColumn(this.string, this.lineStart, this.tabSize) : 0);
    };
    StringStream.prototype.match = function(pattern, consume, caseInsensitive) {
        if (typeof pattern == "string") {
            var cased = function(str) {
                return caseInsensitive ? str.toLowerCase() : str;
            };
            var substr = this.string.substr(this.pos, pattern.length);
            if (cased(substr) == cased(pattern)) {
                if (consume !== false) this.pos += pattern.length;
                return true;
            }
        } else {
            var match = this.string.slice(this.pos).match(pattern);
            if (match && match.index > 0) return null;
            if (match && consume !== false) this.pos += match[0].length;
            return match;
        }
    };
    StringStream.prototype.current = function() {
        return this.string.slice(this.start, this.pos);
    };
    StringStream.prototype.hideFirstChars = function(n, inner) {
        this.lineStart += n;
        try {
            return inner();
        } finally{
            this.lineStart -= n;
        }
    };
    StringStream.prototype.lookAhead = function(n) {
        var oracle = this.lineOracle;
        return oracle && oracle.lookAhead(n);
    };
    StringStream.prototype.baseToken = function() {
        var oracle = this.lineOracle;
        return oracle && oracle.baseToken(this.pos);
    };
    // Find the line object corresponding to the given line number.
    function getLine(doc, n) {
        n -= doc.first;
        if (n < 0 || n >= doc.size) throw new Error("There is no line " + (n + doc.first) + " in the document.");
        var chunk = doc;
        while(!chunk.lines)for(var i = 0;; ++i){
            var child = chunk.children[i], sz = child.chunkSize();
            if (n < sz) {
                chunk = child;
                break;
            }
            n -= sz;
        }
        return chunk.lines[n];
    }
    // Get the part of a document between two positions, as an array of
    // strings.
    function getBetween(doc, start, end) {
        var out = [], n = start.line;
        doc.iter(start.line, end.line + 1, function(line) {
            var text = line.text;
            if (n == end.line) text = text.slice(0, end.ch);
            if (n == start.line) text = text.slice(start.ch);
            out.push(text);
            ++n;
        });
        return out;
    }
    // Get the lines between from and to, as array of strings.
    function getLines(doc, from, to) {
        var out = [];
        doc.iter(from, to, function(line) {
            out.push(line.text);
        }); // iter aborts when callback returns truthy value
        return out;
    }
    // Update the height of a line, propagating the height change
    // upwards to parent nodes.
    function updateLineHeight(line, height) {
        var diff = height - line.height;
        if (diff) for(var n = line; n; n = n.parent)n.height += diff;
    }
    // Given a line object, find its line number by walking up through
    // its parent links.
    function lineNo(line) {
        if (line.parent == null) return null;
        var cur = line.parent, no = indexOf(cur.lines, line);
        for(var chunk = cur.parent; chunk; cur = chunk, chunk = chunk.parent)for(var i = 0;; ++i){
            if (chunk.children[i] == cur) break;
            no += chunk.children[i].chunkSize();
        }
        return no + cur.first;
    }
    // Find the line at the given vertical position, using the height
    // information in the document tree.
    function lineAtHeight(chunk, h) {
        var n = chunk.first;
        outer: do {
            for(var i$1 = 0; i$1 < chunk.children.length; ++i$1){
                var child = chunk.children[i$1], ch = child.height;
                if (h < ch) {
                    chunk = child;
                    continue outer;
                }
                h -= ch;
                n += child.chunkSize();
            }
            return n;
        }while (!chunk.lines);
        var i = 0;
        for(; i < chunk.lines.length; ++i){
            var line = chunk.lines[i], lh = line.height;
            if (h < lh) break;
            h -= lh;
        }
        return n + i;
    }
    function isLine(doc, l) {
        return l >= doc.first && l < doc.first + doc.size;
    }
    function lineNumberFor(options, i) {
        return String(options.lineNumberFormatter(i + options.firstLineNumber));
    }
    // A Pos instance represents a position within the text.
    function Pos(line, ch, sticky) {
        if (sticky === void 0) sticky = null;
        if (!(this instanceof Pos)) return new Pos(line, ch, sticky);
        this.line = line;
        this.ch = ch;
        this.sticky = sticky;
    }
    // Compare two positions, return 0 if they are the same, a negative
    // number when a is less, and a positive number otherwise.
    function cmp(a, b) {
        return a.line - b.line || a.ch - b.ch;
    }
    function equalCursorPos(a, b) {
        return a.sticky == b.sticky && cmp(a, b) == 0;
    }
    function copyPos(x) {
        return Pos(x.line, x.ch);
    }
    function maxPos(a, b) {
        return cmp(a, b) < 0 ? b : a;
    }
    function minPos(a, b) {
        return cmp(a, b) < 0 ? a : b;
    }
    // Most of the external API clips given positions to make sure they
    // actually exist within the document.
    function clipLine(doc, n) {
        return Math.max(doc.first, Math.min(n, doc.first + doc.size - 1));
    }
    function clipPos(doc, pos) {
        if (pos.line < doc.first) return Pos(doc.first, 0);
        var last = doc.first + doc.size - 1;
        if (pos.line > last) return Pos(last, getLine(doc, last).text.length);
        return clipToLen(pos, getLine(doc, pos.line).text.length);
    }
    function clipToLen(pos, linelen) {
        var ch = pos.ch;
        if (ch == null || ch > linelen) return Pos(pos.line, linelen);
        else if (ch < 0) return Pos(pos.line, 0);
        else return pos;
    }
    function clipPosArray(doc, array) {
        var out = [];
        for(var i = 0; i < array.length; i++)out[i] = clipPos(doc, array[i]);
        return out;
    }
    var SavedContext = function(state, lookAhead) {
        this.state = state;
        this.lookAhead = lookAhead;
    };
    var Context = function(doc, state, line, lookAhead) {
        this.state = state;
        this.doc = doc;
        this.line = line;
        this.maxLookAhead = lookAhead || 0;
        this.baseTokens = null;
        this.baseTokenPos = 1;
    };
    Context.prototype.lookAhead = function(n) {
        var line = this.doc.getLine(this.line + n);
        if (line != null && n > this.maxLookAhead) this.maxLookAhead = n;
        return line;
    };
    Context.prototype.baseToken = function(n) {
        var this$1 = this;
        if (!this.baseTokens) return null;
        while(this.baseTokens[this.baseTokenPos] <= n)this$1.baseTokenPos += 2;
        var type = this.baseTokens[this.baseTokenPos + 1];
        return {
            type: type && type.replace(/( |^)overlay .*/, ""),
            size: this.baseTokens[this.baseTokenPos] - n
        };
    };
    Context.prototype.nextLine = function() {
        this.line++;
        if (this.maxLookAhead > 0) this.maxLookAhead--;
    };
    Context.fromSaved = function(doc, saved, line) {
        if (saved instanceof SavedContext) return new Context(doc, copyState(doc.mode, saved.state), line, saved.lookAhead);
        else return new Context(doc, copyState(doc.mode, saved), line);
    };
    Context.prototype.save = function(copy) {
        var state = copy !== false ? copyState(this.doc.mode, this.state) : this.state;
        return this.maxLookAhead > 0 ? new SavedContext(state, this.maxLookAhead) : state;
    };
    // Compute a style array (an array starting with a mode generation
    // -- for invalidation -- followed by pairs of end positions and
    // style strings), which is used to highlight the tokens on the
    // line.
    function highlightLine(cm, line, context, forceToEnd) {
        // A styles array always starts with a number identifying the
        // mode/overlays that it is based on (for easy invalidation).
        var st = [
            cm.state.modeGen
        ], lineClasses = {};
        // Compute the base array of styles
        runMode(cm, line.text, cm.doc.mode, context, function(end, style) {
            return st.push(end, style);
        }, lineClasses, forceToEnd);
        var state = context.state;
        // Run overlays, adjust style array.
        var loop = function(o) {
            context.baseTokens = st;
            var overlay = cm.state.overlays[o], i = 1, at = 0;
            context.state = true;
            runMode(cm, line.text, overlay.mode, context, function(end, style) {
                var start = i;
                // Ensure there's a token end at the current position, and that i points at it
                while(at < end){
                    var i_end = st[i];
                    if (i_end > end) st.splice(i, 1, end, st[i + 1], i_end);
                    i += 2;
                    at = Math.min(end, i_end);
                }
                if (!style) return;
                if (overlay.opaque) {
                    st.splice(start, i - start, end, "overlay " + style);
                    i = start + 2;
                } else for(; start < i; start += 2){
                    var cur = st[start + 1];
                    st[start + 1] = (cur ? cur + " " : "") + "overlay " + style;
                }
            }, lineClasses);
            context.state = state;
            context.baseTokens = null;
            context.baseTokenPos = 1;
        };
        for(var o = 0; o < cm.state.overlays.length; ++o)loop(o);
        return {
            styles: st,
            classes: lineClasses.bgClass || lineClasses.textClass ? lineClasses : null
        };
    }
    function getLineStyles(cm, line, updateFrontier) {
        if (!line.styles || line.styles[0] != cm.state.modeGen) {
            var context = getContextBefore(cm, lineNo(line));
            var resetState = line.text.length > cm.options.maxHighlightLength && copyState(cm.doc.mode, context.state);
            var result = highlightLine(cm, line, context);
            if (resetState) context.state = resetState;
            line.stateAfter = context.save(!resetState);
            line.styles = result.styles;
            if (result.classes) line.styleClasses = result.classes;
            else if (line.styleClasses) line.styleClasses = null;
            if (updateFrontier === cm.doc.highlightFrontier) cm.doc.modeFrontier = Math.max(cm.doc.modeFrontier, ++cm.doc.highlightFrontier);
        }
        return line.styles;
    }
    function getContextBefore(cm, n, precise) {
        var doc = cm.doc, display = cm.display;
        if (!doc.mode.startState) return new Context(doc, true, n);
        var start = findStartLine(cm, n, precise);
        var saved = start > doc.first && getLine(doc, start - 1).stateAfter;
        var context = saved ? Context.fromSaved(doc, saved, start) : new Context(doc, startState(doc.mode), start);
        doc.iter(start, n, function(line) {
            processLine(cm, line.text, context);
            var pos = context.line;
            line.stateAfter = pos == n - 1 || pos % 5 == 0 || pos >= display.viewFrom && pos < display.viewTo ? context.save() : null;
            context.nextLine();
        });
        if (precise) doc.modeFrontier = context.line;
        return context;
    }
    // Lightweight form of highlight -- proceed over this line and
    // update state, but don't save a style array. Used for lines that
    // aren't currently visible.
    function processLine(cm, text, context, startAt) {
        var mode = cm.doc.mode;
        var stream = new StringStream(text, cm.options.tabSize, context);
        stream.start = stream.pos = startAt || 0;
        if (text == "") callBlankLine(mode, context.state);
        while(!stream.eol()){
            readToken(mode, stream, context.state);
            stream.start = stream.pos;
        }
    }
    function callBlankLine(mode, state) {
        if (mode.blankLine) return mode.blankLine(state);
        if (!mode.innerMode) return;
        var inner = innerMode(mode, state);
        if (inner.mode.blankLine) return inner.mode.blankLine(inner.state);
    }
    function readToken(mode, stream, state, inner) {
        for(var i = 0; i < 10; i++){
            if (inner) inner[0] = innerMode(mode, state).mode;
            var style = mode.token(stream, state);
            if (stream.pos > stream.start) return style;
        }
        throw new Error("Mode " + mode.name + " failed to advance stream.");
    }
    var Token = function(stream, type, state) {
        this.start = stream.start;
        this.end = stream.pos;
        this.string = stream.current();
        this.type = type || null;
        this.state = state;
    };
    // Utility for getTokenAt and getLineTokens
    function takeToken(cm, pos, precise, asArray) {
        var doc = cm.doc, mode = doc.mode, style;
        pos = clipPos(doc, pos);
        var line = getLine(doc, pos.line), context = getContextBefore(cm, pos.line, precise);
        var stream = new StringStream(line.text, cm.options.tabSize, context), tokens;
        if (asArray) tokens = [];
        while((asArray || stream.pos < pos.ch) && !stream.eol()){
            stream.start = stream.pos;
            style = readToken(mode, stream, context.state);
            if (asArray) tokens.push(new Token(stream, style, copyState(doc.mode, context.state)));
        }
        return asArray ? tokens : new Token(stream, style, context.state);
    }
    function extractLineClasses(type, output) {
        if (type) for(;;){
            var lineClass = type.match(/(?:^|\s+)line-(background-)?(\S+)/);
            if (!lineClass) break;
            type = type.slice(0, lineClass.index) + type.slice(lineClass.index + lineClass[0].length);
            var prop = lineClass[1] ? "bgClass" : "textClass";
            if (output[prop] == null) output[prop] = lineClass[2];
            else if (!new RegExp("(?:^|s)" + lineClass[2] + "(?:$|s)").test(output[prop])) output[prop] += " " + lineClass[2];
        }
        return type;
    }
    // Run the given mode's parser over a line, calling f for each token.
    function runMode(cm, text, mode, context, f, lineClasses, forceToEnd) {
        var flattenSpans = mode.flattenSpans;
        if (flattenSpans == null) flattenSpans = cm.options.flattenSpans;
        var curStart = 0, curStyle = null;
        var stream = new StringStream(text, cm.options.tabSize, context), style;
        var inner = cm.options.addModeClass && [
            null
        ];
        if (text == "") extractLineClasses(callBlankLine(mode, context.state), lineClasses);
        while(!stream.eol()){
            if (stream.pos > cm.options.maxHighlightLength) {
                flattenSpans = false;
                if (forceToEnd) processLine(cm, text, context, stream.pos);
                stream.pos = text.length;
                style = null;
            } else style = extractLineClasses(readToken(mode, stream, context.state, inner), lineClasses);
            if (inner) {
                var mName = inner[0].name;
                if (mName) style = "m-" + (style ? mName + " " + style : mName);
            }
            if (!flattenSpans || curStyle != style) {
                while(curStart < stream.start){
                    curStart = Math.min(stream.start, curStart + 5000);
                    f(curStart, curStyle);
                }
                curStyle = style;
            }
            stream.start = stream.pos;
        }
        while(curStart < stream.pos){
            // Webkit seems to refuse to render text nodes longer than 57444
            // characters, and returns inaccurate measurements in nodes
            // starting around 5000 chars.
            var pos = Math.min(stream.pos, curStart + 5000);
            f(pos, curStyle);
            curStart = pos;
        }
    }
    // Finds the line to start with when starting a parse. Tries to
    // find a line with a stateAfter, so that it can start with a
    // valid state. If that fails, it returns the line with the
    // smallest indentation, which tends to need the least context to
    // parse correctly.
    function findStartLine(cm, n, precise) {
        var minindent, minline, doc = cm.doc;
        var lim = precise ? -1 : n - (cm.doc.mode.innerMode ? 1000 : 100);
        for(var search = n; search > lim; --search){
            if (search <= doc.first) return doc.first;
            var line = getLine(doc, search - 1), after = line.stateAfter;
            if (after && (!precise || search + (after instanceof SavedContext ? after.lookAhead : 0) <= doc.modeFrontier)) return search;
            var indented = countColumn(line.text, null, cm.options.tabSize);
            if (minline == null || minindent > indented) {
                minline = search - 1;
                minindent = indented;
            }
        }
        return minline;
    }
    function retreatFrontier(doc, n) {
        doc.modeFrontier = Math.min(doc.modeFrontier, n);
        if (doc.highlightFrontier < n - 10) return;
        var start = doc.first;
        for(var line = n - 1; line > start; line--){
            var saved = getLine(doc, line).stateAfter;
            // change is on 3
            // state on line 1 looked ahead 2 -- so saw 3
            // test 1 + 2 < 3 should cover this
            if (saved && (!(saved instanceof SavedContext) || line + saved.lookAhead < n)) {
                start = line + 1;
                break;
            }
        }
        doc.highlightFrontier = Math.min(doc.highlightFrontier, start);
    }
    // Optimize some code when these features are not used.
    var sawReadOnlySpans = false, sawCollapsedSpans = false;
    function seeReadOnlySpans() {
        sawReadOnlySpans = true;
    }
    function seeCollapsedSpans() {
        sawCollapsedSpans = true;
    }
    // TEXTMARKER SPANS
    function MarkedSpan(marker, from, to) {
        this.marker = marker;
        this.from = from;
        this.to = to;
    }
    // Search an array of spans for a span matching the given marker.
    function getMarkedSpanFor(spans, marker) {
        if (spans) for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.marker == marker) return span;
        }
    }
    // Remove a span from an array, returning undefined if no spans are
    // left (we don't store arrays for lines without spans).
    function removeMarkedSpan(spans, span) {
        var r;
        for(var i = 0; i < spans.length; ++i)if (spans[i] != span) (r || (r = [])).push(spans[i]);
        return r;
    }
    // Add a span to a line.
    function addMarkedSpan(line, span) {
        line.markedSpans = line.markedSpans ? line.markedSpans.concat([
            span
        ]) : [
            span
        ];
        span.marker.attachLine(line);
    }
    // Used for the algorithm that adjusts markers for a change in the
    // document. These functions cut an array of spans at a given
    // character position, returning an array of remaining chunks (or
    // undefined if nothing remains).
    function markedSpansBefore(old, startCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= startCh : span.from < startCh);
            if (startsBefore || span.from == startCh && marker.type == "bookmark" && (!isInsert || !span.marker.insertLeft)) {
                var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= startCh : span.to > startCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, span.from, endsAfter ? null : span.to));
            }
        }
        return nw;
    }
    function markedSpansAfter(old, endCh, isInsert) {
        var nw;
        if (old) for(var i = 0; i < old.length; ++i){
            var span = old[i], marker = span.marker;
            var endsAfter = span.to == null || (marker.inclusiveRight ? span.to >= endCh : span.to > endCh);
            if (endsAfter || span.from == endCh && marker.type == "bookmark" && (!isInsert || span.marker.insertLeft)) {
                var startsBefore = span.from == null || (marker.inclusiveLeft ? span.from <= endCh : span.from < endCh);
                (nw || (nw = [])).push(new MarkedSpan(marker, startsBefore ? null : span.from - endCh, span.to == null ? null : span.to - endCh));
            }
        }
        return nw;
    }
    // Given a change object, compute the new set of marker spans that
    // cover the line in which the change took place. Removes spans
    // entirely within the change, reconnects spans belonging to the
    // same marker that appear on both sides of the change, and cuts off
    // spans partially within the change. Returns an array of span
    // arrays with one element for each line in (after) the change.
    function stretchSpansOverChange(doc, change) {
        if (change.full) return null;
        var oldFirst = isLine(doc, change.from.line) && getLine(doc, change.from.line).markedSpans;
        var oldLast = isLine(doc, change.to.line) && getLine(doc, change.to.line).markedSpans;
        if (!oldFirst && !oldLast) return null;
        var startCh = change.from.ch, endCh = change.to.ch, isInsert = cmp(change.from, change.to) == 0;
        // Get the spans that 'stick out' on both sides
        var first = markedSpansBefore(oldFirst, startCh, isInsert);
        var last = markedSpansAfter(oldLast, endCh, isInsert);
        // Next, merge those two ends
        var sameLine = change.text.length == 1, offset = lst(change.text).length + (sameLine ? startCh : 0);
        if (first) // Fix up .to properties of first
        for(var i = 0; i < first.length; ++i){
            var span = first[i];
            if (span.to == null) {
                var found = getMarkedSpanFor(last, span.marker);
                if (!found) span.to = startCh;
                else if (sameLine) span.to = found.to == null ? null : found.to + offset;
            }
        }
        if (last) // Fix up .from in last (or move them into first in case of sameLine)
        for(var i$1 = 0; i$1 < last.length; ++i$1){
            var span$1 = last[i$1];
            if (span$1.to != null) span$1.to += offset;
            if (span$1.from == null) {
                var found$1 = getMarkedSpanFor(first, span$1.marker);
                if (!found$1) {
                    span$1.from = offset;
                    if (sameLine) (first || (first = [])).push(span$1);
                }
            } else {
                span$1.from += offset;
                if (sameLine) (first || (first = [])).push(span$1);
            }
        }
        // Make sure we didn't create any zero-length spans
        if (first) first = clearEmptySpans(first);
        if (last && last != first) last = clearEmptySpans(last);
        var newMarkers = [
            first
        ];
        if (!sameLine) {
            // Fill gap with whole-line-spans
            var gap = change.text.length - 2, gapMarkers;
            if (gap > 0 && first) {
                for(var i$2 = 0; i$2 < first.length; ++i$2)if (first[i$2].to == null) (gapMarkers || (gapMarkers = [])).push(new MarkedSpan(first[i$2].marker, null, null));
            }
            for(var i$3 = 0; i$3 < gap; ++i$3)newMarkers.push(gapMarkers);
            newMarkers.push(last);
        }
        return newMarkers;
    }
    // Remove spans that are empty and don't have a clearWhenEmpty
    // option of false.
    function clearEmptySpans(spans) {
        for(var i = 0; i < spans.length; ++i){
            var span = spans[i];
            if (span.from != null && span.from == span.to && span.marker.clearWhenEmpty !== false) spans.splice(i--, 1);
        }
        if (!spans.length) return null;
        return spans;
    }
    // Used to 'clip' out readOnly ranges when making a change.
    function removeReadOnlyRanges(doc, from, to) {
        var markers = null;
        doc.iter(from.line, to.line + 1, function(line) {
            if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
                var mark = line.markedSpans[i].marker;
                if (mark.readOnly && (!markers || indexOf(markers, mark) == -1)) (markers || (markers = [])).push(mark);
            }
        });
        if (!markers) return null;
        var parts = [
            {
                from: from,
                to: to
            }
        ];
        for(var i = 0; i < markers.length; ++i){
            var mk = markers[i], m = mk.find(0);
            for(var j = 0; j < parts.length; ++j){
                var p = parts[j];
                if (cmp(p.to, m.from) < 0 || cmp(p.from, m.to) > 0) continue;
                var newParts = [
                    j,
                    1
                ], dfrom = cmp(p.from, m.from), dto = cmp(p.to, m.to);
                if (dfrom < 0 || !mk.inclusiveLeft && !dfrom) newParts.push({
                    from: p.from,
                    to: m.from
                });
                if (dto > 0 || !mk.inclusiveRight && !dto) newParts.push({
                    from: m.to,
                    to: p.to
                });
                parts.splice.apply(parts, newParts);
                j += newParts.length - 3;
            }
        }
        return parts;
    }
    // Connect or disconnect spans from a line.
    function detachMarkedSpans(line) {
        var spans = line.markedSpans;
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.detachLine(line);
        line.markedSpans = null;
    }
    function attachMarkedSpans(line, spans) {
        if (!spans) return;
        for(var i = 0; i < spans.length; ++i)spans[i].marker.attachLine(line);
        line.markedSpans = spans;
    }
    // Helpers used when computing which overlapping collapsed span
    // counts as the larger one.
    function extraLeft(marker) {
        return marker.inclusiveLeft ? -1 : 0;
    }
    function extraRight(marker) {
        return marker.inclusiveRight ? 1 : 0;
    }
    // Returns a number indicating which of two overlapping collapsed
    // spans is larger (and thus includes the other). Falls back to
    // comparing ids when the spans cover exactly the same range.
    function compareCollapsedMarkers(a, b) {
        var lenDiff = a.lines.length - b.lines.length;
        if (lenDiff != 0) return lenDiff;
        var aPos = a.find(), bPos = b.find();
        var fromCmp = cmp(aPos.from, bPos.from) || extraLeft(a) - extraLeft(b);
        if (fromCmp) return -fromCmp;
        var toCmp = cmp(aPos.to, bPos.to) || extraRight(a) - extraRight(b);
        if (toCmp) return toCmp;
        return b.id - a.id;
    }
    // Find out whether a line ends or starts in a collapsed span. If
    // so, return the marker for that span.
    function collapsedSpanAtSide(line, start) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (sp.marker.collapsed && (start ? sp.from : sp.to) == null && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    function collapsedSpanAtStart(line) {
        return collapsedSpanAtSide(line, true);
    }
    function collapsedSpanAtEnd(line) {
        return collapsedSpanAtSide(line, false);
    }
    function collapsedSpanAround(line, ch) {
        var sps = sawCollapsedSpans && line.markedSpans, found;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (sp.marker.collapsed && (sp.from == null || sp.from < ch) && (sp.to == null || sp.to > ch) && (!found || compareCollapsedMarkers(found, sp.marker) < 0)) found = sp.marker;
        }
        return found;
    }
    // Test whether there exists a collapsed span that partially
    // overlaps (covers the start or end, but not both) of a new span.
    // Such overlap is not allowed.
    function conflictingCollapsedRange(doc, lineNo$$1, from, to, marker) {
        var line = getLine(doc, lineNo$$1);
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var i = 0; i < sps.length; ++i){
            var sp = sps[i];
            if (!sp.marker.collapsed) continue;
            var found = sp.marker.find(0);
            var fromCmp = cmp(found.from, from) || extraLeft(sp.marker) - extraLeft(marker);
            var toCmp = cmp(found.to, to) || extraRight(sp.marker) - extraRight(marker);
            if (fromCmp >= 0 && toCmp <= 0 || fromCmp <= 0 && toCmp >= 0) continue;
            if (fromCmp <= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.to, from) >= 0 : cmp(found.to, from) > 0) || fromCmp >= 0 && (sp.marker.inclusiveRight && marker.inclusiveLeft ? cmp(found.from, to) <= 0 : cmp(found.from, to) < 0)) return true;
        }
    }
    // A visual line is a line as drawn on the screen. Folding, for
    // example, can cause multiple logical lines to appear on the same
    // visual line. This finds the start of the visual line that the
    // given line is part of (usually that is the line itself).
    function visualLine(line) {
        var merged;
        while(merged = collapsedSpanAtStart(line))line = merged.find(-1, true).line;
        return line;
    }
    function visualLineEnd(line) {
        var merged;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return line;
    }
    // Returns an array of logical lines that continue the visual line
    // started by the argument, or undefined if there are no such lines.
    function visualLineContinued(line) {
        var merged, lines;
        while(merged = collapsedSpanAtEnd(line)){
            line = merged.find(1, true).line;
            (lines || (lines = [])).push(line);
        }
        return lines;
    }
    // Get the line number of the start of the visual line that the
    // given line number is part of.
    function visualLineNo(doc, lineN) {
        var line = getLine(doc, lineN), vis = visualLine(line);
        if (line == vis) return lineN;
        return lineNo(vis);
    }
    // Get the line number of the start of the next visual line after
    // the given line.
    function visualLineEndNo(doc, lineN) {
        if (lineN > doc.lastLine()) return lineN;
        var line = getLine(doc, lineN), merged;
        if (!lineIsHidden(doc, line)) return lineN;
        while(merged = collapsedSpanAtEnd(line))line = merged.find(1, true).line;
        return lineNo(line) + 1;
    }
    // Compute whether a line is hidden. Lines count as hidden when they
    // are part of a visual line that starts with another line, or when
    // they are entirely covered by collapsed, non-widget span.
    function lineIsHidden(doc, line) {
        var sps = sawCollapsedSpans && line.markedSpans;
        if (sps) for(var sp = void 0, i = 0; i < sps.length; ++i){
            sp = sps[i];
            if (!sp.marker.collapsed) continue;
            if (sp.from == null) return true;
            if (sp.marker.widgetNode) continue;
            if (sp.from == 0 && sp.marker.inclusiveLeft && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    function lineIsHiddenInner(doc, line, span) {
        if (span.to == null) {
            var end = span.marker.find(1, true);
            return lineIsHiddenInner(doc, end.line, getMarkedSpanFor(end.line.markedSpans, span.marker));
        }
        if (span.marker.inclusiveRight && span.to == line.text.length) return true;
        for(var sp = void 0, i = 0; i < line.markedSpans.length; ++i){
            sp = line.markedSpans[i];
            if (sp.marker.collapsed && !sp.marker.widgetNode && sp.from == span.to && (sp.to == null || sp.to != span.from) && (sp.marker.inclusiveLeft || span.marker.inclusiveRight) && lineIsHiddenInner(doc, line, sp)) return true;
        }
    }
    // Find the height above the given line.
    function heightAtLine(lineObj) {
        lineObj = visualLine(lineObj);
        var h = 0, chunk = lineObj.parent;
        for(var i = 0; i < chunk.lines.length; ++i){
            var line = chunk.lines[i];
            if (line == lineObj) break;
            else h += line.height;
        }
        for(var p = chunk.parent; p; chunk = p, p = chunk.parent)for(var i$1 = 0; i$1 < p.children.length; ++i$1){
            var cur = p.children[i$1];
            if (cur == chunk) break;
            else h += cur.height;
        }
        return h;
    }
    // Compute the character length of a line, taking into account
    // collapsed ranges (see markText) that might hide parts, and join
    // other lines onto it.
    function lineLength(line) {
        if (line.height == 0) return 0;
        var len = line.text.length, merged, cur = line;
        while(merged = collapsedSpanAtStart(cur)){
            var found = merged.find(0, true);
            cur = found.from.line;
            len += found.from.ch - found.to.ch;
        }
        cur = line;
        while(merged = collapsedSpanAtEnd(cur)){
            var found$1 = merged.find(0, true);
            len -= cur.text.length - found$1.from.ch;
            cur = found$1.to.line;
            len += cur.text.length - found$1.to.ch;
        }
        return len;
    }
    // Find the longest line in the document.
    function findMaxLine(cm) {
        var d = cm.display, doc = cm.doc;
        d.maxLine = getLine(doc, doc.first);
        d.maxLineLength = lineLength(d.maxLine);
        d.maxLineChanged = true;
        doc.iter(function(line) {
            var len = lineLength(line);
            if (len > d.maxLineLength) {
                d.maxLineLength = len;
                d.maxLine = line;
            }
        });
    }
    // LINE DATA STRUCTURE
    // Line objects. These hold state related to a line, including
    // highlighting info (the styles array).
    var Line = function(text, markedSpans, estimateHeight) {
        this.text = text;
        attachMarkedSpans(this, markedSpans);
        this.height = estimateHeight ? estimateHeight(this) : 1;
    };
    Line.prototype.lineNo = function() {
        return lineNo(this);
    };
    eventMixin(Line);
    // Change the content (text, markers) of a line. Automatically
    // invalidates cached information and tries to re-estimate the
    // line's height.
    function updateLine(line, text, markedSpans, estimateHeight) {
        line.text = text;
        if (line.stateAfter) line.stateAfter = null;
        if (line.styles) line.styles = null;
        if (line.order != null) line.order = null;
        detachMarkedSpans(line);
        attachMarkedSpans(line, markedSpans);
        var estHeight = estimateHeight ? estimateHeight(line) : 1;
        if (estHeight != line.height) updateLineHeight(line, estHeight);
    }
    // Detach a line from the document tree and its markers.
    function cleanUpLine(line) {
        line.parent = null;
        detachMarkedSpans(line);
    }
    // Convert a style as returned by a mode (either null, or a string
    // containing one or more styles) to a CSS style. This is cached,
    // and also looks for line-wide styles.
    var styleToClassCache = {}, styleToClassCacheWithMode = {};
    function interpretTokenStyle(style, options) {
        if (!style || /^\s*$/.test(style)) return null;
        var cache = options.addModeClass ? styleToClassCacheWithMode : styleToClassCache;
        return cache[style] || (cache[style] = style.replace(/\S+/g, "cm-$&"));
    }
    // Render the DOM representation of the text of a line. Also builds
    // up a 'line map', which points at the DOM nodes that represent
    // specific stretches of text, and is used by the measuring code.
    // The returned object contains the DOM node, this map, and
    // information about line-wide styles that were set by the mode.
    function buildLineContent(cm, lineView) {
        // The padding-right forces the element to have a 'border', which
        // is needed on Webkit to be able to get line-level bounding
        // rectangles for it (in measureChar).
        var content = eltP("span", null, null, webkit ? "padding-right: .1px" : null);
        var builder = {
            pre: eltP("pre", [
                content
            ], "CodeMirror-line"),
            content: content,
            col: 0,
            pos: 0,
            cm: cm,
            trailingSpace: false,
            splitSpaces: cm.getOption("lineWrapping")
        };
        lineView.measure = {};
        // Iterate over the logical lines that make up this visual line.
        for(var i = 0; i <= (lineView.rest ? lineView.rest.length : 0); i++){
            var line = i ? lineView.rest[i - 1] : lineView.line, order = void 0;
            builder.pos = 0;
            builder.addToken = buildToken;
            // Optionally wire in some hacks into the token-rendering
            // algorithm, to deal with browser quirks.
            if (hasBadBidiRects(cm.display.measure) && (order = getOrder(line, cm.doc.direction))) builder.addToken = buildTokenBadBidi(builder.addToken, order);
            builder.map = [];
            var allowFrontierUpdate = lineView != cm.display.externalMeasured && lineNo(line);
            insertLineContent(line, builder, getLineStyles(cm, line, allowFrontierUpdate));
            if (line.styleClasses) {
                if (line.styleClasses.bgClass) builder.bgClass = joinClasses(line.styleClasses.bgClass, builder.bgClass || "");
                if (line.styleClasses.textClass) builder.textClass = joinClasses(line.styleClasses.textClass, builder.textClass || "");
            }
            // Ensure at least a single node is present, for measuring.
            if (builder.map.length == 0) builder.map.push(0, 0, builder.content.appendChild(zeroWidthElement(cm.display.measure)));
            // Store the map and a cache object for the current logical line
            if (i == 0) {
                lineView.measure.map = builder.map;
                lineView.measure.cache = {};
            } else {
                (lineView.measure.maps || (lineView.measure.maps = [])).push(builder.map);
                (lineView.measure.caches || (lineView.measure.caches = [])).push({});
            }
        }
        // See issue #2901
        if (webkit) {
            var last = builder.content.lastChild;
            if (/\bcm-tab\b/.test(last.className) || last.querySelector && last.querySelector(".cm-tab")) builder.content.className = "cm-tab-wrap-hack";
        }
        signal(cm, "renderLine", cm, lineView.line, builder.pre);
        if (builder.pre.className) builder.textClass = joinClasses(builder.pre.className, builder.textClass || "");
        return builder;
    }
    function defaultSpecialCharPlaceholder(ch) {
        var token = elt("span", "•", "cm-invalidchar");
        token.title = "\\u" + ch.charCodeAt(0).toString(16);
        token.setAttribute("aria-label", token.title);
        return token;
    }
    // Build up the DOM representation for a single token, and add it to
    // the line map. Takes care to render special characters separately.
    function buildToken(builder, text, style, startStyle, endStyle, css, attributes) {
        if (!text) return;
        var displayText = builder.splitSpaces ? splitSpaces(text, builder.trailingSpace) : text;
        var special = builder.cm.state.specialChars, mustWrap = false;
        var content;
        if (!special.test(text)) {
            builder.col += text.length;
            content = document.createTextNode(displayText);
            builder.map.push(builder.pos, builder.pos + text.length, content);
            if (ie && ie_version < 9) mustWrap = true;
            builder.pos += text.length;
        } else {
            content = document.createDocumentFragment();
            var pos = 0;
            while(true){
                special.lastIndex = pos;
                var m = special.exec(text);
                var skipped = m ? m.index - pos : text.length - pos;
                if (skipped) {
                    var txt = document.createTextNode(displayText.slice(pos, pos + skipped));
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt
                    ]));
                    else content.appendChild(txt);
                    builder.map.push(builder.pos, builder.pos + skipped, txt);
                    builder.col += skipped;
                    builder.pos += skipped;
                }
                if (!m) break;
                pos += skipped + 1;
                var txt$1 = void 0;
                if (m[0] == "	") {
                    var tabSize = builder.cm.options.tabSize, tabWidth = tabSize - builder.col % tabSize;
                    txt$1 = content.appendChild(elt("span", spaceStr(tabWidth), "cm-tab"));
                    txt$1.setAttribute("role", "presentation");
                    txt$1.setAttribute("cm-text", "	");
                    builder.col += tabWidth;
                } else if (m[0] == "\r" || m[0] == "\n") {
                    txt$1 = content.appendChild(elt("span", m[0] == "\r" ? "␍" : "␤", "cm-invalidchar"));
                    txt$1.setAttribute("cm-text", m[0]);
                    builder.col += 1;
                } else {
                    txt$1 = builder.cm.options.specialCharPlaceholder(m[0]);
                    txt$1.setAttribute("cm-text", m[0]);
                    if (ie && ie_version < 9) content.appendChild(elt("span", [
                        txt$1
                    ]));
                    else content.appendChild(txt$1);
                    builder.col += 1;
                }
                builder.map.push(builder.pos, builder.pos + 1, txt$1);
                builder.pos++;
            }
        }
        builder.trailingSpace = displayText.charCodeAt(text.length - 1) == 32;
        if (style || startStyle || endStyle || mustWrap || css) {
            var fullStyle = style || "";
            if (startStyle) fullStyle += startStyle;
            if (endStyle) fullStyle += endStyle;
            var token = elt("span", [
                content
            ], fullStyle, css);
            if (attributes) {
                for(var attr in attributes)if (attributes.hasOwnProperty(attr) && attr != "style" && attr != "class") token.setAttribute(attr, attributes[attr]);
            }
            return builder.content.appendChild(token);
        }
        builder.content.appendChild(content);
    }
    // Change some spaces to NBSP to prevent the browser from collapsing
    // trailing spaces at the end of a line when rendering text (issue #1362).
    function splitSpaces(text, trailingBefore) {
        if (text.length > 1 && !/  /.test(text)) return text;
        var spaceBefore = trailingBefore, result = "";
        for(var i = 0; i < text.length; i++){
            var ch = text.charAt(i);
            if (ch == " " && spaceBefore && (i == text.length - 1 || text.charCodeAt(i + 1) == 32)) ch = "\xa0";
            result += ch;
            spaceBefore = ch == " ";
        }
        return result;
    }
    // Work around nonsense dimensions being reported for stretches of
    // right-to-left text.
    function buildTokenBadBidi(inner, order) {
        return function(builder, text, style, startStyle, endStyle, css, attributes) {
            style = style ? style + " cm-force-border" : "cm-force-border";
            var start = builder.pos, end = start + text.length;
            for(;;){
                // Find the part that overlaps with the start of this text
                var part = void 0;
                for(var i = 0; i < order.length; i++){
                    part = order[i];
                    if (part.to > start && part.from <= start) break;
                }
                if (part.to >= end) return inner(builder, text, style, startStyle, endStyle, css, attributes);
                inner(builder, text.slice(0, part.to - start), style, startStyle, null, css, attributes);
                startStyle = null;
                text = text.slice(part.to - start);
                start = part.to;
            }
        };
    }
    function buildCollapsedSpan(builder, size, marker, ignoreWidget) {
        var widget = !ignoreWidget && marker.widgetNode;
        if (widget) builder.map.push(builder.pos, builder.pos + size, widget);
        if (!ignoreWidget && builder.cm.display.input.needsContentAttribute) {
            if (!widget) widget = builder.content.appendChild(document.createElement("span"));
            widget.setAttribute("cm-marker", marker.id);
        }
        if (widget) {
            builder.cm.display.input.setUneditable(widget);
            builder.content.appendChild(widget);
        }
        builder.pos += size;
        builder.trailingSpace = false;
    }
    // Outputs a number of spans to make up a line, taking highlighting
    // and marked text into account.
    function insertLineContent(line, builder, styles) {
        var spans = line.markedSpans, allText = line.text, at = 0;
        if (!spans) {
            for(var i$1 = 1; i$1 < styles.length; i$1 += 2)builder.addToken(builder, allText.slice(at, at = styles[i$1]), interpretTokenStyle(styles[i$1 + 1], builder.cm.options));
            return;
        }
        var len = allText.length, pos = 0, i = 1, text = "", style, css;
        var nextChange = 0, spanStyle, spanEndStyle, spanStartStyle, collapsed, attributes;
        for(;;){
            if (nextChange == pos) {
                spanStyle = spanEndStyle = spanStartStyle = css = "";
                attributes = null;
                collapsed = null;
                nextChange = Infinity;
                var foundBookmarks = [], endStyles = void 0;
                for(var j = 0; j < spans.length; ++j){
                    var sp = spans[j], m = sp.marker;
                    if (m.type == "bookmark" && sp.from == pos && m.widgetNode) foundBookmarks.push(m);
                    else if (sp.from <= pos && (sp.to == null || sp.to > pos || m.collapsed && sp.to == pos && sp.from == pos)) {
                        if (sp.to != null && sp.to != pos && nextChange > sp.to) {
                            nextChange = sp.to;
                            spanEndStyle = "";
                        }
                        if (m.className) spanStyle += " " + m.className;
                        if (m.css) css = (css ? css + ";" : "") + m.css;
                        if (m.startStyle && sp.from == pos) spanStartStyle += " " + m.startStyle;
                        if (m.endStyle && sp.to == nextChange) (endStyles || (endStyles = [])).push(m.endStyle, sp.to);
                        // support for the old title property
                        // https://github.com/codemirror/CodeMirror/pull/5673
                        if (m.title) (attributes || (attributes = {})).title = m.title;
                        if (m.attributes) for(var attr in m.attributes)(attributes || (attributes = {}))[attr] = m.attributes[attr];
                        if (m.collapsed && (!collapsed || compareCollapsedMarkers(collapsed.marker, m) < 0)) collapsed = sp;
                    } else if (sp.from > pos && nextChange > sp.from) nextChange = sp.from;
                }
                if (endStyles) {
                    for(var j$1 = 0; j$1 < endStyles.length; j$1 += 2)if (endStyles[j$1 + 1] == nextChange) spanEndStyle += " " + endStyles[j$1];
                }
                if (!collapsed || collapsed.from == pos) for(var j$2 = 0; j$2 < foundBookmarks.length; ++j$2)buildCollapsedSpan(builder, 0, foundBookmarks[j$2]);
                if (collapsed && (collapsed.from || 0) == pos) {
                    buildCollapsedSpan(builder, (collapsed.to == null ? len + 1 : collapsed.to) - pos, collapsed.marker, collapsed.from == null);
                    if (collapsed.to == null) return;
                    if (collapsed.to == pos) collapsed = false;
                }
            }
            if (pos >= len) break;
            var upto = Math.min(len, nextChange);
            while(true){
                if (text) {
                    var end = pos + text.length;
                    if (!collapsed) {
                        var tokenText = end > upto ? text.slice(0, upto - pos) : text;
                        builder.addToken(builder, tokenText, style ? style + spanStyle : spanStyle, spanStartStyle, pos + tokenText.length == nextChange ? spanEndStyle : "", css, attributes);
                    }
                    if (end >= upto) {
                        text = text.slice(upto - pos);
                        pos = upto;
                        break;
                    }
                    pos = end;
                    spanStartStyle = "";
                }
                text = allText.slice(at, at = styles[i++]);
                style = interpretTokenStyle(styles[i++], builder.cm.options);
            }
        }
    }
    // These objects are used to represent the visible (currently drawn)
    // part of the document. A LineView may correspond to multiple
    // logical lines, if those are connected by collapsed ranges.
    function LineView(doc, line, lineN) {
        // The starting line
        this.line = line;
        // Continuing lines, if any
        this.rest = visualLineContinued(line);
        // Number of logical lines in this visual line
        this.size = this.rest ? lineNo(lst(this.rest)) - lineN + 1 : 1;
        this.node = this.text = null;
        this.hidden = lineIsHidden(doc, line);
    }
    // Create a range of LineView objects for the given lines.
    function buildViewArray(cm, from, to) {
        var array = [], nextPos;
        for(var pos = from; pos < to; pos = nextPos){
            var view = new LineView(cm.doc, getLine(cm.doc, pos), pos);
            nextPos = pos + view.size;
            array.push(view);
        }
        return array;
    }
    var operationGroup = null;
    function pushOperation(op) {
        if (operationGroup) operationGroup.ops.push(op);
        else op.ownsGroup = operationGroup = {
            ops: [
                op
            ],
            delayedCallbacks: []
        };
    }
    function fireCallbacksForOps(group) {
        // Calls delayed callbacks and cursorActivity handlers until no
        // new ones appear
        var callbacks = group.delayedCallbacks, i = 0;
        do {
            for(; i < callbacks.length; i++)callbacks[i].call(null);
            for(var j = 0; j < group.ops.length; j++){
                var op = group.ops[j];
                if (op.cursorActivityHandlers) while(op.cursorActivityCalled < op.cursorActivityHandlers.length)op.cursorActivityHandlers[op.cursorActivityCalled++].call(null, op.cm);
            }
        }while (i < callbacks.length);
    }
    function finishOperation(op, endCb) {
        var group = op.ownsGroup;
        if (!group) return;
        try {
            fireCallbacksForOps(group);
        } finally{
            operationGroup = null;
            endCb(group);
        }
    }
    var orphanDelayedCallbacks = null;
    // Often, we want to signal events at a point where we are in the
    // middle of some work, but don't want the handler to start calling
    // other methods on the editor, which might be in an inconsistent
    // state or simply not expect any other events to happen.
    // signalLater looks whether there are any handlers, and schedules
    // them to be executed when the last operation ends, or, if no
    // operation is active, when a timeout fires.
    function signalLater(emitter, type /*, values...*/ ) {
        var arr = getHandlers(emitter, type);
        if (!arr.length) return;
        var args = Array.prototype.slice.call(arguments, 2), list;
        if (operationGroup) list = operationGroup.delayedCallbacks;
        else if (orphanDelayedCallbacks) list = orphanDelayedCallbacks;
        else {
            list = orphanDelayedCallbacks = [];
            setTimeout(fireOrphanDelayed, 0);
        }
        var loop = function(i) {
            list.push(function() {
                return arr[i].apply(null, args);
            });
        };
        for(var i = 0; i < arr.length; ++i)loop(i);
    }
    function fireOrphanDelayed() {
        var delayed = orphanDelayedCallbacks;
        orphanDelayedCallbacks = null;
        for(var i = 0; i < delayed.length; ++i)delayed[i]();
    }
    // When an aspect of a line changes, a string is added to
    // lineView.changes. This updates the relevant part of the line's
    // DOM structure.
    function updateLineForChanges(cm, lineView, lineN, dims) {
        for(var j = 0; j < lineView.changes.length; j++){
            var type = lineView.changes[j];
            if (type == "text") updateLineText(cm, lineView);
            else if (type == "gutter") updateLineGutter(cm, lineView, lineN, dims);
            else if (type == "class") updateLineClasses(cm, lineView);
            else if (type == "widget") updateLineWidgets(cm, lineView, dims);
        }
        lineView.changes = null;
    }
    // Lines with gutter elements, widgets or a background class need to
    // be wrapped, and have the extra elements added to the wrapper div
    function ensureLineWrapped(lineView) {
        if (lineView.node == lineView.text) {
            lineView.node = elt("div", null, null, "position: relative");
            if (lineView.text.parentNode) lineView.text.parentNode.replaceChild(lineView.node, lineView.text);
            lineView.node.appendChild(lineView.text);
            if (ie && ie_version < 8) lineView.node.style.zIndex = 2;
        }
        return lineView.node;
    }
    function updateLineBackground(cm, lineView) {
        var cls = lineView.bgClass ? lineView.bgClass + " " + (lineView.line.bgClass || "") : lineView.line.bgClass;
        if (cls) cls += " CodeMirror-linebackground";
        if (lineView.background) {
            if (cls) lineView.background.className = cls;
            else {
                lineView.background.parentNode.removeChild(lineView.background);
                lineView.background = null;
            }
        } else if (cls) {
            var wrap = ensureLineWrapped(lineView);
            lineView.background = wrap.insertBefore(elt("div", null, cls), wrap.firstChild);
            cm.display.input.setUneditable(lineView.background);
        }
    }
    // Wrapper around buildLineContent which will reuse the structure
    // in display.externalMeasured when possible.
    function getLineContent(cm, lineView) {
        var ext = cm.display.externalMeasured;
        if (ext && ext.line == lineView.line) {
            cm.display.externalMeasured = null;
            lineView.measure = ext.measure;
            return ext.built;
        }
        return buildLineContent(cm, lineView);
    }
    // Redraw the line's text. Interacts with the background and text
    // classes because the mode may output tokens that influence these
    // classes.
    function updateLineText(cm, lineView) {
        var cls = lineView.text.className;
        var built = getLineContent(cm, lineView);
        if (lineView.text == lineView.node) lineView.node = built.pre;
        lineView.text.parentNode.replaceChild(built.pre, lineView.text);
        lineView.text = built.pre;
        if (built.bgClass != lineView.bgClass || built.textClass != lineView.textClass) {
            lineView.bgClass = built.bgClass;
            lineView.textClass = built.textClass;
            updateLineClasses(cm, lineView);
        } else if (cls) lineView.text.className = cls;
    }
    function updateLineClasses(cm, lineView) {
        updateLineBackground(cm, lineView);
        if (lineView.line.wrapClass) ensureLineWrapped(lineView).className = lineView.line.wrapClass;
        else if (lineView.node != lineView.text) lineView.node.className = "";
        var textClass = lineView.textClass ? lineView.textClass + " " + (lineView.line.textClass || "") : lineView.line.textClass;
        lineView.text.className = textClass || "";
    }
    function updateLineGutter(cm, lineView, lineN, dims) {
        if (lineView.gutter) {
            lineView.node.removeChild(lineView.gutter);
            lineView.gutter = null;
        }
        if (lineView.gutterBackground) {
            lineView.node.removeChild(lineView.gutterBackground);
            lineView.gutterBackground = null;
        }
        if (lineView.line.gutterClass) {
            var wrap = ensureLineWrapped(lineView);
            lineView.gutterBackground = elt("div", null, "CodeMirror-gutter-background " + lineView.line.gutterClass, "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px; width: " + dims.gutterTotalWidth + "px");
            cm.display.input.setUneditable(lineView.gutterBackground);
            wrap.insertBefore(lineView.gutterBackground, lineView.text);
        }
        var markers = lineView.line.gutterMarkers;
        if (cm.options.lineNumbers || markers) {
            var wrap$1 = ensureLineWrapped(lineView);
            var gutterWrap = lineView.gutter = elt("div", null, "CodeMirror-gutter-wrapper", "left: " + (cm.options.fixedGutter ? dims.fixedPos : -dims.gutterTotalWidth) + "px");
            cm.display.input.setUneditable(gutterWrap);
            wrap$1.insertBefore(gutterWrap, lineView.text);
            if (lineView.line.gutterClass) gutterWrap.className += " " + lineView.line.gutterClass;
            if (cm.options.lineNumbers && (!markers || !markers["CodeMirror-linenumbers"])) lineView.lineNumber = gutterWrap.appendChild(elt("div", lineNumberFor(cm.options, lineN), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + dims.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + cm.display.lineNumInnerWidth + "px"));
            if (markers) for(var k = 0; k < cm.display.gutterSpecs.length; ++k){
                var id = cm.display.gutterSpecs[k].className, found = markers.hasOwnProperty(id) && markers[id];
                if (found) gutterWrap.appendChild(elt("div", [
                    found
                ], "CodeMirror-gutter-elt", "left: " + dims.gutterLeft[id] + "px; width: " + dims.gutterWidth[id] + "px"));
            }
        }
    }
    function updateLineWidgets(cm, lineView, dims) {
        if (lineView.alignable) lineView.alignable = null;
        for(var node = lineView.node.firstChild, next = void 0; node; node = next){
            next = node.nextSibling;
            if (node.className == "CodeMirror-linewidget") lineView.node.removeChild(node);
        }
        insertLineWidgets(cm, lineView, dims);
    }
    // Build a line's DOM representation from scratch
    function buildLineElement(cm, lineView, lineN, dims) {
        var built = getLineContent(cm, lineView);
        lineView.text = lineView.node = built.pre;
        if (built.bgClass) lineView.bgClass = built.bgClass;
        if (built.textClass) lineView.textClass = built.textClass;
        updateLineClasses(cm, lineView);
        updateLineGutter(cm, lineView, lineN, dims);
        insertLineWidgets(cm, lineView, dims);
        return lineView.node;
    }
    // A lineView may contain multiple logical lines (when merged by
    // collapsed spans). The widgets for all of them need to be drawn.
    function insertLineWidgets(cm, lineView, dims) {
        insertLineWidgetsFor(cm, lineView.line, lineView, dims, true);
        if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)insertLineWidgetsFor(cm, lineView.rest[i], lineView, dims, false);
    }
    function insertLineWidgetsFor(cm, line, lineView, dims, allowAbove) {
        if (!line.widgets) return;
        var wrap = ensureLineWrapped(lineView);
        for(var i = 0, ws = line.widgets; i < ws.length; ++i){
            var widget = ws[i], node = elt("div", [
                widget.node
            ], "CodeMirror-linewidget");
            if (!widget.handleMouseEvents) node.setAttribute("cm-ignore-events", "true");
            positionLineWidget(widget, node, lineView, dims);
            cm.display.input.setUneditable(node);
            if (allowAbove && widget.above) wrap.insertBefore(node, lineView.gutter || lineView.text);
            else wrap.appendChild(node);
            signalLater(widget, "redraw");
        }
    }
    function positionLineWidget(widget, node, lineView, dims) {
        if (widget.noHScroll) {
            (lineView.alignable || (lineView.alignable = [])).push(node);
            var width = dims.wrapperWidth;
            node.style.left = dims.fixedPos + "px";
            if (!widget.coverGutter) {
                width -= dims.gutterTotalWidth;
                node.style.paddingLeft = dims.gutterTotalWidth + "px";
            }
            node.style.width = width + "px";
        }
        if (widget.coverGutter) {
            node.style.zIndex = 5;
            node.style.position = "relative";
            if (!widget.noHScroll) node.style.marginLeft = -dims.gutterTotalWidth + "px";
        }
    }
    function widgetHeight(widget) {
        if (widget.height != null) return widget.height;
        var cm = widget.doc.cm;
        if (!cm) return 0;
        if (!contains(document.body, widget.node)) {
            var parentStyle = "position: relative;";
            if (widget.coverGutter) parentStyle += "margin-left: -" + cm.display.gutters.offsetWidth + "px;";
            if (widget.noHScroll) parentStyle += "width: " + cm.display.wrapper.clientWidth + "px;";
            removeChildrenAndAdd(cm.display.measure, elt("div", [
                widget.node
            ], null, parentStyle));
        }
        return widget.height = widget.node.parentNode.offsetHeight;
    }
    // Return true when the given mouse event happened in a widget
    function eventInWidget(display, e) {
        for(var n = e_target(e); n != display.wrapper; n = n.parentNode){
            if (!n || n.nodeType == 1 && n.getAttribute("cm-ignore-events") == "true" || n.parentNode == display.sizer && n != display.mover) return true;
        }
    }
    // POSITION MEASUREMENT
    function paddingTop(display) {
        return display.lineSpace.offsetTop;
    }
    function paddingVert(display) {
        return display.mover.offsetHeight - display.lineSpace.offsetHeight;
    }
    function paddingH(display) {
        if (display.cachedPaddingH) return display.cachedPaddingH;
        var e = removeChildrenAndAdd(display.measure, elt("pre", "x", "CodeMirror-line-like"));
        var style = window.getComputedStyle ? window.getComputedStyle(e) : e.currentStyle;
        var data = {
            left: parseInt(style.paddingLeft),
            right: parseInt(style.paddingRight)
        };
        if (!isNaN(data.left) && !isNaN(data.right)) display.cachedPaddingH = data;
        return data;
    }
    function scrollGap(cm) {
        return scrollerGap - cm.display.nativeBarWidth;
    }
    function displayWidth(cm) {
        return cm.display.scroller.clientWidth - scrollGap(cm) - cm.display.barWidth;
    }
    function displayHeight(cm) {
        return cm.display.scroller.clientHeight - scrollGap(cm) - cm.display.barHeight;
    }
    // Ensure the lineView.wrapping.heights array is populated. This is
    // an array of bottom offsets for the lines that make up a drawn
    // line. When lineWrapping is on, there might be more than one
    // height.
    function ensureLineHeights(cm, lineView, rect) {
        var wrapping = cm.options.lineWrapping;
        var curWidth = wrapping && displayWidth(cm);
        if (!lineView.measure.heights || wrapping && lineView.measure.width != curWidth) {
            var heights = lineView.measure.heights = [];
            if (wrapping) {
                lineView.measure.width = curWidth;
                var rects = lineView.text.firstChild.getClientRects();
                for(var i = 0; i < rects.length - 1; i++){
                    var cur = rects[i], next = rects[i + 1];
                    if (Math.abs(cur.bottom - next.bottom) > 2) heights.push((cur.bottom + next.top) / 2 - rect.top);
                }
            }
            heights.push(rect.bottom - rect.top);
        }
    }
    // Find a line map (mapping character offsets to text nodes) and a
    // measurement cache for the given line number. (A line view might
    // contain multiple lines when collapsed ranges are present.)
    function mapFromLineView(lineView, line, lineN) {
        if (lineView.line == line) return {
            map: lineView.measure.map,
            cache: lineView.measure.cache
        };
        for(var i = 0; i < lineView.rest.length; i++){
            if (lineView.rest[i] == line) return {
                map: lineView.measure.maps[i],
                cache: lineView.measure.caches[i]
            };
        }
        for(var i$1 = 0; i$1 < lineView.rest.length; i$1++){
            if (lineNo(lineView.rest[i$1]) > lineN) return {
                map: lineView.measure.maps[i$1],
                cache: lineView.measure.caches[i$1],
                before: true
            };
        }
    }
    // Render a line into the hidden node display.externalMeasured. Used
    // when measurement is needed for a line that's not in the viewport.
    function updateExternalMeasurement(cm, line) {
        line = visualLine(line);
        var lineN = lineNo(line);
        var view = cm.display.externalMeasured = new LineView(cm.doc, line, lineN);
        view.lineN = lineN;
        var built = view.built = buildLineContent(cm, view);
        view.text = built.pre;
        removeChildrenAndAdd(cm.display.lineMeasure, built.pre);
        return view;
    }
    // Get a {top, bottom, left, right} box (in line-local coordinates)
    // for a given character.
    function measureChar(cm, line, ch, bias) {
        return measureCharPrepared(cm, prepareMeasureForLine(cm, line), ch, bias);
    }
    // Find a line view that corresponds to the given line number.
    function findViewForLine(cm, lineN) {
        if (lineN >= cm.display.viewFrom && lineN < cm.display.viewTo) return cm.display.view[findViewIndex(cm, lineN)];
        var ext = cm.display.externalMeasured;
        if (ext && lineN >= ext.lineN && lineN < ext.lineN + ext.size) return ext;
    }
    // Measurement can be split in two steps, the set-up work that
    // applies to the whole line, and the measurement of the actual
    // character. Functions like coordsChar, that need to do a lot of
    // measurements in a row, can thus ensure that the set-up work is
    // only done once.
    function prepareMeasureForLine(cm, line) {
        var lineN = lineNo(line);
        var view = findViewForLine(cm, lineN);
        if (view && !view.text) view = null;
        else if (view && view.changes) {
            updateLineForChanges(cm, view, lineN, getDimensions(cm));
            cm.curOp.forceUpdate = true;
        }
        if (!view) view = updateExternalMeasurement(cm, line);
        var info = mapFromLineView(view, line, lineN);
        return {
            line: line,
            view: view,
            rect: null,
            map: info.map,
            cache: info.cache,
            before: info.before,
            hasHeights: false
        };
    }
    // Given a prepared measurement object, measures the position of an
    // actual character (or fetches it from the cache).
    function measureCharPrepared(cm, prepared, ch, bias, varHeight) {
        if (prepared.before) ch = -1;
        var key = ch + (bias || ""), found;
        if (prepared.cache.hasOwnProperty(key)) found = prepared.cache[key];
        else {
            if (!prepared.rect) prepared.rect = prepared.view.text.getBoundingClientRect();
            if (!prepared.hasHeights) {
                ensureLineHeights(cm, prepared.view, prepared.rect);
                prepared.hasHeights = true;
            }
            found = measureCharInner(cm, prepared, ch, bias);
            if (!found.bogus) prepared.cache[key] = found;
        }
        return {
            left: found.left,
            right: found.right,
            top: varHeight ? found.rtop : found.top,
            bottom: varHeight ? found.rbottom : found.bottom
        };
    }
    var nullRect = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    function nodeAndOffsetInLineMap(map$$1, ch, bias) {
        var node, start, end, collapse, mStart, mEnd;
        // First, search the line map for the text node corresponding to,
        // or closest to, the target character.
        for(var i = 0; i < map$$1.length; i += 3){
            mStart = map$$1[i];
            mEnd = map$$1[i + 1];
            if (ch < mStart) {
                start = 0;
                end = 1;
                collapse = "left";
            } else if (ch < mEnd) {
                start = ch - mStart;
                end = start + 1;
            } else if (i == map$$1.length - 3 || ch == mEnd && map$$1[i + 3] > ch) {
                end = mEnd - mStart;
                start = end - 1;
                if (ch >= mEnd) collapse = "right";
            }
            if (start != null) {
                node = map$$1[i + 2];
                if (mStart == mEnd && bias == (node.insertLeft ? "left" : "right")) collapse = bias;
                if (bias == "left" && start == 0) while(i && map$$1[i - 2] == map$$1[i - 3] && map$$1[i - 1].insertLeft){
                    node = map$$1[(i -= 3) + 2];
                    collapse = "left";
                }
                if (bias == "right" && start == mEnd - mStart) while(i < map$$1.length - 3 && map$$1[i + 3] == map$$1[i + 4] && !map$$1[i + 5].insertLeft){
                    node = map$$1[(i += 3) + 2];
                    collapse = "right";
                }
                break;
            }
        }
        return {
            node: node,
            start: start,
            end: end,
            collapse: collapse,
            coverStart: mStart,
            coverEnd: mEnd
        };
    }
    function getUsefulRect(rects, bias) {
        var rect = nullRect;
        if (bias == "left") for(var i = 0; i < rects.length; i++){
            if ((rect = rects[i]).left != rect.right) break;
        }
        else for(var i$1 = rects.length - 1; i$1 >= 0; i$1--){
            if ((rect = rects[i$1]).left != rect.right) break;
        }
        return rect;
    }
    function measureCharInner(cm, prepared, ch, bias) {
        var place = nodeAndOffsetInLineMap(prepared.map, ch, bias);
        var node = place.node, start = place.start, end = place.end, collapse = place.collapse;
        var rect;
        if (node.nodeType == 3) {
            for(var i$1 = 0; i$1 < 4; i$1++){
                while(start && isExtendingChar(prepared.line.text.charAt(place.coverStart + start)))--start;
                while(place.coverStart + end < place.coverEnd && isExtendingChar(prepared.line.text.charAt(place.coverStart + end)))++end;
                if (ie && ie_version < 9 && start == 0 && end == place.coverEnd - place.coverStart) rect = node.parentNode.getBoundingClientRect();
                else rect = getUsefulRect(range(node, start, end).getClientRects(), bias);
                if (rect.left || rect.right || start == 0) break;
                end = start;
                start = start - 1;
                collapse = "right";
            }
            if (ie && ie_version < 11) rect = maybeUpdateRectForZooming(cm.display.measure, rect);
        } else {
            if (start > 0) collapse = bias = "right";
            var rects;
            if (cm.options.lineWrapping && (rects = node.getClientRects()).length > 1) rect = rects[bias == "right" ? rects.length - 1 : 0];
            else rect = node.getBoundingClientRect();
        }
        if (ie && ie_version < 9 && !start && (!rect || !rect.left && !rect.right)) {
            var rSpan = node.parentNode.getClientRects()[0];
            if (rSpan) rect = {
                left: rSpan.left,
                right: rSpan.left + charWidth(cm.display),
                top: rSpan.top,
                bottom: rSpan.bottom
            };
            else rect = nullRect;
        }
        var rtop = rect.top - prepared.rect.top, rbot = rect.bottom - prepared.rect.top;
        var mid = (rtop + rbot) / 2;
        var heights = prepared.view.measure.heights;
        var i = 0;
        for(; i < heights.length - 1; i++){
            if (mid < heights[i]) break;
        }
        var top = i ? heights[i - 1] : 0, bot = heights[i];
        var result = {
            left: (collapse == "right" ? rect.right : rect.left) - prepared.rect.left,
            right: (collapse == "left" ? rect.left : rect.right) - prepared.rect.left,
            top: top,
            bottom: bot
        };
        if (!rect.left && !rect.right) result.bogus = true;
        if (!cm.options.singleCursorHeightPerLine) {
            result.rtop = rtop;
            result.rbottom = rbot;
        }
        return result;
    }
    // Work around problem with bounding client rects on ranges being
    // returned incorrectly when zoomed on IE10 and below.
    function maybeUpdateRectForZooming(measure, rect) {
        if (!window.screen || screen.logicalXDPI == null || screen.logicalXDPI == screen.deviceXDPI || !hasBadZoomedRects(measure)) return rect;
        var scaleX = screen.logicalXDPI / screen.deviceXDPI;
        var scaleY = screen.logicalYDPI / screen.deviceYDPI;
        return {
            left: rect.left * scaleX,
            right: rect.right * scaleX,
            top: rect.top * scaleY,
            bottom: rect.bottom * scaleY
        };
    }
    function clearLineMeasurementCacheFor(lineView) {
        if (lineView.measure) {
            lineView.measure.cache = {};
            lineView.measure.heights = null;
            if (lineView.rest) for(var i = 0; i < lineView.rest.length; i++)lineView.measure.caches[i] = {};
        }
    }
    function clearLineMeasurementCache(cm) {
        cm.display.externalMeasure = null;
        removeChildren(cm.display.lineMeasure);
        for(var i = 0; i < cm.display.view.length; i++)clearLineMeasurementCacheFor(cm.display.view[i]);
    }
    function clearCaches(cm) {
        clearLineMeasurementCache(cm);
        cm.display.cachedCharWidth = cm.display.cachedTextHeight = cm.display.cachedPaddingH = null;
        if (!cm.options.lineWrapping) cm.display.maxLineChanged = true;
        cm.display.lineNumChars = null;
    }
    function pageScrollX() {
        // Work around https://bugs.chromium.org/p/chromium/issues/detail?id=489206
        // which causes page_Offset and bounding client rects to use
        // different reference viewports and invalidate our calculations.
        if (chrome && android) return -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft));
        return window.pageXOffset || (document.documentElement || document.body).scrollLeft;
    }
    function pageScrollY() {
        if (chrome && android) return -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop));
        return window.pageYOffset || (document.documentElement || document.body).scrollTop;
    }
    function widgetTopHeight(lineObj) {
        var height = 0;
        if (lineObj.widgets) {
            for(var i = 0; i < lineObj.widgets.length; ++i)if (lineObj.widgets[i].above) height += widgetHeight(lineObj.widgets[i]);
        }
        return height;
    }
    // Converts a {top, bottom, left, right} box from line-local
    // coordinates into another coordinate system. Context may be one of
    // "line", "div" (display.lineDiv), "local"./null (editor), "window",
    // or "page".
    function intoCoordSystem(cm, lineObj, rect, context, includeWidgets) {
        if (!includeWidgets) {
            var height = widgetTopHeight(lineObj);
            rect.top += height;
            rect.bottom += height;
        }
        if (context == "line") return rect;
        if (!context) context = "local";
        var yOff = heightAtLine(lineObj);
        if (context == "local") yOff += paddingTop(cm.display);
        else yOff -= cm.display.viewOffset;
        if (context == "page" || context == "window") {
            var lOff = cm.display.lineSpace.getBoundingClientRect();
            yOff += lOff.top + (context == "window" ? 0 : pageScrollY());
            var xOff = lOff.left + (context == "window" ? 0 : pageScrollX());
            rect.left += xOff;
            rect.right += xOff;
        }
        rect.top += yOff;
        rect.bottom += yOff;
        return rect;
    }
    // Coverts a box from "div" coords to another coordinate system.
    // Context may be "window", "page", "div", or "local"./null.
    function fromCoordSystem(cm, coords, context) {
        if (context == "div") return coords;
        var left = coords.left, top = coords.top;
        // First move into "page" coordinate system
        if (context == "page") {
            left -= pageScrollX();
            top -= pageScrollY();
        } else if (context == "local" || !context) {
            var localBox = cm.display.sizer.getBoundingClientRect();
            left += localBox.left;
            top += localBox.top;
        }
        var lineSpaceBox = cm.display.lineSpace.getBoundingClientRect();
        return {
            left: left - lineSpaceBox.left,
            top: top - lineSpaceBox.top
        };
    }
    function charCoords(cm, pos, context, lineObj, bias) {
        if (!lineObj) lineObj = getLine(cm.doc, pos.line);
        return intoCoordSystem(cm, lineObj, measureChar(cm, lineObj, pos.ch, bias), context);
    }
    // Returns a box for a given cursor position, which may have an
    // 'other' property containing the position of the secondary cursor
    // on a bidi boundary.
    // A cursor Pos(line, char, "before") is on the same visual line as `char - 1`
    // and after `char - 1` in writing order of `char - 1`
    // A cursor Pos(line, char, "after") is on the same visual line as `char`
    // and before `char` in writing order of `char`
    // Examples (upper-case letters are RTL, lower-case are LTR):
    //     Pos(0, 1, ...)
    //     before   after
    // ab     a|b     a|b
    // aB     a|B     aB|
    // Ab     |Ab     A|b
    // AB     B|A     B|A
    // Every position after the last character on a line is considered to stick
    // to the last character on the line.
    function cursorCoords(cm, pos, context, lineObj, preparedMeasure, varHeight) {
        lineObj = lineObj || getLine(cm.doc, pos.line);
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        function get(ch, right) {
            var m = measureCharPrepared(cm, preparedMeasure, ch, right ? "right" : "left", varHeight);
            if (right) m.left = m.right;
            else m.right = m.left;
            return intoCoordSystem(cm, lineObj, m, context);
        }
        var order = getOrder(lineObj, cm.doc.direction), ch = pos.ch, sticky = pos.sticky;
        if (ch >= lineObj.text.length) {
            ch = lineObj.text.length;
            sticky = "before";
        } else if (ch <= 0) {
            ch = 0;
            sticky = "after";
        }
        if (!order) return get(sticky == "before" ? ch - 1 : ch, sticky == "before");
        function getBidi(ch, partPos, invert) {
            var part = order[partPos], right = part.level == 1;
            return get(invert ? ch - 1 : ch, right != invert);
        }
        var partPos = getBidiPartAt(order, ch, sticky);
        var other = bidiOther;
        var val = getBidi(ch, partPos, sticky == "before");
        if (other != null) val.other = getBidi(ch, other, sticky != "before");
        return val;
    }
    // Used to cheaply estimate the coordinates for a position. Used for
    // intermediate scroll updates.
    function estimateCoords(cm, pos) {
        var left = 0;
        pos = clipPos(cm.doc, pos);
        if (!cm.options.lineWrapping) left = charWidth(cm.display) * pos.ch;
        var lineObj = getLine(cm.doc, pos.line);
        var top = heightAtLine(lineObj) + paddingTop(cm.display);
        return {
            left: left,
            right: left,
            top: top,
            bottom: top + lineObj.height
        };
    }
    // Positions returned by coordsChar contain some extra information.
    // xRel is the relative x position of the input coordinates compared
    // to the found position (so xRel > 0 means the coordinates are to
    // the right of the character position, for example). When outside
    // is true, that means the coordinates lie outside the line's
    // vertical range.
    function PosWithInfo(line, ch, sticky, outside, xRel) {
        var pos = Pos(line, ch, sticky);
        pos.xRel = xRel;
        if (outside) pos.outside = outside;
        return pos;
    }
    // Compute the character position closest to the given coordinates.
    // Input must be lineSpace-local ("div" coordinate system).
    function coordsChar(cm, x, y) {
        var doc = cm.doc;
        y += cm.display.viewOffset;
        if (y < 0) return PosWithInfo(doc.first, 0, null, -1, -1);
        var lineN = lineAtHeight(doc, y), last = doc.first + doc.size - 1;
        if (lineN > last) return PosWithInfo(doc.first + doc.size - 1, getLine(doc, last).text.length, null, 1, 1);
        if (x < 0) x = 0;
        var lineObj = getLine(doc, lineN);
        for(;;){
            var found = coordsCharInner(cm, lineObj, lineN, x, y);
            var collapsed = collapsedSpanAround(lineObj, found.ch + (found.xRel > 0 || found.outside > 0 ? 1 : 0));
            if (!collapsed) return found;
            var rangeEnd = collapsed.find(1);
            if (rangeEnd.line == lineN) return rangeEnd;
            lineObj = getLine(doc, lineN = rangeEnd.line);
        }
    }
    function wrappedLineExtent(cm, lineObj, preparedMeasure, y) {
        y -= widgetTopHeight(lineObj);
        var end = lineObj.text.length;
        var begin = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch - 1).bottom <= y;
        }, end, 0);
        end = findFirst(function(ch) {
            return measureCharPrepared(cm, preparedMeasure, ch).top > y;
        }, begin, end);
        return {
            begin: begin,
            end: end
        };
    }
    function wrappedLineExtentChar(cm, lineObj, preparedMeasure, target) {
        if (!preparedMeasure) preparedMeasure = prepareMeasureForLine(cm, lineObj);
        var targetTop = intoCoordSystem(cm, lineObj, measureCharPrepared(cm, preparedMeasure, target), "line").top;
        return wrappedLineExtent(cm, lineObj, preparedMeasure, targetTop);
    }
    // Returns true if the given side of a box is after the given
    // coordinates, in top-to-bottom, left-to-right order.
    function boxIsAfter(box, x, y, left) {
        return box.bottom <= y ? false : box.top > y ? true : (left ? box.left : box.right) > x;
    }
    function coordsCharInner(cm, lineObj, lineNo$$1, x, y) {
        // Move y into line-local coordinate space
        y -= heightAtLine(lineObj);
        var preparedMeasure = prepareMeasureForLine(cm, lineObj);
        // When directly calling `measureCharPrepared`, we have to adjust
        // for the widgets at this line.
        var widgetHeight$$1 = widgetTopHeight(lineObj);
        var begin = 0, end = lineObj.text.length, ltr = true;
        var order = getOrder(lineObj, cm.doc.direction);
        // If the line isn't plain left-to-right text, first figure out
        // which bidi section the coordinates fall into.
        if (order) {
            var part = (cm.options.lineWrapping ? coordsBidiPartWrapped : coordsBidiPart)(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y);
            ltr = part.level != 1;
            // The awkward -1 offsets are needed because findFirst (called
            // on these below) will treat its first bound as inclusive,
            // second as exclusive, but we want to actually address the
            // characters in the part's range
            begin = ltr ? part.from : part.to - 1;
            end = ltr ? part.to : part.from - 1;
        }
        // A binary search to find the first character whose bounding box
        // starts after the coordinates. If we run across any whose box wrap
        // the coordinates, store that.
        var chAround = null, boxAround = null;
        var ch = findFirst(function(ch) {
            var box = measureCharPrepared(cm, preparedMeasure, ch);
            box.top += widgetHeight$$1;
            box.bottom += widgetHeight$$1;
            if (!boxIsAfter(box, x, y, false)) return false;
            if (box.top <= y && box.left <= x) {
                chAround = ch;
                boxAround = box;
            }
            return true;
        }, begin, end);
        var baseX, sticky, outside = false;
        // If a box around the coordinates was found, use that
        if (boxAround) {
            // Distinguish coordinates nearer to the left or right side of the box
            var atLeft = x - boxAround.left < boxAround.right - x, atStart = atLeft == ltr;
            ch = chAround + (atStart ? 0 : 1);
            sticky = atStart ? "after" : "before";
            baseX = atLeft ? boxAround.left : boxAround.right;
        } else {
            // (Adjust for extended bound, if necessary.)
            if (!ltr && (ch == end || ch == begin)) ch++;
            // To determine which side to associate with, get the box to the
            // left of the character and compare it's vertical position to the
            // coordinates
            sticky = ch == 0 ? "after" : ch == lineObj.text.length ? "before" : measureCharPrepared(cm, preparedMeasure, ch - (ltr ? 1 : 0)).bottom + widgetHeight$$1 <= y == ltr ? "after" : "before";
            // Now get accurate coordinates for this place, in order to get a
            // base X position
            var coords = cursorCoords(cm, Pos(lineNo$$1, ch, sticky), "line", lineObj, preparedMeasure);
            baseX = coords.left;
            outside = y < coords.top ? -1 : y >= coords.bottom ? 1 : 0;
        }
        ch = skipExtendingChars(lineObj.text, ch, 1);
        return PosWithInfo(lineNo$$1, ch, sticky, outside, x - baseX);
    }
    function coordsBidiPart(cm, lineObj, lineNo$$1, preparedMeasure, order, x, y) {
        // Bidi parts are sorted left-to-right, and in a non-line-wrapping
        // situation, we can take this ordering to correspond to the visual
        // ordering. This finds the first part whose end is after the given
        // coordinates.
        var index = findFirst(function(i) {
            var part = order[i], ltr = part.level != 1;
            return boxIsAfter(cursorCoords(cm, Pos(lineNo$$1, ltr ? part.to : part.from, ltr ? "before" : "after"), "line", lineObj, preparedMeasure), x, y, true);
        }, 0, order.length - 1);
        var part = order[index];
        // If this isn't the first part, the part's start is also after
        // the coordinates, and the coordinates aren't on the same line as
        // that start, move one part back.
        if (index > 0) {
            var ltr = part.level != 1;
            var start = cursorCoords(cm, Pos(lineNo$$1, ltr ? part.from : part.to, ltr ? "after" : "before"), "line", lineObj, preparedMeasure);
            if (boxIsAfter(start, x, y, true) && start.top > y) part = order[index - 1];
        }
        return part;
    }
    function coordsBidiPartWrapped(cm, lineObj, _lineNo, preparedMeasure, order, x, y) {
        // In a wrapped line, rtl text on wrapping boundaries can do things
        // that don't correspond to the ordering in our `order` array at
        // all, so a binary search doesn't work, and we want to return a
        // part that only spans one line so that the binary search in
        // coordsCharInner is safe. As such, we first find the extent of the
        // wrapped line, and then do a flat search in which we discard any
        // spans that aren't on the line.
        var ref = wrappedLineExtent(cm, lineObj, preparedMeasure, y);
        var begin = ref.begin;
        var end = ref.end;
        if (/\s/.test(lineObj.text.charAt(end - 1))) end--;
        var part = null, closestDist = null;
        for(var i = 0; i < order.length; i++){
            var p = order[i];
            if (p.from >= end || p.to <= begin) continue;
            var ltr = p.level != 1;
            var endX = measureCharPrepared(cm, preparedMeasure, ltr ? Math.min(end, p.to) - 1 : Math.max(begin, p.from)).right;
            // Weigh against spans ending before this, so that they are only
            // picked if nothing ends after
            var dist = endX < x ? x - endX + 1e9 : endX - x;
            if (!part || closestDist > dist) {
                part = p;
                closestDist = dist;
            }
        }
        if (!part) part = order[order.length - 1];
        // Clip the part to the wrapped line.
        if (part.from < begin) part = {
            from: begin,
            to: part.to,
            level: part.level
        };
        if (part.to > end) part = {
            from: part.from,
            to: end,
            level: part.level
        };
        return part;
    }
    var measureText;
    // Compute the default text height.
    function textHeight(display) {
        if (display.cachedTextHeight != null) return display.cachedTextHeight;
        if (measureText == null) {
            measureText = elt("pre", null, "CodeMirror-line-like");
            // Measure a bunch of lines, for browsers that compute
            // fractional heights.
            for(var i = 0; i < 49; ++i){
                measureText.appendChild(document.createTextNode("x"));
                measureText.appendChild(elt("br"));
            }
            measureText.appendChild(document.createTextNode("x"));
        }
        removeChildrenAndAdd(display.measure, measureText);
        var height = measureText.offsetHeight / 50;
        if (height > 3) display.cachedTextHeight = height;
        removeChildren(display.measure);
        return height || 1;
    }
    // Compute the default character width.
    function charWidth(display) {
        if (display.cachedCharWidth != null) return display.cachedCharWidth;
        var anchor = elt("span", "xxxxxxxxxx");
        var pre = elt("pre", [
            anchor
        ], "CodeMirror-line-like");
        removeChildrenAndAdd(display.measure, pre);
        var rect = anchor.getBoundingClientRect(), width = (rect.right - rect.left) / 10;
        if (width > 2) display.cachedCharWidth = width;
        return width || 10;
    }
    // Do a bulk-read of the DOM positions and sizes needed to draw the
    // view, so that we don't interleave reading and writing to the DOM.
    function getDimensions(cm) {
        var d = cm.display, left = {}, width = {};
        var gutterLeft = d.gutters.clientLeft;
        for(var n = d.gutters.firstChild, i = 0; n; n = n.nextSibling, ++i){
            var id = cm.display.gutterSpecs[i].className;
            left[id] = n.offsetLeft + n.clientLeft + gutterLeft;
            width[id] = n.clientWidth;
        }
        return {
            fixedPos: compensateForHScroll(d),
            gutterTotalWidth: d.gutters.offsetWidth,
            gutterLeft: left,
            gutterWidth: width,
            wrapperWidth: d.wrapper.clientWidth
        };
    }
    // Computes display.scroller.scrollLeft + display.gutters.offsetWidth,
    // but using getBoundingClientRect to get a sub-pixel-accurate
    // result.
    function compensateForHScroll(display) {
        return display.scroller.getBoundingClientRect().left - display.sizer.getBoundingClientRect().left;
    }
    // Returns a function that estimates the height of a line, to use as
    // first approximation until the line becomes visible (and is thus
    // properly measurable).
    function estimateHeight(cm) {
        var th = textHeight(cm.display), wrapping = cm.options.lineWrapping;
        var perLine = wrapping && Math.max(5, cm.display.scroller.clientWidth / charWidth(cm.display) - 3);
        return function(line) {
            if (lineIsHidden(cm.doc, line)) return 0;
            var widgetsHeight = 0;
            if (line.widgets) {
                for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].height) widgetsHeight += line.widgets[i].height;
            }
            if (wrapping) return widgetsHeight + (Math.ceil(line.text.length / perLine) || 1) * th;
            else return widgetsHeight + th;
        };
    }
    function estimateLineHeights(cm) {
        var doc = cm.doc, est = estimateHeight(cm);
        doc.iter(function(line) {
            var estHeight = est(line);
            if (estHeight != line.height) updateLineHeight(line, estHeight);
        });
    }
    // Given a mouse event, find the corresponding position. If liberal
    // is false, it checks whether a gutter or scrollbar was clicked,
    // and returns null if it was. forRect is used by rectangular
    // selections, and tries to estimate a character position even for
    // coordinates beyond the right of the text.
    function posFromMouse(cm, e, liberal, forRect) {
        var display = cm.display;
        if (!liberal && e_target(e).getAttribute("cm-not-content") == "true") return null;
        var x, y, space = display.lineSpace.getBoundingClientRect();
        // Fails unpredictably on IE[67] when mouse is dragged around quickly.
        try {
            x = e.clientX - space.left;
            y = e.clientY - space.top;
        } catch (e) {
            return null;
        }
        var coords = coordsChar(cm, x, y), line;
        if (forRect && coords.xRel == 1 && (line = getLine(cm.doc, coords.line).text).length == coords.ch) {
            var colDiff = countColumn(line, line.length, cm.options.tabSize) - line.length;
            coords = Pos(coords.line, Math.max(0, Math.round((x - paddingH(cm.display).left) / charWidth(cm.display)) - colDiff));
        }
        return coords;
    }
    // Find the view element corresponding to a given line. Return null
    // when the line isn't visible.
    function findViewIndex(cm, n) {
        if (n >= cm.display.viewTo) return null;
        n -= cm.display.viewFrom;
        if (n < 0) return null;
        var view = cm.display.view;
        for(var i = 0; i < view.length; i++){
            n -= view[i].size;
            if (n < 0) return i;
        }
    }
    // Updates the display.view data structure for a given change to the
    // document. From and to are in pre-change coordinates. Lendiff is
    // the amount of lines added or subtracted by the change. This is
    // used for changes that span multiple lines, or change the way
    // lines are divided into visual lines. regLineChange (below)
    // registers single-line changes.
    function regChange(cm, from, to, lendiff) {
        if (from == null) from = cm.doc.first;
        if (to == null) to = cm.doc.first + cm.doc.size;
        if (!lendiff) lendiff = 0;
        var display = cm.display;
        if (lendiff && to < display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers > from)) display.updateLineNumbers = from;
        cm.curOp.viewChanged = true;
        if (from >= display.viewTo) {
            if (sawCollapsedSpans && visualLineNo(cm.doc, from) < display.viewTo) resetView(cm);
        } else if (to <= display.viewFrom) {
            if (sawCollapsedSpans && visualLineEndNo(cm.doc, to + lendiff) > display.viewFrom) resetView(cm);
            else {
                display.viewFrom += lendiff;
                display.viewTo += lendiff;
            }
        } else if (from <= display.viewFrom && to >= display.viewTo) resetView(cm);
        else if (from <= display.viewFrom) {
            var cut = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cut) {
                display.view = display.view.slice(cut.index);
                display.viewFrom = cut.lineN;
                display.viewTo += lendiff;
            } else resetView(cm);
        } else if (to >= display.viewTo) {
            var cut$1 = viewCuttingPoint(cm, from, from, -1);
            if (cut$1) {
                display.view = display.view.slice(0, cut$1.index);
                display.viewTo = cut$1.lineN;
            } else resetView(cm);
        } else {
            var cutTop = viewCuttingPoint(cm, from, from, -1);
            var cutBot = viewCuttingPoint(cm, to, to + lendiff, 1);
            if (cutTop && cutBot) {
                display.view = display.view.slice(0, cutTop.index).concat(buildViewArray(cm, cutTop.lineN, cutBot.lineN)).concat(display.view.slice(cutBot.index));
                display.viewTo += lendiff;
            } else resetView(cm);
        }
        var ext = display.externalMeasured;
        if (ext) {
            if (to < ext.lineN) ext.lineN += lendiff;
            else if (from < ext.lineN + ext.size) display.externalMeasured = null;
        }
    }
    // Register a change to a single line. Type must be one of "text",
    // "gutter", "class", "widget"
    function regLineChange(cm, line, type) {
        cm.curOp.viewChanged = true;
        var display = cm.display, ext = cm.display.externalMeasured;
        if (ext && line >= ext.lineN && line < ext.lineN + ext.size) display.externalMeasured = null;
        if (line < display.viewFrom || line >= display.viewTo) return;
        var lineView = display.view[findViewIndex(cm, line)];
        if (lineView.node == null) return;
        var arr = lineView.changes || (lineView.changes = []);
        if (indexOf(arr, type) == -1) arr.push(type);
    }
    // Clear the view.
    function resetView(cm) {
        cm.display.viewFrom = cm.display.viewTo = cm.doc.first;
        cm.display.view = [];
        cm.display.viewOffset = 0;
    }
    function viewCuttingPoint(cm, oldN, newN, dir) {
        var index = findViewIndex(cm, oldN), diff, view = cm.display.view;
        if (!sawCollapsedSpans || newN == cm.doc.first + cm.doc.size) return {
            index: index,
            lineN: newN
        };
        var n = cm.display.viewFrom;
        for(var i = 0; i < index; i++)n += view[i].size;
        if (n != oldN) {
            if (dir > 0) {
                if (index == view.length - 1) return null;
                diff = n + view[index].size - oldN;
                index++;
            } else diff = n - oldN;
            oldN += diff;
            newN += diff;
        }
        while(visualLineNo(cm.doc, newN) != newN){
            if (index == (dir < 0 ? 0 : view.length - 1)) return null;
            newN += dir * view[index - (dir < 0 ? 1 : 0)].size;
            index += dir;
        }
        return {
            index: index,
            lineN: newN
        };
    }
    // Force the view to cover a given range, adding empty view element
    // or clipping off existing ones as needed.
    function adjustView(cm, from, to) {
        var display = cm.display, view = display.view;
        if (view.length == 0 || from >= display.viewTo || to <= display.viewFrom) {
            display.view = buildViewArray(cm, from, to);
            display.viewFrom = from;
        } else {
            if (display.viewFrom > from) display.view = buildViewArray(cm, from, display.viewFrom).concat(display.view);
            else if (display.viewFrom < from) display.view = display.view.slice(findViewIndex(cm, from));
            display.viewFrom = from;
            if (display.viewTo < to) display.view = display.view.concat(buildViewArray(cm, display.viewTo, to));
            else if (display.viewTo > to) display.view = display.view.slice(0, findViewIndex(cm, to));
        }
        display.viewTo = to;
    }
    // Count the number of lines in the view whose DOM representation is
    // out of date (or nonexistent).
    function countDirtyView(cm) {
        var view = cm.display.view, dirty = 0;
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (!lineView.hidden && (!lineView.node || lineView.changes)) ++dirty;
        }
        return dirty;
    }
    function updateSelection(cm) {
        cm.display.input.showSelection(cm.display.input.prepareSelection());
    }
    function prepareSelection(cm, primary) {
        if (primary === void 0) primary = true;
        var doc = cm.doc, result = {};
        var curFragment = result.cursors = document.createDocumentFragment();
        var selFragment = result.selection = document.createDocumentFragment();
        for(var i = 0; i < doc.sel.ranges.length; i++){
            if (!primary && i == doc.sel.primIndex) continue;
            var range$$1 = doc.sel.ranges[i];
            if (range$$1.from().line >= cm.display.viewTo || range$$1.to().line < cm.display.viewFrom) continue;
            var collapsed = range$$1.empty();
            if (collapsed || cm.options.showCursorWhenSelecting) drawSelectionCursor(cm, range$$1.head, curFragment);
            if (!collapsed) drawSelectionRange(cm, range$$1, selFragment);
        }
        return result;
    }
    // Draws a cursor for the given range
    function drawSelectionCursor(cm, head, output) {
        var pos = cursorCoords(cm, head, "div", null, null, !cm.options.singleCursorHeightPerLine);
        var cursor = output.appendChild(elt("div", "\xa0", "CodeMirror-cursor"));
        cursor.style.left = pos.left + "px";
        cursor.style.top = pos.top + "px";
        cursor.style.height = Math.max(0, pos.bottom - pos.top) * cm.options.cursorHeight + "px";
        if (pos.other) {
            // Secondary cursor, shown when on a 'jump' in bi-directional text
            var otherCursor = output.appendChild(elt("div", "\xa0", "CodeMirror-cursor CodeMirror-secondarycursor"));
            otherCursor.style.display = "";
            otherCursor.style.left = pos.other.left + "px";
            otherCursor.style.top = pos.other.top + "px";
            otherCursor.style.height = (pos.other.bottom - pos.other.top) * .85 + "px";
        }
    }
    function cmpCoords(a, b) {
        return a.top - b.top || a.left - b.left;
    }
    // Draws the given range as a highlighted selection
    function drawSelectionRange(cm, range$$1, output) {
        var display = cm.display, doc = cm.doc;
        var fragment = document.createDocumentFragment();
        var padding = paddingH(cm.display), leftSide = padding.left;
        var rightSide = Math.max(display.sizerWidth, displayWidth(cm) - display.sizer.offsetLeft) - padding.right;
        var docLTR = doc.direction == "ltr";
        function add(left, top, width, bottom) {
            if (top < 0) top = 0;
            top = Math.round(top);
            bottom = Math.round(bottom);
            fragment.appendChild(elt("div", null, "CodeMirror-selected", "position: absolute; left: " + left + "px;\n                             top: " + top + "px; width: " + (width == null ? rightSide - left : width) + "px;\n                             height: " + (bottom - top) + "px"));
        }
        function drawForLine(line, fromArg, toArg) {
            var lineObj = getLine(doc, line);
            var lineLen = lineObj.text.length;
            var start, end;
            function coords(ch, bias) {
                return charCoords(cm, Pos(line, ch), "div", lineObj, bias);
            }
            function wrapX(pos, dir, side) {
                var extent = wrappedLineExtentChar(cm, lineObj, null, pos);
                var prop = dir == "ltr" == (side == "after") ? "left" : "right";
                var ch = side == "after" ? extent.begin : extent.end - (/\s/.test(lineObj.text.charAt(extent.end - 1)) ? 2 : 1);
                return coords(ch, prop)[prop];
            }
            var order = getOrder(lineObj, doc.direction);
            iterateBidiSections(order, fromArg || 0, toArg == null ? lineLen : toArg, function(from, to, dir, i) {
                var ltr = dir == "ltr";
                var fromPos = coords(from, ltr ? "left" : "right");
                var toPos = coords(to - 1, ltr ? "right" : "left");
                var openStart = fromArg == null && from == 0, openEnd = toArg == null && to == lineLen;
                var first = i == 0, last = !order || i == order.length - 1;
                if (toPos.top - fromPos.top <= 3) {
                    var openLeft = (docLTR ? openStart : openEnd) && first;
                    var openRight = (docLTR ? openEnd : openStart) && last;
                    var left = openLeft ? leftSide : (ltr ? fromPos : toPos).left;
                    var right = openRight ? rightSide : (ltr ? toPos : fromPos).right;
                    add(left, fromPos.top, right - left, fromPos.bottom);
                } else {
                    var topLeft, topRight, botLeft, botRight;
                    if (ltr) {
                        topLeft = docLTR && openStart && first ? leftSide : fromPos.left;
                        topRight = docLTR ? rightSide : wrapX(from, dir, "before");
                        botLeft = docLTR ? leftSide : wrapX(to, dir, "after");
                        botRight = docLTR && openEnd && last ? rightSide : toPos.right;
                    } else {
                        topLeft = !docLTR ? leftSide : wrapX(from, dir, "before");
                        topRight = !docLTR && openStart && first ? rightSide : fromPos.right;
                        botLeft = !docLTR && openEnd && last ? leftSide : toPos.left;
                        botRight = !docLTR ? rightSide : wrapX(to, dir, "after");
                    }
                    add(topLeft, fromPos.top, topRight - topLeft, fromPos.bottom);
                    if (fromPos.bottom < toPos.top) add(leftSide, fromPos.bottom, null, toPos.top);
                    add(botLeft, toPos.top, botRight - botLeft, toPos.bottom);
                }
                if (!start || cmpCoords(fromPos, start) < 0) start = fromPos;
                if (cmpCoords(toPos, start) < 0) start = toPos;
                if (!end || cmpCoords(fromPos, end) < 0) end = fromPos;
                if (cmpCoords(toPos, end) < 0) end = toPos;
            });
            return {
                start: start,
                end: end
            };
        }
        var sFrom = range$$1.from(), sTo = range$$1.to();
        if (sFrom.line == sTo.line) drawForLine(sFrom.line, sFrom.ch, sTo.ch);
        else {
            var fromLine = getLine(doc, sFrom.line), toLine = getLine(doc, sTo.line);
            var singleVLine = visualLine(fromLine) == visualLine(toLine);
            var leftEnd = drawForLine(sFrom.line, sFrom.ch, singleVLine ? fromLine.text.length + 1 : null).end;
            var rightStart = drawForLine(sTo.line, singleVLine ? 0 : null, sTo.ch).start;
            if (singleVLine) {
                if (leftEnd.top < rightStart.top - 2) {
                    add(leftEnd.right, leftEnd.top, null, leftEnd.bottom);
                    add(leftSide, rightStart.top, rightStart.left, rightStart.bottom);
                } else add(leftEnd.right, leftEnd.top, rightStart.left - leftEnd.right, leftEnd.bottom);
            }
            if (leftEnd.bottom < rightStart.top) add(leftSide, leftEnd.bottom, null, rightStart.top);
        }
        output.appendChild(fragment);
    }
    // Cursor-blinking
    function restartBlink(cm) {
        if (!cm.state.focused) return;
        var display = cm.display;
        clearInterval(display.blinker);
        var on = true;
        display.cursorDiv.style.visibility = "";
        if (cm.options.cursorBlinkRate > 0) display.blinker = setInterval(function() {
            return display.cursorDiv.style.visibility = (on = !on) ? "" : "hidden";
        }, cm.options.cursorBlinkRate);
        else if (cm.options.cursorBlinkRate < 0) display.cursorDiv.style.visibility = "hidden";
    }
    function ensureFocus(cm) {
        if (!cm.state.focused) {
            cm.display.input.focus();
            onFocus(cm);
        }
    }
    function delayBlurEvent(cm) {
        cm.state.delayingBlurEvent = true;
        setTimeout(function() {
            if (cm.state.delayingBlurEvent) {
                cm.state.delayingBlurEvent = false;
                onBlur(cm);
            }
        }, 100);
    }
    function onFocus(cm, e) {
        if (cm.state.delayingBlurEvent) cm.state.delayingBlurEvent = false;
        if (cm.options.readOnly == "nocursor") return;
        if (!cm.state.focused) {
            signal(cm, "focus", cm, e);
            cm.state.focused = true;
            addClass(cm.display.wrapper, "CodeMirror-focused");
            // This test prevents this from firing when a context
            // menu is closed (since the input reset would kill the
            // select-all detection hack)
            if (!cm.curOp && cm.display.selForContextMenu != cm.doc.sel) {
                cm.display.input.reset();
                if (webkit) setTimeout(function() {
                    return cm.display.input.reset(true);
                }, 20);
                 // Issue #1730
            }
            cm.display.input.receivedFocus();
        }
        restartBlink(cm);
    }
    function onBlur(cm, e) {
        if (cm.state.delayingBlurEvent) return;
        if (cm.state.focused) {
            signal(cm, "blur", cm, e);
            cm.state.focused = false;
            rmClass(cm.display.wrapper, "CodeMirror-focused");
        }
        clearInterval(cm.display.blinker);
        setTimeout(function() {
            if (!cm.state.focused) cm.display.shift = false;
        }, 150);
    }
    // Read the actual heights of the rendered lines, and update their
    // stored heights to match.
    function updateHeightsInViewport(cm) {
        var display = cm.display;
        var prevBottom = display.lineDiv.offsetTop;
        for(var i = 0; i < display.view.length; i++){
            var cur = display.view[i], wrapping = cm.options.lineWrapping;
            var height = void 0, width = 0;
            if (cur.hidden) continue;
            if (ie && ie_version < 8) {
                var bot = cur.node.offsetTop + cur.node.offsetHeight;
                height = bot - prevBottom;
                prevBottom = bot;
            } else {
                var box = cur.node.getBoundingClientRect();
                height = box.bottom - box.top;
                // Check that lines don't extend past the right of the current
                // editor width
                if (!wrapping && cur.text.firstChild) width = cur.text.firstChild.getBoundingClientRect().right - box.left - 1;
            }
            var diff = cur.line.height - height;
            if (diff > .005 || diff < -0.005) {
                updateLineHeight(cur.line, height);
                updateWidgetHeight(cur.line);
                if (cur.rest) for(var j = 0; j < cur.rest.length; j++)updateWidgetHeight(cur.rest[j]);
            }
            if (width > cm.display.sizerWidth) {
                var chWidth = Math.ceil(width / charWidth(cm.display));
                if (chWidth > cm.display.maxLineLength) {
                    cm.display.maxLineLength = chWidth;
                    cm.display.maxLine = cur.line;
                    cm.display.maxLineChanged = true;
                }
            }
        }
    }
    // Read and store the height of line widgets associated with the
    // given line.
    function updateWidgetHeight(line) {
        if (line.widgets) for(var i = 0; i < line.widgets.length; ++i){
            var w = line.widgets[i], parent = w.node.parentNode;
            if (parent) w.height = parent.offsetHeight;
        }
    }
    // Compute the lines that are visible in a given viewport (defaults
    // the the current scroll position). viewport may contain top,
    // height, and ensure (see op.scrollToPos) properties.
    function visibleLines(display, doc, viewport) {
        var top = viewport && viewport.top != null ? Math.max(0, viewport.top) : display.scroller.scrollTop;
        top = Math.floor(top - paddingTop(display));
        var bottom = viewport && viewport.bottom != null ? viewport.bottom : top + display.wrapper.clientHeight;
        var from = lineAtHeight(doc, top), to = lineAtHeight(doc, bottom);
        // Ensure is a {from: {line, ch}, to: {line, ch}} object, and
        // forces those lines into the viewport (if possible).
        if (viewport && viewport.ensure) {
            var ensureFrom = viewport.ensure.from.line, ensureTo = viewport.ensure.to.line;
            if (ensureFrom < from) {
                from = ensureFrom;
                to = lineAtHeight(doc, heightAtLine(getLine(doc, ensureFrom)) + display.wrapper.clientHeight);
            } else if (Math.min(ensureTo, doc.lastLine()) >= to) {
                from = lineAtHeight(doc, heightAtLine(getLine(doc, ensureTo)) - display.wrapper.clientHeight);
                to = ensureTo;
            }
        }
        return {
            from: from,
            to: Math.max(to, from + 1)
        };
    }
    // SCROLLING THINGS INTO VIEW
    // If an editor sits on the top or bottom of the window, partially
    // scrolled out of view, this ensures that the cursor is visible.
    function maybeScrollWindow(cm, rect) {
        if (signalDOMEvent(cm, "scrollCursorIntoView")) return;
        var display = cm.display, box = display.sizer.getBoundingClientRect(), doScroll = null;
        if (rect.top + box.top < 0) doScroll = true;
        else if (rect.bottom + box.top > (window.innerHeight || document.documentElement.clientHeight)) doScroll = false;
        if (doScroll != null && !phantom) {
            var scrollNode = elt("div", "​", null, "position: absolute;\n                         top: " + (rect.top - display.viewOffset - paddingTop(cm.display)) + "px;\n                         height: " + (rect.bottom - rect.top + scrollGap(cm) + display.barHeight) + "px;\n                         left: " + rect.left + "px; width: " + Math.max(2, rect.right - rect.left) + "px;");
            cm.display.lineSpace.appendChild(scrollNode);
            scrollNode.scrollIntoView(doScroll);
            cm.display.lineSpace.removeChild(scrollNode);
        }
    }
    // Scroll a given position into view (immediately), verifying that
    // it actually became visible (as line heights are accurately
    // measured, the position of something may 'drift' during drawing).
    function scrollPosIntoView(cm, pos, end, margin) {
        if (margin == null) margin = 0;
        var rect;
        if (!cm.options.lineWrapping && pos == end) {
            // Set pos and end to the cursor positions around the character pos sticks to
            // If pos.sticky == "before", that is around pos.ch - 1, otherwise around pos.ch
            // If pos == Pos(_, 0, "before"), pos and end are unchanged
            pos = pos.ch ? Pos(pos.line, pos.sticky == "before" ? pos.ch - 1 : pos.ch, "after") : pos;
            end = pos.sticky == "before" ? Pos(pos.line, pos.ch + 1, "before") : pos;
        }
        for(var limit = 0; limit < 5; limit++){
            var changed = false;
            var coords = cursorCoords(cm, pos);
            var endCoords = !end || end == pos ? coords : cursorCoords(cm, end);
            rect = {
                left: Math.min(coords.left, endCoords.left),
                top: Math.min(coords.top, endCoords.top) - margin,
                right: Math.max(coords.left, endCoords.left),
                bottom: Math.max(coords.bottom, endCoords.bottom) + margin
            };
            var scrollPos = calculateScrollPos(cm, rect);
            var startTop = cm.doc.scrollTop, startLeft = cm.doc.scrollLeft;
            if (scrollPos.scrollTop != null) {
                updateScrollTop(cm, scrollPos.scrollTop);
                if (Math.abs(cm.doc.scrollTop - startTop) > 1) changed = true;
            }
            if (scrollPos.scrollLeft != null) {
                setScrollLeft(cm, scrollPos.scrollLeft);
                if (Math.abs(cm.doc.scrollLeft - startLeft) > 1) changed = true;
            }
            if (!changed) break;
        }
        return rect;
    }
    // Scroll a given set of coordinates into view (immediately).
    function scrollIntoView(cm, rect) {
        var scrollPos = calculateScrollPos(cm, rect);
        if (scrollPos.scrollTop != null) updateScrollTop(cm, scrollPos.scrollTop);
        if (scrollPos.scrollLeft != null) setScrollLeft(cm, scrollPos.scrollLeft);
    }
    // Calculate a new scroll position needed to scroll the given
    // rectangle into view. Returns an object with scrollTop and
    // scrollLeft properties. When these are undefined, the
    // vertical/horizontal position does not need to be adjusted.
    function calculateScrollPos(cm, rect) {
        var display = cm.display, snapMargin = textHeight(cm.display);
        if (rect.top < 0) rect.top = 0;
        var screentop = cm.curOp && cm.curOp.scrollTop != null ? cm.curOp.scrollTop : display.scroller.scrollTop;
        var screen1 = displayHeight(cm), result = {};
        if (rect.bottom - rect.top > screen1) rect.bottom = rect.top + screen1;
        var docBottom = cm.doc.height + paddingVert(display);
        var atTop = rect.top < snapMargin, atBottom = rect.bottom > docBottom - snapMargin;
        if (rect.top < screentop) result.scrollTop = atTop ? 0 : rect.top;
        else if (rect.bottom > screentop + screen1) {
            var newTop = Math.min(rect.top, (atBottom ? docBottom : rect.bottom) - screen1);
            if (newTop != screentop) result.scrollTop = newTop;
        }
        var screenleft = cm.curOp && cm.curOp.scrollLeft != null ? cm.curOp.scrollLeft : display.scroller.scrollLeft;
        var screenw = displayWidth(cm) - (cm.options.fixedGutter ? display.gutters.offsetWidth : 0);
        var tooWide = rect.right - rect.left > screenw;
        if (tooWide) rect.right = rect.left + screenw;
        if (rect.left < 10) result.scrollLeft = 0;
        else if (rect.left < screenleft) result.scrollLeft = Math.max(0, rect.left - (tooWide ? 0 : 10));
        else if (rect.right > screenw + screenleft - 3) result.scrollLeft = rect.right + (tooWide ? 0 : 10) - screenw;
        return result;
    }
    // Store a relative adjustment to the scroll position in the current
    // operation (to be applied when the operation finishes).
    function addToScrollTop(cm, top) {
        if (top == null) return;
        resolveScrollToPos(cm);
        cm.curOp.scrollTop = (cm.curOp.scrollTop == null ? cm.doc.scrollTop : cm.curOp.scrollTop) + top;
    }
    // Make sure that at the end of the operation the current cursor is
    // shown.
    function ensureCursorVisible(cm) {
        resolveScrollToPos(cm);
        var cur = cm.getCursor();
        cm.curOp.scrollToPos = {
            from: cur,
            to: cur,
            margin: cm.options.cursorScrollMargin
        };
    }
    function scrollToCoords(cm, x, y) {
        if (x != null || y != null) resolveScrollToPos(cm);
        if (x != null) cm.curOp.scrollLeft = x;
        if (y != null) cm.curOp.scrollTop = y;
    }
    function scrollToRange(cm, range$$1) {
        resolveScrollToPos(cm);
        cm.curOp.scrollToPos = range$$1;
    }
    // When an operation has its scrollToPos property set, and another
    // scroll action is applied before the end of the operation, this
    // 'simulates' scrolling that position into view in a cheap way, so
    // that the effect of intermediate scroll commands is not ignored.
    function resolveScrollToPos(cm) {
        var range$$1 = cm.curOp.scrollToPos;
        if (range$$1) {
            cm.curOp.scrollToPos = null;
            var from = estimateCoords(cm, range$$1.from), to = estimateCoords(cm, range$$1.to);
            scrollToCoordsRange(cm, from, to, range$$1.margin);
        }
    }
    function scrollToCoordsRange(cm, from, to, margin) {
        var sPos = calculateScrollPos(cm, {
            left: Math.min(from.left, to.left),
            top: Math.min(from.top, to.top) - margin,
            right: Math.max(from.right, to.right),
            bottom: Math.max(from.bottom, to.bottom) + margin
        });
        scrollToCoords(cm, sPos.scrollLeft, sPos.scrollTop);
    }
    // Sync the scrollable area and scrollbars, ensure the viewport
    // covers the visible area.
    function updateScrollTop(cm, val) {
        if (Math.abs(cm.doc.scrollTop - val) < 2) return;
        if (!gecko) updateDisplaySimple(cm, {
            top: val
        });
        setScrollTop(cm, val, true);
        if (gecko) updateDisplaySimple(cm);
        startWorker(cm, 100);
    }
    function setScrollTop(cm, val, forceScroll) {
        val = Math.min(cm.display.scroller.scrollHeight - cm.display.scroller.clientHeight, val);
        if (cm.display.scroller.scrollTop == val && !forceScroll) return;
        cm.doc.scrollTop = val;
        cm.display.scrollbars.setScrollTop(val);
        if (cm.display.scroller.scrollTop != val) cm.display.scroller.scrollTop = val;
    }
    // Sync scroller and scrollbar, ensure the gutter elements are
    // aligned.
    function setScrollLeft(cm, val, isScroller, forceScroll) {
        val = Math.min(val, cm.display.scroller.scrollWidth - cm.display.scroller.clientWidth);
        if ((isScroller ? val == cm.doc.scrollLeft : Math.abs(cm.doc.scrollLeft - val) < 2) && !forceScroll) return;
        cm.doc.scrollLeft = val;
        alignHorizontally(cm);
        if (cm.display.scroller.scrollLeft != val) cm.display.scroller.scrollLeft = val;
        cm.display.scrollbars.setScrollLeft(val);
    }
    // SCROLLBARS
    // Prepare DOM reads needed to update the scrollbars. Done in one
    // shot to minimize update/measure roundtrips.
    function measureForScrollbars(cm) {
        var d = cm.display, gutterW = d.gutters.offsetWidth;
        var docH = Math.round(cm.doc.height + paddingVert(cm.display));
        return {
            clientHeight: d.scroller.clientHeight,
            viewHeight: d.wrapper.clientHeight,
            scrollWidth: d.scroller.scrollWidth,
            clientWidth: d.scroller.clientWidth,
            viewWidth: d.wrapper.clientWidth,
            barLeft: cm.options.fixedGutter ? gutterW : 0,
            docHeight: docH,
            scrollHeight: docH + scrollGap(cm) + d.barHeight,
            nativeBarWidth: d.nativeBarWidth,
            gutterWidth: gutterW
        };
    }
    var NativeScrollbars = function(place, scroll, cm) {
        this.cm = cm;
        var vert = this.vert = elt("div", [
            elt("div", null, null, "min-width: 1px")
        ], "CodeMirror-vscrollbar");
        var horiz = this.horiz = elt("div", [
            elt("div", null, null, "height: 100%; min-height: 1px")
        ], "CodeMirror-hscrollbar");
        vert.tabIndex = horiz.tabIndex = -1;
        place(vert);
        place(horiz);
        on(vert, "scroll", function() {
            if (vert.clientHeight) scroll(vert.scrollTop, "vertical");
        });
        on(horiz, "scroll", function() {
            if (horiz.clientWidth) scroll(horiz.scrollLeft, "horizontal");
        });
        this.checkedZeroWidth = false;
        // Need to set a minimum width to see the scrollbar on IE7 (but must not set it on IE8).
        if (ie && ie_version < 8) this.horiz.style.minHeight = this.vert.style.minWidth = "18px";
    };
    NativeScrollbars.prototype.update = function(measure) {
        var needsH = measure.scrollWidth > measure.clientWidth + 1;
        var needsV = measure.scrollHeight > measure.clientHeight + 1;
        var sWidth = measure.nativeBarWidth;
        if (needsV) {
            this.vert.style.display = "block";
            this.vert.style.bottom = needsH ? sWidth + "px" : "0";
            var totalHeight = measure.viewHeight - (needsH ? sWidth : 0);
            // A bug in IE8 can cause this value to be negative, so guard it.
            this.vert.firstChild.style.height = Math.max(0, measure.scrollHeight - measure.clientHeight + totalHeight) + "px";
        } else {
            this.vert.style.display = "";
            this.vert.firstChild.style.height = "0";
        }
        if (needsH) {
            this.horiz.style.display = "block";
            this.horiz.style.right = needsV ? sWidth + "px" : "0";
            this.horiz.style.left = measure.barLeft + "px";
            var totalWidth = measure.viewWidth - measure.barLeft - (needsV ? sWidth : 0);
            this.horiz.firstChild.style.width = Math.max(0, measure.scrollWidth - measure.clientWidth + totalWidth) + "px";
        } else {
            this.horiz.style.display = "";
            this.horiz.firstChild.style.width = "0";
        }
        if (!this.checkedZeroWidth && measure.clientHeight > 0) {
            if (sWidth == 0) this.zeroWidthHack();
            this.checkedZeroWidth = true;
        }
        return {
            right: needsV ? sWidth : 0,
            bottom: needsH ? sWidth : 0
        };
    };
    NativeScrollbars.prototype.setScrollLeft = function(pos) {
        if (this.horiz.scrollLeft != pos) this.horiz.scrollLeft = pos;
        if (this.disableHoriz) this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
    };
    NativeScrollbars.prototype.setScrollTop = function(pos) {
        if (this.vert.scrollTop != pos) this.vert.scrollTop = pos;
        if (this.disableVert) this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
    };
    NativeScrollbars.prototype.zeroWidthHack = function() {
        var w = mac && !mac_geMountainLion ? "12px" : "18px";
        this.horiz.style.height = this.vert.style.width = w;
        this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none";
        this.disableHoriz = new Delayed;
        this.disableVert = new Delayed;
    };
    NativeScrollbars.prototype.enableZeroWidthBar = function(bar, delay, type) {
        bar.style.pointerEvents = "auto";
        function maybeDisable() {
            // To find out whether the scrollbar is still visible, we
            // check whether the element under the pixel in the bottom
            // right corner of the scrollbar box is the scrollbar box
            // itself (when the bar is still visible) or its filler child
            // (when the bar is hidden). If it is still visible, we keep
            // it enabled, if it's hidden, we disable pointer events.
            var box = bar.getBoundingClientRect();
            var elt$$1 = type == "vert" ? document.elementFromPoint(box.right - 1, (box.top + box.bottom) / 2) : document.elementFromPoint((box.right + box.left) / 2, box.bottom - 1);
            if (elt$$1 != bar) bar.style.pointerEvents = "none";
            else delay.set(1000, maybeDisable);
        }
        delay.set(1000, maybeDisable);
    };
    NativeScrollbars.prototype.clear = function() {
        var parent = this.horiz.parentNode;
        parent.removeChild(this.horiz);
        parent.removeChild(this.vert);
    };
    var NullScrollbars = function() {};
    NullScrollbars.prototype.update = function() {
        return {
            bottom: 0,
            right: 0
        };
    };
    NullScrollbars.prototype.setScrollLeft = function() {};
    NullScrollbars.prototype.setScrollTop = function() {};
    NullScrollbars.prototype.clear = function() {};
    function updateScrollbars(cm, measure) {
        if (!measure) measure = measureForScrollbars(cm);
        var startWidth = cm.display.barWidth, startHeight = cm.display.barHeight;
        updateScrollbarsInner(cm, measure);
        for(var i = 0; i < 4 && startWidth != cm.display.barWidth || startHeight != cm.display.barHeight; i++){
            if (startWidth != cm.display.barWidth && cm.options.lineWrapping) updateHeightsInViewport(cm);
            updateScrollbarsInner(cm, measureForScrollbars(cm));
            startWidth = cm.display.barWidth;
            startHeight = cm.display.barHeight;
        }
    }
    // Re-synchronize the fake scrollbars with the actual size of the
    // content.
    function updateScrollbarsInner(cm, measure) {
        var d = cm.display;
        var sizes = d.scrollbars.update(measure);
        d.sizer.style.paddingRight = (d.barWidth = sizes.right) + "px";
        d.sizer.style.paddingBottom = (d.barHeight = sizes.bottom) + "px";
        d.heightForcer.style.borderBottom = sizes.bottom + "px solid transparent";
        if (sizes.right && sizes.bottom) {
            d.scrollbarFiller.style.display = "block";
            d.scrollbarFiller.style.height = sizes.bottom + "px";
            d.scrollbarFiller.style.width = sizes.right + "px";
        } else d.scrollbarFiller.style.display = "";
        if (sizes.bottom && cm.options.coverGutterNextToScrollbar && cm.options.fixedGutter) {
            d.gutterFiller.style.display = "block";
            d.gutterFiller.style.height = sizes.bottom + "px";
            d.gutterFiller.style.width = measure.gutterWidth + "px";
        } else d.gutterFiller.style.display = "";
    }
    var scrollbarModel = {
        "native": NativeScrollbars,
        "null": NullScrollbars
    };
    function initScrollbars(cm) {
        if (cm.display.scrollbars) {
            cm.display.scrollbars.clear();
            if (cm.display.scrollbars.addClass) rmClass(cm.display.wrapper, cm.display.scrollbars.addClass);
        }
        cm.display.scrollbars = new scrollbarModel[cm.options.scrollbarStyle](function(node) {
            cm.display.wrapper.insertBefore(node, cm.display.scrollbarFiller);
            // Prevent clicks in the scrollbars from killing focus
            on(node, "mousedown", function() {
                if (cm.state.focused) setTimeout(function() {
                    return cm.display.input.focus();
                }, 0);
            });
            node.setAttribute("cm-not-content", "true");
        }, function(pos, axis) {
            if (axis == "horizontal") setScrollLeft(cm, pos);
            else updateScrollTop(cm, pos);
        }, cm);
        if (cm.display.scrollbars.addClass) addClass(cm.display.wrapper, cm.display.scrollbars.addClass);
    }
    // Operations are used to wrap a series of changes to the editor
    // state in such a way that each change won't have to update the
    // cursor and display (which would be awkward, slow, and
    // error-prone). Instead, display updates are batched and then all
    // combined and executed at once.
    var nextOpId = 0;
    // Start a new operation.
    function startOperation(cm) {
        cm.curOp = {
            cm: cm,
            viewChanged: false,
            startHeight: cm.doc.height,
            forceUpdate: false,
            updateInput: 0,
            typing: false,
            changeObjs: null,
            cursorActivityHandlers: null,
            cursorActivityCalled: 0,
            selectionChanged: false,
            updateMaxLine: false,
            scrollLeft: null,
            scrollTop: null,
            scrollToPos: null,
            focus: false,
            id: ++nextOpId // Unique ID
        };
        pushOperation(cm.curOp);
    }
    // Finish an operation, updating the display and signalling delayed events
    function endOperation(cm) {
        var op = cm.curOp;
        if (op) finishOperation(op, function(group) {
            for(var i = 0; i < group.ops.length; i++)group.ops[i].cm.curOp = null;
            endOperations(group);
        });
    }
    // The DOM updates done when an operation finishes are batched so
    // that the minimum number of relayouts are required.
    function endOperations(group) {
        var ops = group.ops;
        for(var i = 0; i < ops.length; i++)endOperation_R1(ops[i]);
        for(var i$1 = 0; i$1 < ops.length; i$1++)endOperation_W1(ops[i$1]);
        for(var i$2 = 0; i$2 < ops.length; i$2++)endOperation_R2(ops[i$2]);
        for(var i$3 = 0; i$3 < ops.length; i$3++)endOperation_W2(ops[i$3]);
        for(var i$4 = 0; i$4 < ops.length; i$4++)endOperation_finish(ops[i$4]);
    }
    function endOperation_R1(op) {
        var cm = op.cm, display = cm.display;
        maybeClipScrollbars(cm);
        if (op.updateMaxLine) findMaxLine(cm);
        op.mustUpdate = op.viewChanged || op.forceUpdate || op.scrollTop != null || op.scrollToPos && (op.scrollToPos.from.line < display.viewFrom || op.scrollToPos.to.line >= display.viewTo) || display.maxLineChanged && cm.options.lineWrapping;
        op.update = op.mustUpdate && new DisplayUpdate(cm, op.mustUpdate && {
            top: op.scrollTop,
            ensure: op.scrollToPos
        }, op.forceUpdate);
    }
    function endOperation_W1(op) {
        op.updatedDisplay = op.mustUpdate && updateDisplayIfNeeded(op.cm, op.update);
    }
    function endOperation_R2(op) {
        var cm = op.cm, display = cm.display;
        if (op.updatedDisplay) updateHeightsInViewport(cm);
        op.barMeasure = measureForScrollbars(cm);
        // If the max line changed since it was last measured, measure it,
        // and ensure the document's width matches it.
        // updateDisplay_W2 will use these properties to do the actual resizing
        if (display.maxLineChanged && !cm.options.lineWrapping) {
            op.adjustWidthTo = measureChar(cm, display.maxLine, display.maxLine.text.length).left + 3;
            cm.display.sizerWidth = op.adjustWidthTo;
            op.barMeasure.scrollWidth = Math.max(display.scroller.clientWidth, display.sizer.offsetLeft + op.adjustWidthTo + scrollGap(cm) + cm.display.barWidth);
            op.maxScrollLeft = Math.max(0, display.sizer.offsetLeft + op.adjustWidthTo - displayWidth(cm));
        }
        if (op.updatedDisplay || op.selectionChanged) op.preparedSelection = display.input.prepareSelection();
    }
    function endOperation_W2(op) {
        var cm = op.cm;
        if (op.adjustWidthTo != null) {
            cm.display.sizer.style.minWidth = op.adjustWidthTo + "px";
            if (op.maxScrollLeft < cm.doc.scrollLeft) setScrollLeft(cm, Math.min(cm.display.scroller.scrollLeft, op.maxScrollLeft), true);
            cm.display.maxLineChanged = false;
        }
        var takeFocus = op.focus && op.focus == activeElt();
        if (op.preparedSelection) cm.display.input.showSelection(op.preparedSelection, takeFocus);
        if (op.updatedDisplay || op.startHeight != cm.doc.height) updateScrollbars(cm, op.barMeasure);
        if (op.updatedDisplay) setDocumentHeight(cm, op.barMeasure);
        if (op.selectionChanged) restartBlink(cm);
        if (cm.state.focused && op.updateInput) cm.display.input.reset(op.typing);
        if (takeFocus) ensureFocus(op.cm);
    }
    function endOperation_finish(op) {
        var cm = op.cm, display = cm.display, doc = cm.doc;
        if (op.updatedDisplay) postUpdateDisplay(cm, op.update);
        // Abort mouse wheel delta measurement, when scrolling explicitly
        if (display.wheelStartX != null && (op.scrollTop != null || op.scrollLeft != null || op.scrollToPos)) display.wheelStartX = display.wheelStartY = null;
        // Propagate the scroll position to the actual DOM scroller
        if (op.scrollTop != null) setScrollTop(cm, op.scrollTop, op.forceScroll);
        if (op.scrollLeft != null) setScrollLeft(cm, op.scrollLeft, true, true);
        // If we need to scroll a specific position into view, do so.
        if (op.scrollToPos) {
            var rect = scrollPosIntoView(cm, clipPos(doc, op.scrollToPos.from), clipPos(doc, op.scrollToPos.to), op.scrollToPos.margin);
            maybeScrollWindow(cm, rect);
        }
        // Fire events for markers that are hidden/unidden by editing or
        // undoing
        var hidden = op.maybeHiddenMarkers, unhidden = op.maybeUnhiddenMarkers;
        if (hidden) {
            for(var i = 0; i < hidden.length; ++i)if (!hidden[i].lines.length) signal(hidden[i], "hide");
        }
        if (unhidden) {
            for(var i$1 = 0; i$1 < unhidden.length; ++i$1)if (unhidden[i$1].lines.length) signal(unhidden[i$1], "unhide");
        }
        if (display.wrapper.offsetHeight) doc.scrollTop = cm.display.scroller.scrollTop;
        // Fire change events, and delayed event handlers
        if (op.changeObjs) signal(cm, "changes", cm, op.changeObjs);
        if (op.update) op.update.finish();
    }
    // Run the given function in an operation
    function runInOp(cm, f) {
        if (cm.curOp) return f();
        startOperation(cm);
        try {
            return f();
        } finally{
            endOperation(cm);
        }
    }
    // Wraps a function in an operation. Returns the wrapped function.
    function operation(cm, f) {
        return function() {
            if (cm.curOp) return f.apply(cm, arguments);
            startOperation(cm);
            try {
                return f.apply(cm, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // Used to add methods to editor and doc instances, wrapping them in
    // operations.
    function methodOp(f) {
        return function() {
            if (this.curOp) return f.apply(this, arguments);
            startOperation(this);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(this);
            }
        };
    }
    function docMethodOp(f) {
        return function() {
            var cm = this.cm;
            if (!cm || cm.curOp) return f.apply(this, arguments);
            startOperation(cm);
            try {
                return f.apply(this, arguments);
            } finally{
                endOperation(cm);
            }
        };
    }
    // HIGHLIGHT WORKER
    function startWorker(cm, time) {
        if (cm.doc.highlightFrontier < cm.display.viewTo) cm.state.highlight.set(time, bind(highlightWorker, cm));
    }
    function highlightWorker(cm) {
        var doc = cm.doc;
        if (doc.highlightFrontier >= cm.display.viewTo) return;
        var end = +new Date + cm.options.workTime;
        var context = getContextBefore(cm, doc.highlightFrontier);
        var changedLines = [];
        doc.iter(context.line, Math.min(doc.first + doc.size, cm.display.viewTo + 500), function(line) {
            if (context.line >= cm.display.viewFrom) {
                var oldStyles = line.styles;
                var resetState = line.text.length > cm.options.maxHighlightLength ? copyState(doc.mode, context.state) : null;
                var highlighted = highlightLine(cm, line, context, true);
                if (resetState) context.state = resetState;
                line.styles = highlighted.styles;
                var oldCls = line.styleClasses, newCls = highlighted.classes;
                if (newCls) line.styleClasses = newCls;
                else if (oldCls) line.styleClasses = null;
                var ischange = !oldStyles || oldStyles.length != line.styles.length || oldCls != newCls && (!oldCls || !newCls || oldCls.bgClass != newCls.bgClass || oldCls.textClass != newCls.textClass);
                for(var i = 0; !ischange && i < oldStyles.length; ++i)ischange = oldStyles[i] != line.styles[i];
                if (ischange) changedLines.push(context.line);
                line.stateAfter = context.save();
                context.nextLine();
            } else {
                if (line.text.length <= cm.options.maxHighlightLength) processLine(cm, line.text, context);
                line.stateAfter = context.line % 5 == 0 ? context.save() : null;
                context.nextLine();
            }
            if (+new Date > end) {
                startWorker(cm, cm.options.workDelay);
                return true;
            }
        });
        doc.highlightFrontier = context.line;
        doc.modeFrontier = Math.max(doc.modeFrontier, context.line);
        if (changedLines.length) runInOp(cm, function() {
            for(var i = 0; i < changedLines.length; i++)regLineChange(cm, changedLines[i], "text");
        });
    }
    // DISPLAY DRAWING
    var DisplayUpdate = function(cm, viewport, force) {
        var display = cm.display;
        this.viewport = viewport;
        // Store some values that we'll need later (but don't want to force a relayout for)
        this.visible = visibleLines(display, cm.doc, viewport);
        this.editorIsHidden = !display.wrapper.offsetWidth;
        this.wrapperHeight = display.wrapper.clientHeight;
        this.wrapperWidth = display.wrapper.clientWidth;
        this.oldDisplayWidth = displayWidth(cm);
        this.force = force;
        this.dims = getDimensions(cm);
        this.events = [];
    };
    DisplayUpdate.prototype.signal = function(emitter, type) {
        if (hasHandler(emitter, type)) this.events.push(arguments);
    };
    DisplayUpdate.prototype.finish = function() {
        var this$1 = this;
        for(var i = 0; i < this.events.length; i++)signal.apply(null, this$1.events[i]);
    };
    function maybeClipScrollbars(cm) {
        var display = cm.display;
        if (!display.scrollbarsClipped && display.scroller.offsetWidth) {
            display.nativeBarWidth = display.scroller.offsetWidth - display.scroller.clientWidth;
            display.heightForcer.style.height = scrollGap(cm) + "px";
            display.sizer.style.marginBottom = -display.nativeBarWidth + "px";
            display.sizer.style.borderRightWidth = scrollGap(cm) + "px";
            display.scrollbarsClipped = true;
        }
    }
    function selectionSnapshot(cm) {
        if (cm.hasFocus()) return null;
        var active = activeElt();
        if (!active || !contains(cm.display.lineDiv, active)) return null;
        var result = {
            activeElt: active
        };
        if (window.getSelection) {
            var sel = window.getSelection();
            if (sel.anchorNode && sel.extend && contains(cm.display.lineDiv, sel.anchorNode)) {
                result.anchorNode = sel.anchorNode;
                result.anchorOffset = sel.anchorOffset;
                result.focusNode = sel.focusNode;
                result.focusOffset = sel.focusOffset;
            }
        }
        return result;
    }
    function restoreSelection(snapshot) {
        if (!snapshot || !snapshot.activeElt || snapshot.activeElt == activeElt()) return;
        snapshot.activeElt.focus();
        if (snapshot.anchorNode && contains(document.body, snapshot.anchorNode) && contains(document.body, snapshot.focusNode)) {
            var sel = window.getSelection(), range$$1 = document.createRange();
            range$$1.setEnd(snapshot.anchorNode, snapshot.anchorOffset);
            range$$1.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range$$1);
            sel.extend(snapshot.focusNode, snapshot.focusOffset);
        }
    }
    // Does the actual updating of the line display. Bails out
    // (returning false) when there is nothing to be done and forced is
    // false.
    function updateDisplayIfNeeded(cm, update) {
        var display = cm.display, doc = cm.doc;
        if (update.editorIsHidden) {
            resetView(cm);
            return false;
        }
        // Bail out if the visible area is already rendered and nothing changed.
        if (!update.force && update.visible.from >= display.viewFrom && update.visible.to <= display.viewTo && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo) && display.renderedView == display.view && countDirtyView(cm) == 0) return false;
        if (maybeUpdateLineNumberWidth(cm)) {
            resetView(cm);
            update.dims = getDimensions(cm);
        }
        // Compute a suitable new viewport (from & to)
        var end = doc.first + doc.size;
        var from = Math.max(update.visible.from - cm.options.viewportMargin, doc.first);
        var to = Math.min(end, update.visible.to + cm.options.viewportMargin);
        if (display.viewFrom < from && from - display.viewFrom < 20) from = Math.max(doc.first, display.viewFrom);
        if (display.viewTo > to && display.viewTo - to < 20) to = Math.min(end, display.viewTo);
        if (sawCollapsedSpans) {
            from = visualLineNo(cm.doc, from);
            to = visualLineEndNo(cm.doc, to);
        }
        var different = from != display.viewFrom || to != display.viewTo || display.lastWrapHeight != update.wrapperHeight || display.lastWrapWidth != update.wrapperWidth;
        adjustView(cm, from, to);
        display.viewOffset = heightAtLine(getLine(cm.doc, display.viewFrom));
        // Position the mover div to align with the current scroll position
        cm.display.mover.style.top = display.viewOffset + "px";
        var toUpdate = countDirtyView(cm);
        if (!different && toUpdate == 0 && !update.force && display.renderedView == display.view && (display.updateLineNumbers == null || display.updateLineNumbers >= display.viewTo)) return false;
        // For big changes, we hide the enclosing element during the
        // update, since that speeds up the operations on most browsers.
        var selSnapshot = selectionSnapshot(cm);
        if (toUpdate > 4) display.lineDiv.style.display = "none";
        patchDisplay(cm, display.updateLineNumbers, update.dims);
        if (toUpdate > 4) display.lineDiv.style.display = "";
        display.renderedView = display.view;
        // There might have been a widget with a focused element that got
        // hidden or updated, if so re-focus it.
        restoreSelection(selSnapshot);
        // Prevent selection and cursors from interfering with the scroll
        // width and height.
        removeChildren(display.cursorDiv);
        removeChildren(display.selectionDiv);
        display.gutters.style.height = display.sizer.style.minHeight = 0;
        if (different) {
            display.lastWrapHeight = update.wrapperHeight;
            display.lastWrapWidth = update.wrapperWidth;
            startWorker(cm, 400);
        }
        display.updateLineNumbers = null;
        return true;
    }
    function postUpdateDisplay(cm, update) {
        var viewport = update.viewport;
        for(var first = true;; first = false){
            if (!first || !cm.options.lineWrapping || update.oldDisplayWidth == displayWidth(cm)) {
                // Clip forced viewport to actual scrollable area.
                if (viewport && viewport.top != null) viewport = {
                    top: Math.min(cm.doc.height + paddingVert(cm.display) - displayHeight(cm), viewport.top)
                };
                // Updated line heights might result in the drawn area not
                // actually covering the viewport. Keep looping until it does.
                update.visible = visibleLines(cm.display, cm.doc, viewport);
                if (update.visible.from >= cm.display.viewFrom && update.visible.to <= cm.display.viewTo) break;
            }
            if (!updateDisplayIfNeeded(cm, update)) break;
            updateHeightsInViewport(cm);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.force = false;
        }
        update.signal(cm, "update", cm);
        if (cm.display.viewFrom != cm.display.reportedViewFrom || cm.display.viewTo != cm.display.reportedViewTo) {
            update.signal(cm, "viewportChange", cm, cm.display.viewFrom, cm.display.viewTo);
            cm.display.reportedViewFrom = cm.display.viewFrom;
            cm.display.reportedViewTo = cm.display.viewTo;
        }
    }
    function updateDisplaySimple(cm, viewport) {
        var update = new DisplayUpdate(cm, viewport);
        if (updateDisplayIfNeeded(cm, update)) {
            updateHeightsInViewport(cm);
            postUpdateDisplay(cm, update);
            var barMeasure = measureForScrollbars(cm);
            updateSelection(cm);
            updateScrollbars(cm, barMeasure);
            setDocumentHeight(cm, barMeasure);
            update.finish();
        }
    }
    // Sync the actual display DOM structure with display.view, removing
    // nodes for lines that are no longer in view, and creating the ones
    // that are not there yet, and updating the ones that are out of
    // date.
    function patchDisplay(cm, updateNumbersFrom, dims) {
        var display = cm.display, lineNumbers = cm.options.lineNumbers;
        var container = display.lineDiv, cur = container.firstChild;
        function rm(node) {
            var next = node.nextSibling;
            // Works around a throw-scroll bug in OS X Webkit
            if (webkit && mac && cm.display.currentWheelTarget == node) node.style.display = "none";
            else node.parentNode.removeChild(node);
            return next;
        }
        var view = display.view, lineN = display.viewFrom;
        // Loop over the elements in the view, syncing cur (the DOM nodes
        // in display.lineDiv) with the view as we go.
        for(var i = 0; i < view.length; i++){
            var lineView = view[i];
            if (lineView.hidden) ;
            else if (!lineView.node || lineView.node.parentNode != container) {
                var node = buildLineElement(cm, lineView, lineN, dims);
                container.insertBefore(node, cur);
            } else {
                while(cur != lineView.node)cur = rm(cur);
                var updateNumber = lineNumbers && updateNumbersFrom != null && updateNumbersFrom <= lineN && lineView.lineNumber;
                if (lineView.changes) {
                    if (indexOf(lineView.changes, "gutter") > -1) updateNumber = false;
                    updateLineForChanges(cm, lineView, lineN, dims);
                }
                if (updateNumber) {
                    removeChildren(lineView.lineNumber);
                    lineView.lineNumber.appendChild(document.createTextNode(lineNumberFor(cm.options, lineN)));
                }
                cur = lineView.node.nextSibling;
            }
            lineN += lineView.size;
        }
        while(cur)cur = rm(cur);
    }
    function updateGutterSpace(display) {
        var width = display.gutters.offsetWidth;
        display.sizer.style.marginLeft = width + "px";
    }
    function setDocumentHeight(cm, measure) {
        cm.display.sizer.style.minHeight = measure.docHeight + "px";
        cm.display.heightForcer.style.top = measure.docHeight + "px";
        cm.display.gutters.style.height = measure.docHeight + cm.display.barHeight + scrollGap(cm) + "px";
    }
    // Re-align line numbers and gutter marks to compensate for
    // horizontal scrolling.
    function alignHorizontally(cm) {
        var display = cm.display, view = display.view;
        if (!display.alignWidgets && (!display.gutters.firstChild || !cm.options.fixedGutter)) return;
        var comp = compensateForHScroll(display) - display.scroller.scrollLeft + cm.doc.scrollLeft;
        var gutterW = display.gutters.offsetWidth, left = comp + "px";
        for(var i = 0; i < view.length; i++)if (!view[i].hidden) {
            if (cm.options.fixedGutter) {
                if (view[i].gutter) view[i].gutter.style.left = left;
                if (view[i].gutterBackground) view[i].gutterBackground.style.left = left;
            }
            var align = view[i].alignable;
            if (align) for(var j = 0; j < align.length; j++)align[j].style.left = left;
        }
        if (cm.options.fixedGutter) display.gutters.style.left = comp + gutterW + "px";
    }
    // Used to ensure that the line number gutter is still the right
    // size for the current document size. Returns true when an update
    // is needed.
    function maybeUpdateLineNumberWidth(cm) {
        if (!cm.options.lineNumbers) return false;
        var doc = cm.doc, last = lineNumberFor(cm.options, doc.first + doc.size - 1), display = cm.display;
        if (last.length != display.lineNumChars) {
            var test = display.measure.appendChild(elt("div", [
                elt("div", last)
            ], "CodeMirror-linenumber CodeMirror-gutter-elt"));
            var innerW = test.firstChild.offsetWidth, padding = test.offsetWidth - innerW;
            display.lineGutter.style.width = "";
            display.lineNumInnerWidth = Math.max(innerW, display.lineGutter.offsetWidth - padding) + 1;
            display.lineNumWidth = display.lineNumInnerWidth + padding;
            display.lineNumChars = display.lineNumInnerWidth ? last.length : -1;
            display.lineGutter.style.width = display.lineNumWidth + "px";
            updateGutterSpace(cm.display);
            return true;
        }
        return false;
    }
    function getGutters(gutters, lineNumbers) {
        var result = [], sawLineNumbers = false;
        for(var i = 0; i < gutters.length; i++){
            var name = gutters[i], style = null;
            if (typeof name != "string") {
                style = name.style;
                name = name.className;
            }
            if (name == "CodeMirror-linenumbers") {
                if (!lineNumbers) continue;
                else sawLineNumbers = true;
            }
            result.push({
                className: name,
                style: style
            });
        }
        if (lineNumbers && !sawLineNumbers) result.push({
            className: "CodeMirror-linenumbers",
            style: null
        });
        return result;
    }
    // Rebuild the gutter elements, ensure the margin to the left of the
    // code matches their width.
    function renderGutters(display) {
        var gutters = display.gutters, specs = display.gutterSpecs;
        removeChildren(gutters);
        display.lineGutter = null;
        for(var i = 0; i < specs.length; ++i){
            var ref = specs[i];
            var className = ref.className;
            var style = ref.style;
            var gElt = gutters.appendChild(elt("div", null, "CodeMirror-gutter " + className));
            if (style) gElt.style.cssText = style;
            if (className == "CodeMirror-linenumbers") {
                display.lineGutter = gElt;
                gElt.style.width = (display.lineNumWidth || 1) + "px";
            }
        }
        gutters.style.display = specs.length ? "" : "none";
        updateGutterSpace(display);
    }
    function updateGutters(cm) {
        renderGutters(cm.display);
        regChange(cm);
        alignHorizontally(cm);
    }
    // The display handles the DOM integration, both for input reading
    // and content drawing. It holds references to DOM nodes and
    // display-related state.
    function Display(place, doc, input, options) {
        var d = this;
        this.input = input;
        // Covers bottom-right square when both scrollbars are present.
        d.scrollbarFiller = elt("div", null, "CodeMirror-scrollbar-filler");
        d.scrollbarFiller.setAttribute("cm-not-content", "true");
        // Covers bottom of gutter when coverGutterNextToScrollbar is on
        // and h scrollbar is present.
        d.gutterFiller = elt("div", null, "CodeMirror-gutter-filler");
        d.gutterFiller.setAttribute("cm-not-content", "true");
        // Will contain the actual code, positioned to cover the viewport.
        d.lineDiv = eltP("div", null, "CodeMirror-code");
        // Elements are added to these to represent selection and cursors.
        d.selectionDiv = elt("div", null, null, "position: relative; z-index: 1");
        d.cursorDiv = elt("div", null, "CodeMirror-cursors");
        // A visibility: hidden element used to find the size of things.
        d.measure = elt("div", null, "CodeMirror-measure");
        // When lines outside of the viewport are measured, they are drawn in this.
        d.lineMeasure = elt("div", null, "CodeMirror-measure");
        // Wraps everything that needs to exist inside the vertically-padded coordinate system
        d.lineSpace = eltP("div", [
            d.measure,
            d.lineMeasure,
            d.selectionDiv,
            d.cursorDiv,
            d.lineDiv
        ], null, "position: relative; outline: none");
        var lines = eltP("div", [
            d.lineSpace
        ], "CodeMirror-lines");
        // Moved around its parent to cover visible view.
        d.mover = elt("div", [
            lines
        ], null, "position: relative");
        // Set to the height of the document, allowing scrolling.
        d.sizer = elt("div", [
            d.mover
        ], "CodeMirror-sizer");
        d.sizerWidth = null;
        // Behavior of elts with overflow: auto and padding is
        // inconsistent across browsers. This is used to ensure the
        // scrollable area is big enough.
        d.heightForcer = elt("div", null, null, "position: absolute; height: " + scrollerGap + "px; width: 1px;");
        // Will contain the gutters, if any.
        d.gutters = elt("div", null, "CodeMirror-gutters");
        d.lineGutter = null;
        // Actual scrollable element.
        d.scroller = elt("div", [
            d.sizer,
            d.heightForcer,
            d.gutters
        ], "CodeMirror-scroll");
        d.scroller.setAttribute("tabIndex", "-1");
        // The element in which the editor lives.
        d.wrapper = elt("div", [
            d.scrollbarFiller,
            d.gutterFiller,
            d.scroller
        ], "CodeMirror");
        // Work around IE7 z-index bug (not perfect, hence IE7 not really being supported)
        if (ie && ie_version < 8) {
            d.gutters.style.zIndex = -1;
            d.scroller.style.paddingRight = 0;
        }
        if (!webkit && !(gecko && mobile)) d.scroller.draggable = true;
        if (place) {
            if (place.appendChild) place.appendChild(d.wrapper);
            else place(d.wrapper);
        }
        // Current rendered range (may be bigger than the view window).
        d.viewFrom = d.viewTo = doc.first;
        d.reportedViewFrom = d.reportedViewTo = doc.first;
        // Information about the rendered lines.
        d.view = [];
        d.renderedView = null;
        // Holds info about a single rendered line when it was rendered
        // for measurement, while not in view.
        d.externalMeasured = null;
        // Empty space (in pixels) above the view
        d.viewOffset = 0;
        d.lastWrapHeight = d.lastWrapWidth = 0;
        d.updateLineNumbers = null;
        d.nativeBarWidth = d.barHeight = d.barWidth = 0;
        d.scrollbarsClipped = false;
        // Used to only resize the line number gutter when necessary (when
        // the amount of lines crosses a boundary that makes its width change)
        d.lineNumWidth = d.lineNumInnerWidth = d.lineNumChars = null;
        // Set to true when a non-horizontal-scrolling line widget is
        // added. As an optimization, line widget aligning is skipped when
        // this is false.
        d.alignWidgets = false;
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        // Tracks the maximum line length so that the horizontal scrollbar
        // can be kept static when scrolling.
        d.maxLine = null;
        d.maxLineLength = 0;
        d.maxLineChanged = false;
        // Used for measuring wheel scrolling granularity
        d.wheelDX = d.wheelDY = d.wheelStartX = d.wheelStartY = null;
        // True when shift is held down.
        d.shift = false;
        // Used to track whether anything happened since the context menu
        // was opened.
        d.selForContextMenu = null;
        d.activeTouch = null;
        d.gutterSpecs = getGutters(options.gutters, options.lineNumbers);
        renderGutters(d);
        input.init(d);
    }
    // Since the delta values reported on mouse wheel events are
    // unstandardized between browsers and even browser versions, and
    // generally horribly unpredictable, this code starts by measuring
    // the scroll effect that the first few mouse wheel events have,
    // and, from that, detects the way it can convert deltas to pixel
    // offsets afterwards.
    //
    // The reason we want to know the amount a wheel event will scroll
    // is that it gives us a chance to update the display before the
    // actual scrolling happens, reducing flickering.
    var wheelSamples = 0, wheelPixelsPerUnit = null;
    // Fill in a browser-detected starting value on browsers where we
    // know one. These don't have to be accurate -- the result of them
    // being wrong would just be a slight flicker on the first wheel
    // scroll (if it is large enough).
    if (ie) wheelPixelsPerUnit = -0.53;
    else if (gecko) wheelPixelsPerUnit = 15;
    else if (chrome) wheelPixelsPerUnit = -0.7;
    else if (safari) wheelPixelsPerUnit = -1 / 3;
    function wheelEventDelta(e) {
        var dx = e.wheelDeltaX, dy = e.wheelDeltaY;
        if (dx == null && e.detail && e.axis == e.HORIZONTAL_AXIS) dx = e.detail;
        if (dy == null && e.detail && e.axis == e.VERTICAL_AXIS) dy = e.detail;
        else if (dy == null) dy = e.wheelDelta;
        return {
            x: dx,
            y: dy
        };
    }
    function wheelEventPixels(e) {
        var delta = wheelEventDelta(e);
        delta.x *= wheelPixelsPerUnit;
        delta.y *= wheelPixelsPerUnit;
        return delta;
    }
    function onScrollWheel(cm, e) {
        var delta = wheelEventDelta(e), dx = delta.x, dy = delta.y;
        var display = cm.display, scroll = display.scroller;
        // Quit if there's nothing to scroll here
        var canScrollX = scroll.scrollWidth > scroll.clientWidth;
        var canScrollY = scroll.scrollHeight > scroll.clientHeight;
        if (!(dx && canScrollX || dy && canScrollY)) return;
        // Webkit browsers on OS X abort momentum scrolls when the target
        // of the scroll event is removed from the scrollable element.
        // This hack (see related code in patchDisplay) makes sure the
        // element is kept around.
        if (dy && mac && webkit) outer: for(var cur = e.target, view = display.view; cur != scroll; cur = cur.parentNode){
            for(var i = 0; i < view.length; i++)if (view[i].node == cur) {
                cm.display.currentWheelTarget = cur;
                break outer;
            }
        }
        // On some browsers, horizontal scrolling will cause redraws to
        // happen before the gutter has been realigned, causing it to
        // wriggle around in a most unseemly way. When we have an
        // estimated pixels/delta value, we just handle horizontal
        // scrolling entirely here. It'll be slightly off from native, but
        // better than glitching out.
        if (dx && !gecko && !presto && wheelPixelsPerUnit != null) {
            if (dy && canScrollY) updateScrollTop(cm, Math.max(0, scroll.scrollTop + dy * wheelPixelsPerUnit));
            setScrollLeft(cm, Math.max(0, scroll.scrollLeft + dx * wheelPixelsPerUnit));
            // Only prevent default scrolling if vertical scrolling is
            // actually possible. Otherwise, it causes vertical scroll
            // jitter on OSX trackpads when deltaX is small and deltaY
            // is large (issue #3579)
            if (!dy || dy && canScrollY) e_preventDefault(e);
            display.wheelStartX = null; // Abort measurement, if in progress
            return;
        }
        // 'Project' the visible viewport to cover the area that is being
        // scrolled into view (if we know enough to estimate it).
        if (dy && wheelPixelsPerUnit != null) {
            var pixels = dy * wheelPixelsPerUnit;
            var top = cm.doc.scrollTop, bot = top + display.wrapper.clientHeight;
            if (pixels < 0) top = Math.max(0, top + pixels - 50);
            else bot = Math.min(cm.doc.height, bot + pixels + 50);
            updateDisplaySimple(cm, {
                top: top,
                bottom: bot
            });
        }
        if (wheelSamples < 20) {
            if (display.wheelStartX == null) {
                display.wheelStartX = scroll.scrollLeft;
                display.wheelStartY = scroll.scrollTop;
                display.wheelDX = dx;
                display.wheelDY = dy;
                setTimeout(function() {
                    if (display.wheelStartX == null) return;
                    var movedX = scroll.scrollLeft - display.wheelStartX;
                    var movedY = scroll.scrollTop - display.wheelStartY;
                    var sample = movedY && display.wheelDY && movedY / display.wheelDY || movedX && display.wheelDX && movedX / display.wheelDX;
                    display.wheelStartX = display.wheelStartY = null;
                    if (!sample) return;
                    wheelPixelsPerUnit = (wheelPixelsPerUnit * wheelSamples + sample) / (wheelSamples + 1);
                    ++wheelSamples;
                }, 200);
            } else {
                display.wheelDX += dx;
                display.wheelDY += dy;
            }
        }
    }
    // Selection objects are immutable. A new one is created every time
    // the selection changes. A selection is one or more non-overlapping
    // (and non-touching) ranges, sorted, and an integer that indicates
    // which one is the primary selection (the one that's scrolled into
    // view, that getCursor returns, etc).
    var Selection = function(ranges, primIndex) {
        this.ranges = ranges;
        this.primIndex = primIndex;
    };
    Selection.prototype.primary = function() {
        return this.ranges[this.primIndex];
    };
    Selection.prototype.equals = function(other) {
        var this$1 = this;
        if (other == this) return true;
        if (other.primIndex != this.primIndex || other.ranges.length != this.ranges.length) return false;
        for(var i = 0; i < this.ranges.length; i++){
            var here = this$1.ranges[i], there = other.ranges[i];
            if (!equalCursorPos(here.anchor, there.anchor) || !equalCursorPos(here.head, there.head)) return false;
        }
        return true;
    };
    Selection.prototype.deepCopy = function() {
        var this$1 = this;
        var out = [];
        for(var i = 0; i < this.ranges.length; i++)out[i] = new Range(copyPos(this$1.ranges[i].anchor), copyPos(this$1.ranges[i].head));
        return new Selection(out, this.primIndex);
    };
    Selection.prototype.somethingSelected = function() {
        var this$1 = this;
        for(var i = 0; i < this.ranges.length; i++){
            if (!this$1.ranges[i].empty()) return true;
        }
        return false;
    };
    Selection.prototype.contains = function(pos, end) {
        var this$1 = this;
        if (!end) end = pos;
        for(var i = 0; i < this.ranges.length; i++){
            var range = this$1.ranges[i];
            if (cmp(end, range.from()) >= 0 && cmp(pos, range.to()) <= 0) return i;
        }
        return -1;
    };
    var Range = function(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    };
    Range.prototype.from = function() {
        return minPos(this.anchor, this.head);
    };
    Range.prototype.to = function() {
        return maxPos(this.anchor, this.head);
    };
    Range.prototype.empty = function() {
        return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
    };
    // Take an unsorted, potentially overlapping set of ranges, and
    // build a selection out of it. 'Consumes' ranges array (modifying
    // it).
    function normalizeSelection(cm, ranges, primIndex) {
        var mayTouch = cm && cm.options.selectionsMayTouch;
        var prim = ranges[primIndex];
        ranges.sort(function(a, b) {
            return cmp(a.from(), b.from());
        });
        primIndex = indexOf(ranges, prim);
        for(var i = 1; i < ranges.length; i++){
            var cur = ranges[i], prev = ranges[i - 1];
            var diff = cmp(prev.to(), cur.from());
            if (mayTouch && !cur.empty() ? diff > 0 : diff >= 0) {
                var from = minPos(prev.from(), cur.from()), to = maxPos(prev.to(), cur.to());
                var inv = prev.empty() ? cur.from() == cur.head : prev.from() == prev.head;
                if (i <= primIndex) --primIndex;
                ranges.splice(--i, 2, new Range(inv ? to : from, inv ? from : to));
            }
        }
        return new Selection(ranges, primIndex);
    }
    function simpleSelection(anchor, head) {
        return new Selection([
            new Range(anchor, head || anchor)
        ], 0);
    }
    // Compute the position of the end of a change (its 'to' property
    // refers to the pre-change end).
    function changeEnd(change) {
        if (!change.text) return change.to;
        return Pos(change.from.line + change.text.length - 1, lst(change.text).length + (change.text.length == 1 ? change.from.ch : 0));
    }
    // Adjust a position to refer to the post-change position of the
    // same text, or the end of the change if the change covers it.
    function adjustForChange(pos, change) {
        if (cmp(pos, change.from) < 0) return pos;
        if (cmp(pos, change.to) <= 0) return changeEnd(change);
        var line = pos.line + change.text.length - (change.to.line - change.from.line) - 1, ch = pos.ch;
        if (pos.line == change.to.line) ch += changeEnd(change).ch - change.to.ch;
        return Pos(line, ch);
    }
    function computeSelAfterChange(doc, change) {
        var out = [];
        for(var i = 0; i < doc.sel.ranges.length; i++){
            var range = doc.sel.ranges[i];
            out.push(new Range(adjustForChange(range.anchor, change), adjustForChange(range.head, change)));
        }
        return normalizeSelection(doc.cm, out, doc.sel.primIndex);
    }
    function offsetPos(pos, old, nw) {
        if (pos.line == old.line) return Pos(nw.line, pos.ch - old.ch + nw.ch);
        else return Pos(nw.line + (pos.line - old.line), pos.ch);
    }
    // Used by replaceSelections to allow moving the selection to the
    // start or around the replaced test. Hint may be "start" or "around".
    function computeReplacedSel(doc, changes, hint) {
        var out = [];
        var oldPrev = Pos(doc.first, 0), newPrev = oldPrev;
        for(var i = 0; i < changes.length; i++){
            var change = changes[i];
            var from = offsetPos(change.from, oldPrev, newPrev);
            var to = offsetPos(changeEnd(change), oldPrev, newPrev);
            oldPrev = change.to;
            newPrev = to;
            if (hint == "around") {
                var range = doc.sel.ranges[i], inv = cmp(range.head, range.anchor) < 0;
                out[i] = new Range(inv ? to : from, inv ? from : to);
            } else out[i] = new Range(from, from);
        }
        return new Selection(out, doc.sel.primIndex);
    }
    // Used to get the editor into a consistent state again when options change.
    function loadMode(cm) {
        cm.doc.mode = getMode(cm.options, cm.doc.modeOption);
        resetModeState(cm);
    }
    function resetModeState(cm) {
        cm.doc.iter(function(line) {
            if (line.stateAfter) line.stateAfter = null;
            if (line.styles) line.styles = null;
        });
        cm.doc.modeFrontier = cm.doc.highlightFrontier = cm.doc.first;
        startWorker(cm, 100);
        cm.state.modeGen++;
        if (cm.curOp) regChange(cm);
    }
    // DOCUMENT DATA STRUCTURE
    // By default, updates that start and end at the beginning of a line
    // are treated specially, in order to make the association of line
    // widgets and marker elements with the text behave more intuitive.
    function isWholeLineUpdate(doc, change) {
        return change.from.ch == 0 && change.to.ch == 0 && lst(change.text) == "" && (!doc.cm || doc.cm.options.wholeLineUpdateBefore);
    }
    // Perform a change on the document data structure.
    function updateDoc(doc, change, markedSpans, estimateHeight$$1) {
        function spansFor(n) {
            return markedSpans ? markedSpans[n] : null;
        }
        function update(line, text, spans) {
            updateLine(line, text, spans, estimateHeight$$1);
            signalLater(line, "change", line, change);
        }
        function linesFor(start, end) {
            var result = [];
            for(var i = start; i < end; ++i)result.push(new Line(text[i], spansFor(i), estimateHeight$$1));
            return result;
        }
        var from = change.from, to = change.to, text = change.text;
        var firstLine = getLine(doc, from.line), lastLine = getLine(doc, to.line);
        var lastText = lst(text), lastSpans = spansFor(text.length - 1), nlines = to.line - from.line;
        // Adjust the line structure
        if (change.full) {
            doc.insert(0, linesFor(0, text.length));
            doc.remove(text.length, doc.size - text.length);
        } else if (isWholeLineUpdate(doc, change)) {
            // This is a whole-line replace. Treated specially to make
            // sure line objects move the way they are supposed to.
            var added = linesFor(0, text.length - 1);
            update(lastLine, lastLine.text, lastSpans);
            if (nlines) doc.remove(from.line, nlines);
            if (added.length) doc.insert(from.line, added);
        } else if (firstLine == lastLine) {
            if (text.length == 1) update(firstLine, firstLine.text.slice(0, from.ch) + lastText + firstLine.text.slice(to.ch), lastSpans);
            else {
                var added$1 = linesFor(1, text.length - 1);
                added$1.push(new Line(lastText + firstLine.text.slice(to.ch), lastSpans, estimateHeight$$1));
                update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
                doc.insert(from.line + 1, added$1);
            }
        } else if (text.length == 1) {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0] + lastLine.text.slice(to.ch), spansFor(0));
            doc.remove(from.line + 1, nlines);
        } else {
            update(firstLine, firstLine.text.slice(0, from.ch) + text[0], spansFor(0));
            update(lastLine, lastText + lastLine.text.slice(to.ch), lastSpans);
            var added$2 = linesFor(1, text.length - 1);
            if (nlines > 1) doc.remove(from.line + 1, nlines - 1);
            doc.insert(from.line + 1, added$2);
        }
        signalLater(doc, "change", doc, change);
    }
    // Call f for all linked documents.
    function linkedDocs(doc, f, sharedHistOnly) {
        function propagate(doc, skip, sharedHist) {
            if (doc.linked) for(var i = 0; i < doc.linked.length; ++i){
                var rel = doc.linked[i];
                if (rel.doc == skip) continue;
                var shared = sharedHist && rel.sharedHist;
                if (sharedHistOnly && !shared) continue;
                f(rel.doc, shared);
                propagate(rel.doc, doc, shared);
            }
        }
        propagate(doc, null, true);
    }
    // Attach a document to an editor.
    function attachDoc(cm, doc) {
        if (doc.cm) throw new Error("This document is already in use.");
        cm.doc = doc;
        doc.cm = cm;
        estimateLineHeights(cm);
        loadMode(cm);
        setDirectionClass(cm);
        if (!cm.options.lineWrapping) findMaxLine(cm);
        cm.options.mode = doc.modeOption;
        regChange(cm);
    }
    function setDirectionClass(cm) {
        (cm.doc.direction == "rtl" ? addClass : rmClass)(cm.display.lineDiv, "CodeMirror-rtl");
    }
    function directionChanged(cm) {
        runInOp(cm, function() {
            setDirectionClass(cm);
            regChange(cm);
        });
    }
    function History(startGen) {
        // Arrays of change events and selections. Doing something adds an
        // event to done and clears undo. Undoing moves events from done
        // to undone, redoing moves them in the other direction.
        this.done = [];
        this.undone = [];
        this.undoDepth = Infinity;
        // Used to track when changes can be merged into a single undo
        // event
        this.lastModTime = this.lastSelTime = 0;
        this.lastOp = this.lastSelOp = null;
        this.lastOrigin = this.lastSelOrigin = null;
        // Used by the isClean() method
        this.generation = this.maxGeneration = startGen || 1;
    }
    // Create a history change event from an updateDoc-style change
    // object.
    function historyChangeFromChange(doc, change) {
        var histChange = {
            from: copyPos(change.from),
            to: changeEnd(change),
            text: getBetween(doc, change.from, change.to)
        };
        attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        linkedDocs(doc, function(doc) {
            return attachLocalSpans(doc, histChange, change.from.line, change.to.line + 1);
        }, true);
        return histChange;
    }
    // Pop all selection events off the end of a history array. Stop at
    // a change event.
    function clearSelectionEvents(array) {
        while(array.length){
            var last = lst(array);
            if (last.ranges) array.pop();
            else break;
        }
    }
    // Find the top change event in the history. Pop off selection
    // events that are in the way.
    function lastChangeEvent(hist, force) {
        if (force) {
            clearSelectionEvents(hist.done);
            return lst(hist.done);
        } else if (hist.done.length && !lst(hist.done).ranges) return lst(hist.done);
        else if (hist.done.length > 1 && !hist.done[hist.done.length - 2].ranges) {
            hist.done.pop();
            return lst(hist.done);
        }
    }
    // Register a change in the history. Merges changes that are within
    // a single operation, or are close together with an origin that
    // allows merging (starting with "+") into a single event.
    function addChangeToHistory(doc, change, selAfter, opId) {
        var hist = doc.history;
        hist.undone.length = 0;
        var time = +new Date, cur;
        var last;
        if ((hist.lastOp == opId || hist.lastOrigin == change.origin && change.origin && (change.origin.charAt(0) == "+" && hist.lastModTime > time - (doc.cm ? doc.cm.options.historyEventDelay : 500) || change.origin.charAt(0) == "*")) && (cur = lastChangeEvent(hist, hist.lastOp == opId))) {
            // Merge this change into the last event
            last = lst(cur.changes);
            if (cmp(change.from, change.to) == 0 && cmp(change.from, last.to) == 0) // Optimized case for simple insertion -- don't want to add
            // new changesets for every character typed
            last.to = changeEnd(change);
            else // Add new sub-event
            cur.changes.push(historyChangeFromChange(doc, change));
        } else {
            // Can not be merged, start a new event.
            var before = lst(hist.done);
            if (!before || !before.ranges) pushSelectionToHistory(doc.sel, hist.done);
            cur = {
                changes: [
                    historyChangeFromChange(doc, change)
                ],
                generation: hist.generation
            };
            hist.done.push(cur);
            while(hist.done.length > hist.undoDepth){
                hist.done.shift();
                if (!hist.done[0].ranges) hist.done.shift();
            }
        }
        hist.done.push(selAfter);
        hist.generation = ++hist.maxGeneration;
        hist.lastModTime = hist.lastSelTime = time;
        hist.lastOp = hist.lastSelOp = opId;
        hist.lastOrigin = hist.lastSelOrigin = change.origin;
        if (!last) signal(doc, "historyAdded");
    }
    function selectionEventCanBeMerged(doc, origin, prev, sel) {
        var ch = origin.charAt(0);
        return ch == "*" || ch == "+" && prev.ranges.length == sel.ranges.length && prev.somethingSelected() == sel.somethingSelected() && new Date - doc.history.lastSelTime <= (doc.cm ? doc.cm.options.historyEventDelay : 500);
    }
    // Called whenever the selection changes, sets the new selection as
    // the pending selection in the history, and pushes the old pending
    // selection into the 'done' array when it was significantly
    // different (in number of selected ranges, emptiness, or time).
    function addSelectionToHistory(doc, sel, opId, options) {
        var hist = doc.history, origin = options && options.origin;
        // A new event is started when the previous origin does not match
        // the current, or the origins don't allow matching. Origins
        // starting with * are always merged, those starting with + are
        // merged when similar and close together in time.
        if (opId == hist.lastSelOp || origin && hist.lastSelOrigin == origin && (hist.lastModTime == hist.lastSelTime && hist.lastOrigin == origin || selectionEventCanBeMerged(doc, origin, lst(hist.done), sel))) hist.done[hist.done.length - 1] = sel;
        else pushSelectionToHistory(sel, hist.done);
        hist.lastSelTime = +new Date;
        hist.lastSelOrigin = origin;
        hist.lastSelOp = opId;
        if (options && options.clearRedo !== false) clearSelectionEvents(hist.undone);
    }
    function pushSelectionToHistory(sel, dest) {
        var top = lst(dest);
        if (!(top && top.ranges && top.equals(sel))) dest.push(sel);
    }
    // Used to store marked span information in the history.
    function attachLocalSpans(doc, change, from, to) {
        var existing = change["spans_" + doc.id], n = 0;
        doc.iter(Math.max(doc.first, from), Math.min(doc.first + doc.size, to), function(line) {
            if (line.markedSpans) (existing || (existing = change["spans_" + doc.id] = {}))[n] = line.markedSpans;
            ++n;
        });
    }
    // When un/re-doing restores text containing marked spans, those
    // that have been explicitly cleared should not be restored.
    function removeClearedSpans(spans) {
        if (!spans) return null;
        var out;
        for(var i = 0; i < spans.length; ++i){
            if (spans[i].marker.explicitlyCleared) {
                if (!out) out = spans.slice(0, i);
            } else if (out) out.push(spans[i]);
        }
        return !out ? spans : out.length ? out : null;
    }
    // Retrieve and filter the old marked spans stored in a change event.
    function getOldSpans(doc, change) {
        var found = change["spans_" + doc.id];
        if (!found) return null;
        var nw = [];
        for(var i = 0; i < change.text.length; ++i)nw.push(removeClearedSpans(found[i]));
        return nw;
    }
    // Used for un/re-doing changes from the history. Combines the
    // result of computing the existing spans with the set of spans that
    // existed in the history (so that deleting around a span and then
    // undoing brings back the span).
    function mergeOldSpans(doc, change) {
        var old = getOldSpans(doc, change);
        var stretched = stretchSpansOverChange(doc, change);
        if (!old) return stretched;
        if (!stretched) return old;
        for(var i = 0; i < old.length; ++i){
            var oldCur = old[i], stretchCur = stretched[i];
            if (oldCur && stretchCur) spans: for(var j = 0; j < stretchCur.length; ++j){
                var span = stretchCur[j];
                for(var k = 0; k < oldCur.length; ++k){
                    if (oldCur[k].marker == span.marker) continue spans;
                }
                oldCur.push(span);
            }
            else if (stretchCur) old[i] = stretchCur;
        }
        return old;
    }
    // Used both to provide a JSON-safe object in .getHistory, and, when
    // detaching a document, to split the history in two
    function copyHistoryArray(events, newGroup, instantiateSel) {
        var copy = [];
        for(var i = 0; i < events.length; ++i){
            var event = events[i];
            if (event.ranges) {
                copy.push(instantiateSel ? Selection.prototype.deepCopy.call(event) : event);
                continue;
            }
            var changes = event.changes, newChanges = [];
            copy.push({
                changes: newChanges
            });
            for(var j = 0; j < changes.length; ++j){
                var change = changes[j], m = void 0;
                newChanges.push({
                    from: change.from,
                    to: change.to,
                    text: change.text
                });
                if (newGroup) for(var prop in change){
                    if (m = prop.match(/^spans_(\d+)$/)) {
                        if (indexOf(newGroup, Number(m[1])) > -1) {
                            lst(newChanges)[prop] = change[prop];
                            delete change[prop];
                        }
                    }
                }
            }
        }
        return copy;
    }
    // The 'scroll' parameter given to many of these indicated whether
    // the new cursor position should be scrolled into view after
    // modifying the selection.
    // If shift is held or the extend flag is set, extends a range to
    // include a given position (and optionally a second position).
    // Otherwise, simply returns the range between the given positions.
    // Used for cursor motion and such.
    function extendRange(range, head, other, extend) {
        if (extend) {
            var anchor = range.anchor;
            if (other) {
                var posBefore = cmp(head, anchor) < 0;
                if (posBefore != cmp(other, anchor) < 0) {
                    anchor = head;
                    head = other;
                } else if (posBefore != cmp(head, other) < 0) head = other;
            }
            return new Range(anchor, head);
        } else return new Range(other || head, head);
    }
    // Extend the primary selection range, discard the rest.
    function extendSelection(doc, head, other, options, extend) {
        if (extend == null) extend = doc.cm && (doc.cm.display.shift || doc.extend);
        setSelection(doc, new Selection([
            extendRange(doc.sel.primary(), head, other, extend)
        ], 0), options);
    }
    // Extend all selections (pos is an array of selections with length
    // equal the number of selections)
    function extendSelections(doc, heads, options) {
        var out = [];
        var extend = doc.cm && (doc.cm.display.shift || doc.extend);
        for(var i = 0; i < doc.sel.ranges.length; i++)out[i] = extendRange(doc.sel.ranges[i], heads[i], null, extend);
        var newSel = normalizeSelection(doc.cm, out, doc.sel.primIndex);
        setSelection(doc, newSel, options);
    }
    // Updates a single range in the selection.
    function replaceOneSelection(doc, i, range, options) {
        var ranges = doc.sel.ranges.slice(0);
        ranges[i] = range;
        setSelection(doc, normalizeSelection(doc.cm, ranges, doc.sel.primIndex), options);
    }
    // Reset the selection to a single range.
    function setSimpleSelection(doc, anchor, head, options) {
        setSelection(doc, simpleSelection(anchor, head), options);
    }
    // Give beforeSelectionChange handlers a change to influence a
    // selection update.
    function filterSelectionChange(doc, sel, options) {
        var obj = {
            ranges: sel.ranges,
            update: function(ranges) {
                var this$1 = this;
                this.ranges = [];
                for(var i = 0; i < ranges.length; i++)this$1.ranges[i] = new Range(clipPos(doc, ranges[i].anchor), clipPos(doc, ranges[i].head));
            },
            origin: options && options.origin
        };
        signal(doc, "beforeSelectionChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeSelectionChange", doc.cm, obj);
        if (obj.ranges != sel.ranges) return normalizeSelection(doc.cm, obj.ranges, obj.ranges.length - 1);
        else return sel;
    }
    function setSelectionReplaceHistory(doc, sel, options) {
        var done = doc.history.done, last = lst(done);
        if (last && last.ranges) {
            done[done.length - 1] = sel;
            setSelectionNoUndo(doc, sel, options);
        } else setSelection(doc, sel, options);
    }
    // Set a new selection.
    function setSelection(doc, sel, options) {
        setSelectionNoUndo(doc, sel, options);
        addSelectionToHistory(doc, doc.sel, doc.cm ? doc.cm.curOp.id : NaN, options);
    }
    function setSelectionNoUndo(doc, sel, options) {
        if (hasHandler(doc, "beforeSelectionChange") || doc.cm && hasHandler(doc.cm, "beforeSelectionChange")) sel = filterSelectionChange(doc, sel, options);
        var bias = options && options.bias || (cmp(sel.primary().head, doc.sel.primary().head) < 0 ? -1 : 1);
        setSelectionInner(doc, skipAtomicInSelection(doc, sel, bias, true));
        if (!(options && options.scroll === false) && doc.cm) ensureCursorVisible(doc.cm);
    }
    function setSelectionInner(doc, sel) {
        if (sel.equals(doc.sel)) return;
        doc.sel = sel;
        if (doc.cm) {
            doc.cm.curOp.updateInput = 1;
            doc.cm.curOp.selectionChanged = true;
            signalCursorActivity(doc.cm);
        }
        signalLater(doc, "cursorActivity", doc);
    }
    // Verify that the selection does not partially select any atomic
    // marked ranges.
    function reCheckSelection(doc) {
        setSelectionInner(doc, skipAtomicInSelection(doc, doc.sel, null, false));
    }
    // Return a selection that does not partially select any atomic
    // ranges.
    function skipAtomicInSelection(doc, sel, bias, mayClear) {
        var out;
        for(var i = 0; i < sel.ranges.length; i++){
            var range = sel.ranges[i];
            var old = sel.ranges.length == doc.sel.ranges.length && doc.sel.ranges[i];
            var newAnchor = skipAtomic(doc, range.anchor, old && old.anchor, bias, mayClear);
            var newHead = skipAtomic(doc, range.head, old && old.head, bias, mayClear);
            if (out || newAnchor != range.anchor || newHead != range.head) {
                if (!out) out = sel.ranges.slice(0, i);
                out[i] = new Range(newAnchor, newHead);
            }
        }
        return out ? normalizeSelection(doc.cm, out, sel.primIndex) : sel;
    }
    function skipAtomicInner(doc, pos, oldPos, dir, mayClear) {
        var line = getLine(doc, pos.line);
        if (line.markedSpans) for(var i = 0; i < line.markedSpans.length; ++i){
            var sp = line.markedSpans[i], m = sp.marker;
            // Determine if we should prevent the cursor being placed to the left/right of an atomic marker
            // Historically this was determined using the inclusiveLeft/Right option, but the new way to control it
            // is with selectLeft/Right
            var preventCursorLeft = "selectLeft" in m ? !m.selectLeft : m.inclusiveLeft;
            var preventCursorRight = "selectRight" in m ? !m.selectRight : m.inclusiveRight;
            if ((sp.from == null || (preventCursorLeft ? sp.from <= pos.ch : sp.from < pos.ch)) && (sp.to == null || (preventCursorRight ? sp.to >= pos.ch : sp.to > pos.ch))) {
                if (mayClear) {
                    signal(m, "beforeCursorEnter");
                    if (m.explicitlyCleared) {
                        if (!line.markedSpans) break;
                        else {
                            --i;
                            continue;
                        }
                    }
                }
                if (!m.atomic) continue;
                if (oldPos) {
                    var near = m.find(dir < 0 ? 1 : -1), diff = void 0;
                    if (dir < 0 ? preventCursorRight : preventCursorLeft) near = movePos(doc, near, -dir, near && near.line == pos.line ? line : null);
                    if (near && near.line == pos.line && (diff = cmp(near, oldPos)) && (dir < 0 ? diff < 0 : diff > 0)) return skipAtomicInner(doc, near, pos, dir, mayClear);
                }
                var far = m.find(dir < 0 ? -1 : 1);
                if (dir < 0 ? preventCursorLeft : preventCursorRight) far = movePos(doc, far, dir, far.line == pos.line ? line : null);
                return far ? skipAtomicInner(doc, far, pos, dir, mayClear) : null;
            }
        }
        return pos;
    }
    // Ensure a given position is not inside an atomic range.
    function skipAtomic(doc, pos, oldPos, bias, mayClear) {
        var dir = bias || 1;
        var found = skipAtomicInner(doc, pos, oldPos, dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, dir, true) || skipAtomicInner(doc, pos, oldPos, -dir, mayClear) || !mayClear && skipAtomicInner(doc, pos, oldPos, -dir, true);
        if (!found) {
            doc.cantEdit = true;
            return Pos(doc.first, 0);
        }
        return found;
    }
    function movePos(doc, pos, dir, line) {
        if (dir < 0 && pos.ch == 0) {
            if (pos.line > doc.first) return clipPos(doc, Pos(pos.line - 1));
            else return null;
        } else if (dir > 0 && pos.ch == (line || getLine(doc, pos.line)).text.length) {
            if (pos.line < doc.first + doc.size - 1) return Pos(pos.line + 1, 0);
            else return null;
        } else return new Pos(pos.line, pos.ch + dir);
    }
    function selectAll(cm) {
        cm.setSelection(Pos(cm.firstLine(), 0), Pos(cm.lastLine()), sel_dontScroll);
    }
    // UPDATING
    // Allow "beforeChange" event handlers to influence a change
    function filterChange(doc, change, update) {
        var obj = {
            canceled: false,
            from: change.from,
            to: change.to,
            text: change.text,
            origin: change.origin,
            cancel: function() {
                return obj.canceled = true;
            }
        };
        if (update) obj.update = function(from, to, text, origin) {
            if (from) obj.from = clipPos(doc, from);
            if (to) obj.to = clipPos(doc, to);
            if (text) obj.text = text;
            if (origin !== undefined) obj.origin = origin;
        };
        signal(doc, "beforeChange", doc, obj);
        if (doc.cm) signal(doc.cm, "beforeChange", doc.cm, obj);
        if (obj.canceled) {
            if (doc.cm) doc.cm.curOp.updateInput = 2;
            return null;
        }
        return {
            from: obj.from,
            to: obj.to,
            text: obj.text,
            origin: obj.origin
        };
    }
    // Apply a change to a document, and add it to the document's
    // history, and propagating it to all linked documents.
    function makeChange(doc, change, ignoreReadOnly) {
        if (doc.cm) {
            if (!doc.cm.curOp) return operation(doc.cm, makeChange)(doc, change, ignoreReadOnly);
            if (doc.cm.state.suppressEdits) return;
        }
        if (hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange")) {
            change = filterChange(doc, change, true);
            if (!change) return;
        }
        // Possibly split or suppress the update based on the presence
        // of read-only spans in its range.
        var split = sawReadOnlySpans && !ignoreReadOnly && removeReadOnlyRanges(doc, change.from, change.to);
        if (split) for(var i = split.length - 1; i >= 0; --i)makeChangeInner(doc, {
            from: split[i].from,
            to: split[i].to,
            text: i ? [
                ""
            ] : change.text,
            origin: change.origin
        });
        else makeChangeInner(doc, change);
    }
    function makeChangeInner(doc, change) {
        if (change.text.length == 1 && change.text[0] == "" && cmp(change.from, change.to) == 0) return;
        var selAfter = computeSelAfterChange(doc, change);
        addChangeToHistory(doc, change, selAfter, doc.cm ? doc.cm.curOp.id : NaN);
        makeChangeSingleDoc(doc, change, selAfter, stretchSpansOverChange(doc, change));
        var rebased = [];
        linkedDocs(doc, function(doc, sharedHist) {
            if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                rebaseHist(doc.history, change);
                rebased.push(doc.history);
            }
            makeChangeSingleDoc(doc, change, null, stretchSpansOverChange(doc, change));
        });
    }
    // Revert a change stored in a document's history.
    function makeChangeFromHistory(doc, type, allowSelectionOnly) {
        var suppress = doc.cm && doc.cm.state.suppressEdits;
        if (suppress && !allowSelectionOnly) return;
        var hist = doc.history, event, selAfter = doc.sel;
        var source = type == "undo" ? hist.done : hist.undone, dest = type == "undo" ? hist.undone : hist.done;
        // Verify that there is a useable event (so that ctrl-z won't
        // needlessly clear selection events)
        var i = 0;
        for(; i < source.length; i++){
            event = source[i];
            if (allowSelectionOnly ? event.ranges && !event.equals(doc.sel) : !event.ranges) break;
        }
        if (i == source.length) return;
        hist.lastOrigin = hist.lastSelOrigin = null;
        for(;;){
            event = source.pop();
            if (event.ranges) {
                pushSelectionToHistory(event, dest);
                if (allowSelectionOnly && !event.equals(doc.sel)) {
                    setSelection(doc, event, {
                        clearRedo: false
                    });
                    return;
                }
                selAfter = event;
            } else if (suppress) {
                source.push(event);
                return;
            } else break;
        }
        // Build up a reverse change object to add to the opposite history
        // stack (redo when undoing, and vice versa).
        var antiChanges = [];
        pushSelectionToHistory(selAfter, dest);
        dest.push({
            changes: antiChanges,
            generation: hist.generation
        });
        hist.generation = event.generation || ++hist.maxGeneration;
        var filter = hasHandler(doc, "beforeChange") || doc.cm && hasHandler(doc.cm, "beforeChange");
        var loop = function(i) {
            var change = event.changes[i];
            change.origin = type;
            if (filter && !filterChange(doc, change, false)) {
                source.length = 0;
                return {};
            }
            antiChanges.push(historyChangeFromChange(doc, change));
            var after = i ? computeSelAfterChange(doc, change) : lst(source);
            makeChangeSingleDoc(doc, change, after, mergeOldSpans(doc, change));
            if (!i && doc.cm) doc.cm.scrollIntoView({
                from: change.from,
                to: changeEnd(change)
            });
            var rebased = [];
            // Propagate to the linked documents
            linkedDocs(doc, function(doc, sharedHist) {
                if (!sharedHist && indexOf(rebased, doc.history) == -1) {
                    rebaseHist(doc.history, change);
                    rebased.push(doc.history);
                }
                makeChangeSingleDoc(doc, change, null, mergeOldSpans(doc, change));
            });
        };
        for(var i$1 = event.changes.length - 1; i$1 >= 0; --i$1){
            var returned = loop(i$1);
            if (returned) return returned.v;
        }
    }
    // Sub-views need their line numbers shifted when text is added
    // above or below them in the parent document.
    function shiftDoc(doc, distance) {
        if (distance == 0) return;
        doc.first += distance;
        doc.sel = new Selection(map(doc.sel.ranges, function(range) {
            return new Range(Pos(range.anchor.line + distance, range.anchor.ch), Pos(range.head.line + distance, range.head.ch));
        }), doc.sel.primIndex);
        if (doc.cm) {
            regChange(doc.cm, doc.first, doc.first - distance, distance);
            for(var d = doc.cm.display, l = d.viewFrom; l < d.viewTo; l++)regLineChange(doc.cm, l, "gutter");
        }
    }
    // More lower-level change function, handling only a single document
    // (not linked ones).
    function makeChangeSingleDoc(doc, change, selAfter, spans) {
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, makeChangeSingleDoc)(doc, change, selAfter, spans);
        if (change.to.line < doc.first) {
            shiftDoc(doc, change.text.length - 1 - (change.to.line - change.from.line));
            return;
        }
        if (change.from.line > doc.lastLine()) return;
        // Clip the change to the size of this doc
        if (change.from.line < doc.first) {
            var shift = change.text.length - 1 - (doc.first - change.from.line);
            shiftDoc(doc, shift);
            change = {
                from: Pos(doc.first, 0),
                to: Pos(change.to.line + shift, change.to.ch),
                text: [
                    lst(change.text)
                ],
                origin: change.origin
            };
        }
        var last = doc.lastLine();
        if (change.to.line > last) change = {
            from: change.from,
            to: Pos(last, getLine(doc, last).text.length),
            text: [
                change.text[0]
            ],
            origin: change.origin
        };
        change.removed = getBetween(doc, change.from, change.to);
        if (!selAfter) selAfter = computeSelAfterChange(doc, change);
        if (doc.cm) makeChangeSingleDocInEditor(doc.cm, change, spans);
        else updateDoc(doc, change, spans);
        setSelectionNoUndo(doc, selAfter, sel_dontScroll);
        if (doc.cantEdit && skipAtomic(doc, Pos(doc.firstLine(), 0))) doc.cantEdit = false;
    }
    // Handle the interaction of a change to a document with the editor
    // that this document is part of.
    function makeChangeSingleDocInEditor(cm, change, spans) {
        var doc = cm.doc, display = cm.display, from = change.from, to = change.to;
        var recomputeMaxLength = false, checkWidthStart = from.line;
        if (!cm.options.lineWrapping) {
            checkWidthStart = lineNo(visualLine(getLine(doc, from.line)));
            doc.iter(checkWidthStart, to.line + 1, function(line) {
                if (line == display.maxLine) {
                    recomputeMaxLength = true;
                    return true;
                }
            });
        }
        if (doc.sel.contains(change.from, change.to) > -1) signalCursorActivity(cm);
        updateDoc(doc, change, spans, estimateHeight(cm));
        if (!cm.options.lineWrapping) {
            doc.iter(checkWidthStart, from.line + change.text.length, function(line) {
                var len = lineLength(line);
                if (len > display.maxLineLength) {
                    display.maxLine = line;
                    display.maxLineLength = len;
                    display.maxLineChanged = true;
                    recomputeMaxLength = false;
                }
            });
            if (recomputeMaxLength) cm.curOp.updateMaxLine = true;
        }
        retreatFrontier(doc, from.line);
        startWorker(cm, 400);
        var lendiff = change.text.length - (to.line - from.line) - 1;
        // Remember that these lines changed, for updating the display
        if (change.full) regChange(cm);
        else if (from.line == to.line && change.text.length == 1 && !isWholeLineUpdate(cm.doc, change)) regLineChange(cm, from.line, "text");
        else regChange(cm, from.line, to.line + 1, lendiff);
        var changesHandler = hasHandler(cm, "changes"), changeHandler = hasHandler(cm, "change");
        if (changeHandler || changesHandler) {
            var obj = {
                from: from,
                to: to,
                text: change.text,
                removed: change.removed,
                origin: change.origin
            };
            if (changeHandler) signalLater(cm, "change", cm, obj);
            if (changesHandler) (cm.curOp.changeObjs || (cm.curOp.changeObjs = [])).push(obj);
        }
        cm.display.selForContextMenu = null;
    }
    function replaceRange(doc, code, from, to, origin) {
        var assign;
        if (!to) to = from;
        if (cmp(to, from) < 0) assign = [
            to,
            from
        ], from = assign[0], to = assign[1];
        if (typeof code == "string") code = doc.splitLines(code);
        makeChange(doc, {
            from: from,
            to: to,
            text: code,
            origin: origin
        });
    }
    // Rebasing/resetting history to deal with externally-sourced changes
    function rebaseHistSelSingle(pos, from, to, diff) {
        if (to < pos.line) pos.line += diff;
        else if (from < pos.line) {
            pos.line = from;
            pos.ch = 0;
        }
    }
    // Tries to rebase an array of history events given a change in the
    // document. If the change touches the same lines as the event, the
    // event, and everything 'behind' it, is discarded. If the change is
    // before the event, the event's positions are updated. Uses a
    // copy-on-write scheme for the positions, to avoid having to
    // reallocate them all on every rebase, but also avoid problems with
    // shared position objects being unsafely updated.
    function rebaseHistArray(array, from, to, diff) {
        for(var i = 0; i < array.length; ++i){
            var sub = array[i], ok = true;
            if (sub.ranges) {
                if (!sub.copied) {
                    sub = array[i] = sub.deepCopy();
                    sub.copied = true;
                }
                for(var j = 0; j < sub.ranges.length; j++){
                    rebaseHistSelSingle(sub.ranges[j].anchor, from, to, diff);
                    rebaseHistSelSingle(sub.ranges[j].head, from, to, diff);
                }
                continue;
            }
            for(var j$1 = 0; j$1 < sub.changes.length; ++j$1){
                var cur = sub.changes[j$1];
                if (to < cur.from.line) {
                    cur.from = Pos(cur.from.line + diff, cur.from.ch);
                    cur.to = Pos(cur.to.line + diff, cur.to.ch);
                } else if (from <= cur.to.line) {
                    ok = false;
                    break;
                }
            }
            if (!ok) {
                array.splice(0, i + 1);
                i = 0;
            }
        }
    }
    function rebaseHist(hist, change) {
        var from = change.from.line, to = change.to.line, diff = change.text.length - (to - from) - 1;
        rebaseHistArray(hist.done, from, to, diff);
        rebaseHistArray(hist.undone, from, to, diff);
    }
    // Utility for applying a change to a line by handle or number,
    // returning the number and optionally registering the line as
    // changed.
    function changeLine(doc, handle, changeType, op) {
        var no = handle, line = handle;
        if (typeof handle == "number") line = getLine(doc, clipLine(doc, handle));
        else no = lineNo(handle);
        if (no == null) return null;
        if (op(line, no) && doc.cm) regLineChange(doc.cm, no, changeType);
        return line;
    }
    // The document is represented as a BTree consisting of leaves, with
    // chunk of lines in them, and branches, with up to ten leaves or
    // other branch nodes below them. The top node is always a branch
    // node, and is the document object itself (meaning it has
    // additional methods and properties).
    //
    // All nodes have parent links. The tree is used both to go from
    // line numbers to line objects, and to go from objects to numbers.
    // It also indexes by height, and is used to convert between height
    // and line object, and to find the total height of the document.
    //
    // See also http://marijnhaverbeke.nl/blog/codemirror-line-tree.html
    function LeafChunk(lines) {
        var this$1 = this;
        this.lines = lines;
        this.parent = null;
        var height = 0;
        for(var i = 0; i < lines.length; ++i){
            lines[i].parent = this$1;
            height += lines[i].height;
        }
        this.height = height;
    }
    LeafChunk.prototype = {
        chunkSize: function() {
            return this.lines.length;
        },
        // Remove the n lines at offset 'at'.
        removeInner: function(at, n) {
            var this$1 = this;
            for(var i = at, e = at + n; i < e; ++i){
                var line = this$1.lines[i];
                this$1.height -= line.height;
                cleanUpLine(line);
                signalLater(line, "delete");
            }
            this.lines.splice(at, n);
        },
        // Helper used to collapse a small branch into a single leaf.
        collapse: function(lines) {
            lines.push.apply(lines, this.lines);
        },
        // Insert the given array of lines at offset 'at', count them as
        // having the given height.
        insertInner: function(at, lines, height) {
            var this$1 = this;
            this.height += height;
            this.lines = this.lines.slice(0, at).concat(lines).concat(this.lines.slice(at));
            for(var i = 0; i < lines.length; ++i)lines[i].parent = this$1;
        },
        // Used to iterate over a part of the tree.
        iterN: function(at, n, op) {
            var this$1 = this;
            for(var e = at + n; at < e; ++at){
                if (op(this$1.lines[at])) return true;
            }
        }
    };
    function BranchChunk(children) {
        var this$1 = this;
        this.children = children;
        var size = 0, height = 0;
        for(var i = 0; i < children.length; ++i){
            var ch = children[i];
            size += ch.chunkSize();
            height += ch.height;
            ch.parent = this$1;
        }
        this.size = size;
        this.height = height;
        this.parent = null;
    }
    BranchChunk.prototype = {
        chunkSize: function() {
            return this.size;
        },
        removeInner: function(at, n) {
            var this$1 = this;
            this.size -= n;
            for(var i = 0; i < this.children.length; ++i){
                var child = this$1.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var rm = Math.min(n, sz - at), oldHeight = child.height;
                    child.removeInner(at, rm);
                    this$1.height -= oldHeight - child.height;
                    if (sz == rm) {
                        this$1.children.splice(i--, 1);
                        child.parent = null;
                    }
                    if ((n -= rm) == 0) break;
                    at = 0;
                } else at -= sz;
            }
            // If the result is smaller than 25 lines, ensure that it is a
            // single leaf node.
            if (this.size - n < 25 && (this.children.length > 1 || !(this.children[0] instanceof LeafChunk))) {
                var lines = [];
                this.collapse(lines);
                this.children = [
                    new LeafChunk(lines)
                ];
                this.children[0].parent = this;
            }
        },
        collapse: function(lines) {
            var this$1 = this;
            for(var i = 0; i < this.children.length; ++i)this$1.children[i].collapse(lines);
        },
        insertInner: function(at, lines, height) {
            var this$1 = this;
            this.size += lines.length;
            this.height += height;
            for(var i = 0; i < this.children.length; ++i){
                var child = this$1.children[i], sz = child.chunkSize();
                if (at <= sz) {
                    child.insertInner(at, lines, height);
                    if (child.lines && child.lines.length > 50) {
                        // To avoid memory thrashing when child.lines is huge (e.g. first view of a large file), it's never spliced.
                        // Instead, small slices are taken. They're taken in order because sequential memory accesses are fastest.
                        var remaining = child.lines.length % 25 + 25;
                        for(var pos = remaining; pos < child.lines.length;){
                            var leaf = new LeafChunk(child.lines.slice(pos, pos += 25));
                            child.height -= leaf.height;
                            this$1.children.splice(++i, 0, leaf);
                            leaf.parent = this$1;
                        }
                        child.lines = child.lines.slice(0, remaining);
                        this$1.maybeSpill();
                    }
                    break;
                }
                at -= sz;
            }
        },
        // When a node has grown, check whether it should be split.
        maybeSpill: function() {
            if (this.children.length <= 10) return;
            var me = this;
            do {
                var spilled = me.children.splice(me.children.length - 5, 5);
                var sibling = new BranchChunk(spilled);
                if (!me.parent) {
                    var copy = new BranchChunk(me.children);
                    copy.parent = me;
                    me.children = [
                        copy,
                        sibling
                    ];
                    me = copy;
                } else {
                    me.size -= sibling.size;
                    me.height -= sibling.height;
                    var myIndex = indexOf(me.parent.children, me);
                    me.parent.children.splice(myIndex + 1, 0, sibling);
                }
                sibling.parent = me.parent;
            }while (me.children.length > 10);
            me.parent.maybeSpill();
        },
        iterN: function(at, n, op) {
            var this$1 = this;
            for(var i = 0; i < this.children.length; ++i){
                var child = this$1.children[i], sz = child.chunkSize();
                if (at < sz) {
                    var used = Math.min(n, sz - at);
                    if (child.iterN(at, used, op)) return true;
                    if ((n -= used) == 0) break;
                    at = 0;
                } else at -= sz;
            }
        }
    };
    // Line widgets are block elements displayed above or below a line.
    var LineWidget = function(doc, node, options) {
        var this$1 = this;
        if (options) {
            for(var opt in options)if (options.hasOwnProperty(opt)) this$1[opt] = options[opt];
        }
        this.doc = doc;
        this.node = node;
    };
    LineWidget.prototype.clear = function() {
        var this$1 = this;
        var cm = this.doc.cm, ws = this.line.widgets, line = this.line, no = lineNo(line);
        if (no == null || !ws) return;
        for(var i = 0; i < ws.length; ++i)if (ws[i] == this$1) ws.splice(i--, 1);
        if (!ws.length) line.widgets = null;
        var height = widgetHeight(this);
        updateLineHeight(line, Math.max(0, line.height - height));
        if (cm) {
            runInOp(cm, function() {
                adjustScrollWhenAboveVisible(cm, line, -height);
                regLineChange(cm, no, "widget");
            });
            signalLater(cm, "lineWidgetCleared", cm, this, no);
        }
    };
    LineWidget.prototype.changed = function() {
        var this$1 = this;
        var oldH = this.height, cm = this.doc.cm, line = this.line;
        this.height = null;
        var diff = widgetHeight(this) - oldH;
        if (!diff) return;
        if (!lineIsHidden(this.doc, line)) updateLineHeight(line, line.height + diff);
        if (cm) runInOp(cm, function() {
            cm.curOp.forceUpdate = true;
            adjustScrollWhenAboveVisible(cm, line, diff);
            signalLater(cm, "lineWidgetChanged", cm, this$1, lineNo(line));
        });
    };
    eventMixin(LineWidget);
    function adjustScrollWhenAboveVisible(cm, line, diff) {
        if (heightAtLine(line) < (cm.curOp && cm.curOp.scrollTop || cm.doc.scrollTop)) addToScrollTop(cm, diff);
    }
    function addLineWidget(doc, handle, node, options) {
        var widget = new LineWidget(doc, node, options);
        var cm = doc.cm;
        if (cm && widget.noHScroll) cm.display.alignWidgets = true;
        changeLine(doc, handle, "widget", function(line) {
            var widgets = line.widgets || (line.widgets = []);
            if (widget.insertAt == null) widgets.push(widget);
            else widgets.splice(Math.min(widgets.length - 1, Math.max(0, widget.insertAt)), 0, widget);
            widget.line = line;
            if (cm && !lineIsHidden(doc, line)) {
                var aboveVisible = heightAtLine(line) < doc.scrollTop;
                updateLineHeight(line, line.height + widgetHeight(widget));
                if (aboveVisible) addToScrollTop(cm, widget.height);
                cm.curOp.forceUpdate = true;
            }
            return true;
        });
        if (cm) signalLater(cm, "lineWidgetAdded", cm, widget, typeof handle == "number" ? handle : lineNo(handle));
        return widget;
    }
    // TEXTMARKERS
    // Created with markText and setBookmark methods. A TextMarker is a
    // handle that can be used to clear or find a marked position in the
    // document. Line objects hold arrays (markedSpans) containing
    // {from, to, marker} object pointing to such marker objects, and
    // indicating that such a marker is present on that line. Multiple
    // lines may point to the same marker when it spans across lines.
    // The spans will have null for their from/to properties when the
    // marker continues beyond the start/end of the line. Markers have
    // links back to the lines they currently touch.
    // Collapsed markers have unique ids, in order to be able to order
    // them, which is needed for uniquely determining an outer marker
    // when they overlap (they may nest, but not partially overlap).
    var nextMarkerId = 0;
    var TextMarker = function(doc, type) {
        this.lines = [];
        this.type = type;
        this.doc = doc;
        this.id = ++nextMarkerId;
    };
    // Clear the marker.
    TextMarker.prototype.clear = function() {
        var this$1 = this;
        if (this.explicitlyCleared) return;
        var cm = this.doc.cm, withOp = cm && !cm.curOp;
        if (withOp) startOperation(cm);
        if (hasHandler(this, "clear")) {
            var found = this.find();
            if (found) signalLater(this, "clear", found.from, found.to);
        }
        var min = null, max = null;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this$1.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this$1);
            if (cm && !this$1.collapsed) regLineChange(cm, lineNo(line), "text");
            else if (cm) {
                if (span.to != null) max = lineNo(line);
                if (span.from != null) min = lineNo(line);
            }
            line.markedSpans = removeMarkedSpan(line.markedSpans, span);
            if (span.from == null && this$1.collapsed && !lineIsHidden(this$1.doc, line) && cm) updateLineHeight(line, textHeight(cm.display));
        }
        if (cm && this.collapsed && !cm.options.lineWrapping) for(var i$1 = 0; i$1 < this.lines.length; ++i$1){
            var visual = visualLine(this$1.lines[i$1]), len = lineLength(visual);
            if (len > cm.display.maxLineLength) {
                cm.display.maxLine = visual;
                cm.display.maxLineLength = len;
                cm.display.maxLineChanged = true;
            }
        }
        if (min != null && cm && this.collapsed) regChange(cm, min, max + 1);
        this.lines.length = 0;
        this.explicitlyCleared = true;
        if (this.atomic && this.doc.cantEdit) {
            this.doc.cantEdit = false;
            if (cm) reCheckSelection(cm.doc);
        }
        if (cm) signalLater(cm, "markerCleared", cm, this, min, max);
        if (withOp) endOperation(cm);
        if (this.parent) this.parent.clear();
    };
    // Find the position of the marker in the document. Returns a {from,
    // to} object by default. Side can be passed to get a specific side
    // -- 0 (both), -1 (left), or 1 (right). When lineObj is true, the
    // Pos objects returned contain a line object, rather than a line
    // number (used to prevent looking up the same line twice).
    TextMarker.prototype.find = function(side, lineObj) {
        var this$1 = this;
        if (side == null && this.type == "bookmark") side = 1;
        var from, to;
        for(var i = 0; i < this.lines.length; ++i){
            var line = this$1.lines[i];
            var span = getMarkedSpanFor(line.markedSpans, this$1);
            if (span.from != null) {
                from = Pos(lineObj ? line : lineNo(line), span.from);
                if (side == -1) return from;
            }
            if (span.to != null) {
                to = Pos(lineObj ? line : lineNo(line), span.to);
                if (side == 1) return to;
            }
        }
        return from && {
            from: from,
            to: to
        };
    };
    // Signals that the marker's widget changed, and surrounding layout
    // should be recomputed.
    TextMarker.prototype.changed = function() {
        var this$1 = this;
        var pos = this.find(-1, true), widget = this, cm = this.doc.cm;
        if (!pos || !cm) return;
        runInOp(cm, function() {
            var line = pos.line, lineN = lineNo(pos.line);
            var view = findViewForLine(cm, lineN);
            if (view) {
                clearLineMeasurementCacheFor(view);
                cm.curOp.selectionChanged = cm.curOp.forceUpdate = true;
            }
            cm.curOp.updateMaxLine = true;
            if (!lineIsHidden(widget.doc, line) && widget.height != null) {
                var oldHeight = widget.height;
                widget.height = null;
                var dHeight = widgetHeight(widget) - oldHeight;
                if (dHeight) updateLineHeight(line, line.height + dHeight);
            }
            signalLater(cm, "markerChanged", cm, this$1);
        });
    };
    TextMarker.prototype.attachLine = function(line) {
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            if (!op.maybeHiddenMarkers || indexOf(op.maybeHiddenMarkers, this) == -1) (op.maybeUnhiddenMarkers || (op.maybeUnhiddenMarkers = [])).push(this);
        }
        this.lines.push(line);
    };
    TextMarker.prototype.detachLine = function(line) {
        this.lines.splice(indexOf(this.lines, line), 1);
        if (!this.lines.length && this.doc.cm) {
            var op = this.doc.cm.curOp;
            (op.maybeHiddenMarkers || (op.maybeHiddenMarkers = [])).push(this);
        }
    };
    eventMixin(TextMarker);
    // Create a marker, wire it up to the right lines, and
    function markText(doc, from, to, options, type) {
        // Shared markers (across linked documents) are handled separately
        // (markTextShared will call out to this again, once per
        // document).
        if (options && options.shared) return markTextShared(doc, from, to, options, type);
        // Ensure we are in an operation.
        if (doc.cm && !doc.cm.curOp) return operation(doc.cm, markText)(doc, from, to, options, type);
        var marker = new TextMarker(doc, type), diff = cmp(from, to);
        if (options) copyObj(options, marker, false);
        // Don't connect empty markers unless clearWhenEmpty is false
        if (diff > 0 || diff == 0 && marker.clearWhenEmpty !== false) return marker;
        if (marker.replacedWith) {
            // Showing up as a widget implies collapsed (widget replaces text)
            marker.collapsed = true;
            marker.widgetNode = eltP("span", [
                marker.replacedWith
            ], "CodeMirror-widget");
            if (!options.handleMouseEvents) marker.widgetNode.setAttribute("cm-ignore-events", "true");
            if (options.insertLeft) marker.widgetNode.insertLeft = true;
        }
        if (marker.collapsed) {
            if (conflictingCollapsedRange(doc, from.line, from, to, marker) || from.line != to.line && conflictingCollapsedRange(doc, to.line, from, to, marker)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
            seeCollapsedSpans();
        }
        if (marker.addToHistory) addChangeToHistory(doc, {
            from: from,
            to: to,
            origin: "markText"
        }, doc.sel, NaN);
        var curLine = from.line, cm = doc.cm, updateMaxLine;
        doc.iter(curLine, to.line + 1, function(line) {
            if (cm && marker.collapsed && !cm.options.lineWrapping && visualLine(line) == cm.display.maxLine) updateMaxLine = true;
            if (marker.collapsed && curLine != from.line) updateLineHeight(line, 0);
            addMarkedSpan(line, new MarkedSpan(marker, curLine == from.line ? from.ch : null, curLine == to.line ? to.ch : null));
            ++curLine;
        });
        // lineIsHidden depends on the presence of the spans, so needs a second pass
        if (marker.collapsed) doc.iter(from.line, to.line + 1, function(line) {
            if (lineIsHidden(doc, line)) updateLineHeight(line, 0);
        });
        if (marker.clearOnEnter) on(marker, "beforeCursorEnter", function() {
            return marker.clear();
        });
        if (marker.readOnly) {
            seeReadOnlySpans();
            if (doc.history.done.length || doc.history.undone.length) doc.clearHistory();
        }
        if (marker.collapsed) {
            marker.id = ++nextMarkerId;
            marker.atomic = true;
        }
        if (cm) {
            // Sync editor state
            if (updateMaxLine) cm.curOp.updateMaxLine = true;
            if (marker.collapsed) regChange(cm, from.line, to.line + 1);
            else if (marker.className || marker.startStyle || marker.endStyle || marker.css || marker.attributes || marker.title) for(var i = from.line; i <= to.line; i++)regLineChange(cm, i, "text");
            if (marker.atomic) reCheckSelection(cm.doc);
            signalLater(cm, "markerAdded", cm, marker);
        }
        return marker;
    }
    // SHARED TEXTMARKERS
    // A shared marker spans multiple linked documents. It is
    // implemented as a meta-marker-object controlling multiple normal
    // markers.
    var SharedTextMarker = function(markers, primary) {
        var this$1 = this;
        this.markers = markers;
        this.primary = primary;
        for(var i = 0; i < markers.length; ++i)markers[i].parent = this$1;
    };
    SharedTextMarker.prototype.clear = function() {
        var this$1 = this;
        if (this.explicitlyCleared) return;
        this.explicitlyCleared = true;
        for(var i = 0; i < this.markers.length; ++i)this$1.markers[i].clear();
        signalLater(this, "clear");
    };
    SharedTextMarker.prototype.find = function(side, lineObj) {
        return this.primary.find(side, lineObj);
    };
    eventMixin(SharedTextMarker);
    function markTextShared(doc, from, to, options, type) {
        options = copyObj(options);
        options.shared = false;
        var markers = [
            markText(doc, from, to, options, type)
        ], primary = markers[0];
        var widget = options.widgetNode;
        linkedDocs(doc, function(doc) {
            if (widget) options.widgetNode = widget.cloneNode(true);
            markers.push(markText(doc, clipPos(doc, from), clipPos(doc, to), options, type));
            for(var i = 0; i < doc.linked.length; ++i){
                if (doc.linked[i].isParent) return;
            }
            primary = lst(markers);
        });
        return new SharedTextMarker(markers, primary);
    }
    function findSharedMarkers(doc) {
        return doc.findMarks(Pos(doc.first, 0), doc.clipPos(Pos(doc.lastLine())), function(m) {
            return m.parent;
        });
    }
    function copySharedMarkers(doc, markers) {
        for(var i = 0; i < markers.length; i++){
            var marker = markers[i], pos = marker.find();
            var mFrom = doc.clipPos(pos.from), mTo = doc.clipPos(pos.to);
            if (cmp(mFrom, mTo)) {
                var subMark = markText(doc, mFrom, mTo, marker.primary, marker.primary.type);
                marker.markers.push(subMark);
                subMark.parent = marker;
            }
        }
    }
    function detachSharedMarkers(markers) {
        var loop = function(i) {
            var marker = markers[i], linked = [
                marker.primary.doc
            ];
            linkedDocs(marker.primary.doc, function(d) {
                return linked.push(d);
            });
            for(var j = 0; j < marker.markers.length; j++){
                var subMarker = marker.markers[j];
                if (indexOf(linked, subMarker.doc) == -1) {
                    subMarker.parent = null;
                    marker.markers.splice(j--, 1);
                }
            }
        };
        for(var i = 0; i < markers.length; i++)loop(i);
    }
    var nextDocId = 0;
    var Doc = function(text, mode, firstLine, lineSep, direction) {
        if (!(this instanceof Doc)) return new Doc(text, mode, firstLine, lineSep, direction);
        if (firstLine == null) firstLine = 0;
        BranchChunk.call(this, [
            new LeafChunk([
                new Line("", null)
            ])
        ]);
        this.first = firstLine;
        this.scrollTop = this.scrollLeft = 0;
        this.cantEdit = false;
        this.cleanGeneration = 1;
        this.modeFrontier = this.highlightFrontier = firstLine;
        var start = Pos(firstLine, 0);
        this.sel = simpleSelection(start);
        this.history = new History(null);
        this.id = ++nextDocId;
        this.modeOption = mode;
        this.lineSep = lineSep;
        this.direction = direction == "rtl" ? "rtl" : "ltr";
        this.extend = false;
        if (typeof text == "string") text = this.splitLines(text);
        updateDoc(this, {
            from: start,
            to: start,
            text: text
        });
        setSelection(this, simpleSelection(start), sel_dontScroll);
    };
    Doc.prototype = createObj(BranchChunk.prototype, {
        constructor: Doc,
        // Iterate over the document. Supports two forms -- with only one
        // argument, it calls that for each line in the document. With
        // three, it iterates over the range given by the first two (with
        // the second being non-inclusive).
        iter: function(from, to, op) {
            if (op) this.iterN(from - this.first, to - from, op);
            else this.iterN(this.first, this.first + this.size, from);
        },
        // Non-public interface for adding and removing lines.
        insert: function(at, lines) {
            var height = 0;
            for(var i = 0; i < lines.length; ++i)height += lines[i].height;
            this.insertInner(at - this.first, lines, height);
        },
        remove: function(at, n) {
            this.removeInner(at - this.first, n);
        },
        // From here, the methods are part of the public interface. Most
        // are also available from CodeMirror (editor) instances.
        getValue: function(lineSep) {
            var lines = getLines(this, this.first, this.first + this.size);
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        setValue: docMethodOp(function(code) {
            var top = Pos(this.first, 0), last = this.first + this.size - 1;
            makeChange(this, {
                from: top,
                to: Pos(last, getLine(this, last).text.length),
                text: this.splitLines(code),
                origin: "setValue",
                full: true
            }, true);
            if (this.cm) scrollToCoords(this.cm, 0, 0);
            setSelection(this, simpleSelection(top), sel_dontScroll);
        }),
        replaceRange: function(code, from, to, origin) {
            from = clipPos(this, from);
            to = to ? clipPos(this, to) : from;
            replaceRange(this, code, from, to, origin);
        },
        getRange: function(from, to, lineSep) {
            var lines = getBetween(this, clipPos(this, from), clipPos(this, to));
            if (lineSep === false) return lines;
            return lines.join(lineSep || this.lineSeparator());
        },
        getLine: function(line) {
            var l = this.getLineHandle(line);
            return l && l.text;
        },
        getLineHandle: function(line) {
            if (isLine(this, line)) return getLine(this, line);
        },
        getLineNumber: function(line) {
            return lineNo(line);
        },
        getLineHandleVisualStart: function(line) {
            if (typeof line == "number") line = getLine(this, line);
            return visualLine(line);
        },
        lineCount: function() {
            return this.size;
        },
        firstLine: function() {
            return this.first;
        },
        lastLine: function() {
            return this.first + this.size - 1;
        },
        clipPos: function(pos) {
            return clipPos(this, pos);
        },
        getCursor: function(start) {
            var range$$1 = this.sel.primary(), pos;
            if (start == null || start == "head") pos = range$$1.head;
            else if (start == "anchor") pos = range$$1.anchor;
            else if (start == "end" || start == "to" || start === false) pos = range$$1.to();
            else pos = range$$1.from();
            return pos;
        },
        listSelections: function() {
            return this.sel.ranges;
        },
        somethingSelected: function() {
            return this.sel.somethingSelected();
        },
        setCursor: docMethodOp(function(line, ch, options) {
            setSimpleSelection(this, clipPos(this, typeof line == "number" ? Pos(line, ch || 0) : line), null, options);
        }),
        setSelection: docMethodOp(function(anchor, head, options) {
            setSimpleSelection(this, clipPos(this, anchor), clipPos(this, head || anchor), options);
        }),
        extendSelection: docMethodOp(function(head, other, options) {
            extendSelection(this, clipPos(this, head), other && clipPos(this, other), options);
        }),
        extendSelections: docMethodOp(function(heads, options) {
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        extendSelectionsBy: docMethodOp(function(f, options) {
            var heads = map(this.sel.ranges, f);
            extendSelections(this, clipPosArray(this, heads), options);
        }),
        setSelections: docMethodOp(function(ranges, primary, options) {
            var this$1 = this;
            if (!ranges.length) return;
            var out = [];
            for(var i = 0; i < ranges.length; i++)out[i] = new Range(clipPos(this$1, ranges[i].anchor), clipPos(this$1, ranges[i].head));
            if (primary == null) primary = Math.min(ranges.length - 1, this.sel.primIndex);
            setSelection(this, normalizeSelection(this.cm, out, primary), options);
        }),
        addSelection: docMethodOp(function(anchor, head, options) {
            var ranges = this.sel.ranges.slice(0);
            ranges.push(new Range(clipPos(this, anchor), clipPos(this, head || anchor)));
            setSelection(this, normalizeSelection(this.cm, ranges, ranges.length - 1), options);
        }),
        getSelection: function(lineSep) {
            var this$1 = this;
            var ranges = this.sel.ranges, lines;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
                lines = lines ? lines.concat(sel) : sel;
            }
            if (lineSep === false) return lines;
            else return lines.join(lineSep || this.lineSeparator());
        },
        getSelections: function(lineSep) {
            var this$1 = this;
            var parts = [], ranges = this.sel.ranges;
            for(var i = 0; i < ranges.length; i++){
                var sel = getBetween(this$1, ranges[i].from(), ranges[i].to());
                if (lineSep !== false) sel = sel.join(lineSep || this$1.lineSeparator());
                parts[i] = sel;
            }
            return parts;
        },
        replaceSelection: function(code, collapse, origin) {
            var dup = [];
            for(var i = 0; i < this.sel.ranges.length; i++)dup[i] = code;
            this.replaceSelections(dup, collapse, origin || "+input");
        },
        replaceSelections: docMethodOp(function(code, collapse, origin) {
            var this$1 = this;
            var changes = [], sel = this.sel;
            for(var i = 0; i < sel.ranges.length; i++){
                var range$$1 = sel.ranges[i];
                changes[i] = {
                    from: range$$1.from(),
                    to: range$$1.to(),
                    text: this$1.splitLines(code[i]),
                    origin: origin
                };
            }
            var newSel = collapse && collapse != "end" && computeReplacedSel(this, changes, collapse);
            for(var i$1 = changes.length - 1; i$1 >= 0; i$1--)makeChange(this$1, changes[i$1]);
            if (newSel) setSelectionReplaceHistory(this, newSel);
            else if (this.cm) ensureCursorVisible(this.cm);
        }),
        undo: docMethodOp(function() {
            makeChangeFromHistory(this, "undo");
        }),
        redo: docMethodOp(function() {
            makeChangeFromHistory(this, "redo");
        }),
        undoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "undo", true);
        }),
        redoSelection: docMethodOp(function() {
            makeChangeFromHistory(this, "redo", true);
        }),
        setExtending: function(val) {
            this.extend = val;
        },
        getExtending: function() {
            return this.extend;
        },
        historySize: function() {
            var hist = this.history, done = 0, undone = 0;
            for(var i = 0; i < hist.done.length; i++)if (!hist.done[i].ranges) ++done;
            for(var i$1 = 0; i$1 < hist.undone.length; i$1++)if (!hist.undone[i$1].ranges) ++undone;
            return {
                undo: done,
                redo: undone
            };
        },
        clearHistory: function() {
            this.history = new History(this.history.maxGeneration);
        },
        markClean: function() {
            this.cleanGeneration = this.changeGeneration(true);
        },
        changeGeneration: function(forceSplit) {
            if (forceSplit) this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null;
            return this.history.generation;
        },
        isClean: function(gen) {
            return this.history.generation == (gen || this.cleanGeneration);
        },
        getHistory: function() {
            return {
                done: copyHistoryArray(this.history.done),
                undone: copyHistoryArray(this.history.undone)
            };
        },
        setHistory: function(histData) {
            var hist = this.history = new History(this.history.maxGeneration);
            hist.done = copyHistoryArray(histData.done.slice(0), null, true);
            hist.undone = copyHistoryArray(histData.undone.slice(0), null, true);
        },
        setGutterMarker: docMethodOp(function(line, gutterID, value) {
            return changeLine(this, line, "gutter", function(line) {
                var markers = line.gutterMarkers || (line.gutterMarkers = {});
                markers[gutterID] = value;
                if (!value && isEmpty(markers)) line.gutterMarkers = null;
                return true;
            });
        }),
        clearGutter: docMethodOp(function(gutterID) {
            var this$1 = this;
            this.iter(function(line) {
                if (line.gutterMarkers && line.gutterMarkers[gutterID]) changeLine(this$1, line, "gutter", function() {
                    line.gutterMarkers[gutterID] = null;
                    if (isEmpty(line.gutterMarkers)) line.gutterMarkers = null;
                    return true;
                });
            });
        }),
        lineInfo: function(line) {
            var n;
            if (typeof line == "number") {
                if (!isLine(this, line)) return null;
                n = line;
                line = getLine(this, line);
                if (!line) return null;
            } else {
                n = lineNo(line);
                if (n == null) return null;
            }
            return {
                line: n,
                handle: line,
                text: line.text,
                gutterMarkers: line.gutterMarkers,
                textClass: line.textClass,
                bgClass: line.bgClass,
                wrapClass: line.wrapClass,
                widgets: line.widgets
            };
        },
        addLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                if (!line[prop]) line[prop] = cls;
                else if (classTest(cls).test(line[prop])) return false;
                else line[prop] += " " + cls;
                return true;
            });
        }),
        removeLineClass: docMethodOp(function(handle, where, cls) {
            return changeLine(this, handle, where == "gutter" ? "gutter" : "class", function(line) {
                var prop = where == "text" ? "textClass" : where == "background" ? "bgClass" : where == "gutter" ? "gutterClass" : "wrapClass";
                var cur = line[prop];
                if (!cur) return false;
                else if (cls == null) line[prop] = null;
                else {
                    var found = cur.match(classTest(cls));
                    if (!found) return false;
                    var end = found.index + found[0].length;
                    line[prop] = cur.slice(0, found.index) + (!found.index || end == cur.length ? "" : " ") + cur.slice(end) || null;
                }
                return true;
            });
        }),
        addLineWidget: docMethodOp(function(handle, node, options) {
            return addLineWidget(this, handle, node, options);
        }),
        removeLineWidget: function(widget) {
            widget.clear();
        },
        markText: function(from, to, options) {
            return markText(this, clipPos(this, from), clipPos(this, to), options, options && options.type || "range");
        },
        setBookmark: function(pos, options) {
            var realOpts = {
                replacedWith: options && (options.nodeType == null ? options.widget : options),
                insertLeft: options && options.insertLeft,
                clearWhenEmpty: false,
                shared: options && options.shared,
                handleMouseEvents: options && options.handleMouseEvents
            };
            pos = clipPos(this, pos);
            return markText(this, pos, pos, realOpts, "bookmark");
        },
        findMarksAt: function(pos) {
            pos = clipPos(this, pos);
            var markers = [], spans = getLine(this, pos.line).markedSpans;
            if (spans) for(var i = 0; i < spans.length; ++i){
                var span = spans[i];
                if ((span.from == null || span.from <= pos.ch) && (span.to == null || span.to >= pos.ch)) markers.push(span.marker.parent || span.marker);
            }
            return markers;
        },
        findMarks: function(from, to, filter) {
            from = clipPos(this, from);
            to = clipPos(this, to);
            var found = [], lineNo$$1 = from.line;
            this.iter(from.line, to.line + 1, function(line) {
                var spans = line.markedSpans;
                if (spans) for(var i = 0; i < spans.length; i++){
                    var span = spans[i];
                    if (!(span.to != null && lineNo$$1 == from.line && from.ch >= span.to || span.from == null && lineNo$$1 != from.line || span.from != null && lineNo$$1 == to.line && span.from >= to.ch) && (!filter || filter(span.marker))) found.push(span.marker.parent || span.marker);
                }
                ++lineNo$$1;
            });
            return found;
        },
        getAllMarks: function() {
            var markers = [];
            this.iter(function(line) {
                var sps = line.markedSpans;
                if (sps) {
                    for(var i = 0; i < sps.length; ++i)if (sps[i].from != null) markers.push(sps[i].marker);
                }
            });
            return markers;
        },
        posFromIndex: function(off) {
            var ch, lineNo$$1 = this.first, sepSize = this.lineSeparator().length;
            this.iter(function(line) {
                var sz = line.text.length + sepSize;
                if (sz > off) {
                    ch = off;
                    return true;
                }
                off -= sz;
                ++lineNo$$1;
            });
            return clipPos(this, Pos(lineNo$$1, ch));
        },
        indexFromPos: function(coords) {
            coords = clipPos(this, coords);
            var index = coords.ch;
            if (coords.line < this.first || coords.ch < 0) return 0;
            var sepSize = this.lineSeparator().length;
            this.iter(this.first, coords.line, function(line) {
                index += line.text.length + sepSize;
            });
            return index;
        },
        copy: function(copyHistory) {
            var doc = new Doc(getLines(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
            doc.scrollTop = this.scrollTop;
            doc.scrollLeft = this.scrollLeft;
            doc.sel = this.sel;
            doc.extend = false;
            if (copyHistory) {
                doc.history.undoDepth = this.history.undoDepth;
                doc.setHistory(this.getHistory());
            }
            return doc;
        },
        linkedDoc: function(options) {
            if (!options) options = {};
            var from = this.first, to = this.first + this.size;
            if (options.from != null && options.from > from) from = options.from;
            if (options.to != null && options.to < to) to = options.to;
            var copy = new Doc(getLines(this, from, to), options.mode || this.modeOption, from, this.lineSep, this.direction);
            if (options.sharedHist) copy.history = this.history;
            (this.linked || (this.linked = [])).push({
                doc: copy,
                sharedHist: options.sharedHist
            });
            copy.linked = [
                {
                    doc: this,
                    isParent: true,
                    sharedHist: options.sharedHist
                }
            ];
            copySharedMarkers(copy, findSharedMarkers(this));
            return copy;
        },
        unlinkDoc: function(other) {
            var this$1 = this;
            if (other instanceof CodeMirror) other = other.doc;
            if (this.linked) for(var i = 0; i < this.linked.length; ++i){
                var link = this$1.linked[i];
                if (link.doc != other) continue;
                this$1.linked.splice(i, 1);
                other.unlinkDoc(this$1);
                detachSharedMarkers(findSharedMarkers(this$1));
                break;
            }
            // If the histories were shared, split them again
            if (other.history == this.history) {
                var splitIds = [
                    other.id
                ];
                linkedDocs(other, function(doc) {
                    return splitIds.push(doc.id);
                }, true);
                other.history = new History(null);
                other.history.done = copyHistoryArray(this.history.done, splitIds);
                other.history.undone = copyHistoryArray(this.history.undone, splitIds);
            }
        },
        iterLinkedDocs: function(f) {
            linkedDocs(this, f);
        },
        getMode: function() {
            return this.mode;
        },
        getEditor: function() {
            return this.cm;
        },
        splitLines: function(str) {
            if (this.lineSep) return str.split(this.lineSep);
            return splitLinesAuto(str);
        },
        lineSeparator: function() {
            return this.lineSep || "\n";
        },
        setDirection: docMethodOp(function(dir) {
            if (dir != "rtl") dir = "ltr";
            if (dir == this.direction) return;
            this.direction = dir;
            this.iter(function(line) {
                return line.order = null;
            });
            if (this.cm) directionChanged(this.cm);
        })
    });
    // Public alias.
    Doc.prototype.eachLine = Doc.prototype.iter;
    // Kludge to work around strange IE behavior where it'll sometimes
    // re-fire a series of drag-related events right after the drop (#1551)
    var lastDrop = 0;
    function onDrop(e) {
        var cm = this;
        clearDragCursor(cm);
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e_preventDefault(e);
        if (ie) lastDrop = +new Date;
        var pos = posFromMouse(cm, e, true), files = e.dataTransfer.files;
        if (!pos || cm.isReadOnly()) return;
        // Might be a file drop, in which case we simply extract the text
        // and insert it.
        if (files && files.length && window.FileReader && window.File) {
            var n = files.length, text = Array(n), read = 0;
            var loadFile = function(file, i) {
                if (cm.options.allowDropFileTypes && indexOf(cm.options.allowDropFileTypes, file.type) == -1) return;
                var reader = new FileReader;
                reader.onload = operation(cm, function() {
                    var content = reader.result;
                    if (/[\x00-\x08\x0e-\x1f]{2}/.test(content)) content = "";
                    text[i] = content;
                    if (++read == n) {
                        pos = clipPos(cm.doc, pos);
                        var change = {
                            from: pos,
                            to: pos,
                            text: cm.doc.splitLines(text.join(cm.doc.lineSeparator())),
                            origin: "paste"
                        };
                        makeChange(cm.doc, change);
                        setSelectionReplaceHistory(cm.doc, simpleSelection(pos, changeEnd(change)));
                    }
                });
                reader.readAsText(file);
            };
            for(var i = 0; i < n; ++i)loadFile(files[i], i);
        } else {
            // Don't do a replace if the drop happened inside of the selected text.
            if (cm.state.draggingText && cm.doc.sel.contains(pos) > -1) {
                cm.state.draggingText(e);
                // Ensure the editor is re-focused
                setTimeout(function() {
                    return cm.display.input.focus();
                }, 20);
                return;
            }
            try {
                var text$1 = e.dataTransfer.getData("Text");
                if (text$1) {
                    var selected;
                    if (cm.state.draggingText && !cm.state.draggingText.copy) selected = cm.listSelections();
                    setSelectionNoUndo(cm.doc, simpleSelection(pos, pos));
                    if (selected) for(var i$1 = 0; i$1 < selected.length; ++i$1)replaceRange(cm.doc, "", selected[i$1].anchor, selected[i$1].head, "drag");
                    cm.replaceSelection(text$1, "around", "paste");
                    cm.display.input.focus();
                }
            } catch (e) {}
        }
    }
    function onDragStart(cm, e) {
        if (ie && (!cm.state.draggingText || +new Date - lastDrop < 100)) {
            e_stop(e);
            return;
        }
        if (signalDOMEvent(cm, e) || eventInWidget(cm.display, e)) return;
        e.dataTransfer.setData("Text", cm.getSelection());
        e.dataTransfer.effectAllowed = "copyMove";
        // Use dummy image instead of default browsers image.
        // Recent Safari (~6.0.2) have a tendency to segfault when this happens, so we don't do it there.
        if (e.dataTransfer.setDragImage && !safari) {
            var img = elt("img", null, null, "position: fixed; left: 0; top: 0;");
            img.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
            if (presto) {
                img.width = img.height = 1;
                cm.display.wrapper.appendChild(img);
                // Force a relayout, or Opera won't use our image for some obscure reason
                img._top = img.offsetTop;
            }
            e.dataTransfer.setDragImage(img, 0, 0);
            if (presto) img.parentNode.removeChild(img);
        }
    }
    function onDragOver(cm, e) {
        var pos = posFromMouse(cm, e);
        if (!pos) return;
        var frag = document.createDocumentFragment();
        drawSelectionCursor(cm, pos, frag);
        if (!cm.display.dragCursor) {
            cm.display.dragCursor = elt("div", null, "CodeMirror-cursors CodeMirror-dragcursors");
            cm.display.lineSpace.insertBefore(cm.display.dragCursor, cm.display.cursorDiv);
        }
        removeChildrenAndAdd(cm.display.dragCursor, frag);
    }
    function clearDragCursor(cm) {
        if (cm.display.dragCursor) {
            cm.display.lineSpace.removeChild(cm.display.dragCursor);
            cm.display.dragCursor = null;
        }
    }
    // These must be handled carefully, because naively registering a
    // handler for each editor will cause the editors to never be
    // garbage collected.
    function forEachCodeMirror(f) {
        if (!document.getElementsByClassName) return;
        var byClass = document.getElementsByClassName("CodeMirror"), editors = [];
        for(var i = 0; i < byClass.length; i++){
            var cm = byClass[i].CodeMirror;
            if (cm) editors.push(cm);
        }
        if (editors.length) editors[0].operation(function() {
            for(var i = 0; i < editors.length; i++)f(editors[i]);
        });
    }
    var globalsRegistered = false;
    function ensureGlobalHandlers() {
        if (globalsRegistered) return;
        registerGlobalHandlers();
        globalsRegistered = true;
    }
    function registerGlobalHandlers() {
        // When the window resizes, we need to refresh active editors.
        var resizeTimer;
        on(window, "resize", function() {
            if (resizeTimer == null) resizeTimer = setTimeout(function() {
                resizeTimer = null;
                forEachCodeMirror(onResize);
            }, 100);
        });
        // When the window loses focus, we want to show the editor as blurred
        on(window, "blur", function() {
            return forEachCodeMirror(onBlur);
        });
    }
    // Called when the window resizes
    function onResize(cm) {
        var d = cm.display;
        // Might be a text scaling operation, clear size caches.
        d.cachedCharWidth = d.cachedTextHeight = d.cachedPaddingH = null;
        d.scrollbarsClipped = false;
        cm.setSize();
    }
    var keyNames = {
        3: "Pause",
        8: "Backspace",
        9: "Tab",
        13: "Enter",
        16: "Shift",
        17: "Ctrl",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Esc",
        32: "Space",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "Left",
        38: "Up",
        39: "Right",
        40: "Down",
        44: "PrintScrn",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Mod",
        92: "Mod",
        93: "Mod",
        106: "*",
        107: "=",
        109: "-",
        110: ".",
        111: "/",
        145: "ScrollLock",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'",
        63232: "Up",
        63233: "Down",
        63234: "Left",
        63235: "Right",
        63272: "Delete",
        63273: "Home",
        63275: "End",
        63276: "PageUp",
        63277: "PageDown",
        63302: "Insert"
    };
    // Number keys
    for(var i = 0; i < 10; i++)keyNames[i + 48] = keyNames[i + 96] = String(i);
    // Alphabetic keys
    for(var i$1 = 65; i$1 <= 90; i$1++)keyNames[i$1] = String.fromCharCode(i$1);
    // Function keys
    for(var i$2 = 1; i$2 <= 12; i$2++)keyNames[i$2 + 111] = keyNames[i$2 + 63235] = "F" + i$2;
    var keyMap = {};
    keyMap.basic = {
        "Left": "goCharLeft",
        "Right": "goCharRight",
        "Up": "goLineUp",
        "Down": "goLineDown",
        "End": "goLineEnd",
        "Home": "goLineStartSmart",
        "PageUp": "goPageUp",
        "PageDown": "goPageDown",
        "Delete": "delCharAfter",
        "Backspace": "delCharBefore",
        "Shift-Backspace": "delCharBefore",
        "Tab": "defaultTab",
        "Shift-Tab": "indentAuto",
        "Enter": "newlineAndIndent",
        "Insert": "toggleOverwrite",
        "Esc": "singleSelection"
    };
    // Note that the save and find-related commands aren't defined by
    // default. User code or addons can define them. Unknown commands
    // are simply ignored.
    keyMap.pcDefault = {
        "Ctrl-A": "selectAll",
        "Ctrl-D": "deleteLine",
        "Ctrl-Z": "undo",
        "Shift-Ctrl-Z": "redo",
        "Ctrl-Y": "redo",
        "Ctrl-Home": "goDocStart",
        "Ctrl-End": "goDocEnd",
        "Ctrl-Up": "goLineUp",
        "Ctrl-Down": "goLineDown",
        "Ctrl-Left": "goGroupLeft",
        "Ctrl-Right": "goGroupRight",
        "Alt-Left": "goLineStart",
        "Alt-Right": "goLineEnd",
        "Ctrl-Backspace": "delGroupBefore",
        "Ctrl-Delete": "delGroupAfter",
        "Ctrl-S": "save",
        "Ctrl-F": "find",
        "Ctrl-G": "findNext",
        "Shift-Ctrl-G": "findPrev",
        "Shift-Ctrl-F": "replace",
        "Shift-Ctrl-R": "replaceAll",
        "Ctrl-[": "indentLess",
        "Ctrl-]": "indentMore",
        "Ctrl-U": "undoSelection",
        "Shift-Ctrl-U": "redoSelection",
        "Alt-U": "redoSelection",
        "fallthrough": "basic"
    };
    // Very basic readline/emacs-style bindings, which are standard on Mac.
    keyMap.emacsy = {
        "Ctrl-F": "goCharRight",
        "Ctrl-B": "goCharLeft",
        "Ctrl-P": "goLineUp",
        "Ctrl-N": "goLineDown",
        "Alt-F": "goWordRight",
        "Alt-B": "goWordLeft",
        "Ctrl-A": "goLineStart",
        "Ctrl-E": "goLineEnd",
        "Ctrl-V": "goPageDown",
        "Shift-Ctrl-V": "goPageUp",
        "Ctrl-D": "delCharAfter",
        "Ctrl-H": "delCharBefore",
        "Alt-D": "delWordAfter",
        "Alt-Backspace": "delWordBefore",
        "Ctrl-K": "killLine",
        "Ctrl-T": "transposeChars",
        "Ctrl-O": "openLine"
    };
    keyMap.macDefault = {
        "Cmd-A": "selectAll",
        "Cmd-D": "deleteLine",
        "Cmd-Z": "undo",
        "Shift-Cmd-Z": "redo",
        "Cmd-Y": "redo",
        "Cmd-Home": "goDocStart",
        "Cmd-Up": "goDocStart",
        "Cmd-End": "goDocEnd",
        "Cmd-Down": "goDocEnd",
        "Alt-Left": "goGroupLeft",
        "Alt-Right": "goGroupRight",
        "Cmd-Left": "goLineLeft",
        "Cmd-Right": "goLineRight",
        "Alt-Backspace": "delGroupBefore",
        "Ctrl-Alt-Backspace": "delGroupAfter",
        "Alt-Delete": "delGroupAfter",
        "Cmd-S": "save",
        "Cmd-F": "find",
        "Cmd-G": "findNext",
        "Shift-Cmd-G": "findPrev",
        "Cmd-Alt-F": "replace",
        "Shift-Cmd-Alt-F": "replaceAll",
        "Cmd-[": "indentLess",
        "Cmd-]": "indentMore",
        "Cmd-Backspace": "delWrappedLineLeft",
        "Cmd-Delete": "delWrappedLineRight",
        "Cmd-U": "undoSelection",
        "Shift-Cmd-U": "redoSelection",
        "Ctrl-Up": "goDocStart",
        "Ctrl-Down": "goDocEnd",
        "fallthrough": [
            "basic",
            "emacsy"
        ]
    };
    keyMap["default"] = mac ? keyMap.macDefault : keyMap.pcDefault;
    // KEYMAP DISPATCH
    function normalizeKeyName(name) {
        var parts = name.split(/-(?!$)/);
        name = parts[parts.length - 1];
        var alt, ctrl, shift, cmd;
        for(var i = 0; i < parts.length - 1; i++){
            var mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) cmd = true;
            else if (/^a(lt)?$/i.test(mod)) alt = true;
            else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
            else if (/^s(hift)?$/i.test(mod)) shift = true;
            else throw new Error("Unrecognized modifier name: " + mod);
        }
        if (alt) name = "Alt-" + name;
        if (ctrl) name = "Ctrl-" + name;
        if (cmd) name = "Cmd-" + name;
        if (shift) name = "Shift-" + name;
        return name;
    }
    // This is a kludge to keep keymaps mostly working as raw objects
    // (backwards compatibility) while at the same time support features
    // like normalization and multi-stroke key bindings. It compiles a
    // new normalized keymap, and then updates the old object to reflect
    // this.
    function normalizeKeyMap(keymap) {
        var copy = {};
        for(var keyname in keymap)if (keymap.hasOwnProperty(keyname)) {
            var value = keymap[keyname];
            if (/^(name|fallthrough|(de|at)tach)$/.test(keyname)) continue;
            if (value == "...") {
                delete keymap[keyname];
                continue;
            }
            var keys = map(keyname.split(" "), normalizeKeyName);
            for(var i = 0; i < keys.length; i++){
                var val = void 0, name = void 0;
                if (i == keys.length - 1) {
                    name = keys.join(" ");
                    val = value;
                } else {
                    name = keys.slice(0, i + 1).join(" ");
                    val = "...";
                }
                var prev = copy[name];
                if (!prev) copy[name] = val;
                else if (prev != val) throw new Error("Inconsistent bindings for " + name);
            }
            delete keymap[keyname];
        }
        for(var prop in copy)keymap[prop] = copy[prop];
        return keymap;
    }
    function lookupKey(key, map$$1, handle, context) {
        map$$1 = getKeyMap(map$$1);
        var found = map$$1.call ? map$$1.call(key, context) : map$$1[key];
        if (found === false) return "nothing";
        if (found === "...") return "multi";
        if (found != null && handle(found)) return "handled";
        if (map$$1.fallthrough) {
            if (Object.prototype.toString.call(map$$1.fallthrough) != "[object Array]") return lookupKey(key, map$$1.fallthrough, handle, context);
            for(var i = 0; i < map$$1.fallthrough.length; i++){
                var result = lookupKey(key, map$$1.fallthrough[i], handle, context);
                if (result) return result;
            }
        }
    }
    // Modifier key presses don't count as 'real' key presses for the
    // purpose of keymap fallthrough.
    function isModifierKey(value) {
        var name = typeof value == "string" ? value : keyNames[value.keyCode];
        return name == "Ctrl" || name == "Alt" || name == "Shift" || name == "Mod";
    }
    function addModifierNames(name, event, noShift) {
        var base = name;
        if (event.altKey && base != "Alt") name = "Alt-" + name;
        if ((flipCtrlCmd ? event.metaKey : event.ctrlKey) && base != "Ctrl") name = "Ctrl-" + name;
        if ((flipCtrlCmd ? event.ctrlKey : event.metaKey) && base != "Cmd") name = "Cmd-" + name;
        if (!noShift && event.shiftKey && base != "Shift") name = "Shift-" + name;
        return name;
    }
    // Look up the name of a key as indicated by an event object.
    function keyName(event, noShift) {
        if (presto && event.keyCode == 34 && event["char"]) return false;
        var name = keyNames[event.keyCode];
        if (name == null || event.altGraphKey) return false;
        // Ctrl-ScrollLock has keyCode 3, same as Ctrl-Pause,
        // so we'll use event.code when available (Chrome 48+, FF 38+, Safari 10.1+)
        if (event.keyCode == 3 && event.code) name = event.code;
        return addModifierNames(name, event, noShift);
    }
    function getKeyMap(val) {
        return typeof val == "string" ? keyMap[val] : val;
    }
    // Helper for deleting text near the selection(s), used to implement
    // backspace, delete, and similar functionality.
    function deleteNearSelection(cm, compute) {
        var ranges = cm.doc.sel.ranges, kill = [];
        // Build up a set of ranges to kill first, merging overlapping
        // ranges.
        for(var i = 0; i < ranges.length; i++){
            var toKill = compute(ranges[i]);
            while(kill.length && cmp(toKill.from, lst(kill).to) <= 0){
                var replaced = kill.pop();
                if (cmp(replaced.from, toKill.from) < 0) {
                    toKill.from = replaced.from;
                    break;
                }
            }
            kill.push(toKill);
        }
        // Next, remove those actual ranges.
        runInOp(cm, function() {
            for(var i = kill.length - 1; i >= 0; i--)replaceRange(cm.doc, "", kill[i].from, kill[i].to, "+delete");
            ensureCursorVisible(cm);
        });
    }
    function moveCharLogically(line, ch, dir) {
        var target = skipExtendingChars(line.text, ch + dir, dir);
        return target < 0 || target > line.text.length ? null : target;
    }
    function moveLogically(line, start, dir) {
        var ch = moveCharLogically(line, start.ch, dir);
        return ch == null ? null : new Pos(start.line, ch, dir < 0 ? "after" : "before");
    }
    function endOfLine(visually, cm, lineObj, lineNo, dir) {
        if (visually) {
            var order = getOrder(lineObj, cm.doc.direction);
            if (order) {
                var part = dir < 0 ? lst(order) : order[0];
                var moveInStorageOrder = dir < 0 == (part.level == 1);
                var sticky = moveInStorageOrder ? "after" : "before";
                var ch;
                // With a wrapped rtl chunk (possibly spanning multiple bidi parts),
                // it could be that the last bidi part is not on the last visual line,
                // since visual lines contain content order-consecutive chunks.
                // Thus, in rtl, we are looking for the first (content-order) character
                // in the rtl chunk that is on the last line (that is, the same line
                // as the last (content-order) character).
                if (part.level > 0 || cm.doc.direction == "rtl") {
                    var prep = prepareMeasureForLine(cm, lineObj);
                    ch = dir < 0 ? lineObj.text.length - 1 : 0;
                    var targetTop = measureCharPrepared(cm, prep, ch).top;
                    ch = findFirst(function(ch) {
                        return measureCharPrepared(cm, prep, ch).top == targetTop;
                    }, dir < 0 == (part.level == 1) ? part.from : part.to - 1, ch);
                    if (sticky == "before") ch = moveCharLogically(lineObj, ch, 1);
                } else ch = dir < 0 ? part.to : part.from;
                return new Pos(lineNo, ch, sticky);
            }
        }
        return new Pos(lineNo, dir < 0 ? lineObj.text.length : 0, dir < 0 ? "before" : "after");
    }
    function moveVisually(cm, line, start, dir) {
        var bidi = getOrder(line, cm.doc.direction);
        if (!bidi) return moveLogically(line, start, dir);
        if (start.ch >= line.text.length) {
            start.ch = line.text.length;
            start.sticky = "before";
        } else if (start.ch <= 0) {
            start.ch = 0;
            start.sticky = "after";
        }
        var partPos = getBidiPartAt(bidi, start.ch, start.sticky), part = bidi[partPos];
        if (cm.doc.direction == "ltr" && part.level % 2 == 0 && (dir > 0 ? part.to > start.ch : part.from < start.ch)) // Case 1: We move within an ltr part in an ltr editor. Even with wrapped lines,
        // nothing interesting happens.
        return moveLogically(line, start, dir);
        var mv = function(pos, dir) {
            return moveCharLogically(line, pos instanceof Pos ? pos.ch : pos, dir);
        };
        var prep;
        var getWrappedLineExtent = function(ch) {
            if (!cm.options.lineWrapping) return {
                begin: 0,
                end: line.text.length
            };
            prep = prep || prepareMeasureForLine(cm, line);
            return wrappedLineExtentChar(cm, line, prep, ch);
        };
        var wrappedLineExtent = getWrappedLineExtent(start.sticky == "before" ? mv(start, -1) : start.ch);
        if (cm.doc.direction == "rtl" || part.level == 1) {
            var moveInStorageOrder = part.level == 1 == dir < 0;
            var ch = mv(start, moveInStorageOrder ? 1 : -1);
            if (ch != null && (!moveInStorageOrder ? ch >= part.from && ch >= wrappedLineExtent.begin : ch <= part.to && ch <= wrappedLineExtent.end)) {
                // Case 2: We move within an rtl part or in an rtl editor on the same visual line
                var sticky = moveInStorageOrder ? "before" : "after";
                return new Pos(start.line, ch, sticky);
            }
        }
        // Case 3: Could not move within this bidi part in this visual line, so leave
        // the current bidi part
        var searchInVisualLine = function(partPos, dir, wrappedLineExtent) {
            var getRes = function(ch, moveInStorageOrder) {
                return moveInStorageOrder ? new Pos(start.line, mv(ch, 1), "before") : new Pos(start.line, ch, "after");
            };
            for(; partPos >= 0 && partPos < bidi.length; partPos += dir){
                var part = bidi[partPos];
                var moveInStorageOrder = dir > 0 == (part.level != 1);
                var ch = moveInStorageOrder ? wrappedLineExtent.begin : mv(wrappedLineExtent.end, -1);
                if (part.from <= ch && ch < part.to) return getRes(ch, moveInStorageOrder);
                ch = moveInStorageOrder ? part.from : mv(part.to, -1);
                if (wrappedLineExtent.begin <= ch && ch < wrappedLineExtent.end) return getRes(ch, moveInStorageOrder);
            }
        };
        // Case 3a: Look for other bidi parts on the same visual line
        var res = searchInVisualLine(partPos + dir, dir, wrappedLineExtent);
        if (res) return res;
        // Case 3b: Look for other bidi parts on the next visual line
        var nextCh = dir > 0 ? wrappedLineExtent.end : mv(wrappedLineExtent.begin, -1);
        if (nextCh != null && !(dir > 0 && nextCh == line.text.length)) {
            res = searchInVisualLine(dir > 0 ? 0 : bidi.length - 1, dir, getWrappedLineExtent(nextCh));
            if (res) return res;
        }
        // Case 4: Nowhere to move
        return null;
    }
    // Commands are parameter-less actions that can be performed on an
    // editor, mostly used for keybindings.
    var commands = {
        selectAll: selectAll,
        singleSelection: function(cm) {
            return cm.setSelection(cm.getCursor("anchor"), cm.getCursor("head"), sel_dontScroll);
        },
        killLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                if (range.empty()) {
                    var len = getLine(cm.doc, range.head.line).text.length;
                    if (range.head.ch == len && range.head.line < cm.lastLine()) return {
                        from: range.head,
                        to: Pos(range.head.line + 1, 0)
                    };
                    else return {
                        from: range.head,
                        to: Pos(range.head.line, len)
                    };
                } else return {
                    from: range.from(),
                    to: range.to()
                };
            });
        },
        deleteLine: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: clipPos(cm.doc, Pos(range.to().line + 1, 0))
                };
            });
        },
        delLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                return {
                    from: Pos(range.from().line, 0),
                    to: range.from()
                };
            });
        },
        delWrappedLineLeft: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var leftPos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                return {
                    from: leftPos,
                    to: range.from()
                };
            });
        },
        delWrappedLineRight: function(cm) {
            return deleteNearSelection(cm, function(range) {
                var top = cm.charCoords(range.head, "div").top + 5;
                var rightPos = cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
                return {
                    from: range.from(),
                    to: rightPos
                };
            });
        },
        undo: function(cm) {
            return cm.undo();
        },
        redo: function(cm) {
            return cm.redo();
        },
        undoSelection: function(cm) {
            return cm.undoSelection();
        },
        redoSelection: function(cm) {
            return cm.redoSelection();
        },
        goDocStart: function(cm) {
            return cm.extendSelection(Pos(cm.firstLine(), 0));
        },
        goDocEnd: function(cm) {
            return cm.extendSelection(Pos(cm.lastLine()));
        },
        goLineStart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStart(cm, range.head.line);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineStartSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineStartSmart(cm, range.head);
            }, {
                origin: "+move",
                bias: 1
            });
        },
        goLineEnd: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                return lineEnd(cm, range.head.line);
            }, {
                origin: "+move",
                bias: -1
            });
        },
        goLineRight: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: cm.display.lineDiv.offsetWidth + 100,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeft: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                return cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
            }, sel_move);
        },
        goLineLeftSmart: function(cm) {
            return cm.extendSelectionsBy(function(range) {
                var top = cm.cursorCoords(range.head, "div").top + 5;
                var pos = cm.coordsChar({
                    left: 0,
                    top: top
                }, "div");
                if (pos.ch < cm.getLine(pos.line).search(/\S/)) return lineStartSmart(cm, range.head);
                return pos;
            }, sel_move);
        },
        goLineUp: function(cm) {
            return cm.moveV(-1, "line");
        },
        goLineDown: function(cm) {
            return cm.moveV(1, "line");
        },
        goPageUp: function(cm) {
            return cm.moveV(-1, "page");
        },
        goPageDown: function(cm) {
            return cm.moveV(1, "page");
        },
        goCharLeft: function(cm) {
            return cm.moveH(-1, "char");
        },
        goCharRight: function(cm) {
            return cm.moveH(1, "char");
        },
        goColumnLeft: function(cm) {
            return cm.moveH(-1, "column");
        },
        goColumnRight: function(cm) {
            return cm.moveH(1, "column");
        },
        goWordLeft: function(cm) {
            return cm.moveH(-1, "word");
        },
        goGroupRight: function(cm) {
            return cm.moveH(1, "group");
        },
        goGroupLeft: function(cm) {
            return cm.moveH(-1, "group");
        },
        goWordRight: function(cm) {
            return cm.moveH(1, "word");
        },
        delCharBefore: function(cm) {
            return cm.deleteH(-1, "char");
        },
        delCharAfter: function(cm) {
            return cm.deleteH(1, "char");
        },
        delWordBefore: function(cm) {
            return cm.deleteH(-1, "word");
        },
        delWordAfter: function(cm) {
            return cm.deleteH(1, "word");
        },
        delGroupBefore: function(cm) {
            return cm.deleteH(-1, "group");
        },
        delGroupAfter: function(cm) {
            return cm.deleteH(1, "group");
        },
        indentAuto: function(cm) {
            return cm.indentSelection("smart");
        },
        indentMore: function(cm) {
            return cm.indentSelection("add");
        },
        indentLess: function(cm) {
            return cm.indentSelection("subtract");
        },
        insertTab: function(cm) {
            return cm.replaceSelection("	");
        },
        insertSoftTab: function(cm) {
            var spaces = [], ranges = cm.listSelections(), tabSize = cm.options.tabSize;
            for(var i = 0; i < ranges.length; i++){
                var pos = ranges[i].from();
                var col = countColumn(cm.getLine(pos.line), pos.ch, tabSize);
                spaces.push(spaceStr(tabSize - col % tabSize));
            }
            cm.replaceSelections(spaces);
        },
        defaultTab: function(cm) {
            if (cm.somethingSelected()) cm.indentSelection("add");
            else cm.execCommand("insertTab");
        },
        // Swap the two chars left and right of each selection's head.
        // Move cursor behind the two swapped characters afterwards.
        //
        // Doesn't consider line feeds a character.
        // Doesn't scan more than one line above to find a character.
        // Doesn't do anything on an empty line.
        // Doesn't do anything with non-empty selections.
        transposeChars: function(cm) {
            return runInOp(cm, function() {
                var ranges = cm.listSelections(), newSel = [];
                for(var i = 0; i < ranges.length; i++){
                    if (!ranges[i].empty()) continue;
                    var cur = ranges[i].head, line = getLine(cm.doc, cur.line).text;
                    if (line) {
                        if (cur.ch == line.length) cur = new Pos(cur.line, cur.ch - 1);
                        if (cur.ch > 0) {
                            cur = new Pos(cur.line, cur.ch + 1);
                            cm.replaceRange(line.charAt(cur.ch - 1) + line.charAt(cur.ch - 2), Pos(cur.line, cur.ch - 2), cur, "+transpose");
                        } else if (cur.line > cm.doc.first) {
                            var prev = getLine(cm.doc, cur.line - 1).text;
                            if (prev) {
                                cur = new Pos(cur.line, 1);
                                cm.replaceRange(line.charAt(0) + cm.doc.lineSeparator() + prev.charAt(prev.length - 1), Pos(cur.line - 1, prev.length - 1), cur, "+transpose");
                            }
                        }
                    }
                    newSel.push(new Range(cur, cur));
                }
                cm.setSelections(newSel);
            });
        },
        newlineAndIndent: function(cm) {
            return runInOp(cm, function() {
                var sels = cm.listSelections();
                for(var i = sels.length - 1; i >= 0; i--)cm.replaceRange(cm.doc.lineSeparator(), sels[i].anchor, sels[i].head, "+input");
                sels = cm.listSelections();
                for(var i$1 = 0; i$1 < sels.length; i$1++)cm.indentLine(sels[i$1].from().line, null, true);
                ensureCursorVisible(cm);
            });
        },
        openLine: function(cm) {
            return cm.replaceSelection("\n", "start");
        },
        toggleOverwrite: function(cm) {
            return cm.toggleOverwrite();
        }
    };
    function lineStart(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLine(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, visual, lineN, 1);
    }
    function lineEnd(cm, lineN) {
        var line = getLine(cm.doc, lineN);
        var visual = visualLineEnd(line);
        if (visual != line) lineN = lineNo(visual);
        return endOfLine(true, cm, line, lineN, -1);
    }
    function lineStartSmart(cm, pos) {
        var start = lineStart(cm, pos.line);
        var line = getLine(cm.doc, start.line);
        var order = getOrder(line, cm.doc.direction);
        if (!order || order[0].level == 0) {
            var firstNonWS = Math.max(0, line.text.search(/\S/));
            var inWS = pos.line == start.line && pos.ch <= firstNonWS && pos.ch;
            return Pos(start.line, inWS ? 0 : firstNonWS, start.sticky);
        }
        return start;
    }
    // Run a handler that was bound to a key.
    function doHandleBinding(cm, bound, dropShift) {
        if (typeof bound == "string") {
            bound = commands[bound];
            if (!bound) return false;
        }
        // Ensure previous input has been read, so that the handler sees a
        // consistent view of the document
        cm.display.input.ensurePolled();
        var prevShift = cm.display.shift, done = false;
        try {
            if (cm.isReadOnly()) cm.state.suppressEdits = true;
            if (dropShift) cm.display.shift = false;
            done = bound(cm) != Pass;
        } finally{
            cm.display.shift = prevShift;
            cm.state.suppressEdits = false;
        }
        return done;
    }
    function lookupKeyForEditor(cm, name, handle) {
        for(var i = 0; i < cm.state.keyMaps.length; i++){
            var result = lookupKey(name, cm.state.keyMaps[i], handle, cm);
            if (result) return result;
        }
        return cm.options.extraKeys && lookupKey(name, cm.options.extraKeys, handle, cm) || lookupKey(name, cm.options.keyMap, handle, cm);
    }
    // Note that, despite the name, this function is also used to check
    // for bound mouse clicks.
    var stopSeq = new Delayed;
    function dispatchKey(cm, name, e, handle) {
        var seq = cm.state.keySeq;
        if (seq) {
            if (isModifierKey(name)) return "handled";
            if (/\'$/.test(name)) cm.state.keySeq = null;
            else stopSeq.set(50, function() {
                if (cm.state.keySeq == seq) {
                    cm.state.keySeq = null;
                    cm.display.input.reset();
                }
            });
            if (dispatchKeyInner(cm, seq + " " + name, e, handle)) return true;
        }
        return dispatchKeyInner(cm, name, e, handle);
    }
    function dispatchKeyInner(cm, name, e, handle) {
        var result = lookupKeyForEditor(cm, name, handle);
        if (result == "multi") cm.state.keySeq = name;
        if (result == "handled") signalLater(cm, "keyHandled", cm, name, e);
        if (result == "handled" || result == "multi") {
            e_preventDefault(e);
            restartBlink(cm);
        }
        return !!result;
    }
    // Handle a key from the keydown event.
    function handleKeyBinding(cm, e) {
        var name = keyName(e, true);
        if (!name) return false;
        if (e.shiftKey && !cm.state.keySeq) // First try to resolve full name (including 'Shift-'). Failing
        // that, see if there is a cursor-motion command (starting with
        // 'go') bound to the keyname without 'Shift-'.
        return dispatchKey(cm, "Shift-" + name, e, function(b) {
            return doHandleBinding(cm, b, true);
        }) || dispatchKey(cm, name, e, function(b) {
            if (typeof b == "string" ? /^go[A-Z]/.test(b) : b.motion) return doHandleBinding(cm, b);
        });
        else return dispatchKey(cm, name, e, function(b) {
            return doHandleBinding(cm, b);
        });
    }
    // Handle a key from the keypress event
    function handleCharBinding(cm, e, ch) {
        return dispatchKey(cm, "'" + ch + "'", e, function(b) {
            return doHandleBinding(cm, b, true);
        });
    }
    var lastStoppedKey = null;
    function onKeyDown(e) {
        var cm = this;
        cm.curOp.focus = activeElt();
        if (signalDOMEvent(cm, e)) return;
        // IE does strange things with escape.
        if (ie && ie_version < 11 && e.keyCode == 27) e.returnValue = false;
        var code = e.keyCode;
        cm.display.shift = code == 16 || e.shiftKey;
        var handled = handleKeyBinding(cm, e);
        if (presto) {
            lastStoppedKey = handled ? code : null;
            // Opera has no cut event... we try to at least catch the key combo
            if (!handled && code == 88 && !hasCopyEvent && (mac ? e.metaKey : e.ctrlKey)) cm.replaceSelection("", null, "cut");
        }
        // Turn mouse into crosshair when Alt is held on Mac.
        if (code == 18 && !/\bCodeMirror-crosshair\b/.test(cm.display.lineDiv.className)) showCrossHair(cm);
    }
    function showCrossHair(cm) {
        var lineDiv = cm.display.lineDiv;
        addClass(lineDiv, "CodeMirror-crosshair");
        function up(e) {
            if (e.keyCode == 18 || !e.altKey) {
                rmClass(lineDiv, "CodeMirror-crosshair");
                off(document, "keyup", up);
                off(document, "mouseover", up);
            }
        }
        on(document, "keyup", up);
        on(document, "mouseover", up);
    }
    function onKeyUp(e) {
        if (e.keyCode == 16) this.doc.sel.shift = false;
        signalDOMEvent(this, e);
    }
    function onKeyPress(e) {
        var cm = this;
        if (eventInWidget(cm.display, e) || signalDOMEvent(cm, e) || e.ctrlKey && !e.altKey || mac && e.metaKey) return;
        var keyCode = e.keyCode, charCode = e.charCode;
        if (presto && keyCode == lastStoppedKey) {
            lastStoppedKey = null;
            e_preventDefault(e);
            return;
        }
        if (presto && (!e.which || e.which < 10) && handleKeyBinding(cm, e)) return;
        var ch = String.fromCharCode(charCode == null ? keyCode : charCode);
        // Some browsers fire keypress events for backspace
        if (ch == "\b") return;
        if (handleCharBinding(cm, e, ch)) return;
        cm.display.input.onKeyPress(e);
    }
    var DOUBLECLICK_DELAY = 400;
    var PastClick = function(time, pos, button) {
        this.time = time;
        this.pos = pos;
        this.button = button;
    };
    PastClick.prototype.compare = function(time, pos, button) {
        return this.time + DOUBLECLICK_DELAY > time && cmp(pos, this.pos) == 0 && button == this.button;
    };
    var lastClick, lastDoubleClick;
    function clickRepeat(pos, button) {
        var now = +new Date;
        if (lastDoubleClick && lastDoubleClick.compare(now, pos, button)) {
            lastClick = lastDoubleClick = null;
            return "triple";
        } else if (lastClick && lastClick.compare(now, pos, button)) {
            lastDoubleClick = new PastClick(now, pos, button);
            lastClick = null;
            return "double";
        } else {
            lastClick = new PastClick(now, pos, button);
            lastDoubleClick = null;
            return "single";
        }
    }
    // A mouse down can be a single click, double click, triple click,
    // start of selection drag, start of text drag, new cursor
    // (ctrl-click), rectangle drag (alt-drag), or xwin
    // middle-click-paste. Or it might be a click on something we should
    // not interfere with, such as a scrollbar or widget.
    function onMouseDown(e) {
        var cm = this, display = cm.display;
        if (signalDOMEvent(cm, e) || display.activeTouch && display.input.supportsTouch()) return;
        display.input.ensurePolled();
        display.shift = e.shiftKey;
        if (eventInWidget(display, e)) {
            if (!webkit) {
                // Briefly turn off draggability, to allow widgets to do
                // normal dragging things.
                display.scroller.draggable = false;
                setTimeout(function() {
                    return display.scroller.draggable = true;
                }, 100);
            }
            return;
        }
        if (clickInGutter(cm, e)) return;
        var pos = posFromMouse(cm, e), button = e_button(e), repeat = pos ? clickRepeat(pos, button) : "single";
        window.focus();
        // #3261: make sure, that we're not starting a second selection
        if (button == 1 && cm.state.selectingText) cm.state.selectingText(e);
        if (pos && handleMappedButton(cm, button, pos, repeat, e)) return;
        if (button == 1) {
            if (pos) leftButtonDown(cm, pos, repeat, e);
            else if (e_target(e) == display.scroller) e_preventDefault(e);
        } else if (button == 2) {
            if (pos) extendSelection(cm.doc, pos);
            setTimeout(function() {
                return display.input.focus();
            }, 20);
        } else if (button == 3) {
            if (captureRightClick) cm.display.input.onContextMenu(e);
            else delayBlurEvent(cm);
        }
    }
    function handleMappedButton(cm, button, pos, repeat, event) {
        var name = "Click";
        if (repeat == "double") name = "Double" + name;
        else if (repeat == "triple") name = "Triple" + name;
        name = (button == 1 ? "Left" : button == 2 ? "Middle" : "Right") + name;
        return dispatchKey(cm, addModifierNames(name, event), event, function(bound) {
            if (typeof bound == "string") bound = commands[bound];
            if (!bound) return false;
            var done = false;
            try {
                if (cm.isReadOnly()) cm.state.suppressEdits = true;
                done = bound(cm, pos) != Pass;
            } finally{
                cm.state.suppressEdits = false;
            }
            return done;
        });
    }
    function configureMouse(cm, repeat, event) {
        var option = cm.getOption("configureMouse");
        var value = option ? option(cm, repeat, event) : {};
        if (value.unit == null) {
            var rect = chromeOS ? event.shiftKey && event.metaKey : event.altKey;
            value.unit = rect ? "rectangle" : repeat == "single" ? "char" : repeat == "double" ? "word" : "line";
        }
        if (value.extend == null || cm.doc.extend) value.extend = cm.doc.extend || event.shiftKey;
        if (value.addNew == null) value.addNew = mac ? event.metaKey : event.ctrlKey;
        if (value.moveOnDrag == null) value.moveOnDrag = !(mac ? event.altKey : event.ctrlKey);
        return value;
    }
    function leftButtonDown(cm, pos, repeat, event) {
        if (ie) setTimeout(bind(ensureFocus, cm), 0);
        else cm.curOp.focus = activeElt();
        var behavior = configureMouse(cm, repeat, event);
        var sel = cm.doc.sel, contained;
        if (cm.options.dragDrop && dragAndDrop && !cm.isReadOnly() && repeat == "single" && (contained = sel.contains(pos)) > -1 && (cmp((contained = sel.ranges[contained]).from(), pos) < 0 || pos.xRel > 0) && (cmp(contained.to(), pos) > 0 || pos.xRel < 0)) leftButtonStartDrag(cm, event, pos, behavior);
        else leftButtonSelect(cm, event, pos, behavior);
    }
    // Start a text drag. When it ends, see if any dragging actually
    // happen, and treat as a click if it didn't.
    function leftButtonStartDrag(cm, event, pos, behavior) {
        var display = cm.display, moved = false;
        var dragEnd = operation(cm, function(e) {
            if (webkit) display.scroller.draggable = false;
            cm.state.draggingText = false;
            off(display.wrapper.ownerDocument, "mouseup", dragEnd);
            off(display.wrapper.ownerDocument, "mousemove", mouseMove);
            off(display.scroller, "dragstart", dragStart);
            off(display.scroller, "drop", dragEnd);
            if (!moved) {
                e_preventDefault(e);
                if (!behavior.addNew) extendSelection(cm.doc, pos, null, null, behavior.extend);
                // Work around unexplainable focus problem in IE9 (#2127) and Chrome (#3081)
                if (webkit || ie && ie_version == 9) setTimeout(function() {
                    display.wrapper.ownerDocument.body.focus();
                    display.input.focus();
                }, 20);
                else display.input.focus();
            }
        });
        var mouseMove = function(e2) {
            moved = moved || Math.abs(event.clientX - e2.clientX) + Math.abs(event.clientY - e2.clientY) >= 10;
        };
        var dragStart = function() {
            return moved = true;
        };
        // Let the drag handler handle this.
        if (webkit) display.scroller.draggable = true;
        cm.state.draggingText = dragEnd;
        dragEnd.copy = !behavior.moveOnDrag;
        // IE's approach to draggable
        if (display.scroller.dragDrop) display.scroller.dragDrop();
        on(display.wrapper.ownerDocument, "mouseup", dragEnd);
        on(display.wrapper.ownerDocument, "mousemove", mouseMove);
        on(display.scroller, "dragstart", dragStart);
        on(display.scroller, "drop", dragEnd);
        delayBlurEvent(cm);
        setTimeout(function() {
            return display.input.focus();
        }, 20);
    }
    function rangeForUnit(cm, pos, unit) {
        if (unit == "char") return new Range(pos, pos);
        if (unit == "word") return cm.findWordAt(pos);
        if (unit == "line") return new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
        var result = unit(cm, pos);
        return new Range(result.from, result.to);
    }
    // Normal selection, as opposed to text dragging.
    function leftButtonSelect(cm, event, start, behavior) {
        var display = cm.display, doc = cm.doc;
        e_preventDefault(event);
        var ourRange, ourIndex, startSel = doc.sel, ranges = startSel.ranges;
        if (behavior.addNew && !behavior.extend) {
            ourIndex = doc.sel.contains(start);
            if (ourIndex > -1) ourRange = ranges[ourIndex];
            else ourRange = new Range(start, start);
        } else {
            ourRange = doc.sel.primary();
            ourIndex = doc.sel.primIndex;
        }
        if (behavior.unit == "rectangle") {
            if (!behavior.addNew) ourRange = new Range(start, start);
            start = posFromMouse(cm, event, true, true);
            ourIndex = -1;
        } else {
            var range$$1 = rangeForUnit(cm, start, behavior.unit);
            if (behavior.extend) ourRange = extendRange(ourRange, range$$1.anchor, range$$1.head, behavior.extend);
            else ourRange = range$$1;
        }
        if (!behavior.addNew) {
            ourIndex = 0;
            setSelection(doc, new Selection([
                ourRange
            ], 0), sel_mouse);
            startSel = doc.sel;
        } else if (ourIndex == -1) {
            ourIndex = ranges.length;
            setSelection(doc, normalizeSelection(cm, ranges.concat([
                ourRange
            ]), ourIndex), {
                scroll: false,
                origin: "*mouse"
            });
        } else if (ranges.length > 1 && ranges[ourIndex].empty() && behavior.unit == "char" && !behavior.extend) {
            setSelection(doc, normalizeSelection(cm, ranges.slice(0, ourIndex).concat(ranges.slice(ourIndex + 1)), 0), {
                scroll: false,
                origin: "*mouse"
            });
            startSel = doc.sel;
        } else replaceOneSelection(doc, ourIndex, ourRange, sel_mouse);
        var lastPos = start;
        function extendTo(pos) {
            if (cmp(lastPos, pos) == 0) return;
            lastPos = pos;
            if (behavior.unit == "rectangle") {
                var ranges = [], tabSize = cm.options.tabSize;
                var startCol = countColumn(getLine(doc, start.line).text, start.ch, tabSize);
                var posCol = countColumn(getLine(doc, pos.line).text, pos.ch, tabSize);
                var left = Math.min(startCol, posCol), right = Math.max(startCol, posCol);
                for(var line = Math.min(start.line, pos.line), end = Math.min(cm.lastLine(), Math.max(start.line, pos.line)); line <= end; line++){
                    var text = getLine(doc, line).text, leftPos = findColumn(text, left, tabSize);
                    if (left == right) ranges.push(new Range(Pos(line, leftPos), Pos(line, leftPos)));
                    else if (text.length > leftPos) ranges.push(new Range(Pos(line, leftPos), Pos(line, findColumn(text, right, tabSize))));
                }
                if (!ranges.length) ranges.push(new Range(start, start));
                setSelection(doc, normalizeSelection(cm, startSel.ranges.slice(0, ourIndex).concat(ranges), ourIndex), {
                    origin: "*mouse",
                    scroll: false
                });
                cm.scrollIntoView(pos);
            } else {
                var oldRange = ourRange;
                var range$$1 = rangeForUnit(cm, pos, behavior.unit);
                var anchor = oldRange.anchor, head;
                if (cmp(range$$1.anchor, anchor) > 0) {
                    head = range$$1.head;
                    anchor = minPos(oldRange.from(), range$$1.anchor);
                } else {
                    head = range$$1.anchor;
                    anchor = maxPos(oldRange.to(), range$$1.head);
                }
                var ranges$1 = startSel.ranges.slice(0);
                ranges$1[ourIndex] = bidiSimplify(cm, new Range(clipPos(doc, anchor), head));
                setSelection(doc, normalizeSelection(cm, ranges$1, ourIndex), sel_mouse);
            }
        }
        var editorSize = display.wrapper.getBoundingClientRect();
        // Used to ensure timeout re-tries don't fire when another extend
        // happened in the meantime (clearTimeout isn't reliable -- at
        // least on Chrome, the timeouts still happen even when cleared,
        // if the clear happens after their scheduled firing time).
        var counter = 0;
        function extend(e) {
            var curCount = ++counter;
            var cur = posFromMouse(cm, e, true, behavior.unit == "rectangle");
            if (!cur) return;
            if (cmp(cur, lastPos) != 0) {
                cm.curOp.focus = activeElt();
                extendTo(cur);
                var visible = visibleLines(display, doc);
                if (cur.line >= visible.to || cur.line < visible.from) setTimeout(operation(cm, function() {
                    if (counter == curCount) extend(e);
                }), 150);
            } else {
                var outside = e.clientY < editorSize.top ? -20 : e.clientY > editorSize.bottom ? 20 : 0;
                if (outside) setTimeout(operation(cm, function() {
                    if (counter != curCount) return;
                    display.scroller.scrollTop += outside;
                    extend(e);
                }), 50);
            }
        }
        function done(e) {
            cm.state.selectingText = false;
            counter = Infinity;
            // If e is null or undefined we interpret this as someone trying
            // to explicitly cancel the selection rather than the user
            // letting go of the mouse button.
            if (e) {
                e_preventDefault(e);
                display.input.focus();
            }
            off(display.wrapper.ownerDocument, "mousemove", move);
            off(display.wrapper.ownerDocument, "mouseup", up);
            doc.history.lastSelOrigin = null;
        }
        var move = operation(cm, function(e) {
            if (e.buttons === 0 || !e_button(e)) done(e);
            else extend(e);
        });
        var up = operation(cm, done);
        cm.state.selectingText = up;
        on(display.wrapper.ownerDocument, "mousemove", move);
        on(display.wrapper.ownerDocument, "mouseup", up);
    }
    // Used when mouse-selecting to adjust the anchor to the proper side
    // of a bidi jump depending on the visual position of the head.
    function bidiSimplify(cm, range$$1) {
        var anchor = range$$1.anchor;
        var head = range$$1.head;
        var anchorLine = getLine(cm.doc, anchor.line);
        if (cmp(anchor, head) == 0 && anchor.sticky == head.sticky) return range$$1;
        var order = getOrder(anchorLine);
        if (!order) return range$$1;
        var index = getBidiPartAt(order, anchor.ch, anchor.sticky), part = order[index];
        if (part.from != anchor.ch && part.to != anchor.ch) return range$$1;
        var boundary = index + (part.from == anchor.ch == (part.level != 1) ? 0 : 1);
        if (boundary == 0 || boundary == order.length) return range$$1;
        // Compute the relative visual position of the head compared to the
        // anchor (<0 is to the left, >0 to the right)
        var leftSide;
        if (head.line != anchor.line) leftSide = (head.line - anchor.line) * (cm.doc.direction == "ltr" ? 1 : -1) > 0;
        else {
            var headIndex = getBidiPartAt(order, head.ch, head.sticky);
            var dir = headIndex - index || (head.ch - anchor.ch) * (part.level == 1 ? -1 : 1);
            if (headIndex == boundary - 1 || headIndex == boundary) leftSide = dir < 0;
            else leftSide = dir > 0;
        }
        var usePart = order[boundary + (leftSide ? -1 : 0)];
        var from = leftSide == (usePart.level == 1);
        var ch = from ? usePart.from : usePart.to, sticky = from ? "after" : "before";
        return anchor.ch == ch && anchor.sticky == sticky ? range$$1 : new Range(new Pos(anchor.line, ch, sticky), head);
    }
    // Determines whether an event happened in the gutter, and fires the
    // handlers for the corresponding event.
    function gutterEvent(cm, e, type, prevent) {
        var mX, mY;
        if (e.touches) {
            mX = e.touches[0].clientX;
            mY = e.touches[0].clientY;
        } else try {
            mX = e.clientX;
            mY = e.clientY;
        } catch (e) {
            return false;
        }
        if (mX >= Math.floor(cm.display.gutters.getBoundingClientRect().right)) return false;
        if (prevent) e_preventDefault(e);
        var display = cm.display;
        var lineBox = display.lineDiv.getBoundingClientRect();
        if (mY > lineBox.bottom || !hasHandler(cm, type)) return e_defaultPrevented(e);
        mY -= lineBox.top - display.viewOffset;
        for(var i = 0; i < cm.display.gutterSpecs.length; ++i){
            var g = display.gutters.childNodes[i];
            if (g && g.getBoundingClientRect().right >= mX) {
                var line = lineAtHeight(cm.doc, mY);
                var gutter = cm.display.gutterSpecs[i];
                signal(cm, type, cm, line, gutter.className, e);
                return e_defaultPrevented(e);
            }
        }
    }
    function clickInGutter(cm, e) {
        return gutterEvent(cm, e, "gutterClick", true);
    }
    // CONTEXT MENU HANDLING
    // To make the context menu work, we need to briefly unhide the
    // textarea (making it as unobtrusive as possible) to let the
    // right-click take effect on it.
    function onContextMenu(cm, e) {
        if (eventInWidget(cm.display, e) || contextMenuInGutter(cm, e)) return;
        if (signalDOMEvent(cm, e, "contextmenu")) return;
        if (!captureRightClick) cm.display.input.onContextMenu(e);
    }
    function contextMenuInGutter(cm, e) {
        if (!hasHandler(cm, "gutterContextMenu")) return false;
        return gutterEvent(cm, e, "gutterContextMenu", false);
    }
    function themeChanged(cm) {
        cm.display.wrapper.className = cm.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + cm.options.theme.replace(/(^|\s)\s*/g, " cm-s-");
        clearCaches(cm);
    }
    var Init = {
        toString: function() {
            return "CodeMirror.Init";
        }
    };
    var defaults = {};
    var optionHandlers = {};
    function defineOptions(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        function option(name, deflt, handle, notOnInit) {
            CodeMirror.defaults[name] = deflt;
            if (handle) optionHandlers[name] = notOnInit ? function(cm, val, old) {
                if (old != Init) handle(cm, val, old);
            } : handle;
        }
        CodeMirror.defineOption = option;
        // Passed to option handlers when there is no old value.
        CodeMirror.Init = Init;
        // These two are, on init, called from the constructor because they
        // have to be initialized before the editor can start at all.
        option("value", "", function(cm, val) {
            return cm.setValue(val);
        }, true);
        option("mode", null, function(cm, val) {
            cm.doc.modeOption = val;
            loadMode(cm);
        }, true);
        option("indentUnit", 2, loadMode, true);
        option("indentWithTabs", false);
        option("smartIndent", true);
        option("tabSize", 4, function(cm) {
            resetModeState(cm);
            clearCaches(cm);
            regChange(cm);
        }, true);
        option("lineSeparator", null, function(cm, val) {
            cm.doc.lineSep = val;
            if (!val) return;
            var newBreaks = [], lineNo = cm.doc.first;
            cm.doc.iter(function(line) {
                for(var pos = 0;;){
                    var found = line.text.indexOf(val, pos);
                    if (found == -1) break;
                    pos = found + val.length;
                    newBreaks.push(Pos(lineNo, found));
                }
                lineNo++;
            });
            for(var i = newBreaks.length - 1; i >= 0; i--)replaceRange(cm.doc, val, newBreaks[i], Pos(newBreaks[i].line, newBreaks[i].ch + val.length));
        });
        option("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function(cm, val, old) {
            cm.state.specialChars = new RegExp(val.source + (val.test("	") ? "" : "|	"), "g");
            if (old != Init) cm.refresh();
        });
        option("specialCharPlaceholder", defaultSpecialCharPlaceholder, function(cm) {
            return cm.refresh();
        }, true);
        option("electricChars", true);
        option("inputStyle", mobile ? "contenteditable" : "textarea", function() {
            throw new Error("inputStyle can not (yet) be changed in a running editor") // FIXME
            ;
        }, true);
        option("spellcheck", false, function(cm, val) {
            return cm.getInputField().spellcheck = val;
        }, true);
        option("autocorrect", false, function(cm, val) {
            return cm.getInputField().autocorrect = val;
        }, true);
        option("autocapitalize", false, function(cm, val) {
            return cm.getInputField().autocapitalize = val;
        }, true);
        option("rtlMoveVisually", !windows);
        option("wholeLineUpdateBefore", true);
        option("theme", "default", function(cm) {
            themeChanged(cm);
            updateGutters(cm);
        }, true);
        option("keyMap", "default", function(cm, val, old) {
            var next = getKeyMap(val);
            var prev = old != Init && getKeyMap(old);
            if (prev && prev.detach) prev.detach(cm, next);
            if (next.attach) next.attach(cm, prev || null);
        });
        option("extraKeys", null);
        option("configureMouse", null);
        option("lineWrapping", false, wrappingChanged, true);
        option("gutters", [], function(cm, val) {
            cm.display.gutterSpecs = getGutters(val, cm.options.lineNumbers);
            updateGutters(cm);
        }, true);
        option("fixedGutter", true, function(cm, val) {
            cm.display.gutters.style.left = val ? compensateForHScroll(cm.display) + "px" : "0";
            cm.refresh();
        }, true);
        option("coverGutterNextToScrollbar", false, function(cm) {
            return updateScrollbars(cm);
        }, true);
        option("scrollbarStyle", "native", function(cm) {
            initScrollbars(cm);
            updateScrollbars(cm);
            cm.display.scrollbars.setScrollTop(cm.doc.scrollTop);
            cm.display.scrollbars.setScrollLeft(cm.doc.scrollLeft);
        }, true);
        option("lineNumbers", false, function(cm, val) {
            cm.display.gutterSpecs = getGutters(cm.options.gutters, val);
            updateGutters(cm);
        }, true);
        option("firstLineNumber", 1, updateGutters, true);
        option("lineNumberFormatter", function(integer) {
            return integer;
        }, updateGutters, true);
        option("showCursorWhenSelecting", false, updateSelection, true);
        option("resetSelectionOnContextMenu", true);
        option("lineWiseCopyCut", true);
        option("pasteLinesPerSelection", true);
        option("selectionsMayTouch", false);
        option("readOnly", false, function(cm, val) {
            if (val == "nocursor") {
                onBlur(cm);
                cm.display.input.blur();
            }
            cm.display.input.readOnlyChanged(val);
        });
        option("disableInput", false, function(cm, val) {
            if (!val) cm.display.input.reset();
        }, true);
        option("dragDrop", true, dragDropChanged);
        option("allowDropFileTypes", null);
        option("cursorBlinkRate", 530);
        option("cursorScrollMargin", 0);
        option("cursorHeight", 1, updateSelection, true);
        option("singleCursorHeightPerLine", true, updateSelection, true);
        option("workTime", 100);
        option("workDelay", 100);
        option("flattenSpans", true, resetModeState, true);
        option("addModeClass", false, resetModeState, true);
        option("pollInterval", 100);
        option("undoDepth", 200, function(cm, val) {
            return cm.doc.history.undoDepth = val;
        });
        option("historyEventDelay", 1250);
        option("viewportMargin", 10, function(cm) {
            return cm.refresh();
        }, true);
        option("maxHighlightLength", 10000, resetModeState, true);
        option("moveInputWithCursor", true, function(cm, val) {
            if (!val) cm.display.input.resetPosition();
        });
        option("tabindex", null, function(cm, val) {
            return cm.display.input.getField().tabIndex = val || "";
        });
        option("autofocus", null);
        option("direction", "ltr", function(cm, val) {
            return cm.doc.setDirection(val);
        }, true);
        option("phrases", null);
    }
    function dragDropChanged(cm, value, old) {
        var wasOn = old && old != Init;
        if (!value != !wasOn) {
            var funcs = cm.display.dragFunctions;
            var toggle = value ? on : off;
            toggle(cm.display.scroller, "dragstart", funcs.start);
            toggle(cm.display.scroller, "dragenter", funcs.enter);
            toggle(cm.display.scroller, "dragover", funcs.over);
            toggle(cm.display.scroller, "dragleave", funcs.leave);
            toggle(cm.display.scroller, "drop", funcs.drop);
        }
    }
    function wrappingChanged(cm) {
        if (cm.options.lineWrapping) {
            addClass(cm.display.wrapper, "CodeMirror-wrap");
            cm.display.sizer.style.minWidth = "";
            cm.display.sizerWidth = null;
        } else {
            rmClass(cm.display.wrapper, "CodeMirror-wrap");
            findMaxLine(cm);
        }
        estimateLineHeights(cm);
        regChange(cm);
        clearCaches(cm);
        setTimeout(function() {
            return updateScrollbars(cm);
        }, 100);
    }
    // A CodeMirror instance represents an editor. This is the object
    // that user code is usually dealing with.
    function CodeMirror(place, options) {
        var this$1 = this;
        if (!(this instanceof CodeMirror)) return new CodeMirror(place, options);
        this.options = options = options ? copyObj(options) : {};
        // Determine effective options based on given values and defaults.
        copyObj(defaults, options, false);
        var doc = options.value;
        if (typeof doc == "string") doc = new Doc(doc, options.mode, null, options.lineSeparator, options.direction);
        else if (options.mode) doc.modeOption = options.mode;
        this.doc = doc;
        var input = new CodeMirror.inputStyles[options.inputStyle](this);
        var display = this.display = new Display(place, doc, input, options);
        display.wrapper.CodeMirror = this;
        themeChanged(this);
        if (options.lineWrapping) this.display.wrapper.className += " CodeMirror-wrap";
        initScrollbars(this);
        this.state = {
            keyMaps: [],
            overlays: [],
            modeGen: 0,
            overwrite: false,
            delayingBlurEvent: false,
            focused: false,
            suppressEdits: false,
            pasteIncoming: -1,
            cutIncoming: -1,
            selectingText: false,
            draggingText: false,
            highlight: new Delayed(),
            keySeq: null,
            specialChars: null
        };
        if (options.autofocus && !mobile) display.input.focus();
        // Override magic textarea content restore that IE sometimes does
        // on our hidden textarea on reload
        if (ie && ie_version < 11) setTimeout(function() {
            return this$1.display.input.reset(true);
        }, 20);
        registerEventHandlers(this);
        ensureGlobalHandlers();
        startOperation(this);
        this.curOp.forceUpdate = true;
        attachDoc(this, doc);
        if (options.autofocus && !mobile || this.hasFocus()) setTimeout(bind(onFocus, this), 20);
        else onBlur(this);
        for(var opt in optionHandlers)if (optionHandlers.hasOwnProperty(opt)) optionHandlers[opt](this$1, options[opt], Init);
        maybeUpdateLineNumberWidth(this);
        if (options.finishInit) options.finishInit(this);
        for(var i = 0; i < initHooks.length; ++i)initHooks[i](this$1);
        endOperation(this);
        // Suppress optimizelegibility in Webkit, since it breaks text
        // measuring on line wrapping boundaries.
        if (webkit && options.lineWrapping && getComputedStyle(display.lineDiv).textRendering == "optimizelegibility") display.lineDiv.style.textRendering = "auto";
    }
    // The default configuration options.
    CodeMirror.defaults = defaults;
    // Functions to run when options are changed.
    CodeMirror.optionHandlers = optionHandlers;
    // Attach the necessary event handlers when initializing the editor
    function registerEventHandlers(cm) {
        var d = cm.display;
        on(d.scroller, "mousedown", operation(cm, onMouseDown));
        // Older IE's will not fire a second mousedown for a double click
        if (ie && ie_version < 11) on(d.scroller, "dblclick", operation(cm, function(e) {
            if (signalDOMEvent(cm, e)) return;
            var pos = posFromMouse(cm, e);
            if (!pos || clickInGutter(cm, e) || eventInWidget(cm.display, e)) return;
            e_preventDefault(e);
            var word = cm.findWordAt(pos);
            extendSelection(cm.doc, word.anchor, word.head);
        }));
        else on(d.scroller, "dblclick", function(e) {
            return signalDOMEvent(cm, e) || e_preventDefault(e);
        });
        // Some browsers fire contextmenu *after* opening the menu, at
        // which point we can't mess with it anymore. Context menu is
        // handled in onMouseDown for these browsers.
        on(d.scroller, "contextmenu", function(e) {
            return onContextMenu(cm, e);
        });
        // Used to suppress mouse event handling when a touch happens
        var touchFinished, prevTouch = {
            end: 0
        };
        function finishTouch() {
            if (d.activeTouch) {
                touchFinished = setTimeout(function() {
                    return d.activeTouch = null;
                }, 1000);
                prevTouch = d.activeTouch;
                prevTouch.end = +new Date;
            }
        }
        function isMouseLikeTouchEvent(e) {
            if (e.touches.length != 1) return false;
            var touch = e.touches[0];
            return touch.radiusX <= 1 && touch.radiusY <= 1;
        }
        function farAway(touch, other) {
            if (other.left == null) return true;
            var dx = other.left - touch.left, dy = other.top - touch.top;
            return dx * dx + dy * dy > 400;
        }
        on(d.scroller, "touchstart", function(e) {
            if (!signalDOMEvent(cm, e) && !isMouseLikeTouchEvent(e) && !clickInGutter(cm, e)) {
                d.input.ensurePolled();
                clearTimeout(touchFinished);
                var now = +new Date;
                d.activeTouch = {
                    start: now,
                    moved: false,
                    prev: now - prevTouch.end <= 300 ? prevTouch : null
                };
                if (e.touches.length == 1) {
                    d.activeTouch.left = e.touches[0].pageX;
                    d.activeTouch.top = e.touches[0].pageY;
                }
            }
        });
        on(d.scroller, "touchmove", function() {
            if (d.activeTouch) d.activeTouch.moved = true;
        });
        on(d.scroller, "touchend", function(e) {
            var touch = d.activeTouch;
            if (touch && !eventInWidget(d, e) && touch.left != null && !touch.moved && new Date - touch.start < 300) {
                var pos = cm.coordsChar(d.activeTouch, "page"), range;
                if (!touch.prev || farAway(touch, touch.prev)) range = new Range(pos, pos);
                else if (!touch.prev.prev || farAway(touch, touch.prev.prev)) range = cm.findWordAt(pos);
                else range = new Range(Pos(pos.line, 0), clipPos(cm.doc, Pos(pos.line + 1, 0)));
                cm.setSelection(range.anchor, range.head);
                cm.focus();
                e_preventDefault(e);
            }
            finishTouch();
        });
        on(d.scroller, "touchcancel", finishTouch);
        // Sync scrolling between fake scrollbars and real scrollable
        // area, ensure viewport is updated when scrolling.
        on(d.scroller, "scroll", function() {
            if (d.scroller.clientHeight) {
                updateScrollTop(cm, d.scroller.scrollTop);
                setScrollLeft(cm, d.scroller.scrollLeft, true);
                signal(cm, "scroll", cm);
            }
        });
        // Listen to wheel events in order to try and update the viewport on time.
        on(d.scroller, "mousewheel", function(e) {
            return onScrollWheel(cm, e);
        });
        on(d.scroller, "DOMMouseScroll", function(e) {
            return onScrollWheel(cm, e);
        });
        // Prevent wrapper from ever scrolling
        on(d.wrapper, "scroll", function() {
            return d.wrapper.scrollTop = d.wrapper.scrollLeft = 0;
        });
        d.dragFunctions = {
            enter: function(e) {
                if (!signalDOMEvent(cm, e)) e_stop(e);
            },
            over: function(e) {
                if (!signalDOMEvent(cm, e)) {
                    onDragOver(cm, e);
                    e_stop(e);
                }
            },
            start: function(e) {
                return onDragStart(cm, e);
            },
            drop: operation(cm, onDrop),
            leave: function(e) {
                if (!signalDOMEvent(cm, e)) clearDragCursor(cm);
            }
        };
        var inp = d.input.getField();
        on(inp, "keyup", function(e) {
            return onKeyUp.call(cm, e);
        });
        on(inp, "keydown", operation(cm, onKeyDown));
        on(inp, "keypress", operation(cm, onKeyPress));
        on(inp, "focus", function(e) {
            return onFocus(cm, e);
        });
        on(inp, "blur", function(e) {
            return onBlur(cm, e);
        });
    }
    var initHooks = [];
    CodeMirror.defineInitHook = function(f) {
        return initHooks.push(f);
    };
    // Indent the given line. The how parameter can be "smart",
    // "add"/null, "subtract", or "prev". When aggressive is false
    // (typically set to true for forced single-line indents), empty
    // lines are not indented, and places where the mode returns Pass
    // are left alone.
    function indentLine(cm, n, how, aggressive) {
        var doc = cm.doc, state;
        if (how == null) how = "add";
        if (how == "smart") {
            // Fall back to "prev" when the mode doesn't have an indentation
            // method.
            if (!doc.mode.indent) how = "prev";
            else state = getContextBefore(cm, n).state;
        }
        var tabSize = cm.options.tabSize;
        var line = getLine(doc, n), curSpace = countColumn(line.text, null, tabSize);
        if (line.stateAfter) line.stateAfter = null;
        var curSpaceString = line.text.match(/^\s*/)[0], indentation;
        if (!aggressive && !/\S/.test(line.text)) {
            indentation = 0;
            how = "not";
        } else if (how == "smart") {
            indentation = doc.mode.indent(state, line.text.slice(curSpaceString.length), line.text);
            if (indentation == Pass || indentation > 150) {
                if (!aggressive) return;
                how = "prev";
            }
        }
        if (how == "prev") {
            if (n > doc.first) indentation = countColumn(getLine(doc, n - 1).text, null, tabSize);
            else indentation = 0;
        } else if (how == "add") indentation = curSpace + cm.options.indentUnit;
        else if (how == "subtract") indentation = curSpace - cm.options.indentUnit;
        else if (typeof how == "number") indentation = curSpace + how;
        indentation = Math.max(0, indentation);
        var indentString = "", pos = 0;
        if (cm.options.indentWithTabs) for(var i = Math.floor(indentation / tabSize); i; --i){
            pos += tabSize;
            indentString += "	";
        }
        if (pos < indentation) indentString += spaceStr(indentation - pos);
        if (indentString != curSpaceString) {
            replaceRange(doc, indentString, Pos(n, 0), Pos(n, curSpaceString.length), "+input");
            line.stateAfter = null;
            return true;
        } else // Ensure that, if the cursor was in the whitespace at the start
        // of the line, it is moved to the end of that space.
        for(var i$1 = 0; i$1 < doc.sel.ranges.length; i$1++){
            var range = doc.sel.ranges[i$1];
            if (range.head.line == n && range.head.ch < curSpaceString.length) {
                var pos$1 = Pos(n, curSpaceString.length);
                replaceOneSelection(doc, i$1, new Range(pos$1, pos$1));
                break;
            }
        }
    }
    // This will be set to a {lineWise: bool, text: [string]} object, so
    // that, when pasting, we know what kind of selections the copied
    // text was made out of.
    var lastCopied = null;
    function setLastCopied(newLastCopied) {
        lastCopied = newLastCopied;
    }
    function applyTextInput(cm, inserted, deleted, sel, origin) {
        var doc = cm.doc;
        cm.display.shift = false;
        if (!sel) sel = doc.sel;
        var recent = +new Date - 200;
        var paste = origin == "paste" || cm.state.pasteIncoming > recent;
        var textLines = splitLinesAuto(inserted), multiPaste = null;
        // When pasting N lines into N selections, insert one line per selection
        if (paste && sel.ranges.length > 1) {
            if (lastCopied && lastCopied.text.join("\n") == inserted) {
                if (sel.ranges.length % lastCopied.text.length == 0) {
                    multiPaste = [];
                    for(var i = 0; i < lastCopied.text.length; i++)multiPaste.push(doc.splitLines(lastCopied.text[i]));
                }
            } else if (textLines.length == sel.ranges.length && cm.options.pasteLinesPerSelection) multiPaste = map(textLines, function(l) {
                return [
                    l
                ];
            });
        }
        var updateInput = cm.curOp.updateInput;
        // Normal behavior is to insert the new text into every selection
        for(var i$1 = sel.ranges.length - 1; i$1 >= 0; i$1--){
            var range$$1 = sel.ranges[i$1];
            var from = range$$1.from(), to = range$$1.to();
            if (range$$1.empty()) {
                if (deleted && deleted > 0) from = Pos(from.line, from.ch - deleted);
                else if (cm.state.overwrite && !paste) to = Pos(to.line, Math.min(getLine(doc, to.line).text.length, to.ch + lst(textLines).length));
                else if (paste && lastCopied && lastCopied.lineWise && lastCopied.text.join("\n") == inserted) from = to = Pos(from.line, 0);
            }
            var changeEvent = {
                from: from,
                to: to,
                text: multiPaste ? multiPaste[i$1 % multiPaste.length] : textLines,
                origin: origin || (paste ? "paste" : cm.state.cutIncoming > recent ? "cut" : "+input")
            };
            makeChange(cm.doc, changeEvent);
            signalLater(cm, "inputRead", cm, changeEvent);
        }
        if (inserted && !paste) triggerElectric(cm, inserted);
        ensureCursorVisible(cm);
        if (cm.curOp.updateInput < 2) cm.curOp.updateInput = updateInput;
        cm.curOp.typing = true;
        cm.state.pasteIncoming = cm.state.cutIncoming = -1;
    }
    function handlePaste(e, cm) {
        var pasted = e.clipboardData && e.clipboardData.getData("Text");
        if (pasted) {
            e.preventDefault();
            if (!cm.isReadOnly() && !cm.options.disableInput) runInOp(cm, function() {
                return applyTextInput(cm, pasted, 0, null, "paste");
            });
            return true;
        }
    }
    function triggerElectric(cm, inserted) {
        // When an 'electric' character is inserted, immediately trigger a reindent
        if (!cm.options.electricChars || !cm.options.smartIndent) return;
        var sel = cm.doc.sel;
        for(var i = sel.ranges.length - 1; i >= 0; i--){
            var range$$1 = sel.ranges[i];
            if (range$$1.head.ch > 100 || i && sel.ranges[i - 1].head.line == range$$1.head.line) continue;
            var mode = cm.getModeAt(range$$1.head);
            var indented = false;
            if (mode.electricChars) {
                for(var j = 0; j < mode.electricChars.length; j++)if (inserted.indexOf(mode.electricChars.charAt(j)) > -1) {
                    indented = indentLine(cm, range$$1.head.line, "smart");
                    break;
                }
            } else if (mode.electricInput) {
                if (mode.electricInput.test(getLine(cm.doc, range$$1.head.line).text.slice(0, range$$1.head.ch))) indented = indentLine(cm, range$$1.head.line, "smart");
            }
            if (indented) signalLater(cm, "electricInput", cm, range$$1.head.line);
        }
    }
    function copyableRanges(cm) {
        var text = [], ranges = [];
        for(var i = 0; i < cm.doc.sel.ranges.length; i++){
            var line = cm.doc.sel.ranges[i].head.line;
            var lineRange = {
                anchor: Pos(line, 0),
                head: Pos(line + 1, 0)
            };
            ranges.push(lineRange);
            text.push(cm.getRange(lineRange.anchor, lineRange.head));
        }
        return {
            text: text,
            ranges: ranges
        };
    }
    function disableBrowserMagic(field, spellcheck, autocorrect, autocapitalize) {
        field.setAttribute("autocorrect", autocorrect ? "" : "off");
        field.setAttribute("autocapitalize", autocapitalize ? "" : "off");
        field.setAttribute("spellcheck", !!spellcheck);
    }
    function hiddenTextarea() {
        var te = elt("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none");
        var div = elt("div", [
            te
        ], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
        // The textarea is kept positioned near the cursor to prevent the
        // fact that it'll be scrolled into view on input from scrolling
        // our fake cursor out of view. On webkit, when wrap=off, paste is
        // very slow. So make the area wide instead.
        if (webkit) te.style.width = "1000px";
        else te.setAttribute("wrap", "off");
        // If border: 0; -- iOS fails to open keyboard (issue #1287)
        if (ios) te.style.border = "1px solid black";
        disableBrowserMagic(te);
        return div;
    }
    // The publicly visible API. Note that methodOp(f) means
    // 'wrap f in an operation, performed on its `this` parameter'.
    // This is not the complete set of editor methods. Most of the
    // methods defined on the Doc type are also injected into
    // CodeMirror.prototype, for backwards compatibility and
    // convenience.
    function addEditorMethods(CodeMirror) {
        var optionHandlers = CodeMirror.optionHandlers;
        var helpers = CodeMirror.helpers = {};
        CodeMirror.prototype = {
            constructor: CodeMirror,
            focus: function() {
                window.focus();
                this.display.input.focus();
            },
            setOption: function(option, value) {
                var options = this.options, old = options[option];
                if (options[option] == value && option != "mode") return;
                options[option] = value;
                if (optionHandlers.hasOwnProperty(option)) operation(this, optionHandlers[option])(this, value, old);
                signal(this, "optionChange", this, option);
            },
            getOption: function(option) {
                return this.options[option];
            },
            getDoc: function() {
                return this.doc;
            },
            addKeyMap: function(map$$1, bottom) {
                this.state.keyMaps[bottom ? "push" : "unshift"](getKeyMap(map$$1));
            },
            removeKeyMap: function(map$$1) {
                var maps = this.state.keyMaps;
                for(var i = 0; i < maps.length; ++i)if (maps[i] == map$$1 || maps[i].name == map$$1) {
                    maps.splice(i, 1);
                    return true;
                }
            },
            addOverlay: methodOp(function(spec, options) {
                var mode = spec.token ? spec : CodeMirror.getMode(this.options, spec);
                if (mode.startState) throw new Error("Overlays may not be stateful.");
                insertSorted(this.state.overlays, {
                    mode: mode,
                    modeSpec: spec,
                    opaque: options && options.opaque,
                    priority: options && options.priority || 0
                }, function(overlay) {
                    return overlay.priority;
                });
                this.state.modeGen++;
                regChange(this);
            }),
            removeOverlay: methodOp(function(spec) {
                var this$1 = this;
                var overlays = this.state.overlays;
                for(var i = 0; i < overlays.length; ++i){
                    var cur = overlays[i].modeSpec;
                    if (cur == spec || typeof spec == "string" && cur.name == spec) {
                        overlays.splice(i, 1);
                        this$1.state.modeGen++;
                        regChange(this$1);
                        return;
                    }
                }
            }),
            indentLine: methodOp(function(n, dir, aggressive) {
                if (typeof dir != "string" && typeof dir != "number") {
                    if (dir == null) dir = this.options.smartIndent ? "smart" : "prev";
                    else dir = dir ? "add" : "subtract";
                }
                if (isLine(this.doc, n)) indentLine(this, n, dir, aggressive);
            }),
            indentSelection: methodOp(function(how) {
                var this$1 = this;
                var ranges = this.doc.sel.ranges, end = -1;
                for(var i = 0; i < ranges.length; i++){
                    var range$$1 = ranges[i];
                    if (!range$$1.empty()) {
                        var from = range$$1.from(), to = range$$1.to();
                        var start = Math.max(end, from.line);
                        end = Math.min(this$1.lastLine(), to.line - (to.ch ? 0 : 1)) + 1;
                        for(var j = start; j < end; ++j)indentLine(this$1, j, how);
                        var newRanges = this$1.doc.sel.ranges;
                        if (from.ch == 0 && ranges.length == newRanges.length && newRanges[i].from().ch > 0) replaceOneSelection(this$1.doc, i, new Range(from, newRanges[i].to()), sel_dontScroll);
                    } else if (range$$1.head.line > end) {
                        indentLine(this$1, range$$1.head.line, how, true);
                        end = range$$1.head.line;
                        if (i == this$1.doc.sel.primIndex) ensureCursorVisible(this$1);
                    }
                }
            }),
            // Fetch the parser token for a given character. Useful for hacks
            // that want to inspect the mode state (say, for completion).
            getTokenAt: function(pos, precise) {
                return takeToken(this, pos, precise);
            },
            getLineTokens: function(line, precise) {
                return takeToken(this, Pos(line), precise, true);
            },
            getTokenTypeAt: function(pos) {
                pos = clipPos(this.doc, pos);
                var styles = getLineStyles(this, getLine(this.doc, pos.line));
                var before = 0, after = (styles.length - 1) / 2, ch = pos.ch;
                var type;
                if (ch == 0) type = styles[2];
                else for(;;){
                    var mid = before + after >> 1;
                    if ((mid ? styles[mid * 2 - 1] : 0) >= ch) after = mid;
                    else if (styles[mid * 2 + 1] < ch) before = mid + 1;
                    else {
                        type = styles[mid * 2 + 2];
                        break;
                    }
                }
                var cut = type ? type.indexOf("overlay ") : -1;
                return cut < 0 ? type : cut == 0 ? null : type.slice(0, cut - 1);
            },
            getModeAt: function(pos) {
                var mode = this.doc.mode;
                if (!mode.innerMode) return mode;
                return CodeMirror.innerMode(mode, this.getTokenAt(pos).state).mode;
            },
            getHelper: function(pos, type) {
                return this.getHelpers(pos, type)[0];
            },
            getHelpers: function(pos, type) {
                var this$1 = this;
                var found = [];
                if (!helpers.hasOwnProperty(type)) return found;
                var help = helpers[type], mode = this.getModeAt(pos);
                if (typeof mode[type] == "string") {
                    if (help[mode[type]]) found.push(help[mode[type]]);
                } else if (mode[type]) for(var i = 0; i < mode[type].length; i++){
                    var val = help[mode[type][i]];
                    if (val) found.push(val);
                }
                else if (mode.helperType && help[mode.helperType]) found.push(help[mode.helperType]);
                else if (help[mode.name]) found.push(help[mode.name]);
                for(var i$1 = 0; i$1 < help._global.length; i$1++){
                    var cur = help._global[i$1];
                    if (cur.pred(mode, this$1) && indexOf(found, cur.val) == -1) found.push(cur.val);
                }
                return found;
            },
            getStateAfter: function(line, precise) {
                var doc = this.doc;
                line = clipLine(doc, line == null ? doc.first + doc.size - 1 : line);
                return getContextBefore(this, line + 1, precise).state;
            },
            cursorCoords: function(start, mode) {
                var pos, range$$1 = this.doc.sel.primary();
                if (start == null) pos = range$$1.head;
                else if (typeof start == "object") pos = clipPos(this.doc, start);
                else pos = start ? range$$1.from() : range$$1.to();
                return cursorCoords(this, pos, mode || "page");
            },
            charCoords: function(pos, mode) {
                return charCoords(this, clipPos(this.doc, pos), mode || "page");
            },
            coordsChar: function(coords, mode) {
                coords = fromCoordSystem(this, coords, mode || "page");
                return coordsChar(this, coords.left, coords.top);
            },
            lineAtHeight: function(height, mode) {
                height = fromCoordSystem(this, {
                    top: height,
                    left: 0
                }, mode || "page").top;
                return lineAtHeight(this.doc, height + this.display.viewOffset);
            },
            heightAtLine: function(line, mode, includeWidgets) {
                var end = false, lineObj;
                if (typeof line == "number") {
                    var last = this.doc.first + this.doc.size - 1;
                    if (line < this.doc.first) line = this.doc.first;
                    else if (line > last) {
                        line = last;
                        end = true;
                    }
                    lineObj = getLine(this.doc, line);
                } else lineObj = line;
                return intoCoordSystem(this, lineObj, {
                    top: 0,
                    left: 0
                }, mode || "page", includeWidgets || end).top + (end ? this.doc.height - heightAtLine(lineObj) : 0);
            },
            defaultTextHeight: function() {
                return textHeight(this.display);
            },
            defaultCharWidth: function() {
                return charWidth(this.display);
            },
            getViewport: function() {
                return {
                    from: this.display.viewFrom,
                    to: this.display.viewTo
                };
            },
            addWidget: function(pos, node, scroll, vert, horiz) {
                var display = this.display;
                pos = cursorCoords(this, clipPos(this.doc, pos));
                var top = pos.bottom, left = pos.left;
                node.style.position = "absolute";
                node.setAttribute("cm-ignore-events", "true");
                this.display.input.setUneditable(node);
                display.sizer.appendChild(node);
                if (vert == "over") top = pos.top;
                else if (vert == "above" || vert == "near") {
                    var vspace = Math.max(display.wrapper.clientHeight, this.doc.height), hspace = Math.max(display.sizer.clientWidth, display.lineSpace.clientWidth);
                    // Default to positioning above (if specified and possible); otherwise default to positioning below
                    if ((vert == "above" || pos.bottom + node.offsetHeight > vspace) && pos.top > node.offsetHeight) top = pos.top - node.offsetHeight;
                    else if (pos.bottom + node.offsetHeight <= vspace) top = pos.bottom;
                    if (left + node.offsetWidth > hspace) left = hspace - node.offsetWidth;
                }
                node.style.top = top + "px";
                node.style.left = node.style.right = "";
                if (horiz == "right") {
                    left = display.sizer.clientWidth - node.offsetWidth;
                    node.style.right = "0px";
                } else {
                    if (horiz == "left") left = 0;
                    else if (horiz == "middle") left = (display.sizer.clientWidth - node.offsetWidth) / 2;
                    node.style.left = left + "px";
                }
                if (scroll) scrollIntoView(this, {
                    left: left,
                    top: top,
                    right: left + node.offsetWidth,
                    bottom: top + node.offsetHeight
                });
            },
            triggerOnKeyDown: methodOp(onKeyDown),
            triggerOnKeyPress: methodOp(onKeyPress),
            triggerOnKeyUp: onKeyUp,
            triggerOnMouseDown: methodOp(onMouseDown),
            execCommand: function(cmd) {
                if (commands.hasOwnProperty(cmd)) return commands[cmd].call(null, this);
            },
            triggerElectric: methodOp(function(text) {
                triggerElectric(this, text);
            }),
            findPosH: function(from, amount, unit, visually) {
                var this$1 = this;
                var dir = 1;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    cur = findPosH(this$1.doc, cur, dir, unit, visually);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveH: methodOp(function(dir, unit) {
                var this$1 = this;
                this.extendSelectionsBy(function(range$$1) {
                    if (this$1.display.shift || this$1.doc.extend || range$$1.empty()) return findPosH(this$1.doc, range$$1.head, dir, unit, this$1.options.rtlMoveVisually);
                    else return dir < 0 ? range$$1.from() : range$$1.to();
                }, sel_move);
            }),
            deleteH: methodOp(function(dir, unit) {
                var sel = this.doc.sel, doc = this.doc;
                if (sel.somethingSelected()) doc.replaceSelection("", null, "+delete");
                else deleteNearSelection(this, function(range$$1) {
                    var other = findPosH(doc, range$$1.head, dir, unit, false);
                    return dir < 0 ? {
                        from: other,
                        to: range$$1.head
                    } : {
                        from: range$$1.head,
                        to: other
                    };
                });
            }),
            findPosV: function(from, amount, unit, goalColumn) {
                var this$1 = this;
                var dir = 1, x = goalColumn;
                if (amount < 0) {
                    dir = -1;
                    amount = -amount;
                }
                var cur = clipPos(this.doc, from);
                for(var i = 0; i < amount; ++i){
                    var coords = cursorCoords(this$1, cur, "div");
                    if (x == null) x = coords.left;
                    else coords.left = x;
                    cur = findPosV(this$1, coords, dir, unit);
                    if (cur.hitSide) break;
                }
                return cur;
            },
            moveV: methodOp(function(dir, unit) {
                var this$1 = this;
                var doc = this.doc, goals = [];
                var collapse = !this.display.shift && !doc.extend && doc.sel.somethingSelected();
                doc.extendSelectionsBy(function(range$$1) {
                    if (collapse) return dir < 0 ? range$$1.from() : range$$1.to();
                    var headPos = cursorCoords(this$1, range$$1.head, "div");
                    if (range$$1.goalColumn != null) headPos.left = range$$1.goalColumn;
                    goals.push(headPos.left);
                    var pos = findPosV(this$1, headPos, dir, unit);
                    if (unit == "page" && range$$1 == doc.sel.primary()) addToScrollTop(this$1, charCoords(this$1, pos, "div").top - headPos.top);
                    return pos;
                }, sel_move);
                if (goals.length) for(var i = 0; i < doc.sel.ranges.length; i++)doc.sel.ranges[i].goalColumn = goals[i];
            }),
            // Find the word at the given position (as returned by coordsChar).
            findWordAt: function(pos) {
                var doc = this.doc, line = getLine(doc, pos.line).text;
                var start = pos.ch, end = pos.ch;
                if (line) {
                    var helper = this.getHelper(pos, "wordChars");
                    if ((pos.sticky == "before" || end == line.length) && start) --start;
                    else ++end;
                    var startChar = line.charAt(start);
                    var check = isWordChar(startChar, helper) ? function(ch) {
                        return isWordChar(ch, helper);
                    } : /\s/.test(startChar) ? function(ch) {
                        return /\s/.test(ch);
                    } : function(ch) {
                        return !/\s/.test(ch) && !isWordChar(ch);
                    };
                    while(start > 0 && check(line.charAt(start - 1)))--start;
                    while(end < line.length && check(line.charAt(end)))++end;
                }
                return new Range(Pos(pos.line, start), Pos(pos.line, end));
            },
            toggleOverwrite: function(value) {
                if (value != null && value == this.state.overwrite) return;
                if (this.state.overwrite = !this.state.overwrite) addClass(this.display.cursorDiv, "CodeMirror-overwrite");
                else rmClass(this.display.cursorDiv, "CodeMirror-overwrite");
                signal(this, "overwriteToggle", this, this.state.overwrite);
            },
            hasFocus: function() {
                return this.display.input.getField() == activeElt();
            },
            isReadOnly: function() {
                return !!(this.options.readOnly || this.doc.cantEdit);
            },
            scrollTo: methodOp(function(x, y) {
                scrollToCoords(this, x, y);
            }),
            getScrollInfo: function() {
                var scroller = this.display.scroller;
                return {
                    left: scroller.scrollLeft,
                    top: scroller.scrollTop,
                    height: scroller.scrollHeight - scrollGap(this) - this.display.barHeight,
                    width: scroller.scrollWidth - scrollGap(this) - this.display.barWidth,
                    clientHeight: displayHeight(this),
                    clientWidth: displayWidth(this)
                };
            },
            scrollIntoView: methodOp(function(range$$1, margin) {
                if (range$$1 == null) {
                    range$$1 = {
                        from: this.doc.sel.primary().head,
                        to: null
                    };
                    if (margin == null) margin = this.options.cursorScrollMargin;
                } else if (typeof range$$1 == "number") range$$1 = {
                    from: Pos(range$$1, 0),
                    to: null
                };
                else if (range$$1.from == null) range$$1 = {
                    from: range$$1,
                    to: null
                };
                if (!range$$1.to) range$$1.to = range$$1.from;
                range$$1.margin = margin || 0;
                if (range$$1.from.line != null) scrollToRange(this, range$$1);
                else scrollToCoordsRange(this, range$$1.from, range$$1.to, range$$1.margin);
            }),
            setSize: methodOp(function(width, height) {
                var this$1 = this;
                var interpret = function(val) {
                    return typeof val == "number" || /^\d+$/.test(String(val)) ? val + "px" : val;
                };
                if (width != null) this.display.wrapper.style.width = interpret(width);
                if (height != null) this.display.wrapper.style.height = interpret(height);
                if (this.options.lineWrapping) clearLineMeasurementCache(this);
                var lineNo$$1 = this.display.viewFrom;
                this.doc.iter(lineNo$$1, this.display.viewTo, function(line) {
                    if (line.widgets) {
                        for(var i = 0; i < line.widgets.length; i++)if (line.widgets[i].noHScroll) {
                            regLineChange(this$1, lineNo$$1, "widget");
                            break;
                        }
                    }
                    ++lineNo$$1;
                });
                this.curOp.forceUpdate = true;
                signal(this, "refresh", this);
            }),
            operation: function(f) {
                return runInOp(this, f);
            },
            startOperation: function() {
                return startOperation(this);
            },
            endOperation: function() {
                return endOperation(this);
            },
            refresh: methodOp(function() {
                var oldHeight = this.display.cachedTextHeight;
                regChange(this);
                this.curOp.forceUpdate = true;
                clearCaches(this);
                scrollToCoords(this, this.doc.scrollLeft, this.doc.scrollTop);
                updateGutterSpace(this.display);
                if (oldHeight == null || Math.abs(oldHeight - textHeight(this.display)) > .5) estimateLineHeights(this);
                signal(this, "refresh", this);
            }),
            swapDoc: methodOp(function(doc) {
                var old = this.doc;
                old.cm = null;
                // Cancel the current text selection if any (#5821)
                if (this.state.selectingText) this.state.selectingText();
                attachDoc(this, doc);
                clearCaches(this);
                this.display.input.reset();
                scrollToCoords(this, doc.scrollLeft, doc.scrollTop);
                this.curOp.forceScroll = true;
                signalLater(this, "swapDoc", this, old);
                return old;
            }),
            phrase: function(phraseText) {
                var phrases = this.options.phrases;
                return phrases && Object.prototype.hasOwnProperty.call(phrases, phraseText) ? phrases[phraseText] : phraseText;
            },
            getInputField: function() {
                return this.display.input.getField();
            },
            getWrapperElement: function() {
                return this.display.wrapper;
            },
            getScrollerElement: function() {
                return this.display.scroller;
            },
            getGutterElement: function() {
                return this.display.gutters;
            }
        };
        eventMixin(CodeMirror);
        CodeMirror.registerHelper = function(type, name, value) {
            if (!helpers.hasOwnProperty(type)) helpers[type] = CodeMirror[type] = {
                _global: []
            };
            helpers[type][name] = value;
        };
        CodeMirror.registerGlobalHelper = function(type, name, predicate, value) {
            CodeMirror.registerHelper(type, name, value);
            helpers[type]._global.push({
                pred: predicate,
                val: value
            });
        };
    }
    // Used for horizontal relative motion. Dir is -1 or 1 (left or
    // right), unit can be "char", "column" (like char, but doesn't
    // cross line boundaries), "word" (across next word), or "group" (to
    // the start of next group of word or non-word-non-whitespace
    // chars). The visually param controls whether, in right-to-left
    // text, direction 1 means to move towards the next index in the
    // string, or towards the character to the right of the current
    // position. The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosH(doc, pos, dir, unit, visually) {
        var oldPos = pos;
        var origDir = dir;
        var lineObj = getLine(doc, pos.line);
        function findNextLine() {
            var l = pos.line + dir;
            if (l < doc.first || l >= doc.first + doc.size) return false;
            pos = new Pos(l, pos.ch, pos.sticky);
            return lineObj = getLine(doc, l);
        }
        function moveOnce(boundToLine) {
            var next;
            if (visually) next = moveVisually(doc.cm, lineObj, pos, dir);
            else next = moveLogically(lineObj, pos, dir);
            if (next == null) {
                if (!boundToLine && findNextLine()) pos = endOfLine(visually, doc.cm, lineObj, pos.line, dir);
                else return false;
            } else pos = next;
            return true;
        }
        if (unit == "char") moveOnce();
        else if (unit == "column") moveOnce(true);
        else if (unit == "word" || unit == "group") {
            var sawType = null, group = unit == "group";
            var helper = doc.cm && doc.cm.getHelper(pos, "wordChars");
            for(var first = true;; first = false){
                if (dir < 0 && !moveOnce(!first)) break;
                var cur = lineObj.text.charAt(pos.ch) || "\n";
                var type = isWordChar(cur, helper) ? "w" : group && cur == "\n" ? "n" : !group || /\s/.test(cur) ? null : "p";
                if (group && !first && !type) type = "s";
                if (sawType && sawType != type) {
                    if (dir < 0) {
                        dir = 1;
                        moveOnce();
                        pos.sticky = "after";
                    }
                    break;
                }
                if (type) sawType = type;
                if (dir > 0 && !moveOnce(!first)) break;
            }
        }
        var result = skipAtomic(doc, pos, oldPos, origDir, true);
        if (equalCursorPos(oldPos, result)) result.hitSide = true;
        return result;
    }
    // For relative vertical movement. Dir may be -1 or 1. Unit can be
    // "page" or "line". The resulting position will have a hitSide=true
    // property if it reached the end of the document.
    function findPosV(cm, pos, dir, unit) {
        var doc = cm.doc, x = pos.left, y;
        if (unit == "page") {
            var pageSize = Math.min(cm.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight);
            var moveAmount = Math.max(pageSize - .5 * textHeight(cm.display), 3);
            y = (dir > 0 ? pos.bottom : pos.top) + dir * moveAmount;
        } else if (unit == "line") y = dir > 0 ? pos.bottom + 3 : pos.top - 3;
        var target;
        for(;;){
            target = coordsChar(cm, x, y);
            if (!target.outside) break;
            if (dir < 0 ? y <= 0 : y >= doc.height) {
                target.hitSide = true;
                break;
            }
            y += dir * 5;
        }
        return target;
    }
    // CONTENTEDITABLE INPUT STYLE
    var ContentEditableInput = function(cm) {
        this.cm = cm;
        this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null;
        this.polling = new Delayed();
        this.composing = null;
        this.gracePeriod = false;
        this.readDOMTimeout = null;
    };
    ContentEditableInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = input.cm;
        var div = input.div = display.lineDiv;
        disableBrowserMagic(div, cm.options.spellcheck, cm.options.autocorrect, cm.options.autocapitalize);
        on(div, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            // IE doesn't fire input events, so we schedule a read for the pasted content in this way
            if (ie_version <= 11) setTimeout(operation(cm, function() {
                return this$1.updateFromDOM();
            }), 20);
        });
        on(div, "compositionstart", function(e) {
            this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionupdate", function(e) {
            if (!this$1.composing) this$1.composing = {
                data: e.data,
                done: false
            };
        });
        on(div, "compositionend", function(e) {
            if (this$1.composing) {
                if (e.data != this$1.composing.data) this$1.readFromDOMSoon();
                this$1.composing.done = true;
            }
        });
        on(div, "touchstart", function() {
            return input.forceCompositionEnd();
        });
        on(div, "input", function() {
            if (!this$1.composing) this$1.readFromDOMSoon();
        });
        function onCopyCut(e) {
            if (signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) {
                setLastCopied({
                    lineWise: false,
                    text: cm.getSelections()
                });
                if (e.type == "cut") cm.replaceSelection("", null, "cut");
            } else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.operation(function() {
                    cm.setSelections(ranges.ranges, 0, sel_dontScroll);
                    cm.replaceSelection("", null, "cut");
                });
            }
            if (e.clipboardData) {
                e.clipboardData.clearData();
                var content = lastCopied.text.join("\n");
                // iOS exposes the clipboard API, but seems to discard content inserted into it
                e.clipboardData.setData("Text", content);
                if (e.clipboardData.getData("Text") == content) {
                    e.preventDefault();
                    return;
                }
            }
            // Old-fashioned briefly-focus-a-textarea hack
            var kludge = hiddenTextarea(), te = kludge.firstChild;
            cm.display.lineSpace.insertBefore(kludge, cm.display.lineSpace.firstChild);
            te.value = lastCopied.text.join("\n");
            var hadFocus = document.activeElement;
            selectInput(te);
            setTimeout(function() {
                cm.display.lineSpace.removeChild(kludge);
                hadFocus.focus();
                if (hadFocus == div) input.showPrimarySelection();
            }, 50);
        }
        on(div, "copy", onCopyCut);
        on(div, "cut", onCopyCut);
    };
    ContentEditableInput.prototype.prepareSelection = function() {
        var result = prepareSelection(this.cm, false);
        result.focus = this.cm.state.focused;
        return result;
    };
    ContentEditableInput.prototype.showSelection = function(info, takeFocus) {
        if (!info || !this.cm.display.view.length) return;
        if (info.focus || takeFocus) this.showPrimarySelection();
        this.showMultipleSelections(info);
    };
    ContentEditableInput.prototype.getSelection = function() {
        return this.cm.display.wrapper.ownerDocument.getSelection();
    };
    ContentEditableInput.prototype.showPrimarySelection = function() {
        var sel = this.getSelection(), cm = this.cm, prim = cm.doc.sel.primary();
        var from = prim.from(), to = prim.to();
        if (cm.display.viewTo == cm.display.viewFrom || from.line >= cm.display.viewTo || to.line < cm.display.viewFrom) {
            sel.removeAllRanges();
            return;
        }
        var curAnchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var curFocus = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (curAnchor && !curAnchor.bad && curFocus && !curFocus.bad && cmp(minPos(curAnchor, curFocus), from) == 0 && cmp(maxPos(curAnchor, curFocus), to) == 0) return;
        var view = cm.display.view;
        var start = from.line >= cm.display.viewFrom && posToDOM(cm, from) || {
            node: view[0].measure.map[2],
            offset: 0
        };
        var end = to.line < cm.display.viewTo && posToDOM(cm, to);
        if (!end) {
            var measure = view[view.length - 1].measure;
            var map$$1 = measure.maps ? measure.maps[measure.maps.length - 1] : measure.map;
            end = {
                node: map$$1[map$$1.length - 1],
                offset: map$$1[map$$1.length - 2] - map$$1[map$$1.length - 3]
            };
        }
        if (!start || !end) {
            sel.removeAllRanges();
            return;
        }
        var old = sel.rangeCount && sel.getRangeAt(0), rng;
        try {
            rng = range(start.node, start.offset, end.offset, end.node);
        } catch (e) {} // Our model of the DOM might be outdated, in which case the range we try to set can be impossible
        if (rng) {
            if (!gecko && cm.state.focused) {
                sel.collapse(start.node, start.offset);
                if (!rng.collapsed) {
                    sel.removeAllRanges();
                    sel.addRange(rng);
                }
            } else {
                sel.removeAllRanges();
                sel.addRange(rng);
            }
            if (old && sel.anchorNode == null) sel.addRange(old);
            else if (gecko) this.startGracePeriod();
        }
        this.rememberSelection();
    };
    ContentEditableInput.prototype.startGracePeriod = function() {
        var this$1 = this;
        clearTimeout(this.gracePeriod);
        this.gracePeriod = setTimeout(function() {
            this$1.gracePeriod = false;
            if (this$1.selectionChanged()) this$1.cm.operation(function() {
                return this$1.cm.curOp.selectionChanged = true;
            });
        }, 20);
    };
    ContentEditableInput.prototype.showMultipleSelections = function(info) {
        removeChildrenAndAdd(this.cm.display.cursorDiv, info.cursors);
        removeChildrenAndAdd(this.cm.display.selectionDiv, info.selection);
    };
    ContentEditableInput.prototype.rememberSelection = function() {
        var sel = this.getSelection();
        this.lastAnchorNode = sel.anchorNode;
        this.lastAnchorOffset = sel.anchorOffset;
        this.lastFocusNode = sel.focusNode;
        this.lastFocusOffset = sel.focusOffset;
    };
    ContentEditableInput.prototype.selectionInEditor = function() {
        var sel = this.getSelection();
        if (!sel.rangeCount) return false;
        var node = sel.getRangeAt(0).commonAncestorContainer;
        return contains(this.div, node);
    };
    ContentEditableInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor") {
            if (!this.selectionInEditor()) this.showSelection(this.prepareSelection(), true);
            this.div.focus();
        }
    };
    ContentEditableInput.prototype.blur = function() {
        this.div.blur();
    };
    ContentEditableInput.prototype.getField = function() {
        return this.div;
    };
    ContentEditableInput.prototype.supportsTouch = function() {
        return true;
    };
    ContentEditableInput.prototype.receivedFocus = function() {
        var input = this;
        if (this.selectionInEditor()) this.pollSelection();
        else runInOp(this.cm, function() {
            return input.cm.curOp.selectionChanged = true;
        });
        function poll() {
            if (input.cm.state.focused) {
                input.pollSelection();
                input.polling.set(input.cm.options.pollInterval, poll);
            }
        }
        this.polling.set(this.cm.options.pollInterval, poll);
    };
    ContentEditableInput.prototype.selectionChanged = function() {
        var sel = this.getSelection();
        return sel.anchorNode != this.lastAnchorNode || sel.anchorOffset != this.lastAnchorOffset || sel.focusNode != this.lastFocusNode || sel.focusOffset != this.lastFocusOffset;
    };
    ContentEditableInput.prototype.pollSelection = function() {
        if (this.readDOMTimeout != null || this.gracePeriod || !this.selectionChanged()) return;
        var sel = this.getSelection(), cm = this.cm;
        // On Android Chrome (version 56, at least), backspacing into an
        // uneditable block element will put the cursor in that element,
        // and then, because it's not editable, hide the virtual keyboard.
        // Because Android doesn't allow us to actually detect backspace
        // presses in a sane way, this code checks for when that happens
        // and simulates a backspace press in this case.
        if (android && chrome && this.cm.display.gutterSpecs.length && isInGutter(sel.anchorNode)) {
            this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
            });
            this.blur();
            this.focus();
            return;
        }
        if (this.composing) return;
        this.rememberSelection();
        var anchor = domToPos(cm, sel.anchorNode, sel.anchorOffset);
        var head = domToPos(cm, sel.focusNode, sel.focusOffset);
        if (anchor && head) runInOp(cm, function() {
            setSelection(cm.doc, simpleSelection(anchor, head), sel_dontScroll);
            if (anchor.bad || head.bad) cm.curOp.selectionChanged = true;
        });
    };
    ContentEditableInput.prototype.pollContent = function() {
        if (this.readDOMTimeout != null) {
            clearTimeout(this.readDOMTimeout);
            this.readDOMTimeout = null;
        }
        var cm = this.cm, display = cm.display, sel = cm.doc.sel.primary();
        var from = sel.from(), to = sel.to();
        if (from.ch == 0 && from.line > cm.firstLine()) from = Pos(from.line - 1, getLine(cm.doc, from.line - 1).length);
        if (to.ch == getLine(cm.doc, to.line).text.length && to.line < cm.lastLine()) to = Pos(to.line + 1, 0);
        if (from.line < display.viewFrom || to.line > display.viewTo - 1) return false;
        var fromIndex, fromLine, fromNode;
        if (from.line == display.viewFrom || (fromIndex = findViewIndex(cm, from.line)) == 0) {
            fromLine = lineNo(display.view[0].line);
            fromNode = display.view[0].node;
        } else {
            fromLine = lineNo(display.view[fromIndex].line);
            fromNode = display.view[fromIndex - 1].node.nextSibling;
        }
        var toIndex = findViewIndex(cm, to.line);
        var toLine, toNode;
        if (toIndex == display.view.length - 1) {
            toLine = display.viewTo - 1;
            toNode = display.lineDiv.lastChild;
        } else {
            toLine = lineNo(display.view[toIndex + 1].line) - 1;
            toNode = display.view[toIndex + 1].node.previousSibling;
        }
        if (!fromNode) return false;
        var newText = cm.doc.splitLines(domTextBetween(cm, fromNode, toNode, fromLine, toLine));
        var oldText = getBetween(cm.doc, Pos(fromLine, 0), Pos(toLine, getLine(cm.doc, toLine).text.length));
        while(newText.length > 1 && oldText.length > 1){
            if (lst(newText) == lst(oldText)) {
                newText.pop();
                oldText.pop();
                toLine--;
            } else if (newText[0] == oldText[0]) {
                newText.shift();
                oldText.shift();
                fromLine++;
            } else break;
        }
        var cutFront = 0, cutEnd = 0;
        var newTop = newText[0], oldTop = oldText[0], maxCutFront = Math.min(newTop.length, oldTop.length);
        while(cutFront < maxCutFront && newTop.charCodeAt(cutFront) == oldTop.charCodeAt(cutFront))++cutFront;
        var newBot = lst(newText), oldBot = lst(oldText);
        var maxCutEnd = Math.min(newBot.length - (newText.length == 1 ? cutFront : 0), oldBot.length - (oldText.length == 1 ? cutFront : 0));
        while(cutEnd < maxCutEnd && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1))++cutEnd;
        // Try to move start of change to start of selection if ambiguous
        if (newText.length == 1 && oldText.length == 1 && fromLine == from.line) while(cutFront && cutFront > from.ch && newBot.charCodeAt(newBot.length - cutEnd - 1) == oldBot.charCodeAt(oldBot.length - cutEnd - 1)){
            cutFront--;
            cutEnd++;
        }
        newText[newText.length - 1] = newBot.slice(0, newBot.length - cutEnd).replace(/^\u200b+/, "");
        newText[0] = newText[0].slice(cutFront).replace(/\u200b+$/, "");
        var chFrom = Pos(fromLine, cutFront);
        var chTo = Pos(toLine, oldText.length ? lst(oldText).length - cutEnd : 0);
        if (newText.length > 1 || newText[0] || cmp(chFrom, chTo)) {
            replaceRange(cm.doc, newText, chFrom, chTo, "+input");
            return true;
        }
    };
    ContentEditableInput.prototype.ensurePolled = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.reset = function() {
        this.forceCompositionEnd();
    };
    ContentEditableInput.prototype.forceCompositionEnd = function() {
        if (!this.composing) return;
        clearTimeout(this.readDOMTimeout);
        this.composing = null;
        this.updateFromDOM();
        this.div.blur();
        this.div.focus();
    };
    ContentEditableInput.prototype.readFromDOMSoon = function() {
        var this$1 = this;
        if (this.readDOMTimeout != null) return;
        this.readDOMTimeout = setTimeout(function() {
            this$1.readDOMTimeout = null;
            if (this$1.composing) {
                if (this$1.composing.done) this$1.composing = null;
                else return;
            }
            this$1.updateFromDOM();
        }, 80);
    };
    ContentEditableInput.prototype.updateFromDOM = function() {
        var this$1 = this;
        if (this.cm.isReadOnly() || !this.pollContent()) runInOp(this.cm, function() {
            return regChange(this$1.cm);
        });
    };
    ContentEditableInput.prototype.setUneditable = function(node) {
        node.contentEditable = "false";
    };
    ContentEditableInput.prototype.onKeyPress = function(e) {
        if (e.charCode == 0 || this.composing) return;
        e.preventDefault();
        if (!this.cm.isReadOnly()) operation(this.cm, applyTextInput)(this.cm, String.fromCharCode(e.charCode == null ? e.keyCode : e.charCode), 0);
    };
    ContentEditableInput.prototype.readOnlyChanged = function(val) {
        this.div.contentEditable = String(val != "nocursor");
    };
    ContentEditableInput.prototype.onContextMenu = function() {};
    ContentEditableInput.prototype.resetPosition = function() {};
    ContentEditableInput.prototype.needsContentAttribute = true;
    function posToDOM(cm, pos) {
        var view = findViewForLine(cm, pos.line);
        if (!view || view.hidden) return null;
        var line = getLine(cm.doc, pos.line);
        var info = mapFromLineView(view, line, pos.line);
        var order = getOrder(line, cm.doc.direction), side = "left";
        if (order) {
            var partPos = getBidiPartAt(order, pos.ch);
            side = partPos % 2 ? "right" : "left";
        }
        var result = nodeAndOffsetInLineMap(info.map, pos.ch, side);
        result.offset = result.collapse == "right" ? result.end : result.start;
        return result;
    }
    function isInGutter(node) {
        for(var scan = node; scan; scan = scan.parentNode){
            if (/CodeMirror-gutter-wrapper/.test(scan.className)) return true;
        }
        return false;
    }
    function badPos(pos, bad) {
        if (bad) pos.bad = true;
        return pos;
    }
    function domTextBetween(cm, from, to, fromLine, toLine) {
        var text = "", closing = false, lineSep = cm.doc.lineSeparator(), extraLinebreak = false;
        function recognizeMarker(id) {
            return function(marker) {
                return marker.id == id;
            };
        }
        function close() {
            if (closing) {
                text += lineSep;
                if (extraLinebreak) text += lineSep;
                closing = extraLinebreak = false;
            }
        }
        function addText(str) {
            if (str) {
                close();
                text += str;
            }
        }
        function walk(node) {
            if (node.nodeType == 1) {
                var cmText = node.getAttribute("cm-text");
                if (cmText) {
                    addText(cmText);
                    return;
                }
                var markerID = node.getAttribute("cm-marker"), range$$1;
                if (markerID) {
                    var found = cm.findMarks(Pos(fromLine, 0), Pos(toLine + 1, 0), recognizeMarker(+markerID));
                    if (found.length && (range$$1 = found[0].find(0))) addText(getBetween(cm.doc, range$$1.from, range$$1.to).join(lineSep));
                    return;
                }
                if (node.getAttribute("contenteditable") == "false") return;
                var isBlock = /^(pre|div|p|li|table|br)$/i.test(node.nodeName);
                if (!/^br$/i.test(node.nodeName) && node.textContent.length == 0) return;
                if (isBlock) close();
                for(var i = 0; i < node.childNodes.length; i++)walk(node.childNodes[i]);
                if (/^(pre|p)$/i.test(node.nodeName)) extraLinebreak = true;
                if (isBlock) closing = true;
            } else if (node.nodeType == 3) addText(node.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
        }
        for(;;){
            walk(from);
            if (from == to) break;
            from = from.nextSibling;
            extraLinebreak = false;
        }
        return text;
    }
    function domToPos(cm, node, offset) {
        var lineNode;
        if (node == cm.display.lineDiv) {
            lineNode = cm.display.lineDiv.childNodes[offset];
            if (!lineNode) return badPos(cm.clipPos(Pos(cm.display.viewTo - 1)), true);
            node = null;
            offset = 0;
        } else for(lineNode = node;; lineNode = lineNode.parentNode){
            if (!lineNode || lineNode == cm.display.lineDiv) return null;
            if (lineNode.parentNode && lineNode.parentNode == cm.display.lineDiv) break;
        }
        for(var i = 0; i < cm.display.view.length; i++){
            var lineView = cm.display.view[i];
            if (lineView.node == lineNode) return locateNodeInLineView(lineView, node, offset);
        }
    }
    function locateNodeInLineView(lineView, node, offset) {
        var wrapper = lineView.text.firstChild, bad = false;
        if (!node || !contains(wrapper, node)) return badPos(Pos(lineNo(lineView.line), 0), true);
        if (node == wrapper) {
            bad = true;
            node = wrapper.childNodes[offset];
            offset = 0;
            if (!node) {
                var line = lineView.rest ? lst(lineView.rest) : lineView.line;
                return badPos(Pos(lineNo(line), line.text.length), bad);
            }
        }
        var textNode = node.nodeType == 3 ? node : null, topNode = node;
        if (!textNode && node.childNodes.length == 1 && node.firstChild.nodeType == 3) {
            textNode = node.firstChild;
            if (offset) offset = textNode.nodeValue.length;
        }
        while(topNode.parentNode != wrapper)topNode = topNode.parentNode;
        var measure = lineView.measure, maps = measure.maps;
        function find(textNode, topNode, offset) {
            for(var i = -1; i < (maps ? maps.length : 0); i++){
                var map$$1 = i < 0 ? measure.map : maps[i];
                for(var j = 0; j < map$$1.length; j += 3){
                    var curNode = map$$1[j + 2];
                    if (curNode == textNode || curNode == topNode) {
                        var line = lineNo(i < 0 ? lineView.line : lineView.rest[i]);
                        var ch = map$$1[j] + offset;
                        if (offset < 0 || curNode != textNode) ch = map$$1[j + (offset ? 1 : 0)];
                        return Pos(line, ch);
                    }
                }
            }
        }
        var found = find(textNode, topNode, offset);
        if (found) return badPos(found, bad);
        // FIXME this is all really shaky. might handle the few cases it needs to handle, but likely to cause problems
        for(var after = topNode.nextSibling, dist = textNode ? textNode.nodeValue.length - offset : 0; after; after = after.nextSibling){
            found = find(after, after.firstChild, 0);
            if (found) return badPos(Pos(found.line, found.ch - dist), bad);
            else dist += after.textContent.length;
        }
        for(var before = topNode.previousSibling, dist$1 = offset; before; before = before.previousSibling){
            found = find(before, before.firstChild, -1);
            if (found) return badPos(Pos(found.line, found.ch + dist$1), bad);
            else dist$1 += before.textContent.length;
        }
    }
    // TEXTAREA INPUT STYLE
    var TextareaInput = function(cm) {
        this.cm = cm;
        // See input.poll and input.reset
        this.prevInput = "";
        // Flag that indicates whether we expect input to appear real soon
        // now (after some event like 'keypress' or 'input') and are
        // polling intensively.
        this.pollingFast = false;
        // Self-resetting timeout for the poller
        this.polling = new Delayed();
        // Used to work around IE issue with selection being forgotten when focus moves away from textarea
        this.hasSelection = false;
        this.composing = null;
    };
    TextareaInput.prototype.init = function(display) {
        var this$1 = this;
        var input = this, cm = this.cm;
        this.createField(display);
        var te = this.textarea;
        display.wrapper.insertBefore(this.wrapper, display.wrapper.firstChild);
        // Needed to hide big blue blinking cursor on Mobile Safari (doesn't seem to work in iOS 8 anymore)
        if (ios) te.style.width = "0px";
        on(te, "input", function() {
            if (ie && ie_version >= 9 && this$1.hasSelection) this$1.hasSelection = null;
            input.poll();
        });
        on(te, "paste", function(e) {
            if (signalDOMEvent(cm, e) || handlePaste(e, cm)) return;
            cm.state.pasteIncoming = +new Date;
            input.fastPoll();
        });
        function prepareCopyCut(e) {
            if (signalDOMEvent(cm, e)) return;
            if (cm.somethingSelected()) setLastCopied({
                lineWise: false,
                text: cm.getSelections()
            });
            else if (!cm.options.lineWiseCopyCut) return;
            else {
                var ranges = copyableRanges(cm);
                setLastCopied({
                    lineWise: true,
                    text: ranges.text
                });
                if (e.type == "cut") cm.setSelections(ranges.ranges, null, sel_dontScroll);
                else {
                    input.prevInput = "";
                    te.value = ranges.text.join("\n");
                    selectInput(te);
                }
            }
            if (e.type == "cut") cm.state.cutIncoming = +new Date;
        }
        on(te, "cut", prepareCopyCut);
        on(te, "copy", prepareCopyCut);
        on(display.scroller, "paste", function(e) {
            if (eventInWidget(display, e) || signalDOMEvent(cm, e)) return;
            if (!te.dispatchEvent) {
                cm.state.pasteIncoming = +new Date;
                input.focus();
                return;
            }
            // Pass the `paste` event to the textarea so it's handled by its event listener.
            var event = new Event("paste");
            event.clipboardData = e.clipboardData;
            te.dispatchEvent(event);
        });
        // Prevent normal selection in the editor (we handle our own)
        on(display.lineSpace, "selectstart", function(e) {
            if (!eventInWidget(display, e)) e_preventDefault(e);
        });
        on(te, "compositionstart", function() {
            var start = cm.getCursor("from");
            if (input.composing) input.composing.range.clear();
            input.composing = {
                start: start,
                range: cm.markText(start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                })
            };
        });
        on(te, "compositionend", function() {
            if (input.composing) {
                input.poll();
                input.composing.range.clear();
                input.composing = null;
            }
        });
    };
    TextareaInput.prototype.createField = function(_display) {
        // Wraps and hides input textarea
        this.wrapper = hiddenTextarea();
        // The semihidden textarea that is focused when the editor is
        // focused, and receives input.
        this.textarea = this.wrapper.firstChild;
    };
    TextareaInput.prototype.prepareSelection = function() {
        // Redraw the selection and/or cursor
        var cm = this.cm, display = cm.display, doc = cm.doc;
        var result = prepareSelection(cm);
        // Move the hidden textarea near the cursor to prevent scrolling artifacts
        if (cm.options.moveInputWithCursor) {
            var headPos = cursorCoords(cm, doc.sel.primary().head, "div");
            var wrapOff = display.wrapper.getBoundingClientRect(), lineOff = display.lineDiv.getBoundingClientRect();
            result.teTop = Math.max(0, Math.min(display.wrapper.clientHeight - 10, headPos.top + lineOff.top - wrapOff.top));
            result.teLeft = Math.max(0, Math.min(display.wrapper.clientWidth - 10, headPos.left + lineOff.left - wrapOff.left));
        }
        return result;
    };
    TextareaInput.prototype.showSelection = function(drawn) {
        var cm = this.cm, display = cm.display;
        removeChildrenAndAdd(display.cursorDiv, drawn.cursors);
        removeChildrenAndAdd(display.selectionDiv, drawn.selection);
        if (drawn.teTop != null) {
            this.wrapper.style.top = drawn.teTop + "px";
            this.wrapper.style.left = drawn.teLeft + "px";
        }
    };
    // Reset the input to correspond to the selection (or to be empty,
    // when not typing and nothing is selected)
    TextareaInput.prototype.reset = function(typing) {
        if (this.contextMenuPending || this.composing) return;
        var cm = this.cm;
        if (cm.somethingSelected()) {
            this.prevInput = "";
            var content = cm.getSelection();
            this.textarea.value = content;
            if (cm.state.focused) selectInput(this.textarea);
            if (ie && ie_version >= 9) this.hasSelection = content;
        } else if (!typing) {
            this.prevInput = this.textarea.value = "";
            if (ie && ie_version >= 9) this.hasSelection = null;
        }
    };
    TextareaInput.prototype.getField = function() {
        return this.textarea;
    };
    TextareaInput.prototype.supportsTouch = function() {
        return false;
    };
    TextareaInput.prototype.focus = function() {
        if (this.cm.options.readOnly != "nocursor" && (!mobile || activeElt() != this.textarea)) try {
            this.textarea.focus();
        } catch (e) {} // IE8 will throw if the textarea is display: none or not in DOM
    };
    TextareaInput.prototype.blur = function() {
        this.textarea.blur();
    };
    TextareaInput.prototype.resetPosition = function() {
        this.wrapper.style.top = this.wrapper.style.left = 0;
    };
    TextareaInput.prototype.receivedFocus = function() {
        this.slowPoll();
    };
    // Poll for input changes, using the normal rate of polling. This
    // runs as long as the editor is focused.
    TextareaInput.prototype.slowPoll = function() {
        var this$1 = this;
        if (this.pollingFast) return;
        this.polling.set(this.cm.options.pollInterval, function() {
            this$1.poll();
            if (this$1.cm.state.focused) this$1.slowPoll();
        });
    };
    // When an event has just come in that is likely to add or change
    // something in the input textarea, we poll faster, to ensure that
    // the change appears on the screen quickly.
    TextareaInput.prototype.fastPoll = function() {
        var missed = false, input = this;
        input.pollingFast = true;
        function p() {
            var changed = input.poll();
            if (!changed && !missed) {
                missed = true;
                input.polling.set(60, p);
            } else {
                input.pollingFast = false;
                input.slowPoll();
            }
        }
        input.polling.set(20, p);
    };
    // Read input from the textarea, and update the document to match.
    // When something is selected, it is present in the textarea, and
    // selected (unless it is huge, in which case a placeholder is
    // used). When nothing is selected, the cursor sits after previously
    // seen text (can be empty), which is stored in prevInput (we must
    // not reset the textarea when typing, because that breaks IME).
    TextareaInput.prototype.poll = function() {
        var this$1 = this;
        var cm = this.cm, input = this.textarea, prevInput = this.prevInput;
        // Since this is called a *lot*, try to bail out as cheaply as
        // possible when it is clear that nothing happened. hasSelection
        // will be the case when there is a lot of text in the textarea,
        // in which case reading its value would be expensive.
        if (this.contextMenuPending || !cm.state.focused || hasSelection(input) && !prevInput && !this.composing || cm.isReadOnly() || cm.options.disableInput || cm.state.keySeq) return false;
        var text = input.value;
        // If nothing changed, bail.
        if (text == prevInput && !cm.somethingSelected()) return false;
        // Work around nonsensical selection resetting in IE9/10, and
        // inexplicable appearance of private area unicode characters on
        // some key combos in Mac (#2689).
        if (ie && ie_version >= 9 && this.hasSelection === text || mac && /[\uf700-\uf7ff]/.test(text)) {
            cm.display.input.reset();
            return false;
        }
        if (cm.doc.sel == cm.display.selForContextMenu) {
            var first = text.charCodeAt(0);
            if (first == 0x200b && !prevInput) prevInput = "​";
            if (first == 0x21da) {
                this.reset();
                return this.cm.execCommand("undo");
            }
        }
        // Find the part of the input that is actually new
        var same = 0, l = Math.min(prevInput.length, text.length);
        while(same < l && prevInput.charCodeAt(same) == text.charCodeAt(same))++same;
        runInOp(cm, function() {
            applyTextInput(cm, text.slice(same), prevInput.length - same, null, this$1.composing ? "*compose" : null);
            // Don't leave long text in the textarea, since it makes further polling slow
            if (text.length > 1000 || text.indexOf("\n") > -1) input.value = this$1.prevInput = "";
            else this$1.prevInput = text;
            if (this$1.composing) {
                this$1.composing.range.clear();
                this$1.composing.range = cm.markText(this$1.composing.start, cm.getCursor("to"), {
                    className: "CodeMirror-composing"
                });
            }
        });
        return true;
    };
    TextareaInput.prototype.ensurePolled = function() {
        if (this.pollingFast && this.poll()) this.pollingFast = false;
    };
    TextareaInput.prototype.onKeyPress = function() {
        if (ie && ie_version >= 9) this.hasSelection = null;
        this.fastPoll();
    };
    TextareaInput.prototype.onContextMenu = function(e) {
        var input = this, cm = input.cm, display = cm.display, te = input.textarea;
        if (input.contextMenuPending) input.contextMenuPending();
        var pos = posFromMouse(cm, e), scrollPos = display.scroller.scrollTop;
        if (!pos || presto) return;
         // Opera is difficult.
        // Reset the current text selection only if the click is done outside of the selection
        // and 'resetSelectionOnContextMenu' option is true.
        var reset = cm.options.resetSelectionOnContextMenu;
        if (reset && cm.doc.sel.contains(pos) == -1) operation(cm, setSelection)(cm.doc, simpleSelection(pos), sel_dontScroll);
        var oldCSS = te.style.cssText, oldWrapperCSS = input.wrapper.style.cssText;
        var wrapperBox = input.wrapper.offsetParent.getBoundingClientRect();
        input.wrapper.style.cssText = "position: static";
        te.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - wrapperBox.top - 5) + "px; left: " + (e.clientX - wrapperBox.left - 5) + "px;\n      z-index: 1000; background: " + (ie ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);";
        var oldScrollY;
        if (webkit) oldScrollY = window.scrollY;
         // Work around Chrome issue (#2712)
        display.input.focus();
        if (webkit) window.scrollTo(null, oldScrollY);
        display.input.reset();
        // Adds "Select all" to context menu in FF
        if (!cm.somethingSelected()) te.value = input.prevInput = " ";
        input.contextMenuPending = rehide;
        display.selForContextMenu = cm.doc.sel;
        clearTimeout(display.detectingSelectAll);
        // Select-all will be greyed out if there's nothing to select, so
        // this adds a zero-width space so that we can later check whether
        // it got selected.
        function prepareSelectAllHack() {
            if (te.selectionStart != null) {
                var selected = cm.somethingSelected();
                var extval = "​" + (selected ? te.value : "");
                te.value = "⇚"; // Used to catch context-menu undo
                te.value = extval;
                input.prevInput = selected ? "" : "​";
                te.selectionStart = 1;
                te.selectionEnd = extval.length;
                // Re-set this, in case some other handler touched the
                // selection in the meantime.
                display.selForContextMenu = cm.doc.sel;
            }
        }
        function rehide() {
            if (input.contextMenuPending != rehide) return;
            input.contextMenuPending = false;
            input.wrapper.style.cssText = oldWrapperCSS;
            te.style.cssText = oldCSS;
            if (ie && ie_version < 9) display.scrollbars.setScrollTop(display.scroller.scrollTop = scrollPos);
            // Try to detect the user choosing select-all
            if (te.selectionStart != null) {
                if (!ie || ie && ie_version < 9) prepareSelectAllHack();
                var i = 0, poll = function() {
                    if (display.selForContextMenu == cm.doc.sel && te.selectionStart == 0 && te.selectionEnd > 0 && input.prevInput == "​") operation(cm, selectAll)(cm);
                    else if (i++ < 10) display.detectingSelectAll = setTimeout(poll, 500);
                    else {
                        display.selForContextMenu = null;
                        display.input.reset();
                    }
                };
                display.detectingSelectAll = setTimeout(poll, 200);
            }
        }
        if (ie && ie_version >= 9) prepareSelectAllHack();
        if (captureRightClick) {
            e_stop(e);
            var mouseup = function() {
                off(window, "mouseup", mouseup);
                setTimeout(rehide, 20);
            };
            on(window, "mouseup", mouseup);
        } else setTimeout(rehide, 50);
    };
    TextareaInput.prototype.readOnlyChanged = function(val) {
        if (!val) this.reset();
        this.textarea.disabled = val == "nocursor";
    };
    TextareaInput.prototype.setUneditable = function() {};
    TextareaInput.prototype.needsContentAttribute = false;
    function fromTextArea(textarea, options) {
        options = options ? copyObj(options) : {};
        options.value = textarea.value;
        if (!options.tabindex && textarea.tabIndex) options.tabindex = textarea.tabIndex;
        if (!options.placeholder && textarea.placeholder) options.placeholder = textarea.placeholder;
        // Set autofocus to true if this textarea is focused, or if it has
        // autofocus and no other element is focused.
        if (options.autofocus == null) {
            var hasFocus = activeElt();
            options.autofocus = hasFocus == textarea || textarea.getAttribute("autofocus") != null && hasFocus == document.body;
        }
        function save() {
            textarea.value = cm.getValue();
        }
        var realSubmit;
        if (textarea.form) {
            on(textarea.form, "submit", save);
            // Deplorable hack to make the submit method do the right thing.
            if (!options.leaveSubmitMethodAlone) {
                var form = textarea.form;
                realSubmit = form.submit;
                try {
                    var wrappedSubmit = form.submit = function() {
                        save();
                        form.submit = realSubmit;
                        form.submit();
                        form.submit = wrappedSubmit;
                    };
                } catch (e) {}
            }
        }
        options.finishInit = function(cm) {
            cm.save = save;
            cm.getTextArea = function() {
                return textarea;
            };
            cm.toTextArea = function() {
                cm.toTextArea = isNaN; // Prevent this from being ran twice
                save();
                textarea.parentNode.removeChild(cm.getWrapperElement());
                textarea.style.display = "";
                if (textarea.form) {
                    off(textarea.form, "submit", save);
                    if (typeof textarea.form.submit == "function") textarea.form.submit = realSubmit;
                }
            };
        };
        textarea.style.display = "none";
        var cm = CodeMirror(function(node) {
            return textarea.parentNode.insertBefore(node, textarea.nextSibling);
        }, options);
        return cm;
    }
    function addLegacyProps(CodeMirror) {
        CodeMirror.off = off;
        CodeMirror.on = on;
        CodeMirror.wheelEventPixels = wheelEventPixels;
        CodeMirror.Doc = Doc;
        CodeMirror.splitLines = splitLinesAuto;
        CodeMirror.countColumn = countColumn;
        CodeMirror.findColumn = findColumn;
        CodeMirror.isWordChar = isWordCharBasic;
        CodeMirror.Pass = Pass;
        CodeMirror.signal = signal;
        CodeMirror.Line = Line;
        CodeMirror.changeEnd = changeEnd;
        CodeMirror.scrollbarModel = scrollbarModel;
        CodeMirror.Pos = Pos;
        CodeMirror.cmpPos = cmp;
        CodeMirror.modes = modes;
        CodeMirror.mimeModes = mimeModes;
        CodeMirror.resolveMode = resolveMode;
        CodeMirror.getMode = getMode;
        CodeMirror.modeExtensions = modeExtensions;
        CodeMirror.extendMode = extendMode;
        CodeMirror.copyState = copyState;
        CodeMirror.startState = startState;
        CodeMirror.innerMode = innerMode;
        CodeMirror.commands = commands;
        CodeMirror.keyMap = keyMap;
        CodeMirror.keyName = keyName;
        CodeMirror.isModifierKey = isModifierKey;
        CodeMirror.lookupKey = lookupKey;
        CodeMirror.normalizeKeyMap = normalizeKeyMap;
        CodeMirror.StringStream = StringStream;
        CodeMirror.SharedTextMarker = SharedTextMarker;
        CodeMirror.TextMarker = TextMarker;
        CodeMirror.LineWidget = LineWidget;
        CodeMirror.e_preventDefault = e_preventDefault;
        CodeMirror.e_stopPropagation = e_stopPropagation;
        CodeMirror.e_stop = e_stop;
        CodeMirror.addClass = addClass;
        CodeMirror.contains = contains;
        CodeMirror.rmClass = rmClass;
        CodeMirror.keyNames = keyNames;
    }
    // EDITOR CONSTRUCTOR
    defineOptions(CodeMirror);
    addEditorMethods(CodeMirror);
    // Set up methods on CodeMirror's prototype to redirect to the editor's document.
    var dontDelegate = "iter insert remove copy getEditor constructor".split(" ");
    for(var prop in Doc.prototype)if (Doc.prototype.hasOwnProperty(prop) && indexOf(dontDelegate, prop) < 0) CodeMirror.prototype[prop] = function(method) {
        return function() {
            return method.apply(this.doc, arguments);
        };
    }(Doc.prototype[prop]);
    eventMixin(Doc);
    CodeMirror.inputStyles = {
        "textarea": TextareaInput,
        "contenteditable": ContentEditableInput
    };
    // Extra arguments are stored as the mode's dependencies, which is
    // used by (legacy) mechanisms like loadmode.js to automatically
    // load a mode. (Preferred mechanism is the require/define calls.)
    CodeMirror.defineMode = function(name /*, mode, …*/ ) {
        if (!CodeMirror.defaults.mode && name != "null") CodeMirror.defaults.mode = name;
        defineMode.apply(this, arguments);
    };
    CodeMirror.defineMIME = defineMIME;
    // Minimal default mode.
    CodeMirror.defineMode("null", function() {
        return {
            token: function(stream) {
                return stream.skipToEnd();
            }
        };
    });
    CodeMirror.defineMIME("text/plain", "null");
    // EXTENSIONS
    CodeMirror.defineExtension = function(name, func) {
        CodeMirror.prototype[name] = func;
    };
    CodeMirror.defineDocExtension = function(name, func) {
        Doc.prototype[name] = func;
    };
    CodeMirror.fromTextArea = fromTextArea;
    addLegacyProps(CodeMirror);
    CodeMirror.version = "5.48.4";
    return CodeMirror;
});





var $bh6RR = parcelRequire("bh6RR");


var $4LfDI = parcelRequire("4LfDI");




var $bh6RR = parcelRequire("bh6RR");

var $4LfDI = parcelRequire("4LfDI");

class $fefc6099805237ea$export$1642339e20d2e486 extends $bh6RR.Component {
    constructor(props){
        super(props);
    }
    shouldComponentUpdate(nextProps) {
        const same = $bb5c76e6a1c0ede6$export$2e2bcd8739ae039(this.props.dep, nextProps.dep);
        // same || Utils.stdout(nextProps.dep)
        return !same;
    }
    render() {
        // const m = this.props.dep as any
        // console.log('rendering ', Utils.show(m.id || m))
        return this.props.children();
    }
}
function $fefc6099805237ea$export$dd164f5517779f15(dep, key, child) {
    return /*#__PURE__*/ $bh6RR.createElement($fefc6099805237ea$export$1642339e20d2e486, {
        dep: dep,
        key: key
    }, ()=>child());
}
function $fefc6099805237ea$export$cd0f44441c3b7719(nodes, s = "") {
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, {
        key: s
    }, nodes.map((n, i)=>/*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, {
            key: i
        }, n)));
}
const $fefc6099805237ea$export$962e3d5eaa2dc953 = (0, $4LfDI.style)($a0933ef57ff1c2b9$export$9acf59296ec0cce1("clean_ul"), {
    $nest: {
        "& ul, & ol": {
            padding: "0px"
        },
        "& li": {
            listStyle: "none"
        }
    }
});
const $fefc6099805237ea$export$3e30dc43d21f9d67 = (0, $4LfDI.style)($a0933ef57ff1c2b9$export$9acf59296ec0cce1("Unselectable"), {
    "-moz-user-select": "none",
    "-webkit-touch-callout": "none",
    "-webkit-user-select": "none",
    "-ms-user-select": "none",
    userSelect: "none",
    cursor: "default"
});
function $fefc6099805237ea$export$379139ebc1c2b235({ store: store, onRef: onRef, ...props }) {
    return /*#__PURE__*/ $bh6RR.createElement("textarea", {
        ...props,
        value: store.get(),
        ref: (e)=>onRef && e && onRef(e),
        onChange: (e)=>store.set(e.target.value)
    });
}
function $fefc6099805237ea$export$f5b8910cec6cf069(store, tabIndex) {
    return /*#__PURE__*/ $bh6RR.createElement("input", {
        value: store.get(),
        tabIndex: tabIndex,
        onChange: (e)=>store.set(e.target.value)
    });
}
const $fefc6099805237ea$export$353f5b6fc5456de1 = (label, title, onClick, enabled = true, stopOnMouseDownPropagation = true)=>/*#__PURE__*/ $bh6RR.createElement("button", {
        title: title,
        key: label,
        onMouseDown: (e)=>stopOnMouseDownPropagation && e.stopPropagation(),
        onClick: onClick,
        style: {
            cursor: "pointer"
        },
        disabled: !enabled
    }, label);
function $fefc6099805237ea$export$f6b1e3902165e5e1(h, k) {
    return /*#__PURE__*/ $bh6RR.createElement("div", {
        ref: (el)=>{
            if (el) {
                while(el && el.lastChild)el.removeChild(el.lastChild);
                el.appendChild(h);
                k();
            }
        }
    });
}
function $fefc6099805237ea$export$f39c2d165cd861fe(props) {
    return /*#__PURE__*/ $bh6RR.createElement("a", {
        className: "close",
        href: "#",
        title: props.title,
        onMouseDown: props.onMouseDown
    }, "\xd7");
}
function $fefc6099805237ea$export$ebd11618f299a286(props) {
    return /*#__PURE__*/ $bh6RR.createElement("a", {
        href: "",
        onClick: (e)=>e.preventDefault(),
        title: props.title,
        onMouseDown: props.onMouseDown
    }, props.text);
}


const $61b0792adb50d7bb$var$intended_font_size = 16;
const $61b0792adb50d7bb$var$px = (i)=>`${i / $61b0792adb50d7bb$var$intended_font_size}em`;
const $61b0792adb50d7bb$export$6cb312a80b588f32 = (0, $4LfDI.style)($a0933ef57ff1c2b9$export$9acf59296ec0cce1("BorderCell"), $4aa2fd92cb1b046f$exports.horizontal, $4aa2fd92cb1b046f$exports.centerJustified, {
    zIndex: 10
}, {
    $nest: {
        "& > div": {
            ...$4aa2fd92cb1b046f$exports.border(`${$61b0792adb50d7bb$var$px($61b0792adb50d7bb$var$intended_font_size / 13)} #777 solid`),
            // csstips.border(`${px(1)} #777 solid`),
            borderRadius: `${$61b0792adb50d7bb$var$px(2)}`,
            fontSize: `${$61b0792adb50d7bb$var$px(13)}`,
            background: "white",
            ...$4aa2fd92cb1b046f$exports.padding($61b0792adb50d7bb$var$px(5), $61b0792adb50d7bb$var$px(3), $61b0792adb50d7bb$var$px(1), $61b0792adb50d7bb$var$px(3)),
            ...$4aa2fd92cb1b046f$exports.centerJustified
        },
        "& > div> span:not(:last-child)": {
            paddingRight: `${$61b0792adb50d7bb$var$px(4)}`,
            marginRight: `${$61b0792adb50d7bb$var$px(4)}`
        },
        "&.OBS > div": {
            background: "pink"
        }
    }
});
const $61b0792adb50d7bb$export$e4e464ca31438e63 = "#6699ee";
const $61b0792adb50d7bb$var$GraphViewStyle = (0, $4LfDI.style)($a0933ef57ff1c2b9$export$9acf59296ec0cce1("GraphViewStyle"), $4aa2fd92cb1b046f$exports.wrap, $4aa2fd92cb1b046f$exports.startJustified, $4aa2fd92cb1b046f$exports.horizontal, $4aa2fd92cb1b046f$exports.inlineRoot, {
    $nest: {
        "& > ul": {
            ...$4aa2fd92cb1b046f$exports.vertical,
            borderTop: `${$61b0792adb50d7bb$var$px(1)} #ccc solid`,
            borderBottom: `${$61b0792adb50d7bb$var$px(1)} #ccc solid`,
            marginBottom: `${$61b0792adb50d7bb$var$px(20)}`
        },
        "& > ul > li": {
            height: `${$61b0792adb50d7bb$var$px(20)}`,
            width: "100%",
            marginRight: `${$61b0792adb50d7bb$var$px(3)}`,
            marginLeft: `${$61b0792adb50d7bb$var$px(3)}`,
            textAlign: "center"
        },
        "& > ul > .bottom, & > ul > .top": {
            marginTop: `${$61b0792adb50d7bb$var$px(3)}`,
            marginBottom: `${$61b0792adb50d7bb$var$px(3)}`
        },
        "& > ul > .source.mid": {
            marginTop: `${$61b0792adb50d7bb$var$px(5)}`
        },
        "& > ul > .target.mid": {
            marginBottom: `-${$61b0792adb50d7bb$var$px(3)}`
        },
        "& > ul > .upper, & > ul > .lower, & > ul > .mid": {
            height: `${$61b0792adb50d7bb$var$px(24)}`
        },
        "& div": {
            color: "#222"
        },
        "& ins": {
            color: "#383",
            backgroundColor: "#cfc",
            borderRadius: ".3em",
            textDecoration: "none"
        },
        "& del": {
            color: "#a00",
            backgroundColor: "#fcd",
            borderRadius: ".3em",
            textDecoration: "none"
        },
        "&.anonymization ins, &.anonymization del": {
            color: "inherit",
            backgroundColor: "inherit"
        },
        "& .GreyPath": {
            stroke: "#999",
            strokeWidth: $61b0792adb50d7bb$var$px(4),
            fill: "none"
        },
        ".NoManualBlue & .GreyPath.Manual": {
            stroke: "#999"
        },
        "& .GreyPath.Manual": {
            stroke: $61b0792adb50d7bb$export$e4e464ca31438e63,
            strokeWidth: $61b0792adb50d7bb$var$px(8),
            fill: "none"
        },
        "& .WhitePath": {
            stroke: "#fff",
            strokeWidth: $61b0792adb50d7bb$var$px(12),
            fill: "none"
        },
        "& .MustacheZ": {
            zIndex: -1
        },
        "& .PathZ": {
            zIndex: -2
        },
        "& .RelativeSVG": {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        "& .AbsoluteSVG": {
            position: "absolute",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
            // This needs to be <=0.5em, but smaller than that makes it not start
            // growing until a sufficiently high zoom
            fontSize: "0.25em"
        },
        // the point of the scaling up and down here is to make the vertical lines
        // be on exact pixel coordinates to not make them look blurry.
        "& .PixelPerfectOuter": {
            // table rounds the sizes in webengine
            display: "table",
            // we try to make the sizes just about 50%
            width: "calc(50% + 1px)",
            height: "calc(50% + 1px)"
        },
        "& .PixelPerfectInner": {
            // and scale this div 200% of this to make it an even number of pixels
            width: "200%",
            height: "200%",
            position: "absolute"
        },
        ".NoPixelPerfect & .PixelPerfectOuter": {
            display: "block",
            width: "100%",
            height: "100%"
        },
        ".NoPixelPerfect & .PixelPerfectInner": {
            width: "100%",
            height: "100%",
            position: "absolute"
        },
        "& .label.blurred": {
            opacity: 0.4
        }
    }
});
const $61b0792adb50d7bb$var$greyPath = (manual)=>"GreyPath " + (manual ? "Manual" : "Auto");
const $61b0792adb50d7bb$var$whitePath = "WhitePath";
const $61b0792adb50d7bb$var$make_brows = (manual)=>{
    const mustache_side = $61b0792adb50d7bb$var$PixelPath("M 0 0.90 C 0 1.1 1 0.85 1 1.15", $61b0792adb50d7bb$var$greyPath(manual));
    const mustache2x2 = /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, $61b0792adb50d7bb$var$PixelPath("M 1 1.1 L 1 0.8", "WhitePath"), mustache_side, /*#__PURE__*/ $bh6RR.createElement("g", {
        transform: "translate(2, 0) scale(-1,1)"
    }, mustache_side));
    const under = /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "AbsoluteSVG MustacheZ",
        style: {
            top: "15%",
            left: "0.5px"
        }
    }, /*#__PURE__*/ $bh6RR.createElement("svg", {
        height: "200%",
        width: "100%",
        viewBox: "0 0 2 2",
        preserveAspectRatio: "none"
    }, mustache2x2));
    const above = /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "AbsoluteSVG MustacheZ",
        style: {
            top: "-100%",
            left: "0.5px"
        }
    }, /*#__PURE__*/ $bh6RR.createElement("svg", {
        height: "200%",
        width: "100%",
        viewBox: "0 0 2 2",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $bh6RR.createElement("g", {
        transform: "translate(0,2) scale(1,-1)"
    }, mustache2x2)));
    return {
        under: under,
        above: above
    };
};
const $61b0792adb50d7bb$var$brows = [
    $61b0792adb50d7bb$var$make_brows(false),
    $61b0792adb50d7bb$var$make_brows(true)
];
function $61b0792adb50d7bb$var$PixelPath(d, className) {
    return /*#__PURE__*/ $bh6RR.createElement("path", {
        d: d,
        className: className,
        vectorEffect: "non-scaling-stroke"
    });
}
function $61b0792adb50d7bb$var$Line({ x0: x0, y0: y0, x1: x1, y1: y1 }, className) {
    const ff = x1 != 0.5;
    const yi = ff ? y1 : y0;
    const xi = ff ? x0 : x1;
    const d = `M ${x0} ${y0} C ${xi} ${yi} ${xi} ${yi} ${x1} ${y1}`;
    return $61b0792adb50d7bb$var$PixelPath(d, className);
}
function $61b0792adb50d7bb$var$LineIsHorizontal({ y0: y0, y1: y1 }) {
    return y0 == y1;
}
const { inserts: $61b0792adb50d7bb$var$inserts, deletes: $61b0792adb50d7bb$var$deletes } = $a0933ef57ff1c2b9$export$dce8637ca0d755f(()=>{
    const diff_to_spans = (rules)=>(token_diff)=>$fefc6099805237ea$export$cd0f44441c3b7719($a0933ef57ff1c2b9$export$dce8637ca0d755f(()=>{
                const out = [];
                token_diff.map(([type, text], i)=>{
                    const ignore = i == token_diff.length - 1 && text.trim().length == 0;
                    const node = ignore ? null : rules[type + 1](text);
                    if (node != null) out.push(node);
                });
                return out;
            }));
    const skip = ()=>null;
    const span = (text)=>/*#__PURE__*/ $bh6RR.createElement("span", null, text);
    const ins = (text)=>text.trim() ? /*#__PURE__*/ $bh6RR.createElement("ins", null, text) : span(text);
    const del = (text)=>text.trim() ? /*#__PURE__*/ $bh6RR.createElement("del", null, text) : span(text);
    return {
        inserts: diff_to_spans([
            skip,
            span,
            ins
        ]),
        deletes: diff_to_spans([
            del,
            span,
            skip
        ])
    };
});
function $61b0792adb50d7bb$export$3f508153b8c100a4(hover_id, id) {
    if (hover_id !== undefined) return id === hover_id ? "hover" : "";
    return "";
}
function $61b0792adb50d7bb$var$Column(column, rel = null) {
    const endpoint_id = column.filter((line)=>!$61b0792adb50d7bb$var$LineIsHorizontal(line)).map((line)=>line.meta.id)[0];
    const top = column.filter((line)=>line.meta.id == endpoint_id);
    const below = column.filter((line)=>line.meta.id != endpoint_id);
    return /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "RelativeSVG"
    }, rel, /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "AbsoluteSVG PixelPerfectOuter PathZ"
    }, /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "PixelPerfectInner"
    }, /*#__PURE__*/ $bh6RR.createElement("svg", {
        height: "100%",
        width: "100%",
        viewBox: "0 0 1 1",
        preserveAspectRatio: "none",
        style: {
            zIndex: -2
        }
    }, $fefc6099805237ea$export$cd0f44441c3b7719([
        ...below.map((line)=>$61b0792adb50d7bb$var$Line(line, $61b0792adb50d7bb$var$greyPath(line.meta.manual) + " " + (line.meta.hover ? " hover " : ""))),
        ...top.map((line)=>$61b0792adb50d7bb$var$Line(line, $61b0792adb50d7bb$var$whitePath + (below.length == 0 ? " CoversNothing" : ""))),
        ...top.map((line)=>$61b0792adb50d7bb$var$Line(line, $61b0792adb50d7bb$var$greyPath(line.meta.manual) + " " + (line.meta.hover ? " hover " : "")))
    ])))));
}
function $61b0792adb50d7bb$export$6a7fe3ef90e8d566(props) {
    const { graph: graph, richDiff: richDiff, orderChangingLabel: orderChangingLabel, onHover: onHover, onSelect: onSelect, hoverId: hoverId, selectedIds: selectedIds, mode: mode, side: side, labelMode: labelMode, labelSort: labelSort, generation: generation } = props;
    const selected_ids = selectedIds || [];
    const edges = graph.edges;
    // The rich diff can be calculated outside and given as a prop to reduce redraw cost.
    const rd0 = richDiff || $c625aec54bd34bcf$export$17043b50a1e129e6(graph, orderChangingLabel);
    const rd = $c625aec54bd34bcf$export$f01a9127b9ddc1c(rd0, side);
    const grids = $ad3f23047509641d$export$4e9beafb3583b360($ad3f23047509641d$export$7fde6103dc528d71(rd), ({ id: id })=>({
            id: id,
            manual: graph.edges[id].manual === true,
            hover: hoverId === id
        }));
    const u = grids.upper;
    const l = grids.lower;
    const c = $a0933ef57ff1c2b9$export$85b9a36db797e02b();
    return /*#__PURE__*/ $bh6RR.createElement("div", {
        className: [
            $61b0792adb50d7bb$var$GraphViewStyle,
            $fefc6099805237ea$export$962e3d5eaa2dc953,
            $fefc6099805237ea$export$3e30dc43d21f9d67,
            mode,
            "graphView"
        ].join(" ")
    }, rd.map((d, i)=>$fefc6099805237ea$export$dd164f5517779f15({
            ...d,
            index: undefined,
            u: u[i],
            l: l[i],
            hover_status: d.id === hoverId,
            e: edges[d.id],
            selected_status: edges[d.id].ids.map((x)=>selected_ids.some((id)=>id === x)),
            generation: generation,
            mode: mode,
            side: side
        }, d.id + "#" + c.inc(d.id), ()=>{
            function HoverSpan(token_id, v) {
                return /*#__PURE__*/ $bh6RR.createElement("span", {
                    key: token_id,
                    className: "Selectable" + (selected_ids.some((id)=>id === token_id) ? " Selected" : ""),
                    onMouseDown: (e)=>{
                        if (onSelect) {
                            onSelect([
                                token_id
                            ], !e.shiftKey && !e.ctrlKey && !e.metaKey);
                            e.stopPropagation();
                            e.preventDefault();
                        }
                    }
                }, v);
            }
            const labels = graph.edges[d.id].labels.filter((lbl)=>lbl.length > 0).sort(labelSort);
            const brow_threshold = side ? labels.length > 0 ? 0 : 1 : 1;
            const [s, t] = $a0933ef57ff1c2b9$export$dce8637ca0d755f(()=>{
                switch(d.edit){
                    case "Edited":
                        return [
                            /*#__PURE__*/ $bh6RR.createElement("div", {
                                style: {
                                    position: "relative"
                                },
                                className: $61b0792adb50d7bb$export$3f508153b8c100a4(hoverId, d.id)
                            }, d.source_diffs.map((ds, i)=>HoverSpan(d.source[i].id, $61b0792adb50d7bb$var$deletes(ds))), d.source.length > brow_threshold && $61b0792adb50d7bb$var$brows[~~d.manual].under),
                            /*#__PURE__*/ $bh6RR.createElement("div", {
                                style: {
                                    position: "relative"
                                },
                                className: $61b0792adb50d7bb$export$3f508153b8c100a4(hoverId, d.id)
                            }, d.target_diffs.map((ds, i)=>HoverSpan(d.target[i].id, $61b0792adb50d7bb$var$inserts(ds))), d.target.length > brow_threshold && $61b0792adb50d7bb$var$brows[~~d.manual].above)
                        ];
                    case "Dragged":
                        return [
                            /*#__PURE__*/ $bh6RR.createElement("div", null, HoverSpan(d.source.id, $61b0792adb50d7bb$var$deletes(d.source_diff))),
                            /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null)
                        ];
                    case "Dropped":
                        return [
                            /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null),
                            /*#__PURE__*/ $bh6RR.createElement("div", null, HoverSpan(d.target.id, $61b0792adb50d7bb$var$inserts(d.target_diff)))
                        ];
                }
            });
            const show_label_now = u[i].some((b)=>b.y1 == 1) || l[i].some((b)=>b.y1 == 0);
            const has_line_below_label = show_label_now && l[i].length > 0;
            const line_below_label = has_line_below_label && !side ? [
                {
                    x0: 0.5,
                    y0: 0,
                    x1: 0.5,
                    y1: 1,
                    meta: {
                        id: d.id,
                        manual: d.manual,
                        hover: d.id === hoverId
                    }
                }
            ] : [];
            const obs_class = labels.some((l)=>-1 != l.indexOf("!")) ? " OBS " : "";
            const mid = $61b0792adb50d7bb$var$Column(line_below_label, labels.length > 0 && show_label_now && /*#__PURE__*/ $bh6RR.createElement("div", {
                className: $61b0792adb50d7bb$export$6cb312a80b588f32 + " " + $61b0792adb50d7bb$export$3f508153b8c100a4(hoverId, d.id) + obs_class
            }, /*#__PURE__*/ $bh6RR.createElement("div", null, labels.map((l, i)=>/*#__PURE__*/ $bh6RR.createElement("span", {
                    key: i,
                    className: "label " + (labelMode && !labelMode(String(mode), l) ? "blurred" : "")
                }, l)))));
            const on_hover = (id)=>onHover && hoverId !== id && onHover(id);
            return /*#__PURE__*/ $bh6RR.createElement("ul", {
                "data-edge": d.id,
                onMouseDown: (e)=>{
                    //console.log('ul mousedown')
                    if (onSelect) {
                        onSelect(edges[d.id].ids, !e.shiftKey && !e.ctrlKey && !e.metaKey);
                        e.preventDefault();
                        e.stopPropagation();
                    }
                },
                onMouseEnter: ()=>on_hover(d.id),
                onMouseLeave: ()=>on_hover(undefined)
            }, side === "target" || /*#__PURE__*/ $bh6RR.createElement("li", {
                className: "top " + $61b0792adb50d7bb$export$3f508153b8c100a4(hoverId, d.id)
            }, s), !side && /*#__PURE__*/ $bh6RR.createElement("li", {
                className: "upper"
            }, $61b0792adb50d7bb$var$Column(u[i])), /*#__PURE__*/ $bh6RR.createElement("li", {
                className: (side || "") + " mid"
            }, mid), !side && /*#__PURE__*/ $bh6RR.createElement("li", {
                className: "lower"
            }, $61b0792adb50d7bb$var$Column(l[i])), side === "source" || /*#__PURE__*/ $bh6RR.createElement("li", {
                className: "bottom " + $61b0792adb50d7bb$export$3f508153b8c100a4(hoverId, d.id)
            }, t));
        })));
}
function $61b0792adb50d7bb$export$3c33041e45e0cc4(graph) {
    return /*#__PURE__*/ $bh6RR.createElement($61b0792adb50d7bb$export$6a7fe3ef90e8d566, {
        graph: graph
    });
}




function $4e3abe992249e14d$var$dragTracker(options) {
    "use strict";
    /*global Element*/ //Element.closest polyfill:
    //https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
    const ep = Element.prototype;
    if (!ep.matches) ep.matches = ep.msMatchesSelector || ep.webkitMatchesSelector;
    if (!ep.closest) ep.closest = function(s) {
        var node = this;
        do {
            if (node.matches(s)) return node;
            //https://github.com/Financial-Times/polyfill-service/issues/1279
            node = node.tagName === "svg" ? node.parentNode : node.parentElement;
        }while (node);
        return null;
    };
    options = options || {};
    const container = options.container || document.documentElement, selector = options.selector, callback = options.callback || console.log, callbackStart = options.callbackDragStart, callbackEnd = options.callbackDragEnd, //dragTracker may not play well with additional click events on the same container,
    //so we include the opportunity to register clicks as well:
    callbackClick = options.callbackClick, propagate = options.propagateEvents, roundCoords = options.roundCoords !== false, dragOutside = options.dragOutside !== false, //handleOffset: "center", true (default), false
    handleOffset = options.handleOffset || options.handleOffset !== false;
    //Whether callback coordinates should be the dragged element's center instead of the top-left corner
    let offsetToCenter = null;
    switch(handleOffset){
        case "center":
            offsetToCenter = true;
            break;
        case "topleft":
        case "top-left":
            offsetToCenter = false;
            break;
    }
    let dragged, mouseOffset, dragStart;
    function getMousePos(e, elm, offset, stayWithin) {
        let x = e.clientX, y = e.clientY;
        function respectBounds(value, min, max) {
            return Math.max(min, Math.min(value, max));
        }
        if (elm) {
            const bounds = elm.getBoundingClientRect();
            x -= bounds.left;
            y -= bounds.top;
            if (offset) {
                x -= offset[0];
                y -= offset[1];
            }
            if (stayWithin) {
                x = respectBounds(x, 0, bounds.width);
                y = respectBounds(y, 0, bounds.height);
            }
            //Adjust the mouseOffset on the dragged element
            //if the element is positioned by its center:
            if (elm !== container) {
                const center = offsetToCenter !== null ? offsetToCenter : elm.nodeName === "circle" || elm.nodeName === "ellipse";
                if (center) {
                    x -= bounds.width / 2;
                    y -= bounds.height / 2;
                }
            }
        }
        return roundCoords ? [
            Math.round(x),
            Math.round(y)
        ] : [
            x,
            y
        ];
    }
    function stopEvent(e) {
        e.preventDefault();
        if (!propagate) e.stopPropagation();
    }
    function onDown(e) {
        if (selector) dragged = selector instanceof Element ? selector.contains(e.target) ? selector : null : e.target.closest(selector);
        else //No specific targets, just register dragging within the container. Create a dummy object so 'dragged' isn't falsy:
        dragged = {};
        if (dragged) {
            stopEvent(e);
            mouseOffset = selector && handleOffset ? getMousePos(e, dragged) : [
                0,
                0
            ];
            dragStart = getMousePos(e, container, mouseOffset);
            if (roundCoords) dragStart = dragStart.map(Math.round);
            if (callbackStart) callbackStart(dragged, dragStart);
        }
    }
    function onMove(e) {
        if (!dragged) return;
        stopEvent(e);
        const pos = getMousePos(e, container, mouseOffset, !dragOutside);
        callback(dragged, pos, dragStart);
    }
    function onEnd(e) {
        if (!dragged) return;
        if (callbackEnd || callbackClick) {
            const pos = getMousePos(e, container, mouseOffset, !dragOutside);
            if (callbackClick && dragStart[0] === pos[0] && dragStart[1] === pos[1]) callbackClick(dragged, dragStart);
            //Call callbackEnd even if this was only a click, because we already called callbackStart:
            if (callbackEnd) callbackEnd(dragged, pos, dragStart);
        }
        dragged = null;
    }
    /* Mouse/touch input */ container.addEventListener("mousedown", function(e) {
        if (isLeftButton(e)) onDown(e);
    });
    container.addEventListener("touchstart", function(e) {
        relayTouch(e, onDown);
    });
    window.addEventListener("mousemove", function(e) {
        if (!dragged) return;
        if (isLeftButton(e)) onMove(e);
        else onEnd(e);
    });
    window.addEventListener("touchmove", function(e) {
        relayTouch(e, onMove);
    });
    window.addEventListener("mouseup", function(e) {
        //Here we check that the left button is *no longer* pressed:
        if (dragged && !isLeftButton(e)) onEnd(e);
    });
    function onTouchEnd(e) {
        onEnd(tweakTouch(e));
    }
    container.addEventListener("touchend", onTouchEnd);
    container.addEventListener("touchcancel", onTouchEnd);
    function isLeftButton(e) {
        return e.buttons !== undefined ? e.buttons === 1 : e.which === 1;
    }
    function relayTouch(e, handler) {
        //Don't interfere with pinch operations - those are probably handled somewhere else..
        if (e.touches.length !== 1) {
            onEnd(e);
            return;
        }
        handler(tweakTouch(e));
    }
    function tweakTouch(e) {
        let touch = e.targetTouches[0];
        //touchend:
        if (!touch) touch = e.changedTouches[0];
        touch.preventDefault = e.preventDefault.bind(e);
        touch.stopPropagation = e.stopPropagation.bind(e);
        return touch;
    }
}
var $4e3abe992249e14d$export$2e2bcd8739ae039 = $4e3abe992249e14d$var$dragTracker;


/* Inlined resize handle CSS */ document.documentElement.firstElementChild //<head>, or <body> if there is no <head>
.appendChild(document.createElement("style")).textContent = "## PLACEHOLDER-CSS ##";
function $690d46ecda1fad16$var$cmResize(cm, config) {
    config = config || {};
    const minW = config.minWidth || 200, minH = config.minHeight || 100, resizeW = config.resizableWidth !== false, resizeH = config.resizableHeight !== false, css = config.cssClass || "cm-resize-handle";
    const cmElement = cm.display.wrapper, cmHandle = config.handle || function() {
        const h = cmElement.appendChild(document.createElement("div"));
        h.className = css;
        return h;
    }();
    let startPos, startSize;
    (0, $4e3abe992249e14d$export$2e2bcd8739ae039)({
        //Might be a different parent container if we were given a custom handler element..
        //  container: cmElement,
        container: cmHandle.offsetParent,
        selector: cmHandle,
        callbackDragStart: (handle, pos)=>{
            startPos = pos;
            startSize = [
                cmElement.clientWidth,
                cmElement.clientHeight
            ];
        },
        callback: (handle, pos)=>{
            const diffX = pos[0] - startPos[0], diffY = pos[1] - startPos[1], cw = resizeW ? Math.max(minW, startSize[0] + diffX) : null, ch = resizeH ? Math.max(minH, startSize[1] + diffY) : null;
            cm.setSize(cw, ch);
            //Leave room for our default handle when only one scrollbar is visible:
            if (!config.handle) {
                cmElement.querySelector(".CodeMirror-vscrollbar").style.bottom = "18px";
                cmElement.querySelector(".CodeMirror-hscrollbar").style.right = "18px";
            }
        }
    });
    return cmHandle;
}
var $690d46ecda1fad16$export$2e2bcd8739ae039 = $690d46ecda1fad16$var$cmResize;


var $8fc89b11265b74ef$require$cmResize = $690d46ecda1fad16$export$2e2bcd8739ae039;
const $8fc89b11265b74ef$export$54e1eea512f4c5b = "ManualMark";
const $8fc89b11265b74ef$export$d0ff3e3bd464c3ec = "SelectedMark";
const $8fc89b11265b74ef$export$9a733f9a8912453a = "Hover";
function $8fc89b11265b74ef$var$CM(opts) {
    const div = document.createElement("div");
    const cm = $d6eaaf2d5469d0cb$exports(div, {
        lineWrapping: true,
        ...opts
    });
    $8fc89b11265b74ef$require$cmResize(cm, {
        resizableWidth: false,
        minHeight: 32,
        cssClass: "cm-resize-handle"
    });
    return {
        node: $fefc6099805237ea$export$f6b1e3902165e5e1(div, ()=>cm.refresh()),
        cm: cm
    };
}
function $8fc89b11265b74ef$var$defaultTabBehaviour(cm) {
    cm.on("keydown", (_, e)=>{
        if (e.key == "Tab") e.codemirrorIgnore = true;
    });
}
function $8fc89b11265b74ef$export$d3eec5620897e8c0(store, side, checkChange) {
    /* Note that we don't show the last character of the graph in the code mirror.
  It must necessarily be whitespace anyway. */ const graph = $7ce66515d279521f$export$46c0d0540c0c99ee(store);
    const advance = $7ce66515d279521f$export$2ae79f5e5d10736f(store);
    const realCheckChange = (change)=>!$7ce66515d279521f$export$d49663c289e0cae7(store.get()).state ? false : checkChange ? checkChange(change) : true;
    const { undo: undo, redo: redo } = $7ce66515d279521f$export$55abd4691b317664(store);
    const extraKeys = {
        "Ctrl-Z": undo,
        "Ctrl-Y": redo,
        "Cmd-Z": undo,
        "Cmd-Y": redo,
        "Alt-Right": transpose(1),
        "Alt-Left": transpose(-1),
        "Cmd-Right": transpose(1),
        "Cmd-Left": transpose(-1)
    };
    const { cm: cm, node: node } = $8fc89b11265b74ef$var$CM({
        extraKeys: extraKeys,
        tabindex: 3
    });
    $8fc89b11265b74ef$var$defaultTabBehaviour(cm);
    const { Index: Index } = $8fc89b11265b74ef$var$PositionUtils(cm, store, side);
    function transpose(d) {
        return ()=>{
            if (!realCheckChange({
                type: "transpose"
            })) return;
            const h = Index.cursor("head").toToken().index;
            const a = Index.cursor("anchor").toToken().index;
            if (h != null && a != null) {
                const [begin, end] = $a0933ef57ff1c2b9$export$bab4a1db406f2fa9([
                    h,
                    a
                ]);
                const g = graph.get();
                const N = g[side].length;
                if ($a0933ef57ff1c2b9$export$f28d906d67a997f3(0, begin + d, N) && $a0933ef57ff1c2b9$export$f28d906d67a997f3(0, end + d, N)) {
                    advance(()=>graph.set($566cb6e3cba7cd4f$export$3286e37e80af903(g, begin, end, d > 0 ? end + d : begin + d)));
                    // update CM text now to set the selection at the moved word(s)
                    graph_to_cm();
                    const g2 = graph.get();
                    // set the selection to the displaced word:
                    const from = $566cb6e3cba7cd4f$export$45415d7f69065d4f(g2, side).slice(0, begin + d).join("").length;
                    const to = $566cb6e3cba7cd4f$export$45415d7f69065d4f(g2, side).slice(0, end + d + 1).join("").length - 1;
                    const doc = cm.getDoc();
                    doc.setSelection(doc.posFromIndex(from), doc.posFromIndex(to));
                    cursor_to_viewport();
                }
            }
        };
    }
    cm.on("beforeChange", (editor, change)=>{
        if (change.origin == "undo") {
            change.cancel();
            undo();
        } else if (change.origin == "redo") {
            change.cancel();
            redo();
        }
        // Why is removed not set? Set it.
        if (change.origin.substr(1) == "delete") change.removed = editor.getDoc().getRange(change.from, change.to).split("\n");
        // Only check manual user-made changes. Programmatic changes should set the origin to @ignore.
        if (change.origin !== "@ignore" && !realCheckChange({
            type: "editor",
            change: change
        })) change.cancel();
    });
    cm.on("mousedown", ()=>$7ce66515d279521f$export$5bb86370ea51314a(store));
    function cursor_to_viewport() {
        $a0933ef57ff1c2b9$export$d6ed4c2f46abc031("cursor_to_viewport", ()=>{
            const g = graph.get();
            const text = $566cb6e3cba7cd4f$export$e9abecb4b4534687(graph.get(), side);
            const doc = cm.getDoc();
            const head = Index.cursor("head").index;
            const anchor = Index.cursor("anchor").index;
            head && anchor && $7ce66515d279521f$export$68c05593fd98348a(store, $566cb6e3cba7cd4f$export$33eaa0f45f0e6960(graph.get(), side, [
                head,
                anchor
            ]));
        });
    }
    cm.on("cursorActivity", (_)=>store.transaction(()=>{
            cursor_to_viewport();
            $a0933ef57ff1c2b9$export$9be1301193883bb5(store.at("hover_id"), undefined);
        }));
    function do_texts_differ() {
        const graph_text = $566cb6e3cba7cd4f$export$e9abecb4b4534687($7ce66515d279521f$export$9a86c1ce88ca19ad(store), side).slice(0, -1);
        const editor_text = cm.getDoc().getValue();
        if (graph_text !== editor_text) return {
            graph_text: graph_text,
            editor_text: editor_text
        };
        else return undefined;
    }
    cm.on("scrollCursorIntoView", (_, e)=>{
        //console.log('scroll cursor into view', e)
        e.preventDefault();
    });
    cm.on("change", (_, change)=>{
        if (do_texts_differ()) advance((g)=>{
            graph.set($566cb6e3cba7cd4f$export$d1eddfd431b5acad(g, side, cm.getDoc().getValue() + " "));
        });
    });
    function graph_to_cm() {
        const t = do_texts_differ();
        if (t) {
            const { from: from, to: to, insert: insert } = $a0933ef57ff1c2b9$export$5160ab928f687bd(t.editor_text, t.graph_text);
            const doc = cm.getDoc();
            doc.replaceRange(insert, doc.posFromIndex(from), doc.posFromIndex(to), "@ignore");
        }
    }
    cm.getWrapperElement().addEventListener("mousemove", (e)=>{
        const i = Index.fromCoords(e);
        const { edge: edge } = i.toEdge();
        store.transaction(()=>{
            $a0933ef57ff1c2b9$export$9be1301193883bb5(store.at("hover_id"), edge ? edge.id : undefined);
        });
    });
    cm.getWrapperElement().addEventListener("mouseleave", (e)=>{
        store.at("hover_id").set(undefined);
    });
    function set_marks() {
        $a0933ef57ff1c2b9$export$d6ed4c2f46abc031("set_marks", ()=>{
            cm.operation(()=>{
                const doc = cm.getDoc();
                doc.getAllMarks().map((m)=>m.clear());
                const g = $7ce66515d279521f$export$9a86c1ce88ca19ad(store);
                const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
                const hover_id = store.get().hover_id;
                let i = 0;
                g[side].forEach((tok)=>{
                    const n = tok.text.length;
                    const e = em.get(tok.id);
                    function mark_me(opts) {
                        const from = doc.posFromIndex(i);
                        const to = doc.posFromIndex(i + n - (tok.text.match(/\s$/) || "").length);
                        doc.markText(from, to, opts);
                    }
                    tok.id in store.get().selected && mark_me({
                        className: $8fc89b11265b74ef$export$d0ff3e3bd464c3ec
                    });
                    if (e) {
                        e.manual && mark_me({
                            className: $8fc89b11265b74ef$export$54e1eea512f4c5b
                        });
                        const className = $61b0792adb50d7bb$export$3f508153b8c100a4(hover_id, e.id);
                        className && mark_me({
                            className: className
                        });
                    }
                    i += n;
                });
            });
        });
    }
    function sync() {
        graph_to_cm();
        set_marks();
    }
    store.on(sync);
    sync();
    store.at("selected").ondiff((selected)=>{
        scrollTokensIntoView(Object.keys(selected));
    });
    function scrollTokensIntoView(token_ids) {
        const g = graph.get();
        const tokens = $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(g)(token_ids)[side].sort();
        if (!tokens.length) return;
        // Turn first and last token indexes to CM positions.
        const [from, to] = $a0933ef57ff1c2b9$export$2bf2d3a3b8f5f2c5(tokens).map((t)=>{
            const sided_index = $566cb6e3cba7cd4f$export$a669ad57b3bc989b(g).get(t.id);
            return sided_index ? Index.fromTokenIndex(sided_index.index).toPos() : null;
        });
        from && to && cm.scrollIntoView({
            from: from,
            to: to
        }, 0);
    }
    return {
        node: node,
        cm: cm
    };
}
function $8fc89b11265b74ef$var$PositionUtils(cm, store, side) {
    class Edge {
        constructor(edge){
            this.edge = edge;
        }
    }
    class Token {
        constructor(index, token){
            this.index = index;
            this.token = token;
        }
        toEdge() {
            if (this.token) {
                const g = $7ce66515d279521f$export$9a86c1ce88ca19ad(store);
                const em = $566cb6e3cba7cd4f$export$13b0e7a577fb573c(g);
                const edge = em.get(this.token.id);
                if (edge) return new Edge(edge);
            }
            return new Edge(null);
        }
    }
    class Index {
        constructor(index){
            this.index = index;
        }
        static cursor(end = "head") {
            const doc = cm.getDoc();
            const sels = cm.getDoc().listSelections();
            return new Index(sels ? doc.indexFromPos(sels[0][end]) : null);
        }
        static fromCoords(e) {
            const coord = cm.coordsChar({
                left: e.pageX,
                top: e.pageY
            });
            if (!("outside" in coord)) return new Index(cm.getDoc().indexFromPos(coord));
            else return new Index(null);
        }
        static fromTokenIndex(tok_i) {
            const g = $7ce66515d279521f$export$9a86c1ce88ca19ad(store);
            const i = $566cb6e3cba7cd4f$export$45415d7f69065d4f(g, side).slice(0, tok_i).join("").length;
            return new Index(i);
        }
        toEdge() {
            return this.toToken().toEdge();
        }
        toToken() {
            if (this.index != null) {
                const g = $7ce66515d279521f$export$9a86c1ce88ca19ad(store);
                const { token: token } = $58ccaae15ba3b7ae$export$162b77d70e08a240($566cb6e3cba7cd4f$export$45415d7f69065d4f(g, side), this.index);
                if (token in g[side]) return new Token(token, g[side][token]);
            }
            return new Token(null, null);
        }
        toPos() {
            return this.index ? cm.getDoc().posFromIndex(this.index) : null;
        }
    }
    return {
        Edge: Edge,
        Token: Token,
        Index: Index
    };
}



var $bh6RR = parcelRequire("bh6RR");


var $4LfDI = parcelRequire("4LfDI");






var $bh6RR = parcelRequire("bh6RR");

var $4293c27bcfbce771$exports = {};
"use strict";


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
const $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    let buf = $d4ecdbf520e63dca$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    const buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        const len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        const buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) buf = $d4ecdbf520e63dca$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $d4ecdbf520e63dca$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $d4ecdbf520e63dca$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigUInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64LE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$d4ecdbf520e63dca$var$Buffer.prototype.writeBigInt64BE = $d4ecdbf520e63dca$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $d4ecdbf520e63dca$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $d4ecdbf520e63dca$var$errors = {};
function $d4ecdbf520e63dca$var$E(sym, getMessage, Base) {
    $d4ecdbf520e63dca$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$d4ecdbf520e63dca$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$d4ecdbf520e63dca$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$d4ecdbf520e63dca$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $d4ecdbf520e63dca$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $d4ecdbf520e63dca$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $d4ecdbf520e63dca$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength) {
    $d4ecdbf520e63dca$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $d4ecdbf520e63dca$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $d4ecdbf520e63dca$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $d4ecdbf520e63dca$var$checkBounds(buf, offset, byteLength);
}
function $d4ecdbf520e63dca$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $d4ecdbf520e63dca$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $d4ecdbf520e63dca$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $d4ecdbf520e63dca$var$validateNumber(value, type);
        throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $d4ecdbf520e63dca$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $d4ecdbf520e63dca$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $d4ecdbf520e63dca$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $d4ecdbf520e63dca$var$BufferBigIntNotDefined : fn;
}
function $d4ecdbf520e63dca$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $1c89f70938c625a7$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
const $1c89f70938c625a7$var$tEXt = "tEXt";
var $ed66684f8d888805$exports = {};
var $51b4819b61af78fe$exports = {};
/* crc32.js (C) 2014-2015 SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ 
var $51b4819b61af78fe$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
var $51b4819b61af78fe$var$CRC32;
(function(factory) {
    if (typeof DO_NOT_EXPORT_CRC === "undefined") factory($51b4819b61af78fe$exports);
    else factory($51b4819b61af78fe$var$CRC32 = {});
})(function(CRC32) {
    CRC32.version = "0.3.0";
    /* see perf/crc32table.js */ function signed_crc_table() {
        var c = 0, table = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var table = signed_crc_table();
    /* charCodeAt is the best approach for binary strings */ var use_buffer = typeof $51b4819b61af78fe$require$Buffer !== "undefined";
    function crc32_bstr(bstr) {
        if (bstr.length > 32768) {
            if (use_buffer) return crc32_buf_8(new $51b4819b61af78fe$require$Buffer(bstr));
        }
        var crc = -1, L = bstr.length - 1;
        for(var i = 0; i < L;){
            crc = table[(crc ^ bstr.charCodeAt(i++)) & 0xFF] ^ crc >>> 8;
            crc = table[(crc ^ bstr.charCodeAt(i++)) & 0xFF] ^ crc >>> 8;
        }
        if (i === L) crc = crc >>> 8 ^ table[(crc ^ bstr.charCodeAt(i)) & 0xFF];
        return crc ^ -1;
    }
    function crc32_buf(buf) {
        if (buf.length > 10000) return crc32_buf_8(buf);
        for(var crc = -1, i = 0, L = buf.length - 3; i < L;){
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        }
        while(i < L + 3)crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        return crc ^ -1;
    }
    function crc32_buf_8(buf) {
        for(var crc = -1, i = 0, L = buf.length - 7; i < L;){
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
            crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        }
        while(i < L + 7)crc = crc >>> 8 ^ table[(crc ^ buf[i++]) & 0xFF];
        return crc ^ -1;
    }
    /* much much faster to intertwine utf8 and crc */ function crc32_str(str) {
        for(var crc = -1, i = 0, L = str.length, c, d; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) crc = crc >>> 8 ^ table[(crc ^ c) & 0xFF];
            else if (c < 0x800) {
                crc = crc >>> 8 ^ table[(crc ^ (192 | c >> 6 & 31)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                crc = crc >>> 8 ^ table[(crc ^ (240 | c >> 8 & 7)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c >> 2 & 63)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | d >> 6 & 15 | c & 3)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | d & 63)) & 0xFF];
            } else {
                crc = crc >>> 8 ^ table[(crc ^ (224 | c >> 12 & 15)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c >> 6 & 63)) & 0xFF];
                crc = crc >>> 8 ^ table[(crc ^ (128 | c & 63)) & 0xFF];
            }
        }
        return crc ^ -1;
    }
    CRC32.table = table;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
});


$ed66684f8d888805$exports = $ed66684f8d888805$var$extractChunks;
// Used for fast-ish conversion between uint8s and uint32s/int32s.
// Also required in order to remain agnostic for both Node Buffers and
// Uint8Arrays.
var $ed66684f8d888805$var$uint8 = new Uint8Array(4);
var $ed66684f8d888805$var$int32 = new Int32Array($ed66684f8d888805$var$uint8.buffer);
var $ed66684f8d888805$var$uint32 = new Uint32Array($ed66684f8d888805$var$uint8.buffer);
function $ed66684f8d888805$var$extractChunks(data) {
    if (data[0] !== 0x89) throw new Error("Invalid .png file header");
    if (data[1] !== 0x50) throw new Error("Invalid .png file header");
    if (data[2] !== 0x4E) throw new Error("Invalid .png file header");
    if (data[3] !== 0x47) throw new Error("Invalid .png file header");
    if (data[4] !== 0x0D) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    if (data[5] !== 0x0A) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    if (data[6] !== 0x1A) throw new Error("Invalid .png file header");
    if (data[7] !== 0x0A) throw new Error("Invalid .png file header: possibly caused by DOS-Unix line ending conversion?");
    var ended = false;
    var chunks = [];
    var idx = 8;
    while(idx < data.length){
        // Read the length of the current chunk,
        // which is stored as a Uint32.
        $ed66684f8d888805$var$uint8[3] = data[idx++];
        $ed66684f8d888805$var$uint8[2] = data[idx++];
        $ed66684f8d888805$var$uint8[1] = data[idx++];
        $ed66684f8d888805$var$uint8[0] = data[idx++];
        // Chunk includes name/type for CRC check (see below).
        var length = $ed66684f8d888805$var$uint32[0] + 4;
        var chunk = new Uint8Array(length);
        chunk[0] = data[idx++];
        chunk[1] = data[idx++];
        chunk[2] = data[idx++];
        chunk[3] = data[idx++];
        // Get the name in ASCII for identification.
        var name = String.fromCharCode(chunk[0]) + String.fromCharCode(chunk[1]) + String.fromCharCode(chunk[2]) + String.fromCharCode(chunk[3]);
        // The IHDR header MUST come first.
        if (!chunks.length && name !== "IHDR") throw new Error("IHDR header missing");
        // The IEND header marks the end of the file,
        // so on discovering it break out of the loop.
        if (name === "IEND") {
            ended = true;
            chunks.push({
                name: name,
                data: new Uint8Array(0)
            });
            break;
        }
        // Read the contents of the chunk out of the main buffer.
        for(var i = 4; i < length; i++)chunk[i] = data[idx++];
        // Read out the CRC value for comparison.
        // It's stored as an Int32.
        $ed66684f8d888805$var$uint8[3] = data[idx++];
        $ed66684f8d888805$var$uint8[2] = data[idx++];
        $ed66684f8d888805$var$uint8[1] = data[idx++];
        $ed66684f8d888805$var$uint8[0] = data[idx++];
        var crcActual = $ed66684f8d888805$var$int32[0];
        var crcExpect = $51b4819b61af78fe$exports.buf(chunk);
        if (crcExpect !== crcActual) throw new Error("CRC values for " + name + " header do not match, PNG file is likely corrupted");
        // The chunk data is now copied to remove the 4 preceding
        // bytes used for the chunk name/type.
        var chunkData = new Uint8Array(chunk.buffer.slice(4));
        chunks.push({
            name: name,
            data: chunkData
        });
    }
    if (!ended) throw new Error(".png file ended prematurely: no IEND header was found");
    return chunks;
}


var $780870197a36e49e$exports = {};
var $d93ee1f0333d77da$exports = {};
/**
 * An Array.prototype.slice.call(arguments) alternative
 *
 * @param {Object} args something with a length
 * @param {Number} slice
 * @param {Number} sliceEnd
 * @api public
 */ $d93ee1f0333d77da$exports = function(args, slice, sliceEnd) {
    var ret = [];
    var len = args.length;
    if (0 === len) return ret;
    var start = slice < 0 ? Math.max(0, slice + len) : slice || 0;
    if (sliceEnd !== undefined) len = sliceEnd < 0 ? sliceEnd + len : sliceEnd;
    while(len-- > start)ret[len - start] = args[len];
    return ret;
};



$780870197a36e49e$exports = $780870197a36e49e$var$encodeChunks;
// Used for fast-ish conversion between uint8s and uint32s/int32s.
// Also required in order to remain agnostic for both Node Buffers and
// Uint8Arrays.
var $780870197a36e49e$var$uint8 = new Uint8Array(4);
var $780870197a36e49e$var$int32 = new Int32Array($780870197a36e49e$var$uint8.buffer);
var $780870197a36e49e$var$uint32 = new Uint32Array($780870197a36e49e$var$uint8.buffer);
function $780870197a36e49e$var$encodeChunks(chunks) {
    var totalSize = 8;
    var idx = totalSize;
    var i;
    for(i = 0; i < chunks.length; i++){
        totalSize += chunks[i].data.length;
        totalSize += 12;
    }
    var output = new Uint8Array(totalSize);
    output[0] = 0x89;
    output[1] = 0x50;
    output[2] = 0x4E;
    output[3] = 0x47;
    output[4] = 0x0D;
    output[5] = 0x0A;
    output[6] = 0x1A;
    output[7] = 0x0A;
    for(i = 0; i < chunks.length; i++){
        var chunk = chunks[i];
        var name = chunk.name;
        var data = chunk.data;
        var size = data.length;
        var nameChars = [
            name.charCodeAt(0),
            name.charCodeAt(1),
            name.charCodeAt(2),
            name.charCodeAt(3)
        ];
        $780870197a36e49e$var$uint32[0] = size;
        output[idx++] = $780870197a36e49e$var$uint8[3];
        output[idx++] = $780870197a36e49e$var$uint8[2];
        output[idx++] = $780870197a36e49e$var$uint8[1];
        output[idx++] = $780870197a36e49e$var$uint8[0];
        output[idx++] = nameChars[0];
        output[idx++] = nameChars[1];
        output[idx++] = nameChars[2];
        output[idx++] = nameChars[3];
        for(var j = 0; j < size;)output[idx++] = data[j++];
        var crcCheck = nameChars.concat($d93ee1f0333d77da$exports(data));
        var crc = $51b4819b61af78fe$exports.buf(crcCheck);
        $780870197a36e49e$var$int32[0] = crc;
        output[idx++] = $780870197a36e49e$var$uint8[3];
        output[idx++] = $780870197a36e49e$var$uint8[2];
        output[idx++] = $780870197a36e49e$var$uint8[1];
        output[idx++] = $780870197a36e49e$var$uint8[0];
    }
    return output;
}


var $93f220e6385f0c39$export$c564cdbbe6da493;
var $93f220e6385f0c39$export$2f872c0f2117be69;

$93f220e6385f0c39$export$c564cdbbe6da493 = (parcelRequire("eSIsJ"));

$93f220e6385f0c39$export$2f872c0f2117be69 = (parcelRequire("hJOiA"));


const $1c89f70938c625a7$export$c333d90108c82a4f = {
    set (key, data, png_buffer) {
        const chunks = $ed66684f8d888805$exports(png_buffer).filter((chunk)=>chunk.name != $1c89f70938c625a7$var$tEXt || $93f220e6385f0c39$export$2f872c0f2117be69(chunk.data).keyword != key);
        // URI-encode because png tEXt must be all latin1
        // I chose this over base64 because I wanted the data to be somewhat readable
        const new_chunk = $93f220e6385f0c39$export$c564cdbbe6da493(key, encodeURI(JSON.stringify(data)));
        // Add new chunk before the IEND chunk
        chunks.splice(-1, 0, new_chunk);
        return new $1c89f70938c625a7$require$Buffer($780870197a36e49e$exports(chunks));
    },
    get (key, png_buffer) {
        const chunks = $ed66684f8d888805$exports(png_buffer);
        for (const chunk of chunks){
            if (chunk.name === $1c89f70938c625a7$var$tEXt) try {
                const kv = $93f220e6385f0c39$export$2f872c0f2117be69(chunk.data);
                if (kv.keyword === key) return JSON.parse(decodeURI(kv.text));
            } catch (e) {}
        }
        return undefined;
    }
};
const $1c89f70938c625a7$export$c55ac7a57c597ab = {
    set (key, data, infile, outfile) {
        $4293c27bcfbce771$exports.writeFileSync(outfile, $1c89f70938c625a7$export$c333d90108c82a4f.set(key, data, $4293c27bcfbce771$exports.readFileSync(infile)));
    },
    get (key, infile) {
        return $1c89f70938c625a7$export$c333d90108c82a4f.get(key, $4293c27bcfbce771$exports.readFileSync(infile));
    }
};




const $930bde7a2384eb68$export$5c75055b9a66b471 = "mode:anon ";
function $930bde7a2384eb68$export$7019fddfdf911435(d) {
    return (d.anon_mode ? $930bde7a2384eb68$export$5c75055b9a66b471 : "") + $8f42eafc2f1b3c8d$export$18523638253a9637(d.graph);
}
function $930bde7a2384eb68$export$eccf2f85c6977700(graph, anon_mode) {
    return {
        graph: graph,
        anon_mode: anon_mode
    };
}
function $930bde7a2384eb68$export$fb1a51131ac00a0(query_string) {
    const [a, b] = $a60e80e084e1281e$export$2e2bcd8739ae039($930bde7a2384eb68$export$5c75055b9a66b471.length, query_string);
    const anon_mode = a == $930bde7a2384eb68$export$5c75055b9a66b471;
    const s = anon_mode ? b : query_string;
    return {
        graph: $8f42eafc2f1b3c8d$export$c4038c4546988c18(s),
        anon_mode: anon_mode
    };
}
const $930bde7a2384eb68$export$df61b30b684217c0 = "swell0";



var $4LfDI = parcelRequire("4LfDI");

var $6f4fc6e76261e086$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;
const $6f4fc6e76261e086$var$ambient = (0, $4LfDI.style)({
    ...$a0933ef57ff1c2b9$export$9acf59296ec0cce1("DropZone_ambient"),
    border: "0.3em dashed #0000",
    margin: "0.1em",
    width: "100%",
    height: "100%"
});
const $6f4fc6e76261e086$var$dropping = (0, $4LfDI.style)({
    ...$a0933ef57ff1c2b9$export$9acf59296ec0cce1("DropZone_dropping"),
    borderColor: "#ccc !important",
    width: "100%",
    height: "100%"
});
const $6f4fc6e76261e086$var$dropTargetClass = (b)=>$6f4fc6e76261e086$var$ambient + " " + (b ? $6f4fc6e76261e086$var$dropping : "");
const $6f4fc6e76261e086$var$log = (...xs)=>void 0 // console.log(...xs)
;
class $6f4fc6e76261e086$export$3c6489d84dc98b6 extends $bh6RR.Component {
    constructor(p){
        super(p);
        this._set_drop_target = $a0933ef57ff1c2b9$export$61fc7d43ac8f84b0(50, (b)=>{
            $6f4fc6e76261e086$var$log("setting drop target", this.state, b);
            this.state.drop_target != b && this.setState({
                drop_target: b
            });
        });
        this.state = {
            drop_target: false
        };
    }
    _onDrop(e) {
        this.setState({
            drop_target: false
        });
        e.preventDefault();
        e.stopPropagation();
        const dt = e.dataTransfer;
        $6f4fc6e76261e086$var$log(dt.files);
        $6f4fc6e76261e086$var$log(dt.items);
        $6f4fc6e76261e086$var$log(dt.types);
        const files = Array.from(dt.files);
        const items = Array.from(dt.items);
        $6f4fc6e76261e086$var$log("items", dt.items.length);
        items.forEach((item, ix)=>{
            $6f4fc6e76261e086$var$log(item);
            item.getAsString((s)=>{
                $6f4fc6e76261e086$var$log(item, ix, "as string:", s);
                const m_url = s.match(/https?:[A-Za-z0-9%\-._~:\/?#@!$&'*+,;=`.]+/);
                if (this.props.webserviceURL && m_url) {
                    const url = m_url[0];
                    $6f4fc6e76261e086$var$log(url, "looks like an address");
                    const query_url = this.props.webserviceURL + "/metadata.json?" + encodeURIComponent(url);
                    $a0933ef57ff1c2b9$export$1bb358554aac31c1(query_url, (str)=>{
                        const data = JSON.parse(str);
                        $6f4fc6e76261e086$var$log(data, "from", url);
                        this.props.onDrop(data);
                    });
                }
            });
            try {
                const file = item.getAsFile();
                file && files.push(file);
            } catch (e) {
                $6f4fc6e76261e086$var$log("item not a file:", item, e);
            }
        });
        $6f4fc6e76261e086$var$log("files", files);
        files.forEach((file)=>{
            $6f4fc6e76261e086$var$log(file, file);
            const r = new FileReader();
            r.readAsArrayBuffer(file);
            r.onload = ()=>{
                $6f4fc6e76261e086$var$log("readyState", r.readyState);
                if (r.readyState === 2) try {
                    const buf = $6f4fc6e76261e086$require$Buffer.from(r.result);
                    const data = $1c89f70938c625a7$export$c333d90108c82a4f.get((0, $930bde7a2384eb68$export$df61b30b684217c0), buf);
                    $6f4fc6e76261e086$var$log({
                        data: data
                    });
                    this.props.onDrop(data);
                } catch (e) {
                    $6f4fc6e76261e086$var$log("file not a png with meta data:", file, r.result);
                }
            };
        });
        return false;
    }
    render() {
        const onDragOver = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.state.drop_target || this.setState({
                drop_target: true
            });
            this._set_drop_target(true);
            return false;
        };
        return /*#__PURE__*/ $bh6RR.createElement("div", {
            className: $6f4fc6e76261e086$var$dropTargetClass(this.state.drop_target),
            onDrop: (e)=>this._onDrop(e),
            onDragLeave: (e)=>{
                $6f4fc6e76261e086$var$log("drag leave");
                e.preventDefault();
                this._set_drop_target(false);
                return false;
            },
            onDragOver: onDragOver,
            onDragEnter: onDragOver
        }, this.props.children);
    }
}






var $bh6RR = parcelRequire("bh6RR");

var $4LfDI = parcelRequire("4LfDI");





const $d0b6c04ea853e168$var$LabelSidekickStyle = (0, $4LfDI.style)({
    ...$a0933ef57ff1c2b9$export$9acf59296ec0cce1("LabelSidekickStyle"),
    $nest: {
        "& .entry": {
            cursor: "pointer",
            padding: "0 5px"
        },
        "& .cursor": {
            background: "#c2e0ff",
            borderRadius: 5,
            padding: "0 5px"
        },
        "& .selected": {
            color: "blue",
            fontWeight: 700
        },
        "& ul ul": {
            paddingLeft: 10,
            marginRight: 5,
            marginLeft: 0
        },
        "&": {
            zIndex: 20,
            position: [
                "-webkit-sticky",
                "sticky"
            ],
            marginRight: "10px",
            margin: 0,
            padding: 1,
            display: "flex",
            flexDirection: "column",
            maxHeight: "92vh"
        },
        "& > * > button": {
            width: "47%",
            marginBottom: "5px"
        },
        "& .taxonomy": {
            overflowY: "auto"
        }
    }
});
class $d0b6c04ea853e168$export$931cbfb6bfb85fc extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            cursor: 0
        };
    }
    render() {
        const props = this.props;
        const { taxonomy: taxonomy, selected: selected, mode: mode } = this.props;
        const { cursor: cursor } = this.state;
        const labels = $a0933ef57ff1c2b9$export$5b8affa63fc6df16(taxonomy, (g)=>g.entries.map((e)=>e.label));
        function isSelected(l) {
            return selected.some((s)=>s === l);
        }
        function isDigit(l) {
            return /^\d+$/.test(l);
        }
        function set(l) {
            props.onChange(l, true);
        }
        function unset(l) {
            props.onChange(l, false);
        }
        function toggle(l) {
            if (isSelected(l)) unset(l);
            else set(l);
        }
        function wrap(c) {
            const N = labels.length;
            return (c + N) % N;
        }
        function new_cursor(base, sign = 1, m = /.*/) {
            for(let i = 0; i < labels.length; i++){
                const c = wrap(base + i * sign);
                if (m.test(labels[c])) return c;
            }
            return cursor;
        }
        const liberal_re = (s)=>new RegExp("^" + s.split("").join("-?"), "i");
        const entry_span = (label, c)=>{
            const classes = (cursor == c ? " cursor" : "") + (isSelected(label) ? " selected" : "");
            return /*#__PURE__*/ $bh6RR.createElement("span", {
                className: "entry" + classes,
                onMouseOver: (evt)=>{
                    // Only on mouse move, not when triggered by scroll.
                    if (c && (!evt || evt.nativeEvent.movementX || evt.nativeEvent.movementY)) this.setState({
                        cursor: c
                    });
                },
                onMouseDown: (e)=>{
                    toggle(label);
                    e.preventDefault();
                }
            }, label);
        };
        const list = $a0933ef57ff1c2b9$export$dce8637ca0d755f(()=>{
            let c = 0;
            return /*#__PURE__*/ $bh6RR.createElement("ul", {
                className: "taxonomy",
                ref: "taxonomy"
            }, props.mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization && selected.filter(isDigit).map((i)=>/*#__PURE__*/ $bh6RR.createElement("li", {
                    key: "d" + i
                }, entry_span(i + ""))), taxonomy.map((g, i)=>/*#__PURE__*/ $bh6RR.createElement("li", {
                    key: i
                }, /*#__PURE__*/ $bh6RR.createElement("b", null, g.group), /*#__PURE__*/ $bh6RR.createElement("ul", null, g.entries.map((e, i)=>{
                    return /*#__PURE__*/ $bh6RR.createElement("li", {
                        ref: "tax_item" + c,
                        key: i,
                        title: e.desc
                    }, entry_span(e.label, c++));
                })))));
        });
        const scrollToCursor = (cursor)=>{
            const parent = this.refs["taxonomy"];
            const height = parent.clientHeight + parent.scrollTop;
            const parentTop = parent.offsetTop;
            const offsetTop = this.refs["tax_item" + cursor].offsetTop - parentTop;
            if (offsetTop + 50 > height) parent.scrollTop = offsetTop;
            else if (offsetTop - 30 < parent.scrollTop) parent.scrollTop = offsetTop - 30;
        };
        const input = /*#__PURE__*/ $bh6RR.createElement("input", {
            onMouseDown: (e)=>e.currentTarget.focus(),
            ref: (e)=>{
                if (e && document.activeElement && !/\bkeepfocus\b/.test(document.activeElement.className)) {
                    const x = window.scrollX;
                    const y = window.scrollY;
                    e.focus();
                    window.scrollTo(x, y);
                }
            },
            placeholder: mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization ? this.props.extraInput ? "Extra input" : "Filter / numeric label" : "Enter filter text",
            onKeyDown: (e)=>{
                const t = e.target;
                if (e.key === "Enter" || e.key === " ") {
                    if (this.props.extraInput) {
                        this.props.extraInput.set(t.value);
                        t.value = "";
                    } else if (isDigit(t.value)) {
                        toggle(t.value);
                        t.value = "";
                    } else {
                        toggle(labels[cursor]);
                        t.value = "";
                    }
                    e.preventDefault();
                } else if (e.key === "Backspace") {
                    if (t.value == "" && selected.length > 0) unset(selected[selected.length - 1]);
                } else if (e.key === "ArrowDown") {
                    const c = new_cursor(cursor + 1, 1);
                    this.setState({
                        cursor: c
                    });
                    scrollToCursor(c);
                    e.preventDefault();
                } else if (e.key === "ArrowUp") {
                    const c = new_cursor(cursor - 1, -1);
                    this.setState({
                        cursor: c
                    });
                    scrollToCursor(c);
                    e.preventDefault();
                } else if (e.key === "Tab") {
                    if (e.shiftKey) {
                        const c = new_cursor(cursor - 1, -1, liberal_re(t.value));
                        this.setState({
                            cursor: c
                        });
                        scrollToCursor(c);
                    } else {
                        const c = new_cursor(cursor + 1, 1, liberal_re(t.value));
                        this.setState({
                            cursor: c
                        });
                        scrollToCursor(c);
                    }
                    e.preventDefault();
                } else if (!e.altKey && !e.ctrlKey && !e.metaKey) {
                    const c = new_cursor(cursor, 1, liberal_re(t.value + e.key));
                    scrollToCursor(c);
                    this.setState({
                        cursor: c
                    });
                }
                this.props.onKeyDown && this.props.onKeyDown(e);
            }
        });
        return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, input, list);
    }
}
function $d0b6c04ea853e168$export$775a140956cd095a({ store: store, taxonomy: taxonomy, mode: mode, extraInput: extraInput, disabled: disabled }) {
    const graph = store.at("graph").at("now");
    const selected = Object.keys(store.get().selected);
    const advance = $7ce66515d279521f$export$2ae79f5e5d10736f(store);
    if (selected.length > 0) {
        const edges = $566cb6e3cba7cd4f$export$8d414a6135f9d320(graph.get(), selected);
        const labels = $a0933ef57ff1c2b9$export$f70730c3d1fc524e($a0933ef57ff1c2b9$export$5b8affa63fc6df16(edges, (e)=>e.labels));
        return /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "sidekick box " + $d0b6c04ea853e168$var$LabelSidekickStyle + " " + $fefc6099805237ea$export$962e3d5eaa2dc953 + " " + "mode-" + mode,
            onMouseDown: (e)=>{
                e.stopPropagation();
                e.preventDefault();
            }
        }, /*#__PURE__*/ $bh6RR.createElement("div", null, $7ce66515d279521f$export$b6fb1741c7f64881[mode].map((action)=>$fefc6099805237ea$export$353f5b6fc5456de1($7ce66515d279521f$export$cb571d1feb4bc7b[action], $7ce66515d279521f$export$a7046e0c111216af[action] + `\n\nShortcut: ${$7ce66515d279521f$export$9fc7b98fb0c7c1a5[action]}`, ()=>$7ce66515d279521f$export$c6f93ba583c9acfc(store, action)))), /*#__PURE__*/ $bh6RR.createElement($d0b6c04ea853e168$export$931cbfb6bfb85fc, {
            taxonomy: taxonomy,
            selected: labels,
            mode: mode,
            onChange: (label, value)=>!disabled && $7ce66515d279521f$export$8fce3efcf5a2aae4(store, (store)=>advance(()=>{
                        $7ce66515d279521f$export$4f65e594f6031297(store, selected, label, value);
                    })),
            onKeyDown: (e)=>{
                const key = (e.altKey || e.metaKey ? "Alt-" : "") + (e.shiftKey ? "Shift-" : "") + e.key;
                const action = $d9d0435d2b879de6$export$44e922edf8a1f41a($7ce66515d279521f$export$9fc7b98fb0c7c1a5, key);
                if (action) $7ce66515d279521f$export$c6f93ba583c9acfc(store, action);
            // e.preventDefault()
            },
            extraInput: extraInput
        }));
    }
    return null;
}










function $93643438ed973f8d$export$f1b3e225638f11c5(url, graphStore, pseudonymsStore, handleError) {
    $a0933ef57ff1c2b9$export$b5fe3f66a567bec0(url, {
        method: "POST",
        data: `text=${encodeURIComponent($566cb6e3cba7cd4f$export$4f78c7b40cf11a9a(graphStore.get()))}`
    }, (response)=>{
        // Join sentences and skip empty tokens resulting from repeated whitespace.
        const toks = [].concat(...JSON.parse(response)).filter((tok)=>tok.string);
        graphStore.transaction(()=>{
            try {
                $93643438ed973f8d$export$20b4894e2edca58a(graphStore, pseudonymsStore, toks);
            } catch (e) {
                console.error(e);
                handleError(e);
            }
        });
    }, (response, code)=>{
        code ? handleError(`Pseudonymizer error ${code}: ${response}`) : handleError("Pseudonymizer error");
    });
}
function $93643438ed973f8d$export$20b4894e2edca58a(graphStore, pseudonymsStore, toks) {
    graphStore.modify($566cb6e3cba7cd4f$export$97d6f5b546d7d09f).modify((g)=>{
        let si = 0 // Source tokens cursor
        ;
        const edges = toks.map((tok, i)=>{
            const labels = tok.label.filter((0, $0cbe5267c7ef82d0$export$ee072a2ca7182767));
            labels.length < tok.label.length && labels.unshift("extra");
            const token_ids = [
                g.source[si].id,
                g.target[si].id
            ];
            si++;
            if (labels.length && !toks[i + 1].label.length) // Include subsequent tokens.
            while(g.source[si] && g.source[si].text.trim() != toks[i + 1].string.trim()){
                token_ids.push(g.source[si].id, g.target[si].id);
                si++;
            }
            labels && pseudonymsStore.update({
                [labels.join(" ")]: tok.string
            });
            return $566cb6e3cba7cd4f$export$b9d9805c9b77a56d(token_ids, labels, !!labels.length);
        });
        return {
            ...g,
            edges: $d9d0435d2b879de6$export$2cd8252107eb640b(edges.map((edge)=>({
                    k: edge.id,
                    v: edge
                })))
        };
    });
}


$4LfDI.cssRaw(`
body > div {
  height: 100%
}
`);
const $028b402cd7dfc321$var$header_height = "32px";
const $028b402cd7dfc321$var$footer_height = "26px";
const $028b402cd7dfc321$var$topStyle = $4LfDI.style({
    ...$a0933ef57ff1c2b9$export$9acf59296ec0cce1("topStyle"),
    fontFamily: "lato, sans-serif, DejaVu Sans",
    color: "#222",
    display: "grid",
    gridGap: "0px 5px",
    margin: "0 auto",
    alignItems: "start",
    gridTemplate: `
    "header   header header"  ${$028b402cd7dfc321$var$header_height}
    "sidekick main   summary" 1fr
    "footer   footer footer"  ${$028b402cd7dfc321$var$footer_height}
  / 185px     3fr    minmax(180px, 1fr)
  `,
    minHeight: "100%",
    $nest: {
        ...$d9d0435d2b879de6$export$bffa455ba8c619a6("sidekick main summary header footer".split(" ").map((area)=>({
                [`& > .${area}`]: {
                    gridArea: area,
                    height: "100%"
                }
            }))),
        "& .header": {
            position: "sticky",
            top: 0,
            zIndex: 20,
            paddingBottom: "5px",
            marginBottom: "5px"
        },
        "& .sidekick > div": {
            top: `${$028b402cd7dfc321$var$header_height}`
        },
        "& .content": {
            height: "100%"
        },
        "& .footer": {
            position: "sticky",
            bottom: 0,
            zIndex: 20
        },
        "& .menu .box": {
            position: "absolute",
            top: $028b402cd7dfc321$var$header_height,
            right: 0,
            zIndex: 100,
            maxWidth: "180px"
        },
        "& .menu button": {
            appearance: "none",
            "-moz-appearance": "none",
            "-webkit-appearance": "none",
            borderWidth: 0,
            background: "none",
            display: "block",
            width: "100%",
            textAlign: "left",
            margin: 0,
            padding: ".2em",
            $nest: {
                "&:hover": {
                    backgroundColor: "rgba(0, 0, 0, .1)"
                },
                "&:disabled": {
                    opacity: 0.5
                },
                "&:disabled:hover": {
                    backgroundColor: "inherit"
                }
            }
        },
        "& .CodeMirror, & textarea": {
            border: "1px solid #ddd",
            height: "auto",
            paddingBottom: "1em",
            lineHeight: "1.5em",
            fontFamily: "'Lato', sans-serif"
        },
        "& .CodeMirror .cm-resize-handle": {
            display: "block",
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 99,
            width: "18px",
            height: "18px",
            boxShadow: "inset -1px -1px 0 0 silver",
            cursor: "nwse-resize"
        },
        [`& .${$8fc89b11265b74ef$export$54e1eea512f4c5b}`]: {
            color: "#26a"
        },
        "& .box": {
            background: "hsl(0,0%,96%)",
            borderTop: "2px hsl(220,65%,65%) solid",
            boxShadow: "2px 2px 3px 0px hsla(0,0%,0%,0.2)",
            borderRadius: "0px 0px 2px 2px",
            padding: "3px"
        },
        "& .vsep": {
            marginBottom: "10px"
        },
        "& .inline": {
            display: "inline-block"
        },
        "& pre.pre-box, & .pre-box pre": {
            fontSize: "0.85em",
            padding: "0.25em"
        },
        "& pre": {
            whiteSpace: "pre-wrap"
        },
        "& .doc img": {
            maxWidth: "100%"
        },
        "& .TopPad": {
            paddingTop: "1em"
        },
        "& path": {
            stroke: "#222"
        },
        "& input": {
            width: "100%",
            fontFamily: "inherit",
            color: "inherit"
        },
        "& .graphView": {
            position: "relative",
            overflowY: "auto",
            resize: "vertical",
            marginTop: "1em"
        },
        "& .graphView ul": {
            zIndex: 10,
            cursor: "pointer"
        },
        "& .Selectable": {
            padding: "2px",
            border: "1px solid transparent",
            borderRadius: "3px"
        },
        "& .hovering .hover .Selectable:not(.Selected), & .hovering path.hover, & .hovering .hover path": {
            background: "#8882"
        },
        "& .Selected": {
            background: "hsla(220,65%,65%, .3)",
            borderColor: "hsl(220,65%,65%)"
        },
        [`& .cm-hovering span.hover:not(.${$8fc89b11265b74ef$export$d0ff3e3bd464c3ec})`]: {
            background: "#8882"
        },
        [`& .${$8fc89b11265b74ef$export$d0ff3e3bd464c3ec}`]: {
            background: "hsla(220,65%,65%, .3)"
        },
        "& button": {
            fontSize: "0.85em",
            marginRight: "5px",
            marginBottom: "5px"
        },
        "& button:last-child": {
            marginRight: 0
        },
        "& .error, & .warning": {
            whiteSpace: "pre-wrap",
            padding: "15px",
            marginBottom: "20px",
            border: "1px solid transparent",
            borderRadius: "4px"
        },
        "& .error": {
            backgroundColor: "#f2dede",
            borderColor: "#ebccd1",
            color: "#a94442"
        },
        "& .warning": {
            backgroundColor: "#f2e9de",
            borderColor: "#ebebd1",
            color: "#a99942"
        },
        "& .comment-pane textarea": {
            display: "block",
            width: "100%",
            resize: "vertical"
        },
        "& .float_right > *": {
            float: "right"
        },
        "& .close": {
            float: "right",
            textDecoration: "none",
            opacity: 0.4
        },
        "& .close:hover": {
            opacity: 0.8
        }
    }
});

function $028b402cd7dfc321$export$27a5bd065ad55220(store, cms) {
    const state = store.get();
    const graph = $7ce66515d279521f$export$46c0d0540c0c99ee(store);
    const readonly = $7ce66515d279521f$export$c6e3ee227122f5b7(state.mode);
    const visibleGraph = $7ce66515d279521f$export$e0a937f731644887(store);
    const advance = $7ce66515d279521f$export$2ae79f5e5d10736f(store);
    const manual_page = state.manual !== undefined && $5459fbbcf1f7402d$export$d5db38ffe1f43b01[state.manual];
    store.at("hover_id").ondiff((hover_id)=>{
        const graphViewElement = document.querySelector(".graphView");
        if (!graphViewElement) return;
        const edgeElement = graphViewElement.querySelector(`[data-edge=${hover_id}]`);
        edgeElement && $a0933ef57ff1c2b9$export$53a0910f038337bd(graphViewElement, edgeElement);
    });
    const manual_part = ()=>manual_page && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "main",
            style: {
                minHeight: "18em"
            }
        }, $5459fbbcf1f7402d$export$e3a471c1563f3053.map((slug)=>/*#__PURE__*/ $bh6RR.createElement("span", {
                key: slug
            }, state.manual === slug ? slug.replace("_", " ") : /*#__PURE__*/ $bh6RR.createElement($fefc6099805237ea$export$ebd11618f299a286, {
                title: slug.replace("_", " "),
                text: slug.replace("_", " "),
                onMouseDown: (e)=>{
                    e.stopPropagation();
                    $7ce66515d279521f$export$9e05035ca7fe6979(store, slug);
                }
            }), " ")), manual_page && /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $fefc6099805237ea$export$f39c2d165cd861fe), {
            onMouseDown: ()=>$7ce66515d279521f$export$9e05035ca7fe6979(store, undefined),
            title: "Close manual"
        }), manual_page.text, $566cb6e3cba7cd4f$export$411ce8e5a71e3069(manual_page.target, graph.get(), true) && /*#__PURE__*/ $bh6RR.createElement("i", {
            style: {
                color: "darkgreen"
            }
        }, "Correct!")));
    function full_manual() {
        return /*#__PURE__*/ $bh6RR.createElement("div", {
            className: $028b402cd7dfc321$var$topStyle
        }, /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "main"
        }, /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "content"
        }, /*#__PURE__*/ $bh6RR.createElement((0, $fefc6099805237ea$export$f39c2d165cd861fe), {
            onMouseDown: ()=>$7ce66515d279521f$export$9e05035ca7fe6979(store, undefined),
            title: "Close manual"
        }), $5459fbbcf1f7402d$export$e3a471c1563f3053.map((slug)=>{
            const page = $5459fbbcf1f7402d$export$d5db38ffe1f43b01[slug];
            if (page) {
                const m = (0, $0cbe5267c7ef82d0$export$6eef6642601245aa)(page.mode == "anonymization");
                return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, page.text, /*#__PURE__*/ $bh6RR.createElement("i", null, "Initial view:"), /*#__PURE__*/ $bh6RR.createElement("div", {
                    className: $7ce66515d279521f$export$c6e3ee227122f5b7(page.mode) ? " NoManualBlue" : ""
                }, /*#__PURE__*/ $bh6RR.createElement($61b0792adb50d7bb$export$6a7fe3ef90e8d566, {
                    graph: m(page.graph, store.at("pseudonyms"))
                })), /*#__PURE__*/ $bh6RR.createElement("i", null, "Target view:"), /*#__PURE__*/ $bh6RR.createElement("div", {
                    className: $7ce66515d279521f$export$c6e3ee227122f5b7(page.mode) ? " NoManualBlue" : ""
                }, /*#__PURE__*/ $bh6RR.createElement($61b0792adb50d7bb$export$6a7fe3ef90e8d566, {
                    graph: m(page.target, store.at("pseudonyms"))
                })), /*#__PURE__*/ $bh6RR.createElement($fefc6099805237ea$export$ebd11618f299a286, {
                    title: "Try this!",
                    text: "Try this!",
                    onMouseDown: (e)=>{
                        e.stopPropagation();
                        $7ce66515d279521f$export$9e05035ca7fe6979(store, slug);
                    }
                }));
            }
        }))));
    }
    function main() {
        const hovering = $7ce66515d279521f$export$93f1b562a4709b2(store);
        const visible_graph = $7ce66515d279521f$export$e0a937f731644887(store);
        // Limit the rich diff to the visible graph.
        const rich_diff = state.rich_diff && state.rich_diff.filter((d)=>visible_graph.edges[d.id]);
        const units = $7ce66515d279521f$export$57bd86207114870b(store);
        const label_mode = (mode, label)=>$566cb6e3cba7cd4f$export$4d1b37ad7bc31b75(label) || (mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization ? (0, $0cbe5267c7ef82d0$export$ee072a2ca7182767)(label) : (0, $144d13b54a739243$export$b9193eea530b254f)(mode, label));
        if (state.svlink) (parcelRequire("27IK1")).then(({ configSwell: configSwell })=>{
            const json = state.svlink && configSwell.corrAnno[state.svlink];
            if (json) $7ce66515d279521f$export$9caaf78dc1897bf2(store, json);
            else console.error("No data found for svlink " + state.svlink);
            store.update({
                svlink: undefined
            });
        });
        return /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "content"
        }, $028b402cd7dfc321$var$ShowErrors(store.at("errors")), manual_part(), state.show.source_text && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "TopPad"
        }, /*#__PURE__*/ $bh6RR.createElement("em", null, "Source text:"), /*#__PURE__*/ $bh6RR.createElement("div", {
            className: hovering ? "cm-hovering" : ""
        }, cms.source.node), /*#__PURE__*/ $bh6RR.createElement("div", null, !!state.backend || (0, $fefc6099805237ea$export$353f5b6fc5456de1)("copy to target", "", ()=>advance(()=>graph.modify((g)=>$566cb6e3cba7cd4f$export$8170fdccd13fc536($566cb6e3cba7cd4f$export$1aa3e3e981886a9b(g))))))), state.show.target_text && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "TopPad"
        }, /*#__PURE__*/ $bh6RR.createElement("em", null, "Target text:"), /*#__PURE__*/ $bh6RR.createElement("div", {
            className: hovering ? "cm-hovering" : ""
        }, cms.target.node)), /*#__PURE__*/ $bh6RR.createElement("br", null), (0, $fefc6099805237ea$export$353f5b6fc5456de1)($028b402cd7dfc321$var$click_replace(store.at("automatic_rendering").get()), "", ()=>store.at("automatic_rendering").modify((b)=>!b)), /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "vsep" + (hovering ? " hovering" : "") + (readonly ? " NoManualBlue" : ""),
            style: {
                minHeight: "10em"
            }
        }, /*#__PURE__*/ $bh6RR.createElement($61b0792adb50d7bb$export$6a7fe3ef90e8d566, {
            mode: state.mode,
            side: state.side_restriction,
            orderChangingLabel: (s)=>(0, $144d13b54a739243$export$e506a1d27d1eaa20).order_changing_labels[s],
            graph: visible_graph,
            richDiff: rich_diff,
            hoverId: state.hover_id,
            onHover: (hover_id)=>store.update({
                    hover_id: hover_id
                }),
            selectedIds: Object.keys(state.selected),
            generation: state.generation,
            labelMode: label_mode,
            labelSort: (0, $144d13b54a739243$export$f4c10db555342dd9),
            onSelect: (ids, only)=>$7ce66515d279521f$export$2cc8197d6ae5570(store, ids, only)
        })), state.show.validation && $028b402cd7dfc321$var$ShowMessages(store), state.show.image_link && $028b402cd7dfc321$var$ImageWebserviceAddresses(visible_graph, $7ce66515d279521f$export$493931e7c80626e7(state)), state.show.graph && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "box pre-box"
        }, /*#__PURE__*/ $bh6RR.createElement("pre", null, $a0933ef57ff1c2b9$export$57bf213be019eeb0(visibleGraph)), /*#__PURE__*/ $bh6RR.createElement("h3", null, "Paste graph"), /*#__PURE__*/ $bh6RR.createElement("input", {
            onChange: (e)=>{
                try {
                    const g = JSON.parse(e.currentTarget.value);
                    $566cb6e3cba7cd4f$export$23b96a0307014ab2(g) && store.at("graph").modify((0, $17d8c0717df1150b$exports.Undo).advance_to(g));
                    e.currentTarget.value = "ok!";
                } catch  {}
            }
        })), state.show.diff && /*#__PURE__*/ $bh6RR.createElement("pre", {
            className: "box pre-box"
        }, $a0933ef57ff1c2b9$export$57bf213be019eeb0($c625aec54bd34bcf$export$17043b50a1e129e6(visibleGraph))), state.show.examples && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "TopPad"
        }, /*#__PURE__*/ $bh6RR.createElement("em", null, "Examples:"), (0, $144d13b54a739243$export$e506a1d27d1eaa20).examples.map((e, i)=>/*#__PURE__*/ $bh6RR.createElement("div", {
                key: i
            }, /*#__PURE__*/ $bh6RR.createElement("div", null, (0, $fefc6099805237ea$export$353f5b6fc5456de1)("⇪", "load example", ()=>advance(()=>units.set({
                        source: e.source,
                        target: e.source
                    }))), !e.target ? /*#__PURE__*/ $bh6RR.createElement("div", null) : (0, $fefc6099805237ea$export$353f5b6fc5456de1)("⇫", "see example analysis", ()=>advance(()=>units.set({
                        source: e.source,
                        target: e.target
                    }))), /*#__PURE__*/ $bh6RR.createElement("span", null, e.source))))), state.doc && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "box doc"
        }, /*#__PURE__*/ $bh6RR.createElement((0, $fefc6099805237ea$export$f39c2d165cd861fe), {
            onMouseDown: ()=>store.at("doc").set(undefined),
            title: "Close"
        }), (0, $fefc6099805237ea$export$353f5b6fc5456de1)("open in new window", "", ()=>{
            window.open(state.doc);
            store.at("doc").set(undefined);
        }), state.doc_node && /*#__PURE__*/ $bh6RR.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: state.doc_node.outerHTML
            }
        })));
    }
    const show_store = (show)=>store.at("show").via((0, $17d8c0717df1150b$exports.Lens).key(show));
    function header() {
        const history = $7ce66515d279521f$export$55abd4691b317664(store);
        const toggle = (show)=>show_store(show).modify((b)=>b ? undefined : true);
        const toggle_button = (show, enabled, label = show.replace("_", " "))=>(0, $fefc6099805237ea$export$353f5b6fc5456de1)($028b402cd7dfc321$var$show_hide_str(state.show[show]) + label, "", ()=>toggle(show), enabled, true);
        const exit_reanonymization = (mode)=>{
            // The done status needs to go from false to true at validation.
            const real_done = store.at("done").get();
            store.at("done").set(false);
            // Overwrite source tokens, then save.
            $7ce66515d279521f$export$8fce3efcf5a2aae4(store, (s)=>{
                s.at("done").set(true);
                s.at("graph").at("now").set((0, $0cbe5267c7ef82d0$export$5da77726a9654879)($7ce66515d279521f$export$e0a937f731644887(store)));
            });
            const validation_success = store.at("done").get();
            store.at("done").set(real_done);
            if (validation_success) {
                $7ce66515d279521f$export$a1544dad697b423d(store);
                $7ce66515d279521f$export$f18d5b0af29128b7(store, "Anonymization changed during " + mode);
                // After save, switch mode.
                const unsub = store.at("version").ondiff(()=>{
                    store.at("mode").set(mode);
                    unsub();
                });
            }
        };
        const mode_switcher = (mode, enable_in_any_mode = false)=>(0, $fefc6099805237ea$export$353f5b6fc5456de1)(`switch to ${$7ce66515d279521f$export$90760e89e7ed6c8a(mode)}`, "", $7ce66515d279521f$export$39d12591b9d419b4(state) ? ()=>exit_reanonymization(mode) : ()=>store.at("mode").set(mode), state.mode !== mode && (!state.backend || state.start_mode == mode || enable_in_any_mode));
        return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("div", {
            style: {
                display: "flex",
                justifyContent: "space-between",
                width: "100%"
            }
        }, /*#__PURE__*/ $bh6RR.createElement("div", null, (0, $fefc6099805237ea$export$353f5b6fc5456de1)("undo", "", history.undo, history.canUndo()), (0, $fefc6099805237ea$export$353f5b6fc5456de1)("redo", "", history.redo, history.canRedo())), /*#__PURE__*/ $bh6RR.createElement("div", {
            style: {
                fontWeight: "bold"
            }
        }, "SVALA ", $7ce66515d279521f$export$90760e89e7ed6c8a(state.mode), " ", state.essay ? `– essay ${state.essay}` : "", " ", !$7ce66515d279521f$export$d49663c289e0cae7(state).state && "(read-only)"), /*#__PURE__*/ $bh6RR.createElement("div", null, !!state.backurl && /*#__PURE__*/ $bh6RR.createElement("a", {
            style: {
                margin: "3px 8px",
                fontSize: "0.9em",
                opacity: 0.8
            },
            href: state.backurl,
            onClick: (e)=>{
                $7ce66515d279521f$export$6925991e7e736e7(store, true);
                const messages = store.at("validation_messages").get();
                if (messages.length && !confirm(messages.map((m)=>m.message).join("\n") + "\n\nLeave anyway?")) e.preventDefault();
            }
        }, "back"), state.done !== undefined && !$7ce66515d279521f$export$39d12591b9d419b4(state) && (0, $fefc6099805237ea$export$353f5b6fc5456de1)(state.done ? "not done" : "done", "toggle between done and not done", ()=>$7ce66515d279521f$export$8fce3efcf5a2aae4(store, (s)=>s.at("done").modify((b)=>!b), true)), toggle_button("options"))), state.show.options && /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "menu"
        }, /*#__PURE__*/ $bh6RR.createElement("div", {
            className: "box"
        }, toggle_button("source_text"), toggle_button("target_text"), $028b402cd7dfc321$var$RestrictionButtons(store.at("side_restriction")), (0, $fefc6099805237ea$export$353f5b6fc5456de1)("fit graph", "adjust the height of the graph view", ()=>$028b402cd7dfc321$var$fitGraph()), (0, $fefc6099805237ea$export$353f5b6fc5456de1)("show full graph", "render the full graph (may be slow, please have patience)", ()=>{
            store.transaction(()=>{
                $7ce66515d279521f$export$f6e36f80a8190133(store, []);
                $7ce66515d279521f$export$68c05593fd98348a(store, []);
            });
        }), /*#__PURE__*/ $bh6RR.createElement("hr", null), state.mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization && (0, $fefc6099805237ea$export$353f5b6fc5456de1)("use\xa0pseudonymizer service", "Add pseudonymization labels using the automatic rule-based pseudonymizer", ()=>(0, $93643438ed973f8d$export$f1b3e225638f11c5)(state.backend ? state.backend.replace(/tasks\/.*/, "annotation/pseuws") : (0, $144d13b54a739243$export$e506a1d27d1eaa20).pseuws_url, $7ce66515d279521f$export$46c0d0540c0c99ee(store), store.at("pseudonyms"), (e)=>$7ce66515d279521f$export$e1c744d13458e1d(store, e))), (0, $fefc6099805237ea$export$353f5b6fc5456de1)("validate", "", ()=>$7ce66515d279521f$export$6925991e7e736e7(store, true)), mode_switcher($7ce66515d279521f$export$4a6bdc0a840be00.anonymization, true), mode_switcher($7ce66515d279521f$export$4a6bdc0a840be00.normalization), mode_switcher($7ce66515d279521f$export$4a6bdc0a840be00.correctannot), /*#__PURE__*/ $bh6RR.createElement("hr", null), toggle_button("graph"), toggle_button("diff"), toggle_button("image_link"), toggle_button("examples", !state.backend), /*#__PURE__*/ $bh6RR.createElement("hr", null), (0, $144d13b54a739243$export$e506a1d27d1eaa20).docs[state.mode] && $d9d0435d2b879de6$export$df3f009e3d155b20((0, $144d13b54a739243$export$e506a1d27d1eaa20).docs[state.mode], (url, label)=>(0, $fefc6099805237ea$export$353f5b6fc5456de1)(`view ${label}`, "", ()=>store.at("doc").set(url))), (0, $fefc6099805237ea$export$353f5b6fc5456de1)(state.manual === undefined ? "manual" : "exit manual", "toggle showing manual", ()=>$7ce66515d279521f$export$9e05035ca7fe6979(store, state.manual ? undefined : "manual")))));
    }
    const selected_edges = $566cb6e3cba7cd4f$export$8d414a6135f9d320(visibleGraph, Object.keys(store.get().selected));
    const selected_only_edge = selected_edges.length === 1 ? selected_edges[0] : undefined;
    const selected_source = selected_only_edge ? $566cb6e3cba7cd4f$export$2ec92a4fdd52410a(visibleGraph)(selected_only_edge.ids).source : [];
    const selected_only_source = selected_source.length ? selected_source[0].id : undefined;
    return state.manual === "print" ? full_manual() : /*#__PURE__*/ $bh6RR.createElement("div", {
        className: $028b402cd7dfc321$var$topStyle,
        style: {
            position: "relative"
        },
        onMouseDown: ()=>show_store("options").set(undefined)
    }, /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "header box"
    }, header()), /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "sidekick"
    }, /*#__PURE__*/ $bh6RR.createElement((0, $d0b6c04ea853e168$export$775a140956cd095a), {
        store: store,
        taxonomy: state.taxonomy[state.mode],
        mode: state.mode,
        extraInput: selected_only_edge && selected_only_source && selected_only_edge.labels.some((l)=>!!(0, $144d13b54a739243$export$ebb418edcdf3dd37)[l]) ? {
            get: ()=>{
                const args = store.get().pseudonym_args[selected_only_source];
                return args ? args.join(" ") : undefined;
            },
            set: (value)=>{
                store.at("pseudonym_args").update({
                    [selected_only_source]: value.split(" ")
                });
            }
        } : undefined,
        disabled: !$7ce66515d279521f$export$d49663c289e0cae7(state).state
    })), /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "main",
        onMouseDown: (e)=>$7ce66515d279521f$export$5bb86370ea51314a(store)
    }, /*#__PURE__*/ $bh6RR.createElement((0, $6f4fc6e76261e086$export$3c6489d84dc98b6), {
        webserviceURL: (0, $144d13b54a739243$export$e506a1d27d1eaa20).image_ws_url,
        onDrop: (d)=>advance(()=>{
                $7ce66515d279521f$export$1aca998cb633196e(store, ()=>{
                    graph.set(d.graph);
                    store.update({
                        mode: d.anon_mode ? $7ce66515d279521f$export$4a6bdc0a840be00.anonymization : $7ce66515d279521f$export$4a6bdc0a840be00.normalization
                    });
                });
            })
    }, main())), $028b402cd7dfc321$var$Summary(store), /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "footer box"
    }, /*#__PURE__*/ $bh6RR.createElement("span", {
        style: {
            opacity: 0.8,
            fontSize: "0.9em"
        }
    }, /*#__PURE__*/ $bh6RR.createElement("b", null, "SVALA:"), " ", /*#__PURE__*/ $bh6RR.createElement("a", {
        href: "https://github.com/spraakbanken/swell-editor",
        target: "_blank"
    }, /*#__PURE__*/ $bh6RR.createElement("i", null, "Repo")), " ", /*#__PURE__*/ $bh6RR.createElement("a", {
        href: "https://github.com/spraakbanken/swell-editor/issues",
        target: "_blank"
    }, /*#__PURE__*/ $bh6RR.createElement("i", null, "Issues")), " ", /*#__PURE__*/ $bh6RR.createElement("b", null, "Link to Articles:"), " ", /*#__PURE__*/ $bh6RR.createElement("a", {
        href: "http://www.ep.liu.se/ecp/159/023/ecp18159023.pdf",
        target: "_blank"
    }, /*#__PURE__*/ $bh6RR.createElement("i", null, "Svala")), " ", /*#__PURE__*/ $bh6RR.createElement("a", {
        href: "https://spraakbanken.gu.se/sites/spraakbanken.gu.se/files/Annotation_of_learner_corpora_SweLL.pdf",
        target: "_blank"
    }, /*#__PURE__*/ $bh6RR.createElement("i", null, "Swell")), " ", /*#__PURE__*/ $bh6RR.createElement("a", {
        href: "http://www.diva-portal.org/smash/get/diva2:1266934/FULLTEXT01.pdf",
        target: "_blank"
    }, /*#__PURE__*/ $bh6RR.createElement("i", null, "Anonymization")), state.essay && state.backend && /*#__PURE__*/ $bh6RR.createElement("span", {
        style: {
            float: "right",
            opacity: 0.9
        }
    }, `${state.version ? "revision " + state.version + " of" : "saving"} essay ${state.essay} at `, /*#__PURE__*/ $bh6RR.createElement("code", {
        style: {
            fontSize: "0.95em"
        }
    }, state.backend)))));
}
/** Auto-size the spaghetti. */ function $028b402cd7dfc321$var$fitGraph() {
    const gv = document.querySelector(".graphView");
    const footer = document.querySelector(".footer");
    if (!gv || !footer) return;
    // Pull spaghetti bottom down to wrapper bottom.
    // Subtracting a few pixels is necessary for some reason.
    gv.style.height = `${window.innerHeight - footer.offsetHeight - gv.offsetTop - 5}px`;
}
function $028b402cd7dfc321$var$show_hide_str(b) {
    return b ? "hide " : "show ";
}
function $028b402cd7dfc321$var$click_replace(b) {
    return b ? "Spaghetti mode disable" : "Spaghetti mode enable";
}
function $028b402cd7dfc321$var$RestrictionButtons(store) {
    return $566cb6e3cba7cd4f$export$832b6fa47fa053d2.map((k)=>(0, $fefc6099805237ea$export$353f5b6fc5456de1)($028b402cd7dfc321$var$show_hide_str(store.get() !== $566cb6e3cba7cd4f$export$a27c3a1c44ba515b(k)) + `${k} in graph`, "", // Undefined means show both.
        ()=>store.set(store.get() === undefined ? $566cb6e3cba7cd4f$export$a27c3a1c44ba515b(k) : undefined), store.get() !== k));
}
function $028b402cd7dfc321$var$ShowErrors(store) {
    return $d9d0435d2b879de6$export$df3f009e3d155b20(store.get(), (_, msg)=>/*#__PURE__*/ $bh6RR.createElement("div", {
            className: "error",
            key: msg
        }, /*#__PURE__*/ $bh6RR.createElement((0, $fefc6099805237ea$export$f39c2d165cd861fe), {
            title: "dismiss",
            onMouseDown: (e)=>{
                store.via((0, $17d8c0717df1150b$exports.Lens).key(msg)).set(undefined);
                e.preventDefault();
            }
        }), msg));
}
function $028b402cd7dfc321$var$ShowMessages(store) {
    const messageStore = store.at("validation_messages");
    return messageStore.get().map((message, i)=>/*#__PURE__*/ $bh6RR.createElement("div", {
            className: message.severity,
            key: i
        }, // They will disappear on the next validation, but we should also let the user dismiss them manually.
        message.severity == (0, $a3df2e600d37ee5f$export$918a9776c0a3cf27).ERROR && /*#__PURE__*/ $bh6RR.createElement((0, $fefc6099805237ea$export$f39c2d165cd861fe), {
            title: "dismiss",
            onMouseDown: (e)=>{
                messageStore.modify((ms)=>ms.slice(0, i).concat(ms.slice(i + 1)));
                e.preventDefault();
            }
        }), message.message, String(message.subject).indexOf("e-") === 0 && /*#__PURE__*/ $bh6RR.createElement("span", null, ": ", $028b402cd7dfc321$export$b9d9805c9b77a56d(store, message.subject))));
}
function $028b402cd7dfc321$var$Summary(store) {
    return /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "summary"
    }, $028b402cd7dfc321$var$ShowComments(store), store.get().mode === $7ce66515d279521f$export$4a6bdc0a840be00.anonymization ? $028b402cd7dfc321$export$355fbf3007b44f78(store, (l)=>/^\d+$/.test(l), "source") : $028b402cd7dfc321$export$355fbf3007b44f78(store, (l)=>(0, $144d13b54a739243$export$571398232cbac325)(l) !== $7ce66515d279521f$export$4a6bdc0a840be00.anonymization));
}
function $028b402cd7dfc321$var$ShowComments(store) {
    const g = $7ce66515d279521f$export$88c4ac24ed656637(store);
    const setGraphComment = $a0933ef57ff1c2b9$export$61fc7d43ac8f84b0(1000, (comment)=>$7ce66515d279521f$export$46c0d0540c0c99ee(store).modify((g)=>$566cb6e3cba7cd4f$export$b9ae51c2964107cf(g, comment)));
    const setEdgeComment = $a0933ef57ff1c2b9$export$61fc7d43ac8f84b0(1000, (edgeId, comment)=>$7ce66515d279521f$export$46c0d0540c0c99ee(store).modify((g)=>$566cb6e3cba7cd4f$export$3ad331fd950bc447(g, edgeId, comment)));
    if ($566cb6e3cba7cd4f$export$6e22c362a0406a2c(g)) return null;
    return /*#__PURE__*/ $bh6RR.createElement("div", null, /*#__PURE__*/ $bh6RR.createElement("div", {
        className: "comment-pane box vsep"
    }, /*#__PURE__*/ $bh6RR.createElement("p", null, "Document comment:"), /*#__PURE__*/ $bh6RR.createElement("textarea", {
        // Prevent refocusing to label filter field.
        className: "keepfocus",
        // Avoid deselecting.
        onMouseDown: (ev)=>ev.stopPropagation(),
        onChange: (ev)=>setGraphComment(ev.target.value),
        defaultValue: g.comment,
        disabled: !$7ce66515d279521f$export$d49663c289e0cae7(store.get()).state
    })), $566cb6e3cba7cd4f$export$8d414a6135f9d320(g, Object.keys(store.at("selected").get())).filter((edge)=>edge.labels.some($566cb6e3cba7cd4f$export$4d1b37ad7bc31b75)).map((edge)=>/*#__PURE__*/ $bh6RR.createElement("div", {
            className: "comment-pane box vsep",
            key: edge.id
        }, /*#__PURE__*/ $bh6RR.createElement("p", null, "Edge comment:"), /*#__PURE__*/ $bh6RR.createElement("textarea", {
            className: "keepfocus",
            onMouseDown: (ev)=>ev.stopPropagation(),
            onChange: (ev)=>setEdgeComment(edge.id, ev.target.value),
            defaultValue: edge.comment,
            disabled: !$7ce66515d279521f$export$d49663c289e0cae7(store.get()).state
        }))));
}
function $028b402cd7dfc321$var$ImageWebserviceAddresses(g, anon_mode) {
    const escape = (s)=>encodeURIComponent(s).replace("(", "%28").replace(")", "%29");
    const data = $930bde7a2384eb68$export$eccf2f85c6977700(g, anon_mode);
    const st = $930bde7a2384eb68$export$7019fddfdf911435(data);
    const url = `${(0, $144d13b54a739243$export$e506a1d27d1eaa20).image_ws_url}/png?${escape(st)}`;
    return /*#__PURE__*/ $bh6RR.createElement("pre", {
        className: "box pre-box",
        style: {
            whiteSpace: "normal",
            wordBreak: "break-all",
            overflowX: "hidden"
        }
    }, url);
}
function $028b402cd7dfc321$export$355fbf3007b44f78(store, label_filter, side) {
    const g = $7ce66515d279521f$export$88c4ac24ed656637(store);
    const obs_class = (labels)=>labels.some((l)=>-1 != l.indexOf("!")) ? " OBS " : "";
    return /*#__PURE__*/ $bh6RR.createElement("div", null, $d9d0435d2b879de6$export$df3f009e3d155b20($566cb6e3cba7cd4f$export$c555d49ba8ab6cad(g, label_filter), (es, label)=>/*#__PURE__*/ $bh6RR.createElement("div", {
            key: label,
            className: "box vsep"
        }, /*#__PURE__*/ $bh6RR.createElement("div", {
            className: $61b0792adb50d7bb$export$6cb312a80b588f32 + obs_class([
                label
            ])
        }, /*#__PURE__*/ $bh6RR.createElement("div", null, label)), /*#__PURE__*/ $bh6RR.createElement("ul", null, es.map((e)=>/*#__PURE__*/ $bh6RR.createElement("li", {
                key: e.id
            }, $028b402cd7dfc321$export$b9d9805c9b77a56d(store, e.id, side))))), true));
}
function $028b402cd7dfc321$export$b9d9805c9b77a56d(store, id, side) {
    const g = $7ce66515d279521f$export$88c4ac24ed656637(store);
    const in_edge = (t)=>g.edges[id].ids.includes(t.id);
    const tokens = {
        source: g.source.filter(in_edge),
        target: g.target.filter(in_edge)
    };
    const tids = side ? tokens[side].map((t)=>t.id) : g.edges[id].ids;
    return /*#__PURE__*/ $bh6RR.createElement("span", {
        onClick: ()=>$7ce66515d279521f$export$f6e36f80a8190133(store, tids),
        style: {
            cursor: "pointer",
            textDecoration: "underline"
        }
    }, side ? $58ccaae15ba3b7ae$export$6f093cfa640b7166(tokens[side]) : `${$58ccaae15ba3b7ae$export$6f093cfa640b7166(tokens.source).trim()}—${$58ccaae15ba3b7ae$export$6f093cfa640b7166(tokens.target).trim()}`);
}



function $5b68a6db0470f18e$export$70aab0216a294b8b(url, show) {
    $a0933ef57ff1c2b9$export$b5fe3f66a567bec0(url, {
        method: "GET"
    }, (res)=>{
        const doc = new DOMParser().parseFromString(res, "text/html");
        const body = doc.querySelector(".markdown-body");
        if (!body) return show($5b68a6db0470f18e$var$message("Could not parse remote document."));
        // Remove the "swell-project" header
        const h1 = body.querySelector("h1");
        h1 && h1.remove();
        show(body);
    }, (res)=>{
        console.error("Could not load", url, res);
        return show($5b68a6db0470f18e$var$message("Could not load remote document."));
    });
}
function $5b68a6db0470f18e$var$message(text, severity = "error") {
    const el = document.createElement("div");
    el.className = severity;
    el.innerText = text;
    return el;
}



const $0ef8ca47b33fdc1f$export$2cd8252107eb640b = $7ce66515d279521f$export$2cd8252107eb640b;
function $0ef8ca47b33fdc1f$export$86fbec116b87613f(store) {
    const global = window;
    global.store = store;
    global.reset = (v0 = "")=>{
        store.set($0ef8ca47b33fdc1f$export$2cd8252107eb640b);
        $7ce66515d279521f$export$46c0d0540c0c99ee(store).set($b402d4a7f0e14377$exports.init(v0));
    };
    global.G = $b402d4a7f0e14377$exports;
    global.Utils = $a0933ef57ff1c2b9$exports;
    global.stress = ()=>$0ef8ca47b33fdc1f$var$stress(store);
    store.at("generation").modify((i)=>i + 1);
    const update_rich_diff = ()=>{
        const rd = $b402d4a7f0e14377$exports.enrichen($7ce66515d279521f$export$9a86c1ce88ca19ad(store), (s)=>(0, $144d13b54a739243$export$e506a1d27d1eaa20).order_changing_labels[s]);
        store.at("rich_diff").set(rd);
    };
    store.at("graph").at("now").ondiff((g)=>{
        $7ce66515d279521f$export$39ede186e36e8c0b(store)(g);
        const restricted = $7ce66515d279521f$export$ab3686cfac071135(store, store.get().selected);
        restricted && store.update(restricted);
        // Enrichen is expensive. Run once at every graph change and keep the result in state.
        if (store.at("automatic_rendering").get()) update_rich_diff();
    });
    (0, $17d8c0717df1150b$exports.Store).location_connect($7ce66515d279521f$export$471a9fea0ebf807(store));
    // Store graph in local storage unless there is a backend.
    // This facilitates development and playing around.
    // Using both backend and local storage is pointless and prone to bugs.
    store.at("backend").get() || store.at("graph").at("now").storage_connect("swell-spaghetti-7");
    store.at("mode").ondiff((mode)=>{
        // Reset/detect pseudonyms when switching to anonymization mode.
        mode === $7ce66515d279521f$export$4a6bdc0a840be00.anonymization && $7ce66515d279521f$export$90a4f11d22f5cfb6(store);
        // Adjust UI to mode.
        store.at("show").update({
            target_text: mode == $7ce66515d279521f$export$4a6bdc0a840be00.anonymization ? undefined : true,
            source_text: undefined
        });
        // Mode affects the viewed graph, so refresh rich diff.
        update_rich_diff();
    });
    store.at("pseudonym_args").ondiff(()=>update_rich_diff());
    {
        const state = store.get();
        const page = state.manual;
        page && $7ce66515d279521f$export$9e05035ca7fe6979(store, page);
        if (state.start_mode) // Inflate a shortname like "anon" to a real mode.
        Object.values($7ce66515d279521f$export$4a6bdc0a840be00).filter((m)=>m.indexOf(state.start_mode) === 0).forEach((m)=>store.update({
                start_mode: m,
                mode: m
            }));
    }
    const load = (url)=>(0, $5b68a6db0470f18e$export$70aab0216a294b8b)(url, (content)=>store.at("doc_node").set(content));
    store.at("doc").ondiff((url)=>url ? load(url) : store.at("doc_node").set(undefined));
    store.at("mode").ondiff(()=>store.at("doc").set(undefined));
    store.at("selected").ondiff((s)=>$d9d0435d2b879de6$export$346677f925de839c(s) && $7ce66515d279521f$export$68c05593fd98348a(store, []));
    $7ce66515d279521f$export$39ede186e36e8c0b(store)(store.get().graph.now);
    global.trigger_invariant_error = ()=>{
        window.setTimeout(()=>{
            const g0 = $b402d4a7f0e14377$exports.init("apa");
            const g = {
                ...g0,
                edges: {
                    oops: g0.edges["e-s0-t0"]
                }
            };
            store.update({
                graph: (0, $17d8c0717df1150b$exports.Undo).init(g)
            });
        }, 1000);
    };
    $7ce66515d279521f$export$f21d8fd7f00f60f4(store, ()=>$7ce66515d279521f$export$3ccf567208079273(store));
    const allowWhitespace = (change)=>change.type == "editor" && !/\S/.test([
            ...change.change.text || [],
            ...change.change.removed || []
        ].join(""));
    const targetChangeCheck = ()=>!$7ce66515d279521f$export$c6e3ee227122f5b7(store.at("mode").get());
    // for transcription mode then change here to make the source code mirror not be readOnly
    const cms = $d9d0435d2b879de6$export$185802fd694ee1f5($b402d4a7f0e14377$exports.sides, (side)=>$8fc89b11265b74ef$export$d3eec5620897e8c0(store, side, !store.get().backend ? undefined : side == "target" ? targetChangeCheck : allowWhitespace));
    return ()=>(0, $028b402cd7dfc321$export$27a5bd065ad55220)(store, cms);
}
function $0ef8ca47b33fdc1f$var$stress(store) {
    const source = $a0933ef57ff1c2b9$exports.range(100).join(" ");
    // const source = Utils.range(100).map(() => Utils.range(25).join(' ')).join(' .\n')
    store.set({
        ...$0ef8ca47b33fdc1f$export$2cd8252107eb640b,
        graph: (0, $17d8c0717df1150b$exports.Undo).init($b402d4a7f0e14377$exports.init(source, false))
    });
    function go(i) {
        if (i === 0) return;
        window.setTimeout(()=>{
            const g = $b402d4a7f0e14377$exports.modify(store.get().graph.now, 10, 10, i + " ");
            store.at("graph").modify((0, $17d8c0717df1150b$exports.Undo).advance_to(g));
            go(i - 1);
        }, 1);
    }
    go(10);
}


const $1e6a16da88d577c6$var$global = window;
if ($1e6a16da88d577c6$var$global.reattach === undefined) {
    $4aa2fd92cb1b046f$exports.normalize();
    $4aa2fd92cb1b046f$exports.setupPage("body");
    const root = document.body.appendChild(document.createElement("div"));
    $1e6a16da88d577c6$var$global.reattach = $17d8c0717df1150b$exports.attach((vn)=>$47cfd4084854a574$exports.render(vn, root), $0ef8ca47b33fdc1f$export$2cd8252107eb640b, $0ef8ca47b33fdc1f$export$86fbec116b87613f);
}
if (null) null.accept(()=>{
    $1e6a16da88d577c6$var$global.reattach($0ef8ca47b33fdc1f$export$86fbec116b87613f);
});


//# sourceMappingURL=index.e866c36d.js.map
